/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  _float8: { input: any; output: any; }
  _uuid: { input: any; output: any; }
  bigint: { input: any; output: any; }
  bit: { input: any; output: any; }
  citext: { input: string; output: string; }
  cube: { input: any; output: any; }
  currencies: { input: string; output: string; }
  date: { input: string; output: string; }
  email_template: { input: any; output: any; }
  energy_ges_values: { input: any; output: any; }
  float8: { input: number; output: number; }
  geography: { input: any; output: any; }
  geometry: { input: any; output: any; }
  invoice_status: { input: any; output: any; }
  json: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  lead_buying_status: { input: any; output: any; }
  lead_mortgage_status: { input: any; output: any; }
  lead_ownership: { input: any; output: any; }
  lead_type: { input: any; output: any; }
  marital_status: { input: any; output: any; }
  mortgage_interest_rate_type: { input: any; output: any; }
  mortgage_interest_type: { input: any; output: any; }
  mortgage_lender_type: { input: any; output: any; }
  pdf_compression_quality: { input: any; output: any; }
  places_scalar: { input: any; output: any; }
  portal_idx_protocol: { input: any; output: any; }
  property_searches_notification: { input: any; output: any; }
  smallint: { input: any; output: any; }
  subscription_status: { input: any; output: any; }
  third_pillar_organisation_type_a: { input: any; output: any; }
  third_pillar_organisation_type_b: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  tsvector: { input: any; output: any; }
  user_language: { input: any; output: any; }
  user_professional_situation: { input: any; output: any; }
  users_scalar: { input: any; output: any; }
  uuid: { input: string; output: string; }
  vector: { input: any; output: any; }
};

export type AddressInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  country_code: CountryCode;
  locality: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  route: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street_number: Scalars['String']['input'];
};

export type ApiKey = {
  PartnerApiKey: Scalars['String']['output'];
  PartnerID: Scalars['String']['output'];
  PartnerName: Scalars['String']['output'];
  PartnerRole: Scalars['String']['output'];
  PartnerTeamsIds?: Maybe<Array<Scalars['String']['output']>>;
  PartnerTenantId: Scalars['String']['output'];
};

export type AppraisableResult = {
  errors: Array<AppraisalError>;
  result: Scalars['Boolean']['output'];
};

export type AppraisalError = {
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  path: Array<Scalars['String']['output']>;
};

export type AutoAssignRankingAgentCh = {
  crm_link?: Maybe<Scalars['String']['output']>;
  first_lead_assigned?: Maybe<Scalars['timestamptz']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  gross_margin_per_lead?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lead_to_transaction_conversion?: Maybe<Scalars['Int']['output']>;
  lead_to_transaction_score?: Maybe<Scalars['Int']['output']>;
  lead_to_visit_conversion?: Maybe<Scalars['Int']['output']>;
  lead_to_visit_score?: Maybe<Scalars['Int']['output']>;
  mandate_to_transaction_conversion?: Maybe<Scalars['Int']['output']>;
  mandate_to_transaction_score?: Maybe<Scalars['Int']['output']>;
  membership_type?: Maybe<Scalars['String']['output']>;
  modules?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  number_of_leads_without_activity?: Maybe<Scalars['Int']['output']>;
  number_of_listings_available?: Maybe<Scalars['Int']['output']>;
  number_of_overdue_days?: Maybe<Scalars['Int']['output']>;
  number_of_overdue_leads?: Maybe<Scalars['Int']['output']>;
  overall_score?: Maybe<Scalars['Int']['output']>;
  revenues_per_lead?: Maybe<Scalars['Float']['output']>;
  total_agent_share?: Maybe<Scalars['Float']['output']>;
  total_call_center_visits?: Maybe<Scalars['Int']['output']>;
  total_commissions?: Maybe<Scalars['Float']['output']>;
  total_lead_mandates?: Maybe<Scalars['Int']['output']>;
  total_leads_assigned?: Maybe<Scalars['Int']['output']>;
  total_leads_assigned_30_days?: Maybe<Scalars['Int']['output']>;
  total_own_mandates?: Maybe<Scalars['Int']['output']>;
  total_transactions?: Maybe<Scalars['Int']['output']>;
  total_unique_lead_visits?: Maybe<Scalars['Int']['output']>;
  total_weighted_leads_assigned?: Maybe<Scalars['Float']['output']>;
  visit_to_mandate_conversion?: Maybe<Scalars['Int']['output']>;
  visit_to_mandate_score?: Maybe<Scalars['Int']['output']>;
};

export type AutoAssignRankingCh = {
  agents?: Maybe<Array<Maybe<AutoAssignRankingAgentCh>>>;
  message: Scalars['String']['output'];
};

export type AutoAssignRankingEu = {
  agents?: Maybe<Array<Maybe<QualifyingAgent>>>;
  assign_to?: Maybe<QualifyingAgent>;
  message: Scalars['String']['output'];
  should_auto_assign?: Maybe<Scalars['Boolean']['output']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type ChangeBuyerLeadsStageOutput = {
  lot?: Maybe<Lots>;
  lot_id: Scalars['uuid']['output'];
};

export enum CountryCode {
  Ch = 'CH',
  Es = 'ES',
  Fr = 'FR',
  It = 'IT'
}

export type CreateBuyerLeadOutput = {
  buyer_lead?: Maybe<Buyer_Leads>;
  id: Scalars['uuid']['output'];
};

export type CreateBuyerLeadUserInput = {
  emails?: InputMaybe<CreateBuyerLeadUserInput_Emails_Arr_Rel_Insert_Input>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone_numbers?: InputMaybe<CreateBuyerLeadUserInput_Phone_Numbers_Arr_Rel_Insert_Input>;
};

export type CreateBuyerLeadUserInput_Emails_Arr_Rel_Insert_Input = {
  data: Array<CreateBuyerLeadUserInput_Emails_Insert_Input>;
};

export type CreateBuyerLeadUserInput_Emails_Insert_Input = {
  email?: InputMaybe<Scalars['citext']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CreateBuyerLeadUserInput_Phone_Number_Type_Enum_Enum {
  /** Home phone number */
  Home = 'home',
  /** Mobile phone number */
  Mobile = 'mobile',
  /** Other phone number */
  Other = 'other',
  /** Proxy number user to track calls */
  Proxy = 'proxy',
  /** Work phone number */
  Work = 'work'
}

export type CreateBuyerLeadUserInput_Phone_Numbers_Arr_Rel_Insert_Input = {
  data: Array<CreateBuyerLeadUserInput_Phone_Numbers_Insert_Input>;
};

export type CreateBuyerLeadUserInput_Phone_Numbers_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<CreateBuyerLeadUserInput_Phone_Number_Type_Enum_Enum>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateBuyerLeadsManyOutput = {
  buyer_lead?: Maybe<Buyer_Leads>;
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['uuid']['output'];
};

export type CurrentSubscription = {
  current_period_end?: Maybe<Scalars['String']['output']>;
  current_period_pct?: Maybe<Scalars['Float']['output']>;
  current_period_start?: Maybe<Scalars['String']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  incurred_cost?: Maybe<Scalars['Int']['output']>;
  latest_invoice?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Int']['output']>;
};

export type DataForSeoApiResponse = {
  cost?: Maybe<Scalars['Float']['output']>;
  status_code?: Maybe<Scalars['Int']['output']>;
  status_message?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Scalars['jsonb']['output']>;
  tasks_count?: Maybe<Scalars['Int']['output']>;
  tasks_error?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type DeleteKeyResponse = {
  message?: Maybe<Scalars['String']['output']>;
  rowsDeleted?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']['input']>;
  _gt?: InputMaybe<Scalars['Float']['input']>;
  _gte?: InputMaybe<Scalars['Float']['input']>;
  _in?: InputMaybe<Array<Scalars['Float']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Float']['input']>;
  _lte?: InputMaybe<Scalars['Float']['input']>;
  _neq?: InputMaybe<Scalars['Float']['input']>;
  _nin?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type GenerateCmaDescription = {
  description: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
};

export type GenerateListingDescription = {
  description: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
};

export type GetListingReferencesOutput = {
  id: Scalars['uuid']['output'];
  listing?: Maybe<Lots>;
  reference_aliases_encoded: Array<ReferenceAlias>;
};

export type GetMeOutput = {
  me?: Maybe<Users>;
  me_id: Scalars['uuid']['output'];
  show_plans: Scalars['String']['output'];
  user_ids_in_led_teams?: Maybe<Array<Scalars['uuid']['output']>>;
};

export type GetSurroundingListingPlacesOutput = {
  place?: Maybe<Places>;
  place_id: Scalars['uuid']['output'];
};

export type GetValuationLinkOutput = {
  agent?: Maybe<Users>;
  agent_id: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  landing_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  valuation_url?: Maybe<Scalars['String']['output']>;
};

export type ImpressionGroup = {
  average_position?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_count?: Maybe<Scalars['Int']['output']>;
};

export type ImpressionsGroupedByColumnResponse = {
  data?: Maybe<Array<ImpressionGroup>>;
};

export enum ImpressionsGroupingColumn {
  Category = 'category',
  City = 'city',
  Country = 'country',
  Date = 'date',
  Device = 'device',
  PageLocation = 'page_location',
  PageReferrer = 'page_referrer',
  PageType = 'page_type',
  Region = 'region'
}

export type ImprovedText = {
  prompt: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type InsertListingActivitiesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingActivitiesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingActivitiesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingActivitiesAggregateBoolExpCount>;
};

export type InsertListingActivitiesAggregateBoolExpBoolAnd = {
  arguments: InsertListingActivitiesSelectColumnActivitiesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingActivitiesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingActivitiesAggregateBoolExpBoolOr = {
  arguments: InsertListingActivitiesSelectColumnActivitiesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingActivitiesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingActivitiesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingActivitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingActivitiesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingActivitiesArrRelInsertInput = {
  data: Array<InsertListingActivitiesInsertInput>;
  on_conflict?: InputMaybe<InsertListingActivitiesOnConflict>;
};

export type InsertListingActivitiesBoolExp = {
  _and?: InputMaybe<Array<InsertListingActivitiesBoolExp>>;
  _not?: InputMaybe<InsertListingActivitiesBoolExp>;
  _or?: InputMaybe<Array<InsertListingActivitiesBoolExp>>;
  activities_participants?: InputMaybe<InsertListingActivitiesParticipantsBoolExp>;
  activities_participants_aggregate?: InputMaybe<InsertListingActivitiesParticipantsAggregateBoolExp>;
  activities_target_users?: InputMaybe<InsertListingActivitiesTargetUsersBoolExp>;
  activities_target_users_aggregate?: InputMaybe<InsertListingActivitiesTargetUsersAggregateBoolExp>;
  activity_type?: InputMaybe<InsertListingActivityTypesEnumEnumComparisonExp>;
  appraisal_id?: InputMaybe<InsertListingUuidComparisonExp>;
  assigned_to?: InputMaybe<InsertListingUuidComparisonExp>;
  assignee?: InputMaybe<InsertListingUsersBoolExp>;
  buyer_lead?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
  buyer_lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  calendar_event_id?: InputMaybe<InsertListingUuidComparisonExp>;
  consolidated_done_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  creator?: InputMaybe<InsertListingUsersBoolExp>;
  development_id?: InputMaybe<InsertListingUuidComparisonExp>;
  done?: InputMaybe<InsertListingBooleanComparisonExp>;
  done_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  due_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  email_message?: InputMaybe<InsertListingEmailMessagesBoolExp>;
  email_message_id?: InputMaybe<InsertListingUuidComparisonExp>;
  end_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  end_date?: InputMaybe<InsertListingDateComparisonExp>;
  enquiry_id?: InputMaybe<InsertListingUuidComparisonExp>;
  extra_data?: InputMaybe<InsertListingJsonbComparisonExp>;
  financing_request_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_overdue?: InputMaybe<InsertListingBooleanComparisonExp>;
  lead?: InputMaybe<InsertListingLeadsBoolExp>;
  lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  location?: InputMaybe<InsertListingStringComparisonExp>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  note?: InputMaybe<InsertListingStringComparisonExp>;
  offer_id?: InputMaybe<InsertListingUuidComparisonExp>;
  offer_refused_id?: InputMaybe<InsertListingUuidComparisonExp>;
  offer_status?: InputMaybe<InsertListingStringComparisonExp>;
  permissions?: InputMaybe<InsertListingActivitiesPermissionsBoolExp>;
  pinned?: InputMaybe<InsertListingBooleanComparisonExp>;
  start_date?: InputMaybe<InsertListingDateComparisonExp>;
  subject?: InputMaybe<InsertListingStringComparisonExp>;
  success?: InputMaybe<InsertListingBooleanComparisonExp>;
  synced_from_calendar?: InputMaybe<InsertListingBooleanComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  visibility?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingActivitiesConstraint {
  /** unique or primary key constraint on columns "calendar_event_id" */
  ActivitiesCalendarEventIdUnique = 'activities_calendar_event_id_unique',
  /** unique or primary key constraint on columns "email_message_id" */
  ActivitiesEmailMessageIdUnique = 'activities_email_message_id_unique',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  ActivitiesIdTenantIdUnique = 'activities_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  ActivitiesPkey = 'activities_pkey'
}

export type InsertListingActivitiesInsertInput = {
  activities_participants?: InputMaybe<InsertListingActivitiesParticipantsArrRelInsertInput>;
  activities_target_users?: InputMaybe<InsertListingActivitiesTargetUsersArrRelInsertInput>;
  activity_type?: InputMaybe<InsertListingActivityTypesEnumEnum>;
  appraisal_id?: InputMaybe<Scalars['uuid']['input']>;
  assigned_to?: InputMaybe<Scalars['uuid']['input']>;
  assignee?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  buyer_lead?: InputMaybe<InsertListingBuyerLeadsObjRelInsertInput>;
  buyer_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  calendar_event_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  creator?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  done_at?: InputMaybe<Scalars['timestamptz']['input']>;
  due_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_message?: InputMaybe<InsertListingEmailMessagesObjRelInsertInput>;
  email_message_id?: InputMaybe<Scalars['uuid']['input']>;
  end_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  enquiry_id?: InputMaybe<Scalars['uuid']['input']>;
  extra_data?: InputMaybe<Scalars['jsonb']['input']>;
  financing_request_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead?: InputMaybe<InsertListingLeadsObjRelInsertInput>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  offer_id?: InputMaybe<Scalars['uuid']['input']>;
  offer_refused_id?: InputMaybe<Scalars['uuid']['input']>;
  offer_status?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<InsertListingActivitiesPermissionsObjRelInsertInput>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  synced_from_calendar?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingActivitiesObjRelInsertInput = {
  data: InsertListingActivitiesInsertInput;
  on_conflict?: InputMaybe<InsertListingActivitiesOnConflict>;
};

export type InsertListingActivitiesOnConflict = {
  constraint: InsertListingActivitiesConstraint;
  update_columns: Array<InsertListingActivitiesUpdateColumn>;
  where?: InputMaybe<InsertListingActivitiesBoolExp>;
};

export type InsertListingActivitiesParticipantsAggregateBoolExp = {
  count?: InputMaybe<InsertListingActivitiesParticipantsAggregateBoolExpCount>;
};

export type InsertListingActivitiesParticipantsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingActivitiesParticipantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingActivitiesParticipantsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingActivitiesParticipantsArrRelInsertInput = {
  data: Array<InsertListingActivitiesParticipantsInsertInput>;
};

export type InsertListingActivitiesParticipantsBoolExp = {
  _and?: InputMaybe<Array<InsertListingActivitiesParticipantsBoolExp>>;
  _not?: InputMaybe<InsertListingActivitiesParticipantsBoolExp>;
  _or?: InputMaybe<Array<InsertListingActivitiesParticipantsBoolExp>>;
  activity_id?: InputMaybe<InsertListingUuidComparisonExp>;
  email?: InputMaybe<InsertListingStringComparisonExp>;
  matched_user?: InputMaybe<InsertListingUsersBoolExp>;
  matched_user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  status?: InputMaybe<InsertListingStringComparisonExp>;
};

export type InsertListingActivitiesParticipantsInsertInput = {
  activity_id?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  matched_user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  matched_user_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export enum InsertListingActivitiesParticipantsSelectColumn {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  Email = 'email',
  /** column name */
  MatchedUserId = 'matched_user_id',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status'
}

export type InsertListingActivitiesPermissionsBoolExp = {
  _and?: InputMaybe<Array<InsertListingActivitiesPermissionsBoolExp>>;
  _not?: InputMaybe<InsertListingActivitiesPermissionsBoolExp>;
  _or?: InputMaybe<Array<InsertListingActivitiesPermissionsBoolExp>>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export type InsertListingActivitiesPermissionsInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingActivitiesPermissionsObjRelInsertInput = {
  data: InsertListingActivitiesPermissionsInsertInput;
};

export enum InsertListingActivitiesSelectColumn {
  /** column name */
  ActivityType = 'activity_type',
  /** column name */
  AppraisalId = 'appraisal_id',
  /** column name */
  AssignedTo = 'assigned_to',
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  ConsolidatedDoneAt = 'consolidated_done_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  Done = 'done',
  /** column name */
  DoneAt = 'done_at',
  /** column name */
  DueAt = 'due_at',
  /** column name */
  EmailMessageId = 'email_message_id',
  /** column name */
  EndAt = 'end_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EnquiryId = 'enquiry_id',
  /** column name */
  ExtraData = 'extra_data',
  /** column name */
  FinancingRequestId = 'financing_request_id',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  Location = 'location',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Note = 'note',
  /** column name */
  OfferId = 'offer_id',
  /** column name */
  OfferRefusedId = 'offer_refused_id',
  /** column name */
  OfferStatus = 'offer_status',
  /** column name */
  Pinned = 'pinned',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Subject = 'subject',
  /** column name */
  Success = 'success',
  /** column name */
  SyncedFromCalendar = 'synced_from_calendar',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Visibility = 'visibility'
}

export enum InsertListingActivitiesSelectColumnActivitiesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Done = 'done',
  /** column name */
  Pinned = 'pinned',
  /** column name */
  Success = 'success',
  /** column name */
  SyncedFromCalendar = 'synced_from_calendar'
}

export enum InsertListingActivitiesSelectColumnActivitiesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Done = 'done',
  /** column name */
  Pinned = 'pinned',
  /** column name */
  Success = 'success',
  /** column name */
  SyncedFromCalendar = 'synced_from_calendar'
}

export type InsertListingActivitiesTargetUsersAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingActivitiesTargetUsersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingActivitiesTargetUsersAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingActivitiesTargetUsersAggregateBoolExpCount>;
};

export type InsertListingActivitiesTargetUsersAggregateBoolExpBoolAnd = {
  arguments: InsertListingActivitiesTargetUsersSelectColumnActivitiesTargetUsersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingActivitiesTargetUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingActivitiesTargetUsersAggregateBoolExpBoolOr = {
  arguments: InsertListingActivitiesTargetUsersSelectColumnActivitiesTargetUsersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingActivitiesTargetUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingActivitiesTargetUsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingActivitiesTargetUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingActivitiesTargetUsersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingActivitiesTargetUsersArrRelInsertInput = {
  data: Array<InsertListingActivitiesTargetUsersInsertInput>;
  on_conflict?: InputMaybe<InsertListingActivitiesTargetUsersOnConflict>;
};

export type InsertListingActivitiesTargetUsersBoolExp = {
  _and?: InputMaybe<Array<InsertListingActivitiesTargetUsersBoolExp>>;
  _not?: InputMaybe<InsertListingActivitiesTargetUsersBoolExp>;
  _or?: InputMaybe<Array<InsertListingActivitiesTargetUsersBoolExp>>;
  activity?: InputMaybe<InsertListingActivitiesBoolExp>;
  activity_id?: InputMaybe<InsertListingUuidComparisonExp>;
  email?: InputMaybe<InsertListingStringComparisonExp>;
  is_owner?: InputMaybe<InsertListingBooleanComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  status?: InputMaybe<InsertListingStringComparisonExp>;
  target_user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  type?: InputMaybe<InsertListingStringComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
};

export enum InsertListingActivitiesTargetUsersConstraint {
  /** unique or primary key constraint on columns "target_user_id", "is_owner", "activity_id", "email" */
  ActivitiesTargetUsersUindex = 'activities_target_users_uindex'
}

export type InsertListingActivitiesTargetUsersInsertInput = {
  activity?: InputMaybe<InsertListingActivitiesObjRelInsertInput>;
  activity_id?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  is_owner?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  target_user_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
};

export type InsertListingActivitiesTargetUsersOnConflict = {
  constraint: InsertListingActivitiesTargetUsersConstraint;
  update_columns: Array<InsertListingActivitiesTargetUsersUpdateColumn>;
  where?: InputMaybe<InsertListingActivitiesTargetUsersBoolExp>;
};

export enum InsertListingActivitiesTargetUsersSelectColumn {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  Email = 'email',
  /** column name */
  IsOwner = 'is_owner',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  TargetUserId = 'target_user_id',
  /** column name */
  Type = 'type'
}

export enum InsertListingActivitiesTargetUsersSelectColumnActivitiesTargetUsersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsOwner = 'is_owner'
}

export enum InsertListingActivitiesTargetUsersSelectColumnActivitiesTargetUsersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsOwner = 'is_owner'
}

export enum InsertListingActivitiesTargetUsersUpdateColumn {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  Email = 'email',
  /** column name */
  IsOwner = 'is_owner',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  TargetUserId = 'target_user_id',
  /** column name */
  Type = 'type'
}

export enum InsertListingActivitiesUpdateColumn {
  /** column name */
  ActivityType = 'activity_type',
  /** column name */
  AppraisalId = 'appraisal_id',
  /** column name */
  AssignedTo = 'assigned_to',
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  Done = 'done',
  /** column name */
  DoneAt = 'done_at',
  /** column name */
  DueAt = 'due_at',
  /** column name */
  EmailMessageId = 'email_message_id',
  /** column name */
  EndAt = 'end_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EnquiryId = 'enquiry_id',
  /** column name */
  ExtraData = 'extra_data',
  /** column name */
  FinancingRequestId = 'financing_request_id',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  Location = 'location',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Note = 'note',
  /** column name */
  OfferId = 'offer_id',
  /** column name */
  OfferRefusedId = 'offer_refused_id',
  /** column name */
  OfferStatus = 'offer_status',
  /** column name */
  Pinned = 'pinned',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Subject = 'subject',
  /** column name */
  Success = 'success',
  /** column name */
  SyncedFromCalendar = 'synced_from_calendar',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Visibility = 'visibility'
}

export enum InsertListingActivityTypesEnumEnum {
  Assignment = 'assignment',
  Call = 'call',
  Change = 'change',
  CreateUser = 'create_user',
  Email = 'email',
  Match = 'match',
  Note = 'note',
  Offer = 'offer',
  Origination = 'origination',
  Requalification = 'requalification',
  Task = 'task',
  Visit = 'visit'
}

export type InsertListingActivityTypesEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingActivityTypesEnumEnum>;
  _in?: InputMaybe<Array<InsertListingActivityTypesEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingActivityTypesEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingActivityTypesEnumEnum>>;
};

export enum InsertListingAddressDisplayOptionsEnumEnum {
  /** Full address */
  FullAddress = 'full_address',
  /** Hide street and street number */
  HideStreet = 'hide_street',
  /** Hide only street number */
  HideStreetNumber = 'hide_street_number'
}

export type InsertListingAddressDisplayOptionsEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingAddressDisplayOptionsEnumEnum>;
  _in?: InputMaybe<Array<InsertListingAddressDisplayOptionsEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingAddressDisplayOptionsEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingAddressDisplayOptionsEnumEnum>>;
};

export type InsertListingAppraisalsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingAppraisalsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingAppraisalsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingAppraisalsAggregateBoolExpCount>;
};

export type InsertListingAppraisalsAggregateBoolExpBoolAnd = {
  arguments: InsertListingAppraisalsSelectColumnAppraisalsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingAppraisalsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingAppraisalsAggregateBoolExpBoolOr = {
  arguments: InsertListingAppraisalsSelectColumnAppraisalsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingAppraisalsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingAppraisalsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingAppraisalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingAppraisalsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingAppraisalsArrRelInsertInput = {
  data: Array<InsertListingAppraisalsInsertInput>;
  on_conflict?: InputMaybe<InsertListingAppraisalsOnConflict>;
};

export type InsertListingAppraisalsBoolExp = {
  _and?: InputMaybe<Array<InsertListingAppraisalsBoolExp>>;
  _not?: InputMaybe<InsertListingAppraisalsBoolExp>;
  _or?: InputMaybe<Array<InsertListingAppraisalsBoolExp>>;
  appraisal_perceived_value?: InputMaybe<InsertListingFloatComparisonExp>;
  balcony_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  building_condition?: InputMaybe<InsertListingFloatComparisonExp>;
  building_standard?: InputMaybe<InsertListingFloatComparisonExp>;
  building_volume?: InputMaybe<InsertListingFloatComparisonExp>;
  building_volume_norm?: InputMaybe<InsertListingStringComparisonExp>;
  built_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  commercial_potential_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  commercial_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  commercial_yearly_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  construction_year?: InputMaybe<InsertListingIntComparisonExp>;
  country?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  ctn?: InputMaybe<InsertListingStringComparisonExp>;
  flat_condition?: InputMaybe<InsertListingFloatComparisonExp>;
  floor_of_flat?: InputMaybe<InsertListingIntComparisonExp>;
  garden_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  google_address_id?: InputMaybe<InsertListingUuidComparisonExp>;
  has_swimming_pool?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_view?: InputMaybe<InsertListingBooleanComparisonExp>;
  iazi_address_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  income_includes_parking?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_commercial_fully_rented?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_luxury?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_maisonette?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_parking_fully_rented?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_pending?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_residential_fully_rented?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_secondary_residence?: InputMaybe<InsertListingBooleanComparisonExp>;
  land_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  lat?: InputMaybe<InsertListingFloatComparisonExp>;
  living_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  lng?: InputMaybe<InsertListingFloatComparisonExp>;
  locality?: InputMaybe<InsertListingStringComparisonExp>;
  max?: InputMaybe<InsertListingFloatComparisonExp>;
  method?: InputMaybe<InsertListingStringComparisonExp>;
  micro_location?: InputMaybe<InsertListingFloatComparisonExp>;
  min?: InputMaybe<InsertListingFloatComparisonExp>;
  minergie_code?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_bathrooms?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_bedrooms?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_commercial_units?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_flats?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_floors?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_indoor_parkings?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_lifts?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_outdoor_parkings?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_residential_units?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_rooms?: InputMaybe<InsertListingFloatComparisonExp>;
  number_of_toilets?: InputMaybe<InsertListingIntComparisonExp>;
  parking_potential_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  parking_yearly_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  plot_has_constructible_reserve?: InputMaybe<InsertListingBooleanComparisonExp>;
  plot_is_constructible?: InputMaybe<InsertListingBooleanComparisonExp>;
  postcode?: InputMaybe<InsertListingStringComparisonExp>;
  price_per_built_surface_meter_squared?: InputMaybe<InsertListingFloatComparisonExp>;
  price_per_land_surface_meter_squared?: InputMaybe<InsertListingFloatComparisonExp>;
  price_per_living_surface_meter_squared?: InputMaybe<InsertListingFloatComparisonExp>;
  property?: InputMaybe<InsertListingPropertiesBoolExp>;
  property_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_type_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_volume?: InputMaybe<InsertListingFloatComparisonExp>;
  property_volume_norm?: InputMaybe<InsertListingStringComparisonExp>;
  relevant_servitudes?: InputMaybe<InsertListingBooleanComparisonExp>;
  renovation_year?: InputMaybe<InsertListingIntComparisonExp>;
  rent_max?: InputMaybe<InsertListingFloatComparisonExp>;
  rent_min?: InputMaybe<InsertListingFloatComparisonExp>;
  rent_value?: InputMaybe<InsertListingFloatComparisonExp>;
  residential_potential_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  residential_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  residential_yearly_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  route?: InputMaybe<InsertListingStringComparisonExp>;
  share_of_ownership?: InputMaybe<InsertListingFloatComparisonExp>;
  side?: InputMaybe<InsertListingPropertySideEnumEnumComparisonExp>;
  state?: InputMaybe<InsertListingStringComparisonExp>;
  street_number?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  valuations?: InputMaybe<InsertListingValuationsBoolExp>;
  valuations_aggregate?: InputMaybe<InsertListingValuationsAggregateBoolExp>;
  value?: InputMaybe<InsertListingFloatComparisonExp>;
};

export enum InsertListingAppraisalsConstraint {
  /** unique or primary key constraint on columns "id" */
  AppraisalsPkey = 'appraisals_pkey'
}

export type InsertListingAppraisalsInsertInput = {
  appraisal_perceived_value?: InputMaybe<Scalars['Float']['input']>;
  balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  building_condition?: InputMaybe<Scalars['Float']['input']>;
  building_standard?: InputMaybe<Scalars['Float']['input']>;
  building_volume?: InputMaybe<Scalars['Float']['input']>;
  building_volume_norm?: InputMaybe<Scalars['String']['input']>;
  built_surface?: InputMaybe<Scalars['Float']['input']>;
  commercial_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  commercial_surface?: InputMaybe<Scalars['Float']['input']>;
  commercial_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  flat_condition?: InputMaybe<Scalars['Float']['input']>;
  floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  garden_surface?: InputMaybe<Scalars['Float']['input']>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  iazi_address_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  income_includes_parking?: InputMaybe<Scalars['Boolean']['input']>;
  is_commercial_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_luxury?: InputMaybe<Scalars['Boolean']['input']>;
  is_maisonette?: InputMaybe<Scalars['Boolean']['input']>;
  is_parking_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_pending?: InputMaybe<Scalars['Boolean']['input']>;
  is_residential_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_secondary_residence?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  living_surface?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  micro_location?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  minergie_code?: InputMaybe<Scalars['Int']['input']>;
  number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_commercial_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_flats?: InputMaybe<Scalars['Int']['input']>;
  number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_lifts?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_residential_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  number_of_toilets?: InputMaybe<Scalars['Int']['input']>;
  parking_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  parking_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  plot_has_constructible_reserve?: InputMaybe<Scalars['Boolean']['input']>;
  plot_is_constructible?: InputMaybe<Scalars['Boolean']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  price_per_built_surface_meter_squared?: InputMaybe<Scalars['Float']['input']>;
  price_per_land_surface_meter_squared?: InputMaybe<Scalars['Float']['input']>;
  price_per_living_surface_meter_squared?: InputMaybe<Scalars['Float']['input']>;
  property?: InputMaybe<InsertListingPropertiesObjRelInsertInput>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_type_id?: InputMaybe<Scalars['uuid']['input']>;
  property_volume?: InputMaybe<Scalars['Float']['input']>;
  property_volume_norm?: InputMaybe<Scalars['String']['input']>;
  relevant_servitudes?: InputMaybe<Scalars['Boolean']['input']>;
  renovation_year?: InputMaybe<Scalars['Int']['input']>;
  rent_max?: InputMaybe<Scalars['Float']['input']>;
  rent_min?: InputMaybe<Scalars['Float']['input']>;
  rent_value?: InputMaybe<Scalars['Float']['input']>;
  residential_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  residential_surface?: InputMaybe<Scalars['Float']['input']>;
  residential_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  share_of_ownership?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<InsertListingPropertySideEnumEnum>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  valuations?: InputMaybe<InsertListingValuationsArrRelInsertInput>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type InsertListingAppraisalsObjRelInsertInput = {
  data: InsertListingAppraisalsInsertInput;
  on_conflict?: InputMaybe<InsertListingAppraisalsOnConflict>;
};

export type InsertListingAppraisalsOnConflict = {
  constraint: InsertListingAppraisalsConstraint;
  update_columns: Array<InsertListingAppraisalsUpdateColumn>;
  where?: InputMaybe<InsertListingAppraisalsBoolExp>;
};

export enum InsertListingAppraisalsSelectColumn {
  /** column name */
  AppraisalPerceivedValue = 'appraisal_perceived_value',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BuildingCondition = 'building_condition',
  /** column name */
  BuildingStandard = 'building_standard',
  /** column name */
  BuildingVolume = 'building_volume',
  /** column name */
  BuildingVolumeNorm = 'building_volume_norm',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CommercialPotentialRentalIncome = 'commercial_potential_rental_income',
  /** column name */
  CommercialSurface = 'commercial_surface',
  /** column name */
  CommercialYearlyRentalIncome = 'commercial_yearly_rental_income',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Ctn = 'ctn',
  /** column name */
  FlatCondition = 'flat_condition',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  IaziAddressId = 'iazi_address_id',
  /** column name */
  Id = 'id',
  /** column name */
  IncomeIncludesParking = 'income_includes_parking',
  /** column name */
  IsCommercialFullyRented = 'is_commercial_fully_rented',
  /** column name */
  IsLuxury = 'is_luxury',
  /** column name */
  IsMaisonette = 'is_maisonette',
  /** column name */
  IsParkingFullyRented = 'is_parking_fully_rented',
  /** column name */
  IsPending = 'is_pending',
  /** column name */
  IsResidentialFullyRented = 'is_residential_fully_rented',
  /** column name */
  IsSecondaryResidence = 'is_secondary_residence',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  Max = 'max',
  /** column name */
  Method = 'method',
  /** column name */
  MicroLocation = 'micro_location',
  /** column name */
  Min = 'min',
  /** column name */
  MinergieCode = 'minergie_code',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfCommercialUnits = 'number_of_commercial_units',
  /** column name */
  NumberOfFlats = 'number_of_flats',
  /** column name */
  NumberOfFloors = 'number_of_floors',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLifts = 'number_of_lifts',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfResidentialUnits = 'number_of_residential_units',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  ParkingPotentialRentalIncome = 'parking_potential_rental_income',
  /** column name */
  ParkingYearlyRentalIncome = 'parking_yearly_rental_income',
  /** column name */
  PlotHasConstructibleReserve = 'plot_has_constructible_reserve',
  /** column name */
  PlotIsConstructible = 'plot_is_constructible',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PricePerBuiltSurfaceMeterSquared = 'price_per_built_surface_meter_squared',
  /** column name */
  PricePerLandSurfaceMeterSquared = 'price_per_land_surface_meter_squared',
  /** column name */
  PricePerLivingSurfaceMeterSquared = 'price_per_living_surface_meter_squared',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyTypeId = 'property_type_id',
  /** column name */
  PropertyVolume = 'property_volume',
  /** column name */
  PropertyVolumeNorm = 'property_volume_norm',
  /** column name */
  RelevantServitudes = 'relevant_servitudes',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentMax = 'rent_max',
  /** column name */
  RentMin = 'rent_min',
  /** column name */
  RentValue = 'rent_value',
  /** column name */
  ResidentialPotentialRentalIncome = 'residential_potential_rental_income',
  /** column name */
  ResidentialSurface = 'residential_surface',
  /** column name */
  ResidentialYearlyRentalIncome = 'residential_yearly_rental_income',
  /** column name */
  Route = 'route',
  /** column name */
  ShareOfOwnership = 'share_of_ownership',
  /** column name */
  Side = 'side',
  /** column name */
  State = 'state',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

export enum InsertListingAppraisalsSelectColumnAppraisalsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  IncomeIncludesParking = 'income_includes_parking',
  /** column name */
  IsCommercialFullyRented = 'is_commercial_fully_rented',
  /** column name */
  IsLuxury = 'is_luxury',
  /** column name */
  IsMaisonette = 'is_maisonette',
  /** column name */
  IsParkingFullyRented = 'is_parking_fully_rented',
  /** column name */
  IsPending = 'is_pending',
  /** column name */
  IsResidentialFullyRented = 'is_residential_fully_rented',
  /** column name */
  IsSecondaryResidence = 'is_secondary_residence',
  /** column name */
  PlotHasConstructibleReserve = 'plot_has_constructible_reserve',
  /** column name */
  PlotIsConstructible = 'plot_is_constructible',
  /** column name */
  RelevantServitudes = 'relevant_servitudes'
}

export enum InsertListingAppraisalsSelectColumnAppraisalsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  IncomeIncludesParking = 'income_includes_parking',
  /** column name */
  IsCommercialFullyRented = 'is_commercial_fully_rented',
  /** column name */
  IsLuxury = 'is_luxury',
  /** column name */
  IsMaisonette = 'is_maisonette',
  /** column name */
  IsParkingFullyRented = 'is_parking_fully_rented',
  /** column name */
  IsPending = 'is_pending',
  /** column name */
  IsResidentialFullyRented = 'is_residential_fully_rented',
  /** column name */
  IsSecondaryResidence = 'is_secondary_residence',
  /** column name */
  PlotHasConstructibleReserve = 'plot_has_constructible_reserve',
  /** column name */
  PlotIsConstructible = 'plot_is_constructible',
  /** column name */
  RelevantServitudes = 'relevant_servitudes'
}

export enum InsertListingAppraisalsUpdateColumn {
  /** column name */
  AppraisalPerceivedValue = 'appraisal_perceived_value',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BuildingCondition = 'building_condition',
  /** column name */
  BuildingStandard = 'building_standard',
  /** column name */
  BuildingVolume = 'building_volume',
  /** column name */
  BuildingVolumeNorm = 'building_volume_norm',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CommercialPotentialRentalIncome = 'commercial_potential_rental_income',
  /** column name */
  CommercialSurface = 'commercial_surface',
  /** column name */
  CommercialYearlyRentalIncome = 'commercial_yearly_rental_income',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Ctn = 'ctn',
  /** column name */
  FlatCondition = 'flat_condition',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  IaziAddressId = 'iazi_address_id',
  /** column name */
  Id = 'id',
  /** column name */
  IncomeIncludesParking = 'income_includes_parking',
  /** column name */
  IsCommercialFullyRented = 'is_commercial_fully_rented',
  /** column name */
  IsLuxury = 'is_luxury',
  /** column name */
  IsMaisonette = 'is_maisonette',
  /** column name */
  IsParkingFullyRented = 'is_parking_fully_rented',
  /** column name */
  IsPending = 'is_pending',
  /** column name */
  IsResidentialFullyRented = 'is_residential_fully_rented',
  /** column name */
  IsSecondaryResidence = 'is_secondary_residence',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  Max = 'max',
  /** column name */
  Method = 'method',
  /** column name */
  MicroLocation = 'micro_location',
  /** column name */
  Min = 'min',
  /** column name */
  MinergieCode = 'minergie_code',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfCommercialUnits = 'number_of_commercial_units',
  /** column name */
  NumberOfFlats = 'number_of_flats',
  /** column name */
  NumberOfFloors = 'number_of_floors',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLifts = 'number_of_lifts',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfResidentialUnits = 'number_of_residential_units',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  ParkingPotentialRentalIncome = 'parking_potential_rental_income',
  /** column name */
  ParkingYearlyRentalIncome = 'parking_yearly_rental_income',
  /** column name */
  PlotHasConstructibleReserve = 'plot_has_constructible_reserve',
  /** column name */
  PlotIsConstructible = 'plot_is_constructible',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PricePerBuiltSurfaceMeterSquared = 'price_per_built_surface_meter_squared',
  /** column name */
  PricePerLandSurfaceMeterSquared = 'price_per_land_surface_meter_squared',
  /** column name */
  PricePerLivingSurfaceMeterSquared = 'price_per_living_surface_meter_squared',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyTypeId = 'property_type_id',
  /** column name */
  PropertyVolume = 'property_volume',
  /** column name */
  PropertyVolumeNorm = 'property_volume_norm',
  /** column name */
  RelevantServitudes = 'relevant_servitudes',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentMax = 'rent_max',
  /** column name */
  RentMin = 'rent_min',
  /** column name */
  RentValue = 'rent_value',
  /** column name */
  ResidentialPotentialRentalIncome = 'residential_potential_rental_income',
  /** column name */
  ResidentialSurface = 'residential_surface',
  /** column name */
  ResidentialYearlyRentalIncome = 'residential_yearly_rental_income',
  /** column name */
  Route = 'route',
  /** column name */
  ShareOfOwnership = 'share_of_ownership',
  /** column name */
  Side = 'side',
  /** column name */
  State = 'state',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

export type InsertListingBigintComparisonExp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

export type InsertListingBooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type InsertListingBuyerLeadsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingBuyerLeadsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingBuyerLeadsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingBuyerLeadsAggregateBoolExpCount>;
};

export type InsertListingBuyerLeadsAggregateBoolExpBoolAnd = {
  arguments: InsertListingBuyerLeadsSelectColumnBuyerLeadsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingBuyerLeadsAggregateBoolExpBoolOr = {
  arguments: InsertListingBuyerLeadsSelectColumnBuyerLeadsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingBuyerLeadsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingBuyerLeadsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingBuyerLeadsArrRelInsertInput = {
  data: Array<InsertListingBuyerLeadsInsertInput>;
  on_conflict?: InputMaybe<InsertListingBuyerLeadsOnConflict>;
};

export type InsertListingBuyerLeadsBoolExp = {
  _and?: InputMaybe<Array<InsertListingBuyerLeadsBoolExp>>;
  _not?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
  _or?: InputMaybe<Array<InsertListingBuyerLeadsBoolExp>>;
  activities?: InputMaybe<InsertListingActivitiesBoolExp>;
  activities_aggregate?: InputMaybe<InsertListingActivitiesAggregateBoolExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  development_id?: InputMaybe<InsertListingUuidComparisonExp>;
  financial_approval?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  lead_stage?: InputMaybe<InsertListingLeadStagesBoolExp>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  source?: InputMaybe<InsertListingStringComparisonExp>;
  stage_id?: InputMaybe<InsertListingUuidComparisonExp>;
  status?: InputMaybe<InsertListingStringComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  user_order_nr?: InputMaybe<InsertListingIntComparisonExp>;
};

export enum InsertListingBuyerLeadsConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  BuyerLeadsIdTenantIdUnique = 'buyer_leads_id_tenant_id_unique',
  /** unique or primary key constraint on columns "user_id", "lot_id" */
  BuyerLeadsLotIdUserIdUnique = 'buyer_leads_lot_id_user_id_unique',
  /** unique or primary key constraint on columns "id" */
  BuyerLeadsPkey = 'buyer_leads_pkey'
}

export type InsertListingBuyerLeadsInsertInput = {
  activities?: InputMaybe<InsertListingActivitiesArrRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  financial_approval?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead_stage?: InputMaybe<InsertListingLeadStagesObjRelInsertInput>;
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_order_nr?: InputMaybe<Scalars['Int']['input']>;
};

export type InsertListingBuyerLeadsObjRelInsertInput = {
  data: InsertListingBuyerLeadsInsertInput;
  on_conflict?: InputMaybe<InsertListingBuyerLeadsOnConflict>;
};

export type InsertListingBuyerLeadsOnConflict = {
  constraint: InsertListingBuyerLeadsConstraint;
  update_columns: Array<InsertListingBuyerLeadsUpdateColumn>;
  where?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
};

export enum InsertListingBuyerLeadsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  FinancialApproval = 'financial_approval',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  Source = 'source',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserOrderNr = 'user_order_nr'
}

export enum InsertListingBuyerLeadsSelectColumnBuyerLeadsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  FinancialApproval = 'financial_approval'
}

export enum InsertListingBuyerLeadsSelectColumnBuyerLeadsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  FinancialApproval = 'financial_approval'
}

export enum InsertListingBuyerLeadsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  FinancialApproval = 'financial_approval',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  Source = 'source',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserOrderNr = 'user_order_nr'
}

export type InsertListingCatchmentAreasAggregateBoolExp = {
  count?: InputMaybe<InsertListingCatchmentAreasAggregateBoolExpCount>;
};

export type InsertListingCatchmentAreasAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingCatchmentAreasSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCatchmentAreasBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingCatchmentAreasArrRelInsertInput = {
  data: Array<InsertListingCatchmentAreasInsertInput>;
  on_conflict?: InputMaybe<InsertListingCatchmentAreasOnConflict>;
};

export type InsertListingCatchmentAreasBoolExp = {
  _and?: InputMaybe<Array<InsertListingCatchmentAreasBoolExp>>;
  _not?: InputMaybe<InsertListingCatchmentAreasBoolExp>;
  _or?: InputMaybe<Array<InsertListingCatchmentAreasBoolExp>>;
  place?: InputMaybe<InsertListingPlacesBoolExp>;
  place_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingCatchmentAreasConstraint {
  /** unique or primary key constraint on columns "place_id", "user_id", "tenant_id" */
  CatchmentAreasUserIdPlaceIdTenantIdUnique = 'catchment_areas_user_id_place_id_tenant_id_unique'
}

export type InsertListingCatchmentAreasInsertInput = {
  place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingCatchmentAreasOnConflict = {
  constraint: InsertListingCatchmentAreasConstraint;
  update_columns: Array<InsertListingCatchmentAreasUpdateColumn>;
  where?: InputMaybe<InsertListingCatchmentAreasBoolExp>;
};

export enum InsertListingCatchmentAreasSelectColumn {
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingCatchmentAreasUpdateColumn {
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingCitextComparisonExp = {
  _eq?: InputMaybe<Scalars['citext']['input']>;
  _gt?: InputMaybe<Scalars['citext']['input']>;
  _gte?: InputMaybe<Scalars['citext']['input']>;
  _ilike?: InputMaybe<Scalars['citext']['input']>;
  _in?: InputMaybe<Array<Scalars['citext']['input']>>;
  _iregex?: InputMaybe<Scalars['citext']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _like?: InputMaybe<Scalars['citext']['input']>;
  _lt?: InputMaybe<Scalars['citext']['input']>;
  _lte?: InputMaybe<Scalars['citext']['input']>;
  _neq?: InputMaybe<Scalars['citext']['input']>;
  _nilike?: InputMaybe<Scalars['citext']['input']>;
  _nin?: InputMaybe<Array<Scalars['citext']['input']>>;
  _niregex?: InputMaybe<Scalars['citext']['input']>;
  _nlike?: InputMaybe<Scalars['citext']['input']>;
  _nregex?: InputMaybe<Scalars['citext']['input']>;
  _nsimilar?: InputMaybe<Scalars['citext']['input']>;
  _regex?: InputMaybe<Scalars['citext']['input']>;
  _similar?: InputMaybe<Scalars['citext']['input']>;
};

export type InsertListingCmaReportFilesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingCmaReportFilesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingCmaReportFilesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingCmaReportFilesAggregateBoolExpCount>;
};

export type InsertListingCmaReportFilesAggregateBoolExpBoolAnd = {
  arguments: InsertListingCmaReportFilesSelectColumnCmaReportFilesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCmaReportFilesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingCmaReportFilesAggregateBoolExpBoolOr = {
  arguments: InsertListingCmaReportFilesSelectColumnCmaReportFilesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCmaReportFilesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingCmaReportFilesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingCmaReportFilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCmaReportFilesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingCmaReportFilesArrRelInsertInput = {
  data: Array<InsertListingCmaReportFilesInsertInput>;
  on_conflict?: InputMaybe<InsertListingCmaReportFilesOnConflict>;
};

export type InsertListingCmaReportFilesBoolExp = {
  _and?: InputMaybe<Array<InsertListingCmaReportFilesBoolExp>>;
  _not?: InputMaybe<InsertListingCmaReportFilesBoolExp>;
  _or?: InputMaybe<Array<InsertListingCmaReportFilesBoolExp>>;
  cma_report?: InputMaybe<InsertListingCmaReportsBoolExp>;
  cma_report_id?: InputMaybe<InsertListingUuidComparisonExp>;
  file?: InputMaybe<InsertListingFilesBoolExp>;
  file_id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_visible?: InputMaybe<InsertListingBooleanComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  tenant?: InputMaybe<InsertListingTenantsBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingCmaReportFilesConstraint {
  /** unique or primary key constraint on columns "file_id", "cma_report_id" */
  CmaReportFilesCmaReportIdFileIdKey = 'cma_report_files_cma_report_id_file_id_key',
  /** unique or primary key constraint on columns "order_nr", "cma_report_id" */
  CmaReportOrderUnique = 'cma_report_order_unique'
}

export type InsertListingCmaReportFilesInsertInput = {
  cma_report?: InputMaybe<InsertListingCmaReportsObjRelInsertInput>;
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  file?: InputMaybe<InsertListingFilesObjRelInsertInput>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  tenant?: InputMaybe<InsertListingTenantsObjRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingCmaReportFilesOnConflict = {
  constraint: InsertListingCmaReportFilesConstraint;
  update_columns: Array<InsertListingCmaReportFilesUpdateColumn>;
  where?: InputMaybe<InsertListingCmaReportFilesBoolExp>;
};

export enum InsertListingCmaReportFilesSelectColumn {
  /** column name */
  CmaReportId = 'cma_report_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TenantId = 'tenant_id'
}

export enum InsertListingCmaReportFilesSelectColumnCmaReportFilesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsVisible = 'is_visible'
}

export enum InsertListingCmaReportFilesSelectColumnCmaReportFilesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsVisible = 'is_visible'
}

export enum InsertListingCmaReportFilesUpdateColumn {
  /** column name */
  CmaReportId = 'cma_report_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TenantId = 'tenant_id'
}

export type InsertListingCmaReportsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingCmaReportsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingCmaReportsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingCmaReportsAggregateBoolExpCount>;
};

export type InsertListingCmaReportsAggregateBoolExpBoolAnd = {
  arguments: InsertListingCmaReportsSelectColumnCmaReportsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCmaReportsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingCmaReportsAggregateBoolExpBoolOr = {
  arguments: InsertListingCmaReportsSelectColumnCmaReportsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCmaReportsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingCmaReportsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingCmaReportsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCmaReportsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingCmaReportsArrRelInsertInput = {
  data: Array<InsertListingCmaReportsInsertInput>;
  on_conflict?: InputMaybe<InsertListingCmaReportsOnConflict>;
};

export type InsertListingCmaReportsBoolExp = {
  _and?: InputMaybe<Array<InsertListingCmaReportsBoolExp>>;
  _not?: InputMaybe<InsertListingCmaReportsBoolExp>;
  _or?: InputMaybe<Array<InsertListingCmaReportsBoolExp>>;
  broker?: InputMaybe<InsertListingUsersBoolExp>;
  broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  caprate_estimated_monthly_rent?: InputMaybe<InsertListingIntComparisonExp>;
  caprate_minimum_required_yield?: InputMaybe<InsertListingFloatComparisonExp>;
  cma_report_files?: InputMaybe<InsertListingCmaReportFilesBoolExp>;
  cma_report_files_aggregate?: InputMaybe<InsertListingCmaReportFilesAggregateBoolExp>;
  comparable_listings?: InputMaybe<InsertListingCmaReportsComparablesBoolExp>;
  comparable_listings_aggregate?: InputMaybe<InsertListingCmaReportsComparablesAggregateBoolExp>;
  construction_cost_base?: InputMaybe<InsertListingCmaReportsConstructionBaseEnumEnumComparisonExp>;
  contact?: InputMaybe<InsertListingUsersBoolExp>;
  contact_id?: InputMaybe<InsertListingUuidComparisonExp>;
  cover_image?: InputMaybe<InsertListingImagesBoolExp>;
  cover_image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  created_by_user?: InputMaybe<InsertListingUsersBoolExp>;
  description?: InputMaybe<InsertListingStringComparisonExp>;
  doc_template?: InputMaybe<InsertListingDocTemplatesBoolExp>;
  doc_template_id?: InputMaybe<InsertListingUuidComparisonExp>;
  font_family?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  include_agent?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_agent_agency?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_append_files?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_client_testimonial?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_comparables_valuation?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_cover?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_cuprate_valuation?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_description?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_final_value?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_hedonistic_valuation?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_intrinsic_valuation?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_introduction?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_potential_buyers?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_property?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_valuation_methods?: InputMaybe<InsertListingBooleanComparisonExp>;
  intrinsic_annual_deprecation_rate?: InputMaybe<InsertListingFloatComparisonExp>;
  intrinsic_building_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  intrinsic_construction_cost?: InputMaybe<InsertListingIntComparisonExp>;
  intrinsic_custom_fields?: InputMaybe<InsertListingJsonbComparisonExp>;
  intrinsic_land_value?: InputMaybe<InsertListingIntComparisonExp>;
  introduction?: InputMaybe<InsertListingStringComparisonExp>;
  is_price_range?: InputMaybe<InsertListingBooleanComparisonExp>;
  language?: InputMaybe<InsertListingUserLanguageComparisonExp>;
  lead?: InputMaybe<InsertListingLeadsBoolExp>;
  lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  max_budget?: InputMaybe<InsertListingIntComparisonExp>;
  min_budget?: InputMaybe<InsertListingIntComparisonExp>;
  negative_comments?: InputMaybe<InsertListingStringComparisonExp>;
  positive_comments?: InputMaybe<InsertListingStringComparisonExp>;
  price_range_max?: InputMaybe<InsertListingIntComparisonExp>;
  price_range_min?: InputMaybe<InsertListingIntComparisonExp>;
  probability_max?: InputMaybe<InsertListingFloatComparisonExp>;
  probability_min?: InputMaybe<InsertListingFloatComparisonExp>;
  probability_time_period?: InputMaybe<InsertListingIntComparisonExp>;
  report_title?: InputMaybe<InsertListingStringComparisonExp>;
  show_probability?: InputMaybe<InsertListingBooleanComparisonExp>;
  suggested_market_value?: InputMaybe<InsertListingIntComparisonExp>;
  tenant?: InputMaybe<InsertListingTenantsBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
};

export type InsertListingCmaReportsComparablesAggregateBoolExp = {
  count?: InputMaybe<InsertListingCmaReportsComparablesAggregateBoolExpCount>;
};

export type InsertListingCmaReportsComparablesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingCmaReportsComparablesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCmaReportsComparablesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingCmaReportsComparablesArrRelInsertInput = {
  data: Array<InsertListingCmaReportsComparablesInsertInput>;
  on_conflict?: InputMaybe<InsertListingCmaReportsComparablesOnConflict>;
};

export type InsertListingCmaReportsComparablesBoolExp = {
  _and?: InputMaybe<Array<InsertListingCmaReportsComparablesBoolExp>>;
  _not?: InputMaybe<InsertListingCmaReportsComparablesBoolExp>;
  _or?: InputMaybe<Array<InsertListingCmaReportsComparablesBoolExp>>;
  aggregates_db__merged_listings_clusters_id?: InputMaybe<InsertListingBigintComparisonExp>;
  cma_report?: InputMaybe<InsertListingCmaReportsBoolExp>;
  cma_report_id?: InputMaybe<InsertListingUuidComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  listing_snapshot?: InputMaybe<InsertListingJsonbComparisonExp>;
  order_nr?: InputMaybe<InsertListingFloatComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingCmaReportsComparablesConstraint {
  /** unique or primary key constraint on columns "cma_report_id", "aggregates_db__merged_listings_clusters_id" */
  CmaReportsComparablesIdListingIdUnique = 'cma_reports_comparables_id_listing_id_unique',
  /** unique or primary key constraint on columns "order_nr", "cma_report_id" */
  CmaReportsComparablesIdOrderNrUnique = 'cma_reports_comparables_id_order_nr_unique'
}

export type InsertListingCmaReportsComparablesInsertInput = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Scalars['bigint']['input']>;
  cma_report?: InputMaybe<InsertListingCmaReportsObjRelInsertInput>;
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  listing_snapshot?: InputMaybe<Scalars['jsonb']['input']>;
  order_nr?: InputMaybe<Scalars['Float']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingCmaReportsComparablesOnConflict = {
  constraint: InsertListingCmaReportsComparablesConstraint;
  update_columns: Array<InsertListingCmaReportsComparablesUpdateColumn>;
  where?: InputMaybe<InsertListingCmaReportsComparablesBoolExp>;
};

export enum InsertListingCmaReportsComparablesSelectColumn {
  /** column name */
  AggregatesDbMergedListingsClustersId = 'aggregates_db__merged_listings_clusters_id',
  /** column name */
  CmaReportId = 'cma_report_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ListingSnapshot = 'listing_snapshot',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingCmaReportsComparablesUpdateColumn {
  /** column name */
  AggregatesDbMergedListingsClustersId = 'aggregates_db__merged_listings_clusters_id',
  /** column name */
  CmaReportId = 'cma_report_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ListingSnapshot = 'listing_snapshot',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingCmaReportsConstraint {
  /** unique or primary key constraint on columns "id" */
  CmaReportsPkey = 'cma_reports_pkey'
}

export enum InsertListingCmaReportsConstructionBaseEnumEnum {
  Surface = 'surface',
  Volume = 'volume'
}

export type InsertListingCmaReportsConstructionBaseEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingCmaReportsConstructionBaseEnumEnum>;
  _in?: InputMaybe<Array<InsertListingCmaReportsConstructionBaseEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingCmaReportsConstructionBaseEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingCmaReportsConstructionBaseEnumEnum>>;
};

export type InsertListingCmaReportsInsertInput = {
  broker?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  caprate_estimated_monthly_rent?: InputMaybe<Scalars['Int']['input']>;
  caprate_minimum_required_yield?: InputMaybe<Scalars['Float']['input']>;
  cma_report_files?: InputMaybe<InsertListingCmaReportFilesArrRelInsertInput>;
  comparable_listings?: InputMaybe<InsertListingCmaReportsComparablesArrRelInsertInput>;
  construction_cost_base?: InputMaybe<InsertListingCmaReportsConstructionBaseEnumEnum>;
  contact?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  cover_image?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  cover_image_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  doc_template?: InputMaybe<InsertListingDocTemplatesObjRelInsertInput>;
  doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  font_family?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_agent?: InputMaybe<Scalars['Boolean']['input']>;
  include_agent_agency?: InputMaybe<Scalars['Boolean']['input']>;
  include_append_files?: InputMaybe<Scalars['Boolean']['input']>;
  include_client_testimonial?: InputMaybe<Scalars['Boolean']['input']>;
  include_comparables_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_cover?: InputMaybe<Scalars['Boolean']['input']>;
  include_cuprate_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_description?: InputMaybe<Scalars['Boolean']['input']>;
  include_final_value?: InputMaybe<Scalars['Boolean']['input']>;
  include_hedonistic_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_intrinsic_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_introduction?: InputMaybe<Scalars['Boolean']['input']>;
  include_potential_buyers?: InputMaybe<Scalars['Boolean']['input']>;
  include_property?: InputMaybe<Scalars['Boolean']['input']>;
  include_valuation_methods?: InputMaybe<Scalars['Boolean']['input']>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_building_surface?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_construction_cost?: InputMaybe<Scalars['Int']['input']>;
  intrinsic_custom_fields?: InputMaybe<Scalars['jsonb']['input']>;
  intrinsic_land_value?: InputMaybe<Scalars['Int']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  is_price_range?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  lead?: InputMaybe<InsertListingLeadsObjRelInsertInput>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  max_budget?: InputMaybe<Scalars['Int']['input']>;
  min_budget?: InputMaybe<Scalars['Int']['input']>;
  negative_comments?: InputMaybe<Scalars['String']['input']>;
  positive_comments?: InputMaybe<Scalars['String']['input']>;
  price_range_max?: InputMaybe<Scalars['Int']['input']>;
  price_range_min?: InputMaybe<Scalars['Int']['input']>;
  probability_max?: InputMaybe<Scalars['Float']['input']>;
  probability_min?: InputMaybe<Scalars['Float']['input']>;
  probability_time_period?: InputMaybe<Scalars['Int']['input']>;
  report_title?: InputMaybe<Scalars['String']['input']>;
  show_probability?: InputMaybe<Scalars['Boolean']['input']>;
  suggested_market_value?: InputMaybe<Scalars['Int']['input']>;
  tenant?: InputMaybe<InsertListingTenantsObjRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
};

export type InsertListingCmaReportsObjRelInsertInput = {
  data: InsertListingCmaReportsInsertInput;
  on_conflict?: InputMaybe<InsertListingCmaReportsOnConflict>;
};

export type InsertListingCmaReportsOnConflict = {
  constraint: InsertListingCmaReportsConstraint;
  update_columns: Array<InsertListingCmaReportsUpdateColumn>;
  where?: InputMaybe<InsertListingCmaReportsBoolExp>;
};

export enum InsertListingCmaReportsSelectColumn {
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CaprateEstimatedMonthlyRent = 'caprate_estimated_monthly_rent',
  /** column name */
  CaprateMinimumRequiredYield = 'caprate_minimum_required_yield',
  /** column name */
  ConstructionCostBase = 'construction_cost_base',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CoverImageId = 'cover_image_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  DocTemplateId = 'doc_template_id',
  /** column name */
  FontFamily = 'font_family',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeAgent = 'include_agent',
  /** column name */
  IncludeAgentAgency = 'include_agent_agency',
  /** column name */
  IncludeAppendFiles = 'include_append_files',
  /** column name */
  IncludeClientTestimonial = 'include_client_testimonial',
  /** column name */
  IncludeComparablesValuation = 'include_comparables_valuation',
  /** column name */
  IncludeCover = 'include_cover',
  /** column name */
  IncludeCuprateValuation = 'include_cuprate_valuation',
  /** column name */
  IncludeDescription = 'include_description',
  /** column name */
  IncludeFinalValue = 'include_final_value',
  /** column name */
  IncludeHedonisticValuation = 'include_hedonistic_valuation',
  /** column name */
  IncludeIntrinsicValuation = 'include_intrinsic_valuation',
  /** column name */
  IncludeIntroduction = 'include_introduction',
  /** column name */
  IncludePotentialBuyers = 'include_potential_buyers',
  /** column name */
  IncludeProperty = 'include_property',
  /** column name */
  IncludeValuationMethods = 'include_valuation_methods',
  /** column name */
  IntrinsicAnnualDeprecationRate = 'intrinsic_annual_deprecation_rate',
  /** column name */
  IntrinsicBuildingSurface = 'intrinsic_building_surface',
  /** column name */
  IntrinsicConstructionCost = 'intrinsic_construction_cost',
  /** column name */
  IntrinsicCustomFields = 'intrinsic_custom_fields',
  /** column name */
  IntrinsicLandValue = 'intrinsic_land_value',
  /** column name */
  Introduction = 'introduction',
  /** column name */
  IsPriceRange = 'is_price_range',
  /** column name */
  Language = 'language',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  MaxBudget = 'max_budget',
  /** column name */
  MinBudget = 'min_budget',
  /** column name */
  NegativeComments = 'negative_comments',
  /** column name */
  PositiveComments = 'positive_comments',
  /** column name */
  PriceRangeMax = 'price_range_max',
  /** column name */
  PriceRangeMin = 'price_range_min',
  /** column name */
  ProbabilityMax = 'probability_max',
  /** column name */
  ProbabilityMin = 'probability_min',
  /** column name */
  ProbabilityTimePeriod = 'probability_time_period',
  /** column name */
  ReportTitle = 'report_title',
  /** column name */
  ShowProbability = 'show_probability',
  /** column name */
  SuggestedMarketValue = 'suggested_market_value',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingCmaReportsSelectColumnCmaReportsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IncludeAgent = 'include_agent',
  /** column name */
  IncludeAgentAgency = 'include_agent_agency',
  /** column name */
  IncludeAppendFiles = 'include_append_files',
  /** column name */
  IncludeClientTestimonial = 'include_client_testimonial',
  /** column name */
  IncludeComparablesValuation = 'include_comparables_valuation',
  /** column name */
  IncludeCover = 'include_cover',
  /** column name */
  IncludeCuprateValuation = 'include_cuprate_valuation',
  /** column name */
  IncludeDescription = 'include_description',
  /** column name */
  IncludeFinalValue = 'include_final_value',
  /** column name */
  IncludeHedonisticValuation = 'include_hedonistic_valuation',
  /** column name */
  IncludeIntrinsicValuation = 'include_intrinsic_valuation',
  /** column name */
  IncludeIntroduction = 'include_introduction',
  /** column name */
  IncludePotentialBuyers = 'include_potential_buyers',
  /** column name */
  IncludeProperty = 'include_property',
  /** column name */
  IncludeValuationMethods = 'include_valuation_methods',
  /** column name */
  IsPriceRange = 'is_price_range',
  /** column name */
  ShowProbability = 'show_probability'
}

export enum InsertListingCmaReportsSelectColumnCmaReportsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IncludeAgent = 'include_agent',
  /** column name */
  IncludeAgentAgency = 'include_agent_agency',
  /** column name */
  IncludeAppendFiles = 'include_append_files',
  /** column name */
  IncludeClientTestimonial = 'include_client_testimonial',
  /** column name */
  IncludeComparablesValuation = 'include_comparables_valuation',
  /** column name */
  IncludeCover = 'include_cover',
  /** column name */
  IncludeCuprateValuation = 'include_cuprate_valuation',
  /** column name */
  IncludeDescription = 'include_description',
  /** column name */
  IncludeFinalValue = 'include_final_value',
  /** column name */
  IncludeHedonisticValuation = 'include_hedonistic_valuation',
  /** column name */
  IncludeIntrinsicValuation = 'include_intrinsic_valuation',
  /** column name */
  IncludeIntroduction = 'include_introduction',
  /** column name */
  IncludePotentialBuyers = 'include_potential_buyers',
  /** column name */
  IncludeProperty = 'include_property',
  /** column name */
  IncludeValuationMethods = 'include_valuation_methods',
  /** column name */
  IsPriceRange = 'is_price_range',
  /** column name */
  ShowProbability = 'show_probability'
}

export enum InsertListingCmaReportsUpdateColumn {
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CaprateEstimatedMonthlyRent = 'caprate_estimated_monthly_rent',
  /** column name */
  CaprateMinimumRequiredYield = 'caprate_minimum_required_yield',
  /** column name */
  ConstructionCostBase = 'construction_cost_base',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CoverImageId = 'cover_image_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  DocTemplateId = 'doc_template_id',
  /** column name */
  FontFamily = 'font_family',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeAgent = 'include_agent',
  /** column name */
  IncludeAgentAgency = 'include_agent_agency',
  /** column name */
  IncludeAppendFiles = 'include_append_files',
  /** column name */
  IncludeClientTestimonial = 'include_client_testimonial',
  /** column name */
  IncludeComparablesValuation = 'include_comparables_valuation',
  /** column name */
  IncludeCover = 'include_cover',
  /** column name */
  IncludeCuprateValuation = 'include_cuprate_valuation',
  /** column name */
  IncludeDescription = 'include_description',
  /** column name */
  IncludeFinalValue = 'include_final_value',
  /** column name */
  IncludeHedonisticValuation = 'include_hedonistic_valuation',
  /** column name */
  IncludeIntrinsicValuation = 'include_intrinsic_valuation',
  /** column name */
  IncludeIntroduction = 'include_introduction',
  /** column name */
  IncludePotentialBuyers = 'include_potential_buyers',
  /** column name */
  IncludeProperty = 'include_property',
  /** column name */
  IncludeValuationMethods = 'include_valuation_methods',
  /** column name */
  IntrinsicAnnualDeprecationRate = 'intrinsic_annual_deprecation_rate',
  /** column name */
  IntrinsicBuildingSurface = 'intrinsic_building_surface',
  /** column name */
  IntrinsicConstructionCost = 'intrinsic_construction_cost',
  /** column name */
  IntrinsicCustomFields = 'intrinsic_custom_fields',
  /** column name */
  IntrinsicLandValue = 'intrinsic_land_value',
  /** column name */
  Introduction = 'introduction',
  /** column name */
  IsPriceRange = 'is_price_range',
  /** column name */
  Language = 'language',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  MaxBudget = 'max_budget',
  /** column name */
  MinBudget = 'min_budget',
  /** column name */
  NegativeComments = 'negative_comments',
  /** column name */
  PositiveComments = 'positive_comments',
  /** column name */
  PriceRangeMax = 'price_range_max',
  /** column name */
  PriceRangeMin = 'price_range_min',
  /** column name */
  ProbabilityMax = 'probability_max',
  /** column name */
  ProbabilityMin = 'probability_min',
  /** column name */
  ProbabilityTimePeriod = 'probability_time_period',
  /** column name */
  ReportTitle = 'report_title',
  /** column name */
  ShowProbability = 'show_probability',
  /** column name */
  SuggestedMarketValue = 'suggested_market_value',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingCombinedReviewsAggregateBoolExp = {
  count?: InputMaybe<InsertListingCombinedReviewsAggregateBoolExpCount>;
};

export type InsertListingCombinedReviewsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingCombinedReviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCombinedReviewsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingCombinedReviewsArrRelInsertInput = {
  data: Array<InsertListingCombinedReviewsInsertInput>;
};

export type InsertListingCombinedReviewsBoolExp = {
  _and?: InputMaybe<Array<InsertListingCombinedReviewsBoolExp>>;
  _not?: InputMaybe<InsertListingCombinedReviewsBoolExp>;
  _or?: InputMaybe<Array<InsertListingCombinedReviewsBoolExp>>;
  display_name?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingStringComparisonExp>;
  organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  profile_image_url?: InputMaybe<InsertListingStringComparisonExp>;
  rating?: InputMaybe<InsertListingIntComparisonExp>;
  review_date?: InputMaybe<InsertListingStringComparisonExp>;
  review_text?: InputMaybe<InsertListingStringComparisonExp>;
  review_url?: InputMaybe<InsertListingStringComparisonExp>;
  team?: InputMaybe<InsertListingTeamsBoolExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  type?: InputMaybe<InsertListingStringComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export type InsertListingCombinedReviewsInsertInput = {
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_date?: InputMaybe<Scalars['String']['input']>;
  review_text?: InputMaybe<Scalars['String']['input']>;
  review_url?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export enum InsertListingCombinedReviewsSelectColumn {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewDate = 'review_date',
  /** column name */
  ReviewText = 'review_text',
  /** column name */
  ReviewUrl = 'review_url',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingCommissionsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingCommissionsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingCommissionsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingCommissionsAggregateBoolExpCount>;
};

export type InsertListingCommissionsAggregateBoolExpBoolAnd = {
  arguments: InsertListingCommissionsSelectColumnCommissionsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCommissionsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingCommissionsAggregateBoolExpBoolOr = {
  arguments: InsertListingCommissionsSelectColumnCommissionsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCommissionsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingCommissionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingCommissionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCommissionsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingCommissionsArrRelInsertInput = {
  data: Array<InsertListingCommissionsInsertInput>;
  on_conflict?: InputMaybe<InsertListingCommissionsOnConflict>;
};

export type InsertListingCommissionsBoolExp = {
  _and?: InputMaybe<Array<InsertListingCommissionsBoolExp>>;
  _not?: InputMaybe<InsertListingCommissionsBoolExp>;
  _or?: InputMaybe<Array<InsertListingCommissionsBoolExp>>;
  amount?: InputMaybe<InsertListingFloatComparisonExp>;
  beneficiary_team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  contact?: InputMaybe<InsertListingUsersBoolExp>;
  contact_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_paid?: InputMaybe<InsertListingBooleanComparisonExp>;
  payment_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  property_transaction_id?: InputMaybe<InsertListingUuidComparisonExp>;
  team?: InputMaybe<InsertListingTeamsBoolExp>;
  transaction?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  type?: InputMaybe<InsertListingStringComparisonExp>;
  vat?: InputMaybe<InsertListingFloatComparisonExp>;
};

export enum InsertListingCommissionsConstraint {
  /** unique or primary key constraint on columns "id" */
  CommissionsPkey = 'commissions_pkey',
  /** unique or primary key constraint on columns "property_transaction_id", "type" */
  IdxPropertyTransactionCommissionTotal = 'idx_property_transaction_commission_total'
}

export type InsertListingCommissionsInsertInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  beneficiary_team_id?: InputMaybe<Scalars['uuid']['input']>;
  contact?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  property_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  transaction?: InputMaybe<InsertListingPropertyTransactionsObjRelInsertInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['Float']['input']>;
};

export type InsertListingCommissionsOnConflict = {
  constraint: InsertListingCommissionsConstraint;
  update_columns: Array<InsertListingCommissionsUpdateColumn>;
  where?: InputMaybe<InsertListingCommissionsBoolExp>;
};

export enum InsertListingCommissionsSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  BeneficiaryTeamId = 'beneficiary_team_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PropertyTransactionId = 'property_transaction_id',
  /** column name */
  Type = 'type',
  /** column name */
  Vat = 'vat'
}

export enum InsertListingCommissionsSelectColumnCommissionsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsPaid = 'is_paid'
}

export enum InsertListingCommissionsSelectColumnCommissionsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsPaid = 'is_paid'
}

export enum InsertListingCommissionsUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  BeneficiaryTeamId = 'beneficiary_team_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PropertyTransactionId = 'property_transaction_id',
  /** column name */
  Type = 'type',
  /** column name */
  Vat = 'vat'
}

export enum InsertListingCoolingEnumEnum {
  AirConditioning = 'air_conditioning',
  CeilingFans = 'ceiling_fans',
  None = 'none'
}

export type InsertListingCoolingEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingCoolingEnumEnum>;
  _in?: InputMaybe<Array<InsertListingCoolingEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingCoolingEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingCoolingEnumEnum>>;
};

export type InsertListingCurrenciesComparisonExp = {
  _eq?: InputMaybe<Scalars['currencies']['input']>;
  _gt?: InputMaybe<Scalars['currencies']['input']>;
  _gte?: InputMaybe<Scalars['currencies']['input']>;
  _in?: InputMaybe<Array<Scalars['currencies']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['currencies']['input']>;
  _lte?: InputMaybe<Scalars['currencies']['input']>;
  _neq?: InputMaybe<Scalars['currencies']['input']>;
  _nin?: InputMaybe<Array<Scalars['currencies']['input']>>;
};

export type InsertListingDateComparisonExp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

export type InsertListingDevelopmentImagesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingDevelopmentImagesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingDevelopmentImagesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingDevelopmentImagesAggregateBoolExpCount>;
};

export type InsertListingDevelopmentImagesAggregateBoolExpBoolAnd = {
  arguments: InsertListingDevelopmentImagesSelectColumnDevelopmentImagesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingDevelopmentImagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingDevelopmentImagesAggregateBoolExpBoolOr = {
  arguments: InsertListingDevelopmentImagesSelectColumnDevelopmentImagesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingDevelopmentImagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingDevelopmentImagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingDevelopmentImagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingDevelopmentImagesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingDevelopmentImagesArrRelInsertInput = {
  data: Array<InsertListingDevelopmentImagesInsertInput>;
  on_conflict?: InputMaybe<InsertListingDevelopmentImagesOnConflict>;
};

export type InsertListingDevelopmentImagesBoolExp = {
  _and?: InputMaybe<Array<InsertListingDevelopmentImagesBoolExp>>;
  _not?: InputMaybe<InsertListingDevelopmentImagesBoolExp>;
  _or?: InputMaybe<Array<InsertListingDevelopmentImagesBoolExp>>;
  background_color?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  crop?: InputMaybe<InsertListingStringComparisonExp>;
  description?: InputMaybe<InsertListingStringComparisonExp>;
  development_id?: InputMaybe<InsertListingUuidComparisonExp>;
  display_on_brochure?: InputMaybe<InsertListingBooleanComparisonExp>;
  display_on_listing?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  image?: InputMaybe<InsertListingImagesBoolExp>;
  image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  size?: InputMaybe<InsertListingStringComparisonExp>;
  title?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingDevelopmentImagesConstraint {
  /** unique or primary key constraint on columns "development_id", "image_id" */
  DevelopmentImagesDevelopmentIdImageIdUnique = 'development_images_development_id_image_id_unique',
  /** unique or primary key constraint on columns "order_nr", "development_id" */
  DevelopmentImagesDevelopmentIdOrderNrUnique = 'development_images_development_id_order_nr_unique',
  /** unique or primary key constraint on columns "id" */
  DevelopmentImagesPkey = 'development_images_pkey'
}

export type InsertListingDevelopmentImagesInsertInput = {
  background_color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  display_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  display_on_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingDevelopmentImagesOnConflict = {
  constraint: InsertListingDevelopmentImagesConstraint;
  update_columns: Array<InsertListingDevelopmentImagesUpdateColumn>;
  where?: InputMaybe<InsertListingDevelopmentImagesBoolExp>;
};

export enum InsertListingDevelopmentImagesSelectColumn {
  /** column name */
  BackgroundColor = 'background_color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crop = 'crop',
  /** column name */
  Description = 'description',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  Size = 'size',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingDevelopmentImagesSelectColumnDevelopmentImagesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing'
}

export enum InsertListingDevelopmentImagesSelectColumnDevelopmentImagesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing'
}

export enum InsertListingDevelopmentImagesUpdateColumn {
  /** column name */
  BackgroundColor = 'background_color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crop = 'crop',
  /** column name */
  Description = 'description',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  Size = 'size',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingDevelopmentMappingsAggregateBoolExp = {
  count?: InputMaybe<InsertListingDevelopmentMappingsAggregateBoolExpCount>;
};

export type InsertListingDevelopmentMappingsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingDevelopmentMappingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingDevelopmentMappingsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingDevelopmentMappingsArrRelInsertInput = {
  data: Array<InsertListingDevelopmentMappingsInsertInput>;
  on_conflict?: InputMaybe<InsertListingDevelopmentMappingsOnConflict>;
};

export type InsertListingDevelopmentMappingsBoolExp = {
  _and?: InputMaybe<Array<InsertListingDevelopmentMappingsBoolExp>>;
  _not?: InputMaybe<InsertListingDevelopmentMappingsBoolExp>;
  _or?: InputMaybe<Array<InsertListingDevelopmentMappingsBoolExp>>;
  image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  svg_path?: InputMaybe<InsertListingStringComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingDevelopmentMappingsConstraint {
  /** unique or primary key constraint on columns "image_id", "lot_id" */
  DevelopmentMappingsPkey = 'development_mappings_pkey'
}

export type InsertListingDevelopmentMappingsInsertInput = {
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  svg_path?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingDevelopmentMappingsOnConflict = {
  constraint: InsertListingDevelopmentMappingsConstraint;
  update_columns: Array<InsertListingDevelopmentMappingsUpdateColumn>;
  where?: InputMaybe<InsertListingDevelopmentMappingsBoolExp>;
};

export enum InsertListingDevelopmentMappingsSelectColumn {
  /** column name */
  ImageId = 'image_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  SvgPath = 'svg_path',
  /** column name */
  TenantId = 'tenant_id'
}

export enum InsertListingDevelopmentMappingsUpdateColumn {
  /** column name */
  ImageId = 'image_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  SvgPath = 'svg_path',
  /** column name */
  TenantId = 'tenant_id'
}

export type InsertListingDevelopmentsBoolExp = {
  _and?: InputMaybe<Array<InsertListingDevelopmentsBoolExp>>;
  _not?: InputMaybe<InsertListingDevelopmentsBoolExp>;
  _or?: InputMaybe<Array<InsertListingDevelopmentsBoolExp>>;
  architect_id?: InputMaybe<InsertListingUuidComparisonExp>;
  broker?: InputMaybe<InsertListingUsersBoolExp>;
  broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  delivery_date?: InputMaybe<InsertListingDateComparisonExp>;
  description?: InputMaybe<InsertListingStringComparisonExp>;
  developer_id?: InputMaybe<InsertListingUuidComparisonExp>;
  development_images?: InputMaybe<InsertListingDevelopmentImagesBoolExp>;
  development_images_aggregate?: InputMaybe<InsertListingDevelopmentImagesAggregateBoolExp>;
  email_templates?: InputMaybe<InsertListingEmailTemplatesBoolExp>;
  email_templates_aggregate?: InputMaybe<InsertListingEmailTemplatesAggregateBoolExp>;
  enquiry_response_enabled?: InputMaybe<InsertListingBooleanComparisonExp>;
  enquiry_response_override_lot?: InputMaybe<InsertListingBooleanComparisonExp>;
  general_contractor_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_published?: InputMaybe<InsertListingBooleanComparisonExp>;
  lots?: InputMaybe<InsertListingLotsBoolExp>;
  lots_aggregate?: InputMaybe<InsertListingLotsAggregateBoolExp>;
  mapping_image?: InputMaybe<InsertListingImagesBoolExp>;
  mapping_image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  registration_type?: InputMaybe<InsertListingStringComparisonExp>;
  response_sender_id?: InputMaybe<InsertListingUuidComparisonExp>;
  slug?: InputMaybe<InsertListingStringComparisonExp>;
  status?: InputMaybe<InsertListingStringComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  title?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingDevelopmentsConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  DevelopmentsIdTenantIdUnique = 'developments_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  DevelopmentsPkey = 'developments_pkey',
  /** unique or primary key constraint on columns "slug", "tenant_id" */
  DevelopmentsSlugTenantIdUnique = 'developments_slug_tenant_id_unique'
}

export type InsertListingDevelopmentsInsertInput = {
  architect_id?: InputMaybe<Scalars['uuid']['input']>;
  broker?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  delivery_date?: InputMaybe<Scalars['date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  developer_id?: InputMaybe<Scalars['uuid']['input']>;
  development_images?: InputMaybe<InsertListingDevelopmentImagesArrRelInsertInput>;
  email_templates?: InputMaybe<InsertListingEmailTemplatesArrRelInsertInput>;
  enquiry_response_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enquiry_response_override_lot?: InputMaybe<Scalars['Boolean']['input']>;
  general_contractor_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  lots?: InputMaybe<InsertListingLotsArrRelInsertInput>;
  mapping_image?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  mapping_image_id?: InputMaybe<Scalars['uuid']['input']>;
  registration_type?: InputMaybe<Scalars['String']['input']>;
  response_sender_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingDevelopmentsObjRelInsertInput = {
  data: InsertListingDevelopmentsInsertInput;
  on_conflict?: InputMaybe<InsertListingDevelopmentsOnConflict>;
};

export type InsertListingDevelopmentsOnConflict = {
  constraint: InsertListingDevelopmentsConstraint;
  update_columns: Array<InsertListingDevelopmentsUpdateColumn>;
  where?: InputMaybe<InsertListingDevelopmentsBoolExp>;
};

export enum InsertListingDevelopmentsUpdateColumn {
  /** column name */
  ArchitectId = 'architect_id',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DeliveryDate = 'delivery_date',
  /** column name */
  Description = 'description',
  /** column name */
  DeveloperId = 'developer_id',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  EnquiryResponseOverrideLot = 'enquiry_response_override_lot',
  /** column name */
  GeneralContractorId = 'general_contractor_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  MappingImageId = 'mapping_image_id',
  /** column name */
  RegistrationType = 'registration_type',
  /** column name */
  ResponseSenderId = 'response_sender_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingDictionariesBoolExp = {
  _and?: InputMaybe<Array<InsertListingDictionariesBoolExp>>;
  _not?: InputMaybe<InsertListingDictionariesBoolExp>;
  _or?: InputMaybe<Array<InsertListingDictionariesBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  dictionaries_types?: InputMaybe<InsertListingDictionariesTypesEnumBoolExp>;
  group?: InputMaybe<InsertListingDictionariesBoolExp>;
  group_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_deletable?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_used?: InputMaybe<InsertListingBooleanComparisonExp>;
  label?: InputMaybe<InsertListingStringComparisonExp>;
  label_de?: InputMaybe<InsertListingStringComparisonExp>;
  label_en?: InputMaybe<InsertListingStringComparisonExp>;
  label_es?: InputMaybe<InsertListingStringComparisonExp>;
  label_fr?: InputMaybe<InsertListingStringComparisonExp>;
  label_it?: InputMaybe<InsertListingStringComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  type?: InputMaybe<InsertListingDictionariesTypesEnumEnumComparisonExp>;
  types?: InputMaybe<InsertListingStringArrayComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingDictionariesConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  DictionariesIdTenantIdUnique = 'dictionaries_id_tenant_id_unique',
  /** unique or primary key constraint on columns "type", "name" */
  DictionariesNameTypeKey = 'dictionaries_name_type_key',
  /** unique or primary key constraint on columns "type", "tenant_id", "name" */
  DictionariesNameTypeTenantIdKey = 'dictionaries_name_type_tenant_id_key',
  /** unique or primary key constraint on columns "id" */
  DictionariesPkey = 'dictionaries_pkey'
}

export type InsertListingDictionariesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dictionaries_types?: InputMaybe<InsertListingDictionariesTypesEnumObjRelInsertInput>;
  group?: InputMaybe<InsertListingDictionariesObjRelInsertInput>;
  group_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deletable?: InputMaybe<Scalars['Boolean']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<InsertListingDictionariesTypesEnumEnum>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingDictionariesObjRelInsertInput = {
  data: InsertListingDictionariesInsertInput;
  on_conflict?: InputMaybe<InsertListingDictionariesOnConflict>;
};

export type InsertListingDictionariesOnConflict = {
  constraint: InsertListingDictionariesConstraint;
  update_columns: Array<InsertListingDictionariesUpdateColumn>;
  where?: InputMaybe<InsertListingDictionariesBoolExp>;
};

export type InsertListingDictionariesTypesEnumBoolExp = {
  _and?: InputMaybe<Array<InsertListingDictionariesTypesEnumBoolExp>>;
  _not?: InputMaybe<InsertListingDictionariesTypesEnumBoolExp>;
  _or?: InputMaybe<Array<InsertListingDictionariesTypesEnumBoolExp>>;
  comment?: InputMaybe<InsertListingStringComparisonExp>;
  label?: InputMaybe<InsertListingStringComparisonExp>;
  value?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingDictionariesTypesEnumConstraint {
  /** unique or primary key constraint on columns "value" */
  DictionariesTypesEnumPkey = 'dictionaries_types_enum_pkey'
}

export enum InsertListingDictionariesTypesEnumEnum {
  /** Certifications available for users */
  Certifications = 'certifications',
  DocumentTypeGroups = 'document_type_groups',
  Documents = 'documents',
  Enums = 'enums',
  Languages = 'languages',
  LeadRefusedTypes = 'lead_refused_types',
  LeadSourceTypes = 'lead_source_types',
  LotOriginTypes = 'lot_origin_types',
  MandateProbabilityTypes = 'mandate_probability_types',
  MembershipTypes = 'membership_types',
  NationalityTypes = 'nationality_types',
  OccupationTypes = 'occupation_types',
  OfferRefusedTypes = 'offer_refused_types',
  Services = 'services',
  StringFilters = 'string_filters',
  TagsTypes = 'tags_types',
  WorkPermitTypes = 'work_permit_types'
}

export type InsertListingDictionariesTypesEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingDictionariesTypesEnumEnum>;
  _in?: InputMaybe<Array<InsertListingDictionariesTypesEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingDictionariesTypesEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingDictionariesTypesEnumEnum>>;
};

export type InsertListingDictionariesTypesEnumInsertInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingDictionariesTypesEnumObjRelInsertInput = {
  data: InsertListingDictionariesTypesEnumInsertInput;
  on_conflict?: InputMaybe<InsertListingDictionariesTypesEnumOnConflict>;
};

export type InsertListingDictionariesTypesEnumOnConflict = {
  constraint: InsertListingDictionariesTypesEnumConstraint;
  update_columns: Array<InsertListingDictionariesTypesEnumUpdateColumn>;
  where?: InputMaybe<InsertListingDictionariesTypesEnumBoolExp>;
};

export enum InsertListingDictionariesTypesEnumUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export enum InsertListingDictionariesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeletable = 'is_deletable',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  Name = 'name',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  Types = 'types',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingDocTemplateTypeEnumBoolExp = {
  _and?: InputMaybe<Array<InsertListingDocTemplateTypeEnumBoolExp>>;
  _not?: InputMaybe<InsertListingDocTemplateTypeEnumBoolExp>;
  _or?: InputMaybe<Array<InsertListingDocTemplateTypeEnumBoolExp>>;
  value?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingDocTemplateTypeEnumConstraint {
  /** unique or primary key constraint on columns "value" */
  DocTemplateTypeEnumPkey = 'doc_template_type_enum_pkey'
}

export enum InsertListingDocTemplateTypeEnumEnum {
  AppraisalReport = 'appraisal_report',
  CmaReport = 'cma_report',
  DevelopmentBrochure = 'development_brochure',
  FinancingPassport = 'financing_passport',
  LotBrochure = 'lot_brochure',
  Mandate = 'mandate'
}

export type InsertListingDocTemplateTypeEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingDocTemplateTypeEnumEnum>;
  _in?: InputMaybe<Array<InsertListingDocTemplateTypeEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingDocTemplateTypeEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingDocTemplateTypeEnumEnum>>;
};

export type InsertListingDocTemplateTypeEnumInsertInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingDocTemplateTypeEnumObjRelInsertInput = {
  data: InsertListingDocTemplateTypeEnumInsertInput;
  on_conflict?: InputMaybe<InsertListingDocTemplateTypeEnumOnConflict>;
};

export type InsertListingDocTemplateTypeEnumOnConflict = {
  constraint: InsertListingDocTemplateTypeEnumConstraint;
  update_columns: Array<InsertListingDocTemplateTypeEnumUpdateColumn>;
  where?: InputMaybe<InsertListingDocTemplateTypeEnumBoolExp>;
};

export enum InsertListingDocTemplateTypeEnumUpdateColumn {
  /** column name */
  Value = 'value'
}

export type InsertListingDocTemplatesBoolExp = {
  _and?: InputMaybe<Array<InsertListingDocTemplatesBoolExp>>;
  _not?: InputMaybe<InsertListingDocTemplatesBoolExp>;
  _or?: InputMaybe<Array<InsertListingDocTemplatesBoolExp>>;
  active?: InputMaybe<InsertListingBooleanComparisonExp>;
  content?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  created_by_tenant?: InputMaybe<InsertListingReadOnlyTenantsBoolExp>;
  doc_template_type_enum?: InputMaybe<InsertListingDocTemplateTypeEnumBoolExp>;
  doc_templates_tenants?: InputMaybe<InsertListingDocTemplatesTenantsBoolExp>;
  doc_templates_tenants_aggregate?: InputMaybe<InsertListingDocTemplatesTenantsAggregateBoolExp>;
  filename_template?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  translations?: InputMaybe<InsertListingJsonbComparisonExp>;
  type?: InputMaybe<InsertListingDocTemplateTypeEnumEnumComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingDocTemplatesConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  DocTemplatesIdTenantIdUnique = 'doc_templates_id_tenant_id_unique',
  /** unique or primary key constraint on columns "tenant_id", "name" */
  DocTemplatesNameTenantIdUnique = 'doc_templates_name_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  DocTemplatesPkey = 'doc_templates_pkey'
}

export type InsertListingDocTemplatesInsertInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_by_tenant?: InputMaybe<InsertListingReadOnlyTenantsObjRelInsertInput>;
  doc_template_type_enum?: InputMaybe<InsertListingDocTemplateTypeEnumObjRelInsertInput>;
  doc_templates_tenants?: InputMaybe<InsertListingDocTemplatesTenantsArrRelInsertInput>;
  filename_template?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  translations?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<InsertListingDocTemplateTypeEnumEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingDocTemplatesObjRelInsertInput = {
  data: InsertListingDocTemplatesInsertInput;
  on_conflict?: InputMaybe<InsertListingDocTemplatesOnConflict>;
};

export type InsertListingDocTemplatesOnConflict = {
  constraint: InsertListingDocTemplatesConstraint;
  update_columns: Array<InsertListingDocTemplatesUpdateColumn>;
  where?: InputMaybe<InsertListingDocTemplatesBoolExp>;
};

export type InsertListingDocTemplatesTenantsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingDocTemplatesTenantsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingDocTemplatesTenantsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingDocTemplatesTenantsAggregateBoolExpCount>;
};

export type InsertListingDocTemplatesTenantsAggregateBoolExpBoolAnd = {
  arguments: InsertListingDocTemplatesTenantsSelectColumnDocTemplatesTenantsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingDocTemplatesTenantsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingDocTemplatesTenantsAggregateBoolExpBoolOr = {
  arguments: InsertListingDocTemplatesTenantsSelectColumnDocTemplatesTenantsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingDocTemplatesTenantsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingDocTemplatesTenantsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingDocTemplatesTenantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingDocTemplatesTenantsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingDocTemplatesTenantsArrRelInsertInput = {
  data: Array<InsertListingDocTemplatesTenantsInsertInput>;
  on_conflict?: InputMaybe<InsertListingDocTemplatesTenantsOnConflict>;
};

export type InsertListingDocTemplatesTenantsBoolExp = {
  _and?: InputMaybe<Array<InsertListingDocTemplatesTenantsBoolExp>>;
  _not?: InputMaybe<InsertListingDocTemplatesTenantsBoolExp>;
  _or?: InputMaybe<Array<InsertListingDocTemplatesTenantsBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  doc_template?: InputMaybe<InsertListingDocTemplatesBoolExp>;
  doc_template_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_default?: InputMaybe<InsertListingBooleanComparisonExp>;
  tenant?: InputMaybe<InsertListingReadOnlyTenantsBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingDocTemplatesTenantsConstraint {
  /** unique or primary key constraint on columns "doc_template_id", "tenant_id" */
  DocTemplatesTenantsDocTemplateIdTenantIdKey = 'doc_templates_tenants_doc_template_id_tenant_id_key',
  /** unique or primary key constraint on columns "id" */
  DocTemplatesTenantsPkey = 'doc_templates_tenants_pkey'
}

export type InsertListingDocTemplatesTenantsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  doc_template?: InputMaybe<InsertListingDocTemplatesObjRelInsertInput>;
  doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  tenant?: InputMaybe<InsertListingReadOnlyTenantsObjRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingDocTemplatesTenantsOnConflict = {
  constraint: InsertListingDocTemplatesTenantsConstraint;
  update_columns: Array<InsertListingDocTemplatesTenantsUpdateColumn>;
  where?: InputMaybe<InsertListingDocTemplatesTenantsBoolExp>;
};

export enum InsertListingDocTemplatesTenantsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocTemplateId = 'doc_template_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingDocTemplatesTenantsSelectColumnDocTemplatesTenantsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsDefault = 'is_default'
}

export enum InsertListingDocTemplatesTenantsSelectColumnDocTemplatesTenantsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsDefault = 'is_default'
}

export enum InsertListingDocTemplatesTenantsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocTemplateId = 'doc_template_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingDocTemplatesUpdateColumn {
  /** column name */
  Active = 'active',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FilenameTemplate = 'filename_template',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Translations = 'translations',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingEmailCampaignsBoolExp = {
  _and?: InputMaybe<Array<InsertListingEmailCampaignsBoolExp>>;
  _not?: InputMaybe<InsertListingEmailCampaignsBoolExp>;
  _or?: InputMaybe<Array<InsertListingEmailCampaignsBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  email_messages?: InputMaybe<InsertListingEmailMessagesBoolExp>;
  email_messages_aggregate?: InputMaybe<InsertListingEmailMessagesAggregateBoolExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  status?: InputMaybe<InsertListingEmailCampaignsStatusEnumEnumComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
};

export enum InsertListingEmailCampaignsConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  EmailCampaignsIdTenantIdUnique = 'email_campaigns_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  EmailCampaignsPkey = 'email_campaigns_pkey'
}

export type InsertListingEmailCampaignsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  email_messages?: InputMaybe<InsertListingEmailMessagesArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<InsertListingEmailCampaignsStatusEnumEnum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
};

export type InsertListingEmailCampaignsObjRelInsertInput = {
  data: InsertListingEmailCampaignsInsertInput;
  on_conflict?: InputMaybe<InsertListingEmailCampaignsOnConflict>;
};

export type InsertListingEmailCampaignsOnConflict = {
  constraint: InsertListingEmailCampaignsConstraint;
  update_columns: Array<InsertListingEmailCampaignsUpdateColumn>;
  where?: InputMaybe<InsertListingEmailCampaignsBoolExp>;
};

export enum InsertListingEmailCampaignsStatusEnumEnum {
  Done = 'done',
  Pending = 'pending'
}

export type InsertListingEmailCampaignsStatusEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingEmailCampaignsStatusEnumEnum>;
  _in?: InputMaybe<Array<InsertListingEmailCampaignsStatusEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingEmailCampaignsStatusEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingEmailCampaignsStatusEnumEnum>>;
};

export enum InsertListingEmailCampaignsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingEmailMessagesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingEmailMessagesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingEmailMessagesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingEmailMessagesAggregateBoolExpCount>;
};

export type InsertListingEmailMessagesAggregateBoolExpBoolAnd = {
  arguments: InsertListingEmailMessagesSelectColumnEmailMessagesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailMessagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingEmailMessagesAggregateBoolExpBoolOr = {
  arguments: InsertListingEmailMessagesSelectColumnEmailMessagesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailMessagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingEmailMessagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingEmailMessagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailMessagesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingEmailMessagesArrRelInsertInput = {
  data: Array<InsertListingEmailMessagesInsertInput>;
  on_conflict?: InputMaybe<InsertListingEmailMessagesOnConflict>;
};

export type InsertListingEmailMessagesBoolExp = {
  _and?: InputMaybe<Array<InsertListingEmailMessagesBoolExp>>;
  _not?: InputMaybe<InsertListingEmailMessagesBoolExp>;
  _or?: InputMaybe<Array<InsertListingEmailMessagesBoolExp>>;
  account_id?: InputMaybe<InsertListingStringComparisonExp>;
  activity?: InputMaybe<InsertListingActivitiesBoolExp>;
  bcc?: InputMaybe<InsertListingJsonbComparisonExp>;
  body_template?: InputMaybe<InsertListingStringComparisonExp>;
  campaign_id?: InputMaybe<InsertListingUuidComparisonExp>;
  cc?: InputMaybe<InsertListingJsonbComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  email_campaign?: InputMaybe<InsertListingEmailCampaignsBoolExp>;
  email_sequences_step?: InputMaybe<InsertListingEmailSequencesStepsBoolExp>;
  email_thread?: InputMaybe<InsertListingEmailThreadsBoolExp>;
  error_message?: InputMaybe<InsertListingStringComparisonExp>;
  events?: InputMaybe<InsertListingJsonbComparisonExp>;
  files?: InputMaybe<InsertListingJsonbComparisonExp>;
  from?: InputMaybe<InsertListingJsonbComparisonExp>;
  from_crm?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_sent?: InputMaybe<InsertListingBooleanComparisonExp>;
  labels?: InputMaybe<InsertListingJsonbComparisonExp>;
  message_id?: InputMaybe<InsertListingStringComparisonExp>;
  nylas_thread_id?: InputMaybe<InsertListingStringComparisonExp>;
  opens?: InputMaybe<InsertListingBooleanComparisonExp>;
  reply_to?: InputMaybe<InsertListingJsonbComparisonExp>;
  reply_to_message_id?: InputMaybe<InsertListingStringComparisonExp>;
  sequences_recipient_id?: InputMaybe<InsertListingUuidComparisonExp>;
  sequences_step_id?: InputMaybe<InsertListingUuidComparisonExp>;
  snippet?: InputMaybe<InsertListingStringComparisonExp>;
  starred?: InputMaybe<InsertListingBooleanComparisonExp>;
  status?: InputMaybe<InsertListingStringComparisonExp>;
  status_code?: InputMaybe<InsertListingStringComparisonExp>;
  subject?: InputMaybe<InsertListingStringComparisonExp>;
  subject_template?: InputMaybe<InsertListingStringComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  thread_id?: InputMaybe<InsertListingUuidComparisonExp>;
  to?: InputMaybe<InsertListingJsonbComparisonExp>;
  unread?: InputMaybe<InsertListingBooleanComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingEmailMessagesConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  EmailMessagesIdTenantIdUnique = 'email_messages_id_tenant_id_unique',
  /** unique or primary key constraint on columns "created_by", "message_id" */
  EmailMessagesMessageIdCreatedByUnique = 'email_messages_message_id_created_by_unique',
  /** unique or primary key constraint on columns "id" */
  EmailMessagesPkey = 'email_messages_pkey',
  /** unique or primary key constraint on columns "sequences_recipient_id", "sequences_step_id" */
  EmailMessagesSequencesStepIdSequencesRecipientIdKey = 'email_messages_sequences_step_id_sequences_recipient_id_key'
}

export type InsertListingEmailMessagesInsertInput = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  activity?: InputMaybe<InsertListingActivitiesObjRelInsertInput>;
  bcc?: InputMaybe<Scalars['jsonb']['input']>;
  body_template?: InputMaybe<Scalars['String']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  cc?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  email_campaign?: InputMaybe<InsertListingEmailCampaignsObjRelInsertInput>;
  email_sequences_step?: InputMaybe<InsertListingEmailSequencesStepsObjRelInsertInput>;
  email_thread?: InputMaybe<InsertListingEmailThreadsObjRelInsertInput>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Scalars['jsonb']['input']>;
  files?: InputMaybe<Scalars['jsonb']['input']>;
  from?: InputMaybe<Scalars['jsonb']['input']>;
  from_crm?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_sent?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Scalars['jsonb']['input']>;
  message_id?: InputMaybe<Scalars['String']['input']>;
  nylas_thread_id?: InputMaybe<Scalars['String']['input']>;
  opens?: InputMaybe<Scalars['Boolean']['input']>;
  reply_to?: InputMaybe<Scalars['jsonb']['input']>;
  reply_to_message_id?: InputMaybe<Scalars['String']['input']>;
  sequences_recipient_id?: InputMaybe<Scalars['uuid']['input']>;
  sequences_step_id?: InputMaybe<Scalars['uuid']['input']>;
  snippet?: InputMaybe<Scalars['String']['input']>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_code?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subject_template?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  thread_id?: InputMaybe<Scalars['uuid']['input']>;
  to?: InputMaybe<Scalars['jsonb']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingEmailMessagesObjRelInsertInput = {
  data: InsertListingEmailMessagesInsertInput;
  on_conflict?: InputMaybe<InsertListingEmailMessagesOnConflict>;
};

export type InsertListingEmailMessagesOnConflict = {
  constraint: InsertListingEmailMessagesConstraint;
  update_columns: Array<InsertListingEmailMessagesUpdateColumn>;
  where?: InputMaybe<InsertListingEmailMessagesBoolExp>;
};

export enum InsertListingEmailMessagesSelectColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Bcc = 'bcc',
  /** column name */
  BodyTemplate = 'body_template',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  Cc = 'cc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Date = 'date',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  Events = 'events',
  /** column name */
  Files = 'files',
  /** column name */
  From = 'from',
  /** column name */
  FromCrm = 'from_crm',
  /** column name */
  Id = 'id',
  /** column name */
  IsSent = 'is_sent',
  /** column name */
  Labels = 'labels',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  NylasThreadId = 'nylas_thread_id',
  /** column name */
  Opens = 'opens',
  /** column name */
  ReplyTo = 'reply_to',
  /** column name */
  ReplyToMessageId = 'reply_to_message_id',
  /** column name */
  SequencesRecipientId = 'sequences_recipient_id',
  /** column name */
  SequencesStepId = 'sequences_step_id',
  /** column name */
  Snippet = 'snippet',
  /** column name */
  Starred = 'starred',
  /** column name */
  Status = 'status',
  /** column name */
  StatusCode = 'status_code',
  /** column name */
  Subject = 'subject',
  /** column name */
  SubjectTemplate = 'subject_template',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  To = 'to',
  /** column name */
  Unread = 'unread',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingEmailMessagesSelectColumnEmailMessagesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  FromCrm = 'from_crm',
  /** column name */
  IsSent = 'is_sent',
  /** column name */
  Opens = 'opens',
  /** column name */
  Starred = 'starred',
  /** column name */
  Unread = 'unread'
}

export enum InsertListingEmailMessagesSelectColumnEmailMessagesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  FromCrm = 'from_crm',
  /** column name */
  IsSent = 'is_sent',
  /** column name */
  Opens = 'opens',
  /** column name */
  Starred = 'starred',
  /** column name */
  Unread = 'unread'
}

export enum InsertListingEmailMessagesUpdateColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Bcc = 'bcc',
  /** column name */
  BodyTemplate = 'body_template',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  Cc = 'cc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Date = 'date',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  Events = 'events',
  /** column name */
  Files = 'files',
  /** column name */
  From = 'from',
  /** column name */
  FromCrm = 'from_crm',
  /** column name */
  Id = 'id',
  /** column name */
  IsSent = 'is_sent',
  /** column name */
  Labels = 'labels',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  NylasThreadId = 'nylas_thread_id',
  /** column name */
  Opens = 'opens',
  /** column name */
  ReplyTo = 'reply_to',
  /** column name */
  ReplyToMessageId = 'reply_to_message_id',
  /** column name */
  SequencesRecipientId = 'sequences_recipient_id',
  /** column name */
  SequencesStepId = 'sequences_step_id',
  /** column name */
  Snippet = 'snippet',
  /** column name */
  Starred = 'starred',
  /** column name */
  Status = 'status',
  /** column name */
  StatusCode = 'status_code',
  /** column name */
  Subject = 'subject',
  /** column name */
  SubjectTemplate = 'subject_template',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  To = 'to',
  /** column name */
  Unread = 'unread',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingEmailSequencesBoolExp = {
  _and?: InputMaybe<Array<InsertListingEmailSequencesBoolExp>>;
  _not?: InputMaybe<InsertListingEmailSequencesBoolExp>;
  _or?: InputMaybe<Array<InsertListingEmailSequencesBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  created_by_user?: InputMaybe<InsertListingUsersBoolExp>;
  email_sequences_recipients?: InputMaybe<InsertListingEmailSequencesRecipientsBoolExp>;
  email_sequences_recipients_aggregate?: InputMaybe<InsertListingEmailSequencesRecipientsAggregateBoolExp>;
  email_sequences_steps?: InputMaybe<InsertListingEmailSequencesStepsBoolExp>;
  email_sequences_steps_aggregate?: InputMaybe<InsertListingEmailSequencesStepsAggregateBoolExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_shared_with_everyone?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_shared_with_team?: InputMaybe<InsertListingBooleanComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  status?: InputMaybe<InsertListingEmailSequencesStatusEnumEnumComparisonExp>;
  stop_after_reply?: InputMaybe<InsertListingBooleanComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingEmailSequencesConstraint {
  /** unique or primary key constraint on columns "id" */
  EmailSequencesPkey = 'email_sequences_pkey'
}

export type InsertListingEmailSequencesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  email_sequences_recipients?: InputMaybe<InsertListingEmailSequencesRecipientsArrRelInsertInput>;
  email_sequences_steps?: InputMaybe<InsertListingEmailSequencesStepsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared_with_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_team?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InsertListingEmailSequencesStatusEnumEnum>;
  stop_after_reply?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingEmailSequencesObjRelInsertInput = {
  data: InsertListingEmailSequencesInsertInput;
  on_conflict?: InputMaybe<InsertListingEmailSequencesOnConflict>;
};

export type InsertListingEmailSequencesOnConflict = {
  constraint: InsertListingEmailSequencesConstraint;
  update_columns: Array<InsertListingEmailSequencesUpdateColumn>;
  where?: InputMaybe<InsertListingEmailSequencesBoolExp>;
};

export type InsertListingEmailSequencesRecipientsAggregateBoolExp = {
  count?: InputMaybe<InsertListingEmailSequencesRecipientsAggregateBoolExpCount>;
};

export type InsertListingEmailSequencesRecipientsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingEmailSequencesRecipientsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailSequencesRecipientsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingEmailSequencesRecipientsArrRelInsertInput = {
  data: Array<InsertListingEmailSequencesRecipientsInsertInput>;
  on_conflict?: InputMaybe<InsertListingEmailSequencesRecipientsOnConflict>;
};

export type InsertListingEmailSequencesRecipientsBoolExp = {
  _and?: InputMaybe<Array<InsertListingEmailSequencesRecipientsBoolExp>>;
  _not?: InputMaybe<InsertListingEmailSequencesRecipientsBoolExp>;
  _or?: InputMaybe<Array<InsertListingEmailSequencesRecipientsBoolExp>>;
  buyer_lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  buyer_leads?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  email_messages?: InputMaybe<InsertListingEmailMessagesBoolExp>;
  email_messages_aggregate?: InputMaybe<InsertListingEmailMessagesAggregateBoolExp>;
  email_sequence?: InputMaybe<InsertListingEmailSequencesBoolExp>;
  email_sequence_id?: InputMaybe<InsertListingUuidComparisonExp>;
  from_user?: InputMaybe<InsertListingUsersBoolExp>;
  from_user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  last_step_number?: InputMaybe<InsertListingSmallintComparisonExp>;
  lead?: InputMaybe<InsertListingLeadsBoolExp>;
  lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  status?: InputMaybe<InsertListingEmailSequencesRecipientsStatusEnumEnumComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingEmailSequencesRecipientsConstraint {
  /** unique or primary key constraint on columns "buyer_lead_id", "user_id", "email_sequence_id" */
  EmailSequencesRecipientsEmailSequenceIdUserIdBuyerLead = 'email_sequences_recipients_email_sequence_id_user_id_buyer_lead',
  /** unique or primary key constraint on columns "user_id", "email_sequence_id", "lead_id" */
  EmailSequencesRecipientsEmailSequenceIdUserIdLeadIdKe = 'email_sequences_recipients_email_sequence_id_user_id_lead_id_ke',
  /** unique or primary key constraint on columns "user_id", "email_sequence_id", "lot_id" */
  EmailSequencesRecipientsEmailSequenceIdUserIdLotIdKey = 'email_sequences_recipients_email_sequence_id_user_id_lot_id_key',
  /** unique or primary key constraint on columns "id" */
  EmailSequencesRecipientsPkey = 'email_sequences_recipients_pkey'
}

export type InsertListingEmailSequencesRecipientsInsertInput = {
  buyer_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_leads?: InputMaybe<InsertListingBuyerLeadsObjRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_messages?: InputMaybe<InsertListingEmailMessagesArrRelInsertInput>;
  email_sequence?: InputMaybe<InsertListingEmailSequencesObjRelInsertInput>;
  email_sequence_id?: InputMaybe<Scalars['uuid']['input']>;
  from_user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  from_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_step_number?: InputMaybe<Scalars['smallint']['input']>;
  lead?: InputMaybe<InsertListingLeadsObjRelInsertInput>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<InsertListingEmailSequencesRecipientsStatusEnumEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingEmailSequencesRecipientsOnConflict = {
  constraint: InsertListingEmailSequencesRecipientsConstraint;
  update_columns: Array<InsertListingEmailSequencesRecipientsUpdateColumn>;
  where?: InputMaybe<InsertListingEmailSequencesRecipientsBoolExp>;
};

export enum InsertListingEmailSequencesRecipientsSelectColumn {
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailSequenceId = 'email_sequence_id',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastStepNumber = 'last_step_number',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingEmailSequencesRecipientsStatusEnumEnum {
  /** Active */
  Active = 'active',
  /** Stopped */
  Stopped = 'stopped'
}

export type InsertListingEmailSequencesRecipientsStatusEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingEmailSequencesRecipientsStatusEnumEnum>;
  _in?: InputMaybe<Array<InsertListingEmailSequencesRecipientsStatusEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingEmailSequencesRecipientsStatusEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingEmailSequencesRecipientsStatusEnumEnum>>;
};

export enum InsertListingEmailSequencesRecipientsUpdateColumn {
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailSequenceId = 'email_sequence_id',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastStepNumber = 'last_step_number',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingEmailSequencesStatusEnumEnum {
  /** Active */
  Active = 'active',
  /** Inactive */
  Inactive = 'inactive'
}

export type InsertListingEmailSequencesStatusEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingEmailSequencesStatusEnumEnum>;
  _in?: InputMaybe<Array<InsertListingEmailSequencesStatusEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingEmailSequencesStatusEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingEmailSequencesStatusEnumEnum>>;
};

export type InsertListingEmailSequencesStepsAggregateBoolExp = {
  count?: InputMaybe<InsertListingEmailSequencesStepsAggregateBoolExpCount>;
};

export type InsertListingEmailSequencesStepsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingEmailSequencesStepsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailSequencesStepsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingEmailSequencesStepsArrRelInsertInput = {
  data: Array<InsertListingEmailSequencesStepsInsertInput>;
  on_conflict?: InputMaybe<InsertListingEmailSequencesStepsOnConflict>;
};

export type InsertListingEmailSequencesStepsBoolExp = {
  _and?: InputMaybe<Array<InsertListingEmailSequencesStepsBoolExp>>;
  _not?: InputMaybe<InsertListingEmailSequencesStepsBoolExp>;
  _or?: InputMaybe<Array<InsertListingEmailSequencesStepsBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  delay?: InputMaybe<InsertListingSmallintComparisonExp>;
  email_messages?: InputMaybe<InsertListingEmailMessagesBoolExp>;
  email_messages_aggregate?: InputMaybe<InsertListingEmailMessagesAggregateBoolExp>;
  email_sequence?: InputMaybe<InsertListingEmailSequencesBoolExp>;
  email_sequence_id?: InputMaybe<InsertListingUuidComparisonExp>;
  email_template?: InputMaybe<InsertListingEmailTemplatesBoolExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  number?: InputMaybe<InsertListingSmallintComparisonExp>;
  template_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingEmailSequencesStepsConstraint {
  /** unique or primary key constraint on columns "email_sequence_id", "number" */
  EmailSequencesStepsEmailSequenceIdNumberKey = 'email_sequences_steps_email_sequence_id_number_key',
  /** unique or primary key constraint on columns "id" */
  EmailSequencesStepsPkey = 'email_sequences_steps_pkey'
}

export type InsertListingEmailSequencesStepsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delay?: InputMaybe<Scalars['smallint']['input']>;
  email_messages?: InputMaybe<InsertListingEmailMessagesArrRelInsertInput>;
  email_sequence?: InputMaybe<InsertListingEmailSequencesObjRelInsertInput>;
  email_sequence_id?: InputMaybe<Scalars['uuid']['input']>;
  email_template?: InputMaybe<InsertListingEmailTemplatesObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  number?: InputMaybe<Scalars['smallint']['input']>;
  template_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingEmailSequencesStepsObjRelInsertInput = {
  data: InsertListingEmailSequencesStepsInsertInput;
  on_conflict?: InputMaybe<InsertListingEmailSequencesStepsOnConflict>;
};

export type InsertListingEmailSequencesStepsOnConflict = {
  constraint: InsertListingEmailSequencesStepsConstraint;
  update_columns: Array<InsertListingEmailSequencesStepsUpdateColumn>;
  where?: InputMaybe<InsertListingEmailSequencesStepsBoolExp>;
};

export enum InsertListingEmailSequencesStepsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Delay = 'delay',
  /** column name */
  EmailSequenceId = 'email_sequence_id',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingEmailSequencesStepsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Delay = 'delay',
  /** column name */
  EmailSequenceId = 'email_sequence_id',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingEmailSequencesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsSharedWithEveryone = 'is_shared_with_everyone',
  /** column name */
  IsSharedWithTeam = 'is_shared_with_team',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  StopAfterReply = 'stop_after_reply',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingEmailTemplateComparisonExp = {
  _eq?: InputMaybe<Scalars['email_template']['input']>;
  _gt?: InputMaybe<Scalars['email_template']['input']>;
  _gte?: InputMaybe<Scalars['email_template']['input']>;
  _in?: InputMaybe<Array<Scalars['email_template']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['email_template']['input']>;
  _lte?: InputMaybe<Scalars['email_template']['input']>;
  _neq?: InputMaybe<Scalars['email_template']['input']>;
  _nin?: InputMaybe<Array<Scalars['email_template']['input']>>;
};

export type InsertListingEmailTemplatesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingEmailTemplatesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingEmailTemplatesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingEmailTemplatesAggregateBoolExpCount>;
};

export type InsertListingEmailTemplatesAggregateBoolExpBoolAnd = {
  arguments: InsertListingEmailTemplatesSelectColumnEmailTemplatesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailTemplatesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingEmailTemplatesAggregateBoolExpBoolOr = {
  arguments: InsertListingEmailTemplatesSelectColumnEmailTemplatesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailTemplatesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingEmailTemplatesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingEmailTemplatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailTemplatesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingEmailTemplatesArrRelInsertInput = {
  data: Array<InsertListingEmailTemplatesInsertInput>;
  on_conflict?: InputMaybe<InsertListingEmailTemplatesOnConflict>;
};

export type InsertListingEmailTemplatesBoolExp = {
  _and?: InputMaybe<Array<InsertListingEmailTemplatesBoolExp>>;
  _not?: InputMaybe<InsertListingEmailTemplatesBoolExp>;
  _or?: InputMaybe<Array<InsertListingEmailTemplatesBoolExp>>;
  add_signature?: InputMaybe<InsertListingBooleanComparisonExp>;
  bcc?: InputMaybe<InsertListingJsonbComparisonExp>;
  cc?: InputMaybe<InsertListingJsonbComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  development?: InputMaybe<InsertListingDevelopmentsBoolExp>;
  development_id?: InputMaybe<InsertListingUuidComparisonExp>;
  email_templates_files?: InputMaybe<InsertListingEmailTemplatesFilesBoolExp>;
  email_templates_files_aggregate?: InputMaybe<InsertListingEmailTemplatesFilesAggregateBoolExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_shared?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_shared_with_everyone?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_shared_with_organisation?: InputMaybe<InsertListingBooleanComparisonExp>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  subject?: InputMaybe<InsertListingStringComparisonExp>;
  subject_plaintext?: InputMaybe<InsertListingStringComparisonExp>;
  target?: InputMaybe<InsertListingEmailTemplatesTargetEnumEnumComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  text?: InputMaybe<InsertListingStringComparisonExp>;
  text_html?: InputMaybe<InsertListingStringComparisonExp>;
  text_plaintext?: InputMaybe<InsertListingStringComparisonExp>;
  type?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingEmailTemplatesConstraint {
  /** unique or primary key constraint on columns "id" */
  EmailTemplatesPkey = 'email_templates_pkey'
}

export type InsertListingEmailTemplatesFilesAggregateBoolExp = {
  count?: InputMaybe<InsertListingEmailTemplatesFilesAggregateBoolExpCount>;
};

export type InsertListingEmailTemplatesFilesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingEmailTemplatesFilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailTemplatesFilesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingEmailTemplatesFilesArrRelInsertInput = {
  data: Array<InsertListingEmailTemplatesFilesInsertInput>;
  on_conflict?: InputMaybe<InsertListingEmailTemplatesFilesOnConflict>;
};

export type InsertListingEmailTemplatesFilesBoolExp = {
  _and?: InputMaybe<Array<InsertListingEmailTemplatesFilesBoolExp>>;
  _not?: InputMaybe<InsertListingEmailTemplatesFilesBoolExp>;
  _or?: InputMaybe<Array<InsertListingEmailTemplatesFilesBoolExp>>;
  email_template?: InputMaybe<InsertListingEmailTemplatesBoolExp>;
  email_template_id?: InputMaybe<InsertListingUuidComparisonExp>;
  file?: InputMaybe<InsertListingFilesBoolExp>;
  file_id?: InputMaybe<InsertListingUuidComparisonExp>;
  nylas_file_id?: InputMaybe<InsertListingStringComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingEmailTemplatesFilesConstraint {
  /** unique or primary key constraint on columns "email_template_id", "file_id" */
  EmailTemplatesFilesPkey = 'email_templates_files_pkey'
}

export type InsertListingEmailTemplatesFilesInsertInput = {
  email_template?: InputMaybe<InsertListingEmailTemplatesObjRelInsertInput>;
  email_template_id?: InputMaybe<Scalars['uuid']['input']>;
  file?: InputMaybe<InsertListingFilesObjRelInsertInput>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  nylas_file_id?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingEmailTemplatesFilesOnConflict = {
  constraint: InsertListingEmailTemplatesFilesConstraint;
  update_columns: Array<InsertListingEmailTemplatesFilesUpdateColumn>;
  where?: InputMaybe<InsertListingEmailTemplatesFilesBoolExp>;
};

export enum InsertListingEmailTemplatesFilesSelectColumn {
  /** column name */
  EmailTemplateId = 'email_template_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  NylasFileId = 'nylas_file_id',
  /** column name */
  TenantId = 'tenant_id'
}

export enum InsertListingEmailTemplatesFilesUpdateColumn {
  /** column name */
  EmailTemplateId = 'email_template_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  NylasFileId = 'nylas_file_id',
  /** column name */
  TenantId = 'tenant_id'
}

export type InsertListingEmailTemplatesInsertInput = {
  add_signature?: InputMaybe<Scalars['Boolean']['input']>;
  bcc?: InputMaybe<Scalars['jsonb']['input']>;
  cc?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  development?: InputMaybe<InsertListingDevelopmentsObjRelInsertInput>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  email_templates_files?: InputMaybe<InsertListingEmailTemplatesFilesArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_organisation?: InputMaybe<Scalars['Boolean']['input']>;
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subject_plaintext?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<InsertListingEmailTemplatesTargetEnumEnum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_html?: InputMaybe<Scalars['String']['input']>;
  text_plaintext?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingEmailTemplatesObjRelInsertInput = {
  data: InsertListingEmailTemplatesInsertInput;
  on_conflict?: InputMaybe<InsertListingEmailTemplatesOnConflict>;
};

export type InsertListingEmailTemplatesOnConflict = {
  constraint: InsertListingEmailTemplatesConstraint;
  update_columns: Array<InsertListingEmailTemplatesUpdateColumn>;
  where?: InputMaybe<InsertListingEmailTemplatesBoolExp>;
};

export enum InsertListingEmailTemplatesSelectColumn {
  /** column name */
  AddSignature = 'add_signature',
  /** column name */
  Bcc = 'bcc',
  /** column name */
  Cc = 'cc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  IsSharedWithEveryone = 'is_shared_with_everyone',
  /** column name */
  IsSharedWithOrganisation = 'is_shared_with_organisation',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Name = 'name',
  /** column name */
  Subject = 'subject',
  /** column name */
  SubjectPlaintext = 'subject_plaintext',
  /** column name */
  Target = 'target',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Text = 'text',
  /** column name */
  TextHtml = 'text_html',
  /** column name */
  TextPlaintext = 'text_plaintext',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingEmailTemplatesSelectColumnEmailTemplatesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  AddSignature = 'add_signature',
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  IsSharedWithEveryone = 'is_shared_with_everyone',
  /** column name */
  IsSharedWithOrganisation = 'is_shared_with_organisation'
}

export enum InsertListingEmailTemplatesSelectColumnEmailTemplatesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  AddSignature = 'add_signature',
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  IsSharedWithEveryone = 'is_shared_with_everyone',
  /** column name */
  IsSharedWithOrganisation = 'is_shared_with_organisation'
}

export enum InsertListingEmailTemplatesTargetEnumEnum {
  /** Sequence */
  Sequence = 'sequence',
  /** Standalone */
  Standalone = 'standalone'
}

export type InsertListingEmailTemplatesTargetEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingEmailTemplatesTargetEnumEnum>;
  _in?: InputMaybe<Array<InsertListingEmailTemplatesTargetEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingEmailTemplatesTargetEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingEmailTemplatesTargetEnumEnum>>;
};

export enum InsertListingEmailTemplatesUpdateColumn {
  /** column name */
  AddSignature = 'add_signature',
  /** column name */
  Bcc = 'bcc',
  /** column name */
  Cc = 'cc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  IsSharedWithEveryone = 'is_shared_with_everyone',
  /** column name */
  IsSharedWithOrganisation = 'is_shared_with_organisation',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Name = 'name',
  /** column name */
  Subject = 'subject',
  /** column name */
  SubjectPlaintext = 'subject_plaintext',
  /** column name */
  Target = 'target',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Text = 'text',
  /** column name */
  TextHtml = 'text_html',
  /** column name */
  TextPlaintext = 'text_plaintext',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingEmailThreadsBoolExp = {
  _and?: InputMaybe<Array<InsertListingEmailThreadsBoolExp>>;
  _not?: InputMaybe<InsertListingEmailThreadsBoolExp>;
  _or?: InputMaybe<Array<InsertListingEmailThreadsBoolExp>>;
  account_id?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  draft_ids?: InputMaybe<InsertListingJsonbComparisonExp>;
  drafts?: InputMaybe<InsertListingJsonbComparisonExp>;
  email_messages?: InputMaybe<InsertListingEmailMessagesBoolExp>;
  email_messages_aggregate?: InputMaybe<InsertListingEmailMessagesAggregateBoolExp>;
  first_message_timestamp?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  from_crm?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_attachments?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  initial_nylas_message_id?: InputMaybe<InsertListingStringComparisonExp>;
  labels?: InputMaybe<InsertListingJsonbComparisonExp>;
  last_message_received_timestamp?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  last_message_sent_timestamp?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  last_message_timestamp?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  message_ids?: InputMaybe<InsertListingJsonbComparisonExp>;
  messages?: InputMaybe<InsertListingJsonbComparisonExp>;
  participants?: InputMaybe<InsertListingJsonbComparisonExp>;
  snippet?: InputMaybe<InsertListingStringComparisonExp>;
  starred?: InputMaybe<InsertListingBooleanComparisonExp>;
  subject?: InputMaybe<InsertListingStringComparisonExp>;
  thread_id?: InputMaybe<InsertListingStringComparisonExp>;
  unread?: InputMaybe<InsertListingBooleanComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  version?: InputMaybe<InsertListingIntComparisonExp>;
  visibility?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingEmailThreadsConstraint {
  /** unique or primary key constraint on columns "id" */
  EmailThreadsPkey = 'email_threads_pkey',
  /** unique or primary key constraint on columns "thread_id", "user_id" */
  EmailThreadsThreadIdUserIdUnique = 'email_threads_thread_id_user_id_unique'
}

export type InsertListingEmailThreadsInsertInput = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  draft_ids?: InputMaybe<Scalars['jsonb']['input']>;
  drafts?: InputMaybe<Scalars['jsonb']['input']>;
  email_messages?: InputMaybe<InsertListingEmailMessagesArrRelInsertInput>;
  first_message_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  from_crm?: InputMaybe<Scalars['Boolean']['input']>;
  has_attachments?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  initial_nylas_message_id?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Scalars['jsonb']['input']>;
  last_message_received_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  last_message_sent_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  last_message_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  message_ids?: InputMaybe<Scalars['jsonb']['input']>;
  messages?: InputMaybe<Scalars['jsonb']['input']>;
  participants?: InputMaybe<Scalars['jsonb']['input']>;
  snippet?: InputMaybe<Scalars['String']['input']>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  thread_id?: InputMaybe<Scalars['String']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingEmailThreadsObjRelInsertInput = {
  data: InsertListingEmailThreadsInsertInput;
  on_conflict?: InputMaybe<InsertListingEmailThreadsOnConflict>;
};

export type InsertListingEmailThreadsOnConflict = {
  constraint: InsertListingEmailThreadsConstraint;
  update_columns: Array<InsertListingEmailThreadsUpdateColumn>;
  where?: InputMaybe<InsertListingEmailThreadsBoolExp>;
};

export enum InsertListingEmailThreadsUpdateColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DraftIds = 'draft_ids',
  /** column name */
  Drafts = 'drafts',
  /** column name */
  FirstMessageTimestamp = 'first_message_timestamp',
  /** column name */
  FromCrm = 'from_crm',
  /** column name */
  HasAttachments = 'has_attachments',
  /** column name */
  Id = 'id',
  /** column name */
  InitialNylasMessageId = 'initial_nylas_message_id',
  /** column name */
  Labels = 'labels',
  /** column name */
  LastMessageReceivedTimestamp = 'last_message_received_timestamp',
  /** column name */
  LastMessageSentTimestamp = 'last_message_sent_timestamp',
  /** column name */
  LastMessageTimestamp = 'last_message_timestamp',
  /** column name */
  MessageIds = 'message_ids',
  /** column name */
  Messages = 'messages',
  /** column name */
  Participants = 'participants',
  /** column name */
  Snippet = 'snippet',
  /** column name */
  Starred = 'starred',
  /** column name */
  Subject = 'subject',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  Unread = 'unread',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Version = 'version',
  /** column name */
  Visibility = 'visibility'
}

export type InsertListingEmailsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingEmailsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingEmailsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingEmailsAggregateBoolExpCount>;
};

export type InsertListingEmailsAggregateBoolExpBoolAnd = {
  arguments: InsertListingEmailsSelectColumnEmailsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingEmailsAggregateBoolExpBoolOr = {
  arguments: InsertListingEmailsSelectColumnEmailsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingEmailsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingEmailsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingEmailsArrRelInsertInput = {
  data: Array<InsertListingEmailsInsertInput>;
  on_conflict?: InputMaybe<InsertListingEmailsOnConflict>;
};

export type InsertListingEmailsBoolExp = {
  _and?: InputMaybe<Array<InsertListingEmailsBoolExp>>;
  _not?: InputMaybe<InsertListingEmailsBoolExp>;
  _or?: InputMaybe<Array<InsertListingEmailsBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  email?: InputMaybe<InsertListingCitextComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  organisation?: InputMaybe<InsertListingOrganisationsBoolExp>;
  organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  primary?: InputMaybe<InsertListingBooleanComparisonExp>;
  subscription?: InputMaybe<InsertListingSubscriptionsBoolExp>;
  subscriptions?: InputMaybe<InsertListingSubscriptionsBoolExp>;
  subscriptions_aggregate?: InputMaybe<InsertListingSubscriptionsAggregateBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  verified?: InputMaybe<InsertListingBooleanComparisonExp>;
};

export enum InsertListingEmailsConstraint {
  /** unique or primary key constraint on columns "id" */
  EmailsPkey = 'emails_pkey',
  /** unique or primary key constraint on columns "tenant_id", "email" */
  EmailsTenantIdEmailUnique = 'emails_tenant_id_email_unique',
  /** unique or primary key constraint on columns "user_id", "tenant_id", "verified", "email" */
  EmailsUserIdTenantIdEmailVerifiedUnique = 'emails_user_id_tenant_id_email_verified_unique'
}

export type InsertListingEmailsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisation?: InputMaybe<InsertListingOrganisationsObjRelInsertInput>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  subscription?: InputMaybe<InsertListingSubscriptionsObjRelInsertInput>;
  subscriptions?: InputMaybe<InsertListingSubscriptionsArrRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsertListingEmailsObjRelInsertInput = {
  data: InsertListingEmailsInsertInput;
  on_conflict?: InputMaybe<InsertListingEmailsOnConflict>;
};

export type InsertListingEmailsOnConflict = {
  constraint: InsertListingEmailsConstraint;
  update_columns: Array<InsertListingEmailsUpdateColumn>;
  where?: InputMaybe<InsertListingEmailsBoolExp>;
};

export enum InsertListingEmailsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Primary = 'primary',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingEmailsSelectColumnEmailsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Primary = 'primary',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingEmailsSelectColumnEmailsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Primary = 'primary',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingEmailsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Primary = 'primary',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingEnergyClassTypeEnumEnum {
  A = 'a',
  B = 'b',
  C = 'c',
  D = 'd',
  E = 'e',
  F = 'f',
  G = 'g',
  NotSet = 'not_set'
}

export type InsertListingEnergyClassTypeEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingEnergyClassTypeEnumEnum>;
  _in?: InputMaybe<Array<InsertListingEnergyClassTypeEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingEnergyClassTypeEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingEnergyClassTypeEnumEnum>>;
};

export type InsertListingEnquiriesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingEnquiriesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingEnquiriesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingEnquiriesAggregateBoolExpCount>;
};

export type InsertListingEnquiriesAggregateBoolExpBoolAnd = {
  arguments: InsertListingEnquiriesSelectColumnEnquiriesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEnquiriesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingEnquiriesAggregateBoolExpBoolOr = {
  arguments: InsertListingEnquiriesSelectColumnEnquiriesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEnquiriesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingEnquiriesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingEnquiriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEnquiriesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingEnquiriesArrRelInsertInput = {
  data: Array<InsertListingEnquiriesInsertInput>;
  on_conflict?: InputMaybe<InsertListingEnquiriesOnConflict>;
};

export type InsertListingEnquiriesBoolExp = {
  _and?: InputMaybe<Array<InsertListingEnquiriesBoolExp>>;
  _not?: InputMaybe<InsertListingEnquiriesBoolExp>;
  _or?: InputMaybe<Array<InsertListingEnquiriesBoolExp>>;
  address?: InputMaybe<InsertListingStringComparisonExp>;
  broker?: InputMaybe<InsertListingUsersBoolExp>;
  broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  buyer_lead?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
  buyer_lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  call_times?: InputMaybe<InsertListingStringArrayComparisonExp>;
  contact_reason?: InputMaybe<InsertListingStringComparisonExp>;
  country?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  development_registration_form_id?: InputMaybe<InsertListingUuidComparisonExp>;
  email_address?: InputMaybe<InsertListingStringComparisonExp>;
  first_name?: InputMaybe<InsertListingStringComparisonExp>;
  has_conflict?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_invalid_input?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  language?: InputMaybe<InsertListingUserLanguageComparisonExp>;
  last_name?: InputMaybe<InsertListingStringComparisonExp>;
  listing_link?: InputMaybe<InsertListingStringComparisonExp>;
  locality?: InputMaybe<InsertListingStringComparisonExp>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  matched_email_user?: InputMaybe<InsertListingUsersBoolExp>;
  matched_phone_user?: InputMaybe<InsertListingUsersBoolExp>;
  message?: InputMaybe<InsertListingStringComparisonExp>;
  neverbounce_result?: InputMaybe<InsertListingStringComparisonExp>;
  object_ref?: InputMaybe<InsertListingStringComparisonExp>;
  original_enquiry_id?: InputMaybe<InsertListingUuidComparisonExp>;
  phone_number?: InputMaybe<InsertListingStringComparisonExp>;
  portal?: InputMaybe<InsertListingPortalsBoolExp>;
  portal_id?: InputMaybe<InsertListingUuidComparisonExp>;
  postcode?: InputMaybe<InsertListingStringComparisonExp>;
  processed?: InputMaybe<InsertListingBooleanComparisonExp>;
  property_search_notification?: InputMaybe<InsertListingPropertySearchesNotificationComparisonExp>;
  property_transaction?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  property_transaction_id?: InputMaybe<InsertListingUuidComparisonExp>;
  raw_email?: InputMaybe<InsertListingStringComparisonExp>;
  raw_email_address?: InputMaybe<InsertListingStringComparisonExp>;
  raw_phone_number?: InputMaybe<InsertListingStringComparisonExp>;
  response_activity?: InputMaybe<InsertListingActivitiesBoolExp>;
  response_activity_id?: InputMaybe<InsertListingUuidComparisonExp>;
  session_id?: InputMaybe<InsertListingStringComparisonExp>;
  source_email_id?: InputMaybe<InsertListingStringComparisonExp>;
  team?: InputMaybe<InsertListingTeamsBoolExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  title?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_email_id?: InputMaybe<InsertListingUuidComparisonExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  user_phone_id?: InputMaybe<InsertListingUuidComparisonExp>;
  visit_date?: InputMaybe<InsertListingTimestampComparisonExp>;
};

export enum InsertListingEnquiriesConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  EnquiriesIdTenantIdUnique = 'enquiries_id_tenant_id_unique',
  /** unique or primary key constraint on columns "source_email_id" */
  EnquiriesSourceEmailIdUnique = 'enquiries_source_email_id_unique',
  /** unique or primary key constraint on columns "id" */
  InquiriesPkey = 'inquiries_pkey'
}

export type InsertListingEnquiriesInsertInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  broker?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_lead?: InputMaybe<InsertListingBuyerLeadsObjRelInsertInput>;
  buyer_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  call_times?: InputMaybe<Array<Scalars['String']['input']>>;
  contact_reason?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  development_registration_form_id?: InputMaybe<Scalars['uuid']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  has_conflict?: InputMaybe<Scalars['Boolean']['input']>;
  has_invalid_input?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  listing_link?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  matched_email_user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  matched_phone_user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  neverbounce_result?: InputMaybe<Scalars['String']['input']>;
  object_ref?: InputMaybe<Scalars['String']['input']>;
  original_enquiry_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<InsertListingPortalsObjRelInsertInput>;
  portal_id?: InputMaybe<Scalars['uuid']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
  property_search_notification?: InputMaybe<Scalars['property_searches_notification']['input']>;
  property_transaction?: InputMaybe<InsertListingPropertyTransactionsObjRelInsertInput>;
  property_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  raw_email?: InputMaybe<Scalars['String']['input']>;
  raw_email_address?: InputMaybe<Scalars['String']['input']>;
  raw_phone_number?: InputMaybe<Scalars['String']['input']>;
  response_activity?: InputMaybe<InsertListingActivitiesObjRelInsertInput>;
  response_activity_id?: InputMaybe<Scalars['uuid']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  source_email_id?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_email_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_phone_id?: InputMaybe<Scalars['uuid']['input']>;
  visit_date?: InputMaybe<Scalars['timestamp']['input']>;
};

export type InsertListingEnquiriesObjRelInsertInput = {
  data: InsertListingEnquiriesInsertInput;
  on_conflict?: InputMaybe<InsertListingEnquiriesOnConflict>;
};

export type InsertListingEnquiriesOnConflict = {
  constraint: InsertListingEnquiriesConstraint;
  update_columns: Array<InsertListingEnquiriesUpdateColumn>;
  where?: InputMaybe<InsertListingEnquiriesBoolExp>;
};

export enum InsertListingEnquiriesSelectColumn {
  /** column name */
  Address = 'address',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  CallTimes = 'call_times',
  /** column name */
  ContactReason = 'contact_reason',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevelopmentRegistrationFormId = 'development_registration_form_id',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  HasConflict = 'has_conflict',
  /** column name */
  HasInvalidInput = 'has_invalid_input',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  LastName = 'last_name',
  /** column name */
  ListingLink = 'listing_link',
  /** column name */
  Locality = 'locality',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Message = 'message',
  /** column name */
  NeverbounceResult = 'neverbounce_result',
  /** column name */
  ObjectRef = 'object_ref',
  /** column name */
  OriginalEnquiryId = 'original_enquiry_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PortalId = 'portal_id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  Processed = 'processed',
  /** column name */
  PropertySearchNotification = 'property_search_notification',
  /** column name */
  PropertyTransactionId = 'property_transaction_id',
  /** column name */
  RawEmail = 'raw_email',
  /** column name */
  RawEmailAddress = 'raw_email_address',
  /** column name */
  RawPhoneNumber = 'raw_phone_number',
  /** column name */
  ResponseActivityId = 'response_activity_id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  SourceEmailId = 'source_email_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserEmailId = 'user_email_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserPhoneId = 'user_phone_id',
  /** column name */
  VisitDate = 'visit_date'
}

export enum InsertListingEnquiriesSelectColumnEnquiriesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  HasConflict = 'has_conflict',
  /** column name */
  HasInvalidInput = 'has_invalid_input',
  /** column name */
  Processed = 'processed'
}

export enum InsertListingEnquiriesSelectColumnEnquiriesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  HasConflict = 'has_conflict',
  /** column name */
  HasInvalidInput = 'has_invalid_input',
  /** column name */
  Processed = 'processed'
}

export enum InsertListingEnquiriesUpdateColumn {
  /** column name */
  Address = 'address',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  CallTimes = 'call_times',
  /** column name */
  ContactReason = 'contact_reason',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevelopmentRegistrationFormId = 'development_registration_form_id',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  HasConflict = 'has_conflict',
  /** column name */
  HasInvalidInput = 'has_invalid_input',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  LastName = 'last_name',
  /** column name */
  ListingLink = 'listing_link',
  /** column name */
  Locality = 'locality',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Message = 'message',
  /** column name */
  NeverbounceResult = 'neverbounce_result',
  /** column name */
  ObjectRef = 'object_ref',
  /** column name */
  OriginalEnquiryId = 'original_enquiry_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PortalId = 'portal_id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  Processed = 'processed',
  /** column name */
  PropertySearchNotification = 'property_search_notification',
  /** column name */
  PropertyTransactionId = 'property_transaction_id',
  /** column name */
  RawEmail = 'raw_email',
  /** column name */
  RawEmailAddress = 'raw_email_address',
  /** column name */
  RawPhoneNumber = 'raw_phone_number',
  /** column name */
  ResponseActivityId = 'response_activity_id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  SourceEmailId = 'source_email_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserEmailId = 'user_email_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserPhoneId = 'user_phone_id',
  /** column name */
  VisitDate = 'visit_date'
}

export type InsertListingFilesBoolExp = {
  _and?: InputMaybe<Array<InsertListingFilesBoolExp>>;
  _not?: InputMaybe<InsertListingFilesBoolExp>;
  _or?: InputMaybe<Array<InsertListingFilesBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  document_type?: InputMaybe<InsertListingDictionariesBoolExp>;
  document_type_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  mimetype?: InputMaybe<InsertListingStringComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  size?: InputMaybe<InsertListingIntComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  uploader?: InputMaybe<InsertListingUsersBoolExp>;
  uploader_id?: InputMaybe<InsertListingUuidComparisonExp>;
  url?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingFilesConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  FilesIdTenantIdUnique = 'files_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  FilesPkey = 'files_pkey'
}

export type InsertListingFilesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_type?: InputMaybe<InsertListingDictionariesObjRelInsertInput>;
  document_type_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mimetype?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uploader?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  uploader_id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingFilesObjRelInsertInput = {
  data: InsertListingFilesInsertInput;
  on_conflict?: InputMaybe<InsertListingFilesOnConflict>;
};

export type InsertListingFilesOnConflict = {
  constraint: InsertListingFilesConstraint;
  update_columns: Array<InsertListingFilesUpdateColumn>;
  where?: InputMaybe<InsertListingFilesBoolExp>;
};

export enum InsertListingFilesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentTypeId = 'document_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Mimetype = 'mimetype',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploaderId = 'uploader_id',
  /** column name */
  Url = 'url'
}

export type InsertListingFinancingPassportsAggregateBoolExp = {
  avg?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExpAvg>;
  corr?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExpCorr>;
  count?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExpCount>;
  covar_samp?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExpCovarSamp>;
  max?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExpMax>;
  min?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExpSum>;
  var_samp?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExpVarSamp>;
};

export type InsertListingFinancingPassportsAggregateBoolExpAvg = {
  arguments: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingFinancingPassportsAggregateBoolExpCorr = {
  arguments: InsertListingFinancingPassportsAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingFinancingPassportsAggregateBoolExpCorrArguments = {
  X: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpCorrArgumentsColumns;
  Y: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpCorrArgumentsColumns;
};

export type InsertListingFinancingPassportsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingFinancingPassportsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingFinancingPassportsAggregateBoolExpCovarSamp = {
  arguments: InsertListingFinancingPassportsAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingFinancingPassportsAggregateBoolExpCovarSampArguments = {
  X: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpCovarSampArgumentsColumns;
  Y: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpCovarSampArgumentsColumns;
};

export type InsertListingFinancingPassportsAggregateBoolExpMax = {
  arguments: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingFinancingPassportsAggregateBoolExpMin = {
  arguments: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingFinancingPassportsAggregateBoolExpStddevSamp = {
  arguments: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingFinancingPassportsAggregateBoolExpSum = {
  arguments: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingFinancingPassportsAggregateBoolExpVarSamp = {
  arguments: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingFinancingPassportsArrRelInsertInput = {
  data: Array<InsertListingFinancingPassportsInsertInput>;
  on_conflict?: InputMaybe<InsertListingFinancingPassportsOnConflict>;
};

export type InsertListingFinancingPassportsBoolExp = {
  _and?: InputMaybe<Array<InsertListingFinancingPassportsBoolExp>>;
  _not?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  _or?: InputMaybe<Array<InsertListingFinancingPassportsBoolExp>>;
  amount?: InputMaybe<InsertListingFloat8ComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  document_url?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  lead?: InputMaybe<InsertListingLeadsBoolExp>;
  lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  source?: InputMaybe<InsertListingStringComparisonExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingFinancingPassportsConstraint {
  /** unique or primary key constraint on columns "id" */
  FinancingPassportsPkey = 'financing_passports_pkey'
}

export type InsertListingFinancingPassportsInsertInput = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  document_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead?: InputMaybe<InsertListingLeadsObjRelInsertInput>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingFinancingPassportsOnConflict = {
  constraint: InsertListingFinancingPassportsConstraint;
  update_columns: Array<InsertListingFinancingPassportsUpdateColumn>;
  where?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
};

export enum InsertListingFinancingPassportsSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DocumentUrl = 'document_url',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  Source = 'source',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

export enum InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

export enum InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

export enum InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

export enum InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpMinArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

export enum InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

export enum InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpSumArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

export enum InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

export enum InsertListingFinancingPassportsUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DocumentUrl = 'document_url',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  Source = 'source',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingFloat8ArrayComparisonExp = {
  _contained_in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _contains?: InputMaybe<Array<Scalars['float8']['input']>>;
  _eq?: InputMaybe<Array<Scalars['float8']['input']>>;
  _gt?: InputMaybe<Array<Scalars['float8']['input']>>;
  _gte?: InputMaybe<Array<Scalars['float8']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['float8']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['float8']['input']>>;
  _lte?: InputMaybe<Array<Scalars['float8']['input']>>;
  _neq?: InputMaybe<Array<Scalars['float8']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['float8']['input']>>>;
};

export type InsertListingFloat8ComparisonExp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

export type InsertListingFloatComparisonExp = {
  _eq?: InputMaybe<Scalars['Float']['input']>;
  _gt?: InputMaybe<Scalars['Float']['input']>;
  _gte?: InputMaybe<Scalars['Float']['input']>;
  _in?: InputMaybe<Array<Scalars['Float']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Float']['input']>;
  _lte?: InputMaybe<Scalars['Float']['input']>;
  _neq?: InputMaybe<Scalars['Float']['input']>;
  _nin?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type InsertListingGeographyCastExp = {
  geometry?: InputMaybe<InsertListingGeometryComparisonExp>;
};

export type InsertListingGeographyComparisonExp = {
  _cast?: InputMaybe<InsertListingGeographyCastExp>;
  _eq?: InputMaybe<Scalars['geography']['input']>;
  _gt?: InputMaybe<Scalars['geography']['input']>;
  _gte?: InputMaybe<Scalars['geography']['input']>;
  _in?: InputMaybe<Array<Scalars['geography']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geography']['input']>;
  _lte?: InputMaybe<Scalars['geography']['input']>;
  _neq?: InputMaybe<Scalars['geography']['input']>;
  _nin?: InputMaybe<Array<Scalars['geography']['input']>>;
  _st_d_within?: InputMaybe<InsertListingStDWithinGeographyInput>;
  _st_intersects?: InputMaybe<Scalars['geography']['input']>;
};

export type InsertListingGeometryCastExp = {
  geography?: InputMaybe<InsertListingGeographyComparisonExp>;
};

export type InsertListingGeometryComparisonExp = {
  _cast?: InputMaybe<InsertListingGeometryCastExp>;
  _eq?: InputMaybe<Scalars['geometry']['input']>;
  _gt?: InputMaybe<Scalars['geometry']['input']>;
  _gte?: InputMaybe<Scalars['geometry']['input']>;
  _in?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geometry']['input']>;
  _lte?: InputMaybe<Scalars['geometry']['input']>;
  _neq?: InputMaybe<Scalars['geometry']['input']>;
  _nin?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _st_3d_d_within?: InputMaybe<InsertListingStDWithinInput>;
  _st_3d_intersects?: InputMaybe<Scalars['geometry']['input']>;
  _st_contains?: InputMaybe<Scalars['geometry']['input']>;
  _st_crosses?: InputMaybe<Scalars['geometry']['input']>;
  _st_d_within?: InputMaybe<InsertListingStDWithinInput>;
  _st_equals?: InputMaybe<Scalars['geometry']['input']>;
  _st_intersects?: InputMaybe<Scalars['geometry']['input']>;
  _st_overlaps?: InputMaybe<Scalars['geometry']['input']>;
  _st_touches?: InputMaybe<Scalars['geometry']['input']>;
  _st_within?: InputMaybe<Scalars['geometry']['input']>;
};

export type InsertListingGoogleAddressesBoolExp = {
  _and?: InputMaybe<Array<InsertListingGoogleAddressesBoolExp>>;
  _not?: InputMaybe<InsertListingGoogleAddressesBoolExp>;
  _or?: InputMaybe<Array<InsertListingGoogleAddressesBoolExp>>;
  centroid?: InputMaybe<InsertListingGeometryComparisonExp>;
  country?: InputMaybe<InsertListingStringComparisonExp>;
  country_code?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  ctn?: InputMaybe<InsertListingStringComparisonExp>;
  formatted_address?: InputMaybe<InsertListingStringComparisonExp>;
  google_place_id?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  lat?: InputMaybe<InsertListingFloatComparisonExp>;
  lng?: InputMaybe<InsertListingFloatComparisonExp>;
  locality?: InputMaybe<InsertListingStringComparisonExp>;
  place_type?: InputMaybe<InsertListingStringComparisonExp>;
  postcode?: InputMaybe<InsertListingStringComparisonExp>;
  route?: InputMaybe<InsertListingStringComparisonExp>;
  state?: InputMaybe<InsertListingStringComparisonExp>;
  street_number?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingGoogleAddressesConstraint {
  /** unique or primary key constraint on columns "id" */
  GoogleAddressesPkey = 'google_addresses_pkey'
}

export type InsertListingGoogleAddressesInsertInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  place_type?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingGoogleAddressesObjRelInsertInput = {
  data: InsertListingGoogleAddressesInsertInput;
  on_conflict?: InputMaybe<InsertListingGoogleAddressesOnConflict>;
};

export type InsertListingGoogleAddressesOnConflict = {
  constraint: InsertListingGoogleAddressesConstraint;
  update_columns: Array<InsertListingGoogleAddressesUpdateColumn>;
  where?: InputMaybe<InsertListingGoogleAddressesBoolExp>;
};

export enum InsertListingGoogleAddressesUpdateColumn {
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Ctn = 'ctn',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  PlaceType = 'place_type',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  Route = 'route',
  /** column name */
  State = 'state',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingGoogleReviewsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingGoogleReviewsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingGoogleReviewsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingGoogleReviewsAggregateBoolExpCount>;
};

export type InsertListingGoogleReviewsAggregateBoolExpBoolAnd = {
  arguments: InsertListingGoogleReviewsSelectColumnGoogleReviewsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingGoogleReviewsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingGoogleReviewsAggregateBoolExpBoolOr = {
  arguments: InsertListingGoogleReviewsSelectColumnGoogleReviewsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingGoogleReviewsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingGoogleReviewsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingGoogleReviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingGoogleReviewsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingGoogleReviewsArrRelInsertInput = {
  data: Array<InsertListingGoogleReviewsInsertInput>;
  on_conflict?: InputMaybe<InsertListingGoogleReviewsOnConflict>;
};

export type InsertListingGoogleReviewsBoolExp = {
  _and?: InputMaybe<Array<InsertListingGoogleReviewsBoolExp>>;
  _not?: InputMaybe<InsertListingGoogleReviewsBoolExp>;
  _or?: InputMaybe<Array<InsertListingGoogleReviewsBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  google_place_id?: InputMaybe<InsertListingStringComparisonExp>;
  google_timestamp?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  local_guide?: InputMaybe<InsertListingBooleanComparisonExp>;
  original_owner_answer?: InputMaybe<InsertListingStringComparisonExp>;
  original_review_text?: InputMaybe<InsertListingStringComparisonExp>;
  owner_answer?: InputMaybe<InsertListingStringComparisonExp>;
  profile_image_url?: InputMaybe<InsertListingStringComparisonExp>;
  profile_name?: InputMaybe<InsertListingStringComparisonExp>;
  profile_url?: InputMaybe<InsertListingStringComparisonExp>;
  rating?: InputMaybe<InsertListingIntComparisonExp>;
  review_text?: InputMaybe<InsertListingStringComparisonExp>;
  review_url?: InputMaybe<InsertListingStringComparisonExp>;
  team?: InputMaybe<InsertListingTeamsBoolExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingGoogleReviewsConstraint {
  /** unique or primary key constraint on columns "id" */
  GoogleReviewsPkey = 'google_reviews_pkey',
  /** unique or primary key constraint on columns "profile_url", "team_id" */
  GoogleReviewsTeamIdProfileUrlKey = 'google_reviews_team_id_profile_url_key'
}

export type InsertListingGoogleReviewsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  google_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  local_guide?: InputMaybe<Scalars['Boolean']['input']>;
  original_owner_answer?: InputMaybe<Scalars['String']['input']>;
  original_review_text?: InputMaybe<Scalars['String']['input']>;
  owner_answer?: InputMaybe<Scalars['String']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  profile_name?: InputMaybe<Scalars['String']['input']>;
  profile_url?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_text?: InputMaybe<Scalars['String']['input']>;
  review_url?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingGoogleReviewsOnConflict = {
  constraint: InsertListingGoogleReviewsConstraint;
  update_columns: Array<InsertListingGoogleReviewsUpdateColumn>;
  where?: InputMaybe<InsertListingGoogleReviewsBoolExp>;
};

export enum InsertListingGoogleReviewsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  GoogleTimestamp = 'google_timestamp',
  /** column name */
  Id = 'id',
  /** column name */
  LocalGuide = 'local_guide',
  /** column name */
  OriginalOwnerAnswer = 'original_owner_answer',
  /** column name */
  OriginalReviewText = 'original_review_text',
  /** column name */
  OwnerAnswer = 'owner_answer',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  ProfileName = 'profile_name',
  /** column name */
  ProfileUrl = 'profile_url',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewText = 'review_text',
  /** column name */
  ReviewUrl = 'review_url',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingGoogleReviewsSelectColumnGoogleReviewsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  LocalGuide = 'local_guide'
}

export enum InsertListingGoogleReviewsSelectColumnGoogleReviewsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  LocalGuide = 'local_guide'
}

export enum InsertListingGoogleReviewsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  GoogleTimestamp = 'google_timestamp',
  /** column name */
  Id = 'id',
  /** column name */
  LocalGuide = 'local_guide',
  /** column name */
  OriginalOwnerAnswer = 'original_owner_answer',
  /** column name */
  OriginalReviewText = 'original_review_text',
  /** column name */
  OwnerAnswer = 'owner_answer',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  ProfileName = 'profile_name',
  /** column name */
  ProfileUrl = 'profile_url',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewText = 'review_text',
  /** column name */
  ReviewUrl = 'review_url',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingHeatingDistributionEnumEnum {
  Floor = 'floor',
  ForcedAir = 'forced_air',
  Other = 'other',
  Radiators = 'radiators',
  Stove = 'stove'
}

export type InsertListingHeatingDistributionEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingHeatingDistributionEnumEnum>;
  _in?: InputMaybe<Array<InsertListingHeatingDistributionEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingHeatingDistributionEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingHeatingDistributionEnumEnum>>;
};

export enum InsertListingHeatingEnumEnum {
  Central = 'central',
  District = 'district',
  Electric = 'electric',
  Gas = 'gas',
  HeatPump = 'heat_pump',
  None = 'none',
  Oil = 'oil',
  Other = 'other',
  Solar = 'solar',
  Wood = 'wood'
}

export type InsertListingHeatingEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingHeatingEnumEnum>;
  _in?: InputMaybe<Array<InsertListingHeatingEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingHeatingEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingHeatingEnumEnum>>;
};

export type InsertListingImagesBoolExp = {
  _and?: InputMaybe<Array<InsertListingImagesBoolExp>>;
  _not?: InputMaybe<InsertListingImagesBoolExp>;
  _or?: InputMaybe<Array<InsertListingImagesBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  url?: InputMaybe<InsertListingStringComparisonExp>;
  user_images?: InputMaybe<InsertListingUserImagesBoolExp>;
  user_images_aggregate?: InputMaybe<InsertListingUserImagesAggregateBoolExp>;
};

export enum InsertListingImagesConstraint {
  /** unique or primary key constraint on columns "id" */
  ImagesPkey = 'images_pkey'
}

export type InsertListingImagesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user_images?: InputMaybe<InsertListingUserImagesArrRelInsertInput>;
};

export type InsertListingImagesObjRelInsertInput = {
  data: InsertListingImagesInsertInput;
  on_conflict?: InputMaybe<InsertListingImagesOnConflict>;
};

export type InsertListingImagesOnConflict = {
  constraint: InsertListingImagesConstraint;
  update_columns: Array<InsertListingImagesUpdateColumn>;
  where?: InputMaybe<InsertListingImagesBoolExp>;
};

export enum InsertListingImagesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

export type InsertListingIntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InsertListingInvoiceStatusComparisonExp = {
  _eq?: InputMaybe<Scalars['invoice_status']['input']>;
  _gt?: InputMaybe<Scalars['invoice_status']['input']>;
  _gte?: InputMaybe<Scalars['invoice_status']['input']>;
  _in?: InputMaybe<Array<Scalars['invoice_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['invoice_status']['input']>;
  _lte?: InputMaybe<Scalars['invoice_status']['input']>;
  _neq?: InputMaybe<Scalars['invoice_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['invoice_status']['input']>>;
};

export type InsertListingInvoicesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingInvoicesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingInvoicesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingInvoicesAggregateBoolExpCount>;
};

export type InsertListingInvoicesAggregateBoolExpBoolAnd = {
  arguments: InsertListingInvoicesSelectColumnInvoicesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingInvoicesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingInvoicesAggregateBoolExpBoolOr = {
  arguments: InsertListingInvoicesSelectColumnInvoicesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingInvoicesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingInvoicesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingInvoicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingInvoicesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingInvoicesArrRelInsertInput = {
  data: Array<InsertListingInvoicesInsertInput>;
  on_conflict?: InputMaybe<InsertListingInvoicesOnConflict>;
};

export type InsertListingInvoicesBoolExp = {
  _and?: InputMaybe<Array<InsertListingInvoicesBoolExp>>;
  _not?: InputMaybe<InsertListingInvoicesBoolExp>;
  _or?: InputMaybe<Array<InsertListingInvoicesBoolExp>>;
  account_country?: InputMaybe<InsertListingStringComparisonExp>;
  account_name?: InputMaybe<InsertListingStringComparisonExp>;
  account_tax_ids?: InputMaybe<InsertListingJsonbComparisonExp>;
  amount_due?: InputMaybe<InsertListingIntComparisonExp>;
  amount_paid?: InputMaybe<InsertListingIntComparisonExp>;
  amount_remaining?: InputMaybe<InsertListingIntComparisonExp>;
  application_fee_amount?: InputMaybe<InsertListingIntComparisonExp>;
  attempt_count?: InputMaybe<InsertListingIntComparisonExp>;
  attempted?: InputMaybe<InsertListingBooleanComparisonExp>;
  auto_advance?: InputMaybe<InsertListingBooleanComparisonExp>;
  billing_reason?: InputMaybe<InsertListingStringComparisonExp>;
  charge?: InputMaybe<InsertListingStringComparisonExp>;
  collection_method?: InputMaybe<InsertListingStringComparisonExp>;
  created?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  currency?: InputMaybe<InsertListingStringComparisonExp>;
  custom_fields?: InputMaybe<InsertListingJsonbComparisonExp>;
  customer?: InputMaybe<InsertListingStringComparisonExp>;
  customer_address?: InputMaybe<InsertListingJsonbComparisonExp>;
  customer_email_raw?: InputMaybe<InsertListingStringComparisonExp>;
  customer_name?: InputMaybe<InsertListingStringComparisonExp>;
  customer_phone?: InputMaybe<InsertListingStringComparisonExp>;
  customer_shipping?: InputMaybe<InsertListingJsonbComparisonExp>;
  customer_tax_exempt?: InputMaybe<InsertListingStringComparisonExp>;
  customer_tax_ids?: InputMaybe<InsertListingJsonbComparisonExp>;
  default_payment_method?: InputMaybe<InsertListingStringComparisonExp>;
  default_source?: InputMaybe<InsertListingStringComparisonExp>;
  default_tax_rates?: InputMaybe<InsertListingJsonbComparisonExp>;
  description?: InputMaybe<InsertListingStringComparisonExp>;
  discounts?: InputMaybe<InsertListingJsonbComparisonExp>;
  due_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  ending_balance?: InputMaybe<InsertListingIntComparisonExp>;
  footer?: InputMaybe<InsertListingStringComparisonExp>;
  hosted_invoice_url?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  invoice_object?: InputMaybe<InsertListingJsonbComparisonExp>;
  invoice_pdf?: InputMaybe<InsertListingStringComparisonExp>;
  last_finalization_error?: InputMaybe<InsertListingJsonbComparisonExp>;
  lines?: InputMaybe<InsertListingJsonbComparisonExp>;
  livemode?: InputMaybe<InsertListingBooleanComparisonExp>;
  metadata?: InputMaybe<InsertListingJsonbComparisonExp>;
  next_payment_attempt?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  number?: InputMaybe<InsertListingStringComparisonExp>;
  on_behalf_of?: InputMaybe<InsertListingStringComparisonExp>;
  paid?: InputMaybe<InsertListingBooleanComparisonExp>;
  payment_intent?: InputMaybe<InsertListingStringComparisonExp>;
  payment_settings?: InputMaybe<InsertListingJsonbComparisonExp>;
  period_end?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  period_start?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  post_payment_credit_notes_amount?: InputMaybe<InsertListingIntComparisonExp>;
  pre_payment_credit_notes_amount?: InputMaybe<InsertListingIntComparisonExp>;
  receipt_number?: InputMaybe<InsertListingStringComparisonExp>;
  starting_balance?: InputMaybe<InsertListingIntComparisonExp>;
  statement_descriptor?: InputMaybe<InsertListingStringComparisonExp>;
  status?: InputMaybe<InsertListingInvoiceStatusComparisonExp>;
  status_transitions?: InputMaybe<InsertListingJsonbComparisonExp>;
  stripe_id?: InputMaybe<InsertListingStringComparisonExp>;
  subscription?: InputMaybe<InsertListingStringComparisonExp>;
  subscription_proration_date?: InputMaybe<InsertListingIntComparisonExp>;
  subtotal?: InputMaybe<InsertListingIntComparisonExp>;
  tax?: InputMaybe<InsertListingIntComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  threshold_reason?: InputMaybe<InsertListingJsonbComparisonExp>;
  total?: InputMaybe<InsertListingIntComparisonExp>;
  total_discount_amounts?: InputMaybe<InsertListingJsonbComparisonExp>;
  total_tax_amounts?: InputMaybe<InsertListingJsonbComparisonExp>;
  transfer_data?: InputMaybe<InsertListingJsonbComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  webhooks_delivered_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingInvoicesConstraint {
  /** unique or primary key constraint on columns "id" */
  InvoicesPkey = 'invoices_pkey',
  /** unique or primary key constraint on columns "stripe_id" */
  InvoicesStripeIdUnique = 'invoices_stripe_id_unique'
}

export type InsertListingInvoicesInsertInput = {
  account_country?: InputMaybe<Scalars['String']['input']>;
  account_name?: InputMaybe<Scalars['String']['input']>;
  account_tax_ids?: InputMaybe<Scalars['jsonb']['input']>;
  amount_due?: InputMaybe<Scalars['Int']['input']>;
  amount_paid?: InputMaybe<Scalars['Int']['input']>;
  amount_remaining?: InputMaybe<Scalars['Int']['input']>;
  application_fee_amount?: InputMaybe<Scalars['Int']['input']>;
  attempt_count?: InputMaybe<Scalars['Int']['input']>;
  attempted?: InputMaybe<Scalars['Boolean']['input']>;
  auto_advance?: InputMaybe<Scalars['Boolean']['input']>;
  billing_reason?: InputMaybe<Scalars['String']['input']>;
  charge?: InputMaybe<Scalars['String']['input']>;
  collection_method?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  custom_fields?: InputMaybe<Scalars['jsonb']['input']>;
  customer?: InputMaybe<Scalars['String']['input']>;
  customer_address?: InputMaybe<Scalars['jsonb']['input']>;
  customer_email_raw?: InputMaybe<Scalars['String']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  customer_phone?: InputMaybe<Scalars['String']['input']>;
  customer_shipping?: InputMaybe<Scalars['jsonb']['input']>;
  customer_tax_exempt?: InputMaybe<Scalars['String']['input']>;
  customer_tax_ids?: InputMaybe<Scalars['jsonb']['input']>;
  default_payment_method?: InputMaybe<Scalars['String']['input']>;
  default_source?: InputMaybe<Scalars['String']['input']>;
  default_tax_rates?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Scalars['jsonb']['input']>;
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  ending_balance?: InputMaybe<Scalars['Int']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  hosted_invoice_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_object?: InputMaybe<Scalars['jsonb']['input']>;
  invoice_pdf?: InputMaybe<Scalars['String']['input']>;
  last_finalization_error?: InputMaybe<Scalars['jsonb']['input']>;
  lines?: InputMaybe<Scalars['jsonb']['input']>;
  livemode?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  next_payment_attempt?: InputMaybe<Scalars['timestamptz']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  on_behalf_of?: InputMaybe<Scalars['String']['input']>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_settings?: InputMaybe<Scalars['jsonb']['input']>;
  period_end?: InputMaybe<Scalars['timestamptz']['input']>;
  period_start?: InputMaybe<Scalars['timestamptz']['input']>;
  post_payment_credit_notes_amount?: InputMaybe<Scalars['Int']['input']>;
  pre_payment_credit_notes_amount?: InputMaybe<Scalars['Int']['input']>;
  receipt_number?: InputMaybe<Scalars['String']['input']>;
  starting_balance?: InputMaybe<Scalars['Int']['input']>;
  statement_descriptor?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['invoice_status']['input']>;
  status_transitions?: InputMaybe<Scalars['jsonb']['input']>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  subscription?: InputMaybe<Scalars['String']['input']>;
  subscription_proration_date?: InputMaybe<Scalars['Int']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  tax?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  threshold_reason?: InputMaybe<Scalars['jsonb']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  total_discount_amounts?: InputMaybe<Scalars['jsonb']['input']>;
  total_tax_amounts?: InputMaybe<Scalars['jsonb']['input']>;
  transfer_data?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  webhooks_delivered_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingInvoicesOnConflict = {
  constraint: InsertListingInvoicesConstraint;
  update_columns: Array<InsertListingInvoicesUpdateColumn>;
  where?: InputMaybe<InsertListingInvoicesBoolExp>;
};

export enum InsertListingInvoicesSelectColumn {
  /** column name */
  AccountCountry = 'account_country',
  /** column name */
  AccountName = 'account_name',
  /** column name */
  AccountTaxIds = 'account_tax_ids',
  /** column name */
  AmountDue = 'amount_due',
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  AmountRemaining = 'amount_remaining',
  /** column name */
  ApplicationFeeAmount = 'application_fee_amount',
  /** column name */
  AttemptCount = 'attempt_count',
  /** column name */
  Attempted = 'attempted',
  /** column name */
  AutoAdvance = 'auto_advance',
  /** column name */
  BillingReason = 'billing_reason',
  /** column name */
  Charge = 'charge',
  /** column name */
  CollectionMethod = 'collection_method',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  Customer = 'customer',
  /** column name */
  CustomerAddress = 'customer_address',
  /** column name */
  CustomerEmailRaw = 'customer_email_raw',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  CustomerPhone = 'customer_phone',
  /** column name */
  CustomerShipping = 'customer_shipping',
  /** column name */
  CustomerTaxExempt = 'customer_tax_exempt',
  /** column name */
  CustomerTaxIds = 'customer_tax_ids',
  /** column name */
  DefaultPaymentMethod = 'default_payment_method',
  /** column name */
  DefaultSource = 'default_source',
  /** column name */
  DefaultTaxRates = 'default_tax_rates',
  /** column name */
  Description = 'description',
  /** column name */
  Discounts = 'discounts',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  EndingBalance = 'ending_balance',
  /** column name */
  Footer = 'footer',
  /** column name */
  HostedInvoiceUrl = 'hosted_invoice_url',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceObject = 'invoice_object',
  /** column name */
  InvoicePdf = 'invoice_pdf',
  /** column name */
  LastFinalizationError = 'last_finalization_error',
  /** column name */
  Lines = 'lines',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextPaymentAttempt = 'next_payment_attempt',
  /** column name */
  Number = 'number',
  /** column name */
  OnBehalfOf = 'on_behalf_of',
  /** column name */
  Paid = 'paid',
  /** column name */
  PaymentIntent = 'payment_intent',
  /** column name */
  PaymentSettings = 'payment_settings',
  /** column name */
  PeriodEnd = 'period_end',
  /** column name */
  PeriodStart = 'period_start',
  /** column name */
  PostPaymentCreditNotesAmount = 'post_payment_credit_notes_amount',
  /** column name */
  PrePaymentCreditNotesAmount = 'pre_payment_credit_notes_amount',
  /** column name */
  ReceiptNumber = 'receipt_number',
  /** column name */
  StartingBalance = 'starting_balance',
  /** column name */
  StatementDescriptor = 'statement_descriptor',
  /** column name */
  Status = 'status',
  /** column name */
  StatusTransitions = 'status_transitions',
  /** column name */
  StripeId = 'stripe_id',
  /** column name */
  Subscription = 'subscription',
  /** column name */
  SubscriptionProrationDate = 'subscription_proration_date',
  /** column name */
  Subtotal = 'subtotal',
  /** column name */
  Tax = 'tax',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThresholdReason = 'threshold_reason',
  /** column name */
  Total = 'total',
  /** column name */
  TotalDiscountAmounts = 'total_discount_amounts',
  /** column name */
  TotalTaxAmounts = 'total_tax_amounts',
  /** column name */
  TransferData = 'transfer_data',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WebhooksDeliveredAt = 'webhooks_delivered_at'
}

export enum InsertListingInvoicesSelectColumnInvoicesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Attempted = 'attempted',
  /** column name */
  AutoAdvance = 'auto_advance',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Paid = 'paid'
}

export enum InsertListingInvoicesSelectColumnInvoicesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Attempted = 'attempted',
  /** column name */
  AutoAdvance = 'auto_advance',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Paid = 'paid'
}

export enum InsertListingInvoicesUpdateColumn {
  /** column name */
  AccountCountry = 'account_country',
  /** column name */
  AccountName = 'account_name',
  /** column name */
  AccountTaxIds = 'account_tax_ids',
  /** column name */
  AmountDue = 'amount_due',
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  AmountRemaining = 'amount_remaining',
  /** column name */
  ApplicationFeeAmount = 'application_fee_amount',
  /** column name */
  AttemptCount = 'attempt_count',
  /** column name */
  Attempted = 'attempted',
  /** column name */
  AutoAdvance = 'auto_advance',
  /** column name */
  BillingReason = 'billing_reason',
  /** column name */
  Charge = 'charge',
  /** column name */
  CollectionMethod = 'collection_method',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  Customer = 'customer',
  /** column name */
  CustomerAddress = 'customer_address',
  /** column name */
  CustomerEmailRaw = 'customer_email_raw',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  CustomerPhone = 'customer_phone',
  /** column name */
  CustomerShipping = 'customer_shipping',
  /** column name */
  CustomerTaxExempt = 'customer_tax_exempt',
  /** column name */
  CustomerTaxIds = 'customer_tax_ids',
  /** column name */
  DefaultPaymentMethod = 'default_payment_method',
  /** column name */
  DefaultSource = 'default_source',
  /** column name */
  DefaultTaxRates = 'default_tax_rates',
  /** column name */
  Description = 'description',
  /** column name */
  Discounts = 'discounts',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  EndingBalance = 'ending_balance',
  /** column name */
  Footer = 'footer',
  /** column name */
  HostedInvoiceUrl = 'hosted_invoice_url',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceObject = 'invoice_object',
  /** column name */
  InvoicePdf = 'invoice_pdf',
  /** column name */
  LastFinalizationError = 'last_finalization_error',
  /** column name */
  Lines = 'lines',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextPaymentAttempt = 'next_payment_attempt',
  /** column name */
  Number = 'number',
  /** column name */
  OnBehalfOf = 'on_behalf_of',
  /** column name */
  Paid = 'paid',
  /** column name */
  PaymentIntent = 'payment_intent',
  /** column name */
  PaymentSettings = 'payment_settings',
  /** column name */
  PeriodEnd = 'period_end',
  /** column name */
  PeriodStart = 'period_start',
  /** column name */
  PostPaymentCreditNotesAmount = 'post_payment_credit_notes_amount',
  /** column name */
  PrePaymentCreditNotesAmount = 'pre_payment_credit_notes_amount',
  /** column name */
  ReceiptNumber = 'receipt_number',
  /** column name */
  StartingBalance = 'starting_balance',
  /** column name */
  StatementDescriptor = 'statement_descriptor',
  /** column name */
  Status = 'status',
  /** column name */
  StatusTransitions = 'status_transitions',
  /** column name */
  StripeId = 'stripe_id',
  /** column name */
  Subscription = 'subscription',
  /** column name */
  SubscriptionProrationDate = 'subscription_proration_date',
  /** column name */
  Subtotal = 'subtotal',
  /** column name */
  Tax = 'tax',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThresholdReason = 'threshold_reason',
  /** column name */
  Total = 'total',
  /** column name */
  TotalDiscountAmounts = 'total_discount_amounts',
  /** column name */
  TotalTaxAmounts = 'total_tax_amounts',
  /** column name */
  TransferData = 'transfer_data',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WebhooksDeliveredAt = 'webhooks_delivered_at'
}

export type InsertListingJsonbArrayComparisonExp = {
  _contained_in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _contains?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _eq?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _gt?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _gte?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['jsonb']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _lte?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _neq?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['jsonb']['input']>>>;
};

export type InsertListingJsonbCastExp = {
  String?: InputMaybe<InsertListingStringComparisonExp>;
};

export type InsertListingJsonbComparisonExp = {
  _cast?: InputMaybe<InsertListingJsonbCastExp>;
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  _has_key?: InputMaybe<Scalars['String']['input']>;
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

export enum InsertListingLeadAgentSourceEnumEnum {
  Automation = 'automation',
  Crm = 'crm',
  ResultPage = 'result_page'
}

export type InsertListingLeadAgentSourceEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingLeadAgentSourceEnumEnum>;
  _in?: InputMaybe<Array<InsertListingLeadAgentSourceEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingLeadAgentSourceEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingLeadAgentSourceEnumEnum>>;
};

export type InsertListingLeadAgentsAggregateBoolExp = {
  count?: InputMaybe<InsertListingLeadAgentsAggregateBoolExpCount>;
};

export type InsertListingLeadAgentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLeadAgentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadAgentsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLeadAgentsArrRelInsertInput = {
  data: Array<InsertListingLeadAgentsInsertInput>;
  on_conflict?: InputMaybe<InsertListingLeadAgentsOnConflict>;
};

export type InsertListingLeadAgentsBoolExp = {
  _and?: InputMaybe<Array<InsertListingLeadAgentsBoolExp>>;
  _not?: InputMaybe<InsertListingLeadAgentsBoolExp>;
  _or?: InputMaybe<Array<InsertListingLeadAgentsBoolExp>>;
  claimed_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  lead?: InputMaybe<InsertListingLeadsBoolExp>;
  lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  lead_stage?: InputMaybe<InsertListingLeadStagesBoolExp>;
  passed_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  predicted_win_date?: InputMaybe<InsertListingDateComparisonExp>;
  source?: InputMaybe<InsertListingLeadAgentSourceEnumEnumComparisonExp>;
  stage_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  win_probability?: InputMaybe<InsertListingIntComparisonExp>;
};

export enum InsertListingLeadAgentsConstraint {
  /** unique or primary key constraint on columns "source", "user_id", "lead_id" */
  LeadAgentsLeadIdUserIdSourceKey = 'lead_agents_lead_id_user_id_source_key',
  /** unique or primary key constraint on columns "id" */
  LeadAgentsPkey = 'lead_agents_pkey'
}

export type InsertListingLeadAgentsInsertInput = {
  claimed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead?: InputMaybe<InsertListingLeadsObjRelInsertInput>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  lead_stage?: InputMaybe<InsertListingLeadStagesObjRelInsertInput>;
  passed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  predicted_win_date?: InputMaybe<Scalars['date']['input']>;
  source?: InputMaybe<InsertListingLeadAgentSourceEnumEnum>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  win_probability?: InputMaybe<Scalars['Int']['input']>;
};

export type InsertListingLeadAgentsOnConflict = {
  constraint: InsertListingLeadAgentsConstraint;
  update_columns: Array<InsertListingLeadAgentsUpdateColumn>;
  where?: InputMaybe<InsertListingLeadAgentsBoolExp>;
};

export enum InsertListingLeadAgentsSelectColumn {
  /** column name */
  ClaimedAt = 'claimed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  PassedAt = 'passed_at',
  /** column name */
  PredictedWinDate = 'predicted_win_date',
  /** column name */
  Source = 'source',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WinProbability = 'win_probability'
}

export enum InsertListingLeadAgentsUpdateColumn {
  /** column name */
  ClaimedAt = 'claimed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  PassedAt = 'passed_at',
  /** column name */
  PredictedWinDate = 'predicted_win_date',
  /** column name */
  Source = 'source',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WinProbability = 'win_probability'
}

export type InsertListingLeadBuyingStatusComparisonExp = {
  _eq?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _gt?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _gte?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _in?: InputMaybe<Array<Scalars['lead_buying_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _lte?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _neq?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['lead_buying_status']['input']>>;
};

export type InsertListingLeadLookingPlacesAggregateBoolExp = {
  count?: InputMaybe<InsertListingLeadLookingPlacesAggregateBoolExpCount>;
};

export type InsertListingLeadLookingPlacesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLeadLookingPlacesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadLookingPlacesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLeadLookingPlacesArrRelInsertInput = {
  data: Array<InsertListingLeadLookingPlacesInsertInput>;
  on_conflict?: InputMaybe<InsertListingLeadLookingPlacesOnConflict>;
};

export type InsertListingLeadLookingPlacesBoolExp = {
  _and?: InputMaybe<Array<InsertListingLeadLookingPlacesBoolExp>>;
  _not?: InputMaybe<InsertListingLeadLookingPlacesBoolExp>;
  _or?: InputMaybe<Array<InsertListingLeadLookingPlacesBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  place?: InputMaybe<InsertListingPlacesBoolExp>;
  place_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingLeadLookingPlacesConstraint {
  /** unique or primary key constraint on columns "place_id", "lead_id" */
  LeadLookingPlacesPkey = 'lead_looking_places_pkey'
}

export type InsertListingLeadLookingPlacesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingLeadLookingPlacesOnConflict = {
  constraint: InsertListingLeadLookingPlacesConstraint;
  update_columns: Array<InsertListingLeadLookingPlacesUpdateColumn>;
  where?: InputMaybe<InsertListingLeadLookingPlacesBoolExp>;
};

export enum InsertListingLeadLookingPlacesSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingLeadLookingPlacesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingLeadMortgageStatusComparisonExp = {
  _eq?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _gt?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _gte?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _in?: InputMaybe<Array<Scalars['lead_mortgage_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _lte?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _neq?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['lead_mortgage_status']['input']>>;
};

export type InsertListingLeadOwnershipComparisonExp = {
  _eq?: InputMaybe<Scalars['lead_ownership']['input']>;
  _gt?: InputMaybe<Scalars['lead_ownership']['input']>;
  _gte?: InputMaybe<Scalars['lead_ownership']['input']>;
  _in?: InputMaybe<Array<Scalars['lead_ownership']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['lead_ownership']['input']>;
  _lte?: InputMaybe<Scalars['lead_ownership']['input']>;
  _neq?: InputMaybe<Scalars['lead_ownership']['input']>;
  _nin?: InputMaybe<Array<Scalars['lead_ownership']['input']>>;
};

export type InsertListingLeadStagesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingLeadStagesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingLeadStagesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingLeadStagesAggregateBoolExpCount>;
};

export type InsertListingLeadStagesAggregateBoolExpBoolAnd = {
  arguments: InsertListingLeadStagesSelectColumnLeadStagesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadStagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingLeadStagesAggregateBoolExpBoolOr = {
  arguments: InsertListingLeadStagesSelectColumnLeadStagesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadStagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingLeadStagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLeadStagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadStagesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLeadStagesArrRelInsertInput = {
  data: Array<InsertListingLeadStagesInsertInput>;
  on_conflict?: InputMaybe<InsertListingLeadStagesOnConflict>;
};

export type InsertListingLeadStagesBoolExp = {
  _and?: InputMaybe<Array<InsertListingLeadStagesBoolExp>>;
  _not?: InputMaybe<InsertListingLeadStagesBoolExp>;
  _or?: InputMaybe<Array<InsertListingLeadStagesBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  deletable?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  label?: InputMaybe<InsertListingStringComparisonExp>;
  label_de?: InputMaybe<InsertListingStringComparisonExp>;
  label_en?: InputMaybe<InsertListingStringComparisonExp>;
  label_es?: InputMaybe<InsertListingStringComparisonExp>;
  label_fr?: InputMaybe<InsertListingStringComparisonExp>;
  label_it?: InputMaybe<InsertListingStringComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  pipeline?: InputMaybe<InsertListingPipelinesBoolExp>;
  pipeline_id?: InputMaybe<InsertListingUuidComparisonExp>;
  status?: InputMaybe<InsertListingLeadsStatusEnumComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingLeadStagesConstraint {
  /** unique or primary key constraint on columns "order_nr", "pipeline_id" */
  LeadStagesPipelineIdOrderNrUnique = 'lead_stages_pipeline_id_order_nr_unique',
  /** unique or primary key constraint on columns "id" */
  LeadStagesPkey = 'lead_stages_pkey'
}

export type InsertListingLeadStagesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deletable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  pipeline?: InputMaybe<InsertListingPipelinesObjRelInsertInput>;
  pipeline_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<InsertListingLeadsStatusEnum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingLeadStagesObjRelInsertInput = {
  data: InsertListingLeadStagesInsertInput;
  on_conflict?: InputMaybe<InsertListingLeadStagesOnConflict>;
};

export type InsertListingLeadStagesOnConflict = {
  constraint: InsertListingLeadStagesConstraint;
  update_columns: Array<InsertListingLeadStagesUpdateColumn>;
  where?: InputMaybe<InsertListingLeadStagesBoolExp>;
};

export enum InsertListingLeadStagesSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deletable = 'deletable',
  /** column name */
  Id = 'id',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  Name = 'name',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PipelineId = 'pipeline_id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingLeadStagesSelectColumnLeadStagesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Deletable = 'deletable'
}

export enum InsertListingLeadStagesSelectColumnLeadStagesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Deletable = 'deletable'
}

export enum InsertListingLeadStagesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deletable = 'deletable',
  /** column name */
  Id = 'id',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  Name = 'name',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PipelineId = 'pipeline_id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingLeadTypeComparisonExp = {
  _eq?: InputMaybe<Scalars['lead_type']['input']>;
  _gt?: InputMaybe<Scalars['lead_type']['input']>;
  _gte?: InputMaybe<Scalars['lead_type']['input']>;
  _in?: InputMaybe<Array<Scalars['lead_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['lead_type']['input']>;
  _lte?: InputMaybe<Scalars['lead_type']['input']>;
  _neq?: InputMaybe<Scalars['lead_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['lead_type']['input']>>;
};

export type InsertListingLeadsAggregateBoolExp = {
  avg?: InputMaybe<InsertListingLeadsAggregateBoolExpAvg>;
  bool_and?: InputMaybe<InsertListingLeadsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingLeadsAggregateBoolExpBoolOr>;
  corr?: InputMaybe<InsertListingLeadsAggregateBoolExpCorr>;
  count?: InputMaybe<InsertListingLeadsAggregateBoolExpCount>;
  covar_samp?: InputMaybe<InsertListingLeadsAggregateBoolExpCovarSamp>;
  max?: InputMaybe<InsertListingLeadsAggregateBoolExpMax>;
  min?: InputMaybe<InsertListingLeadsAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<InsertListingLeadsAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<InsertListingLeadsAggregateBoolExpSum>;
  var_samp?: InputMaybe<InsertListingLeadsAggregateBoolExpVarSamp>;
};

export type InsertListingLeadsAggregateBoolExpAvg = {
  arguments: InsertListingLeadsSelectColumnLeadsAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpBoolAnd = {
  arguments: InsertListingLeadsSelectColumnLeadsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpBoolOr = {
  arguments: InsertListingLeadsSelectColumnLeadsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpCorr = {
  arguments: InsertListingLeadsAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpCorrArguments = {
  X: InsertListingLeadsSelectColumnLeadsAggregateBoolExpCorrArgumentsColumns;
  Y: InsertListingLeadsSelectColumnLeadsAggregateBoolExpCorrArgumentsColumns;
};

export type InsertListingLeadsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLeadsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpCovarSamp = {
  arguments: InsertListingLeadsAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpCovarSampArguments = {
  X: InsertListingLeadsSelectColumnLeadsAggregateBoolExpCovarSampArgumentsColumns;
  Y: InsertListingLeadsSelectColumnLeadsAggregateBoolExpCovarSampArgumentsColumns;
};

export type InsertListingLeadsAggregateBoolExpMax = {
  arguments: InsertListingLeadsSelectColumnLeadsAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpMin = {
  arguments: InsertListingLeadsSelectColumnLeadsAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpStddevSamp = {
  arguments: InsertListingLeadsSelectColumnLeadsAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpSum = {
  arguments: InsertListingLeadsSelectColumnLeadsAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpVarSamp = {
  arguments: InsertListingLeadsSelectColumnLeadsAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export enum InsertListingLeadsAppraisalReasonEnum {
  AlreadyForSale = 'already_for_sale',
  BuySoon = 'buy_soon',
  BuyThis = 'buy_this',
  Inheritance = 'inheritance',
  MoveRental = 'move_rental',
  NotSelling = 'not_selling',
  NotSet = 'not_set',
  Other = 'other',
  OtherNotOwner = 'other_not_owner',
  OtherOwner = 'other_owner',
  OtherRenting = 'other_renting',
  Refinance = 'refinance',
  Sell = 'sell',
  Separation = 'separation'
}

export type InsertListingLeadsAppraisalReasonEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingLeadsAppraisalReasonEnum>;
  _in?: InputMaybe<Array<InsertListingLeadsAppraisalReasonEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingLeadsAppraisalReasonEnum>;
  _nin?: InputMaybe<Array<InsertListingLeadsAppraisalReasonEnum>>;
};

export type InsertListingLeadsArrRelInsertInput = {
  data: Array<InsertListingLeadsInsertInput>;
  on_conflict?: InputMaybe<InsertListingLeadsOnConflict>;
};

export type InsertListingLeadsBoolExp = {
  _and?: InputMaybe<Array<InsertListingLeadsBoolExp>>;
  _not?: InputMaybe<InsertListingLeadsBoolExp>;
  _or?: InputMaybe<Array<InsertListingLeadsBoolExp>>;
  activities?: InputMaybe<InsertListingActivitiesBoolExp>;
  activities_aggregate?: InputMaybe<InsertListingActivitiesAggregateBoolExp>;
  affordability_rate?: InputMaybe<InsertListingFloat8ComparisonExp>;
  annual_premium?: InputMaybe<InsertListingFloat8ComparisonExp>;
  appraisal_inheritance_next_step?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_market_time?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_monthly_gross_rent?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_next_step?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_open_to_offer?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_perceived_value?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_perception?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_balcony_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_building_condition?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_built_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_commercial_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_construction_year?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_country?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_country_code?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_ctn?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_floor_of_flat?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_garden_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_google_address_id?: InputMaybe<InsertListingUuidComparisonExp>;
  appraisal_property_has_elevator?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_has_garden?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_has_storage_room?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_has_swimming_pool?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_has_view?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_income_includes_parking?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_is_commercial_fully_rented?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_is_parking_fully_rented?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_is_renovated?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_is_residential_fully_rented?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_know_plot_number?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_land_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_lat?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_living_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_lng?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_locality?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_number_of_bathrooms?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_number_of_bedrooms?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_number_of_commercial_units?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_number_of_floors?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_number_of_residential_units?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_number_of_rooms?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_occupied?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_plot_number?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_postcode?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_property_type_id?: InputMaybe<InsertListingUuidComparisonExp>;
  appraisal_property_renovation_year?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_residential_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_route?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_side?: InputMaybe<InsertListingPropertySideEnumEnumComparisonExp>;
  appraisal_property_state?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_street_number?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_usage?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_reason?: InputMaybe<InsertListingLeadsAppraisalReasonEnumComparisonExp>;
  appraisal_selling_with?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_separation_next_step?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_step?: InputMaybe<InsertListingStringComparisonExp>;
  assets_second_pillar?: InputMaybe<InsertListingFloat8ComparisonExp>;
  assets_third_pillar_a_organisation?: InputMaybe<InsertListingStringComparisonExp>;
  broker?: InputMaybe<InsertListingUsersBoolExp>;
  broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  buy_horizon?: InputMaybe<InsertListingLeadsBuyHorizonEnumComparisonExp>;
  call_times?: InputMaybe<InsertListingStringArrayComparisonExp>;
  cma_reports?: InputMaybe<InsertListingCmaReportsBoolExp>;
  cma_reports_aggregate?: InputMaybe<InsertListingCmaReportsAggregateBoolExp>;
  completed?: InputMaybe<InsertListingBooleanComparisonExp>;
  contact?: InputMaybe<InsertListingUsersBoolExp>;
  contact_id?: InputMaybe<InsertListingUuidComparisonExp>;
  createdBy?: InputMaybe<InsertListingUsersBoolExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  creator?: InputMaybe<InsertListingUsersBoolExp>;
  crm_link?: InputMaybe<InsertListingStringComparisonExp>;
  date_of_birth?: InputMaybe<InsertListingDateComparisonExp>;
  debt?: InputMaybe<InsertListingFloat8ComparisonExp>;
  donation?: InputMaybe<InsertListingFloat8ComparisonExp>;
  email_address?: InputMaybe<InsertListingStringComparisonExp>;
  financing_crm_link?: InputMaybe<InsertListingStringComparisonExp>;
  financing_secured?: InputMaybe<InsertListingBooleanComparisonExp>;
  first_name?: InputMaybe<InsertListingStringComparisonExp>;
  fund_usage?: InputMaybe<InsertListingFloat8ComparisonExp>;
  gender?: InputMaybe<InsertListingStringComparisonExp>;
  google_address?: InputMaybe<InsertListingGoogleAddressesBoolExp>;
  has_accepted_terms?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_dependant_children?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_no_street_number?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_other_credits?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  imported_id?: InputMaybe<InsertListingStringComparisonExp>;
  landing_page_url?: InputMaybe<InsertListingStringComparisonExp>;
  last_activity?: InputMaybe<InsertListingActivitiesBoolExp>;
  last_activity_done_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  last_bonus?: InputMaybe<InsertListingFloat8ComparisonExp>;
  last_name?: InputMaybe<InsertListingStringComparisonExp>;
  last_requalification_mail_sent_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  last_requalification_sms_sent_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  lead_agents?: InputMaybe<InsertListingLeadAgentsBoolExp>;
  lead_agents_aggregate?: InputMaybe<InsertListingLeadAgentsAggregateBoolExp>;
  lead_looking_places?: InputMaybe<InsertListingLeadLookingPlacesBoolExp>;
  lead_looking_places_aggregate?: InputMaybe<InsertListingLeadLookingPlacesAggregateBoolExp>;
  leads_tags?: InputMaybe<InsertListingLeadsTagsBoolExp>;
  leads_tags_aggregate?: InputMaybe<InsertListingLeadsTagsAggregateBoolExp>;
  lots?: InputMaybe<InsertListingLotsBoolExp>;
  lots_aggregate?: InputMaybe<InsertListingLotsAggregateBoolExp>;
  mandate_probability?: InputMaybe<InsertListingIntComparisonExp>;
  marital_status?: InputMaybe<InsertListingStringComparisonExp>;
  max_property_value?: InputMaybe<InsertListingFloat8ComparisonExp>;
  mortgage_auto_mortgage_type?: InputMaybe<InsertListingBooleanComparisonExp>;
  mortgage_buying_status?: InputMaybe<InsertListingLeadBuyingStatusComparisonExp>;
  mortgage_comments?: InputMaybe<InsertListingStringComparisonExp>;
  mortgage_financial_institution?: InputMaybe<InsertListingStringComparisonExp>;
  mortgage_google_address?: InputMaybe<InsertListingGoogleAddressesBoolExp>;
  mortgage_google_address_id?: InputMaybe<InsertListingUuidComparisonExp>;
  mortgage_has_mortgage?: InputMaybe<InsertListingBooleanComparisonExp>;
  mortgage_insurance_provider_id?: InputMaybe<InsertListingUuidComparisonExp>;
  mortgage_insurance_revenue?: InputMaybe<InsertListingFloatComparisonExp>;
  mortgage_interest_rate?: InputMaybe<InsertListingFloatComparisonExp>;
  mortgage_interest_rate_type?: InputMaybe<InsertListingMortgageInterestRateTypeComparisonExp>;
  mortgage_is_construction?: InputMaybe<InsertListingBooleanComparisonExp>;
  mortgage_is_property_identified?: InputMaybe<InsertListingBooleanComparisonExp>;
  mortgage_lender_id?: InputMaybe<InsertListingUuidComparisonExp>;
  mortgage_lender_name?: InputMaybe<InsertListingStringComparisonExp>;
  mortgage_lender_type?: InputMaybe<InsertListingMortgageLenderTypeComparisonExp>;
  mortgage_mortgage_type?: InputMaybe<InsertListingStringComparisonExp>;
  mortgage_notary_id?: InputMaybe<InsertListingUuidComparisonExp>;
  mortgage_product_mortgage?: InputMaybe<InsertListingBooleanComparisonExp>;
  mortgage_product_third_pillar?: InputMaybe<InsertListingBooleanComparisonExp>;
  mortgage_property_usage?: InputMaybe<InsertListingStringComparisonExp>;
  mortgage_property_value?: InputMaybe<InsertListingFloat8ComparisonExp>;
  mortgage_purchase_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  mortgage_purchase_price?: InputMaybe<InsertListingFloatComparisonExp>;
  mortgage_real_estate_broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  mortgage_report_type?: InputMaybe<InsertListingStringComparisonExp>;
  mortgage_revenue?: InputMaybe<InsertListingFloatComparisonExp>;
  mortgage_sell?: InputMaybe<InsertListingBooleanComparisonExp>;
  mortgage_start_date?: InputMaybe<InsertListingDateComparisonExp>;
  mortgage_status?: InputMaybe<InsertListingLeadMortgageStatusComparisonExp>;
  mortgage_step?: InputMaybe<InsertListingStringComparisonExp>;
  mortgage_term?: InputMaybe<InsertListingStringComparisonExp>;
  nationality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  next_activity?: InputMaybe<InsertListingActivitiesBoolExp>;
  next_activity_due_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  number_of_buyers?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_dependant_children?: InputMaybe<InsertListingIntComparisonExp>;
  occupation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  occupation_text?: InputMaybe<InsertListingStringComparisonExp>;
  other_credits?: InputMaybe<InsertListingIntComparisonExp>;
  ownership?: InputMaybe<InsertListingLeadOwnershipComparisonExp>;
  parent_lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  partner_annual_premium?: InputMaybe<InsertListingFloat8ComparisonExp>;
  partner_date_of_birth?: InputMaybe<InsertListingDateComparisonExp>;
  partner_donation?: InputMaybe<InsertListingFloat8ComparisonExp>;
  partner_first_name?: InputMaybe<InsertListingStringComparisonExp>;
  partner_gender?: InputMaybe<InsertListingStringComparisonExp>;
  partner_has_other_credits?: InputMaybe<InsertListingBooleanComparisonExp>;
  partner_has_third_pillar?: InputMaybe<InsertListingBooleanComparisonExp>;
  partner_last_bonus?: InputMaybe<InsertListingFloat8ComparisonExp>;
  partner_last_name?: InputMaybe<InsertListingStringComparisonExp>;
  partner_marital_status?: InputMaybe<InsertListingStringComparisonExp>;
  partner_nationality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  partner_occupation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  partner_occupation_text?: InputMaybe<InsertListingStringComparisonExp>;
  partner_other_credits?: InputMaybe<InsertListingFloat8ComparisonExp>;
  partner_professional_situation?: InputMaybe<InsertListingUserProfessionalSituationComparisonExp>;
  partner_residence_country_code?: InputMaybe<InsertListingStringComparisonExp>;
  partner_residence_state_id?: InputMaybe<InsertListingUuidComparisonExp>;
  partner_savings?: InputMaybe<InsertListingFloat8ComparisonExp>;
  partner_second_pillar?: InputMaybe<InsertListingFloat8ComparisonExp>;
  partner_third_pillar?: InputMaybe<InsertListingFloat8ComparisonExp>;
  partner_third_pillar_a_organisation?: InputMaybe<InsertListingStringComparisonExp>;
  partner_use_bank_third_pillar?: InputMaybe<InsertListingBooleanComparisonExp>;
  partner_use_insurance_third_pillar?: InputMaybe<InsertListingBooleanComparisonExp>;
  partner_work_permit_id?: InputMaybe<InsertListingUuidComparisonExp>;
  partner_yearly_revenues?: InputMaybe<InsertListingFloat8ComparisonExp>;
  partner_yearly_revenues_at_retirement?: InputMaybe<InsertListingFloat8ComparisonExp>;
  phone_number?: InputMaybe<InsertListingStringComparisonExp>;
  pos_within_stage?: InputMaybe<InsertListingIntComparisonExp>;
  potential_development?: InputMaybe<InsertListingBooleanComparisonExp>;
  predicted_listing_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  professional_situation?: InputMaybe<InsertListingUserProfessionalSituationComparisonExp>;
  property?: InputMaybe<InsertListingPropertiesBoolExp>;
  property_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_search_notification?: InputMaybe<InsertListingPropertySearchesNotificationComparisonExp>;
  property_type?: InputMaybe<InsertListingPropertyTypesBoolExp>;
  property_usage?: InputMaybe<InsertListingLeadsPropertyUsageEnumComparisonExp>;
  received_mortgage_offer?: InputMaybe<InsertListingBooleanComparisonExp>;
  referrer?: InputMaybe<InsertListingStringComparisonExp>;
  referring_domain?: InputMaybe<InsertListingStringComparisonExp>;
  refused_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  relationship?: InputMaybe<InsertListingLeadsRelationshipEnumComparisonExp>;
  requalification_status?: InputMaybe<InsertListingLeadsRequalificationStatusEnumComparisonExp>;
  requalified_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  requalified_or_created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  residence_country_code?: InputMaybe<InsertListingStringComparisonExp>;
  residence_state_id?: InputMaybe<InsertListingUuidComparisonExp>;
  sale_comments?: InputMaybe<InsertListingStringComparisonExp>;
  sale_has_found?: InputMaybe<InsertListingBooleanComparisonExp>;
  sale_horizon?: InputMaybe<InsertListingLeadsSaleHorizonEnumComparisonExp>;
  sale_is_seller?: InputMaybe<InsertListingBooleanComparisonExp>;
  sale_price?: InputMaybe<InsertListingIntComparisonExp>;
  sale_started?: InputMaybe<InsertListingBooleanComparisonExp>;
  savings?: InputMaybe<InsertListingFloat8ComparisonExp>;
  second_contact?: InputMaybe<InsertListingUsersBoolExp>;
  second_contact_id?: InputMaybe<InsertListingUuidComparisonExp>;
  second_pillar?: InputMaybe<InsertListingFloat8ComparisonExp>;
  session_id?: InputMaybe<InsertListingStringComparisonExp>;
  should_be_requalified?: InputMaybe<InsertListingBooleanComparisonExp>;
  should_send_market_update?: InputMaybe<InsertListingBooleanComparisonExp>;
  snapshot?: InputMaybe<InsertListingJsonbComparisonExp>;
  source?: InputMaybe<InsertListingDictionariesBoolExp>;
  source_id?: InputMaybe<InsertListingUuidComparisonExp>;
  source_organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  stage?: InputMaybe<InsertListingLeadStagesBoolExp>;
  stage_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tenant?: InputMaybe<InsertListingTenantsBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  third_pillar?: InputMaybe<InsertListingFloat8ComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  usable_own_funds?: InputMaybe<InsertListingFloat8ComparisonExp>;
  use_bank_third_pillar?: InputMaybe<InsertListingBooleanComparisonExp>;
  use_insurance_third_pillar?: InputMaybe<InsertListingBooleanComparisonExp>;
  use_second_pillar?: InputMaybe<InsertListingBooleanComparisonExp>;
  use_third_pillar?: InputMaybe<InsertListingBooleanComparisonExp>;
  user_info_ip?: InputMaybe<InsertListingStringComparisonExp>;
  user_info_user_agent?: InputMaybe<InsertListingStringComparisonExp>;
  verified?: InputMaybe<InsertListingBooleanComparisonExp>;
  work_permit_id?: InputMaybe<InsertListingUuidComparisonExp>;
  yearly_revenues?: InputMaybe<InsertListingFloat8ComparisonExp>;
  yearly_revenues_at_retirement?: InputMaybe<InsertListingFloat8ComparisonExp>;
};

export enum InsertListingLeadsBuyHorizonEnum {
  NotSet = 'not_set',
  Over_12Months = 'over_12_months',
  Under_3Months = 'under_3_months',
  Under_12Months = 'under_12_months'
}

export type InsertListingLeadsBuyHorizonEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingLeadsBuyHorizonEnum>;
  _in?: InputMaybe<Array<InsertListingLeadsBuyHorizonEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingLeadsBuyHorizonEnum>;
  _nin?: InputMaybe<Array<InsertListingLeadsBuyHorizonEnum>>;
};

export enum InsertListingLeadsConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  LeadsIdTenantIdUnique = 'leads_id_tenant_id_unique',
  /** unique or primary key constraint on columns "imported_id", "tenant_id" */
  LeadsImportedIdTenantIdUnique = 'leads_imported_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  LeadsPkey = 'leads_pkey'
}

export type InsertListingLeadsInsertInput = {
  activities?: InputMaybe<InsertListingActivitiesArrRelInsertInput>;
  annual_premium?: InputMaybe<Scalars['float8']['input']>;
  appraisal_inheritance_next_step?: InputMaybe<Scalars['String']['input']>;
  appraisal_market_time?: InputMaybe<Scalars['Int']['input']>;
  appraisal_monthly_gross_rent?: InputMaybe<Scalars['Float']['input']>;
  appraisal_next_step?: InputMaybe<Scalars['String']['input']>;
  appraisal_open_to_offer?: InputMaybe<Scalars['String']['input']>;
  appraisal_perceived_value?: InputMaybe<Scalars['Float']['input']>;
  appraisal_perception?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_building_condition?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_built_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_commercial_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_construction_year?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_country?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_country_code?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_ctn?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_garden_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  appraisal_property_has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_has_garden?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_has_storage_room?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_has_view?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_income_includes_parking?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_is_commercial_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_is_parking_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_is_renovated?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_is_residential_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_know_plot_number?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_land_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_lat?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_living_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_lng?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_locality?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_residential_units?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_occupied?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_plot_number?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_postcode?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_property_type_id?: InputMaybe<Scalars['uuid']['input']>;
  appraisal_property_renovation_year?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_residential_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_route?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_side?: InputMaybe<InsertListingPropertySideEnumEnum>;
  appraisal_property_state?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_street_number?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_usage?: InputMaybe<Scalars['String']['input']>;
  appraisal_reason?: InputMaybe<InsertListingLeadsAppraisalReasonEnum>;
  appraisal_selling_with?: InputMaybe<Scalars['String']['input']>;
  appraisal_separation_next_step?: InputMaybe<Scalars['String']['input']>;
  appraisal_step?: InputMaybe<Scalars['String']['input']>;
  assets_second_pillar?: InputMaybe<Scalars['float8']['input']>;
  assets_third_pillar_a_organisation?: InputMaybe<Scalars['String']['input']>;
  broker?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buy_horizon?: InputMaybe<InsertListingLeadsBuyHorizonEnum>;
  call_times?: InputMaybe<Array<Scalars['String']['input']>>;
  cma_reports?: InputMaybe<InsertListingCmaReportsArrRelInsertInput>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  contact?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  createdBy?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  creator?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  date_of_birth?: InputMaybe<Scalars['date']['input']>;
  debt?: InputMaybe<Scalars['float8']['input']>;
  donation?: InputMaybe<Scalars['float8']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  financing_secured?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  google_address?: InputMaybe<InsertListingGoogleAddressesObjRelInsertInput>;
  has_accepted_terms?: InputMaybe<Scalars['Boolean']['input']>;
  has_dependant_children?: InputMaybe<Scalars['Boolean']['input']>;
  has_no_street_number?: InputMaybe<Scalars['Boolean']['input']>;
  has_other_credits?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  landing_page_url?: InputMaybe<Scalars['String']['input']>;
  last_activity_done_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_bonus?: InputMaybe<Scalars['float8']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  last_requalification_mail_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_requalification_sms_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lead_agents?: InputMaybe<InsertListingLeadAgentsArrRelInsertInput>;
  lead_looking_places?: InputMaybe<InsertListingLeadLookingPlacesArrRelInsertInput>;
  leads_tags?: InputMaybe<InsertListingLeadsTagsArrRelInsertInput>;
  lots?: InputMaybe<InsertListingLotsArrRelInsertInput>;
  mandate_probability?: InputMaybe<Scalars['Int']['input']>;
  marital_status?: InputMaybe<Scalars['String']['input']>;
  max_property_value?: InputMaybe<Scalars['float8']['input']>;
  mortgage_auto_mortgage_type?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_buying_status?: InputMaybe<Scalars['lead_buying_status']['input']>;
  mortgage_comments?: InputMaybe<Scalars['String']['input']>;
  mortgage_financial_institution?: InputMaybe<Scalars['String']['input']>;
  mortgage_google_address?: InputMaybe<InsertListingGoogleAddressesObjRelInsertInput>;
  mortgage_google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  mortgage_has_mortgage?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_insurance_provider_id?: InputMaybe<Scalars['uuid']['input']>;
  mortgage_insurance_revenue?: InputMaybe<Scalars['Float']['input']>;
  mortgage_interest_rate?: InputMaybe<Scalars['Float']['input']>;
  mortgage_interest_rate_type?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  mortgage_is_construction?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_is_property_identified?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_lender_id?: InputMaybe<Scalars['uuid']['input']>;
  mortgage_lender_name?: InputMaybe<Scalars['String']['input']>;
  mortgage_lender_type?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  mortgage_mortgage_type?: InputMaybe<Scalars['String']['input']>;
  mortgage_notary_id?: InputMaybe<Scalars['uuid']['input']>;
  mortgage_product_mortgage?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_product_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_property_usage?: InputMaybe<Scalars['String']['input']>;
  mortgage_property_value?: InputMaybe<Scalars['float8']['input']>;
  mortgage_purchase_date?: InputMaybe<Scalars['timestamptz']['input']>;
  mortgage_purchase_price?: InputMaybe<Scalars['Float']['input']>;
  mortgage_real_estate_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  mortgage_report_type?: InputMaybe<Scalars['String']['input']>;
  mortgage_revenue?: InputMaybe<Scalars['Float']['input']>;
  mortgage_sell?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_start_date?: InputMaybe<Scalars['date']['input']>;
  mortgage_status?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  mortgage_step?: InputMaybe<Scalars['String']['input']>;
  mortgage_term?: InputMaybe<Scalars['String']['input']>;
  nationality_id?: InputMaybe<Scalars['uuid']['input']>;
  next_activity_due_at?: InputMaybe<Scalars['timestamptz']['input']>;
  number_of_buyers?: InputMaybe<Scalars['Int']['input']>;
  number_of_dependant_children?: InputMaybe<Scalars['Int']['input']>;
  occupation_id?: InputMaybe<Scalars['uuid']['input']>;
  occupation_text?: InputMaybe<Scalars['String']['input']>;
  other_credits?: InputMaybe<Scalars['Int']['input']>;
  ownership?: InputMaybe<Scalars['lead_ownership']['input']>;
  parent_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_annual_premium?: InputMaybe<Scalars['float8']['input']>;
  partner_date_of_birth?: InputMaybe<Scalars['date']['input']>;
  partner_donation?: InputMaybe<Scalars['float8']['input']>;
  partner_first_name?: InputMaybe<Scalars['String']['input']>;
  partner_gender?: InputMaybe<Scalars['String']['input']>;
  partner_has_other_credits?: InputMaybe<Scalars['Boolean']['input']>;
  partner_has_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  partner_last_bonus?: InputMaybe<Scalars['float8']['input']>;
  partner_last_name?: InputMaybe<Scalars['String']['input']>;
  partner_marital_status?: InputMaybe<Scalars['String']['input']>;
  partner_nationality_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_occupation_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_occupation_text?: InputMaybe<Scalars['String']['input']>;
  partner_other_credits?: InputMaybe<Scalars['float8']['input']>;
  partner_professional_situation?: InputMaybe<Scalars['user_professional_situation']['input']>;
  partner_residence_country_code?: InputMaybe<Scalars['String']['input']>;
  partner_residence_state_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_savings?: InputMaybe<Scalars['float8']['input']>;
  partner_second_pillar?: InputMaybe<Scalars['float8']['input']>;
  partner_third_pillar?: InputMaybe<Scalars['float8']['input']>;
  partner_third_pillar_a_organisation?: InputMaybe<Scalars['String']['input']>;
  partner_use_bank_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  partner_use_insurance_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  partner_work_permit_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_yearly_revenues?: InputMaybe<Scalars['float8']['input']>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Scalars['float8']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  pos_within_stage?: InputMaybe<Scalars['Int']['input']>;
  potential_development?: InputMaybe<Scalars['Boolean']['input']>;
  predicted_listing_date?: InputMaybe<Scalars['timestamptz']['input']>;
  professional_situation?: InputMaybe<Scalars['user_professional_situation']['input']>;
  property?: InputMaybe<InsertListingPropertiesObjRelInsertInput>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_search_notification?: InputMaybe<Scalars['property_searches_notification']['input']>;
  property_type?: InputMaybe<InsertListingPropertyTypesObjRelInsertInput>;
  property_usage?: InputMaybe<InsertListingLeadsPropertyUsageEnum>;
  received_mortgage_offer?: InputMaybe<Scalars['Boolean']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  referring_domain?: InputMaybe<Scalars['String']['input']>;
  refused_at?: InputMaybe<Scalars['timestamptz']['input']>;
  relationship?: InputMaybe<InsertListingLeadsRelationshipEnum>;
  requalification_status?: InputMaybe<InsertListingLeadsRequalificationStatusEnum>;
  requalified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  residence_country_code?: InputMaybe<Scalars['String']['input']>;
  residence_state_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_comments?: InputMaybe<Scalars['String']['input']>;
  sale_has_found?: InputMaybe<Scalars['Boolean']['input']>;
  sale_horizon?: InputMaybe<InsertListingLeadsSaleHorizonEnum>;
  sale_is_seller?: InputMaybe<Scalars['Boolean']['input']>;
  sale_price?: InputMaybe<Scalars['Int']['input']>;
  sale_started?: InputMaybe<Scalars['Boolean']['input']>;
  savings?: InputMaybe<Scalars['float8']['input']>;
  second_contact?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  second_contact_id?: InputMaybe<Scalars['uuid']['input']>;
  second_pillar?: InputMaybe<Scalars['float8']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  snapshot?: InputMaybe<Scalars['jsonb']['input']>;
  source?: InputMaybe<InsertListingDictionariesObjRelInsertInput>;
  source_id?: InputMaybe<Scalars['uuid']['input']>;
  source_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  stage?: InputMaybe<InsertListingLeadStagesObjRelInsertInput>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<InsertListingTenantsObjRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  third_pillar?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  usable_own_funds?: InputMaybe<Scalars['float8']['input']>;
  use_bank_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  use_insurance_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  use_second_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  use_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  user_info_ip?: InputMaybe<Scalars['String']['input']>;
  user_info_user_agent?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  work_permit_id?: InputMaybe<Scalars['uuid']['input']>;
  yearly_revenues?: InputMaybe<Scalars['float8']['input']>;
  yearly_revenues_at_retirement?: InputMaybe<Scalars['float8']['input']>;
};

export type InsertListingLeadsObjRelInsertInput = {
  data: InsertListingLeadsInsertInput;
  on_conflict?: InputMaybe<InsertListingLeadsOnConflict>;
};

export type InsertListingLeadsOnConflict = {
  constraint: InsertListingLeadsConstraint;
  update_columns: Array<InsertListingLeadsUpdateColumn>;
  where?: InputMaybe<InsertListingLeadsBoolExp>;
};

export enum InsertListingLeadsPropertyUsageEnum {
  NotSet = 'not_set',
  Other = 'other',
  PrimaryResidence = 'primary_residence',
  RentalProperty = 'rental_property',
  SecondaryResidence = 'secondary_residence'
}

export type InsertListingLeadsPropertyUsageEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingLeadsPropertyUsageEnum>;
  _in?: InputMaybe<Array<InsertListingLeadsPropertyUsageEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingLeadsPropertyUsageEnum>;
  _nin?: InputMaybe<Array<InsertListingLeadsPropertyUsageEnum>>;
};

export enum InsertListingLeadsRelationshipEnum {
  Agent = 'agent',
  Buyer = 'buyer',
  Heir = 'heir',
  NotSet = 'not_set',
  Other = 'other',
  Owner = 'owner',
  Tenant = 'tenant'
}

export type InsertListingLeadsRelationshipEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingLeadsRelationshipEnum>;
  _in?: InputMaybe<Array<InsertListingLeadsRelationshipEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingLeadsRelationshipEnum>;
  _nin?: InputMaybe<Array<InsertListingLeadsRelationshipEnum>>;
};

export enum InsertListingLeadsRequalificationStatusEnum {
  NotSet = 'not_set',
  Started = 'started'
}

export type InsertListingLeadsRequalificationStatusEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingLeadsRequalificationStatusEnum>;
  _in?: InputMaybe<Array<InsertListingLeadsRequalificationStatusEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingLeadsRequalificationStatusEnum>;
  _nin?: InputMaybe<Array<InsertListingLeadsRequalificationStatusEnum>>;
};

export enum InsertListingLeadsSaleHorizonEnum {
  AlreadyForSale = 'already_for_sale',
  From_1To_2Years = 'from_1_to_2_years',
  From_2Years = 'from_2_years',
  From_6To_12Months = 'from_6_to_12_months',
  NotSelling = 'not_selling',
  NotSet = 'not_set',
  Under_6Months = 'under_6_months'
}

export type InsertListingLeadsSaleHorizonEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingLeadsSaleHorizonEnum>;
  _in?: InputMaybe<Array<InsertListingLeadsSaleHorizonEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingLeadsSaleHorizonEnum>;
  _nin?: InputMaybe<Array<InsertListingLeadsSaleHorizonEnum>>;
};

export enum InsertListingLeadsSelectColumn {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AppraisalInheritanceNextStep = 'appraisal_inheritance_next_step',
  /** column name */
  AppraisalMarketTime = 'appraisal_market_time',
  /** column name */
  AppraisalMonthlyGrossRent = 'appraisal_monthly_gross_rent',
  /** column name */
  AppraisalNextStep = 'appraisal_next_step',
  /** column name */
  AppraisalOpenToOffer = 'appraisal_open_to_offer',
  /** column name */
  AppraisalPerceivedValue = 'appraisal_perceived_value',
  /** column name */
  AppraisalPerception = 'appraisal_perception',
  /** column name */
  AppraisalPropertyBalconySurface = 'appraisal_property_balcony_surface',
  /** column name */
  AppraisalPropertyBuildingCondition = 'appraisal_property_building_condition',
  /** column name */
  AppraisalPropertyBuiltSurface = 'appraisal_property_built_surface',
  /** column name */
  AppraisalPropertyCommercialPotentialRentalIncome = 'appraisal_property_commercial_potential_rental_income',
  /** column name */
  AppraisalPropertyCommercialSurface = 'appraisal_property_commercial_surface',
  /** column name */
  AppraisalPropertyCommercialYearlyRentalIncome = 'appraisal_property_commercial_yearly_rental_income',
  /** column name */
  AppraisalPropertyConstructionYear = 'appraisal_property_construction_year',
  /** column name */
  AppraisalPropertyCountry = 'appraisal_property_country',
  /** column name */
  AppraisalPropertyCountryCode = 'appraisal_property_country_code',
  /** column name */
  AppraisalPropertyCtn = 'appraisal_property_ctn',
  /** column name */
  AppraisalPropertyFloorOfFlat = 'appraisal_property_floor_of_flat',
  /** column name */
  AppraisalPropertyGardenSurface = 'appraisal_property_garden_surface',
  /** column name */
  AppraisalPropertyGoogleAddressId = 'appraisal_property_google_address_id',
  /** column name */
  AppraisalPropertyHasElevator = 'appraisal_property_has_elevator',
  /** column name */
  AppraisalPropertyHasGarden = 'appraisal_property_has_garden',
  /** column name */
  AppraisalPropertyHasStorageRoom = 'appraisal_property_has_storage_room',
  /** column name */
  AppraisalPropertyHasSwimmingPool = 'appraisal_property_has_swimming_pool',
  /** column name */
  AppraisalPropertyHasView = 'appraisal_property_has_view',
  /** column name */
  AppraisalPropertyIncomeIncludesParking = 'appraisal_property_income_includes_parking',
  /** column name */
  AppraisalPropertyIsCommercialFullyRented = 'appraisal_property_is_commercial_fully_rented',
  /** column name */
  AppraisalPropertyIsParkingFullyRented = 'appraisal_property_is_parking_fully_rented',
  /** column name */
  AppraisalPropertyIsRenovated = 'appraisal_property_is_renovated',
  /** column name */
  AppraisalPropertyIsResidentialFullyRented = 'appraisal_property_is_residential_fully_rented',
  /** column name */
  AppraisalPropertyKnowPlotNumber = 'appraisal_property_know_plot_number',
  /** column name */
  AppraisalPropertyLandSurface = 'appraisal_property_land_surface',
  /** column name */
  AppraisalPropertyLat = 'appraisal_property_lat',
  /** column name */
  AppraisalPropertyLivingSurface = 'appraisal_property_living_surface',
  /** column name */
  AppraisalPropertyLng = 'appraisal_property_lng',
  /** column name */
  AppraisalPropertyLocality = 'appraisal_property_locality',
  /** column name */
  AppraisalPropertyNumberOfBathrooms = 'appraisal_property_number_of_bathrooms',
  /** column name */
  AppraisalPropertyNumberOfBedrooms = 'appraisal_property_number_of_bedrooms',
  /** column name */
  AppraisalPropertyNumberOfCommercialUnits = 'appraisal_property_number_of_commercial_units',
  /** column name */
  AppraisalPropertyNumberOfFloors = 'appraisal_property_number_of_floors',
  /** column name */
  AppraisalPropertyNumberOfIndoorParkings = 'appraisal_property_number_of_indoor_parkings',
  /** column name */
  AppraisalPropertyNumberOfOutdoorParkings = 'appraisal_property_number_of_outdoor_parkings',
  /** column name */
  AppraisalPropertyNumberOfResidentialUnits = 'appraisal_property_number_of_residential_units',
  /** column name */
  AppraisalPropertyNumberOfRooms = 'appraisal_property_number_of_rooms',
  /** column name */
  AppraisalPropertyOccupied = 'appraisal_property_occupied',
  /** column name */
  AppraisalPropertyParkingPotentialRentalIncome = 'appraisal_property_parking_potential_rental_income',
  /** column name */
  AppraisalPropertyParkingYearlyRentalIncome = 'appraisal_property_parking_yearly_rental_income',
  /** column name */
  AppraisalPropertyPlotNumber = 'appraisal_property_plot_number',
  /** column name */
  AppraisalPropertyPostcode = 'appraisal_property_postcode',
  /** column name */
  AppraisalPropertyPropertyTypeId = 'appraisal_property_property_type_id',
  /** column name */
  AppraisalPropertyRenovationYear = 'appraisal_property_renovation_year',
  /** column name */
  AppraisalPropertyResidentialPotentialRentalIncome = 'appraisal_property_residential_potential_rental_income',
  /** column name */
  AppraisalPropertyResidentialSurface = 'appraisal_property_residential_surface',
  /** column name */
  AppraisalPropertyResidentialYearlyRentalIncome = 'appraisal_property_residential_yearly_rental_income',
  /** column name */
  AppraisalPropertyRoute = 'appraisal_property_route',
  /** column name */
  AppraisalPropertySide = 'appraisal_property_side',
  /** column name */
  AppraisalPropertyState = 'appraisal_property_state',
  /** column name */
  AppraisalPropertyStreetNumber = 'appraisal_property_street_number',
  /** column name */
  AppraisalPropertyUsage = 'appraisal_property_usage',
  /** column name */
  AppraisalReason = 'appraisal_reason',
  /** column name */
  AppraisalSellingWith = 'appraisal_selling_with',
  /** column name */
  AppraisalSeparationNextStep = 'appraisal_separation_next_step',
  /** column name */
  AppraisalStep = 'appraisal_step',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  AssetsThirdPillarAOrganisation = 'assets_third_pillar_a_organisation',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  BuyHorizon = 'buy_horizon',
  /** column name */
  CallTimes = 'call_times',
  /** column name */
  Completed = 'completed',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FinancingSecured = 'financing_secured',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasDependantChildren = 'has_dependant_children',
  /** column name */
  HasNoStreetNumber = 'has_no_street_number',
  /** column name */
  HasOtherCredits = 'has_other_credits',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  LandingPageUrl = 'landing_page_url',
  /** column name */
  LastActivityDoneAt = 'last_activity_done_at',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LastRequalificationMailSentAt = 'last_requalification_mail_sent_at',
  /** column name */
  LastRequalificationSmsSentAt = 'last_requalification_sms_sent_at',
  /** column name */
  MandateProbability = 'mandate_probability',
  /** column name */
  MaritalStatus = 'marital_status',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgageAutoMortgageType = 'mortgage_auto_mortgage_type',
  /** column name */
  MortgageBuyingStatus = 'mortgage_buying_status',
  /** column name */
  MortgageComments = 'mortgage_comments',
  /** column name */
  MortgageFinancialInstitution = 'mortgage_financial_institution',
  /** column name */
  MortgageGoogleAddressId = 'mortgage_google_address_id',
  /** column name */
  MortgageHasMortgage = 'mortgage_has_mortgage',
  /** column name */
  MortgageInsuranceProviderId = 'mortgage_insurance_provider_id',
  /** column name */
  MortgageInsuranceRevenue = 'mortgage_insurance_revenue',
  /** column name */
  MortgageInterestRate = 'mortgage_interest_rate',
  /** column name */
  MortgageInterestRateType = 'mortgage_interest_rate_type',
  /** column name */
  MortgageIsConstruction = 'mortgage_is_construction',
  /** column name */
  MortgageIsPropertyIdentified = 'mortgage_is_property_identified',
  /** column name */
  MortgageLenderId = 'mortgage_lender_id',
  /** column name */
  MortgageLenderName = 'mortgage_lender_name',
  /** column name */
  MortgageLenderType = 'mortgage_lender_type',
  /** column name */
  MortgageMortgageType = 'mortgage_mortgage_type',
  /** column name */
  MortgageNotaryId = 'mortgage_notary_id',
  /** column name */
  MortgageProductMortgage = 'mortgage_product_mortgage',
  /** column name */
  MortgageProductThirdPillar = 'mortgage_product_third_pillar',
  /** column name */
  MortgagePropertyUsage = 'mortgage_property_usage',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  MortgagePurchaseDate = 'mortgage_purchase_date',
  /** column name */
  MortgagePurchasePrice = 'mortgage_purchase_price',
  /** column name */
  MortgageRealEstateBrokerId = 'mortgage_real_estate_broker_id',
  /** column name */
  MortgageReportType = 'mortgage_report_type',
  /** column name */
  MortgageRevenue = 'mortgage_revenue',
  /** column name */
  MortgageSell = 'mortgage_sell',
  /** column name */
  MortgageStartDate = 'mortgage_start_date',
  /** column name */
  MortgageStatus = 'mortgage_status',
  /** column name */
  MortgageStep = 'mortgage_step',
  /** column name */
  MortgageTerm = 'mortgage_term',
  /** column name */
  NationalityId = 'nationality_id',
  /** column name */
  NextActivityDueAt = 'next_activity_due_at',
  /** column name */
  NumberOfBuyers = 'number_of_buyers',
  /** column name */
  NumberOfDependantChildren = 'number_of_dependant_children',
  /** column name */
  OccupationId = 'occupation_id',
  /** column name */
  OccupationText = 'occupation_text',
  /** column name */
  OtherCredits = 'other_credits',
  /** column name */
  Ownership = 'ownership',
  /** column name */
  ParentLeadId = 'parent_lead_id',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDateOfBirth = 'partner_date_of_birth',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerFirstName = 'partner_first_name',
  /** column name */
  PartnerGender = 'partner_gender',
  /** column name */
  PartnerHasOtherCredits = 'partner_has_other_credits',
  /** column name */
  PartnerHasThirdPillar = 'partner_has_third_pillar',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerLastName = 'partner_last_name',
  /** column name */
  PartnerMaritalStatus = 'partner_marital_status',
  /** column name */
  PartnerNationalityId = 'partner_nationality_id',
  /** column name */
  PartnerOccupationId = 'partner_occupation_id',
  /** column name */
  PartnerOccupationText = 'partner_occupation_text',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerProfessionalSituation = 'partner_professional_situation',
  /** column name */
  PartnerResidenceCountryCode = 'partner_residence_country_code',
  /** column name */
  PartnerResidenceStateId = 'partner_residence_state_id',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerThirdPillarAOrganisation = 'partner_third_pillar_a_organisation',
  /** column name */
  PartnerUseBankThirdPillar = 'partner_use_bank_third_pillar',
  /** column name */
  PartnerUseInsuranceThirdPillar = 'partner_use_insurance_third_pillar',
  /** column name */
  PartnerWorkPermitId = 'partner_work_permit_id',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PosWithinStage = 'pos_within_stage',
  /** column name */
  PotentialDevelopment = 'potential_development',
  /** column name */
  PredictedListingDate = 'predicted_listing_date',
  /** column name */
  ProfessionalSituation = 'professional_situation',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertySearchNotification = 'property_search_notification',
  /** column name */
  PropertyUsage = 'property_usage',
  /** column name */
  ReceivedMortgageOffer = 'received_mortgage_offer',
  /** column name */
  Referrer = 'referrer',
  /** column name */
  ReferringDomain = 'referring_domain',
  /** column name */
  RefusedAt = 'refused_at',
  /** column name */
  Relationship = 'relationship',
  /** column name */
  RequalificationStatus = 'requalification_status',
  /** column name */
  RequalifiedAt = 'requalified_at',
  /** column name */
  RequalifiedOrCreatedAt = 'requalified_or_created_at',
  /** column name */
  ResidenceCountryCode = 'residence_country_code',
  /** column name */
  ResidenceStateId = 'residence_state_id',
  /** column name */
  SaleComments = 'sale_comments',
  /** column name */
  SaleHasFound = 'sale_has_found',
  /** column name */
  SaleHorizon = 'sale_horizon',
  /** column name */
  SaleIsSeller = 'sale_is_seller',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SaleStarted = 'sale_started',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondContactId = 'second_contact_id',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Snapshot = 'snapshot',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  SourceOrganisationId = 'source_organisation_id',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  UseBankThirdPillar = 'use_bank_third_pillar',
  /** column name */
  UseInsuranceThirdPillar = 'use_insurance_third_pillar',
  /** column name */
  UseSecondPillar = 'use_second_pillar',
  /** column name */
  UseThirdPillar = 'use_third_pillar',
  /** column name */
  UserInfoIp = 'user_info_ip',
  /** column name */
  UserInfoUserAgent = 'user_info_user_agent',
  /** column name */
  Verified = 'verified',
  /** column name */
  WorkPermitId = 'work_permit_id',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  AppraisalPropertyHasElevator = 'appraisal_property_has_elevator',
  /** column name */
  AppraisalPropertyHasGarden = 'appraisal_property_has_garden',
  /** column name */
  AppraisalPropertyHasStorageRoom = 'appraisal_property_has_storage_room',
  /** column name */
  AppraisalPropertyHasSwimmingPool = 'appraisal_property_has_swimming_pool',
  /** column name */
  AppraisalPropertyHasView = 'appraisal_property_has_view',
  /** column name */
  AppraisalPropertyIncomeIncludesParking = 'appraisal_property_income_includes_parking',
  /** column name */
  AppraisalPropertyIsCommercialFullyRented = 'appraisal_property_is_commercial_fully_rented',
  /** column name */
  AppraisalPropertyIsParkingFullyRented = 'appraisal_property_is_parking_fully_rented',
  /** column name */
  AppraisalPropertyIsRenovated = 'appraisal_property_is_renovated',
  /** column name */
  AppraisalPropertyIsResidentialFullyRented = 'appraisal_property_is_residential_fully_rented',
  /** column name */
  AppraisalPropertyKnowPlotNumber = 'appraisal_property_know_plot_number',
  /** column name */
  Completed = 'completed',
  /** column name */
  FinancingSecured = 'financing_secured',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasDependantChildren = 'has_dependant_children',
  /** column name */
  HasNoStreetNumber = 'has_no_street_number',
  /** column name */
  HasOtherCredits = 'has_other_credits',
  /** column name */
  MortgageAutoMortgageType = 'mortgage_auto_mortgage_type',
  /** column name */
  MortgageHasMortgage = 'mortgage_has_mortgage',
  /** column name */
  MortgageIsConstruction = 'mortgage_is_construction',
  /** column name */
  MortgageIsPropertyIdentified = 'mortgage_is_property_identified',
  /** column name */
  MortgageProductMortgage = 'mortgage_product_mortgage',
  /** column name */
  MortgageProductThirdPillar = 'mortgage_product_third_pillar',
  /** column name */
  MortgageSell = 'mortgage_sell',
  /** column name */
  PartnerHasOtherCredits = 'partner_has_other_credits',
  /** column name */
  PartnerHasThirdPillar = 'partner_has_third_pillar',
  /** column name */
  PartnerUseBankThirdPillar = 'partner_use_bank_third_pillar',
  /** column name */
  PartnerUseInsuranceThirdPillar = 'partner_use_insurance_third_pillar',
  /** column name */
  PotentialDevelopment = 'potential_development',
  /** column name */
  ReceivedMortgageOffer = 'received_mortgage_offer',
  /** column name */
  SaleHasFound = 'sale_has_found',
  /** column name */
  SaleIsSeller = 'sale_is_seller',
  /** column name */
  SaleStarted = 'sale_started',
  /** column name */
  UseBankThirdPillar = 'use_bank_third_pillar',
  /** column name */
  UseInsuranceThirdPillar = 'use_insurance_third_pillar',
  /** column name */
  UseSecondPillar = 'use_second_pillar',
  /** column name */
  UseThirdPillar = 'use_third_pillar',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  AppraisalPropertyHasElevator = 'appraisal_property_has_elevator',
  /** column name */
  AppraisalPropertyHasGarden = 'appraisal_property_has_garden',
  /** column name */
  AppraisalPropertyHasStorageRoom = 'appraisal_property_has_storage_room',
  /** column name */
  AppraisalPropertyHasSwimmingPool = 'appraisal_property_has_swimming_pool',
  /** column name */
  AppraisalPropertyHasView = 'appraisal_property_has_view',
  /** column name */
  AppraisalPropertyIncomeIncludesParking = 'appraisal_property_income_includes_parking',
  /** column name */
  AppraisalPropertyIsCommercialFullyRented = 'appraisal_property_is_commercial_fully_rented',
  /** column name */
  AppraisalPropertyIsParkingFullyRented = 'appraisal_property_is_parking_fully_rented',
  /** column name */
  AppraisalPropertyIsRenovated = 'appraisal_property_is_renovated',
  /** column name */
  AppraisalPropertyIsResidentialFullyRented = 'appraisal_property_is_residential_fully_rented',
  /** column name */
  AppraisalPropertyKnowPlotNumber = 'appraisal_property_know_plot_number',
  /** column name */
  Completed = 'completed',
  /** column name */
  FinancingSecured = 'financing_secured',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasDependantChildren = 'has_dependant_children',
  /** column name */
  HasNoStreetNumber = 'has_no_street_number',
  /** column name */
  HasOtherCredits = 'has_other_credits',
  /** column name */
  MortgageAutoMortgageType = 'mortgage_auto_mortgage_type',
  /** column name */
  MortgageHasMortgage = 'mortgage_has_mortgage',
  /** column name */
  MortgageIsConstruction = 'mortgage_is_construction',
  /** column name */
  MortgageIsPropertyIdentified = 'mortgage_is_property_identified',
  /** column name */
  MortgageProductMortgage = 'mortgage_product_mortgage',
  /** column name */
  MortgageProductThirdPillar = 'mortgage_product_third_pillar',
  /** column name */
  MortgageSell = 'mortgage_sell',
  /** column name */
  PartnerHasOtherCredits = 'partner_has_other_credits',
  /** column name */
  PartnerHasThirdPillar = 'partner_has_third_pillar',
  /** column name */
  PartnerUseBankThirdPillar = 'partner_use_bank_third_pillar',
  /** column name */
  PartnerUseInsuranceThirdPillar = 'partner_use_insurance_third_pillar',
  /** column name */
  PotentialDevelopment = 'potential_development',
  /** column name */
  ReceivedMortgageOffer = 'received_mortgage_offer',
  /** column name */
  SaleHasFound = 'sale_has_found',
  /** column name */
  SaleIsSeller = 'sale_is_seller',
  /** column name */
  SaleStarted = 'sale_started',
  /** column name */
  UseBankThirdPillar = 'use_bank_third_pillar',
  /** column name */
  UseInsuranceThirdPillar = 'use_insurance_third_pillar',
  /** column name */
  UseSecondPillar = 'use_second_pillar',
  /** column name */
  UseThirdPillar = 'use_third_pillar',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpMinArgumentsColumns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpSumArgumentsColumns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingLeadsStatusEnum {
  Active = 'active',
  Lost = 'lost',
  Won = 'won'
}

export type InsertListingLeadsStatusEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingLeadsStatusEnum>;
  _in?: InputMaybe<Array<InsertListingLeadsStatusEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingLeadsStatusEnum>;
  _nin?: InputMaybe<Array<InsertListingLeadsStatusEnum>>;
};

export type InsertListingLeadsTagsAggregateBoolExp = {
  count?: InputMaybe<InsertListingLeadsTagsAggregateBoolExpCount>;
};

export type InsertListingLeadsTagsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLeadsTagsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsTagsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLeadsTagsArrRelInsertInput = {
  data: Array<InsertListingLeadsTagsInsertInput>;
  on_conflict?: InputMaybe<InsertListingLeadsTagsOnConflict>;
};

export type InsertListingLeadsTagsBoolExp = {
  _and?: InputMaybe<Array<InsertListingLeadsTagsBoolExp>>;
  _not?: InputMaybe<InsertListingLeadsTagsBoolExp>;
  _or?: InputMaybe<Array<InsertListingLeadsTagsBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  created_by_user?: InputMaybe<InsertListingUsersBoolExp>;
  dictionary?: InputMaybe<InsertListingDictionariesBoolExp>;
  dictionary_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  lead?: InputMaybe<InsertListingLeadsBoolExp>;
  lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingLeadsTagsConstraint {
  /** unique or primary key constraint on columns "id" */
  LeadsTagsPkey = 'leads_tags_pkey',
  /** unique or primary key constraint on columns "dictionary_id", "tenant_id", "lead_id" */
  LeadsTagsUnique = 'leads_tags_unique'
}

export type InsertListingLeadsTagsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  dictionary?: InputMaybe<InsertListingDictionariesObjRelInsertInput>;
  dictionary_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead?: InputMaybe<InsertListingLeadsObjRelInsertInput>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingLeadsTagsOnConflict = {
  constraint: InsertListingLeadsTagsConstraint;
  update_columns: Array<InsertListingLeadsTagsUpdateColumn>;
  where?: InputMaybe<InsertListingLeadsTagsBoolExp>;
};

export enum InsertListingLeadsTagsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DictionaryId = 'dictionary_id',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingLeadsTagsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DictionaryId = 'dictionary_id',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingLeadsUpdateColumn {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AppraisalInheritanceNextStep = 'appraisal_inheritance_next_step',
  /** column name */
  AppraisalMarketTime = 'appraisal_market_time',
  /** column name */
  AppraisalMonthlyGrossRent = 'appraisal_monthly_gross_rent',
  /** column name */
  AppraisalNextStep = 'appraisal_next_step',
  /** column name */
  AppraisalOpenToOffer = 'appraisal_open_to_offer',
  /** column name */
  AppraisalPerceivedValue = 'appraisal_perceived_value',
  /** column name */
  AppraisalPerception = 'appraisal_perception',
  /** column name */
  AppraisalPropertyBalconySurface = 'appraisal_property_balcony_surface',
  /** column name */
  AppraisalPropertyBuildingCondition = 'appraisal_property_building_condition',
  /** column name */
  AppraisalPropertyBuiltSurface = 'appraisal_property_built_surface',
  /** column name */
  AppraisalPropertyCommercialPotentialRentalIncome = 'appraisal_property_commercial_potential_rental_income',
  /** column name */
  AppraisalPropertyCommercialSurface = 'appraisal_property_commercial_surface',
  /** column name */
  AppraisalPropertyCommercialYearlyRentalIncome = 'appraisal_property_commercial_yearly_rental_income',
  /** column name */
  AppraisalPropertyConstructionYear = 'appraisal_property_construction_year',
  /** column name */
  AppraisalPropertyCountry = 'appraisal_property_country',
  /** column name */
  AppraisalPropertyCountryCode = 'appraisal_property_country_code',
  /** column name */
  AppraisalPropertyCtn = 'appraisal_property_ctn',
  /** column name */
  AppraisalPropertyFloorOfFlat = 'appraisal_property_floor_of_flat',
  /** column name */
  AppraisalPropertyGardenSurface = 'appraisal_property_garden_surface',
  /** column name */
  AppraisalPropertyGoogleAddressId = 'appraisal_property_google_address_id',
  /** column name */
  AppraisalPropertyHasElevator = 'appraisal_property_has_elevator',
  /** column name */
  AppraisalPropertyHasGarden = 'appraisal_property_has_garden',
  /** column name */
  AppraisalPropertyHasStorageRoom = 'appraisal_property_has_storage_room',
  /** column name */
  AppraisalPropertyHasSwimmingPool = 'appraisal_property_has_swimming_pool',
  /** column name */
  AppraisalPropertyHasView = 'appraisal_property_has_view',
  /** column name */
  AppraisalPropertyIncomeIncludesParking = 'appraisal_property_income_includes_parking',
  /** column name */
  AppraisalPropertyIsCommercialFullyRented = 'appraisal_property_is_commercial_fully_rented',
  /** column name */
  AppraisalPropertyIsParkingFullyRented = 'appraisal_property_is_parking_fully_rented',
  /** column name */
  AppraisalPropertyIsRenovated = 'appraisal_property_is_renovated',
  /** column name */
  AppraisalPropertyIsResidentialFullyRented = 'appraisal_property_is_residential_fully_rented',
  /** column name */
  AppraisalPropertyKnowPlotNumber = 'appraisal_property_know_plot_number',
  /** column name */
  AppraisalPropertyLandSurface = 'appraisal_property_land_surface',
  /** column name */
  AppraisalPropertyLat = 'appraisal_property_lat',
  /** column name */
  AppraisalPropertyLivingSurface = 'appraisal_property_living_surface',
  /** column name */
  AppraisalPropertyLng = 'appraisal_property_lng',
  /** column name */
  AppraisalPropertyLocality = 'appraisal_property_locality',
  /** column name */
  AppraisalPropertyNumberOfBathrooms = 'appraisal_property_number_of_bathrooms',
  /** column name */
  AppraisalPropertyNumberOfBedrooms = 'appraisal_property_number_of_bedrooms',
  /** column name */
  AppraisalPropertyNumberOfCommercialUnits = 'appraisal_property_number_of_commercial_units',
  /** column name */
  AppraisalPropertyNumberOfFloors = 'appraisal_property_number_of_floors',
  /** column name */
  AppraisalPropertyNumberOfIndoorParkings = 'appraisal_property_number_of_indoor_parkings',
  /** column name */
  AppraisalPropertyNumberOfOutdoorParkings = 'appraisal_property_number_of_outdoor_parkings',
  /** column name */
  AppraisalPropertyNumberOfResidentialUnits = 'appraisal_property_number_of_residential_units',
  /** column name */
  AppraisalPropertyNumberOfRooms = 'appraisal_property_number_of_rooms',
  /** column name */
  AppraisalPropertyOccupied = 'appraisal_property_occupied',
  /** column name */
  AppraisalPropertyParkingPotentialRentalIncome = 'appraisal_property_parking_potential_rental_income',
  /** column name */
  AppraisalPropertyParkingYearlyRentalIncome = 'appraisal_property_parking_yearly_rental_income',
  /** column name */
  AppraisalPropertyPlotNumber = 'appraisal_property_plot_number',
  /** column name */
  AppraisalPropertyPostcode = 'appraisal_property_postcode',
  /** column name */
  AppraisalPropertyPropertyTypeId = 'appraisal_property_property_type_id',
  /** column name */
  AppraisalPropertyRenovationYear = 'appraisal_property_renovation_year',
  /** column name */
  AppraisalPropertyResidentialPotentialRentalIncome = 'appraisal_property_residential_potential_rental_income',
  /** column name */
  AppraisalPropertyResidentialSurface = 'appraisal_property_residential_surface',
  /** column name */
  AppraisalPropertyResidentialYearlyRentalIncome = 'appraisal_property_residential_yearly_rental_income',
  /** column name */
  AppraisalPropertyRoute = 'appraisal_property_route',
  /** column name */
  AppraisalPropertySide = 'appraisal_property_side',
  /** column name */
  AppraisalPropertyState = 'appraisal_property_state',
  /** column name */
  AppraisalPropertyStreetNumber = 'appraisal_property_street_number',
  /** column name */
  AppraisalPropertyUsage = 'appraisal_property_usage',
  /** column name */
  AppraisalReason = 'appraisal_reason',
  /** column name */
  AppraisalSellingWith = 'appraisal_selling_with',
  /** column name */
  AppraisalSeparationNextStep = 'appraisal_separation_next_step',
  /** column name */
  AppraisalStep = 'appraisal_step',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  AssetsThirdPillarAOrganisation = 'assets_third_pillar_a_organisation',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  BuyHorizon = 'buy_horizon',
  /** column name */
  CallTimes = 'call_times',
  /** column name */
  Completed = 'completed',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FinancingSecured = 'financing_secured',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasDependantChildren = 'has_dependant_children',
  /** column name */
  HasNoStreetNumber = 'has_no_street_number',
  /** column name */
  HasOtherCredits = 'has_other_credits',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  LandingPageUrl = 'landing_page_url',
  /** column name */
  LastActivityDoneAt = 'last_activity_done_at',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LastRequalificationMailSentAt = 'last_requalification_mail_sent_at',
  /** column name */
  LastRequalificationSmsSentAt = 'last_requalification_sms_sent_at',
  /** column name */
  MandateProbability = 'mandate_probability',
  /** column name */
  MaritalStatus = 'marital_status',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgageAutoMortgageType = 'mortgage_auto_mortgage_type',
  /** column name */
  MortgageBuyingStatus = 'mortgage_buying_status',
  /** column name */
  MortgageComments = 'mortgage_comments',
  /** column name */
  MortgageFinancialInstitution = 'mortgage_financial_institution',
  /** column name */
  MortgageGoogleAddressId = 'mortgage_google_address_id',
  /** column name */
  MortgageHasMortgage = 'mortgage_has_mortgage',
  /** column name */
  MortgageInsuranceProviderId = 'mortgage_insurance_provider_id',
  /** column name */
  MortgageInsuranceRevenue = 'mortgage_insurance_revenue',
  /** column name */
  MortgageInterestRate = 'mortgage_interest_rate',
  /** column name */
  MortgageInterestRateType = 'mortgage_interest_rate_type',
  /** column name */
  MortgageIsConstruction = 'mortgage_is_construction',
  /** column name */
  MortgageIsPropertyIdentified = 'mortgage_is_property_identified',
  /** column name */
  MortgageLenderId = 'mortgage_lender_id',
  /** column name */
  MortgageLenderName = 'mortgage_lender_name',
  /** column name */
  MortgageLenderType = 'mortgage_lender_type',
  /** column name */
  MortgageMortgageType = 'mortgage_mortgage_type',
  /** column name */
  MortgageNotaryId = 'mortgage_notary_id',
  /** column name */
  MortgageProductMortgage = 'mortgage_product_mortgage',
  /** column name */
  MortgageProductThirdPillar = 'mortgage_product_third_pillar',
  /** column name */
  MortgagePropertyUsage = 'mortgage_property_usage',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  MortgagePurchaseDate = 'mortgage_purchase_date',
  /** column name */
  MortgagePurchasePrice = 'mortgage_purchase_price',
  /** column name */
  MortgageRealEstateBrokerId = 'mortgage_real_estate_broker_id',
  /** column name */
  MortgageReportType = 'mortgage_report_type',
  /** column name */
  MortgageRevenue = 'mortgage_revenue',
  /** column name */
  MortgageSell = 'mortgage_sell',
  /** column name */
  MortgageStartDate = 'mortgage_start_date',
  /** column name */
  MortgageStatus = 'mortgage_status',
  /** column name */
  MortgageStep = 'mortgage_step',
  /** column name */
  MortgageTerm = 'mortgage_term',
  /** column name */
  NationalityId = 'nationality_id',
  /** column name */
  NextActivityDueAt = 'next_activity_due_at',
  /** column name */
  NumberOfBuyers = 'number_of_buyers',
  /** column name */
  NumberOfDependantChildren = 'number_of_dependant_children',
  /** column name */
  OccupationId = 'occupation_id',
  /** column name */
  OccupationText = 'occupation_text',
  /** column name */
  OtherCredits = 'other_credits',
  /** column name */
  Ownership = 'ownership',
  /** column name */
  ParentLeadId = 'parent_lead_id',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDateOfBirth = 'partner_date_of_birth',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerFirstName = 'partner_first_name',
  /** column name */
  PartnerGender = 'partner_gender',
  /** column name */
  PartnerHasOtherCredits = 'partner_has_other_credits',
  /** column name */
  PartnerHasThirdPillar = 'partner_has_third_pillar',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerLastName = 'partner_last_name',
  /** column name */
  PartnerMaritalStatus = 'partner_marital_status',
  /** column name */
  PartnerNationalityId = 'partner_nationality_id',
  /** column name */
  PartnerOccupationId = 'partner_occupation_id',
  /** column name */
  PartnerOccupationText = 'partner_occupation_text',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerProfessionalSituation = 'partner_professional_situation',
  /** column name */
  PartnerResidenceCountryCode = 'partner_residence_country_code',
  /** column name */
  PartnerResidenceStateId = 'partner_residence_state_id',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerThirdPillarAOrganisation = 'partner_third_pillar_a_organisation',
  /** column name */
  PartnerUseBankThirdPillar = 'partner_use_bank_third_pillar',
  /** column name */
  PartnerUseInsuranceThirdPillar = 'partner_use_insurance_third_pillar',
  /** column name */
  PartnerWorkPermitId = 'partner_work_permit_id',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PosWithinStage = 'pos_within_stage',
  /** column name */
  PotentialDevelopment = 'potential_development',
  /** column name */
  PredictedListingDate = 'predicted_listing_date',
  /** column name */
  ProfessionalSituation = 'professional_situation',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertySearchNotification = 'property_search_notification',
  /** column name */
  PropertyUsage = 'property_usage',
  /** column name */
  ReceivedMortgageOffer = 'received_mortgage_offer',
  /** column name */
  Referrer = 'referrer',
  /** column name */
  ReferringDomain = 'referring_domain',
  /** column name */
  RefusedAt = 'refused_at',
  /** column name */
  Relationship = 'relationship',
  /** column name */
  RequalificationStatus = 'requalification_status',
  /** column name */
  RequalifiedAt = 'requalified_at',
  /** column name */
  ResidenceCountryCode = 'residence_country_code',
  /** column name */
  ResidenceStateId = 'residence_state_id',
  /** column name */
  SaleComments = 'sale_comments',
  /** column name */
  SaleHasFound = 'sale_has_found',
  /** column name */
  SaleHorizon = 'sale_horizon',
  /** column name */
  SaleIsSeller = 'sale_is_seller',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SaleStarted = 'sale_started',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondContactId = 'second_contact_id',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Snapshot = 'snapshot',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  SourceOrganisationId = 'source_organisation_id',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  UseBankThirdPillar = 'use_bank_third_pillar',
  /** column name */
  UseInsuranceThirdPillar = 'use_insurance_third_pillar',
  /** column name */
  UseSecondPillar = 'use_second_pillar',
  /** column name */
  UseThirdPillar = 'use_third_pillar',
  /** column name */
  UserInfoIp = 'user_info_ip',
  /** column name */
  UserInfoUserAgent = 'user_info_user_agent',
  /** column name */
  Verified = 'verified',
  /** column name */
  WorkPermitId = 'work_permit_id',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export type InsertListingLoginsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingLoginsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingLoginsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingLoginsAggregateBoolExpCount>;
};

export type InsertListingLoginsAggregateBoolExpBoolAnd = {
  arguments: InsertListingLoginsSelectColumnLoginsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLoginsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingLoginsAggregateBoolExpBoolOr = {
  arguments: InsertListingLoginsSelectColumnLoginsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLoginsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingLoginsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLoginsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLoginsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLoginsArrRelInsertInput = {
  data: Array<InsertListingLoginsInsertInput>;
  on_conflict?: InputMaybe<InsertListingLoginsOnConflict>;
};

export type InsertListingLoginsBoolExp = {
  _and?: InputMaybe<Array<InsertListingLoginsBoolExp>>;
  _not?: InputMaybe<InsertListingLoginsBoolExp>;
  _or?: InputMaybe<Array<InsertListingLoginsBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingStringComparisonExp>;
  invalid?: InputMaybe<InsertListingBooleanComparisonExp>;
  nylas_provider?: InputMaybe<InsertListingStringComparisonExp>;
  profile?: InputMaybe<InsertListingJsonbComparisonExp>;
  provider?: InputMaybe<InsertListingStringComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tokens?: InputMaybe<InsertListingJsonbComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  username?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingLoginsConstraint {
  /** unique or primary key constraint on columns "provider", "id", "tenant_id" */
  LoginsIdProviderTenantIdUnique = 'logins_id_provider_tenant_id_unique'
}

export type InsertListingLoginsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invalid?: InputMaybe<Scalars['Boolean']['input']>;
  nylas_provider?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<Scalars['jsonb']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  tokens?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingLoginsOnConflict = {
  constraint: InsertListingLoginsConstraint;
  update_columns: Array<InsertListingLoginsUpdateColumn>;
  where?: InputMaybe<InsertListingLoginsBoolExp>;
};

export enum InsertListingLoginsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Invalid = 'invalid',
  /** column name */
  NylasProvider = 'nylas_provider',
  /** column name */
  Profile = 'profile',
  /** column name */
  Provider = 'provider',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Tokens = 'tokens',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Username = 'username'
}

export enum InsertListingLoginsSelectColumnLoginsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Invalid = 'invalid'
}

export enum InsertListingLoginsSelectColumnLoginsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Invalid = 'invalid'
}

export enum InsertListingLoginsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Invalid = 'invalid',
  /** column name */
  NylasProvider = 'nylas_provider',
  /** column name */
  Profile = 'profile',
  /** column name */
  Provider = 'provider',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Tokens = 'tokens',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Username = 'username'
}

export type InsertListingLotBuyersAggregateBoolExp = {
  count?: InputMaybe<InsertListingLotBuyersAggregateBoolExpCount>;
};

export type InsertListingLotBuyersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLotBuyersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotBuyersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLotBuyersArrRelInsertInput = {
  data: Array<InsertListingLotBuyersInsertInput>;
  on_conflict?: InputMaybe<InsertListingLotBuyersOnConflict>;
};

export type InsertListingLotBuyersBoolExp = {
  _and?: InputMaybe<Array<InsertListingLotBuyersBoolExp>>;
  _not?: InputMaybe<InsertListingLotBuyersBoolExp>;
  _or?: InputMaybe<Array<InsertListingLotBuyersBoolExp>>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingLotBuyersConstraint {
  /** unique or primary key constraint on columns "user_id", "lot_id" */
  LotBuyersLotIdUserIdUnique = 'lot_buyers_lot_id_user_id_unique'
}

export type InsertListingLotBuyersInsertInput = {
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingLotBuyersOnConflict = {
  constraint: InsertListingLotBuyersConstraint;
  update_columns: Array<InsertListingLotBuyersUpdateColumn>;
  where?: InputMaybe<InsertListingLotBuyersBoolExp>;
};

export enum InsertListingLotBuyersSelectColumn {
  /** column name */
  LotId = 'lot_id',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingLotBuyersUpdateColumn {
  /** column name */
  LotId = 'lot_id',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingLotCollaboratorsAggregateBoolExp = {
  count?: InputMaybe<InsertListingLotCollaboratorsAggregateBoolExpCount>;
};

export type InsertListingLotCollaboratorsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLotCollaboratorsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotCollaboratorsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLotCollaboratorsArrRelInsertInput = {
  data: Array<InsertListingLotCollaboratorsInsertInput>;
  on_conflict?: InputMaybe<InsertListingLotCollaboratorsOnConflict>;
};

export type InsertListingLotCollaboratorsBoolExp = {
  _and?: InputMaybe<Array<InsertListingLotCollaboratorsBoolExp>>;
  _not?: InputMaybe<InsertListingLotCollaboratorsBoolExp>;
  _or?: InputMaybe<Array<InsertListingLotCollaboratorsBoolExp>>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingLotCollaboratorsConstraint {
  /** unique or primary key constraint on columns "user_id", "lot_id" */
  LotCollaboratorsLotIdUserIdUnique = 'lot_collaborators_lot_id_user_id_unique'
}

export type InsertListingLotCollaboratorsInsertInput = {
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingLotCollaboratorsOnConflict = {
  constraint: InsertListingLotCollaboratorsConstraint;
  update_columns: Array<InsertListingLotCollaboratorsUpdateColumn>;
  where?: InputMaybe<InsertListingLotCollaboratorsBoolExp>;
};

export enum InsertListingLotCollaboratorsSelectColumn {
  /** column name */
  LotId = 'lot_id',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingLotCollaboratorsUpdateColumn {
  /** column name */
  LotId = 'lot_id',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingLotReferenceAliasesAggregateBoolExp = {
  count?: InputMaybe<InsertListingLotReferenceAliasesAggregateBoolExpCount>;
};

export type InsertListingLotReferenceAliasesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLotReferenceAliasesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotReferenceAliasesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLotReferenceAliasesArrRelInsertInput = {
  data: Array<InsertListingLotReferenceAliasesInsertInput>;
  on_conflict?: InputMaybe<InsertListingLotReferenceAliasesOnConflict>;
};

export type InsertListingLotReferenceAliasesBoolExp = {
  _and?: InputMaybe<Array<InsertListingLotReferenceAliasesBoolExp>>;
  _not?: InputMaybe<InsertListingLotReferenceAliasesBoolExp>;
  _or?: InputMaybe<Array<InsertListingLotReferenceAliasesBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  reference_alias_decoded?: InputMaybe<InsertListingIntComparisonExp>;
};

export enum InsertListingLotReferenceAliasesConstraint {
  /** unique or primary key constraint on columns "reference_alias_decoded" */
  LotReferenceAliasesPkey = 'lot_reference_aliases_pkey'
}

export type InsertListingLotReferenceAliasesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  reference_alias_decoded?: InputMaybe<Scalars['Int']['input']>;
};

export type InsertListingLotReferenceAliasesOnConflict = {
  constraint: InsertListingLotReferenceAliasesConstraint;
  update_columns: Array<InsertListingLotReferenceAliasesUpdateColumn>;
  where?: InputMaybe<InsertListingLotReferenceAliasesBoolExp>;
};

export enum InsertListingLotReferenceAliasesSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  ReferenceAliasDecoded = 'reference_alias_decoded'
}

export enum InsertListingLotReferenceAliasesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  ReferenceAliasDecoded = 'reference_alias_decoded'
}

export type InsertListingLotSellersAggregateBoolExp = {
  count?: InputMaybe<InsertListingLotSellersAggregateBoolExpCount>;
};

export type InsertListingLotSellersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLotSellersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotSellersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLotSellersArrRelInsertInput = {
  data: Array<InsertListingLotSellersInsertInput>;
  on_conflict?: InputMaybe<InsertListingLotSellersOnConflict>;
};

export type InsertListingLotSellersBoolExp = {
  _and?: InputMaybe<Array<InsertListingLotSellersBoolExp>>;
  _not?: InputMaybe<InsertListingLotSellersBoolExp>;
  _or?: InputMaybe<Array<InsertListingLotSellersBoolExp>>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  seller?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingLotSellersConstraint {
  /** unique or primary key constraint on columns "user_id", "lot_id" */
  LotSellersLotIdUserIdUnique = 'lot_sellers_lot_id_user_id_unique'
}

export type InsertListingLotSellersInsertInput = {
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  seller?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingLotSellersOnConflict = {
  constraint: InsertListingLotSellersConstraint;
  update_columns: Array<InsertListingLotSellersUpdateColumn>;
  where?: InputMaybe<InsertListingLotSellersBoolExp>;
};

export enum InsertListingLotSellersSelectColumn {
  /** column name */
  LotId = 'lot_id',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingLotSellersUpdateColumn {
  /** column name */
  LotId = 'lot_id',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingLotsAggregateBoolExp = {
  avg?: InputMaybe<InsertListingLotsAggregateBoolExpAvg>;
  bool_and?: InputMaybe<InsertListingLotsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingLotsAggregateBoolExpBoolOr>;
  corr?: InputMaybe<InsertListingLotsAggregateBoolExpCorr>;
  count?: InputMaybe<InsertListingLotsAggregateBoolExpCount>;
  covar_samp?: InputMaybe<InsertListingLotsAggregateBoolExpCovarSamp>;
  max?: InputMaybe<InsertListingLotsAggregateBoolExpMax>;
  min?: InputMaybe<InsertListingLotsAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<InsertListingLotsAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<InsertListingLotsAggregateBoolExpSum>;
  var_samp?: InputMaybe<InsertListingLotsAggregateBoolExpVarSamp>;
};

export type InsertListingLotsAggregateBoolExpAvg = {
  arguments: InsertListingLotsSelectColumnLotsAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLotsAggregateBoolExpBoolAnd = {
  arguments: InsertListingLotsSelectColumnLotsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingLotsAggregateBoolExpBoolOr = {
  arguments: InsertListingLotsSelectColumnLotsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingLotsAggregateBoolExpCorr = {
  arguments: InsertListingLotsAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLotsAggregateBoolExpCorrArguments = {
  X: InsertListingLotsSelectColumnLotsAggregateBoolExpCorrArgumentsColumns;
  Y: InsertListingLotsSelectColumnLotsAggregateBoolExpCorrArgumentsColumns;
};

export type InsertListingLotsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLotsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLotsAggregateBoolExpCovarSamp = {
  arguments: InsertListingLotsAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLotsAggregateBoolExpCovarSampArguments = {
  X: InsertListingLotsSelectColumnLotsAggregateBoolExpCovarSampArgumentsColumns;
  Y: InsertListingLotsSelectColumnLotsAggregateBoolExpCovarSampArgumentsColumns;
};

export type InsertListingLotsAggregateBoolExpMax = {
  arguments: InsertListingLotsSelectColumnLotsAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLotsAggregateBoolExpMin = {
  arguments: InsertListingLotsSelectColumnLotsAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLotsAggregateBoolExpStddevSamp = {
  arguments: InsertListingLotsSelectColumnLotsAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLotsAggregateBoolExpSum = {
  arguments: InsertListingLotsSelectColumnLotsAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLotsAggregateBoolExpVarSamp = {
  arguments: InsertListingLotsSelectColumnLotsAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLotsArrRelInsertInput = {
  data: Array<InsertListingLotsInsertInput>;
  on_conflict?: InputMaybe<InsertListingLotsOnConflict>;
};

export type InsertListingLotsBoolExp = {
  _and?: InputMaybe<Array<InsertListingLotsBoolExp>>;
  _not?: InputMaybe<InsertListingLotsBoolExp>;
  _or?: InputMaybe<Array<InsertListingLotsBoolExp>>;
  activities?: InputMaybe<InsertListingActivitiesBoolExp>;
  activities_aggregate?: InputMaybe<InsertListingActivitiesAggregateBoolExp>;
  address_display_option?: InputMaybe<InsertListingAddressDisplayOptionsEnumEnumComparisonExp>;
  address_display_option_brochure?: InputMaybe<InsertListingAddressDisplayOptionsEnumEnumComparisonExp>;
  auto_matching_filters?: InputMaybe<InsertListingJsonbComparisonExp>;
  available_from?: InputMaybe<InsertListingDateComparisonExp>;
  brochure_description?: InputMaybe<InsertListingStringComparisonExp>;
  brochure_pdf_compression_quality?: InputMaybe<InsertListingPdfCompressionQualityComparisonExp>;
  brochure_title?: InputMaybe<InsertListingStringComparisonExp>;
  broker?: InputMaybe<InsertListingUsersBoolExp>;
  broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  buyer_leads?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
  buyer_leads_aggregate?: InputMaybe<InsertListingBuyerLeadsAggregateBoolExp>;
  commission_rate?: InputMaybe<InsertListingFloatComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  created_by_user?: InputMaybe<InsertListingUsersBoolExp>;
  crm_link?: InputMaybe<InsertListingStringComparisonExp>;
  currency?: InputMaybe<InsertListingCurrenciesComparisonExp>;
  description?: InputMaybe<InsertListingStringComparisonExp>;
  development?: InputMaybe<InsertListingDevelopmentsBoolExp>;
  development_id?: InputMaybe<InsertListingUuidComparisonExp>;
  development_mappings?: InputMaybe<InsertListingDevelopmentMappingsBoolExp>;
  development_mappings_aggregate?: InputMaybe<InsertListingDevelopmentMappingsAggregateBoolExp>;
  dummy_broker_name?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_broker_phone?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_country_code?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_geom?: InputMaybe<InsertListingGeometryComparisonExp>;
  dummy_lat?: InputMaybe<InsertListingFloat8ComparisonExp>;
  dummy_living_surface?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_lng?: InputMaybe<InsertListingFloat8ComparisonExp>;
  dummy_locality?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_locality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  dummy_organisation_country_code?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_organisation_lat?: InputMaybe<InsertListingFloat8ComparisonExp>;
  dummy_organisation_lng?: InputMaybe<InsertListingFloat8ComparisonExp>;
  dummy_organisation_locality?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_organisation_name?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_organisation_phone?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_organisation_postcode?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_organisation_route?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_organisation_state?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_organisation_street_number?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_postcode?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_route?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_state?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_street_number?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_usable_surface?: InputMaybe<InsertListingStringComparisonExp>;
  duration_in_months?: InputMaybe<InsertListingIntComparisonExp>;
  email_templates?: InputMaybe<InsertListingEmailTemplatesBoolExp>;
  email_templates_aggregate?: InputMaybe<InsertListingEmailTemplatesAggregateBoolExp>;
  enable_auto_matching?: InputMaybe<InsertListingBooleanComparisonExp>;
  enquiries?: InputMaybe<InsertListingEnquiriesBoolExp>;
  enquiries_aggregate?: InputMaybe<InsertListingEnquiriesAggregateBoolExp>;
  enquiry_response_enabled?: InputMaybe<InsertListingBooleanComparisonExp>;
  expected_time_to_sell?: InputMaybe<InsertListingStringComparisonExp>;
  fixed_fee?: InputMaybe<InsertListingIntComparisonExp>;
  has_success_fee?: InputMaybe<InsertListingBooleanComparisonExp>;
  hide_price_on_brochure?: InputMaybe<InsertListingBooleanComparisonExp>;
  hide_price_on_portals?: InputMaybe<InsertListingBooleanComparisonExp>;
  hide_route?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_exclusive?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_paid?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_parking_included_in_total?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_sales_tax_inclusive?: InputMaybe<InsertListingBooleanComparisonExp>;
  lead?: InputMaybe<InsertListingLeadsBoolExp>;
  lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  listing_url?: InputMaybe<InsertListingStringComparisonExp>;
  lot_buyers?: InputMaybe<InsertListingLotBuyersBoolExp>;
  lot_buyers_aggregate?: InputMaybe<InsertListingLotBuyersAggregateBoolExp>;
  lot_collaborators?: InputMaybe<InsertListingLotCollaboratorsBoolExp>;
  lot_collaborators_aggregate?: InputMaybe<InsertListingLotCollaboratorsAggregateBoolExp>;
  lot_property_files?: InputMaybe<InsertListingPropertyFilesBoolExp>;
  lot_property_files_aggregate?: InputMaybe<InsertListingPropertyFilesAggregateBoolExp>;
  lot_reference?: InputMaybe<InsertListingStringComparisonExp>;
  lot_reference_aliases?: InputMaybe<InsertListingLotReferenceAliasesBoolExp>;
  lot_reference_aliases_aggregate?: InputMaybe<InsertListingLotReferenceAliasesAggregateBoolExp>;
  lots_status?: InputMaybe<InsertListingLotsStatusEnumBoolExp>;
  mandate_sale_price?: InputMaybe<InsertListingFloatComparisonExp>;
  mandate_type?: InputMaybe<InsertListingStringComparisonExp>;
  minimum_net_seller_price?: InputMaybe<InsertListingFloatComparisonExp>;
  monthly_rent_computed?: InputMaybe<InsertListingFloatComparisonExp>;
  mortgage_broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  offer_type?: InputMaybe<InsertListingStringComparisonExp>;
  offers?: InputMaybe<InsertListingOffersBoolExp>;
  offers_aggregate?: InputMaybe<InsertListingOffersAggregateBoolExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  origin?: InputMaybe<InsertListingDictionariesBoolExp>;
  origin_id?: InputMaybe<InsertListingUuidComparisonExp>;
  parking_price?: InputMaybe<InsertListingFloat8ComparisonExp>;
  payment_id?: InputMaybe<InsertListingUuidComparisonExp>;
  portal_listings?: InputMaybe<InsertListingPortalListingsBoolExp>;
  portal_listings_aggregate?: InputMaybe<InsertListingPortalListingsAggregateBoolExp>;
  price_unit?: InputMaybe<InsertListingStringComparisonExp>;
  property?: InputMaybe<InsertListingPropertiesBoolExp>;
  property_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  property_transactions_aggregate?: InputMaybe<InsertListingPropertyTransactionsAggregateBoolExp>;
  publish_step?: InputMaybe<InsertListingStringComparisonExp>;
  rent_extra?: InputMaybe<InsertListingFloatComparisonExp>;
  rent_net?: InputMaybe<InsertListingFloatComparisonExp>;
  response_sender?: InputMaybe<InsertListingUsersBoolExp>;
  response_sender_id?: InputMaybe<InsertListingUuidComparisonExp>;
  sale_price?: InputMaybe<InsertListingFloat8ComparisonExp>;
  sale_price_computed?: InputMaybe<InsertListingFloat8ComparisonExp>;
  sellers?: InputMaybe<InsertListingLotSellersBoolExp>;
  sellers_aggregate?: InputMaybe<InsertListingLotSellersAggregateBoolExp>;
  send_enquiries_to_sellers?: InputMaybe<InsertListingBooleanComparisonExp>;
  shared_on_mls?: InputMaybe<InsertListingBooleanComparisonExp>;
  signed_at?: InputMaybe<InsertListingDateComparisonExp>;
  status?: InputMaybe<InsertListingLotsStatusEnumEnumComparisonExp>;
  success_fee_custom?: InputMaybe<InsertListingStringComparisonExp>;
  success_fee_percentage?: InputMaybe<InsertListingFloatComparisonExp>;
  success_fee_type?: InputMaybe<InsertListingStringComparisonExp>;
  tenant?: InputMaybe<InsertListingTenantsBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  title?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  use_custom_brochure_description?: InputMaybe<InsertListingBooleanComparisonExp>;
  use_custom_brochure_title?: InputMaybe<InsertListingBooleanComparisonExp>;
  use_dummy_address?: InputMaybe<InsertListingBooleanComparisonExp>;
  use_dummy_contact?: InputMaybe<InsertListingBooleanComparisonExp>;
  video_url?: InputMaybe<InsertListingStringComparisonExp>;
  virtual_visit_url?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingLotsConstraint {
  /** unique or primary key constraint on columns "order_nr", "development_id" */
  LotsDevelopmentIdOrderNrUnique = 'lots_development_id_order_nr_unique',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  LotsIdTenantIdUnique = 'lots_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  LotsIdUindex = 'lots_id_uindex',
  /** unique or primary key constraint on columns "id" */
  LotsPkey = 'lots_pkey'
}

export type InsertListingLotsInsertInput = {
  activities?: InputMaybe<InsertListingActivitiesArrRelInsertInput>;
  address_display_option?: InputMaybe<InsertListingAddressDisplayOptionsEnumEnum>;
  address_display_option_brochure?: InputMaybe<InsertListingAddressDisplayOptionsEnumEnum>;
  auto_matching_filters?: InputMaybe<Scalars['jsonb']['input']>;
  available_from?: InputMaybe<Scalars['date']['input']>;
  brochure_description?: InputMaybe<Scalars['String']['input']>;
  brochure_pdf_compression_quality?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  brochure_title?: InputMaybe<Scalars['String']['input']>;
  broker?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_leads?: InputMaybe<InsertListingBuyerLeadsArrRelInsertInput>;
  commission_rate?: InputMaybe<Scalars['Float']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  currency?: InputMaybe<Scalars['currencies']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  development?: InputMaybe<InsertListingDevelopmentsObjRelInsertInput>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  development_mappings?: InputMaybe<InsertListingDevelopmentMappingsArrRelInsertInput>;
  dummy_broker_name?: InputMaybe<Scalars['String']['input']>;
  dummy_broker_phone?: InputMaybe<Scalars['String']['input']>;
  dummy_country_code?: InputMaybe<Scalars['String']['input']>;
  dummy_geom?: InputMaybe<Scalars['geometry']['input']>;
  dummy_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_living_surface?: InputMaybe<Scalars['String']['input']>;
  dummy_lng?: InputMaybe<Scalars['float8']['input']>;
  dummy_locality?: InputMaybe<Scalars['String']['input']>;
  dummy_locality_id?: InputMaybe<Scalars['uuid']['input']>;
  dummy_organisation_country_code?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_lng?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_locality?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_name?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_phone?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_postcode?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_route?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_state?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_street_number?: InputMaybe<Scalars['String']['input']>;
  dummy_postcode?: InputMaybe<Scalars['String']['input']>;
  dummy_route?: InputMaybe<Scalars['String']['input']>;
  dummy_state?: InputMaybe<Scalars['String']['input']>;
  dummy_street_number?: InputMaybe<Scalars['String']['input']>;
  dummy_usable_surface?: InputMaybe<Scalars['String']['input']>;
  duration_in_months?: InputMaybe<Scalars['Int']['input']>;
  email_templates?: InputMaybe<InsertListingEmailTemplatesArrRelInsertInput>;
  enable_auto_matching?: InputMaybe<Scalars['Boolean']['input']>;
  enquiries?: InputMaybe<InsertListingEnquiriesArrRelInsertInput>;
  enquiry_response_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  expected_time_to_sell?: InputMaybe<Scalars['String']['input']>;
  fixed_fee?: InputMaybe<Scalars['Int']['input']>;
  has_success_fee?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_portals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_exclusive?: InputMaybe<Scalars['Boolean']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  is_parking_included_in_total?: InputMaybe<Scalars['Boolean']['input']>;
  is_sales_tax_inclusive?: InputMaybe<Scalars['Boolean']['input']>;
  lead?: InputMaybe<InsertListingLeadsObjRelInsertInput>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  listing_url?: InputMaybe<Scalars['String']['input']>;
  lot_buyers?: InputMaybe<InsertListingLotBuyersArrRelInsertInput>;
  lot_collaborators?: InputMaybe<InsertListingLotCollaboratorsArrRelInsertInput>;
  lot_property_files?: InputMaybe<InsertListingPropertyFilesArrRelInsertInput>;
  lot_reference?: InputMaybe<Scalars['String']['input']>;
  lot_reference_aliases?: InputMaybe<InsertListingLotReferenceAliasesArrRelInsertInput>;
  lots_status?: InputMaybe<InsertListingLotsStatusEnumObjRelInsertInput>;
  mandate_sale_price?: InputMaybe<Scalars['Float']['input']>;
  mandate_type?: InputMaybe<Scalars['String']['input']>;
  minimum_net_seller_price?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_computed?: InputMaybe<Scalars['Float']['input']>;
  mortgage_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  offer_type?: InputMaybe<Scalars['String']['input']>;
  offers?: InputMaybe<InsertListingOffersArrRelInsertInput>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  origin?: InputMaybe<InsertListingDictionariesObjRelInsertInput>;
  origin_id?: InputMaybe<Scalars['uuid']['input']>;
  parking_price?: InputMaybe<Scalars['float8']['input']>;
  payment_id?: InputMaybe<Scalars['uuid']['input']>;
  portal_listings?: InputMaybe<InsertListingPortalListingsArrRelInsertInput>;
  price_unit?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<InsertListingPropertiesObjRelInsertInput>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsArrRelInsertInput>;
  publish_step?: InputMaybe<Scalars['String']['input']>;
  rent_extra?: InputMaybe<Scalars['Float']['input']>;
  rent_net?: InputMaybe<Scalars['Float']['input']>;
  response_sender?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  response_sender_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_price?: InputMaybe<Scalars['float8']['input']>;
  sale_price_computed?: InputMaybe<Scalars['float8']['input']>;
  sellers?: InputMaybe<InsertListingLotSellersArrRelInsertInput>;
  send_enquiries_to_sellers?: InputMaybe<Scalars['Boolean']['input']>;
  shared_on_mls?: InputMaybe<Scalars['Boolean']['input']>;
  signed_at?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<InsertListingLotsStatusEnumEnum>;
  success_fee_custom?: InputMaybe<Scalars['String']['input']>;
  success_fee_percentage?: InputMaybe<Scalars['Float']['input']>;
  success_fee_type?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<InsertListingTenantsObjRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_custom_brochure_description?: InputMaybe<Scalars['Boolean']['input']>;
  use_custom_brochure_title?: InputMaybe<Scalars['Boolean']['input']>;
  use_dummy_address?: InputMaybe<Scalars['Boolean']['input']>;
  use_dummy_contact?: InputMaybe<Scalars['Boolean']['input']>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  virtual_visit_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingLotsObjRelInsertInput = {
  data: InsertListingLotsInsertInput;
  on_conflict?: InputMaybe<InsertListingLotsOnConflict>;
};

export type InsertListingLotsOnConflict = {
  constraint: InsertListingLotsConstraint;
  update_columns: Array<InsertListingLotsUpdateColumn>;
  where?: InputMaybe<InsertListingLotsBoolExp>;
};

export enum InsertListingLotsSelectColumn {
  /** column name */
  AddressDisplayOption = 'address_display_option',
  /** column name */
  AddressDisplayOptionBrochure = 'address_display_option_brochure',
  /** column name */
  AutoMatchingFilters = 'auto_matching_filters',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BrochureDescription = 'brochure_description',
  /** column name */
  BrochurePdfCompressionQuality = 'brochure_pdf_compression_quality',
  /** column name */
  BrochureTitle = 'brochure_title',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CommissionRate = 'commission_rate',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  DummyBrokerName = 'dummy_broker_name',
  /** column name */
  DummyBrokerPhone = 'dummy_broker_phone',
  /** column name */
  DummyCountryCode = 'dummy_country_code',
  /** column name */
  DummyGeom = 'dummy_geom',
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLivingSurface = 'dummy_living_surface',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyLocality = 'dummy_locality',
  /** column name */
  DummyLocalityId = 'dummy_locality_id',
  /** column name */
  DummyOrganisationCountryCode = 'dummy_organisation_country_code',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  DummyOrganisationLocality = 'dummy_organisation_locality',
  /** column name */
  DummyOrganisationName = 'dummy_organisation_name',
  /** column name */
  DummyOrganisationPhone = 'dummy_organisation_phone',
  /** column name */
  DummyOrganisationPostcode = 'dummy_organisation_postcode',
  /** column name */
  DummyOrganisationRoute = 'dummy_organisation_route',
  /** column name */
  DummyOrganisationState = 'dummy_organisation_state',
  /** column name */
  DummyOrganisationStreetNumber = 'dummy_organisation_street_number',
  /** column name */
  DummyPostcode = 'dummy_postcode',
  /** column name */
  DummyRoute = 'dummy_route',
  /** column name */
  DummyState = 'dummy_state',
  /** column name */
  DummyStreetNumber = 'dummy_street_number',
  /** column name */
  DummyUsableSurface = 'dummy_usable_surface',
  /** column name */
  DurationInMonths = 'duration_in_months',
  /** column name */
  EnableAutoMatching = 'enable_auto_matching',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  ExpectedTimeToSell = 'expected_time_to_sell',
  /** column name */
  FixedFee = 'fixed_fee',
  /** column name */
  HasSuccessFee = 'has_success_fee',
  /** column name */
  HidePriceOnBrochure = 'hide_price_on_brochure',
  /** column name */
  HidePriceOnPortals = 'hide_price_on_portals',
  /** column name */
  Id = 'id',
  /** column name */
  IsExclusive = 'is_exclusive',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  IsParkingIncludedInTotal = 'is_parking_included_in_total',
  /** column name */
  IsSalesTaxInclusive = 'is_sales_tax_inclusive',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  ListingUrl = 'listing_url',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MandateSalePrice = 'mandate_sale_price',
  /** column name */
  MandateType = 'mandate_type',
  /** column name */
  MinimumNetSellerPrice = 'minimum_net_seller_price',
  /** column name */
  MonthlyRentComputed = 'monthly_rent_computed',
  /** column name */
  MortgageBrokerId = 'mortgage_broker_id',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  OriginId = 'origin_id',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  PaymentId = 'payment_id',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PublishStep = 'publish_step',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  ResponseSenderId = 'response_sender_id',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed',
  /** column name */
  SendEnquiriesToSellers = 'send_enquiries_to_sellers',
  /** column name */
  SharedOnMls = 'shared_on_mls',
  /** column name */
  SignedAt = 'signed_at',
  /** column name */
  Status = 'status',
  /** column name */
  SuccessFeeCustom = 'success_fee_custom',
  /** column name */
  SuccessFeePercentage = 'success_fee_percentage',
  /** column name */
  SuccessFeeType = 'success_fee_type',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseCustomBrochureDescription = 'use_custom_brochure_description',
  /** column name */
  UseCustomBrochureTitle = 'use_custom_brochure_title',
  /** column name */
  UseDummyAddress = 'use_dummy_address',
  /** column name */
  UseDummyContact = 'use_dummy_contact',
  /** column name */
  VideoUrl = 'video_url',
  /** column name */
  VirtualVisitUrl = 'virtual_visit_url'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  EnableAutoMatching = 'enable_auto_matching',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  HasSuccessFee = 'has_success_fee',
  /** column name */
  HidePriceOnBrochure = 'hide_price_on_brochure',
  /** column name */
  HidePriceOnPortals = 'hide_price_on_portals',
  /** column name */
  IsExclusive = 'is_exclusive',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  IsParkingIncludedInTotal = 'is_parking_included_in_total',
  /** column name */
  IsSalesTaxInclusive = 'is_sales_tax_inclusive',
  /** column name */
  SendEnquiriesToSellers = 'send_enquiries_to_sellers',
  /** column name */
  SharedOnMls = 'shared_on_mls',
  /** column name */
  UseCustomBrochureDescription = 'use_custom_brochure_description',
  /** column name */
  UseCustomBrochureTitle = 'use_custom_brochure_title',
  /** column name */
  UseDummyAddress = 'use_dummy_address',
  /** column name */
  UseDummyContact = 'use_dummy_contact'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  EnableAutoMatching = 'enable_auto_matching',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  HasSuccessFee = 'has_success_fee',
  /** column name */
  HidePriceOnBrochure = 'hide_price_on_brochure',
  /** column name */
  HidePriceOnPortals = 'hide_price_on_portals',
  /** column name */
  IsExclusive = 'is_exclusive',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  IsParkingIncludedInTotal = 'is_parking_included_in_total',
  /** column name */
  IsSalesTaxInclusive = 'is_sales_tax_inclusive',
  /** column name */
  SendEnquiriesToSellers = 'send_enquiries_to_sellers',
  /** column name */
  SharedOnMls = 'shared_on_mls',
  /** column name */
  UseCustomBrochureDescription = 'use_custom_brochure_description',
  /** column name */
  UseCustomBrochureTitle = 'use_custom_brochure_title',
  /** column name */
  UseDummyAddress = 'use_dummy_address',
  /** column name */
  UseDummyContact = 'use_dummy_contact'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpMinArgumentsColumns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpSumArgumentsColumns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

export type InsertListingLotsStatusEnumBoolExp = {
  _and?: InputMaybe<Array<InsertListingLotsStatusEnumBoolExp>>;
  _not?: InputMaybe<InsertListingLotsStatusEnumBoolExp>;
  _or?: InputMaybe<Array<InsertListingLotsStatusEnumBoolExp>>;
  comment?: InputMaybe<InsertListingStringComparisonExp>;
  label?: InputMaybe<InsertListingStringComparisonExp>;
  value?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingLotsStatusEnumConstraint {
  /** unique or primary key constraint on columns "value" */
  LotsStatusEnumPkey = 'lots_status_enum_pkey'
}

export enum InsertListingLotsStatusEnumEnum {
  Abandoned = 'abandoned',
  Available = 'available',
  AvailableComingSoon = 'available_coming_soon',
  AvailableOffMarket = 'available_off_market',
  Draft = 'draft',
  LostSoldOwner = 'lost_sold_owner',
  LostSoldSomeone = 'lost_sold_someone',
  Paused = 'paused',
  Reserved = 'reserved',
  Won = 'won'
}

export type InsertListingLotsStatusEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingLotsStatusEnumEnum>;
  _in?: InputMaybe<Array<InsertListingLotsStatusEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingLotsStatusEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingLotsStatusEnumEnum>>;
};

export type InsertListingLotsStatusEnumInsertInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingLotsStatusEnumObjRelInsertInput = {
  data: InsertListingLotsStatusEnumInsertInput;
  on_conflict?: InputMaybe<InsertListingLotsStatusEnumOnConflict>;
};

export type InsertListingLotsStatusEnumOnConflict = {
  constraint: InsertListingLotsStatusEnumConstraint;
  update_columns: Array<InsertListingLotsStatusEnumUpdateColumn>;
  where?: InputMaybe<InsertListingLotsStatusEnumBoolExp>;
};

export enum InsertListingLotsStatusEnumUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export enum InsertListingLotsUpdateColumn {
  /** column name */
  AddressDisplayOption = 'address_display_option',
  /** column name */
  AddressDisplayOptionBrochure = 'address_display_option_brochure',
  /** column name */
  AutoMatchingFilters = 'auto_matching_filters',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BrochureDescription = 'brochure_description',
  /** column name */
  BrochurePdfCompressionQuality = 'brochure_pdf_compression_quality',
  /** column name */
  BrochureTitle = 'brochure_title',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CommissionRate = 'commission_rate',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  DummyBrokerName = 'dummy_broker_name',
  /** column name */
  DummyBrokerPhone = 'dummy_broker_phone',
  /** column name */
  DummyCountryCode = 'dummy_country_code',
  /** column name */
  DummyGeom = 'dummy_geom',
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLivingSurface = 'dummy_living_surface',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyLocality = 'dummy_locality',
  /** column name */
  DummyLocalityId = 'dummy_locality_id',
  /** column name */
  DummyOrganisationCountryCode = 'dummy_organisation_country_code',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  DummyOrganisationLocality = 'dummy_organisation_locality',
  /** column name */
  DummyOrganisationName = 'dummy_organisation_name',
  /** column name */
  DummyOrganisationPhone = 'dummy_organisation_phone',
  /** column name */
  DummyOrganisationPostcode = 'dummy_organisation_postcode',
  /** column name */
  DummyOrganisationRoute = 'dummy_organisation_route',
  /** column name */
  DummyOrganisationState = 'dummy_organisation_state',
  /** column name */
  DummyOrganisationStreetNumber = 'dummy_organisation_street_number',
  /** column name */
  DummyPostcode = 'dummy_postcode',
  /** column name */
  DummyRoute = 'dummy_route',
  /** column name */
  DummyState = 'dummy_state',
  /** column name */
  DummyStreetNumber = 'dummy_street_number',
  /** column name */
  DummyUsableSurface = 'dummy_usable_surface',
  /** column name */
  DurationInMonths = 'duration_in_months',
  /** column name */
  EnableAutoMatching = 'enable_auto_matching',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  ExpectedTimeToSell = 'expected_time_to_sell',
  /** column name */
  FixedFee = 'fixed_fee',
  /** column name */
  HasSuccessFee = 'has_success_fee',
  /** column name */
  HidePriceOnBrochure = 'hide_price_on_brochure',
  /** column name */
  HidePriceOnPortals = 'hide_price_on_portals',
  /** column name */
  Id = 'id',
  /** column name */
  IsExclusive = 'is_exclusive',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  IsParkingIncludedInTotal = 'is_parking_included_in_total',
  /** column name */
  IsSalesTaxInclusive = 'is_sales_tax_inclusive',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  ListingUrl = 'listing_url',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MandateSalePrice = 'mandate_sale_price',
  /** column name */
  MandateType = 'mandate_type',
  /** column name */
  MinimumNetSellerPrice = 'minimum_net_seller_price',
  /** column name */
  MonthlyRentComputed = 'monthly_rent_computed',
  /** column name */
  MortgageBrokerId = 'mortgage_broker_id',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  OriginId = 'origin_id',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  PaymentId = 'payment_id',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PublishStep = 'publish_step',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  ResponseSenderId = 'response_sender_id',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed',
  /** column name */
  SendEnquiriesToSellers = 'send_enquiries_to_sellers',
  /** column name */
  SharedOnMls = 'shared_on_mls',
  /** column name */
  SignedAt = 'signed_at',
  /** column name */
  Status = 'status',
  /** column name */
  SuccessFeeCustom = 'success_fee_custom',
  /** column name */
  SuccessFeePercentage = 'success_fee_percentage',
  /** column name */
  SuccessFeeType = 'success_fee_type',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseCustomBrochureDescription = 'use_custom_brochure_description',
  /** column name */
  UseCustomBrochureTitle = 'use_custom_brochure_title',
  /** column name */
  UseDummyAddress = 'use_dummy_address',
  /** column name */
  UseDummyContact = 'use_dummy_contact',
  /** column name */
  VideoUrl = 'video_url',
  /** column name */
  VirtualVisitUrl = 'virtual_visit_url'
}

export type InsertListingMaritalStatusComparisonExp = {
  _eq?: InputMaybe<Scalars['marital_status']['input']>;
  _gt?: InputMaybe<Scalars['marital_status']['input']>;
  _gte?: InputMaybe<Scalars['marital_status']['input']>;
  _in?: InputMaybe<Array<Scalars['marital_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['marital_status']['input']>;
  _lte?: InputMaybe<Scalars['marital_status']['input']>;
  _neq?: InputMaybe<Scalars['marital_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['marital_status']['input']>>;
};

export type InsertListingMortgageInterestRateTypeComparisonExp = {
  _eq?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  _gt?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  _gte?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  _in?: InputMaybe<Array<Scalars['mortgage_interest_rate_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  _lte?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  _neq?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['mortgage_interest_rate_type']['input']>>;
};

export type InsertListingMortgageInterestTypeComparisonExp = {
  _eq?: InputMaybe<Scalars['mortgage_interest_type']['input']>;
  _gt?: InputMaybe<Scalars['mortgage_interest_type']['input']>;
  _gte?: InputMaybe<Scalars['mortgage_interest_type']['input']>;
  _in?: InputMaybe<Array<Scalars['mortgage_interest_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['mortgage_interest_type']['input']>;
  _lte?: InputMaybe<Scalars['mortgage_interest_type']['input']>;
  _neq?: InputMaybe<Scalars['mortgage_interest_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['mortgage_interest_type']['input']>>;
};

export type InsertListingMortgageLenderTypeComparisonExp = {
  _eq?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  _gt?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  _gte?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  _in?: InputMaybe<Array<Scalars['mortgage_lender_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  _lte?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  _neq?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['mortgage_lender_type']['input']>>;
};

export type InsertListingMortgagesAggregateBoolExp = {
  avg?: InputMaybe<InsertListingMortgagesAggregateBoolExpAvg>;
  bool_and?: InputMaybe<InsertListingMortgagesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingMortgagesAggregateBoolExpBoolOr>;
  corr?: InputMaybe<InsertListingMortgagesAggregateBoolExpCorr>;
  count?: InputMaybe<InsertListingMortgagesAggregateBoolExpCount>;
  covar_samp?: InputMaybe<InsertListingMortgagesAggregateBoolExpCovarSamp>;
  max?: InputMaybe<InsertListingMortgagesAggregateBoolExpMax>;
  min?: InputMaybe<InsertListingMortgagesAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<InsertListingMortgagesAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<InsertListingMortgagesAggregateBoolExpSum>;
  var_samp?: InputMaybe<InsertListingMortgagesAggregateBoolExpVarSamp>;
};

export type InsertListingMortgagesAggregateBoolExpAvg = {
  arguments: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpBoolAnd = {
  arguments: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpBoolOr = {
  arguments: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpCorr = {
  arguments: InsertListingMortgagesAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpCorrArguments = {
  X: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpCorrArgumentsColumns;
  Y: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpCorrArgumentsColumns;
};

export type InsertListingMortgagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingMortgagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpCovarSamp = {
  arguments: InsertListingMortgagesAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpCovarSampArguments = {
  X: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpCovarSampArgumentsColumns;
  Y: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpCovarSampArgumentsColumns;
};

export type InsertListingMortgagesAggregateBoolExpMax = {
  arguments: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpMin = {
  arguments: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpStddevSamp = {
  arguments: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpSum = {
  arguments: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpVarSamp = {
  arguments: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingMortgagesArrRelInsertInput = {
  data: Array<InsertListingMortgagesInsertInput>;
  on_conflict?: InputMaybe<InsertListingMortgagesOnConflict>;
};

export type InsertListingMortgagesBoolExp = {
  _and?: InputMaybe<Array<InsertListingMortgagesBoolExp>>;
  _not?: InputMaybe<InsertListingMortgagesBoolExp>;
  _or?: InputMaybe<Array<InsertListingMortgagesBoolExp>>;
  amortisation?: InputMaybe<InsertListingFloatComparisonExp>;
  annual_rental_income?: InputMaybe<InsertListingFloat8ComparisonExp>;
  banker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  borrower_property_location?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  expiry_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  interest_rate?: InputMaybe<InsertListingFloatComparisonExp>;
  lender?: InputMaybe<InsertListingStringComparisonExp>;
  lender_id?: InputMaybe<InsertListingUuidComparisonExp>;
  loan_amount?: InputMaybe<InsertListingFloatComparisonExp>;
  mortgage_broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_id?: InputMaybe<InsertListingUuidComparisonExp>;
  signed_at?: InputMaybe<InsertListingDateComparisonExp>;
  start_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  tranches_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  type?: InputMaybe<InsertListingMortgageInterestTypeComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  value?: InputMaybe<InsertListingFloatComparisonExp>;
};

export enum InsertListingMortgagesConstraint {
  /** unique or primary key constraint on columns "id" */
  MortgagesPkey = 'mortgages_pkey'
}

export type InsertListingMortgagesInsertInput = {
  amortisation?: InputMaybe<Scalars['Float']['input']>;
  annual_rental_income?: InputMaybe<Scalars['float8']['input']>;
  banker_id?: InputMaybe<Scalars['uuid']['input']>;
  borrower_property_location?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interest_rate?: InputMaybe<Scalars['Float']['input']>;
  lender?: InputMaybe<Scalars['String']['input']>;
  lender_id?: InputMaybe<Scalars['uuid']['input']>;
  loan_amount?: InputMaybe<Scalars['Float']['input']>;
  mortgage_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  signed_at?: InputMaybe<Scalars['date']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  tranches_exist?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['mortgage_interest_type']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type InsertListingMortgagesOnConflict = {
  constraint: InsertListingMortgagesConstraint;
  update_columns: Array<InsertListingMortgagesUpdateColumn>;
  where?: InputMaybe<InsertListingMortgagesBoolExp>;
};

export enum InsertListingMortgagesSelectColumn {
  /** column name */
  Amortisation = 'amortisation',
  /** column name */
  AnnualRentalIncome = 'annual_rental_income',
  /** column name */
  BankerId = 'banker_id',
  /** column name */
  BorrowerPropertyLocation = 'borrower_property_location',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  InterestRate = 'interest_rate',
  /** column name */
  Lender = 'lender',
  /** column name */
  LenderId = 'lender_id',
  /** column name */
  LoanAmount = 'loan_amount',
  /** column name */
  MortgageBrokerId = 'mortgage_broker_id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  SignedAt = 'signed_at',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TranchesExist = 'tranches_exist',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  AnnualRentalIncome = 'annual_rental_income'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  TranchesExist = 'tranches_exist'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  TranchesExist = 'tranches_exist'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  AnnualRentalIncome = 'annual_rental_income'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  AnnualRentalIncome = 'annual_rental_income'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  AnnualRentalIncome = 'annual_rental_income'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpMinArgumentsColumns {
  /** column name */
  AnnualRentalIncome = 'annual_rental_income'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  AnnualRentalIncome = 'annual_rental_income'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpSumArgumentsColumns {
  /** column name */
  AnnualRentalIncome = 'annual_rental_income'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  AnnualRentalIncome = 'annual_rental_income'
}

export enum InsertListingMortgagesUpdateColumn {
  /** column name */
  Amortisation = 'amortisation',
  /** column name */
  AnnualRentalIncome = 'annual_rental_income',
  /** column name */
  BankerId = 'banker_id',
  /** column name */
  BorrowerPropertyLocation = 'borrower_property_location',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  InterestRate = 'interest_rate',
  /** column name */
  Lender = 'lender',
  /** column name */
  LenderId = 'lender_id',
  /** column name */
  LoanAmount = 'loan_amount',
  /** column name */
  MortgageBrokerId = 'mortgage_broker_id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  SignedAt = 'signed_at',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TranchesExist = 'tranches_exist',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type InsertListingNylasAccountConfigsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingNylasAccountConfigsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingNylasAccountConfigsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingNylasAccountConfigsAggregateBoolExpCount>;
};

export type InsertListingNylasAccountConfigsAggregateBoolExpBoolAnd = {
  arguments: InsertListingNylasAccountConfigsSelectColumnNylasAccountConfigsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingNylasAccountConfigsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingNylasAccountConfigsAggregateBoolExpBoolOr = {
  arguments: InsertListingNylasAccountConfigsSelectColumnNylasAccountConfigsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingNylasAccountConfigsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingNylasAccountConfigsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingNylasAccountConfigsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingNylasAccountConfigsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingNylasAccountConfigsArrRelInsertInput = {
  data: Array<InsertListingNylasAccountConfigsInsertInput>;
  on_conflict?: InputMaybe<InsertListingNylasAccountConfigsOnConflict>;
};

export type InsertListingNylasAccountConfigsBoolExp = {
  _and?: InputMaybe<Array<InsertListingNylasAccountConfigsBoolExp>>;
  _not?: InputMaybe<InsertListingNylasAccountConfigsBoolExp>;
  _or?: InputMaybe<Array<InsertListingNylasAccountConfigsBoolExp>>;
  account_id?: InputMaybe<InsertListingStringComparisonExp>;
  calendar_name?: InputMaybe<InsertListingStringComparisonExp>;
  calendar_sync_enabled?: InputMaybe<InsertListingBooleanComparisonExp>;
  calendar_sync_enabled_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  nylas_calendar_id?: InputMaybe<InsertListingStringComparisonExp>;
  scopes?: InputMaybe<InsertListingJsonbComparisonExp>;
  sync_activity_types?: InputMaybe<InsertListingStringArrayComparisonExp>;
  sync_enabled?: InputMaybe<InsertListingBooleanComparisonExp>;
  sync_enabled_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  sync_state?: InputMaybe<InsertListingStringComparisonExp>;
  sync_state_updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  sync_type?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingNylasAccountConfigsConstraint {
  /** unique or primary key constraint on columns "account_id", "user_id" */
  NylasAccountConfigsAccountIdUserIdUnique = 'nylas_account_configs_account_id_user_id_unique',
  /** unique or primary key constraint on columns "id" */
  NylasAccountConfigsPkey = 'nylas_account_configs_pkey'
}

export type InsertListingNylasAccountConfigsInsertInput = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  calendar_name?: InputMaybe<Scalars['String']['input']>;
  calendar_sync_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  calendar_sync_enabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nylas_calendar_id?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Scalars['jsonb']['input']>;
  sync_activity_types?: InputMaybe<Array<Scalars['String']['input']>>;
  sync_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  sync_enabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sync_state?: InputMaybe<Scalars['String']['input']>;
  sync_state_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sync_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingNylasAccountConfigsOnConflict = {
  constraint: InsertListingNylasAccountConfigsConstraint;
  update_columns: Array<InsertListingNylasAccountConfigsUpdateColumn>;
  where?: InputMaybe<InsertListingNylasAccountConfigsBoolExp>;
};

export enum InsertListingNylasAccountConfigsSelectColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CalendarName = 'calendar_name',
  /** column name */
  CalendarSyncEnabled = 'calendar_sync_enabled',
  /** column name */
  CalendarSyncEnabledAt = 'calendar_sync_enabled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NylasCalendarId = 'nylas_calendar_id',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  SyncActivityTypes = 'sync_activity_types',
  /** column name */
  SyncEnabled = 'sync_enabled',
  /** column name */
  SyncEnabledAt = 'sync_enabled_at',
  /** column name */
  SyncState = 'sync_state',
  /** column name */
  SyncStateUpdatedAt = 'sync_state_updated_at',
  /** column name */
  SyncType = 'sync_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingNylasAccountConfigsSelectColumnNylasAccountConfigsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  CalendarSyncEnabled = 'calendar_sync_enabled',
  /** column name */
  SyncEnabled = 'sync_enabled'
}

export enum InsertListingNylasAccountConfigsSelectColumnNylasAccountConfigsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  CalendarSyncEnabled = 'calendar_sync_enabled',
  /** column name */
  SyncEnabled = 'sync_enabled'
}

export enum InsertListingNylasAccountConfigsUpdateColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CalendarName = 'calendar_name',
  /** column name */
  CalendarSyncEnabled = 'calendar_sync_enabled',
  /** column name */
  CalendarSyncEnabledAt = 'calendar_sync_enabled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NylasCalendarId = 'nylas_calendar_id',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  SyncActivityTypes = 'sync_activity_types',
  /** column name */
  SyncEnabled = 'sync_enabled',
  /** column name */
  SyncEnabledAt = 'sync_enabled_at',
  /** column name */
  SyncState = 'sync_state',
  /** column name */
  SyncStateUpdatedAt = 'sync_state_updated_at',
  /** column name */
  SyncType = 'sync_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingOffersAggregateBoolExp = {
  count?: InputMaybe<InsertListingOffersAggregateBoolExpCount>;
};

export type InsertListingOffersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingOffersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingOffersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingOffersArrRelInsertInput = {
  data: Array<InsertListingOffersInsertInput>;
  on_conflict?: InputMaybe<InsertListingOffersOnConflict>;
};

export type InsertListingOffersBoolExp = {
  _and?: InputMaybe<Array<InsertListingOffersBoolExp>>;
  _not?: InputMaybe<InsertListingOffersBoolExp>;
  _or?: InputMaybe<Array<InsertListingOffersBoolExp>>;
  amount?: InputMaybe<InsertListingIntComparisonExp>;
  buyer?: InputMaybe<InsertListingUsersBoolExp>;
  buyer_id?: InputMaybe<InsertListingUuidComparisonExp>;
  comments?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  creator?: InputMaybe<InsertListingUsersBoolExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  made_on?: InputMaybe<InsertListingDateComparisonExp>;
  offer_refused_id?: InputMaybe<InsertListingUuidComparisonExp>;
  offer_refused_type?: InputMaybe<InsertListingDictionariesBoolExp>;
  status?: InputMaybe<InsertListingOffersStatusEnumComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  valid_until?: InputMaybe<InsertListingDateComparisonExp>;
};

export enum InsertListingOffersConstraint {
  /** unique or primary key constraint on columns "id" */
  OffersPkey = 'offers_pkey'
}

export type InsertListingOffersInsertInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  buyer?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  buyer_id?: InputMaybe<Scalars['uuid']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  creator?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  made_on?: InputMaybe<Scalars['date']['input']>;
  offer_refused_id?: InputMaybe<Scalars['uuid']['input']>;
  offer_refused_type?: InputMaybe<InsertListingDictionariesObjRelInsertInput>;
  status?: InputMaybe<InsertListingOffersStatusEnum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  valid_until?: InputMaybe<Scalars['date']['input']>;
};

export type InsertListingOffersOnConflict = {
  constraint: InsertListingOffersConstraint;
  update_columns: Array<InsertListingOffersUpdateColumn>;
  where?: InputMaybe<InsertListingOffersBoolExp>;
};

export enum InsertListingOffersSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  BuyerId = 'buyer_id',
  /** column name */
  Comments = 'comments',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  MadeOn = 'made_on',
  /** column name */
  OfferRefusedId = 'offer_refused_id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidUntil = 'valid_until'
}

export enum InsertListingOffersStatusEnum {
  Accepted = 'accepted',
  Pending = 'pending',
  Refused = 'refused'
}

export type InsertListingOffersStatusEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingOffersStatusEnum>;
  _in?: InputMaybe<Array<InsertListingOffersStatusEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingOffersStatusEnum>;
  _nin?: InputMaybe<Array<InsertListingOffersStatusEnum>>;
};

export enum InsertListingOffersUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  BuyerId = 'buyer_id',
  /** column name */
  Comments = 'comments',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  MadeOn = 'made_on',
  /** column name */
  OfferRefusedId = 'offer_refused_id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidUntil = 'valid_until'
}

export type InsertListingOrganisationImagesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingOrganisationImagesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingOrganisationImagesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingOrganisationImagesAggregateBoolExpCount>;
};

export type InsertListingOrganisationImagesAggregateBoolExpBoolAnd = {
  arguments: InsertListingOrganisationImagesSelectColumnOrganisationImagesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingOrganisationImagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingOrganisationImagesAggregateBoolExpBoolOr = {
  arguments: InsertListingOrganisationImagesSelectColumnOrganisationImagesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingOrganisationImagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingOrganisationImagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingOrganisationImagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingOrganisationImagesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingOrganisationImagesArrRelInsertInput = {
  data: Array<InsertListingOrganisationImagesInsertInput>;
  on_conflict?: InputMaybe<InsertListingOrganisationImagesOnConflict>;
};

export type InsertListingOrganisationImagesBoolExp = {
  _and?: InputMaybe<Array<InsertListingOrganisationImagesBoolExp>>;
  _not?: InputMaybe<InsertListingOrganisationImagesBoolExp>;
  _or?: InputMaybe<Array<InsertListingOrganisationImagesBoolExp>>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  image?: InputMaybe<InsertListingImagesBoolExp>;
  image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_primary?: InputMaybe<InsertListingBooleanComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  organisation?: InputMaybe<InsertListingOrganisationsBoolExp>;
  organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingOrganisationImagesConstraint {
  /** unique or primary key constraint on columns "organisation_id", "is_primary" */
  IdxOrganisationImagesOrganisationIdIsPrimary = 'idx_organisation_images_organisation_id_is_primary',
  /** unique or primary key constraint on columns "id" */
  OrganisationImagesIdKey = 'organisation_images_id_key',
  /** unique or primary key constraint on columns "organisation_id", "image_id" */
  OrganisationImagesOrganisationIdImageIdUnique = 'organisation_images_organisation_id_image_id_unique'
}

export type InsertListingOrganisationImagesInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  organisation?: InputMaybe<InsertListingOrganisationsObjRelInsertInput>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingOrganisationImagesOnConflict = {
  constraint: InsertListingOrganisationImagesConstraint;
  update_columns: Array<InsertListingOrganisationImagesUpdateColumn>;
  where?: InputMaybe<InsertListingOrganisationImagesBoolExp>;
};

export enum InsertListingOrganisationImagesSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  OrganisationId = 'organisation_id'
}

export enum InsertListingOrganisationImagesSelectColumnOrganisationImagesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsPrimary = 'is_primary'
}

export enum InsertListingOrganisationImagesSelectColumnOrganisationImagesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsPrimary = 'is_primary'
}

export enum InsertListingOrganisationImagesUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  OrganisationId = 'organisation_id'
}

export type InsertListingOrganisationUsersAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingOrganisationUsersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingOrganisationUsersAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingOrganisationUsersAggregateBoolExpCount>;
};

export type InsertListingOrganisationUsersAggregateBoolExpBoolAnd = {
  arguments: InsertListingOrganisationUsersSelectColumnOrganisationUsersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingOrganisationUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingOrganisationUsersAggregateBoolExpBoolOr = {
  arguments: InsertListingOrganisationUsersSelectColumnOrganisationUsersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingOrganisationUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingOrganisationUsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingOrganisationUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingOrganisationUsersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingOrganisationUsersArrRelInsertInput = {
  data: Array<InsertListingOrganisationUsersInsertInput>;
  on_conflict?: InputMaybe<InsertListingOrganisationUsersOnConflict>;
};

export type InsertListingOrganisationUsersBoolExp = {
  _and?: InputMaybe<Array<InsertListingOrganisationUsersBoolExp>>;
  _not?: InputMaybe<InsertListingOrganisationUsersBoolExp>;
  _or?: InputMaybe<Array<InsertListingOrganisationUsersBoolExp>>;
  is_primary?: InputMaybe<InsertListingBooleanComparisonExp>;
  organisation?: InputMaybe<InsertListingOrganisationsBoolExp>;
  organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  users?: InputMaybe<InsertListingUsersBoolExp>;
};

export enum InsertListingOrganisationUsersConstraint {
  /** unique or primary key constraint on columns "organisation_id", "is_primary" */
  IdxOrganisationUsersOrganisationIdIsPrimary = 'idx_organisation_users_organisation_id_is_primary',
  /** unique or primary key constraint on columns "user_id" */
  OrganisationUsersUserIdUnique = 'organisation_users_user_id_unique'
}

export type InsertListingOrganisationUsersInsertInput = {
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  organisation?: InputMaybe<InsertListingOrganisationsObjRelInsertInput>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  users?: InputMaybe<InsertListingUsersObjRelInsertInput>;
};

export type InsertListingOrganisationUsersObjRelInsertInput = {
  data: InsertListingOrganisationUsersInsertInput;
  on_conflict?: InputMaybe<InsertListingOrganisationUsersOnConflict>;
};

export type InsertListingOrganisationUsersOnConflict = {
  constraint: InsertListingOrganisationUsersConstraint;
  update_columns: Array<InsertListingOrganisationUsersUpdateColumn>;
  where?: InputMaybe<InsertListingOrganisationUsersBoolExp>;
};

export enum InsertListingOrganisationUsersSelectColumn {
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingOrganisationUsersSelectColumnOrganisationUsersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsPrimary = 'is_primary'
}

export enum InsertListingOrganisationUsersSelectColumnOrganisationUsersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsPrimary = 'is_primary'
}

export enum InsertListingOrganisationUsersUpdateColumn {
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingOrganisationsBoolExp = {
  _and?: InputMaybe<Array<InsertListingOrganisationsBoolExp>>;
  _not?: InputMaybe<InsertListingOrganisationsBoolExp>;
  _or?: InputMaybe<Array<InsertListingOrganisationsBoolExp>>;
  branding_color?: InputMaybe<InsertListingStringComparisonExp>;
  country?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  emails?: InputMaybe<InsertListingEmailsBoolExp>;
  emails_aggregate?: InputMaybe<InsertListingEmailsAggregateBoolExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_default_lender?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_lender?: InputMaybe<InsertListingBooleanComparisonExp>;
  lat?: InputMaybe<InsertListingFloatComparisonExp>;
  lng?: InputMaybe<InsertListingFloatComparisonExp>;
  locality?: InputMaybe<InsertListingStringComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  organisation_images?: InputMaybe<InsertListingOrganisationImagesBoolExp>;
  organisation_images_aggregate?: InputMaybe<InsertListingOrganisationImagesAggregateBoolExp>;
  organisation_users?: InputMaybe<InsertListingOrganisationUsersBoolExp>;
  organisation_users_aggregate?: InputMaybe<InsertListingOrganisationUsersAggregateBoolExp>;
  parent_organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  phone_numbers?: InputMaybe<InsertListingPhoneNumbersBoolExp>;
  phone_numbers_aggregate?: InputMaybe<InsertListingPhoneNumbersAggregateBoolExp>;
  postcode?: InputMaybe<InsertListingStringComparisonExp>;
  state?: InputMaybe<InsertListingStringComparisonExp>;
  street?: InputMaybe<InsertListingStringComparisonExp>;
  street_number?: InputMaybe<InsertListingStringComparisonExp>;
  teams?: InputMaybe<InsertListingTeamsBoolExp>;
  teams_aggregate?: InputMaybe<InsertListingTeamsAggregateBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  website?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingOrganisationsConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  OrganisationsIdTenantIdUnique = 'organisations_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  OrganisationsPkey = 'organisations_pkey'
}

export type InsertListingOrganisationsInsertInput = {
  branding_color?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  emails?: InputMaybe<InsertListingEmailsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_default_lender?: InputMaybe<Scalars['Boolean']['input']>;
  is_lender?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation_images?: InputMaybe<InsertListingOrganisationImagesArrRelInsertInput>;
  organisation_users?: InputMaybe<InsertListingOrganisationUsersArrRelInsertInput>;
  parent_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_numbers?: InputMaybe<InsertListingPhoneNumbersArrRelInsertInput>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<InsertListingTeamsArrRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingOrganisationsObjRelInsertInput = {
  data: InsertListingOrganisationsInsertInput;
  on_conflict?: InputMaybe<InsertListingOrganisationsOnConflict>;
};

export type InsertListingOrganisationsOnConflict = {
  constraint: InsertListingOrganisationsConstraint;
  update_columns: Array<InsertListingOrganisationsUpdateColumn>;
  where?: InputMaybe<InsertListingOrganisationsBoolExp>;
};

export enum InsertListingOrganisationsUpdateColumn {
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefaultLender = 'is_default_lender',
  /** column name */
  IsLender = 'is_lender',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  Name = 'name',
  /** column name */
  ParentOrganisationId = 'parent_organisation_id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  State = 'state',
  /** column name */
  Street = 'street',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Website = 'website'
}

export type InsertListingOutput = {
  id: Scalars['uuid']['output'];
  lot?: Maybe<Lots>;
};

export type InsertListingPaymentsAggregateBoolExp = {
  count?: InputMaybe<InsertListingPaymentsAggregateBoolExpCount>;
};

export type InsertListingPaymentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPaymentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPaymentsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPaymentsArrRelInsertInput = {
  data: Array<InsertListingPaymentsInsertInput>;
  on_conflict?: InputMaybe<InsertListingPaymentsOnConflict>;
};

export type InsertListingPaymentsBoolExp = {
  _and?: InputMaybe<Array<InsertListingPaymentsBoolExp>>;
  _not?: InputMaybe<InsertListingPaymentsBoolExp>;
  _or?: InputMaybe<Array<InsertListingPaymentsBoolExp>>;
  amount?: InputMaybe<InsertListingFloatComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  currency?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  payment_created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  payment_intent_id?: InputMaybe<InsertListingStringComparisonExp>;
  payment_intent_raw?: InputMaybe<InsertListingJsonbComparisonExp>;
  receipt_url?: InputMaybe<InsertListingStringComparisonExp>;
  title?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingPaymentsConstraint {
  /** unique or primary key constraint on columns "payment_intent_id" */
  PaymentsPaymentIntentIdUnique = 'payments_payment_intent_id_unique',
  /** unique or primary key constraint on columns "id" */
  PaymentsPkey = 'payments_pkey'
}

export type InsertListingPaymentsInsertInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  payment_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent_raw?: InputMaybe<Scalars['jsonb']['input']>;
  receipt_url?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingPaymentsOnConflict = {
  constraint: InsertListingPaymentsConstraint;
  update_columns: Array<InsertListingPaymentsUpdateColumn>;
  where?: InputMaybe<InsertListingPaymentsBoolExp>;
};

export enum InsertListingPaymentsSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentCreatedAt = 'payment_created_at',
  /** column name */
  PaymentIntentId = 'payment_intent_id',
  /** column name */
  PaymentIntentRaw = 'payment_intent_raw',
  /** column name */
  ReceiptUrl = 'receipt_url',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingPaymentsUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentCreatedAt = 'payment_created_at',
  /** column name */
  PaymentIntentId = 'payment_intent_id',
  /** column name */
  PaymentIntentRaw = 'payment_intent_raw',
  /** column name */
  ReceiptUrl = 'receipt_url',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingPdfCompressionQualityComparisonExp = {
  _eq?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _gt?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _gte?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _in?: InputMaybe<Array<Scalars['pdf_compression_quality']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _lte?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _neq?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _nin?: InputMaybe<Array<Scalars['pdf_compression_quality']['input']>>;
};

export enum InsertListingPhoneNumberTypeEnumEnum {
  /** Home phone number */
  Home = 'home',
  /** Mobile phone number */
  Mobile = 'mobile',
  /** Other phone number */
  Other = 'other',
  /** Proxy number user to track calls */
  Proxy = 'proxy',
  /** Work phone number */
  Work = 'work'
}

export type InsertListingPhoneNumberTypeEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingPhoneNumberTypeEnumEnum>;
  _in?: InputMaybe<Array<InsertListingPhoneNumberTypeEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingPhoneNumberTypeEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingPhoneNumberTypeEnumEnum>>;
};

export type InsertListingPhoneNumbersAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingPhoneNumbersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingPhoneNumbersAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingPhoneNumbersAggregateBoolExpCount>;
};

export type InsertListingPhoneNumbersAggregateBoolExpBoolAnd = {
  arguments: InsertListingPhoneNumbersSelectColumnPhoneNumbersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPhoneNumbersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPhoneNumbersAggregateBoolExpBoolOr = {
  arguments: InsertListingPhoneNumbersSelectColumnPhoneNumbersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPhoneNumbersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPhoneNumbersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPhoneNumbersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPhoneNumbersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPhoneNumbersArrRelInsertInput = {
  data: Array<InsertListingPhoneNumbersInsertInput>;
  on_conflict?: InputMaybe<InsertListingPhoneNumbersOnConflict>;
};

export type InsertListingPhoneNumbersBoolExp = {
  _and?: InputMaybe<Array<InsertListingPhoneNumbersBoolExp>>;
  _not?: InputMaybe<InsertListingPhoneNumbersBoolExp>;
  _or?: InputMaybe<Array<InsertListingPhoneNumbersBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  number?: InputMaybe<InsertListingStringComparisonExp>;
  organisation?: InputMaybe<InsertListingOrganisationsBoolExp>;
  organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  primary?: InputMaybe<InsertListingBooleanComparisonExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  type?: InputMaybe<InsertListingPhoneNumberTypeEnumEnumComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  verification_attempts?: InputMaybe<InsertListingIntComparisonExp>;
  verification_code?: InputMaybe<InsertListingIntComparisonExp>;
  verification_codes_sent?: InputMaybe<InsertListingIntComparisonExp>;
  verified?: InputMaybe<InsertListingBooleanComparisonExp>;
};

export enum InsertListingPhoneNumbersConstraint {
  /** unique or primary key constraint on columns "id" */
  PhoneNumbersPkey = 'phone_numbers_pkey',
  /** unique or primary key constraint on columns "tenant_id", "number" */
  PhoneNumbersTenantIdOrganisationIdUnique = 'phone_numbers_tenant_id_organisation_id_unique',
  /** unique or primary key constraint on columns "tenant_id", "number" */
  PhoneNumbersTenantIdUserIdUnique = 'phone_numbers_tenant_id_user_id_unique'
}

export type InsertListingPhoneNumbersInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  organisation?: InputMaybe<InsertListingOrganisationsObjRelInsertInput>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<InsertListingPhoneNumberTypeEnumEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verification_attempts?: InputMaybe<Scalars['Int']['input']>;
  verification_code?: InputMaybe<Scalars['Int']['input']>;
  verification_codes_sent?: InputMaybe<Scalars['Int']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsertListingPhoneNumbersOnConflict = {
  constraint: InsertListingPhoneNumbersConstraint;
  update_columns: Array<InsertListingPhoneNumbersUpdateColumn>;
  where?: InputMaybe<InsertListingPhoneNumbersBoolExp>;
};

export enum InsertListingPhoneNumbersSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Primary = 'primary',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VerificationAttempts = 'verification_attempts',
  /** column name */
  VerificationCode = 'verification_code',
  /** column name */
  VerificationCodesSent = 'verification_codes_sent',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingPhoneNumbersSelectColumnPhoneNumbersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Primary = 'primary',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingPhoneNumbersSelectColumnPhoneNumbersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Primary = 'primary',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingPhoneNumbersUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Primary = 'primary',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VerificationAttempts = 'verification_attempts',
  /** column name */
  VerificationCode = 'verification_code',
  /** column name */
  VerificationCodesSent = 'verification_codes_sent',
  /** column name */
  Verified = 'verified'
}

export type InsertListingPipelinesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPipelinesBoolExp>>;
  _not?: InputMaybe<InsertListingPipelinesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPipelinesBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  deletable?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  label?: InputMaybe<InsertListingStringComparisonExp>;
  label_de?: InputMaybe<InsertListingStringComparisonExp>;
  label_en?: InputMaybe<InsertListingStringComparisonExp>;
  label_es?: InputMaybe<InsertListingStringComparisonExp>;
  label_fr?: InputMaybe<InsertListingStringComparisonExp>;
  label_it?: InputMaybe<InsertListingStringComparisonExp>;
  lead_type?: InputMaybe<InsertListingLeadTypeComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  stages?: InputMaybe<InsertListingLeadStagesBoolExp>;
  stages_aggregate?: InputMaybe<InsertListingLeadStagesAggregateBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingPipelinesConstraint {
  /** unique or primary key constraint on columns "id" */
  PipelinesPkey = 'pipelines_pkey'
}

export type InsertListingPipelinesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deletable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  lead_type?: InputMaybe<Scalars['lead_type']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stages?: InputMaybe<InsertListingLeadStagesArrRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingPipelinesObjRelInsertInput = {
  data: InsertListingPipelinesInsertInput;
  on_conflict?: InputMaybe<InsertListingPipelinesOnConflict>;
};

export type InsertListingPipelinesOnConflict = {
  constraint: InsertListingPipelinesConstraint;
  update_columns: Array<InsertListingPipelinesUpdateColumn>;
  where?: InputMaybe<InsertListingPipelinesBoolExp>;
};

export enum InsertListingPipelinesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deletable = 'deletable',
  /** column name */
  Id = 'id',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LeadType = 'lead_type',
  /** column name */
  Name = 'name',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingPlaceTypeEnumEnum {
  /** Agglomeration */
  Agglomeration = 'agglomeration',
  /** Сountry */
  Country = 'country',
  /** District */
  District = 'district',
  /** Locality */
  Locality = 'locality',
  /** Municipality */
  Municipality = 'municipality',
  /** Neighbourhood */
  Neighbourhood = 'neighbourhood',
  /** Postcode */
  Postcode = 'postcode',
  /** Region */
  Region = 'region',
  /** State */
  State = 'state'
}

export type InsertListingPlaceTypeEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingPlaceTypeEnumEnum>;
  _in?: InputMaybe<Array<InsertListingPlaceTypeEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingPlaceTypeEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingPlaceTypeEnumEnum>>;
};

export type InsertListingPlacesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingPlacesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingPlacesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingPlacesAggregateBoolExpCount>;
};

export type InsertListingPlacesAggregateBoolExpBoolAnd = {
  arguments: InsertListingPlacesSelectColumnPlacesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPlacesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPlacesAggregateBoolExpBoolOr = {
  arguments: InsertListingPlacesSelectColumnPlacesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPlacesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPlacesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPlacesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPlacesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPlacesArrRelInsertInput = {
  data: Array<InsertListingPlacesInsertInput>;
  on_conflict?: InputMaybe<InsertListingPlacesOnConflict>;
};

export type InsertListingPlacesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPlacesBoolExp>>;
  _not?: InputMaybe<InsertListingPlacesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPlacesBoolExp>>;
  agglomeration_id?: InputMaybe<InsertListingUuidComparisonExp>;
  breadcrumbs?: InputMaybe<InsertListingPlacesBreadcrumbsBoolExp>;
  breadcrumbs_aggregate?: InputMaybe<InsertListingPlacesBreadcrumbsAggregateBoolExp>;
  canonical_id?: InputMaybe<InsertListingUuidComparisonExp>;
  canonical_place?: InputMaybe<InsertListingPlacesBoolExp>;
  catchment_areas?: InputMaybe<InsertListingCatchmentAreasBoolExp>;
  catchment_areas_aggregate?: InputMaybe<InsertListingCatchmentAreasAggregateBoolExp>;
  centroid?: InputMaybe<InsertListingGeometryComparisonExp>;
  children_bbox?: InputMaybe<InsertListingJsonbComparisonExp>;
  country?: InputMaybe<InsertListingPlacesBoolExp>;
  country_code?: InputMaybe<InsertListingStringComparisonExp>;
  country_id?: InputMaybe<InsertListingUuidComparisonExp>;
  country_place?: InputMaybe<InsertListingPlacesBoolExp>;
  district?: InputMaybe<InsertListingPlacesBoolExp>;
  district_id?: InputMaybe<InsertListingUuidComparisonExp>;
  extra?: InputMaybe<InsertListingJsonbComparisonExp>;
  geom?: InputMaybe<InsertListingGeometryComparisonExp>;
  hasura_type?: InputMaybe<InsertListingPlaceTypeEnumEnumComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  in_label?: InputMaybe<InsertListingStringComparisonExp>;
  in_label_fr?: InputMaybe<InsertListingStringComparisonExp>;
  index?: InputMaybe<InsertListingBooleanComparisonExp>;
  index_rooms?: InputMaybe<InsertListingBooleanComparisonExp>;
  label?: InputMaybe<InsertListingStringComparisonExp>;
  label_de?: InputMaybe<InsertListingStringComparisonExp>;
  label_en?: InputMaybe<InsertListingStringComparisonExp>;
  label_es?: InputMaybe<InsertListingStringComparisonExp>;
  label_fr?: InputMaybe<InsertListingStringComparisonExp>;
  label_it?: InputMaybe<InsertListingStringComparisonExp>;
  lat?: InputMaybe<InsertListingFloatComparisonExp>;
  lead_looking_places?: InputMaybe<InsertListingLeadLookingPlacesBoolExp>;
  lead_looking_places_aggregate?: InputMaybe<InsertListingLeadLookingPlacesAggregateBoolExp>;
  lng?: InputMaybe<InsertListingFloatComparisonExp>;
  locality?: InputMaybe<InsertListingPlacesBoolExp>;
  locality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  municipality?: InputMaybe<InsertListingPlacesBoolExp>;
  municipality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  municipality_places?: InputMaybe<InsertListingPlacesBoolExp>;
  municipality_places_aggregate?: InputMaybe<InsertListingPlacesAggregateBoolExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  neighbourhood?: InputMaybe<InsertListingPlacesBoolExp>;
  neighbourhood_id?: InputMaybe<InsertListingUuidComparisonExp>;
  parent_places?: InputMaybe<InsertListingPlacesBoolExp>;
  population?: InputMaybe<InsertListingIntComparisonExp>;
  postcode?: InputMaybe<InsertListingStringComparisonExp>;
  postcode_id?: InputMaybe<InsertListingUuidComparisonExp>;
  properties?: InputMaybe<InsertListingPropertiesBoolExp>;
  region_id?: InputMaybe<InsertListingUuidComparisonExp>;
  search_base?: InputMaybe<InsertListingTsvectorComparisonExp>;
  simplified_geom?: InputMaybe<InsertListingGeometryComparisonExp>;
  slug?: InputMaybe<InsertListingStringComparisonExp>;
  slug_de?: InputMaybe<InsertListingStringComparisonExp>;
  slug_en?: InputMaybe<InsertListingStringComparisonExp>;
  slug_es?: InputMaybe<InsertListingStringComparisonExp>;
  slug_fr?: InputMaybe<InsertListingStringComparisonExp>;
  slug_it?: InputMaybe<InsertListingStringComparisonExp>;
  state?: InputMaybe<InsertListingPlacesBoolExp>;
  state_id?: InputMaybe<InsertListingUuidComparisonExp>;
  state_places?: InputMaybe<InsertListingPlacesBoolExp>;
  state_places_aggregate?: InputMaybe<InsertListingPlacesAggregateBoolExp>;
  type?: InputMaybe<InsertListingPlaceTypeEnumEnumComparisonExp>;
};

export type InsertListingPlacesBreadcrumbsAggregateBoolExp = {
  count?: InputMaybe<InsertListingPlacesBreadcrumbsAggregateBoolExpCount>;
};

export type InsertListingPlacesBreadcrumbsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPlacesBreadcrumbsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPlacesBreadcrumbsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPlacesBreadcrumbsArrRelInsertInput = {
  data: Array<InsertListingPlacesBreadcrumbsInsertInput>;
};

export type InsertListingPlacesBreadcrumbsBoolExp = {
  _and?: InputMaybe<Array<InsertListingPlacesBreadcrumbsBoolExp>>;
  _not?: InputMaybe<InsertListingPlacesBreadcrumbsBoolExp>;
  _or?: InputMaybe<Array<InsertListingPlacesBreadcrumbsBoolExp>>;
  breadcrumb_place_id?: InputMaybe<InsertListingUuidComparisonExp>;
  order_num?: InputMaybe<InsertListingBigintComparisonExp>;
  place?: InputMaybe<InsertListingPlacesBoolExp>;
  place_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export type InsertListingPlacesBreadcrumbsInsertInput = {
  breadcrumb_place_id?: InputMaybe<Scalars['uuid']['input']>;
  order_num?: InputMaybe<Scalars['bigint']['input']>;
  place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
};

export enum InsertListingPlacesBreadcrumbsSelectColumn {
  /** column name */
  BreadcrumbPlaceId = 'breadcrumb_place_id',
  /** column name */
  OrderNum = 'order_num',
  /** column name */
  PlaceId = 'place_id'
}

export enum InsertListingPlacesConstraint {
  /** unique or primary key constraint on columns "id" */
  PlacesPkey = 'places_pkey',
  /** unique or primary key constraint on columns "slug_de" */
  PlacesSlugDeIdx = 'places_slug_de_idx',
  /** unique or primary key constraint on columns "slug_en" */
  PlacesSlugEnIdx = 'places_slug_en_idx',
  /** unique or primary key constraint on columns "slug_es" */
  PlacesSlugEsIdx = 'places_slug_es_idx',
  /** unique or primary key constraint on columns "slug_fr" */
  PlacesSlugFrIdx = 'places_slug_fr_idx',
  /** unique or primary key constraint on columns "slug_it" */
  PlacesSlugItIdx = 'places_slug_it_idx'
}

export type InsertListingPlacesInsertInput = {
  agglomeration_id?: InputMaybe<Scalars['uuid']['input']>;
  breadcrumbs?: InputMaybe<InsertListingPlacesBreadcrumbsArrRelInsertInput>;
  canonical_id?: InputMaybe<Scalars['uuid']['input']>;
  canonical_place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  catchment_areas?: InputMaybe<InsertListingCatchmentAreasArrRelInsertInput>;
  centroid?: InputMaybe<Scalars['geometry']['input']>;
  children_bbox?: InputMaybe<Scalars['jsonb']['input']>;
  country?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  country_place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  district?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  district_id?: InputMaybe<Scalars['uuid']['input']>;
  extra?: InputMaybe<Scalars['jsonb']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  hasura_type?: InputMaybe<InsertListingPlaceTypeEnumEnum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  in_label_fr?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Boolean']['input']>;
  index_rooms?: InputMaybe<Scalars['Boolean']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lead_looking_places?: InputMaybe<InsertListingLeadLookingPlacesArrRelInsertInput>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  municipality?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  municipality_places?: InputMaybe<InsertListingPlacesArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  neighbourhood?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  population?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_id?: InputMaybe<Scalars['uuid']['input']>;
  region_id?: InputMaybe<Scalars['uuid']['input']>;
  search_base?: InputMaybe<Scalars['tsvector']['input']>;
  slug_de?: InputMaybe<Scalars['String']['input']>;
  slug_en?: InputMaybe<Scalars['String']['input']>;
  slug_es?: InputMaybe<Scalars['String']['input']>;
  slug_fr?: InputMaybe<Scalars['String']['input']>;
  slug_it?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  state_places?: InputMaybe<InsertListingPlacesArrRelInsertInput>;
  type?: InputMaybe<InsertListingPlaceTypeEnumEnum>;
};

export type InsertListingPlacesObjRelInsertInput = {
  data: InsertListingPlacesInsertInput;
  on_conflict?: InputMaybe<InsertListingPlacesOnConflict>;
};

export type InsertListingPlacesOnConflict = {
  constraint: InsertListingPlacesConstraint;
  update_columns: Array<InsertListingPlacesUpdateColumn>;
  where?: InputMaybe<InsertListingPlacesBoolExp>;
};

export enum InsertListingPlacesSelectColumn {
  /** column name */
  AgglomerationId = 'agglomeration_id',
  /** column name */
  CanonicalId = 'canonical_id',
  /** column name */
  Centroid = 'centroid',
  /** column name */
  ChildrenBbox = 'children_bbox',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  HasuraType = 'hasura_type',
  /** column name */
  Id = 'id',
  /** column name */
  InLabelFr = 'in_label_fr',
  /** column name */
  Index = 'index',
  /** column name */
  IndexRooms = 'index_rooms',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  Population = 'population',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SearchBase = 'search_base',
  /** column name */
  SimplifiedGeom = 'simplified_geom',
  /** column name */
  SlugDe = 'slug_de',
  /** column name */
  SlugEn = 'slug_en',
  /** column name */
  SlugEs = 'slug_es',
  /** column name */
  SlugFr = 'slug_fr',
  /** column name */
  SlugIt = 'slug_it',
  /** column name */
  StateId = 'state_id',
  /** column name */
  Type = 'type'
}

export enum InsertListingPlacesSelectColumnPlacesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Index = 'index',
  /** column name */
  IndexRooms = 'index_rooms'
}

export enum InsertListingPlacesSelectColumnPlacesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Index = 'index',
  /** column name */
  IndexRooms = 'index_rooms'
}

export enum InsertListingPlacesUpdateColumn {
  /** column name */
  AgglomerationId = 'agglomeration_id',
  /** column name */
  CanonicalId = 'canonical_id',
  /** column name */
  Centroid = 'centroid',
  /** column name */
  ChildrenBbox = 'children_bbox',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  HasuraType = 'hasura_type',
  /** column name */
  Id = 'id',
  /** column name */
  InLabelFr = 'in_label_fr',
  /** column name */
  Index = 'index',
  /** column name */
  IndexRooms = 'index_rooms',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  Population = 'population',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SearchBase = 'search_base',
  /** column name */
  SlugDe = 'slug_de',
  /** column name */
  SlugEn = 'slug_en',
  /** column name */
  SlugEs = 'slug_es',
  /** column name */
  SlugFr = 'slug_fr',
  /** column name */
  SlugIt = 'slug_it',
  /** column name */
  StateId = 'state_id',
  /** column name */
  Type = 'type'
}

export type InsertListingPortalIdxProtocolComparisonExp = {
  _eq?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _gt?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _gte?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _in?: InputMaybe<Array<Scalars['portal_idx_protocol']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _lte?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _neq?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _nin?: InputMaybe<Array<Scalars['portal_idx_protocol']['input']>>;
};

export type InsertListingPortalListingsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingPortalListingsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingPortalListingsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingPortalListingsAggregateBoolExpCount>;
};

export type InsertListingPortalListingsAggregateBoolExpBoolAnd = {
  arguments: InsertListingPortalListingsSelectColumnPortalListingsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPortalListingsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPortalListingsAggregateBoolExpBoolOr = {
  arguments: InsertListingPortalListingsSelectColumnPortalListingsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPortalListingsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPortalListingsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPortalListingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPortalListingsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPortalListingsArrRelInsertInput = {
  data: Array<InsertListingPortalListingsInsertInput>;
  on_conflict?: InputMaybe<InsertListingPortalListingsOnConflict>;
};

export type InsertListingPortalListingsBoolExp = {
  _and?: InputMaybe<Array<InsertListingPortalListingsBoolExp>>;
  _not?: InputMaybe<InsertListingPortalListingsBoolExp>;
  _or?: InputMaybe<Array<InsertListingPortalListingsBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  external_property_id?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  last_publication_warnings?: InputMaybe<InsertListingJsonbComparisonExp>;
  live?: InputMaybe<InsertListingBooleanComparisonExp>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  milliseconds_online?: InputMaybe<InsertListingFloatComparisonExp>;
  portal?: InputMaybe<InsertListingPortalsBoolExp>;
  portal_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingPortalListingsConstraint {
  /** unique or primary key constraint on columns "id" */
  PortalListingsPkey = 'portal_listings_pkey',
  /** unique or primary key constraint on columns "portal_id", "lot_id" */
  PortalListingsPortalIdLotIdKey = 'portal_listings_portal_id_lot_id_key'
}

export type InsertListingPortalListingsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_property_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_publication_warnings?: InputMaybe<Scalars['jsonb']['input']>;
  live?: InputMaybe<Scalars['Boolean']['input']>;
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  milliseconds_online?: InputMaybe<Scalars['Float']['input']>;
  portal?: InputMaybe<InsertListingPortalsObjRelInsertInput>;
  portal_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingPortalListingsOnConflict = {
  constraint: InsertListingPortalListingsConstraint;
  update_columns: Array<InsertListingPortalListingsUpdateColumn>;
  where?: InputMaybe<InsertListingPortalListingsBoolExp>;
};

export enum InsertListingPortalListingsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalPropertyId = 'external_property_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastPublicationWarnings = 'last_publication_warnings',
  /** column name */
  Live = 'live',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  MillisecondsOnline = 'milliseconds_online',
  /** column name */
  PortalId = 'portal_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingPortalListingsSelectColumnPortalListingsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Live = 'live'
}

export enum InsertListingPortalListingsSelectColumnPortalListingsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Live = 'live'
}

export enum InsertListingPortalListingsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalPropertyId = 'external_property_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastPublicationWarnings = 'last_publication_warnings',
  /** column name */
  Live = 'live',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  MillisecondsOnline = 'milliseconds_online',
  /** column name */
  PortalId = 'portal_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingPortalsBoolExp = {
  _and?: InputMaybe<Array<InsertListingPortalsBoolExp>>;
  _not?: InputMaybe<InsertListingPortalsBoolExp>;
  _or?: InputMaybe<Array<InsertListingPortalsBoolExp>>;
  active?: InputMaybe<InsertListingBooleanComparisonExp>;
  contract_id?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  email?: InputMaybe<InsertListingStringComparisonExp>;
  enquiries?: InputMaybe<InsertListingEnquiriesBoolExp>;
  enquiries_aggregate?: InputMaybe<InsertListingEnquiriesAggregateBoolExp>;
  exact_address_required?: InputMaybe<InsertListingBooleanComparisonExp>;
  exclude_from_published_stats?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_top_premium_listing?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  idx_protocol?: InputMaybe<InsertListingPortalIdxProtocolComparisonExp>;
  increment?: InputMaybe<InsertListingIntComparisonExp>;
  logo?: InputMaybe<InsertListingImagesBoolExp>;
  logo_image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  master_portal_id?: InputMaybe<InsertListingUuidComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  password?: InputMaybe<InsertListingStringComparisonExp>;
  port?: InputMaybe<InsertListingIntComparisonExp>;
  portal_listings?: InputMaybe<InsertListingPortalListingsBoolExp>;
  portal_listings_aggregate?: InputMaybe<InsertListingPortalListingsAggregateBoolExp>;
  quota?: InputMaybe<InsertListingIntComparisonExp>;
  shared_portal?: InputMaybe<InsertListingSharedPortalsBoolExp>;
  team?: InputMaybe<InsertListingTeamsBoolExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  teams_portals?: InputMaybe<InsertListingTeamsPortalsBoolExp>;
  teams_portals_aggregate?: InputMaybe<InsertListingTeamsPortalsAggregateBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  type?: InputMaybe<InsertListingPortalsTypesEnumEnumComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  url?: InputMaybe<InsertListingStringComparisonExp>;
  username?: InputMaybe<InsertListingStringComparisonExp>;
  website_url?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingPortalsConstraint {
  /** unique or primary key constraint on columns "increment" */
  PortalsIncrementKey = 'portals_increment_key',
  /** unique or primary key constraint on columns "id" */
  RealEstatePortalsPkey = 'real_estate_portals_pkey'
}

export type InsertListingPortalsInsertInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contract_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enquiries?: InputMaybe<InsertListingEnquiriesArrRelInsertInput>;
  exact_address_required?: InputMaybe<Scalars['Boolean']['input']>;
  exclude_from_published_stats?: InputMaybe<Scalars['Boolean']['input']>;
  has_top_premium_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_protocol?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  logo?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  master_portal_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  portal_listings?: InputMaybe<InsertListingPortalListingsArrRelInsertInput>;
  quota?: InputMaybe<Scalars['Int']['input']>;
  shared_portal?: InputMaybe<InsertListingSharedPortalsObjRelInsertInput>;
  team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  teams_portals?: InputMaybe<InsertListingTeamsPortalsArrRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<InsertListingPortalsTypesEnumEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingPortalsObjRelInsertInput = {
  data: InsertListingPortalsInsertInput;
  on_conflict?: InputMaybe<InsertListingPortalsOnConflict>;
};

export type InsertListingPortalsOnConflict = {
  constraint: InsertListingPortalsConstraint;
  update_columns: Array<InsertListingPortalsUpdateColumn>;
  where?: InputMaybe<InsertListingPortalsBoolExp>;
};

export enum InsertListingPortalsTypesEnumEnum {
  Api = 'api',
  Comparis = 'comparis',
  Idealista = 'idealista',
  Idx = 'idx',
  Pisos = 'pisos',
  Shared = 'shared'
}

export type InsertListingPortalsTypesEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingPortalsTypesEnumEnum>;
  _in?: InputMaybe<Array<InsertListingPortalsTypesEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingPortalsTypesEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingPortalsTypesEnumEnum>>;
};

export enum InsertListingPortalsUpdateColumn {
  /** column name */
  Active = 'active',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Email = 'email',
  /** column name */
  ExactAddressRequired = 'exact_address_required',
  /** column name */
  ExcludeFromPublishedStats = 'exclude_from_published_stats',
  /** column name */
  HasTopPremiumListing = 'has_top_premium_listing',
  /** column name */
  Id = 'id',
  /** column name */
  IdxProtocol = 'idx_protocol',
  /** column name */
  Increment = 'increment',
  /** column name */
  LogoImageId = 'logo_image_id',
  /** column name */
  MasterPortalId = 'master_portal_id',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password',
  /** column name */
  Port = 'port',
  /** column name */
  Quota = 'quota',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  Username = 'username',
  /** column name */
  WebsiteUrl = 'website_url'
}

export type InsertListingPropertiesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertiesBoolExp>>;
  _not?: InputMaybe<InsertListingPropertiesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertiesBoolExp>>;
  appraisals?: InputMaybe<InsertListingAppraisalsBoolExp>;
  appraisals_aggregate?: InputMaybe<InsertListingAppraisalsAggregateBoolExp>;
  balcony_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  basement_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  borrower_lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  building_condition?: InputMaybe<InsertListingFloatComparisonExp>;
  building_standard?: InputMaybe<InsertListingFloatComparisonExp>;
  building_volume?: InputMaybe<InsertListingFloatComparisonExp>;
  building_volume_norm?: InputMaybe<InsertListingStringComparisonExp>;
  built_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  ceiling_height?: InputMaybe<InsertListingFloatComparisonExp>;
  centroid?: InputMaybe<InsertListingGeometryComparisonExp>;
  charges?: InputMaybe<InsertListingFloatComparisonExp>;
  commercial_potential_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  commercial_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  commercial_yearly_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  computed_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  construction_year?: InputMaybe<InsertListingIntComparisonExp>;
  consumption?: InputMaybe<InsertListingIntComparisonExp>;
  cooling?: InputMaybe<InsertListingCoolingEnumEnumComparisonExp>;
  country?: InputMaybe<InsertListingStringComparisonExp>;
  country_code?: InputMaybe<InsertListingStringComparisonExp>;
  country_id?: InputMaybe<InsertListingUuidComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  ctn?: InputMaybe<InsertListingStringComparisonExp>;
  deleted_by_user?: InputMaybe<InsertListingBooleanComparisonExp>;
  distance_to_airport?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_city_center?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_grocery_shop?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_high_school?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_hospital?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_kindergarten?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_motorway?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_primary_school?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_public_transport?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_sports_center?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_train_station?: InputMaybe<InsertListingFloatComparisonExp>;
  district_id?: InputMaybe<InsertListingUuidComparisonExp>;
  district_place?: InputMaybe<InsertListingPlacesBoolExp>;
  emissions?: InputMaybe<InsertListingIntComparisonExp>;
  energy_certificate_version?: InputMaybe<InsertListingStringComparisonExp>;
  energy_consumption_class?: InputMaybe<InsertListingEnergyClassTypeEnumEnumComparisonExp>;
  energy_inspection_date?: InputMaybe<InsertListingDateComparisonExp>;
  energy_reference_year?: InputMaybe<InsertListingIntComparisonExp>;
  estimated_higher_energy_cost?: InputMaybe<InsertListingIntComparisonExp>;
  estimated_lower_energy_cost?: InputMaybe<InsertListingIntComparisonExp>;
  financing_institution_id?: InputMaybe<InsertListingUuidComparisonExp>;
  flat_condition?: InputMaybe<InsertListingFloatComparisonExp>;
  floor_of_flat?: InputMaybe<InsertListingIntComparisonExp>;
  garden_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  gas_emissions_class?: InputMaybe<InsertListingEnergyClassTypeEnumEnumComparisonExp>;
  geom?: InputMaybe<InsertListingGeometryComparisonExp>;
  google_address?: InputMaybe<InsertListingGoogleAddressesBoolExp>;
  google_address_id?: InputMaybe<InsertListingUuidComparisonExp>;
  gross_floor_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  has_attic?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_cellar?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_elevator?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_fireplace?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_gym?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_photovoltaic_panels?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_sauna?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_storage_room?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_swimming_pool?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_view?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_wellness_area?: InputMaybe<InsertListingBooleanComparisonExp>;
  heating?: InputMaybe<InsertListingHeatingEnumEnumComparisonExp>;
  heating_distribution?: InputMaybe<InsertListingHeatingDistributionEnumEnumComparisonExp>;
  iazi_address_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  income_includes_parking?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_child_friendly?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_commercial_fully_rented?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_luxury?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_maisonette?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_oriented_east?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_oriented_north?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_oriented_south?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_oriented_west?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_parking_fully_rented?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_rental?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_residential_fully_rented?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_secondary_residence?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_wheelchair_accessible?: InputMaybe<InsertListingBooleanComparisonExp>;
  land_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  lat?: InputMaybe<InsertListingFloatComparisonExp>;
  latest_appraisal?: InputMaybe<InsertListingAppraisalsBoolExp>;
  latest_appraisal_id?: InputMaybe<InsertListingUuidComparisonExp>;
  leads?: InputMaybe<InsertListingLeadsBoolExp>;
  leads_aggregate?: InputMaybe<InsertListingLeadsAggregateBoolExp>;
  living_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  lng?: InputMaybe<InsertListingFloatComparisonExp>;
  locality?: InputMaybe<InsertListingStringComparisonExp>;
  locality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  locality_place?: InputMaybe<InsertListingPlacesBoolExp>;
  lots?: InputMaybe<InsertListingLotsBoolExp>;
  lots_aggregate?: InputMaybe<InsertListingLotsAggregateBoolExp>;
  macro_location?: InputMaybe<InsertListingFloatComparisonExp>;
  micro_location?: InputMaybe<InsertListingFloatComparisonExp>;
  minergie_code?: InputMaybe<InsertListingIntComparisonExp>;
  monthly_gross_rent?: InputMaybe<InsertListingFloatComparisonExp>;
  mortgages?: InputMaybe<InsertListingMortgagesBoolExp>;
  mortgages_aggregate?: InputMaybe<InsertListingMortgagesAggregateBoolExp>;
  municipality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  municipality_place?: InputMaybe<InsertListingPlacesBoolExp>;
  neighbourhood_id?: InputMaybe<InsertListingUuidComparisonExp>;
  neighbourhood_place?: InputMaybe<InsertListingPlacesBoolExp>;
  number_of_bathrooms?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_bedrooms?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_commercial_units?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_flats?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_floors?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_indoor_parkings?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_lifts?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_outdoor_parkings?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_residential_units?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_rooms?: InputMaybe<InsertListingFloatComparisonExp>;
  number_of_toilets?: InputMaybe<InsertListingIntComparisonExp>;
  orientation?: InputMaybe<InsertListingStringComparisonExp>;
  ownership_form?: InputMaybe<InsertListingStringComparisonExp>;
  parking_potential_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  parking_yearly_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  perceived_value?: InputMaybe<InsertListingFloatComparisonExp>;
  places?: InputMaybe<InsertListingPlacesBoolExp>;
  plot_has_constructible_reserve?: InputMaybe<InsertListingBooleanComparisonExp>;
  plot_is_constructible?: InputMaybe<InsertListingBooleanComparisonExp>;
  plot_number?: InputMaybe<InsertListingStringComparisonExp>;
  plot_registry_number?: InputMaybe<InsertListingStringComparisonExp>;
  postcode?: InputMaybe<InsertListingStringComparisonExp>;
  postcode_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_files?: InputMaybe<InsertListingPropertyFilesBoolExp>;
  property_files_aggregate?: InputMaybe<InsertListingPropertyFilesAggregateBoolExp>;
  property_images?: InputMaybe<InsertListingPropertyImagesBoolExp>;
  property_images_aggregate?: InputMaybe<InsertListingPropertyImagesAggregateBoolExp>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  property_transactions_aggregate?: InputMaybe<InsertListingPropertyTransactionsAggregateBoolExp>;
  property_type?: InputMaybe<InsertListingPropertyTypesBoolExp>;
  property_type_id?: InputMaybe<InsertListingUuidComparisonExp>;
  region_id?: InputMaybe<InsertListingUuidComparisonExp>;
  relevant_servitudes?: InputMaybe<InsertListingBooleanComparisonExp>;
  renovation_fund?: InputMaybe<InsertListingFloatComparisonExp>;
  renovation_year?: InputMaybe<InsertListingIntComparisonExp>;
  residential_potential_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  residential_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  residential_yearly_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  route?: InputMaybe<InsertListingStringComparisonExp>;
  session_id?: InputMaybe<InsertListingStringComparisonExp>;
  share_of_ownership?: InputMaybe<InsertListingFloatComparisonExp>;
  side?: InputMaybe<InsertListingPropertySideEnumEnumComparisonExp>;
  state?: InputMaybe<InsertListingStringComparisonExp>;
  state_id?: InputMaybe<InsertListingUuidComparisonExp>;
  state_place?: InputMaybe<InsertListingPlacesBoolExp>;
  street_number?: InputMaybe<InsertListingStringComparisonExp>;
  sub_locality?: InputMaybe<InsertListingStringComparisonExp>;
  tenant?: InputMaybe<InsertListingTenantsBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  terrace_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  tsv?: InputMaybe<InsertListingTsvectorComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  usable_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  weighted_floor_surface?: InputMaybe<InsertListingFloatComparisonExp>;
};

export enum InsertListingPropertiesConstraint {
  /** unique or primary key constraint on columns "id" */
  PropertiesPkey = 'properties_pkey'
}

export type InsertListingPropertiesInsertInput = {
  appraisals?: InputMaybe<InsertListingAppraisalsArrRelInsertInput>;
  balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  basement_surface?: InputMaybe<Scalars['Float']['input']>;
  borrower_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  building_condition?: InputMaybe<Scalars['Float']['input']>;
  building_standard?: InputMaybe<Scalars['Float']['input']>;
  building_volume?: InputMaybe<Scalars['Float']['input']>;
  building_volume_norm?: InputMaybe<Scalars['String']['input']>;
  built_surface?: InputMaybe<Scalars['Float']['input']>;
  ceiling_height?: InputMaybe<Scalars['Float']['input']>;
  charges?: InputMaybe<Scalars['Float']['input']>;
  commercial_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  commercial_surface?: InputMaybe<Scalars['Float']['input']>;
  commercial_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  consumption?: InputMaybe<Scalars['Int']['input']>;
  cooling?: InputMaybe<InsertListingCoolingEnumEnum>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  deleted_by_user?: InputMaybe<Scalars['Boolean']['input']>;
  distance_to_airport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_city_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_grocery_shop?: InputMaybe<Scalars['Float']['input']>;
  distance_to_high_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_hospital?: InputMaybe<Scalars['Float']['input']>;
  distance_to_kindergarten?: InputMaybe<Scalars['Float']['input']>;
  distance_to_motorway?: InputMaybe<Scalars['Float']['input']>;
  distance_to_primary_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_public_transport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_sports_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_train_station?: InputMaybe<Scalars['Float']['input']>;
  district_id?: InputMaybe<Scalars['uuid']['input']>;
  district_place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  emissions?: InputMaybe<Scalars['Int']['input']>;
  energy_certificate_version?: InputMaybe<Scalars['String']['input']>;
  energy_consumption_class?: InputMaybe<InsertListingEnergyClassTypeEnumEnum>;
  energy_inspection_date?: InputMaybe<Scalars['date']['input']>;
  energy_reference_year?: InputMaybe<Scalars['Int']['input']>;
  estimated_higher_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  estimated_lower_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  financing_institution_id?: InputMaybe<Scalars['uuid']['input']>;
  flat_condition?: InputMaybe<Scalars['Float']['input']>;
  floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  garden_surface?: InputMaybe<Scalars['Float']['input']>;
  gas_emissions_class?: InputMaybe<InsertListingEnergyClassTypeEnumEnum>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  google_address?: InputMaybe<InsertListingGoogleAddressesObjRelInsertInput>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  gross_floor_surface?: InputMaybe<Scalars['Float']['input']>;
  has_attic?: InputMaybe<Scalars['Boolean']['input']>;
  has_cellar?: InputMaybe<Scalars['Boolean']['input']>;
  has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_gym?: InputMaybe<Scalars['Boolean']['input']>;
  has_photovoltaic_panels?: InputMaybe<Scalars['Boolean']['input']>;
  has_sauna?: InputMaybe<Scalars['Boolean']['input']>;
  has_storage_room?: InputMaybe<Scalars['Boolean']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  has_wellness_area?: InputMaybe<Scalars['Boolean']['input']>;
  heating?: InputMaybe<InsertListingHeatingEnumEnum>;
  heating_distribution?: InputMaybe<InsertListingHeatingDistributionEnumEnum>;
  iazi_address_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  income_includes_parking?: InputMaybe<Scalars['Boolean']['input']>;
  is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_commercial_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_luxury?: InputMaybe<Scalars['Boolean']['input']>;
  is_maisonette?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_east?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_north?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_south?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_west?: InputMaybe<Scalars['Boolean']['input']>;
  is_parking_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_rental?: InputMaybe<Scalars['Boolean']['input']>;
  is_residential_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_secondary_residence?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  latest_appraisal?: InputMaybe<InsertListingAppraisalsObjRelInsertInput>;
  latest_appraisal_id?: InputMaybe<Scalars['uuid']['input']>;
  leads?: InputMaybe<InsertListingLeadsArrRelInsertInput>;
  living_surface?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  locality_place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  lots?: InputMaybe<InsertListingLotsArrRelInsertInput>;
  macro_location?: InputMaybe<Scalars['Float']['input']>;
  micro_location?: InputMaybe<Scalars['Float']['input']>;
  minergie_code?: InputMaybe<Scalars['Int']['input']>;
  monthly_gross_rent?: InputMaybe<Scalars['Float']['input']>;
  mortgages?: InputMaybe<InsertListingMortgagesArrRelInsertInput>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  municipality_place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  neighbourhood_place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_commercial_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_flats?: InputMaybe<Scalars['Int']['input']>;
  number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_lifts?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_residential_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  number_of_toilets?: InputMaybe<Scalars['Int']['input']>;
  orientation?: InputMaybe<Scalars['String']['input']>;
  ownership_form?: InputMaybe<Scalars['String']['input']>;
  parking_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  parking_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  perceived_value?: InputMaybe<Scalars['Float']['input']>;
  plot_has_constructible_reserve?: InputMaybe<Scalars['Boolean']['input']>;
  plot_is_constructible?: InputMaybe<Scalars['Boolean']['input']>;
  plot_number?: InputMaybe<Scalars['String']['input']>;
  plot_registry_number?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_id?: InputMaybe<Scalars['uuid']['input']>;
  property_files?: InputMaybe<InsertListingPropertyFilesArrRelInsertInput>;
  property_images?: InputMaybe<InsertListingPropertyImagesArrRelInsertInput>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsArrRelInsertInput>;
  property_type?: InputMaybe<InsertListingPropertyTypesObjRelInsertInput>;
  property_type_id?: InputMaybe<Scalars['uuid']['input']>;
  region_id?: InputMaybe<Scalars['uuid']['input']>;
  relevant_servitudes?: InputMaybe<Scalars['Boolean']['input']>;
  renovation_fund?: InputMaybe<Scalars['Float']['input']>;
  renovation_year?: InputMaybe<Scalars['Int']['input']>;
  residential_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  residential_surface?: InputMaybe<Scalars['Float']['input']>;
  residential_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  share_of_ownership?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<InsertListingPropertySideEnumEnum>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  state_place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  sub_locality?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<InsertListingTenantsObjRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  terrace_surface?: InputMaybe<Scalars['Float']['input']>;
  tsv?: InputMaybe<Scalars['tsvector']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  usable_surface?: InputMaybe<Scalars['Float']['input']>;
  weighted_floor_surface?: InputMaybe<Scalars['Float']['input']>;
};

export type InsertListingPropertiesObjRelInsertInput = {
  data: InsertListingPropertiesInsertInput;
  on_conflict?: InputMaybe<InsertListingPropertiesOnConflict>;
};

export type InsertListingPropertiesOnConflict = {
  constraint: InsertListingPropertiesConstraint;
  update_columns: Array<InsertListingPropertiesUpdateColumn>;
  where?: InputMaybe<InsertListingPropertiesBoolExp>;
};

export enum InsertListingPropertiesUpdateColumn {
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BasementSurface = 'basement_surface',
  /** column name */
  BorrowerLeadId = 'borrower_lead_id',
  /** column name */
  BuildingCondition = 'building_condition',
  /** column name */
  BuildingStandard = 'building_standard',
  /** column name */
  BuildingVolume = 'building_volume',
  /** column name */
  BuildingVolumeNorm = 'building_volume_norm',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CeilingHeight = 'ceiling_height',
  /** column name */
  Charges = 'charges',
  /** column name */
  CommercialPotentialRentalIncome = 'commercial_potential_rental_income',
  /** column name */
  CommercialSurface = 'commercial_surface',
  /** column name */
  CommercialYearlyRentalIncome = 'commercial_yearly_rental_income',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  Consumption = 'consumption',
  /** column name */
  Cooling = 'cooling',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Ctn = 'ctn',
  /** column name */
  DeletedByUser = 'deleted_by_user',
  /** column name */
  DistanceToAirport = 'distance_to_airport',
  /** column name */
  DistanceToCityCenter = 'distance_to_city_center',
  /** column name */
  DistanceToGroceryShop = 'distance_to_grocery_shop',
  /** column name */
  DistanceToHighSchool = 'distance_to_high_school',
  /** column name */
  DistanceToHospital = 'distance_to_hospital',
  /** column name */
  DistanceToKindergarten = 'distance_to_kindergarten',
  /** column name */
  DistanceToMotorway = 'distance_to_motorway',
  /** column name */
  DistanceToPrimarySchool = 'distance_to_primary_school',
  /** column name */
  DistanceToPublicTransport = 'distance_to_public_transport',
  /** column name */
  DistanceToSportsCenter = 'distance_to_sports_center',
  /** column name */
  DistanceToTrainStation = 'distance_to_train_station',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Emissions = 'emissions',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyConsumptionClass = 'energy_consumption_class',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FinancingInstitutionId = 'financing_institution_id',
  /** column name */
  FlatCondition = 'flat_condition',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  GasEmissionsClass = 'gas_emissions_class',
  /** column name */
  Geom = 'geom',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  GrossFloorSurface = 'gross_floor_surface',
  /** column name */
  HasAttic = 'has_attic',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGym = 'has_gym',
  /** column name */
  HasPhotovoltaicPanels = 'has_photovoltaic_panels',
  /** column name */
  HasSauna = 'has_sauna',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasWellnessArea = 'has_wellness_area',
  /** column name */
  Heating = 'heating',
  /** column name */
  HeatingDistribution = 'heating_distribution',
  /** column name */
  IaziAddressId = 'iazi_address_id',
  /** column name */
  Id = 'id',
  /** column name */
  IncomeIncludesParking = 'income_includes_parking',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsCommercialFullyRented = 'is_commercial_fully_rented',
  /** column name */
  IsLuxury = 'is_luxury',
  /** column name */
  IsMaisonette = 'is_maisonette',
  /** column name */
  IsOrientedEast = 'is_oriented_east',
  /** column name */
  IsOrientedNorth = 'is_oriented_north',
  /** column name */
  IsOrientedSouth = 'is_oriented_south',
  /** column name */
  IsOrientedWest = 'is_oriented_west',
  /** column name */
  IsParkingFullyRented = 'is_parking_fully_rented',
  /** column name */
  IsRental = 'is_rental',
  /** column name */
  IsResidentialFullyRented = 'is_residential_fully_rented',
  /** column name */
  IsSecondaryResidence = 'is_secondary_residence',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LatestAppraisalId = 'latest_appraisal_id',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MacroLocation = 'macro_location',
  /** column name */
  MicroLocation = 'micro_location',
  /** column name */
  MinergieCode = 'minergie_code',
  /** column name */
  MonthlyGrossRent = 'monthly_gross_rent',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfCommercialUnits = 'number_of_commercial_units',
  /** column name */
  NumberOfFlats = 'number_of_flats',
  /** column name */
  NumberOfFloors = 'number_of_floors',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLifts = 'number_of_lifts',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfResidentialUnits = 'number_of_residential_units',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  Orientation = 'orientation',
  /** column name */
  OwnershipForm = 'ownership_form',
  /** column name */
  ParkingPotentialRentalIncome = 'parking_potential_rental_income',
  /** column name */
  ParkingYearlyRentalIncome = 'parking_yearly_rental_income',
  /** column name */
  PerceivedValue = 'perceived_value',
  /** column name */
  PlotHasConstructibleReserve = 'plot_has_constructible_reserve',
  /** column name */
  PlotIsConstructible = 'plot_is_constructible',
  /** column name */
  PlotNumber = 'plot_number',
  /** column name */
  PlotRegistryNumber = 'plot_registry_number',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PropertyTypeId = 'property_type_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  RelevantServitudes = 'relevant_servitudes',
  /** column name */
  RenovationFund = 'renovation_fund',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  ResidentialPotentialRentalIncome = 'residential_potential_rental_income',
  /** column name */
  ResidentialSurface = 'residential_surface',
  /** column name */
  ResidentialYearlyRentalIncome = 'residential_yearly_rental_income',
  /** column name */
  Route = 'route',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  ShareOfOwnership = 'share_of_ownership',
  /** column name */
  Side = 'side',
  /** column name */
  State = 'state',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Tsv = 'tsv',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  WeightedFloorSurface = 'weighted_floor_surface'
}

export type InsertListingPropertiesUsersAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingPropertiesUsersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingPropertiesUsersAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingPropertiesUsersAggregateBoolExpCount>;
};

export type InsertListingPropertiesUsersAggregateBoolExpBoolAnd = {
  arguments: InsertListingPropertiesUsersSelectColumnPropertiesUsersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertiesUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertiesUsersAggregateBoolExpBoolOr = {
  arguments: InsertListingPropertiesUsersSelectColumnPropertiesUsersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertiesUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertiesUsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPropertiesUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertiesUsersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPropertiesUsersArrRelInsertInput = {
  data: Array<InsertListingPropertiesUsersInsertInput>;
  on_conflict?: InputMaybe<InsertListingPropertiesUsersOnConflict>;
};

export type InsertListingPropertiesUsersBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertiesUsersBoolExp>>;
  _not?: InputMaybe<InsertListingPropertiesUsersBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertiesUsersBoolExp>>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  property?: InputMaybe<InsertListingPropertiesBoolExp>;
  property_id?: InputMaybe<InsertListingUuidComparisonExp>;
  role?: InputMaybe<InsertListingStringComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  verified?: InputMaybe<InsertListingBooleanComparisonExp>;
};

export enum InsertListingPropertiesUsersConstraint {
  /** unique or primary key constraint on columns "property_id", "user_id" */
  PropertiesUsersPropertyIdUserIdUnique = 'properties_users_property_id_user_id_unique',
  /** unique or primary key constraint on columns "id" */
  PropertyOwnersPkey = 'property_owners_pkey'
}

export type InsertListingPropertiesUsersInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  property?: InputMaybe<InsertListingPropertiesObjRelInsertInput>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsertListingPropertiesUsersOnConflict = {
  constraint: InsertListingPropertiesUsersConstraint;
  update_columns: Array<InsertListingPropertiesUsersUpdateColumn>;
  where?: InputMaybe<InsertListingPropertiesUsersBoolExp>;
};

export enum InsertListingPropertiesUsersSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingPropertiesUsersSelectColumnPropertiesUsersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Verified = 'verified'
}

export enum InsertListingPropertiesUsersSelectColumnPropertiesUsersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Verified = 'verified'
}

export enum InsertListingPropertiesUsersUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Verified = 'verified'
}

export type InsertListingPropertyFilesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingPropertyFilesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingPropertyFilesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingPropertyFilesAggregateBoolExpCount>;
};

export type InsertListingPropertyFilesAggregateBoolExpBoolAnd = {
  arguments: InsertListingPropertyFilesSelectColumnPropertyFilesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertyFilesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertyFilesAggregateBoolExpBoolOr = {
  arguments: InsertListingPropertyFilesSelectColumnPropertyFilesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertyFilesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertyFilesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPropertyFilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertyFilesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPropertyFilesArrRelInsertInput = {
  data: Array<InsertListingPropertyFilesInsertInput>;
  on_conflict?: InputMaybe<InsertListingPropertyFilesOnConflict>;
};

export type InsertListingPropertyFilesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertyFilesBoolExp>>;
  _not?: InputMaybe<InsertListingPropertyFilesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertyFilesBoolExp>>;
  file?: InputMaybe<InsertListingFilesBoolExp>;
  file_id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_visible?: InputMaybe<InsertListingBooleanComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  property?: InputMaybe<InsertListingPropertiesBoolExp>;
  property_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingPropertyFilesConstraint {
  /** unique or primary key constraint on columns "property_id", "file_id" */
  PropertyFilesPropertyIdFileIdUnique = 'property_files_property_id_file_id_unique',
  /** unique or primary key constraint on columns "property_id", "file_id" */
  UniquePropertyIdFileId = 'unique_property_id_file_id',
  /** unique or primary key constraint on columns "order_nr", "property_id" */
  UniquePropertyIdOrderNr = 'unique_property_id_order_nr'
}

export type InsertListingPropertyFilesInsertInput = {
  file?: InputMaybe<InsertListingFilesObjRelInsertInput>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  property?: InputMaybe<InsertListingPropertiesObjRelInsertInput>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingPropertyFilesOnConflict = {
  constraint: InsertListingPropertyFilesConstraint;
  update_columns: Array<InsertListingPropertyFilesUpdateColumn>;
  where?: InputMaybe<InsertListingPropertyFilesBoolExp>;
};

export enum InsertListingPropertyFilesSelectColumn {
  /** column name */
  FileId = 'file_id',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  TenantId = 'tenant_id'
}

export enum InsertListingPropertyFilesSelectColumnPropertyFilesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsVisible = 'is_visible'
}

export enum InsertListingPropertyFilesSelectColumnPropertyFilesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsVisible = 'is_visible'
}

export enum InsertListingPropertyFilesUpdateColumn {
  /** column name */
  FileId = 'file_id',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  TenantId = 'tenant_id'
}

export type InsertListingPropertyImagesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingPropertyImagesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingPropertyImagesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingPropertyImagesAggregateBoolExpCount>;
};

export type InsertListingPropertyImagesAggregateBoolExpBoolAnd = {
  arguments: InsertListingPropertyImagesSelectColumnPropertyImagesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertyImagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertyImagesAggregateBoolExpBoolOr = {
  arguments: InsertListingPropertyImagesSelectColumnPropertyImagesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertyImagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertyImagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPropertyImagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertyImagesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPropertyImagesArrRelInsertInput = {
  data: Array<InsertListingPropertyImagesInsertInput>;
  on_conflict?: InputMaybe<InsertListingPropertyImagesOnConflict>;
};

export type InsertListingPropertyImagesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertyImagesBoolExp>>;
  _not?: InputMaybe<InsertListingPropertyImagesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertyImagesBoolExp>>;
  background_color?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  crop?: InputMaybe<InsertListingStringComparisonExp>;
  description?: InputMaybe<InsertListingStringComparisonExp>;
  display_on_brochure?: InputMaybe<InsertListingBooleanComparisonExp>;
  display_on_listing?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  image?: InputMaybe<InsertListingImagesBoolExp>;
  image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_floor_plan?: InputMaybe<InsertListingBooleanComparisonExp>;
  landscape_background_color?: InputMaybe<InsertListingStringComparisonExp>;
  landscape_crop?: InputMaybe<InsertListingStringComparisonExp>;
  landscape_size?: InputMaybe<InsertListingStringComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  property?: InputMaybe<InsertListingPropertiesBoolExp>;
  property_id?: InputMaybe<InsertListingUuidComparisonExp>;
  size?: InputMaybe<InsertListingStringComparisonExp>;
  title?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingPropertyImagesConstraint {
  /** unique or primary key constraint on columns "id" */
  PropertyImagesPkey = 'property_images_pkey',
  /** unique or primary key constraint on columns "property_id", "image_id" */
  PropertyImagesPropertyIdImageIdUnique = 'property_images_property_id_image_id_unique',
  /** unique or primary key constraint on columns "order_nr", "property_id" */
  PropertyImagesPropertyIdOrderNrUnique = 'property_images_property_id_order_nr_unique'
}

export type InsertListingPropertyImagesInsertInput = {
  background_color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  display_on_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_floor_plan?: InputMaybe<Scalars['Boolean']['input']>;
  landscape_background_color?: InputMaybe<Scalars['String']['input']>;
  landscape_crop?: InputMaybe<Scalars['String']['input']>;
  landscape_size?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  property?: InputMaybe<InsertListingPropertiesObjRelInsertInput>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingPropertyImagesOnConflict = {
  constraint: InsertListingPropertyImagesConstraint;
  update_columns: Array<InsertListingPropertyImagesUpdateColumn>;
  where?: InputMaybe<InsertListingPropertyImagesBoolExp>;
};

export enum InsertListingPropertyImagesSelectColumn {
  /** column name */
  BackgroundColor = 'background_color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crop = 'crop',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsFloorPlan = 'is_floor_plan',
  /** column name */
  LandscapeBackgroundColor = 'landscape_background_color',
  /** column name */
  LandscapeCrop = 'landscape_crop',
  /** column name */
  LandscapeSize = 'landscape_size',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  Size = 'size',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingPropertyImagesSelectColumnPropertyImagesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  IsFloorPlan = 'is_floor_plan'
}

export enum InsertListingPropertyImagesSelectColumnPropertyImagesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  IsFloorPlan = 'is_floor_plan'
}

export enum InsertListingPropertyImagesUpdateColumn {
  /** column name */
  BackgroundColor = 'background_color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crop = 'crop',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsFloorPlan = 'is_floor_plan',
  /** column name */
  LandscapeBackgroundColor = 'landscape_background_color',
  /** column name */
  LandscapeCrop = 'landscape_crop',
  /** column name */
  LandscapeSize = 'landscape_size',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  Size = 'size',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingPropertySearchAggregatorSourceEnum {
  ListingClickout = 'listing_clickout',
  ListingSimilarClick = 'listing_similar_click',
  ListingsManual = 'listings_manual',
  ListingsPageNavigationClick = 'listings_page_navigation_click'
}

export type InsertListingPropertySearchAggregatorSourceEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingPropertySearchAggregatorSourceEnum>;
  _in?: InputMaybe<Array<InsertListingPropertySearchAggregatorSourceEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingPropertySearchAggregatorSourceEnum>;
  _nin?: InputMaybe<Array<InsertListingPropertySearchAggregatorSourceEnum>>;
};

export enum InsertListingPropertySearchSourceEnum {
  Aggregator = 'aggregator',
  Crm = 'crm',
  Enquiry = 'enquiry',
  ImmologicForm = 'immologic_form',
  Other = 'other',
  Valuation = 'valuation'
}

export type InsertListingPropertySearchSourceEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingPropertySearchSourceEnum>;
  _in?: InputMaybe<Array<InsertListingPropertySearchSourceEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingPropertySearchSourceEnum>;
  _nin?: InputMaybe<Array<InsertListingPropertySearchSourceEnum>>;
};

export type InsertListingPropertySearchesAggregateBoolExp = {
  avg?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpAvg>;
  bool_and?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpBoolOr>;
  corr?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpCorr>;
  count?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpCount>;
  covar_samp?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpCovarSamp>;
  max?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpMax>;
  min?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpSum>;
  var_samp?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpVarSamp>;
};

export type InsertListingPropertySearchesAggregateBoolExpAvg = {
  arguments: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpBoolAnd = {
  arguments: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpBoolOr = {
  arguments: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpCorr = {
  arguments: InsertListingPropertySearchesAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpCorrArguments = {
  X: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpCorrArgumentsColumns;
  Y: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpCorrArgumentsColumns;
};

export type InsertListingPropertySearchesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPropertySearchesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpCovarSamp = {
  arguments: InsertListingPropertySearchesAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpCovarSampArguments = {
  X: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpCovarSampArgumentsColumns;
  Y: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpCovarSampArgumentsColumns;
};

export type InsertListingPropertySearchesAggregateBoolExpMax = {
  arguments: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpMin = {
  arguments: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpStddevSamp = {
  arguments: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpSum = {
  arguments: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpVarSamp = {
  arguments: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingPropertySearchesArrRelInsertInput = {
  data: Array<InsertListingPropertySearchesInsertInput>;
  on_conflict?: InputMaybe<InsertListingPropertySearchesOnConflict>;
};

export type InsertListingPropertySearchesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertySearchesBoolExp>>;
  _not?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertySearchesBoolExp>>;
  activate_aggregator?: InputMaybe<InsertListingBooleanComparisonExp>;
  agency_reference_contains?: InputMaybe<InsertListingStringComparisonExp>;
  aggregator_source?: InputMaybe<InsertListingPropertySearchAggregatorSourceEnumComparisonExp>;
  awaiting_alert_handle?: InputMaybe<InsertListingBooleanComparisonExp>;
  balcony_surface_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  book_online?: InputMaybe<InsertListingBooleanComparisonExp>;
  built_surface_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  built_surface_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  comment?: InputMaybe<InsertListingStringComparisonExp>;
  composite_property_type_eq?: InputMaybe<InsertListingStringComparisonExp>;
  computed_budget_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  computed_budget_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_at_gte?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  garden_surface_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  geog?: InputMaybe<InsertListingGeographyComparisonExp>;
  gross_rent_m2_yearly_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  gross_rent_m2_yearly_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  gross_rent_room_monthly_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  gross_rent_room_monthly_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  has_balcony?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_fireplace?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_garage?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_garden?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_lift?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_parking?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_swimming_pool?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_view?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  imported_id?: InputMaybe<InsertListingStringComparisonExp>;
  is_child_friendly?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_fsbo?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_furnished?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_minergie_certified?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_new_development?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_wheelchair_accessible?: InputMaybe<InsertListingBooleanComparisonExp>;
  land_surface_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  land_surface_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  last_alert_handle?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  last_notified_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  last_viewed_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  living_surface_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  living_surface_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  max_distance?: InputMaybe<InsertListingFloat8ComparisonExp>;
  monthly_rent_gte?: InputMaybe<InsertListingIntComparisonExp>;
  monthly_rent_lte?: InputMaybe<InsertListingIntComparisonExp>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  notification?: InputMaybe<InsertListingPropertySearchesNotificationComparisonExp>;
  number_of_bathrooms_gte?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_bathrooms_lte?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_bedrooms_gte?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_bedrooms_lte?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_indoor_parkings_gte?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_outdoor_parkings_gte?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_rooms_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  number_of_rooms_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  offer_type?: InputMaybe<InsertListingStringComparisonExp>;
  portal_in?: InputMaybe<InsertListingStringArrayComparisonExp>;
  property_main_type_in?: InputMaybe<InsertListingStringArrayComparisonExp>;
  property_main_type_nin?: InputMaybe<InsertListingStringArrayComparisonExp>;
  property_searches_enquiries?: InputMaybe<InsertListingPropertySearchesEnquiriesBoolExp>;
  property_searches_enquiries_aggregate?: InputMaybe<InsertListingPropertySearchesEnquiriesAggregateBoolExp>;
  property_searches_places?: InputMaybe<InsertListingPropertySearchesPlacesBoolExp>;
  property_searches_places_aggregate?: InputMaybe<InsertListingPropertySearchesPlacesAggregateBoolExp>;
  property_status?: InputMaybe<InsertListingStringArrayComparisonExp>;
  property_types?: InputMaybe<InsertListingPropertySearchesPropertyTypesBoolExp>;
  property_types_aggregate?: InputMaybe<InsertListingPropertySearchesPropertyTypesAggregateBoolExp>;
  property_usage?: InputMaybe<InsertListingStringComparisonExp>;
  rental_return_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  rental_return_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  sale_price_gte?: InputMaybe<InsertListingIntComparisonExp>;
  sale_price_lte?: InputMaybe<InsertListingIntComparisonExp>;
  sale_price_per_land_surface_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  sale_price_per_land_surface_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  sale_price_per_living_surface_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  sale_price_per_living_surface_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  sale_vs_estimated_price_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  sale_vs_estimated_price_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  session_id?: InputMaybe<InsertListingStringComparisonExp>;
  source?: InputMaybe<InsertListingPropertySearchSourceEnumComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  title?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingPropertySearchesConstraint {
  /** unique or primary key constraint on columns "id" */
  PropertySearchesTmpPkey = 'property_searches_tmp_pkey'
}

export type InsertListingPropertySearchesEnquiriesAggregateBoolExp = {
  count?: InputMaybe<InsertListingPropertySearchesEnquiriesAggregateBoolExpCount>;
};

export type InsertListingPropertySearchesEnquiriesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPropertySearchesEnquiriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesEnquiriesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPropertySearchesEnquiriesArrRelInsertInput = {
  data: Array<InsertListingPropertySearchesEnquiriesInsertInput>;
  on_conflict?: InputMaybe<InsertListingPropertySearchesEnquiriesOnConflict>;
};

export type InsertListingPropertySearchesEnquiriesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertySearchesEnquiriesBoolExp>>;
  _not?: InputMaybe<InsertListingPropertySearchesEnquiriesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertySearchesEnquiriesBoolExp>>;
  enquiry?: InputMaybe<InsertListingEnquiriesBoolExp>;
  enquiry_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_search?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  property_search_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingPropertySearchesEnquiriesConstraint {
  /** unique or primary key constraint on columns "property_search_id", "enquiry_id" */
  PropertySearchesInquiriesPkey = 'property_searches_inquiries_pkey'
}

export type InsertListingPropertySearchesEnquiriesInsertInput = {
  enquiry?: InputMaybe<InsertListingEnquiriesObjRelInsertInput>;
  enquiry_id?: InputMaybe<Scalars['uuid']['input']>;
  property_search?: InputMaybe<InsertListingPropertySearchesObjRelInsertInput>;
  property_search_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingPropertySearchesEnquiriesOnConflict = {
  constraint: InsertListingPropertySearchesEnquiriesConstraint;
  update_columns: Array<InsertListingPropertySearchesEnquiriesUpdateColumn>;
  where?: InputMaybe<InsertListingPropertySearchesEnquiriesBoolExp>;
};

export enum InsertListingPropertySearchesEnquiriesSelectColumn {
  /** column name */
  EnquiryId = 'enquiry_id',
  /** column name */
  PropertySearchId = 'property_search_id'
}

export enum InsertListingPropertySearchesEnquiriesUpdateColumn {
  /** column name */
  EnquiryId = 'enquiry_id',
  /** column name */
  PropertySearchId = 'property_search_id'
}

export type InsertListingPropertySearchesInsertInput = {
  activate_aggregator?: InputMaybe<Scalars['Boolean']['input']>;
  agency_reference_contains?: InputMaybe<Scalars['String']['input']>;
  aggregator_source?: InputMaybe<InsertListingPropertySearchAggregatorSourceEnum>;
  awaiting_alert_handle?: InputMaybe<Scalars['Boolean']['input']>;
  balcony_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  book_online?: InputMaybe<Scalars['Boolean']['input']>;
  built_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  built_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  composite_property_type_eq?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at_gte?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  garden_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  geog?: InputMaybe<Scalars['geography']['input']>;
  gross_rent_m2_yearly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_m2_yearly_lte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_lte?: InputMaybe<Scalars['Float']['input']>;
  has_balcony?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_garage?: InputMaybe<Scalars['Boolean']['input']>;
  has_garden?: InputMaybe<Scalars['Boolean']['input']>;
  has_lift?: InputMaybe<Scalars['Boolean']['input']>;
  has_parking?: InputMaybe<Scalars['Boolean']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_fsbo?: InputMaybe<Scalars['Boolean']['input']>;
  is_furnished?: InputMaybe<Scalars['Boolean']['input']>;
  is_minergie_certified?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_development?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  last_alert_handle?: InputMaybe<Scalars['timestamptz']['input']>;
  last_notified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_viewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  monthly_rent_gte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_lte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Scalars['Float']['input']>;
  notification?: InputMaybe<Scalars['property_searches_notification']['input']>;
  number_of_bathrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bathrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms_gte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_lte?: InputMaybe<Scalars['Float']['input']>;
  offer_type?: InputMaybe<Scalars['String']['input']>;
  portal_in?: InputMaybe<Array<Scalars['String']['input']>>;
  property_main_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  property_main_type_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  property_searches_enquiries?: InputMaybe<InsertListingPropertySearchesEnquiriesArrRelInsertInput>;
  property_searches_places?: InputMaybe<InsertListingPropertySearchesPlacesArrRelInsertInput>;
  property_statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  property_types?: InputMaybe<InsertListingPropertySearchesPropertyTypesArrRelInsertInput>;
  property_usage?: InputMaybe<Scalars['String']['input']>;
  rental_return_gte?: InputMaybe<Scalars['Float']['input']>;
  rental_return_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_gte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_lte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_per_land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_lte?: InputMaybe<Scalars['Float']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<InsertListingPropertySearchSourceEnum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingPropertySearchesNotificationComparisonExp = {
  _eq?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _gt?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _gte?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _in?: InputMaybe<Array<Scalars['property_searches_notification']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _lte?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _neq?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _nin?: InputMaybe<Array<Scalars['property_searches_notification']['input']>>;
};

export type InsertListingPropertySearchesObjRelInsertInput = {
  data: InsertListingPropertySearchesInsertInput;
  on_conflict?: InputMaybe<InsertListingPropertySearchesOnConflict>;
};

export type InsertListingPropertySearchesOnConflict = {
  constraint: InsertListingPropertySearchesConstraint;
  update_columns: Array<InsertListingPropertySearchesUpdateColumn>;
  where?: InputMaybe<InsertListingPropertySearchesBoolExp>;
};

export type InsertListingPropertySearchesPlacesAggregateBoolExp = {
  count?: InputMaybe<InsertListingPropertySearchesPlacesAggregateBoolExpCount>;
};

export type InsertListingPropertySearchesPlacesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPropertySearchesPlacesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesPlacesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPropertySearchesPlacesArrRelInsertInput = {
  data: Array<InsertListingPropertySearchesPlacesInsertInput>;
  on_conflict?: InputMaybe<InsertListingPropertySearchesPlacesOnConflict>;
};

export type InsertListingPropertySearchesPlacesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertySearchesPlacesBoolExp>>;
  _not?: InputMaybe<InsertListingPropertySearchesPlacesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertySearchesPlacesBoolExp>>;
  place?: InputMaybe<InsertListingPlacesBoolExp>;
  place_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_search?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  property_search_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingPropertySearchesPlacesConstraint {
  /** unique or primary key constraint on columns "property_search_id", "place_id" */
  PropertySearchesPlacesPkey = 'property_searches_places_pkey'
}

export type InsertListingPropertySearchesPlacesInsertInput = {
  place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  property_search?: InputMaybe<InsertListingPropertySearchesObjRelInsertInput>;
  property_search_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingPropertySearchesPlacesOnConflict = {
  constraint: InsertListingPropertySearchesPlacesConstraint;
  update_columns: Array<InsertListingPropertySearchesPlacesUpdateColumn>;
  where?: InputMaybe<InsertListingPropertySearchesPlacesBoolExp>;
};

export enum InsertListingPropertySearchesPlacesSelectColumn {
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PropertySearchId = 'property_search_id'
}

export enum InsertListingPropertySearchesPlacesUpdateColumn {
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PropertySearchId = 'property_search_id'
}

export type InsertListingPropertySearchesPropertyTypesAggregateBoolExp = {
  count?: InputMaybe<InsertListingPropertySearchesPropertyTypesAggregateBoolExpCount>;
};

export type InsertListingPropertySearchesPropertyTypesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPropertySearchesPropertyTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesPropertyTypesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPropertySearchesPropertyTypesArrRelInsertInput = {
  data: Array<InsertListingPropertySearchesPropertyTypesInsertInput>;
  on_conflict?: InputMaybe<InsertListingPropertySearchesPropertyTypesOnConflict>;
};

export type InsertListingPropertySearchesPropertyTypesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertySearchesPropertyTypesBoolExp>>;
  _not?: InputMaybe<InsertListingPropertySearchesPropertyTypesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertySearchesPropertyTypesBoolExp>>;
  property_search?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  property_search_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_type?: InputMaybe<InsertListingPropertyTypesBoolExp>;
  property_type_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingPropertySearchesPropertyTypesConstraint {
  /** unique or primary key constraint on columns "property_type_id", "property_search_id" */
  PropertySearchesPropertyTypesPropertySearchIdPropertyTy = 'property_searches_property_types_property_search_id_property_ty'
}

export type InsertListingPropertySearchesPropertyTypesInsertInput = {
  property_search?: InputMaybe<InsertListingPropertySearchesObjRelInsertInput>;
  property_search_id?: InputMaybe<Scalars['uuid']['input']>;
  property_type?: InputMaybe<InsertListingPropertyTypesObjRelInsertInput>;
  property_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingPropertySearchesPropertyTypesOnConflict = {
  constraint: InsertListingPropertySearchesPropertyTypesConstraint;
  update_columns: Array<InsertListingPropertySearchesPropertyTypesUpdateColumn>;
  where?: InputMaybe<InsertListingPropertySearchesPropertyTypesBoolExp>;
};

export enum InsertListingPropertySearchesPropertyTypesSelectColumn {
  /** column name */
  PropertySearchId = 'property_search_id',
  /** column name */
  PropertyTypeId = 'property_type_id'
}

export enum InsertListingPropertySearchesPropertyTypesUpdateColumn {
  /** column name */
  PropertySearchId = 'property_search_id',
  /** column name */
  PropertyTypeId = 'property_type_id'
}

export enum InsertListingPropertySearchesSelectColumn {
  /** column name */
  ActivateAggregator = 'activate_aggregator',
  /** column name */
  AgencyReferenceContains = 'agency_reference_contains',
  /** column name */
  AggregatorSource = 'aggregator_source',
  /** column name */
  AwaitingAlertHandle = 'awaiting_alert_handle',
  /** column name */
  BalconySurfaceGte = 'balcony_surface_gte',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurfaceGte = 'built_surface_gte',
  /** column name */
  BuiltSurfaceLte = 'built_surface_lte',
  /** column name */
  Comment = 'comment',
  /** column name */
  CompositePropertyTypeEq = 'composite_property_type_eq',
  /** column name */
  ComputedBudgetGte = 'computed_budget_gte',
  /** column name */
  ComputedBudgetLte = 'computed_budget_lte',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedAtGte = 'created_at_gte',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  GardenSurfaceGte = 'garden_surface_gte',
  /** column name */
  Geog = 'geog',
  /** column name */
  GrossRentM2YearlyGte = 'gross_rent_m2_yearly_gte',
  /** column name */
  GrossRentM2YearlyLte = 'gross_rent_m2_yearly_lte',
  /** column name */
  GrossRentRoomMonthlyGte = 'gross_rent_room_monthly_gte',
  /** column name */
  GrossRentRoomMonthlyLte = 'gross_rent_room_monthly_lte',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasLift = 'has_lift',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  LandSurfaceGte = 'land_surface_gte',
  /** column name */
  LandSurfaceLte = 'land_surface_lte',
  /** column name */
  LastAlertHandle = 'last_alert_handle',
  /** column name */
  LastNotifiedAt = 'last_notified_at',
  /** column name */
  LastViewedAt = 'last_viewed_at',
  /** column name */
  LivingSurfaceGte = 'living_surface_gte',
  /** column name */
  LivingSurfaceLte = 'living_surface_lte',
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  MonthlyRentGte = 'monthly_rent_gte',
  /** column name */
  MonthlyRentLte = 'monthly_rent_lte',
  /** column name */
  MonthlyRentVsEstimatedRentGte = 'monthly_rent_vs_estimated_rent_gte',
  /** column name */
  MonthlyRentVsEstimatedRentLte = 'monthly_rent_vs_estimated_rent_lte',
  /** column name */
  Notification = 'notification',
  /** column name */
  NumberOfBathroomsGte = 'number_of_bathrooms_gte',
  /** column name */
  NumberOfBathroomsLte = 'number_of_bathrooms_lte',
  /** column name */
  NumberOfBedroomsGte = 'number_of_bedrooms_gte',
  /** column name */
  NumberOfBedroomsLte = 'number_of_bedrooms_lte',
  /** column name */
  NumberOfIndoorParkingsGte = 'number_of_indoor_parkings_gte',
  /** column name */
  NumberOfOutdoorParkingsGte = 'number_of_outdoor_parkings_gte',
  /** column name */
  NumberOfRoomsGte = 'number_of_rooms_gte',
  /** column name */
  NumberOfRoomsLte = 'number_of_rooms_lte',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  PortalIn = 'portal_in',
  /** column name */
  PropertyMainTypeIn = 'property_main_type_in',
  /** column name */
  PropertyMainTypeNin = 'property_main_type_nin',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  PropertyUsage = 'property_usage',
  /** column name */
  RentalReturnGte = 'rental_return_gte',
  /** column name */
  RentalReturnLte = 'rental_return_lte',
  /** column name */
  SalePriceGte = 'sale_price_gte',
  /** column name */
  SalePriceLte = 'sale_price_lte',
  /** column name */
  SalePricePerLandSurfaceGte = 'sale_price_per_land_surface_gte',
  /** column name */
  SalePricePerLandSurfaceLte = 'sale_price_per_land_surface_lte',
  /** column name */
  SalePricePerLivingSurfaceGte = 'sale_price_per_living_surface_gte',
  /** column name */
  SalePricePerLivingSurfaceLte = 'sale_price_per_living_surface_lte',
  /** column name */
  SaleVsEstimatedPriceGte = 'sale_vs_estimated_price_gte',
  /** column name */
  SaleVsEstimatedPriceLte = 'sale_vs_estimated_price_lte',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Source = 'source',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  MaxDistance = 'max_distance'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ActivateAggregator = 'activate_aggregator',
  /** column name */
  AwaitingAlertHandle = 'awaiting_alert_handle',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasLift = 'has_lift',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ActivateAggregator = 'activate_aggregator',
  /** column name */
  AwaitingAlertHandle = 'awaiting_alert_handle',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasLift = 'has_lift',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  MaxDistance = 'max_distance'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  MaxDistance = 'max_distance'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  MaxDistance = 'max_distance'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpMinArgumentsColumns {
  /** column name */
  MaxDistance = 'max_distance'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  MaxDistance = 'max_distance'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpSumArgumentsColumns {
  /** column name */
  MaxDistance = 'max_distance'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  MaxDistance = 'max_distance'
}

export enum InsertListingPropertySearchesUpdateColumn {
  /** column name */
  ActivateAggregator = 'activate_aggregator',
  /** column name */
  AgencyReferenceContains = 'agency_reference_contains',
  /** column name */
  AggregatorSource = 'aggregator_source',
  /** column name */
  AwaitingAlertHandle = 'awaiting_alert_handle',
  /** column name */
  BalconySurfaceGte = 'balcony_surface_gte',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurfaceGte = 'built_surface_gte',
  /** column name */
  BuiltSurfaceLte = 'built_surface_lte',
  /** column name */
  Comment = 'comment',
  /** column name */
  CompositePropertyTypeEq = 'composite_property_type_eq',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedAtGte = 'created_at_gte',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  GardenSurfaceGte = 'garden_surface_gte',
  /** column name */
  Geog = 'geog',
  /** column name */
  GrossRentM2YearlyGte = 'gross_rent_m2_yearly_gte',
  /** column name */
  GrossRentM2YearlyLte = 'gross_rent_m2_yearly_lte',
  /** column name */
  GrossRentRoomMonthlyGte = 'gross_rent_room_monthly_gte',
  /** column name */
  GrossRentRoomMonthlyLte = 'gross_rent_room_monthly_lte',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasLift = 'has_lift',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  LandSurfaceGte = 'land_surface_gte',
  /** column name */
  LandSurfaceLte = 'land_surface_lte',
  /** column name */
  LastAlertHandle = 'last_alert_handle',
  /** column name */
  LastNotifiedAt = 'last_notified_at',
  /** column name */
  LastViewedAt = 'last_viewed_at',
  /** column name */
  LivingSurfaceGte = 'living_surface_gte',
  /** column name */
  LivingSurfaceLte = 'living_surface_lte',
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  MonthlyRentGte = 'monthly_rent_gte',
  /** column name */
  MonthlyRentLte = 'monthly_rent_lte',
  /** column name */
  MonthlyRentVsEstimatedRentGte = 'monthly_rent_vs_estimated_rent_gte',
  /** column name */
  MonthlyRentVsEstimatedRentLte = 'monthly_rent_vs_estimated_rent_lte',
  /** column name */
  Notification = 'notification',
  /** column name */
  NumberOfBathroomsGte = 'number_of_bathrooms_gte',
  /** column name */
  NumberOfBathroomsLte = 'number_of_bathrooms_lte',
  /** column name */
  NumberOfBedroomsGte = 'number_of_bedrooms_gte',
  /** column name */
  NumberOfBedroomsLte = 'number_of_bedrooms_lte',
  /** column name */
  NumberOfIndoorParkingsGte = 'number_of_indoor_parkings_gte',
  /** column name */
  NumberOfOutdoorParkingsGte = 'number_of_outdoor_parkings_gte',
  /** column name */
  NumberOfRoomsGte = 'number_of_rooms_gte',
  /** column name */
  NumberOfRoomsLte = 'number_of_rooms_lte',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  PortalIn = 'portal_in',
  /** column name */
  PropertyMainTypeIn = 'property_main_type_in',
  /** column name */
  PropertyMainTypeNin = 'property_main_type_nin',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  PropertyUsage = 'property_usage',
  /** column name */
  RentalReturnGte = 'rental_return_gte',
  /** column name */
  RentalReturnLte = 'rental_return_lte',
  /** column name */
  SalePriceGte = 'sale_price_gte',
  /** column name */
  SalePriceLte = 'sale_price_lte',
  /** column name */
  SalePricePerLandSurfaceGte = 'sale_price_per_land_surface_gte',
  /** column name */
  SalePricePerLandSurfaceLte = 'sale_price_per_land_surface_lte',
  /** column name */
  SalePricePerLivingSurfaceGte = 'sale_price_per_living_surface_gte',
  /** column name */
  SalePricePerLivingSurfaceLte = 'sale_price_per_living_surface_lte',
  /** column name */
  SaleVsEstimatedPriceGte = 'sale_vs_estimated_price_gte',
  /** column name */
  SaleVsEstimatedPriceLte = 'sale_vs_estimated_price_lte',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Source = 'source',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingPropertySideEnumEnum {
  Exterior = 'exterior',
  Interior = 'interior'
}

export type InsertListingPropertySideEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingPropertySideEnumEnum>;
  _in?: InputMaybe<Array<InsertListingPropertySideEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingPropertySideEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingPropertySideEnumEnum>>;
};

export type InsertListingPropertyTransactionsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingPropertyTransactionsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingPropertyTransactionsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingPropertyTransactionsAggregateBoolExpCount>;
};

export type InsertListingPropertyTransactionsAggregateBoolExpBoolAnd = {
  arguments: InsertListingPropertyTransactionsSelectColumnPropertyTransactionsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertyTransactionsAggregateBoolExpBoolOr = {
  arguments: InsertListingPropertyTransactionsSelectColumnPropertyTransactionsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertyTransactionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPropertyTransactionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPropertyTransactionsArrRelInsertInput = {
  data: Array<InsertListingPropertyTransactionsInsertInput>;
  on_conflict?: InputMaybe<InsertListingPropertyTransactionsOnConflict>;
};

export type InsertListingPropertyTransactionsBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertyTransactionsBoolExp>>;
  _not?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertyTransactionsBoolExp>>;
  buyer_broker?: InputMaybe<InsertListingUsersBoolExp>;
  buyer_broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  buyer_broker_team?: InputMaybe<InsertListingTeamsBoolExp>;
  buyer_broker_team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  buyers?: InputMaybe<InsertListingTransactionBuyersBoolExp>;
  buyers_aggregate?: InputMaybe<InsertListingTransactionBuyersAggregateBoolExp>;
  commissions?: InputMaybe<InsertListingCommissionsBoolExp>;
  commissions_aggregate?: InputMaybe<InsertListingCommissionsAggregateBoolExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  creator?: InputMaybe<InsertListingUsersBoolExp>;
  crm_link?: InputMaybe<InsertListingStringComparisonExp>;
  estimated_signature_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_published?: InputMaybe<InsertListingBooleanComparisonExp>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  notary_id?: InputMaybe<InsertListingUuidComparisonExp>;
  payment_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  property?: InputMaybe<InsertListingPropertiesBoolExp>;
  property_id?: InputMaybe<InsertListingUuidComparisonExp>;
  purchase_price?: InputMaybe<InsertListingFloatComparisonExp>;
  seller_broker?: InputMaybe<InsertListingUsersBoolExp>;
  seller_broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  seller_broker_team?: InputMaybe<InsertListingTeamsBoolExp>;
  seller_broker_team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  sellers?: InputMaybe<InsertListingTransactionSellersBoolExp>;
  sellers_aggregate?: InputMaybe<InsertListingTransactionSellersAggregateBoolExp>;
  signature_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingPropertyTransactionsConstraint {
  /** unique or primary key constraint on columns "id" */
  PropertyTransactionsPkey = 'property_transactions_pkey'
}

export type InsertListingPropertyTransactionsInsertInput = {
  buyer_broker?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  buyer_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_broker_team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  buyer_broker_team_id?: InputMaybe<Scalars['uuid']['input']>;
  buyers?: InputMaybe<InsertListingTransactionBuyersArrRelInsertInput>;
  commissions?: InputMaybe<InsertListingCommissionsArrRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  creator?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  estimated_signature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  notary_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  property?: InputMaybe<InsertListingPropertiesObjRelInsertInput>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  purchase_price?: InputMaybe<Scalars['Float']['input']>;
  seller_broker?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  seller_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  seller_broker_team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  seller_broker_team_id?: InputMaybe<Scalars['uuid']['input']>;
  sellers?: InputMaybe<InsertListingTransactionSellersArrRelInsertInput>;
  signature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingPropertyTransactionsObjRelInsertInput = {
  data: InsertListingPropertyTransactionsInsertInput;
  on_conflict?: InputMaybe<InsertListingPropertyTransactionsOnConflict>;
};

export type InsertListingPropertyTransactionsOnConflict = {
  constraint: InsertListingPropertyTransactionsConstraint;
  update_columns: Array<InsertListingPropertyTransactionsUpdateColumn>;
  where?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
};

export enum InsertListingPropertyTransactionsSelectColumn {
  /** column name */
  BuyerBrokerId = 'buyer_broker_id',
  /** column name */
  BuyerBrokerTeamId = 'buyer_broker_team_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  EstimatedSignatureDate = 'estimated_signature_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  NotaryId = 'notary_id',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  SellerBrokerId = 'seller_broker_id',
  /** column name */
  SellerBrokerTeamId = 'seller_broker_team_id',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingPropertyTransactionsSelectColumnPropertyTransactionsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsPublished = 'is_published'
}

export enum InsertListingPropertyTransactionsSelectColumnPropertyTransactionsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsPublished = 'is_published'
}

export enum InsertListingPropertyTransactionsUpdateColumn {
  /** column name */
  BuyerBrokerId = 'buyer_broker_id',
  /** column name */
  BuyerBrokerTeamId = 'buyer_broker_team_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  EstimatedSignatureDate = 'estimated_signature_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  NotaryId = 'notary_id',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  SellerBrokerId = 'seller_broker_id',
  /** column name */
  SellerBrokerTeamId = 'seller_broker_team_id',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingPropertyTypesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertyTypesBoolExp>>;
  _not?: InputMaybe<InsertListingPropertyTypesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertyTypesBoolExp>>;
  appraisal_type?: InputMaybe<InsertListingStringComparisonExp>;
  composite_type?: InputMaybe<InsertListingStringComparisonExp>;
  composite_type_object?: InputMaybe<InsertListingPropertyTypesBoolExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  idx_type_id?: InputMaybe<InsertListingIntComparisonExp>;
  is_visible?: InputMaybe<InsertListingBooleanComparisonExp>;
  label?: InputMaybe<InsertListingStringComparisonExp>;
  label_de?: InputMaybe<InsertListingStringComparisonExp>;
  label_en?: InputMaybe<InsertListingStringComparisonExp>;
  label_es?: InputMaybe<InsertListingStringComparisonExp>;
  label_fr?: InputMaybe<InsertListingStringComparisonExp>;
  label_it?: InputMaybe<InsertListingStringComparisonExp>;
  main_type?: InputMaybe<InsertListingStringComparisonExp>;
  main_type_object?: InputMaybe<InsertListingPropertyTypesBoolExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  parent_type?: InputMaybe<InsertListingPropertyTypesBoolExp>;
  pricehubble_subcode?: InputMaybe<InsertListingStringComparisonExp>;
  type?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingPropertyTypesConstraint {
  /** unique or primary key constraint on columns "name" */
  PropertyTypesNameUnique = 'property_types_name_unique',
  /** unique or primary key constraint on columns "id" */
  PropertyTypesPkey = 'property_types_pkey'
}

export type InsertListingPropertyTypesInsertInput = {
  appraisal_type?: InputMaybe<Scalars['String']['input']>;
  composite_type?: InputMaybe<Scalars['String']['input']>;
  composite_type_object?: InputMaybe<InsertListingPropertyTypesObjRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_type_id?: InputMaybe<Scalars['Int']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  main_type?: InputMaybe<Scalars['String']['input']>;
  main_type_object?: InputMaybe<InsertListingPropertyTypesObjRelInsertInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  parent_type?: InputMaybe<InsertListingPropertyTypesObjRelInsertInput>;
  pricehubble_subcode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingPropertyTypesObjRelInsertInput = {
  data: InsertListingPropertyTypesInsertInput;
  on_conflict?: InputMaybe<InsertListingPropertyTypesOnConflict>;
};

export type InsertListingPropertyTypesOnConflict = {
  constraint: InsertListingPropertyTypesConstraint;
  update_columns: Array<InsertListingPropertyTypesUpdateColumn>;
  where?: InputMaybe<InsertListingPropertyTypesBoolExp>;
};

export enum InsertListingPropertyTypesUpdateColumn {
  /** column name */
  AppraisalType = 'appraisal_type',
  /** column name */
  CompositeType = 'composite_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdxTypeId = 'idx_type_id',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  MainType = 'main_type',
  /** column name */
  Name = 'name',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PricehubbleSubcode = 'pricehubble_subcode',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingPushNotificationTokensAggregateBoolExp = {
  count?: InputMaybe<InsertListingPushNotificationTokensAggregateBoolExpCount>;
};

export type InsertListingPushNotificationTokensAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPushNotificationTokensSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPushNotificationTokensBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPushNotificationTokensArrRelInsertInput = {
  data: Array<InsertListingPushNotificationTokensInsertInput>;
  on_conflict?: InputMaybe<InsertListingPushNotificationTokensOnConflict>;
};

export type InsertListingPushNotificationTokensBoolExp = {
  _and?: InputMaybe<Array<InsertListingPushNotificationTokensBoolExp>>;
  _not?: InputMaybe<InsertListingPushNotificationTokensBoolExp>;
  _or?: InputMaybe<Array<InsertListingPushNotificationTokensBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  token?: InputMaybe<InsertListingStringComparisonExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingPushNotificationTokensConstraint {
  /** unique or primary key constraint on columns "id" */
  PushNotificationTokensPkey = 'push_notification_tokens_pkey'
}

export type InsertListingPushNotificationTokensInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingPushNotificationTokensOnConflict = {
  constraint: InsertListingPushNotificationTokensConstraint;
  update_columns: Array<InsertListingPushNotificationTokensUpdateColumn>;
  where?: InputMaybe<InsertListingPushNotificationTokensBoolExp>;
};

export enum InsertListingPushNotificationTokensSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Token = 'token',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingPushNotificationTokensUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Token = 'token',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingReadOnlyTenantsBoolExp = {
  _and?: InputMaybe<Array<InsertListingReadOnlyTenantsBoolExp>>;
  _not?: InputMaybe<InsertListingReadOnlyTenantsBoolExp>;
  _or?: InputMaybe<Array<InsertListingReadOnlyTenantsBoolExp>>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
};

export type InsertListingReadOnlyTenantsInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingReadOnlyTenantsObjRelInsertInput = {
  data: InsertListingReadOnlyTenantsInsertInput;
};

export type InsertListingReviewsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingReviewsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingReviewsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingReviewsAggregateBoolExpCount>;
};

export type InsertListingReviewsAggregateBoolExpBoolAnd = {
  arguments: InsertListingReviewsSelectColumnReviewsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingReviewsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingReviewsAggregateBoolExpBoolOr = {
  arguments: InsertListingReviewsSelectColumnReviewsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingReviewsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingReviewsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingReviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingReviewsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingReviewsArrRelInsertInput = {
  data: Array<InsertListingReviewsInsertInput>;
  on_conflict?: InputMaybe<InsertListingReviewsOnConflict>;
};

export type InsertListingReviewsBoolExp = {
  _and?: InputMaybe<Array<InsertListingReviewsBoolExp>>;
  _not?: InputMaybe<InsertListingReviewsBoolExp>;
  _or?: InputMaybe<Array<InsertListingReviewsBoolExp>>;
  completed?: InputMaybe<InsertListingBooleanComparisonExp>;
  completed_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  display_name?: InputMaybe<InsertListingStringComparisonExp>;
  email_address?: InputMaybe<InsertListingStringComparisonExp>;
  first_name?: InputMaybe<InsertListingStringComparisonExp>;
  formatted_address?: InputMaybe<InsertListingStringComparisonExp>;
  google_address?: InputMaybe<InsertListingGoogleAddressesBoolExp>;
  google_address_id?: InputMaybe<InsertListingUuidComparisonExp>;
  has_accepted_terms?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_buyer?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_seller?: InputMaybe<InsertListingBooleanComparisonExp>;
  language?: InputMaybe<InsertListingStringComparisonExp>;
  last_name?: InputMaybe<InsertListingStringComparisonExp>;
  neverbounce_result?: InputMaybe<InsertListingStringComparisonExp>;
  organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  rating?: InputMaybe<InsertListingIntComparisonExp>;
  review_text?: InputMaybe<InsertListingStringComparisonExp>;
  review_url?: InputMaybe<InsertListingStringComparisonExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  transaction_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingReviewsConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  ReviewsIdTenantIdUnique = 'reviews_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  ReviewsPkey = 'reviews_pkey'
}

export type InsertListingReviewsInsertInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  google_address?: InputMaybe<InsertListingGoogleAddressesObjRelInsertInput>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  has_accepted_terms?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_buyer?: InputMaybe<Scalars['Boolean']['input']>;
  is_seller?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  neverbounce_result?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_text?: InputMaybe<Scalars['String']['input']>;
  review_url?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  transaction_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingReviewsOnConflict = {
  constraint: InsertListingReviewsConstraint;
  update_columns: Array<InsertListingReviewsUpdateColumn>;
  where?: InputMaybe<InsertListingReviewsBoolExp>;
};

export enum InsertListingReviewsSelectColumn {
  /** column name */
  Completed = 'completed',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  Id = 'id',
  /** column name */
  IsBuyer = 'is_buyer',
  /** column name */
  IsSeller = 'is_seller',
  /** column name */
  Language = 'language',
  /** column name */
  LastName = 'last_name',
  /** column name */
  NeverbounceResult = 'neverbounce_result',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewText = 'review_text',
  /** column name */
  ReviewUrl = 'review_url',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TransactionDate = 'transaction_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingReviewsSelectColumnReviewsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Completed = 'completed',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  IsBuyer = 'is_buyer',
  /** column name */
  IsSeller = 'is_seller'
}

export enum InsertListingReviewsSelectColumnReviewsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Completed = 'completed',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  IsBuyer = 'is_buyer',
  /** column name */
  IsSeller = 'is_seller'
}

export enum InsertListingReviewsUpdateColumn {
  /** column name */
  Completed = 'completed',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  Id = 'id',
  /** column name */
  IsBuyer = 'is_buyer',
  /** column name */
  IsSeller = 'is_seller',
  /** column name */
  LastName = 'last_name',
  /** column name */
  NeverbounceResult = 'neverbounce_result',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewText = 'review_text',
  /** column name */
  ReviewUrl = 'review_url',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TransactionDate = 'transaction_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingSharedPortalsBoolExp = {
  _and?: InputMaybe<Array<InsertListingSharedPortalsBoolExp>>;
  _not?: InputMaybe<InsertListingSharedPortalsBoolExp>;
  _or?: InputMaybe<Array<InsertListingSharedPortalsBoolExp>>;
  active?: InputMaybe<InsertListingBooleanComparisonExp>;
  contract_id?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  email?: InputMaybe<InsertListingStringComparisonExp>;
  exact_address_required?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_top_premium_listing?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  idx_protocol?: InputMaybe<InsertListingPortalIdxProtocolComparisonExp>;
  logo_image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  password?: InputMaybe<InsertListingStringComparisonExp>;
  port?: InputMaybe<InsertListingIntComparisonExp>;
  quota?: InputMaybe<InsertListingIntComparisonExp>;
  type?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  url?: InputMaybe<InsertListingStringComparisonExp>;
  username?: InputMaybe<InsertListingStringComparisonExp>;
  website_url?: InputMaybe<InsertListingStringComparisonExp>;
};

export type InsertListingSharedPortalsInsertInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contract_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exact_address_required?: InputMaybe<Scalars['Boolean']['input']>;
  has_top_premium_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_protocol?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  quota?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingSharedPortalsObjRelInsertInput = {
  data: InsertListingSharedPortalsInsertInput;
};

export type InsertListingSmallintComparisonExp = {
  _eq?: InputMaybe<Scalars['smallint']['input']>;
  _gt?: InputMaybe<Scalars['smallint']['input']>;
  _gte?: InputMaybe<Scalars['smallint']['input']>;
  _in?: InputMaybe<Array<Scalars['smallint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['smallint']['input']>;
  _lte?: InputMaybe<Scalars['smallint']['input']>;
  _neq?: InputMaybe<Scalars['smallint']['input']>;
  _nin?: InputMaybe<Array<Scalars['smallint']['input']>>;
};

export type InsertListingStDWithinGeographyInput = {
  distance: Scalars['Float']['input'];
  from: Scalars['geography']['input'];
  use_spheroid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsertListingStDWithinInput = {
  distance: Scalars['Float']['input'];
  from: Scalars['geometry']['input'];
};

export type InsertListingStringArrayComparisonExp = {
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

export type InsertListingStringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  _niregex?: InputMaybe<Scalars['String']['input']>;
  _nlike?: InputMaybe<Scalars['String']['input']>;
  _nregex?: InputMaybe<Scalars['String']['input']>;
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  _regex?: InputMaybe<Scalars['String']['input']>;
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingSubscriptionStatusComparisonExp = {
  _eq?: InputMaybe<Scalars['subscription_status']['input']>;
  _gt?: InputMaybe<Scalars['subscription_status']['input']>;
  _gte?: InputMaybe<Scalars['subscription_status']['input']>;
  _in?: InputMaybe<Array<Scalars['subscription_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['subscription_status']['input']>;
  _lte?: InputMaybe<Scalars['subscription_status']['input']>;
  _neq?: InputMaybe<Scalars['subscription_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['subscription_status']['input']>>;
};

export type InsertListingSubscriptionsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingSubscriptionsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingSubscriptionsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingSubscriptionsAggregateBoolExpCount>;
};

export type InsertListingSubscriptionsAggregateBoolExpBoolAnd = {
  arguments: InsertListingSubscriptionsSelectColumnSubscriptionsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingSubscriptionsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingSubscriptionsAggregateBoolExpBoolOr = {
  arguments: InsertListingSubscriptionsSelectColumnSubscriptionsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingSubscriptionsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingSubscriptionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingSubscriptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingSubscriptionsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingSubscriptionsArrRelInsertInput = {
  data: Array<InsertListingSubscriptionsInsertInput>;
  on_conflict?: InputMaybe<InsertListingSubscriptionsOnConflict>;
};

export type InsertListingSubscriptionsBoolExp = {
  _and?: InputMaybe<Array<InsertListingSubscriptionsBoolExp>>;
  _not?: InputMaybe<InsertListingSubscriptionsBoolExp>;
  _or?: InputMaybe<Array<InsertListingSubscriptionsBoolExp>>;
  application_fee_percent?: InputMaybe<InsertListingFloatComparisonExp>;
  billing_cycle_anchor?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  billing_thresholds?: InputMaybe<InsertListingJsonbComparisonExp>;
  cancel_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  cancel_at_period_end?: InputMaybe<InsertListingBooleanComparisonExp>;
  canceled_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  collection_method?: InputMaybe<InsertListingStringComparisonExp>;
  created?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  current_period_end?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  current_period_start?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  customer?: InputMaybe<InsertListingStringComparisonExp>;
  customer_email?: InputMaybe<InsertListingStringComparisonExp>;
  customer_name?: InputMaybe<InsertListingStringComparisonExp>;
  customer_object?: InputMaybe<InsertListingJsonbComparisonExp>;
  days_until_due?: InputMaybe<InsertListingIntComparisonExp>;
  default_payment_method?: InputMaybe<InsertListingStringComparisonExp>;
  default_source?: InputMaybe<InsertListingStringComparisonExp>;
  default_tax_rates?: InputMaybe<InsertListingJsonbComparisonExp>;
  discount?: InputMaybe<InsertListingJsonbComparisonExp>;
  email?: InputMaybe<InsertListingEmailsBoolExp>;
  ended_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  interval_count?: InputMaybe<InsertListingIntComparisonExp>;
  invoices?: InputMaybe<InsertListingInvoicesBoolExp>;
  invoices_aggregate?: InputMaybe<InsertListingInvoicesAggregateBoolExp>;
  items?: InputMaybe<InsertListingJsonbComparisonExp>;
  latest_invoice?: InputMaybe<InsertListingStringComparisonExp>;
  livemode?: InputMaybe<InsertListingBooleanComparisonExp>;
  metadata?: InputMaybe<InsertListingJsonbComparisonExp>;
  next_pending_invoice_item_invoice?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  pause_collection?: InputMaybe<InsertListingJsonbComparisonExp>;
  pending_invoice_item_interval?: InputMaybe<InsertListingJsonbComparisonExp>;
  pending_setup_intent?: InputMaybe<InsertListingStringComparisonExp>;
  pending_update?: InputMaybe<InsertListingJsonbComparisonExp>;
  plan_name?: InputMaybe<InsertListingStringComparisonExp>;
  quantity?: InputMaybe<InsertListingIntComparisonExp>;
  schedule?: InputMaybe<InsertListingStringComparisonExp>;
  start_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  status?: InputMaybe<InsertListingSubscriptionStatusComparisonExp>;
  stripe_id?: InputMaybe<InsertListingStringComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  total_amount?: InputMaybe<InsertListingIntComparisonExp>;
  transfer_data?: InputMaybe<InsertListingJsonbComparisonExp>;
  trial_end?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  trial_start?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingSubscriptionsConstraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionsPkey = 'subscriptions_pkey',
  /** unique or primary key constraint on columns "stripe_id" */
  SubscriptionsStripeIdUnique = 'subscriptions_stripe_id_unique'
}

export type InsertListingSubscriptionsInsertInput = {
  application_fee_percent?: InputMaybe<Scalars['Float']['input']>;
  billing_cycle_anchor?: InputMaybe<Scalars['timestamptz']['input']>;
  billing_thresholds?: InputMaybe<Scalars['jsonb']['input']>;
  cancel_at?: InputMaybe<Scalars['timestamptz']['input']>;
  cancel_at_period_end?: InputMaybe<Scalars['Boolean']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  collection_method?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_period_end?: InputMaybe<Scalars['timestamptz']['input']>;
  current_period_start?: InputMaybe<Scalars['timestamptz']['input']>;
  customer?: InputMaybe<Scalars['String']['input']>;
  customer_email?: InputMaybe<Scalars['String']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  customer_object?: InputMaybe<Scalars['jsonb']['input']>;
  days_until_due?: InputMaybe<Scalars['Int']['input']>;
  default_payment_method?: InputMaybe<Scalars['String']['input']>;
  default_source?: InputMaybe<Scalars['String']['input']>;
  default_tax_rates?: InputMaybe<Scalars['jsonb']['input']>;
  discount?: InputMaybe<Scalars['jsonb']['input']>;
  email?: InputMaybe<InsertListingEmailsObjRelInsertInput>;
  ended_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interval_count?: InputMaybe<Scalars['Int']['input']>;
  invoices?: InputMaybe<InsertListingInvoicesArrRelInsertInput>;
  items?: InputMaybe<Scalars['jsonb']['input']>;
  latest_invoice?: InputMaybe<Scalars['String']['input']>;
  livemode?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  next_pending_invoice_item_invoice?: InputMaybe<Scalars['timestamptz']['input']>;
  pause_collection?: InputMaybe<Scalars['jsonb']['input']>;
  pending_invoice_item_interval?: InputMaybe<Scalars['jsonb']['input']>;
  pending_setup_intent?: InputMaybe<Scalars['String']['input']>;
  pending_update?: InputMaybe<Scalars['jsonb']['input']>;
  plan_name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['subscription_status']['input']>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  total_amount?: InputMaybe<Scalars['Int']['input']>;
  transfer_data?: InputMaybe<Scalars['jsonb']['input']>;
  trial_end?: InputMaybe<Scalars['timestamptz']['input']>;
  trial_start?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingSubscriptionsObjRelInsertInput = {
  data: InsertListingSubscriptionsInsertInput;
  on_conflict?: InputMaybe<InsertListingSubscriptionsOnConflict>;
};

export type InsertListingSubscriptionsOnConflict = {
  constraint: InsertListingSubscriptionsConstraint;
  update_columns: Array<InsertListingSubscriptionsUpdateColumn>;
  where?: InputMaybe<InsertListingSubscriptionsBoolExp>;
};

export enum InsertListingSubscriptionsSelectColumn {
  /** column name */
  ApplicationFeePercent = 'application_fee_percent',
  /** column name */
  BillingCycleAnchor = 'billing_cycle_anchor',
  /** column name */
  BillingThresholds = 'billing_thresholds',
  /** column name */
  CancelAt = 'cancel_at',
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CollectionMethod = 'collection_method',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentPeriodEnd = 'current_period_end',
  /** column name */
  CurrentPeriodStart = 'current_period_start',
  /** column name */
  Customer = 'customer',
  /** column name */
  CustomerEmail = 'customer_email',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  CustomerObject = 'customer_object',
  /** column name */
  DaysUntilDue = 'days_until_due',
  /** column name */
  DefaultPaymentMethod = 'default_payment_method',
  /** column name */
  DefaultSource = 'default_source',
  /** column name */
  DefaultTaxRates = 'default_tax_rates',
  /** column name */
  Discount = 'discount',
  /** column name */
  EndedAt = 'ended_at',
  /** column name */
  Id = 'id',
  /** column name */
  IntervalCount = 'interval_count',
  /** column name */
  Items = 'items',
  /** column name */
  LatestInvoice = 'latest_invoice',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextPendingInvoiceItemInvoice = 'next_pending_invoice_item_invoice',
  /** column name */
  PauseCollection = 'pause_collection',
  /** column name */
  PendingInvoiceItemInterval = 'pending_invoice_item_interval',
  /** column name */
  PendingSetupIntent = 'pending_setup_intent',
  /** column name */
  PendingUpdate = 'pending_update',
  /** column name */
  PlanName = 'plan_name',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Schedule = 'schedule',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  StripeId = 'stripe_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TransferData = 'transfer_data',
  /** column name */
  TrialEnd = 'trial_end',
  /** column name */
  TrialStart = 'trial_start',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingSubscriptionsSelectColumnSubscriptionsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  Livemode = 'livemode'
}

export enum InsertListingSubscriptionsSelectColumnSubscriptionsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  Livemode = 'livemode'
}

export enum InsertListingSubscriptionsUpdateColumn {
  /** column name */
  ApplicationFeePercent = 'application_fee_percent',
  /** column name */
  BillingCycleAnchor = 'billing_cycle_anchor',
  /** column name */
  BillingThresholds = 'billing_thresholds',
  /** column name */
  CancelAt = 'cancel_at',
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CollectionMethod = 'collection_method',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentPeriodEnd = 'current_period_end',
  /** column name */
  CurrentPeriodStart = 'current_period_start',
  /** column name */
  Customer = 'customer',
  /** column name */
  CustomerEmail = 'customer_email',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  CustomerObject = 'customer_object',
  /** column name */
  DaysUntilDue = 'days_until_due',
  /** column name */
  DefaultPaymentMethod = 'default_payment_method',
  /** column name */
  DefaultSource = 'default_source',
  /** column name */
  DefaultTaxRates = 'default_tax_rates',
  /** column name */
  Discount = 'discount',
  /** column name */
  EndedAt = 'ended_at',
  /** column name */
  Id = 'id',
  /** column name */
  IntervalCount = 'interval_count',
  /** column name */
  Items = 'items',
  /** column name */
  LatestInvoice = 'latest_invoice',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextPendingInvoiceItemInvoice = 'next_pending_invoice_item_invoice',
  /** column name */
  PauseCollection = 'pause_collection',
  /** column name */
  PendingInvoiceItemInterval = 'pending_invoice_item_interval',
  /** column name */
  PendingSetupIntent = 'pending_setup_intent',
  /** column name */
  PendingUpdate = 'pending_update',
  /** column name */
  PlanName = 'plan_name',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Schedule = 'schedule',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  StripeId = 'stripe_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TransferData = 'transfer_data',
  /** column name */
  TrialEnd = 'trial_end',
  /** column name */
  TrialStart = 'trial_start',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingTeamImagesAggregateBoolExp = {
  count?: InputMaybe<InsertListingTeamImagesAggregateBoolExpCount>;
};

export type InsertListingTeamImagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingTeamImagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTeamImagesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingTeamImagesArrRelInsertInput = {
  data: Array<InsertListingTeamImagesInsertInput>;
  on_conflict?: InputMaybe<InsertListingTeamImagesOnConflict>;
};

export type InsertListingTeamImagesBoolExp = {
  _and?: InputMaybe<Array<InsertListingTeamImagesBoolExp>>;
  _not?: InputMaybe<InsertListingTeamImagesBoolExp>;
  _or?: InputMaybe<Array<InsertListingTeamImagesBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  image?: InputMaybe<InsertListingImagesBoolExp>;
  image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  team?: InputMaybe<InsertListingTeamsBoolExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingTeamImagesConstraint {
  /** unique or primary key constraint on columns "id" */
  TeamImagesPkey = 'team_images_pkey'
}

export type InsertListingTeamImagesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingTeamImagesOnConflict = {
  constraint: InsertListingTeamImagesConstraint;
  update_columns: Array<InsertListingTeamImagesUpdateColumn>;
  where?: InputMaybe<InsertListingTeamImagesBoolExp>;
};

export enum InsertListingTeamImagesSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingTeamImagesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingTeamsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingTeamsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingTeamsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingTeamsAggregateBoolExpCount>;
};

export type InsertListingTeamsAggregateBoolExpBoolAnd = {
  arguments: InsertListingTeamsSelectColumnTeamsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTeamsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingTeamsAggregateBoolExpBoolOr = {
  arguments: InsertListingTeamsSelectColumnTeamsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTeamsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingTeamsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingTeamsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTeamsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingTeamsArrRelInsertInput = {
  data: Array<InsertListingTeamsInsertInput>;
  on_conflict?: InputMaybe<InsertListingTeamsOnConflict>;
};

export type InsertListingTeamsBoolExp = {
  _and?: InputMaybe<Array<InsertListingTeamsBoolExp>>;
  _not?: InputMaybe<InsertListingTeamsBoolExp>;
  _or?: InputMaybe<Array<InsertListingTeamsBoolExp>>;
  active_since?: InputMaybe<InsertListingIntComparisonExp>;
  agency_slug?: InputMaybe<InsertListingStringComparisonExp>;
  branding_color?: InputMaybe<InsertListingStringComparisonExp>;
  centroid?: InputMaybe<InsertListingGeometryComparisonExp>;
  combined_reviews?: InputMaybe<InsertListingCombinedReviewsBoolExp>;
  combined_reviews_aggregate?: InputMaybe<InsertListingCombinedReviewsAggregateBoolExp>;
  country?: InputMaybe<InsertListingStringComparisonExp>;
  country_code?: InputMaybe<InsertListingStringComparisonExp>;
  country_id?: InputMaybe<InsertListingUuidComparisonExp>;
  cover_photo?: InputMaybe<InsertListingImagesBoolExp>;
  cover_photo_image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  default_team_users?: InputMaybe<InsertListingUsersBoolExp>;
  default_team_users_aggregate?: InputMaybe<InsertListingUsersAggregateBoolExp>;
  description?: InputMaybe<InsertListingStringComparisonExp>;
  do_follow_link?: InputMaybe<InsertListingBooleanComparisonExp>;
  enquiries?: InputMaybe<InsertListingEnquiriesBoolExp>;
  enquiries_aggregate?: InputMaybe<InsertListingEnquiriesAggregateBoolExp>;
  facebook_url?: InputMaybe<InsertListingStringComparisonExp>;
  google_business_id?: InputMaybe<InsertListingStringComparisonExp>;
  google_place_description?: InputMaybe<InsertListingStringComparisonExp>;
  google_place_id?: InputMaybe<InsertListingStringComparisonExp>;
  google_reviews?: InputMaybe<InsertListingGoogleReviewsBoolExp>;
  google_reviews_aggregate?: InputMaybe<InsertListingGoogleReviewsAggregateBoolExp>;
  hide_exact_address?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  idx_agency_id?: InputMaybe<InsertListingStringComparisonExp>;
  idx_ftp_client_id?: InputMaybe<InsertListingStringComparisonExp>;
  instagram_url?: InputMaybe<InsertListingStringComparisonExp>;
  last_review_scraping?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  lat?: InputMaybe<InsertListingFloatComparisonExp>;
  legal_name?: InputMaybe<InsertListingStringComparisonExp>;
  linkedin_url?: InputMaybe<InsertListingStringComparisonExp>;
  listings_agency_names?: InputMaybe<InsertListingStringArrayComparisonExp>;
  lng?: InputMaybe<InsertListingFloatComparisonExp>;
  locality?: InputMaybe<InsertListingStringComparisonExp>;
  locality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  logo?: InputMaybe<InsertListingImagesBoolExp>;
  logo_image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  municipality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  neighbourhood_id?: InputMaybe<InsertListingUuidComparisonExp>;
  opening_hours?: InputMaybe<InsertListingJsonbComparisonExp>;
  organisation?: InputMaybe<InsertListingOrganisationsBoolExp>;
  organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  phone_numbers?: InputMaybe<InsertListingPhoneNumbersBoolExp>;
  phone_numbers_aggregate?: InputMaybe<InsertListingPhoneNumbersAggregateBoolExp>;
  postcode?: InputMaybe<InsertListingStringComparisonExp>;
  postcode_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  property_transactions_aggregate?: InputMaybe<InsertListingPropertyTransactionsAggregateBoolExp>;
  region_id?: InputMaybe<InsertListingUuidComparisonExp>;
  route?: InputMaybe<InsertListingStringComparisonExp>;
  show_in_agency_pages?: InputMaybe<InsertListingBooleanComparisonExp>;
  state?: InputMaybe<InsertListingStringComparisonExp>;
  state_id?: InputMaybe<InsertListingUuidComparisonExp>;
  street_number?: InputMaybe<InsertListingStringComparisonExp>;
  team_images?: InputMaybe<InsertListingTeamImagesBoolExp>;
  team_images_aggregate?: InputMaybe<InsertListingTeamImagesAggregateBoolExp>;
  teams_portals?: InputMaybe<InsertListingTeamsPortalsBoolExp>;
  teams_portals_aggregate?: InputMaybe<InsertListingTeamsPortalsAggregateBoolExp>;
  teams_users?: InputMaybe<InsertListingTeamsUsersBoolExp>;
  teams_users_aggregate?: InputMaybe<InsertListingTeamsUsersAggregateBoolExp>;
  tenant?: InputMaybe<InsertListingTenantsBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tsv?: InputMaybe<InsertListingTsvectorComparisonExp>;
  twitter_url?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  website_url?: InputMaybe<InsertListingStringComparisonExp>;
  youtube_url?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingTeamsConstraint {
  /** unique or primary key constraint on columns "id" */
  TeamsPkey = 'teams_pkey',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  TeamsTenantIdIdIdx = 'teams_tenant_id_id_idx',
  /** unique or primary key constraint on columns "agency_slug" */
  UniqueAgencySlugIndex = 'unique_agency_slug_index'
}

export type InsertListingTeamsInsertInput = {
  active_since?: InputMaybe<Scalars['Int']['input']>;
  agency_slug?: InputMaybe<Scalars['String']['input']>;
  branding_color?: InputMaybe<Scalars['String']['input']>;
  combined_reviews?: InputMaybe<InsertListingCombinedReviewsArrRelInsertInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  cover_photo?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  cover_photo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  default_team_users?: InputMaybe<InsertListingUsersArrRelInsertInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  do_follow_link?: InputMaybe<Scalars['Boolean']['input']>;
  enquiries?: InputMaybe<InsertListingEnquiriesArrRelInsertInput>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  google_business_id?: InputMaybe<Scalars['String']['input']>;
  google_place_description?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  google_reviews?: InputMaybe<InsertListingGoogleReviewsArrRelInsertInput>;
  hide_exact_address?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_agency_id?: InputMaybe<Scalars['String']['input']>;
  idx_ftp_client_id?: InputMaybe<Scalars['String']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  last_review_scraping?: InputMaybe<Scalars['timestamptz']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  legal_name?: InputMaybe<Scalars['String']['input']>;
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  listings_agency_names?: InputMaybe<Array<Scalars['String']['input']>>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  logo?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  opening_hours?: InputMaybe<Scalars['jsonb']['input']>;
  organisation?: InputMaybe<InsertListingOrganisationsObjRelInsertInput>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_numbers?: InputMaybe<InsertListingPhoneNumbersArrRelInsertInput>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_id?: InputMaybe<Scalars['uuid']['input']>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsArrRelInsertInput>;
  region_id?: InputMaybe<Scalars['uuid']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  show_in_agency_pages?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  team_images?: InputMaybe<InsertListingTeamImagesArrRelInsertInput>;
  teams_portals?: InputMaybe<InsertListingTeamsPortalsArrRelInsertInput>;
  teams_users?: InputMaybe<InsertListingTeamsUsersArrRelInsertInput>;
  tenant?: InputMaybe<InsertListingTenantsObjRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  tsv?: InputMaybe<Scalars['tsvector']['input']>;
  twitter_url?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
  youtube_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingTeamsObjRelInsertInput = {
  data: InsertListingTeamsInsertInput;
  on_conflict?: InputMaybe<InsertListingTeamsOnConflict>;
};

export type InsertListingTeamsOnConflict = {
  constraint: InsertListingTeamsConstraint;
  update_columns: Array<InsertListingTeamsUpdateColumn>;
  where?: InputMaybe<InsertListingTeamsBoolExp>;
};

export type InsertListingTeamsPortalsAggregateBoolExp = {
  count?: InputMaybe<InsertListingTeamsPortalsAggregateBoolExpCount>;
};

export type InsertListingTeamsPortalsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingTeamsPortalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTeamsPortalsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingTeamsPortalsArrRelInsertInput = {
  data: Array<InsertListingTeamsPortalsInsertInput>;
  on_conflict?: InputMaybe<InsertListingTeamsPortalsOnConflict>;
};

export type InsertListingTeamsPortalsBoolExp = {
  _and?: InputMaybe<Array<InsertListingTeamsPortalsBoolExp>>;
  _not?: InputMaybe<InsertListingTeamsPortalsBoolExp>;
  _or?: InputMaybe<Array<InsertListingTeamsPortalsBoolExp>>;
  contract_id?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  portal?: InputMaybe<InsertListingPortalsBoolExp>;
  portal_id?: InputMaybe<InsertListingUuidComparisonExp>;
  team?: InputMaybe<InsertListingTeamsBoolExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingTeamsPortalsConstraint {
  /** unique or primary key constraint on columns "id" */
  TeamsPortalsPkey = 'teams_portals_pkey',
  /** unique or primary key constraint on columns "portal_id", "team_id" */
  TeamsPortalsTeamIdPortalIdKey = 'teams_portals_team_id_portal_id_key'
}

export type InsertListingTeamsPortalsInsertInput = {
  contract_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portal?: InputMaybe<InsertListingPortalsObjRelInsertInput>;
  portal_id?: InputMaybe<Scalars['uuid']['input']>;
  team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingTeamsPortalsOnConflict = {
  constraint: InsertListingTeamsPortalsConstraint;
  update_columns: Array<InsertListingTeamsPortalsUpdateColumn>;
  where?: InputMaybe<InsertListingTeamsPortalsBoolExp>;
};

export enum InsertListingTeamsPortalsSelectColumn {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PortalId = 'portal_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingTeamsPortalsUpdateColumn {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PortalId = 'portal_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingTeamsSelectColumn {
  /** column name */
  ActiveSince = 'active_since',
  /** column name */
  AgencySlug = 'agency_slug',
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  Centroid = 'centroid',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CoverPhotoImageId = 'cover_photo_image_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  DoFollowLink = 'do_follow_link',
  /** column name */
  FacebookUrl = 'facebook_url',
  /** column name */
  GoogleBusinessId = 'google_business_id',
  /** column name */
  GooglePlaceDescription = 'google_place_description',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  HideExactAddress = 'hide_exact_address',
  /** column name */
  Id = 'id',
  /** column name */
  IdxAgencyId = 'idx_agency_id',
  /** column name */
  IdxFtpClientId = 'idx_ftp_client_id',
  /** column name */
  InstagramUrl = 'instagram_url',
  /** column name */
  LastReviewScraping = 'last_review_scraping',
  /** column name */
  Lat = 'lat',
  /** column name */
  LegalName = 'legal_name',
  /** column name */
  LinkedinUrl = 'linkedin_url',
  /** column name */
  ListingsAgencyNames = 'listings_agency_names',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LogoImageId = 'logo_image_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  OpeningHours = 'opening_hours',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Route = 'route',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  State = 'state',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Tsv = 'tsv',
  /** column name */
  TwitterUrl = 'twitter_url',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WebsiteUrl = 'website_url',
  /** column name */
  YoutubeUrl = 'youtube_url'
}

export enum InsertListingTeamsSelectColumnTeamsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  DoFollowLink = 'do_follow_link',
  /** column name */
  HideExactAddress = 'hide_exact_address',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages'
}

export enum InsertListingTeamsSelectColumnTeamsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  DoFollowLink = 'do_follow_link',
  /** column name */
  HideExactAddress = 'hide_exact_address',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages'
}

export enum InsertListingTeamsUpdateColumn {
  /** column name */
  ActiveSince = 'active_since',
  /** column name */
  AgencySlug = 'agency_slug',
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CoverPhotoImageId = 'cover_photo_image_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  DoFollowLink = 'do_follow_link',
  /** column name */
  FacebookUrl = 'facebook_url',
  /** column name */
  GoogleBusinessId = 'google_business_id',
  /** column name */
  GooglePlaceDescription = 'google_place_description',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  HideExactAddress = 'hide_exact_address',
  /** column name */
  Id = 'id',
  /** column name */
  IdxAgencyId = 'idx_agency_id',
  /** column name */
  IdxFtpClientId = 'idx_ftp_client_id',
  /** column name */
  InstagramUrl = 'instagram_url',
  /** column name */
  LastReviewScraping = 'last_review_scraping',
  /** column name */
  Lat = 'lat',
  /** column name */
  LegalName = 'legal_name',
  /** column name */
  LinkedinUrl = 'linkedin_url',
  /** column name */
  ListingsAgencyNames = 'listings_agency_names',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LogoImageId = 'logo_image_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  OpeningHours = 'opening_hours',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Route = 'route',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  State = 'state',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Tsv = 'tsv',
  /** column name */
  TwitterUrl = 'twitter_url',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WebsiteUrl = 'website_url',
  /** column name */
  YoutubeUrl = 'youtube_url'
}

export type InsertListingTeamsUsersAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingTeamsUsersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingTeamsUsersAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingTeamsUsersAggregateBoolExpCount>;
};

export type InsertListingTeamsUsersAggregateBoolExpBoolAnd = {
  arguments: InsertListingTeamsUsersSelectColumnTeamsUsersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTeamsUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingTeamsUsersAggregateBoolExpBoolOr = {
  arguments: InsertListingTeamsUsersSelectColumnTeamsUsersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTeamsUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingTeamsUsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingTeamsUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTeamsUsersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingTeamsUsersArrRelInsertInput = {
  data: Array<InsertListingTeamsUsersInsertInput>;
  on_conflict?: InputMaybe<InsertListingTeamsUsersOnConflict>;
};

export type InsertListingTeamsUsersBoolExp = {
  _and?: InputMaybe<Array<InsertListingTeamsUsersBoolExp>>;
  _not?: InputMaybe<InsertListingTeamsUsersBoolExp>;
  _or?: InputMaybe<Array<InsertListingTeamsUsersBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  deactivated?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_leader?: InputMaybe<InsertListingBooleanComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  team?: InputMaybe<InsertListingTeamsBoolExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  title?: InputMaybe<InsertListingStringComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingTeamsUsersConstraint {
  /** unique or primary key constraint on columns "user_id", "team_id" */
  TeamUsersTeamIdUserIdIdx = 'team_users_team_id_user_id_idx',
  /** unique or primary key constraint on columns "order_nr", "team_id" */
  UcTeamsUsersOrderNrTeamId = 'uc_teams_users_order_nr_team_id'
}

export type InsertListingTeamsUsersInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated?: InputMaybe<Scalars['Boolean']['input']>;
  is_leader?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsObjRelInsertInput>;
  team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingTeamsUsersOnConflict = {
  constraint: InsertListingTeamsUsersConstraint;
  update_columns: Array<InsertListingTeamsUsersUpdateColumn>;
  where?: InputMaybe<InsertListingTeamsUsersBoolExp>;
};

export enum InsertListingTeamsUsersSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deactivated = 'deactivated',
  /** column name */
  IsLeader = 'is_leader',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingTeamsUsersSelectColumnTeamsUsersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Deactivated = 'deactivated',
  /** column name */
  IsLeader = 'is_leader'
}

export enum InsertListingTeamsUsersSelectColumnTeamsUsersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Deactivated = 'deactivated',
  /** column name */
  IsLeader = 'is_leader'
}

export enum InsertListingTeamsUsersUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deactivated = 'deactivated',
  /** column name */
  IsLeader = 'is_leader',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingTenantsBoolExp = {
  _and?: InputMaybe<Array<InsertListingTenantsBoolExp>>;
  _not?: InputMaybe<InsertListingTenantsBoolExp>;
  _or?: InputMaybe<Array<InsertListingTenantsBoolExp>>;
  activate_land_registry_owners?: InputMaybe<InsertListingBooleanComparisonExp>;
  activate_model_details?: InputMaybe<InsertListingBooleanComparisonExp>;
  activate_model_iazi?: InputMaybe<InsertListingBooleanComparisonExp>;
  activate_model_pricehubble?: InputMaybe<InsertListingBooleanComparisonExp>;
  activate_model_propertydata?: InputMaybe<InsertListingBooleanComparisonExp>;
  activate_model_realadvisor_listings?: InputMaybe<InsertListingBooleanComparisonExp>;
  activate_model_realadvisor_perceived?: InputMaybe<InsertListingBooleanComparisonExp>;
  activate_model_realadvisor_transactions?: InputMaybe<InsertListingBooleanComparisonExp>;
  activate_model_wup?: InputMaybe<InsertListingBooleanComparisonExp>;
  country?: InputMaybe<InsertListingStringComparisonExp>;
  country_code?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  debug_email_mode?: InputMaybe<InsertListingBooleanComparisonExp>;
  default_pipeline_id?: InputMaybe<InsertListingUuidComparisonExp>;
  email_is_verified?: InputMaybe<InsertListingBooleanComparisonExp>;
  email_sender_email?: InputMaybe<InsertListingStringComparisonExp>;
  email_sender_name?: InputMaybe<InsertListingStringComparisonExp>;
  email_template?: InputMaybe<InsertListingEmailTemplateComparisonExp>;
  google_place_description?: InputMaybe<InsertListingStringComparisonExp>;
  google_place_id?: InputMaybe<InsertListingStringComparisonExp>;
  google_tag_manager_id?: InputMaybe<InsertListingStringComparisonExp>;
  help_link_de?: InputMaybe<InsertListingStringComparisonExp>;
  help_link_en?: InputMaybe<InsertListingStringComparisonExp>;
  help_link_es?: InputMaybe<InsertListingStringComparisonExp>;
  help_link_fr?: InputMaybe<InsertListingStringComparisonExp>;
  help_link_it?: InputMaybe<InsertListingStringComparisonExp>;
  homepage_url?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  image?: InputMaybe<InsertListingImagesBoolExp>;
  lat?: InputMaybe<InsertListingFloatComparisonExp>;
  lng?: InputMaybe<InsertListingFloatComparisonExp>;
  locality?: InputMaybe<InsertListingStringComparisonExp>;
  logo_image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  main_color?: InputMaybe<InsertListingStringComparisonExp>;
  mortgage_rates?: InputMaybe<InsertListingJsonbComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  phone_main?: InputMaybe<InsertListingStringComparisonExp>;
  postcode?: InputMaybe<InsertListingStringComparisonExp>;
  resources_de?: InputMaybe<InsertListingStringComparisonExp>;
  resources_en?: InputMaybe<InsertListingStringComparisonExp>;
  resources_es?: InputMaybe<InsertListingStringComparisonExp>;
  resources_fr?: InputMaybe<InsertListingStringComparisonExp>;
  resources_it?: InputMaybe<InsertListingStringComparisonExp>;
  route?: InputMaybe<InsertListingStringComparisonExp>;
  send_in_blue_api_key?: InputMaybe<InsertListingStringComparisonExp>;
  slug?: InputMaybe<InsertListingStringComparisonExp>;
  state?: InputMaybe<InsertListingStringComparisonExp>;
  street_number?: InputMaybe<InsertListingStringComparisonExp>;
  stripe_secret_key?: InputMaybe<InsertListingStringComparisonExp>;
  stripe_secret_key_test?: InputMaybe<InsertListingStringComparisonExp>;
  stripe_webhook_secret?: InputMaybe<InsertListingStringComparisonExp>;
  stripe_webhook_secret_test?: InputMaybe<InsertListingStringComparisonExp>;
  system_user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  users?: InputMaybe<InsertListingUsersBoolExp>;
  users_aggregate?: InputMaybe<InsertListingUsersAggregateBoolExp>;
};

export enum InsertListingTenantsConstraint {
  /** unique or primary key constraint on columns "id" */
  TenantsPkey = 'tenants_pkey',
  /** unique or primary key constraint on columns "slug" */
  UniqueSlugIndex = 'unique_slug_index'
}

export type InsertListingTenantsInsertInput = {
  activate_land_registry_owners?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_details?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_iazi?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_pricehubble?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_propertydata?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_realadvisor_listings?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_realadvisor_perceived?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_realadvisor_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_wup?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  debug_email_mode?: InputMaybe<Scalars['Boolean']['input']>;
  default_pipeline_id?: InputMaybe<Scalars['uuid']['input']>;
  email_is_verified?: InputMaybe<Scalars['Boolean']['input']>;
  email_sender_email?: InputMaybe<Scalars['String']['input']>;
  email_sender_name?: InputMaybe<Scalars['String']['input']>;
  email_template?: InputMaybe<Scalars['email_template']['input']>;
  google_place_description?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  google_tag_manager_id?: InputMaybe<Scalars['String']['input']>;
  help_link_de?: InputMaybe<Scalars['String']['input']>;
  help_link_en?: InputMaybe<Scalars['String']['input']>;
  help_link_es?: InputMaybe<Scalars['String']['input']>;
  help_link_fr?: InputMaybe<Scalars['String']['input']>;
  help_link_it?: InputMaybe<Scalars['String']['input']>;
  homepage_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  main_color?: InputMaybe<Scalars['String']['input']>;
  mortgage_rates?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_main?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  resources_de?: InputMaybe<Scalars['String']['input']>;
  resources_en?: InputMaybe<Scalars['String']['input']>;
  resources_es?: InputMaybe<Scalars['String']['input']>;
  resources_fr?: InputMaybe<Scalars['String']['input']>;
  resources_it?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  send_in_blue_api_key?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  stripe_secret_key?: InputMaybe<Scalars['String']['input']>;
  stripe_secret_key_test?: InputMaybe<Scalars['String']['input']>;
  stripe_webhook_secret?: InputMaybe<Scalars['String']['input']>;
  stripe_webhook_secret_test?: InputMaybe<Scalars['String']['input']>;
  system_user_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  users?: InputMaybe<InsertListingUsersArrRelInsertInput>;
};

export type InsertListingTenantsObjRelInsertInput = {
  data: InsertListingTenantsInsertInput;
  on_conflict?: InputMaybe<InsertListingTenantsOnConflict>;
};

export type InsertListingTenantsOnConflict = {
  constraint: InsertListingTenantsConstraint;
  update_columns: Array<InsertListingTenantsUpdateColumn>;
  where?: InputMaybe<InsertListingTenantsBoolExp>;
};

export enum InsertListingTenantsUpdateColumn {
  /** column name */
  ActivateLandRegistryOwners = 'activate_land_registry_owners',
  /** column name */
  ActivateModelDetails = 'activate_model_details',
  /** column name */
  ActivateModelIazi = 'activate_model_iazi',
  /** column name */
  ActivateModelPricehubble = 'activate_model_pricehubble',
  /** column name */
  ActivateModelPropertydata = 'activate_model_propertydata',
  /** column name */
  ActivateModelRealadvisorListings = 'activate_model_realadvisor_listings',
  /** column name */
  ActivateModelRealadvisorPerceived = 'activate_model_realadvisor_perceived',
  /** column name */
  ActivateModelRealadvisorTransactions = 'activate_model_realadvisor_transactions',
  /** column name */
  ActivateModelWup = 'activate_model_wup',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DebugEmailMode = 'debug_email_mode',
  /** column name */
  DefaultPipelineId = 'default_pipeline_id',
  /** column name */
  EmailIsVerified = 'email_is_verified',
  /** column name */
  EmailSenderEmail = 'email_sender_email',
  /** column name */
  EmailSenderName = 'email_sender_name',
  /** column name */
  EmailTemplate = 'email_template',
  /** column name */
  GooglePlaceDescription = 'google_place_description',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  GoogleTagManagerId = 'google_tag_manager_id',
  /** column name */
  HelpLinkDe = 'help_link_de',
  /** column name */
  HelpLinkEn = 'help_link_en',
  /** column name */
  HelpLinkEs = 'help_link_es',
  /** column name */
  HelpLinkFr = 'help_link_fr',
  /** column name */
  HelpLinkIt = 'help_link_it',
  /** column name */
  HomepageUrl = 'homepage_url',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LogoImageId = 'logo_image_id',
  /** column name */
  MainColor = 'main_color',
  /** column name */
  MortgageRates = 'mortgage_rates',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneMain = 'phone_main',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  ResourcesDe = 'resources_de',
  /** column name */
  ResourcesEn = 'resources_en',
  /** column name */
  ResourcesEs = 'resources_es',
  /** column name */
  ResourcesFr = 'resources_fr',
  /** column name */
  ResourcesIt = 'resources_it',
  /** column name */
  Route = 'route',
  /** column name */
  SendInBlueApiKey = 'send_in_blue_api_key',
  /** column name */
  Slug = 'slug',
  /** column name */
  State = 'state',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  StripeSecretKey = 'stripe_secret_key',
  /** column name */
  StripeSecretKeyTest = 'stripe_secret_key_test',
  /** column name */
  StripeWebhookSecret = 'stripe_webhook_secret',
  /** column name */
  StripeWebhookSecretTest = 'stripe_webhook_secret_test',
  /** column name */
  SystemUserId = 'system_user_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingThirdPillarOrganisationTypeAComparisonExp = {
  _eq?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _gt?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _gte?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _in?: InputMaybe<Array<Scalars['third_pillar_organisation_type_a']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _lte?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _neq?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _nin?: InputMaybe<Array<Scalars['third_pillar_organisation_type_a']['input']>>;
};

export type InsertListingThirdPillarOrganisationTypeBComparisonExp = {
  _eq?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _gt?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _gte?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _in?: InputMaybe<Array<Scalars['third_pillar_organisation_type_b']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _lte?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _neq?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _nin?: InputMaybe<Array<Scalars['third_pillar_organisation_type_b']['input']>>;
};

export type InsertListingTimestampComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

export type InsertListingTimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

export type InsertListingTransactionBuyersAggregateBoolExp = {
  count?: InputMaybe<InsertListingTransactionBuyersAggregateBoolExpCount>;
};

export type InsertListingTransactionBuyersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingTransactionBuyersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTransactionBuyersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingTransactionBuyersArrRelInsertInput = {
  data: Array<InsertListingTransactionBuyersInsertInput>;
};

export type InsertListingTransactionBuyersBoolExp = {
  _and?: InputMaybe<Array<InsertListingTransactionBuyersBoolExp>>;
  _not?: InputMaybe<InsertListingTransactionBuyersBoolExp>;
  _or?: InputMaybe<Array<InsertListingTransactionBuyersBoolExp>>;
  property_transaction?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  transaction_id?: InputMaybe<InsertListingUuidComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export type InsertListingTransactionBuyersInsertInput = {
  property_transaction?: InputMaybe<InsertListingPropertyTransactionsObjRelInsertInput>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export enum InsertListingTransactionBuyersSelectColumn {
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingTransactionSellersAggregateBoolExp = {
  count?: InputMaybe<InsertListingTransactionSellersAggregateBoolExpCount>;
};

export type InsertListingTransactionSellersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingTransactionSellersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTransactionSellersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingTransactionSellersArrRelInsertInput = {
  data: Array<InsertListingTransactionSellersInsertInput>;
};

export type InsertListingTransactionSellersBoolExp = {
  _and?: InputMaybe<Array<InsertListingTransactionSellersBoolExp>>;
  _not?: InputMaybe<InsertListingTransactionSellersBoolExp>;
  _or?: InputMaybe<Array<InsertListingTransactionSellersBoolExp>>;
  property_transaction?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  transaction_id?: InputMaybe<InsertListingUuidComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export type InsertListingTransactionSellersInsertInput = {
  property_transaction?: InputMaybe<InsertListingPropertyTransactionsObjRelInsertInput>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export enum InsertListingTransactionSellersSelectColumn {
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingTsvectorComparisonExp = {
  _eq?: InputMaybe<Scalars['tsvector']['input']>;
  _gt?: InputMaybe<Scalars['tsvector']['input']>;
  _gte?: InputMaybe<Scalars['tsvector']['input']>;
  _in?: InputMaybe<Array<Scalars['tsvector']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['tsvector']['input']>;
  _lte?: InputMaybe<Scalars['tsvector']['input']>;
  _neq?: InputMaybe<Scalars['tsvector']['input']>;
  _nin?: InputMaybe<Array<Scalars['tsvector']['input']>>;
};

export type InsertListingUserImagesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingUserImagesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingUserImagesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingUserImagesAggregateBoolExpCount>;
};

export type InsertListingUserImagesAggregateBoolExpBoolAnd = {
  arguments: InsertListingUserImagesSelectColumnUserImagesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUserImagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingUserImagesAggregateBoolExpBoolOr = {
  arguments: InsertListingUserImagesSelectColumnUserImagesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUserImagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingUserImagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingUserImagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUserImagesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingUserImagesArrRelInsertInput = {
  data: Array<InsertListingUserImagesInsertInput>;
  on_conflict?: InputMaybe<InsertListingUserImagesOnConflict>;
};

export type InsertListingUserImagesBoolExp = {
  _and?: InputMaybe<Array<InsertListingUserImagesBoolExp>>;
  _not?: InputMaybe<InsertListingUserImagesBoolExp>;
  _or?: InputMaybe<Array<InsertListingUserImagesBoolExp>>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  image?: InputMaybe<InsertListingImagesBoolExp>;
  image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_primary?: InputMaybe<InsertListingBooleanComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingUserImagesConstraint {
  /** unique or primary key constraint on columns "user_id", "is_primary" */
  IdxUserImagesUserIdIsPrimary = 'idx_user_images_user_id_is_primary',
  /** unique or primary key constraint on columns "id" */
  UserImagesIdKey = 'user_images_id_key',
  /** unique or primary key constraint on columns "id" */
  UserImagesPkey = 'user_images_pkey',
  /** unique or primary key constraint on columns "user_id", "image_id" */
  UserImagesUserIdImageIdUnique = 'user_images_user_id_image_id_unique'
}

export type InsertListingUserImagesInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingUserImagesOnConflict = {
  constraint: InsertListingUserImagesConstraint;
  update_columns: Array<InsertListingUserImagesUpdateColumn>;
  where?: InputMaybe<InsertListingUserImagesBoolExp>;
};

export enum InsertListingUserImagesSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingUserImagesSelectColumnUserImagesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsPrimary = 'is_primary'
}

export enum InsertListingUserImagesSelectColumnUserImagesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsPrimary = 'is_primary'
}

export enum InsertListingUserImagesUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingUserLanguageComparisonExp = {
  _eq?: InputMaybe<Scalars['user_language']['input']>;
  _gt?: InputMaybe<Scalars['user_language']['input']>;
  _gte?: InputMaybe<Scalars['user_language']['input']>;
  _in?: InputMaybe<Array<Scalars['user_language']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['user_language']['input']>;
  _lte?: InputMaybe<Scalars['user_language']['input']>;
  _neq?: InputMaybe<Scalars['user_language']['input']>;
  _nin?: InputMaybe<Array<Scalars['user_language']['input']>>;
};

export type InsertListingUserProfessionalSituationComparisonExp = {
  _eq?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _gt?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _gte?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _in?: InputMaybe<Array<Scalars['user_professional_situation']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _lte?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _neq?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _nin?: InputMaybe<Array<Scalars['user_professional_situation']['input']>>;
};

export type InsertListingUsersAggregateBoolExp = {
  avg?: InputMaybe<InsertListingUsersAggregateBoolExpAvg>;
  bool_and?: InputMaybe<InsertListingUsersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingUsersAggregateBoolExpBoolOr>;
  corr?: InputMaybe<InsertListingUsersAggregateBoolExpCorr>;
  count?: InputMaybe<InsertListingUsersAggregateBoolExpCount>;
  covar_samp?: InputMaybe<InsertListingUsersAggregateBoolExpCovarSamp>;
  max?: InputMaybe<InsertListingUsersAggregateBoolExpMax>;
  min?: InputMaybe<InsertListingUsersAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<InsertListingUsersAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<InsertListingUsersAggregateBoolExpSum>;
  var_samp?: InputMaybe<InsertListingUsersAggregateBoolExpVarSamp>;
};

export type InsertListingUsersAggregateBoolExpAvg = {
  arguments: InsertListingUsersSelectColumnUsersAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingUsersAggregateBoolExpBoolAnd = {
  arguments: InsertListingUsersSelectColumnUsersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingUsersAggregateBoolExpBoolOr = {
  arguments: InsertListingUsersSelectColumnUsersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingUsersAggregateBoolExpCorr = {
  arguments: InsertListingUsersAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingUsersAggregateBoolExpCorrArguments = {
  X: InsertListingUsersSelectColumnUsersAggregateBoolExpCorrArgumentsColumns;
  Y: InsertListingUsersSelectColumnUsersAggregateBoolExpCorrArgumentsColumns;
};

export type InsertListingUsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingUsersAggregateBoolExpCovarSamp = {
  arguments: InsertListingUsersAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingUsersAggregateBoolExpCovarSampArguments = {
  X: InsertListingUsersSelectColumnUsersAggregateBoolExpCovarSampArgumentsColumns;
  Y: InsertListingUsersSelectColumnUsersAggregateBoolExpCovarSampArgumentsColumns;
};

export type InsertListingUsersAggregateBoolExpMax = {
  arguments: InsertListingUsersSelectColumnUsersAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingUsersAggregateBoolExpMin = {
  arguments: InsertListingUsersSelectColumnUsersAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingUsersAggregateBoolExpStddevSamp = {
  arguments: InsertListingUsersSelectColumnUsersAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingUsersAggregateBoolExpSum = {
  arguments: InsertListingUsersSelectColumnUsersAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingUsersAggregateBoolExpVarSamp = {
  arguments: InsertListingUsersSelectColumnUsersAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingUsersArrRelInsertInput = {
  data: Array<InsertListingUsersInsertInput>;
  on_conflict?: InputMaybe<InsertListingUsersOnConflict>;
};

export type InsertListingUsersBoolExp = {
  _and?: InputMaybe<Array<InsertListingUsersBoolExp>>;
  _not?: InputMaybe<InsertListingUsersBoolExp>;
  _or?: InputMaybe<Array<InsertListingUsersBoolExp>>;
  account_manager?: InputMaybe<InsertListingUsersBoolExp>;
  account_manager_id?: InputMaybe<InsertListingUuidComparisonExp>;
  active_since?: InputMaybe<InsertListingIntComparisonExp>;
  activities?: InputMaybe<InsertListingActivitiesBoolExp>;
  activities_aggregate?: InputMaybe<InsertListingActivitiesAggregateBoolExp>;
  age?: InputMaybe<InsertListingIntComparisonExp>;
  agent_slug?: InputMaybe<InsertListingStringComparisonExp>;
  annual_costs_child_support?: InputMaybe<InsertListingFloat8ComparisonExp>;
  annual_costs_leasing?: InputMaybe<InsertListingFloat8ComparisonExp>;
  annual_costs_other_credits?: InputMaybe<InsertListingFloat8ComparisonExp>;
  annual_credits?: InputMaybe<InsertListingJsonbArrayComparisonExp>;
  annual_credits_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  annual_income_additional_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  annual_income_bonus?: InputMaybe<InsertListingFloat8ComparisonExp>;
  annual_income_family_allowances?: InputMaybe<InsertListingFloat8ComparisonExp>;
  annual_income_other?: InputMaybe<InsertListingFloat8ComparisonExp>;
  annual_income_rent?: InputMaybe<InsertListingFloat8ComparisonExp>;
  annual_income_salary?: InputMaybe<InsertListingIntComparisonExp>;
  annual_income_salary13?: InputMaybe<InsertListingBooleanComparisonExp>;
  annual_income_salary14?: InputMaybe<InsertListingBooleanComparisonExp>;
  annual_leasings?: InputMaybe<InsertListingJsonbArrayComparisonExp>;
  annual_leasings_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  annual_other_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  annual_other_payments?: InputMaybe<InsertListingFloat8ArrayComparisonExp>;
  assets_savings?: InputMaybe<InsertListingIntComparisonExp>;
  assets_savings_donation?: InputMaybe<InsertListingFloatComparisonExp>;
  assets_second_pillar?: InputMaybe<InsertListingIntComparisonExp>;
  assets_second_pillar_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  assets_second_pillar_organisation?: InputMaybe<InsertListingStringComparisonExp>;
  assets_securities?: InputMaybe<InsertListingFloat8ComparisonExp>;
  assets_third_pillar_a?: InputMaybe<InsertListingIntComparisonExp>;
  assets_third_pillar_a_annual_premium?: InputMaybe<InsertListingFloatComparisonExp>;
  assets_third_pillar_a_annual_premium_organization?: InputMaybe<InsertListingStringComparisonExp>;
  assets_third_pillar_a_cash?: InputMaybe<InsertListingFloat8ComparisonExp>;
  assets_third_pillar_a_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  assets_third_pillar_a_life_insurance?: InputMaybe<InsertListingBooleanComparisonExp>;
  assets_third_pillar_a_organisation?: InputMaybe<InsertListingStringComparisonExp>;
  assets_third_pillar_a_organisation_type?: InputMaybe<InsertListingThirdPillarOrganisationTypeAComparisonExp>;
  assets_third_pillar_b?: InputMaybe<InsertListingFloatComparisonExp>;
  assets_third_pillar_b_annual_premium?: InputMaybe<InsertListingFloatComparisonExp>;
  assets_third_pillar_b_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  assets_third_pillar_b_life_insurance?: InputMaybe<InsertListingBooleanComparisonExp>;
  assets_third_pillar_b_organisation?: InputMaybe<InsertListingStringComparisonExp>;
  assets_third_pillar_b_organisation_type?: InputMaybe<InsertListingThirdPillarOrganisationTypeBComparisonExp>;
  assets_third_pillar_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  assigned_activities?: InputMaybe<InsertListingActivitiesBoolExp>;
  assigned_activities_aggregate?: InputMaybe<InsertListingActivitiesAggregateBoolExp>;
  auto_assign_leads?: InputMaybe<InsertListingBooleanComparisonExp>;
  branding_color?: InputMaybe<InsertListingStringComparisonExp>;
  branding_logo?: InputMaybe<InsertListingStringComparisonExp>;
  branding_name?: InputMaybe<InsertListingStringComparisonExp>;
  branding_website?: InputMaybe<InsertListingStringComparisonExp>;
  broker?: InputMaybe<InsertListingUsersBoolExp>;
  broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  broker_leads?: InputMaybe<InsertListingLeadsBoolExp>;
  broker_leads_aggregate?: InputMaybe<InsertListingLeadsAggregateBoolExp>;
  buyer_leads?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
  buyer_leads_aggregate?: InputMaybe<InsertListingBuyerLeadsAggregateBoolExp>;
  buyer_offers?: InputMaybe<InsertListingOffersBoolExp>;
  buyer_offers_aggregate?: InputMaybe<InsertListingOffersAggregateBoolExp>;
  can_edit_settings?: InputMaybe<InsertListingBooleanComparisonExp>;
  can_user_login_as?: InputMaybe<InsertListingBooleanComparisonExp>;
  catchment_areas?: InputMaybe<InsertListingCatchmentAreasBoolExp>;
  catchment_areas_aggregate?: InputMaybe<InsertListingCatchmentAreasAggregateBoolExp>;
  certifications?: InputMaybe<InsertListingStringArrayComparisonExp>;
  combined_reviews?: InputMaybe<InsertListingCombinedReviewsBoolExp>;
  combined_reviews_aggregate?: InputMaybe<InsertListingCombinedReviewsAggregateBoolExp>;
  created_activities?: InputMaybe<InsertListingActivitiesBoolExp>;
  created_activities_aggregate?: InputMaybe<InsertListingActivitiesAggregateBoolExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  creator?: InputMaybe<InsertListingUsersBoolExp>;
  crm_link?: InputMaybe<InsertListingStringComparisonExp>;
  date_of_birth?: InputMaybe<InsertListingDateComparisonExp>;
  debt?: InputMaybe<InsertListingIntComparisonExp>;
  debt_leasing_balance?: InputMaybe<InsertListingFloat8ComparisonExp>;
  debt_mortgage_balance?: InputMaybe<InsertListingFloat8ComparisonExp>;
  debt_other_credits_balance?: InputMaybe<InsertListingIntComparisonExp>;
  default_team?: InputMaybe<InsertListingTeamsBoolExp>;
  default_team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  description?: InputMaybe<InsertListingStringComparisonExp>;
  display_name?: InputMaybe<InsertListingStringComparisonExp>;
  divorce_date?: InputMaybe<InsertListingDateComparisonExp>;
  donation?: InputMaybe<InsertListingFloat8ComparisonExp>;
  email_signature?: InputMaybe<InsertListingStringComparisonExp>;
  email_signature_html?: InputMaybe<InsertListingStringComparisonExp>;
  emails?: InputMaybe<InsertListingEmailsBoolExp>;
  emails_aggregate?: InputMaybe<InsertListingEmailsAggregateBoolExp>;
  employer?: InputMaybe<InsertListingStringComparisonExp>;
  employer_id?: InputMaybe<InsertListingUuidComparisonExp>;
  employment_commencement_date?: InputMaybe<InsertListingDateComparisonExp>;
  employment_rate?: InputMaybe<InsertListingFloat8ComparisonExp>;
  enquiries?: InputMaybe<InsertListingEnquiriesBoolExp>;
  enquiries_aggregate?: InputMaybe<InsertListingEnquiriesAggregateBoolExp>;
  facebook_profile?: InputMaybe<InsertListingStringComparisonExp>;
  financing_passports?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  financing_passports_aggregate?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExp>;
  first_name?: InputMaybe<InsertListingStringComparisonExp>;
  full_name?: InputMaybe<InsertListingStringComparisonExp>;
  gender?: InputMaybe<InsertListingStringComparisonExp>;
  has_accepted_terms?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_children?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_churned?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_free_crm_access?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_used_trial_button?: InputMaybe<InsertListingBooleanComparisonExp>;
  home_address_country_code?: InputMaybe<InsertListingStringComparisonExp>;
  home_address_lat?: InputMaybe<InsertListingFloatComparisonExp>;
  home_address_lng?: InputMaybe<InsertListingFloatComparisonExp>;
  home_address_locality?: InputMaybe<InsertListingStringComparisonExp>;
  home_address_postcode?: InputMaybe<InsertListingStringComparisonExp>;
  home_address_route?: InputMaybe<InsertListingStringComparisonExp>;
  home_address_state?: InputMaybe<InsertListingStringComparisonExp>;
  home_address_street_number?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  identification_document_expiry_date?: InputMaybe<InsertListingDateComparisonExp>;
  identification_document_issue_date?: InputMaybe<InsertListingDateComparisonExp>;
  identification_document_number?: InputMaybe<InsertListingStringComparisonExp>;
  identification_document_type_id?: InputMaybe<InsertListingUuidComparisonExp>;
  imported_id?: InputMaybe<InsertListingStringComparisonExp>;
  intercom_hash?: InputMaybe<InsertListingStringComparisonExp>;
  is_admin?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_bot?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_broker?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_deleted?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_mortgage_broker?: InputMaybe<InsertListingBooleanComparisonExp>;
  job_title?: InputMaybe<InsertListingStringComparisonExp>;
  landing_page_url?: InputMaybe<InsertListingStringComparisonExp>;
  language?: InputMaybe<InsertListingUserLanguageComparisonExp>;
  languages?: InputMaybe<InsertListingStringArrayComparisonExp>;
  last_bonus?: InputMaybe<InsertListingFloat8ComparisonExp>;
  last_name?: InputMaybe<InsertListingStringComparisonExp>;
  lead_agents?: InputMaybe<InsertListingLeadAgentsBoolExp>;
  lead_agents_aggregate?: InputMaybe<InsertListingLeadAgentsAggregateBoolExp>;
  leads?: InputMaybe<InsertListingLeadsBoolExp>;
  leads_aggregate?: InputMaybe<InsertListingLeadsAggregateBoolExp>;
  linked_in_profile?: InputMaybe<InsertListingStringComparisonExp>;
  logins?: InputMaybe<InsertListingLoginsBoolExp>;
  logins_aggregate?: InputMaybe<InsertListingLoginsAggregateBoolExp>;
  lot_buyers?: InputMaybe<InsertListingLotBuyersBoolExp>;
  lot_buyers_aggregate?: InputMaybe<InsertListingLotBuyersAggregateBoolExp>;
  lot_sellers?: InputMaybe<InsertListingLotSellersBoolExp>;
  lot_sellers_aggregate?: InputMaybe<InsertListingLotSellersAggregateBoolExp>;
  lots?: InputMaybe<InsertListingLotsBoolExp>;
  lots_aggregate?: InputMaybe<InsertListingLotsAggregateBoolExp>;
  marital_partner_id?: InputMaybe<InsertListingUuidComparisonExp>;
  marital_status?: InputMaybe<InsertListingMaritalStatusComparisonExp>;
  matrimonial_regime?: InputMaybe<InsertListingStringComparisonExp>;
  membership_type?: InputMaybe<InsertListingStringComparisonExp>;
  modules?: InputMaybe<InsertListingStringArrayComparisonExp>;
  mortgage_broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  nationality?: InputMaybe<InsertListingDictionariesBoolExp>;
  nationality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  number_of_buyers?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_dependant_children?: InputMaybe<InsertListingIntComparisonExp>;
  nylas_account_config?: InputMaybe<InsertListingNylasAccountConfigsBoolExp>;
  nylas_account_config_aggregate?: InputMaybe<InsertListingNylasAccountConfigsAggregateBoolExp>;
  occupation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  occupation_text?: InputMaybe<InsertListingStringComparisonExp>;
  organisation?: InputMaybe<InsertListingOrganisationsBoolExp>;
  organisation_user?: InputMaybe<InsertListingOrganisationUsersBoolExp>;
  payments?: InputMaybe<InsertListingPaymentsBoolExp>;
  payments_aggregate?: InputMaybe<InsertListingPaymentsAggregateBoolExp>;
  phone_numbers?: InputMaybe<InsertListingPhoneNumbersBoolExp>;
  phone_numbers_aggregate?: InputMaybe<InsertListingPhoneNumbersAggregateBoolExp>;
  place_of_origin?: InputMaybe<InsertListingStringComparisonExp>;
  primary_phone_number?: InputMaybe<InsertListingPhoneNumbersBoolExp>;
  professional_address_country_code?: InputMaybe<InsertListingStringComparisonExp>;
  professional_address_lat?: InputMaybe<InsertListingFloat8ComparisonExp>;
  professional_address_lng?: InputMaybe<InsertListingFloat8ComparisonExp>;
  professional_address_locality?: InputMaybe<InsertListingStringComparisonExp>;
  professional_address_postcode?: InputMaybe<InsertListingStringComparisonExp>;
  professional_address_route?: InputMaybe<InsertListingStringComparisonExp>;
  professional_address_state?: InputMaybe<InsertListingStringComparisonExp>;
  professional_address_street_number?: InputMaybe<InsertListingStringComparisonExp>;
  professional_situation?: InputMaybe<InsertListingUserProfessionalSituationComparisonExp>;
  properties?: InputMaybe<InsertListingPropertiesUsersBoolExp>;
  properties_aggregate?: InputMaybe<InsertListingPropertiesUsersAggregateBoolExp>;
  properties_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  property_searches?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  property_searches_aggregate?: InputMaybe<InsertListingPropertySearchesAggregateBoolExp>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  property_transactions_aggregate?: InputMaybe<InsertListingPropertyTransactionsAggregateBoolExp>;
  push_notification_tokens?: InputMaybe<InsertListingPushNotificationTokensBoolExp>;
  push_notification_tokens_aggregate?: InputMaybe<InsertListingPushNotificationTokensAggregateBoolExp>;
  recommended_listings?: InputMaybe<InsertListingBooleanComparisonExp>;
  referrer?: InputMaybe<InsertListingStringComparisonExp>;
  referring_domain?: InputMaybe<InsertListingStringComparisonExp>;
  registered_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  residence_country_code?: InputMaybe<InsertListingStringComparisonExp>;
  residence_state_id?: InputMaybe<InsertListingUuidComparisonExp>;
  reviews?: InputMaybe<InsertListingReviewsBoolExp>;
  reviews_aggregate?: InputMaybe<InsertListingReviewsAggregateBoolExp>;
  second_pillar_organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  services?: InputMaybe<InsertListingStringArrayComparisonExp>;
  show_in_agency_pages?: InputMaybe<InsertListingBooleanComparisonExp>;
  social_security_number?: InputMaybe<InsertListingStringComparisonExp>;
  subscriptions?: InputMaybe<InsertListingSubscriptionsBoolExp>;
  subscriptions_aggregate?: InputMaybe<InsertListingSubscriptionsAggregateBoolExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  teams_users?: InputMaybe<InsertListingTeamsUsersBoolExp>;
  teams_users_aggregate?: InputMaybe<InsertListingTeamsUsersAggregateBoolExp>;
  tenant?: InputMaybe<InsertListingTenantsBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  test_jwt?: InputMaybe<InsertListingStringComparisonExp>;
  third_pillar_a_annual_premium_organization_id?: InputMaybe<InsertListingUuidComparisonExp>;
  third_pillar_a_organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  third_pillar_b_organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  title?: InputMaybe<InsertListingStringComparisonExp>;
  tsv?: InputMaybe<InsertListingTsvectorComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  updates_daily_tasks?: InputMaybe<InsertListingBooleanComparisonExp>;
  updates_introduction_to_lead_contacts?: InputMaybe<InsertListingBooleanComparisonExp>;
  updates_new_lead_assigned_sms?: InputMaybe<InsertListingBooleanComparisonExp>;
  updates_newsletter?: InputMaybe<InsertListingBooleanComparisonExp>;
  updates_property_revaluation?: InputMaybe<InsertListingBooleanComparisonExp>;
  user_images?: InputMaybe<InsertListingUserImagesBoolExp>;
  user_images_aggregate?: InputMaybe<InsertListingUserImagesAggregateBoolExp>;
  wedding_date?: InputMaybe<InsertListingDateComparisonExp>;
  work_permit?: InputMaybe<InsertListingDictionariesBoolExp>;
  work_permit_id?: InputMaybe<InsertListingUuidComparisonExp>;
  yearly_revenues_at_retirement?: InputMaybe<InsertListingFloat8ComparisonExp>;
};

export enum InsertListingUsersConstraint {
  /** unique or primary key constraint on columns "agent_slug" */
  UniqueAgentSlugIndex = 'unique_agent_slug_index',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  UsersIdTenantIdUnique = 'users_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

export type InsertListingUsersInsertInput = {
  account_manager?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  account_manager_id?: InputMaybe<Scalars['uuid']['input']>;
  active_since?: InputMaybe<Scalars['Int']['input']>;
  activities?: InputMaybe<InsertListingActivitiesArrRelInsertInput>;
  agent_slug?: InputMaybe<Scalars['String']['input']>;
  annual_costs_child_support?: InputMaybe<Scalars['float8']['input']>;
  annual_costs_leasing?: InputMaybe<Scalars['float8']['input']>;
  annual_costs_other_credits?: InputMaybe<Scalars['float8']['input']>;
  annual_credits?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  annual_credits_exist?: InputMaybe<Scalars['Boolean']['input']>;
  annual_income_additional_exist?: InputMaybe<Scalars['Boolean']['input']>;
  annual_income_bonus?: InputMaybe<Scalars['float8']['input']>;
  annual_income_family_allowances?: InputMaybe<Scalars['float8']['input']>;
  annual_income_other?: InputMaybe<Scalars['float8']['input']>;
  annual_income_rent?: InputMaybe<Scalars['float8']['input']>;
  annual_income_salary?: InputMaybe<Scalars['Int']['input']>;
  annual_income_salary13?: InputMaybe<Scalars['Boolean']['input']>;
  annual_income_salary14?: InputMaybe<Scalars['Boolean']['input']>;
  annual_leasings?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  annual_leasings_exist?: InputMaybe<Scalars['Boolean']['input']>;
  annual_other_exist?: InputMaybe<Scalars['Boolean']['input']>;
  annual_other_payments?: InputMaybe<Array<Scalars['float8']['input']>>;
  assets_savings?: InputMaybe<Scalars['Int']['input']>;
  assets_savings_donation?: InputMaybe<Scalars['Float']['input']>;
  assets_second_pillar?: InputMaybe<Scalars['Int']['input']>;
  assets_second_pillar_exist?: InputMaybe<Scalars['Boolean']['input']>;
  assets_second_pillar_organisation?: InputMaybe<Scalars['String']['input']>;
  assets_securities?: InputMaybe<Scalars['float8']['input']>;
  assets_third_pillar_a?: InputMaybe<Scalars['Int']['input']>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Scalars['Float']['input']>;
  assets_third_pillar_a_annual_premium_organization?: InputMaybe<Scalars['String']['input']>;
  assets_third_pillar_a_cash?: InputMaybe<Scalars['float8']['input']>;
  assets_third_pillar_a_exist?: InputMaybe<Scalars['Boolean']['input']>;
  assets_third_pillar_a_life_insurance?: InputMaybe<Scalars['Boolean']['input']>;
  assets_third_pillar_a_organisation?: InputMaybe<Scalars['String']['input']>;
  assets_third_pillar_a_organisation_type?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  assets_third_pillar_b?: InputMaybe<Scalars['Float']['input']>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Scalars['Float']['input']>;
  assets_third_pillar_b_exist?: InputMaybe<Scalars['Boolean']['input']>;
  assets_third_pillar_b_life_insurance?: InputMaybe<Scalars['Boolean']['input']>;
  assets_third_pillar_b_organisation?: InputMaybe<Scalars['String']['input']>;
  assets_third_pillar_b_organisation_type?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  assets_third_pillar_exist?: InputMaybe<Scalars['Boolean']['input']>;
  assigned_activities?: InputMaybe<InsertListingActivitiesArrRelInsertInput>;
  auto_assign_leads?: InputMaybe<Scalars['Boolean']['input']>;
  branding_color?: InputMaybe<Scalars['String']['input']>;
  branding_logo?: InputMaybe<Scalars['String']['input']>;
  branding_name?: InputMaybe<Scalars['String']['input']>;
  branding_website?: InputMaybe<Scalars['String']['input']>;
  broker?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  broker_leads?: InputMaybe<InsertListingLeadsArrRelInsertInput>;
  buyer_leads?: InputMaybe<InsertListingBuyerLeadsArrRelInsertInput>;
  buyer_offers?: InputMaybe<InsertListingOffersArrRelInsertInput>;
  can_edit_settings?: InputMaybe<Scalars['Boolean']['input']>;
  can_user_login_as?: InputMaybe<Scalars['Boolean']['input']>;
  catchment_areas?: InputMaybe<InsertListingCatchmentAreasArrRelInsertInput>;
  certifications?: InputMaybe<Array<Scalars['String']['input']>>;
  combined_reviews?: InputMaybe<InsertListingCombinedReviewsArrRelInsertInput>;
  created_activities?: InputMaybe<InsertListingActivitiesArrRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  creator?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  date_of_birth?: InputMaybe<Scalars['date']['input']>;
  debt?: InputMaybe<Scalars['Int']['input']>;
  debt_leasing_balance?: InputMaybe<Scalars['float8']['input']>;
  debt_mortgage_balance?: InputMaybe<Scalars['float8']['input']>;
  debt_other_credits_balance?: InputMaybe<Scalars['Int']['input']>;
  default_team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  default_team_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  divorce_date?: InputMaybe<Scalars['date']['input']>;
  donation?: InputMaybe<Scalars['float8']['input']>;
  email_signature?: InputMaybe<Scalars['String']['input']>;
  email_signature_html?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<InsertListingEmailsArrRelInsertInput>;
  employer?: InputMaybe<Scalars['String']['input']>;
  employer_id?: InputMaybe<Scalars['uuid']['input']>;
  employment_commencement_date?: InputMaybe<Scalars['date']['input']>;
  employment_rate?: InputMaybe<Scalars['float8']['input']>;
  enquiries?: InputMaybe<InsertListingEnquiriesArrRelInsertInput>;
  facebook_profile?: InputMaybe<Scalars['String']['input']>;
  financing_passports?: InputMaybe<InsertListingFinancingPassportsArrRelInsertInput>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  has_accepted_terms?: InputMaybe<Scalars['Boolean']['input']>;
  has_children?: InputMaybe<Scalars['Boolean']['input']>;
  has_free_crm_access?: InputMaybe<Scalars['Boolean']['input']>;
  has_used_trial_button?: InputMaybe<Scalars['Boolean']['input']>;
  home_address_country_code?: InputMaybe<Scalars['String']['input']>;
  home_address_lat?: InputMaybe<Scalars['Float']['input']>;
  home_address_lng?: InputMaybe<Scalars['Float']['input']>;
  home_address_locality?: InputMaybe<Scalars['String']['input']>;
  home_address_postcode?: InputMaybe<Scalars['String']['input']>;
  home_address_route?: InputMaybe<Scalars['String']['input']>;
  home_address_state?: InputMaybe<Scalars['String']['input']>;
  home_address_street_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  identification_document_expiry_date?: InputMaybe<Scalars['date']['input']>;
  identification_document_issue_date?: InputMaybe<Scalars['date']['input']>;
  identification_document_number?: InputMaybe<Scalars['String']['input']>;
  identification_document_type_id?: InputMaybe<Scalars['uuid']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  is_admin?: InputMaybe<Scalars['Boolean']['input']>;
  is_bot?: InputMaybe<Scalars['Boolean']['input']>;
  is_broker?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_mortgage_broker?: InputMaybe<Scalars['Boolean']['input']>;
  job_title?: InputMaybe<Scalars['String']['input']>;
  landing_page_url?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  last_bonus?: InputMaybe<Scalars['float8']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  lead_agents?: InputMaybe<InsertListingLeadAgentsArrRelInsertInput>;
  leads?: InputMaybe<InsertListingLeadsArrRelInsertInput>;
  linked_in_profile?: InputMaybe<Scalars['String']['input']>;
  logins?: InputMaybe<InsertListingLoginsArrRelInsertInput>;
  lot_buyers?: InputMaybe<InsertListingLotBuyersArrRelInsertInput>;
  lot_sellers?: InputMaybe<InsertListingLotSellersArrRelInsertInput>;
  lots?: InputMaybe<InsertListingLotsArrRelInsertInput>;
  marital_partner_id?: InputMaybe<Scalars['uuid']['input']>;
  marital_status?: InputMaybe<Scalars['marital_status']['input']>;
  matrimonial_regime?: InputMaybe<Scalars['String']['input']>;
  membership_type?: InputMaybe<Scalars['String']['input']>;
  modules?: InputMaybe<Array<Scalars['String']['input']>>;
  mortgage_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  nationality?: InputMaybe<InsertListingDictionariesObjRelInsertInput>;
  nationality_id?: InputMaybe<Scalars['uuid']['input']>;
  number_of_buyers?: InputMaybe<Scalars['Int']['input']>;
  number_of_dependant_children?: InputMaybe<Scalars['Int']['input']>;
  nylas_account_config?: InputMaybe<InsertListingNylasAccountConfigsArrRelInsertInput>;
  occupation_id?: InputMaybe<Scalars['uuid']['input']>;
  occupation_text?: InputMaybe<Scalars['String']['input']>;
  organisation?: InputMaybe<InsertListingOrganisationsObjRelInsertInput>;
  organisation_user?: InputMaybe<InsertListingOrganisationUsersObjRelInsertInput>;
  payments?: InputMaybe<InsertListingPaymentsArrRelInsertInput>;
  phone_numbers?: InputMaybe<InsertListingPhoneNumbersArrRelInsertInput>;
  place_of_origin?: InputMaybe<Scalars['String']['input']>;
  professional_address_country_code?: InputMaybe<Scalars['String']['input']>;
  professional_address_lat?: InputMaybe<Scalars['float8']['input']>;
  professional_address_lng?: InputMaybe<Scalars['float8']['input']>;
  professional_address_locality?: InputMaybe<Scalars['String']['input']>;
  professional_address_postcode?: InputMaybe<Scalars['String']['input']>;
  professional_address_route?: InputMaybe<Scalars['String']['input']>;
  professional_address_state?: InputMaybe<Scalars['String']['input']>;
  professional_address_street_number?: InputMaybe<Scalars['String']['input']>;
  professional_situation?: InputMaybe<Scalars['user_professional_situation']['input']>;
  properties?: InputMaybe<InsertListingPropertiesUsersArrRelInsertInput>;
  properties_exist?: InputMaybe<Scalars['Boolean']['input']>;
  property_searches?: InputMaybe<InsertListingPropertySearchesArrRelInsertInput>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsArrRelInsertInput>;
  push_notification_tokens?: InputMaybe<InsertListingPushNotificationTokensArrRelInsertInput>;
  recommended_listings?: InputMaybe<Scalars['Boolean']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  referring_domain?: InputMaybe<Scalars['String']['input']>;
  registered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  residence_country_code?: InputMaybe<Scalars['String']['input']>;
  residence_state_id?: InputMaybe<Scalars['uuid']['input']>;
  reviews?: InputMaybe<InsertListingReviewsArrRelInsertInput>;
  second_pillar_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  show_in_agency_pages?: InputMaybe<Scalars['Boolean']['input']>;
  social_security_number?: InputMaybe<Scalars['String']['input']>;
  subscriptions?: InputMaybe<InsertListingSubscriptionsArrRelInsertInput>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  teams_users?: InputMaybe<InsertListingTeamsUsersArrRelInsertInput>;
  tenant?: InputMaybe<InsertListingTenantsObjRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  third_pillar_a_annual_premium_organization_id?: InputMaybe<Scalars['uuid']['input']>;
  third_pillar_a_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  third_pillar_b_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tsv?: InputMaybe<Scalars['tsvector']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updates_daily_tasks?: InputMaybe<Scalars['Boolean']['input']>;
  updates_introduction_to_lead_contacts?: InputMaybe<Scalars['Boolean']['input']>;
  updates_new_lead_assigned_sms?: InputMaybe<Scalars['Boolean']['input']>;
  updates_newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  updates_property_revaluation?: InputMaybe<Scalars['Boolean']['input']>;
  user_images?: InputMaybe<InsertListingUserImagesArrRelInsertInput>;
  wedding_date?: InputMaybe<Scalars['date']['input']>;
  work_permit?: InputMaybe<InsertListingDictionariesObjRelInsertInput>;
  work_permit_id?: InputMaybe<Scalars['uuid']['input']>;
  yearly_revenues_at_retirement?: InputMaybe<Scalars['float8']['input']>;
};

export type InsertListingUsersObjRelInsertInput = {
  data: InsertListingUsersInsertInput;
  on_conflict?: InputMaybe<InsertListingUsersOnConflict>;
};

export type InsertListingUsersOnConflict = {
  constraint: InsertListingUsersConstraint;
  update_columns: Array<InsertListingUsersUpdateColumn>;
  where?: InputMaybe<InsertListingUsersBoolExp>;
};

export enum InsertListingUsersSelectColumn {
  /** column name */
  AccountManagerId = 'account_manager_id',
  /** column name */
  ActiveSince = 'active_since',
  /** column name */
  AgentSlug = 'agent_slug',
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualCredits = 'annual_credits',
  /** column name */
  AnnualCreditsExist = 'annual_credits_exist',
  /** column name */
  AnnualIncomeAdditionalExist = 'annual_income_additional_exist',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AnnualIncomeSalary = 'annual_income_salary',
  /** column name */
  AnnualIncomeSalary13 = 'annual_income_salary13',
  /** column name */
  AnnualIncomeSalary14 = 'annual_income_salary14',
  /** column name */
  AnnualLeasings = 'annual_leasings',
  /** column name */
  AnnualLeasingsExist = 'annual_leasings_exist',
  /** column name */
  AnnualOtherExist = 'annual_other_exist',
  /** column name */
  AnnualOtherPayments = 'annual_other_payments',
  /** column name */
  AssetsSavings = 'assets_savings',
  /** column name */
  AssetsSavingsDonation = 'assets_savings_donation',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  AssetsSecondPillarExist = 'assets_second_pillar_exist',
  /** column name */
  AssetsSecondPillarOrganisation = 'assets_second_pillar_organisation',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarA = 'assets_third_pillar_a',
  /** column name */
  AssetsThirdPillarAAnnualPremium = 'assets_third_pillar_a_annual_premium',
  /** column name */
  AssetsThirdPillarAAnnualPremiumOrganization = 'assets_third_pillar_a_annual_premium_organization',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  AssetsThirdPillarAExist = 'assets_third_pillar_a_exist',
  /** column name */
  AssetsThirdPillarALifeInsurance = 'assets_third_pillar_a_life_insurance',
  /** column name */
  AssetsThirdPillarAOrganisation = 'assets_third_pillar_a_organisation',
  /** column name */
  AssetsThirdPillarAOrganisationType = 'assets_third_pillar_a_organisation_type',
  /** column name */
  AssetsThirdPillarB = 'assets_third_pillar_b',
  /** column name */
  AssetsThirdPillarBAnnualPremium = 'assets_third_pillar_b_annual_premium',
  /** column name */
  AssetsThirdPillarBExist = 'assets_third_pillar_b_exist',
  /** column name */
  AssetsThirdPillarBLifeInsurance = 'assets_third_pillar_b_life_insurance',
  /** column name */
  AssetsThirdPillarBOrganisation = 'assets_third_pillar_b_organisation',
  /** column name */
  AssetsThirdPillarBOrganisationType = 'assets_third_pillar_b_organisation_type',
  /** column name */
  AssetsThirdPillarExist = 'assets_third_pillar_exist',
  /** column name */
  AutoAssignLeads = 'auto_assign_leads',
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  BrandingLogo = 'branding_logo',
  /** column name */
  BrandingName = 'branding_name',
  /** column name */
  BrandingWebsite = 'branding_website',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CanEditSettings = 'can_edit_settings',
  /** column name */
  CanUserLoginAs = 'can_user_login_as',
  /** column name */
  Certifications = 'certifications',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Debt = 'debt',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  DebtOtherCreditsBalance = 'debt_other_credits_balance',
  /** column name */
  DefaultTeamId = 'default_team_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  DivorceDate = 'divorce_date',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmailSignature = 'email_signature',
  /** column name */
  EmailSignatureHtml = 'email_signature_html',
  /** column name */
  Employer = 'employer',
  /** column name */
  EmployerId = 'employer_id',
  /** column name */
  EmploymentCommencementDate = 'employment_commencement_date',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  FacebookProfile = 'facebook_profile',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasChildren = 'has_children',
  /** column name */
  HasFreeCrmAccess = 'has_free_crm_access',
  /** column name */
  HasUsedTrialButton = 'has_used_trial_button',
  /** column name */
  HomeAddressCountryCode = 'home_address_country_code',
  /** column name */
  HomeAddressLat = 'home_address_lat',
  /** column name */
  HomeAddressLng = 'home_address_lng',
  /** column name */
  HomeAddressLocality = 'home_address_locality',
  /** column name */
  HomeAddressPostcode = 'home_address_postcode',
  /** column name */
  HomeAddressRoute = 'home_address_route',
  /** column name */
  HomeAddressState = 'home_address_state',
  /** column name */
  HomeAddressStreetNumber = 'home_address_street_number',
  /** column name */
  Id = 'id',
  /** column name */
  IdentificationDocumentExpiryDate = 'identification_document_expiry_date',
  /** column name */
  IdentificationDocumentIssueDate = 'identification_document_issue_date',
  /** column name */
  IdentificationDocumentNumber = 'identification_document_number',
  /** column name */
  IdentificationDocumentTypeId = 'identification_document_type_id',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  IsBot = 'is_bot',
  /** column name */
  IsBroker = 'is_broker',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMortgageBroker = 'is_mortgage_broker',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  LandingPageUrl = 'landing_page_url',
  /** column name */
  Language = 'language',
  /** column name */
  Languages = 'languages',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LinkedInProfile = 'linked_in_profile',
  /** column name */
  MaritalPartnerId = 'marital_partner_id',
  /** column name */
  MaritalStatus = 'marital_status',
  /** column name */
  MatrimonialRegime = 'matrimonial_regime',
  /** column name */
  MembershipType = 'membership_type',
  /** column name */
  Modules = 'modules',
  /** column name */
  MortgageBrokerId = 'mortgage_broker_id',
  /** column name */
  NationalityId = 'nationality_id',
  /** column name */
  NumberOfBuyers = 'number_of_buyers',
  /** column name */
  NumberOfDependantChildren = 'number_of_dependant_children',
  /** column name */
  OccupationId = 'occupation_id',
  /** column name */
  OccupationText = 'occupation_text',
  /** column name */
  PlaceOfOrigin = 'place_of_origin',
  /** column name */
  ProfessionalAddressCountryCode = 'professional_address_country_code',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  ProfessionalAddressLocality = 'professional_address_locality',
  /** column name */
  ProfessionalAddressPostcode = 'professional_address_postcode',
  /** column name */
  ProfessionalAddressRoute = 'professional_address_route',
  /** column name */
  ProfessionalAddressState = 'professional_address_state',
  /** column name */
  ProfessionalAddressStreetNumber = 'professional_address_street_number',
  /** column name */
  ProfessionalSituation = 'professional_situation',
  /** column name */
  PropertiesExist = 'properties_exist',
  /** column name */
  RecommendedListings = 'recommended_listings',
  /** column name */
  Referrer = 'referrer',
  /** column name */
  ReferringDomain = 'referring_domain',
  /** column name */
  RegisteredAt = 'registered_at',
  /** column name */
  ResidenceCountryCode = 'residence_country_code',
  /** column name */
  ResidenceStateId = 'residence_state_id',
  /** column name */
  SecondPillarOrganisationId = 'second_pillar_organisation_id',
  /** column name */
  Services = 'services',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  SocialSecurityNumber = 'social_security_number',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPillarAAnnualPremiumOrganizationId = 'third_pillar_a_annual_premium_organization_id',
  /** column name */
  ThirdPillarAOrganisationId = 'third_pillar_a_organisation_id',
  /** column name */
  ThirdPillarBOrganisationId = 'third_pillar_b_organisation_id',
  /** column name */
  Title = 'title',
  /** column name */
  Tsv = 'tsv',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatesDailyTasks = 'updates_daily_tasks',
  /** column name */
  UpdatesIntroductionToLeadContacts = 'updates_introduction_to_lead_contacts',
  /** column name */
  UpdatesNewLeadAssignedSms = 'updates_new_lead_assigned_sms',
  /** column name */
  UpdatesNewsletter = 'updates_newsletter',
  /** column name */
  UpdatesPropertyRevaluation = 'updates_property_revaluation',
  /** column name */
  WeddingDate = 'wedding_date',
  /** column name */
  WorkPermitId = 'work_permit_id',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  AnnualCreditsExist = 'annual_credits_exist',
  /** column name */
  AnnualIncomeAdditionalExist = 'annual_income_additional_exist',
  /** column name */
  AnnualIncomeSalary13 = 'annual_income_salary13',
  /** column name */
  AnnualIncomeSalary14 = 'annual_income_salary14',
  /** column name */
  AnnualLeasingsExist = 'annual_leasings_exist',
  /** column name */
  AnnualOtherExist = 'annual_other_exist',
  /** column name */
  AssetsSecondPillarExist = 'assets_second_pillar_exist',
  /** column name */
  AssetsThirdPillarAExist = 'assets_third_pillar_a_exist',
  /** column name */
  AssetsThirdPillarALifeInsurance = 'assets_third_pillar_a_life_insurance',
  /** column name */
  AssetsThirdPillarBExist = 'assets_third_pillar_b_exist',
  /** column name */
  AssetsThirdPillarBLifeInsurance = 'assets_third_pillar_b_life_insurance',
  /** column name */
  AssetsThirdPillarExist = 'assets_third_pillar_exist',
  /** column name */
  AutoAssignLeads = 'auto_assign_leads',
  /** column name */
  CanEditSettings = 'can_edit_settings',
  /** column name */
  CanUserLoginAs = 'can_user_login_as',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasChildren = 'has_children',
  /** column name */
  HasFreeCrmAccess = 'has_free_crm_access',
  /** column name */
  HasUsedTrialButton = 'has_used_trial_button',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  IsBot = 'is_bot',
  /** column name */
  IsBroker = 'is_broker',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMortgageBroker = 'is_mortgage_broker',
  /** column name */
  PropertiesExist = 'properties_exist',
  /** column name */
  RecommendedListings = 'recommended_listings',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  UpdatesDailyTasks = 'updates_daily_tasks',
  /** column name */
  UpdatesIntroductionToLeadContacts = 'updates_introduction_to_lead_contacts',
  /** column name */
  UpdatesNewLeadAssignedSms = 'updates_new_lead_assigned_sms',
  /** column name */
  UpdatesNewsletter = 'updates_newsletter',
  /** column name */
  UpdatesPropertyRevaluation = 'updates_property_revaluation'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  AnnualCreditsExist = 'annual_credits_exist',
  /** column name */
  AnnualIncomeAdditionalExist = 'annual_income_additional_exist',
  /** column name */
  AnnualIncomeSalary13 = 'annual_income_salary13',
  /** column name */
  AnnualIncomeSalary14 = 'annual_income_salary14',
  /** column name */
  AnnualLeasingsExist = 'annual_leasings_exist',
  /** column name */
  AnnualOtherExist = 'annual_other_exist',
  /** column name */
  AssetsSecondPillarExist = 'assets_second_pillar_exist',
  /** column name */
  AssetsThirdPillarAExist = 'assets_third_pillar_a_exist',
  /** column name */
  AssetsThirdPillarALifeInsurance = 'assets_third_pillar_a_life_insurance',
  /** column name */
  AssetsThirdPillarBExist = 'assets_third_pillar_b_exist',
  /** column name */
  AssetsThirdPillarBLifeInsurance = 'assets_third_pillar_b_life_insurance',
  /** column name */
  AssetsThirdPillarExist = 'assets_third_pillar_exist',
  /** column name */
  AutoAssignLeads = 'auto_assign_leads',
  /** column name */
  CanEditSettings = 'can_edit_settings',
  /** column name */
  CanUserLoginAs = 'can_user_login_as',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasChildren = 'has_children',
  /** column name */
  HasFreeCrmAccess = 'has_free_crm_access',
  /** column name */
  HasUsedTrialButton = 'has_used_trial_button',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  IsBot = 'is_bot',
  /** column name */
  IsBroker = 'is_broker',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMortgageBroker = 'is_mortgage_broker',
  /** column name */
  PropertiesExist = 'properties_exist',
  /** column name */
  RecommendedListings = 'recommended_listings',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  UpdatesDailyTasks = 'updates_daily_tasks',
  /** column name */
  UpdatesIntroductionToLeadContacts = 'updates_introduction_to_lead_contacts',
  /** column name */
  UpdatesNewLeadAssignedSms = 'updates_new_lead_assigned_sms',
  /** column name */
  UpdatesNewsletter = 'updates_newsletter',
  /** column name */
  UpdatesPropertyRevaluation = 'updates_property_revaluation'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpMinArgumentsColumns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpSumArgumentsColumns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingUsersUpdateColumn {
  /** column name */
  AccountManagerId = 'account_manager_id',
  /** column name */
  ActiveSince = 'active_since',
  /** column name */
  AgentSlug = 'agent_slug',
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualCredits = 'annual_credits',
  /** column name */
  AnnualCreditsExist = 'annual_credits_exist',
  /** column name */
  AnnualIncomeAdditionalExist = 'annual_income_additional_exist',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AnnualIncomeSalary = 'annual_income_salary',
  /** column name */
  AnnualIncomeSalary13 = 'annual_income_salary13',
  /** column name */
  AnnualIncomeSalary14 = 'annual_income_salary14',
  /** column name */
  AnnualLeasings = 'annual_leasings',
  /** column name */
  AnnualLeasingsExist = 'annual_leasings_exist',
  /** column name */
  AnnualOtherExist = 'annual_other_exist',
  /** column name */
  AnnualOtherPayments = 'annual_other_payments',
  /** column name */
  AssetsSavings = 'assets_savings',
  /** column name */
  AssetsSavingsDonation = 'assets_savings_donation',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  AssetsSecondPillarExist = 'assets_second_pillar_exist',
  /** column name */
  AssetsSecondPillarOrganisation = 'assets_second_pillar_organisation',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarA = 'assets_third_pillar_a',
  /** column name */
  AssetsThirdPillarAAnnualPremium = 'assets_third_pillar_a_annual_premium',
  /** column name */
  AssetsThirdPillarAAnnualPremiumOrganization = 'assets_third_pillar_a_annual_premium_organization',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  AssetsThirdPillarAExist = 'assets_third_pillar_a_exist',
  /** column name */
  AssetsThirdPillarALifeInsurance = 'assets_third_pillar_a_life_insurance',
  /** column name */
  AssetsThirdPillarAOrganisation = 'assets_third_pillar_a_organisation',
  /** column name */
  AssetsThirdPillarAOrganisationType = 'assets_third_pillar_a_organisation_type',
  /** column name */
  AssetsThirdPillarB = 'assets_third_pillar_b',
  /** column name */
  AssetsThirdPillarBAnnualPremium = 'assets_third_pillar_b_annual_premium',
  /** column name */
  AssetsThirdPillarBExist = 'assets_third_pillar_b_exist',
  /** column name */
  AssetsThirdPillarBLifeInsurance = 'assets_third_pillar_b_life_insurance',
  /** column name */
  AssetsThirdPillarBOrganisation = 'assets_third_pillar_b_organisation',
  /** column name */
  AssetsThirdPillarBOrganisationType = 'assets_third_pillar_b_organisation_type',
  /** column name */
  AssetsThirdPillarExist = 'assets_third_pillar_exist',
  /** column name */
  AutoAssignLeads = 'auto_assign_leads',
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  BrandingLogo = 'branding_logo',
  /** column name */
  BrandingName = 'branding_name',
  /** column name */
  BrandingWebsite = 'branding_website',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CanEditSettings = 'can_edit_settings',
  /** column name */
  CanUserLoginAs = 'can_user_login_as',
  /** column name */
  Certifications = 'certifications',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Debt = 'debt',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  DebtOtherCreditsBalance = 'debt_other_credits_balance',
  /** column name */
  DefaultTeamId = 'default_team_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  DivorceDate = 'divorce_date',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmailSignature = 'email_signature',
  /** column name */
  EmailSignatureHtml = 'email_signature_html',
  /** column name */
  Employer = 'employer',
  /** column name */
  EmployerId = 'employer_id',
  /** column name */
  EmploymentCommencementDate = 'employment_commencement_date',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  FacebookProfile = 'facebook_profile',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasChildren = 'has_children',
  /** column name */
  HasFreeCrmAccess = 'has_free_crm_access',
  /** column name */
  HasUsedTrialButton = 'has_used_trial_button',
  /** column name */
  HomeAddressCountryCode = 'home_address_country_code',
  /** column name */
  HomeAddressLat = 'home_address_lat',
  /** column name */
  HomeAddressLng = 'home_address_lng',
  /** column name */
  HomeAddressLocality = 'home_address_locality',
  /** column name */
  HomeAddressPostcode = 'home_address_postcode',
  /** column name */
  HomeAddressRoute = 'home_address_route',
  /** column name */
  HomeAddressState = 'home_address_state',
  /** column name */
  HomeAddressStreetNumber = 'home_address_street_number',
  /** column name */
  Id = 'id',
  /** column name */
  IdentificationDocumentExpiryDate = 'identification_document_expiry_date',
  /** column name */
  IdentificationDocumentIssueDate = 'identification_document_issue_date',
  /** column name */
  IdentificationDocumentNumber = 'identification_document_number',
  /** column name */
  IdentificationDocumentTypeId = 'identification_document_type_id',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  IsBot = 'is_bot',
  /** column name */
  IsBroker = 'is_broker',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMortgageBroker = 'is_mortgage_broker',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  LandingPageUrl = 'landing_page_url',
  /** column name */
  Language = 'language',
  /** column name */
  Languages = 'languages',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LinkedInProfile = 'linked_in_profile',
  /** column name */
  MaritalPartnerId = 'marital_partner_id',
  /** column name */
  MaritalStatus = 'marital_status',
  /** column name */
  MatrimonialRegime = 'matrimonial_regime',
  /** column name */
  MembershipType = 'membership_type',
  /** column name */
  Modules = 'modules',
  /** column name */
  MortgageBrokerId = 'mortgage_broker_id',
  /** column name */
  NationalityId = 'nationality_id',
  /** column name */
  NumberOfBuyers = 'number_of_buyers',
  /** column name */
  NumberOfDependantChildren = 'number_of_dependant_children',
  /** column name */
  OccupationId = 'occupation_id',
  /** column name */
  OccupationText = 'occupation_text',
  /** column name */
  PlaceOfOrigin = 'place_of_origin',
  /** column name */
  ProfessionalAddressCountryCode = 'professional_address_country_code',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  ProfessionalAddressLocality = 'professional_address_locality',
  /** column name */
  ProfessionalAddressPostcode = 'professional_address_postcode',
  /** column name */
  ProfessionalAddressRoute = 'professional_address_route',
  /** column name */
  ProfessionalAddressState = 'professional_address_state',
  /** column name */
  ProfessionalAddressStreetNumber = 'professional_address_street_number',
  /** column name */
  ProfessionalSituation = 'professional_situation',
  /** column name */
  PropertiesExist = 'properties_exist',
  /** column name */
  RecommendedListings = 'recommended_listings',
  /** column name */
  Referrer = 'referrer',
  /** column name */
  ReferringDomain = 'referring_domain',
  /** column name */
  RegisteredAt = 'registered_at',
  /** column name */
  ResidenceCountryCode = 'residence_country_code',
  /** column name */
  ResidenceStateId = 'residence_state_id',
  /** column name */
  SecondPillarOrganisationId = 'second_pillar_organisation_id',
  /** column name */
  Services = 'services',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  SocialSecurityNumber = 'social_security_number',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPillarAAnnualPremiumOrganizationId = 'third_pillar_a_annual_premium_organization_id',
  /** column name */
  ThirdPillarAOrganisationId = 'third_pillar_a_organisation_id',
  /** column name */
  ThirdPillarBOrganisationId = 'third_pillar_b_organisation_id',
  /** column name */
  Title = 'title',
  /** column name */
  Tsv = 'tsv',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatesDailyTasks = 'updates_daily_tasks',
  /** column name */
  UpdatesIntroductionToLeadContacts = 'updates_introduction_to_lead_contacts',
  /** column name */
  UpdatesNewLeadAssignedSms = 'updates_new_lead_assigned_sms',
  /** column name */
  UpdatesNewsletter = 'updates_newsletter',
  /** column name */
  UpdatesPropertyRevaluation = 'updates_property_revaluation',
  /** column name */
  WeddingDate = 'wedding_date',
  /** column name */
  WorkPermitId = 'work_permit_id',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export type InsertListingUuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type InsertListingValuationModelsBoolExp = {
  _and?: InputMaybe<Array<InsertListingValuationModelsBoolExp>>;
  _not?: InputMaybe<InsertListingValuationModelsBoolExp>;
  _or?: InputMaybe<Array<InsertListingValuationModelsBoolExp>>;
  country_codes?: InputMaybe<InsertListingJsonbComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  password?: InputMaybe<InsertListingStringComparisonExp>;
  short_name?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  username?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingValuationModelsConstraint {
  /** unique or primary key constraint on columns "name" */
  ValuationModelsPkey = 'valuation_models_pkey'
}

export type InsertListingValuationModelsInsertInput = {
  country_codes?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingValuationModelsObjRelInsertInput = {
  data: InsertListingValuationModelsInsertInput;
  on_conflict?: InputMaybe<InsertListingValuationModelsOnConflict>;
};

export type InsertListingValuationModelsOnConflict = {
  constraint: InsertListingValuationModelsConstraint;
  update_columns: Array<InsertListingValuationModelsUpdateColumn>;
  where?: InputMaybe<InsertListingValuationModelsBoolExp>;
};

export enum InsertListingValuationModelsUpdateColumn {
  /** column name */
  CountryCodes = 'country_codes',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Username = 'username'
}

export type InsertListingValuationsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingValuationsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingValuationsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingValuationsAggregateBoolExpCount>;
};

export type InsertListingValuationsAggregateBoolExpBoolAnd = {
  arguments: InsertListingValuationsSelectColumnValuationsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingValuationsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingValuationsAggregateBoolExpBoolOr = {
  arguments: InsertListingValuationsSelectColumnValuationsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingValuationsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingValuationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingValuationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingValuationsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingValuationsArrRelInsertInput = {
  data: Array<InsertListingValuationsInsertInput>;
  on_conflict?: InputMaybe<InsertListingValuationsOnConflict>;
};

export type InsertListingValuationsBoolExp = {
  _and?: InputMaybe<Array<InsertListingValuationsBoolExp>>;
  _not?: InputMaybe<InsertListingValuationsBoolExp>;
  _or?: InputMaybe<Array<InsertListingValuationsBoolExp>>;
  appraisal?: InputMaybe<InsertListingAppraisalsBoolExp>;
  appraisal_id?: InputMaybe<InsertListingUuidComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  input_payload?: InputMaybe<InsertListingJsonbComparisonExp>;
  is_rental?: InputMaybe<InsertListingBooleanComparisonExp>;
  max?: InputMaybe<InsertListingFloatComparisonExp>;
  min?: InputMaybe<InsertListingFloatComparisonExp>;
  model?: InputMaybe<InsertListingStringComparisonExp>;
  model_version?: InputMaybe<InsertListingStringComparisonExp>;
  output_payload?: InputMaybe<InsertListingJsonbComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  use_in_calculations?: InputMaybe<InsertListingBooleanComparisonExp>;
  valuation_model?: InputMaybe<InsertListingValuationModelsBoolExp>;
  value?: InputMaybe<InsertListingFloatComparisonExp>;
};

export enum InsertListingValuationsConstraint {
  /** unique or primary key constraint on columns "id" */
  ValuationsPkey = 'valuations_pkey'
}

export type InsertListingValuationsInsertInput = {
  appraisal?: InputMaybe<InsertListingAppraisalsObjRelInsertInput>;
  appraisal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  input_payload?: InputMaybe<Scalars['jsonb']['input']>;
  is_rental?: InputMaybe<Scalars['Boolean']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  model_version?: InputMaybe<Scalars['String']['input']>;
  output_payload?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_in_calculations?: InputMaybe<Scalars['Boolean']['input']>;
  valuation_model?: InputMaybe<InsertListingValuationModelsObjRelInsertInput>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type InsertListingValuationsOnConflict = {
  constraint: InsertListingValuationsConstraint;
  update_columns: Array<InsertListingValuationsUpdateColumn>;
  where?: InputMaybe<InsertListingValuationsBoolExp>;
};

export enum InsertListingValuationsSelectColumn {
  /** column name */
  AppraisalId = 'appraisal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InputPayload = 'input_payload',
  /** column name */
  IsRental = 'is_rental',
  /** column name */
  Max = 'max',
  /** column name */
  Min = 'min',
  /** column name */
  Model = 'model',
  /** column name */
  ModelVersion = 'model_version',
  /** column name */
  OutputPayload = 'output_payload',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseInCalculations = 'use_in_calculations',
  /** column name */
  Value = 'value'
}

export enum InsertListingValuationsSelectColumnValuationsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsRental = 'is_rental',
  /** column name */
  UseInCalculations = 'use_in_calculations'
}

export enum InsertListingValuationsSelectColumnValuationsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsRental = 'is_rental',
  /** column name */
  UseInCalculations = 'use_in_calculations'
}

export enum InsertListingValuationsUpdateColumn {
  /** column name */
  AppraisalId = 'appraisal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InputPayload = 'input_payload',
  /** column name */
  IsRental = 'is_rental',
  /** column name */
  Max = 'max',
  /** column name */
  Min = 'min',
  /** column name */
  Model = 'model',
  /** column name */
  ModelVersion = 'model_version',
  /** column name */
  OutputPayload = 'output_payload',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseInCalculations = 'use_in_calculations',
  /** column name */
  Value = 'value'
}

export type InsertPoisOneInput = {
  category: Scalars['String']['input'];
  distance: Scalars['Float']['input'];
  formattedAddress: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  primaryType: Scalars['String']['input'];
  propertyId: Scalars['uuid']['input'];
  types: Array<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LotImportInput = {
  available_from?: InputMaybe<Scalars['date']['input']>;
  brochure_description?: InputMaybe<Scalars['String']['input']>;
  brochure_title?: InputMaybe<Scalars['String']['input']>;
  broker_email?: InputMaybe<Scalars['String']['input']>;
  broker_imported_id?: InputMaybe<Scalars['String']['input']>;
  commission_rate?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration_in_months?: InputMaybe<Scalars['Int']['input']>;
  enquiry_response_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  expected_time_to_sell?: InputMaybe<Scalars['String']['input']>;
  fixed_fee?: InputMaybe<Scalars['Int']['input']>;
  has_success_fee?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_portals?: InputMaybe<Scalars['Boolean']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  is_exclusive?: InputMaybe<Scalars['Boolean']['input']>;
  is_sales_tax_inclusive?: InputMaybe<Scalars['Boolean']['input']>;
  lot_reference?: InputMaybe<Scalars['String']['input']>;
  mandate_sale_price?: InputMaybe<Scalars['Float']['input']>;
  mandate_type?: InputMaybe<Scalars['String']['input']>;
  minimum_net_seller_price?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_computed?: InputMaybe<Scalars['Float']['input']>;
  offer_type?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  price_unit?: InputMaybe<Scalars['String']['input']>;
  property_balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  property_basement_surface?: InputMaybe<Scalars['Float']['input']>;
  property_building_condition?: InputMaybe<Scalars['Int']['input']>;
  property_building_volume?: InputMaybe<Scalars['Float']['input']>;
  property_building_volume_norm?: InputMaybe<Scalars['String']['input']>;
  property_built_surface?: InputMaybe<Scalars['Float']['input']>;
  property_ceiling_height?: InputMaybe<Scalars['Float']['input']>;
  property_commercial_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  property_commercial_surface?: InputMaybe<Scalars['Float']['input']>;
  property_commercial_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  property_construction_year?: InputMaybe<Scalars['Int']['input']>;
  property_cooling?: InputMaybe<Scalars['String']['input']>;
  property_country?: InputMaybe<Scalars['String']['input']>;
  property_country_code?: InputMaybe<Scalars['String']['input']>;
  property_emissions?: InputMaybe<Scalars['Float']['input']>;
  property_energy_certificate_version?: InputMaybe<Scalars['String']['input']>;
  property_energy_consumption_class?: InputMaybe<Scalars['String']['input']>;
  property_energy_inspection_date?: InputMaybe<Scalars['date']['input']>;
  property_energy_reference_year?: InputMaybe<Scalars['Int']['input']>;
  property_estimated_higher_energy_cost?: InputMaybe<Scalars['Float']['input']>;
  property_estimated_lower_energy_cost?: InputMaybe<Scalars['Float']['input']>;
  property_flat_condition?: InputMaybe<Scalars['Int']['input']>;
  property_floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  property_garden_surface?: InputMaybe<Scalars['Float']['input']>;
  property_gas_emissions_class?: InputMaybe<Scalars['String']['input']>;
  property_gross_floor_surface?: InputMaybe<Scalars['Float']['input']>;
  property_has_attic?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_cellar?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_gym?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_photovoltaic_panels?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_sauna?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_storage_room?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_view?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_wellness_area?: InputMaybe<Scalars['Boolean']['input']>;
  property_heating?: InputMaybe<Scalars['String']['input']>;
  property_heating_distribution?: InputMaybe<Scalars['String']['input']>;
  property_income_includes_parking?: InputMaybe<Scalars['Boolean']['input']>;
  property_is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  property_is_commercial_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  property_is_luxury?: InputMaybe<Scalars['Boolean']['input']>;
  property_is_maisonette?: InputMaybe<Scalars['Boolean']['input']>;
  property_is_parking_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  property_is_rental?: InputMaybe<Scalars['Boolean']['input']>;
  property_is_residential_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  property_is_secondary_residence?: InputMaybe<Scalars['Boolean']['input']>;
  property_is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  property_land_surface?: InputMaybe<Scalars['Float']['input']>;
  property_lat?: InputMaybe<Scalars['Float']['input']>;
  property_living_surface?: InputMaybe<Scalars['Float']['input']>;
  property_lng?: InputMaybe<Scalars['Float']['input']>;
  property_locality?: InputMaybe<Scalars['String']['input']>;
  property_macro_location?: InputMaybe<Scalars['Float']['input']>;
  property_micro_location?: InputMaybe<Scalars['Float']['input']>;
  property_minergie_code?: InputMaybe<Scalars['Int']['input']>;
  property_number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  property_number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  property_number_of_commercial_units?: InputMaybe<Scalars['Int']['input']>;
  property_number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  property_number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  property_number_of_lifts?: InputMaybe<Scalars['Int']['input']>;
  property_number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  property_number_of_residential_units?: InputMaybe<Scalars['Int']['input']>;
  property_number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  property_number_of_toilets?: InputMaybe<Scalars['Int']['input']>;
  property_orientation?: InputMaybe<Scalars['String']['input']>;
  property_parking_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  property_parking_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  property_plot_has_constructible_reserve?: InputMaybe<Scalars['Boolean']['input']>;
  property_plot_is_constructible?: InputMaybe<Scalars['Boolean']['input']>;
  property_plot_number?: InputMaybe<Scalars['String']['input']>;
  property_plot_registry_number?: InputMaybe<Scalars['String']['input']>;
  property_postcode?: InputMaybe<Scalars['String']['input']>;
  property_property_images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property_property_type_name?: InputMaybe<Scalars['String']['input']>;
  property_renovation_fund?: InputMaybe<Scalars['Float']['input']>;
  property_renovation_year?: InputMaybe<Scalars['Int']['input']>;
  property_residential_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  property_residential_surface?: InputMaybe<Scalars['Float']['input']>;
  property_residential_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  property_route?: InputMaybe<Scalars['String']['input']>;
  property_share_of_ownership?: InputMaybe<Scalars['Float']['input']>;
  property_state?: InputMaybe<Scalars['String']['input']>;
  property_street_number?: InputMaybe<Scalars['String']['input']>;
  property_terrace_surface?: InputMaybe<Scalars['Float']['input']>;
  property_usable_surface?: InputMaybe<Scalars['Float']['input']>;
  property_weighted_floor_surface?: InputMaybe<Scalars['Float']['input']>;
  rent_extra?: InputMaybe<Scalars['Float']['input']>;
  rent_net?: InputMaybe<Scalars['Float']['input']>;
  sale_price?: InputMaybe<Scalars['Float']['input']>;
  send_enquiries_to_sellers?: InputMaybe<Scalars['Boolean']['input']>;
  shared_on_mls?: InputMaybe<Scalars['Boolean']['input']>;
  signed_at?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  success_fee_custom?: InputMaybe<Scalars['String']['input']>;
  success_fee_percentage?: InputMaybe<Scalars['Float']['input']>;
  success_fee_type?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  use_custom_brochure_description?: InputMaybe<Scalars['Boolean']['input']>;
  use_custom_brochure_title?: InputMaybe<Scalars['Boolean']['input']>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  virtual_visit_url?: InputMaybe<Scalars['String']['input']>;
};

export type LotImportOutput = {
  lot_id?: Maybe<Scalars['uuid']['output']>;
};

export type MonthlyCost = {
  amortization: Scalars['Float']['output'];
  interest: Scalars['Float']['output'];
  maintenance: Scalars['Float']['output'];
  total?: Maybe<Scalars['Float']['output']>;
};

export type MortgageAnalysis = {
  affordability_rate?: Maybe<Scalars['Float']['output']>;
  interest_rate: Scalars['Float']['output'];
  is_simulated: Scalars['Boolean']['output'];
  loan_amount?: Maybe<Scalars['Float']['output']>;
  ltv?: Maybe<Scalars['Float']['output']>;
  max_property_value?: Maybe<Scalars['Float']['output']>;
  monthly_cost: MonthlyCost;
  net_available_cash?: Maybe<Scalars['Float']['output']>;
  situation?: Maybe<Scalars['String']['output']>;
  total_charges?: Maybe<Scalars['Float']['output']>;
  total_revenues?: Maybe<Scalars['Float']['output']>;
};

export type MortgageOutput = {
  mortgage_analysis?: Maybe<MortgageAnalysis>;
};

export type OrderBuyerLeadOutput = {
  buyer_lead?: Maybe<Buyer_Leads>;
  id: Scalars['uuid']['output'];
};

export enum OrderBuyerLeadSource {
  Development = 'development',
  Lot = 'lot',
  User = 'user'
}

export type Place = {
  category: Scalars['String']['output'];
  distance: Scalars['Int']['output'];
  formattedAddress: Scalars['String']['output'];
  id: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  primaryType: Scalars['String']['output'];
  types: Array<Scalars['String']['output']>;
};

export type PortalListing = {
  created_at: Scalars['timestamptz']['output'];
  external_property_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  last_publication_warnings?: Maybe<Scalars['jsonb']['output']>;
  live: Scalars['Boolean']['output'];
  lot?: Maybe<Lots>;
  lot_id: Scalars['uuid']['output'];
  milliseconds_online: Scalars['Float']['output'];
  portal_id: Scalars['uuid']['output'];
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

export type PreparedUpload = {
  id: Scalars['String']['output'];
  signed_url: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PropertyAppraisableOutput = {
  appraisable: AppraisableResult;
};

export type PropertyAppraisalInput = {
  address: AddressInput;
  balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  building_condition?: InputMaybe<Scalars['Int']['input']>;
  building_volume?: InputMaybe<Scalars['Float']['input']>;
  built_surface?: InputMaybe<Scalars['Float']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  garden_surface?: InputMaybe<Scalars['Float']['input']>;
  has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  is_secondary_residence?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  living_surface: Scalars['Float']['input'];
  number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_toilets?: InputMaybe<Scalars['Int']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  property_type: PropertyType;
  renovation_year?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  terrace_surface?: InputMaybe<Scalars['Float']['input']>;
  usable_surface?: InputMaybe<Scalars['Float']['input']>;
};

export type PropertyAppraisalOutput = {
  id: Scalars['ID']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  property_id: Scalars['ID']['output'];
  updated_at: Scalars['String']['output'];
  valuations: Array<Valuation>;
  value: Scalars['Float']['output'];
};

export type PropertySearchImportInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  land_surface_gte?: InputMaybe<Scalars['Int']['input']>;
  land_surface_lte?: InputMaybe<Scalars['Int']['input']>;
  living_surface_gte?: InputMaybe<Scalars['Int']['input']>;
  living_surface_lte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_gte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_lte?: InputMaybe<Scalars['Int']['input']>;
  notification: Scalars['String']['input'];
  number_of_bedrooms_gte?: InputMaybe<Scalars['Float']['input']>;
  number_of_bedrooms_lte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_gte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_lte?: InputMaybe<Scalars['Float']['input']>;
  offer_type: Scalars['String']['input'];
  places: Array<Scalars['String']['input']>;
  property_main_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  property_usage?: InputMaybe<Scalars['String']['input']>;
  sale_price_gte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_lte?: InputMaybe<Scalars['Int']['input']>;
  source: Scalars['String']['input'];
};

export type PropertySearchImportOutput = {
  property_search?: Maybe<Property_Searches>;
  property_search_id?: Maybe<Scalars['uuid']['output']>;
};

export enum PropertyType {
  ApartmentDuplex = 'apartment_duplex',
  ApartmentNormal = 'apartment_normal',
  ApartmentPenthouse = 'apartment_penthouse',
  ApartmentPenthouseDuplex = 'apartment_penthouse_duplex',
  HouseAttachedEnd = 'house_attached_end',
  HouseAttachedMiddle = 'house_attached_middle',
  HouseDetached = 'house_detached',
  HouseSemiDetached = 'house_semi_detached'
}

export type QualifyingAgent = {
  already_assigned?: Maybe<Scalars['Boolean']['output']>;
  amount_spent?: Maybe<Scalars['Float']['output']>;
  assigned_leads?: Maybe<Scalars['Float']['output']>;
  auto_assign_leads?: Maybe<Scalars['Boolean']['output']>;
  cost_per_lead?: Maybe<Scalars['Float']['output']>;
  crm_link?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  subscriptions?: Maybe<Array<Maybe<CurrentSubscription>>>;
};

export type ReferenceAlias = {
  alias: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
};

export type SlackNotificationOutput = {
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StartReviewGoogleAddressInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  place_type?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
};

export type StartReviewResponse = {
  id: Scalars['uuid']['output'];
  success: Scalars['Boolean']['output'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type SyncDictionaryEnumsOutput = {
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdatePortalListing = {
  success: Scalars['Boolean']['output'];
  warnings?: Maybe<Scalars['jsonb']['output']>;
};

export type ValidateInvitationOutput = {
  magic_token?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

export type Valuation = {
  id: Scalars['ID']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  model: Scalars['String']['output'];
  valuation_model: ValuationModel;
  value: Scalars['Float']['output'];
};

export type ValuationLinkOutput = {
  agent_id?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  landing_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  survey_id?: Maybe<Scalars['String']['output']>;
  valuation_url?: Maybe<Scalars['String']['output']>;
};

export type ValuationModel = {
  name: Scalars['String']['output'];
  short_name?: Maybe<Scalars['String']['output']>;
};

export type ValuePropertyOutput = {
  appraisal?: Maybe<Appraisals>;
  appraisal_id: Scalars['uuid']['output'];
};

/** Boolean expression to compare columns of type "_float8". All fields are combined with logical 'AND'. */
export type _Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_float8']['input']>;
  _gt?: InputMaybe<Scalars['_float8']['input']>;
  _gte?: InputMaybe<Scalars['_float8']['input']>;
  _in?: InputMaybe<Array<Scalars['_float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['_float8']['input']>;
  _lte?: InputMaybe<Scalars['_float8']['input']>;
  _neq?: InputMaybe<Scalars['_float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['_float8']['input']>>;
};

/** columns and relationships of "activities" */
export type Activities = {
  /** An array relationship */
  activities_target_users: Array<Activities_Target_Users>;
  activity_type: Activity_Types_Enum_Enum;
  appraisal_id?: Maybe<Scalars['uuid']['output']>;
  assigned_to?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  assignee?: Maybe<Users>;
  /** An object relationship */
  buyer_lead?: Maybe<Buyer_Leads>;
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  calendar_event_id?: Maybe<Scalars['uuid']['output']>;
  consolidated_done_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  creator?: Maybe<Users>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  done: Scalars['Boolean']['output'];
  done_at?: Maybe<Scalars['timestamptz']['output']>;
  due_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  email_message?: Maybe<Email_Messages>;
  email_message_id?: Maybe<Scalars['uuid']['output']>;
  end_at?: Maybe<Scalars['timestamptz']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  enquiry_id?: Maybe<Scalars['uuid']['output']>;
  extra_data?: Maybe<Scalars['jsonb']['output']>;
  financing_request_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** A computed field, executes function "is_overdue" */
  is_overdue?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  lead?: Maybe<Leads>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  lot?: Maybe<Lots>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  offer_id?: Maybe<Scalars['uuid']['output']>;
  offer_status?: Maybe<Scalars['String']['output']>;
  pinned: Scalars['Boolean']['output'];
  start_date?: Maybe<Scalars['date']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  synced_from_calendar: Scalars['Boolean']['output'];
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id?: Maybe<Scalars['uuid']['output']>;
  visibility: Scalars['String']['output'];
};


/** columns and relationships of "activities" */
export type ActivitiesActivities_Target_UsersArgs = {
  distinct_on?: InputMaybe<Array<Activities_Target_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Target_Users_Order_By>>;
  where?: InputMaybe<Activities_Target_Users_Bool_Exp>;
};


/** columns and relationships of "activities" */
export type ActivitiesExtra_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "activities" */
export type Activities_Aggregate = {
  aggregate?: Maybe<Activities_Aggregate_Fields>;
  nodes: Array<Activities>;
};

export type Activities_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Activities_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Activities_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Activities_Aggregate_Bool_Exp_Count>;
};

export type Activities_Aggregate_Bool_Exp_Bool_And = {
  arguments: Activities_Select_Column_Activities_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Activities_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Activities_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Activities_Select_Column_Activities_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Activities_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Activities_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Activities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Activities_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "activities" */
export type Activities_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Activities_Max_Fields>;
  min?: Maybe<Activities_Min_Fields>;
};


/** aggregate fields of "activities" */
export type Activities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Activities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "activities" */
export type Activities_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Activities_Max_Order_By>;
  min?: InputMaybe<Activities_Min_Order_By>;
};

/** input type for inserting array relation for remote table "activities" */
export type Activities_Arr_Rel_Insert_Input = {
  data: Array<Activities_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Activities_On_Conflict>;
};

/** Boolean expression to filter rows from the table "activities". All fields are combined with a logical 'AND'. */
export type Activities_Bool_Exp = {
  _and?: InputMaybe<Array<Activities_Bool_Exp>>;
  _not?: InputMaybe<Activities_Bool_Exp>;
  _or?: InputMaybe<Array<Activities_Bool_Exp>>;
  activities_target_users?: InputMaybe<Activities_Target_Users_Bool_Exp>;
  activity_type?: InputMaybe<Activity_Types_Enum_Enum_Comparison_Exp>;
  appraisal_id?: InputMaybe<Uuid_Comparison_Exp>;
  assigned_to?: InputMaybe<Uuid_Comparison_Exp>;
  assignee?: InputMaybe<Users_Bool_Exp>;
  buyer_lead?: InputMaybe<Buyer_Leads_Bool_Exp>;
  buyer_lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  calendar_event_id?: InputMaybe<Uuid_Comparison_Exp>;
  consolidated_done_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  development_id?: InputMaybe<Uuid_Comparison_Exp>;
  done?: InputMaybe<Boolean_Comparison_Exp>;
  done_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  due_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_message?: InputMaybe<Email_Messages_Bool_Exp>;
  email_message_id?: InputMaybe<Uuid_Comparison_Exp>;
  end_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  enquiry_id?: InputMaybe<Uuid_Comparison_Exp>;
  extra_data?: InputMaybe<Jsonb_Comparison_Exp>;
  financing_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_overdue?: InputMaybe<Boolean_Comparison_Exp>;
  lead?: InputMaybe<Leads_Bool_Exp>;
  lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  offer_id?: InputMaybe<Uuid_Comparison_Exp>;
  offer_status?: InputMaybe<String_Comparison_Exp>;
  pinned?: InputMaybe<Boolean_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  success?: InputMaybe<Boolean_Comparison_Exp>;
  synced_from_calendar?: InputMaybe<Boolean_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  visibility?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "activities" */
export enum Activities_Constraint {
  /** unique or primary key constraint on columns "calendar_event_id" */
  ActivitiesCalendarEventIdUnique = 'activities_calendar_event_id_unique',
  /** unique or primary key constraint on columns "email_message_id" */
  ActivitiesEmailMessageIdUnique = 'activities_email_message_id_unique',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  ActivitiesIdTenantIdUnique = 'activities_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  ActivitiesPkey = 'activities_pkey'
}

/** input type for inserting data into table "activities" */
export type Activities_Insert_Input = {
  activities_target_users?: InputMaybe<Activities_Target_Users_Arr_Rel_Insert_Input>;
  activity_type?: InputMaybe<Activity_Types_Enum_Enum>;
  appraisal_id?: InputMaybe<Scalars['uuid']['input']>;
  assigned_to?: InputMaybe<Scalars['uuid']['input']>;
  assignee?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  buyer_lead?: InputMaybe<Buyer_Leads_Obj_Rel_Insert_Input>;
  buyer_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  calendar_event_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  creator?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  done_at?: InputMaybe<Scalars['timestamptz']['input']>;
  due_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_message_id?: InputMaybe<Scalars['uuid']['input']>;
  end_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  enquiry_id?: InputMaybe<Scalars['uuid']['input']>;
  extra_data?: InputMaybe<Scalars['jsonb']['input']>;
  financing_request_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead?: InputMaybe<Leads_Obj_Rel_Insert_Input>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  offer_id?: InputMaybe<Scalars['uuid']['input']>;
  offer_refused_id?: InputMaybe<Scalars['uuid']['input']>;
  offer_status?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  synced_from_calendar?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Activities_Max_Fields = {
  appraisal_id?: Maybe<Scalars['uuid']['output']>;
  assigned_to?: Maybe<Scalars['uuid']['output']>;
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  calendar_event_id?: Maybe<Scalars['uuid']['output']>;
  consolidated_done_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  done_at?: Maybe<Scalars['timestamptz']['output']>;
  due_at?: Maybe<Scalars['timestamptz']['output']>;
  email_message_id?: Maybe<Scalars['uuid']['output']>;
  end_at?: Maybe<Scalars['timestamptz']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  enquiry_id?: Maybe<Scalars['uuid']['output']>;
  financing_request_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  offer_id?: Maybe<Scalars['uuid']['output']>;
  offer_status?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "activities" */
export type Activities_Max_Order_By = {
  appraisal_id?: InputMaybe<Order_By>;
  assigned_to?: InputMaybe<Order_By>;
  buyer_lead_id?: InputMaybe<Order_By>;
  calendar_event_id?: InputMaybe<Order_By>;
  consolidated_done_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  done_at?: InputMaybe<Order_By>;
  due_at?: InputMaybe<Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  end_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  enquiry_id?: InputMaybe<Order_By>;
  financing_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  offer_status?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Activities_Min_Fields = {
  appraisal_id?: Maybe<Scalars['uuid']['output']>;
  assigned_to?: Maybe<Scalars['uuid']['output']>;
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  calendar_event_id?: Maybe<Scalars['uuid']['output']>;
  consolidated_done_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  done_at?: Maybe<Scalars['timestamptz']['output']>;
  due_at?: Maybe<Scalars['timestamptz']['output']>;
  email_message_id?: Maybe<Scalars['uuid']['output']>;
  end_at?: Maybe<Scalars['timestamptz']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  enquiry_id?: Maybe<Scalars['uuid']['output']>;
  financing_request_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  offer_id?: Maybe<Scalars['uuid']['output']>;
  offer_status?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "activities" */
export type Activities_Min_Order_By = {
  appraisal_id?: InputMaybe<Order_By>;
  assigned_to?: InputMaybe<Order_By>;
  buyer_lead_id?: InputMaybe<Order_By>;
  calendar_event_id?: InputMaybe<Order_By>;
  consolidated_done_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  done_at?: InputMaybe<Order_By>;
  due_at?: InputMaybe<Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  end_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  enquiry_id?: InputMaybe<Order_By>;
  financing_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  offer_status?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "activities" */
export type Activities_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Activities>;
};

/** input type for inserting object relation for remote table "activities" */
export type Activities_Obj_Rel_Insert_Input = {
  data: Activities_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Activities_On_Conflict>;
};

/** on_conflict condition type for table "activities" */
export type Activities_On_Conflict = {
  constraint: Activities_Constraint;
  update_columns?: Array<Activities_Update_Column>;
  where?: InputMaybe<Activities_Bool_Exp>;
};

/** Ordering options when selecting data from "activities". */
export type Activities_Order_By = {
  activities_target_users_aggregate?: InputMaybe<Activities_Target_Users_Aggregate_Order_By>;
  activity_type?: InputMaybe<Order_By>;
  appraisal_id?: InputMaybe<Order_By>;
  assigned_to?: InputMaybe<Order_By>;
  assignee?: InputMaybe<Users_Order_By>;
  buyer_lead?: InputMaybe<Buyer_Leads_Order_By>;
  buyer_lead_id?: InputMaybe<Order_By>;
  calendar_event_id?: InputMaybe<Order_By>;
  consolidated_done_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  development_id?: InputMaybe<Order_By>;
  done?: InputMaybe<Order_By>;
  done_at?: InputMaybe<Order_By>;
  due_at?: InputMaybe<Order_By>;
  email_message?: InputMaybe<Email_Messages_Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  end_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  enquiry_id?: InputMaybe<Order_By>;
  extra_data?: InputMaybe<Order_By>;
  financing_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_overdue?: InputMaybe<Order_By>;
  lead?: InputMaybe<Leads_Order_By>;
  lead_id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  offer_status?: InputMaybe<Order_By>;
  pinned?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  success?: InputMaybe<Order_By>;
  synced_from_calendar?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
};

/** primary key columns input for table: activities */
export type Activities_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "activities" */
export enum Activities_Select_Column {
  /** column name */
  ActivityType = 'activity_type',
  /** column name */
  AppraisalId = 'appraisal_id',
  /** column name */
  AssignedTo = 'assigned_to',
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  ConsolidatedDoneAt = 'consolidated_done_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  Done = 'done',
  /** column name */
  DoneAt = 'done_at',
  /** column name */
  DueAt = 'due_at',
  /** column name */
  EmailMessageId = 'email_message_id',
  /** column name */
  EndAt = 'end_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EnquiryId = 'enquiry_id',
  /** column name */
  ExtraData = 'extra_data',
  /** column name */
  FinancingRequestId = 'financing_request_id',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  Location = 'location',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Note = 'note',
  /** column name */
  OfferId = 'offer_id',
  /** column name */
  OfferStatus = 'offer_status',
  /** column name */
  Pinned = 'pinned',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Subject = 'subject',
  /** column name */
  Success = 'success',
  /** column name */
  SyncedFromCalendar = 'synced_from_calendar',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Visibility = 'visibility'
}

/** select "activities_aggregate_bool_exp_bool_and_arguments_columns" columns of table "activities" */
export enum Activities_Select_Column_Activities_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Done = 'done',
  /** column name */
  Pinned = 'pinned',
  /** column name */
  Success = 'success',
  /** column name */
  SyncedFromCalendar = 'synced_from_calendar'
}

/** select "activities_aggregate_bool_exp_bool_or_arguments_columns" columns of table "activities" */
export enum Activities_Select_Column_Activities_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Done = 'done',
  /** column name */
  Pinned = 'pinned',
  /** column name */
  Success = 'success',
  /** column name */
  SyncedFromCalendar = 'synced_from_calendar'
}

/** input type for updating data in table "activities" */
export type Activities_Set_Input = {
  done?: InputMaybe<Scalars['Boolean']['input']>;
  done_at?: InputMaybe<Scalars['timestamptz']['input']>;
  due_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "activities" */
export type Activities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Activities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Activities_Stream_Cursor_Value_Input = {
  activity_type?: InputMaybe<Activity_Types_Enum_Enum>;
  appraisal_id?: InputMaybe<Scalars['uuid']['input']>;
  assigned_to?: InputMaybe<Scalars['uuid']['input']>;
  buyer_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  calendar_event_id?: InputMaybe<Scalars['uuid']['input']>;
  consolidated_done_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  done_at?: InputMaybe<Scalars['timestamptz']['input']>;
  due_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_message_id?: InputMaybe<Scalars['uuid']['input']>;
  end_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  enquiry_id?: InputMaybe<Scalars['uuid']['input']>;
  extra_data?: InputMaybe<Scalars['jsonb']['input']>;
  financing_request_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  offer_id?: InputMaybe<Scalars['uuid']['input']>;
  offer_status?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  synced_from_calendar?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "activities_target_users" */
export type Activities_Target_Users = {
  /** An object relationship */
  activity: Activities;
  activity_id: Scalars['uuid']['output'];
  email?: Maybe<Scalars['String']['output']>;
  is_owner: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  target_user_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
};

/** order by aggregate values of table "activities_target_users" */
export type Activities_Target_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Activities_Target_Users_Max_Order_By>;
  min?: InputMaybe<Activities_Target_Users_Min_Order_By>;
};

/** input type for inserting array relation for remote table "activities_target_users" */
export type Activities_Target_Users_Arr_Rel_Insert_Input = {
  data: Array<Activities_Target_Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Activities_Target_Users_On_Conflict>;
};

/** Boolean expression to filter rows from the table "activities_target_users". All fields are combined with a logical 'AND'. */
export type Activities_Target_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Activities_Target_Users_Bool_Exp>>;
  _not?: InputMaybe<Activities_Target_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Activities_Target_Users_Bool_Exp>>;
  activity?: InputMaybe<Activities_Bool_Exp>;
  activity_id?: InputMaybe<Uuid_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  is_owner?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  target_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "activities_target_users" */
export enum Activities_Target_Users_Constraint {
  /** unique or primary key constraint on columns "target_user_id", "is_owner", "activity_id", "email" */
  ActivitiesTargetUsersUindex = 'activities_target_users_uindex'
}

/** input type for inserting data into table "activities_target_users" */
export type Activities_Target_Users_Insert_Input = {
  activity?: InputMaybe<Activities_Obj_Rel_Insert_Input>;
  activity_id?: InputMaybe<Scalars['uuid']['input']>;
  target_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "activities_target_users" */
export type Activities_Target_Users_Max_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  target_user_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "activities_target_users" */
export type Activities_Target_Users_Min_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  target_user_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "activities_target_users" */
export type Activities_Target_Users_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Activities_Target_Users>;
};

/** on_conflict condition type for table "activities_target_users" */
export type Activities_Target_Users_On_Conflict = {
  constraint: Activities_Target_Users_Constraint;
  update_columns?: Array<Activities_Target_Users_Update_Column>;
  where?: InputMaybe<Activities_Target_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "activities_target_users". */
export type Activities_Target_Users_Order_By = {
  activity?: InputMaybe<Activities_Order_By>;
  activity_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  is_owner?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  target_user_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "activities_target_users" */
export enum Activities_Target_Users_Select_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  Email = 'email',
  /** column name */
  IsOwner = 'is_owner',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  TargetUserId = 'target_user_id',
  /** column name */
  Type = 'type'
}

/** placeholder for update columns of table "activities_target_users" (current role has no relevant permissions) */
export enum Activities_Target_Users_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** update columns of table "activities" */
export enum Activities_Update_Column {
  /** column name */
  Done = 'done',
  /** column name */
  DoneAt = 'done_at',
  /** column name */
  DueAt = 'due_at',
  /** column name */
  EndAt = 'end_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Pinned = 'pinned',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Subject = 'subject',
  /** column name */
  Success = 'success'
}

export type Activities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Activities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Activities_Bool_Exp;
};

export enum Activity_Types_Enum_Enum {
  Assignment = 'assignment',
  Call = 'call',
  Change = 'change',
  CreateUser = 'create_user',
  Email = 'email',
  Match = 'match',
  Note = 'note',
  Offer = 'offer',
  Origination = 'origination',
  Requalification = 'requalification',
  Task = 'task',
  Visit = 'visit'
}

/** Boolean expression to compare columns of type "activity_types_enum_enum". All fields are combined with logical 'AND'. */
export type Activity_Types_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Activity_Types_Enum_Enum>;
  _in?: InputMaybe<Array<Activity_Types_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Activity_Types_Enum_Enum>;
  _nin?: InputMaybe<Array<Activity_Types_Enum_Enum>>;
};

/** columns and relationships of "address_display_options_enum" */
export type Address_Display_Options_Enum = {
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "address_display_options_enum". All fields are combined with a logical 'AND'. */
export type Address_Display_Options_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Display_Options_Enum_Bool_Exp>>;
  _not?: InputMaybe<Address_Display_Options_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Display_Options_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Address_Display_Options_Enum_Enum {
  /** Full address */
  FullAddress = 'full_address',
  /** Hide street and street number */
  HideStreet = 'hide_street',
  /** Hide only street number */
  HideStreetNumber = 'hide_street_number'
}

/** Boolean expression to compare columns of type "address_display_options_enum_enum". All fields are combined with logical 'AND'. */
export type Address_Display_Options_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Address_Display_Options_Enum_Enum>;
  _in?: InputMaybe<Array<Address_Display_Options_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Address_Display_Options_Enum_Enum>;
  _nin?: InputMaybe<Array<Address_Display_Options_Enum_Enum>>;
};

/** Ordering options when selecting data from "address_display_options_enum". */
export type Address_Display_Options_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "address_display_options_enum" */
export enum Address_Display_Options_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "address_display_options_enum" */
export type Address_Display_Options_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Display_Options_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Display_Options_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Agent_Ranking_Places_Args = {
  exclude_rental_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  offset_count?: InputMaybe<Scalars['Int']['input']>;
  transaction_radius?: InputMaybe<Scalars['float8']['input']>;
};

export type Agent_Ranking_Properties_Args = {
  exclude_rental_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  offset_count?: InputMaybe<Scalars['Int']['input']>;
  transaction_radius?: InputMaybe<Scalars['float8']['input']>;
};

export type Agent_Statistics_Args = {
  filters?: InputMaybe<Scalars['json']['input']>;
};

/** columns and relationships of "agent_stats" */
export type Agent_Stats = {
  assigned_leads?: Maybe<Scalars['Int']['output']>;
  call_attempts?: Maybe<Scalars['Int']['output']>;
  call_attempts_missed?: Maybe<Scalars['Int']['output']>;
  call_attempts_successful?: Maybe<Scalars['Int']['output']>;
  claimed_leads?: Maybe<Scalars['Int']['output']>;
  gross_commission?: Maybe<Scalars['float8']['output']>;
  mandates_published?: Maybe<Scalars['Int']['output']>;
  mandates_signed?: Maybe<Scalars['Int']['output']>;
  offers_accepted?: Maybe<Scalars['Int']['output']>;
  offers_made?: Maybe<Scalars['Int']['output']>;
  offers_refused?: Maybe<Scalars['Int']['output']>;
  tenant_id: Scalars['uuid']['output'];
  transactions_closed?: Maybe<Scalars['Int']['output']>;
  transactions_volume?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
  visits_booked?: Maybe<Scalars['Int']['output']>;
  visits_completed?: Maybe<Scalars['Int']['output']>;
  visits_planned?: Maybe<Scalars['Int']['output']>;
};

/** Boolean expression to filter rows from the table "agent_stats". All fields are combined with a logical 'AND'. */
export type Agent_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Agent_Stats_Bool_Exp>>;
  _not?: InputMaybe<Agent_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Agent_Stats_Bool_Exp>>;
  assigned_leads?: InputMaybe<Int_Comparison_Exp>;
  call_attempts?: InputMaybe<Int_Comparison_Exp>;
  call_attempts_missed?: InputMaybe<Int_Comparison_Exp>;
  call_attempts_successful?: InputMaybe<Int_Comparison_Exp>;
  claimed_leads?: InputMaybe<Int_Comparison_Exp>;
  gross_commission?: InputMaybe<Float8_Comparison_Exp>;
  mandates_published?: InputMaybe<Int_Comparison_Exp>;
  mandates_signed?: InputMaybe<Int_Comparison_Exp>;
  offers_accepted?: InputMaybe<Int_Comparison_Exp>;
  offers_made?: InputMaybe<Int_Comparison_Exp>;
  offers_refused?: InputMaybe<Int_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  transactions_closed?: InputMaybe<Int_Comparison_Exp>;
  transactions_volume?: InputMaybe<Float8_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  visits_booked?: InputMaybe<Int_Comparison_Exp>;
  visits_completed?: InputMaybe<Int_Comparison_Exp>;
  visits_planned?: InputMaybe<Int_Comparison_Exp>;
};

/** Ordering options when selecting data from "agent_stats". */
export type Agent_Stats_Order_By = {
  assigned_leads?: InputMaybe<Order_By>;
  call_attempts?: InputMaybe<Order_By>;
  call_attempts_missed?: InputMaybe<Order_By>;
  call_attempts_successful?: InputMaybe<Order_By>;
  claimed_leads?: InputMaybe<Order_By>;
  gross_commission?: InputMaybe<Order_By>;
  mandates_published?: InputMaybe<Order_By>;
  mandates_signed?: InputMaybe<Order_By>;
  offers_accepted?: InputMaybe<Order_By>;
  offers_made?: InputMaybe<Order_By>;
  offers_refused?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  transactions_closed?: InputMaybe<Order_By>;
  transactions_volume?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  visits_booked?: InputMaybe<Order_By>;
  visits_completed?: InputMaybe<Order_By>;
  visits_planned?: InputMaybe<Order_By>;
};

/** select columns of table "agent_stats" */
export enum Agent_Stats_Select_Column {
  /** column name */
  AssignedLeads = 'assigned_leads',
  /** column name */
  CallAttempts = 'call_attempts',
  /** column name */
  CallAttemptsMissed = 'call_attempts_missed',
  /** column name */
  CallAttemptsSuccessful = 'call_attempts_successful',
  /** column name */
  ClaimedLeads = 'claimed_leads',
  /** column name */
  GrossCommission = 'gross_commission',
  /** column name */
  MandatesPublished = 'mandates_published',
  /** column name */
  MandatesSigned = 'mandates_signed',
  /** column name */
  OffersAccepted = 'offers_accepted',
  /** column name */
  OffersMade = 'offers_made',
  /** column name */
  OffersRefused = 'offers_refused',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TransactionsClosed = 'transactions_closed',
  /** column name */
  TransactionsVolume = 'transactions_volume',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VisitsBooked = 'visits_booked',
  /** column name */
  VisitsCompleted = 'visits_completed',
  /** column name */
  VisitsPlanned = 'visits_planned'
}

/** Streaming cursor of the table "agent_stats" */
export type Agent_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agent_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agent_Stats_Stream_Cursor_Value_Input = {
  assigned_leads?: InputMaybe<Scalars['Int']['input']>;
  call_attempts?: InputMaybe<Scalars['Int']['input']>;
  call_attempts_missed?: InputMaybe<Scalars['Int']['input']>;
  call_attempts_successful?: InputMaybe<Scalars['Int']['input']>;
  claimed_leads?: InputMaybe<Scalars['Int']['input']>;
  gross_commission?: InputMaybe<Scalars['float8']['input']>;
  mandates_published?: InputMaybe<Scalars['Int']['input']>;
  mandates_signed?: InputMaybe<Scalars['Int']['input']>;
  offers_accepted?: InputMaybe<Scalars['Int']['input']>;
  offers_made?: InputMaybe<Scalars['Int']['input']>;
  offers_refused?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  transactions_closed?: InputMaybe<Scalars['Int']['input']>;
  transactions_volume?: InputMaybe<Scalars['float8']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  visits_booked?: InputMaybe<Scalars['Int']['input']>;
  visits_completed?: InputMaybe<Scalars['Int']['input']>;
  visits_planned?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "agents_rankings" */
export type Agents_Rankings = {
  distance?: Maybe<Scalars['float8']['output']>;
  payment_amount: Scalars['Int']['output'];
  subscription_status?: Maybe<Scalars['subscription_status']['output']>;
  total_transactions: Scalars['Int']['output'];
  transactions_in_district?: Maybe<Scalars['Int']['output']>;
  transactions_in_location?: Maybe<Scalars['Int']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Int']['output']>;
  transactions_in_radius?: Maybe<Scalars['Int']['output']>;
  transactions_in_state?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id: Scalars['uuid']['output'];
};

export type Agents_Rankings_Aggregate = {
  aggregate?: Maybe<Agents_Rankings_Aggregate_Fields>;
  nodes: Array<Agents_Rankings>;
};

/** aggregate fields of "agents_rankings" */
export type Agents_Rankings_Aggregate_Fields = {
  avg?: Maybe<Agents_Rankings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Agents_Rankings_Max_Fields>;
  min?: Maybe<Agents_Rankings_Min_Fields>;
  stddev?: Maybe<Agents_Rankings_Stddev_Fields>;
  stddev_pop?: Maybe<Agents_Rankings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agents_Rankings_Stddev_Samp_Fields>;
  sum?: Maybe<Agents_Rankings_Sum_Fields>;
  var_pop?: Maybe<Agents_Rankings_Var_Pop_Fields>;
  var_samp?: Maybe<Agents_Rankings_Var_Samp_Fields>;
  variance?: Maybe<Agents_Rankings_Variance_Fields>;
};


/** aggregate fields of "agents_rankings" */
export type Agents_Rankings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Agents_Rankings_Avg_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "agents_rankings". All fields are combined with a logical 'AND'. */
export type Agents_Rankings_Bool_Exp = {
  _and?: InputMaybe<Array<Agents_Rankings_Bool_Exp>>;
  _not?: InputMaybe<Agents_Rankings_Bool_Exp>;
  _or?: InputMaybe<Array<Agents_Rankings_Bool_Exp>>;
  distance?: InputMaybe<Float8_Comparison_Exp>;
  payment_amount?: InputMaybe<Int_Comparison_Exp>;
  subscription_status?: InputMaybe<Subscription_Status_Comparison_Exp>;
  total_transactions?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_district?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_location?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_municipality?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_radius?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_state?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Agents_Rankings_Max_Fields = {
  distance?: Maybe<Scalars['float8']['output']>;
  payment_amount?: Maybe<Scalars['Int']['output']>;
  subscription_status?: Maybe<Scalars['subscription_status']['output']>;
  total_transactions?: Maybe<Scalars['Int']['output']>;
  transactions_in_district?: Maybe<Scalars['Int']['output']>;
  transactions_in_location?: Maybe<Scalars['Int']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Int']['output']>;
  transactions_in_radius?: Maybe<Scalars['Int']['output']>;
  transactions_in_state?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Agents_Rankings_Min_Fields = {
  distance?: Maybe<Scalars['float8']['output']>;
  payment_amount?: Maybe<Scalars['Int']['output']>;
  subscription_status?: Maybe<Scalars['subscription_status']['output']>;
  total_transactions?: Maybe<Scalars['Int']['output']>;
  transactions_in_district?: Maybe<Scalars['Int']['output']>;
  transactions_in_location?: Maybe<Scalars['Int']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Int']['output']>;
  transactions_in_radius?: Maybe<Scalars['Int']['output']>;
  transactions_in_state?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "agents_rankings". */
export type Agents_Rankings_Order_By = {
  distance?: InputMaybe<Order_By>;
  payment_amount?: InputMaybe<Order_By>;
  subscription_status?: InputMaybe<Order_By>;
  total_transactions?: InputMaybe<Order_By>;
  transactions_in_district?: InputMaybe<Order_By>;
  transactions_in_location?: InputMaybe<Order_By>;
  transactions_in_municipality?: InputMaybe<Order_By>;
  transactions_in_radius?: InputMaybe<Order_By>;
  transactions_in_state?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "agents_rankings" */
export enum Agents_Rankings_Select_Column {
  /** column name */
  Distance = 'distance',
  /** column name */
  PaymentAmount = 'payment_amount',
  /** column name */
  SubscriptionStatus = 'subscription_status',
  /** column name */
  TotalTransactions = 'total_transactions',
  /** column name */
  TransactionsInDistrict = 'transactions_in_district',
  /** column name */
  TransactionsInLocation = 'transactions_in_location',
  /** column name */
  TransactionsInMunicipality = 'transactions_in_municipality',
  /** column name */
  TransactionsInRadius = 'transactions_in_radius',
  /** column name */
  TransactionsInState = 'transactions_in_state',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Agents_Rankings_Stddev_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Agents_Rankings_Stddev_Pop_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Agents_Rankings_Stddev_Samp_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Agents_Rankings_Sum_Fields = {
  distance?: Maybe<Scalars['float8']['output']>;
  payment_amount?: Maybe<Scalars['Int']['output']>;
  total_transactions?: Maybe<Scalars['Int']['output']>;
  transactions_in_district?: Maybe<Scalars['Int']['output']>;
  transactions_in_location?: Maybe<Scalars['Int']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Int']['output']>;
  transactions_in_radius?: Maybe<Scalars['Int']['output']>;
  transactions_in_state?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Agents_Rankings_Var_Pop_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Agents_Rankings_Var_Samp_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Agents_Rankings_Variance_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "appraisals" */
export type Appraisals = {
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  building_condition?: Maybe<Scalars['Float']['output']>;
  building_standard?: Maybe<Scalars['Float']['output']>;
  building_volume?: Maybe<Scalars['Float']['output']>;
  building_volume_norm?: Maybe<Scalars['String']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  ctn?: Maybe<Scalars['String']['output']>;
  flat_condition?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  google_address_id?: Maybe<Scalars['uuid']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  iazi_address_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_luxury?: Maybe<Scalars['Boolean']['output']>;
  is_maisonette?: Maybe<Scalars['Boolean']['output']>;
  is_pending: Scalars['Boolean']['output'];
  is_secondary_residence?: Maybe<Scalars['Boolean']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  micro_location?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  minergie_code?: Maybe<Scalars['Int']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Int']['output']>;
  number_of_flats?: Maybe<Scalars['Int']['output']>;
  number_of_floors?: Maybe<Scalars['Int']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_lifts?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Int']['output']>;
  plot_has_constructible_reserve?: Maybe<Scalars['Boolean']['output']>;
  plot_is_constructible?: Maybe<Scalars['Boolean']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  price_per_land_surface_meter_squared?: Maybe<Scalars['Float']['output']>;
  price_per_living_surface_meter_squared?: Maybe<Scalars['Float']['output']>;
  /** An object relationship */
  property?: Maybe<Properties>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_type_id?: Maybe<Scalars['uuid']['output']>;
  property_volume?: Maybe<Scalars['Float']['output']>;
  property_volume_norm?: Maybe<Scalars['String']['output']>;
  relevant_servitudes?: Maybe<Scalars['Boolean']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_max?: Maybe<Scalars['Float']['output']>;
  rent_min?: Maybe<Scalars['Float']['output']>;
  rent_value?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  share_of_ownership?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  user_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  valuations: Array<Valuations>;
  value?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "appraisals" */
export type AppraisalsValuationsArgs = {
  distinct_on?: InputMaybe<Array<Valuations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Valuations_Order_By>>;
  where?: InputMaybe<Valuations_Bool_Exp>;
};

/** order by aggregate values of table "appraisals" */
export type Appraisals_Aggregate_Order_By = {
  avg?: InputMaybe<Appraisals_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Appraisals_Max_Order_By>;
  min?: InputMaybe<Appraisals_Min_Order_By>;
  stddev?: InputMaybe<Appraisals_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Appraisals_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Appraisals_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Appraisals_Sum_Order_By>;
  var_pop?: InputMaybe<Appraisals_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Appraisals_Var_Samp_Order_By>;
  variance?: InputMaybe<Appraisals_Variance_Order_By>;
};

/** order by avg() on columns of table "appraisals" */
export type Appraisals_Avg_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "appraisals". All fields are combined with a logical 'AND'. */
export type Appraisals_Bool_Exp = {
  _and?: InputMaybe<Array<Appraisals_Bool_Exp>>;
  _not?: InputMaybe<Appraisals_Bool_Exp>;
  _or?: InputMaybe<Array<Appraisals_Bool_Exp>>;
  appraisal_perceived_value?: InputMaybe<Float_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  building_condition?: InputMaybe<Float_Comparison_Exp>;
  building_standard?: InputMaybe<Float_Comparison_Exp>;
  building_volume?: InputMaybe<Float_Comparison_Exp>;
  building_volume_norm?: InputMaybe<String_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ctn?: InputMaybe<String_Comparison_Exp>;
  flat_condition?: InputMaybe<Float_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  google_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  iazi_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_luxury?: InputMaybe<Boolean_Comparison_Exp>;
  is_maisonette?: InputMaybe<Boolean_Comparison_Exp>;
  is_pending?: InputMaybe<Boolean_Comparison_Exp>;
  is_secondary_residence?: InputMaybe<Boolean_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  max?: InputMaybe<Float_Comparison_Exp>;
  method?: InputMaybe<String_Comparison_Exp>;
  micro_location?: InputMaybe<Float_Comparison_Exp>;
  min?: InputMaybe<Float_Comparison_Exp>;
  minergie_code?: InputMaybe<Int_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_flats?: InputMaybe<Int_Comparison_Exp>;
  number_of_floors?: InputMaybe<Int_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_lifts?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Int_Comparison_Exp>;
  plot_has_constructible_reserve?: InputMaybe<Boolean_Comparison_Exp>;
  plot_is_constructible?: InputMaybe<Boolean_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  price_per_land_surface_meter_squared?: InputMaybe<Float_Comparison_Exp>;
  price_per_living_surface_meter_squared?: InputMaybe<Float_Comparison_Exp>;
  property?: InputMaybe<Properties_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_volume?: InputMaybe<Float_Comparison_Exp>;
  property_volume_norm?: InputMaybe<String_Comparison_Exp>;
  relevant_servitudes?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_max?: InputMaybe<Float_Comparison_Exp>;
  rent_min?: InputMaybe<Float_Comparison_Exp>;
  rent_value?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  share_of_ownership?: InputMaybe<Float_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  valuations?: InputMaybe<Valuations_Bool_Exp>;
  value?: InputMaybe<Float_Comparison_Exp>;
};

/** order by max() on columns of table "appraisals" */
export type Appraisals_Max_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  building_volume_norm?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  ctn?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  google_address_id?: InputMaybe<Order_By>;
  iazi_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_type_id?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  property_volume_norm?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "appraisals" */
export type Appraisals_Min_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  building_volume_norm?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  ctn?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  google_address_id?: InputMaybe<Order_By>;
  iazi_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_type_id?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  property_volume_norm?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "appraisals". */
export type Appraisals_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  building_volume_norm?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  ctn?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  google_address_id?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  iazi_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_luxury?: InputMaybe<Order_By>;
  is_maisonette?: InputMaybe<Order_By>;
  is_pending?: InputMaybe<Order_By>;
  is_secondary_residence?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  plot_has_constructible_reserve?: InputMaybe<Order_By>;
  plot_is_constructible?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property?: InputMaybe<Properties_Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_type_id?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  property_volume_norm?: InputMaybe<Order_By>;
  relevant_servitudes?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  valuations_aggregate?: InputMaybe<Valuations_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "appraisals_public_view" */
export type Appraisals_Public_View = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  price_per_living_surface_meter_squared?: Maybe<Scalars['Float']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "appraisals_public_view". All fields are combined with a logical 'AND'. */
export type Appraisals_Public_View_Bool_Exp = {
  _and?: InputMaybe<Array<Appraisals_Public_View_Bool_Exp>>;
  _not?: InputMaybe<Appraisals_Public_View_Bool_Exp>;
  _or?: InputMaybe<Array<Appraisals_Public_View_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  price_per_living_surface_meter_squared?: InputMaybe<Float_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "appraisals_public_view". */
export type Appraisals_Public_View_Order_By = {
  created_at?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** select columns of table "appraisals_public_view" */
export enum Appraisals_Public_View_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PricePerLivingSurfaceMeterSquared = 'price_per_living_surface_meter_squared',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  Route = 'route',
  /** column name */
  TenantId = 'tenant_id'
}

/** select columns of table "appraisals" */
export enum Appraisals_Select_Column {
  /** column name */
  AppraisalPerceivedValue = 'appraisal_perceived_value',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BuildingCondition = 'building_condition',
  /** column name */
  BuildingStandard = 'building_standard',
  /** column name */
  BuildingVolume = 'building_volume',
  /** column name */
  BuildingVolumeNorm = 'building_volume_norm',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Ctn = 'ctn',
  /** column name */
  FlatCondition = 'flat_condition',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  IaziAddressId = 'iazi_address_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsLuxury = 'is_luxury',
  /** column name */
  IsMaisonette = 'is_maisonette',
  /** column name */
  IsPending = 'is_pending',
  /** column name */
  IsSecondaryResidence = 'is_secondary_residence',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  Max = 'max',
  /** column name */
  Method = 'method',
  /** column name */
  MicroLocation = 'micro_location',
  /** column name */
  Min = 'min',
  /** column name */
  MinergieCode = 'minergie_code',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfFlats = 'number_of_flats',
  /** column name */
  NumberOfFloors = 'number_of_floors',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLifts = 'number_of_lifts',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  PlotHasConstructibleReserve = 'plot_has_constructible_reserve',
  /** column name */
  PlotIsConstructible = 'plot_is_constructible',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PricePerLandSurfaceMeterSquared = 'price_per_land_surface_meter_squared',
  /** column name */
  PricePerLivingSurfaceMeterSquared = 'price_per_living_surface_meter_squared',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyTypeId = 'property_type_id',
  /** column name */
  PropertyVolume = 'property_volume',
  /** column name */
  PropertyVolumeNorm = 'property_volume_norm',
  /** column name */
  RelevantServitudes = 'relevant_servitudes',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentMax = 'rent_max',
  /** column name */
  RentMin = 'rent_min',
  /** column name */
  RentValue = 'rent_value',
  /** column name */
  Route = 'route',
  /** column name */
  ShareOfOwnership = 'share_of_ownership',
  /** column name */
  State = 'state',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

/** order by stddev() on columns of table "appraisals" */
export type Appraisals_Stddev_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "appraisals" */
export type Appraisals_Stddev_Pop_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "appraisals" */
export type Appraisals_Stddev_Samp_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "appraisals" */
export type Appraisals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Appraisals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Appraisals_Stream_Cursor_Value_Input = {
  appraisal_perceived_value?: InputMaybe<Scalars['Float']['input']>;
  balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  building_condition?: InputMaybe<Scalars['Float']['input']>;
  building_standard?: InputMaybe<Scalars['Float']['input']>;
  building_volume?: InputMaybe<Scalars['Float']['input']>;
  building_volume_norm?: InputMaybe<Scalars['String']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  flat_condition?: InputMaybe<Scalars['Float']['input']>;
  floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  garden_surface?: InputMaybe<Scalars['Float']['input']>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  iazi_address_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_luxury?: InputMaybe<Scalars['Boolean']['input']>;
  is_maisonette?: InputMaybe<Scalars['Boolean']['input']>;
  is_pending?: InputMaybe<Scalars['Boolean']['input']>;
  is_secondary_residence?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  living_surface?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  micro_location?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  minergie_code?: InputMaybe<Scalars['Int']['input']>;
  number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_flats?: InputMaybe<Scalars['Int']['input']>;
  number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_lifts?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  number_of_toilets?: InputMaybe<Scalars['Int']['input']>;
  plot_has_constructible_reserve?: InputMaybe<Scalars['Boolean']['input']>;
  plot_is_constructible?: InputMaybe<Scalars['Boolean']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  price_per_land_surface_meter_squared?: InputMaybe<Scalars['Float']['input']>;
  price_per_living_surface_meter_squared?: InputMaybe<Scalars['Float']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_type_id?: InputMaybe<Scalars['uuid']['input']>;
  property_volume?: InputMaybe<Scalars['Float']['input']>;
  property_volume_norm?: InputMaybe<Scalars['String']['input']>;
  relevant_servitudes?: InputMaybe<Scalars['Boolean']['input']>;
  renovation_year?: InputMaybe<Scalars['Int']['input']>;
  rent_max?: InputMaybe<Scalars['Float']['input']>;
  rent_min?: InputMaybe<Scalars['Float']['input']>;
  rent_value?: InputMaybe<Scalars['Float']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  share_of_ownership?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** order by sum() on columns of table "appraisals" */
export type Appraisals_Sum_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "appraisals" */
export type Appraisals_Var_Pop_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "appraisals" */
export type Appraisals_Var_Samp_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "appraisals" */
export type Appraisals_Variance_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** Boolean expression to compare columns of type "bit". All fields are combined with logical 'AND'. */
export type Bit_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bit']['input']>;
  _gt?: InputMaybe<Scalars['bit']['input']>;
  _gte?: InputMaybe<Scalars['bit']['input']>;
  _in?: InputMaybe<Array<Scalars['bit']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bit']['input']>;
  _lte?: InputMaybe<Scalars['bit']['input']>;
  _neq?: InputMaybe<Scalars['bit']['input']>;
  _nin?: InputMaybe<Array<Scalars['bit']['input']>>;
};

/** columns and relationships of "buyer_leads" */
export type Buyer_Leads = {
  /** An array relationship */
  activities: Array<Activities>;
  /** An aggregate relationship */
  activities_aggregate: Activities_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  financial_approval?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lead_stage?: Maybe<Lead_Stages>;
  /** An object relationship */
  lot: Lots;
  lot_id: Scalars['uuid']['output'];
  order_nr: Scalars['Int']['output'];
  source?: Maybe<Scalars['String']['output']>;
  stage_id?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
  user_order_nr: Scalars['Int']['output'];
};


/** columns and relationships of "buyer_leads" */
export type Buyer_LeadsActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** columns and relationships of "buyer_leads" */
export type Buyer_LeadsActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};

/** aggregated selection of "buyer_leads" */
export type Buyer_Leads_Aggregate = {
  aggregate?: Maybe<Buyer_Leads_Aggregate_Fields>;
  nodes: Array<Buyer_Leads>;
};

export type Buyer_Leads_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Buyer_Leads_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Buyer_Leads_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Buyer_Leads_Aggregate_Bool_Exp_Count>;
};

export type Buyer_Leads_Aggregate_Bool_Exp_Bool_And = {
  arguments: Buyer_Leads_Select_Column_Buyer_Leads_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Buyer_Leads_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Buyer_Leads_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Buyer_Leads_Select_Column_Buyer_Leads_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Buyer_Leads_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Buyer_Leads_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Buyer_Leads_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "buyer_leads" */
export type Buyer_Leads_Aggregate_Fields = {
  avg?: Maybe<Buyer_Leads_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Buyer_Leads_Max_Fields>;
  min?: Maybe<Buyer_Leads_Min_Fields>;
  stddev?: Maybe<Buyer_Leads_Stddev_Fields>;
  stddev_pop?: Maybe<Buyer_Leads_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Buyer_Leads_Stddev_Samp_Fields>;
  sum?: Maybe<Buyer_Leads_Sum_Fields>;
  var_pop?: Maybe<Buyer_Leads_Var_Pop_Fields>;
  var_samp?: Maybe<Buyer_Leads_Var_Samp_Fields>;
  variance?: Maybe<Buyer_Leads_Variance_Fields>;
};


/** aggregate fields of "buyer_leads" */
export type Buyer_Leads_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "buyer_leads" */
export type Buyer_Leads_Aggregate_Order_By = {
  avg?: InputMaybe<Buyer_Leads_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Buyer_Leads_Max_Order_By>;
  min?: InputMaybe<Buyer_Leads_Min_Order_By>;
  stddev?: InputMaybe<Buyer_Leads_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Buyer_Leads_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Buyer_Leads_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Buyer_Leads_Sum_Order_By>;
  var_pop?: InputMaybe<Buyer_Leads_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Buyer_Leads_Var_Samp_Order_By>;
  variance?: InputMaybe<Buyer_Leads_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "buyer_leads" */
export type Buyer_Leads_Arr_Rel_Insert_Input = {
  data: Array<Buyer_Leads_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Buyer_Leads_On_Conflict>;
};

/** aggregate avg on columns */
export type Buyer_Leads_Avg_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
  user_order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "buyer_leads" */
export type Buyer_Leads_Avg_Order_By = {
  order_nr?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "buyer_leads". All fields are combined with a logical 'AND'. */
export type Buyer_Leads_Bool_Exp = {
  _and?: InputMaybe<Array<Buyer_Leads_Bool_Exp>>;
  _not?: InputMaybe<Buyer_Leads_Bool_Exp>;
  _or?: InputMaybe<Array<Buyer_Leads_Bool_Exp>>;
  activities?: InputMaybe<Activities_Bool_Exp>;
  activities_aggregate?: InputMaybe<Activities_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  development_id?: InputMaybe<Uuid_Comparison_Exp>;
  financial_approval?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lead_stage?: InputMaybe<Lead_Stages_Bool_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  stage_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_order_nr?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "buyer_leads" */
export enum Buyer_Leads_Constraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  BuyerLeadsIdTenantIdUnique = 'buyer_leads_id_tenant_id_unique',
  /** unique or primary key constraint on columns "user_id", "lot_id" */
  BuyerLeadsLotIdUserIdUnique = 'buyer_leads_lot_id_user_id_unique',
  /** unique or primary key constraint on columns "id" */
  BuyerLeadsPkey = 'buyer_leads_pkey'
}

/** input type for incrementing numeric columns in table "buyer_leads" */
export type Buyer_Leads_Inc_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  user_order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "buyer_leads" */
export type Buyer_Leads_Insert_Input = {
  activities?: InputMaybe<Activities_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead_stage?: InputMaybe<Lead_Stages_Obj_Rel_Insert_Input>;
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Buyer_Leads_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  stage_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_order_nr?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "buyer_leads" */
export type Buyer_Leads_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Buyer_Leads_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  stage_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_order_nr?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "buyer_leads" */
export type Buyer_Leads_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "buyer_leads" */
export type Buyer_Leads_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Buyer_Leads>;
};

/** input type for inserting object relation for remote table "buyer_leads" */
export type Buyer_Leads_Obj_Rel_Insert_Input = {
  data: Buyer_Leads_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Buyer_Leads_On_Conflict>;
};

/** on_conflict condition type for table "buyer_leads" */
export type Buyer_Leads_On_Conflict = {
  constraint: Buyer_Leads_Constraint;
  update_columns?: Array<Buyer_Leads_Update_Column>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};

/** Ordering options when selecting data from "buyer_leads". */
export type Buyer_Leads_Order_By = {
  activities_aggregate?: InputMaybe<Activities_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  financial_approval?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_stage?: InputMaybe<Lead_Stages_Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** primary key columns input for table: buyer_leads */
export type Buyer_Leads_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "buyer_leads" */
export enum Buyer_Leads_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  FinancialApproval = 'financial_approval',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  Source = 'source',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserOrderNr = 'user_order_nr'
}

/** select "buyer_leads_aggregate_bool_exp_bool_and_arguments_columns" columns of table "buyer_leads" */
export enum Buyer_Leads_Select_Column_Buyer_Leads_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  FinancialApproval = 'financial_approval'
}

/** select "buyer_leads_aggregate_bool_exp_bool_or_arguments_columns" columns of table "buyer_leads" */
export enum Buyer_Leads_Select_Column_Buyer_Leads_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  FinancialApproval = 'financial_approval'
}

/** input type for updating data in table "buyer_leads" */
export type Buyer_Leads_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  financial_approval?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Buyer_Leads_Stddev_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
  user_order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "buyer_leads" */
export type Buyer_Leads_Stddev_Order_By = {
  order_nr?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Buyer_Leads_Stddev_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
  user_order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "buyer_leads" */
export type Buyer_Leads_Stddev_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Buyer_Leads_Stddev_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
  user_order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "buyer_leads" */
export type Buyer_Leads_Stddev_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "buyer_leads" */
export type Buyer_Leads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Buyer_Leads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Buyer_Leads_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  financial_approval?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Buyer_Leads_Sum_Fields = {
  order_nr?: Maybe<Scalars['Int']['output']>;
  user_order_nr?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "buyer_leads" */
export type Buyer_Leads_Sum_Order_By = {
  order_nr?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** update columns of table "buyer_leads" */
export enum Buyer_Leads_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  FinancialApproval = 'financial_approval',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  Source = 'source',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserOrderNr = 'user_order_nr'
}

export type Buyer_Leads_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Buyer_Leads_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Buyer_Leads_Set_Input>;
  /** filter the rows which have to be updated */
  where: Buyer_Leads_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Buyer_Leads_Var_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
  user_order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "buyer_leads" */
export type Buyer_Leads_Var_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Buyer_Leads_Var_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
  user_order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "buyer_leads" */
export type Buyer_Leads_Var_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Buyer_Leads_Variance_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
  user_order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "buyer_leads" */
export type Buyer_Leads_Variance_Order_By = {
  order_nr?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** columns and relationships of "catchment_areas" */
export type Catchment_Areas = {
  /** An object relationship */
  place: Places;
  place_id: Scalars['uuid']['output'];
  tenant_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "catchment_areas" */
export type Catchment_Areas_Aggregate = {
  aggregate?: Maybe<Catchment_Areas_Aggregate_Fields>;
  nodes: Array<Catchment_Areas>;
};

export type Catchment_Areas_Aggregate_Bool_Exp = {
  count?: InputMaybe<Catchment_Areas_Aggregate_Bool_Exp_Count>;
};

export type Catchment_Areas_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Catchment_Areas_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "catchment_areas" */
export type Catchment_Areas_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Catchment_Areas_Max_Fields>;
  min?: Maybe<Catchment_Areas_Min_Fields>;
};


/** aggregate fields of "catchment_areas" */
export type Catchment_Areas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "catchment_areas" */
export type Catchment_Areas_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Catchment_Areas_Max_Order_By>;
  min?: InputMaybe<Catchment_Areas_Min_Order_By>;
};

/** input type for inserting array relation for remote table "catchment_areas" */
export type Catchment_Areas_Arr_Rel_Insert_Input = {
  data: Array<Catchment_Areas_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Catchment_Areas_On_Conflict>;
};

/** Boolean expression to filter rows from the table "catchment_areas". All fields are combined with a logical 'AND'. */
export type Catchment_Areas_Bool_Exp = {
  _and?: InputMaybe<Array<Catchment_Areas_Bool_Exp>>;
  _not?: InputMaybe<Catchment_Areas_Bool_Exp>;
  _or?: InputMaybe<Array<Catchment_Areas_Bool_Exp>>;
  place?: InputMaybe<Places_Bool_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "catchment_areas" */
export enum Catchment_Areas_Constraint {
  /** unique or primary key constraint on columns "place_id", "user_id", "tenant_id" */
  CatchmentAreasUserIdPlaceIdTenantIdUnique = 'catchment_areas_user_id_place_id_tenant_id_unique'
}

/** input type for inserting data into table "catchment_areas" */
export type Catchment_Areas_Insert_Input = {
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Catchment_Areas_Max_Fields = {
  place_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "catchment_areas" */
export type Catchment_Areas_Max_Order_By = {
  place_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Catchment_Areas_Min_Fields = {
  place_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "catchment_areas" */
export type Catchment_Areas_Min_Order_By = {
  place_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "catchment_areas" */
export type Catchment_Areas_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Catchment_Areas>;
};

/** on_conflict condition type for table "catchment_areas" */
export type Catchment_Areas_On_Conflict = {
  constraint: Catchment_Areas_Constraint;
  update_columns?: Array<Catchment_Areas_Update_Column>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};

/** Ordering options when selecting data from "catchment_areas". */
export type Catchment_Areas_Order_By = {
  place?: InputMaybe<Places_Order_By>;
  place_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "catchment_areas" */
export enum Catchment_Areas_Select_Column {
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "catchment_areas" */
export type Catchment_Areas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Catchment_Areas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Catchment_Areas_Stream_Cursor_Value_Input = {
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "catchment_areas" (current role has no relevant permissions) */
export enum Catchment_Areas_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "cma_listings" */
export type Ch_Cma_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Ch_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Ch_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "listing_is_online" */
  is_online?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  /** Gets all places associated with this listing */
  places?: Maybe<Array<Ch_Places>>;
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  /** An object relationship */
  property_types?: Maybe<Ch_Property_Types>;
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id: Scalars['uuid']['output'];
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "cma_listings" */
export type Ch_Cma_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_listings" */
export type Ch_Cma_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_listings" */
export type Ch_Cma_ListingsPlacesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


/** columns and relationships of "cma_listings" */
export type Ch_Cma_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cma_listings" */
export type Ch_Cma_Listings_Aggregate = {
  aggregate?: Maybe<Ch_Cma_Listings_Aggregate_Fields>;
  nodes: Array<Ch_Cma_Listings>;
};

/** aggregate fields of "cma_listings" */
export type Ch_Cma_Listings_Aggregate_Fields = {
  avg?: Maybe<Ch_Cma_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Cma_Listings_Max_Fields>;
  min?: Maybe<Ch_Cma_Listings_Min_Fields>;
  stddev?: Maybe<Ch_Cma_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Cma_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Cma_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Cma_Listings_Sum_Fields>;
  var_pop?: Maybe<Ch_Cma_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Cma_Listings_Var_Samp_Fields>;
  variance?: Maybe<Ch_Cma_Listings_Variance_Fields>;
};


/** aggregate fields of "cma_listings" */
export type Ch_Cma_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Cma_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Ch_Cma_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_listings". All fields are combined with a logical 'AND'. */
export type Ch_Cma_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Cma_Listings_Bool_Exp>>;
  _not?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Cma_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  available_from?: InputMaybe<Date_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_online?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  places?: InputMaybe<Ch_Places_Bool_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  property_types?: InputMaybe<Ch_Property_Types_Bool_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ch_Cma_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Ch_Cma_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "cma_listings". */
export type Ch_Cma_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  available_from?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Ch_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_online?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Ch_Places_Aggregate_Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  property_types?: InputMaybe<Ch_Property_Types_Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "cma_listings" */
export enum Ch_Cma_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Ch_Cma_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Ch_Cma_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Ch_Cma_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Ch_Cma_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Ch_Cma_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Ch_Cma_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Ch_Cma_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "get_merged_listings_type" */
export type Ch_Get_Merged_Listings_Type = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Scalars['json']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  removed?: Maybe<Scalars['Boolean']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "get_merged_listings_type" */
export type Ch_Get_Merged_Listings_TypeImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "get_merged_listings_type". All fields are combined with a logical 'AND'. */
export type Ch_Get_Merged_Listings_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Bool_Exp>>;
  _not?: InputMaybe<Ch_Get_Merged_Listings_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Json_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
};

/** Ordering options when selecting data from "get_merged_listings_type". */
export type Ch_Get_Merged_Listings_Type_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
};

/** select columns of table "get_merged_listings_type" */
export enum Ch_Get_Merged_Listings_Type_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UsableSurface = 'usable_surface'
}

/** columns and relationships of "merged_images" */
export type Ch_Merged_Images = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_hash?: Maybe<Scalars['bit']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "merged_images" */
export type Ch_Merged_Images_Aggregate = {
  aggregate?: Maybe<Ch_Merged_Images_Aggregate_Fields>;
  nodes: Array<Ch_Merged_Images>;
};

/** aggregate fields of "merged_images" */
export type Ch_Merged_Images_Aggregate_Fields = {
  avg?: Maybe<Ch_Merged_Images_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Merged_Images_Max_Fields>;
  min?: Maybe<Ch_Merged_Images_Min_Fields>;
  stddev?: Maybe<Ch_Merged_Images_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Merged_Images_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Merged_Images_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Merged_Images_Sum_Fields>;
  var_pop?: Maybe<Ch_Merged_Images_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Merged_Images_Var_Samp_Fields>;
  variance?: Maybe<Ch_Merged_Images_Variance_Fields>;
};


/** aggregate fields of "merged_images" */
export type Ch_Merged_Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "merged_images" */
export type Ch_Merged_Images_Aggregate_Order_By = {
  avg?: InputMaybe<Ch_Merged_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ch_Merged_Images_Max_Order_By>;
  min?: InputMaybe<Ch_Merged_Images_Min_Order_By>;
  stddev?: InputMaybe<Ch_Merged_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ch_Merged_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ch_Merged_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ch_Merged_Images_Sum_Order_By>;
  var_pop?: InputMaybe<Ch_Merged_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ch_Merged_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Ch_Merged_Images_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Ch_Merged_Images_Avg_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "merged_images" */
export type Ch_Merged_Images_Avg_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "merged_images". All fields are combined with a logical 'AND'. */
export type Ch_Merged_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Merged_Images_Bool_Exp>>;
  _not?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Merged_Images_Bool_Exp>>;
  bucket_name?: InputMaybe<String_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_hash?: InputMaybe<Bit_Comparison_Exp>;
  image_index?: InputMaybe<Int_Comparison_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ch_Merged_Images_Max_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "merged_images" */
export type Ch_Merged_Images_Max_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ch_Merged_Images_Min_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "merged_images" */
export type Ch_Merged_Images_Min_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "merged_images". */
export type Ch_Merged_Images_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_hash?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** select columns of table "merged_images" */
export enum Ch_Merged_Images_Select_Column {
  /** column name */
  BucketName = 'bucket_name',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImageHash = 'image_hash',
  /** column name */
  ImageIndex = 'image_index',
  /** column name */
  ListingId = 'listing_id'
}

/** aggregate stddev on columns */
export type Ch_Merged_Images_Stddev_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "merged_images" */
export type Ch_Merged_Images_Stddev_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ch_Merged_Images_Stddev_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "merged_images" */
export type Ch_Merged_Images_Stddev_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ch_Merged_Images_Stddev_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "merged_images" */
export type Ch_Merged_Images_Stddev_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Ch_Merged_Images_Sum_Fields = {
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "merged_images" */
export type Ch_Merged_Images_Sum_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Ch_Merged_Images_Var_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "merged_images" */
export type Ch_Merged_Images_Var_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ch_Merged_Images_Var_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "merged_images" */
export type Ch_Merged_Images_Var_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ch_Merged_Images_Variance_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "merged_images" */
export type Ch_Merged_Images_Variance_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "merged_listings" */
export type Ch_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_composite_property_type" */
  composite_property_type?: Maybe<Scalars['String']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Ch_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Ch_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Ch_Property_Main_Type_Enum;
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "merged_listings" */
export type Ch_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "merged_listings" */
export type Ch_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "merged_listings" */
export type Ch_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Ch_Merged_Listings_Aggregate = {
  aggregate?: Maybe<Ch_Merged_Listings_Aggregate_Fields>;
  nodes: Array<Ch_Merged_Listings>;
};

/** aggregate fields of "merged_listings" */
export type Ch_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<Ch_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Merged_Listings_Max_Fields>;
  min?: Maybe<Ch_Merged_Listings_Min_Fields>;
  stddev?: Maybe<Ch_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<Ch_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<Ch_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "merged_listings" */
export type Ch_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Ch_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "merged_listings". All fields are combined with a logical 'AND'. */
export type Ch_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  composite_property_type?: InputMaybe<String_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<Ch_Property_Main_Type_Enum_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ch_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Ch_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "merged_listings". */
export type Ch_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  composite_property_type?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Ch_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "merged_listings" */
export enum Ch_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Ch_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Ch_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Ch_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Ch_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Ch_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Ch_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Ch_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "places" */
export type Ch_Places = {
  /** An object relationship */
  agglomeration?: Maybe<Ch_Places>;
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  bbox?: Maybe<Scalars['_float8']['output']>;
  /** An array relationship */
  breadcrumbs: Array<Ch_Places_Breadcrumbs>;
  /** An aggregate relationship */
  breadcrumbs_aggregate: Ch_Places_Breadcrumbs_Aggregate;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  canonical_place?: Maybe<Ch_Places>;
  children_bbox?: Maybe<Scalars['jsonb']['output']>;
  children_count?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  district?: Maybe<Ch_Places>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  extra: Scalars['jsonb']['output'];
  geom: Scalars['geometry']['output'];
  id: Scalars['uuid']['output'];
  index: Scalars['Boolean']['output'];
  /** to use instead of label_en label_de etc, x-hasura-website-language must be set */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  /** An object relationship */
  locality?: Maybe<Ch_Places>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  municipality?: Maybe<Ch_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  municipality_places: Array<Ch_Places>;
  /** An aggregate relationship */
  municipality_places_aggregate: Ch_Places_Aggregate;
  name: Scalars['String']['output'];
  /** An object relationship */
  neighbourhood?: Maybe<Ch_Places>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  price_stats_quantiles: Array<Ch_Price_Stats_Quantiles>;
  /** An aggregate relationship */
  price_stats_quantiles_aggregate: Ch_Price_Stats_Quantiles_Aggregate;
  /** An object relationship */
  region?: Maybe<Ch_Places>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  search_base: Scalars['tsvector']['output'];
  /** to use instead of slug_en slug_de etc, x-hasura-website-language must be set */
  slug?: Maybe<Scalars['String']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  state?: Maybe<Ch_Places>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  state_places: Array<Ch_Places>;
  /** An aggregate relationship */
  state_places_aggregate: Ch_Places_Aggregate;
  type: Scalars['String']['output'];
};


/** columns and relationships of "places" */
export type Ch_PlacesBreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Ch_Places_Breadcrumbs_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Ch_PlacesBreadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Ch_Places_Breadcrumbs_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Ch_PlacesChildren_BboxArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "places" */
export type Ch_PlacesExtraArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "places" */
export type Ch_PlacesMunicipality_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Ch_PlacesMunicipality_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Ch_PlacesPrice_Stats_QuantilesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Quantiles_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Ch_PlacesPrice_Stats_Quantiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Quantiles_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Ch_PlacesState_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Ch_PlacesState_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};

/** aggregated selection of "places" */
export type Ch_Places_Aggregate = {
  aggregate?: Maybe<Ch_Places_Aggregate_Fields>;
  nodes: Array<Ch_Places>;
};

/** aggregate fields of "places" */
export type Ch_Places_Aggregate_Fields = {
  avg?: Maybe<Ch_Places_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Places_Max_Fields>;
  min?: Maybe<Ch_Places_Min_Fields>;
  stddev?: Maybe<Ch_Places_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Places_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Places_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Places_Sum_Fields>;
  var_pop?: Maybe<Ch_Places_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Places_Var_Samp_Fields>;
  variance?: Maybe<Ch_Places_Variance_Fields>;
};


/** aggregate fields of "places" */
export type Ch_Places_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Places_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places" */
export type Ch_Places_Aggregate_Order_By = {
  avg?: InputMaybe<Ch_Places_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ch_Places_Max_Order_By>;
  min?: InputMaybe<Ch_Places_Min_Order_By>;
  stddev?: InputMaybe<Ch_Places_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ch_Places_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ch_Places_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ch_Places_Sum_Order_By>;
  var_pop?: InputMaybe<Ch_Places_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ch_Places_Var_Samp_Order_By>;
  variance?: InputMaybe<Ch_Places_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Ch_Places_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places" */
export type Ch_Places_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places". All fields are combined with a logical 'AND'. */
export type Ch_Places_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Places_Bool_Exp>>;
  _not?: InputMaybe<Ch_Places_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Places_Bool_Exp>>;
  agglomeration?: InputMaybe<Ch_Places_Bool_Exp>;
  agglomeration_id?: InputMaybe<Uuid_Comparison_Exp>;
  bbox?: InputMaybe<_Float8_Comparison_Exp>;
  breadcrumbs?: InputMaybe<Ch_Places_Breadcrumbs_Bool_Exp>;
  canonical_id?: InputMaybe<Uuid_Comparison_Exp>;
  canonical_place?: InputMaybe<Ch_Places_Bool_Exp>;
  children_bbox?: InputMaybe<Jsonb_Comparison_Exp>;
  children_count?: InputMaybe<Int_Comparison_Exp>;
  district?: InputMaybe<Ch_Places_Bool_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  extra?: InputMaybe<Jsonb_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  index?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<Ch_Places_Bool_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality?: InputMaybe<Ch_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality_places?: InputMaybe<Ch_Places_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  neighbourhood?: InputMaybe<Ch_Places_Bool_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  population?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  price_stats_quantiles?: InputMaybe<Ch_Price_Stats_Quantiles_Bool_Exp>;
  region?: InputMaybe<Ch_Places_Bool_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  search_base?: InputMaybe<Tsvector_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  slug_de?: InputMaybe<String_Comparison_Exp>;
  slug_en?: InputMaybe<String_Comparison_Exp>;
  slug_es?: InputMaybe<String_Comparison_Exp>;
  slug_fr?: InputMaybe<String_Comparison_Exp>;
  slug_it?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<Ch_Places_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  state_places?: InputMaybe<Ch_Places_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  place?: Maybe<Ch_Places>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Aggregate = {
  aggregate?: Maybe<Ch_Places_Breadcrumbs_Aggregate_Fields>;
  nodes: Array<Ch_Places_Breadcrumbs>;
};

/** aggregate fields of "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Aggregate_Fields = {
  avg?: Maybe<Ch_Places_Breadcrumbs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Places_Breadcrumbs_Max_Fields>;
  min?: Maybe<Ch_Places_Breadcrumbs_Min_Fields>;
  stddev?: Maybe<Ch_Places_Breadcrumbs_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Places_Breadcrumbs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Places_Breadcrumbs_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Places_Breadcrumbs_Sum_Fields>;
  var_pop?: Maybe<Ch_Places_Breadcrumbs_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Places_Breadcrumbs_Var_Samp_Fields>;
  variance?: Maybe<Ch_Places_Breadcrumbs_Variance_Fields>;
};


/** aggregate fields of "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Places_Breadcrumbs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Aggregate_Order_By = {
  avg?: InputMaybe<Ch_Places_Breadcrumbs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ch_Places_Breadcrumbs_Max_Order_By>;
  min?: InputMaybe<Ch_Places_Breadcrumbs_Min_Order_By>;
  stddev?: InputMaybe<Ch_Places_Breadcrumbs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ch_Places_Breadcrumbs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ch_Places_Breadcrumbs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ch_Places_Breadcrumbs_Sum_Order_By>;
  var_pop?: InputMaybe<Ch_Places_Breadcrumbs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ch_Places_Breadcrumbs_Var_Samp_Order_By>;
  variance?: InputMaybe<Ch_Places_Breadcrumbs_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Ch_Places_Breadcrumbs_Avg_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Avg_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places_breadcrumbs". All fields are combined with a logical 'AND'. */
export type Ch_Places_Breadcrumbs_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Places_Breadcrumbs_Bool_Exp>>;
  _not?: InputMaybe<Ch_Places_Breadcrumbs_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Places_Breadcrumbs_Bool_Exp>>;
  breadcrumb_place_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_num?: InputMaybe<Bigint_Comparison_Exp>;
  place?: InputMaybe<Ch_Places_Bool_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ch_Places_Breadcrumbs_Max_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Max_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ch_Places_Breadcrumbs_Min_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Min_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places_breadcrumbs". */
export type Ch_Places_Breadcrumbs_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place?: InputMaybe<Ch_Places_Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** select columns of table "places_breadcrumbs" */
export enum Ch_Places_Breadcrumbs_Select_Column {
  /** column name */
  BreadcrumbPlaceId = 'breadcrumb_place_id',
  /** column name */
  OrderNum = 'order_num',
  /** column name */
  PlaceId = 'place_id'
}

/** aggregate stddev on columns */
export type Ch_Places_Breadcrumbs_Stddev_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Stddev_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ch_Places_Breadcrumbs_Stddev_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Stddev_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ch_Places_Breadcrumbs_Stddev_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Stddev_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Ch_Places_Breadcrumbs_Sum_Fields = {
  order_num?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Sum_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Ch_Places_Breadcrumbs_Var_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Var_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ch_Places_Breadcrumbs_Var_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Var_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ch_Places_Breadcrumbs_Variance_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Variance_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Ch_Places_Max_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "places" */
export type Ch_Places_Max_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ch_Places_Min_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "places" */
export type Ch_Places_Min_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places". */
export type Ch_Places_Order_By = {
  agglomeration?: InputMaybe<Ch_Places_Order_By>;
  agglomeration_id?: InputMaybe<Order_By>;
  bbox?: InputMaybe<Order_By>;
  breadcrumbs_aggregate?: InputMaybe<Ch_Places_Breadcrumbs_Aggregate_Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  canonical_place?: InputMaybe<Ch_Places_Order_By>;
  children_bbox?: InputMaybe<Order_By>;
  children_count?: InputMaybe<Order_By>;
  district?: InputMaybe<Ch_Places_Order_By>;
  district_id?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Ch_Places_Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Ch_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  municipality_places_aggregate?: InputMaybe<Ch_Places_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood?: InputMaybe<Ch_Places_Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  price_stats_quantiles_aggregate?: InputMaybe<Ch_Price_Stats_Quantiles_Aggregate_Order_By>;
  region?: InputMaybe<Ch_Places_Order_By>;
  region_id?: InputMaybe<Order_By>;
  search_base?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  state?: InputMaybe<Ch_Places_Order_By>;
  state_id?: InputMaybe<Order_By>;
  state_places_aggregate?: InputMaybe<Ch_Places_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "places" */
export enum Ch_Places_Select_Column {
  /** column name */
  AgglomerationId = 'agglomeration_id',
  /** column name */
  Bbox = 'bbox',
  /** column name */
  CanonicalId = 'canonical_id',
  /** column name */
  ChildrenBbox = 'children_bbox',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  Population = 'population',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SearchBase = 'search_base',
  /** column name */
  SlugDe = 'slug_de',
  /** column name */
  SlugEn = 'slug_en',
  /** column name */
  SlugEs = 'slug_es',
  /** column name */
  SlugFr = 'slug_fr',
  /** column name */
  SlugIt = 'slug_it',
  /** column name */
  StateId = 'state_id',
  /** column name */
  Type = 'type'
}

/** aggregate stddev on columns */
export type Ch_Places_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places" */
export type Ch_Places_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ch_Places_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places" */
export type Ch_Places_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ch_Places_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places" */
export type Ch_Places_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Ch_Places_Sum_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "places" */
export type Ch_Places_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Ch_Places_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places" */
export type Ch_Places_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ch_Places_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places" */
export type Ch_Places_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ch_Places_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places" */
export type Ch_Places_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** columns and relationships of "post_merged_listings" */
export type Ch_Post_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** A computed field, executes function "get_least_created_at" */
  created_at_consolidated?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Ch_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Ch_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_listing_images" */
  listing_images?: Maybe<Array<Ch_Merged_Images>>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_object?: Maybe<Ch_Places>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  municipality?: Maybe<Ch_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "post_merged_listings" */
export type Ch_Post_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "post_merged_listings" */
export type Ch_Post_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "post_merged_listings" */
export type Ch_Post_Merged_ListingsListing_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "post_merged_listings" */
export type Ch_Post_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Ch_Post_Merged_Listings_Aggregate = {
  aggregate?: Maybe<Ch_Post_Merged_Listings_Aggregate_Fields>;
  nodes: Array<Ch_Post_Merged_Listings>;
};

/** aggregate fields of "post_merged_listings" */
export type Ch_Post_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<Ch_Post_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Post_Merged_Listings_Max_Fields>;
  min?: Maybe<Ch_Post_Merged_Listings_Min_Fields>;
  stddev?: Maybe<Ch_Post_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Post_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Post_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Post_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<Ch_Post_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Post_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<Ch_Post_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "post_merged_listings" */
export type Ch_Post_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Post_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Ch_Post_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "post_merged_listings". All fields are combined with a logical 'AND'. */
export type Ch_Post_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Post_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<Ch_Post_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Post_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at_consolidated?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_images?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_object?: InputMaybe<Ch_Places_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality?: InputMaybe<Ch_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ch_Post_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Ch_Post_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "post_merged_listings". */
export type Ch_Post_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_at_consolidated?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Ch_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_images_aggregate?: InputMaybe<Ch_Merged_Images_Aggregate_Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_object?: InputMaybe<Ch_Places_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Ch_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "post_merged_listings" */
export enum Ch_Post_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Ch_Post_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Ch_Post_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Ch_Post_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Ch_Post_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Ch_Post_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Ch_Post_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Ch_Post_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles = {
  computed_surface_per_room_median?: Maybe<Scalars['jsonb']['output']>;
  confidence?: Maybe<Scalars['float8']['output']>;
  inherited?: Maybe<Scalars['Boolean']['output']>;
  p2m_cv?: Maybe<Scalars['float8']['output']>;
  percent_listings?: Maybe<Scalars['float8']['output']>;
  percent_perceived?: Maybe<Scalars['float8']['output']>;
  percent_sred?: Maybe<Scalars['float8']['output']>;
  place_id: Scalars['uuid']['output'];
  price_cv?: Maybe<Scalars['float8']['output']>;
  price_median?: Maybe<Scalars['float8']['output']>;
  price_p10?: Maybe<Scalars['float8']['output']>;
  price_p90?: Maybe<Scalars['float8']['output']>;
  price_per_m2_distribution?: Maybe<Scalars['jsonb']['output']>;
  price_per_m2_median?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['float8']['output']>;
  price_per_m2_percentiles?: Maybe<Scalars['jsonb']['output']>;
  property_main_type: Scalars['String']['output'];
  rent_generated_at?: Maybe<Scalars['date']['output']>;
  rent_median?: Maybe<Scalars['float8']['output']>;
  rent_p10?: Maybe<Scalars['float8']['output']>;
  rent_p90?: Maybe<Scalars['float8']['output']>;
  rent_per_m2_distribution?: Maybe<Scalars['jsonb']['output']>;
  rent_per_m2_median?: Maybe<Scalars['float8']['output']>;
  rent_per_m2_percentiles?: Maybe<Scalars['jsonb']['output']>;
  sale_generated_at?: Maybe<Scalars['date']['output']>;
  stock?: Maybe<Scalars['float8']['output']>;
};


/** columns and relationships of "price_stats_quantiles" */
export type Ch_Price_Stats_QuantilesComputed_Surface_Per_Room_MedianArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "price_stats_quantiles" */
export type Ch_Price_Stats_QuantilesPrice_Per_M2_DistributionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "price_stats_quantiles" */
export type Ch_Price_Stats_QuantilesPrice_Per_M2_PercentilesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "price_stats_quantiles" */
export type Ch_Price_Stats_QuantilesRent_Per_M2_DistributionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "price_stats_quantiles" */
export type Ch_Price_Stats_QuantilesRent_Per_M2_PercentilesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Aggregate = {
  aggregate?: Maybe<Ch_Price_Stats_Quantiles_Aggregate_Fields>;
  nodes: Array<Ch_Price_Stats_Quantiles>;
};

/** aggregate fields of "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Aggregate_Fields = {
  avg?: Maybe<Ch_Price_Stats_Quantiles_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Price_Stats_Quantiles_Max_Fields>;
  min?: Maybe<Ch_Price_Stats_Quantiles_Min_Fields>;
  stddev?: Maybe<Ch_Price_Stats_Quantiles_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Price_Stats_Quantiles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Price_Stats_Quantiles_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Price_Stats_Quantiles_Sum_Fields>;
  var_pop?: Maybe<Ch_Price_Stats_Quantiles_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Price_Stats_Quantiles_Var_Samp_Fields>;
  variance?: Maybe<Ch_Price_Stats_Quantiles_Variance_Fields>;
};


/** aggregate fields of "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Aggregate_Order_By = {
  avg?: InputMaybe<Ch_Price_Stats_Quantiles_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ch_Price_Stats_Quantiles_Max_Order_By>;
  min?: InputMaybe<Ch_Price_Stats_Quantiles_Min_Order_By>;
  stddev?: InputMaybe<Ch_Price_Stats_Quantiles_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ch_Price_Stats_Quantiles_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ch_Price_Stats_Quantiles_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ch_Price_Stats_Quantiles_Sum_Order_By>;
  var_pop?: InputMaybe<Ch_Price_Stats_Quantiles_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ch_Price_Stats_Quantiles_Var_Samp_Order_By>;
  variance?: InputMaybe<Ch_Price_Stats_Quantiles_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Ch_Price_Stats_Quantiles_Avg_Fields = {
  confidence?: Maybe<Scalars['Float']['output']>;
  p2m_cv?: Maybe<Scalars['Float']['output']>;
  percent_listings?: Maybe<Scalars['Float']['output']>;
  percent_perceived?: Maybe<Scalars['Float']['output']>;
  percent_sred?: Maybe<Scalars['Float']['output']>;
  price_cv?: Maybe<Scalars['Float']['output']>;
  price_median?: Maybe<Scalars['Float']['output']>;
  price_p10?: Maybe<Scalars['Float']['output']>;
  price_p90?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['Float']['output']>;
  rent_median?: Maybe<Scalars['Float']['output']>;
  rent_p10?: Maybe<Scalars['Float']['output']>;
  rent_p90?: Maybe<Scalars['Float']['output']>;
  rent_per_m2_median?: Maybe<Scalars['Float']['output']>;
  stock?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Avg_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "price_stats_quantiles". All fields are combined with a logical 'AND'. */
export type Ch_Price_Stats_Quantiles_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Bool_Exp>>;
  _not?: InputMaybe<Ch_Price_Stats_Quantiles_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Bool_Exp>>;
  computed_surface_per_room_median?: InputMaybe<Jsonb_Comparison_Exp>;
  confidence?: InputMaybe<Float8_Comparison_Exp>;
  inherited?: InputMaybe<Boolean_Comparison_Exp>;
  p2m_cv?: InputMaybe<Float8_Comparison_Exp>;
  percent_listings?: InputMaybe<Float8_Comparison_Exp>;
  percent_perceived?: InputMaybe<Float8_Comparison_Exp>;
  percent_sred?: InputMaybe<Float8_Comparison_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_cv?: InputMaybe<Float8_Comparison_Exp>;
  price_median?: InputMaybe<Float8_Comparison_Exp>;
  price_p10?: InputMaybe<Float8_Comparison_Exp>;
  price_p90?: InputMaybe<Float8_Comparison_Exp>;
  price_per_m2_distribution?: InputMaybe<Jsonb_Comparison_Exp>;
  price_per_m2_median?: InputMaybe<Float8_Comparison_Exp>;
  price_per_m2_median_listings?: InputMaybe<Float8_Comparison_Exp>;
  price_per_m2_median_sred?: InputMaybe<Float8_Comparison_Exp>;
  price_per_m2_percentiles?: InputMaybe<Jsonb_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  rent_generated_at?: InputMaybe<Date_Comparison_Exp>;
  rent_median?: InputMaybe<Float8_Comparison_Exp>;
  rent_p10?: InputMaybe<Float8_Comparison_Exp>;
  rent_p90?: InputMaybe<Float8_Comparison_Exp>;
  rent_per_m2_distribution?: InputMaybe<Jsonb_Comparison_Exp>;
  rent_per_m2_median?: InputMaybe<Float8_Comparison_Exp>;
  rent_per_m2_percentiles?: InputMaybe<Jsonb_Comparison_Exp>;
  sale_generated_at?: InputMaybe<Date_Comparison_Exp>;
  stock?: InputMaybe<Float8_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ch_Price_Stats_Quantiles_Max_Fields = {
  confidence?: Maybe<Scalars['float8']['output']>;
  p2m_cv?: Maybe<Scalars['float8']['output']>;
  percent_listings?: Maybe<Scalars['float8']['output']>;
  percent_perceived?: Maybe<Scalars['float8']['output']>;
  percent_sred?: Maybe<Scalars['float8']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  price_cv?: Maybe<Scalars['float8']['output']>;
  price_median?: Maybe<Scalars['float8']['output']>;
  price_p10?: Maybe<Scalars['float8']['output']>;
  price_p90?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['float8']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_generated_at?: Maybe<Scalars['date']['output']>;
  rent_median?: Maybe<Scalars['float8']['output']>;
  rent_p10?: Maybe<Scalars['float8']['output']>;
  rent_p90?: Maybe<Scalars['float8']['output']>;
  rent_per_m2_median?: Maybe<Scalars['float8']['output']>;
  sale_generated_at?: Maybe<Scalars['date']['output']>;
  stock?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Max_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_generated_at?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  sale_generated_at?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ch_Price_Stats_Quantiles_Min_Fields = {
  confidence?: Maybe<Scalars['float8']['output']>;
  p2m_cv?: Maybe<Scalars['float8']['output']>;
  percent_listings?: Maybe<Scalars['float8']['output']>;
  percent_perceived?: Maybe<Scalars['float8']['output']>;
  percent_sred?: Maybe<Scalars['float8']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  price_cv?: Maybe<Scalars['float8']['output']>;
  price_median?: Maybe<Scalars['float8']['output']>;
  price_p10?: Maybe<Scalars['float8']['output']>;
  price_p90?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['float8']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_generated_at?: Maybe<Scalars['date']['output']>;
  rent_median?: Maybe<Scalars['float8']['output']>;
  rent_p10?: Maybe<Scalars['float8']['output']>;
  rent_p90?: Maybe<Scalars['float8']['output']>;
  rent_per_m2_median?: Maybe<Scalars['float8']['output']>;
  sale_generated_at?: Maybe<Scalars['date']['output']>;
  stock?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Min_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_generated_at?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  sale_generated_at?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "price_stats_quantiles". */
export type Ch_Price_Stats_Quantiles_Order_By = {
  computed_surface_per_room_median?: InputMaybe<Order_By>;
  confidence?: InputMaybe<Order_By>;
  inherited?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_distribution?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  price_per_m2_percentiles?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_generated_at?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_distribution?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  rent_per_m2_percentiles?: InputMaybe<Order_By>;
  sale_generated_at?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** select columns of table "price_stats_quantiles" */
export enum Ch_Price_Stats_Quantiles_Select_Column {
  /** column name */
  ComputedSurfacePerRoomMedian = 'computed_surface_per_room_median',
  /** column name */
  Confidence = 'confidence',
  /** column name */
  Inherited = 'inherited',
  /** column name */
  P2mCv = 'p2m_cv',
  /** column name */
  PercentListings = 'percent_listings',
  /** column name */
  PercentPerceived = 'percent_perceived',
  /** column name */
  PercentSred = 'percent_sred',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PriceCv = 'price_cv',
  /** column name */
  PriceMedian = 'price_median',
  /** column name */
  PriceP10 = 'price_p10',
  /** column name */
  PriceP90 = 'price_p90',
  /** column name */
  PricePerM2Distribution = 'price_per_m2_distribution',
  /** column name */
  PricePerM2Median = 'price_per_m2_median',
  /** column name */
  PricePerM2MedianListings = 'price_per_m2_median_listings',
  /** column name */
  PricePerM2MedianSred = 'price_per_m2_median_sred',
  /** column name */
  PricePerM2Percentiles = 'price_per_m2_percentiles',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  RentGeneratedAt = 'rent_generated_at',
  /** column name */
  RentMedian = 'rent_median',
  /** column name */
  RentP10 = 'rent_p10',
  /** column name */
  RentP90 = 'rent_p90',
  /** column name */
  RentPerM2Distribution = 'rent_per_m2_distribution',
  /** column name */
  RentPerM2Median = 'rent_per_m2_median',
  /** column name */
  RentPerM2Percentiles = 'rent_per_m2_percentiles',
  /** column name */
  SaleGeneratedAt = 'sale_generated_at',
  /** column name */
  Stock = 'stock'
}

/** aggregate stddev on columns */
export type Ch_Price_Stats_Quantiles_Stddev_Fields = {
  confidence?: Maybe<Scalars['Float']['output']>;
  p2m_cv?: Maybe<Scalars['Float']['output']>;
  percent_listings?: Maybe<Scalars['Float']['output']>;
  percent_perceived?: Maybe<Scalars['Float']['output']>;
  percent_sred?: Maybe<Scalars['Float']['output']>;
  price_cv?: Maybe<Scalars['Float']['output']>;
  price_median?: Maybe<Scalars['Float']['output']>;
  price_p10?: Maybe<Scalars['Float']['output']>;
  price_p90?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['Float']['output']>;
  rent_median?: Maybe<Scalars['Float']['output']>;
  rent_p10?: Maybe<Scalars['Float']['output']>;
  rent_p90?: Maybe<Scalars['Float']['output']>;
  rent_per_m2_median?: Maybe<Scalars['Float']['output']>;
  stock?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Stddev_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ch_Price_Stats_Quantiles_Stddev_Pop_Fields = {
  confidence?: Maybe<Scalars['Float']['output']>;
  p2m_cv?: Maybe<Scalars['Float']['output']>;
  percent_listings?: Maybe<Scalars['Float']['output']>;
  percent_perceived?: Maybe<Scalars['Float']['output']>;
  percent_sred?: Maybe<Scalars['Float']['output']>;
  price_cv?: Maybe<Scalars['Float']['output']>;
  price_median?: Maybe<Scalars['Float']['output']>;
  price_p10?: Maybe<Scalars['Float']['output']>;
  price_p90?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['Float']['output']>;
  rent_median?: Maybe<Scalars['Float']['output']>;
  rent_p10?: Maybe<Scalars['Float']['output']>;
  rent_p90?: Maybe<Scalars['Float']['output']>;
  rent_per_m2_median?: Maybe<Scalars['Float']['output']>;
  stock?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Stddev_Pop_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ch_Price_Stats_Quantiles_Stddev_Samp_Fields = {
  confidence?: Maybe<Scalars['Float']['output']>;
  p2m_cv?: Maybe<Scalars['Float']['output']>;
  percent_listings?: Maybe<Scalars['Float']['output']>;
  percent_perceived?: Maybe<Scalars['Float']['output']>;
  percent_sred?: Maybe<Scalars['Float']['output']>;
  price_cv?: Maybe<Scalars['Float']['output']>;
  price_median?: Maybe<Scalars['Float']['output']>;
  price_p10?: Maybe<Scalars['Float']['output']>;
  price_p90?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['Float']['output']>;
  rent_median?: Maybe<Scalars['Float']['output']>;
  rent_p10?: Maybe<Scalars['Float']['output']>;
  rent_p90?: Maybe<Scalars['Float']['output']>;
  rent_per_m2_median?: Maybe<Scalars['Float']['output']>;
  stock?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Stddev_Samp_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Ch_Price_Stats_Quantiles_Sum_Fields = {
  confidence?: Maybe<Scalars['float8']['output']>;
  p2m_cv?: Maybe<Scalars['float8']['output']>;
  percent_listings?: Maybe<Scalars['float8']['output']>;
  percent_perceived?: Maybe<Scalars['float8']['output']>;
  percent_sred?: Maybe<Scalars['float8']['output']>;
  price_cv?: Maybe<Scalars['float8']['output']>;
  price_median?: Maybe<Scalars['float8']['output']>;
  price_p10?: Maybe<Scalars['float8']['output']>;
  price_p90?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['float8']['output']>;
  rent_median?: Maybe<Scalars['float8']['output']>;
  rent_p10?: Maybe<Scalars['float8']['output']>;
  rent_p90?: Maybe<Scalars['float8']['output']>;
  rent_per_m2_median?: Maybe<Scalars['float8']['output']>;
  stock?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Sum_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Ch_Price_Stats_Quantiles_Var_Pop_Fields = {
  confidence?: Maybe<Scalars['Float']['output']>;
  p2m_cv?: Maybe<Scalars['Float']['output']>;
  percent_listings?: Maybe<Scalars['Float']['output']>;
  percent_perceived?: Maybe<Scalars['Float']['output']>;
  percent_sred?: Maybe<Scalars['Float']['output']>;
  price_cv?: Maybe<Scalars['Float']['output']>;
  price_median?: Maybe<Scalars['Float']['output']>;
  price_p10?: Maybe<Scalars['Float']['output']>;
  price_p90?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['Float']['output']>;
  rent_median?: Maybe<Scalars['Float']['output']>;
  rent_p10?: Maybe<Scalars['Float']['output']>;
  rent_p90?: Maybe<Scalars['Float']['output']>;
  rent_per_m2_median?: Maybe<Scalars['Float']['output']>;
  stock?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Var_Pop_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ch_Price_Stats_Quantiles_Var_Samp_Fields = {
  confidence?: Maybe<Scalars['Float']['output']>;
  p2m_cv?: Maybe<Scalars['Float']['output']>;
  percent_listings?: Maybe<Scalars['Float']['output']>;
  percent_perceived?: Maybe<Scalars['Float']['output']>;
  percent_sred?: Maybe<Scalars['Float']['output']>;
  price_cv?: Maybe<Scalars['Float']['output']>;
  price_median?: Maybe<Scalars['Float']['output']>;
  price_p10?: Maybe<Scalars['Float']['output']>;
  price_p90?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['Float']['output']>;
  rent_median?: Maybe<Scalars['Float']['output']>;
  rent_p10?: Maybe<Scalars['Float']['output']>;
  rent_p90?: Maybe<Scalars['Float']['output']>;
  rent_per_m2_median?: Maybe<Scalars['Float']['output']>;
  stock?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Var_Samp_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ch_Price_Stats_Quantiles_Variance_Fields = {
  confidence?: Maybe<Scalars['Float']['output']>;
  p2m_cv?: Maybe<Scalars['Float']['output']>;
  percent_listings?: Maybe<Scalars['Float']['output']>;
  percent_perceived?: Maybe<Scalars['Float']['output']>;
  percent_sred?: Maybe<Scalars['Float']['output']>;
  price_cv?: Maybe<Scalars['Float']['output']>;
  price_median?: Maybe<Scalars['Float']['output']>;
  price_p10?: Maybe<Scalars['Float']['output']>;
  price_p90?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['Float']['output']>;
  rent_median?: Maybe<Scalars['Float']['output']>;
  rent_p10?: Maybe<Scalars['Float']['output']>;
  rent_p90?: Maybe<Scalars['Float']['output']>;
  rent_per_m2_median?: Maybe<Scalars['Float']['output']>;
  stock?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Variance_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

export enum Ch_Property_Main_Type_Enum {
  Agri = 'AGRI',
  Appt = 'APPT',
  Building = 'BUILDING',
  Commercial = 'COMMERCIAL',
  Garden = 'GARDEN',
  Gastro = 'GASTRO',
  House = 'HOUSE',
  HouseAppt = 'HOUSE_APPT',
  Indus = 'INDUS',
  Other = 'OTHER',
  Park = 'PARK',
  Prop = 'PROP',
  Room = 'ROOM',
  Secondary = 'SECONDARY'
}

/** Boolean expression to compare columns of type "ch_property_main_type_enum". All fields are combined with logical 'AND'. */
export type Ch_Property_Main_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ch_Property_Main_Type_Enum>;
  _in?: InputMaybe<Array<Ch_Property_Main_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Ch_Property_Main_Type_Enum>;
  _nin?: InputMaybe<Array<Ch_Property_Main_Type_Enum>>;
};

/** columns and relationships of "property_types" */
export type Ch_Property_Types = {
  /** A computed field, executes function "property_types_label" */
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "property_types". All fields are combined with a logical 'AND'. */
export type Ch_Property_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Property_Types_Bool_Exp>>;
  _not?: InputMaybe<Ch_Property_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Property_Types_Bool_Exp>>;
  label?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "property_types". */
export type Ch_Property_Types_Order_By = {
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "property_types" */
export enum Ch_Property_Types_Select_Column {
  /** column name */
  Name = 'name'
}

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type Citext_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['citext']['input']>;
  _gt?: InputMaybe<Scalars['citext']['input']>;
  _gte?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['citext']['input']>;
  _in?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['citext']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['citext']['input']>;
  _lt?: InputMaybe<Scalars['citext']['input']>;
  _lte?: InputMaybe<Scalars['citext']['input']>;
  _neq?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['citext']['input']>;
  _nin?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['citext']['input']>;
};

/** columns and relationships of "cma_report_files" */
export type Cma_Report_Files = {
  /** An object relationship */
  cma_report?: Maybe<Cma_Reports>;
  cma_report_id: Scalars['uuid']['output'];
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  is_visible: Scalars['Boolean']['output'];
  order_nr: Scalars['Int']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
};

/** aggregated selection of "cma_report_files" */
export type Cma_Report_Files_Aggregate = {
  aggregate?: Maybe<Cma_Report_Files_Aggregate_Fields>;
  nodes: Array<Cma_Report_Files>;
};

export type Cma_Report_Files_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Cma_Report_Files_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Cma_Report_Files_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Cma_Report_Files_Aggregate_Bool_Exp_Count>;
};

export type Cma_Report_Files_Aggregate_Bool_Exp_Bool_And = {
  arguments: Cma_Report_Files_Select_Column_Cma_Report_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Report_Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cma_Report_Files_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Cma_Report_Files_Select_Column_Cma_Report_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Report_Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cma_Report_Files_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cma_Report_Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Report_Files_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cma_report_files" */
export type Cma_Report_Files_Aggregate_Fields = {
  avg?: Maybe<Cma_Report_Files_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Cma_Report_Files_Max_Fields>;
  min?: Maybe<Cma_Report_Files_Min_Fields>;
  stddev?: Maybe<Cma_Report_Files_Stddev_Fields>;
  stddev_pop?: Maybe<Cma_Report_Files_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cma_Report_Files_Stddev_Samp_Fields>;
  sum?: Maybe<Cma_Report_Files_Sum_Fields>;
  var_pop?: Maybe<Cma_Report_Files_Var_Pop_Fields>;
  var_samp?: Maybe<Cma_Report_Files_Var_Samp_Fields>;
  variance?: Maybe<Cma_Report_Files_Variance_Fields>;
};


/** aggregate fields of "cma_report_files" */
export type Cma_Report_Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cma_Report_Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cma_report_files" */
export type Cma_Report_Files_Aggregate_Order_By = {
  avg?: InputMaybe<Cma_Report_Files_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cma_Report_Files_Max_Order_By>;
  min?: InputMaybe<Cma_Report_Files_Min_Order_By>;
  stddev?: InputMaybe<Cma_Report_Files_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Cma_Report_Files_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Cma_Report_Files_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Cma_Report_Files_Sum_Order_By>;
  var_pop?: InputMaybe<Cma_Report_Files_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Cma_Report_Files_Var_Samp_Order_By>;
  variance?: InputMaybe<Cma_Report_Files_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "cma_report_files" */
export type Cma_Report_Files_Arr_Rel_Insert_Input = {
  data: Array<Cma_Report_Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cma_Report_Files_On_Conflict>;
};

/** aggregate avg on columns */
export type Cma_Report_Files_Avg_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "cma_report_files" */
export type Cma_Report_Files_Avg_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cma_report_files". All fields are combined with a logical 'AND'. */
export type Cma_Report_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Cma_Report_Files_Bool_Exp>>;
  _not?: InputMaybe<Cma_Report_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Cma_Report_Files_Bool_Exp>>;
  cma_report?: InputMaybe<Cma_Reports_Bool_Exp>;
  cma_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_visible?: InputMaybe<Boolean_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "cma_report_files" */
export enum Cma_Report_Files_Constraint {
  /** unique or primary key constraint on columns "file_id", "cma_report_id" */
  CmaReportFilesCmaReportIdFileIdKey = 'cma_report_files_cma_report_id_file_id_key',
  /** unique or primary key constraint on columns "order_nr", "cma_report_id" */
  CmaReportOrderUnique = 'cma_report_order_unique'
}

/** input type for incrementing numeric columns in table "cma_report_files" */
export type Cma_Report_Files_Inc_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "cma_report_files" */
export type Cma_Report_Files_Insert_Input = {
  cma_report?: InputMaybe<Cma_Reports_Obj_Rel_Insert_Input>;
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Cma_Report_Files_Max_Fields = {
  cma_report_id?: Maybe<Scalars['uuid']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "cma_report_files" */
export type Cma_Report_Files_Max_Order_By = {
  cma_report_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cma_Report_Files_Min_Fields = {
  cma_report_id?: Maybe<Scalars['uuid']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "cma_report_files" */
export type Cma_Report_Files_Min_Order_By = {
  cma_report_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cma_report_files" */
export type Cma_Report_Files_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cma_Report_Files>;
};

/** on_conflict condition type for table "cma_report_files" */
export type Cma_Report_Files_On_Conflict = {
  constraint: Cma_Report_Files_Constraint;
  update_columns?: Array<Cma_Report_Files_Update_Column>;
  where?: InputMaybe<Cma_Report_Files_Bool_Exp>;
};

/** Ordering options when selecting data from "cma_report_files". */
export type Cma_Report_Files_Order_By = {
  cma_report?: InputMaybe<Cma_Reports_Order_By>;
  cma_report_id?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  is_visible?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** select columns of table "cma_report_files" */
export enum Cma_Report_Files_Select_Column {
  /** column name */
  CmaReportId = 'cma_report_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TenantId = 'tenant_id'
}

/** select "cma_report_files_aggregate_bool_exp_bool_and_arguments_columns" columns of table "cma_report_files" */
export enum Cma_Report_Files_Select_Column_Cma_Report_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsVisible = 'is_visible'
}

/** select "cma_report_files_aggregate_bool_exp_bool_or_arguments_columns" columns of table "cma_report_files" */
export enum Cma_Report_Files_Select_Column_Cma_Report_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsVisible = 'is_visible'
}

/** input type for updating data in table "cma_report_files" */
export type Cma_Report_Files_Set_Input = {
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Cma_Report_Files_Stddev_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "cma_report_files" */
export type Cma_Report_Files_Stddev_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Cma_Report_Files_Stddev_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "cma_report_files" */
export type Cma_Report_Files_Stddev_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Cma_Report_Files_Stddev_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "cma_report_files" */
export type Cma_Report_Files_Stddev_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cma_report_files" */
export type Cma_Report_Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cma_Report_Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cma_Report_Files_Stream_Cursor_Value_Input = {
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Cma_Report_Files_Sum_Fields = {
  order_nr?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "cma_report_files" */
export type Cma_Report_Files_Sum_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** update columns of table "cma_report_files" */
export enum Cma_Report_Files_Update_Column {
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  OrderNr = 'order_nr'
}

export type Cma_Report_Files_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cma_Report_Files_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cma_Report_Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cma_Report_Files_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Cma_Report_Files_Var_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "cma_report_files" */
export type Cma_Report_Files_Var_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Cma_Report_Files_Var_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "cma_report_files" */
export type Cma_Report_Files_Var_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Cma_Report_Files_Variance_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "cma_report_files" */
export type Cma_Report_Files_Variance_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** columns and relationships of "cma_reports" */
export type Cma_Reports = {
  /** An object relationship */
  broker?: Maybe<Users>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  caprate_estimated_monthly_rent?: Maybe<Scalars['Int']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  /** An array relationship */
  cma_report_files: Array<Cma_Report_Files>;
  /** An aggregate relationship */
  cma_report_files_aggregate: Cma_Report_Files_Aggregate;
  /** An array relationship */
  comparable_listings: Array<Cma_Reports_Comparables>;
  construction_cost_base?: Maybe<Cma_Reports_Construction_Base_Enum_Enum>;
  /** An object relationship */
  contact?: Maybe<Users>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  cover_image?: Maybe<Images>;
  cover_image_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  doc_template?: Maybe<Doc_Templates>;
  doc_template_id?: Maybe<Scalars['uuid']['output']>;
  font_family?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  include_agent: Scalars['Boolean']['output'];
  include_agent_agency: Scalars['Boolean']['output'];
  include_append_files: Scalars['Boolean']['output'];
  include_client_testimonial: Scalars['Boolean']['output'];
  include_comparables_valuation: Scalars['Boolean']['output'];
  include_cover: Scalars['Boolean']['output'];
  include_cuprate_valuation: Scalars['Boolean']['output'];
  include_description: Scalars['Boolean']['output'];
  include_final_value: Scalars['Boolean']['output'];
  include_hedonistic_valuation: Scalars['Boolean']['output'];
  include_intrinsic_valuation: Scalars['Boolean']['output'];
  include_introduction: Scalars['Boolean']['output'];
  include_photos: Scalars['Boolean']['output'];
  include_pois: Scalars['Boolean']['output'];
  include_potential_buyers: Scalars['Boolean']['output'];
  include_property: Scalars['Boolean']['output'];
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Int']['output']>;
  /** Array of custom fields for intrinsic valuation, each containing id, title, and value */
  intrinsic_custom_fields?: Maybe<Scalars['jsonb']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Int']['output']>;
  introduction?: Maybe<Scalars['String']['output']>;
  is_price_range: Scalars['Boolean']['output'];
  language: Scalars['user_language']['output'];
  /** An object relationship */
  lead?: Maybe<Leads>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  max_budget?: Maybe<Scalars['Int']['output']>;
  min_budget?: Maybe<Scalars['Int']['output']>;
  negative_comments?: Maybe<Scalars['String']['output']>;
  positive_comments?: Maybe<Scalars['String']['output']>;
  price_range_max?: Maybe<Scalars['Int']['output']>;
  price_range_min?: Maybe<Scalars['Int']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Int']['output']>;
  report_title?: Maybe<Scalars['String']['output']>;
  show_probability: Scalars['Boolean']['output'];
  suggested_market_value?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  tenant?: Maybe<Tenants>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
};


/** columns and relationships of "cma_reports" */
export type Cma_ReportsCma_Report_FilesArgs = {
  distinct_on?: InputMaybe<Array<Cma_Report_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Report_Files_Order_By>>;
  where?: InputMaybe<Cma_Report_Files_Bool_Exp>;
};


/** columns and relationships of "cma_reports" */
export type Cma_ReportsCma_Report_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cma_Report_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Report_Files_Order_By>>;
  where?: InputMaybe<Cma_Report_Files_Bool_Exp>;
};


/** columns and relationships of "cma_reports" */
export type Cma_ReportsComparable_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Comparables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Comparables_Order_By>>;
  where?: InputMaybe<Cma_Reports_Comparables_Bool_Exp>;
};


/** columns and relationships of "cma_reports" */
export type Cma_ReportsIntrinsic_Custom_FieldsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cma_reports" */
export type Cma_Reports_Aggregate = {
  aggregate?: Maybe<Cma_Reports_Aggregate_Fields>;
  nodes: Array<Cma_Reports>;
};

export type Cma_Reports_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Cma_Reports_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Cma_Reports_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Cma_Reports_Aggregate_Bool_Exp_Count>;
};

export type Cma_Reports_Aggregate_Bool_Exp_Bool_And = {
  arguments: Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Reports_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cma_Reports_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Reports_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cma_Reports_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Reports_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cma_reports" */
export type Cma_Reports_Aggregate_Fields = {
  avg?: Maybe<Cma_Reports_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Cma_Reports_Max_Fields>;
  min?: Maybe<Cma_Reports_Min_Fields>;
  stddev?: Maybe<Cma_Reports_Stddev_Fields>;
  stddev_pop?: Maybe<Cma_Reports_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cma_Reports_Stddev_Samp_Fields>;
  sum?: Maybe<Cma_Reports_Sum_Fields>;
  var_pop?: Maybe<Cma_Reports_Var_Pop_Fields>;
  var_samp?: Maybe<Cma_Reports_Var_Samp_Fields>;
  variance?: Maybe<Cma_Reports_Variance_Fields>;
};


/** aggregate fields of "cma_reports" */
export type Cma_Reports_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cma_reports" */
export type Cma_Reports_Aggregate_Order_By = {
  avg?: InputMaybe<Cma_Reports_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cma_Reports_Max_Order_By>;
  min?: InputMaybe<Cma_Reports_Min_Order_By>;
  stddev?: InputMaybe<Cma_Reports_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Cma_Reports_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Cma_Reports_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Cma_Reports_Sum_Order_By>;
  var_pop?: InputMaybe<Cma_Reports_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Cma_Reports_Var_Samp_Order_By>;
  variance?: InputMaybe<Cma_Reports_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Cma_Reports_Append_Input = {
  /** Array of custom fields for intrinsic valuation, each containing id, title, and value */
  intrinsic_custom_fields?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "cma_reports" */
export type Cma_Reports_Arr_Rel_Insert_Input = {
  data: Array<Cma_Reports_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cma_Reports_On_Conflict>;
};

/** aggregate avg on columns */
export type Cma_Reports_Avg_Fields = {
  caprate_estimated_monthly_rent?: Maybe<Scalars['Float']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Float']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Float']['output']>;
  max_budget?: Maybe<Scalars['Float']['output']>;
  min_budget?: Maybe<Scalars['Float']['output']>;
  price_range_max?: Maybe<Scalars['Float']['output']>;
  price_range_min?: Maybe<Scalars['Float']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Float']['output']>;
  suggested_market_value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "cma_reports" */
export type Cma_Reports_Avg_Order_By = {
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cma_reports". All fields are combined with a logical 'AND'. */
export type Cma_Reports_Bool_Exp = {
  _and?: InputMaybe<Array<Cma_Reports_Bool_Exp>>;
  _not?: InputMaybe<Cma_Reports_Bool_Exp>;
  _or?: InputMaybe<Array<Cma_Reports_Bool_Exp>>;
  broker?: InputMaybe<Users_Bool_Exp>;
  broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  caprate_estimated_monthly_rent?: InputMaybe<Int_Comparison_Exp>;
  caprate_minimum_required_yield?: InputMaybe<Float_Comparison_Exp>;
  cma_report_files?: InputMaybe<Cma_Report_Files_Bool_Exp>;
  cma_report_files_aggregate?: InputMaybe<Cma_Report_Files_Aggregate_Bool_Exp>;
  comparable_listings?: InputMaybe<Cma_Reports_Comparables_Bool_Exp>;
  construction_cost_base?: InputMaybe<Cma_Reports_Construction_Base_Enum_Enum_Comparison_Exp>;
  contact?: InputMaybe<Users_Bool_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  cover_image?: InputMaybe<Images_Bool_Exp>;
  cover_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_user?: InputMaybe<Users_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  doc_template?: InputMaybe<Doc_Templates_Bool_Exp>;
  doc_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  font_family?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  include_agent?: InputMaybe<Boolean_Comparison_Exp>;
  include_agent_agency?: InputMaybe<Boolean_Comparison_Exp>;
  include_append_files?: InputMaybe<Boolean_Comparison_Exp>;
  include_client_testimonial?: InputMaybe<Boolean_Comparison_Exp>;
  include_comparables_valuation?: InputMaybe<Boolean_Comparison_Exp>;
  include_cover?: InputMaybe<Boolean_Comparison_Exp>;
  include_cuprate_valuation?: InputMaybe<Boolean_Comparison_Exp>;
  include_description?: InputMaybe<Boolean_Comparison_Exp>;
  include_final_value?: InputMaybe<Boolean_Comparison_Exp>;
  include_hedonistic_valuation?: InputMaybe<Boolean_Comparison_Exp>;
  include_intrinsic_valuation?: InputMaybe<Boolean_Comparison_Exp>;
  include_introduction?: InputMaybe<Boolean_Comparison_Exp>;
  include_photos?: InputMaybe<Boolean_Comparison_Exp>;
  include_pois?: InputMaybe<Boolean_Comparison_Exp>;
  include_potential_buyers?: InputMaybe<Boolean_Comparison_Exp>;
  include_property?: InputMaybe<Boolean_Comparison_Exp>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Float_Comparison_Exp>;
  intrinsic_building_surface?: InputMaybe<Float_Comparison_Exp>;
  intrinsic_construction_cost?: InputMaybe<Int_Comparison_Exp>;
  intrinsic_custom_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  intrinsic_land_value?: InputMaybe<Int_Comparison_Exp>;
  introduction?: InputMaybe<String_Comparison_Exp>;
  is_price_range?: InputMaybe<Boolean_Comparison_Exp>;
  language?: InputMaybe<User_Language_Comparison_Exp>;
  lead?: InputMaybe<Leads_Bool_Exp>;
  lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  max_budget?: InputMaybe<Int_Comparison_Exp>;
  min_budget?: InputMaybe<Int_Comparison_Exp>;
  negative_comments?: InputMaybe<String_Comparison_Exp>;
  positive_comments?: InputMaybe<String_Comparison_Exp>;
  price_range_max?: InputMaybe<Int_Comparison_Exp>;
  price_range_min?: InputMaybe<Int_Comparison_Exp>;
  probability_max?: InputMaybe<Float_Comparison_Exp>;
  probability_min?: InputMaybe<Float_Comparison_Exp>;
  probability_time_period?: InputMaybe<Int_Comparison_Exp>;
  report_title?: InputMaybe<String_Comparison_Exp>;
  show_probability?: InputMaybe<Boolean_Comparison_Exp>;
  suggested_market_value?: InputMaybe<Int_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** columns and relationships of "cma_reports_comparables" */
export type Cma_Reports_Comparables = {
  aggregates_db__merged_listings_clusters_id: Scalars['bigint']['output'];
  /** An object relationship */
  cma_report: Cma_Reports;
  cma_report_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  listing_snapshot?: Maybe<Scalars['jsonb']['output']>;
  order_nr: Scalars['Float']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "cma_reports_comparables" */
export type Cma_Reports_ComparablesListing_SnapshotArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Aggregate_Order_By = {
  avg?: InputMaybe<Cma_Reports_Comparables_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cma_Reports_Comparables_Max_Order_By>;
  min?: InputMaybe<Cma_Reports_Comparables_Min_Order_By>;
  stddev?: InputMaybe<Cma_Reports_Comparables_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Cma_Reports_Comparables_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Cma_Reports_Comparables_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Cma_Reports_Comparables_Sum_Order_By>;
  var_pop?: InputMaybe<Cma_Reports_Comparables_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Cma_Reports_Comparables_Var_Samp_Order_By>;
  variance?: InputMaybe<Cma_Reports_Comparables_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Cma_Reports_Comparables_Append_Input = {
  listing_snapshot?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Arr_Rel_Insert_Input = {
  data: Array<Cma_Reports_Comparables_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cma_Reports_Comparables_On_Conflict>;
};

/** order by avg() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Avg_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cma_reports_comparables". All fields are combined with a logical 'AND'. */
export type Cma_Reports_Comparables_Bool_Exp = {
  _and?: InputMaybe<Array<Cma_Reports_Comparables_Bool_Exp>>;
  _not?: InputMaybe<Cma_Reports_Comparables_Bool_Exp>;
  _or?: InputMaybe<Array<Cma_Reports_Comparables_Bool_Exp>>;
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Bigint_Comparison_Exp>;
  cma_report?: InputMaybe<Cma_Reports_Bool_Exp>;
  cma_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  listing_snapshot?: InputMaybe<Jsonb_Comparison_Exp>;
  order_nr?: InputMaybe<Float_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "cma_reports_comparables" */
export enum Cma_Reports_Comparables_Constraint {
  /** unique or primary key constraint on columns "cma_report_id", "aggregates_db__merged_listings_clusters_id" */
  CmaReportsComparablesIdListingIdUnique = 'cma_reports_comparables_id_listing_id_unique',
  /** unique or primary key constraint on columns "order_nr", "cma_report_id" */
  CmaReportsComparablesIdOrderNrUnique = 'cma_reports_comparables_id_order_nr_unique'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Cma_Reports_Comparables_Delete_At_Path_Input = {
  listing_snapshot?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Cma_Reports_Comparables_Delete_Elem_Input = {
  listing_snapshot?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Cma_Reports_Comparables_Delete_Key_Input = {
  listing_snapshot?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Inc_Input = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Scalars['bigint']['input']>;
  order_nr?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Insert_Input = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Scalars['bigint']['input']>;
  cma_report?: InputMaybe<Cma_Reports_Obj_Rel_Insert_Input>;
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  listing_snapshot?: InputMaybe<Scalars['jsonb']['input']>;
};

/** order by max() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Max_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  cma_report_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Min_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  cma_report_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cma_Reports_Comparables>;
};

/** on_conflict condition type for table "cma_reports_comparables" */
export type Cma_Reports_Comparables_On_Conflict = {
  constraint: Cma_Reports_Comparables_Constraint;
  update_columns?: Array<Cma_Reports_Comparables_Update_Column>;
  where?: InputMaybe<Cma_Reports_Comparables_Bool_Exp>;
};

/** Ordering options when selecting data from "cma_reports_comparables". */
export type Cma_Reports_Comparables_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  cma_report?: InputMaybe<Cma_Reports_Order_By>;
  cma_report_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  listing_snapshot?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Cma_Reports_Comparables_Prepend_Input = {
  listing_snapshot?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "cma_reports_comparables" */
export enum Cma_Reports_Comparables_Select_Column {
  /** column name */
  AggregatesDbMergedListingsClustersId = 'aggregates_db__merged_listings_clusters_id',
  /** column name */
  CmaReportId = 'cma_report_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ListingSnapshot = 'listing_snapshot',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Set_Input = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Scalars['bigint']['input']>;
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  listing_snapshot?: InputMaybe<Scalars['jsonb']['input']>;
  order_nr?: InputMaybe<Scalars['Float']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Stddev_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Stddev_Pop_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Stddev_Samp_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cma_Reports_Comparables_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cma_Reports_Comparables_Stream_Cursor_Value_Input = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Scalars['bigint']['input']>;
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  listing_snapshot?: InputMaybe<Scalars['jsonb']['input']>;
  order_nr?: InputMaybe<Scalars['Float']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Sum_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
};

/** update columns of table "cma_reports_comparables" */
export enum Cma_Reports_Comparables_Update_Column {
  /** column name */
  AggregatesDbMergedListingsClustersId = 'aggregates_db__merged_listings_clusters_id',
  /** column name */
  CmaReportId = 'cma_report_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ListingSnapshot = 'listing_snapshot',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Cma_Reports_Comparables_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Cma_Reports_Comparables_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Cma_Reports_Comparables_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Cma_Reports_Comparables_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Cma_Reports_Comparables_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cma_Reports_Comparables_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Cma_Reports_Comparables_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cma_Reports_Comparables_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cma_Reports_Comparables_Bool_Exp;
};

/** order by var_pop() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Var_Pop_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Var_Samp_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Variance_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "cma_reports" */
export enum Cma_Reports_Constraint {
  /** unique or primary key constraint on columns "id" */
  CmaReportsPkey = 'cma_reports_pkey'
}

export enum Cma_Reports_Construction_Base_Enum_Enum {
  Surface = 'surface',
  Volume = 'volume'
}

/** Boolean expression to compare columns of type "cma_reports_construction_base_enum_enum". All fields are combined with logical 'AND'. */
export type Cma_Reports_Construction_Base_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Cma_Reports_Construction_Base_Enum_Enum>;
  _in?: InputMaybe<Array<Cma_Reports_Construction_Base_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Cma_Reports_Construction_Base_Enum_Enum>;
  _nin?: InputMaybe<Array<Cma_Reports_Construction_Base_Enum_Enum>>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Cma_Reports_Delete_At_Path_Input = {
  /** Array of custom fields for intrinsic valuation, each containing id, title, and value */
  intrinsic_custom_fields?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Cma_Reports_Delete_Elem_Input = {
  /** Array of custom fields for intrinsic valuation, each containing id, title, and value */
  intrinsic_custom_fields?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Cma_Reports_Delete_Key_Input = {
  /** Array of custom fields for intrinsic valuation, each containing id, title, and value */
  intrinsic_custom_fields?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "cma_reports" */
export type Cma_Reports_Inc_Input = {
  caprate_estimated_monthly_rent?: InputMaybe<Scalars['Int']['input']>;
  caprate_minimum_required_yield?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_building_surface?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_construction_cost?: InputMaybe<Scalars['Int']['input']>;
  intrinsic_land_value?: InputMaybe<Scalars['Int']['input']>;
  max_budget?: InputMaybe<Scalars['Int']['input']>;
  min_budget?: InputMaybe<Scalars['Int']['input']>;
  price_range_max?: InputMaybe<Scalars['Int']['input']>;
  price_range_min?: InputMaybe<Scalars['Int']['input']>;
  probability_max?: InputMaybe<Scalars['Float']['input']>;
  probability_min?: InputMaybe<Scalars['Float']['input']>;
  probability_time_period?: InputMaybe<Scalars['Int']['input']>;
  suggested_market_value?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "cma_reports" */
export type Cma_Reports_Insert_Input = {
  broker?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  caprate_estimated_monthly_rent?: InputMaybe<Scalars['Int']['input']>;
  caprate_minimum_required_yield?: InputMaybe<Scalars['Float']['input']>;
  cma_report_files?: InputMaybe<Cma_Report_Files_Arr_Rel_Insert_Input>;
  comparable_listings?: InputMaybe<Cma_Reports_Comparables_Arr_Rel_Insert_Input>;
  construction_cost_base?: InputMaybe<Cma_Reports_Construction_Base_Enum_Enum>;
  contact?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  cover_image?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  cover_image_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  doc_template?: InputMaybe<Doc_Templates_Obj_Rel_Insert_Input>;
  doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  font_family?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_agent?: InputMaybe<Scalars['Boolean']['input']>;
  include_agent_agency?: InputMaybe<Scalars['Boolean']['input']>;
  include_append_files?: InputMaybe<Scalars['Boolean']['input']>;
  include_client_testimonial?: InputMaybe<Scalars['Boolean']['input']>;
  include_comparables_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_cover?: InputMaybe<Scalars['Boolean']['input']>;
  include_cuprate_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_description?: InputMaybe<Scalars['Boolean']['input']>;
  include_final_value?: InputMaybe<Scalars['Boolean']['input']>;
  include_hedonistic_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_intrinsic_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_introduction?: InputMaybe<Scalars['Boolean']['input']>;
  include_photos?: InputMaybe<Scalars['Boolean']['input']>;
  include_pois?: InputMaybe<Scalars['Boolean']['input']>;
  include_potential_buyers?: InputMaybe<Scalars['Boolean']['input']>;
  include_property?: InputMaybe<Scalars['Boolean']['input']>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_building_surface?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_construction_cost?: InputMaybe<Scalars['Int']['input']>;
  /** Array of custom fields for intrinsic valuation, each containing id, title, and value */
  intrinsic_custom_fields?: InputMaybe<Scalars['jsonb']['input']>;
  intrinsic_land_value?: InputMaybe<Scalars['Int']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  is_price_range?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  lead?: InputMaybe<Leads_Obj_Rel_Insert_Input>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  max_budget?: InputMaybe<Scalars['Int']['input']>;
  min_budget?: InputMaybe<Scalars['Int']['input']>;
  negative_comments?: InputMaybe<Scalars['String']['input']>;
  positive_comments?: InputMaybe<Scalars['String']['input']>;
  price_range_max?: InputMaybe<Scalars['Int']['input']>;
  price_range_min?: InputMaybe<Scalars['Int']['input']>;
  probability_max?: InputMaybe<Scalars['Float']['input']>;
  probability_min?: InputMaybe<Scalars['Float']['input']>;
  probability_time_period?: InputMaybe<Scalars['Int']['input']>;
  report_title?: InputMaybe<Scalars['String']['input']>;
  show_probability?: InputMaybe<Scalars['Boolean']['input']>;
  suggested_market_value?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Cma_Reports_Max_Fields = {
  broker_id?: Maybe<Scalars['uuid']['output']>;
  caprate_estimated_monthly_rent?: Maybe<Scalars['Int']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  cover_image_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  doc_template_id?: Maybe<Scalars['uuid']['output']>;
  font_family?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Int']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Int']['output']>;
  introduction?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['user_language']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  max_budget?: Maybe<Scalars['Int']['output']>;
  min_budget?: Maybe<Scalars['Int']['output']>;
  negative_comments?: Maybe<Scalars['String']['output']>;
  positive_comments?: Maybe<Scalars['String']['output']>;
  price_range_max?: Maybe<Scalars['Int']['output']>;
  price_range_min?: Maybe<Scalars['Int']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Int']['output']>;
  report_title?: Maybe<Scalars['String']['output']>;
  suggested_market_value?: Maybe<Scalars['Int']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "cma_reports" */
export type Cma_Reports_Max_Order_By = {
  broker_id?: InputMaybe<Order_By>;
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  cover_image_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  doc_template_id?: InputMaybe<Order_By>;
  font_family?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  introduction?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  negative_comments?: InputMaybe<Order_By>;
  positive_comments?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  report_title?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cma_Reports_Min_Fields = {
  broker_id?: Maybe<Scalars['uuid']['output']>;
  caprate_estimated_monthly_rent?: Maybe<Scalars['Int']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  cover_image_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  doc_template_id?: Maybe<Scalars['uuid']['output']>;
  font_family?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Int']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Int']['output']>;
  introduction?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['user_language']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  max_budget?: Maybe<Scalars['Int']['output']>;
  min_budget?: Maybe<Scalars['Int']['output']>;
  negative_comments?: Maybe<Scalars['String']['output']>;
  positive_comments?: Maybe<Scalars['String']['output']>;
  price_range_max?: Maybe<Scalars['Int']['output']>;
  price_range_min?: Maybe<Scalars['Int']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Int']['output']>;
  report_title?: Maybe<Scalars['String']['output']>;
  suggested_market_value?: Maybe<Scalars['Int']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "cma_reports" */
export type Cma_Reports_Min_Order_By = {
  broker_id?: InputMaybe<Order_By>;
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  cover_image_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  doc_template_id?: InputMaybe<Order_By>;
  font_family?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  introduction?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  negative_comments?: InputMaybe<Order_By>;
  positive_comments?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  report_title?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cma_reports" */
export type Cma_Reports_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cma_Reports>;
};

/** input type for inserting object relation for remote table "cma_reports" */
export type Cma_Reports_Obj_Rel_Insert_Input = {
  data: Cma_Reports_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Cma_Reports_On_Conflict>;
};

/** on_conflict condition type for table "cma_reports" */
export type Cma_Reports_On_Conflict = {
  constraint: Cma_Reports_Constraint;
  update_columns?: Array<Cma_Reports_Update_Column>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};

/** Ordering options when selecting data from "cma_reports". */
export type Cma_Reports_Order_By = {
  broker?: InputMaybe<Users_Order_By>;
  broker_id?: InputMaybe<Order_By>;
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  cma_report_files_aggregate?: InputMaybe<Cma_Report_Files_Aggregate_Order_By>;
  comparable_listings_aggregate?: InputMaybe<Cma_Reports_Comparables_Aggregate_Order_By>;
  construction_cost_base?: InputMaybe<Order_By>;
  contact?: InputMaybe<Users_Order_By>;
  contact_id?: InputMaybe<Order_By>;
  cover_image?: InputMaybe<Images_Order_By>;
  cover_image_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<Users_Order_By>;
  description?: InputMaybe<Order_By>;
  doc_template?: InputMaybe<Doc_Templates_Order_By>;
  doc_template_id?: InputMaybe<Order_By>;
  font_family?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  include_agent?: InputMaybe<Order_By>;
  include_agent_agency?: InputMaybe<Order_By>;
  include_append_files?: InputMaybe<Order_By>;
  include_client_testimonial?: InputMaybe<Order_By>;
  include_comparables_valuation?: InputMaybe<Order_By>;
  include_cover?: InputMaybe<Order_By>;
  include_cuprate_valuation?: InputMaybe<Order_By>;
  include_description?: InputMaybe<Order_By>;
  include_final_value?: InputMaybe<Order_By>;
  include_hedonistic_valuation?: InputMaybe<Order_By>;
  include_intrinsic_valuation?: InputMaybe<Order_By>;
  include_introduction?: InputMaybe<Order_By>;
  include_photos?: InputMaybe<Order_By>;
  include_pois?: InputMaybe<Order_By>;
  include_potential_buyers?: InputMaybe<Order_By>;
  include_property?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_custom_fields?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  introduction?: InputMaybe<Order_By>;
  is_price_range?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  lead?: InputMaybe<Leads_Order_By>;
  lead_id?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  negative_comments?: InputMaybe<Order_By>;
  positive_comments?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  report_title?: InputMaybe<Order_By>;
  show_probability?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: cma_reports */
export type Cma_Reports_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Cma_Reports_Prepend_Input = {
  /** Array of custom fields for intrinsic valuation, each containing id, title, and value */
  intrinsic_custom_fields?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "cma_reports" */
export enum Cma_Reports_Select_Column {
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CaprateEstimatedMonthlyRent = 'caprate_estimated_monthly_rent',
  /** column name */
  CaprateMinimumRequiredYield = 'caprate_minimum_required_yield',
  /** column name */
  ConstructionCostBase = 'construction_cost_base',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CoverImageId = 'cover_image_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  DocTemplateId = 'doc_template_id',
  /** column name */
  FontFamily = 'font_family',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeAgent = 'include_agent',
  /** column name */
  IncludeAgentAgency = 'include_agent_agency',
  /** column name */
  IncludeAppendFiles = 'include_append_files',
  /** column name */
  IncludeClientTestimonial = 'include_client_testimonial',
  /** column name */
  IncludeComparablesValuation = 'include_comparables_valuation',
  /** column name */
  IncludeCover = 'include_cover',
  /** column name */
  IncludeCuprateValuation = 'include_cuprate_valuation',
  /** column name */
  IncludeDescription = 'include_description',
  /** column name */
  IncludeFinalValue = 'include_final_value',
  /** column name */
  IncludeHedonisticValuation = 'include_hedonistic_valuation',
  /** column name */
  IncludeIntrinsicValuation = 'include_intrinsic_valuation',
  /** column name */
  IncludeIntroduction = 'include_introduction',
  /** column name */
  IncludePhotos = 'include_photos',
  /** column name */
  IncludePois = 'include_pois',
  /** column name */
  IncludePotentialBuyers = 'include_potential_buyers',
  /** column name */
  IncludeProperty = 'include_property',
  /** column name */
  IntrinsicAnnualDeprecationRate = 'intrinsic_annual_deprecation_rate',
  /** column name */
  IntrinsicBuildingSurface = 'intrinsic_building_surface',
  /** column name */
  IntrinsicConstructionCost = 'intrinsic_construction_cost',
  /** column name */
  IntrinsicCustomFields = 'intrinsic_custom_fields',
  /** column name */
  IntrinsicLandValue = 'intrinsic_land_value',
  /** column name */
  Introduction = 'introduction',
  /** column name */
  IsPriceRange = 'is_price_range',
  /** column name */
  Language = 'language',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  MaxBudget = 'max_budget',
  /** column name */
  MinBudget = 'min_budget',
  /** column name */
  NegativeComments = 'negative_comments',
  /** column name */
  PositiveComments = 'positive_comments',
  /** column name */
  PriceRangeMax = 'price_range_max',
  /** column name */
  PriceRangeMin = 'price_range_min',
  /** column name */
  ProbabilityMax = 'probability_max',
  /** column name */
  ProbabilityMin = 'probability_min',
  /** column name */
  ProbabilityTimePeriod = 'probability_time_period',
  /** column name */
  ReportTitle = 'report_title',
  /** column name */
  ShowProbability = 'show_probability',
  /** column name */
  SuggestedMarketValue = 'suggested_market_value',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "cma_reports_aggregate_bool_exp_bool_and_arguments_columns" columns of table "cma_reports" */
export enum Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IncludeAgent = 'include_agent',
  /** column name */
  IncludeAgentAgency = 'include_agent_agency',
  /** column name */
  IncludeAppendFiles = 'include_append_files',
  /** column name */
  IncludeClientTestimonial = 'include_client_testimonial',
  /** column name */
  IncludeComparablesValuation = 'include_comparables_valuation',
  /** column name */
  IncludeCover = 'include_cover',
  /** column name */
  IncludeCuprateValuation = 'include_cuprate_valuation',
  /** column name */
  IncludeDescription = 'include_description',
  /** column name */
  IncludeFinalValue = 'include_final_value',
  /** column name */
  IncludeHedonisticValuation = 'include_hedonistic_valuation',
  /** column name */
  IncludeIntrinsicValuation = 'include_intrinsic_valuation',
  /** column name */
  IncludeIntroduction = 'include_introduction',
  /** column name */
  IncludePhotos = 'include_photos',
  /** column name */
  IncludePois = 'include_pois',
  /** column name */
  IncludePotentialBuyers = 'include_potential_buyers',
  /** column name */
  IncludeProperty = 'include_property',
  /** column name */
  IsPriceRange = 'is_price_range',
  /** column name */
  ShowProbability = 'show_probability'
}

/** select "cma_reports_aggregate_bool_exp_bool_or_arguments_columns" columns of table "cma_reports" */
export enum Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IncludeAgent = 'include_agent',
  /** column name */
  IncludeAgentAgency = 'include_agent_agency',
  /** column name */
  IncludeAppendFiles = 'include_append_files',
  /** column name */
  IncludeClientTestimonial = 'include_client_testimonial',
  /** column name */
  IncludeComparablesValuation = 'include_comparables_valuation',
  /** column name */
  IncludeCover = 'include_cover',
  /** column name */
  IncludeCuprateValuation = 'include_cuprate_valuation',
  /** column name */
  IncludeDescription = 'include_description',
  /** column name */
  IncludeFinalValue = 'include_final_value',
  /** column name */
  IncludeHedonisticValuation = 'include_hedonistic_valuation',
  /** column name */
  IncludeIntrinsicValuation = 'include_intrinsic_valuation',
  /** column name */
  IncludeIntroduction = 'include_introduction',
  /** column name */
  IncludePhotos = 'include_photos',
  /** column name */
  IncludePois = 'include_pois',
  /** column name */
  IncludePotentialBuyers = 'include_potential_buyers',
  /** column name */
  IncludeProperty = 'include_property',
  /** column name */
  IsPriceRange = 'is_price_range',
  /** column name */
  ShowProbability = 'show_probability'
}

/** input type for updating data in table "cma_reports" */
export type Cma_Reports_Set_Input = {
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  caprate_estimated_monthly_rent?: InputMaybe<Scalars['Int']['input']>;
  caprate_minimum_required_yield?: InputMaybe<Scalars['Float']['input']>;
  construction_cost_base?: InputMaybe<Cma_Reports_Construction_Base_Enum_Enum>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  cover_image_id?: InputMaybe<Scalars['uuid']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  font_family?: InputMaybe<Scalars['String']['input']>;
  include_agent?: InputMaybe<Scalars['Boolean']['input']>;
  include_agent_agency?: InputMaybe<Scalars['Boolean']['input']>;
  include_append_files?: InputMaybe<Scalars['Boolean']['input']>;
  include_client_testimonial?: InputMaybe<Scalars['Boolean']['input']>;
  include_comparables_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_cover?: InputMaybe<Scalars['Boolean']['input']>;
  include_cuprate_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_description?: InputMaybe<Scalars['Boolean']['input']>;
  include_final_value?: InputMaybe<Scalars['Boolean']['input']>;
  include_hedonistic_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_intrinsic_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_introduction?: InputMaybe<Scalars['Boolean']['input']>;
  include_photos?: InputMaybe<Scalars['Boolean']['input']>;
  include_pois?: InputMaybe<Scalars['Boolean']['input']>;
  include_potential_buyers?: InputMaybe<Scalars['Boolean']['input']>;
  include_property?: InputMaybe<Scalars['Boolean']['input']>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_building_surface?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_construction_cost?: InputMaybe<Scalars['Int']['input']>;
  /** Array of custom fields for intrinsic valuation, each containing id, title, and value */
  intrinsic_custom_fields?: InputMaybe<Scalars['jsonb']['input']>;
  intrinsic_land_value?: InputMaybe<Scalars['Int']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  is_price_range?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  max_budget?: InputMaybe<Scalars['Int']['input']>;
  min_budget?: InputMaybe<Scalars['Int']['input']>;
  negative_comments?: InputMaybe<Scalars['String']['input']>;
  positive_comments?: InputMaybe<Scalars['String']['input']>;
  price_range_max?: InputMaybe<Scalars['Int']['input']>;
  price_range_min?: InputMaybe<Scalars['Int']['input']>;
  probability_max?: InputMaybe<Scalars['Float']['input']>;
  probability_min?: InputMaybe<Scalars['Float']['input']>;
  probability_time_period?: InputMaybe<Scalars['Int']['input']>;
  report_title?: InputMaybe<Scalars['String']['input']>;
  show_probability?: InputMaybe<Scalars['Boolean']['input']>;
  suggested_market_value?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Cma_Reports_Stddev_Fields = {
  caprate_estimated_monthly_rent?: Maybe<Scalars['Float']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Float']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Float']['output']>;
  max_budget?: Maybe<Scalars['Float']['output']>;
  min_budget?: Maybe<Scalars['Float']['output']>;
  price_range_max?: Maybe<Scalars['Float']['output']>;
  price_range_min?: Maybe<Scalars['Float']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Float']['output']>;
  suggested_market_value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "cma_reports" */
export type Cma_Reports_Stddev_Order_By = {
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Cma_Reports_Stddev_Pop_Fields = {
  caprate_estimated_monthly_rent?: Maybe<Scalars['Float']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Float']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Float']['output']>;
  max_budget?: Maybe<Scalars['Float']['output']>;
  min_budget?: Maybe<Scalars['Float']['output']>;
  price_range_max?: Maybe<Scalars['Float']['output']>;
  price_range_min?: Maybe<Scalars['Float']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Float']['output']>;
  suggested_market_value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "cma_reports" */
export type Cma_Reports_Stddev_Pop_Order_By = {
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Cma_Reports_Stddev_Samp_Fields = {
  caprate_estimated_monthly_rent?: Maybe<Scalars['Float']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Float']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Float']['output']>;
  max_budget?: Maybe<Scalars['Float']['output']>;
  min_budget?: Maybe<Scalars['Float']['output']>;
  price_range_max?: Maybe<Scalars['Float']['output']>;
  price_range_min?: Maybe<Scalars['Float']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Float']['output']>;
  suggested_market_value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "cma_reports" */
export type Cma_Reports_Stddev_Samp_Order_By = {
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cma_reports" */
export type Cma_Reports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cma_Reports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cma_Reports_Stream_Cursor_Value_Input = {
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  caprate_estimated_monthly_rent?: InputMaybe<Scalars['Int']['input']>;
  caprate_minimum_required_yield?: InputMaybe<Scalars['Float']['input']>;
  construction_cost_base?: InputMaybe<Cma_Reports_Construction_Base_Enum_Enum>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  cover_image_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  font_family?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_agent?: InputMaybe<Scalars['Boolean']['input']>;
  include_agent_agency?: InputMaybe<Scalars['Boolean']['input']>;
  include_append_files?: InputMaybe<Scalars['Boolean']['input']>;
  include_client_testimonial?: InputMaybe<Scalars['Boolean']['input']>;
  include_comparables_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_cover?: InputMaybe<Scalars['Boolean']['input']>;
  include_cuprate_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_description?: InputMaybe<Scalars['Boolean']['input']>;
  include_final_value?: InputMaybe<Scalars['Boolean']['input']>;
  include_hedonistic_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_intrinsic_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_introduction?: InputMaybe<Scalars['Boolean']['input']>;
  include_photos?: InputMaybe<Scalars['Boolean']['input']>;
  include_pois?: InputMaybe<Scalars['Boolean']['input']>;
  include_potential_buyers?: InputMaybe<Scalars['Boolean']['input']>;
  include_property?: InputMaybe<Scalars['Boolean']['input']>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_building_surface?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_construction_cost?: InputMaybe<Scalars['Int']['input']>;
  /** Array of custom fields for intrinsic valuation, each containing id, title, and value */
  intrinsic_custom_fields?: InputMaybe<Scalars['jsonb']['input']>;
  intrinsic_land_value?: InputMaybe<Scalars['Int']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  is_price_range?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  max_budget?: InputMaybe<Scalars['Int']['input']>;
  min_budget?: InputMaybe<Scalars['Int']['input']>;
  negative_comments?: InputMaybe<Scalars['String']['input']>;
  positive_comments?: InputMaybe<Scalars['String']['input']>;
  price_range_max?: InputMaybe<Scalars['Int']['input']>;
  price_range_min?: InputMaybe<Scalars['Int']['input']>;
  probability_max?: InputMaybe<Scalars['Float']['input']>;
  probability_min?: InputMaybe<Scalars['Float']['input']>;
  probability_time_period?: InputMaybe<Scalars['Int']['input']>;
  report_title?: InputMaybe<Scalars['String']['input']>;
  show_probability?: InputMaybe<Scalars['Boolean']['input']>;
  suggested_market_value?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Cma_Reports_Sum_Fields = {
  caprate_estimated_monthly_rent?: Maybe<Scalars['Int']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Int']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Int']['output']>;
  max_budget?: Maybe<Scalars['Int']['output']>;
  min_budget?: Maybe<Scalars['Int']['output']>;
  price_range_max?: Maybe<Scalars['Int']['output']>;
  price_range_min?: Maybe<Scalars['Int']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Int']['output']>;
  suggested_market_value?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "cma_reports" */
export type Cma_Reports_Sum_Order_By = {
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
};

/** update columns of table "cma_reports" */
export enum Cma_Reports_Update_Column {
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CaprateEstimatedMonthlyRent = 'caprate_estimated_monthly_rent',
  /** column name */
  CaprateMinimumRequiredYield = 'caprate_minimum_required_yield',
  /** column name */
  ConstructionCostBase = 'construction_cost_base',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CoverImageId = 'cover_image_id',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  DocTemplateId = 'doc_template_id',
  /** column name */
  FontFamily = 'font_family',
  /** column name */
  IncludeAgent = 'include_agent',
  /** column name */
  IncludeAgentAgency = 'include_agent_agency',
  /** column name */
  IncludeAppendFiles = 'include_append_files',
  /** column name */
  IncludeClientTestimonial = 'include_client_testimonial',
  /** column name */
  IncludeComparablesValuation = 'include_comparables_valuation',
  /** column name */
  IncludeCover = 'include_cover',
  /** column name */
  IncludeCuprateValuation = 'include_cuprate_valuation',
  /** column name */
  IncludeDescription = 'include_description',
  /** column name */
  IncludeFinalValue = 'include_final_value',
  /** column name */
  IncludeHedonisticValuation = 'include_hedonistic_valuation',
  /** column name */
  IncludeIntrinsicValuation = 'include_intrinsic_valuation',
  /** column name */
  IncludeIntroduction = 'include_introduction',
  /** column name */
  IncludePhotos = 'include_photos',
  /** column name */
  IncludePois = 'include_pois',
  /** column name */
  IncludePotentialBuyers = 'include_potential_buyers',
  /** column name */
  IncludeProperty = 'include_property',
  /** column name */
  IntrinsicAnnualDeprecationRate = 'intrinsic_annual_deprecation_rate',
  /** column name */
  IntrinsicBuildingSurface = 'intrinsic_building_surface',
  /** column name */
  IntrinsicConstructionCost = 'intrinsic_construction_cost',
  /** column name */
  IntrinsicCustomFields = 'intrinsic_custom_fields',
  /** column name */
  IntrinsicLandValue = 'intrinsic_land_value',
  /** column name */
  Introduction = 'introduction',
  /** column name */
  IsPriceRange = 'is_price_range',
  /** column name */
  Language = 'language',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  MaxBudget = 'max_budget',
  /** column name */
  MinBudget = 'min_budget',
  /** column name */
  NegativeComments = 'negative_comments',
  /** column name */
  PositiveComments = 'positive_comments',
  /** column name */
  PriceRangeMax = 'price_range_max',
  /** column name */
  PriceRangeMin = 'price_range_min',
  /** column name */
  ProbabilityMax = 'probability_max',
  /** column name */
  ProbabilityMin = 'probability_min',
  /** column name */
  ProbabilityTimePeriod = 'probability_time_period',
  /** column name */
  ReportTitle = 'report_title',
  /** column name */
  ShowProbability = 'show_probability',
  /** column name */
  SuggestedMarketValue = 'suggested_market_value'
}

export type Cma_Reports_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Cma_Reports_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Cma_Reports_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Cma_Reports_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Cma_Reports_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cma_Reports_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Cma_Reports_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cma_Reports_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cma_Reports_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Cma_Reports_Var_Pop_Fields = {
  caprate_estimated_monthly_rent?: Maybe<Scalars['Float']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Float']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Float']['output']>;
  max_budget?: Maybe<Scalars['Float']['output']>;
  min_budget?: Maybe<Scalars['Float']['output']>;
  price_range_max?: Maybe<Scalars['Float']['output']>;
  price_range_min?: Maybe<Scalars['Float']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Float']['output']>;
  suggested_market_value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "cma_reports" */
export type Cma_Reports_Var_Pop_Order_By = {
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Cma_Reports_Var_Samp_Fields = {
  caprate_estimated_monthly_rent?: Maybe<Scalars['Float']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Float']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Float']['output']>;
  max_budget?: Maybe<Scalars['Float']['output']>;
  min_budget?: Maybe<Scalars['Float']['output']>;
  price_range_max?: Maybe<Scalars['Float']['output']>;
  price_range_min?: Maybe<Scalars['Float']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Float']['output']>;
  suggested_market_value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "cma_reports" */
export type Cma_Reports_Var_Samp_Order_By = {
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Cma_Reports_Variance_Fields = {
  caprate_estimated_monthly_rent?: Maybe<Scalars['Float']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Float']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Float']['output']>;
  max_budget?: Maybe<Scalars['Float']['output']>;
  min_budget?: Maybe<Scalars['Float']['output']>;
  price_range_max?: Maybe<Scalars['Float']['output']>;
  price_range_min?: Maybe<Scalars['Float']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Float']['output']>;
  suggested_market_value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "cma_reports" */
export type Cma_Reports_Variance_Order_By = {
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
};

/** columns and relationships of "combined_reviews" */
export type Combined_Reviews = {
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_date?: Maybe<Scalars['String']['output']>;
  review_text?: Maybe<Scalars['String']['output']>;
  review_url?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "combined_reviews" */
export type Combined_Reviews_Aggregate = {
  aggregate?: Maybe<Combined_Reviews_Aggregate_Fields>;
  nodes: Array<Combined_Reviews>;
};

export type Combined_Reviews_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Combined_Reviews_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Combined_Reviews_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Combined_Reviews_Aggregate_Bool_Exp_Count>;
};

export type Combined_Reviews_Aggregate_Bool_Exp_Bool_And = {
  arguments: Combined_Reviews_Select_Column_Combined_Reviews_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Combined_Reviews_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Combined_Reviews_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Combined_Reviews_Select_Column_Combined_Reviews_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Combined_Reviews_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Combined_Reviews_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Combined_Reviews_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "combined_reviews" */
export type Combined_Reviews_Aggregate_Fields = {
  avg?: Maybe<Combined_Reviews_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Combined_Reviews_Max_Fields>;
  min?: Maybe<Combined_Reviews_Min_Fields>;
  stddev?: Maybe<Combined_Reviews_Stddev_Fields>;
  stddev_pop?: Maybe<Combined_Reviews_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Combined_Reviews_Stddev_Samp_Fields>;
  sum?: Maybe<Combined_Reviews_Sum_Fields>;
  var_pop?: Maybe<Combined_Reviews_Var_Pop_Fields>;
  var_samp?: Maybe<Combined_Reviews_Var_Samp_Fields>;
  variance?: Maybe<Combined_Reviews_Variance_Fields>;
};


/** aggregate fields of "combined_reviews" */
export type Combined_Reviews_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "combined_reviews" */
export type Combined_Reviews_Aggregate_Order_By = {
  avg?: InputMaybe<Combined_Reviews_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Combined_Reviews_Max_Order_By>;
  min?: InputMaybe<Combined_Reviews_Min_Order_By>;
  stddev?: InputMaybe<Combined_Reviews_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Combined_Reviews_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Combined_Reviews_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Combined_Reviews_Sum_Order_By>;
  var_pop?: InputMaybe<Combined_Reviews_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Combined_Reviews_Var_Samp_Order_By>;
  variance?: InputMaybe<Combined_Reviews_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Combined_Reviews_Avg_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "combined_reviews" */
export type Combined_Reviews_Avg_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "combined_reviews". All fields are combined with a logical 'AND'. */
export type Combined_Reviews_Bool_Exp = {
  _and?: InputMaybe<Array<Combined_Reviews_Bool_Exp>>;
  _not?: InputMaybe<Combined_Reviews_Bool_Exp>;
  _or?: InputMaybe<Array<Combined_Reviews_Bool_Exp>>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  profile_image_url?: InputMaybe<String_Comparison_Exp>;
  rating?: InputMaybe<Int_Comparison_Exp>;
  review_date?: InputMaybe<String_Comparison_Exp>;
  review_text?: InputMaybe<String_Comparison_Exp>;
  review_url?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** aggregate max on columns */
export type Combined_Reviews_Max_Fields = {
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_date?: Maybe<Scalars['String']['output']>;
  review_text?: Maybe<Scalars['String']['output']>;
  review_url?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "combined_reviews" */
export type Combined_Reviews_Max_Order_By = {
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  review_date?: InputMaybe<Order_By>;
  review_text?: InputMaybe<Order_By>;
  review_url?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Combined_Reviews_Min_Fields = {
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_date?: Maybe<Scalars['String']['output']>;
  review_text?: Maybe<Scalars['String']['output']>;
  review_url?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "combined_reviews" */
export type Combined_Reviews_Min_Order_By = {
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  review_date?: InputMaybe<Order_By>;
  review_text?: InputMaybe<Order_By>;
  review_url?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "combined_reviews". */
export type Combined_Reviews_Order_By = {
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  review_date?: InputMaybe<Order_By>;
  review_text?: InputMaybe<Order_By>;
  review_url?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** select columns of table "combined_reviews" */
export enum Combined_Reviews_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewDate = 'review_date',
  /** column name */
  ReviewText = 'review_text',
  /** column name */
  ReviewUrl = 'review_url',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Verified = 'verified'
}

/** select "combined_reviews_aggregate_bool_exp_bool_and_arguments_columns" columns of table "combined_reviews" */
export enum Combined_Reviews_Select_Column_Combined_Reviews_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Verified = 'verified'
}

/** select "combined_reviews_aggregate_bool_exp_bool_or_arguments_columns" columns of table "combined_reviews" */
export enum Combined_Reviews_Select_Column_Combined_Reviews_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Verified = 'verified'
}

/** aggregate stddev on columns */
export type Combined_Reviews_Stddev_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "combined_reviews" */
export type Combined_Reviews_Stddev_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Combined_Reviews_Stddev_Pop_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "combined_reviews" */
export type Combined_Reviews_Stddev_Pop_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Combined_Reviews_Stddev_Samp_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "combined_reviews" */
export type Combined_Reviews_Stddev_Samp_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "combined_reviews" */
export type Combined_Reviews_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Combined_Reviews_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Combined_Reviews_Stream_Cursor_Value_Input = {
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_date?: InputMaybe<Scalars['String']['input']>;
  review_text?: InputMaybe<Scalars['String']['input']>;
  review_url?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Combined_Reviews_Sum_Fields = {
  rating?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "combined_reviews" */
export type Combined_Reviews_Sum_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Combined_Reviews_Var_Pop_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "combined_reviews" */
export type Combined_Reviews_Var_Pop_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Combined_Reviews_Var_Samp_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "combined_reviews" */
export type Combined_Reviews_Var_Samp_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Combined_Reviews_Variance_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "combined_reviews" */
export type Combined_Reviews_Variance_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** columns and relationships of "commissions" */
export type Commissions = {
  amount?: Maybe<Scalars['Float']['output']>;
  beneficiary_team_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  contact?: Maybe<Users>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_paid?: Maybe<Scalars['Boolean']['output']>;
  payment_date?: Maybe<Scalars['timestamptz']['output']>;
  property_transaction_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  team?: Maybe<Teams>;
  /** An object relationship */
  transaction?: Maybe<Property_Transactions>;
  type?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "commissions" */
export type Commissions_Aggregate = {
  aggregate?: Maybe<Commissions_Aggregate_Fields>;
  nodes: Array<Commissions>;
};

export type Commissions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Commissions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Commissions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Commissions_Aggregate_Bool_Exp_Count>;
};

export type Commissions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Commissions_Select_Column_Commissions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Commissions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Commissions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Commissions_Select_Column_Commissions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Commissions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Commissions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Commissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Commissions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "commissions" */
export type Commissions_Aggregate_Fields = {
  avg?: Maybe<Commissions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Commissions_Max_Fields>;
  min?: Maybe<Commissions_Min_Fields>;
  stddev?: Maybe<Commissions_Stddev_Fields>;
  stddev_pop?: Maybe<Commissions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Commissions_Stddev_Samp_Fields>;
  sum?: Maybe<Commissions_Sum_Fields>;
  var_pop?: Maybe<Commissions_Var_Pop_Fields>;
  var_samp?: Maybe<Commissions_Var_Samp_Fields>;
  variance?: Maybe<Commissions_Variance_Fields>;
};


/** aggregate fields of "commissions" */
export type Commissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Commissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "commissions" */
export type Commissions_Aggregate_Order_By = {
  avg?: InputMaybe<Commissions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Commissions_Max_Order_By>;
  min?: InputMaybe<Commissions_Min_Order_By>;
  stddev?: InputMaybe<Commissions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Commissions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Commissions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Commissions_Sum_Order_By>;
  var_pop?: InputMaybe<Commissions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Commissions_Var_Samp_Order_By>;
  variance?: InputMaybe<Commissions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "commissions" */
export type Commissions_Arr_Rel_Insert_Input = {
  data: Array<Commissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Commissions_On_Conflict>;
};

/** aggregate avg on columns */
export type Commissions_Avg_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "commissions" */
export type Commissions_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "commissions". All fields are combined with a logical 'AND'. */
export type Commissions_Bool_Exp = {
  _and?: InputMaybe<Array<Commissions_Bool_Exp>>;
  _not?: InputMaybe<Commissions_Bool_Exp>;
  _or?: InputMaybe<Array<Commissions_Bool_Exp>>;
  amount?: InputMaybe<Float_Comparison_Exp>;
  beneficiary_team_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact?: InputMaybe<Users_Bool_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_paid?: InputMaybe<Boolean_Comparison_Exp>;
  payment_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  property_transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  transaction?: InputMaybe<Property_Transactions_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  vat?: InputMaybe<Float_Comparison_Exp>;
};

/** unique or primary key constraints on table "commissions" */
export enum Commissions_Constraint {
  /** unique or primary key constraint on columns "id" */
  CommissionsPkey = 'commissions_pkey',
  /** unique or primary key constraint on columns "property_transaction_id", "type" */
  IdxPropertyTransactionCommissionTotal = 'idx_property_transaction_commission_total'
}

/** input type for incrementing numeric columns in table "commissions" */
export type Commissions_Inc_Input = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  vat?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "commissions" */
export type Commissions_Insert_Input = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  beneficiary_team_id?: InputMaybe<Scalars['uuid']['input']>;
  contact?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  property_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  transaction?: InputMaybe<Property_Transactions_Obj_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate max on columns */
export type Commissions_Max_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  beneficiary_team_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  payment_date?: Maybe<Scalars['timestamptz']['output']>;
  property_transaction_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by max() on columns of table "commissions" */
export type Commissions_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  beneficiary_team_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  property_transaction_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Commissions_Min_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  beneficiary_team_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  payment_date?: Maybe<Scalars['timestamptz']['output']>;
  property_transaction_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by min() on columns of table "commissions" */
export type Commissions_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  beneficiary_team_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  property_transaction_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "commissions" */
export type Commissions_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Commissions>;
};

/** on_conflict condition type for table "commissions" */
export type Commissions_On_Conflict = {
  constraint: Commissions_Constraint;
  update_columns?: Array<Commissions_Update_Column>;
  where?: InputMaybe<Commissions_Bool_Exp>;
};

/** Ordering options when selecting data from "commissions". */
export type Commissions_Order_By = {
  amount?: InputMaybe<Order_By>;
  beneficiary_team_id?: InputMaybe<Order_By>;
  contact?: InputMaybe<Users_Order_By>;
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_paid?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  property_transaction_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  transaction?: InputMaybe<Property_Transactions_Order_By>;
  type?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** primary key columns input for table: commissions */
export type Commissions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "commissions" */
export enum Commissions_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BeneficiaryTeamId = 'beneficiary_team_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PropertyTransactionId = 'property_transaction_id',
  /** column name */
  Type = 'type',
  /** column name */
  Vat = 'vat'
}

/** select "commissions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "commissions" */
export enum Commissions_Select_Column_Commissions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPaid = 'is_paid'
}

/** select "commissions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "commissions" */
export enum Commissions_Select_Column_Commissions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPaid = 'is_paid'
}

/** input type for updating data in table "commissions" */
export type Commissions_Set_Input = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  beneficiary_team_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  vat?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate stddev on columns */
export type Commissions_Stddev_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "commissions" */
export type Commissions_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Commissions_Stddev_Pop_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "commissions" */
export type Commissions_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Commissions_Stddev_Samp_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "commissions" */
export type Commissions_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Commissions_Sum_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "commissions" */
export type Commissions_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** update columns of table "commissions" */
export enum Commissions_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BeneficiaryTeamId = 'beneficiary_team_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  Vat = 'vat'
}

export type Commissions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Commissions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Commissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Commissions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Commissions_Var_Pop_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "commissions" */
export type Commissions_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Commissions_Var_Samp_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "commissions" */
export type Commissions_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Commissions_Variance_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "commissions" */
export type Commissions_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** columns and relationships of "cooling_enum" */
export type Cooling_Enum = {
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "cooling_enum". All fields are combined with a logical 'AND'. */
export type Cooling_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Cooling_Enum_Bool_Exp>>;
  _not?: InputMaybe<Cooling_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Cooling_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Cooling_Enum_Enum {
  AirConditioning = 'air_conditioning',
  CeilingFans = 'ceiling_fans',
  None = 'none'
}

/** Boolean expression to compare columns of type "cooling_enum_enum". All fields are combined with logical 'AND'. */
export type Cooling_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Cooling_Enum_Enum>;
  _in?: InputMaybe<Array<Cooling_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Cooling_Enum_Enum>;
  _nin?: InputMaybe<Array<Cooling_Enum_Enum>>;
};

/** Ordering options when selecting data from "cooling_enum". */
export type Cooling_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "cooling_enum" */
export enum Cooling_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "cooling_enum" */
export type Cooling_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cooling_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cooling_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "countries" */
export type Countries = {
  country_code: Scalars['String']['output'];
  country_code_iso_3: Scalars['String']['output'];
  geog: Scalars['geography']['output'];
  id: Scalars['uuid']['output'];
  local_name?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone_number_allowed: Scalars['Boolean']['output'];
};

/** Boolean expression to filter rows from the table "countries". All fields are combined with a logical 'AND'. */
export type Countries_Bool_Exp = {
  _and?: InputMaybe<Array<Countries_Bool_Exp>>;
  _not?: InputMaybe<Countries_Bool_Exp>;
  _or?: InputMaybe<Array<Countries_Bool_Exp>>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  country_code_iso_3?: InputMaybe<String_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  local_name?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone_number_allowed?: InputMaybe<Boolean_Comparison_Exp>;
};

/** Ordering options when selecting data from "countries". */
export type Countries_Order_By = {
  country_code?: InputMaybe<Order_By>;
  country_code_iso_3?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  local_name?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone_number_allowed?: InputMaybe<Order_By>;
};

/** select columns of table "countries" */
export enum Countries_Select_Column {
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryCodeIso_3 = 'country_code_iso_3',
  /** column name */
  Geog = 'geog',
  /** column name */
  Id = 'id',
  /** column name */
  LocalName = 'local_name',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneNumberAllowed = 'phone_number_allowed'
}

/** Streaming cursor of the table "countries" */
export type Countries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Countries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Countries_Stream_Cursor_Value_Input = {
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_code_iso_3?: InputMaybe<Scalars['String']['input']>;
  geog?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  local_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number_allowed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to compare columns of type "cube". All fields are combined with logical 'AND'. */
export type Cube_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['cube']['input']>;
  _gt?: InputMaybe<Scalars['cube']['input']>;
  _gte?: InputMaybe<Scalars['cube']['input']>;
  _in?: InputMaybe<Array<Scalars['cube']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['cube']['input']>;
  _lte?: InputMaybe<Scalars['cube']['input']>;
  _neq?: InputMaybe<Scalars['cube']['input']>;
  _nin?: InputMaybe<Array<Scalars['cube']['input']>>;
};

/** Boolean expression to compare columns of type "currencies". All fields are combined with logical 'AND'. */
export type Currencies_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['currencies']['input']>;
  _gt?: InputMaybe<Scalars['currencies']['input']>;
  _gte?: InputMaybe<Scalars['currencies']['input']>;
  _in?: InputMaybe<Array<Scalars['currencies']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['currencies']['input']>;
  _lte?: InputMaybe<Scalars['currencies']['input']>;
  _neq?: InputMaybe<Scalars['currencies']['input']>;
  _nin?: InputMaybe<Array<Scalars['currencies']['input']>>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "developments" */
export type Developments = {
  architect_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  broker?: Maybe<Users>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  delivery_date?: Maybe<Scalars['date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  developer_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  email_templates: Array<Email_Templates>;
  enquiry_response_enabled?: Maybe<Scalars['Boolean']['output']>;
  enquiry_response_override_lot: Scalars['Boolean']['output'];
  general_contractor_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_published: Scalars['Boolean']['output'];
  /** An array relationship */
  lots: Array<Lots>;
  /** An aggregate relationship */
  lots_aggregate: Lots_Aggregate;
  /** An object relationship */
  mapping_image?: Maybe<Images>;
  mapping_image_id?: Maybe<Scalars['uuid']['output']>;
  registration_type: Scalars['String']['output'];
  response_sender_id?: Maybe<Scalars['uuid']['output']>;
  slug: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tenant_id: Scalars['uuid']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "developments" */
export type DevelopmentsEmail_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Templates_Order_By>>;
  where?: InputMaybe<Email_Templates_Bool_Exp>;
};


/** columns and relationships of "developments" */
export type DevelopmentsLotsArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


/** columns and relationships of "developments" */
export type DevelopmentsLots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "developments". All fields are combined with a logical 'AND'. */
export type Developments_Bool_Exp = {
  _and?: InputMaybe<Array<Developments_Bool_Exp>>;
  _not?: InputMaybe<Developments_Bool_Exp>;
  _or?: InputMaybe<Array<Developments_Bool_Exp>>;
  architect_id?: InputMaybe<Uuid_Comparison_Exp>;
  broker?: InputMaybe<Users_Bool_Exp>;
  broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  delivery_date?: InputMaybe<Date_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  developer_id?: InputMaybe<Uuid_Comparison_Exp>;
  email_templates?: InputMaybe<Email_Templates_Bool_Exp>;
  enquiry_response_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  enquiry_response_override_lot?: InputMaybe<Boolean_Comparison_Exp>;
  general_contractor_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_published?: InputMaybe<Boolean_Comparison_Exp>;
  lots?: InputMaybe<Lots_Bool_Exp>;
  lots_aggregate?: InputMaybe<Lots_Aggregate_Bool_Exp>;
  mapping_image?: InputMaybe<Images_Bool_Exp>;
  mapping_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  registration_type?: InputMaybe<String_Comparison_Exp>;
  response_sender_id?: InputMaybe<Uuid_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "developments". */
export type Developments_Order_By = {
  architect_id?: InputMaybe<Order_By>;
  broker?: InputMaybe<Users_Order_By>;
  broker_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  delivery_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  developer_id?: InputMaybe<Order_By>;
  email_templates_aggregate?: InputMaybe<Email_Templates_Aggregate_Order_By>;
  enquiry_response_enabled?: InputMaybe<Order_By>;
  enquiry_response_override_lot?: InputMaybe<Order_By>;
  general_contractor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_published?: InputMaybe<Order_By>;
  lots_aggregate?: InputMaybe<Lots_Aggregate_Order_By>;
  mapping_image?: InputMaybe<Images_Order_By>;
  mapping_image_id?: InputMaybe<Order_By>;
  registration_type?: InputMaybe<Order_By>;
  response_sender_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "developments" */
export enum Developments_Select_Column {
  /** column name */
  ArchitectId = 'architect_id',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DeliveryDate = 'delivery_date',
  /** column name */
  Description = 'description',
  /** column name */
  DeveloperId = 'developer_id',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  EnquiryResponseOverrideLot = 'enquiry_response_override_lot',
  /** column name */
  GeneralContractorId = 'general_contractor_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  MappingImageId = 'mapping_image_id',
  /** column name */
  RegistrationType = 'registration_type',
  /** column name */
  ResponseSenderId = 'response_sender_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "developments" */
export type Developments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Developments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Developments_Stream_Cursor_Value_Input = {
  architect_id?: InputMaybe<Scalars['uuid']['input']>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  delivery_date?: InputMaybe<Scalars['date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  developer_id?: InputMaybe<Scalars['uuid']['input']>;
  enquiry_response_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enquiry_response_override_lot?: InputMaybe<Scalars['Boolean']['input']>;
  general_contractor_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  mapping_image_id?: InputMaybe<Scalars['uuid']['input']>;
  registration_type?: InputMaybe<Scalars['String']['input']>;
  response_sender_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "dictionaries" */
export type Dictionaries = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  dictionaries_types: Dictionaries_Types_Enum;
  /** An object relationship */
  group?: Maybe<Dictionaries>;
  group_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_deletable?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "dictionary_is_used" */
  is_used?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "dictionary_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en: Scalars['String']['output'];
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  order_nr?: Maybe<Scalars['Int']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  type: Dictionaries_Types_Enum_Enum;
  types?: Maybe<Array<Scalars['String']['output']>>;
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "dictionaries". All fields are combined with a logical 'AND'. */
export type Dictionaries_Bool_Exp = {
  _and?: InputMaybe<Array<Dictionaries_Bool_Exp>>;
  _not?: InputMaybe<Dictionaries_Bool_Exp>;
  _or?: InputMaybe<Array<Dictionaries_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dictionaries_types?: InputMaybe<Dictionaries_Types_Enum_Bool_Exp>;
  group?: InputMaybe<Dictionaries_Bool_Exp>;
  group_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_deletable?: InputMaybe<Boolean_Comparison_Exp>;
  is_used?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Dictionaries_Types_Enum_Enum_Comparison_Exp>;
  types?: InputMaybe<String_Array_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "dictionaries" */
export enum Dictionaries_Constraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  DictionariesIdTenantIdUnique = 'dictionaries_id_tenant_id_unique',
  /** unique or primary key constraint on columns "type", "name" */
  DictionariesNameTypeKey = 'dictionaries_name_type_key',
  /** unique or primary key constraint on columns "type", "tenant_id", "name" */
  DictionariesNameTypeTenantIdKey = 'dictionaries_name_type_tenant_id_key',
  /** unique or primary key constraint on columns "id" */
  DictionariesPkey = 'dictionaries_pkey'
}

/** input type for incrementing numeric columns in table "dictionaries" */
export type Dictionaries_Inc_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "dictionaries" */
export type Dictionaries_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group?: InputMaybe<Dictionaries_Obj_Rel_Insert_Input>;
  group_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deletable?: InputMaybe<Scalars['Boolean']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Dictionaries_Types_Enum_Enum>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "dictionaries" */
export type Dictionaries_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Dictionaries>;
};

/** input type for inserting object relation for remote table "dictionaries" */
export type Dictionaries_Obj_Rel_Insert_Input = {
  data: Dictionaries_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Dictionaries_On_Conflict>;
};

/** on_conflict condition type for table "dictionaries" */
export type Dictionaries_On_Conflict = {
  constraint: Dictionaries_Constraint;
  update_columns?: Array<Dictionaries_Update_Column>;
  where?: InputMaybe<Dictionaries_Bool_Exp>;
};

/** Ordering options when selecting data from "dictionaries". */
export type Dictionaries_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dictionaries_types?: InputMaybe<Dictionaries_Types_Enum_Order_By>;
  group?: InputMaybe<Dictionaries_Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deletable?: InputMaybe<Order_By>;
  is_used?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  types?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dictionaries */
export type Dictionaries_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "dictionaries" */
export enum Dictionaries_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeletable = 'is_deletable',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  Name = 'name',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  Types = 'types',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "dictionaries" */
export type Dictionaries_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deletable?: InputMaybe<Scalars['Boolean']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Dictionaries_Types_Enum_Enum>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "dictionaries" */
export type Dictionaries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dictionaries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dictionaries_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deletable?: InputMaybe<Scalars['Boolean']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Dictionaries_Types_Enum_Enum>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "dictionaries_types_enum" */
export type Dictionaries_Types_Enum = {
  comment: Scalars['String']['output'];
  /** A computed field, executes function "dictionaries_types_enum_label" */
  label?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "dictionaries_types_enum". All fields are combined with a logical 'AND'. */
export type Dictionaries_Types_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Dictionaries_Types_Enum_Bool_Exp>>;
  _not?: InputMaybe<Dictionaries_Types_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Dictionaries_Types_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Dictionaries_Types_Enum_Enum {
  /** Certifications available for users */
  Certifications = 'certifications',
  DocumentTypeGroups = 'document_type_groups',
  Documents = 'documents',
  Enums = 'enums',
  Languages = 'languages',
  LeadRefusedTypes = 'lead_refused_types',
  LeadSourceTypes = 'lead_source_types',
  LotOriginTypes = 'lot_origin_types',
  MandateProbabilityTypes = 'mandate_probability_types',
  MembershipTypes = 'membership_types',
  NationalityTypes = 'nationality_types',
  OccupationTypes = 'occupation_types',
  OfferRefusedTypes = 'offer_refused_types',
  /** Point of Interest types for properties */
  PoiTypes = 'poi_types',
  Services = 'services',
  StringFilters = 'string_filters',
  TagsTypes = 'tags_types',
  WorkPermitTypes = 'work_permit_types'
}

/** Boolean expression to compare columns of type "dictionaries_types_enum_enum". All fields are combined with logical 'AND'. */
export type Dictionaries_Types_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Dictionaries_Types_Enum_Enum>;
  _in?: InputMaybe<Array<Dictionaries_Types_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Dictionaries_Types_Enum_Enum>;
  _nin?: InputMaybe<Array<Dictionaries_Types_Enum_Enum>>;
};

/** Ordering options when selecting data from "dictionaries_types_enum". */
export type Dictionaries_Types_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "dictionaries_types_enum" */
export enum Dictionaries_Types_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "dictionaries_types_enum" */
export type Dictionaries_Types_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dictionaries_Types_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dictionaries_Types_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "dictionaries" */
export enum Dictionaries_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeletable = 'is_deletable',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  Name = 'name',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  Types = 'types',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Dictionaries_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Dictionaries_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dictionaries_Set_Input>;
  /** filter the rows which have to be updated */
  where: Dictionaries_Bool_Exp;
};

/** Enum for doc_template_type */
export type Doc_Template_Type_Enum = {
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "doc_template_type_enum". All fields are combined with a logical 'AND'. */
export type Doc_Template_Type_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Doc_Template_Type_Enum_Bool_Exp>>;
  _not?: InputMaybe<Doc_Template_Type_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Doc_Template_Type_Enum_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Doc_Template_Type_Enum_Enum {
  AppraisalReport = 'appraisal_report',
  CmaReport = 'cma_report',
  DevelopmentBrochure = 'development_brochure',
  FinancingPassport = 'financing_passport',
  LotBrochure = 'lot_brochure',
  Mandate = 'mandate',
  SellerReport = 'seller_report'
}

/** Boolean expression to compare columns of type "doc_template_type_enum_enum". All fields are combined with logical 'AND'. */
export type Doc_Template_Type_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Doc_Template_Type_Enum_Enum>;
  _in?: InputMaybe<Array<Doc_Template_Type_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Doc_Template_Type_Enum_Enum>;
  _nin?: InputMaybe<Array<Doc_Template_Type_Enum_Enum>>;
};

/** Ordering options when selecting data from "doc_template_type_enum". */
export type Doc_Template_Type_Enum_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** select columns of table "doc_template_type_enum" */
export enum Doc_Template_Type_Enum_Select_Column {
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "doc_template_type_enum" */
export type Doc_Template_Type_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Doc_Template_Type_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Doc_Template_Type_Enum_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "doc_templates" */
export type Doc_Templates = {
  active: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_tenant?: Maybe<Read_Only_Tenants>;
  /** An object relationship */
  doc_template_type_enum: Doc_Template_Type_Enum;
  /** An array relationship */
  doc_templates_tenants: Array<Doc_Templates_Tenants>;
  filename_template: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  tenant_id: Scalars['uuid']['output'];
  translations?: Maybe<Scalars['jsonb']['output']>;
  type: Doc_Template_Type_Enum_Enum;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "doc_templates" */
export type Doc_TemplatesDoc_Templates_TenantsArgs = {
  distinct_on?: InputMaybe<Array<Doc_Templates_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Templates_Tenants_Order_By>>;
  where?: InputMaybe<Doc_Templates_Tenants_Bool_Exp>;
};


/** columns and relationships of "doc_templates" */
export type Doc_TemplatesTranslationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Doc_Templates_Append_Input = {
  translations?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "doc_templates". All fields are combined with a logical 'AND'. */
export type Doc_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Doc_Templates_Bool_Exp>>;
  _not?: InputMaybe<Doc_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Doc_Templates_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_tenant?: InputMaybe<Read_Only_Tenants_Bool_Exp>;
  doc_template_type_enum?: InputMaybe<Doc_Template_Type_Enum_Bool_Exp>;
  doc_templates_tenants?: InputMaybe<Doc_Templates_Tenants_Bool_Exp>;
  filename_template?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  translations?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<Doc_Template_Type_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "doc_templates" */
export enum Doc_Templates_Constraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  DocTemplatesIdTenantIdUnique = 'doc_templates_id_tenant_id_unique',
  /** unique or primary key constraint on columns "tenant_id", "name" */
  DocTemplatesNameTenantIdUnique = 'doc_templates_name_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  DocTemplatesPkey = 'doc_templates_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Doc_Templates_Delete_At_Path_Input = {
  translations?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Doc_Templates_Delete_Elem_Input = {
  translations?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Doc_Templates_Delete_Key_Input = {
  translations?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "doc_templates" */
export type Doc_Templates_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  doc_templates_tenants?: InputMaybe<Doc_Templates_Tenants_Arr_Rel_Insert_Input>;
  filename_template?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Doc_Template_Type_Enum_Enum>;
};

/** response of any mutation on the table "doc_templates" */
export type Doc_Templates_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Doc_Templates>;
};

/** input type for inserting object relation for remote table "doc_templates" */
export type Doc_Templates_Obj_Rel_Insert_Input = {
  data: Doc_Templates_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Doc_Templates_On_Conflict>;
};

/** on_conflict condition type for table "doc_templates" */
export type Doc_Templates_On_Conflict = {
  constraint: Doc_Templates_Constraint;
  update_columns?: Array<Doc_Templates_Update_Column>;
  where?: InputMaybe<Doc_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "doc_templates". */
export type Doc_Templates_Order_By = {
  active?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_tenant?: InputMaybe<Read_Only_Tenants_Order_By>;
  doc_template_type_enum?: InputMaybe<Doc_Template_Type_Enum_Order_By>;
  doc_templates_tenants_aggregate?: InputMaybe<Doc_Templates_Tenants_Aggregate_Order_By>;
  filename_template?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  translations?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: doc_templates */
export type Doc_Templates_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Doc_Templates_Prepend_Input = {
  translations?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "doc_templates" */
export enum Doc_Templates_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FilenameTemplate = 'filename_template',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Translations = 'translations',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "doc_templates" */
export type Doc_Templates_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  filename_template?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "doc_templates" */
export type Doc_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Doc_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Doc_Templates_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  filename_template?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  translations?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Doc_Template_Type_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "doc_templates_tenants" */
export type Doc_Templates_Tenants = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  doc_template: Doc_Templates;
  doc_template_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_default: Scalars['Boolean']['output'];
  /** An object relationship */
  tenant?: Maybe<Read_Only_Tenants>;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "doc_templates_tenants" */
export type Doc_Templates_Tenants_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Doc_Templates_Tenants_Max_Order_By>;
  min?: InputMaybe<Doc_Templates_Tenants_Min_Order_By>;
};

/** input type for inserting array relation for remote table "doc_templates_tenants" */
export type Doc_Templates_Tenants_Arr_Rel_Insert_Input = {
  data: Array<Doc_Templates_Tenants_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Doc_Templates_Tenants_On_Conflict>;
};

/** Boolean expression to filter rows from the table "doc_templates_tenants". All fields are combined with a logical 'AND'. */
export type Doc_Templates_Tenants_Bool_Exp = {
  _and?: InputMaybe<Array<Doc_Templates_Tenants_Bool_Exp>>;
  _not?: InputMaybe<Doc_Templates_Tenants_Bool_Exp>;
  _or?: InputMaybe<Array<Doc_Templates_Tenants_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  doc_template?: InputMaybe<Doc_Templates_Bool_Exp>;
  doc_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  tenant?: InputMaybe<Read_Only_Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "doc_templates_tenants" */
export enum Doc_Templates_Tenants_Constraint {
  /** unique or primary key constraint on columns "doc_template_id", "tenant_id" */
  DocTemplatesTenantsDocTemplateIdTenantIdKey = 'doc_templates_tenants_doc_template_id_tenant_id_key',
  /** unique or primary key constraint on columns "id" */
  DocTemplatesTenantsPkey = 'doc_templates_tenants_pkey'
}

/** input type for inserting data into table "doc_templates_tenants" */
export type Doc_Templates_Tenants_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  doc_template?: InputMaybe<Doc_Templates_Obj_Rel_Insert_Input>;
  doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "doc_templates_tenants" */
export type Doc_Templates_Tenants_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  doc_template_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "doc_templates_tenants" */
export type Doc_Templates_Tenants_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  doc_template_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "doc_templates_tenants" */
export type Doc_Templates_Tenants_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Doc_Templates_Tenants>;
};

/** on_conflict condition type for table "doc_templates_tenants" */
export type Doc_Templates_Tenants_On_Conflict = {
  constraint: Doc_Templates_Tenants_Constraint;
  update_columns?: Array<Doc_Templates_Tenants_Update_Column>;
  where?: InputMaybe<Doc_Templates_Tenants_Bool_Exp>;
};

/** Ordering options when selecting data from "doc_templates_tenants". */
export type Doc_Templates_Tenants_Order_By = {
  created_at?: InputMaybe<Order_By>;
  doc_template?: InputMaybe<Doc_Templates_Order_By>;
  doc_template_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_default?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Read_Only_Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: doc_templates_tenants */
export type Doc_Templates_Tenants_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "doc_templates_tenants" */
export enum Doc_Templates_Tenants_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocTemplateId = 'doc_template_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "doc_templates_tenants" */
export type Doc_Templates_Tenants_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "doc_templates_tenants" */
export type Doc_Templates_Tenants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Doc_Templates_Tenants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Doc_Templates_Tenants_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "doc_templates_tenants" */
export enum Doc_Templates_Tenants_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocTemplateId = 'doc_template_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Doc_Templates_Tenants_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Doc_Templates_Tenants_Set_Input>;
  /** filter the rows which have to be updated */
  where: Doc_Templates_Tenants_Bool_Exp;
};

/** update columns of table "doc_templates" */
export enum Doc_Templates_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Content = 'content',
  /** column name */
  FilenameTemplate = 'filename_template',
  /** column name */
  Name = 'name',
  /** column name */
  Translations = 'translations'
}

export type Doc_Templates_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Doc_Templates_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Doc_Templates_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Doc_Templates_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Doc_Templates_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Doc_Templates_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Doc_Templates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Doc_Templates_Bool_Exp;
};

/** columns and relationships of "email_messages" */
export type Email_Messages = {
  account_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  activity?: Maybe<Activities>;
  bcc: Scalars['jsonb']['output'];
  body_template?: Maybe<Scalars['String']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  cc: Scalars['jsonb']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  date: Scalars['timestamptz']['output'];
  /** An object relationship */
  email_sequences_step?: Maybe<Email_Sequences_Steps>;
  /** An object relationship */
  email_thread?: Maybe<Email_Threads>;
  error_message?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Scalars['jsonb']['output']>;
  files?: Maybe<Scalars['jsonb']['output']>;
  from: Scalars['jsonb']['output'];
  from_crm: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  is_sent: Scalars['Boolean']['output'];
  labels?: Maybe<Scalars['jsonb']['output']>;
  message_id?: Maybe<Scalars['String']['output']>;
  nylas_thread_id?: Maybe<Scalars['String']['output']>;
  opens?: Maybe<Scalars['Boolean']['output']>;
  reply_to: Scalars['jsonb']['output'];
  reply_to_message_id?: Maybe<Scalars['String']['output']>;
  sequences_recipient_id?: Maybe<Scalars['uuid']['output']>;
  sequences_step_id?: Maybe<Scalars['uuid']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  starred?: Maybe<Scalars['Boolean']['output']>;
  status: Scalars['String']['output'];
  status_code?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subject_template?: Maybe<Scalars['String']['output']>;
  tenant_id: Scalars['uuid']['output'];
  thread_id?: Maybe<Scalars['uuid']['output']>;
  to: Scalars['jsonb']['output'];
  unread?: Maybe<Scalars['Boolean']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "email_messages" */
export type Email_MessagesBccArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "email_messages" */
export type Email_MessagesCcArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "email_messages" */
export type Email_MessagesEventsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "email_messages" */
export type Email_MessagesFilesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "email_messages" */
export type Email_MessagesFromArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "email_messages" */
export type Email_MessagesLabelsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "email_messages" */
export type Email_MessagesReply_ToArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "email_messages" */
export type Email_MessagesToArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "email_messages" */
export type Email_Messages_Aggregate = {
  aggregate?: Maybe<Email_Messages_Aggregate_Fields>;
  nodes: Array<Email_Messages>;
};

export type Email_Messages_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Email_Messages_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Email_Messages_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Email_Messages_Aggregate_Bool_Exp_Count>;
};

export type Email_Messages_Aggregate_Bool_Exp_Bool_And = {
  arguments: Email_Messages_Select_Column_Email_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Email_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Email_Messages_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Email_Messages_Select_Column_Email_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Email_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Email_Messages_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Email_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Email_Messages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "email_messages" */
export type Email_Messages_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Email_Messages_Max_Fields>;
  min?: Maybe<Email_Messages_Min_Fields>;
};


/** aggregate fields of "email_messages" */
export type Email_Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "email_messages" */
export type Email_Messages_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Email_Messages_Max_Order_By>;
  min?: InputMaybe<Email_Messages_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "email_messages". All fields are combined with a logical 'AND'. */
export type Email_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Messages_Bool_Exp>>;
  _not?: InputMaybe<Email_Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Messages_Bool_Exp>>;
  account_id?: InputMaybe<String_Comparison_Exp>;
  activity?: InputMaybe<Activities_Bool_Exp>;
  bcc?: InputMaybe<Jsonb_Comparison_Exp>;
  body_template?: InputMaybe<String_Comparison_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  cc?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_sequences_step?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
  email_thread?: InputMaybe<Email_Threads_Bool_Exp>;
  error_message?: InputMaybe<String_Comparison_Exp>;
  events?: InputMaybe<Jsonb_Comparison_Exp>;
  files?: InputMaybe<Jsonb_Comparison_Exp>;
  from?: InputMaybe<Jsonb_Comparison_Exp>;
  from_crm?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_sent?: InputMaybe<Boolean_Comparison_Exp>;
  labels?: InputMaybe<Jsonb_Comparison_Exp>;
  message_id?: InputMaybe<String_Comparison_Exp>;
  nylas_thread_id?: InputMaybe<String_Comparison_Exp>;
  opens?: InputMaybe<Boolean_Comparison_Exp>;
  reply_to?: InputMaybe<Jsonb_Comparison_Exp>;
  reply_to_message_id?: InputMaybe<String_Comparison_Exp>;
  sequences_recipient_id?: InputMaybe<Uuid_Comparison_Exp>;
  sequences_step_id?: InputMaybe<Uuid_Comparison_Exp>;
  snippet?: InputMaybe<String_Comparison_Exp>;
  starred?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_code?: InputMaybe<String_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  subject_template?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  thread_id?: InputMaybe<Uuid_Comparison_Exp>;
  to?: InputMaybe<Jsonb_Comparison_Exp>;
  unread?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Email_Messages_Max_Fields = {
  account_id?: Maybe<Scalars['String']['output']>;
  body_template?: Maybe<Scalars['String']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message_id?: Maybe<Scalars['String']['output']>;
  nylas_thread_id?: Maybe<Scalars['String']['output']>;
  reply_to_message_id?: Maybe<Scalars['String']['output']>;
  sequences_recipient_id?: Maybe<Scalars['uuid']['output']>;
  sequences_step_id?: Maybe<Scalars['uuid']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_code?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subject_template?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  thread_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "email_messages" */
export type Email_Messages_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  body_template?: InputMaybe<Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  nylas_thread_id?: InputMaybe<Order_By>;
  reply_to_message_id?: InputMaybe<Order_By>;
  sequences_recipient_id?: InputMaybe<Order_By>;
  sequences_step_id?: InputMaybe<Order_By>;
  snippet?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_code?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  subject_template?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Email_Messages_Min_Fields = {
  account_id?: Maybe<Scalars['String']['output']>;
  body_template?: Maybe<Scalars['String']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message_id?: Maybe<Scalars['String']['output']>;
  nylas_thread_id?: Maybe<Scalars['String']['output']>;
  reply_to_message_id?: Maybe<Scalars['String']['output']>;
  sequences_recipient_id?: Maybe<Scalars['uuid']['output']>;
  sequences_step_id?: Maybe<Scalars['uuid']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_code?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subject_template?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  thread_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "email_messages" */
export type Email_Messages_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  body_template?: InputMaybe<Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  nylas_thread_id?: InputMaybe<Order_By>;
  reply_to_message_id?: InputMaybe<Order_By>;
  sequences_recipient_id?: InputMaybe<Order_By>;
  sequences_step_id?: InputMaybe<Order_By>;
  snippet?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_code?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  subject_template?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "email_messages". */
export type Email_Messages_Order_By = {
  account_id?: InputMaybe<Order_By>;
  activity?: InputMaybe<Activities_Order_By>;
  bcc?: InputMaybe<Order_By>;
  body_template?: InputMaybe<Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  cc?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  email_sequences_step?: InputMaybe<Email_Sequences_Steps_Order_By>;
  email_thread?: InputMaybe<Email_Threads_Order_By>;
  error_message?: InputMaybe<Order_By>;
  events?: InputMaybe<Order_By>;
  files?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  from_crm?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_sent?: InputMaybe<Order_By>;
  labels?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  nylas_thread_id?: InputMaybe<Order_By>;
  opens?: InputMaybe<Order_By>;
  reply_to?: InputMaybe<Order_By>;
  reply_to_message_id?: InputMaybe<Order_By>;
  sequences_recipient_id?: InputMaybe<Order_By>;
  sequences_step_id?: InputMaybe<Order_By>;
  snippet?: InputMaybe<Order_By>;
  starred?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_code?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  subject_template?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
  unread?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "email_messages" */
export enum Email_Messages_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Bcc = 'bcc',
  /** column name */
  BodyTemplate = 'body_template',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  Cc = 'cc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Date = 'date',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  Events = 'events',
  /** column name */
  Files = 'files',
  /** column name */
  From = 'from',
  /** column name */
  FromCrm = 'from_crm',
  /** column name */
  Id = 'id',
  /** column name */
  IsSent = 'is_sent',
  /** column name */
  Labels = 'labels',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  NylasThreadId = 'nylas_thread_id',
  /** column name */
  Opens = 'opens',
  /** column name */
  ReplyTo = 'reply_to',
  /** column name */
  ReplyToMessageId = 'reply_to_message_id',
  /** column name */
  SequencesRecipientId = 'sequences_recipient_id',
  /** column name */
  SequencesStepId = 'sequences_step_id',
  /** column name */
  Snippet = 'snippet',
  /** column name */
  Starred = 'starred',
  /** column name */
  Status = 'status',
  /** column name */
  StatusCode = 'status_code',
  /** column name */
  Subject = 'subject',
  /** column name */
  SubjectTemplate = 'subject_template',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  To = 'to',
  /** column name */
  Unread = 'unread',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "email_messages_aggregate_bool_exp_bool_and_arguments_columns" columns of table "email_messages" */
export enum Email_Messages_Select_Column_Email_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  FromCrm = 'from_crm',
  /** column name */
  IsSent = 'is_sent',
  /** column name */
  Opens = 'opens',
  /** column name */
  Starred = 'starred',
  /** column name */
  Unread = 'unread'
}

/** select "email_messages_aggregate_bool_exp_bool_or_arguments_columns" columns of table "email_messages" */
export enum Email_Messages_Select_Column_Email_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  FromCrm = 'from_crm',
  /** column name */
  IsSent = 'is_sent',
  /** column name */
  Opens = 'opens',
  /** column name */
  Starred = 'starred',
  /** column name */
  Unread = 'unread'
}

/** columns and relationships of "email_sequences" */
export type Email_Sequences = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['uuid']['output'];
  /** An object relationship */
  created_by_user: Users;
  /** An array relationship */
  email_sequences_recipients: Array<Email_Sequences_Recipients>;
  /** An aggregate relationship */
  email_sequences_recipients_aggregate: Email_Sequences_Recipients_Aggregate;
  /** An array relationship */
  email_sequences_steps: Array<Email_Sequences_Steps>;
  /** An aggregate relationship */
  email_sequences_steps_aggregate: Email_Sequences_Steps_Aggregate;
  id: Scalars['uuid']['output'];
  is_shared_with_everyone?: Maybe<Scalars['Boolean']['output']>;
  is_shared_with_team?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status: Email_Sequences_Status_Enum_Enum;
  stop_after_reply?: Maybe<Scalars['Boolean']['output']>;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "email_sequences" */
export type Email_SequencesEmail_Sequences_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Recipients_Order_By>>;
  where?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
};


/** columns and relationships of "email_sequences" */
export type Email_SequencesEmail_Sequences_Recipients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Recipients_Order_By>>;
  where?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
};


/** columns and relationships of "email_sequences" */
export type Email_SequencesEmail_Sequences_StepsArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Steps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Steps_Order_By>>;
  where?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
};


/** columns and relationships of "email_sequences" */
export type Email_SequencesEmail_Sequences_Steps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Steps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Steps_Order_By>>;
  where?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "email_sequences". All fields are combined with a logical 'AND'. */
export type Email_Sequences_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Sequences_Bool_Exp>>;
  _not?: InputMaybe<Email_Sequences_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Sequences_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_user?: InputMaybe<Users_Bool_Exp>;
  email_sequences_recipients?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
  email_sequences_recipients_aggregate?: InputMaybe<Email_Sequences_Recipients_Aggregate_Bool_Exp>;
  email_sequences_steps?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
  email_sequences_steps_aggregate?: InputMaybe<Email_Sequences_Steps_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_shared_with_everyone?: InputMaybe<Boolean_Comparison_Exp>;
  is_shared_with_team?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Email_Sequences_Status_Enum_Enum_Comparison_Exp>;
  stop_after_reply?: InputMaybe<Boolean_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_sequences" */
export enum Email_Sequences_Constraint {
  /** unique or primary key constraint on columns "id" */
  EmailSequencesPkey = 'email_sequences_pkey'
}

/** input type for inserting data into table "email_sequences" */
export type Email_Sequences_Insert_Input = {
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  email_sequences_recipients?: InputMaybe<Email_Sequences_Recipients_Arr_Rel_Insert_Input>;
  email_sequences_steps?: InputMaybe<Email_Sequences_Steps_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared_with_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_team?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Email_Sequences_Status_Enum_Enum>;
  stop_after_reply?: InputMaybe<Scalars['Boolean']['input']>;
};

/** response of any mutation on the table "email_sequences" */
export type Email_Sequences_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Sequences>;
};

/** input type for inserting object relation for remote table "email_sequences" */
export type Email_Sequences_Obj_Rel_Insert_Input = {
  data: Email_Sequences_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Sequences_On_Conflict>;
};

/** on_conflict condition type for table "email_sequences" */
export type Email_Sequences_On_Conflict = {
  constraint: Email_Sequences_Constraint;
  update_columns?: Array<Email_Sequences_Update_Column>;
  where?: InputMaybe<Email_Sequences_Bool_Exp>;
};

/** Ordering options when selecting data from "email_sequences". */
export type Email_Sequences_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<Users_Order_By>;
  email_sequences_recipients_aggregate?: InputMaybe<Email_Sequences_Recipients_Aggregate_Order_By>;
  email_sequences_steps_aggregate?: InputMaybe<Email_Sequences_Steps_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_shared_with_everyone?: InputMaybe<Order_By>;
  is_shared_with_team?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stop_after_reply?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_sequences */
export type Email_Sequences_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "email_sequences_recipients" */
export type Email_Sequences_Recipients = {
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  buyer_leads?: Maybe<Buyer_Leads>;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  email_messages: Array<Email_Messages>;
  /** An aggregate relationship */
  email_messages_aggregate: Email_Messages_Aggregate;
  /** An object relationship */
  email_sequence: Email_Sequences;
  email_sequence_id: Scalars['uuid']['output'];
  /** An object relationship */
  from_user: Users;
  from_user_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  last_step_number?: Maybe<Scalars['smallint']['output']>;
  /** An object relationship */
  lead?: Maybe<Leads>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  lot?: Maybe<Lots>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  status: Email_Sequences_Recipients_Status_Enum_Enum;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "email_sequences_recipients" */
export type Email_Sequences_RecipientsEmail_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>;
  where?: InputMaybe<Email_Messages_Bool_Exp>;
};


/** columns and relationships of "email_sequences_recipients" */
export type Email_Sequences_RecipientsEmail_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>;
  where?: InputMaybe<Email_Messages_Bool_Exp>;
};

/** aggregated selection of "email_sequences_recipients" */
export type Email_Sequences_Recipients_Aggregate = {
  aggregate?: Maybe<Email_Sequences_Recipients_Aggregate_Fields>;
  nodes: Array<Email_Sequences_Recipients>;
};

export type Email_Sequences_Recipients_Aggregate_Bool_Exp = {
  count?: InputMaybe<Email_Sequences_Recipients_Aggregate_Bool_Exp_Count>;
};

export type Email_Sequences_Recipients_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Email_Sequences_Recipients_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "email_sequences_recipients" */
export type Email_Sequences_Recipients_Aggregate_Fields = {
  avg?: Maybe<Email_Sequences_Recipients_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Email_Sequences_Recipients_Max_Fields>;
  min?: Maybe<Email_Sequences_Recipients_Min_Fields>;
  stddev?: Maybe<Email_Sequences_Recipients_Stddev_Fields>;
  stddev_pop?: Maybe<Email_Sequences_Recipients_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Email_Sequences_Recipients_Stddev_Samp_Fields>;
  sum?: Maybe<Email_Sequences_Recipients_Sum_Fields>;
  var_pop?: Maybe<Email_Sequences_Recipients_Var_Pop_Fields>;
  var_samp?: Maybe<Email_Sequences_Recipients_Var_Samp_Fields>;
  variance?: Maybe<Email_Sequences_Recipients_Variance_Fields>;
};


/** aggregate fields of "email_sequences_recipients" */
export type Email_Sequences_Recipients_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Sequences_Recipients_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Aggregate_Order_By = {
  avg?: InputMaybe<Email_Sequences_Recipients_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Email_Sequences_Recipients_Max_Order_By>;
  min?: InputMaybe<Email_Sequences_Recipients_Min_Order_By>;
  stddev?: InputMaybe<Email_Sequences_Recipients_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Email_Sequences_Recipients_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Email_Sequences_Recipients_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Email_Sequences_Recipients_Sum_Order_By>;
  var_pop?: InputMaybe<Email_Sequences_Recipients_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Email_Sequences_Recipients_Var_Samp_Order_By>;
  variance?: InputMaybe<Email_Sequences_Recipients_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Arr_Rel_Insert_Input = {
  data: Array<Email_Sequences_Recipients_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Sequences_Recipients_On_Conflict>;
};

/** aggregate avg on columns */
export type Email_Sequences_Recipients_Avg_Fields = {
  last_step_number?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Avg_Order_By = {
  last_step_number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "email_sequences_recipients". All fields are combined with a logical 'AND'. */
export type Email_Sequences_Recipients_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Sequences_Recipients_Bool_Exp>>;
  _not?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Sequences_Recipients_Bool_Exp>>;
  buyer_lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  buyer_leads?: InputMaybe<Buyer_Leads_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_messages?: InputMaybe<Email_Messages_Bool_Exp>;
  email_messages_aggregate?: InputMaybe<Email_Messages_Aggregate_Bool_Exp>;
  email_sequence?: InputMaybe<Email_Sequences_Bool_Exp>;
  email_sequence_id?: InputMaybe<Uuid_Comparison_Exp>;
  from_user?: InputMaybe<Users_Bool_Exp>;
  from_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_step_number?: InputMaybe<Smallint_Comparison_Exp>;
  lead?: InputMaybe<Leads_Bool_Exp>;
  lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Email_Sequences_Recipients_Status_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_sequences_recipients" */
export enum Email_Sequences_Recipients_Constraint {
  /** unique or primary key constraint on columns "buyer_lead_id", "user_id", "email_sequence_id" */
  EmailSequencesRecipientsEmailSequenceIdUserIdBuyerLead = 'email_sequences_recipients_email_sequence_id_user_id_buyer_lead',
  /** unique or primary key constraint on columns "user_id", "email_sequence_id", "lead_id" */
  EmailSequencesRecipientsEmailSequenceIdUserIdLeadIdKe = 'email_sequences_recipients_email_sequence_id_user_id_lead_id_ke',
  /** unique or primary key constraint on columns "user_id", "email_sequence_id", "lot_id" */
  EmailSequencesRecipientsEmailSequenceIdUserIdLotIdKey = 'email_sequences_recipients_email_sequence_id_user_id_lot_id_key',
  /** unique or primary key constraint on columns "id" */
  EmailSequencesRecipientsPkey = 'email_sequences_recipients_pkey'
}

/** input type for inserting data into table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Insert_Input = {
  buyer_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_leads?: InputMaybe<Buyer_Leads_Obj_Rel_Insert_Input>;
  email_sequence?: InputMaybe<Email_Sequences_Obj_Rel_Insert_Input>;
  email_sequence_id?: InputMaybe<Scalars['uuid']['input']>;
  from_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  from_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_step_number?: InputMaybe<Scalars['smallint']['input']>;
  lead?: InputMaybe<Leads_Obj_Rel_Insert_Input>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Email_Sequences_Recipients_Status_Enum_Enum>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Email_Sequences_Recipients_Max_Fields = {
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email_sequence_id?: Maybe<Scalars['uuid']['output']>;
  from_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_step_number?: Maybe<Scalars['smallint']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Max_Order_By = {
  buyer_lead_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_sequence_id?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_step_number?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Email_Sequences_Recipients_Min_Fields = {
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email_sequence_id?: Maybe<Scalars['uuid']['output']>;
  from_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_step_number?: Maybe<Scalars['smallint']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Min_Order_By = {
  buyer_lead_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_sequence_id?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_step_number?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Sequences_Recipients>;
};

/** on_conflict condition type for table "email_sequences_recipients" */
export type Email_Sequences_Recipients_On_Conflict = {
  constraint: Email_Sequences_Recipients_Constraint;
  update_columns?: Array<Email_Sequences_Recipients_Update_Column>;
  where?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
};

/** Ordering options when selecting data from "email_sequences_recipients". */
export type Email_Sequences_Recipients_Order_By = {
  buyer_lead_id?: InputMaybe<Order_By>;
  buyer_leads?: InputMaybe<Buyer_Leads_Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_messages_aggregate?: InputMaybe<Email_Messages_Aggregate_Order_By>;
  email_sequence?: InputMaybe<Email_Sequences_Order_By>;
  email_sequence_id?: InputMaybe<Order_By>;
  from_user?: InputMaybe<Users_Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_step_number?: InputMaybe<Order_By>;
  lead?: InputMaybe<Leads_Order_By>;
  lead_id?: InputMaybe<Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_sequences_recipients */
export type Email_Sequences_Recipients_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "email_sequences_recipients" */
export enum Email_Sequences_Recipients_Select_Column {
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailSequenceId = 'email_sequence_id',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastStepNumber = 'last_step_number',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Set_Input = {
  status?: InputMaybe<Email_Sequences_Recipients_Status_Enum_Enum>;
};

export enum Email_Sequences_Recipients_Status_Enum_Enum {
  /** Active */
  Active = 'active',
  /** Stopped */
  Stopped = 'stopped'
}

/** Boolean expression to compare columns of type "email_sequences_recipients_status_enum_enum". All fields are combined with logical 'AND'. */
export type Email_Sequences_Recipients_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Email_Sequences_Recipients_Status_Enum_Enum>;
  _in?: InputMaybe<Array<Email_Sequences_Recipients_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Email_Sequences_Recipients_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<Email_Sequences_Recipients_Status_Enum_Enum>>;
};

/** aggregate stddev on columns */
export type Email_Sequences_Recipients_Stddev_Fields = {
  last_step_number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Stddev_Order_By = {
  last_step_number?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Email_Sequences_Recipients_Stddev_Pop_Fields = {
  last_step_number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Stddev_Pop_Order_By = {
  last_step_number?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Email_Sequences_Recipients_Stddev_Samp_Fields = {
  last_step_number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Stddev_Samp_Order_By = {
  last_step_number?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Sequences_Recipients_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Sequences_Recipients_Stream_Cursor_Value_Input = {
  buyer_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_sequence_id?: InputMaybe<Scalars['uuid']['input']>;
  from_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_step_number?: InputMaybe<Scalars['smallint']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Email_Sequences_Recipients_Status_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Email_Sequences_Recipients_Sum_Fields = {
  last_step_number?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Sum_Order_By = {
  last_step_number?: InputMaybe<Order_By>;
};

/** update columns of table "email_sequences_recipients" */
export enum Email_Sequences_Recipients_Update_Column {
  /** column name */
  Status = 'status'
}

export type Email_Sequences_Recipients_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Sequences_Recipients_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Sequences_Recipients_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Email_Sequences_Recipients_Var_Pop_Fields = {
  last_step_number?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Var_Pop_Order_By = {
  last_step_number?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Email_Sequences_Recipients_Var_Samp_Fields = {
  last_step_number?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Var_Samp_Order_By = {
  last_step_number?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Email_Sequences_Recipients_Variance_Fields = {
  last_step_number?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Variance_Order_By = {
  last_step_number?: InputMaybe<Order_By>;
};

/** select columns of table "email_sequences" */
export enum Email_Sequences_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsSharedWithEveryone = 'is_shared_with_everyone',
  /** column name */
  IsSharedWithTeam = 'is_shared_with_team',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  StopAfterReply = 'stop_after_reply',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "email_sequences" */
export type Email_Sequences_Set_Input = {
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  is_shared_with_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_team?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Email_Sequences_Status_Enum_Enum>;
  stop_after_reply?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum Email_Sequences_Status_Enum_Enum {
  /** Active */
  Active = 'active',
  /** Inactive */
  Inactive = 'inactive'
}

/** Boolean expression to compare columns of type "email_sequences_status_enum_enum". All fields are combined with logical 'AND'. */
export type Email_Sequences_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Email_Sequences_Status_Enum_Enum>;
  _in?: InputMaybe<Array<Email_Sequences_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Email_Sequences_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<Email_Sequences_Status_Enum_Enum>>;
};

/** columns and relationships of "email_sequences_steps" */
export type Email_Sequences_Steps = {
  created_at: Scalars['timestamptz']['output'];
  delay: Scalars['smallint']['output'];
  /** An array relationship */
  email_messages: Array<Email_Messages>;
  /** An aggregate relationship */
  email_messages_aggregate: Email_Messages_Aggregate;
  /** An object relationship */
  email_sequence: Email_Sequences;
  email_sequence_id: Scalars['uuid']['output'];
  /** An object relationship */
  email_template: Email_Templates;
  id: Scalars['uuid']['output'];
  number: Scalars['smallint']['output'];
  template_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "email_sequences_steps" */
export type Email_Sequences_StepsEmail_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>;
  where?: InputMaybe<Email_Messages_Bool_Exp>;
};


/** columns and relationships of "email_sequences_steps" */
export type Email_Sequences_StepsEmail_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>;
  where?: InputMaybe<Email_Messages_Bool_Exp>;
};

/** aggregated selection of "email_sequences_steps" */
export type Email_Sequences_Steps_Aggregate = {
  aggregate?: Maybe<Email_Sequences_Steps_Aggregate_Fields>;
  nodes: Array<Email_Sequences_Steps>;
};

export type Email_Sequences_Steps_Aggregate_Bool_Exp = {
  count?: InputMaybe<Email_Sequences_Steps_Aggregate_Bool_Exp_Count>;
};

export type Email_Sequences_Steps_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Email_Sequences_Steps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "email_sequences_steps" */
export type Email_Sequences_Steps_Aggregate_Fields = {
  avg?: Maybe<Email_Sequences_Steps_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Email_Sequences_Steps_Max_Fields>;
  min?: Maybe<Email_Sequences_Steps_Min_Fields>;
  stddev?: Maybe<Email_Sequences_Steps_Stddev_Fields>;
  stddev_pop?: Maybe<Email_Sequences_Steps_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Email_Sequences_Steps_Stddev_Samp_Fields>;
  sum?: Maybe<Email_Sequences_Steps_Sum_Fields>;
  var_pop?: Maybe<Email_Sequences_Steps_Var_Pop_Fields>;
  var_samp?: Maybe<Email_Sequences_Steps_Var_Samp_Fields>;
  variance?: Maybe<Email_Sequences_Steps_Variance_Fields>;
};


/** aggregate fields of "email_sequences_steps" */
export type Email_Sequences_Steps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Sequences_Steps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "email_sequences_steps" */
export type Email_Sequences_Steps_Aggregate_Order_By = {
  avg?: InputMaybe<Email_Sequences_Steps_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Email_Sequences_Steps_Max_Order_By>;
  min?: InputMaybe<Email_Sequences_Steps_Min_Order_By>;
  stddev?: InputMaybe<Email_Sequences_Steps_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Email_Sequences_Steps_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Email_Sequences_Steps_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Email_Sequences_Steps_Sum_Order_By>;
  var_pop?: InputMaybe<Email_Sequences_Steps_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Email_Sequences_Steps_Var_Samp_Order_By>;
  variance?: InputMaybe<Email_Sequences_Steps_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "email_sequences_steps" */
export type Email_Sequences_Steps_Arr_Rel_Insert_Input = {
  data: Array<Email_Sequences_Steps_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Sequences_Steps_On_Conflict>;
};

/** aggregate avg on columns */
export type Email_Sequences_Steps_Avg_Fields = {
  delay?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Avg_Order_By = {
  delay?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "email_sequences_steps". All fields are combined with a logical 'AND'. */
export type Email_Sequences_Steps_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Sequences_Steps_Bool_Exp>>;
  _not?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Sequences_Steps_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  delay?: InputMaybe<Smallint_Comparison_Exp>;
  email_messages?: InputMaybe<Email_Messages_Bool_Exp>;
  email_messages_aggregate?: InputMaybe<Email_Messages_Aggregate_Bool_Exp>;
  email_sequence?: InputMaybe<Email_Sequences_Bool_Exp>;
  email_sequence_id?: InputMaybe<Uuid_Comparison_Exp>;
  email_template?: InputMaybe<Email_Templates_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  number?: InputMaybe<Smallint_Comparison_Exp>;
  template_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_sequences_steps" */
export enum Email_Sequences_Steps_Constraint {
  /** unique or primary key constraint on columns "email_sequence_id", "number" */
  EmailSequencesStepsEmailSequenceIdNumberKey = 'email_sequences_steps_email_sequence_id_number_key',
  /** unique or primary key constraint on columns "id" */
  EmailSequencesStepsPkey = 'email_sequences_steps_pkey'
}

/** input type for incrementing numeric columns in table "email_sequences_steps" */
export type Email_Sequences_Steps_Inc_Input = {
  delay?: InputMaybe<Scalars['smallint']['input']>;
  number?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "email_sequences_steps" */
export type Email_Sequences_Steps_Insert_Input = {
  delay?: InputMaybe<Scalars['smallint']['input']>;
  email_sequence?: InputMaybe<Email_Sequences_Obj_Rel_Insert_Input>;
  email_sequence_id?: InputMaybe<Scalars['uuid']['input']>;
  email_template?: InputMaybe<Email_Templates_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  number?: InputMaybe<Scalars['smallint']['input']>;
  template_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Email_Sequences_Steps_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  delay?: Maybe<Scalars['smallint']['output']>;
  email_sequence_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  number?: Maybe<Scalars['smallint']['output']>;
  template_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  delay?: InputMaybe<Order_By>;
  email_sequence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Email_Sequences_Steps_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  delay?: Maybe<Scalars['smallint']['output']>;
  email_sequence_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  number?: Maybe<Scalars['smallint']['output']>;
  template_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  delay?: InputMaybe<Order_By>;
  email_sequence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "email_sequences_steps" */
export type Email_Sequences_Steps_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Sequences_Steps>;
};

/** on_conflict condition type for table "email_sequences_steps" */
export type Email_Sequences_Steps_On_Conflict = {
  constraint: Email_Sequences_Steps_Constraint;
  update_columns?: Array<Email_Sequences_Steps_Update_Column>;
  where?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
};

/** Ordering options when selecting data from "email_sequences_steps". */
export type Email_Sequences_Steps_Order_By = {
  created_at?: InputMaybe<Order_By>;
  delay?: InputMaybe<Order_By>;
  email_messages_aggregate?: InputMaybe<Email_Messages_Aggregate_Order_By>;
  email_sequence?: InputMaybe<Email_Sequences_Order_By>;
  email_sequence_id?: InputMaybe<Order_By>;
  email_template?: InputMaybe<Email_Templates_Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_sequences_steps */
export type Email_Sequences_Steps_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "email_sequences_steps" */
export enum Email_Sequences_Steps_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Delay = 'delay',
  /** column name */
  EmailSequenceId = 'email_sequence_id',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "email_sequences_steps" */
export type Email_Sequences_Steps_Set_Input = {
  delay?: InputMaybe<Scalars['smallint']['input']>;
  email_sequence_id?: InputMaybe<Scalars['uuid']['input']>;
  number?: InputMaybe<Scalars['smallint']['input']>;
  template_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Email_Sequences_Steps_Stddev_Fields = {
  delay?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Stddev_Order_By = {
  delay?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Email_Sequences_Steps_Stddev_Pop_Fields = {
  delay?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Stddev_Pop_Order_By = {
  delay?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Email_Sequences_Steps_Stddev_Samp_Fields = {
  delay?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Stddev_Samp_Order_By = {
  delay?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "email_sequences_steps" */
export type Email_Sequences_Steps_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Sequences_Steps_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Sequences_Steps_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delay?: InputMaybe<Scalars['smallint']['input']>;
  email_sequence_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  number?: InputMaybe<Scalars['smallint']['input']>;
  template_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Email_Sequences_Steps_Sum_Fields = {
  delay?: Maybe<Scalars['smallint']['output']>;
  number?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Sum_Order_By = {
  delay?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** update columns of table "email_sequences_steps" */
export enum Email_Sequences_Steps_Update_Column {
  /** column name */
  Delay = 'delay',
  /** column name */
  EmailSequenceId = 'email_sequence_id',
  /** column name */
  Number = 'number',
  /** column name */
  TemplateId = 'template_id'
}

export type Email_Sequences_Steps_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Email_Sequences_Steps_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Sequences_Steps_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Sequences_Steps_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Email_Sequences_Steps_Var_Pop_Fields = {
  delay?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Var_Pop_Order_By = {
  delay?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Email_Sequences_Steps_Var_Samp_Fields = {
  delay?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Var_Samp_Order_By = {
  delay?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Email_Sequences_Steps_Variance_Fields = {
  delay?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Variance_Order_By = {
  delay?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "email_sequences" */
export type Email_Sequences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Sequences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Sequences_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared_with_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_team?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Email_Sequences_Status_Enum_Enum>;
  stop_after_reply?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "email_sequences" */
export enum Email_Sequences_Update_Column {
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  IsSharedWithEveryone = 'is_shared_with_everyone',
  /** column name */
  IsSharedWithTeam = 'is_shared_with_team',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  StopAfterReply = 'stop_after_reply'
}

export type Email_Sequences_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Sequences_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Sequences_Bool_Exp;
};

/** Boolean expression to compare columns of type "email_template". All fields are combined with logical 'AND'. */
export type Email_Template_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['email_template']['input']>;
  _gt?: InputMaybe<Scalars['email_template']['input']>;
  _gte?: InputMaybe<Scalars['email_template']['input']>;
  _in?: InputMaybe<Array<Scalars['email_template']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['email_template']['input']>;
  _lte?: InputMaybe<Scalars['email_template']['input']>;
  _neq?: InputMaybe<Scalars['email_template']['input']>;
  _nin?: InputMaybe<Array<Scalars['email_template']['input']>>;
};

/** columns and relationships of "email_templates" */
export type Email_Templates = {
  add_signature: Scalars['Boolean']['output'];
  bcc?: Maybe<Scalars['jsonb']['output']>;
  cc?: Maybe<Scalars['jsonb']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  development?: Maybe<Developments>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  email_templates_files: Array<Email_Templates_Files>;
  id: Scalars['uuid']['output'];
  is_shared: Scalars['Boolean']['output'];
  is_shared_with_everyone: Scalars['Boolean']['output'];
  is_shared_with_organisation: Scalars['Boolean']['output'];
  /** An object relationship */
  lot?: Maybe<Lots>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subject_plaintext?: Maybe<Scalars['String']['output']>;
  target: Email_Templates_Target_Enum_Enum;
  tenant_id: Scalars['uuid']['output'];
  text?: Maybe<Scalars['String']['output']>;
  text_html?: Maybe<Scalars['String']['output']>;
  text_plaintext?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "email_templates" */
export type Email_TemplatesBccArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "email_templates" */
export type Email_TemplatesCcArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "email_templates" */
export type Email_TemplatesEmail_Templates_FilesArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Templates_Files_Order_By>>;
  where?: InputMaybe<Email_Templates_Files_Bool_Exp>;
};

/** order by aggregate values of table "email_templates" */
export type Email_Templates_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Email_Templates_Max_Order_By>;
  min?: InputMaybe<Email_Templates_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Email_Templates_Append_Input = {
  bcc?: InputMaybe<Scalars['jsonb']['input']>;
  cc?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "email_templates" */
export type Email_Templates_Arr_Rel_Insert_Input = {
  data: Array<Email_Templates_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Templates_On_Conflict>;
};

/** Boolean expression to filter rows from the table "email_templates". All fields are combined with a logical 'AND'. */
export type Email_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Templates_Bool_Exp>>;
  _not?: InputMaybe<Email_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Templates_Bool_Exp>>;
  add_signature?: InputMaybe<Boolean_Comparison_Exp>;
  bcc?: InputMaybe<Jsonb_Comparison_Exp>;
  cc?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  development?: InputMaybe<Developments_Bool_Exp>;
  development_id?: InputMaybe<Uuid_Comparison_Exp>;
  email_templates_files?: InputMaybe<Email_Templates_Files_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_shared?: InputMaybe<Boolean_Comparison_Exp>;
  is_shared_with_everyone?: InputMaybe<Boolean_Comparison_Exp>;
  is_shared_with_organisation?: InputMaybe<Boolean_Comparison_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  subject_plaintext?: InputMaybe<String_Comparison_Exp>;
  target?: InputMaybe<Email_Templates_Target_Enum_Enum_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  text_html?: InputMaybe<String_Comparison_Exp>;
  text_plaintext?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_templates" */
export enum Email_Templates_Constraint {
  /** unique or primary key constraint on columns "id" */
  EmailTemplatesPkey = 'email_templates_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Email_Templates_Delete_At_Path_Input = {
  bcc?: InputMaybe<Array<Scalars['String']['input']>>;
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Email_Templates_Delete_Elem_Input = {
  bcc?: InputMaybe<Scalars['Int']['input']>;
  cc?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Email_Templates_Delete_Key_Input = {
  bcc?: InputMaybe<Scalars['String']['input']>;
  cc?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "email_templates_files" */
export type Email_Templates_Files = {
  /** An object relationship */
  email_template: Email_Templates;
  email_template_id: Scalars['uuid']['output'];
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  nylas_file_id?: Maybe<Scalars['String']['output']>;
  tenant_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "email_templates_files" */
export type Email_Templates_Files_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Email_Templates_Files_Max_Order_By>;
  min?: InputMaybe<Email_Templates_Files_Min_Order_By>;
};

/** input type for inserting array relation for remote table "email_templates_files" */
export type Email_Templates_Files_Arr_Rel_Insert_Input = {
  data: Array<Email_Templates_Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Templates_Files_On_Conflict>;
};

/** Boolean expression to filter rows from the table "email_templates_files". All fields are combined with a logical 'AND'. */
export type Email_Templates_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Templates_Files_Bool_Exp>>;
  _not?: InputMaybe<Email_Templates_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Templates_Files_Bool_Exp>>;
  email_template?: InputMaybe<Email_Templates_Bool_Exp>;
  email_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  nylas_file_id?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_templates_files" */
export enum Email_Templates_Files_Constraint {
  /** unique or primary key constraint on columns "email_template_id", "file_id" */
  EmailTemplatesFilesPkey = 'email_templates_files_pkey'
}

/** input type for inserting data into table "email_templates_files" */
export type Email_Templates_Files_Insert_Input = {
  email_template?: InputMaybe<Email_Templates_Obj_Rel_Insert_Input>;
  email_template_id?: InputMaybe<Scalars['uuid']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  nylas_file_id?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "email_templates_files" */
export type Email_Templates_Files_Max_Order_By = {
  email_template_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  nylas_file_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "email_templates_files" */
export type Email_Templates_Files_Min_Order_By = {
  email_template_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  nylas_file_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "email_templates_files" */
export type Email_Templates_Files_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Templates_Files>;
};

/** on_conflict condition type for table "email_templates_files" */
export type Email_Templates_Files_On_Conflict = {
  constraint: Email_Templates_Files_Constraint;
  update_columns?: Array<Email_Templates_Files_Update_Column>;
  where?: InputMaybe<Email_Templates_Files_Bool_Exp>;
};

/** Ordering options when selecting data from "email_templates_files". */
export type Email_Templates_Files_Order_By = {
  email_template?: InputMaybe<Email_Templates_Order_By>;
  email_template_id?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  nylas_file_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** select columns of table "email_templates_files" */
export enum Email_Templates_Files_Select_Column {
  /** column name */
  EmailTemplateId = 'email_template_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  NylasFileId = 'nylas_file_id',
  /** column name */
  TenantId = 'tenant_id'
}

/** placeholder for update columns of table "email_templates_files" (current role has no relevant permissions) */
export enum Email_Templates_Files_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** input type for inserting data into table "email_templates" */
export type Email_Templates_Insert_Input = {
  add_signature?: InputMaybe<Scalars['Boolean']['input']>;
  bcc?: InputMaybe<Scalars['jsonb']['input']>;
  cc?: InputMaybe<Scalars['jsonb']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  email_templates_files?: InputMaybe<Email_Templates_Files_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_organisation?: InputMaybe<Scalars['Boolean']['input']>;
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subject_plaintext?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Email_Templates_Target_Enum_Enum>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_html?: InputMaybe<Scalars['String']['input']>;
  text_plaintext?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "email_templates" */
export type Email_Templates_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  subject_plaintext?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  text_html?: InputMaybe<Order_By>;
  text_plaintext?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "email_templates" */
export type Email_Templates_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  subject_plaintext?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  text_html?: InputMaybe<Order_By>;
  text_plaintext?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "email_templates" */
export type Email_Templates_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Templates>;
};

/** input type for inserting object relation for remote table "email_templates" */
export type Email_Templates_Obj_Rel_Insert_Input = {
  data: Email_Templates_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Templates_On_Conflict>;
};

/** on_conflict condition type for table "email_templates" */
export type Email_Templates_On_Conflict = {
  constraint: Email_Templates_Constraint;
  update_columns?: Array<Email_Templates_Update_Column>;
  where?: InputMaybe<Email_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "email_templates". */
export type Email_Templates_Order_By = {
  add_signature?: InputMaybe<Order_By>;
  bcc?: InputMaybe<Order_By>;
  cc?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  development?: InputMaybe<Developments_Order_By>;
  development_id?: InputMaybe<Order_By>;
  email_templates_files_aggregate?: InputMaybe<Email_Templates_Files_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_shared?: InputMaybe<Order_By>;
  is_shared_with_everyone?: InputMaybe<Order_By>;
  is_shared_with_organisation?: InputMaybe<Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  subject_plaintext?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  text_html?: InputMaybe<Order_By>;
  text_plaintext?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_templates */
export type Email_Templates_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Email_Templates_Prepend_Input = {
  bcc?: InputMaybe<Scalars['jsonb']['input']>;
  cc?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "email_templates" */
export enum Email_Templates_Select_Column {
  /** column name */
  AddSignature = 'add_signature',
  /** column name */
  Bcc = 'bcc',
  /** column name */
  Cc = 'cc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  IsSharedWithEveryone = 'is_shared_with_everyone',
  /** column name */
  IsSharedWithOrganisation = 'is_shared_with_organisation',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Name = 'name',
  /** column name */
  Subject = 'subject',
  /** column name */
  SubjectPlaintext = 'subject_plaintext',
  /** column name */
  Target = 'target',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Text = 'text',
  /** column name */
  TextHtml = 'text_html',
  /** column name */
  TextPlaintext = 'text_plaintext',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "email_templates" */
export type Email_Templates_Set_Input = {
  add_signature?: InputMaybe<Scalars['Boolean']['input']>;
  bcc?: InputMaybe<Scalars['jsonb']['input']>;
  cc?: InputMaybe<Scalars['jsonb']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_organisation?: InputMaybe<Scalars['Boolean']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subject_plaintext?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Email_Templates_Target_Enum_Enum>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_html?: InputMaybe<Scalars['String']['input']>;
  text_plaintext?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "email_templates" */
export type Email_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Templates_Stream_Cursor_Value_Input = {
  add_signature?: InputMaybe<Scalars['Boolean']['input']>;
  bcc?: InputMaybe<Scalars['jsonb']['input']>;
  cc?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_organisation?: InputMaybe<Scalars['Boolean']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subject_plaintext?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Email_Templates_Target_Enum_Enum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_html?: InputMaybe<Scalars['String']['input']>;
  text_plaintext?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export enum Email_Templates_Target_Enum_Enum {
  /** Sequence */
  Sequence = 'sequence',
  /** Standalone */
  Standalone = 'standalone'
}

/** Boolean expression to compare columns of type "email_templates_target_enum_enum". All fields are combined with logical 'AND'. */
export type Email_Templates_Target_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Email_Templates_Target_Enum_Enum>;
  _in?: InputMaybe<Array<Email_Templates_Target_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Email_Templates_Target_Enum_Enum>;
  _nin?: InputMaybe<Array<Email_Templates_Target_Enum_Enum>>;
};

/** update columns of table "email_templates" */
export enum Email_Templates_Update_Column {
  /** column name */
  AddSignature = 'add_signature',
  /** column name */
  Bcc = 'bcc',
  /** column name */
  Cc = 'cc',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  IsSharedWithEveryone = 'is_shared_with_everyone',
  /** column name */
  IsSharedWithOrganisation = 'is_shared_with_organisation',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Name = 'name',
  /** column name */
  Subject = 'subject',
  /** column name */
  SubjectPlaintext = 'subject_plaintext',
  /** column name */
  Target = 'target',
  /** column name */
  Text = 'text',
  /** column name */
  TextHtml = 'text_html',
  /** column name */
  TextPlaintext = 'text_plaintext',
  /** column name */
  Type = 'type'
}

export type Email_Templates_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Email_Templates_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Email_Templates_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Email_Templates_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Email_Templates_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Email_Templates_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Templates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Templates_Bool_Exp;
};

/** columns and relationships of "email_threads" */
export type Email_Threads = {
  /** An array relationship */
  email_messages: Array<Email_Messages>;
  /** An aggregate relationship */
  email_messages_aggregate: Email_Messages_Aggregate;
  id: Scalars['uuid']['output'];
  visibility: Scalars['String']['output'];
};


/** columns and relationships of "email_threads" */
export type Email_ThreadsEmail_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>;
  where?: InputMaybe<Email_Messages_Bool_Exp>;
};


/** columns and relationships of "email_threads" */
export type Email_ThreadsEmail_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>;
  where?: InputMaybe<Email_Messages_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "email_threads". All fields are combined with a logical 'AND'. */
export type Email_Threads_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Threads_Bool_Exp>>;
  _not?: InputMaybe<Email_Threads_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Threads_Bool_Exp>>;
  email_messages?: InputMaybe<Email_Messages_Bool_Exp>;
  email_messages_aggregate?: InputMaybe<Email_Messages_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  visibility?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "email_threads". */
export type Email_Threads_Order_By = {
  email_messages_aggregate?: InputMaybe<Email_Messages_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
};

/** columns and relationships of "emails" */
export type Emails = {
  created_at: Scalars['timestamptz']['output'];
  email: Scalars['citext']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation?: Maybe<Organisations>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  primary: Scalars['Boolean']['output'];
  /** An object relationship */
  subscription?: Maybe<Subscriptions>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  verified: Scalars['Boolean']['output'];
};


/** columns and relationships of "emails" */
export type EmailsSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "emails" */
export type EmailsSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};

/** order by aggregate values of table "emails" */
export type Emails_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Emails_Max_Order_By>;
  min?: InputMaybe<Emails_Min_Order_By>;
};

/** input type for inserting array relation for remote table "emails" */
export type Emails_Arr_Rel_Insert_Input = {
  data: Array<Emails_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Emails_On_Conflict>;
};

/** Boolean expression to filter rows from the table "emails". All fields are combined with a logical 'AND'. */
export type Emails_Bool_Exp = {
  _and?: InputMaybe<Array<Emails_Bool_Exp>>;
  _not?: InputMaybe<Emails_Bool_Exp>;
  _or?: InputMaybe<Array<Emails_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  primary?: InputMaybe<Boolean_Comparison_Exp>;
  subscription?: InputMaybe<Subscriptions_Bool_Exp>;
  subscriptions?: InputMaybe<Subscriptions_Bool_Exp>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Bool_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "emails" */
export enum Emails_Constraint {
  /** unique or primary key constraint on columns "id" */
  EmailsPkey = 'emails_pkey',
  /** unique or primary key constraint on columns "tenant_id", "owner_id", "email" */
  EmailsTenantEmailOwnerUnique = 'emails_tenant_email_owner_unique',
  /** unique or primary key constraint on columns "tenant_id", "email" */
  EmailsTenantIdOrganisationIdUnique = 'emails_tenant_id_organisation_id_unique',
  /** unique or primary key constraint on columns "tenant_id", "email" */
  EmailsTenantIdTeamIdUnique = 'emails_tenant_id_team_id_unique',
  /** unique or primary key constraint on columns "tenant_id", "email" */
  EmailsTenantIdUserIdUnique = 'emails_tenant_id_user_id_unique',
  /** unique or primary key constraint on columns "user_id", "tenant_id", "verified", "email" */
  EmailsUserIdTenantIdEmailVerifiedUnique = 'emails_user_id_tenant_id_email_verified_unique'
}

/** input type for inserting data into table "emails" */
export type Emails_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  organisation?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by max() on columns of table "emails" */
export type Emails_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "emails" */
export type Emails_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "emails" */
export type Emails_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Emails>;
};

/** on_conflict condition type for table "emails" */
export type Emails_On_Conflict = {
  constraint: Emails_Constraint;
  update_columns?: Array<Emails_Update_Column>;
  where?: InputMaybe<Emails_Bool_Exp>;
};

/** Ordering options when selecting data from "emails". */
export type Emails_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisations_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  primary?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Subscriptions_Order_By>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: emails */
export type Emails_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "emails" */
export enum Emails_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Primary = 'primary',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "emails" */
export type Emails_Set_Input = {
  email?: InputMaybe<Scalars['citext']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "emails" */
export type Emails_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Emails_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Emails_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "emails" */
export enum Emails_Update_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Primary = 'primary',
  /** column name */
  Verified = 'verified'
}

export type Emails_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Emails_Set_Input>;
  /** filter the rows which have to be updated */
  where: Emails_Bool_Exp;
};

export enum Energy_Class_Type_Enum_Enum {
  A = 'a',
  B = 'b',
  C = 'c',
  D = 'd',
  E = 'e',
  F = 'f',
  G = 'g',
  NotSet = 'not_set'
}

/** Boolean expression to compare columns of type "energy_class_type_enum_enum". All fields are combined with logical 'AND'. */
export type Energy_Class_Type_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Energy_Class_Type_Enum_Enum>;
  _in?: InputMaybe<Array<Energy_Class_Type_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Energy_Class_Type_Enum_Enum>;
  _nin?: InputMaybe<Array<Energy_Class_Type_Enum_Enum>>;
};

/** Boolean expression to compare columns of type "energy_ges_values". All fields are combined with logical 'AND'. */
export type Energy_Ges_Values_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['energy_ges_values']['input']>;
  _gt?: InputMaybe<Scalars['energy_ges_values']['input']>;
  _gte?: InputMaybe<Scalars['energy_ges_values']['input']>;
  _in?: InputMaybe<Array<Scalars['energy_ges_values']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['energy_ges_values']['input']>;
  _lte?: InputMaybe<Scalars['energy_ges_values']['input']>;
  _neq?: InputMaybe<Scalars['energy_ges_values']['input']>;
  _nin?: InputMaybe<Array<Scalars['energy_ges_values']['input']>>;
};

/** columns and relationships of "enquiries" */
export type Enquiries = {
  address?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  broker?: Maybe<Users>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  buyer_lead?: Maybe<Buyer_Leads>;
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  call_times?: Maybe<Array<Scalars['String']['output']>>;
  contact_reason?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  development_registration_form_id?: Maybe<Scalars['uuid']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  has_conflict?: Maybe<Scalars['Boolean']['output']>;
  has_invalid_input?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  language?: Maybe<Scalars['user_language']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  listing_link?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  lot?: Maybe<Lots>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  matched_email_user?: Maybe<Users>;
  /** An object relationship */
  matched_phone_user?: Maybe<Users>;
  message?: Maybe<Scalars['String']['output']>;
  /** Valid = 0, Not Valid = 1, Disposable =	2, No Accept All = 3, Unkown = 4 */
  neverbounce_result?: Maybe<Scalars['String']['output']>;
  object_ref?: Maybe<Scalars['String']['output']>;
  original_enquiry_id?: Maybe<Scalars['uuid']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  portal?: Maybe<Portals>;
  portal_id?: Maybe<Scalars['uuid']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  processed: Scalars['Boolean']['output'];
  property_search_notification?: Maybe<Scalars['property_searches_notification']['output']>;
  /** An object relationship */
  property_transaction?: Maybe<Property_Transactions>;
  property_transaction_id?: Maybe<Scalars['uuid']['output']>;
  raw_email?: Maybe<Scalars['String']['output']>;
  raw_email_address?: Maybe<Scalars['String']['output']>;
  raw_phone_number?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  response_activity?: Maybe<Activities>;
  response_activity_id?: Maybe<Scalars['uuid']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Enquiries_Source_Enum_Enum>;
  source_email_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id: Scalars['uuid']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_email_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_phone_id?: Maybe<Scalars['uuid']['output']>;
  visit_date?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "enquiries" */
export type Enquiries_Aggregate = {
  aggregate?: Maybe<Enquiries_Aggregate_Fields>;
  nodes: Array<Enquiries>;
};

export type Enquiries_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Enquiries_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Enquiries_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Enquiries_Aggregate_Bool_Exp_Count>;
};

export type Enquiries_Aggregate_Bool_Exp_Bool_And = {
  arguments: Enquiries_Select_Column_Enquiries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Enquiries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Enquiries_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Enquiries_Select_Column_Enquiries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Enquiries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Enquiries_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Enquiries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Enquiries_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "enquiries" */
export type Enquiries_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Enquiries_Max_Fields>;
  min?: Maybe<Enquiries_Min_Fields>;
};


/** aggregate fields of "enquiries" */
export type Enquiries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enquiries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "enquiries" */
export type Enquiries_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Enquiries_Max_Order_By>;
  min?: InputMaybe<Enquiries_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "enquiries". All fields are combined with a logical 'AND'. */
export type Enquiries_Bool_Exp = {
  _and?: InputMaybe<Array<Enquiries_Bool_Exp>>;
  _not?: InputMaybe<Enquiries_Bool_Exp>;
  _or?: InputMaybe<Array<Enquiries_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  broker?: InputMaybe<Users_Bool_Exp>;
  broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  buyer_lead?: InputMaybe<Buyer_Leads_Bool_Exp>;
  buyer_lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  call_times?: InputMaybe<String_Array_Comparison_Exp>;
  contact_reason?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  development_registration_form_id?: InputMaybe<Uuid_Comparison_Exp>;
  email_address?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  has_conflict?: InputMaybe<Boolean_Comparison_Exp>;
  has_invalid_input?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  language?: InputMaybe<User_Language_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  listing_link?: InputMaybe<String_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  matched_email_user?: InputMaybe<Users_Bool_Exp>;
  matched_phone_user?: InputMaybe<Users_Bool_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  neverbounce_result?: InputMaybe<String_Comparison_Exp>;
  object_ref?: InputMaybe<String_Comparison_Exp>;
  original_enquiry_id?: InputMaybe<Uuid_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<Portals_Bool_Exp>;
  portal_id?: InputMaybe<Uuid_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  processed?: InputMaybe<Boolean_Comparison_Exp>;
  property_search_notification?: InputMaybe<Property_Searches_Notification_Comparison_Exp>;
  property_transaction?: InputMaybe<Property_Transactions_Bool_Exp>;
  property_transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  raw_email?: InputMaybe<String_Comparison_Exp>;
  raw_email_address?: InputMaybe<String_Comparison_Exp>;
  raw_phone_number?: InputMaybe<String_Comparison_Exp>;
  response_activity?: InputMaybe<Activities_Bool_Exp>;
  response_activity_id?: InputMaybe<Uuid_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<Enquiries_Source_Enum_Enum_Comparison_Exp>;
  source_email_id?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_email_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_phone_id?: InputMaybe<Uuid_Comparison_Exp>;
  visit_date?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** aggregate max on columns */
export type Enquiries_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  call_times?: Maybe<Array<Scalars['String']['output']>>;
  contact_reason?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  development_registration_form_id?: Maybe<Scalars['uuid']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language?: Maybe<Scalars['user_language']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  listing_link?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** Valid = 0, Not Valid = 1, Disposable =	2, No Accept All = 3, Unkown = 4 */
  neverbounce_result?: Maybe<Scalars['String']['output']>;
  object_ref?: Maybe<Scalars['String']['output']>;
  original_enquiry_id?: Maybe<Scalars['uuid']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  portal_id?: Maybe<Scalars['uuid']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_search_notification?: Maybe<Scalars['property_searches_notification']['output']>;
  property_transaction_id?: Maybe<Scalars['uuid']['output']>;
  raw_email?: Maybe<Scalars['String']['output']>;
  raw_email_address?: Maybe<Scalars['String']['output']>;
  raw_phone_number?: Maybe<Scalars['String']['output']>;
  response_activity_id?: Maybe<Scalars['uuid']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  source_email_id?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_email_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_phone_id?: Maybe<Scalars['uuid']['output']>;
  visit_date?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "enquiries" */
export type Enquiries_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  broker_id?: InputMaybe<Order_By>;
  buyer_lead_id?: InputMaybe<Order_By>;
  call_times?: InputMaybe<Order_By>;
  contact_reason?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  development_registration_form_id?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  listing_link?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  /** Valid = 0, Not Valid = 1, Disposable =	2, No Accept All = 3, Unkown = 4 */
  neverbounce_result?: InputMaybe<Order_By>;
  object_ref?: InputMaybe<Order_By>;
  original_enquiry_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  portal_id?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_search_notification?: InputMaybe<Order_By>;
  property_transaction_id?: InputMaybe<Order_By>;
  raw_email?: InputMaybe<Order_By>;
  raw_email_address?: InputMaybe<Order_By>;
  raw_phone_number?: InputMaybe<Order_By>;
  response_activity_id?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  source_email_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_email_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_phone_id?: InputMaybe<Order_By>;
  visit_date?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Enquiries_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  call_times?: Maybe<Array<Scalars['String']['output']>>;
  contact_reason?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  development_registration_form_id?: Maybe<Scalars['uuid']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language?: Maybe<Scalars['user_language']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  listing_link?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** Valid = 0, Not Valid = 1, Disposable =	2, No Accept All = 3, Unkown = 4 */
  neverbounce_result?: Maybe<Scalars['String']['output']>;
  object_ref?: Maybe<Scalars['String']['output']>;
  original_enquiry_id?: Maybe<Scalars['uuid']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  portal_id?: Maybe<Scalars['uuid']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_search_notification?: Maybe<Scalars['property_searches_notification']['output']>;
  property_transaction_id?: Maybe<Scalars['uuid']['output']>;
  raw_email?: Maybe<Scalars['String']['output']>;
  raw_email_address?: Maybe<Scalars['String']['output']>;
  raw_phone_number?: Maybe<Scalars['String']['output']>;
  response_activity_id?: Maybe<Scalars['uuid']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  source_email_id?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_email_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_phone_id?: Maybe<Scalars['uuid']['output']>;
  visit_date?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "enquiries" */
export type Enquiries_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  broker_id?: InputMaybe<Order_By>;
  buyer_lead_id?: InputMaybe<Order_By>;
  call_times?: InputMaybe<Order_By>;
  contact_reason?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  development_registration_form_id?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  listing_link?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  /** Valid = 0, Not Valid = 1, Disposable =	2, No Accept All = 3, Unkown = 4 */
  neverbounce_result?: InputMaybe<Order_By>;
  object_ref?: InputMaybe<Order_By>;
  original_enquiry_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  portal_id?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_search_notification?: InputMaybe<Order_By>;
  property_transaction_id?: InputMaybe<Order_By>;
  raw_email?: InputMaybe<Order_By>;
  raw_email_address?: InputMaybe<Order_By>;
  raw_phone_number?: InputMaybe<Order_By>;
  response_activity_id?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  source_email_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_email_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_phone_id?: InputMaybe<Order_By>;
  visit_date?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "enquiries" */
export type Enquiries_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enquiries>;
};

/** Ordering options when selecting data from "enquiries". */
export type Enquiries_Order_By = {
  address?: InputMaybe<Order_By>;
  broker?: InputMaybe<Users_Order_By>;
  broker_id?: InputMaybe<Order_By>;
  buyer_lead?: InputMaybe<Buyer_Leads_Order_By>;
  buyer_lead_id?: InputMaybe<Order_By>;
  call_times?: InputMaybe<Order_By>;
  contact_reason?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  development_registration_form_id?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  has_conflict?: InputMaybe<Order_By>;
  has_invalid_input?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  listing_link?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  matched_email_user?: InputMaybe<Users_Order_By>;
  matched_phone_user?: InputMaybe<Users_Order_By>;
  message?: InputMaybe<Order_By>;
  neverbounce_result?: InputMaybe<Order_By>;
  object_ref?: InputMaybe<Order_By>;
  original_enquiry_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  portal?: InputMaybe<Portals_Order_By>;
  portal_id?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  processed?: InputMaybe<Order_By>;
  property_search_notification?: InputMaybe<Order_By>;
  property_transaction?: InputMaybe<Property_Transactions_Order_By>;
  property_transaction_id?: InputMaybe<Order_By>;
  raw_email?: InputMaybe<Order_By>;
  raw_email_address?: InputMaybe<Order_By>;
  raw_phone_number?: InputMaybe<Order_By>;
  response_activity?: InputMaybe<Activities_Order_By>;
  response_activity_id?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  source_email_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_email_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_phone_id?: InputMaybe<Order_By>;
  visit_date?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enquiries */
export type Enquiries_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "enquiries" */
export enum Enquiries_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  CallTimes = 'call_times',
  /** column name */
  ContactReason = 'contact_reason',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevelopmentRegistrationFormId = 'development_registration_form_id',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  HasConflict = 'has_conflict',
  /** column name */
  HasInvalidInput = 'has_invalid_input',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  LastName = 'last_name',
  /** column name */
  ListingLink = 'listing_link',
  /** column name */
  Locality = 'locality',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Message = 'message',
  /** column name */
  NeverbounceResult = 'neverbounce_result',
  /** column name */
  ObjectRef = 'object_ref',
  /** column name */
  OriginalEnquiryId = 'original_enquiry_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PortalId = 'portal_id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  Processed = 'processed',
  /** column name */
  PropertySearchNotification = 'property_search_notification',
  /** column name */
  PropertyTransactionId = 'property_transaction_id',
  /** column name */
  RawEmail = 'raw_email',
  /** column name */
  RawEmailAddress = 'raw_email_address',
  /** column name */
  RawPhoneNumber = 'raw_phone_number',
  /** column name */
  ResponseActivityId = 'response_activity_id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Source = 'source',
  /** column name */
  SourceEmailId = 'source_email_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserEmailId = 'user_email_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserPhoneId = 'user_phone_id',
  /** column name */
  VisitDate = 'visit_date'
}

/** select "enquiries_aggregate_bool_exp_bool_and_arguments_columns" columns of table "enquiries" */
export enum Enquiries_Select_Column_Enquiries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasConflict = 'has_conflict',
  /** column name */
  HasInvalidInput = 'has_invalid_input',
  /** column name */
  Processed = 'processed'
}

/** select "enquiries_aggregate_bool_exp_bool_or_arguments_columns" columns of table "enquiries" */
export enum Enquiries_Select_Column_Enquiries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasConflict = 'has_conflict',
  /** column name */
  HasInvalidInput = 'has_invalid_input',
  /** column name */
  Processed = 'processed'
}

/** input type for updating data in table "enquiries" */
export type Enquiries_Set_Input = {
  buyer_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export enum Enquiries_Source_Enum_Enum {
  /** Received from agent/agency contact form */
  AgencyPages = 'agency_pages',
  /** Received from our mobile application */
  MobileApp = 'mobile_app',
  /** Parsed from portal email */
  Portal = 'portal',
  /** Received from price pages transaction modal contact form */
  PricePages = 'price_pages',
  /** Unknown */
  Unknown = 'unknown'
}

/** Boolean expression to compare columns of type "enquiries_source_enum_enum". All fields are combined with logical 'AND'. */
export type Enquiries_Source_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enquiries_Source_Enum_Enum>;
  _in?: InputMaybe<Array<Enquiries_Source_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Enquiries_Source_Enum_Enum>;
  _nin?: InputMaybe<Array<Enquiries_Source_Enum_Enum>>;
};

/** Streaming cursor of the table "enquiries" */
export type Enquiries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enquiries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enquiries_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  call_times?: InputMaybe<Array<Scalars['String']['input']>>;
  contact_reason?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  development_registration_form_id?: InputMaybe<Scalars['uuid']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  has_conflict?: InputMaybe<Scalars['Boolean']['input']>;
  has_invalid_input?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  listing_link?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** Valid = 0, Not Valid = 1, Disposable =	2, No Accept All = 3, Unkown = 4 */
  neverbounce_result?: InputMaybe<Scalars['String']['input']>;
  object_ref?: InputMaybe<Scalars['String']['input']>;
  original_enquiry_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  portal_id?: InputMaybe<Scalars['uuid']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
  property_search_notification?: InputMaybe<Scalars['property_searches_notification']['input']>;
  property_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  raw_email?: InputMaybe<Scalars['String']['input']>;
  raw_email_address?: InputMaybe<Scalars['String']['input']>;
  raw_phone_number?: InputMaybe<Scalars['String']['input']>;
  response_activity_id?: InputMaybe<Scalars['uuid']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Enquiries_Source_Enum_Enum>;
  source_email_id?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_email_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_phone_id?: InputMaybe<Scalars['uuid']['input']>;
  visit_date?: InputMaybe<Scalars['timestamp']['input']>;
};

export type Enquiries_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enquiries_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enquiries_Bool_Exp;
};

/** columns and relationships of "cma_listings" */
export type Es_Cma_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Es_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Es_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "listing_is_online" */
  is_online?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  /** Gets all places associated with this listing */
  places?: Maybe<Array<Es_Places>>;
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  /** An object relationship */
  property_types?: Maybe<Es_Property_Types>;
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id: Scalars['uuid']['output'];
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "cma_listings" */
export type Es_Cma_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_listings" */
export type Es_Cma_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_listings" */
export type Es_Cma_ListingsPlacesArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** columns and relationships of "cma_listings" */
export type Es_Cma_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cma_listings" */
export type Es_Cma_Listings_Aggregate = {
  aggregate?: Maybe<Es_Cma_Listings_Aggregate_Fields>;
  nodes: Array<Es_Cma_Listings>;
};

/** aggregate fields of "cma_listings" */
export type Es_Cma_Listings_Aggregate_Fields = {
  avg?: Maybe<Es_Cma_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_Cma_Listings_Max_Fields>;
  min?: Maybe<Es_Cma_Listings_Min_Fields>;
  stddev?: Maybe<Es_Cma_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Es_Cma_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_Cma_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Es_Cma_Listings_Sum_Fields>;
  var_pop?: Maybe<Es_Cma_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Es_Cma_Listings_Var_Samp_Fields>;
  variance?: Maybe<Es_Cma_Listings_Variance_Fields>;
};


/** aggregate fields of "cma_listings" */
export type Es_Cma_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_Cma_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Es_Cma_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_listings". All fields are combined with a logical 'AND'. */
export type Es_Cma_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Cma_Listings_Bool_Exp>>;
  _not?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Cma_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  available_from?: InputMaybe<Date_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Es_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_online?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  places?: InputMaybe<Es_Places_Bool_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  property_types?: InputMaybe<Es_Property_Types_Bool_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Es_Cma_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Es_Cma_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "cma_listings". */
export type Es_Cma_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  available_from?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Es_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_online?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Es_Places_Aggregate_Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  property_types?: InputMaybe<Es_Property_Types_Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "cma_listings" */
export enum Es_Cma_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Es_Cma_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Es_Cma_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Es_Cma_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Es_Cma_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Es_Cma_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Es_Cma_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Es_Cma_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "get_merged_listings_type" */
export type Es_Get_Merged_Listings_Type = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Scalars['json']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  removed?: Maybe<Scalars['Boolean']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "get_merged_listings_type" */
export type Es_Get_Merged_Listings_TypeImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "get_merged_listings_type". All fields are combined with a logical 'AND'. */
export type Es_Get_Merged_Listings_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Bool_Exp>>;
  _not?: InputMaybe<Es_Get_Merged_Listings_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Json_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
};

/** Ordering options when selecting data from "get_merged_listings_type". */
export type Es_Get_Merged_Listings_Type_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
};

/** select columns of table "get_merged_listings_type" */
export enum Es_Get_Merged_Listings_Type_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UsableSurface = 'usable_surface'
}

/** columns and relationships of "merged_images" */
export type Es_Merged_Images = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "merged_images" */
export type Es_Merged_Images_Aggregate = {
  aggregate?: Maybe<Es_Merged_Images_Aggregate_Fields>;
  nodes: Array<Es_Merged_Images>;
};

/** aggregate fields of "merged_images" */
export type Es_Merged_Images_Aggregate_Fields = {
  avg?: Maybe<Es_Merged_Images_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_Merged_Images_Max_Fields>;
  min?: Maybe<Es_Merged_Images_Min_Fields>;
  stddev?: Maybe<Es_Merged_Images_Stddev_Fields>;
  stddev_pop?: Maybe<Es_Merged_Images_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_Merged_Images_Stddev_Samp_Fields>;
  sum?: Maybe<Es_Merged_Images_Sum_Fields>;
  var_pop?: Maybe<Es_Merged_Images_Var_Pop_Fields>;
  var_samp?: Maybe<Es_Merged_Images_Var_Samp_Fields>;
  variance?: Maybe<Es_Merged_Images_Variance_Fields>;
};


/** aggregate fields of "merged_images" */
export type Es_Merged_Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "merged_images" */
export type Es_Merged_Images_Aggregate_Order_By = {
  avg?: InputMaybe<Es_Merged_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Es_Merged_Images_Max_Order_By>;
  min?: InputMaybe<Es_Merged_Images_Min_Order_By>;
  stddev?: InputMaybe<Es_Merged_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Es_Merged_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Es_Merged_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Es_Merged_Images_Sum_Order_By>;
  var_pop?: InputMaybe<Es_Merged_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Es_Merged_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Es_Merged_Images_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Es_Merged_Images_Avg_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "merged_images" */
export type Es_Merged_Images_Avg_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "merged_images". All fields are combined with a logical 'AND'. */
export type Es_Merged_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Merged_Images_Bool_Exp>>;
  _not?: InputMaybe<Es_Merged_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Merged_Images_Bool_Exp>>;
  bucket_name?: InputMaybe<String_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_index?: InputMaybe<Int_Comparison_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Es_Merged_Images_Max_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "merged_images" */
export type Es_Merged_Images_Max_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Es_Merged_Images_Min_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "merged_images" */
export type Es_Merged_Images_Min_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "merged_images". */
export type Es_Merged_Images_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** select columns of table "merged_images" */
export enum Es_Merged_Images_Select_Column {
  /** column name */
  BucketName = 'bucket_name',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImageIndex = 'image_index',
  /** column name */
  ListingId = 'listing_id'
}

/** aggregate stddev on columns */
export type Es_Merged_Images_Stddev_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "merged_images" */
export type Es_Merged_Images_Stddev_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Es_Merged_Images_Stddev_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "merged_images" */
export type Es_Merged_Images_Stddev_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Es_Merged_Images_Stddev_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "merged_images" */
export type Es_Merged_Images_Stddev_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Es_Merged_Images_Sum_Fields = {
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "merged_images" */
export type Es_Merged_Images_Sum_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Es_Merged_Images_Var_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "merged_images" */
export type Es_Merged_Images_Var_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Es_Merged_Images_Var_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "merged_images" */
export type Es_Merged_Images_Var_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Es_Merged_Images_Variance_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "merged_images" */
export type Es_Merged_Images_Variance_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "merged_listings" */
export type Es_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Es_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Es_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Es_Property_Main_Type_Enum;
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "merged_listings" */
export type Es_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "merged_listings" */
export type Es_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "merged_listings" */
export type Es_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "merged_listings" */
export type Es_Merged_Listings_Aggregate = {
  aggregate?: Maybe<Es_Merged_Listings_Aggregate_Fields>;
  nodes: Array<Es_Merged_Listings>;
};

/** aggregate fields of "merged_listings" */
export type Es_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<Es_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_Merged_Listings_Max_Fields>;
  min?: Maybe<Es_Merged_Listings_Min_Fields>;
  stddev?: Maybe<Es_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Es_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Es_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<Es_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Es_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<Es_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "merged_listings" */
export type Es_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Es_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "merged_listings". All fields are combined with a logical 'AND'. */
export type Es_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<Es_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Es_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<Es_Property_Main_Type_Enum_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Es_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Es_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "merged_listings". */
export type Es_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Es_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "merged_listings" */
export enum Es_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Es_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Es_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Es_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Es_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Es_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Es_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Es_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "places" */
export type Es_Places = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  breadcrumbs: Array<Es_Places_Breadcrumbs>;
  /** An aggregate relationship */
  breadcrumbs_aggregate: Es_Places_Breadcrumbs_Aggregate;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  canonical_place?: Maybe<Es_Places>;
  children_bbox?: Maybe<Scalars['jsonb']['output']>;
  /** A computed field, executes function "count_children_place" */
  children_count?: Maybe<Scalars['Int']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  extra: Scalars['jsonb']['output'];
  geom: Scalars['geometry']['output'];
  id: Scalars['uuid']['output'];
  index: Scalars['Boolean']['output'];
  /** to use instead of label_en label_de etc, x-hasura-website-language must be set */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  municipality?: Maybe<Es_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  municipality_places: Array<Es_Places>;
  /** An aggregate relationship */
  municipality_places_aggregate: Es_Places_Aggregate;
  name: Scalars['String']['output'];
  /** An array relationship */
  neighbourhood: Array<Es_Places>;
  /** An aggregate relationship */
  neighbourhood_aggregate: Es_Places_Aggregate;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  region: Array<Es_Places>;
  /** An aggregate relationship */
  region_aggregate: Es_Places_Aggregate;
  region_id?: Maybe<Scalars['uuid']['output']>;
  search_base: Scalars['tsvector']['output'];
  /** to use instead of slug_en slug_de etc, x-hasura-website-language must be set */
  slug?: Maybe<Scalars['String']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  state: Array<Es_Places>;
  /** An aggregate relationship */
  state_aggregate: Es_Places_Aggregate;
  state_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  state_places: Array<Es_Places>;
  /** An aggregate relationship */
  state_places_aggregate: Es_Places_Aggregate;
  type: Scalars['String']['output'];
};


/** columns and relationships of "places" */
export type Es_PlacesBreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Es_Places_Breadcrumbs_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Es_PlacesBreadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Es_Places_Breadcrumbs_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Es_PlacesChildren_BboxArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "places" */
export type Es_PlacesExtraArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "places" */
export type Es_PlacesMunicipality_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Es_PlacesMunicipality_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Es_PlacesNeighbourhoodArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Es_PlacesNeighbourhood_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Es_PlacesRegionArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Es_PlacesRegion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Es_PlacesStateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Es_PlacesState_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Es_PlacesState_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Es_PlacesState_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};

/** aggregated selection of "places" */
export type Es_Places_Aggregate = {
  aggregate?: Maybe<Es_Places_Aggregate_Fields>;
  nodes: Array<Es_Places>;
};

/** aggregate fields of "places" */
export type Es_Places_Aggregate_Fields = {
  avg?: Maybe<Es_Places_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_Places_Max_Fields>;
  min?: Maybe<Es_Places_Min_Fields>;
  stddev?: Maybe<Es_Places_Stddev_Fields>;
  stddev_pop?: Maybe<Es_Places_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_Places_Stddev_Samp_Fields>;
  sum?: Maybe<Es_Places_Sum_Fields>;
  var_pop?: Maybe<Es_Places_Var_Pop_Fields>;
  var_samp?: Maybe<Es_Places_Var_Samp_Fields>;
  variance?: Maybe<Es_Places_Variance_Fields>;
};


/** aggregate fields of "places" */
export type Es_Places_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_Places_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places" */
export type Es_Places_Aggregate_Order_By = {
  avg?: InputMaybe<Es_Places_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Es_Places_Max_Order_By>;
  min?: InputMaybe<Es_Places_Min_Order_By>;
  stddev?: InputMaybe<Es_Places_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Es_Places_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Es_Places_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Es_Places_Sum_Order_By>;
  var_pop?: InputMaybe<Es_Places_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Es_Places_Var_Samp_Order_By>;
  variance?: InputMaybe<Es_Places_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Es_Places_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places" */
export type Es_Places_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places". All fields are combined with a logical 'AND'. */
export type Es_Places_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Places_Bool_Exp>>;
  _not?: InputMaybe<Es_Places_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Places_Bool_Exp>>;
  agglomeration_id?: InputMaybe<Uuid_Comparison_Exp>;
  breadcrumbs?: InputMaybe<Es_Places_Breadcrumbs_Bool_Exp>;
  canonical_id?: InputMaybe<Uuid_Comparison_Exp>;
  canonical_place?: InputMaybe<Es_Places_Bool_Exp>;
  children_bbox?: InputMaybe<Jsonb_Comparison_Exp>;
  children_count?: InputMaybe<Int_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  extra?: InputMaybe<Jsonb_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  index?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality?: InputMaybe<Es_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality_places?: InputMaybe<Es_Places_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  neighbourhood?: InputMaybe<Es_Places_Bool_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  population?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<Es_Places_Bool_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  search_base?: InputMaybe<Tsvector_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  slug_de?: InputMaybe<String_Comparison_Exp>;
  slug_en?: InputMaybe<String_Comparison_Exp>;
  slug_es?: InputMaybe<String_Comparison_Exp>;
  slug_fr?: InputMaybe<String_Comparison_Exp>;
  slug_it?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<Es_Places_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  state_places?: InputMaybe<Es_Places_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "places_breadcrumbs" */
export type Es_Places_Breadcrumbs = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  place?: Maybe<Es_Places>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Aggregate = {
  aggregate?: Maybe<Es_Places_Breadcrumbs_Aggregate_Fields>;
  nodes: Array<Es_Places_Breadcrumbs>;
};

/** aggregate fields of "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Aggregate_Fields = {
  avg?: Maybe<Es_Places_Breadcrumbs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_Places_Breadcrumbs_Max_Fields>;
  min?: Maybe<Es_Places_Breadcrumbs_Min_Fields>;
  stddev?: Maybe<Es_Places_Breadcrumbs_Stddev_Fields>;
  stddev_pop?: Maybe<Es_Places_Breadcrumbs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_Places_Breadcrumbs_Stddev_Samp_Fields>;
  sum?: Maybe<Es_Places_Breadcrumbs_Sum_Fields>;
  var_pop?: Maybe<Es_Places_Breadcrumbs_Var_Pop_Fields>;
  var_samp?: Maybe<Es_Places_Breadcrumbs_Var_Samp_Fields>;
  variance?: Maybe<Es_Places_Breadcrumbs_Variance_Fields>;
};


/** aggregate fields of "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_Places_Breadcrumbs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Aggregate_Order_By = {
  avg?: InputMaybe<Es_Places_Breadcrumbs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Es_Places_Breadcrumbs_Max_Order_By>;
  min?: InputMaybe<Es_Places_Breadcrumbs_Min_Order_By>;
  stddev?: InputMaybe<Es_Places_Breadcrumbs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Es_Places_Breadcrumbs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Es_Places_Breadcrumbs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Es_Places_Breadcrumbs_Sum_Order_By>;
  var_pop?: InputMaybe<Es_Places_Breadcrumbs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Es_Places_Breadcrumbs_Var_Samp_Order_By>;
  variance?: InputMaybe<Es_Places_Breadcrumbs_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Es_Places_Breadcrumbs_Avg_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Avg_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places_breadcrumbs". All fields are combined with a logical 'AND'. */
export type Es_Places_Breadcrumbs_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Places_Breadcrumbs_Bool_Exp>>;
  _not?: InputMaybe<Es_Places_Breadcrumbs_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Places_Breadcrumbs_Bool_Exp>>;
  breadcrumb_place_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_num?: InputMaybe<Bigint_Comparison_Exp>;
  place?: InputMaybe<Es_Places_Bool_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Es_Places_Breadcrumbs_Max_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Max_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Es_Places_Breadcrumbs_Min_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Min_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places_breadcrumbs". */
export type Es_Places_Breadcrumbs_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place?: InputMaybe<Es_Places_Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** select columns of table "places_breadcrumbs" */
export enum Es_Places_Breadcrumbs_Select_Column {
  /** column name */
  BreadcrumbPlaceId = 'breadcrumb_place_id',
  /** column name */
  OrderNum = 'order_num',
  /** column name */
  PlaceId = 'place_id'
}

/** aggregate stddev on columns */
export type Es_Places_Breadcrumbs_Stddev_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Stddev_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Es_Places_Breadcrumbs_Stddev_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Stddev_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Es_Places_Breadcrumbs_Stddev_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Stddev_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Es_Places_Breadcrumbs_Sum_Fields = {
  order_num?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Sum_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Es_Places_Breadcrumbs_Var_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Var_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Es_Places_Breadcrumbs_Var_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Var_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Es_Places_Breadcrumbs_Variance_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Variance_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Es_Places_Max_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "places" */
export type Es_Places_Max_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Es_Places_Min_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "places" */
export type Es_Places_Min_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places". */
export type Es_Places_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  breadcrumbs_aggregate?: InputMaybe<Es_Places_Breadcrumbs_Aggregate_Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  canonical_place?: InputMaybe<Es_Places_Order_By>;
  children_bbox?: InputMaybe<Order_By>;
  children_count?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Es_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  municipality_places_aggregate?: InputMaybe<Es_Places_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_aggregate?: InputMaybe<Es_Places_Aggregate_Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_aggregate?: InputMaybe<Es_Places_Aggregate_Order_By>;
  region_id?: InputMaybe<Order_By>;
  search_base?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  state_aggregate?: InputMaybe<Es_Places_Aggregate_Order_By>;
  state_id?: InputMaybe<Order_By>;
  state_places_aggregate?: InputMaybe<Es_Places_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "places" */
export enum Es_Places_Select_Column {
  /** column name */
  AgglomerationId = 'agglomeration_id',
  /** column name */
  CanonicalId = 'canonical_id',
  /** column name */
  ChildrenBbox = 'children_bbox',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  Population = 'population',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SearchBase = 'search_base',
  /** column name */
  SlugDe = 'slug_de',
  /** column name */
  SlugEn = 'slug_en',
  /** column name */
  SlugEs = 'slug_es',
  /** column name */
  SlugFr = 'slug_fr',
  /** column name */
  SlugIt = 'slug_it',
  /** column name */
  StateId = 'state_id',
  /** column name */
  Type = 'type'
}

/** aggregate stddev on columns */
export type Es_Places_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places" */
export type Es_Places_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Es_Places_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places" */
export type Es_Places_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Es_Places_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places" */
export type Es_Places_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Es_Places_Sum_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "places" */
export type Es_Places_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Es_Places_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places" */
export type Es_Places_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Es_Places_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places" */
export type Es_Places_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Es_Places_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places" */
export type Es_Places_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** columns and relationships of "post_merged_listings" */
export type Es_Post_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** A computed field, executes function "get_least_created_at" */
  created_at_consolidated?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Es_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Es_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_listing_images" */
  listing_images?: Maybe<Array<Es_Merged_Images>>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_object?: Maybe<Es_Places>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  municipality?: Maybe<Es_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "post_merged_listings" */
export type Es_Post_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "post_merged_listings" */
export type Es_Post_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "post_merged_listings" */
export type Es_Post_Merged_ListingsListing_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "post_merged_listings" */
export type Es_Post_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Es_Post_Merged_Listings_Aggregate = {
  aggregate?: Maybe<Es_Post_Merged_Listings_Aggregate_Fields>;
  nodes: Array<Es_Post_Merged_Listings>;
};

/** aggregate fields of "post_merged_listings" */
export type Es_Post_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<Es_Post_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_Post_Merged_Listings_Max_Fields>;
  min?: Maybe<Es_Post_Merged_Listings_Min_Fields>;
  stddev?: Maybe<Es_Post_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Es_Post_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_Post_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Es_Post_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<Es_Post_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Es_Post_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<Es_Post_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "post_merged_listings" */
export type Es_Post_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_Post_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Es_Post_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "post_merged_listings". All fields are combined with a logical 'AND'. */
export type Es_Post_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Post_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<Es_Post_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Post_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at_consolidated?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Es_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_images?: InputMaybe<Es_Merged_Images_Bool_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_object?: InputMaybe<Es_Places_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality?: InputMaybe<Es_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Es_Post_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Es_Post_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "post_merged_listings". */
export type Es_Post_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_at_consolidated?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Es_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_images_aggregate?: InputMaybe<Es_Merged_Images_Aggregate_Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_object?: InputMaybe<Es_Places_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Es_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "post_merged_listings" */
export enum Es_Post_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Es_Post_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Es_Post_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Es_Post_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Es_Post_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Es_Post_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Es_Post_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Es_Post_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

export enum Es_Property_Main_Type_Enum {
  Agri = 'AGRI',
  Appt = 'APPT',
  Building = 'BUILDING',
  Commercial = 'COMMERCIAL',
  Garden = 'GARDEN',
  Gastro = 'GASTRO',
  House = 'HOUSE',
  HouseAppt = 'HOUSE_APPT',
  Indus = 'INDUS',
  Other = 'OTHER',
  Park = 'PARK',
  Prop = 'PROP',
  Room = 'ROOM',
  Secondary = 'SECONDARY'
}

/** Boolean expression to compare columns of type "es_property_main_type_enum". All fields are combined with logical 'AND'. */
export type Es_Property_Main_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Es_Property_Main_Type_Enum>;
  _in?: InputMaybe<Array<Es_Property_Main_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Es_Property_Main_Type_Enum>;
  _nin?: InputMaybe<Array<Es_Property_Main_Type_Enum>>;
};

/** columns and relationships of "property_types" */
export type Es_Property_Types = {
  /** A computed field, executes function "property_types_label" */
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "property_types". All fields are combined with a logical 'AND'. */
export type Es_Property_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Property_Types_Bool_Exp>>;
  _not?: InputMaybe<Es_Property_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Property_Types_Bool_Exp>>;
  label?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "property_types". */
export type Es_Property_Types_Order_By = {
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "property_types" */
export enum Es_Property_Types_Select_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "files" */
export type Files = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  document_type?: Maybe<Dictionaries>;
  document_type_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  mimetype?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Size in bytes */
  size: Scalars['Int']['output'];
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  uploader?: Maybe<Users>;
  uploader_id?: Maybe<Scalars['uuid']['output']>;
  url: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp = {
  _and?: InputMaybe<Array<Files_Bool_Exp>>;
  _not?: InputMaybe<Files_Bool_Exp>;
  _or?: InputMaybe<Array<Files_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_type?: InputMaybe<Dictionaries_Bool_Exp>;
  document_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mimetype?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploader?: InputMaybe<Users_Bool_Exp>;
  uploader_id?: InputMaybe<Uuid_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "files" */
export enum Files_Constraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  FilesIdTenantIdUnique = 'files_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  FilesPkey = 'files_pkey'
}

/** input type for inserting data into table "files" */
export type Files_Insert_Input = {
  document_type?: InputMaybe<Dictionaries_Obj_Rel_Insert_Input>;
  document_type_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mimetype?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Size in bytes */
  size?: InputMaybe<Scalars['Int']['input']>;
  uploader?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "files" */
export type Files_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Files>;
};

/** input type for inserting object relation for remote table "files" */
export type Files_Obj_Rel_Insert_Input = {
  data: Files_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** on_conflict condition type for table "files" */
export type Files_On_Conflict = {
  constraint: Files_Constraint;
  update_columns?: Array<Files_Update_Column>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** Ordering options when selecting data from "files". */
export type Files_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Dictionaries_Order_By>;
  document_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimetype?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploader?: InputMaybe<Users_Order_By>;
  uploader_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: files */
export type Files_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "files" */
export enum Files_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentTypeId = 'document_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Mimetype = 'mimetype',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploaderId = 'uploader_id',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "files" */
export type Files_Set_Input = {
  document_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "files" */
export type Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Files_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_type_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mimetype?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Size in bytes */
  size?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uploader_id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "files" */
export enum Files_Update_Column {
  /** column name */
  DocumentTypeId = 'document_type_id'
}

export type Files_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Files_Bool_Exp;
};

export type Financing_Statistics_Args = {
  filters?: InputMaybe<Scalars['json']['input']>;
};

/** Financing statistics */
export type Financing_Stats = {
  assigned_leads: Scalars['Int']['output'];
  call_attempts: Scalars['Int']['output'];
  call_attempts_missed: Scalars['Int']['output'];
  call_attempts_successful: Scalars['Int']['output'];
  claimed_leads: Scalars['Int']['output'];
  date: Scalars['date']['output'];
  financing_chatbot: Scalars['Int']['output'];
  financing_manually: Scalars['Int']['output'];
  lost: Scalars['Int']['output'];
  new_mortgage: Scalars['Int']['output'];
  re_mortgage: Scalars['Int']['output'];
  total_leads: Scalars['Int']['output'];
  won: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "financing_stats". All fields are combined with a logical 'AND'. */
export type Financing_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Financing_Stats_Bool_Exp>>;
  _not?: InputMaybe<Financing_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Financing_Stats_Bool_Exp>>;
  assigned_leads?: InputMaybe<Int_Comparison_Exp>;
  call_attempts?: InputMaybe<Int_Comparison_Exp>;
  call_attempts_missed?: InputMaybe<Int_Comparison_Exp>;
  call_attempts_successful?: InputMaybe<Int_Comparison_Exp>;
  claimed_leads?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  financing_chatbot?: InputMaybe<Int_Comparison_Exp>;
  financing_manually?: InputMaybe<Int_Comparison_Exp>;
  lost?: InputMaybe<Int_Comparison_Exp>;
  new_mortgage?: InputMaybe<Int_Comparison_Exp>;
  re_mortgage?: InputMaybe<Int_Comparison_Exp>;
  total_leads?: InputMaybe<Int_Comparison_Exp>;
  won?: InputMaybe<Int_Comparison_Exp>;
};

/** Ordering options when selecting data from "financing_stats". */
export type Financing_Stats_Order_By = {
  assigned_leads?: InputMaybe<Order_By>;
  call_attempts?: InputMaybe<Order_By>;
  call_attempts_missed?: InputMaybe<Order_By>;
  call_attempts_successful?: InputMaybe<Order_By>;
  claimed_leads?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  financing_chatbot?: InputMaybe<Order_By>;
  financing_manually?: InputMaybe<Order_By>;
  lost?: InputMaybe<Order_By>;
  new_mortgage?: InputMaybe<Order_By>;
  re_mortgage?: InputMaybe<Order_By>;
  total_leads?: InputMaybe<Order_By>;
  won?: InputMaybe<Order_By>;
};

/** select columns of table "financing_stats" */
export enum Financing_Stats_Select_Column {
  /** column name */
  AssignedLeads = 'assigned_leads',
  /** column name */
  CallAttempts = 'call_attempts',
  /** column name */
  CallAttemptsMissed = 'call_attempts_missed',
  /** column name */
  CallAttemptsSuccessful = 'call_attempts_successful',
  /** column name */
  ClaimedLeads = 'claimed_leads',
  /** column name */
  Date = 'date',
  /** column name */
  FinancingChatbot = 'financing_chatbot',
  /** column name */
  FinancingManually = 'financing_manually',
  /** column name */
  Lost = 'lost',
  /** column name */
  NewMortgage = 'new_mortgage',
  /** column name */
  ReMortgage = 're_mortgage',
  /** column name */
  TotalLeads = 'total_leads',
  /** column name */
  Won = 'won'
}

/** Streaming cursor of the table "financing_stats" */
export type Financing_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financing_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Financing_Stats_Stream_Cursor_Value_Input = {
  assigned_leads?: InputMaybe<Scalars['Int']['input']>;
  call_attempts?: InputMaybe<Scalars['Int']['input']>;
  call_attempts_missed?: InputMaybe<Scalars['Int']['input']>;
  call_attempts_successful?: InputMaybe<Scalars['Int']['input']>;
  claimed_leads?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  financing_chatbot?: InputMaybe<Scalars['Int']['input']>;
  financing_manually?: InputMaybe<Scalars['Int']['input']>;
  lost?: InputMaybe<Scalars['Int']['input']>;
  new_mortgage?: InputMaybe<Scalars['Int']['input']>;
  re_mortgage?: InputMaybe<Scalars['Int']['input']>;
  total_leads?: InputMaybe<Scalars['Int']['input']>;
  won?: InputMaybe<Scalars['Int']['input']>;
};

export type Find_Price_Map_Places_Args = {
  p_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['float8']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['float8']['input']>>;
  _eq?: InputMaybe<Array<Scalars['float8']['input']>>;
  _gt?: InputMaybe<Array<Scalars['float8']['input']>>;
  _gte?: InputMaybe<Array<Scalars['float8']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['float8']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['float8']['input']>>;
  _lte?: InputMaybe<Array<Scalars['float8']['input']>>;
  _neq?: InputMaybe<Array<Scalars['float8']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['float8']['input']>>>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "cma_listings" */
export type Fr_Cma_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Fr_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Fr_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "listing_is_online" */
  is_online?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  /** A computed field, executes function "cma_listings_places" */
  places?: Maybe<Array<Fr_Places>>;
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  /** An object relationship */
  property_types?: Maybe<Fr_Property_Types>;
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id: Scalars['uuid']['output'];
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "cma_listings" */
export type Fr_Cma_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_listings" */
export type Fr_Cma_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_listings" */
export type Fr_Cma_ListingsPlacesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** columns and relationships of "cma_listings" */
export type Fr_Cma_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cma_listings" */
export type Fr_Cma_Listings_Aggregate = {
  aggregate?: Maybe<Fr_Cma_Listings_Aggregate_Fields>;
  nodes: Array<Fr_Cma_Listings>;
};

/** aggregate fields of "cma_listings" */
export type Fr_Cma_Listings_Aggregate_Fields = {
  avg?: Maybe<Fr_Cma_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_Cma_Listings_Max_Fields>;
  min?: Maybe<Fr_Cma_Listings_Min_Fields>;
  stddev?: Maybe<Fr_Cma_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_Cma_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_Cma_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_Cma_Listings_Sum_Fields>;
  var_pop?: Maybe<Fr_Cma_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_Cma_Listings_Var_Samp_Fields>;
  variance?: Maybe<Fr_Cma_Listings_Variance_Fields>;
};


/** aggregate fields of "cma_listings" */
export type Fr_Cma_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_Cma_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Fr_Cma_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_listings". All fields are combined with a logical 'AND'. */
export type Fr_Cma_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Cma_Listings_Bool_Exp>>;
  _not?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Cma_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  available_from?: InputMaybe<Date_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_online?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  places?: InputMaybe<Fr_Places_Bool_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  property_types?: InputMaybe<Fr_Property_Types_Bool_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fr_Cma_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Fr_Cma_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "cma_listings". */
export type Fr_Cma_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  available_from?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Fr_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_online?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Fr_Places_Aggregate_Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  property_types?: InputMaybe<Fr_Property_Types_Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "cma_listings" */
export enum Fr_Cma_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Fr_Cma_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Fr_Cma_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Fr_Cma_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Fr_Cma_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Fr_Cma_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Fr_Cma_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Fr_Cma_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "get_merged_listings_type" */
export type Fr_Get_Merged_Listings_Type = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Scalars['json']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  removed?: Maybe<Scalars['Boolean']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "get_merged_listings_type" */
export type Fr_Get_Merged_Listings_TypeImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "get_merged_listings_type". All fields are combined with a logical 'AND'. */
export type Fr_Get_Merged_Listings_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Bool_Exp>>;
  _not?: InputMaybe<Fr_Get_Merged_Listings_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Json_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
};

/** Ordering options when selecting data from "get_merged_listings_type". */
export type Fr_Get_Merged_Listings_Type_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
};

/** select columns of table "get_merged_listings_type" */
export enum Fr_Get_Merged_Listings_Type_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UsableSurface = 'usable_surface'
}

/** columns and relationships of "merged_images" */
export type Fr_Merged_Images = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "merged_images" */
export type Fr_Merged_Images_Aggregate = {
  aggregate?: Maybe<Fr_Merged_Images_Aggregate_Fields>;
  nodes: Array<Fr_Merged_Images>;
};

/** aggregate fields of "merged_images" */
export type Fr_Merged_Images_Aggregate_Fields = {
  avg?: Maybe<Fr_Merged_Images_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_Merged_Images_Max_Fields>;
  min?: Maybe<Fr_Merged_Images_Min_Fields>;
  stddev?: Maybe<Fr_Merged_Images_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_Merged_Images_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_Merged_Images_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_Merged_Images_Sum_Fields>;
  var_pop?: Maybe<Fr_Merged_Images_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_Merged_Images_Var_Samp_Fields>;
  variance?: Maybe<Fr_Merged_Images_Variance_Fields>;
};


/** aggregate fields of "merged_images" */
export type Fr_Merged_Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "merged_images" */
export type Fr_Merged_Images_Aggregate_Order_By = {
  avg?: InputMaybe<Fr_Merged_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fr_Merged_Images_Max_Order_By>;
  min?: InputMaybe<Fr_Merged_Images_Min_Order_By>;
  stddev?: InputMaybe<Fr_Merged_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fr_Merged_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fr_Merged_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fr_Merged_Images_Sum_Order_By>;
  var_pop?: InputMaybe<Fr_Merged_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fr_Merged_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Fr_Merged_Images_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Fr_Merged_Images_Avg_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "merged_images" */
export type Fr_Merged_Images_Avg_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "merged_images". All fields are combined with a logical 'AND'. */
export type Fr_Merged_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Merged_Images_Bool_Exp>>;
  _not?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Merged_Images_Bool_Exp>>;
  bucket_name?: InputMaybe<String_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_index?: InputMaybe<Int_Comparison_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fr_Merged_Images_Max_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "merged_images" */
export type Fr_Merged_Images_Max_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fr_Merged_Images_Min_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "merged_images" */
export type Fr_Merged_Images_Min_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "merged_images". */
export type Fr_Merged_Images_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** select columns of table "merged_images" */
export enum Fr_Merged_Images_Select_Column {
  /** column name */
  BucketName = 'bucket_name',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImageIndex = 'image_index',
  /** column name */
  ListingId = 'listing_id'
}

/** aggregate stddev on columns */
export type Fr_Merged_Images_Stddev_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "merged_images" */
export type Fr_Merged_Images_Stddev_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fr_Merged_Images_Stddev_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "merged_images" */
export type Fr_Merged_Images_Stddev_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fr_Merged_Images_Stddev_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "merged_images" */
export type Fr_Merged_Images_Stddev_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Fr_Merged_Images_Sum_Fields = {
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "merged_images" */
export type Fr_Merged_Images_Sum_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Fr_Merged_Images_Var_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "merged_images" */
export type Fr_Merged_Images_Var_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fr_Merged_Images_Var_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "merged_images" */
export type Fr_Merged_Images_Var_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fr_Merged_Images_Variance_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "merged_images" */
export type Fr_Merged_Images_Variance_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "merged_listings" */
export type Fr_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Fr_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Fr_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Fr_Property_Main_Type_Enum;
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "merged_listings" */
export type Fr_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "merged_listings" */
export type Fr_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "merged_listings" */
export type Fr_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Fr_Merged_Listings_Aggregate = {
  aggregate?: Maybe<Fr_Merged_Listings_Aggregate_Fields>;
  nodes: Array<Fr_Merged_Listings>;
};

/** aggregate fields of "merged_listings" */
export type Fr_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<Fr_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_Merged_Listings_Max_Fields>;
  min?: Maybe<Fr_Merged_Listings_Min_Fields>;
  stddev?: Maybe<Fr_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<Fr_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<Fr_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "merged_listings" */
export type Fr_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Fr_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "merged_listings". All fields are combined with a logical 'AND'. */
export type Fr_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<Fr_Property_Main_Type_Enum_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fr_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Fr_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "merged_listings". */
export type Fr_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Fr_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "merged_listings" */
export enum Fr_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Fr_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Fr_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Fr_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Fr_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Fr_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Fr_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Fr_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "places" */
export type Fr_Places = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  breadcrumbs: Array<Fr_Places_Breadcrumbs>;
  /** An aggregate relationship */
  breadcrumbs_aggregate: Fr_Places_Breadcrumbs_Aggregate;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  canonical_place?: Maybe<Fr_Places>;
  children_bbox?: Maybe<Scalars['jsonb']['output']>;
  /** A computed field, executes function "count_children_place" */
  children_count?: Maybe<Scalars['Int']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  extra: Scalars['jsonb']['output'];
  geom: Scalars['geometry']['output'];
  id: Scalars['uuid']['output'];
  index: Scalars['Boolean']['output'];
  /** to use instead of label_en label_de etc, x-hasura-website-language must be set */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  municipality?: Maybe<Fr_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  municipality_places: Array<Fr_Places>;
  /** An aggregate relationship */
  municipality_places_aggregate: Fr_Places_Aggregate;
  name: Scalars['String']['output'];
  /** An array relationship */
  neighbourhood: Array<Fr_Places>;
  /** An aggregate relationship */
  neighbourhood_aggregate: Fr_Places_Aggregate;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  region: Array<Fr_Places>;
  /** An aggregate relationship */
  region_aggregate: Fr_Places_Aggregate;
  region_id?: Maybe<Scalars['uuid']['output']>;
  search_base: Scalars['tsvector']['output'];
  /** to use instead of slug_en slug_de etc, x-hasura-website-language must be set */
  slug?: Maybe<Scalars['String']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  state: Array<Fr_Places>;
  /** An aggregate relationship */
  state_aggregate: Fr_Places_Aggregate;
  state_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  state_places: Array<Fr_Places>;
  /** An aggregate relationship */
  state_places_aggregate: Fr_Places_Aggregate;
  type: Scalars['String']['output'];
};


/** columns and relationships of "places" */
export type Fr_PlacesBreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Fr_Places_Breadcrumbs_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Fr_PlacesBreadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Fr_Places_Breadcrumbs_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Fr_PlacesChildren_BboxArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "places" */
export type Fr_PlacesExtraArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "places" */
export type Fr_PlacesMunicipality_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Fr_PlacesMunicipality_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Fr_PlacesNeighbourhoodArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Fr_PlacesNeighbourhood_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Fr_PlacesRegionArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Fr_PlacesRegion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Fr_PlacesStateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Fr_PlacesState_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Fr_PlacesState_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type Fr_PlacesState_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};

/** aggregated selection of "places" */
export type Fr_Places_Aggregate = {
  aggregate?: Maybe<Fr_Places_Aggregate_Fields>;
  nodes: Array<Fr_Places>;
};

/** aggregate fields of "places" */
export type Fr_Places_Aggregate_Fields = {
  avg?: Maybe<Fr_Places_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_Places_Max_Fields>;
  min?: Maybe<Fr_Places_Min_Fields>;
  stddev?: Maybe<Fr_Places_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_Places_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_Places_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_Places_Sum_Fields>;
  var_pop?: Maybe<Fr_Places_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_Places_Var_Samp_Fields>;
  variance?: Maybe<Fr_Places_Variance_Fields>;
};


/** aggregate fields of "places" */
export type Fr_Places_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_Places_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places" */
export type Fr_Places_Aggregate_Order_By = {
  avg?: InputMaybe<Fr_Places_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fr_Places_Max_Order_By>;
  min?: InputMaybe<Fr_Places_Min_Order_By>;
  stddev?: InputMaybe<Fr_Places_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fr_Places_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fr_Places_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fr_Places_Sum_Order_By>;
  var_pop?: InputMaybe<Fr_Places_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fr_Places_Var_Samp_Order_By>;
  variance?: InputMaybe<Fr_Places_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Fr_Places_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places" */
export type Fr_Places_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places". All fields are combined with a logical 'AND'. */
export type Fr_Places_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Places_Bool_Exp>>;
  _not?: InputMaybe<Fr_Places_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Places_Bool_Exp>>;
  agglomeration_id?: InputMaybe<Uuid_Comparison_Exp>;
  breadcrumbs?: InputMaybe<Fr_Places_Breadcrumbs_Bool_Exp>;
  canonical_id?: InputMaybe<Uuid_Comparison_Exp>;
  canonical_place?: InputMaybe<Fr_Places_Bool_Exp>;
  children_bbox?: InputMaybe<Jsonb_Comparison_Exp>;
  children_count?: InputMaybe<Int_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  extra?: InputMaybe<Jsonb_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  index?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality?: InputMaybe<Fr_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality_places?: InputMaybe<Fr_Places_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  neighbourhood?: InputMaybe<Fr_Places_Bool_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  population?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<Fr_Places_Bool_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  search_base?: InputMaybe<Tsvector_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  slug_de?: InputMaybe<String_Comparison_Exp>;
  slug_en?: InputMaybe<String_Comparison_Exp>;
  slug_es?: InputMaybe<String_Comparison_Exp>;
  slug_fr?: InputMaybe<String_Comparison_Exp>;
  slug_it?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<Fr_Places_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  state_places?: InputMaybe<Fr_Places_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  place?: Maybe<Fr_Places>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Aggregate = {
  aggregate?: Maybe<Fr_Places_Breadcrumbs_Aggregate_Fields>;
  nodes: Array<Fr_Places_Breadcrumbs>;
};

/** aggregate fields of "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Aggregate_Fields = {
  avg?: Maybe<Fr_Places_Breadcrumbs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_Places_Breadcrumbs_Max_Fields>;
  min?: Maybe<Fr_Places_Breadcrumbs_Min_Fields>;
  stddev?: Maybe<Fr_Places_Breadcrumbs_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_Places_Breadcrumbs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_Places_Breadcrumbs_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_Places_Breadcrumbs_Sum_Fields>;
  var_pop?: Maybe<Fr_Places_Breadcrumbs_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_Places_Breadcrumbs_Var_Samp_Fields>;
  variance?: Maybe<Fr_Places_Breadcrumbs_Variance_Fields>;
};


/** aggregate fields of "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_Places_Breadcrumbs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Aggregate_Order_By = {
  avg?: InputMaybe<Fr_Places_Breadcrumbs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fr_Places_Breadcrumbs_Max_Order_By>;
  min?: InputMaybe<Fr_Places_Breadcrumbs_Min_Order_By>;
  stddev?: InputMaybe<Fr_Places_Breadcrumbs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fr_Places_Breadcrumbs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fr_Places_Breadcrumbs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fr_Places_Breadcrumbs_Sum_Order_By>;
  var_pop?: InputMaybe<Fr_Places_Breadcrumbs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fr_Places_Breadcrumbs_Var_Samp_Order_By>;
  variance?: InputMaybe<Fr_Places_Breadcrumbs_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Fr_Places_Breadcrumbs_Avg_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Avg_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places_breadcrumbs". All fields are combined with a logical 'AND'. */
export type Fr_Places_Breadcrumbs_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Places_Breadcrumbs_Bool_Exp>>;
  _not?: InputMaybe<Fr_Places_Breadcrumbs_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Places_Breadcrumbs_Bool_Exp>>;
  breadcrumb_place_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_num?: InputMaybe<Bigint_Comparison_Exp>;
  place?: InputMaybe<Fr_Places_Bool_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fr_Places_Breadcrumbs_Max_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Max_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fr_Places_Breadcrumbs_Min_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Min_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places_breadcrumbs". */
export type Fr_Places_Breadcrumbs_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place?: InputMaybe<Fr_Places_Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** select columns of table "places_breadcrumbs" */
export enum Fr_Places_Breadcrumbs_Select_Column {
  /** column name */
  BreadcrumbPlaceId = 'breadcrumb_place_id',
  /** column name */
  OrderNum = 'order_num',
  /** column name */
  PlaceId = 'place_id'
}

/** aggregate stddev on columns */
export type Fr_Places_Breadcrumbs_Stddev_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Stddev_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fr_Places_Breadcrumbs_Stddev_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Stddev_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fr_Places_Breadcrumbs_Stddev_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Stddev_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Fr_Places_Breadcrumbs_Sum_Fields = {
  order_num?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Sum_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Fr_Places_Breadcrumbs_Var_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Var_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fr_Places_Breadcrumbs_Var_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Var_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fr_Places_Breadcrumbs_Variance_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Variance_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Fr_Places_Max_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "places" */
export type Fr_Places_Max_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fr_Places_Min_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "places" */
export type Fr_Places_Min_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places". */
export type Fr_Places_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  breadcrumbs_aggregate?: InputMaybe<Fr_Places_Breadcrumbs_Aggregate_Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  canonical_place?: InputMaybe<Fr_Places_Order_By>;
  children_bbox?: InputMaybe<Order_By>;
  children_count?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Fr_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  municipality_places_aggregate?: InputMaybe<Fr_Places_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_aggregate?: InputMaybe<Fr_Places_Aggregate_Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_aggregate?: InputMaybe<Fr_Places_Aggregate_Order_By>;
  region_id?: InputMaybe<Order_By>;
  search_base?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  state_aggregate?: InputMaybe<Fr_Places_Aggregate_Order_By>;
  state_id?: InputMaybe<Order_By>;
  state_places_aggregate?: InputMaybe<Fr_Places_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "places" */
export enum Fr_Places_Select_Column {
  /** column name */
  AgglomerationId = 'agglomeration_id',
  /** column name */
  CanonicalId = 'canonical_id',
  /** column name */
  ChildrenBbox = 'children_bbox',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  Population = 'population',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SearchBase = 'search_base',
  /** column name */
  SlugDe = 'slug_de',
  /** column name */
  SlugEn = 'slug_en',
  /** column name */
  SlugEs = 'slug_es',
  /** column name */
  SlugFr = 'slug_fr',
  /** column name */
  SlugIt = 'slug_it',
  /** column name */
  StateId = 'state_id',
  /** column name */
  Type = 'type'
}

/** aggregate stddev on columns */
export type Fr_Places_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places" */
export type Fr_Places_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fr_Places_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places" */
export type Fr_Places_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fr_Places_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places" */
export type Fr_Places_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Fr_Places_Sum_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "places" */
export type Fr_Places_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Fr_Places_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places" */
export type Fr_Places_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fr_Places_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places" */
export type Fr_Places_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fr_Places_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places" */
export type Fr_Places_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** columns and relationships of "post_merged_listings" */
export type Fr_Post_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** A computed field, executes function "get_least_created_at" */
  created_at_consolidated?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Fr_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Fr_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_listing_images" */
  listing_images?: Maybe<Array<Fr_Merged_Images>>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_object?: Maybe<Fr_Places>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  municipality?: Maybe<Fr_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "post_merged_listings" */
export type Fr_Post_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "post_merged_listings" */
export type Fr_Post_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "post_merged_listings" */
export type Fr_Post_Merged_ListingsListing_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "post_merged_listings" */
export type Fr_Post_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Fr_Post_Merged_Listings_Aggregate = {
  aggregate?: Maybe<Fr_Post_Merged_Listings_Aggregate_Fields>;
  nodes: Array<Fr_Post_Merged_Listings>;
};

/** aggregate fields of "post_merged_listings" */
export type Fr_Post_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<Fr_Post_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_Post_Merged_Listings_Max_Fields>;
  min?: Maybe<Fr_Post_Merged_Listings_Min_Fields>;
  stddev?: Maybe<Fr_Post_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_Post_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_Post_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_Post_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<Fr_Post_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_Post_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<Fr_Post_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "post_merged_listings" */
export type Fr_Post_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_Post_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Fr_Post_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "post_merged_listings". All fields are combined with a logical 'AND'. */
export type Fr_Post_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Post_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<Fr_Post_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Post_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at_consolidated?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_images?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_object?: InputMaybe<Fr_Places_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality?: InputMaybe<Fr_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fr_Post_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Fr_Post_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "post_merged_listings". */
export type Fr_Post_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_at_consolidated?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Fr_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_images_aggregate?: InputMaybe<Fr_Merged_Images_Aggregate_Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_object?: InputMaybe<Fr_Places_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Fr_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "post_merged_listings" */
export enum Fr_Post_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Fr_Post_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Fr_Post_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Fr_Post_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Fr_Post_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Fr_Post_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Fr_Post_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Fr_Post_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

export enum Fr_Property_Main_Type_Enum {
  Agri = 'AGRI',
  Appt = 'APPT',
  Building = 'BUILDING',
  Commercial = 'COMMERCIAL',
  Garden = 'GARDEN',
  Gastro = 'GASTRO',
  House = 'HOUSE',
  HouseAppt = 'HOUSE_APPT',
  Indus = 'INDUS',
  Other = 'OTHER',
  Park = 'PARK',
  Prop = 'PROP',
  Room = 'ROOM',
  Secondary = 'SECONDARY'
}

/** Boolean expression to compare columns of type "fr_property_main_type_enum". All fields are combined with logical 'AND'. */
export type Fr_Property_Main_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Fr_Property_Main_Type_Enum>;
  _in?: InputMaybe<Array<Fr_Property_Main_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Fr_Property_Main_Type_Enum>;
  _nin?: InputMaybe<Array<Fr_Property_Main_Type_Enum>>;
};

/** columns and relationships of "property_types" */
export type Fr_Property_Types = {
  /** A computed field, executes function "property_types_label" */
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "property_types". All fields are combined with a logical 'AND'. */
export type Fr_Property_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Property_Types_Bool_Exp>>;
  _not?: InputMaybe<Fr_Property_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Property_Types_Bool_Exp>>;
  label?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "property_types". */
export type Fr_Property_Types_Order_By = {
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "property_types" */
export enum Fr_Property_Types_Select_Column {
  /** column name */
  Name = 'name'
}

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']['input']>;
  _gt?: InputMaybe<Scalars['geography']['input']>;
  _gte?: InputMaybe<Scalars['geography']['input']>;
  _in?: InputMaybe<Array<Scalars['geography']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geography']['input']>;
  _lte?: InputMaybe<Scalars['geography']['input']>;
  _neq?: InputMaybe<Scalars['geography']['input']>;
  _nin?: InputMaybe<Array<Scalars['geography']['input']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']['input']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']['input']>;
  _gt?: InputMaybe<Scalars['geometry']['input']>;
  _gte?: InputMaybe<Scalars['geometry']['input']>;
  _in?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geometry']['input']>;
  _lte?: InputMaybe<Scalars['geometry']['input']>;
  _neq?: InputMaybe<Scalars['geometry']['input']>;
  _nin?: InputMaybe<Array<Scalars['geometry']['input']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']['input']>;
};

export type Get_Agents_Ranking_Args = {
  agent_ids?: InputMaybe<Scalars['_uuid']['input']>;
  exclude_rental_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  location_lat?: InputMaybe<Scalars['float8']['input']>;
  location_lng?: InputMaybe<Scalars['float8']['input']>;
  location_uuid?: InputMaybe<Scalars['uuid']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  offset_count?: InputMaybe<Scalars['Int']['input']>;
  tenant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  transaction_radius?: InputMaybe<Scalars['float8']['input']>;
};

export type Get_Appraisals_By_Slug_Args = {
  place_slug?: InputMaybe<Scalars['String']['input']>;
};

export type Get_Buy_Rent_Listings_Args = {
  p_slug?: InputMaybe<Scalars['String']['input']>;
};

export type Get_Catchment_Area_Args = {
  target_population?: InputMaybe<Scalars['Int']['input']>;
  x?: InputMaybe<Scalars['float8']['input']>;
  y?: InputMaybe<Scalars['float8']['input']>;
};

export type Get_Merged_Listings_Args = {
  listings_ids?: InputMaybe<Scalars['String']['input']>;
  show_hidden_listings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Get_Nearby_Appraisals_Args = {
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  location_lat?: InputMaybe<Scalars['float8']['input']>;
  location_lon?: InputMaybe<Scalars['float8']['input']>;
  municipality_uuid?: InputMaybe<Scalars['uuid']['input']>;
  offset_count?: InputMaybe<Scalars['Int']['input']>;
  radius_meters?: InputMaybe<Scalars['float8']['input']>;
};

export type Get_Nearby_Reviews_Args = {
  p_lat?: InputMaybe<Scalars['Float']['input']>;
  p_limit?: InputMaybe<Scalars['Int']['input']>;
  p_lng?: InputMaybe<Scalars['Float']['input']>;
  p_max_distance?: InputMaybe<Scalars['Float']['input']>;
  p_offset?: InputMaybe<Scalars['Int']['input']>;
  p_tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Get_Nearby_Transactions_Args = {
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  location_lat?: InputMaybe<Scalars['float8']['input']>;
  location_lon?: InputMaybe<Scalars['float8']['input']>;
  municipality_uuid?: InputMaybe<Scalars['uuid']['input']>;
  offset_count?: InputMaybe<Scalars['Int']['input']>;
  radius_meters?: InputMaybe<Scalars['float8']['input']>;
  today_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type Get_Online_Listing_Map_Data_Args = {
  _id?: InputMaybe<Scalars['Int']['input']>;
};

export type Get_Place_By_Slug_Args = {
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type Get_Similar_Listings_Args = {
  _built_surface?: InputMaybe<Scalars['Float']['input']>;
  _lat?: InputMaybe<Scalars['Float']['input']>;
  _limit?: InputMaybe<Scalars['Int']['input']>;
  _living_surface?: InputMaybe<Scalars['Float']['input']>;
  _lng?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms?: InputMaybe<Scalars['Int']['input']>;
  _property_main_type?: InputMaybe<Scalars['String']['input']>;
  _sale_price?: InputMaybe<Scalars['Float']['input']>;
  _usable_surface?: InputMaybe<Scalars['Float']['input']>;
};

export type Get_Similar_Listings_Vector_Args = {
  _built_surface?: InputMaybe<Scalars['Float']['input']>;
  _computed_surface_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _computed_surface_scale?: InputMaybe<Scalars['Float']['input']>;
  _computed_surface_weight?: InputMaybe<Scalars['Float']['input']>;
  _geog_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _geog_scale?: InputMaybe<Scalars['Float']['input']>;
  _geog_weight?: InputMaybe<Scalars['Float']['input']>;
  _lat?: InputMaybe<Scalars['Float']['input']>;
  _limit?: InputMaybe<Scalars['Int']['input']>;
  _living_surface?: InputMaybe<Scalars['Float']['input']>;
  _lng?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms?: InputMaybe<Scalars['Int']['input']>;
  _number_of_rooms_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms_scale?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms_weight?: InputMaybe<Scalars['Float']['input']>;
  _online_ratio?: InputMaybe<Scalars['Float']['input']>;
  _price_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _price_scale?: InputMaybe<Scalars['Float']['input']>;
  _price_weight?: InputMaybe<Scalars['Float']['input']>;
  _property_main_type?: InputMaybe<Scalars['String']['input']>;
  _sale_price?: InputMaybe<Scalars['Float']['input']>;
  _usable_surface?: InputMaybe<Scalars['Float']['input']>;
};

export type Get_Similar_Online_Listings_Args = {
  _computed_surface?: InputMaybe<Scalars['Float']['input']>;
  _extra_params?: InputMaybe<Scalars['jsonb']['input']>;
  _lat?: InputMaybe<Scalars['Float']['input']>;
  _limit?: InputMaybe<Scalars['Int']['input']>;
  _lng?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms?: InputMaybe<Scalars['Int']['input']>;
  _offer_price?: InputMaybe<Scalars['Float']['input']>;
  _offer_type?: InputMaybe<Scalars['String']['input']>;
};

export type Get_Similar_Online_Listings_Ids_Args = {
  _id?: InputMaybe<Scalars['Int']['input']>;
};

export type Get_Similar_Online_Listings_Vector_Args = {
  _computed_surface?: InputMaybe<Scalars['Float']['input']>;
  _computed_surface_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _computed_surface_scale?: InputMaybe<Scalars['Float']['input']>;
  _computed_surface_weight?: InputMaybe<Scalars['Float']['input']>;
  _geog_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _geog_scale?: InputMaybe<Scalars['Float']['input']>;
  _geog_weight?: InputMaybe<Scalars['Float']['input']>;
  _lat?: InputMaybe<Scalars['Float']['input']>;
  _limit?: InputMaybe<Scalars['Int']['input']>;
  _lng?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms?: InputMaybe<Scalars['Int']['input']>;
  _number_of_rooms_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms_scale?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms_weight?: InputMaybe<Scalars['Float']['input']>;
  _offer_price?: InputMaybe<Scalars['Float']['input']>;
  _offer_type?: InputMaybe<Scalars['String']['input']>;
  _price_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _price_scale?: InputMaybe<Scalars['Float']['input']>;
  _price_weight?: InputMaybe<Scalars['Float']['input']>;
};

export type Get_Teams_Ranking_Args = {
  exclude_rental_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  location_lat?: InputMaybe<Scalars['float8']['input']>;
  location_lng?: InputMaybe<Scalars['float8']['input']>;
  location_uuid?: InputMaybe<Scalars['uuid']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  offset_count?: InputMaybe<Scalars['Int']['input']>;
  tenant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  transaction_radius?: InputMaybe<Scalars['float8']['input']>;
};

export type Global_Statistics_Args = {
  filters?: InputMaybe<Scalars['json']['input']>;
};

/** columns and relationships of "global_stats" */
export type Global_Stats = {
  buyers_agent_share?: Maybe<Scalars['float8']['output']>;
  buyers_call_attempts?: Maybe<Scalars['Int']['output']>;
  buyers_call_attempts_missed?: Maybe<Scalars['Int']['output']>;
  buyers_call_attempts_successful?: Maybe<Scalars['Int']['output']>;
  buyers_gross_commission?: Maybe<Scalars['float8']['output']>;
  buyers_new_buyer_leads?: Maybe<Scalars['Int']['output']>;
  buyers_new_enquiries?: Maybe<Scalars['Int']['output']>;
  buyers_offers_accepted?: Maybe<Scalars['Int']['output']>;
  buyers_offers_made?: Maybe<Scalars['Int']['output']>;
  buyers_offers_refused?: Maybe<Scalars['Int']['output']>;
  buyers_own_share?: Maybe<Scalars['float8']['output']>;
  buyers_property_searches_created?: Maybe<Scalars['Int']['output']>;
  buyers_realadvisor_share?: Maybe<Scalars['float8']['output']>;
  buyers_transactions_closed?: Maybe<Scalars['Int']['output']>;
  buyers_transactions_closed_rent?: Maybe<Scalars['Int']['output']>;
  buyers_transactions_closed_sale?: Maybe<Scalars['Int']['output']>;
  buyers_transactions_volume?: Maybe<Scalars['float8']['output']>;
  buyers_visits_booked?: Maybe<Scalars['Int']['output']>;
  buyers_visits_completed?: Maybe<Scalars['Int']['output']>;
  buyers_visits_planned?: Maybe<Scalars['Int']['output']>;
  date: Scalars['date']['output'];
  sellers_assigned_leads?: Maybe<Scalars['Int']['output']>;
  sellers_call_attempts?: Maybe<Scalars['Int']['output']>;
  sellers_call_attempts_missed?: Maybe<Scalars['Int']['output']>;
  sellers_call_attempts_successful?: Maybe<Scalars['Int']['output']>;
  sellers_claimed_leads?: Maybe<Scalars['Int']['output']>;
  sellers_mandates_published?: Maybe<Scalars['Int']['output']>;
  sellers_mandates_signed?: Maybe<Scalars['Int']['output']>;
  sellers_rent_mandates_signed?: Maybe<Scalars['Int']['output']>;
  sellers_rent_mandates_signed_broker?: Maybe<Scalars['Int']['output']>;
  sellers_rent_mandates_signed_realadvisor?: Maybe<Scalars['Int']['output']>;
  sellers_sale_mandates_signed?: Maybe<Scalars['Int']['output']>;
  sellers_sale_mandates_signed_broker?: Maybe<Scalars['Int']['output']>;
  sellers_sale_mandates_signed_realadvisor?: Maybe<Scalars['Int']['output']>;
  sellers_seller_leads?: Maybe<Scalars['Int']['output']>;
  sellers_seller_leads_months?: Maybe<Scalars['Int']['output']>;
  sellers_total_leads?: Maybe<Scalars['Int']['output']>;
  sellers_total_requalified?: Maybe<Scalars['Int']['output']>;
  sellers_visits_booked?: Maybe<Scalars['Int']['output']>;
  sellers_visits_completed?: Maybe<Scalars['Int']['output']>;
  sellers_visits_planned?: Maybe<Scalars['Int']['output']>;
};

/** Boolean expression to filter rows from the table "global_stats". All fields are combined with a logical 'AND'. */
export type Global_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Global_Stats_Bool_Exp>>;
  _not?: InputMaybe<Global_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Global_Stats_Bool_Exp>>;
  buyers_agent_share?: InputMaybe<Float8_Comparison_Exp>;
  buyers_call_attempts?: InputMaybe<Int_Comparison_Exp>;
  buyers_call_attempts_missed?: InputMaybe<Int_Comparison_Exp>;
  buyers_call_attempts_successful?: InputMaybe<Int_Comparison_Exp>;
  buyers_gross_commission?: InputMaybe<Float8_Comparison_Exp>;
  buyers_new_buyer_leads?: InputMaybe<Int_Comparison_Exp>;
  buyers_new_enquiries?: InputMaybe<Int_Comparison_Exp>;
  buyers_offers_accepted?: InputMaybe<Int_Comparison_Exp>;
  buyers_offers_made?: InputMaybe<Int_Comparison_Exp>;
  buyers_offers_refused?: InputMaybe<Int_Comparison_Exp>;
  buyers_own_share?: InputMaybe<Float8_Comparison_Exp>;
  buyers_property_searches_created?: InputMaybe<Int_Comparison_Exp>;
  buyers_realadvisor_share?: InputMaybe<Float8_Comparison_Exp>;
  buyers_transactions_closed?: InputMaybe<Int_Comparison_Exp>;
  buyers_transactions_closed_rent?: InputMaybe<Int_Comparison_Exp>;
  buyers_transactions_closed_sale?: InputMaybe<Int_Comparison_Exp>;
  buyers_transactions_volume?: InputMaybe<Float8_Comparison_Exp>;
  buyers_visits_booked?: InputMaybe<Int_Comparison_Exp>;
  buyers_visits_completed?: InputMaybe<Int_Comparison_Exp>;
  buyers_visits_planned?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  sellers_assigned_leads?: InputMaybe<Int_Comparison_Exp>;
  sellers_call_attempts?: InputMaybe<Int_Comparison_Exp>;
  sellers_call_attempts_missed?: InputMaybe<Int_Comparison_Exp>;
  sellers_call_attempts_successful?: InputMaybe<Int_Comparison_Exp>;
  sellers_claimed_leads?: InputMaybe<Int_Comparison_Exp>;
  sellers_mandates_published?: InputMaybe<Int_Comparison_Exp>;
  sellers_mandates_signed?: InputMaybe<Int_Comparison_Exp>;
  sellers_rent_mandates_signed?: InputMaybe<Int_Comparison_Exp>;
  sellers_rent_mandates_signed_broker?: InputMaybe<Int_Comparison_Exp>;
  sellers_rent_mandates_signed_realadvisor?: InputMaybe<Int_Comparison_Exp>;
  sellers_sale_mandates_signed?: InputMaybe<Int_Comparison_Exp>;
  sellers_sale_mandates_signed_broker?: InputMaybe<Int_Comparison_Exp>;
  sellers_sale_mandates_signed_realadvisor?: InputMaybe<Int_Comparison_Exp>;
  sellers_seller_leads?: InputMaybe<Int_Comparison_Exp>;
  sellers_seller_leads_months?: InputMaybe<Int_Comparison_Exp>;
  sellers_total_leads?: InputMaybe<Int_Comparison_Exp>;
  sellers_total_requalified?: InputMaybe<Int_Comparison_Exp>;
  sellers_visits_booked?: InputMaybe<Int_Comparison_Exp>;
  sellers_visits_completed?: InputMaybe<Int_Comparison_Exp>;
  sellers_visits_planned?: InputMaybe<Int_Comparison_Exp>;
};

/** Ordering options when selecting data from "global_stats". */
export type Global_Stats_Order_By = {
  buyers_agent_share?: InputMaybe<Order_By>;
  buyers_call_attempts?: InputMaybe<Order_By>;
  buyers_call_attempts_missed?: InputMaybe<Order_By>;
  buyers_call_attempts_successful?: InputMaybe<Order_By>;
  buyers_gross_commission?: InputMaybe<Order_By>;
  buyers_new_buyer_leads?: InputMaybe<Order_By>;
  buyers_new_enquiries?: InputMaybe<Order_By>;
  buyers_offers_accepted?: InputMaybe<Order_By>;
  buyers_offers_made?: InputMaybe<Order_By>;
  buyers_offers_refused?: InputMaybe<Order_By>;
  buyers_own_share?: InputMaybe<Order_By>;
  buyers_property_searches_created?: InputMaybe<Order_By>;
  buyers_realadvisor_share?: InputMaybe<Order_By>;
  buyers_transactions_closed?: InputMaybe<Order_By>;
  buyers_transactions_closed_rent?: InputMaybe<Order_By>;
  buyers_transactions_closed_sale?: InputMaybe<Order_By>;
  buyers_transactions_volume?: InputMaybe<Order_By>;
  buyers_visits_booked?: InputMaybe<Order_By>;
  buyers_visits_completed?: InputMaybe<Order_By>;
  buyers_visits_planned?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  sellers_assigned_leads?: InputMaybe<Order_By>;
  sellers_call_attempts?: InputMaybe<Order_By>;
  sellers_call_attempts_missed?: InputMaybe<Order_By>;
  sellers_call_attempts_successful?: InputMaybe<Order_By>;
  sellers_claimed_leads?: InputMaybe<Order_By>;
  sellers_mandates_published?: InputMaybe<Order_By>;
  sellers_mandates_signed?: InputMaybe<Order_By>;
  sellers_rent_mandates_signed?: InputMaybe<Order_By>;
  sellers_rent_mandates_signed_broker?: InputMaybe<Order_By>;
  sellers_rent_mandates_signed_realadvisor?: InputMaybe<Order_By>;
  sellers_sale_mandates_signed?: InputMaybe<Order_By>;
  sellers_sale_mandates_signed_broker?: InputMaybe<Order_By>;
  sellers_sale_mandates_signed_realadvisor?: InputMaybe<Order_By>;
  sellers_seller_leads?: InputMaybe<Order_By>;
  sellers_seller_leads_months?: InputMaybe<Order_By>;
  sellers_total_leads?: InputMaybe<Order_By>;
  sellers_total_requalified?: InputMaybe<Order_By>;
  sellers_visits_booked?: InputMaybe<Order_By>;
  sellers_visits_completed?: InputMaybe<Order_By>;
  sellers_visits_planned?: InputMaybe<Order_By>;
};

/** select columns of table "global_stats" */
export enum Global_Stats_Select_Column {
  /** column name */
  BuyersAgentShare = 'buyers_agent_share',
  /** column name */
  BuyersCallAttempts = 'buyers_call_attempts',
  /** column name */
  BuyersCallAttemptsMissed = 'buyers_call_attempts_missed',
  /** column name */
  BuyersCallAttemptsSuccessful = 'buyers_call_attempts_successful',
  /** column name */
  BuyersGrossCommission = 'buyers_gross_commission',
  /** column name */
  BuyersNewBuyerLeads = 'buyers_new_buyer_leads',
  /** column name */
  BuyersNewEnquiries = 'buyers_new_enquiries',
  /** column name */
  BuyersOffersAccepted = 'buyers_offers_accepted',
  /** column name */
  BuyersOffersMade = 'buyers_offers_made',
  /** column name */
  BuyersOffersRefused = 'buyers_offers_refused',
  /** column name */
  BuyersOwnShare = 'buyers_own_share',
  /** column name */
  BuyersPropertySearchesCreated = 'buyers_property_searches_created',
  /** column name */
  BuyersRealadvisorShare = 'buyers_realadvisor_share',
  /** column name */
  BuyersTransactionsClosed = 'buyers_transactions_closed',
  /** column name */
  BuyersTransactionsClosedRent = 'buyers_transactions_closed_rent',
  /** column name */
  BuyersTransactionsClosedSale = 'buyers_transactions_closed_sale',
  /** column name */
  BuyersTransactionsVolume = 'buyers_transactions_volume',
  /** column name */
  BuyersVisitsBooked = 'buyers_visits_booked',
  /** column name */
  BuyersVisitsCompleted = 'buyers_visits_completed',
  /** column name */
  BuyersVisitsPlanned = 'buyers_visits_planned',
  /** column name */
  Date = 'date',
  /** column name */
  SellersAssignedLeads = 'sellers_assigned_leads',
  /** column name */
  SellersCallAttempts = 'sellers_call_attempts',
  /** column name */
  SellersCallAttemptsMissed = 'sellers_call_attempts_missed',
  /** column name */
  SellersCallAttemptsSuccessful = 'sellers_call_attempts_successful',
  /** column name */
  SellersClaimedLeads = 'sellers_claimed_leads',
  /** column name */
  SellersMandatesPublished = 'sellers_mandates_published',
  /** column name */
  SellersMandatesSigned = 'sellers_mandates_signed',
  /** column name */
  SellersRentMandatesSigned = 'sellers_rent_mandates_signed',
  /** column name */
  SellersRentMandatesSignedBroker = 'sellers_rent_mandates_signed_broker',
  /** column name */
  SellersRentMandatesSignedRealadvisor = 'sellers_rent_mandates_signed_realadvisor',
  /** column name */
  SellersSaleMandatesSigned = 'sellers_sale_mandates_signed',
  /** column name */
  SellersSaleMandatesSignedBroker = 'sellers_sale_mandates_signed_broker',
  /** column name */
  SellersSaleMandatesSignedRealadvisor = 'sellers_sale_mandates_signed_realadvisor',
  /** column name */
  SellersSellerLeads = 'sellers_seller_leads',
  /** column name */
  SellersSellerLeadsMonths = 'sellers_seller_leads_months',
  /** column name */
  SellersTotalLeads = 'sellers_total_leads',
  /** column name */
  SellersTotalRequalified = 'sellers_total_requalified',
  /** column name */
  SellersVisitsBooked = 'sellers_visits_booked',
  /** column name */
  SellersVisitsCompleted = 'sellers_visits_completed',
  /** column name */
  SellersVisitsPlanned = 'sellers_visits_planned'
}

/** Streaming cursor of the table "global_stats" */
export type Global_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Global_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Global_Stats_Stream_Cursor_Value_Input = {
  buyers_agent_share?: InputMaybe<Scalars['float8']['input']>;
  buyers_call_attempts?: InputMaybe<Scalars['Int']['input']>;
  buyers_call_attempts_missed?: InputMaybe<Scalars['Int']['input']>;
  buyers_call_attempts_successful?: InputMaybe<Scalars['Int']['input']>;
  buyers_gross_commission?: InputMaybe<Scalars['float8']['input']>;
  buyers_new_buyer_leads?: InputMaybe<Scalars['Int']['input']>;
  buyers_new_enquiries?: InputMaybe<Scalars['Int']['input']>;
  buyers_offers_accepted?: InputMaybe<Scalars['Int']['input']>;
  buyers_offers_made?: InputMaybe<Scalars['Int']['input']>;
  buyers_offers_refused?: InputMaybe<Scalars['Int']['input']>;
  buyers_own_share?: InputMaybe<Scalars['float8']['input']>;
  buyers_property_searches_created?: InputMaybe<Scalars['Int']['input']>;
  buyers_realadvisor_share?: InputMaybe<Scalars['float8']['input']>;
  buyers_transactions_closed?: InputMaybe<Scalars['Int']['input']>;
  buyers_transactions_closed_rent?: InputMaybe<Scalars['Int']['input']>;
  buyers_transactions_closed_sale?: InputMaybe<Scalars['Int']['input']>;
  buyers_transactions_volume?: InputMaybe<Scalars['float8']['input']>;
  buyers_visits_booked?: InputMaybe<Scalars['Int']['input']>;
  buyers_visits_completed?: InputMaybe<Scalars['Int']['input']>;
  buyers_visits_planned?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  sellers_assigned_leads?: InputMaybe<Scalars['Int']['input']>;
  sellers_call_attempts?: InputMaybe<Scalars['Int']['input']>;
  sellers_call_attempts_missed?: InputMaybe<Scalars['Int']['input']>;
  sellers_call_attempts_successful?: InputMaybe<Scalars['Int']['input']>;
  sellers_claimed_leads?: InputMaybe<Scalars['Int']['input']>;
  sellers_mandates_published?: InputMaybe<Scalars['Int']['input']>;
  sellers_mandates_signed?: InputMaybe<Scalars['Int']['input']>;
  sellers_rent_mandates_signed?: InputMaybe<Scalars['Int']['input']>;
  sellers_rent_mandates_signed_broker?: InputMaybe<Scalars['Int']['input']>;
  sellers_rent_mandates_signed_realadvisor?: InputMaybe<Scalars['Int']['input']>;
  sellers_sale_mandates_signed?: InputMaybe<Scalars['Int']['input']>;
  sellers_sale_mandates_signed_broker?: InputMaybe<Scalars['Int']['input']>;
  sellers_sale_mandates_signed_realadvisor?: InputMaybe<Scalars['Int']['input']>;
  sellers_seller_leads?: InputMaybe<Scalars['Int']['input']>;
  sellers_seller_leads_months?: InputMaybe<Scalars['Int']['input']>;
  sellers_total_leads?: InputMaybe<Scalars['Int']['input']>;
  sellers_total_requalified?: InputMaybe<Scalars['Int']['input']>;
  sellers_visits_booked?: InputMaybe<Scalars['Int']['input']>;
  sellers_visits_completed?: InputMaybe<Scalars['Int']['input']>;
  sellers_visits_planned?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "google_addresses" */
export type Google_Addresses = {
  centroid?: Maybe<Scalars['geometry']['output']>;
  formatted_address?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "google_addresses". All fields are combined with a logical 'AND'. */
export type Google_Addresses_Bool_Exp = {
  _and?: InputMaybe<Array<Google_Addresses_Bool_Exp>>;
  _not?: InputMaybe<Google_Addresses_Bool_Exp>;
  _or?: InputMaybe<Array<Google_Addresses_Bool_Exp>>;
  centroid?: InputMaybe<Geometry_Comparison_Exp>;
  formatted_address?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
};

/** unique or primary key constraints on table "google_addresses" */
export enum Google_Addresses_Constraint {
  /** unique or primary key constraint on columns "id" */
  GoogleAddressesPkey = 'google_addresses_pkey'
}

/** input type for incrementing numeric columns in table "google_addresses" */
export type Google_Addresses_Inc_Input = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "google_addresses" */
export type Google_Addresses_Insert_Input = {
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  place_type?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "google_addresses" */
export type Google_Addresses_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Google_Addresses>;
};

/** input type for inserting object relation for remote table "google_addresses" */
export type Google_Addresses_Obj_Rel_Insert_Input = {
  data: Google_Addresses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Google_Addresses_On_Conflict>;
};

/** on_conflict condition type for table "google_addresses" */
export type Google_Addresses_On_Conflict = {
  constraint: Google_Addresses_Constraint;
  update_columns?: Array<Google_Addresses_Update_Column>;
  where?: InputMaybe<Google_Addresses_Bool_Exp>;
};

/** Ordering options when selecting data from "google_addresses". */
export type Google_Addresses_Order_By = {
  centroid?: InputMaybe<Order_By>;
  formatted_address?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** select columns of table "google_addresses" */
export enum Google_Addresses_Select_Column {
  /** column name */
  Centroid = 'centroid',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** input type for updating data in table "google_addresses" */
export type Google_Addresses_Set_Input = {
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  place_type?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "google_addresses" */
export enum Google_Addresses_Update_Column {
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Ctn = 'ctn',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  PlaceType = 'place_type',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  Route = 'route',
  /** column name */
  State = 'state',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Google_Addresses_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Google_Addresses_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Google_Addresses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Google_Addresses_Bool_Exp;
};

/** columns and relationships of "google_reviews" */
export type Google_Reviews = {
  created_at: Scalars['timestamptz']['output'];
  google_place_id: Scalars['String']['output'];
  google_timestamp: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  local_guide: Scalars['Boolean']['output'];
  original_owner_answer?: Maybe<Scalars['String']['output']>;
  original_review_text?: Maybe<Scalars['String']['output']>;
  owner_answer?: Maybe<Scalars['String']['output']>;
  profile_image_url: Scalars['String']['output'];
  profile_name: Scalars['String']['output'];
  profile_url: Scalars['String']['output'];
  rating: Scalars['Int']['output'];
  review_text?: Maybe<Scalars['String']['output']>;
  review_url: Scalars['String']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "google_reviews" */
export type Google_Reviews_Aggregate = {
  aggregate?: Maybe<Google_Reviews_Aggregate_Fields>;
  nodes: Array<Google_Reviews>;
};

export type Google_Reviews_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Google_Reviews_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Google_Reviews_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Google_Reviews_Aggregate_Bool_Exp_Count>;
};

export type Google_Reviews_Aggregate_Bool_Exp_Bool_And = {
  arguments: Google_Reviews_Select_Column_Google_Reviews_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Google_Reviews_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Google_Reviews_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Google_Reviews_Select_Column_Google_Reviews_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Google_Reviews_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Google_Reviews_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Google_Reviews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Google_Reviews_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "google_reviews" */
export type Google_Reviews_Aggregate_Fields = {
  avg?: Maybe<Google_Reviews_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Google_Reviews_Max_Fields>;
  min?: Maybe<Google_Reviews_Min_Fields>;
  stddev?: Maybe<Google_Reviews_Stddev_Fields>;
  stddev_pop?: Maybe<Google_Reviews_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Google_Reviews_Stddev_Samp_Fields>;
  sum?: Maybe<Google_Reviews_Sum_Fields>;
  var_pop?: Maybe<Google_Reviews_Var_Pop_Fields>;
  var_samp?: Maybe<Google_Reviews_Var_Samp_Fields>;
  variance?: Maybe<Google_Reviews_Variance_Fields>;
};


/** aggregate fields of "google_reviews" */
export type Google_Reviews_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Google_Reviews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "google_reviews" */
export type Google_Reviews_Aggregate_Order_By = {
  avg?: InputMaybe<Google_Reviews_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Google_Reviews_Max_Order_By>;
  min?: InputMaybe<Google_Reviews_Min_Order_By>;
  stddev?: InputMaybe<Google_Reviews_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Google_Reviews_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Google_Reviews_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Google_Reviews_Sum_Order_By>;
  var_pop?: InputMaybe<Google_Reviews_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Google_Reviews_Var_Samp_Order_By>;
  variance?: InputMaybe<Google_Reviews_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Google_Reviews_Avg_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "google_reviews" */
export type Google_Reviews_Avg_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "google_reviews". All fields are combined with a logical 'AND'. */
export type Google_Reviews_Bool_Exp = {
  _and?: InputMaybe<Array<Google_Reviews_Bool_Exp>>;
  _not?: InputMaybe<Google_Reviews_Bool_Exp>;
  _or?: InputMaybe<Array<Google_Reviews_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  google_place_id?: InputMaybe<String_Comparison_Exp>;
  google_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  local_guide?: InputMaybe<Boolean_Comparison_Exp>;
  original_owner_answer?: InputMaybe<String_Comparison_Exp>;
  original_review_text?: InputMaybe<String_Comparison_Exp>;
  owner_answer?: InputMaybe<String_Comparison_Exp>;
  profile_image_url?: InputMaybe<String_Comparison_Exp>;
  profile_name?: InputMaybe<String_Comparison_Exp>;
  profile_url?: InputMaybe<String_Comparison_Exp>;
  rating?: InputMaybe<Int_Comparison_Exp>;
  review_text?: InputMaybe<String_Comparison_Exp>;
  review_url?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Google_Reviews_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  google_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  original_owner_answer?: Maybe<Scalars['String']['output']>;
  original_review_text?: Maybe<Scalars['String']['output']>;
  owner_answer?: Maybe<Scalars['String']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  profile_name?: Maybe<Scalars['String']['output']>;
  profile_url?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_text?: Maybe<Scalars['String']['output']>;
  review_url?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "google_reviews" */
export type Google_Reviews_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  google_timestamp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  original_owner_answer?: InputMaybe<Order_By>;
  original_review_text?: InputMaybe<Order_By>;
  owner_answer?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  profile_name?: InputMaybe<Order_By>;
  profile_url?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  review_text?: InputMaybe<Order_By>;
  review_url?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Google_Reviews_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  google_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  original_owner_answer?: Maybe<Scalars['String']['output']>;
  original_review_text?: Maybe<Scalars['String']['output']>;
  owner_answer?: Maybe<Scalars['String']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  profile_name?: Maybe<Scalars['String']['output']>;
  profile_url?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_text?: Maybe<Scalars['String']['output']>;
  review_url?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "google_reviews" */
export type Google_Reviews_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  google_timestamp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  original_owner_answer?: InputMaybe<Order_By>;
  original_review_text?: InputMaybe<Order_By>;
  owner_answer?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  profile_name?: InputMaybe<Order_By>;
  profile_url?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  review_text?: InputMaybe<Order_By>;
  review_url?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "google_reviews" */
export type Google_Reviews_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Google_Reviews>;
};

/** Ordering options when selecting data from "google_reviews". */
export type Google_Reviews_Order_By = {
  created_at?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  google_timestamp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  local_guide?: InputMaybe<Order_By>;
  original_owner_answer?: InputMaybe<Order_By>;
  original_review_text?: InputMaybe<Order_By>;
  owner_answer?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  profile_name?: InputMaybe<Order_By>;
  profile_url?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  review_text?: InputMaybe<Order_By>;
  review_url?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "google_reviews" */
export enum Google_Reviews_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  GoogleTimestamp = 'google_timestamp',
  /** column name */
  Id = 'id',
  /** column name */
  LocalGuide = 'local_guide',
  /** column name */
  OriginalOwnerAnswer = 'original_owner_answer',
  /** column name */
  OriginalReviewText = 'original_review_text',
  /** column name */
  OwnerAnswer = 'owner_answer',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  ProfileName = 'profile_name',
  /** column name */
  ProfileUrl = 'profile_url',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewText = 'review_text',
  /** column name */
  ReviewUrl = 'review_url',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "google_reviews_aggregate_bool_exp_bool_and_arguments_columns" columns of table "google_reviews" */
export enum Google_Reviews_Select_Column_Google_Reviews_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  LocalGuide = 'local_guide'
}

/** select "google_reviews_aggregate_bool_exp_bool_or_arguments_columns" columns of table "google_reviews" */
export enum Google_Reviews_Select_Column_Google_Reviews_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  LocalGuide = 'local_guide'
}

/** aggregate stddev on columns */
export type Google_Reviews_Stddev_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "google_reviews" */
export type Google_Reviews_Stddev_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Google_Reviews_Stddev_Pop_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "google_reviews" */
export type Google_Reviews_Stddev_Pop_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Google_Reviews_Stddev_Samp_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "google_reviews" */
export type Google_Reviews_Stddev_Samp_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "google_reviews" */
export type Google_Reviews_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Google_Reviews_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Google_Reviews_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  google_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  local_guide?: InputMaybe<Scalars['Boolean']['input']>;
  original_owner_answer?: InputMaybe<Scalars['String']['input']>;
  original_review_text?: InputMaybe<Scalars['String']['input']>;
  owner_answer?: InputMaybe<Scalars['String']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  profile_name?: InputMaybe<Scalars['String']['input']>;
  profile_url?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_text?: InputMaybe<Scalars['String']['input']>;
  review_url?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Google_Reviews_Sum_Fields = {
  rating?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "google_reviews" */
export type Google_Reviews_Sum_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Google_Reviews_Var_Pop_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "google_reviews" */
export type Google_Reviews_Var_Pop_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Google_Reviews_Var_Samp_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "google_reviews" */
export type Google_Reviews_Var_Samp_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Google_Reviews_Variance_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "google_reviews" */
export type Google_Reviews_Variance_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** columns and relationships of "heating_distribution_enum" */
export type Heating_Distribution_Enum = {
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "heating_distribution_enum". All fields are combined with a logical 'AND'. */
export type Heating_Distribution_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Heating_Distribution_Enum_Bool_Exp>>;
  _not?: InputMaybe<Heating_Distribution_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Heating_Distribution_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Heating_Distribution_Enum_Enum {
  Floor = 'floor',
  ForcedAir = 'forced_air',
  Other = 'other',
  Radiators = 'radiators',
  Stove = 'stove'
}

/** Boolean expression to compare columns of type "heating_distribution_enum_enum". All fields are combined with logical 'AND'. */
export type Heating_Distribution_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Heating_Distribution_Enum_Enum>;
  _in?: InputMaybe<Array<Heating_Distribution_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Heating_Distribution_Enum_Enum>;
  _nin?: InputMaybe<Array<Heating_Distribution_Enum_Enum>>;
};

/** Ordering options when selecting data from "heating_distribution_enum". */
export type Heating_Distribution_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "heating_distribution_enum" */
export enum Heating_Distribution_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "heating_distribution_enum" */
export type Heating_Distribution_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Heating_Distribution_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Heating_Distribution_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "heating_enum" */
export type Heating_Enum = {
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "heating_enum". All fields are combined with a logical 'AND'. */
export type Heating_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Heating_Enum_Bool_Exp>>;
  _not?: InputMaybe<Heating_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Heating_Enum_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Heating_Enum_Enum {
  Central = 'central',
  District = 'district',
  Electric = 'electric',
  Gas = 'gas',
  HeatPump = 'heat_pump',
  None = 'none',
  Oil = 'oil',
  Other = 'other',
  Solar = 'solar',
  Wood = 'wood'
}

/** Boolean expression to compare columns of type "heating_enum_enum". All fields are combined with logical 'AND'. */
export type Heating_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Heating_Enum_Enum>;
  _in?: InputMaybe<Array<Heating_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Heating_Enum_Enum>;
  _nin?: InputMaybe<Array<Heating_Enum_Enum>>;
};

/** Ordering options when selecting data from "heating_enum". */
export type Heating_Enum_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** select columns of table "heating_enum" */
export enum Heating_Enum_Select_Column {
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "heating_enum" */
export type Heating_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Heating_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Heating_Enum_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "images" */
export type Images = {
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  url?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  user_images: Array<User_Images>;
};


/** columns and relationships of "images" */
export type ImagesUser_ImagesArgs = {
  distinct_on?: InputMaybe<Array<User_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Images_Order_By>>;
  where?: InputMaybe<User_Images_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "images". All fields are combined with a logical 'AND'. */
export type Images_Bool_Exp = {
  _and?: InputMaybe<Array<Images_Bool_Exp>>;
  _not?: InputMaybe<Images_Bool_Exp>;
  _or?: InputMaybe<Array<Images_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  user_images?: InputMaybe<User_Images_Bool_Exp>;
};

/** unique or primary key constraints on table "images" */
export enum Images_Constraint {
  /** unique or primary key constraint on columns "id" */
  ImagesPkey = 'images_pkey'
}

/** input type for inserting data into table "images" */
export type Images_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user_images?: InputMaybe<User_Images_Arr_Rel_Insert_Input>;
};

/** response of any mutation on the table "images" */
export type Images_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Images>;
};

/** input type for inserting object relation for remote table "images" */
export type Images_Obj_Rel_Insert_Input = {
  data: Images_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Images_On_Conflict>;
};

/** on_conflict condition type for table "images" */
export type Images_On_Conflict = {
  constraint: Images_Constraint;
  update_columns?: Array<Images_Update_Column>;
  where?: InputMaybe<Images_Bool_Exp>;
};

/** Ordering options when selecting data from "images". */
export type Images_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user_images_aggregate?: InputMaybe<User_Images_Aggregate_Order_By>;
};

/** select columns of table "images" */
export enum Images_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** Streaming cursor of the table "images" */
export type Images_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Images_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Images_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** placeholder for update columns of table "images" (current role has no relevant permissions) */
export enum Images_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "invitations" */
export type Invitations = {
  accepted_at?: Maybe<Scalars['timestamptz']['output']>;
  cancelled_at?: Maybe<Scalars['timestamptz']['output']>;
  email: Scalars['citext']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  invited_by: Users;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
};

/** aggregated selection of "invitations" */
export type Invitations_Aggregate = {
  aggregate?: Maybe<Invitations_Aggregate_Fields>;
  nodes: Array<Invitations>;
};

/** aggregate fields of "invitations" */
export type Invitations_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Invitations_Max_Fields>;
  min?: Maybe<Invitations_Min_Fields>;
};


/** aggregate fields of "invitations" */
export type Invitations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invitations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "invitations". All fields are combined with a logical 'AND'. */
export type Invitations_Bool_Exp = {
  _and?: InputMaybe<Array<Invitations_Bool_Exp>>;
  _not?: InputMaybe<Invitations_Bool_Exp>;
  _or?: InputMaybe<Array<Invitations_Bool_Exp>>;
  accepted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  cancelled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invited_by?: InputMaybe<Users_Bool_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "invitations" */
export enum Invitations_Constraint {
  /** unique or primary key constraint on columns "organisation_id", "tenant_id", "team_id", "email" */
  InvitationsEmailTeamIdOrganisationIdTenantIdKey = 'invitations_email_team_id_organisation_id_tenant_id_key',
  /** unique or primary key constraint on columns "id" */
  InvitationsPkey = 'invitations_pkey',
  /** unique or primary key constraint on columns "token" */
  InvitationsTokenKey = 'invitations_token_key'
}

/** input type for inserting data into table "invitations" */
export type Invitations_Insert_Input = {
  email?: InputMaybe<Scalars['citext']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  invited_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  modules?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Invitations_Max_Fields = {
  accepted_at?: Maybe<Scalars['timestamptz']['output']>;
  cancelled_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Invitations_Min_Fields = {
  accepted_at?: Maybe<Scalars['timestamptz']['output']>;
  cancelled_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "invitations" */
export type Invitations_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Invitations>;
};

/** on_conflict condition type for table "invitations" */
export type Invitations_On_Conflict = {
  constraint: Invitations_Constraint;
  update_columns?: Array<Invitations_Update_Column>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};

/** Ordering options when selecting data from "invitations". */
export type Invitations_Order_By = {
  accepted_at?: InputMaybe<Order_By>;
  cancelled_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invited_by?: InputMaybe<Users_Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invitations */
export type Invitations_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "invitations" */
export enum Invitations_Select_Column {
  /** column name */
  AcceptedAt = 'accepted_at',
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id'
}

/** input type for updating data in table "invitations" */
export type Invitations_Set_Input = {
  cancelled_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "invitations" */
export type Invitations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invitations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invitations_Stream_Cursor_Value_Input = {
  accepted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  cancelled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "invitations" */
export enum Invitations_Update_Column {
  /** column name */
  CancelledAt = 'cancelled_at'
}

export type Invitations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invitations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invitations_Bool_Exp;
};

/** Boolean expression to compare columns of type "invoice_status". All fields are combined with logical 'AND'. */
export type Invoice_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['invoice_status']['input']>;
  _gt?: InputMaybe<Scalars['invoice_status']['input']>;
  _gte?: InputMaybe<Scalars['invoice_status']['input']>;
  _in?: InputMaybe<Array<Scalars['invoice_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['invoice_status']['input']>;
  _lte?: InputMaybe<Scalars['invoice_status']['input']>;
  _neq?: InputMaybe<Scalars['invoice_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['invoice_status']['input']>>;
};

/** columns and relationships of "invoices" */
export type Invoices = {
  account_country?: Maybe<Scalars['String']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  account_tax_ids?: Maybe<Scalars['jsonb']['output']>;
  amount_due?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['Int']['output']>;
  amount_remaining?: Maybe<Scalars['Int']['output']>;
  application_fee_amount?: Maybe<Scalars['Int']['output']>;
  attempt_count?: Maybe<Scalars['Int']['output']>;
  attempted?: Maybe<Scalars['Boolean']['output']>;
  auto_advance: Scalars['Boolean']['output'];
  billing_reason?: Maybe<Scalars['String']['output']>;
  charge?: Maybe<Scalars['String']['output']>;
  collection_method?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency: Scalars['String']['output'];
  custom_fields?: Maybe<Scalars['jsonb']['output']>;
  customer: Scalars['String']['output'];
  customer_address?: Maybe<Scalars['jsonb']['output']>;
  customer_email_raw?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_shipping?: Maybe<Scalars['jsonb']['output']>;
  customer_tax_exempt?: Maybe<Scalars['String']['output']>;
  customer_tax_ids?: Maybe<Scalars['jsonb']['output']>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  default_tax_rates?: Maybe<Scalars['jsonb']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Scalars['jsonb']['output']>;
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  ending_balance?: Maybe<Scalars['Int']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  hosted_invoice_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  invoice_object?: Maybe<Scalars['jsonb']['output']>;
  invoice_pdf?: Maybe<Scalars['String']['output']>;
  last_finalization_error?: Maybe<Scalars['jsonb']['output']>;
  lines?: Maybe<Scalars['jsonb']['output']>;
  livemode: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  next_payment_attempt?: Maybe<Scalars['timestamptz']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  on_behalf_of?: Maybe<Scalars['String']['output']>;
  paid: Scalars['Boolean']['output'];
  payment_intent?: Maybe<Scalars['String']['output']>;
  payment_settings?: Maybe<Scalars['jsonb']['output']>;
  period_end?: Maybe<Scalars['timestamptz']['output']>;
  period_start?: Maybe<Scalars['timestamptz']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  receipt_number?: Maybe<Scalars['String']['output']>;
  starting_balance?: Maybe<Scalars['Int']['output']>;
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  status: Scalars['invoice_status']['output'];
  status_transitions?: Maybe<Scalars['jsonb']['output']>;
  stripe_id: Scalars['String']['output'];
  subscription?: Maybe<Scalars['String']['output']>;
  subscription_proration_date?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  tenant_id: Scalars['uuid']['output'];
  threshold_reason?: Maybe<Scalars['jsonb']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  total_discount_amounts?: Maybe<Scalars['jsonb']['output']>;
  total_tax_amounts?: Maybe<Scalars['jsonb']['output']>;
  transfer_data?: Maybe<Scalars['jsonb']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  webhooks_delivered_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "invoices" */
export type InvoicesAccount_Tax_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesCustom_FieldsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesCustomer_AddressArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesCustomer_ShippingArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesCustomer_Tax_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesDefault_Tax_RatesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesDiscountsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesInvoice_ObjectArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesLast_Finalization_ErrorArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesLinesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesPayment_SettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesStatus_TransitionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesThreshold_ReasonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesTotal_Discount_AmountsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesTotal_Tax_AmountsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesTransfer_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "invoices" */
export type Invoices_Aggregate = {
  aggregate?: Maybe<Invoices_Aggregate_Fields>;
  nodes: Array<Invoices>;
};

export type Invoices_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Invoices_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Invoices_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Invoices_Aggregate_Bool_Exp_Count>;
};

export type Invoices_Aggregate_Bool_Exp_Bool_And = {
  arguments: Invoices_Select_Column_Invoices_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invoices_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoices_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Invoices_Select_Column_Invoices_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invoices_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoices_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invoices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invoices_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invoices" */
export type Invoices_Aggregate_Fields = {
  avg?: Maybe<Invoices_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Invoices_Max_Fields>;
  min?: Maybe<Invoices_Min_Fields>;
  stddev?: Maybe<Invoices_Stddev_Fields>;
  stddev_pop?: Maybe<Invoices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoices_Stddev_Samp_Fields>;
  sum?: Maybe<Invoices_Sum_Fields>;
  var_pop?: Maybe<Invoices_Var_Pop_Fields>;
  var_samp?: Maybe<Invoices_Var_Samp_Fields>;
  variance?: Maybe<Invoices_Variance_Fields>;
};


/** aggregate fields of "invoices" */
export type Invoices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "invoices" */
export type Invoices_Aggregate_Order_By = {
  avg?: InputMaybe<Invoices_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invoices_Max_Order_By>;
  min?: InputMaybe<Invoices_Min_Order_By>;
  stddev?: InputMaybe<Invoices_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Invoices_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Invoices_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Invoices_Sum_Order_By>;
  var_pop?: InputMaybe<Invoices_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Invoices_Var_Samp_Order_By>;
  variance?: InputMaybe<Invoices_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Invoices_Avg_Fields = {
  amount_due?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_remaining?: Maybe<Scalars['Float']['output']>;
  application_fee_amount?: Maybe<Scalars['Float']['output']>;
  attempt_count?: Maybe<Scalars['Float']['output']>;
  ending_balance?: Maybe<Scalars['Float']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  starting_balance?: Maybe<Scalars['Float']['output']>;
  subscription_proration_date?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "invoices" */
export type Invoices_Avg_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "invoices". All fields are combined with a logical 'AND'. */
export type Invoices_Bool_Exp = {
  _and?: InputMaybe<Array<Invoices_Bool_Exp>>;
  _not?: InputMaybe<Invoices_Bool_Exp>;
  _or?: InputMaybe<Array<Invoices_Bool_Exp>>;
  account_country?: InputMaybe<String_Comparison_Exp>;
  account_name?: InputMaybe<String_Comparison_Exp>;
  account_tax_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  amount_due?: InputMaybe<Int_Comparison_Exp>;
  amount_paid?: InputMaybe<Int_Comparison_Exp>;
  amount_remaining?: InputMaybe<Int_Comparison_Exp>;
  application_fee_amount?: InputMaybe<Int_Comparison_Exp>;
  attempt_count?: InputMaybe<Int_Comparison_Exp>;
  attempted?: InputMaybe<Boolean_Comparison_Exp>;
  auto_advance?: InputMaybe<Boolean_Comparison_Exp>;
  billing_reason?: InputMaybe<String_Comparison_Exp>;
  charge?: InputMaybe<String_Comparison_Exp>;
  collection_method?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  custom_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  customer?: InputMaybe<String_Comparison_Exp>;
  customer_address?: InputMaybe<Jsonb_Comparison_Exp>;
  customer_email_raw?: InputMaybe<String_Comparison_Exp>;
  customer_name?: InputMaybe<String_Comparison_Exp>;
  customer_phone?: InputMaybe<String_Comparison_Exp>;
  customer_shipping?: InputMaybe<Jsonb_Comparison_Exp>;
  customer_tax_exempt?: InputMaybe<String_Comparison_Exp>;
  customer_tax_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  default_payment_method?: InputMaybe<String_Comparison_Exp>;
  default_source?: InputMaybe<String_Comparison_Exp>;
  default_tax_rates?: InputMaybe<Jsonb_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  discounts?: InputMaybe<Jsonb_Comparison_Exp>;
  due_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  ending_balance?: InputMaybe<Int_Comparison_Exp>;
  footer?: InputMaybe<String_Comparison_Exp>;
  hosted_invoice_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoice_object?: InputMaybe<Jsonb_Comparison_Exp>;
  invoice_pdf?: InputMaybe<String_Comparison_Exp>;
  last_finalization_error?: InputMaybe<Jsonb_Comparison_Exp>;
  lines?: InputMaybe<Jsonb_Comparison_Exp>;
  livemode?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  next_payment_attempt?: InputMaybe<Timestamptz_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  on_behalf_of?: InputMaybe<String_Comparison_Exp>;
  paid?: InputMaybe<Boolean_Comparison_Exp>;
  payment_intent?: InputMaybe<String_Comparison_Exp>;
  payment_settings?: InputMaybe<Jsonb_Comparison_Exp>;
  period_end?: InputMaybe<Timestamptz_Comparison_Exp>;
  period_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  post_payment_credit_notes_amount?: InputMaybe<Int_Comparison_Exp>;
  pre_payment_credit_notes_amount?: InputMaybe<Int_Comparison_Exp>;
  receipt_number?: InputMaybe<String_Comparison_Exp>;
  starting_balance?: InputMaybe<Int_Comparison_Exp>;
  statement_descriptor?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Invoice_Status_Comparison_Exp>;
  status_transitions?: InputMaybe<Jsonb_Comparison_Exp>;
  stripe_id?: InputMaybe<String_Comparison_Exp>;
  subscription?: InputMaybe<String_Comparison_Exp>;
  subscription_proration_date?: InputMaybe<Int_Comparison_Exp>;
  subtotal?: InputMaybe<Int_Comparison_Exp>;
  tax?: InputMaybe<Int_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  threshold_reason?: InputMaybe<Jsonb_Comparison_Exp>;
  total?: InputMaybe<Int_Comparison_Exp>;
  total_discount_amounts?: InputMaybe<Jsonb_Comparison_Exp>;
  total_tax_amounts?: InputMaybe<Jsonb_Comparison_Exp>;
  transfer_data?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  webhooks_delivered_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Invoices_Max_Fields = {
  account_country?: Maybe<Scalars['String']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  amount_due?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['Int']['output']>;
  amount_remaining?: Maybe<Scalars['Int']['output']>;
  application_fee_amount?: Maybe<Scalars['Int']['output']>;
  attempt_count?: Maybe<Scalars['Int']['output']>;
  billing_reason?: Maybe<Scalars['String']['output']>;
  charge?: Maybe<Scalars['String']['output']>;
  collection_method?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  customer_email_raw?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_tax_exempt?: Maybe<Scalars['String']['output']>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  ending_balance?: Maybe<Scalars['Int']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  hosted_invoice_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoice_pdf?: Maybe<Scalars['String']['output']>;
  next_payment_attempt?: Maybe<Scalars['timestamptz']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  on_behalf_of?: Maybe<Scalars['String']['output']>;
  payment_intent?: Maybe<Scalars['String']['output']>;
  period_end?: Maybe<Scalars['timestamptz']['output']>;
  period_start?: Maybe<Scalars['timestamptz']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  receipt_number?: Maybe<Scalars['String']['output']>;
  starting_balance?: Maybe<Scalars['Int']['output']>;
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['invoice_status']['output']>;
  stripe_id?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Scalars['String']['output']>;
  subscription_proration_date?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  webhooks_delivered_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "invoices" */
export type Invoices_Max_Order_By = {
  account_country?: InputMaybe<Order_By>;
  account_name?: InputMaybe<Order_By>;
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  billing_reason?: InputMaybe<Order_By>;
  charge?: InputMaybe<Order_By>;
  collection_method?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer?: InputMaybe<Order_By>;
  customer_email_raw?: InputMaybe<Order_By>;
  customer_name?: InputMaybe<Order_By>;
  customer_phone?: InputMaybe<Order_By>;
  customer_tax_exempt?: InputMaybe<Order_By>;
  default_payment_method?: InputMaybe<Order_By>;
  default_source?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  footer?: InputMaybe<Order_By>;
  hosted_invoice_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_pdf?: InputMaybe<Order_By>;
  next_payment_attempt?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  on_behalf_of?: InputMaybe<Order_By>;
  payment_intent?: InputMaybe<Order_By>;
  period_end?: InputMaybe<Order_By>;
  period_start?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  receipt_number?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  statement_descriptor?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  webhooks_delivered_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invoices_Min_Fields = {
  account_country?: Maybe<Scalars['String']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  amount_due?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['Int']['output']>;
  amount_remaining?: Maybe<Scalars['Int']['output']>;
  application_fee_amount?: Maybe<Scalars['Int']['output']>;
  attempt_count?: Maybe<Scalars['Int']['output']>;
  billing_reason?: Maybe<Scalars['String']['output']>;
  charge?: Maybe<Scalars['String']['output']>;
  collection_method?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  customer_email_raw?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_tax_exempt?: Maybe<Scalars['String']['output']>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  ending_balance?: Maybe<Scalars['Int']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  hosted_invoice_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoice_pdf?: Maybe<Scalars['String']['output']>;
  next_payment_attempt?: Maybe<Scalars['timestamptz']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  on_behalf_of?: Maybe<Scalars['String']['output']>;
  payment_intent?: Maybe<Scalars['String']['output']>;
  period_end?: Maybe<Scalars['timestamptz']['output']>;
  period_start?: Maybe<Scalars['timestamptz']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  receipt_number?: Maybe<Scalars['String']['output']>;
  starting_balance?: Maybe<Scalars['Int']['output']>;
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['invoice_status']['output']>;
  stripe_id?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Scalars['String']['output']>;
  subscription_proration_date?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  webhooks_delivered_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "invoices" */
export type Invoices_Min_Order_By = {
  account_country?: InputMaybe<Order_By>;
  account_name?: InputMaybe<Order_By>;
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  billing_reason?: InputMaybe<Order_By>;
  charge?: InputMaybe<Order_By>;
  collection_method?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer?: InputMaybe<Order_By>;
  customer_email_raw?: InputMaybe<Order_By>;
  customer_name?: InputMaybe<Order_By>;
  customer_phone?: InputMaybe<Order_By>;
  customer_tax_exempt?: InputMaybe<Order_By>;
  default_payment_method?: InputMaybe<Order_By>;
  default_source?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  footer?: InputMaybe<Order_By>;
  hosted_invoice_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_pdf?: InputMaybe<Order_By>;
  next_payment_attempt?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  on_behalf_of?: InputMaybe<Order_By>;
  payment_intent?: InputMaybe<Order_By>;
  period_end?: InputMaybe<Order_By>;
  period_start?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  receipt_number?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  statement_descriptor?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  webhooks_delivered_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "invoices". */
export type Invoices_Order_By = {
  account_country?: InputMaybe<Order_By>;
  account_name?: InputMaybe<Order_By>;
  account_tax_ids?: InputMaybe<Order_By>;
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  attempted?: InputMaybe<Order_By>;
  auto_advance?: InputMaybe<Order_By>;
  billing_reason?: InputMaybe<Order_By>;
  charge?: InputMaybe<Order_By>;
  collection_method?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  custom_fields?: InputMaybe<Order_By>;
  customer?: InputMaybe<Order_By>;
  customer_address?: InputMaybe<Order_By>;
  customer_email_raw?: InputMaybe<Order_By>;
  customer_name?: InputMaybe<Order_By>;
  customer_phone?: InputMaybe<Order_By>;
  customer_shipping?: InputMaybe<Order_By>;
  customer_tax_exempt?: InputMaybe<Order_By>;
  customer_tax_ids?: InputMaybe<Order_By>;
  default_payment_method?: InputMaybe<Order_By>;
  default_source?: InputMaybe<Order_By>;
  default_tax_rates?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discounts?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  footer?: InputMaybe<Order_By>;
  hosted_invoice_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_object?: InputMaybe<Order_By>;
  invoice_pdf?: InputMaybe<Order_By>;
  last_finalization_error?: InputMaybe<Order_By>;
  lines?: InputMaybe<Order_By>;
  livemode?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  next_payment_attempt?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  on_behalf_of?: InputMaybe<Order_By>;
  paid?: InputMaybe<Order_By>;
  payment_intent?: InputMaybe<Order_By>;
  payment_settings?: InputMaybe<Order_By>;
  period_end?: InputMaybe<Order_By>;
  period_start?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  receipt_number?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  statement_descriptor?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_transitions?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  threshold_reason?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  total_discount_amounts?: InputMaybe<Order_By>;
  total_tax_amounts?: InputMaybe<Order_By>;
  transfer_data?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  webhooks_delivered_at?: InputMaybe<Order_By>;
};

/** select columns of table "invoices" */
export enum Invoices_Select_Column {
  /** column name */
  AccountCountry = 'account_country',
  /** column name */
  AccountName = 'account_name',
  /** column name */
  AccountTaxIds = 'account_tax_ids',
  /** column name */
  AmountDue = 'amount_due',
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  AmountRemaining = 'amount_remaining',
  /** column name */
  ApplicationFeeAmount = 'application_fee_amount',
  /** column name */
  AttemptCount = 'attempt_count',
  /** column name */
  Attempted = 'attempted',
  /** column name */
  AutoAdvance = 'auto_advance',
  /** column name */
  BillingReason = 'billing_reason',
  /** column name */
  Charge = 'charge',
  /** column name */
  CollectionMethod = 'collection_method',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  Customer = 'customer',
  /** column name */
  CustomerAddress = 'customer_address',
  /** column name */
  CustomerEmailRaw = 'customer_email_raw',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  CustomerPhone = 'customer_phone',
  /** column name */
  CustomerShipping = 'customer_shipping',
  /** column name */
  CustomerTaxExempt = 'customer_tax_exempt',
  /** column name */
  CustomerTaxIds = 'customer_tax_ids',
  /** column name */
  DefaultPaymentMethod = 'default_payment_method',
  /** column name */
  DefaultSource = 'default_source',
  /** column name */
  DefaultTaxRates = 'default_tax_rates',
  /** column name */
  Description = 'description',
  /** column name */
  Discounts = 'discounts',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  EndingBalance = 'ending_balance',
  /** column name */
  Footer = 'footer',
  /** column name */
  HostedInvoiceUrl = 'hosted_invoice_url',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceObject = 'invoice_object',
  /** column name */
  InvoicePdf = 'invoice_pdf',
  /** column name */
  LastFinalizationError = 'last_finalization_error',
  /** column name */
  Lines = 'lines',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextPaymentAttempt = 'next_payment_attempt',
  /** column name */
  Number = 'number',
  /** column name */
  OnBehalfOf = 'on_behalf_of',
  /** column name */
  Paid = 'paid',
  /** column name */
  PaymentIntent = 'payment_intent',
  /** column name */
  PaymentSettings = 'payment_settings',
  /** column name */
  PeriodEnd = 'period_end',
  /** column name */
  PeriodStart = 'period_start',
  /** column name */
  PostPaymentCreditNotesAmount = 'post_payment_credit_notes_amount',
  /** column name */
  PrePaymentCreditNotesAmount = 'pre_payment_credit_notes_amount',
  /** column name */
  ReceiptNumber = 'receipt_number',
  /** column name */
  StartingBalance = 'starting_balance',
  /** column name */
  StatementDescriptor = 'statement_descriptor',
  /** column name */
  Status = 'status',
  /** column name */
  StatusTransitions = 'status_transitions',
  /** column name */
  StripeId = 'stripe_id',
  /** column name */
  Subscription = 'subscription',
  /** column name */
  SubscriptionProrationDate = 'subscription_proration_date',
  /** column name */
  Subtotal = 'subtotal',
  /** column name */
  Tax = 'tax',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThresholdReason = 'threshold_reason',
  /** column name */
  Total = 'total',
  /** column name */
  TotalDiscountAmounts = 'total_discount_amounts',
  /** column name */
  TotalTaxAmounts = 'total_tax_amounts',
  /** column name */
  TransferData = 'transfer_data',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WebhooksDeliveredAt = 'webhooks_delivered_at'
}

/** select "invoices_aggregate_bool_exp_bool_and_arguments_columns" columns of table "invoices" */
export enum Invoices_Select_Column_Invoices_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Attempted = 'attempted',
  /** column name */
  AutoAdvance = 'auto_advance',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Paid = 'paid'
}

/** select "invoices_aggregate_bool_exp_bool_or_arguments_columns" columns of table "invoices" */
export enum Invoices_Select_Column_Invoices_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Attempted = 'attempted',
  /** column name */
  AutoAdvance = 'auto_advance',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Paid = 'paid'
}

/** aggregate stddev on columns */
export type Invoices_Stddev_Fields = {
  amount_due?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_remaining?: Maybe<Scalars['Float']['output']>;
  application_fee_amount?: Maybe<Scalars['Float']['output']>;
  attempt_count?: Maybe<Scalars['Float']['output']>;
  ending_balance?: Maybe<Scalars['Float']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  starting_balance?: Maybe<Scalars['Float']['output']>;
  subscription_proration_date?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "invoices" */
export type Invoices_Stddev_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Invoices_Stddev_Pop_Fields = {
  amount_due?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_remaining?: Maybe<Scalars['Float']['output']>;
  application_fee_amount?: Maybe<Scalars['Float']['output']>;
  attempt_count?: Maybe<Scalars['Float']['output']>;
  ending_balance?: Maybe<Scalars['Float']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  starting_balance?: Maybe<Scalars['Float']['output']>;
  subscription_proration_date?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "invoices" */
export type Invoices_Stddev_Pop_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Invoices_Stddev_Samp_Fields = {
  amount_due?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_remaining?: Maybe<Scalars['Float']['output']>;
  application_fee_amount?: Maybe<Scalars['Float']['output']>;
  attempt_count?: Maybe<Scalars['Float']['output']>;
  ending_balance?: Maybe<Scalars['Float']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  starting_balance?: Maybe<Scalars['Float']['output']>;
  subscription_proration_date?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "invoices" */
export type Invoices_Stddev_Samp_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "invoices" */
export type Invoices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoices_Stream_Cursor_Value_Input = {
  account_country?: InputMaybe<Scalars['String']['input']>;
  account_name?: InputMaybe<Scalars['String']['input']>;
  account_tax_ids?: InputMaybe<Scalars['jsonb']['input']>;
  amount_due?: InputMaybe<Scalars['Int']['input']>;
  amount_paid?: InputMaybe<Scalars['Int']['input']>;
  amount_remaining?: InputMaybe<Scalars['Int']['input']>;
  application_fee_amount?: InputMaybe<Scalars['Int']['input']>;
  attempt_count?: InputMaybe<Scalars['Int']['input']>;
  attempted?: InputMaybe<Scalars['Boolean']['input']>;
  auto_advance?: InputMaybe<Scalars['Boolean']['input']>;
  billing_reason?: InputMaybe<Scalars['String']['input']>;
  charge?: InputMaybe<Scalars['String']['input']>;
  collection_method?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  custom_fields?: InputMaybe<Scalars['jsonb']['input']>;
  customer?: InputMaybe<Scalars['String']['input']>;
  customer_address?: InputMaybe<Scalars['jsonb']['input']>;
  customer_email_raw?: InputMaybe<Scalars['String']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  customer_phone?: InputMaybe<Scalars['String']['input']>;
  customer_shipping?: InputMaybe<Scalars['jsonb']['input']>;
  customer_tax_exempt?: InputMaybe<Scalars['String']['input']>;
  customer_tax_ids?: InputMaybe<Scalars['jsonb']['input']>;
  default_payment_method?: InputMaybe<Scalars['String']['input']>;
  default_source?: InputMaybe<Scalars['String']['input']>;
  default_tax_rates?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Scalars['jsonb']['input']>;
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  ending_balance?: InputMaybe<Scalars['Int']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  hosted_invoice_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_object?: InputMaybe<Scalars['jsonb']['input']>;
  invoice_pdf?: InputMaybe<Scalars['String']['input']>;
  last_finalization_error?: InputMaybe<Scalars['jsonb']['input']>;
  lines?: InputMaybe<Scalars['jsonb']['input']>;
  livemode?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  next_payment_attempt?: InputMaybe<Scalars['timestamptz']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  on_behalf_of?: InputMaybe<Scalars['String']['input']>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_settings?: InputMaybe<Scalars['jsonb']['input']>;
  period_end?: InputMaybe<Scalars['timestamptz']['input']>;
  period_start?: InputMaybe<Scalars['timestamptz']['input']>;
  post_payment_credit_notes_amount?: InputMaybe<Scalars['Int']['input']>;
  pre_payment_credit_notes_amount?: InputMaybe<Scalars['Int']['input']>;
  receipt_number?: InputMaybe<Scalars['String']['input']>;
  starting_balance?: InputMaybe<Scalars['Int']['input']>;
  statement_descriptor?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['invoice_status']['input']>;
  status_transitions?: InputMaybe<Scalars['jsonb']['input']>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  subscription?: InputMaybe<Scalars['String']['input']>;
  subscription_proration_date?: InputMaybe<Scalars['Int']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  tax?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  threshold_reason?: InputMaybe<Scalars['jsonb']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  total_discount_amounts?: InputMaybe<Scalars['jsonb']['input']>;
  total_tax_amounts?: InputMaybe<Scalars['jsonb']['input']>;
  transfer_data?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  webhooks_delivered_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Invoices_Sum_Fields = {
  amount_due?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['Int']['output']>;
  amount_remaining?: Maybe<Scalars['Int']['output']>;
  application_fee_amount?: Maybe<Scalars['Int']['output']>;
  attempt_count?: Maybe<Scalars['Int']['output']>;
  ending_balance?: Maybe<Scalars['Int']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  starting_balance?: Maybe<Scalars['Int']['output']>;
  subscription_proration_date?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "invoices" */
export type Invoices_Sum_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Invoices_Var_Pop_Fields = {
  amount_due?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_remaining?: Maybe<Scalars['Float']['output']>;
  application_fee_amount?: Maybe<Scalars['Float']['output']>;
  attempt_count?: Maybe<Scalars['Float']['output']>;
  ending_balance?: Maybe<Scalars['Float']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  starting_balance?: Maybe<Scalars['Float']['output']>;
  subscription_proration_date?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "invoices" */
export type Invoices_Var_Pop_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Invoices_Var_Samp_Fields = {
  amount_due?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_remaining?: Maybe<Scalars['Float']['output']>;
  application_fee_amount?: Maybe<Scalars['Float']['output']>;
  attempt_count?: Maybe<Scalars['Float']['output']>;
  ending_balance?: Maybe<Scalars['Float']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  starting_balance?: Maybe<Scalars['Float']['output']>;
  subscription_proration_date?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "invoices" */
export type Invoices_Var_Samp_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Invoices_Variance_Fields = {
  amount_due?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_remaining?: Maybe<Scalars['Float']['output']>;
  application_fee_amount?: Maybe<Scalars['Float']['output']>;
  attempt_count?: Maybe<Scalars['Float']['output']>;
  ending_balance?: Maybe<Scalars['Float']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  starting_balance?: Maybe<Scalars['Float']['output']>;
  subscription_proration_date?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "invoices" */
export type Invoices_Variance_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** columns and relationships of "cma_listings" */
export type It_Cma_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<It_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: It_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "listing_is_online" */
  is_online?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  /** Gets all places associated with this listing */
  places?: Maybe<Array<It_Places>>;
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  /** An object relationship */
  property_types?: Maybe<It_Property_Types>;
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id: Scalars['uuid']['output'];
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "cma_listings" */
export type It_Cma_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_listings" */
export type It_Cma_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_listings" */
export type It_Cma_ListingsPlacesArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** columns and relationships of "cma_listings" */
export type It_Cma_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cma_listings" */
export type It_Cma_Listings_Aggregate = {
  aggregate?: Maybe<It_Cma_Listings_Aggregate_Fields>;
  nodes: Array<It_Cma_Listings>;
};

/** aggregate fields of "cma_listings" */
export type It_Cma_Listings_Aggregate_Fields = {
  avg?: Maybe<It_Cma_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_Cma_Listings_Max_Fields>;
  min?: Maybe<It_Cma_Listings_Min_Fields>;
  stddev?: Maybe<It_Cma_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<It_Cma_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_Cma_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<It_Cma_Listings_Sum_Fields>;
  var_pop?: Maybe<It_Cma_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<It_Cma_Listings_Var_Samp_Fields>;
  variance?: Maybe<It_Cma_Listings_Variance_Fields>;
};


/** aggregate fields of "cma_listings" */
export type It_Cma_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_Cma_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type It_Cma_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_listings". All fields are combined with a logical 'AND'. */
export type It_Cma_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<It_Cma_Listings_Bool_Exp>>;
  _not?: InputMaybe<It_Cma_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<It_Cma_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  available_from?: InputMaybe<Date_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<It_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_online?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  places?: InputMaybe<It_Places_Bool_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  property_types?: InputMaybe<It_Property_Types_Bool_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type It_Cma_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type It_Cma_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "cma_listings". */
export type It_Cma_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  available_from?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<It_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_online?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<It_Places_Aggregate_Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  property_types?: InputMaybe<It_Property_Types_Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "cma_listings" */
export enum It_Cma_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type It_Cma_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type It_Cma_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type It_Cma_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type It_Cma_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type It_Cma_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type It_Cma_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type It_Cma_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "get_merged_listings_type" */
export type It_Get_Merged_Listings_Type = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Scalars['json']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  removed?: Maybe<Scalars['Boolean']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "get_merged_listings_type" */
export type It_Get_Merged_Listings_TypeImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "get_merged_listings_type". All fields are combined with a logical 'AND'. */
export type It_Get_Merged_Listings_Type_Bool_Exp = {
  _and?: InputMaybe<Array<It_Get_Merged_Listings_Type_Bool_Exp>>;
  _not?: InputMaybe<It_Get_Merged_Listings_Type_Bool_Exp>;
  _or?: InputMaybe<Array<It_Get_Merged_Listings_Type_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Json_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
};

/** Ordering options when selecting data from "get_merged_listings_type". */
export type It_Get_Merged_Listings_Type_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
};

/** select columns of table "get_merged_listings_type" */
export enum It_Get_Merged_Listings_Type_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UsableSurface = 'usable_surface'
}

/** columns and relationships of "merged_images" */
export type It_Merged_Images = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "merged_images" */
export type It_Merged_Images_Aggregate = {
  aggregate?: Maybe<It_Merged_Images_Aggregate_Fields>;
  nodes: Array<It_Merged_Images>;
};

/** aggregate fields of "merged_images" */
export type It_Merged_Images_Aggregate_Fields = {
  avg?: Maybe<It_Merged_Images_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_Merged_Images_Max_Fields>;
  min?: Maybe<It_Merged_Images_Min_Fields>;
  stddev?: Maybe<It_Merged_Images_Stddev_Fields>;
  stddev_pop?: Maybe<It_Merged_Images_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_Merged_Images_Stddev_Samp_Fields>;
  sum?: Maybe<It_Merged_Images_Sum_Fields>;
  var_pop?: Maybe<It_Merged_Images_Var_Pop_Fields>;
  var_samp?: Maybe<It_Merged_Images_Var_Samp_Fields>;
  variance?: Maybe<It_Merged_Images_Variance_Fields>;
};


/** aggregate fields of "merged_images" */
export type It_Merged_Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "merged_images" */
export type It_Merged_Images_Aggregate_Order_By = {
  avg?: InputMaybe<It_Merged_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<It_Merged_Images_Max_Order_By>;
  min?: InputMaybe<It_Merged_Images_Min_Order_By>;
  stddev?: InputMaybe<It_Merged_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<It_Merged_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<It_Merged_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<It_Merged_Images_Sum_Order_By>;
  var_pop?: InputMaybe<It_Merged_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<It_Merged_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<It_Merged_Images_Variance_Order_By>;
};

/** aggregate avg on columns */
export type It_Merged_Images_Avg_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "merged_images" */
export type It_Merged_Images_Avg_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "merged_images". All fields are combined with a logical 'AND'. */
export type It_Merged_Images_Bool_Exp = {
  _and?: InputMaybe<Array<It_Merged_Images_Bool_Exp>>;
  _not?: InputMaybe<It_Merged_Images_Bool_Exp>;
  _or?: InputMaybe<Array<It_Merged_Images_Bool_Exp>>;
  bucket_name?: InputMaybe<String_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_index?: InputMaybe<Int_Comparison_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type It_Merged_Images_Max_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "merged_images" */
export type It_Merged_Images_Max_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type It_Merged_Images_Min_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "merged_images" */
export type It_Merged_Images_Min_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "merged_images". */
export type It_Merged_Images_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** select columns of table "merged_images" */
export enum It_Merged_Images_Select_Column {
  /** column name */
  BucketName = 'bucket_name',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImageIndex = 'image_index',
  /** column name */
  ListingId = 'listing_id'
}

/** aggregate stddev on columns */
export type It_Merged_Images_Stddev_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "merged_images" */
export type It_Merged_Images_Stddev_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type It_Merged_Images_Stddev_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "merged_images" */
export type It_Merged_Images_Stddev_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type It_Merged_Images_Stddev_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "merged_images" */
export type It_Merged_Images_Stddev_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type It_Merged_Images_Sum_Fields = {
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "merged_images" */
export type It_Merged_Images_Sum_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type It_Merged_Images_Var_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "merged_images" */
export type It_Merged_Images_Var_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type It_Merged_Images_Var_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "merged_images" */
export type It_Merged_Images_Var_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type It_Merged_Images_Variance_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "merged_images" */
export type It_Merged_Images_Variance_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "merged_listings" */
export type It_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<It_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: It_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "merged_listings" */
export type It_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "merged_listings" */
export type It_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "merged_listings" */
export type It_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "merged_listings" */
export type It_Merged_Listings_Aggregate = {
  aggregate?: Maybe<It_Merged_Listings_Aggregate_Fields>;
  nodes: Array<It_Merged_Listings>;
};

/** aggregate fields of "merged_listings" */
export type It_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<It_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_Merged_Listings_Max_Fields>;
  min?: Maybe<It_Merged_Listings_Min_Fields>;
  stddev?: Maybe<It_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<It_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<It_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<It_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<It_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<It_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "merged_listings" */
export type It_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type It_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "merged_listings". All fields are combined with a logical 'AND'. */
export type It_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<It_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<It_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<It_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<It_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type It_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type It_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "merged_listings". */
export type It_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<It_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "merged_listings" */
export enum It_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type It_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type It_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type It_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type It_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type It_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type It_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type It_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "places" */
export type It_Places = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  breadcrumbs: Array<It_Places_Breadcrumbs>;
  /** An aggregate relationship */
  breadcrumbs_aggregate: It_Places_Breadcrumbs_Aggregate;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  canonical_place?: Maybe<It_Places>;
  children_bbox?: Maybe<Scalars['jsonb']['output']>;
  /** A computed field, executes function "count_children_place" */
  children_count?: Maybe<Scalars['Int']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  extra: Scalars['jsonb']['output'];
  geom: Scalars['geometry']['output'];
  id: Scalars['uuid']['output'];
  index: Scalars['Boolean']['output'];
  /** to use instead of label_en label_de etc, x-hasura-website-language must be set */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  municipality?: Maybe<It_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  municipality_places: Array<It_Places>;
  /** An aggregate relationship */
  municipality_places_aggregate: It_Places_Aggregate;
  name: Scalars['String']['output'];
  /** An array relationship */
  neighbourhood: Array<It_Places>;
  /** An aggregate relationship */
  neighbourhood_aggregate: It_Places_Aggregate;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  region: Array<It_Places>;
  /** An aggregate relationship */
  region_aggregate: It_Places_Aggregate;
  region_id?: Maybe<Scalars['uuid']['output']>;
  search_base: Scalars['tsvector']['output'];
  /** to use instead of slug_en slug_de etc, x-hasura-website-language must be set */
  slug?: Maybe<Scalars['String']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  state: Array<It_Places>;
  /** An aggregate relationship */
  state_aggregate: It_Places_Aggregate;
  state_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  state_places: Array<It_Places>;
  /** An aggregate relationship */
  state_places_aggregate: It_Places_Aggregate;
  type: Scalars['String']['output'];
};


/** columns and relationships of "places" */
export type It_PlacesBreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<It_Places_Breadcrumbs_Bool_Exp>;
};


/** columns and relationships of "places" */
export type It_PlacesBreadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<It_Places_Breadcrumbs_Bool_Exp>;
};


/** columns and relationships of "places" */
export type It_PlacesChildren_BboxArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "places" */
export type It_PlacesExtraArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "places" */
export type It_PlacesMunicipality_PlacesArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type It_PlacesMunicipality_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type It_PlacesNeighbourhoodArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type It_PlacesNeighbourhood_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type It_PlacesRegionArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type It_PlacesRegion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type It_PlacesStateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type It_PlacesState_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type It_PlacesState_PlacesArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type It_PlacesState_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};

/** aggregated selection of "places" */
export type It_Places_Aggregate = {
  aggregate?: Maybe<It_Places_Aggregate_Fields>;
  nodes: Array<It_Places>;
};

/** aggregate fields of "places" */
export type It_Places_Aggregate_Fields = {
  avg?: Maybe<It_Places_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_Places_Max_Fields>;
  min?: Maybe<It_Places_Min_Fields>;
  stddev?: Maybe<It_Places_Stddev_Fields>;
  stddev_pop?: Maybe<It_Places_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_Places_Stddev_Samp_Fields>;
  sum?: Maybe<It_Places_Sum_Fields>;
  var_pop?: Maybe<It_Places_Var_Pop_Fields>;
  var_samp?: Maybe<It_Places_Var_Samp_Fields>;
  variance?: Maybe<It_Places_Variance_Fields>;
};


/** aggregate fields of "places" */
export type It_Places_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_Places_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places" */
export type It_Places_Aggregate_Order_By = {
  avg?: InputMaybe<It_Places_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<It_Places_Max_Order_By>;
  min?: InputMaybe<It_Places_Min_Order_By>;
  stddev?: InputMaybe<It_Places_Stddev_Order_By>;
  stddev_pop?: InputMaybe<It_Places_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<It_Places_Stddev_Samp_Order_By>;
  sum?: InputMaybe<It_Places_Sum_Order_By>;
  var_pop?: InputMaybe<It_Places_Var_Pop_Order_By>;
  var_samp?: InputMaybe<It_Places_Var_Samp_Order_By>;
  variance?: InputMaybe<It_Places_Variance_Order_By>;
};

/** aggregate avg on columns */
export type It_Places_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places" */
export type It_Places_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places". All fields are combined with a logical 'AND'. */
export type It_Places_Bool_Exp = {
  _and?: InputMaybe<Array<It_Places_Bool_Exp>>;
  _not?: InputMaybe<It_Places_Bool_Exp>;
  _or?: InputMaybe<Array<It_Places_Bool_Exp>>;
  agglomeration_id?: InputMaybe<Uuid_Comparison_Exp>;
  breadcrumbs?: InputMaybe<It_Places_Breadcrumbs_Bool_Exp>;
  canonical_id?: InputMaybe<Uuid_Comparison_Exp>;
  canonical_place?: InputMaybe<It_Places_Bool_Exp>;
  children_bbox?: InputMaybe<Jsonb_Comparison_Exp>;
  children_count?: InputMaybe<Int_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  extra?: InputMaybe<Jsonb_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  index?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality?: InputMaybe<It_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality_places?: InputMaybe<It_Places_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  neighbourhood?: InputMaybe<It_Places_Bool_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  population?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<It_Places_Bool_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  search_base?: InputMaybe<Tsvector_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  slug_de?: InputMaybe<String_Comparison_Exp>;
  slug_en?: InputMaybe<String_Comparison_Exp>;
  slug_es?: InputMaybe<String_Comparison_Exp>;
  slug_fr?: InputMaybe<String_Comparison_Exp>;
  slug_it?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<It_Places_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  state_places?: InputMaybe<It_Places_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "places_breadcrumbs" */
export type It_Places_Breadcrumbs = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  place?: Maybe<It_Places>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Aggregate = {
  aggregate?: Maybe<It_Places_Breadcrumbs_Aggregate_Fields>;
  nodes: Array<It_Places_Breadcrumbs>;
};

/** aggregate fields of "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Aggregate_Fields = {
  avg?: Maybe<It_Places_Breadcrumbs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_Places_Breadcrumbs_Max_Fields>;
  min?: Maybe<It_Places_Breadcrumbs_Min_Fields>;
  stddev?: Maybe<It_Places_Breadcrumbs_Stddev_Fields>;
  stddev_pop?: Maybe<It_Places_Breadcrumbs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_Places_Breadcrumbs_Stddev_Samp_Fields>;
  sum?: Maybe<It_Places_Breadcrumbs_Sum_Fields>;
  var_pop?: Maybe<It_Places_Breadcrumbs_Var_Pop_Fields>;
  var_samp?: Maybe<It_Places_Breadcrumbs_Var_Samp_Fields>;
  variance?: Maybe<It_Places_Breadcrumbs_Variance_Fields>;
};


/** aggregate fields of "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_Places_Breadcrumbs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Aggregate_Order_By = {
  avg?: InputMaybe<It_Places_Breadcrumbs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<It_Places_Breadcrumbs_Max_Order_By>;
  min?: InputMaybe<It_Places_Breadcrumbs_Min_Order_By>;
  stddev?: InputMaybe<It_Places_Breadcrumbs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<It_Places_Breadcrumbs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<It_Places_Breadcrumbs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<It_Places_Breadcrumbs_Sum_Order_By>;
  var_pop?: InputMaybe<It_Places_Breadcrumbs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<It_Places_Breadcrumbs_Var_Samp_Order_By>;
  variance?: InputMaybe<It_Places_Breadcrumbs_Variance_Order_By>;
};

/** aggregate avg on columns */
export type It_Places_Breadcrumbs_Avg_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Avg_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places_breadcrumbs". All fields are combined with a logical 'AND'. */
export type It_Places_Breadcrumbs_Bool_Exp = {
  _and?: InputMaybe<Array<It_Places_Breadcrumbs_Bool_Exp>>;
  _not?: InputMaybe<It_Places_Breadcrumbs_Bool_Exp>;
  _or?: InputMaybe<Array<It_Places_Breadcrumbs_Bool_Exp>>;
  breadcrumb_place_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_num?: InputMaybe<Bigint_Comparison_Exp>;
  place?: InputMaybe<It_Places_Bool_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type It_Places_Breadcrumbs_Max_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Max_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type It_Places_Breadcrumbs_Min_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Min_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places_breadcrumbs". */
export type It_Places_Breadcrumbs_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place?: InputMaybe<It_Places_Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** select columns of table "places_breadcrumbs" */
export enum It_Places_Breadcrumbs_Select_Column {
  /** column name */
  BreadcrumbPlaceId = 'breadcrumb_place_id',
  /** column name */
  OrderNum = 'order_num',
  /** column name */
  PlaceId = 'place_id'
}

/** aggregate stddev on columns */
export type It_Places_Breadcrumbs_Stddev_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Stddev_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type It_Places_Breadcrumbs_Stddev_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Stddev_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type It_Places_Breadcrumbs_Stddev_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Stddev_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type It_Places_Breadcrumbs_Sum_Fields = {
  order_num?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Sum_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type It_Places_Breadcrumbs_Var_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Var_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type It_Places_Breadcrumbs_Var_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Var_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type It_Places_Breadcrumbs_Variance_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Variance_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type It_Places_Max_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "places" */
export type It_Places_Max_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type It_Places_Min_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "places" */
export type It_Places_Min_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places". */
export type It_Places_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  breadcrumbs_aggregate?: InputMaybe<It_Places_Breadcrumbs_Aggregate_Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  canonical_place?: InputMaybe<It_Places_Order_By>;
  children_bbox?: InputMaybe<Order_By>;
  children_count?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality?: InputMaybe<It_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  municipality_places_aggregate?: InputMaybe<It_Places_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_aggregate?: InputMaybe<It_Places_Aggregate_Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_aggregate?: InputMaybe<It_Places_Aggregate_Order_By>;
  region_id?: InputMaybe<Order_By>;
  search_base?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  state_aggregate?: InputMaybe<It_Places_Aggregate_Order_By>;
  state_id?: InputMaybe<Order_By>;
  state_places_aggregate?: InputMaybe<It_Places_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "places" */
export enum It_Places_Select_Column {
  /** column name */
  AgglomerationId = 'agglomeration_id',
  /** column name */
  CanonicalId = 'canonical_id',
  /** column name */
  ChildrenBbox = 'children_bbox',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  Population = 'population',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SearchBase = 'search_base',
  /** column name */
  SlugDe = 'slug_de',
  /** column name */
  SlugEn = 'slug_en',
  /** column name */
  SlugEs = 'slug_es',
  /** column name */
  SlugFr = 'slug_fr',
  /** column name */
  SlugIt = 'slug_it',
  /** column name */
  StateId = 'state_id',
  /** column name */
  Type = 'type'
}

/** aggregate stddev on columns */
export type It_Places_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places" */
export type It_Places_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type It_Places_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places" */
export type It_Places_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type It_Places_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places" */
export type It_Places_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type It_Places_Sum_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "places" */
export type It_Places_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type It_Places_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places" */
export type It_Places_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type It_Places_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places" */
export type It_Places_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type It_Places_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places" */
export type It_Places_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** columns and relationships of "post_merged_listings" */
export type It_Post_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** A computed field, executes function "get_least_created_at" */
  created_at_consolidated?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<It_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: It_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_listing_images" */
  listing_images?: Maybe<Array<It_Merged_Images>>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_object?: Maybe<It_Places>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  municipality?: Maybe<It_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "post_merged_listings" */
export type It_Post_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "post_merged_listings" */
export type It_Post_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "post_merged_listings" */
export type It_Post_Merged_ListingsListing_ImagesArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "post_merged_listings" */
export type It_Post_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type It_Post_Merged_Listings_Aggregate = {
  aggregate?: Maybe<It_Post_Merged_Listings_Aggregate_Fields>;
  nodes: Array<It_Post_Merged_Listings>;
};

/** aggregate fields of "post_merged_listings" */
export type It_Post_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<It_Post_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_Post_Merged_Listings_Max_Fields>;
  min?: Maybe<It_Post_Merged_Listings_Min_Fields>;
  stddev?: Maybe<It_Post_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<It_Post_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_Post_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<It_Post_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<It_Post_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<It_Post_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<It_Post_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "post_merged_listings" */
export type It_Post_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_Post_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type It_Post_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "post_merged_listings". All fields are combined with a logical 'AND'. */
export type It_Post_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<It_Post_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<It_Post_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<It_Post_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at_consolidated?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<It_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_images?: InputMaybe<It_Merged_Images_Bool_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_object?: InputMaybe<It_Places_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality?: InputMaybe<It_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type It_Post_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type It_Post_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "post_merged_listings". */
export type It_Post_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_at_consolidated?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<It_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_images_aggregate?: InputMaybe<It_Merged_Images_Aggregate_Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_object?: InputMaybe<It_Places_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality?: InputMaybe<It_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "post_merged_listings" */
export enum It_Post_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type It_Post_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type It_Post_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type It_Post_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type It_Post_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type It_Post_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type It_Post_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type It_Post_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "property_types" */
export type It_Property_Types = {
  /** A computed field, executes function "property_types_label" */
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "property_types". All fields are combined with a logical 'AND'. */
export type It_Property_Types_Bool_Exp = {
  _and?: InputMaybe<Array<It_Property_Types_Bool_Exp>>;
  _not?: InputMaybe<It_Property_Types_Bool_Exp>;
  _or?: InputMaybe<Array<It_Property_Types_Bool_Exp>>;
  label?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "property_types". */
export type It_Property_Types_Order_By = {
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "property_types" */
export enum It_Property_Types_Select_Column {
  /** column name */
  Name = 'name'
}

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']['input']>;
  _gt?: InputMaybe<Scalars['json']['input']>;
  _gte?: InputMaybe<Scalars['json']['input']>;
  _in?: InputMaybe<Array<Scalars['json']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['json']['input']>;
  _lte?: InputMaybe<Scalars['json']['input']>;
  _neq?: InputMaybe<Scalars['json']['input']>;
  _nin?: InputMaybe<Array<Scalars['json']['input']>>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _eq?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _gt?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _gte?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['jsonb']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _lte?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _neq?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['jsonb']['input']>>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

export type Lead_Agent_Ranking_Properties_Args = {
  exclude_rental_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  offset_count?: InputMaybe<Scalars['Int']['input']>;
  transaction_radius?: InputMaybe<Scalars['float8']['input']>;
};

export enum Lead_Agent_Source_Enum_Enum {
  Automation = 'automation',
  Crm = 'crm',
  ResultPage = 'result_page'
}

/** Boolean expression to compare columns of type "lead_agent_source_enum_enum". All fields are combined with logical 'AND'. */
export type Lead_Agent_Source_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Lead_Agent_Source_Enum_Enum>;
  _in?: InputMaybe<Array<Lead_Agent_Source_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Lead_Agent_Source_Enum_Enum>;
  _nin?: InputMaybe<Array<Lead_Agent_Source_Enum_Enum>>;
};

/** columns and relationships of "lead_agents" */
export type Lead_Agents = {
  claimed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lead: Leads;
  lead_id: Scalars['uuid']['output'];
  /** An object relationship */
  lead_stage?: Maybe<Lead_Stages>;
  passed_at?: Maybe<Scalars['timestamptz']['output']>;
  predicted_win_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Lead_Agent_Source_Enum_Enum>;
  stage_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id: Scalars['uuid']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
  win_probability?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "lead_agents" */
export type Lead_Agents_Aggregate = {
  aggregate?: Maybe<Lead_Agents_Aggregate_Fields>;
  nodes: Array<Lead_Agents>;
};

export type Lead_Agents_Aggregate_Bool_Exp = {
  count?: InputMaybe<Lead_Agents_Aggregate_Bool_Exp_Count>;
};

export type Lead_Agents_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lead_Agents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "lead_agents" */
export type Lead_Agents_Aggregate_Fields = {
  avg?: Maybe<Lead_Agents_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lead_Agents_Max_Fields>;
  min?: Maybe<Lead_Agents_Min_Fields>;
  stddev?: Maybe<Lead_Agents_Stddev_Fields>;
  stddev_pop?: Maybe<Lead_Agents_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lead_Agents_Stddev_Samp_Fields>;
  sum?: Maybe<Lead_Agents_Sum_Fields>;
  var_pop?: Maybe<Lead_Agents_Var_Pop_Fields>;
  var_samp?: Maybe<Lead_Agents_Var_Samp_Fields>;
  variance?: Maybe<Lead_Agents_Variance_Fields>;
};


/** aggregate fields of "lead_agents" */
export type Lead_Agents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lead_agents" */
export type Lead_Agents_Aggregate_Order_By = {
  avg?: InputMaybe<Lead_Agents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lead_Agents_Max_Order_By>;
  min?: InputMaybe<Lead_Agents_Min_Order_By>;
  stddev?: InputMaybe<Lead_Agents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lead_Agents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lead_Agents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lead_Agents_Sum_Order_By>;
  var_pop?: InputMaybe<Lead_Agents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lead_Agents_Var_Samp_Order_By>;
  variance?: InputMaybe<Lead_Agents_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "lead_agents" */
export type Lead_Agents_Arr_Rel_Insert_Input = {
  data: Array<Lead_Agents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lead_Agents_On_Conflict>;
};

/** aggregate avg on columns */
export type Lead_Agents_Avg_Fields = {
  win_probability?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "lead_agents" */
export type Lead_Agents_Avg_Order_By = {
  win_probability?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lead_agents". All fields are combined with a logical 'AND'. */
export type Lead_Agents_Bool_Exp = {
  _and?: InputMaybe<Array<Lead_Agents_Bool_Exp>>;
  _not?: InputMaybe<Lead_Agents_Bool_Exp>;
  _or?: InputMaybe<Array<Lead_Agents_Bool_Exp>>;
  claimed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lead?: InputMaybe<Leads_Bool_Exp>;
  lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  lead_stage?: InputMaybe<Lead_Stages_Bool_Exp>;
  passed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  predicted_win_date?: InputMaybe<Date_Comparison_Exp>;
  source?: InputMaybe<Lead_Agent_Source_Enum_Enum_Comparison_Exp>;
  stage_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  win_probability?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "lead_agents" */
export enum Lead_Agents_Constraint {
  /** unique or primary key constraint on columns "source", "user_id", "lead_id" */
  LeadAgentsLeadIdUserIdSourceKey = 'lead_agents_lead_id_user_id_source_key',
  /** unique or primary key constraint on columns "id" */
  LeadAgentsPkey = 'lead_agents_pkey'
}

/** input type for incrementing numeric columns in table "lead_agents" */
export type Lead_Agents_Inc_Input = {
  win_probability?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "lead_agents" */
export type Lead_Agents_Insert_Input = {
  claimed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lead?: InputMaybe<Leads_Obj_Rel_Insert_Input>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  lead_stage?: InputMaybe<Lead_Stages_Obj_Rel_Insert_Input>;
  predicted_win_date?: InputMaybe<Scalars['date']['input']>;
  source?: InputMaybe<Lead_Agent_Source_Enum_Enum>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  win_probability?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Lead_Agents_Max_Fields = {
  claimed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  passed_at?: Maybe<Scalars['timestamptz']['output']>;
  predicted_win_date?: Maybe<Scalars['date']['output']>;
  stage_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  win_probability?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "lead_agents" */
export type Lead_Agents_Max_Order_By = {
  claimed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  passed_at?: InputMaybe<Order_By>;
  predicted_win_date?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  win_probability?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lead_Agents_Min_Fields = {
  claimed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  passed_at?: Maybe<Scalars['timestamptz']['output']>;
  predicted_win_date?: Maybe<Scalars['date']['output']>;
  stage_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  win_probability?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "lead_agents" */
export type Lead_Agents_Min_Order_By = {
  claimed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  passed_at?: InputMaybe<Order_By>;
  predicted_win_date?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  win_probability?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lead_agents" */
export type Lead_Agents_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lead_Agents>;
};

/** on_conflict condition type for table "lead_agents" */
export type Lead_Agents_On_Conflict = {
  constraint: Lead_Agents_Constraint;
  update_columns?: Array<Lead_Agents_Update_Column>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};

/** Ordering options when selecting data from "lead_agents". */
export type Lead_Agents_Order_By = {
  claimed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead?: InputMaybe<Leads_Order_By>;
  lead_id?: InputMaybe<Order_By>;
  lead_stage?: InputMaybe<Lead_Stages_Order_By>;
  passed_at?: InputMaybe<Order_By>;
  predicted_win_date?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  win_probability?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lead_agents */
export type Lead_Agents_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "lead_agents" */
export enum Lead_Agents_Select_Column {
  /** column name */
  ClaimedAt = 'claimed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  PassedAt = 'passed_at',
  /** column name */
  PredictedWinDate = 'predicted_win_date',
  /** column name */
  Source = 'source',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WinProbability = 'win_probability'
}

/** input type for updating data in table "lead_agents" */
export type Lead_Agents_Set_Input = {
  claimed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  passed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  predicted_win_date?: InputMaybe<Scalars['date']['input']>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  win_probability?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Lead_Agents_Stddev_Fields = {
  win_probability?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "lead_agents" */
export type Lead_Agents_Stddev_Order_By = {
  win_probability?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lead_Agents_Stddev_Pop_Fields = {
  win_probability?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "lead_agents" */
export type Lead_Agents_Stddev_Pop_Order_By = {
  win_probability?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lead_Agents_Stddev_Samp_Fields = {
  win_probability?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "lead_agents" */
export type Lead_Agents_Stddev_Samp_Order_By = {
  win_probability?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lead_agents" */
export type Lead_Agents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lead_Agents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lead_Agents_Stream_Cursor_Value_Input = {
  claimed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  passed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  predicted_win_date?: InputMaybe<Scalars['date']['input']>;
  source?: InputMaybe<Lead_Agent_Source_Enum_Enum>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  win_probability?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Lead_Agents_Sum_Fields = {
  win_probability?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "lead_agents" */
export type Lead_Agents_Sum_Order_By = {
  win_probability?: InputMaybe<Order_By>;
};

/** update columns of table "lead_agents" */
export enum Lead_Agents_Update_Column {
  /** column name */
  ClaimedAt = 'claimed_at',
  /** column name */
  PassedAt = 'passed_at',
  /** column name */
  PredictedWinDate = 'predicted_win_date',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  WinProbability = 'win_probability'
}

export type Lead_Agents_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Lead_Agents_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lead_Agents_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lead_Agents_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Lead_Agents_Var_Pop_Fields = {
  win_probability?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "lead_agents" */
export type Lead_Agents_Var_Pop_Order_By = {
  win_probability?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lead_Agents_Var_Samp_Fields = {
  win_probability?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "lead_agents" */
export type Lead_Agents_Var_Samp_Order_By = {
  win_probability?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lead_Agents_Variance_Fields = {
  win_probability?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "lead_agents" */
export type Lead_Agents_Variance_Order_By = {
  win_probability?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "lead_buying_status". All fields are combined with logical 'AND'. */
export type Lead_Buying_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _gt?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _gte?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _in?: InputMaybe<Array<Scalars['lead_buying_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _lte?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _neq?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['lead_buying_status']['input']>>;
};

/** Boolean expression to filter rows from the table "lead_debts". All fields are combined with a logical 'AND'. */
export type Lead_Debts_Bool_Exp = {
  _and?: InputMaybe<Array<Lead_Debts_Bool_Exp>>;
  _not?: InputMaybe<Lead_Debts_Bool_Exp>;
  _or?: InputMaybe<Array<Lead_Debts_Bool_Exp>>;
};

/** response of any mutation on the table "lead_debts" */
export type Lead_Debts_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
};

/** Boolean expression to compare columns of type "lead_mortgage_status". All fields are combined with logical 'AND'. */
export type Lead_Mortgage_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _gt?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _gte?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _in?: InputMaybe<Array<Scalars['lead_mortgage_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _lte?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _neq?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['lead_mortgage_status']['input']>>;
};

/** Boolean expression to compare columns of type "lead_ownership". All fields are combined with logical 'AND'. */
export type Lead_Ownership_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['lead_ownership']['input']>;
  _gt?: InputMaybe<Scalars['lead_ownership']['input']>;
  _gte?: InputMaybe<Scalars['lead_ownership']['input']>;
  _in?: InputMaybe<Array<Scalars['lead_ownership']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['lead_ownership']['input']>;
  _lte?: InputMaybe<Scalars['lead_ownership']['input']>;
  _neq?: InputMaybe<Scalars['lead_ownership']['input']>;
  _nin?: InputMaybe<Array<Scalars['lead_ownership']['input']>>;
};

/** columns and relationships of "lead_stages" */
export type Lead_Stages = {
  created_at: Scalars['timestamptz']['output'];
  deletable?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  /** compute lead stages label */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_nr: Scalars['Int']['output'];
  /** An object relationship */
  pipeline: Pipelines;
  pipeline_id: Scalars['uuid']['output'];
  status: Leads_Status_Enum;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "lead_stages" */
export type Lead_Stages_Aggregate = {
  aggregate?: Maybe<Lead_Stages_Aggregate_Fields>;
  nodes: Array<Lead_Stages>;
};

export type Lead_Stages_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Lead_Stages_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Lead_Stages_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Lead_Stages_Aggregate_Bool_Exp_Count>;
};

export type Lead_Stages_Aggregate_Bool_Exp_Bool_And = {
  arguments: Lead_Stages_Select_Column_Lead_Stages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lead_Stages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lead_Stages_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Lead_Stages_Select_Column_Lead_Stages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lead_Stages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lead_Stages_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lead_Stages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lead_Stages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "lead_stages" */
export type Lead_Stages_Aggregate_Fields = {
  avg?: Maybe<Lead_Stages_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lead_Stages_Max_Fields>;
  min?: Maybe<Lead_Stages_Min_Fields>;
  stddev?: Maybe<Lead_Stages_Stddev_Fields>;
  stddev_pop?: Maybe<Lead_Stages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lead_Stages_Stddev_Samp_Fields>;
  sum?: Maybe<Lead_Stages_Sum_Fields>;
  var_pop?: Maybe<Lead_Stages_Var_Pop_Fields>;
  var_samp?: Maybe<Lead_Stages_Var_Samp_Fields>;
  variance?: Maybe<Lead_Stages_Variance_Fields>;
};


/** aggregate fields of "lead_stages" */
export type Lead_Stages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lead_Stages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lead_stages" */
export type Lead_Stages_Aggregate_Order_By = {
  avg?: InputMaybe<Lead_Stages_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lead_Stages_Max_Order_By>;
  min?: InputMaybe<Lead_Stages_Min_Order_By>;
  stddev?: InputMaybe<Lead_Stages_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lead_Stages_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lead_Stages_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lead_Stages_Sum_Order_By>;
  var_pop?: InputMaybe<Lead_Stages_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lead_Stages_Var_Samp_Order_By>;
  variance?: InputMaybe<Lead_Stages_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "lead_stages" */
export type Lead_Stages_Arr_Rel_Insert_Input = {
  data: Array<Lead_Stages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lead_Stages_On_Conflict>;
};

/** aggregate avg on columns */
export type Lead_Stages_Avg_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "lead_stages" */
export type Lead_Stages_Avg_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lead_stages". All fields are combined with a logical 'AND'. */
export type Lead_Stages_Bool_Exp = {
  _and?: InputMaybe<Array<Lead_Stages_Bool_Exp>>;
  _not?: InputMaybe<Lead_Stages_Bool_Exp>;
  _or?: InputMaybe<Array<Lead_Stages_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletable?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  pipeline?: InputMaybe<Pipelines_Bool_Exp>;
  pipeline_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Leads_Status_Enum_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "lead_stages" */
export enum Lead_Stages_Constraint {
  /** unique or primary key constraint on columns "order_nr", "pipeline_id" */
  LeadStagesPipelineIdOrderNrUnique = 'lead_stages_pipeline_id_order_nr_unique',
  /** unique or primary key constraint on columns "id" */
  LeadStagesPkey = 'lead_stages_pkey'
}

/** input type for incrementing numeric columns in table "lead_stages" */
export type Lead_Stages_Inc_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "lead_stages" */
export type Lead_Stages_Insert_Input = {
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  pipeline?: InputMaybe<Pipelines_Obj_Rel_Insert_Input>;
  pipeline_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Leads_Status_Enum>;
};

/** aggregate max on columns */
export type Lead_Stages_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** compute lead stages label */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  pipeline_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "lead_stages" */
export type Lead_Stages_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  pipeline_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lead_Stages_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** compute lead stages label */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  pipeline_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "lead_stages" */
export type Lead_Stages_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  pipeline_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lead_stages" */
export type Lead_Stages_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lead_Stages>;
};

/** input type for inserting object relation for remote table "lead_stages" */
export type Lead_Stages_Obj_Rel_Insert_Input = {
  data: Lead_Stages_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Lead_Stages_On_Conflict>;
};

/** on_conflict condition type for table "lead_stages" */
export type Lead_Stages_On_Conflict = {
  constraint: Lead_Stages_Constraint;
  update_columns?: Array<Lead_Stages_Update_Column>;
  where?: InputMaybe<Lead_Stages_Bool_Exp>;
};

/** Ordering options when selecting data from "lead_stages". */
export type Lead_Stages_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deletable?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  pipeline?: InputMaybe<Pipelines_Order_By>;
  pipeline_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lead_stages */
export type Lead_Stages_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "lead_stages" */
export enum Lead_Stages_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deletable = 'deletable',
  /** column name */
  Id = 'id',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  Name = 'name',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PipelineId = 'pipeline_id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "lead_stages_aggregate_bool_exp_bool_and_arguments_columns" columns of table "lead_stages" */
export enum Lead_Stages_Select_Column_Lead_Stages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deletable = 'deletable'
}

/** select "lead_stages_aggregate_bool_exp_bool_or_arguments_columns" columns of table "lead_stages" */
export enum Lead_Stages_Select_Column_Lead_Stages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deletable = 'deletable'
}

/** input type for updating data in table "lead_stages" */
export type Lead_Stages_Set_Input = {
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Leads_Status_Enum>;
};

/** aggregate stddev on columns */
export type Lead_Stages_Stddev_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "lead_stages" */
export type Lead_Stages_Stddev_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lead_Stages_Stddev_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "lead_stages" */
export type Lead_Stages_Stddev_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lead_Stages_Stddev_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "lead_stages" */
export type Lead_Stages_Stddev_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lead_stages" */
export type Lead_Stages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lead_Stages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lead_Stages_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deletable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  pipeline_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Leads_Status_Enum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Lead_Stages_Sum_Fields = {
  order_nr?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "lead_stages" */
export type Lead_Stages_Sum_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** update columns of table "lead_stages" */
export enum Lead_Stages_Update_Column {
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  Name = 'name',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  Status = 'status'
}

export type Lead_Stages_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Lead_Stages_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lead_Stages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lead_Stages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Lead_Stages_Var_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "lead_stages" */
export type Lead_Stages_Var_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lead_Stages_Var_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "lead_stages" */
export type Lead_Stages_Var_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lead_Stages_Variance_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "lead_stages" */
export type Lead_Stages_Variance_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "lead_type". All fields are combined with logical 'AND'. */
export type Lead_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['lead_type']['input']>;
  _gt?: InputMaybe<Scalars['lead_type']['input']>;
  _gte?: InputMaybe<Scalars['lead_type']['input']>;
  _in?: InputMaybe<Array<Scalars['lead_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['lead_type']['input']>;
  _lte?: InputMaybe<Scalars['lead_type']['input']>;
  _neq?: InputMaybe<Scalars['lead_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['lead_type']['input']>>;
};

/** columns and relationships of "leads" */
export type Leads = {
  /** An array relationship */
  activities: Array<Activities>;
  /** An aggregate relationship */
  activities_aggregate: Activities_Aggregate;
  /** A computed field, executes function "lead_user_affordability" */
  affordability_rate?: Maybe<Scalars['float8']['output']>;
  annual_premium?: Maybe<Scalars['float8']['output']>;
  anonymized_contact?: Maybe<Scalars['String']['output']>;
  appraisal_inheritance_next_step?: Maybe<Scalars['String']['output']>;
  appraisal_market_time?: Maybe<Scalars['Int']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_next_step?: Maybe<Scalars['String']['output']>;
  appraisal_open_to_offer?: Maybe<Scalars['String']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_perception?: Maybe<Scalars['String']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Int']['output']>;
  appraisal_property_country?: Maybe<Scalars['String']['output']>;
  appraisal_property_country_code?: Maybe<Scalars['String']['output']>;
  appraisal_property_ctn?: Maybe<Scalars['String']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Int']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_google_address_id?: Maybe<Scalars['uuid']['output']>;
  appraisal_property_has_elevator?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_has_garden?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_has_view?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_income_includes_parking?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_is_commercial_fully_rented?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_is_parking_fully_rented?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_is_renovated?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_is_residential_fully_rented?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_know_plot_number?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_locality?: Maybe<Scalars['String']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_occupied?: Maybe<Scalars['String']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_plot_number?: Maybe<Scalars['String']['output']>;
  appraisal_property_postcode?: Maybe<Scalars['String']['output']>;
  appraisal_property_property_type_id?: Maybe<Scalars['uuid']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Int']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_route?: Maybe<Scalars['String']['output']>;
  appraisal_property_side?: Maybe<Property_Side_Enum_Enum>;
  appraisal_property_state?: Maybe<Scalars['String']['output']>;
  appraisal_property_street_number?: Maybe<Scalars['String']['output']>;
  appraisal_property_usage?: Maybe<Scalars['String']['output']>;
  appraisal_reason: Leads_Appraisal_Reason_Enum;
  appraisal_selling_with?: Maybe<Scalars['String']['output']>;
  appraisal_separation_next_step?: Maybe<Scalars['String']['output']>;
  appraisal_step?: Maybe<Scalars['String']['output']>;
  assets_second_pillar?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a_organisation?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  broker?: Maybe<Users>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  buy_horizon: Leads_Buy_Horizon_Enum;
  call_times?: Maybe<Array<Scalars['String']['output']>>;
  /** A computed field, executes function "leads_claimed_by" */
  claimed_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  cma_reports: Array<Cma_Reports>;
  /** An aggregate relationship */
  cma_reports_aggregate: Cma_Reports_Aggregate;
  completed: Scalars['Boolean']['output'];
  /** An object relationship */
  contact?: Maybe<Users>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  createdBy?: Maybe<Users>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  creator?: Maybe<Users>;
  /** A computed field, executes function "leads_crm_link" */
  crm_link?: Maybe<Scalars['String']['output']>;
  date_of_birth?: Maybe<Scalars['date']['output']>;
  debt?: Maybe<Scalars['float8']['output']>;
  donation?: Maybe<Scalars['float8']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "financing_crm_link" */
  financing_crm_link?: Maybe<Scalars['String']['output']>;
  financing_secured?: Maybe<Scalars['Boolean']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "lead_user_funds_percentage" */
  fund_usage?: Maybe<Scalars['float8']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  google_address?: Maybe<Google_Addresses>;
  has_accepted_terms?: Maybe<Scalars['Boolean']['output']>;
  has_dependant_children?: Maybe<Scalars['Boolean']['output']>;
  has_no_street_number?: Maybe<Scalars['Boolean']['output']>;
  has_other_credits?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  imported_id?: Maybe<Scalars['String']['output']>;
  landing_page_url?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "computed_last_activity" */
  last_activity?: Maybe<Array<Activities>>;
  last_activity_done_at?: Maybe<Scalars['timestamptz']['output']>;
  last_bonus?: Maybe<Scalars['float8']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_requalification_mail_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  last_requalification_sms_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  lead_agents: Array<Lead_Agents>;
  /** An aggregate relationship */
  lead_agents_aggregate: Lead_Agents_Aggregate;
  /** An array relationship */
  leads_tags: Array<Leads_Tags>;
  /** An aggregate relationship */
  leads_tags_aggregate: Leads_Tags_Aggregate;
  /** An array relationship */
  lots: Array<Lots>;
  /** An aggregate relationship */
  lots_aggregate: Lots_Aggregate;
  mandate_probability?: Maybe<Scalars['Int']['output']>;
  marital_status?: Maybe<Scalars['String']['output']>;
  max_property_value?: Maybe<Scalars['float8']['output']>;
  mortgage_auto_mortgage_type?: Maybe<Scalars['Boolean']['output']>;
  mortgage_buying_status?: Maybe<Scalars['lead_buying_status']['output']>;
  mortgage_comments?: Maybe<Scalars['String']['output']>;
  mortgage_financial_institution?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  mortgage_google_address?: Maybe<Google_Addresses>;
  mortgage_google_address_id?: Maybe<Scalars['uuid']['output']>;
  mortgage_has_mortgage?: Maybe<Scalars['Boolean']['output']>;
  mortgage_insurance_provider_id?: Maybe<Scalars['uuid']['output']>;
  mortgage_insurance_revenue?: Maybe<Scalars['Float']['output']>;
  mortgage_interest_rate?: Maybe<Scalars['Float']['output']>;
  mortgage_interest_rate_type?: Maybe<Scalars['mortgage_interest_rate_type']['output']>;
  mortgage_is_construction?: Maybe<Scalars['Boolean']['output']>;
  mortgage_is_property_identified?: Maybe<Scalars['Boolean']['output']>;
  mortgage_lender_id?: Maybe<Scalars['uuid']['output']>;
  mortgage_lender_name?: Maybe<Scalars['String']['output']>;
  mortgage_lender_type?: Maybe<Scalars['mortgage_lender_type']['output']>;
  mortgage_mortgage_type?: Maybe<Scalars['String']['output']>;
  mortgage_notary_id?: Maybe<Scalars['uuid']['output']>;
  mortgage_product_mortgage?: Maybe<Scalars['Boolean']['output']>;
  mortgage_product_third_pillar?: Maybe<Scalars['Boolean']['output']>;
  mortgage_property_usage?: Maybe<Scalars['String']['output']>;
  mortgage_property_value?: Maybe<Scalars['float8']['output']>;
  mortgage_purchase_date?: Maybe<Scalars['timestamptz']['output']>;
  mortgage_purchase_price?: Maybe<Scalars['Float']['output']>;
  mortgage_real_estate_broker_id?: Maybe<Scalars['uuid']['output']>;
  mortgage_report_type?: Maybe<Scalars['String']['output']>;
  mortgage_revenue?: Maybe<Scalars['Float']['output']>;
  mortgage_sell?: Maybe<Scalars['Boolean']['output']>;
  mortgage_start_date?: Maybe<Scalars['date']['output']>;
  mortgage_status?: Maybe<Scalars['lead_mortgage_status']['output']>;
  mortgage_step?: Maybe<Scalars['String']['output']>;
  mortgage_term?: Maybe<Scalars['String']['output']>;
  nationality_id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "computed_next_activity" */
  next_activity?: Maybe<Array<Activities>>;
  next_activity_due_at?: Maybe<Scalars['timestamptz']['output']>;
  number_of_buyers?: Maybe<Scalars['Int']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Int']['output']>;
  occupation_id?: Maybe<Scalars['uuid']['output']>;
  occupation_text?: Maybe<Scalars['String']['output']>;
  other_credits?: Maybe<Scalars['Int']['output']>;
  ownership?: Maybe<Scalars['lead_ownership']['output']>;
  parent_lead_id?: Maybe<Scalars['uuid']['output']>;
  partner_annual_premium?: Maybe<Scalars['float8']['output']>;
  partner_date_of_birth?: Maybe<Scalars['date']['output']>;
  partner_donation?: Maybe<Scalars['float8']['output']>;
  partner_first_name?: Maybe<Scalars['String']['output']>;
  partner_gender?: Maybe<Scalars['String']['output']>;
  partner_has_other_credits?: Maybe<Scalars['Boolean']['output']>;
  partner_has_third_pillar?: Maybe<Scalars['Boolean']['output']>;
  partner_last_bonus?: Maybe<Scalars['float8']['output']>;
  partner_last_name?: Maybe<Scalars['String']['output']>;
  partner_marital_status?: Maybe<Scalars['String']['output']>;
  partner_nationality_id?: Maybe<Scalars['uuid']['output']>;
  partner_occupation_id?: Maybe<Scalars['uuid']['output']>;
  partner_occupation_text?: Maybe<Scalars['String']['output']>;
  partner_other_credits?: Maybe<Scalars['float8']['output']>;
  partner_professional_situation?: Maybe<Scalars['user_professional_situation']['output']>;
  partner_residence_country_code?: Maybe<Scalars['String']['output']>;
  partner_residence_state_id?: Maybe<Scalars['uuid']['output']>;
  partner_savings?: Maybe<Scalars['float8']['output']>;
  partner_second_pillar?: Maybe<Scalars['float8']['output']>;
  partner_third_pillar?: Maybe<Scalars['float8']['output']>;
  partner_third_pillar_a_organisation?: Maybe<Scalars['String']['output']>;
  partner_use_bank_third_pillar?: Maybe<Scalars['Boolean']['output']>;
  partner_use_insurance_third_pillar?: Maybe<Scalars['Boolean']['output']>;
  partner_work_permit_id?: Maybe<Scalars['uuid']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['float8']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  pos_within_stage?: Maybe<Scalars['Int']['output']>;
  potential_development: Scalars['Boolean']['output'];
  predicted_listing_date?: Maybe<Scalars['timestamptz']['output']>;
  professional_situation?: Maybe<Scalars['user_professional_situation']['output']>;
  /** An object relationship */
  property?: Maybe<Properties>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_search_notification?: Maybe<Scalars['property_searches_notification']['output']>;
  /** An object relationship */
  property_type?: Maybe<Property_Types>;
  property_usage: Leads_Property_Usage_Enum;
  received_mortgage_offer?: Maybe<Scalars['Boolean']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
  referring_domain?: Maybe<Scalars['String']['output']>;
  refused_at?: Maybe<Scalars['timestamptz']['output']>;
  relationship: Leads_Relationship_Enum;
  requalification_status: Leads_Requalification_Status_Enum;
  requalified_at?: Maybe<Scalars['timestamptz']['output']>;
  requalified_or_created_at?: Maybe<Scalars['timestamptz']['output']>;
  residence_country_code?: Maybe<Scalars['String']['output']>;
  residence_state_id?: Maybe<Scalars['uuid']['output']>;
  sale_comments?: Maybe<Scalars['String']['output']>;
  sale_has_found?: Maybe<Scalars['Boolean']['output']>;
  sale_horizon: Leads_Sale_Horizon_Enum;
  sale_is_seller?: Maybe<Scalars['Boolean']['output']>;
  sale_price?: Maybe<Scalars['Int']['output']>;
  sale_started?: Maybe<Scalars['Boolean']['output']>;
  savings?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  second_contact?: Maybe<Users>;
  second_contact_id?: Maybe<Scalars['uuid']['output']>;
  second_pillar?: Maybe<Scalars['float8']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "should_be_requalified" */
  should_be_requalified?: Maybe<Scalars['Boolean']['output']>;
  snapshot?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  source: Dictionaries;
  source_id: Scalars['uuid']['output'];
  source_organisation_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  stage?: Maybe<Lead_Stages>;
  stage_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
  third_pillar?: Maybe<Scalars['float8']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  usable_own_funds?: Maybe<Scalars['float8']['output']>;
  use_bank_third_pillar?: Maybe<Scalars['Boolean']['output']>;
  use_insurance_third_pillar?: Maybe<Scalars['Boolean']['output']>;
  use_second_pillar?: Maybe<Scalars['Boolean']['output']>;
  use_third_pillar?: Maybe<Scalars['Boolean']['output']>;
  user_info_ip?: Maybe<Scalars['String']['output']>;
  user_info_user_agent?: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
  work_permit_id?: Maybe<Scalars['uuid']['output']>;
  yearly_revenues?: Maybe<Scalars['float8']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
};


/** columns and relationships of "leads" */
export type LeadsActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** columns and relationships of "leads" */
export type LeadsActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** columns and relationships of "leads" */
export type LeadsCma_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Order_By>>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};


/** columns and relationships of "leads" */
export type LeadsCma_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Order_By>>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};


/** columns and relationships of "leads" */
export type LeadsLast_ActivityArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** columns and relationships of "leads" */
export type LeadsLead_AgentsArgs = {
  distinct_on?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Agents_Order_By>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


/** columns and relationships of "leads" */
export type LeadsLead_Agents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Agents_Order_By>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


/** columns and relationships of "leads" */
export type LeadsLeads_TagsArgs = {
  distinct_on?: InputMaybe<Array<Leads_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Tags_Order_By>>;
  where?: InputMaybe<Leads_Tags_Bool_Exp>;
};


/** columns and relationships of "leads" */
export type LeadsLeads_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Leads_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Tags_Order_By>>;
  where?: InputMaybe<Leads_Tags_Bool_Exp>;
};


/** columns and relationships of "leads" */
export type LeadsLotsArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


/** columns and relationships of "leads" */
export type LeadsLots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


/** columns and relationships of "leads" */
export type LeadsNext_ActivityArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** columns and relationships of "leads" */
export type LeadsSnapshotArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "leads" */
export type Leads_Aggregate = {
  aggregate?: Maybe<Leads_Aggregate_Fields>;
  nodes: Array<Leads>;
};

export type Leads_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Leads_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Leads_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Leads_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Leads_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Leads_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Leads_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Leads_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Leads_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Leads_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Leads_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Leads_Aggregate_Bool_Exp_Var_Samp>;
};

export type Leads_Aggregate_Bool_Exp_Avg = {
  arguments: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Bool_And = {
  arguments: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Corr = {
  arguments: Leads_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Leads_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Leads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Leads_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Leads_Aggregate_Bool_Exp_Max = {
  arguments: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Min = {
  arguments: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Sum = {
  arguments: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "leads" */
export type Leads_Aggregate_Fields = {
  avg?: Maybe<Leads_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Leads_Max_Fields>;
  min?: Maybe<Leads_Min_Fields>;
  stddev?: Maybe<Leads_Stddev_Fields>;
  stddev_pop?: Maybe<Leads_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Leads_Stddev_Samp_Fields>;
  sum?: Maybe<Leads_Sum_Fields>;
  var_pop?: Maybe<Leads_Var_Pop_Fields>;
  var_samp?: Maybe<Leads_Var_Samp_Fields>;
  variance?: Maybe<Leads_Variance_Fields>;
};


/** aggregate fields of "leads" */
export type Leads_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Leads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "leads" */
export type Leads_Aggregate_Order_By = {
  avg?: InputMaybe<Leads_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Leads_Max_Order_By>;
  min?: InputMaybe<Leads_Min_Order_By>;
  stddev?: InputMaybe<Leads_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Leads_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Leads_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Leads_Sum_Order_By>;
  var_pop?: InputMaybe<Leads_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Leads_Var_Samp_Order_By>;
  variance?: InputMaybe<Leads_Variance_Order_By>;
};

export enum Leads_Appraisal_Reason_Enum {
  AlreadyForSale = 'already_for_sale',
  BuySoon = 'buy_soon',
  BuyThis = 'buy_this',
  Inheritance = 'inheritance',
  MoveRental = 'move_rental',
  NotSelling = 'not_selling',
  NotSet = 'not_set',
  Other = 'other',
  OtherNotOwner = 'other_not_owner',
  OtherOwner = 'other_owner',
  OtherRenting = 'other_renting',
  Refinance = 'refinance',
  Sell = 'sell',
  Separation = 'separation'
}

/** Boolean expression to compare columns of type "leads_appraisal_reason_enum". All fields are combined with logical 'AND'. */
export type Leads_Appraisal_Reason_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Leads_Appraisal_Reason_Enum>;
  _in?: InputMaybe<Array<Leads_Appraisal_Reason_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Leads_Appraisal_Reason_Enum>;
  _nin?: InputMaybe<Array<Leads_Appraisal_Reason_Enum>>;
};

/** input type for inserting array relation for remote table "leads" */
export type Leads_Arr_Rel_Insert_Input = {
  data: Array<Leads_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Leads_On_Conflict>;
};

/** aggregate avg on columns */
export type Leads_Avg_Fields = {
  /** A computed field, executes function "lead_user_affordability" */
  affordability_rate?: Maybe<Scalars['float8']['output']>;
  annual_premium?: Maybe<Scalars['Float']['output']>;
  appraisal_market_time?: Maybe<Scalars['Float']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "lead_user_funds_percentage" */
  fund_usage?: Maybe<Scalars['float8']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  mandate_probability?: Maybe<Scalars['Float']['output']>;
  max_property_value?: Maybe<Scalars['Float']['output']>;
  mortgage_insurance_revenue?: Maybe<Scalars['Float']['output']>;
  mortgage_interest_rate?: Maybe<Scalars['Float']['output']>;
  mortgage_property_value?: Maybe<Scalars['Float']['output']>;
  mortgage_purchase_price?: Maybe<Scalars['Float']['output']>;
  mortgage_revenue?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  other_credits?: Maybe<Scalars['Float']['output']>;
  partner_annual_premium?: Maybe<Scalars['Float']['output']>;
  partner_donation?: Maybe<Scalars['Float']['output']>;
  partner_last_bonus?: Maybe<Scalars['Float']['output']>;
  partner_other_credits?: Maybe<Scalars['Float']['output']>;
  partner_savings?: Maybe<Scalars['Float']['output']>;
  partner_second_pillar?: Maybe<Scalars['Float']['output']>;
  partner_third_pillar?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
  pos_within_stage?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  savings?: Maybe<Scalars['Float']['output']>;
  second_pillar?: Maybe<Scalars['Float']['output']>;
  third_pillar?: Maybe<Scalars['Float']['output']>;
  usable_own_funds?: Maybe<Scalars['Float']['output']>;
  yearly_revenues?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "leads" */
export type Leads_Avg_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  mortgage_insurance_revenue?: InputMaybe<Order_By>;
  mortgage_interest_rate?: InputMaybe<Order_By>;
  mortgage_property_value?: InputMaybe<Order_By>;
  mortgage_purchase_price?: InputMaybe<Order_By>;
  mortgage_revenue?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  pos_within_stage?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "leads". All fields are combined with a logical 'AND'. */
export type Leads_Bool_Exp = {
  _and?: InputMaybe<Array<Leads_Bool_Exp>>;
  _not?: InputMaybe<Leads_Bool_Exp>;
  _or?: InputMaybe<Array<Leads_Bool_Exp>>;
  activities?: InputMaybe<Activities_Bool_Exp>;
  activities_aggregate?: InputMaybe<Activities_Aggregate_Bool_Exp>;
  affordability_rate?: InputMaybe<Float8_Comparison_Exp>;
  annual_premium?: InputMaybe<Float8_Comparison_Exp>;
  anonymized_contact?: InputMaybe<String_Comparison_Exp>;
  appraisal_inheritance_next_step?: InputMaybe<String_Comparison_Exp>;
  appraisal_market_time?: InputMaybe<Int_Comparison_Exp>;
  appraisal_monthly_gross_rent?: InputMaybe<Float_Comparison_Exp>;
  appraisal_next_step?: InputMaybe<String_Comparison_Exp>;
  appraisal_open_to_offer?: InputMaybe<String_Comparison_Exp>;
  appraisal_perceived_value?: InputMaybe<Float_Comparison_Exp>;
  appraisal_perception?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_built_surface?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_commercial_surface?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_construction_year?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_country?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_country_code?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_ctn?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_garden_surface?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_google_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  appraisal_property_has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_has_view?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_income_includes_parking?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_is_commercial_fully_rented?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_is_parking_fully_rented?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_is_renovated?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_is_residential_fully_rented?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_know_plot_number?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_land_surface?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_lat?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_living_surface?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_lng?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_locality?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_number_of_floors?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_number_of_residential_units?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_occupied?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_plot_number?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_postcode?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_property_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  appraisal_property_renovation_year?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_residential_surface?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_route?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_side?: InputMaybe<Property_Side_Enum_Enum_Comparison_Exp>;
  appraisal_property_state?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_street_number?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_usage?: InputMaybe<String_Comparison_Exp>;
  appraisal_reason?: InputMaybe<Leads_Appraisal_Reason_Enum_Comparison_Exp>;
  appraisal_selling_with?: InputMaybe<String_Comparison_Exp>;
  appraisal_separation_next_step?: InputMaybe<String_Comparison_Exp>;
  appraisal_step?: InputMaybe<String_Comparison_Exp>;
  assets_second_pillar?: InputMaybe<Float8_Comparison_Exp>;
  assets_third_pillar_a_organisation?: InputMaybe<String_Comparison_Exp>;
  broker?: InputMaybe<Users_Bool_Exp>;
  broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  buy_horizon?: InputMaybe<Leads_Buy_Horizon_Enum_Comparison_Exp>;
  call_times?: InputMaybe<String_Array_Comparison_Exp>;
  claimed_by?: InputMaybe<Uuid_Comparison_Exp>;
  cma_reports?: InputMaybe<Cma_Reports_Bool_Exp>;
  cma_reports_aggregate?: InputMaybe<Cma_Reports_Aggregate_Bool_Exp>;
  completed?: InputMaybe<Boolean_Comparison_Exp>;
  contact?: InputMaybe<Users_Bool_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  createdBy?: InputMaybe<Users_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  crm_link?: InputMaybe<String_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  debt?: InputMaybe<Float8_Comparison_Exp>;
  donation?: InputMaybe<Float8_Comparison_Exp>;
  email_address?: InputMaybe<String_Comparison_Exp>;
  financing_crm_link?: InputMaybe<String_Comparison_Exp>;
  financing_secured?: InputMaybe<Boolean_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  fund_usage?: InputMaybe<Float8_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  google_address?: InputMaybe<Google_Addresses_Bool_Exp>;
  has_accepted_terms?: InputMaybe<Boolean_Comparison_Exp>;
  has_dependant_children?: InputMaybe<Boolean_Comparison_Exp>;
  has_no_street_number?: InputMaybe<Boolean_Comparison_Exp>;
  has_other_credits?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_id?: InputMaybe<String_Comparison_Exp>;
  landing_page_url?: InputMaybe<String_Comparison_Exp>;
  last_activity?: InputMaybe<Activities_Bool_Exp>;
  last_activity_done_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_bonus?: InputMaybe<Float8_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  last_requalification_mail_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_requalification_sms_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lead_agents?: InputMaybe<Lead_Agents_Bool_Exp>;
  lead_agents_aggregate?: InputMaybe<Lead_Agents_Aggregate_Bool_Exp>;
  leads_tags?: InputMaybe<Leads_Tags_Bool_Exp>;
  leads_tags_aggregate?: InputMaybe<Leads_Tags_Aggregate_Bool_Exp>;
  lots?: InputMaybe<Lots_Bool_Exp>;
  lots_aggregate?: InputMaybe<Lots_Aggregate_Bool_Exp>;
  mandate_probability?: InputMaybe<Int_Comparison_Exp>;
  marital_status?: InputMaybe<String_Comparison_Exp>;
  max_property_value?: InputMaybe<Float8_Comparison_Exp>;
  mortgage_auto_mortgage_type?: InputMaybe<Boolean_Comparison_Exp>;
  mortgage_buying_status?: InputMaybe<Lead_Buying_Status_Comparison_Exp>;
  mortgage_comments?: InputMaybe<String_Comparison_Exp>;
  mortgage_financial_institution?: InputMaybe<String_Comparison_Exp>;
  mortgage_google_address?: InputMaybe<Google_Addresses_Bool_Exp>;
  mortgage_google_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  mortgage_has_mortgage?: InputMaybe<Boolean_Comparison_Exp>;
  mortgage_insurance_provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  mortgage_insurance_revenue?: InputMaybe<Float_Comparison_Exp>;
  mortgage_interest_rate?: InputMaybe<Float_Comparison_Exp>;
  mortgage_interest_rate_type?: InputMaybe<Mortgage_Interest_Rate_Type_Comparison_Exp>;
  mortgage_is_construction?: InputMaybe<Boolean_Comparison_Exp>;
  mortgage_is_property_identified?: InputMaybe<Boolean_Comparison_Exp>;
  mortgage_lender_id?: InputMaybe<Uuid_Comparison_Exp>;
  mortgage_lender_name?: InputMaybe<String_Comparison_Exp>;
  mortgage_lender_type?: InputMaybe<Mortgage_Lender_Type_Comparison_Exp>;
  mortgage_mortgage_type?: InputMaybe<String_Comparison_Exp>;
  mortgage_notary_id?: InputMaybe<Uuid_Comparison_Exp>;
  mortgage_product_mortgage?: InputMaybe<Boolean_Comparison_Exp>;
  mortgage_product_third_pillar?: InputMaybe<Boolean_Comparison_Exp>;
  mortgage_property_usage?: InputMaybe<String_Comparison_Exp>;
  mortgage_property_value?: InputMaybe<Float8_Comparison_Exp>;
  mortgage_purchase_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  mortgage_purchase_price?: InputMaybe<Float_Comparison_Exp>;
  mortgage_real_estate_broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  mortgage_report_type?: InputMaybe<String_Comparison_Exp>;
  mortgage_revenue?: InputMaybe<Float_Comparison_Exp>;
  mortgage_sell?: InputMaybe<Boolean_Comparison_Exp>;
  mortgage_start_date?: InputMaybe<Date_Comparison_Exp>;
  mortgage_status?: InputMaybe<Lead_Mortgage_Status_Comparison_Exp>;
  mortgage_step?: InputMaybe<String_Comparison_Exp>;
  mortgage_term?: InputMaybe<String_Comparison_Exp>;
  nationality_id?: InputMaybe<Uuid_Comparison_Exp>;
  next_activity?: InputMaybe<Activities_Bool_Exp>;
  next_activity_due_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  number_of_buyers?: InputMaybe<Int_Comparison_Exp>;
  number_of_dependant_children?: InputMaybe<Int_Comparison_Exp>;
  occupation_id?: InputMaybe<Uuid_Comparison_Exp>;
  occupation_text?: InputMaybe<String_Comparison_Exp>;
  other_credits?: InputMaybe<Int_Comparison_Exp>;
  ownership?: InputMaybe<Lead_Ownership_Comparison_Exp>;
  parent_lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_annual_premium?: InputMaybe<Float8_Comparison_Exp>;
  partner_date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  partner_donation?: InputMaybe<Float8_Comparison_Exp>;
  partner_first_name?: InputMaybe<String_Comparison_Exp>;
  partner_gender?: InputMaybe<String_Comparison_Exp>;
  partner_has_other_credits?: InputMaybe<Boolean_Comparison_Exp>;
  partner_has_third_pillar?: InputMaybe<Boolean_Comparison_Exp>;
  partner_last_bonus?: InputMaybe<Float8_Comparison_Exp>;
  partner_last_name?: InputMaybe<String_Comparison_Exp>;
  partner_marital_status?: InputMaybe<String_Comparison_Exp>;
  partner_nationality_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_occupation_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_occupation_text?: InputMaybe<String_Comparison_Exp>;
  partner_other_credits?: InputMaybe<Float8_Comparison_Exp>;
  partner_professional_situation?: InputMaybe<User_Professional_Situation_Comparison_Exp>;
  partner_residence_country_code?: InputMaybe<String_Comparison_Exp>;
  partner_residence_state_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_savings?: InputMaybe<Float8_Comparison_Exp>;
  partner_second_pillar?: InputMaybe<Float8_Comparison_Exp>;
  partner_third_pillar?: InputMaybe<Float8_Comparison_Exp>;
  partner_third_pillar_a_organisation?: InputMaybe<String_Comparison_Exp>;
  partner_use_bank_third_pillar?: InputMaybe<Boolean_Comparison_Exp>;
  partner_use_insurance_third_pillar?: InputMaybe<Boolean_Comparison_Exp>;
  partner_work_permit_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_yearly_revenues?: InputMaybe<Float8_Comparison_Exp>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Float8_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  pos_within_stage?: InputMaybe<Int_Comparison_Exp>;
  potential_development?: InputMaybe<Boolean_Comparison_Exp>;
  predicted_listing_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  professional_situation?: InputMaybe<User_Professional_Situation_Comparison_Exp>;
  property?: InputMaybe<Properties_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_search_notification?: InputMaybe<Property_Searches_Notification_Comparison_Exp>;
  property_type?: InputMaybe<Property_Types_Bool_Exp>;
  property_usage?: InputMaybe<Leads_Property_Usage_Enum_Comparison_Exp>;
  received_mortgage_offer?: InputMaybe<Boolean_Comparison_Exp>;
  referrer?: InputMaybe<String_Comparison_Exp>;
  referring_domain?: InputMaybe<String_Comparison_Exp>;
  refused_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  relationship?: InputMaybe<Leads_Relationship_Enum_Comparison_Exp>;
  requalification_status?: InputMaybe<Leads_Requalification_Status_Enum_Comparison_Exp>;
  requalified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  requalified_or_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  residence_country_code?: InputMaybe<String_Comparison_Exp>;
  residence_state_id?: InputMaybe<Uuid_Comparison_Exp>;
  sale_comments?: InputMaybe<String_Comparison_Exp>;
  sale_has_found?: InputMaybe<Boolean_Comparison_Exp>;
  sale_horizon?: InputMaybe<Leads_Sale_Horizon_Enum_Comparison_Exp>;
  sale_is_seller?: InputMaybe<Boolean_Comparison_Exp>;
  sale_price?: InputMaybe<Int_Comparison_Exp>;
  sale_started?: InputMaybe<Boolean_Comparison_Exp>;
  savings?: InputMaybe<Float8_Comparison_Exp>;
  second_contact?: InputMaybe<Users_Bool_Exp>;
  second_contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  second_pillar?: InputMaybe<Float8_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  should_be_requalified?: InputMaybe<Boolean_Comparison_Exp>;
  snapshot?: InputMaybe<Jsonb_Comparison_Exp>;
  source?: InputMaybe<Dictionaries_Bool_Exp>;
  source_id?: InputMaybe<Uuid_Comparison_Exp>;
  source_organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  stage?: InputMaybe<Lead_Stages_Bool_Exp>;
  stage_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  third_pillar?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  usable_own_funds?: InputMaybe<Float8_Comparison_Exp>;
  use_bank_third_pillar?: InputMaybe<Boolean_Comparison_Exp>;
  use_insurance_third_pillar?: InputMaybe<Boolean_Comparison_Exp>;
  use_second_pillar?: InputMaybe<Boolean_Comparison_Exp>;
  use_third_pillar?: InputMaybe<Boolean_Comparison_Exp>;
  user_info_ip?: InputMaybe<String_Comparison_Exp>;
  user_info_user_agent?: InputMaybe<String_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
  work_permit_id?: InputMaybe<Uuid_Comparison_Exp>;
  yearly_revenues?: InputMaybe<Float8_Comparison_Exp>;
  yearly_revenues_at_retirement?: InputMaybe<Float8_Comparison_Exp>;
};

export enum Leads_Buy_Horizon_Enum {
  NotSet = 'not_set',
  Over_12Months = 'over_12_months',
  Under_3Months = 'under_3_months',
  Under_12Months = 'under_12_months'
}

/** Boolean expression to compare columns of type "leads_buy_horizon_enum". All fields are combined with logical 'AND'. */
export type Leads_Buy_Horizon_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Leads_Buy_Horizon_Enum>;
  _in?: InputMaybe<Array<Leads_Buy_Horizon_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Leads_Buy_Horizon_Enum>;
  _nin?: InputMaybe<Array<Leads_Buy_Horizon_Enum>>;
};

/** unique or primary key constraints on table "leads" */
export enum Leads_Constraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  LeadsIdTenantIdUnique = 'leads_id_tenant_id_unique',
  /** unique or primary key constraint on columns "imported_id", "tenant_id" */
  LeadsImportedIdTenantIdUnique = 'leads_imported_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  LeadsPkey = 'leads_pkey'
}

/** input type for inserting data into table "leads" */
export type Leads_Insert_Input = {
  activities?: InputMaybe<Activities_Arr_Rel_Insert_Input>;
  broker?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  cma_reports?: InputMaybe<Cma_Reports_Arr_Rel_Insert_Input>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  contact?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  createdBy?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  creator?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  google_address?: InputMaybe<Google_Addresses_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  lead_agents?: InputMaybe<Lead_Agents_Arr_Rel_Insert_Input>;
  leads_tags?: InputMaybe<Leads_Tags_Arr_Rel_Insert_Input>;
  lots?: InputMaybe<Lots_Arr_Rel_Insert_Input>;
  mortgage_google_address?: InputMaybe<Google_Addresses_Obj_Rel_Insert_Input>;
  property?: InputMaybe<Properties_Obj_Rel_Insert_Input>;
  relationship?: InputMaybe<Leads_Relationship_Enum>;
  sale_horizon?: InputMaybe<Leads_Sale_Horizon_Enum>;
  second_contact?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  source?: InputMaybe<Dictionaries_Obj_Rel_Insert_Input>;
  source_id?: InputMaybe<Scalars['uuid']['input']>;
  stage?: InputMaybe<Lead_Stages_Obj_Rel_Insert_Input>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Leads_Max_Fields = {
  /** A computed field, executes function "lead_user_affordability" */
  affordability_rate?: Maybe<Scalars['float8']['output']>;
  annual_premium?: Maybe<Scalars['float8']['output']>;
  anonymized_contact?: Maybe<Scalars['String']['output']>;
  appraisal_inheritance_next_step?: Maybe<Scalars['String']['output']>;
  appraisal_market_time?: Maybe<Scalars['Int']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_next_step?: Maybe<Scalars['String']['output']>;
  appraisal_open_to_offer?: Maybe<Scalars['String']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_perception?: Maybe<Scalars['String']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Int']['output']>;
  appraisal_property_country?: Maybe<Scalars['String']['output']>;
  appraisal_property_country_code?: Maybe<Scalars['String']['output']>;
  appraisal_property_ctn?: Maybe<Scalars['String']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Int']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_google_address_id?: Maybe<Scalars['uuid']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_locality?: Maybe<Scalars['String']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_occupied?: Maybe<Scalars['String']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_plot_number?: Maybe<Scalars['String']['output']>;
  appraisal_property_postcode?: Maybe<Scalars['String']['output']>;
  appraisal_property_property_type_id?: Maybe<Scalars['uuid']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Int']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_route?: Maybe<Scalars['String']['output']>;
  appraisal_property_state?: Maybe<Scalars['String']['output']>;
  appraisal_property_street_number?: Maybe<Scalars['String']['output']>;
  appraisal_property_usage?: Maybe<Scalars['String']['output']>;
  appraisal_selling_with?: Maybe<Scalars['String']['output']>;
  appraisal_separation_next_step?: Maybe<Scalars['String']['output']>;
  appraisal_step?: Maybe<Scalars['String']['output']>;
  assets_second_pillar?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a_organisation?: Maybe<Scalars['String']['output']>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  call_times?: Maybe<Array<Scalars['String']['output']>>;
  /** A computed field, executes function "leads_claimed_by" */
  claimed_by?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "leads_crm_link" */
  crm_link?: Maybe<Scalars['String']['output']>;
  date_of_birth?: Maybe<Scalars['date']['output']>;
  debt?: Maybe<Scalars['float8']['output']>;
  donation?: Maybe<Scalars['float8']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "financing_crm_link" */
  financing_crm_link?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "lead_user_funds_percentage" */
  fund_usage?: Maybe<Scalars['float8']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_id?: Maybe<Scalars['String']['output']>;
  landing_page_url?: Maybe<Scalars['String']['output']>;
  last_activity_done_at?: Maybe<Scalars['timestamptz']['output']>;
  last_bonus?: Maybe<Scalars['float8']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_requalification_mail_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  last_requalification_sms_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  mandate_probability?: Maybe<Scalars['Int']['output']>;
  marital_status?: Maybe<Scalars['String']['output']>;
  max_property_value?: Maybe<Scalars['float8']['output']>;
  mortgage_buying_status?: Maybe<Scalars['lead_buying_status']['output']>;
  mortgage_comments?: Maybe<Scalars['String']['output']>;
  mortgage_financial_institution?: Maybe<Scalars['String']['output']>;
  mortgage_google_address_id?: Maybe<Scalars['uuid']['output']>;
  mortgage_insurance_provider_id?: Maybe<Scalars['uuid']['output']>;
  mortgage_insurance_revenue?: Maybe<Scalars['Float']['output']>;
  mortgage_interest_rate?: Maybe<Scalars['Float']['output']>;
  mortgage_interest_rate_type?: Maybe<Scalars['mortgage_interest_rate_type']['output']>;
  mortgage_lender_id?: Maybe<Scalars['uuid']['output']>;
  mortgage_lender_name?: Maybe<Scalars['String']['output']>;
  mortgage_lender_type?: Maybe<Scalars['mortgage_lender_type']['output']>;
  mortgage_mortgage_type?: Maybe<Scalars['String']['output']>;
  mortgage_notary_id?: Maybe<Scalars['uuid']['output']>;
  mortgage_property_usage?: Maybe<Scalars['String']['output']>;
  mortgage_property_value?: Maybe<Scalars['float8']['output']>;
  mortgage_purchase_date?: Maybe<Scalars['timestamptz']['output']>;
  mortgage_purchase_price?: Maybe<Scalars['Float']['output']>;
  mortgage_real_estate_broker_id?: Maybe<Scalars['uuid']['output']>;
  mortgage_report_type?: Maybe<Scalars['String']['output']>;
  mortgage_revenue?: Maybe<Scalars['Float']['output']>;
  mortgage_start_date?: Maybe<Scalars['date']['output']>;
  mortgage_status?: Maybe<Scalars['lead_mortgage_status']['output']>;
  mortgage_step?: Maybe<Scalars['String']['output']>;
  mortgage_term?: Maybe<Scalars['String']['output']>;
  nationality_id?: Maybe<Scalars['uuid']['output']>;
  next_activity_due_at?: Maybe<Scalars['timestamptz']['output']>;
  number_of_buyers?: Maybe<Scalars['Int']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Int']['output']>;
  occupation_id?: Maybe<Scalars['uuid']['output']>;
  occupation_text?: Maybe<Scalars['String']['output']>;
  other_credits?: Maybe<Scalars['Int']['output']>;
  ownership?: Maybe<Scalars['lead_ownership']['output']>;
  parent_lead_id?: Maybe<Scalars['uuid']['output']>;
  partner_annual_premium?: Maybe<Scalars['float8']['output']>;
  partner_date_of_birth?: Maybe<Scalars['date']['output']>;
  partner_donation?: Maybe<Scalars['float8']['output']>;
  partner_first_name?: Maybe<Scalars['String']['output']>;
  partner_gender?: Maybe<Scalars['String']['output']>;
  partner_last_bonus?: Maybe<Scalars['float8']['output']>;
  partner_last_name?: Maybe<Scalars['String']['output']>;
  partner_marital_status?: Maybe<Scalars['String']['output']>;
  partner_nationality_id?: Maybe<Scalars['uuid']['output']>;
  partner_occupation_id?: Maybe<Scalars['uuid']['output']>;
  partner_occupation_text?: Maybe<Scalars['String']['output']>;
  partner_other_credits?: Maybe<Scalars['float8']['output']>;
  partner_professional_situation?: Maybe<Scalars['user_professional_situation']['output']>;
  partner_residence_country_code?: Maybe<Scalars['String']['output']>;
  partner_residence_state_id?: Maybe<Scalars['uuid']['output']>;
  partner_savings?: Maybe<Scalars['float8']['output']>;
  partner_second_pillar?: Maybe<Scalars['float8']['output']>;
  partner_third_pillar?: Maybe<Scalars['float8']['output']>;
  partner_third_pillar_a_organisation?: Maybe<Scalars['String']['output']>;
  partner_work_permit_id?: Maybe<Scalars['uuid']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['float8']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  pos_within_stage?: Maybe<Scalars['Int']['output']>;
  predicted_listing_date?: Maybe<Scalars['timestamptz']['output']>;
  professional_situation?: Maybe<Scalars['user_professional_situation']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_search_notification?: Maybe<Scalars['property_searches_notification']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
  referring_domain?: Maybe<Scalars['String']['output']>;
  refused_at?: Maybe<Scalars['timestamptz']['output']>;
  requalified_at?: Maybe<Scalars['timestamptz']['output']>;
  requalified_or_created_at?: Maybe<Scalars['timestamptz']['output']>;
  residence_country_code?: Maybe<Scalars['String']['output']>;
  residence_state_id?: Maybe<Scalars['uuid']['output']>;
  sale_comments?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Int']['output']>;
  savings?: Maybe<Scalars['float8']['output']>;
  second_contact_id?: Maybe<Scalars['uuid']['output']>;
  second_pillar?: Maybe<Scalars['float8']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  source_organisation_id?: Maybe<Scalars['uuid']['output']>;
  stage_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  third_pillar?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  usable_own_funds?: Maybe<Scalars['float8']['output']>;
  user_info_ip?: Maybe<Scalars['String']['output']>;
  user_info_user_agent?: Maybe<Scalars['String']['output']>;
  work_permit_id?: Maybe<Scalars['uuid']['output']>;
  yearly_revenues?: Maybe<Scalars['float8']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "leads" */
export type Leads_Max_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  anonymized_contact?: InputMaybe<Order_By>;
  appraisal_inheritance_next_step?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_next_step?: InputMaybe<Order_By>;
  appraisal_open_to_offer?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_perception?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_country?: InputMaybe<Order_By>;
  appraisal_property_country_code?: InputMaybe<Order_By>;
  appraisal_property_ctn?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_google_address_id?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_locality?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_occupied?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_plot_number?: InputMaybe<Order_By>;
  appraisal_property_postcode?: InputMaybe<Order_By>;
  appraisal_property_property_type_id?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_route?: InputMaybe<Order_By>;
  appraisal_property_state?: InputMaybe<Order_By>;
  appraisal_property_street_number?: InputMaybe<Order_By>;
  appraisal_property_usage?: InputMaybe<Order_By>;
  appraisal_selling_with?: InputMaybe<Order_By>;
  appraisal_separation_next_step?: InputMaybe<Order_By>;
  appraisal_step?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_third_pillar_a_organisation?: InputMaybe<Order_By>;
  broker_id?: InputMaybe<Order_By>;
  call_times?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_id?: InputMaybe<Order_By>;
  landing_page_url?: InputMaybe<Order_By>;
  last_activity_done_at?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  last_requalification_mail_sent_at?: InputMaybe<Order_By>;
  last_requalification_sms_sent_at?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  marital_status?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  mortgage_buying_status?: InputMaybe<Order_By>;
  mortgage_comments?: InputMaybe<Order_By>;
  mortgage_financial_institution?: InputMaybe<Order_By>;
  mortgage_google_address_id?: InputMaybe<Order_By>;
  mortgage_insurance_provider_id?: InputMaybe<Order_By>;
  mortgage_insurance_revenue?: InputMaybe<Order_By>;
  mortgage_interest_rate?: InputMaybe<Order_By>;
  mortgage_interest_rate_type?: InputMaybe<Order_By>;
  mortgage_lender_id?: InputMaybe<Order_By>;
  mortgage_lender_name?: InputMaybe<Order_By>;
  mortgage_lender_type?: InputMaybe<Order_By>;
  mortgage_mortgage_type?: InputMaybe<Order_By>;
  mortgage_notary_id?: InputMaybe<Order_By>;
  mortgage_property_usage?: InputMaybe<Order_By>;
  mortgage_property_value?: InputMaybe<Order_By>;
  mortgage_purchase_date?: InputMaybe<Order_By>;
  mortgage_purchase_price?: InputMaybe<Order_By>;
  mortgage_real_estate_broker_id?: InputMaybe<Order_By>;
  mortgage_report_type?: InputMaybe<Order_By>;
  mortgage_revenue?: InputMaybe<Order_By>;
  mortgage_start_date?: InputMaybe<Order_By>;
  mortgage_status?: InputMaybe<Order_By>;
  mortgage_step?: InputMaybe<Order_By>;
  mortgage_term?: InputMaybe<Order_By>;
  nationality_id?: InputMaybe<Order_By>;
  next_activity_due_at?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  occupation_id?: InputMaybe<Order_By>;
  occupation_text?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  ownership?: InputMaybe<Order_By>;
  parent_lead_id?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_date_of_birth?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_first_name?: InputMaybe<Order_By>;
  partner_gender?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_last_name?: InputMaybe<Order_By>;
  partner_marital_status?: InputMaybe<Order_By>;
  partner_nationality_id?: InputMaybe<Order_By>;
  partner_occupation_id?: InputMaybe<Order_By>;
  partner_occupation_text?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_professional_situation?: InputMaybe<Order_By>;
  partner_residence_country_code?: InputMaybe<Order_By>;
  partner_residence_state_id?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_third_pillar_a_organisation?: InputMaybe<Order_By>;
  partner_work_permit_id?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  pos_within_stage?: InputMaybe<Order_By>;
  predicted_listing_date?: InputMaybe<Order_By>;
  professional_situation?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_search_notification?: InputMaybe<Order_By>;
  referrer?: InputMaybe<Order_By>;
  referring_domain?: InputMaybe<Order_By>;
  refused_at?: InputMaybe<Order_By>;
  requalified_at?: InputMaybe<Order_By>;
  requalified_or_created_at?: InputMaybe<Order_By>;
  residence_country_code?: InputMaybe<Order_By>;
  residence_state_id?: InputMaybe<Order_By>;
  sale_comments?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_contact_id?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  source_organisation_id?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  user_info_ip?: InputMaybe<Order_By>;
  user_info_user_agent?: InputMaybe<Order_By>;
  work_permit_id?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Leads_Min_Fields = {
  /** A computed field, executes function "lead_user_affordability" */
  affordability_rate?: Maybe<Scalars['float8']['output']>;
  annual_premium?: Maybe<Scalars['float8']['output']>;
  anonymized_contact?: Maybe<Scalars['String']['output']>;
  appraisal_inheritance_next_step?: Maybe<Scalars['String']['output']>;
  appraisal_market_time?: Maybe<Scalars['Int']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_next_step?: Maybe<Scalars['String']['output']>;
  appraisal_open_to_offer?: Maybe<Scalars['String']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_perception?: Maybe<Scalars['String']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Int']['output']>;
  appraisal_property_country?: Maybe<Scalars['String']['output']>;
  appraisal_property_country_code?: Maybe<Scalars['String']['output']>;
  appraisal_property_ctn?: Maybe<Scalars['String']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Int']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_google_address_id?: Maybe<Scalars['uuid']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_locality?: Maybe<Scalars['String']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_occupied?: Maybe<Scalars['String']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_plot_number?: Maybe<Scalars['String']['output']>;
  appraisal_property_postcode?: Maybe<Scalars['String']['output']>;
  appraisal_property_property_type_id?: Maybe<Scalars['uuid']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Int']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_route?: Maybe<Scalars['String']['output']>;
  appraisal_property_state?: Maybe<Scalars['String']['output']>;
  appraisal_property_street_number?: Maybe<Scalars['String']['output']>;
  appraisal_property_usage?: Maybe<Scalars['String']['output']>;
  appraisal_selling_with?: Maybe<Scalars['String']['output']>;
  appraisal_separation_next_step?: Maybe<Scalars['String']['output']>;
  appraisal_step?: Maybe<Scalars['String']['output']>;
  assets_second_pillar?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a_organisation?: Maybe<Scalars['String']['output']>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  call_times?: Maybe<Array<Scalars['String']['output']>>;
  /** A computed field, executes function "leads_claimed_by" */
  claimed_by?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "leads_crm_link" */
  crm_link?: Maybe<Scalars['String']['output']>;
  date_of_birth?: Maybe<Scalars['date']['output']>;
  debt?: Maybe<Scalars['float8']['output']>;
  donation?: Maybe<Scalars['float8']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "financing_crm_link" */
  financing_crm_link?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "lead_user_funds_percentage" */
  fund_usage?: Maybe<Scalars['float8']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_id?: Maybe<Scalars['String']['output']>;
  landing_page_url?: Maybe<Scalars['String']['output']>;
  last_activity_done_at?: Maybe<Scalars['timestamptz']['output']>;
  last_bonus?: Maybe<Scalars['float8']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_requalification_mail_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  last_requalification_sms_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  mandate_probability?: Maybe<Scalars['Int']['output']>;
  marital_status?: Maybe<Scalars['String']['output']>;
  max_property_value?: Maybe<Scalars['float8']['output']>;
  mortgage_buying_status?: Maybe<Scalars['lead_buying_status']['output']>;
  mortgage_comments?: Maybe<Scalars['String']['output']>;
  mortgage_financial_institution?: Maybe<Scalars['String']['output']>;
  mortgage_google_address_id?: Maybe<Scalars['uuid']['output']>;
  mortgage_insurance_provider_id?: Maybe<Scalars['uuid']['output']>;
  mortgage_insurance_revenue?: Maybe<Scalars['Float']['output']>;
  mortgage_interest_rate?: Maybe<Scalars['Float']['output']>;
  mortgage_interest_rate_type?: Maybe<Scalars['mortgage_interest_rate_type']['output']>;
  mortgage_lender_id?: Maybe<Scalars['uuid']['output']>;
  mortgage_lender_name?: Maybe<Scalars['String']['output']>;
  mortgage_lender_type?: Maybe<Scalars['mortgage_lender_type']['output']>;
  mortgage_mortgage_type?: Maybe<Scalars['String']['output']>;
  mortgage_notary_id?: Maybe<Scalars['uuid']['output']>;
  mortgage_property_usage?: Maybe<Scalars['String']['output']>;
  mortgage_property_value?: Maybe<Scalars['float8']['output']>;
  mortgage_purchase_date?: Maybe<Scalars['timestamptz']['output']>;
  mortgage_purchase_price?: Maybe<Scalars['Float']['output']>;
  mortgage_real_estate_broker_id?: Maybe<Scalars['uuid']['output']>;
  mortgage_report_type?: Maybe<Scalars['String']['output']>;
  mortgage_revenue?: Maybe<Scalars['Float']['output']>;
  mortgage_start_date?: Maybe<Scalars['date']['output']>;
  mortgage_status?: Maybe<Scalars['lead_mortgage_status']['output']>;
  mortgage_step?: Maybe<Scalars['String']['output']>;
  mortgage_term?: Maybe<Scalars['String']['output']>;
  nationality_id?: Maybe<Scalars['uuid']['output']>;
  next_activity_due_at?: Maybe<Scalars['timestamptz']['output']>;
  number_of_buyers?: Maybe<Scalars['Int']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Int']['output']>;
  occupation_id?: Maybe<Scalars['uuid']['output']>;
  occupation_text?: Maybe<Scalars['String']['output']>;
  other_credits?: Maybe<Scalars['Int']['output']>;
  ownership?: Maybe<Scalars['lead_ownership']['output']>;
  parent_lead_id?: Maybe<Scalars['uuid']['output']>;
  partner_annual_premium?: Maybe<Scalars['float8']['output']>;
  partner_date_of_birth?: Maybe<Scalars['date']['output']>;
  partner_donation?: Maybe<Scalars['float8']['output']>;
  partner_first_name?: Maybe<Scalars['String']['output']>;
  partner_gender?: Maybe<Scalars['String']['output']>;
  partner_last_bonus?: Maybe<Scalars['float8']['output']>;
  partner_last_name?: Maybe<Scalars['String']['output']>;
  partner_marital_status?: Maybe<Scalars['String']['output']>;
  partner_nationality_id?: Maybe<Scalars['uuid']['output']>;
  partner_occupation_id?: Maybe<Scalars['uuid']['output']>;
  partner_occupation_text?: Maybe<Scalars['String']['output']>;
  partner_other_credits?: Maybe<Scalars['float8']['output']>;
  partner_professional_situation?: Maybe<Scalars['user_professional_situation']['output']>;
  partner_residence_country_code?: Maybe<Scalars['String']['output']>;
  partner_residence_state_id?: Maybe<Scalars['uuid']['output']>;
  partner_savings?: Maybe<Scalars['float8']['output']>;
  partner_second_pillar?: Maybe<Scalars['float8']['output']>;
  partner_third_pillar?: Maybe<Scalars['float8']['output']>;
  partner_third_pillar_a_organisation?: Maybe<Scalars['String']['output']>;
  partner_work_permit_id?: Maybe<Scalars['uuid']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['float8']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  pos_within_stage?: Maybe<Scalars['Int']['output']>;
  predicted_listing_date?: Maybe<Scalars['timestamptz']['output']>;
  professional_situation?: Maybe<Scalars['user_professional_situation']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_search_notification?: Maybe<Scalars['property_searches_notification']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
  referring_domain?: Maybe<Scalars['String']['output']>;
  refused_at?: Maybe<Scalars['timestamptz']['output']>;
  requalified_at?: Maybe<Scalars['timestamptz']['output']>;
  requalified_or_created_at?: Maybe<Scalars['timestamptz']['output']>;
  residence_country_code?: Maybe<Scalars['String']['output']>;
  residence_state_id?: Maybe<Scalars['uuid']['output']>;
  sale_comments?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Int']['output']>;
  savings?: Maybe<Scalars['float8']['output']>;
  second_contact_id?: Maybe<Scalars['uuid']['output']>;
  second_pillar?: Maybe<Scalars['float8']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  source_organisation_id?: Maybe<Scalars['uuid']['output']>;
  stage_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  third_pillar?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  usable_own_funds?: Maybe<Scalars['float8']['output']>;
  user_info_ip?: Maybe<Scalars['String']['output']>;
  user_info_user_agent?: Maybe<Scalars['String']['output']>;
  work_permit_id?: Maybe<Scalars['uuid']['output']>;
  yearly_revenues?: Maybe<Scalars['float8']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "leads" */
export type Leads_Min_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  anonymized_contact?: InputMaybe<Order_By>;
  appraisal_inheritance_next_step?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_next_step?: InputMaybe<Order_By>;
  appraisal_open_to_offer?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_perception?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_country?: InputMaybe<Order_By>;
  appraisal_property_country_code?: InputMaybe<Order_By>;
  appraisal_property_ctn?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_google_address_id?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_locality?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_occupied?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_plot_number?: InputMaybe<Order_By>;
  appraisal_property_postcode?: InputMaybe<Order_By>;
  appraisal_property_property_type_id?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_route?: InputMaybe<Order_By>;
  appraisal_property_state?: InputMaybe<Order_By>;
  appraisal_property_street_number?: InputMaybe<Order_By>;
  appraisal_property_usage?: InputMaybe<Order_By>;
  appraisal_selling_with?: InputMaybe<Order_By>;
  appraisal_separation_next_step?: InputMaybe<Order_By>;
  appraisal_step?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_third_pillar_a_organisation?: InputMaybe<Order_By>;
  broker_id?: InputMaybe<Order_By>;
  call_times?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_id?: InputMaybe<Order_By>;
  landing_page_url?: InputMaybe<Order_By>;
  last_activity_done_at?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  last_requalification_mail_sent_at?: InputMaybe<Order_By>;
  last_requalification_sms_sent_at?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  marital_status?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  mortgage_buying_status?: InputMaybe<Order_By>;
  mortgage_comments?: InputMaybe<Order_By>;
  mortgage_financial_institution?: InputMaybe<Order_By>;
  mortgage_google_address_id?: InputMaybe<Order_By>;
  mortgage_insurance_provider_id?: InputMaybe<Order_By>;
  mortgage_insurance_revenue?: InputMaybe<Order_By>;
  mortgage_interest_rate?: InputMaybe<Order_By>;
  mortgage_interest_rate_type?: InputMaybe<Order_By>;
  mortgage_lender_id?: InputMaybe<Order_By>;
  mortgage_lender_name?: InputMaybe<Order_By>;
  mortgage_lender_type?: InputMaybe<Order_By>;
  mortgage_mortgage_type?: InputMaybe<Order_By>;
  mortgage_notary_id?: InputMaybe<Order_By>;
  mortgage_property_usage?: InputMaybe<Order_By>;
  mortgage_property_value?: InputMaybe<Order_By>;
  mortgage_purchase_date?: InputMaybe<Order_By>;
  mortgage_purchase_price?: InputMaybe<Order_By>;
  mortgage_real_estate_broker_id?: InputMaybe<Order_By>;
  mortgage_report_type?: InputMaybe<Order_By>;
  mortgage_revenue?: InputMaybe<Order_By>;
  mortgage_start_date?: InputMaybe<Order_By>;
  mortgage_status?: InputMaybe<Order_By>;
  mortgage_step?: InputMaybe<Order_By>;
  mortgage_term?: InputMaybe<Order_By>;
  nationality_id?: InputMaybe<Order_By>;
  next_activity_due_at?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  occupation_id?: InputMaybe<Order_By>;
  occupation_text?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  ownership?: InputMaybe<Order_By>;
  parent_lead_id?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_date_of_birth?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_first_name?: InputMaybe<Order_By>;
  partner_gender?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_last_name?: InputMaybe<Order_By>;
  partner_marital_status?: InputMaybe<Order_By>;
  partner_nationality_id?: InputMaybe<Order_By>;
  partner_occupation_id?: InputMaybe<Order_By>;
  partner_occupation_text?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_professional_situation?: InputMaybe<Order_By>;
  partner_residence_country_code?: InputMaybe<Order_By>;
  partner_residence_state_id?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_third_pillar_a_organisation?: InputMaybe<Order_By>;
  partner_work_permit_id?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  pos_within_stage?: InputMaybe<Order_By>;
  predicted_listing_date?: InputMaybe<Order_By>;
  professional_situation?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_search_notification?: InputMaybe<Order_By>;
  referrer?: InputMaybe<Order_By>;
  referring_domain?: InputMaybe<Order_By>;
  refused_at?: InputMaybe<Order_By>;
  requalified_at?: InputMaybe<Order_By>;
  requalified_or_created_at?: InputMaybe<Order_By>;
  residence_country_code?: InputMaybe<Order_By>;
  residence_state_id?: InputMaybe<Order_By>;
  sale_comments?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_contact_id?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  source_organisation_id?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  user_info_ip?: InputMaybe<Order_By>;
  user_info_user_agent?: InputMaybe<Order_By>;
  work_permit_id?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "leads" */
export type Leads_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Leads>;
};

/** input type for inserting object relation for remote table "leads" */
export type Leads_Obj_Rel_Insert_Input = {
  data: Leads_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Leads_On_Conflict>;
};

/** on_conflict condition type for table "leads" */
export type Leads_On_Conflict = {
  constraint: Leads_Constraint;
  update_columns?: Array<Leads_Update_Column>;
  where?: InputMaybe<Leads_Bool_Exp>;
};

/** Ordering options when selecting data from "leads". */
export type Leads_Order_By = {
  activities_aggregate?: InputMaybe<Activities_Aggregate_Order_By>;
  affordability_rate?: InputMaybe<Order_By>;
  annual_premium?: InputMaybe<Order_By>;
  anonymized_contact?: InputMaybe<Order_By>;
  appraisal_inheritance_next_step?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_next_step?: InputMaybe<Order_By>;
  appraisal_open_to_offer?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_perception?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_country?: InputMaybe<Order_By>;
  appraisal_property_country_code?: InputMaybe<Order_By>;
  appraisal_property_ctn?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_google_address_id?: InputMaybe<Order_By>;
  appraisal_property_has_elevator?: InputMaybe<Order_By>;
  appraisal_property_has_garden?: InputMaybe<Order_By>;
  appraisal_property_has_storage_room?: InputMaybe<Order_By>;
  appraisal_property_has_swimming_pool?: InputMaybe<Order_By>;
  appraisal_property_has_view?: InputMaybe<Order_By>;
  appraisal_property_income_includes_parking?: InputMaybe<Order_By>;
  appraisal_property_is_commercial_fully_rented?: InputMaybe<Order_By>;
  appraisal_property_is_parking_fully_rented?: InputMaybe<Order_By>;
  appraisal_property_is_renovated?: InputMaybe<Order_By>;
  appraisal_property_is_residential_fully_rented?: InputMaybe<Order_By>;
  appraisal_property_know_plot_number?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_locality?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_occupied?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_plot_number?: InputMaybe<Order_By>;
  appraisal_property_postcode?: InputMaybe<Order_By>;
  appraisal_property_property_type_id?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_route?: InputMaybe<Order_By>;
  appraisal_property_side?: InputMaybe<Order_By>;
  appraisal_property_state?: InputMaybe<Order_By>;
  appraisal_property_street_number?: InputMaybe<Order_By>;
  appraisal_property_usage?: InputMaybe<Order_By>;
  appraisal_reason?: InputMaybe<Order_By>;
  appraisal_selling_with?: InputMaybe<Order_By>;
  appraisal_separation_next_step?: InputMaybe<Order_By>;
  appraisal_step?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_third_pillar_a_organisation?: InputMaybe<Order_By>;
  broker?: InputMaybe<Users_Order_By>;
  broker_id?: InputMaybe<Order_By>;
  buy_horizon?: InputMaybe<Order_By>;
  call_times?: InputMaybe<Order_By>;
  claimed_by?: InputMaybe<Order_By>;
  cma_reports_aggregate?: InputMaybe<Cma_Reports_Aggregate_Order_By>;
  completed?: InputMaybe<Order_By>;
  contact?: InputMaybe<Users_Order_By>;
  contact_id?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Users_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  crm_link?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  financing_crm_link?: InputMaybe<Order_By>;
  financing_secured?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  fund_usage?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  google_address?: InputMaybe<Google_Addresses_Order_By>;
  has_accepted_terms?: InputMaybe<Order_By>;
  has_dependant_children?: InputMaybe<Order_By>;
  has_no_street_number?: InputMaybe<Order_By>;
  has_other_credits?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_id?: InputMaybe<Order_By>;
  landing_page_url?: InputMaybe<Order_By>;
  last_activity_aggregate?: InputMaybe<Activities_Aggregate_Order_By>;
  last_activity_done_at?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  last_requalification_mail_sent_at?: InputMaybe<Order_By>;
  last_requalification_sms_sent_at?: InputMaybe<Order_By>;
  lead_agents_aggregate?: InputMaybe<Lead_Agents_Aggregate_Order_By>;
  leads_tags_aggregate?: InputMaybe<Leads_Tags_Aggregate_Order_By>;
  lots_aggregate?: InputMaybe<Lots_Aggregate_Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  marital_status?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  mortgage_auto_mortgage_type?: InputMaybe<Order_By>;
  mortgage_buying_status?: InputMaybe<Order_By>;
  mortgage_comments?: InputMaybe<Order_By>;
  mortgage_financial_institution?: InputMaybe<Order_By>;
  mortgage_google_address?: InputMaybe<Google_Addresses_Order_By>;
  mortgage_google_address_id?: InputMaybe<Order_By>;
  mortgage_has_mortgage?: InputMaybe<Order_By>;
  mortgage_insurance_provider_id?: InputMaybe<Order_By>;
  mortgage_insurance_revenue?: InputMaybe<Order_By>;
  mortgage_interest_rate?: InputMaybe<Order_By>;
  mortgage_interest_rate_type?: InputMaybe<Order_By>;
  mortgage_is_construction?: InputMaybe<Order_By>;
  mortgage_is_property_identified?: InputMaybe<Order_By>;
  mortgage_lender_id?: InputMaybe<Order_By>;
  mortgage_lender_name?: InputMaybe<Order_By>;
  mortgage_lender_type?: InputMaybe<Order_By>;
  mortgage_mortgage_type?: InputMaybe<Order_By>;
  mortgage_notary_id?: InputMaybe<Order_By>;
  mortgage_product_mortgage?: InputMaybe<Order_By>;
  mortgage_product_third_pillar?: InputMaybe<Order_By>;
  mortgage_property_usage?: InputMaybe<Order_By>;
  mortgage_property_value?: InputMaybe<Order_By>;
  mortgage_purchase_date?: InputMaybe<Order_By>;
  mortgage_purchase_price?: InputMaybe<Order_By>;
  mortgage_real_estate_broker_id?: InputMaybe<Order_By>;
  mortgage_report_type?: InputMaybe<Order_By>;
  mortgage_revenue?: InputMaybe<Order_By>;
  mortgage_sell?: InputMaybe<Order_By>;
  mortgage_start_date?: InputMaybe<Order_By>;
  mortgage_status?: InputMaybe<Order_By>;
  mortgage_step?: InputMaybe<Order_By>;
  mortgage_term?: InputMaybe<Order_By>;
  nationality_id?: InputMaybe<Order_By>;
  next_activity_aggregate?: InputMaybe<Activities_Aggregate_Order_By>;
  next_activity_due_at?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  occupation_id?: InputMaybe<Order_By>;
  occupation_text?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  ownership?: InputMaybe<Order_By>;
  parent_lead_id?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_date_of_birth?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_first_name?: InputMaybe<Order_By>;
  partner_gender?: InputMaybe<Order_By>;
  partner_has_other_credits?: InputMaybe<Order_By>;
  partner_has_third_pillar?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_last_name?: InputMaybe<Order_By>;
  partner_marital_status?: InputMaybe<Order_By>;
  partner_nationality_id?: InputMaybe<Order_By>;
  partner_occupation_id?: InputMaybe<Order_By>;
  partner_occupation_text?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_professional_situation?: InputMaybe<Order_By>;
  partner_residence_country_code?: InputMaybe<Order_By>;
  partner_residence_state_id?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_third_pillar_a_organisation?: InputMaybe<Order_By>;
  partner_use_bank_third_pillar?: InputMaybe<Order_By>;
  partner_use_insurance_third_pillar?: InputMaybe<Order_By>;
  partner_work_permit_id?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  pos_within_stage?: InputMaybe<Order_By>;
  potential_development?: InputMaybe<Order_By>;
  predicted_listing_date?: InputMaybe<Order_By>;
  professional_situation?: InputMaybe<Order_By>;
  property?: InputMaybe<Properties_Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_search_notification?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Property_Types_Order_By>;
  property_usage?: InputMaybe<Order_By>;
  received_mortgage_offer?: InputMaybe<Order_By>;
  referrer?: InputMaybe<Order_By>;
  referring_domain?: InputMaybe<Order_By>;
  refused_at?: InputMaybe<Order_By>;
  relationship?: InputMaybe<Order_By>;
  requalification_status?: InputMaybe<Order_By>;
  requalified_at?: InputMaybe<Order_By>;
  requalified_or_created_at?: InputMaybe<Order_By>;
  residence_country_code?: InputMaybe<Order_By>;
  residence_state_id?: InputMaybe<Order_By>;
  sale_comments?: InputMaybe<Order_By>;
  sale_has_found?: InputMaybe<Order_By>;
  sale_horizon?: InputMaybe<Order_By>;
  sale_is_seller?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_started?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_contact?: InputMaybe<Users_Order_By>;
  second_contact_id?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  should_be_requalified?: InputMaybe<Order_By>;
  snapshot?: InputMaybe<Order_By>;
  source?: InputMaybe<Dictionaries_Order_By>;
  source_id?: InputMaybe<Order_By>;
  source_organisation_id?: InputMaybe<Order_By>;
  stage?: InputMaybe<Lead_Stages_Order_By>;
  stage_id?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  use_bank_third_pillar?: InputMaybe<Order_By>;
  use_insurance_third_pillar?: InputMaybe<Order_By>;
  use_second_pillar?: InputMaybe<Order_By>;
  use_third_pillar?: InputMaybe<Order_By>;
  user_info_ip?: InputMaybe<Order_By>;
  user_info_user_agent?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
  work_permit_id?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** primary key columns input for table: leads */
export type Leads_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

export enum Leads_Property_Usage_Enum {
  NotSet = 'not_set',
  Other = 'other',
  PrimaryResidence = 'primary_residence',
  RentalProperty = 'rental_property',
  SecondaryResidence = 'secondary_residence'
}

/** Boolean expression to compare columns of type "leads_property_usage_enum". All fields are combined with logical 'AND'. */
export type Leads_Property_Usage_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Leads_Property_Usage_Enum>;
  _in?: InputMaybe<Array<Leads_Property_Usage_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Leads_Property_Usage_Enum>;
  _nin?: InputMaybe<Array<Leads_Property_Usage_Enum>>;
};

export enum Leads_Relationship_Enum {
  Agent = 'agent',
  Buyer = 'buyer',
  Heir = 'heir',
  NotSet = 'not_set',
  Other = 'other',
  Owner = 'owner',
  Tenant = 'tenant'
}

/** Boolean expression to compare columns of type "leads_relationship_enum". All fields are combined with logical 'AND'. */
export type Leads_Relationship_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Leads_Relationship_Enum>;
  _in?: InputMaybe<Array<Leads_Relationship_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Leads_Relationship_Enum>;
  _nin?: InputMaybe<Array<Leads_Relationship_Enum>>;
};

export enum Leads_Requalification_Status_Enum {
  NotSet = 'not_set',
  Started = 'started'
}

/** Boolean expression to compare columns of type "leads_requalification_status_enum". All fields are combined with logical 'AND'. */
export type Leads_Requalification_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Leads_Requalification_Status_Enum>;
  _in?: InputMaybe<Array<Leads_Requalification_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Leads_Requalification_Status_Enum>;
  _nin?: InputMaybe<Array<Leads_Requalification_Status_Enum>>;
};

export enum Leads_Sale_Horizon_Enum {
  AlreadyForSale = 'already_for_sale',
  From_1To_2Years = 'from_1_to_2_years',
  From_2Years = 'from_2_years',
  From_6To_12Months = 'from_6_to_12_months',
  NotSelling = 'not_selling',
  NotSet = 'not_set',
  Under_6Months = 'under_6_months'
}

/** Boolean expression to compare columns of type "leads_sale_horizon_enum". All fields are combined with logical 'AND'. */
export type Leads_Sale_Horizon_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Leads_Sale_Horizon_Enum>;
  _in?: InputMaybe<Array<Leads_Sale_Horizon_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Leads_Sale_Horizon_Enum>;
  _nin?: InputMaybe<Array<Leads_Sale_Horizon_Enum>>;
};

/** select columns of table "leads" */
export enum Leads_Select_Column {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AnonymizedContact = 'anonymized_contact',
  /** column name */
  AppraisalInheritanceNextStep = 'appraisal_inheritance_next_step',
  /** column name */
  AppraisalMarketTime = 'appraisal_market_time',
  /** column name */
  AppraisalMonthlyGrossRent = 'appraisal_monthly_gross_rent',
  /** column name */
  AppraisalNextStep = 'appraisal_next_step',
  /** column name */
  AppraisalOpenToOffer = 'appraisal_open_to_offer',
  /** column name */
  AppraisalPerceivedValue = 'appraisal_perceived_value',
  /** column name */
  AppraisalPerception = 'appraisal_perception',
  /** column name */
  AppraisalPropertyBalconySurface = 'appraisal_property_balcony_surface',
  /** column name */
  AppraisalPropertyBuiltSurface = 'appraisal_property_built_surface',
  /** column name */
  AppraisalPropertyCommercialPotentialRentalIncome = 'appraisal_property_commercial_potential_rental_income',
  /** column name */
  AppraisalPropertyCommercialSurface = 'appraisal_property_commercial_surface',
  /** column name */
  AppraisalPropertyCommercialYearlyRentalIncome = 'appraisal_property_commercial_yearly_rental_income',
  /** column name */
  AppraisalPropertyConstructionYear = 'appraisal_property_construction_year',
  /** column name */
  AppraisalPropertyCountry = 'appraisal_property_country',
  /** column name */
  AppraisalPropertyCountryCode = 'appraisal_property_country_code',
  /** column name */
  AppraisalPropertyCtn = 'appraisal_property_ctn',
  /** column name */
  AppraisalPropertyFloorOfFlat = 'appraisal_property_floor_of_flat',
  /** column name */
  AppraisalPropertyGardenSurface = 'appraisal_property_garden_surface',
  /** column name */
  AppraisalPropertyGoogleAddressId = 'appraisal_property_google_address_id',
  /** column name */
  AppraisalPropertyHasElevator = 'appraisal_property_has_elevator',
  /** column name */
  AppraisalPropertyHasGarden = 'appraisal_property_has_garden',
  /** column name */
  AppraisalPropertyHasStorageRoom = 'appraisal_property_has_storage_room',
  /** column name */
  AppraisalPropertyHasSwimmingPool = 'appraisal_property_has_swimming_pool',
  /** column name */
  AppraisalPropertyHasView = 'appraisal_property_has_view',
  /** column name */
  AppraisalPropertyIncomeIncludesParking = 'appraisal_property_income_includes_parking',
  /** column name */
  AppraisalPropertyIsCommercialFullyRented = 'appraisal_property_is_commercial_fully_rented',
  /** column name */
  AppraisalPropertyIsParkingFullyRented = 'appraisal_property_is_parking_fully_rented',
  /** column name */
  AppraisalPropertyIsRenovated = 'appraisal_property_is_renovated',
  /** column name */
  AppraisalPropertyIsResidentialFullyRented = 'appraisal_property_is_residential_fully_rented',
  /** column name */
  AppraisalPropertyKnowPlotNumber = 'appraisal_property_know_plot_number',
  /** column name */
  AppraisalPropertyLandSurface = 'appraisal_property_land_surface',
  /** column name */
  AppraisalPropertyLat = 'appraisal_property_lat',
  /** column name */
  AppraisalPropertyLivingSurface = 'appraisal_property_living_surface',
  /** column name */
  AppraisalPropertyLng = 'appraisal_property_lng',
  /** column name */
  AppraisalPropertyLocality = 'appraisal_property_locality',
  /** column name */
  AppraisalPropertyNumberOfBathrooms = 'appraisal_property_number_of_bathrooms',
  /** column name */
  AppraisalPropertyNumberOfBedrooms = 'appraisal_property_number_of_bedrooms',
  /** column name */
  AppraisalPropertyNumberOfCommercialUnits = 'appraisal_property_number_of_commercial_units',
  /** column name */
  AppraisalPropertyNumberOfFloors = 'appraisal_property_number_of_floors',
  /** column name */
  AppraisalPropertyNumberOfIndoorParkings = 'appraisal_property_number_of_indoor_parkings',
  /** column name */
  AppraisalPropertyNumberOfOutdoorParkings = 'appraisal_property_number_of_outdoor_parkings',
  /** column name */
  AppraisalPropertyNumberOfResidentialUnits = 'appraisal_property_number_of_residential_units',
  /** column name */
  AppraisalPropertyNumberOfRooms = 'appraisal_property_number_of_rooms',
  /** column name */
  AppraisalPropertyOccupied = 'appraisal_property_occupied',
  /** column name */
  AppraisalPropertyParkingPotentialRentalIncome = 'appraisal_property_parking_potential_rental_income',
  /** column name */
  AppraisalPropertyParkingYearlyRentalIncome = 'appraisal_property_parking_yearly_rental_income',
  /** column name */
  AppraisalPropertyPlotNumber = 'appraisal_property_plot_number',
  /** column name */
  AppraisalPropertyPostcode = 'appraisal_property_postcode',
  /** column name */
  AppraisalPropertyPropertyTypeId = 'appraisal_property_property_type_id',
  /** column name */
  AppraisalPropertyRenovationYear = 'appraisal_property_renovation_year',
  /** column name */
  AppraisalPropertyResidentialPotentialRentalIncome = 'appraisal_property_residential_potential_rental_income',
  /** column name */
  AppraisalPropertyResidentialSurface = 'appraisal_property_residential_surface',
  /** column name */
  AppraisalPropertyResidentialYearlyRentalIncome = 'appraisal_property_residential_yearly_rental_income',
  /** column name */
  AppraisalPropertyRoute = 'appraisal_property_route',
  /** column name */
  AppraisalPropertySide = 'appraisal_property_side',
  /** column name */
  AppraisalPropertyState = 'appraisal_property_state',
  /** column name */
  AppraisalPropertyStreetNumber = 'appraisal_property_street_number',
  /** column name */
  AppraisalPropertyUsage = 'appraisal_property_usage',
  /** column name */
  AppraisalReason = 'appraisal_reason',
  /** column name */
  AppraisalSellingWith = 'appraisal_selling_with',
  /** column name */
  AppraisalSeparationNextStep = 'appraisal_separation_next_step',
  /** column name */
  AppraisalStep = 'appraisal_step',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  AssetsThirdPillarAOrganisation = 'assets_third_pillar_a_organisation',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  BuyHorizon = 'buy_horizon',
  /** column name */
  CallTimes = 'call_times',
  /** column name */
  Completed = 'completed',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FinancingSecured = 'financing_secured',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasDependantChildren = 'has_dependant_children',
  /** column name */
  HasNoStreetNumber = 'has_no_street_number',
  /** column name */
  HasOtherCredits = 'has_other_credits',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  LandingPageUrl = 'landing_page_url',
  /** column name */
  LastActivityDoneAt = 'last_activity_done_at',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LastRequalificationMailSentAt = 'last_requalification_mail_sent_at',
  /** column name */
  LastRequalificationSmsSentAt = 'last_requalification_sms_sent_at',
  /** column name */
  MandateProbability = 'mandate_probability',
  /** column name */
  MaritalStatus = 'marital_status',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgageAutoMortgageType = 'mortgage_auto_mortgage_type',
  /** column name */
  MortgageBuyingStatus = 'mortgage_buying_status',
  /** column name */
  MortgageComments = 'mortgage_comments',
  /** column name */
  MortgageFinancialInstitution = 'mortgage_financial_institution',
  /** column name */
  MortgageGoogleAddressId = 'mortgage_google_address_id',
  /** column name */
  MortgageHasMortgage = 'mortgage_has_mortgage',
  /** column name */
  MortgageInsuranceProviderId = 'mortgage_insurance_provider_id',
  /** column name */
  MortgageInsuranceRevenue = 'mortgage_insurance_revenue',
  /** column name */
  MortgageInterestRate = 'mortgage_interest_rate',
  /** column name */
  MortgageInterestRateType = 'mortgage_interest_rate_type',
  /** column name */
  MortgageIsConstruction = 'mortgage_is_construction',
  /** column name */
  MortgageIsPropertyIdentified = 'mortgage_is_property_identified',
  /** column name */
  MortgageLenderId = 'mortgage_lender_id',
  /** column name */
  MortgageLenderName = 'mortgage_lender_name',
  /** column name */
  MortgageLenderType = 'mortgage_lender_type',
  /** column name */
  MortgageMortgageType = 'mortgage_mortgage_type',
  /** column name */
  MortgageNotaryId = 'mortgage_notary_id',
  /** column name */
  MortgageProductMortgage = 'mortgage_product_mortgage',
  /** column name */
  MortgageProductThirdPillar = 'mortgage_product_third_pillar',
  /** column name */
  MortgagePropertyUsage = 'mortgage_property_usage',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  MortgagePurchaseDate = 'mortgage_purchase_date',
  /** column name */
  MortgagePurchasePrice = 'mortgage_purchase_price',
  /** column name */
  MortgageRealEstateBrokerId = 'mortgage_real_estate_broker_id',
  /** column name */
  MortgageReportType = 'mortgage_report_type',
  /** column name */
  MortgageRevenue = 'mortgage_revenue',
  /** column name */
  MortgageSell = 'mortgage_sell',
  /** column name */
  MortgageStartDate = 'mortgage_start_date',
  /** column name */
  MortgageStatus = 'mortgage_status',
  /** column name */
  MortgageStep = 'mortgage_step',
  /** column name */
  MortgageTerm = 'mortgage_term',
  /** column name */
  NationalityId = 'nationality_id',
  /** column name */
  NextActivityDueAt = 'next_activity_due_at',
  /** column name */
  NumberOfBuyers = 'number_of_buyers',
  /** column name */
  NumberOfDependantChildren = 'number_of_dependant_children',
  /** column name */
  OccupationId = 'occupation_id',
  /** column name */
  OccupationText = 'occupation_text',
  /** column name */
  OtherCredits = 'other_credits',
  /** column name */
  Ownership = 'ownership',
  /** column name */
  ParentLeadId = 'parent_lead_id',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDateOfBirth = 'partner_date_of_birth',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerFirstName = 'partner_first_name',
  /** column name */
  PartnerGender = 'partner_gender',
  /** column name */
  PartnerHasOtherCredits = 'partner_has_other_credits',
  /** column name */
  PartnerHasThirdPillar = 'partner_has_third_pillar',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerLastName = 'partner_last_name',
  /** column name */
  PartnerMaritalStatus = 'partner_marital_status',
  /** column name */
  PartnerNationalityId = 'partner_nationality_id',
  /** column name */
  PartnerOccupationId = 'partner_occupation_id',
  /** column name */
  PartnerOccupationText = 'partner_occupation_text',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerProfessionalSituation = 'partner_professional_situation',
  /** column name */
  PartnerResidenceCountryCode = 'partner_residence_country_code',
  /** column name */
  PartnerResidenceStateId = 'partner_residence_state_id',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerThirdPillarAOrganisation = 'partner_third_pillar_a_organisation',
  /** column name */
  PartnerUseBankThirdPillar = 'partner_use_bank_third_pillar',
  /** column name */
  PartnerUseInsuranceThirdPillar = 'partner_use_insurance_third_pillar',
  /** column name */
  PartnerWorkPermitId = 'partner_work_permit_id',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PosWithinStage = 'pos_within_stage',
  /** column name */
  PotentialDevelopment = 'potential_development',
  /** column name */
  PredictedListingDate = 'predicted_listing_date',
  /** column name */
  ProfessionalSituation = 'professional_situation',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertySearchNotification = 'property_search_notification',
  /** column name */
  PropertyUsage = 'property_usage',
  /** column name */
  ReceivedMortgageOffer = 'received_mortgage_offer',
  /** column name */
  Referrer = 'referrer',
  /** column name */
  ReferringDomain = 'referring_domain',
  /** column name */
  RefusedAt = 'refused_at',
  /** column name */
  Relationship = 'relationship',
  /** column name */
  RequalificationStatus = 'requalification_status',
  /** column name */
  RequalifiedAt = 'requalified_at',
  /** column name */
  RequalifiedOrCreatedAt = 'requalified_or_created_at',
  /** column name */
  ResidenceCountryCode = 'residence_country_code',
  /** column name */
  ResidenceStateId = 'residence_state_id',
  /** column name */
  SaleComments = 'sale_comments',
  /** column name */
  SaleHasFound = 'sale_has_found',
  /** column name */
  SaleHorizon = 'sale_horizon',
  /** column name */
  SaleIsSeller = 'sale_is_seller',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SaleStarted = 'sale_started',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondContactId = 'second_contact_id',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Snapshot = 'snapshot',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  SourceOrganisationId = 'source_organisation_id',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  UseBankThirdPillar = 'use_bank_third_pillar',
  /** column name */
  UseInsuranceThirdPillar = 'use_insurance_third_pillar',
  /** column name */
  UseSecondPillar = 'use_second_pillar',
  /** column name */
  UseThirdPillar = 'use_third_pillar',
  /** column name */
  UserInfoIp = 'user_info_ip',
  /** column name */
  UserInfoUserAgent = 'user_info_user_agent',
  /** column name */
  Verified = 'verified',
  /** column name */
  WorkPermitId = 'work_permit_id',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "leads_aggregate_bool_exp_avg_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "leads_aggregate_bool_exp_bool_and_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AppraisalPropertyHasElevator = 'appraisal_property_has_elevator',
  /** column name */
  AppraisalPropertyHasGarden = 'appraisal_property_has_garden',
  /** column name */
  AppraisalPropertyHasStorageRoom = 'appraisal_property_has_storage_room',
  /** column name */
  AppraisalPropertyHasSwimmingPool = 'appraisal_property_has_swimming_pool',
  /** column name */
  AppraisalPropertyHasView = 'appraisal_property_has_view',
  /** column name */
  AppraisalPropertyIncomeIncludesParking = 'appraisal_property_income_includes_parking',
  /** column name */
  AppraisalPropertyIsCommercialFullyRented = 'appraisal_property_is_commercial_fully_rented',
  /** column name */
  AppraisalPropertyIsParkingFullyRented = 'appraisal_property_is_parking_fully_rented',
  /** column name */
  AppraisalPropertyIsRenovated = 'appraisal_property_is_renovated',
  /** column name */
  AppraisalPropertyIsResidentialFullyRented = 'appraisal_property_is_residential_fully_rented',
  /** column name */
  AppraisalPropertyKnowPlotNumber = 'appraisal_property_know_plot_number',
  /** column name */
  Completed = 'completed',
  /** column name */
  FinancingSecured = 'financing_secured',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasDependantChildren = 'has_dependant_children',
  /** column name */
  HasNoStreetNumber = 'has_no_street_number',
  /** column name */
  HasOtherCredits = 'has_other_credits',
  /** column name */
  MortgageAutoMortgageType = 'mortgage_auto_mortgage_type',
  /** column name */
  MortgageHasMortgage = 'mortgage_has_mortgage',
  /** column name */
  MortgageIsConstruction = 'mortgage_is_construction',
  /** column name */
  MortgageIsPropertyIdentified = 'mortgage_is_property_identified',
  /** column name */
  MortgageProductMortgage = 'mortgage_product_mortgage',
  /** column name */
  MortgageProductThirdPillar = 'mortgage_product_third_pillar',
  /** column name */
  MortgageSell = 'mortgage_sell',
  /** column name */
  PartnerHasOtherCredits = 'partner_has_other_credits',
  /** column name */
  PartnerHasThirdPillar = 'partner_has_third_pillar',
  /** column name */
  PartnerUseBankThirdPillar = 'partner_use_bank_third_pillar',
  /** column name */
  PartnerUseInsuranceThirdPillar = 'partner_use_insurance_third_pillar',
  /** column name */
  PotentialDevelopment = 'potential_development',
  /** column name */
  ReceivedMortgageOffer = 'received_mortgage_offer',
  /** column name */
  SaleHasFound = 'sale_has_found',
  /** column name */
  SaleIsSeller = 'sale_is_seller',
  /** column name */
  SaleStarted = 'sale_started',
  /** column name */
  UseBankThirdPillar = 'use_bank_third_pillar',
  /** column name */
  UseInsuranceThirdPillar = 'use_insurance_third_pillar',
  /** column name */
  UseSecondPillar = 'use_second_pillar',
  /** column name */
  UseThirdPillar = 'use_third_pillar',
  /** column name */
  Verified = 'verified'
}

/** select "leads_aggregate_bool_exp_bool_or_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AppraisalPropertyHasElevator = 'appraisal_property_has_elevator',
  /** column name */
  AppraisalPropertyHasGarden = 'appraisal_property_has_garden',
  /** column name */
  AppraisalPropertyHasStorageRoom = 'appraisal_property_has_storage_room',
  /** column name */
  AppraisalPropertyHasSwimmingPool = 'appraisal_property_has_swimming_pool',
  /** column name */
  AppraisalPropertyHasView = 'appraisal_property_has_view',
  /** column name */
  AppraisalPropertyIncomeIncludesParking = 'appraisal_property_income_includes_parking',
  /** column name */
  AppraisalPropertyIsCommercialFullyRented = 'appraisal_property_is_commercial_fully_rented',
  /** column name */
  AppraisalPropertyIsParkingFullyRented = 'appraisal_property_is_parking_fully_rented',
  /** column name */
  AppraisalPropertyIsRenovated = 'appraisal_property_is_renovated',
  /** column name */
  AppraisalPropertyIsResidentialFullyRented = 'appraisal_property_is_residential_fully_rented',
  /** column name */
  AppraisalPropertyKnowPlotNumber = 'appraisal_property_know_plot_number',
  /** column name */
  Completed = 'completed',
  /** column name */
  FinancingSecured = 'financing_secured',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasDependantChildren = 'has_dependant_children',
  /** column name */
  HasNoStreetNumber = 'has_no_street_number',
  /** column name */
  HasOtherCredits = 'has_other_credits',
  /** column name */
  MortgageAutoMortgageType = 'mortgage_auto_mortgage_type',
  /** column name */
  MortgageHasMortgage = 'mortgage_has_mortgage',
  /** column name */
  MortgageIsConstruction = 'mortgage_is_construction',
  /** column name */
  MortgageIsPropertyIdentified = 'mortgage_is_property_identified',
  /** column name */
  MortgageProductMortgage = 'mortgage_product_mortgage',
  /** column name */
  MortgageProductThirdPillar = 'mortgage_product_third_pillar',
  /** column name */
  MortgageSell = 'mortgage_sell',
  /** column name */
  PartnerHasOtherCredits = 'partner_has_other_credits',
  /** column name */
  PartnerHasThirdPillar = 'partner_has_third_pillar',
  /** column name */
  PartnerUseBankThirdPillar = 'partner_use_bank_third_pillar',
  /** column name */
  PartnerUseInsuranceThirdPillar = 'partner_use_insurance_third_pillar',
  /** column name */
  PotentialDevelopment = 'potential_development',
  /** column name */
  ReceivedMortgageOffer = 'received_mortgage_offer',
  /** column name */
  SaleHasFound = 'sale_has_found',
  /** column name */
  SaleIsSeller = 'sale_is_seller',
  /** column name */
  SaleStarted = 'sale_started',
  /** column name */
  UseBankThirdPillar = 'use_bank_third_pillar',
  /** column name */
  UseInsuranceThirdPillar = 'use_insurance_third_pillar',
  /** column name */
  UseSecondPillar = 'use_second_pillar',
  /** column name */
  UseThirdPillar = 'use_third_pillar',
  /** column name */
  Verified = 'verified'
}

/** select "leads_aggregate_bool_exp_corr_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "leads_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "leads_aggregate_bool_exp_max_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "leads_aggregate_bool_exp_min_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "leads_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "leads_aggregate_bool_exp_sum_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "leads_aggregate_bool_exp_var_samp_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** input type for updating data in table "leads" */
export type Leads_Set_Input = {
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "leads_status" */
export type Leads_Status = {
  /** A computed field, executes function "leads_status_label" */
  label?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "leads_status". All fields are combined with a logical 'AND'. */
export type Leads_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Leads_Status_Bool_Exp>>;
  _not?: InputMaybe<Leads_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Leads_Status_Bool_Exp>>;
  label?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Leads_Status_Enum {
  Active = 'active',
  Lost = 'lost',
  Won = 'won'
}

/** Boolean expression to compare columns of type "leads_status_enum". All fields are combined with logical 'AND'. */
export type Leads_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Leads_Status_Enum>;
  _in?: InputMaybe<Array<Leads_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Leads_Status_Enum>;
  _nin?: InputMaybe<Array<Leads_Status_Enum>>;
};

/** Ordering options when selecting data from "leads_status". */
export type Leads_Status_Order_By = {
  label?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "leads_status" */
export enum Leads_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "leads_status" */
export type Leads_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Leads_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Leads_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Leads_Stddev_Fields = {
  /** A computed field, executes function "lead_user_affordability" */
  affordability_rate?: Maybe<Scalars['float8']['output']>;
  annual_premium?: Maybe<Scalars['Float']['output']>;
  appraisal_market_time?: Maybe<Scalars['Float']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "lead_user_funds_percentage" */
  fund_usage?: Maybe<Scalars['float8']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  mandate_probability?: Maybe<Scalars['Float']['output']>;
  max_property_value?: Maybe<Scalars['Float']['output']>;
  mortgage_insurance_revenue?: Maybe<Scalars['Float']['output']>;
  mortgage_interest_rate?: Maybe<Scalars['Float']['output']>;
  mortgage_property_value?: Maybe<Scalars['Float']['output']>;
  mortgage_purchase_price?: Maybe<Scalars['Float']['output']>;
  mortgage_revenue?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  other_credits?: Maybe<Scalars['Float']['output']>;
  partner_annual_premium?: Maybe<Scalars['Float']['output']>;
  partner_donation?: Maybe<Scalars['Float']['output']>;
  partner_last_bonus?: Maybe<Scalars['Float']['output']>;
  partner_other_credits?: Maybe<Scalars['Float']['output']>;
  partner_savings?: Maybe<Scalars['Float']['output']>;
  partner_second_pillar?: Maybe<Scalars['Float']['output']>;
  partner_third_pillar?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
  pos_within_stage?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  savings?: Maybe<Scalars['Float']['output']>;
  second_pillar?: Maybe<Scalars['Float']['output']>;
  third_pillar?: Maybe<Scalars['Float']['output']>;
  usable_own_funds?: Maybe<Scalars['Float']['output']>;
  yearly_revenues?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "leads" */
export type Leads_Stddev_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  mortgage_insurance_revenue?: InputMaybe<Order_By>;
  mortgage_interest_rate?: InputMaybe<Order_By>;
  mortgage_property_value?: InputMaybe<Order_By>;
  mortgage_purchase_price?: InputMaybe<Order_By>;
  mortgage_revenue?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  pos_within_stage?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Leads_Stddev_Pop_Fields = {
  /** A computed field, executes function "lead_user_affordability" */
  affordability_rate?: Maybe<Scalars['float8']['output']>;
  annual_premium?: Maybe<Scalars['Float']['output']>;
  appraisal_market_time?: Maybe<Scalars['Float']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "lead_user_funds_percentage" */
  fund_usage?: Maybe<Scalars['float8']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  mandate_probability?: Maybe<Scalars['Float']['output']>;
  max_property_value?: Maybe<Scalars['Float']['output']>;
  mortgage_insurance_revenue?: Maybe<Scalars['Float']['output']>;
  mortgage_interest_rate?: Maybe<Scalars['Float']['output']>;
  mortgage_property_value?: Maybe<Scalars['Float']['output']>;
  mortgage_purchase_price?: Maybe<Scalars['Float']['output']>;
  mortgage_revenue?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  other_credits?: Maybe<Scalars['Float']['output']>;
  partner_annual_premium?: Maybe<Scalars['Float']['output']>;
  partner_donation?: Maybe<Scalars['Float']['output']>;
  partner_last_bonus?: Maybe<Scalars['Float']['output']>;
  partner_other_credits?: Maybe<Scalars['Float']['output']>;
  partner_savings?: Maybe<Scalars['Float']['output']>;
  partner_second_pillar?: Maybe<Scalars['Float']['output']>;
  partner_third_pillar?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
  pos_within_stage?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  savings?: Maybe<Scalars['Float']['output']>;
  second_pillar?: Maybe<Scalars['Float']['output']>;
  third_pillar?: Maybe<Scalars['Float']['output']>;
  usable_own_funds?: Maybe<Scalars['Float']['output']>;
  yearly_revenues?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "leads" */
export type Leads_Stddev_Pop_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  mortgage_insurance_revenue?: InputMaybe<Order_By>;
  mortgage_interest_rate?: InputMaybe<Order_By>;
  mortgage_property_value?: InputMaybe<Order_By>;
  mortgage_purchase_price?: InputMaybe<Order_By>;
  mortgage_revenue?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  pos_within_stage?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Leads_Stddev_Samp_Fields = {
  /** A computed field, executes function "lead_user_affordability" */
  affordability_rate?: Maybe<Scalars['float8']['output']>;
  annual_premium?: Maybe<Scalars['Float']['output']>;
  appraisal_market_time?: Maybe<Scalars['Float']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "lead_user_funds_percentage" */
  fund_usage?: Maybe<Scalars['float8']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  mandate_probability?: Maybe<Scalars['Float']['output']>;
  max_property_value?: Maybe<Scalars['Float']['output']>;
  mortgage_insurance_revenue?: Maybe<Scalars['Float']['output']>;
  mortgage_interest_rate?: Maybe<Scalars['Float']['output']>;
  mortgage_property_value?: Maybe<Scalars['Float']['output']>;
  mortgage_purchase_price?: Maybe<Scalars['Float']['output']>;
  mortgage_revenue?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  other_credits?: Maybe<Scalars['Float']['output']>;
  partner_annual_premium?: Maybe<Scalars['Float']['output']>;
  partner_donation?: Maybe<Scalars['Float']['output']>;
  partner_last_bonus?: Maybe<Scalars['Float']['output']>;
  partner_other_credits?: Maybe<Scalars['Float']['output']>;
  partner_savings?: Maybe<Scalars['Float']['output']>;
  partner_second_pillar?: Maybe<Scalars['Float']['output']>;
  partner_third_pillar?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
  pos_within_stage?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  savings?: Maybe<Scalars['Float']['output']>;
  second_pillar?: Maybe<Scalars['Float']['output']>;
  third_pillar?: Maybe<Scalars['Float']['output']>;
  usable_own_funds?: Maybe<Scalars['Float']['output']>;
  yearly_revenues?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "leads" */
export type Leads_Stddev_Samp_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  mortgage_insurance_revenue?: InputMaybe<Order_By>;
  mortgage_interest_rate?: InputMaybe<Order_By>;
  mortgage_property_value?: InputMaybe<Order_By>;
  mortgage_purchase_price?: InputMaybe<Order_By>;
  mortgage_revenue?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  pos_within_stage?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "leads" */
export type Leads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Leads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Leads_Stream_Cursor_Value_Input = {
  annual_premium?: InputMaybe<Scalars['float8']['input']>;
  anonymized_contact?: InputMaybe<Scalars['String']['input']>;
  appraisal_inheritance_next_step?: InputMaybe<Scalars['String']['input']>;
  appraisal_market_time?: InputMaybe<Scalars['Int']['input']>;
  appraisal_monthly_gross_rent?: InputMaybe<Scalars['Float']['input']>;
  appraisal_next_step?: InputMaybe<Scalars['String']['input']>;
  appraisal_open_to_offer?: InputMaybe<Scalars['String']['input']>;
  appraisal_perceived_value?: InputMaybe<Scalars['Float']['input']>;
  appraisal_perception?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_built_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_commercial_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_construction_year?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_country?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_country_code?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_ctn?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_garden_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  appraisal_property_has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_has_garden?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_has_storage_room?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_has_view?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_income_includes_parking?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_is_commercial_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_is_parking_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_is_renovated?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_is_residential_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_know_plot_number?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_land_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_lat?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_living_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_lng?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_locality?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_residential_units?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_occupied?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_plot_number?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_postcode?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_property_type_id?: InputMaybe<Scalars['uuid']['input']>;
  appraisal_property_renovation_year?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_residential_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_route?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_side?: InputMaybe<Property_Side_Enum_Enum>;
  appraisal_property_state?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_street_number?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_usage?: InputMaybe<Scalars['String']['input']>;
  appraisal_reason?: InputMaybe<Leads_Appraisal_Reason_Enum>;
  appraisal_selling_with?: InputMaybe<Scalars['String']['input']>;
  appraisal_separation_next_step?: InputMaybe<Scalars['String']['input']>;
  appraisal_step?: InputMaybe<Scalars['String']['input']>;
  assets_second_pillar?: InputMaybe<Scalars['float8']['input']>;
  assets_third_pillar_a_organisation?: InputMaybe<Scalars['String']['input']>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buy_horizon?: InputMaybe<Leads_Buy_Horizon_Enum>;
  call_times?: InputMaybe<Array<Scalars['String']['input']>>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  date_of_birth?: InputMaybe<Scalars['date']['input']>;
  debt?: InputMaybe<Scalars['float8']['input']>;
  donation?: InputMaybe<Scalars['float8']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  financing_secured?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  has_accepted_terms?: InputMaybe<Scalars['Boolean']['input']>;
  has_dependant_children?: InputMaybe<Scalars['Boolean']['input']>;
  has_no_street_number?: InputMaybe<Scalars['Boolean']['input']>;
  has_other_credits?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  landing_page_url?: InputMaybe<Scalars['String']['input']>;
  last_activity_done_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_bonus?: InputMaybe<Scalars['float8']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  last_requalification_mail_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_requalification_sms_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  mandate_probability?: InputMaybe<Scalars['Int']['input']>;
  marital_status?: InputMaybe<Scalars['String']['input']>;
  max_property_value?: InputMaybe<Scalars['float8']['input']>;
  mortgage_auto_mortgage_type?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_buying_status?: InputMaybe<Scalars['lead_buying_status']['input']>;
  mortgage_comments?: InputMaybe<Scalars['String']['input']>;
  mortgage_financial_institution?: InputMaybe<Scalars['String']['input']>;
  mortgage_google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  mortgage_has_mortgage?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_insurance_provider_id?: InputMaybe<Scalars['uuid']['input']>;
  mortgage_insurance_revenue?: InputMaybe<Scalars['Float']['input']>;
  mortgage_interest_rate?: InputMaybe<Scalars['Float']['input']>;
  mortgage_interest_rate_type?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  mortgage_is_construction?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_is_property_identified?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_lender_id?: InputMaybe<Scalars['uuid']['input']>;
  mortgage_lender_name?: InputMaybe<Scalars['String']['input']>;
  mortgage_lender_type?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  mortgage_mortgage_type?: InputMaybe<Scalars['String']['input']>;
  mortgage_notary_id?: InputMaybe<Scalars['uuid']['input']>;
  mortgage_product_mortgage?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_product_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_property_usage?: InputMaybe<Scalars['String']['input']>;
  mortgage_property_value?: InputMaybe<Scalars['float8']['input']>;
  mortgage_purchase_date?: InputMaybe<Scalars['timestamptz']['input']>;
  mortgage_purchase_price?: InputMaybe<Scalars['Float']['input']>;
  mortgage_real_estate_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  mortgage_report_type?: InputMaybe<Scalars['String']['input']>;
  mortgage_revenue?: InputMaybe<Scalars['Float']['input']>;
  mortgage_sell?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_start_date?: InputMaybe<Scalars['date']['input']>;
  mortgage_status?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  mortgage_step?: InputMaybe<Scalars['String']['input']>;
  mortgage_term?: InputMaybe<Scalars['String']['input']>;
  nationality_id?: InputMaybe<Scalars['uuid']['input']>;
  next_activity_due_at?: InputMaybe<Scalars['timestamptz']['input']>;
  number_of_buyers?: InputMaybe<Scalars['Int']['input']>;
  number_of_dependant_children?: InputMaybe<Scalars['Int']['input']>;
  occupation_id?: InputMaybe<Scalars['uuid']['input']>;
  occupation_text?: InputMaybe<Scalars['String']['input']>;
  other_credits?: InputMaybe<Scalars['Int']['input']>;
  ownership?: InputMaybe<Scalars['lead_ownership']['input']>;
  parent_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_annual_premium?: InputMaybe<Scalars['float8']['input']>;
  partner_date_of_birth?: InputMaybe<Scalars['date']['input']>;
  partner_donation?: InputMaybe<Scalars['float8']['input']>;
  partner_first_name?: InputMaybe<Scalars['String']['input']>;
  partner_gender?: InputMaybe<Scalars['String']['input']>;
  partner_has_other_credits?: InputMaybe<Scalars['Boolean']['input']>;
  partner_has_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  partner_last_bonus?: InputMaybe<Scalars['float8']['input']>;
  partner_last_name?: InputMaybe<Scalars['String']['input']>;
  partner_marital_status?: InputMaybe<Scalars['String']['input']>;
  partner_nationality_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_occupation_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_occupation_text?: InputMaybe<Scalars['String']['input']>;
  partner_other_credits?: InputMaybe<Scalars['float8']['input']>;
  partner_professional_situation?: InputMaybe<Scalars['user_professional_situation']['input']>;
  partner_residence_country_code?: InputMaybe<Scalars['String']['input']>;
  partner_residence_state_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_savings?: InputMaybe<Scalars['float8']['input']>;
  partner_second_pillar?: InputMaybe<Scalars['float8']['input']>;
  partner_third_pillar?: InputMaybe<Scalars['float8']['input']>;
  partner_third_pillar_a_organisation?: InputMaybe<Scalars['String']['input']>;
  partner_use_bank_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  partner_use_insurance_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  partner_work_permit_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_yearly_revenues?: InputMaybe<Scalars['float8']['input']>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Scalars['float8']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  pos_within_stage?: InputMaybe<Scalars['Int']['input']>;
  potential_development?: InputMaybe<Scalars['Boolean']['input']>;
  predicted_listing_date?: InputMaybe<Scalars['timestamptz']['input']>;
  professional_situation?: InputMaybe<Scalars['user_professional_situation']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_search_notification?: InputMaybe<Scalars['property_searches_notification']['input']>;
  property_usage?: InputMaybe<Leads_Property_Usage_Enum>;
  received_mortgage_offer?: InputMaybe<Scalars['Boolean']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  referring_domain?: InputMaybe<Scalars['String']['input']>;
  refused_at?: InputMaybe<Scalars['timestamptz']['input']>;
  relationship?: InputMaybe<Leads_Relationship_Enum>;
  requalification_status?: InputMaybe<Leads_Requalification_Status_Enum>;
  requalified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  requalified_or_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  residence_country_code?: InputMaybe<Scalars['String']['input']>;
  residence_state_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_comments?: InputMaybe<Scalars['String']['input']>;
  sale_has_found?: InputMaybe<Scalars['Boolean']['input']>;
  sale_horizon?: InputMaybe<Leads_Sale_Horizon_Enum>;
  sale_is_seller?: InputMaybe<Scalars['Boolean']['input']>;
  sale_price?: InputMaybe<Scalars['Int']['input']>;
  sale_started?: InputMaybe<Scalars['Boolean']['input']>;
  savings?: InputMaybe<Scalars['float8']['input']>;
  second_contact_id?: InputMaybe<Scalars['uuid']['input']>;
  second_pillar?: InputMaybe<Scalars['float8']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  snapshot?: InputMaybe<Scalars['jsonb']['input']>;
  source_id?: InputMaybe<Scalars['uuid']['input']>;
  source_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  third_pillar?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  usable_own_funds?: InputMaybe<Scalars['float8']['input']>;
  use_bank_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  use_insurance_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  use_second_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  use_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  user_info_ip?: InputMaybe<Scalars['String']['input']>;
  user_info_user_agent?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  work_permit_id?: InputMaybe<Scalars['uuid']['input']>;
  yearly_revenues?: InputMaybe<Scalars['float8']['input']>;
  yearly_revenues_at_retirement?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Leads_Sum_Fields = {
  /** A computed field, executes function "lead_user_affordability" */
  affordability_rate?: Maybe<Scalars['float8']['output']>;
  annual_premium?: Maybe<Scalars['float8']['output']>;
  appraisal_market_time?: Maybe<Scalars['Int']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Int']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Int']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Int']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['float8']['output']>;
  debt?: Maybe<Scalars['float8']['output']>;
  donation?: Maybe<Scalars['float8']['output']>;
  /** A computed field, executes function "lead_user_funds_percentage" */
  fund_usage?: Maybe<Scalars['float8']['output']>;
  last_bonus?: Maybe<Scalars['float8']['output']>;
  mandate_probability?: Maybe<Scalars['Int']['output']>;
  max_property_value?: Maybe<Scalars['float8']['output']>;
  mortgage_insurance_revenue?: Maybe<Scalars['Float']['output']>;
  mortgage_interest_rate?: Maybe<Scalars['Float']['output']>;
  mortgage_property_value?: Maybe<Scalars['float8']['output']>;
  mortgage_purchase_price?: Maybe<Scalars['Float']['output']>;
  mortgage_revenue?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Int']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Int']['output']>;
  other_credits?: Maybe<Scalars['Int']['output']>;
  partner_annual_premium?: Maybe<Scalars['float8']['output']>;
  partner_donation?: Maybe<Scalars['float8']['output']>;
  partner_last_bonus?: Maybe<Scalars['float8']['output']>;
  partner_other_credits?: Maybe<Scalars['float8']['output']>;
  partner_savings?: Maybe<Scalars['float8']['output']>;
  partner_second_pillar?: Maybe<Scalars['float8']['output']>;
  partner_third_pillar?: Maybe<Scalars['float8']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['float8']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
  pos_within_stage?: Maybe<Scalars['Int']['output']>;
  sale_price?: Maybe<Scalars['Int']['output']>;
  savings?: Maybe<Scalars['float8']['output']>;
  second_pillar?: Maybe<Scalars['float8']['output']>;
  third_pillar?: Maybe<Scalars['float8']['output']>;
  usable_own_funds?: Maybe<Scalars['float8']['output']>;
  yearly_revenues?: Maybe<Scalars['float8']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "leads" */
export type Leads_Sum_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  mortgage_insurance_revenue?: InputMaybe<Order_By>;
  mortgage_interest_rate?: InputMaybe<Order_By>;
  mortgage_property_value?: InputMaybe<Order_By>;
  mortgage_purchase_price?: InputMaybe<Order_By>;
  mortgage_revenue?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  pos_within_stage?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** columns and relationships of "leads_tags" */
export type Leads_Tags = {
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An object relationship */
  dictionary?: Maybe<Dictionaries>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lead?: Maybe<Leads>;
};

/** aggregated selection of "leads_tags" */
export type Leads_Tags_Aggregate = {
  aggregate?: Maybe<Leads_Tags_Aggregate_Fields>;
  nodes: Array<Leads_Tags>;
};

export type Leads_Tags_Aggregate_Bool_Exp = {
  count?: InputMaybe<Leads_Tags_Aggregate_Bool_Exp_Count>;
};

export type Leads_Tags_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Leads_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Tags_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "leads_tags" */
export type Leads_Tags_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Leads_Tags_Max_Fields>;
  min?: Maybe<Leads_Tags_Min_Fields>;
};


/** aggregate fields of "leads_tags" */
export type Leads_Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Leads_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "leads_tags" */
export type Leads_Tags_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Leads_Tags_Max_Order_By>;
  min?: InputMaybe<Leads_Tags_Min_Order_By>;
};

/** input type for inserting array relation for remote table "leads_tags" */
export type Leads_Tags_Arr_Rel_Insert_Input = {
  data: Array<Leads_Tags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Leads_Tags_On_Conflict>;
};

/** Boolean expression to filter rows from the table "leads_tags". All fields are combined with a logical 'AND'. */
export type Leads_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Leads_Tags_Bool_Exp>>;
  _not?: InputMaybe<Leads_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Leads_Tags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_user?: InputMaybe<Users_Bool_Exp>;
  dictionary?: InputMaybe<Dictionaries_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lead?: InputMaybe<Leads_Bool_Exp>;
};

/** unique or primary key constraints on table "leads_tags" */
export enum Leads_Tags_Constraint {
  /** unique or primary key constraint on columns "id" */
  LeadsTagsPkey = 'leads_tags_pkey',
  /** unique or primary key constraint on columns "dictionary_id", "tenant_id", "lead_id" */
  LeadsTagsUnique = 'leads_tags_unique'
}

/** input type for inserting data into table "leads_tags" */
export type Leads_Tags_Insert_Input = {
  created_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  dictionary?: InputMaybe<Dictionaries_Obj_Rel_Insert_Input>;
  dictionary_id?: InputMaybe<Scalars['uuid']['input']>;
  lead?: InputMaybe<Leads_Obj_Rel_Insert_Input>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Leads_Tags_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "leads_tags" */
export type Leads_Tags_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Leads_Tags_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "leads_tags" */
export type Leads_Tags_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "leads_tags" */
export type Leads_Tags_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Leads_Tags>;
};

/** on_conflict condition type for table "leads_tags" */
export type Leads_Tags_On_Conflict = {
  constraint: Leads_Tags_Constraint;
  update_columns?: Array<Leads_Tags_Update_Column>;
  where?: InputMaybe<Leads_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "leads_tags". */
export type Leads_Tags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<Users_Order_By>;
  dictionary?: InputMaybe<Dictionaries_Order_By>;
  id?: InputMaybe<Order_By>;
  lead?: InputMaybe<Leads_Order_By>;
};

/** select columns of table "leads_tags" */
export enum Leads_Tags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id'
}

/** Streaming cursor of the table "leads_tags" */
export type Leads_Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Leads_Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Leads_Tags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "leads_tags" (current role has no relevant permissions) */
export enum Leads_Tags_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** update columns of table "leads" */
export enum Leads_Update_Column {
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  StageId = 'stage_id'
}

export type Leads_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Leads_Set_Input>;
  /** filter the rows which have to be updated */
  where: Leads_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Leads_Var_Pop_Fields = {
  /** A computed field, executes function "lead_user_affordability" */
  affordability_rate?: Maybe<Scalars['float8']['output']>;
  annual_premium?: Maybe<Scalars['Float']['output']>;
  appraisal_market_time?: Maybe<Scalars['Float']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "lead_user_funds_percentage" */
  fund_usage?: Maybe<Scalars['float8']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  mandate_probability?: Maybe<Scalars['Float']['output']>;
  max_property_value?: Maybe<Scalars['Float']['output']>;
  mortgage_insurance_revenue?: Maybe<Scalars['Float']['output']>;
  mortgage_interest_rate?: Maybe<Scalars['Float']['output']>;
  mortgage_property_value?: Maybe<Scalars['Float']['output']>;
  mortgage_purchase_price?: Maybe<Scalars['Float']['output']>;
  mortgage_revenue?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  other_credits?: Maybe<Scalars['Float']['output']>;
  partner_annual_premium?: Maybe<Scalars['Float']['output']>;
  partner_donation?: Maybe<Scalars['Float']['output']>;
  partner_last_bonus?: Maybe<Scalars['Float']['output']>;
  partner_other_credits?: Maybe<Scalars['Float']['output']>;
  partner_savings?: Maybe<Scalars['Float']['output']>;
  partner_second_pillar?: Maybe<Scalars['Float']['output']>;
  partner_third_pillar?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
  pos_within_stage?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  savings?: Maybe<Scalars['Float']['output']>;
  second_pillar?: Maybe<Scalars['Float']['output']>;
  third_pillar?: Maybe<Scalars['Float']['output']>;
  usable_own_funds?: Maybe<Scalars['Float']['output']>;
  yearly_revenues?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "leads" */
export type Leads_Var_Pop_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  mortgage_insurance_revenue?: InputMaybe<Order_By>;
  mortgage_interest_rate?: InputMaybe<Order_By>;
  mortgage_property_value?: InputMaybe<Order_By>;
  mortgage_purchase_price?: InputMaybe<Order_By>;
  mortgage_revenue?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  pos_within_stage?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Leads_Var_Samp_Fields = {
  /** A computed field, executes function "lead_user_affordability" */
  affordability_rate?: Maybe<Scalars['float8']['output']>;
  annual_premium?: Maybe<Scalars['Float']['output']>;
  appraisal_market_time?: Maybe<Scalars['Float']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "lead_user_funds_percentage" */
  fund_usage?: Maybe<Scalars['float8']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  mandate_probability?: Maybe<Scalars['Float']['output']>;
  max_property_value?: Maybe<Scalars['Float']['output']>;
  mortgage_insurance_revenue?: Maybe<Scalars['Float']['output']>;
  mortgage_interest_rate?: Maybe<Scalars['Float']['output']>;
  mortgage_property_value?: Maybe<Scalars['Float']['output']>;
  mortgage_purchase_price?: Maybe<Scalars['Float']['output']>;
  mortgage_revenue?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  other_credits?: Maybe<Scalars['Float']['output']>;
  partner_annual_premium?: Maybe<Scalars['Float']['output']>;
  partner_donation?: Maybe<Scalars['Float']['output']>;
  partner_last_bonus?: Maybe<Scalars['Float']['output']>;
  partner_other_credits?: Maybe<Scalars['Float']['output']>;
  partner_savings?: Maybe<Scalars['Float']['output']>;
  partner_second_pillar?: Maybe<Scalars['Float']['output']>;
  partner_third_pillar?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
  pos_within_stage?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  savings?: Maybe<Scalars['Float']['output']>;
  second_pillar?: Maybe<Scalars['Float']['output']>;
  third_pillar?: Maybe<Scalars['Float']['output']>;
  usable_own_funds?: Maybe<Scalars['Float']['output']>;
  yearly_revenues?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "leads" */
export type Leads_Var_Samp_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  mortgage_insurance_revenue?: InputMaybe<Order_By>;
  mortgage_interest_rate?: InputMaybe<Order_By>;
  mortgage_property_value?: InputMaybe<Order_By>;
  mortgage_purchase_price?: InputMaybe<Order_By>;
  mortgage_revenue?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  pos_within_stage?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Leads_Variance_Fields = {
  /** A computed field, executes function "lead_user_affordability" */
  affordability_rate?: Maybe<Scalars['float8']['output']>;
  annual_premium?: Maybe<Scalars['Float']['output']>;
  appraisal_market_time?: Maybe<Scalars['Float']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "lead_user_funds_percentage" */
  fund_usage?: Maybe<Scalars['float8']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  mandate_probability?: Maybe<Scalars['Float']['output']>;
  max_property_value?: Maybe<Scalars['Float']['output']>;
  mortgage_insurance_revenue?: Maybe<Scalars['Float']['output']>;
  mortgage_interest_rate?: Maybe<Scalars['Float']['output']>;
  mortgage_property_value?: Maybe<Scalars['Float']['output']>;
  mortgage_purchase_price?: Maybe<Scalars['Float']['output']>;
  mortgage_revenue?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  other_credits?: Maybe<Scalars['Float']['output']>;
  partner_annual_premium?: Maybe<Scalars['Float']['output']>;
  partner_donation?: Maybe<Scalars['Float']['output']>;
  partner_last_bonus?: Maybe<Scalars['Float']['output']>;
  partner_other_credits?: Maybe<Scalars['Float']['output']>;
  partner_savings?: Maybe<Scalars['Float']['output']>;
  partner_second_pillar?: Maybe<Scalars['Float']['output']>;
  partner_third_pillar?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
  pos_within_stage?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  savings?: Maybe<Scalars['Float']['output']>;
  second_pillar?: Maybe<Scalars['Float']['output']>;
  third_pillar?: Maybe<Scalars['Float']['output']>;
  usable_own_funds?: Maybe<Scalars['Float']['output']>;
  yearly_revenues?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "leads" */
export type Leads_Variance_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  mortgage_insurance_revenue?: InputMaybe<Order_By>;
  mortgage_interest_rate?: InputMaybe<Order_By>;
  mortgage_property_value?: InputMaybe<Order_By>;
  mortgage_purchase_price?: InputMaybe<Order_By>;
  mortgage_revenue?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  pos_within_stage?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** columns and relationships of "logins" */
export type Logins = {
  id: Scalars['String']['output'];
  invalid: Scalars['Boolean']['output'];
  provider: Scalars['String']['output'];
  /** An object relationship */
  user: Users;
};

/** order by aggregate values of table "logins" */
export type Logins_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Logins_Max_Order_By>;
  min?: InputMaybe<Logins_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "logins". All fields are combined with a logical 'AND'. */
export type Logins_Bool_Exp = {
  _and?: InputMaybe<Array<Logins_Bool_Exp>>;
  _not?: InputMaybe<Logins_Bool_Exp>;
  _or?: InputMaybe<Array<Logins_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  invalid?: InputMaybe<Boolean_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** order by max() on columns of table "logins" */
export type Logins_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "logins" */
export type Logins_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "logins". */
export type Logins_Order_By = {
  id?: InputMaybe<Order_By>;
  invalid?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "logins" */
export enum Logins_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Invalid = 'invalid',
  /** column name */
  Provider = 'provider'
}

/** Streaming cursor of the table "logins" */
export type Logins_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Logins_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Logins_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  invalid?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "lot_reference_aliases" */
export type Lot_Reference_Aliases = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  lot: Lots;
  lot_id: Scalars['uuid']['output'];
  reference_alias_decoded: Scalars['Int']['output'];
};

/** order by aggregate values of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Aggregate_Order_By = {
  avg?: InputMaybe<Lot_Reference_Aliases_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lot_Reference_Aliases_Max_Order_By>;
  min?: InputMaybe<Lot_Reference_Aliases_Min_Order_By>;
  stddev?: InputMaybe<Lot_Reference_Aliases_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lot_Reference_Aliases_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lot_Reference_Aliases_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lot_Reference_Aliases_Sum_Order_By>;
  var_pop?: InputMaybe<Lot_Reference_Aliases_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lot_Reference_Aliases_Var_Samp_Order_By>;
  variance?: InputMaybe<Lot_Reference_Aliases_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Arr_Rel_Insert_Input = {
  data: Array<Lot_Reference_Aliases_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lot_Reference_Aliases_On_Conflict>;
};

/** order by avg() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Avg_Order_By = {
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lot_reference_aliases". All fields are combined with a logical 'AND'. */
export type Lot_Reference_Aliases_Bool_Exp = {
  _and?: InputMaybe<Array<Lot_Reference_Aliases_Bool_Exp>>;
  _not?: InputMaybe<Lot_Reference_Aliases_Bool_Exp>;
  _or?: InputMaybe<Array<Lot_Reference_Aliases_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  reference_alias_decoded?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "lot_reference_aliases" */
export enum Lot_Reference_Aliases_Constraint {
  /** unique or primary key constraint on columns "reference_alias_decoded" */
  LotReferenceAliasesPkey = 'lot_reference_aliases_pkey'
}

/** input type for inserting data into table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  reference_alias_decoded?: InputMaybe<Scalars['Int']['input']>;
};

/** order by max() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lot_Reference_Aliases>;
};

/** on_conflict condition type for table "lot_reference_aliases" */
export type Lot_Reference_Aliases_On_Conflict = {
  constraint: Lot_Reference_Aliases_Constraint;
  update_columns?: Array<Lot_Reference_Aliases_Update_Column>;
  where?: InputMaybe<Lot_Reference_Aliases_Bool_Exp>;
};

/** Ordering options when selecting data from "lot_reference_aliases". */
export type Lot_Reference_Aliases_Order_By = {
  created_at?: InputMaybe<Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** select columns of table "lot_reference_aliases" */
export enum Lot_Reference_Aliases_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  ReferenceAliasDecoded = 'reference_alias_decoded'
}

/** order by stddev() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Stddev_Order_By = {
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Stddev_Pop_Order_By = {
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Stddev_Samp_Order_By = {
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lot_Reference_Aliases_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lot_Reference_Aliases_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  reference_alias_decoded?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Sum_Order_By = {
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "lot_reference_aliases" (current role has no relevant permissions) */
export enum Lot_Reference_Aliases_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Var_Pop_Order_By = {
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Var_Samp_Order_By = {
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Variance_Order_By = {
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** columns and relationships of "lot_sellers" */
export type Lot_Sellers = {
  /** An object relationship */
  lot: Lots;
  lot_id: Scalars['uuid']['output'];
  /** An object relationship */
  seller: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "lot_sellers" */
export type Lot_Sellers_Aggregate = {
  aggregate?: Maybe<Lot_Sellers_Aggregate_Fields>;
  nodes: Array<Lot_Sellers>;
};

export type Lot_Sellers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Lot_Sellers_Aggregate_Bool_Exp_Count>;
};

export type Lot_Sellers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lot_Sellers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "lot_sellers" */
export type Lot_Sellers_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Lot_Sellers_Max_Fields>;
  min?: Maybe<Lot_Sellers_Min_Fields>;
};


/** aggregate fields of "lot_sellers" */
export type Lot_Sellers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lot_sellers" */
export type Lot_Sellers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lot_Sellers_Max_Order_By>;
  min?: InputMaybe<Lot_Sellers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "lot_sellers" */
export type Lot_Sellers_Arr_Rel_Insert_Input = {
  data: Array<Lot_Sellers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lot_Sellers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "lot_sellers". All fields are combined with a logical 'AND'. */
export type Lot_Sellers_Bool_Exp = {
  _and?: InputMaybe<Array<Lot_Sellers_Bool_Exp>>;
  _not?: InputMaybe<Lot_Sellers_Bool_Exp>;
  _or?: InputMaybe<Array<Lot_Sellers_Bool_Exp>>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  seller?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "lot_sellers" */
export enum Lot_Sellers_Constraint {
  /** unique or primary key constraint on columns "user_id", "lot_id" */
  LotSellersLotIdUserIdUnique = 'lot_sellers_lot_id_user_id_unique'
}

/** input type for inserting data into table "lot_sellers" */
export type Lot_Sellers_Insert_Input = {
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  seller?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Lot_Sellers_Max_Fields = {
  lot_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "lot_sellers" */
export type Lot_Sellers_Max_Order_By = {
  lot_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lot_Sellers_Min_Fields = {
  lot_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "lot_sellers" */
export type Lot_Sellers_Min_Order_By = {
  lot_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lot_sellers" */
export type Lot_Sellers_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lot_Sellers>;
};

/** on_conflict condition type for table "lot_sellers" */
export type Lot_Sellers_On_Conflict = {
  constraint: Lot_Sellers_Constraint;
  update_columns?: Array<Lot_Sellers_Update_Column>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};

/** Ordering options when selecting data from "lot_sellers". */
export type Lot_Sellers_Order_By = {
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  seller?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "lot_sellers" */
export enum Lot_Sellers_Select_Column {
  /** column name */
  LotId = 'lot_id',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "lot_sellers" */
export type Lot_Sellers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lot_Sellers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lot_Sellers_Stream_Cursor_Value_Input = {
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "lot_sellers" (current role has no relevant permissions) */
export enum Lot_Sellers_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "lots" */
export type Lots = {
  /** An array relationship */
  activities: Array<Activities>;
  /** An aggregate relationship */
  activities_aggregate: Activities_Aggregate;
  address_display_option: Address_Display_Options_Enum_Enum;
  address_display_option_brochure: Address_Display_Options_Enum_Enum;
  auto_matching_filters?: Maybe<Scalars['jsonb']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  brochure_cover_image?: Maybe<Images>;
  brochure_cover_image_id?: Maybe<Scalars['uuid']['output']>;
  brochure_description?: Maybe<Scalars['String']['output']>;
  brochure_description_layout: Scalars['smallint']['output'];
  brochure_doc_template_id?: Maybe<Scalars['uuid']['output']>;
  brochure_font_family?: Maybe<Scalars['String']['output']>;
  brochure_include_append_files: Scalars['Boolean']['output'];
  brochure_include_cover: Scalars['Boolean']['output'];
  brochure_include_description: Scalars['Boolean']['output'];
  brochure_include_photos: Scalars['Boolean']['output'];
  brochure_include_property: Scalars['Boolean']['output'];
  brochure_pdf_compression_quality: Scalars['pdf_compression_quality']['output'];
  brochure_show_agent_on_brochure: Scalars['Boolean']['output'];
  brochure_title?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  broker?: Maybe<Users>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  buyer_leads: Array<Buyer_Leads>;
  /** An aggregate relationship */
  buyer_leads_aggregate: Buyer_Leads_Aggregate;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** A computed field, executes function "lot_crm_link" */
  crm_link?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['currencies']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  development?: Maybe<Developments>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  doc_template?: Maybe<Doc_Templates>;
  dummy_broker_name?: Maybe<Scalars['String']['output']>;
  dummy_broker_phone?: Maybe<Scalars['String']['output']>;
  dummy_country_code?: Maybe<Scalars['String']['output']>;
  dummy_geom?: Maybe<Scalars['geometry']['output']>;
  dummy_lat?: Maybe<Scalars['float8']['output']>;
  dummy_living_surface: Scalars['String']['output'];
  dummy_lng?: Maybe<Scalars['float8']['output']>;
  dummy_locality?: Maybe<Scalars['String']['output']>;
  dummy_locality_id?: Maybe<Scalars['uuid']['output']>;
  dummy_organisation_country_code?: Maybe<Scalars['String']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['float8']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['float8']['output']>;
  dummy_organisation_locality?: Maybe<Scalars['String']['output']>;
  dummy_organisation_name?: Maybe<Scalars['String']['output']>;
  dummy_organisation_phone?: Maybe<Scalars['String']['output']>;
  dummy_organisation_postcode?: Maybe<Scalars['String']['output']>;
  dummy_organisation_route?: Maybe<Scalars['String']['output']>;
  dummy_organisation_state?: Maybe<Scalars['String']['output']>;
  dummy_organisation_street_number?: Maybe<Scalars['String']['output']>;
  dummy_postcode?: Maybe<Scalars['String']['output']>;
  dummy_route?: Maybe<Scalars['String']['output']>;
  dummy_state?: Maybe<Scalars['String']['output']>;
  dummy_street_number?: Maybe<Scalars['String']['output']>;
  dummy_usable_surface: Scalars['String']['output'];
  duration_in_months?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  email_templates: Array<Email_Templates>;
  enable_auto_matching: Scalars['Boolean']['output'];
  /** An array relationship */
  enquiries: Array<Enquiries>;
  /** An aggregate relationship */
  enquiries_aggregate: Enquiries_Aggregate;
  enquiry_response_enabled?: Maybe<Scalars['Boolean']['output']>;
  expected_time_to_sell: Scalars['String']['output'];
  fixed_fee?: Maybe<Scalars['Int']['output']>;
  has_success_fee: Scalars['Boolean']['output'];
  hide_price_on_brochure: Scalars['Boolean']['output'];
  hide_price_on_portals: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  indoor_parking_price?: Maybe<Scalars['float8']['output']>;
  is_exclusive?: Maybe<Scalars['Boolean']['output']>;
  is_paid: Scalars['Boolean']['output'];
  is_parking_included_in_total: Scalars['Boolean']['output'];
  is_sales_tax_inclusive?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  lead?: Maybe<Leads>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  listing_url?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  lot_property_files: Array<Property_Files>;
  /** An aggregate relationship */
  lot_property_files_aggregate: Property_Files_Aggregate;
  lot_reference?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  lot_reference_aliases: Array<Lot_Reference_Aliases>;
  /** An object relationship */
  lots_status: Lots_Status_Enum;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  mandate_type?: Maybe<Scalars['String']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  mortgage_broker_id?: Maybe<Scalars['uuid']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  offers: Array<Offers>;
  /** An aggregate relationship */
  offers_aggregate: Offers_Aggregate;
  order_nr: Scalars['Int']['output'];
  /** An object relationship */
  origin?: Maybe<Dictionaries>;
  origin_id?: Maybe<Scalars['uuid']['output']>;
  outdoor_parking_price?: Maybe<Scalars['float8']['output']>;
  parking_price?: Maybe<Scalars['float8']['output']>;
  parking_price_type?: Maybe<Parking_Price_Type_Enum_Enum>;
  payment_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  portal_listings: Array<Portal_Listings>;
  /** An aggregate relationship */
  portal_listings_aggregate: Portal_Listings_Aggregate;
  price_unit?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  property: Properties;
  property_id: Scalars['uuid']['output'];
  /** An array relationship */
  property_transactions: Array<Property_Transactions>;
  /** An aggregate relationship */
  property_transactions_aggregate: Property_Transactions_Aggregate;
  publish_step?: Maybe<Scalars['String']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  /** An object relationship */
  response_sender?: Maybe<Users>;
  response_sender_id?: Maybe<Scalars['uuid']['output']>;
  sale_price?: Maybe<Scalars['float8']['output']>;
  sale_price_computed?: Maybe<Scalars['float8']['output']>;
  /** An array relationship */
  sellers: Array<Lot_Sellers>;
  /** An aggregate relationship */
  sellers_aggregate: Lot_Sellers_Aggregate;
  send_enquiries_to_sellers: Scalars['Boolean']['output'];
  shared_on_mls?: Maybe<Scalars['Boolean']['output']>;
  signed_at?: Maybe<Scalars['date']['output']>;
  status: Lots_Status_Enum_Enum;
  success_fee_custom?: Maybe<Scalars['String']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
  success_fee_type: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  use_custom_brochure_description: Scalars['Boolean']['output'];
  use_custom_brochure_title: Scalars['Boolean']['output'];
  use_dummy_address?: Maybe<Scalars['Boolean']['output']>;
  use_dummy_contact: Scalars['Boolean']['output'];
  video_url?: Maybe<Scalars['String']['output']>;
  virtual_visit_url?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "lots" */
export type LotsActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** columns and relationships of "lots" */
export type LotsActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** columns and relationships of "lots" */
export type LotsAuto_Matching_FiltersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "lots" */
export type LotsBuyer_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


/** columns and relationships of "lots" */
export type LotsBuyer_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


/** columns and relationships of "lots" */
export type LotsEmail_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Templates_Order_By>>;
  where?: InputMaybe<Email_Templates_Bool_Exp>;
};


/** columns and relationships of "lots" */
export type LotsEnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


/** columns and relationships of "lots" */
export type LotsEnquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


/** columns and relationships of "lots" */
export type LotsLot_Property_FilesArgs = {
  distinct_on?: InputMaybe<Array<Property_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Files_Order_By>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


/** columns and relationships of "lots" */
export type LotsLot_Property_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Files_Order_By>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


/** columns and relationships of "lots" */
export type LotsLot_Reference_AliasesArgs = {
  distinct_on?: InputMaybe<Array<Lot_Reference_Aliases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Reference_Aliases_Order_By>>;
  where?: InputMaybe<Lot_Reference_Aliases_Bool_Exp>;
};


/** columns and relationships of "lots" */
export type LotsOffersArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


/** columns and relationships of "lots" */
export type LotsOffers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


/** columns and relationships of "lots" */
export type LotsPortal_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portal_Listings_Order_By>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};


/** columns and relationships of "lots" */
export type LotsPortal_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portal_Listings_Order_By>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};


/** columns and relationships of "lots" */
export type LotsProperty_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


/** columns and relationships of "lots" */
export type LotsProperty_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


/** columns and relationships of "lots" */
export type LotsSellersArgs = {
  distinct_on?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Sellers_Order_By>>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};


/** columns and relationships of "lots" */
export type LotsSellers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Sellers_Order_By>>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};

/** aggregated selection of "lots" */
export type Lots_Aggregate = {
  aggregate?: Maybe<Lots_Aggregate_Fields>;
  nodes: Array<Lots>;
};

export type Lots_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Lots_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Lots_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Lots_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Lots_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Lots_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Lots_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Lots_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Lots_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Lots_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Lots_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Lots_Aggregate_Bool_Exp_Var_Samp>;
};

export type Lots_Aggregate_Bool_Exp_Avg = {
  arguments: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Bool_And = {
  arguments: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Corr = {
  arguments: Lots_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Lots_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lots_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Lots_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Lots_Aggregate_Bool_Exp_Max = {
  arguments: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Min = {
  arguments: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Sum = {
  arguments: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "lots" */
export type Lots_Aggregate_Fields = {
  avg?: Maybe<Lots_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lots_Max_Fields>;
  min?: Maybe<Lots_Min_Fields>;
  stddev?: Maybe<Lots_Stddev_Fields>;
  stddev_pop?: Maybe<Lots_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lots_Stddev_Samp_Fields>;
  sum?: Maybe<Lots_Sum_Fields>;
  var_pop?: Maybe<Lots_Var_Pop_Fields>;
  var_samp?: Maybe<Lots_Var_Samp_Fields>;
  variance?: Maybe<Lots_Variance_Fields>;
};


/** aggregate fields of "lots" */
export type Lots_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lots_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lots" */
export type Lots_Aggregate_Order_By = {
  avg?: InputMaybe<Lots_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lots_Max_Order_By>;
  min?: InputMaybe<Lots_Min_Order_By>;
  stddev?: InputMaybe<Lots_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lots_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lots_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lots_Sum_Order_By>;
  var_pop?: InputMaybe<Lots_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lots_Var_Samp_Order_By>;
  variance?: InputMaybe<Lots_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Lots_Append_Input = {
  auto_matching_filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "lots" */
export type Lots_Arr_Rel_Insert_Input = {
  data: Array<Lots_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lots_On_Conflict>;
};

/** aggregate avg on columns */
export type Lots_Avg_Fields = {
  brochure_description_layout?: Maybe<Scalars['Float']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['Float']['output']>;
  duration_in_months?: Maybe<Scalars['Float']['output']>;
  fixed_fee?: Maybe<Scalars['Float']['output']>;
  indoor_parking_price?: Maybe<Scalars['Float']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  outdoor_parking_price?: Maybe<Scalars['Float']['output']>;
  parking_price?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_computed?: Maybe<Scalars['Float']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "lots" */
export type Lots_Avg_Order_By = {
  brochure_description_layout?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lots". All fields are combined with a logical 'AND'. */
export type Lots_Bool_Exp = {
  _and?: InputMaybe<Array<Lots_Bool_Exp>>;
  _not?: InputMaybe<Lots_Bool_Exp>;
  _or?: InputMaybe<Array<Lots_Bool_Exp>>;
  activities?: InputMaybe<Activities_Bool_Exp>;
  activities_aggregate?: InputMaybe<Activities_Aggregate_Bool_Exp>;
  address_display_option?: InputMaybe<Address_Display_Options_Enum_Enum_Comparison_Exp>;
  address_display_option_brochure?: InputMaybe<Address_Display_Options_Enum_Enum_Comparison_Exp>;
  auto_matching_filters?: InputMaybe<Jsonb_Comparison_Exp>;
  available_from?: InputMaybe<Date_Comparison_Exp>;
  brochure_cover_image?: InputMaybe<Images_Bool_Exp>;
  brochure_cover_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  brochure_description?: InputMaybe<String_Comparison_Exp>;
  brochure_description_layout?: InputMaybe<Smallint_Comparison_Exp>;
  brochure_doc_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  brochure_font_family?: InputMaybe<String_Comparison_Exp>;
  brochure_include_append_files?: InputMaybe<Boolean_Comparison_Exp>;
  brochure_include_cover?: InputMaybe<Boolean_Comparison_Exp>;
  brochure_include_description?: InputMaybe<Boolean_Comparison_Exp>;
  brochure_include_photos?: InputMaybe<Boolean_Comparison_Exp>;
  brochure_include_property?: InputMaybe<Boolean_Comparison_Exp>;
  brochure_pdf_compression_quality?: InputMaybe<Pdf_Compression_Quality_Comparison_Exp>;
  brochure_show_agent_on_brochure?: InputMaybe<Boolean_Comparison_Exp>;
  brochure_title?: InputMaybe<String_Comparison_Exp>;
  broker?: InputMaybe<Users_Bool_Exp>;
  broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  buyer_leads?: InputMaybe<Buyer_Leads_Bool_Exp>;
  buyer_leads_aggregate?: InputMaybe<Buyer_Leads_Aggregate_Bool_Exp>;
  commission_rate?: InputMaybe<Float_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_user?: InputMaybe<Users_Bool_Exp>;
  crm_link?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<Currencies_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  development?: InputMaybe<Developments_Bool_Exp>;
  development_id?: InputMaybe<Uuid_Comparison_Exp>;
  doc_template?: InputMaybe<Doc_Templates_Bool_Exp>;
  dummy_broker_name?: InputMaybe<String_Comparison_Exp>;
  dummy_broker_phone?: InputMaybe<String_Comparison_Exp>;
  dummy_country_code?: InputMaybe<String_Comparison_Exp>;
  dummy_geom?: InputMaybe<Geometry_Comparison_Exp>;
  dummy_lat?: InputMaybe<Float8_Comparison_Exp>;
  dummy_living_surface?: InputMaybe<String_Comparison_Exp>;
  dummy_lng?: InputMaybe<Float8_Comparison_Exp>;
  dummy_locality?: InputMaybe<String_Comparison_Exp>;
  dummy_locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  dummy_organisation_country_code?: InputMaybe<String_Comparison_Exp>;
  dummy_organisation_lat?: InputMaybe<Float8_Comparison_Exp>;
  dummy_organisation_lng?: InputMaybe<Float8_Comparison_Exp>;
  dummy_organisation_locality?: InputMaybe<String_Comparison_Exp>;
  dummy_organisation_name?: InputMaybe<String_Comparison_Exp>;
  dummy_organisation_phone?: InputMaybe<String_Comparison_Exp>;
  dummy_organisation_postcode?: InputMaybe<String_Comparison_Exp>;
  dummy_organisation_route?: InputMaybe<String_Comparison_Exp>;
  dummy_organisation_state?: InputMaybe<String_Comparison_Exp>;
  dummy_organisation_street_number?: InputMaybe<String_Comparison_Exp>;
  dummy_postcode?: InputMaybe<String_Comparison_Exp>;
  dummy_route?: InputMaybe<String_Comparison_Exp>;
  dummy_state?: InputMaybe<String_Comparison_Exp>;
  dummy_street_number?: InputMaybe<String_Comparison_Exp>;
  dummy_usable_surface?: InputMaybe<String_Comparison_Exp>;
  duration_in_months?: InputMaybe<Int_Comparison_Exp>;
  email_templates?: InputMaybe<Email_Templates_Bool_Exp>;
  enable_auto_matching?: InputMaybe<Boolean_Comparison_Exp>;
  enquiries?: InputMaybe<Enquiries_Bool_Exp>;
  enquiries_aggregate?: InputMaybe<Enquiries_Aggregate_Bool_Exp>;
  enquiry_response_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  expected_time_to_sell?: InputMaybe<String_Comparison_Exp>;
  fixed_fee?: InputMaybe<Int_Comparison_Exp>;
  has_success_fee?: InputMaybe<Boolean_Comparison_Exp>;
  hide_price_on_brochure?: InputMaybe<Boolean_Comparison_Exp>;
  hide_price_on_portals?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  indoor_parking_price?: InputMaybe<Float8_Comparison_Exp>;
  is_exclusive?: InputMaybe<Boolean_Comparison_Exp>;
  is_paid?: InputMaybe<Boolean_Comparison_Exp>;
  is_parking_included_in_total?: InputMaybe<Boolean_Comparison_Exp>;
  is_sales_tax_inclusive?: InputMaybe<Boolean_Comparison_Exp>;
  lead?: InputMaybe<Leads_Bool_Exp>;
  lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  listing_url?: InputMaybe<String_Comparison_Exp>;
  lot_property_files?: InputMaybe<Property_Files_Bool_Exp>;
  lot_property_files_aggregate?: InputMaybe<Property_Files_Aggregate_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  lot_reference_aliases?: InputMaybe<Lot_Reference_Aliases_Bool_Exp>;
  lots_status?: InputMaybe<Lots_Status_Enum_Bool_Exp>;
  mandate_sale_price?: InputMaybe<Float_Comparison_Exp>;
  mandate_type?: InputMaybe<String_Comparison_Exp>;
  minimum_net_seller_price?: InputMaybe<Float_Comparison_Exp>;
  monthly_rent_computed?: InputMaybe<Float_Comparison_Exp>;
  mortgage_broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offers?: InputMaybe<Offers_Bool_Exp>;
  offers_aggregate?: InputMaybe<Offers_Aggregate_Bool_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  origin?: InputMaybe<Dictionaries_Bool_Exp>;
  origin_id?: InputMaybe<Uuid_Comparison_Exp>;
  outdoor_parking_price?: InputMaybe<Float8_Comparison_Exp>;
  parking_price?: InputMaybe<Float8_Comparison_Exp>;
  parking_price_type?: InputMaybe<Parking_Price_Type_Enum_Enum_Comparison_Exp>;
  payment_id?: InputMaybe<Uuid_Comparison_Exp>;
  portal_listings?: InputMaybe<Portal_Listings_Bool_Exp>;
  portal_listings_aggregate?: InputMaybe<Portal_Listings_Aggregate_Bool_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property?: InputMaybe<Properties_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_transactions?: InputMaybe<Property_Transactions_Bool_Exp>;
  property_transactions_aggregate?: InputMaybe<Property_Transactions_Aggregate_Bool_Exp>;
  publish_step?: InputMaybe<String_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  response_sender?: InputMaybe<Users_Bool_Exp>;
  response_sender_id?: InputMaybe<Uuid_Comparison_Exp>;
  sale_price?: InputMaybe<Float8_Comparison_Exp>;
  sale_price_computed?: InputMaybe<Float8_Comparison_Exp>;
  sellers?: InputMaybe<Lot_Sellers_Bool_Exp>;
  sellers_aggregate?: InputMaybe<Lot_Sellers_Aggregate_Bool_Exp>;
  send_enquiries_to_sellers?: InputMaybe<Boolean_Comparison_Exp>;
  shared_on_mls?: InputMaybe<Boolean_Comparison_Exp>;
  signed_at?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Lots_Status_Enum_Enum_Comparison_Exp>;
  success_fee_custom?: InputMaybe<String_Comparison_Exp>;
  success_fee_percentage?: InputMaybe<Float_Comparison_Exp>;
  success_fee_type?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  use_custom_brochure_description?: InputMaybe<Boolean_Comparison_Exp>;
  use_custom_brochure_title?: InputMaybe<Boolean_Comparison_Exp>;
  use_dummy_address?: InputMaybe<Boolean_Comparison_Exp>;
  use_dummy_contact?: InputMaybe<Boolean_Comparison_Exp>;
  video_url?: InputMaybe<String_Comparison_Exp>;
  virtual_visit_url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "lots" */
export enum Lots_Constraint {
  /** unique or primary key constraint on columns "order_nr", "development_id" */
  LotsDevelopmentIdOrderNrUnique = 'lots_development_id_order_nr_unique',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  LotsIdTenantIdUnique = 'lots_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  LotsIdUindex = 'lots_id_uindex',
  /** unique or primary key constraint on columns "id" */
  LotsPkey = 'lots_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Lots_Delete_At_Path_Input = {
  auto_matching_filters?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Lots_Delete_Elem_Input = {
  auto_matching_filters?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Lots_Delete_Key_Input = {
  auto_matching_filters?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "lots" */
export type Lots_Inc_Input = {
  brochure_description_layout?: InputMaybe<Scalars['smallint']['input']>;
  commission_rate?: InputMaybe<Scalars['Float']['input']>;
  dummy_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_lng?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_lng?: InputMaybe<Scalars['float8']['input']>;
  duration_in_months?: InputMaybe<Scalars['Int']['input']>;
  fixed_fee?: InputMaybe<Scalars['Int']['input']>;
  indoor_parking_price?: InputMaybe<Scalars['float8']['input']>;
  mandate_sale_price?: InputMaybe<Scalars['Float']['input']>;
  minimum_net_seller_price?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_computed?: InputMaybe<Scalars['Float']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  outdoor_parking_price?: InputMaybe<Scalars['float8']['input']>;
  parking_price?: InputMaybe<Scalars['float8']['input']>;
  rent_extra?: InputMaybe<Scalars['Float']['input']>;
  rent_net?: InputMaybe<Scalars['Float']['input']>;
  sale_price?: InputMaybe<Scalars['float8']['input']>;
  sale_price_computed?: InputMaybe<Scalars['float8']['input']>;
  success_fee_percentage?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "lots" */
export type Lots_Insert_Input = {
  activities?: InputMaybe<Activities_Arr_Rel_Insert_Input>;
  address_display_option?: InputMaybe<Address_Display_Options_Enum_Enum>;
  address_display_option_brochure?: InputMaybe<Address_Display_Options_Enum_Enum>;
  auto_matching_filters?: InputMaybe<Scalars['jsonb']['input']>;
  available_from?: InputMaybe<Scalars['date']['input']>;
  brochure_cover_image?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  brochure_cover_image_id?: InputMaybe<Scalars['uuid']['input']>;
  brochure_description?: InputMaybe<Scalars['String']['input']>;
  brochure_font_family?: InputMaybe<Scalars['String']['input']>;
  brochure_include_cover?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_description?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_property?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_pdf_compression_quality?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  brochure_title?: InputMaybe<Scalars['String']['input']>;
  broker?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_leads?: InputMaybe<Buyer_Leads_Arr_Rel_Insert_Input>;
  commission_rate?: InputMaybe<Scalars['Float']['input']>;
  created_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  currency?: InputMaybe<Scalars['currencies']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  doc_template?: InputMaybe<Doc_Templates_Obj_Rel_Insert_Input>;
  dummy_broker_name?: InputMaybe<Scalars['String']['input']>;
  dummy_broker_phone?: InputMaybe<Scalars['String']['input']>;
  dummy_country_code?: InputMaybe<Scalars['String']['input']>;
  dummy_geom?: InputMaybe<Scalars['geometry']['input']>;
  dummy_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_living_surface?: InputMaybe<Scalars['String']['input']>;
  dummy_lng?: InputMaybe<Scalars['float8']['input']>;
  dummy_locality?: InputMaybe<Scalars['String']['input']>;
  dummy_locality_id?: InputMaybe<Scalars['uuid']['input']>;
  dummy_organisation_country_code?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_lng?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_locality?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_name?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_phone?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_postcode?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_route?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_state?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_street_number?: InputMaybe<Scalars['String']['input']>;
  dummy_postcode?: InputMaybe<Scalars['String']['input']>;
  dummy_route?: InputMaybe<Scalars['String']['input']>;
  dummy_state?: InputMaybe<Scalars['String']['input']>;
  dummy_street_number?: InputMaybe<Scalars['String']['input']>;
  dummy_usable_surface?: InputMaybe<Scalars['String']['input']>;
  duration_in_months?: InputMaybe<Scalars['Int']['input']>;
  email_templates?: InputMaybe<Email_Templates_Arr_Rel_Insert_Input>;
  enable_auto_matching?: InputMaybe<Scalars['Boolean']['input']>;
  enquiry_response_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  expected_time_to_sell?: InputMaybe<Scalars['String']['input']>;
  fixed_fee?: InputMaybe<Scalars['Int']['input']>;
  has_success_fee?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_portals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indoor_parking_price?: InputMaybe<Scalars['float8']['input']>;
  is_exclusive?: InputMaybe<Scalars['Boolean']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  is_parking_included_in_total?: InputMaybe<Scalars['Boolean']['input']>;
  is_sales_tax_inclusive?: InputMaybe<Scalars['Boolean']['input']>;
  lead?: InputMaybe<Leads_Obj_Rel_Insert_Input>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  listing_url?: InputMaybe<Scalars['String']['input']>;
  lot_property_files?: InputMaybe<Property_Files_Arr_Rel_Insert_Input>;
  lot_reference?: InputMaybe<Scalars['String']['input']>;
  lot_reference_aliases?: InputMaybe<Lot_Reference_Aliases_Arr_Rel_Insert_Input>;
  mandate_sale_price?: InputMaybe<Scalars['Float']['input']>;
  mandate_type?: InputMaybe<Scalars['String']['input']>;
  minimum_net_seller_price?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_computed?: InputMaybe<Scalars['Float']['input']>;
  mortgage_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  offer_type?: InputMaybe<Scalars['String']['input']>;
  offers?: InputMaybe<Offers_Arr_Rel_Insert_Input>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  origin?: InputMaybe<Dictionaries_Obj_Rel_Insert_Input>;
  origin_id?: InputMaybe<Scalars['uuid']['input']>;
  outdoor_parking_price?: InputMaybe<Scalars['float8']['input']>;
  parking_price?: InputMaybe<Scalars['float8']['input']>;
  parking_price_type?: InputMaybe<Parking_Price_Type_Enum_Enum>;
  payment_id?: InputMaybe<Scalars['uuid']['input']>;
  price_unit?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Properties_Obj_Rel_Insert_Input>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_transactions?: InputMaybe<Property_Transactions_Arr_Rel_Insert_Input>;
  publish_step?: InputMaybe<Scalars['String']['input']>;
  rent_extra?: InputMaybe<Scalars['Float']['input']>;
  rent_net?: InputMaybe<Scalars['Float']['input']>;
  response_sender?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  response_sender_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_price?: InputMaybe<Scalars['float8']['input']>;
  sale_price_computed?: InputMaybe<Scalars['float8']['input']>;
  sellers?: InputMaybe<Lot_Sellers_Arr_Rel_Insert_Input>;
  send_enquiries_to_sellers?: InputMaybe<Scalars['Boolean']['input']>;
  shared_on_mls?: InputMaybe<Scalars['Boolean']['input']>;
  signed_at?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Lots_Status_Enum_Enum>;
  success_fee_custom?: InputMaybe<Scalars['String']['input']>;
  success_fee_percentage?: InputMaybe<Scalars['Float']['input']>;
  success_fee_type?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  use_custom_brochure_description?: InputMaybe<Scalars['Boolean']['input']>;
  use_custom_brochure_title?: InputMaybe<Scalars['Boolean']['input']>;
  use_dummy_address?: InputMaybe<Scalars['Boolean']['input']>;
  use_dummy_contact?: InputMaybe<Scalars['Boolean']['input']>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  virtual_visit_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Lots_Max_Fields = {
  available_from?: Maybe<Scalars['date']['output']>;
  brochure_cover_image_id?: Maybe<Scalars['uuid']['output']>;
  brochure_description?: Maybe<Scalars['String']['output']>;
  brochure_description_layout?: Maybe<Scalars['smallint']['output']>;
  brochure_doc_template_id?: Maybe<Scalars['uuid']['output']>;
  brochure_font_family?: Maybe<Scalars['String']['output']>;
  brochure_pdf_compression_quality?: Maybe<Scalars['pdf_compression_quality']['output']>;
  brochure_title?: Maybe<Scalars['String']['output']>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "lot_crm_link" */
  crm_link?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['currencies']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  dummy_broker_name?: Maybe<Scalars['String']['output']>;
  dummy_broker_phone?: Maybe<Scalars['String']['output']>;
  dummy_country_code?: Maybe<Scalars['String']['output']>;
  dummy_lat?: Maybe<Scalars['float8']['output']>;
  dummy_living_surface?: Maybe<Scalars['String']['output']>;
  dummy_lng?: Maybe<Scalars['float8']['output']>;
  dummy_locality?: Maybe<Scalars['String']['output']>;
  dummy_locality_id?: Maybe<Scalars['uuid']['output']>;
  dummy_organisation_country_code?: Maybe<Scalars['String']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['float8']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['float8']['output']>;
  dummy_organisation_locality?: Maybe<Scalars['String']['output']>;
  dummy_organisation_name?: Maybe<Scalars['String']['output']>;
  dummy_organisation_phone?: Maybe<Scalars['String']['output']>;
  dummy_organisation_postcode?: Maybe<Scalars['String']['output']>;
  dummy_organisation_route?: Maybe<Scalars['String']['output']>;
  dummy_organisation_state?: Maybe<Scalars['String']['output']>;
  dummy_organisation_street_number?: Maybe<Scalars['String']['output']>;
  dummy_postcode?: Maybe<Scalars['String']['output']>;
  dummy_route?: Maybe<Scalars['String']['output']>;
  dummy_state?: Maybe<Scalars['String']['output']>;
  dummy_street_number?: Maybe<Scalars['String']['output']>;
  dummy_usable_surface?: Maybe<Scalars['String']['output']>;
  duration_in_months?: Maybe<Scalars['Int']['output']>;
  expected_time_to_sell?: Maybe<Scalars['String']['output']>;
  fixed_fee?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indoor_parking_price?: Maybe<Scalars['float8']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  listing_url?: Maybe<Scalars['String']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  mandate_type?: Maybe<Scalars['String']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  mortgage_broker_id?: Maybe<Scalars['uuid']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  origin_id?: Maybe<Scalars['uuid']['output']>;
  outdoor_parking_price?: Maybe<Scalars['float8']['output']>;
  parking_price?: Maybe<Scalars['float8']['output']>;
  payment_id?: Maybe<Scalars['uuid']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  publish_step?: Maybe<Scalars['String']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  response_sender_id?: Maybe<Scalars['uuid']['output']>;
  sale_price?: Maybe<Scalars['float8']['output']>;
  sale_price_computed?: Maybe<Scalars['float8']['output']>;
  signed_at?: Maybe<Scalars['date']['output']>;
  success_fee_custom?: Maybe<Scalars['String']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
  success_fee_type?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  video_url?: Maybe<Scalars['String']['output']>;
  virtual_visit_url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "lots" */
export type Lots_Max_Order_By = {
  available_from?: InputMaybe<Order_By>;
  brochure_cover_image_id?: InputMaybe<Order_By>;
  brochure_description?: InputMaybe<Order_By>;
  brochure_description_layout?: InputMaybe<Order_By>;
  brochure_doc_template_id?: InputMaybe<Order_By>;
  brochure_font_family?: InputMaybe<Order_By>;
  brochure_pdf_compression_quality?: InputMaybe<Order_By>;
  brochure_title?: InputMaybe<Order_By>;
  broker_id?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  dummy_broker_name?: InputMaybe<Order_By>;
  dummy_broker_phone?: InputMaybe<Order_By>;
  dummy_country_code?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_living_surface?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_locality?: InputMaybe<Order_By>;
  dummy_locality_id?: InputMaybe<Order_By>;
  dummy_organisation_country_code?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  dummy_organisation_locality?: InputMaybe<Order_By>;
  dummy_organisation_name?: InputMaybe<Order_By>;
  dummy_organisation_phone?: InputMaybe<Order_By>;
  dummy_organisation_postcode?: InputMaybe<Order_By>;
  dummy_organisation_route?: InputMaybe<Order_By>;
  dummy_organisation_state?: InputMaybe<Order_By>;
  dummy_organisation_street_number?: InputMaybe<Order_By>;
  dummy_postcode?: InputMaybe<Order_By>;
  dummy_route?: InputMaybe<Order_By>;
  dummy_state?: InputMaybe<Order_By>;
  dummy_street_number?: InputMaybe<Order_By>;
  dummy_usable_surface?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  expected_time_to_sell?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  listing_url?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  mandate_type?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  mortgage_broker_id?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  origin_id?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  publish_step?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  response_sender_id?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  signed_at?: InputMaybe<Order_By>;
  success_fee_custom?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
  success_fee_type?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  video_url?: InputMaybe<Order_By>;
  virtual_visit_url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lots_Min_Fields = {
  available_from?: Maybe<Scalars['date']['output']>;
  brochure_cover_image_id?: Maybe<Scalars['uuid']['output']>;
  brochure_description?: Maybe<Scalars['String']['output']>;
  brochure_description_layout?: Maybe<Scalars['smallint']['output']>;
  brochure_doc_template_id?: Maybe<Scalars['uuid']['output']>;
  brochure_font_family?: Maybe<Scalars['String']['output']>;
  brochure_pdf_compression_quality?: Maybe<Scalars['pdf_compression_quality']['output']>;
  brochure_title?: Maybe<Scalars['String']['output']>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "lot_crm_link" */
  crm_link?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['currencies']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  dummy_broker_name?: Maybe<Scalars['String']['output']>;
  dummy_broker_phone?: Maybe<Scalars['String']['output']>;
  dummy_country_code?: Maybe<Scalars['String']['output']>;
  dummy_lat?: Maybe<Scalars['float8']['output']>;
  dummy_living_surface?: Maybe<Scalars['String']['output']>;
  dummy_lng?: Maybe<Scalars['float8']['output']>;
  dummy_locality?: Maybe<Scalars['String']['output']>;
  dummy_locality_id?: Maybe<Scalars['uuid']['output']>;
  dummy_organisation_country_code?: Maybe<Scalars['String']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['float8']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['float8']['output']>;
  dummy_organisation_locality?: Maybe<Scalars['String']['output']>;
  dummy_organisation_name?: Maybe<Scalars['String']['output']>;
  dummy_organisation_phone?: Maybe<Scalars['String']['output']>;
  dummy_organisation_postcode?: Maybe<Scalars['String']['output']>;
  dummy_organisation_route?: Maybe<Scalars['String']['output']>;
  dummy_organisation_state?: Maybe<Scalars['String']['output']>;
  dummy_organisation_street_number?: Maybe<Scalars['String']['output']>;
  dummy_postcode?: Maybe<Scalars['String']['output']>;
  dummy_route?: Maybe<Scalars['String']['output']>;
  dummy_state?: Maybe<Scalars['String']['output']>;
  dummy_street_number?: Maybe<Scalars['String']['output']>;
  dummy_usable_surface?: Maybe<Scalars['String']['output']>;
  duration_in_months?: Maybe<Scalars['Int']['output']>;
  expected_time_to_sell?: Maybe<Scalars['String']['output']>;
  fixed_fee?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indoor_parking_price?: Maybe<Scalars['float8']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  listing_url?: Maybe<Scalars['String']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  mandate_type?: Maybe<Scalars['String']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  mortgage_broker_id?: Maybe<Scalars['uuid']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  origin_id?: Maybe<Scalars['uuid']['output']>;
  outdoor_parking_price?: Maybe<Scalars['float8']['output']>;
  parking_price?: Maybe<Scalars['float8']['output']>;
  payment_id?: Maybe<Scalars['uuid']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  publish_step?: Maybe<Scalars['String']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  response_sender_id?: Maybe<Scalars['uuid']['output']>;
  sale_price?: Maybe<Scalars['float8']['output']>;
  sale_price_computed?: Maybe<Scalars['float8']['output']>;
  signed_at?: Maybe<Scalars['date']['output']>;
  success_fee_custom?: Maybe<Scalars['String']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
  success_fee_type?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  video_url?: Maybe<Scalars['String']['output']>;
  virtual_visit_url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "lots" */
export type Lots_Min_Order_By = {
  available_from?: InputMaybe<Order_By>;
  brochure_cover_image_id?: InputMaybe<Order_By>;
  brochure_description?: InputMaybe<Order_By>;
  brochure_description_layout?: InputMaybe<Order_By>;
  brochure_doc_template_id?: InputMaybe<Order_By>;
  brochure_font_family?: InputMaybe<Order_By>;
  brochure_pdf_compression_quality?: InputMaybe<Order_By>;
  brochure_title?: InputMaybe<Order_By>;
  broker_id?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  dummy_broker_name?: InputMaybe<Order_By>;
  dummy_broker_phone?: InputMaybe<Order_By>;
  dummy_country_code?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_living_surface?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_locality?: InputMaybe<Order_By>;
  dummy_locality_id?: InputMaybe<Order_By>;
  dummy_organisation_country_code?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  dummy_organisation_locality?: InputMaybe<Order_By>;
  dummy_organisation_name?: InputMaybe<Order_By>;
  dummy_organisation_phone?: InputMaybe<Order_By>;
  dummy_organisation_postcode?: InputMaybe<Order_By>;
  dummy_organisation_route?: InputMaybe<Order_By>;
  dummy_organisation_state?: InputMaybe<Order_By>;
  dummy_organisation_street_number?: InputMaybe<Order_By>;
  dummy_postcode?: InputMaybe<Order_By>;
  dummy_route?: InputMaybe<Order_By>;
  dummy_state?: InputMaybe<Order_By>;
  dummy_street_number?: InputMaybe<Order_By>;
  dummy_usable_surface?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  expected_time_to_sell?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  listing_url?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  mandate_type?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  mortgage_broker_id?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  origin_id?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  publish_step?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  response_sender_id?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  signed_at?: InputMaybe<Order_By>;
  success_fee_custom?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
  success_fee_type?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  video_url?: InputMaybe<Order_By>;
  virtual_visit_url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lots" */
export type Lots_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lots>;
};

/** input type for inserting object relation for remote table "lots" */
export type Lots_Obj_Rel_Insert_Input = {
  data: Lots_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Lots_On_Conflict>;
};

/** on_conflict condition type for table "lots" */
export type Lots_On_Conflict = {
  constraint: Lots_Constraint;
  update_columns?: Array<Lots_Update_Column>;
  where?: InputMaybe<Lots_Bool_Exp>;
};

/** Ordering options when selecting data from "lots". */
export type Lots_Order_By = {
  activities_aggregate?: InputMaybe<Activities_Aggregate_Order_By>;
  address_display_option?: InputMaybe<Order_By>;
  address_display_option_brochure?: InputMaybe<Order_By>;
  auto_matching_filters?: InputMaybe<Order_By>;
  available_from?: InputMaybe<Order_By>;
  brochure_cover_image?: InputMaybe<Images_Order_By>;
  brochure_cover_image_id?: InputMaybe<Order_By>;
  brochure_description?: InputMaybe<Order_By>;
  brochure_description_layout?: InputMaybe<Order_By>;
  brochure_doc_template_id?: InputMaybe<Order_By>;
  brochure_font_family?: InputMaybe<Order_By>;
  brochure_include_append_files?: InputMaybe<Order_By>;
  brochure_include_cover?: InputMaybe<Order_By>;
  brochure_include_description?: InputMaybe<Order_By>;
  brochure_include_photos?: InputMaybe<Order_By>;
  brochure_include_property?: InputMaybe<Order_By>;
  brochure_pdf_compression_quality?: InputMaybe<Order_By>;
  brochure_show_agent_on_brochure?: InputMaybe<Order_By>;
  brochure_title?: InputMaybe<Order_By>;
  broker?: InputMaybe<Users_Order_By>;
  broker_id?: InputMaybe<Order_By>;
  buyer_leads_aggregate?: InputMaybe<Buyer_Leads_Aggregate_Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<Users_Order_By>;
  crm_link?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  development?: InputMaybe<Developments_Order_By>;
  development_id?: InputMaybe<Order_By>;
  doc_template?: InputMaybe<Doc_Templates_Order_By>;
  dummy_broker_name?: InputMaybe<Order_By>;
  dummy_broker_phone?: InputMaybe<Order_By>;
  dummy_country_code?: InputMaybe<Order_By>;
  dummy_geom?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_living_surface?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_locality?: InputMaybe<Order_By>;
  dummy_locality_id?: InputMaybe<Order_By>;
  dummy_organisation_country_code?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  dummy_organisation_locality?: InputMaybe<Order_By>;
  dummy_organisation_name?: InputMaybe<Order_By>;
  dummy_organisation_phone?: InputMaybe<Order_By>;
  dummy_organisation_postcode?: InputMaybe<Order_By>;
  dummy_organisation_route?: InputMaybe<Order_By>;
  dummy_organisation_state?: InputMaybe<Order_By>;
  dummy_organisation_street_number?: InputMaybe<Order_By>;
  dummy_postcode?: InputMaybe<Order_By>;
  dummy_route?: InputMaybe<Order_By>;
  dummy_state?: InputMaybe<Order_By>;
  dummy_street_number?: InputMaybe<Order_By>;
  dummy_usable_surface?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  email_templates_aggregate?: InputMaybe<Email_Templates_Aggregate_Order_By>;
  enable_auto_matching?: InputMaybe<Order_By>;
  enquiries_aggregate?: InputMaybe<Enquiries_Aggregate_Order_By>;
  enquiry_response_enabled?: InputMaybe<Order_By>;
  expected_time_to_sell?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  has_success_fee?: InputMaybe<Order_By>;
  hide_price_on_brochure?: InputMaybe<Order_By>;
  hide_price_on_portals?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  is_exclusive?: InputMaybe<Order_By>;
  is_paid?: InputMaybe<Order_By>;
  is_parking_included_in_total?: InputMaybe<Order_By>;
  is_sales_tax_inclusive?: InputMaybe<Order_By>;
  lead?: InputMaybe<Leads_Order_By>;
  lead_id?: InputMaybe<Order_By>;
  listing_url?: InputMaybe<Order_By>;
  lot_property_files_aggregate?: InputMaybe<Property_Files_Aggregate_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  lot_reference_aliases_aggregate?: InputMaybe<Lot_Reference_Aliases_Aggregate_Order_By>;
  lots_status?: InputMaybe<Lots_Status_Enum_Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  mandate_type?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  mortgage_broker_id?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offers_aggregate?: InputMaybe<Offers_Aggregate_Order_By>;
  order_nr?: InputMaybe<Order_By>;
  origin?: InputMaybe<Dictionaries_Order_By>;
  origin_id?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  parking_price_type?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
  portal_listings_aggregate?: InputMaybe<Portal_Listings_Aggregate_Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property?: InputMaybe<Properties_Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_transactions_aggregate?: InputMaybe<Property_Transactions_Aggregate_Order_By>;
  publish_step?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  response_sender?: InputMaybe<Users_Order_By>;
  response_sender_id?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  sellers_aggregate?: InputMaybe<Lot_Sellers_Aggregate_Order_By>;
  send_enquiries_to_sellers?: InputMaybe<Order_By>;
  shared_on_mls?: InputMaybe<Order_By>;
  signed_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  success_fee_custom?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
  success_fee_type?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  use_custom_brochure_description?: InputMaybe<Order_By>;
  use_custom_brochure_title?: InputMaybe<Order_By>;
  use_dummy_address?: InputMaybe<Order_By>;
  use_dummy_contact?: InputMaybe<Order_By>;
  video_url?: InputMaybe<Order_By>;
  virtual_visit_url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lots */
export type Lots_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Lots_Prepend_Input = {
  auto_matching_filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "lots" */
export enum Lots_Select_Column {
  /** column name */
  AddressDisplayOption = 'address_display_option',
  /** column name */
  AddressDisplayOptionBrochure = 'address_display_option_brochure',
  /** column name */
  AutoMatchingFilters = 'auto_matching_filters',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BrochureCoverImageId = 'brochure_cover_image_id',
  /** column name */
  BrochureDescription = 'brochure_description',
  /** column name */
  BrochureDescriptionLayout = 'brochure_description_layout',
  /** column name */
  BrochureDocTemplateId = 'brochure_doc_template_id',
  /** column name */
  BrochureFontFamily = 'brochure_font_family',
  /** column name */
  BrochureIncludeAppendFiles = 'brochure_include_append_files',
  /** column name */
  BrochureIncludeCover = 'brochure_include_cover',
  /** column name */
  BrochureIncludeDescription = 'brochure_include_description',
  /** column name */
  BrochureIncludePhotos = 'brochure_include_photos',
  /** column name */
  BrochureIncludeProperty = 'brochure_include_property',
  /** column name */
  BrochurePdfCompressionQuality = 'brochure_pdf_compression_quality',
  /** column name */
  BrochureShowAgentOnBrochure = 'brochure_show_agent_on_brochure',
  /** column name */
  BrochureTitle = 'brochure_title',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CommissionRate = 'commission_rate',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  DummyBrokerName = 'dummy_broker_name',
  /** column name */
  DummyBrokerPhone = 'dummy_broker_phone',
  /** column name */
  DummyCountryCode = 'dummy_country_code',
  /** column name */
  DummyGeom = 'dummy_geom',
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLivingSurface = 'dummy_living_surface',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyLocality = 'dummy_locality',
  /** column name */
  DummyLocalityId = 'dummy_locality_id',
  /** column name */
  DummyOrganisationCountryCode = 'dummy_organisation_country_code',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  DummyOrganisationLocality = 'dummy_organisation_locality',
  /** column name */
  DummyOrganisationName = 'dummy_organisation_name',
  /** column name */
  DummyOrganisationPhone = 'dummy_organisation_phone',
  /** column name */
  DummyOrganisationPostcode = 'dummy_organisation_postcode',
  /** column name */
  DummyOrganisationRoute = 'dummy_organisation_route',
  /** column name */
  DummyOrganisationState = 'dummy_organisation_state',
  /** column name */
  DummyOrganisationStreetNumber = 'dummy_organisation_street_number',
  /** column name */
  DummyPostcode = 'dummy_postcode',
  /** column name */
  DummyRoute = 'dummy_route',
  /** column name */
  DummyState = 'dummy_state',
  /** column name */
  DummyStreetNumber = 'dummy_street_number',
  /** column name */
  DummyUsableSurface = 'dummy_usable_surface',
  /** column name */
  DurationInMonths = 'duration_in_months',
  /** column name */
  EnableAutoMatching = 'enable_auto_matching',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  ExpectedTimeToSell = 'expected_time_to_sell',
  /** column name */
  FixedFee = 'fixed_fee',
  /** column name */
  HasSuccessFee = 'has_success_fee',
  /** column name */
  HidePriceOnBrochure = 'hide_price_on_brochure',
  /** column name */
  HidePriceOnPortals = 'hide_price_on_portals',
  /** column name */
  Id = 'id',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  IsExclusive = 'is_exclusive',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  IsParkingIncludedInTotal = 'is_parking_included_in_total',
  /** column name */
  IsSalesTaxInclusive = 'is_sales_tax_inclusive',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  ListingUrl = 'listing_url',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MandateSalePrice = 'mandate_sale_price',
  /** column name */
  MandateType = 'mandate_type',
  /** column name */
  MinimumNetSellerPrice = 'minimum_net_seller_price',
  /** column name */
  MonthlyRentComputed = 'monthly_rent_computed',
  /** column name */
  MortgageBrokerId = 'mortgage_broker_id',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  OriginId = 'origin_id',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  ParkingPriceType = 'parking_price_type',
  /** column name */
  PaymentId = 'payment_id',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PublishStep = 'publish_step',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  ResponseSenderId = 'response_sender_id',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed',
  /** column name */
  SendEnquiriesToSellers = 'send_enquiries_to_sellers',
  /** column name */
  SharedOnMls = 'shared_on_mls',
  /** column name */
  SignedAt = 'signed_at',
  /** column name */
  Status = 'status',
  /** column name */
  SuccessFeeCustom = 'success_fee_custom',
  /** column name */
  SuccessFeePercentage = 'success_fee_percentage',
  /** column name */
  SuccessFeeType = 'success_fee_type',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseCustomBrochureDescription = 'use_custom_brochure_description',
  /** column name */
  UseCustomBrochureTitle = 'use_custom_brochure_title',
  /** column name */
  UseDummyAddress = 'use_dummy_address',
  /** column name */
  UseDummyContact = 'use_dummy_contact',
  /** column name */
  VideoUrl = 'video_url',
  /** column name */
  VirtualVisitUrl = 'virtual_visit_url'
}

/** select "lots_aggregate_bool_exp_avg_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

/** select "lots_aggregate_bool_exp_bool_and_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  BrochureIncludeAppendFiles = 'brochure_include_append_files',
  /** column name */
  BrochureIncludeCover = 'brochure_include_cover',
  /** column name */
  BrochureIncludeDescription = 'brochure_include_description',
  /** column name */
  BrochureIncludePhotos = 'brochure_include_photos',
  /** column name */
  BrochureIncludeProperty = 'brochure_include_property',
  /** column name */
  BrochureShowAgentOnBrochure = 'brochure_show_agent_on_brochure',
  /** column name */
  EnableAutoMatching = 'enable_auto_matching',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  HasSuccessFee = 'has_success_fee',
  /** column name */
  HidePriceOnBrochure = 'hide_price_on_brochure',
  /** column name */
  HidePriceOnPortals = 'hide_price_on_portals',
  /** column name */
  IsExclusive = 'is_exclusive',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  IsParkingIncludedInTotal = 'is_parking_included_in_total',
  /** column name */
  IsSalesTaxInclusive = 'is_sales_tax_inclusive',
  /** column name */
  SendEnquiriesToSellers = 'send_enquiries_to_sellers',
  /** column name */
  SharedOnMls = 'shared_on_mls',
  /** column name */
  UseCustomBrochureDescription = 'use_custom_brochure_description',
  /** column name */
  UseCustomBrochureTitle = 'use_custom_brochure_title',
  /** column name */
  UseDummyAddress = 'use_dummy_address',
  /** column name */
  UseDummyContact = 'use_dummy_contact'
}

/** select "lots_aggregate_bool_exp_bool_or_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  BrochureIncludeAppendFiles = 'brochure_include_append_files',
  /** column name */
  BrochureIncludeCover = 'brochure_include_cover',
  /** column name */
  BrochureIncludeDescription = 'brochure_include_description',
  /** column name */
  BrochureIncludePhotos = 'brochure_include_photos',
  /** column name */
  BrochureIncludeProperty = 'brochure_include_property',
  /** column name */
  BrochureShowAgentOnBrochure = 'brochure_show_agent_on_brochure',
  /** column name */
  EnableAutoMatching = 'enable_auto_matching',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  HasSuccessFee = 'has_success_fee',
  /** column name */
  HidePriceOnBrochure = 'hide_price_on_brochure',
  /** column name */
  HidePriceOnPortals = 'hide_price_on_portals',
  /** column name */
  IsExclusive = 'is_exclusive',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  IsParkingIncludedInTotal = 'is_parking_included_in_total',
  /** column name */
  IsSalesTaxInclusive = 'is_sales_tax_inclusive',
  /** column name */
  SendEnquiriesToSellers = 'send_enquiries_to_sellers',
  /** column name */
  SharedOnMls = 'shared_on_mls',
  /** column name */
  UseCustomBrochureDescription = 'use_custom_brochure_description',
  /** column name */
  UseCustomBrochureTitle = 'use_custom_brochure_title',
  /** column name */
  UseDummyAddress = 'use_dummy_address',
  /** column name */
  UseDummyContact = 'use_dummy_contact'
}

/** select "lots_aggregate_bool_exp_corr_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

/** select "lots_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

/** select "lots_aggregate_bool_exp_max_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

/** select "lots_aggregate_bool_exp_min_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

/** select "lots_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

/** select "lots_aggregate_bool_exp_sum_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

/** select "lots_aggregate_bool_exp_var_samp_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

/** input type for updating data in table "lots" */
export type Lots_Set_Input = {
  address_display_option?: InputMaybe<Address_Display_Options_Enum_Enum>;
  address_display_option_brochure?: InputMaybe<Address_Display_Options_Enum_Enum>;
  auto_matching_filters?: InputMaybe<Scalars['jsonb']['input']>;
  available_from?: InputMaybe<Scalars['date']['input']>;
  brochure_cover_image_id?: InputMaybe<Scalars['uuid']['input']>;
  brochure_description?: InputMaybe<Scalars['String']['input']>;
  brochure_description_layout?: InputMaybe<Scalars['smallint']['input']>;
  brochure_doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  brochure_font_family?: InputMaybe<Scalars['String']['input']>;
  brochure_include_append_files?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_cover?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_description?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_photos?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_property?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_pdf_compression_quality?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  brochure_show_agent_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_title?: InputMaybe<Scalars['String']['input']>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  commission_rate?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['currencies']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  dummy_broker_name?: InputMaybe<Scalars['String']['input']>;
  dummy_broker_phone?: InputMaybe<Scalars['String']['input']>;
  dummy_country_code?: InputMaybe<Scalars['String']['input']>;
  dummy_geom?: InputMaybe<Scalars['geometry']['input']>;
  dummy_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_living_surface?: InputMaybe<Scalars['String']['input']>;
  dummy_lng?: InputMaybe<Scalars['float8']['input']>;
  dummy_locality?: InputMaybe<Scalars['String']['input']>;
  dummy_locality_id?: InputMaybe<Scalars['uuid']['input']>;
  dummy_organisation_country_code?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_lng?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_locality?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_name?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_phone?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_postcode?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_route?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_state?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_street_number?: InputMaybe<Scalars['String']['input']>;
  dummy_postcode?: InputMaybe<Scalars['String']['input']>;
  dummy_route?: InputMaybe<Scalars['String']['input']>;
  dummy_state?: InputMaybe<Scalars['String']['input']>;
  dummy_street_number?: InputMaybe<Scalars['String']['input']>;
  dummy_usable_surface?: InputMaybe<Scalars['String']['input']>;
  duration_in_months?: InputMaybe<Scalars['Int']['input']>;
  enable_auto_matching?: InputMaybe<Scalars['Boolean']['input']>;
  enquiry_response_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  expected_time_to_sell?: InputMaybe<Scalars['String']['input']>;
  fixed_fee?: InputMaybe<Scalars['Int']['input']>;
  has_success_fee?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_portals?: InputMaybe<Scalars['Boolean']['input']>;
  indoor_parking_price?: InputMaybe<Scalars['float8']['input']>;
  is_exclusive?: InputMaybe<Scalars['Boolean']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  is_parking_included_in_total?: InputMaybe<Scalars['Boolean']['input']>;
  is_sales_tax_inclusive?: InputMaybe<Scalars['Boolean']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  listing_url?: InputMaybe<Scalars['String']['input']>;
  lot_reference?: InputMaybe<Scalars['String']['input']>;
  mandate_sale_price?: InputMaybe<Scalars['Float']['input']>;
  mandate_type?: InputMaybe<Scalars['String']['input']>;
  minimum_net_seller_price?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_computed?: InputMaybe<Scalars['Float']['input']>;
  mortgage_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  offer_type?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  origin_id?: InputMaybe<Scalars['uuid']['input']>;
  outdoor_parking_price?: InputMaybe<Scalars['float8']['input']>;
  parking_price?: InputMaybe<Scalars['float8']['input']>;
  parking_price_type?: InputMaybe<Parking_Price_Type_Enum_Enum>;
  payment_id?: InputMaybe<Scalars['uuid']['input']>;
  price_unit?: InputMaybe<Scalars['String']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  publish_step?: InputMaybe<Scalars['String']['input']>;
  rent_extra?: InputMaybe<Scalars['Float']['input']>;
  rent_net?: InputMaybe<Scalars['Float']['input']>;
  response_sender_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_price?: InputMaybe<Scalars['float8']['input']>;
  sale_price_computed?: InputMaybe<Scalars['float8']['input']>;
  send_enquiries_to_sellers?: InputMaybe<Scalars['Boolean']['input']>;
  shared_on_mls?: InputMaybe<Scalars['Boolean']['input']>;
  signed_at?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Lots_Status_Enum_Enum>;
  success_fee_custom?: InputMaybe<Scalars['String']['input']>;
  success_fee_percentage?: InputMaybe<Scalars['Float']['input']>;
  success_fee_type?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_custom_brochure_description?: InputMaybe<Scalars['Boolean']['input']>;
  use_custom_brochure_title?: InputMaybe<Scalars['Boolean']['input']>;
  use_dummy_address?: InputMaybe<Scalars['Boolean']['input']>;
  use_dummy_contact?: InputMaybe<Scalars['Boolean']['input']>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  virtual_visit_url?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "lots_status_enum" */
export type Lots_Status_Enum = {
  comment?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "lots_status_enum_label" */
  label?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "lots_status_enum". All fields are combined with a logical 'AND'. */
export type Lots_Status_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Lots_Status_Enum_Bool_Exp>>;
  _not?: InputMaybe<Lots_Status_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Lots_Status_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Lots_Status_Enum_Enum {
  Abandoned = 'abandoned',
  Available = 'available',
  AvailableComingSoon = 'available_coming_soon',
  AvailableOffMarket = 'available_off_market',
  Draft = 'draft',
  LostSoldOwner = 'lost_sold_owner',
  LostSoldSomeone = 'lost_sold_someone',
  Paused = 'paused',
  Reserved = 'reserved',
  Won = 'won'
}

/** Boolean expression to compare columns of type "lots_status_enum_enum". All fields are combined with logical 'AND'. */
export type Lots_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Lots_Status_Enum_Enum>;
  _in?: InputMaybe<Array<Lots_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Lots_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<Lots_Status_Enum_Enum>>;
};

/** Ordering options when selecting data from "lots_status_enum". */
export type Lots_Status_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "lots_status_enum" */
export enum Lots_Status_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "lots_status_enum" */
export type Lots_Status_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lots_Status_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lots_Status_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Lots_Stddev_Fields = {
  brochure_description_layout?: Maybe<Scalars['Float']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['Float']['output']>;
  duration_in_months?: Maybe<Scalars['Float']['output']>;
  fixed_fee?: Maybe<Scalars['Float']['output']>;
  indoor_parking_price?: Maybe<Scalars['Float']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  outdoor_parking_price?: Maybe<Scalars['Float']['output']>;
  parking_price?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_computed?: Maybe<Scalars['Float']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "lots" */
export type Lots_Stddev_Order_By = {
  brochure_description_layout?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lots_Stddev_Pop_Fields = {
  brochure_description_layout?: Maybe<Scalars['Float']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['Float']['output']>;
  duration_in_months?: Maybe<Scalars['Float']['output']>;
  fixed_fee?: Maybe<Scalars['Float']['output']>;
  indoor_parking_price?: Maybe<Scalars['Float']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  outdoor_parking_price?: Maybe<Scalars['Float']['output']>;
  parking_price?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_computed?: Maybe<Scalars['Float']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "lots" */
export type Lots_Stddev_Pop_Order_By = {
  brochure_description_layout?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lots_Stddev_Samp_Fields = {
  brochure_description_layout?: Maybe<Scalars['Float']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['Float']['output']>;
  duration_in_months?: Maybe<Scalars['Float']['output']>;
  fixed_fee?: Maybe<Scalars['Float']['output']>;
  indoor_parking_price?: Maybe<Scalars['Float']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  outdoor_parking_price?: Maybe<Scalars['Float']['output']>;
  parking_price?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_computed?: Maybe<Scalars['Float']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "lots" */
export type Lots_Stddev_Samp_Order_By = {
  brochure_description_layout?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lots" */
export type Lots_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lots_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lots_Stream_Cursor_Value_Input = {
  address_display_option?: InputMaybe<Address_Display_Options_Enum_Enum>;
  address_display_option_brochure?: InputMaybe<Address_Display_Options_Enum_Enum>;
  auto_matching_filters?: InputMaybe<Scalars['jsonb']['input']>;
  available_from?: InputMaybe<Scalars['date']['input']>;
  brochure_cover_image_id?: InputMaybe<Scalars['uuid']['input']>;
  brochure_description?: InputMaybe<Scalars['String']['input']>;
  brochure_description_layout?: InputMaybe<Scalars['smallint']['input']>;
  brochure_doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  brochure_font_family?: InputMaybe<Scalars['String']['input']>;
  brochure_include_append_files?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_cover?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_description?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_photos?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_property?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_pdf_compression_quality?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  brochure_show_agent_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_title?: InputMaybe<Scalars['String']['input']>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  commission_rate?: InputMaybe<Scalars['Float']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['currencies']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  dummy_broker_name?: InputMaybe<Scalars['String']['input']>;
  dummy_broker_phone?: InputMaybe<Scalars['String']['input']>;
  dummy_country_code?: InputMaybe<Scalars['String']['input']>;
  dummy_geom?: InputMaybe<Scalars['geometry']['input']>;
  dummy_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_living_surface?: InputMaybe<Scalars['String']['input']>;
  dummy_lng?: InputMaybe<Scalars['float8']['input']>;
  dummy_locality?: InputMaybe<Scalars['String']['input']>;
  dummy_locality_id?: InputMaybe<Scalars['uuid']['input']>;
  dummy_organisation_country_code?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_lng?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_locality?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_name?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_phone?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_postcode?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_route?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_state?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_street_number?: InputMaybe<Scalars['String']['input']>;
  dummy_postcode?: InputMaybe<Scalars['String']['input']>;
  dummy_route?: InputMaybe<Scalars['String']['input']>;
  dummy_state?: InputMaybe<Scalars['String']['input']>;
  dummy_street_number?: InputMaybe<Scalars['String']['input']>;
  dummy_usable_surface?: InputMaybe<Scalars['String']['input']>;
  duration_in_months?: InputMaybe<Scalars['Int']['input']>;
  enable_auto_matching?: InputMaybe<Scalars['Boolean']['input']>;
  enquiry_response_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  expected_time_to_sell?: InputMaybe<Scalars['String']['input']>;
  fixed_fee?: InputMaybe<Scalars['Int']['input']>;
  has_success_fee?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_portals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indoor_parking_price?: InputMaybe<Scalars['float8']['input']>;
  is_exclusive?: InputMaybe<Scalars['Boolean']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  is_parking_included_in_total?: InputMaybe<Scalars['Boolean']['input']>;
  is_sales_tax_inclusive?: InputMaybe<Scalars['Boolean']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  listing_url?: InputMaybe<Scalars['String']['input']>;
  lot_reference?: InputMaybe<Scalars['String']['input']>;
  mandate_sale_price?: InputMaybe<Scalars['Float']['input']>;
  mandate_type?: InputMaybe<Scalars['String']['input']>;
  minimum_net_seller_price?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_computed?: InputMaybe<Scalars['Float']['input']>;
  mortgage_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  offer_type?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  origin_id?: InputMaybe<Scalars['uuid']['input']>;
  outdoor_parking_price?: InputMaybe<Scalars['float8']['input']>;
  parking_price?: InputMaybe<Scalars['float8']['input']>;
  parking_price_type?: InputMaybe<Parking_Price_Type_Enum_Enum>;
  payment_id?: InputMaybe<Scalars['uuid']['input']>;
  price_unit?: InputMaybe<Scalars['String']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  publish_step?: InputMaybe<Scalars['String']['input']>;
  rent_extra?: InputMaybe<Scalars['Float']['input']>;
  rent_net?: InputMaybe<Scalars['Float']['input']>;
  response_sender_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_price?: InputMaybe<Scalars['float8']['input']>;
  sale_price_computed?: InputMaybe<Scalars['float8']['input']>;
  send_enquiries_to_sellers?: InputMaybe<Scalars['Boolean']['input']>;
  shared_on_mls?: InputMaybe<Scalars['Boolean']['input']>;
  signed_at?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Lots_Status_Enum_Enum>;
  success_fee_custom?: InputMaybe<Scalars['String']['input']>;
  success_fee_percentage?: InputMaybe<Scalars['Float']['input']>;
  success_fee_type?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_custom_brochure_description?: InputMaybe<Scalars['Boolean']['input']>;
  use_custom_brochure_title?: InputMaybe<Scalars['Boolean']['input']>;
  use_dummy_address?: InputMaybe<Scalars['Boolean']['input']>;
  use_dummy_contact?: InputMaybe<Scalars['Boolean']['input']>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  virtual_visit_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Lots_Sum_Fields = {
  brochure_description_layout?: Maybe<Scalars['smallint']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  dummy_lat?: Maybe<Scalars['float8']['output']>;
  dummy_lng?: Maybe<Scalars['float8']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['float8']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['float8']['output']>;
  duration_in_months?: Maybe<Scalars['Int']['output']>;
  fixed_fee?: Maybe<Scalars['Int']['output']>;
  indoor_parking_price?: Maybe<Scalars['float8']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  outdoor_parking_price?: Maybe<Scalars['float8']['output']>;
  parking_price?: Maybe<Scalars['float8']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['float8']['output']>;
  sale_price_computed?: Maybe<Scalars['float8']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "lots" */
export type Lots_Sum_Order_By = {
  brochure_description_layout?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
};

/** update columns of table "lots" */
export enum Lots_Update_Column {
  /** column name */
  AddressDisplayOption = 'address_display_option',
  /** column name */
  AddressDisplayOptionBrochure = 'address_display_option_brochure',
  /** column name */
  AutoMatchingFilters = 'auto_matching_filters',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BrochureCoverImageId = 'brochure_cover_image_id',
  /** column name */
  BrochureDescription = 'brochure_description',
  /** column name */
  BrochureDescriptionLayout = 'brochure_description_layout',
  /** column name */
  BrochureDocTemplateId = 'brochure_doc_template_id',
  /** column name */
  BrochureFontFamily = 'brochure_font_family',
  /** column name */
  BrochureIncludeAppendFiles = 'brochure_include_append_files',
  /** column name */
  BrochureIncludeCover = 'brochure_include_cover',
  /** column name */
  BrochureIncludeDescription = 'brochure_include_description',
  /** column name */
  BrochureIncludePhotos = 'brochure_include_photos',
  /** column name */
  BrochureIncludeProperty = 'brochure_include_property',
  /** column name */
  BrochurePdfCompressionQuality = 'brochure_pdf_compression_quality',
  /** column name */
  BrochureShowAgentOnBrochure = 'brochure_show_agent_on_brochure',
  /** column name */
  BrochureTitle = 'brochure_title',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CommissionRate = 'commission_rate',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  DummyBrokerName = 'dummy_broker_name',
  /** column name */
  DummyBrokerPhone = 'dummy_broker_phone',
  /** column name */
  DummyCountryCode = 'dummy_country_code',
  /** column name */
  DummyGeom = 'dummy_geom',
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLivingSurface = 'dummy_living_surface',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyLocality = 'dummy_locality',
  /** column name */
  DummyLocalityId = 'dummy_locality_id',
  /** column name */
  DummyOrganisationCountryCode = 'dummy_organisation_country_code',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  DummyOrganisationLocality = 'dummy_organisation_locality',
  /** column name */
  DummyOrganisationName = 'dummy_organisation_name',
  /** column name */
  DummyOrganisationPhone = 'dummy_organisation_phone',
  /** column name */
  DummyOrganisationPostcode = 'dummy_organisation_postcode',
  /** column name */
  DummyOrganisationRoute = 'dummy_organisation_route',
  /** column name */
  DummyOrganisationState = 'dummy_organisation_state',
  /** column name */
  DummyOrganisationStreetNumber = 'dummy_organisation_street_number',
  /** column name */
  DummyPostcode = 'dummy_postcode',
  /** column name */
  DummyRoute = 'dummy_route',
  /** column name */
  DummyState = 'dummy_state',
  /** column name */
  DummyStreetNumber = 'dummy_street_number',
  /** column name */
  DummyUsableSurface = 'dummy_usable_surface',
  /** column name */
  DurationInMonths = 'duration_in_months',
  /** column name */
  EnableAutoMatching = 'enable_auto_matching',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  ExpectedTimeToSell = 'expected_time_to_sell',
  /** column name */
  FixedFee = 'fixed_fee',
  /** column name */
  HasSuccessFee = 'has_success_fee',
  /** column name */
  HidePriceOnBrochure = 'hide_price_on_brochure',
  /** column name */
  HidePriceOnPortals = 'hide_price_on_portals',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  IsExclusive = 'is_exclusive',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  IsParkingIncludedInTotal = 'is_parking_included_in_total',
  /** column name */
  IsSalesTaxInclusive = 'is_sales_tax_inclusive',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  ListingUrl = 'listing_url',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MandateSalePrice = 'mandate_sale_price',
  /** column name */
  MandateType = 'mandate_type',
  /** column name */
  MinimumNetSellerPrice = 'minimum_net_seller_price',
  /** column name */
  MonthlyRentComputed = 'monthly_rent_computed',
  /** column name */
  MortgageBrokerId = 'mortgage_broker_id',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  OriginId = 'origin_id',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  ParkingPriceType = 'parking_price_type',
  /** column name */
  PaymentId = 'payment_id',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PublishStep = 'publish_step',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  ResponseSenderId = 'response_sender_id',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed',
  /** column name */
  SendEnquiriesToSellers = 'send_enquiries_to_sellers',
  /** column name */
  SharedOnMls = 'shared_on_mls',
  /** column name */
  SignedAt = 'signed_at',
  /** column name */
  Status = 'status',
  /** column name */
  SuccessFeeCustom = 'success_fee_custom',
  /** column name */
  SuccessFeePercentage = 'success_fee_percentage',
  /** column name */
  SuccessFeeType = 'success_fee_type',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseCustomBrochureDescription = 'use_custom_brochure_description',
  /** column name */
  UseCustomBrochureTitle = 'use_custom_brochure_title',
  /** column name */
  UseDummyAddress = 'use_dummy_address',
  /** column name */
  UseDummyContact = 'use_dummy_contact',
  /** column name */
  VideoUrl = 'video_url',
  /** column name */
  VirtualVisitUrl = 'virtual_visit_url'
}

export type Lots_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Lots_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Lots_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Lots_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Lots_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Lots_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Lots_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lots_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lots_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Lots_Var_Pop_Fields = {
  brochure_description_layout?: Maybe<Scalars['Float']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['Float']['output']>;
  duration_in_months?: Maybe<Scalars['Float']['output']>;
  fixed_fee?: Maybe<Scalars['Float']['output']>;
  indoor_parking_price?: Maybe<Scalars['Float']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  outdoor_parking_price?: Maybe<Scalars['Float']['output']>;
  parking_price?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_computed?: Maybe<Scalars['Float']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "lots" */
export type Lots_Var_Pop_Order_By = {
  brochure_description_layout?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lots_Var_Samp_Fields = {
  brochure_description_layout?: Maybe<Scalars['Float']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['Float']['output']>;
  duration_in_months?: Maybe<Scalars['Float']['output']>;
  fixed_fee?: Maybe<Scalars['Float']['output']>;
  indoor_parking_price?: Maybe<Scalars['Float']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  outdoor_parking_price?: Maybe<Scalars['Float']['output']>;
  parking_price?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_computed?: Maybe<Scalars['Float']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "lots" */
export type Lots_Var_Samp_Order_By = {
  brochure_description_layout?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lots_Variance_Fields = {
  brochure_description_layout?: Maybe<Scalars['Float']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['Float']['output']>;
  duration_in_months?: Maybe<Scalars['Float']['output']>;
  fixed_fee?: Maybe<Scalars['Float']['output']>;
  indoor_parking_price?: Maybe<Scalars['Float']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  outdoor_parking_price?: Maybe<Scalars['Float']['output']>;
  parking_price?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_computed?: Maybe<Scalars['Float']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "lots" */
export type Lots_Variance_Order_By = {
  brochure_description_layout?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "marital_status". All fields are combined with logical 'AND'. */
export type Marital_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['marital_status']['input']>;
  _gt?: InputMaybe<Scalars['marital_status']['input']>;
  _gte?: InputMaybe<Scalars['marital_status']['input']>;
  _in?: InputMaybe<Array<Scalars['marital_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['marital_status']['input']>;
  _lte?: InputMaybe<Scalars['marital_status']['input']>;
  _neq?: InputMaybe<Scalars['marital_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['marital_status']['input']>>;
};

export type Merged_Listings_Compare_Args = {
  computed_price_per_sqm_gte?: InputMaybe<Scalars['Int']['input']>;
  computed_price_per_sqm_lte?: InputMaybe<Scalars['Int']['input']>;
  computed_surface_gte?: InputMaybe<Scalars['Int']['input']>;
  computed_surface_lte?: InputMaybe<Scalars['Int']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  district_id_in?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  land_surface_gte?: InputMaybe<Scalars['Int']['input']>;
  land_surface_lte?: InputMaybe<Scalars['Int']['input']>;
  locality_id_in?: InputMaybe<Scalars['String']['input']>;
  municipality_id_in?: InputMaybe<Scalars['String']['input']>;
  neighbourhood_id_in?: InputMaybe<Scalars['String']['input']>;
  number_of_rooms_gte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_lte?: InputMaybe<Scalars['Float']['input']>;
  offline?: InputMaybe<Scalars['Boolean']['input']>;
  property_main_type_in?: InputMaybe<Scalars['String']['input']>;
  property_type_in?: InputMaybe<Scalars['String']['input']>;
  property_type_nin?: InputMaybe<Scalars['String']['input']>;
  sale_price_gte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_lte?: InputMaybe<Scalars['Int']['input']>;
  sort_by?: InputMaybe<Scalars['String']['input']>;
  sort_dir?: InputMaybe<Scalars['String']['input']>;
  state_id_in?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "mls_lots" */
export type Mls_Lots = {
  available_from?: Maybe<Scalars['date']['output']>;
  brochure_description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  broker?: Maybe<Users>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['currencies']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hide_price_on_portals?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  property?: Maybe<Mls_Properties>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['float8']['output']>;
  shared_on_mls?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  use_custom_brochure_description?: Maybe<Scalars['Boolean']['output']>;
  use_custom_brochure_title?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "mls_lots" */
export type Mls_Lots_Aggregate = {
  aggregate?: Maybe<Mls_Lots_Aggregate_Fields>;
  nodes: Array<Mls_Lots>;
};

/** aggregate fields of "mls_lots" */
export type Mls_Lots_Aggregate_Fields = {
  avg?: Maybe<Mls_Lots_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mls_Lots_Max_Fields>;
  min?: Maybe<Mls_Lots_Min_Fields>;
  stddev?: Maybe<Mls_Lots_Stddev_Fields>;
  stddev_pop?: Maybe<Mls_Lots_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mls_Lots_Stddev_Samp_Fields>;
  sum?: Maybe<Mls_Lots_Sum_Fields>;
  var_pop?: Maybe<Mls_Lots_Var_Pop_Fields>;
  var_samp?: Maybe<Mls_Lots_Var_Samp_Fields>;
  variance?: Maybe<Mls_Lots_Variance_Fields>;
};


/** aggregate fields of "mls_lots" */
export type Mls_Lots_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mls_Lots_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mls_Lots_Avg_Fields = {
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mls_lots". All fields are combined with a logical 'AND'. */
export type Mls_Lots_Bool_Exp = {
  _and?: InputMaybe<Array<Mls_Lots_Bool_Exp>>;
  _not?: InputMaybe<Mls_Lots_Bool_Exp>;
  _or?: InputMaybe<Array<Mls_Lots_Bool_Exp>>;
  available_from?: InputMaybe<Date_Comparison_Exp>;
  brochure_description?: InputMaybe<String_Comparison_Exp>;
  broker?: InputMaybe<Users_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<Currencies_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  hide_price_on_portals?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  monthly_rent_computed?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property?: InputMaybe<Mls_Properties_Bool_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  sale_price?: InputMaybe<Float8_Comparison_Exp>;
  shared_on_mls?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  use_custom_brochure_description?: InputMaybe<Boolean_Comparison_Exp>;
  use_custom_brochure_title?: InputMaybe<Boolean_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mls_Lots_Max_Fields = {
  available_from?: Maybe<Scalars['date']['output']>;
  brochure_description?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['currencies']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['float8']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mls_Lots_Min_Fields = {
  available_from?: Maybe<Scalars['date']['output']>;
  brochure_description?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['currencies']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['float8']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "mls_lots". */
export type Mls_Lots_Order_By = {
  available_from?: InputMaybe<Order_By>;
  brochure_description?: InputMaybe<Order_By>;
  broker?: InputMaybe<Users_Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  hide_price_on_portals?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property?: InputMaybe<Mls_Properties_Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  shared_on_mls?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  use_custom_brochure_description?: InputMaybe<Order_By>;
  use_custom_brochure_title?: InputMaybe<Order_By>;
};

/** select columns of table "mls_lots" */
export enum Mls_Lots_Select_Column {
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BrochureDescription = 'brochure_description',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  HidePriceOnPortals = 'hide_price_on_portals',
  /** column name */
  Id = 'id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MonthlyRentComputed = 'monthly_rent_computed',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SharedOnMls = 'shared_on_mls',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UseCustomBrochureDescription = 'use_custom_brochure_description',
  /** column name */
  UseCustomBrochureTitle = 'use_custom_brochure_title'
}

/** aggregate stddev on columns */
export type Mls_Lots_Stddev_Fields = {
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mls_Lots_Stddev_Pop_Fields = {
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mls_Lots_Stddev_Samp_Fields = {
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mls_lots" */
export type Mls_Lots_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mls_Lots_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mls_Lots_Stream_Cursor_Value_Input = {
  available_from?: InputMaybe<Scalars['date']['input']>;
  brochure_description?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['currencies']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hide_price_on_portals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lot_reference?: InputMaybe<Scalars['String']['input']>;
  monthly_rent_computed?: InputMaybe<Scalars['Float']['input']>;
  offer_type?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  price_unit?: InputMaybe<Scalars['String']['input']>;
  rent_extra?: InputMaybe<Scalars['Float']['input']>;
  rent_net?: InputMaybe<Scalars['Float']['input']>;
  sale_price?: InputMaybe<Scalars['float8']['input']>;
  shared_on_mls?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  use_custom_brochure_description?: InputMaybe<Scalars['Boolean']['input']>;
  use_custom_brochure_title?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Mls_Lots_Sum_Fields = {
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Mls_Lots_Var_Pop_Fields = {
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mls_Lots_Var_Samp_Fields = {
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mls_Lots_Variance_Fields = {
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mls_properties" */
export type Mls_Properties = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  basement_surface?: Maybe<Scalars['Float']['output']>;
  building_condition?: Maybe<Scalars['Float']['output']>;
  building_standard?: Maybe<Scalars['Float']['output']>;
  building_volume?: Maybe<Scalars['Float']['output']>;
  building_volume_norm?: Maybe<Scalars['String']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  ceiling_height?: Maybe<Scalars['Float']['output']>;
  charges?: Maybe<Scalars['Float']['output']>;
  commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  commercial_surface?: Maybe<Scalars['Float']['output']>;
  commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  consumption?: Maybe<Scalars['Int']['output']>;
  cooling?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  ctn?: Maybe<Scalars['String']['output']>;
  distance_to_airport?: Maybe<Scalars['Float']['output']>;
  distance_to_city_center?: Maybe<Scalars['Float']['output']>;
  distance_to_grocery_shop?: Maybe<Scalars['Float']['output']>;
  distance_to_high_school?: Maybe<Scalars['Float']['output']>;
  distance_to_hospital?: Maybe<Scalars['Float']['output']>;
  distance_to_kindergarten?: Maybe<Scalars['Float']['output']>;
  distance_to_motorway?: Maybe<Scalars['Float']['output']>;
  distance_to_primary_school?: Maybe<Scalars['Float']['output']>;
  distance_to_public_transport?: Maybe<Scalars['Float']['output']>;
  distance_to_sports_center?: Maybe<Scalars['Float']['output']>;
  distance_to_train_station?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  emissions?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_consumption_class?: Maybe<Scalars['String']['output']>;
  energy_inspection_date?: Maybe<Scalars['date']['output']>;
  energy_reference_year?: Maybe<Scalars['Int']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Int']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Int']['output']>;
  flat_condition?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gas_emissions_class?: Maybe<Scalars['String']['output']>;
  geom?: Maybe<Scalars['geometry']['output']>;
  gross_floor_surface?: Maybe<Scalars['Float']['output']>;
  has_attic?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_gym?: Maybe<Scalars['Boolean']['output']>;
  has_photovoltaic_panels?: Maybe<Scalars['Boolean']['output']>;
  has_sauna?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_wellness_area?: Maybe<Scalars['Boolean']['output']>;
  heating?: Maybe<Scalars['String']['output']>;
  heating_distribution?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  income_includes_parking?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_commercial_fully_rented?: Maybe<Scalars['Boolean']['output']>;
  is_luxury?: Maybe<Scalars['Boolean']['output']>;
  is_maisonette?: Maybe<Scalars['Boolean']['output']>;
  is_parking_fully_rented?: Maybe<Scalars['Boolean']['output']>;
  is_rental?: Maybe<Scalars['Boolean']['output']>;
  is_residential_fully_rented?: Maybe<Scalars['Boolean']['output']>;
  is_secondary_residence?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  macro_location?: Maybe<Scalars['Float']['output']>;
  micro_location?: Maybe<Scalars['Float']['output']>;
  minergie_code?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  mls_lots?: Maybe<Mls_Lots>;
  monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_commercial_units?: Maybe<Scalars['Int']['output']>;
  number_of_flats?: Maybe<Scalars['Int']['output']>;
  number_of_floors?: Maybe<Scalars['Int']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_lifts?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_residential_units?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Int']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  ownership_form?: Maybe<Scalars['String']['output']>;
  parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  perceived_value?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "mls_property_places" */
  places?: Maybe<Array<Places>>;
  plot_has_constructible_reserve?: Maybe<Scalars['Boolean']['output']>;
  plot_is_constructible?: Maybe<Scalars['Boolean']['output']>;
  plot_number?: Maybe<Scalars['String']['output']>;
  plot_registry_number?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  property_images: Array<Property_Images>;
  /** An aggregate relationship */
  property_images_aggregate: Property_Images_Aggregate;
  /** An object relationship */
  property_type?: Maybe<Property_Types>;
  property_type_id?: Maybe<Scalars['uuid']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  relevant_servitudes?: Maybe<Scalars['Boolean']['output']>;
  renovation_fund?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  residential_surface?: Maybe<Scalars['Float']['output']>;
  residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  share_of_ownership?: Maybe<Scalars['Float']['output']>;
  side?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  weighted_floor_surface?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "mls_properties" */
export type Mls_PropertiesPlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


/** columns and relationships of "mls_properties" */
export type Mls_PropertiesProperty_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Property_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Images_Order_By>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};


/** columns and relationships of "mls_properties" */
export type Mls_PropertiesProperty_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Images_Order_By>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "mls_properties". All fields are combined with a logical 'AND'. */
export type Mls_Properties_Bool_Exp = {
  _and?: InputMaybe<Array<Mls_Properties_Bool_Exp>>;
  _not?: InputMaybe<Mls_Properties_Bool_Exp>;
  _or?: InputMaybe<Array<Mls_Properties_Bool_Exp>>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  basement_surface?: InputMaybe<Float_Comparison_Exp>;
  building_condition?: InputMaybe<Float_Comparison_Exp>;
  building_standard?: InputMaybe<Float_Comparison_Exp>;
  building_volume?: InputMaybe<Float_Comparison_Exp>;
  building_volume_norm?: InputMaybe<String_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  ceiling_height?: InputMaybe<Float_Comparison_Exp>;
  charges?: InputMaybe<Float_Comparison_Exp>;
  commercial_potential_rental_income?: InputMaybe<Float_Comparison_Exp>;
  commercial_surface?: InputMaybe<Float_Comparison_Exp>;
  commercial_yearly_rental_income?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  consumption?: InputMaybe<Int_Comparison_Exp>;
  cooling?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  country_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ctn?: InputMaybe<String_Comparison_Exp>;
  distance_to_airport?: InputMaybe<Float_Comparison_Exp>;
  distance_to_city_center?: InputMaybe<Float_Comparison_Exp>;
  distance_to_grocery_shop?: InputMaybe<Float_Comparison_Exp>;
  distance_to_high_school?: InputMaybe<Float_Comparison_Exp>;
  distance_to_hospital?: InputMaybe<Float_Comparison_Exp>;
  distance_to_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  distance_to_motorway?: InputMaybe<Float_Comparison_Exp>;
  distance_to_primary_school?: InputMaybe<Float_Comparison_Exp>;
  distance_to_public_transport?: InputMaybe<Float_Comparison_Exp>;
  distance_to_sports_center?: InputMaybe<Float_Comparison_Exp>;
  distance_to_train_station?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  emissions?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_consumption_class?: InputMaybe<String_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Date_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Int_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Int_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Int_Comparison_Exp>;
  flat_condition?: InputMaybe<Float_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  gas_emissions_class?: InputMaybe<String_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  gross_floor_surface?: InputMaybe<Float_Comparison_Exp>;
  has_attic?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_gym?: InputMaybe<Boolean_Comparison_Exp>;
  has_photovoltaic_panels?: InputMaybe<Boolean_Comparison_Exp>;
  has_sauna?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_wellness_area?: InputMaybe<Boolean_Comparison_Exp>;
  heating?: InputMaybe<String_Comparison_Exp>;
  heating_distribution?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  income_includes_parking?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_commercial_fully_rented?: InputMaybe<Boolean_Comparison_Exp>;
  is_luxury?: InputMaybe<Boolean_Comparison_Exp>;
  is_maisonette?: InputMaybe<Boolean_Comparison_Exp>;
  is_parking_fully_rented?: InputMaybe<Boolean_Comparison_Exp>;
  is_rental?: InputMaybe<Boolean_Comparison_Exp>;
  is_residential_fully_rented?: InputMaybe<Boolean_Comparison_Exp>;
  is_secondary_residence?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  macro_location?: InputMaybe<Float_Comparison_Exp>;
  micro_location?: InputMaybe<Float_Comparison_Exp>;
  minergie_code?: InputMaybe<Int_Comparison_Exp>;
  mls_lots?: InputMaybe<Mls_Lots_Bool_Exp>;
  monthly_gross_rent?: InputMaybe<Float_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_commercial_units?: InputMaybe<Int_Comparison_Exp>;
  number_of_flats?: InputMaybe<Int_Comparison_Exp>;
  number_of_floors?: InputMaybe<Int_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_lifts?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_residential_units?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Int_Comparison_Exp>;
  orientation?: InputMaybe<String_Comparison_Exp>;
  ownership_form?: InputMaybe<String_Comparison_Exp>;
  parking_potential_rental_income?: InputMaybe<Float_Comparison_Exp>;
  parking_yearly_rental_income?: InputMaybe<Float_Comparison_Exp>;
  perceived_value?: InputMaybe<Float_Comparison_Exp>;
  places?: InputMaybe<Places_Bool_Exp>;
  plot_has_constructible_reserve?: InputMaybe<Boolean_Comparison_Exp>;
  plot_is_constructible?: InputMaybe<Boolean_Comparison_Exp>;
  plot_number?: InputMaybe<String_Comparison_Exp>;
  plot_registry_number?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_images?: InputMaybe<Property_Images_Bool_Exp>;
  property_images_aggregate?: InputMaybe<Property_Images_Aggregate_Bool_Exp>;
  property_type?: InputMaybe<Property_Types_Bool_Exp>;
  property_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  relevant_servitudes?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_fund?: InputMaybe<Float_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  residential_potential_rental_income?: InputMaybe<Float_Comparison_Exp>;
  residential_surface?: InputMaybe<Float_Comparison_Exp>;
  residential_yearly_rental_income?: InputMaybe<Float_Comparison_Exp>;
  share_of_ownership?: InputMaybe<Float_Comparison_Exp>;
  side?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  weighted_floor_surface?: InputMaybe<Float_Comparison_Exp>;
};

/** Ordering options when selecting data from "mls_properties". */
export type Mls_Properties_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  building_volume_norm?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  cooling?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  ctn?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_consumption_class?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gas_emissions_class?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  has_attic?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_gym?: InputMaybe<Order_By>;
  has_photovoltaic_panels?: InputMaybe<Order_By>;
  has_sauna?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_wellness_area?: InputMaybe<Order_By>;
  heating?: InputMaybe<Order_By>;
  heating_distribution?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  income_includes_parking?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_commercial_fully_rented?: InputMaybe<Order_By>;
  is_luxury?: InputMaybe<Order_By>;
  is_maisonette?: InputMaybe<Order_By>;
  is_parking_fully_rented?: InputMaybe<Order_By>;
  is_rental?: InputMaybe<Order_By>;
  is_residential_fully_rented?: InputMaybe<Order_By>;
  is_secondary_residence?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  mls_lots?: InputMaybe<Mls_Lots_Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  orientation?: InputMaybe<Order_By>;
  ownership_form?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Places_Aggregate_Order_By>;
  plot_has_constructible_reserve?: InputMaybe<Order_By>;
  plot_is_constructible?: InputMaybe<Order_By>;
  plot_number?: InputMaybe<Order_By>;
  plot_registry_number?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  property_images_aggregate?: InputMaybe<Property_Images_Aggregate_Order_By>;
  property_type?: InputMaybe<Property_Types_Order_By>;
  property_type_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  relevant_servitudes?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  side?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** select columns of table "mls_properties" */
export enum Mls_Properties_Select_Column {
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BasementSurface = 'basement_surface',
  /** column name */
  BuildingCondition = 'building_condition',
  /** column name */
  BuildingStandard = 'building_standard',
  /** column name */
  BuildingVolume = 'building_volume',
  /** column name */
  BuildingVolumeNorm = 'building_volume_norm',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CeilingHeight = 'ceiling_height',
  /** column name */
  Charges = 'charges',
  /** column name */
  CommercialPotentialRentalIncome = 'commercial_potential_rental_income',
  /** column name */
  CommercialSurface = 'commercial_surface',
  /** column name */
  CommercialYearlyRentalIncome = 'commercial_yearly_rental_income',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  Consumption = 'consumption',
  /** column name */
  Cooling = 'cooling',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Ctn = 'ctn',
  /** column name */
  DistanceToAirport = 'distance_to_airport',
  /** column name */
  DistanceToCityCenter = 'distance_to_city_center',
  /** column name */
  DistanceToGroceryShop = 'distance_to_grocery_shop',
  /** column name */
  DistanceToHighSchool = 'distance_to_high_school',
  /** column name */
  DistanceToHospital = 'distance_to_hospital',
  /** column name */
  DistanceToKindergarten = 'distance_to_kindergarten',
  /** column name */
  DistanceToMotorway = 'distance_to_motorway',
  /** column name */
  DistanceToPrimarySchool = 'distance_to_primary_school',
  /** column name */
  DistanceToPublicTransport = 'distance_to_public_transport',
  /** column name */
  DistanceToSportsCenter = 'distance_to_sports_center',
  /** column name */
  DistanceToTrainStation = 'distance_to_train_station',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Emissions = 'emissions',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyConsumptionClass = 'energy_consumption_class',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FlatCondition = 'flat_condition',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  GasEmissionsClass = 'gas_emissions_class',
  /** column name */
  Geom = 'geom',
  /** column name */
  GrossFloorSurface = 'gross_floor_surface',
  /** column name */
  HasAttic = 'has_attic',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGym = 'has_gym',
  /** column name */
  HasPhotovoltaicPanels = 'has_photovoltaic_panels',
  /** column name */
  HasSauna = 'has_sauna',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasWellnessArea = 'has_wellness_area',
  /** column name */
  Heating = 'heating',
  /** column name */
  HeatingDistribution = 'heating_distribution',
  /** column name */
  Id = 'id',
  /** column name */
  IncomeIncludesParking = 'income_includes_parking',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsCommercialFullyRented = 'is_commercial_fully_rented',
  /** column name */
  IsLuxury = 'is_luxury',
  /** column name */
  IsMaisonette = 'is_maisonette',
  /** column name */
  IsParkingFullyRented = 'is_parking_fully_rented',
  /** column name */
  IsRental = 'is_rental',
  /** column name */
  IsResidentialFullyRented = 'is_residential_fully_rented',
  /** column name */
  IsSecondaryResidence = 'is_secondary_residence',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MacroLocation = 'macro_location',
  /** column name */
  MicroLocation = 'micro_location',
  /** column name */
  MinergieCode = 'minergie_code',
  /** column name */
  MonthlyGrossRent = 'monthly_gross_rent',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfCommercialUnits = 'number_of_commercial_units',
  /** column name */
  NumberOfFlats = 'number_of_flats',
  /** column name */
  NumberOfFloors = 'number_of_floors',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLifts = 'number_of_lifts',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfResidentialUnits = 'number_of_residential_units',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  Orientation = 'orientation',
  /** column name */
  OwnershipForm = 'ownership_form',
  /** column name */
  ParkingPotentialRentalIncome = 'parking_potential_rental_income',
  /** column name */
  ParkingYearlyRentalIncome = 'parking_yearly_rental_income',
  /** column name */
  PerceivedValue = 'perceived_value',
  /** column name */
  PlotHasConstructibleReserve = 'plot_has_constructible_reserve',
  /** column name */
  PlotIsConstructible = 'plot_is_constructible',
  /** column name */
  PlotNumber = 'plot_number',
  /** column name */
  PlotRegistryNumber = 'plot_registry_number',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PropertyTypeId = 'property_type_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  RelevantServitudes = 'relevant_servitudes',
  /** column name */
  RenovationFund = 'renovation_fund',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  ResidentialPotentialRentalIncome = 'residential_potential_rental_income',
  /** column name */
  ResidentialSurface = 'residential_surface',
  /** column name */
  ResidentialYearlyRentalIncome = 'residential_yearly_rental_income',
  /** column name */
  ShareOfOwnership = 'share_of_ownership',
  /** column name */
  Side = 'side',
  /** column name */
  State = 'state',
  /** column name */
  StateId = 'state_id',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  WeightedFloorSurface = 'weighted_floor_surface'
}

/** Streaming cursor of the table "mls_properties" */
export type Mls_Properties_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mls_Properties_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mls_Properties_Stream_Cursor_Value_Input = {
  balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  basement_surface?: InputMaybe<Scalars['Float']['input']>;
  building_condition?: InputMaybe<Scalars['Float']['input']>;
  building_standard?: InputMaybe<Scalars['Float']['input']>;
  building_volume?: InputMaybe<Scalars['Float']['input']>;
  building_volume_norm?: InputMaybe<Scalars['String']['input']>;
  built_surface?: InputMaybe<Scalars['Float']['input']>;
  ceiling_height?: InputMaybe<Scalars['Float']['input']>;
  charges?: InputMaybe<Scalars['Float']['input']>;
  commercial_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  commercial_surface?: InputMaybe<Scalars['Float']['input']>;
  commercial_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  consumption?: InputMaybe<Scalars['Int']['input']>;
  cooling?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  distance_to_airport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_city_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_grocery_shop?: InputMaybe<Scalars['Float']['input']>;
  distance_to_high_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_hospital?: InputMaybe<Scalars['Float']['input']>;
  distance_to_kindergarten?: InputMaybe<Scalars['Float']['input']>;
  distance_to_motorway?: InputMaybe<Scalars['Float']['input']>;
  distance_to_primary_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_public_transport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_sports_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_train_station?: InputMaybe<Scalars['Float']['input']>;
  district_id?: InputMaybe<Scalars['uuid']['input']>;
  emissions?: InputMaybe<Scalars['Int']['input']>;
  energy_certificate_version?: InputMaybe<Scalars['String']['input']>;
  energy_consumption_class?: InputMaybe<Scalars['String']['input']>;
  energy_inspection_date?: InputMaybe<Scalars['date']['input']>;
  energy_reference_year?: InputMaybe<Scalars['Int']['input']>;
  estimated_higher_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  estimated_lower_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  flat_condition?: InputMaybe<Scalars['Float']['input']>;
  floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  garden_surface?: InputMaybe<Scalars['Float']['input']>;
  gas_emissions_class?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  gross_floor_surface?: InputMaybe<Scalars['Float']['input']>;
  has_attic?: InputMaybe<Scalars['Boolean']['input']>;
  has_cellar?: InputMaybe<Scalars['Boolean']['input']>;
  has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_gym?: InputMaybe<Scalars['Boolean']['input']>;
  has_photovoltaic_panels?: InputMaybe<Scalars['Boolean']['input']>;
  has_sauna?: InputMaybe<Scalars['Boolean']['input']>;
  has_storage_room?: InputMaybe<Scalars['Boolean']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  has_wellness_area?: InputMaybe<Scalars['Boolean']['input']>;
  heating?: InputMaybe<Scalars['String']['input']>;
  heating_distribution?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  income_includes_parking?: InputMaybe<Scalars['Boolean']['input']>;
  is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_commercial_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_luxury?: InputMaybe<Scalars['Boolean']['input']>;
  is_maisonette?: InputMaybe<Scalars['Boolean']['input']>;
  is_parking_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_rental?: InputMaybe<Scalars['Boolean']['input']>;
  is_residential_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_secondary_residence?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface?: InputMaybe<Scalars['Float']['input']>;
  living_surface?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  macro_location?: InputMaybe<Scalars['Float']['input']>;
  micro_location?: InputMaybe<Scalars['Float']['input']>;
  minergie_code?: InputMaybe<Scalars['Int']['input']>;
  monthly_gross_rent?: InputMaybe<Scalars['Float']['input']>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_commercial_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_flats?: InputMaybe<Scalars['Int']['input']>;
  number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_lifts?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_residential_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  number_of_toilets?: InputMaybe<Scalars['Int']['input']>;
  orientation?: InputMaybe<Scalars['String']['input']>;
  ownership_form?: InputMaybe<Scalars['String']['input']>;
  parking_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  parking_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  perceived_value?: InputMaybe<Scalars['Float']['input']>;
  plot_has_constructible_reserve?: InputMaybe<Scalars['Boolean']['input']>;
  plot_is_constructible?: InputMaybe<Scalars['Boolean']['input']>;
  plot_number?: InputMaybe<Scalars['String']['input']>;
  plot_registry_number?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_id?: InputMaybe<Scalars['uuid']['input']>;
  property_type_id?: InputMaybe<Scalars['uuid']['input']>;
  region_id?: InputMaybe<Scalars['uuid']['input']>;
  relevant_servitudes?: InputMaybe<Scalars['Boolean']['input']>;
  renovation_fund?: InputMaybe<Scalars['Float']['input']>;
  renovation_year?: InputMaybe<Scalars['Int']['input']>;
  residential_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  residential_surface?: InputMaybe<Scalars['Float']['input']>;
  residential_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  share_of_ownership?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  sub_locality?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  terrace_surface?: InputMaybe<Scalars['Float']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  usable_surface?: InputMaybe<Scalars['Float']['input']>;
  weighted_floor_surface?: InputMaybe<Scalars['Float']['input']>;
};

/** Boolean expression to compare columns of type "mortgage_interest_rate_type". All fields are combined with logical 'AND'. */
export type Mortgage_Interest_Rate_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  _gt?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  _gte?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  _in?: InputMaybe<Array<Scalars['mortgage_interest_rate_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  _lte?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  _neq?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['mortgage_interest_rate_type']['input']>>;
};

/** Boolean expression to compare columns of type "mortgage_lender_type". All fields are combined with logical 'AND'. */
export type Mortgage_Lender_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  _gt?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  _gte?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  _in?: InputMaybe<Array<Scalars['mortgage_lender_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  _lte?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  _neq?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['mortgage_lender_type']['input']>>;
};

/** mutation root */
export type Mutation_Root = {
  auto_search_pois: Scalars['Boolean']['output'];
  change_buyer_leads_stage?: Maybe<ChangeBuyerLeadsStageOutput>;
  /** create_buyer_lead */
  create_buyer_lead?: Maybe<CreateBuyerLeadOutput>;
  /** create_buyer_leads_many */
  create_buyer_leads_many?: Maybe<Array<CreateBuyerLeadsManyOutput>>;
  create_key?: Maybe<ApiKey>;
  /** delete data from the table: "buyer_leads" */
  delete_buyer_leads?: Maybe<Buyer_Leads_Mutation_Response>;
  /** delete single row from the table: "buyer_leads" */
  delete_buyer_leads_by_pk?: Maybe<Buyer_Leads>;
  /** delete data from the table: "catchment_areas" */
  delete_catchment_areas?: Maybe<Catchment_Areas_Mutation_Response>;
  /** delete data from the table: "cma_report_files" */
  delete_cma_report_files?: Maybe<Cma_Report_Files_Mutation_Response>;
  /** delete data from the table: "cma_reports" */
  delete_cma_reports?: Maybe<Cma_Reports_Mutation_Response>;
  /** delete single row from the table: "cma_reports" */
  delete_cma_reports_by_pk?: Maybe<Cma_Reports>;
  /** delete data from the table: "cma_reports_comparables" */
  delete_cma_reports_comparables?: Maybe<Cma_Reports_Comparables_Mutation_Response>;
  /** delete data from the table: "commissions" */
  delete_commissions?: Maybe<Commissions_Mutation_Response>;
  /** delete single row from the table: "commissions" */
  delete_commissions_by_pk?: Maybe<Commissions>;
  /** delete data from the table: "dictionaries" */
  delete_dictionaries?: Maybe<Dictionaries_Mutation_Response>;
  /** delete single row from the table: "dictionaries" */
  delete_dictionaries_by_pk?: Maybe<Dictionaries>;
  /** delete data from the table: "doc_templates" */
  delete_doc_templates?: Maybe<Doc_Templates_Mutation_Response>;
  /** delete single row from the table: "doc_templates" */
  delete_doc_templates_by_pk?: Maybe<Doc_Templates>;
  /** delete data from the table: "doc_templates_tenants" */
  delete_doc_templates_tenants?: Maybe<Doc_Templates_Tenants_Mutation_Response>;
  /** delete single row from the table: "doc_templates_tenants" */
  delete_doc_templates_tenants_by_pk?: Maybe<Doc_Templates_Tenants>;
  /** delete data from the table: "email_sequences" */
  delete_email_sequences?: Maybe<Email_Sequences_Mutation_Response>;
  /** delete single row from the table: "email_sequences" */
  delete_email_sequences_by_pk?: Maybe<Email_Sequences>;
  /** delete data from the table: "email_sequences_recipients" */
  delete_email_sequences_recipients?: Maybe<Email_Sequences_Recipients_Mutation_Response>;
  /** delete single row from the table: "email_sequences_recipients" */
  delete_email_sequences_recipients_by_pk?: Maybe<Email_Sequences_Recipients>;
  /** delete data from the table: "email_sequences_steps" */
  delete_email_sequences_steps?: Maybe<Email_Sequences_Steps_Mutation_Response>;
  /** delete single row from the table: "email_sequences_steps" */
  delete_email_sequences_steps_by_pk?: Maybe<Email_Sequences_Steps>;
  /** delete data from the table: "email_templates_files" */
  delete_email_templates_files?: Maybe<Email_Templates_Files_Mutation_Response>;
  /** delete single row from the table: "email_templates_files" */
  delete_email_templates_files_by_pk?: Maybe<Email_Templates_Files>;
  /** delete data from the table: "emails" */
  delete_emails?: Maybe<Emails_Mutation_Response>;
  /** delete single row from the table: "emails" */
  delete_emails_by_pk?: Maybe<Emails>;
  /** delete data from the table: "enquiries" */
  delete_enquiries?: Maybe<Enquiries_Mutation_Response>;
  /** delete single row from the table: "enquiries" */
  delete_enquiries_by_pk?: Maybe<Enquiries>;
  /** delete data from the table: "files" */
  delete_files?: Maybe<Files_Mutation_Response>;
  /** delete single row from the table: "files" */
  delete_files_by_pk?: Maybe<Files>;
  /** delete data from the table: "google_reviews" */
  delete_google_reviews?: Maybe<Google_Reviews_Mutation_Response>;
  /** delete single row from the table: "google_reviews" */
  delete_google_reviews_by_pk?: Maybe<Google_Reviews>;
  delete_key?: Maybe<DeleteKeyResponse>;
  /** delete data from the table: "lead_agents" */
  delete_lead_agents?: Maybe<Lead_Agents_Mutation_Response>;
  /** delete single row from the table: "lead_agents" */
  delete_lead_agents_by_pk?: Maybe<Lead_Agents>;
  /** delete data from the table: "lead_debts" */
  delete_lead_debts?: Maybe<Lead_Debts_Mutation_Response>;
  /** delete data from the table: "lead_stages" */
  delete_lead_stages?: Maybe<Lead_Stages_Mutation_Response>;
  /** delete single row from the table: "lead_stages" */
  delete_lead_stages_by_pk?: Maybe<Lead_Stages>;
  /** delete data from the table: "leads_tags" */
  delete_leads_tags?: Maybe<Leads_Tags_Mutation_Response>;
  /** delete single row from the table: "leads_tags" */
  delete_leads_tags_by_pk?: Maybe<Leads_Tags>;
  /** delete data from the table: "lot_sellers" */
  delete_lot_sellers?: Maybe<Lot_Sellers_Mutation_Response>;
  /** delete data from the table: "lots" */
  delete_lots?: Maybe<Lots_Mutation_Response>;
  /** delete single row from the table: "lots" */
  delete_lots_by_pk?: Maybe<Lots>;
  /** delete data from the table: "offers" */
  delete_offers?: Maybe<Offers_Mutation_Response>;
  /** delete single row from the table: "offers" */
  delete_offers_by_pk?: Maybe<Offers>;
  /** delete data from the table: "organisations" */
  delete_organisations?: Maybe<Organisations_Mutation_Response>;
  /** delete single row from the table: "organisations" */
  delete_organisations_by_pk?: Maybe<Organisations>;
  /** delete data from the table: "phone_numbers" */
  delete_phone_numbers?: Maybe<Phone_Numbers_Mutation_Response>;
  /** delete single row from the table: "phone_numbers" */
  delete_phone_numbers_by_pk?: Maybe<Phone_Numbers>;
  /** delete data from the table: "pipelines" */
  delete_pipelines?: Maybe<Pipelines_Mutation_Response>;
  /** delete single row from the table: "pipelines" */
  delete_pipelines_by_pk?: Maybe<Pipelines>;
  /** delete data from the table: "portals" */
  delete_portals?: Maybe<Portals_Mutation_Response>;
  /** delete single row from the table: "portals" */
  delete_portals_by_pk?: Maybe<Portals>;
  /** delete data from the table: "property_files" */
  delete_property_files?: Maybe<Property_Files_Mutation_Response>;
  /** delete data from the table: "property_images" */
  delete_property_images?: Maybe<Property_Images_Mutation_Response>;
  /** delete single row from the table: "property_images" */
  delete_property_images_by_pk?: Maybe<Property_Images>;
  /** delete data from the table: "property_pois" */
  delete_property_pois?: Maybe<Property_Pois_Mutation_Response>;
  /** delete single row from the table: "property_pois" */
  delete_property_pois_by_pk?: Maybe<Property_Pois>;
  /** delete data from the table: "property_searches" */
  delete_property_searches?: Maybe<Property_Searches_Mutation_Response>;
  /** delete single row from the table: "property_searches" */
  delete_property_searches_by_pk?: Maybe<Property_Searches>;
  /** delete data from the table: "property_transactions" */
  delete_property_transactions?: Maybe<Property_Transactions_Mutation_Response>;
  /** delete single row from the table: "property_transactions" */
  delete_property_transactions_by_pk?: Maybe<Property_Transactions>;
  /** delete data from the table: "property_transactions_listings" */
  delete_property_transactions_listings?: Maybe<Property_Transactions_Listings_Mutation_Response>;
  /** delete single row from the table: "property_transactions_listings" */
  delete_property_transactions_listings_by_pk?: Maybe<Property_Transactions_Listings>;
  /** delete data from the table: "push_notification_tokens" */
  delete_push_notification_tokens?: Maybe<Push_Notification_Tokens_Mutation_Response>;
  /** delete single row from the table: "push_notification_tokens" */
  delete_push_notification_tokens_by_pk?: Maybe<Push_Notification_Tokens>;
  /** delete data from the table: "reviews" */
  delete_reviews?: Maybe<Reviews_Mutation_Response>;
  /** delete single row from the table: "reviews" */
  delete_reviews_by_pk?: Maybe<Reviews>;
  /** delete data from the table: "smart_lists" */
  delete_smart_lists?: Maybe<Smart_Lists_Mutation_Response>;
  /** delete single row from the table: "smart_lists" */
  delete_smart_lists_by_pk?: Maybe<Smart_Lists>;
  /** delete data from the table: "team_images" */
  delete_team_images?: Maybe<Team_Images_Mutation_Response>;
  /** delete single row from the table: "team_images" */
  delete_team_images_by_pk?: Maybe<Team_Images>;
  /** delete data from the table: "teams" */
  delete_teams?: Maybe<Teams_Mutation_Response>;
  /** delete single row from the table: "teams" */
  delete_teams_by_pk?: Maybe<Teams>;
  /** delete data from the table: "teams_portals" */
  delete_teams_portals?: Maybe<Teams_Portals_Mutation_Response>;
  /** delete single row from the table: "teams_portals" */
  delete_teams_portals_by_pk?: Maybe<Teams_Portals>;
  /** delete data from the table: "teams_users" */
  delete_teams_users?: Maybe<Teams_Users_Mutation_Response>;
  /** delete data from the table: "transaction_buyers" */
  delete_transaction_buyers?: Maybe<Transaction_Buyers_Mutation_Response>;
  /** delete data from the table: "transaction_sellers" */
  delete_transaction_sellers?: Maybe<Transaction_Sellers_Mutation_Response>;
  /** delete data from the table: "user_images" */
  delete_user_images?: Maybe<User_Images_Mutation_Response>;
  /** delete single row from the table: "user_images" */
  delete_user_images_by_pk?: Maybe<User_Images>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "users_listings" */
  delete_users_listings?: Maybe<Users_Listings_Mutation_Response>;
  /** delete single row from the table: "users_listings" */
  delete_users_listings_by_pk?: Maybe<Users_Listings>;
  /** Import lots */
  import_lots?: Maybe<Array<LotImportOutput>>;
  /** Import property searches */
  import_property_searches?: Maybe<Array<PropertySearchImportOutput>>;
  /** insert data into the table: "activities" */
  insert_activities?: Maybe<Activities_Mutation_Response>;
  /** insert a single row into the table: "activities" */
  insert_activities_one?: Maybe<Activities>;
  /** insert data into the table: "activities_target_users" */
  insert_activities_target_users?: Maybe<Activities_Target_Users_Mutation_Response>;
  /** insert a single row into the table: "activities_target_users" */
  insert_activities_target_users_one?: Maybe<Activities_Target_Users>;
  /** insert data into the table: "buyer_leads" */
  insert_buyer_leads?: Maybe<Buyer_Leads_Mutation_Response>;
  /** insert a single row into the table: "buyer_leads" */
  insert_buyer_leads_one?: Maybe<Buyer_Leads>;
  /** insert data into the table: "catchment_areas" */
  insert_catchment_areas?: Maybe<Catchment_Areas_Mutation_Response>;
  /** insert a single row into the table: "catchment_areas" */
  insert_catchment_areas_one?: Maybe<Catchment_Areas>;
  /** insert data into the table: "cma_report_files" */
  insert_cma_report_files?: Maybe<Cma_Report_Files_Mutation_Response>;
  /** insert a single row into the table: "cma_report_files" */
  insert_cma_report_files_one?: Maybe<Cma_Report_Files>;
  /** insert data into the table: "cma_reports" */
  insert_cma_reports?: Maybe<Cma_Reports_Mutation_Response>;
  /** insert data into the table: "cma_reports_comparables" */
  insert_cma_reports_comparables?: Maybe<Cma_Reports_Comparables_Mutation_Response>;
  /** insert a single row into the table: "cma_reports_comparables" */
  insert_cma_reports_comparables_one?: Maybe<Cma_Reports_Comparables>;
  /** insert a single row into the table: "cma_reports" */
  insert_cma_reports_one?: Maybe<Cma_Reports>;
  /** insert data into the table: "commissions" */
  insert_commissions?: Maybe<Commissions_Mutation_Response>;
  /** insert a single row into the table: "commissions" */
  insert_commissions_one?: Maybe<Commissions>;
  /** insert data into the table: "dictionaries" */
  insert_dictionaries?: Maybe<Dictionaries_Mutation_Response>;
  /** insert a single row into the table: "dictionaries" */
  insert_dictionaries_one?: Maybe<Dictionaries>;
  /** insert data into the table: "doc_templates" */
  insert_doc_templates?: Maybe<Doc_Templates_Mutation_Response>;
  /** insert a single row into the table: "doc_templates" */
  insert_doc_templates_one?: Maybe<Doc_Templates>;
  /** insert data into the table: "doc_templates_tenants" */
  insert_doc_templates_tenants?: Maybe<Doc_Templates_Tenants_Mutation_Response>;
  /** insert a single row into the table: "doc_templates_tenants" */
  insert_doc_templates_tenants_one?: Maybe<Doc_Templates_Tenants>;
  /** insert data into the table: "email_sequences" */
  insert_email_sequences?: Maybe<Email_Sequences_Mutation_Response>;
  /** insert a single row into the table: "email_sequences" */
  insert_email_sequences_one?: Maybe<Email_Sequences>;
  /** insert data into the table: "email_sequences_recipients" */
  insert_email_sequences_recipients?: Maybe<Email_Sequences_Recipients_Mutation_Response>;
  /** insert a single row into the table: "email_sequences_recipients" */
  insert_email_sequences_recipients_one?: Maybe<Email_Sequences_Recipients>;
  /** insert data into the table: "email_sequences_steps" */
  insert_email_sequences_steps?: Maybe<Email_Sequences_Steps_Mutation_Response>;
  /** insert a single row into the table: "email_sequences_steps" */
  insert_email_sequences_steps_one?: Maybe<Email_Sequences_Steps>;
  /** insert data into the table: "email_templates" */
  insert_email_templates?: Maybe<Email_Templates_Mutation_Response>;
  /** insert data into the table: "email_templates_files" */
  insert_email_templates_files?: Maybe<Email_Templates_Files_Mutation_Response>;
  /** insert a single row into the table: "email_templates_files" */
  insert_email_templates_files_one?: Maybe<Email_Templates_Files>;
  /** insert a single row into the table: "email_templates" */
  insert_email_templates_one?: Maybe<Email_Templates>;
  /** insert data into the table: "emails" */
  insert_emails?: Maybe<Emails_Mutation_Response>;
  /** insert a single row into the table: "emails" */
  insert_emails_one?: Maybe<Emails>;
  /** insert data into the table: "files" */
  insert_files?: Maybe<Files_Mutation_Response>;
  /** insert a single row into the table: "files" */
  insert_files_one?: Maybe<Files>;
  /** insert data into the table: "google_addresses" */
  insert_google_addresses?: Maybe<Google_Addresses_Mutation_Response>;
  /** insert a single row into the table: "google_addresses" */
  insert_google_addresses_one?: Maybe<Google_Addresses>;
  /** insert data into the table: "images" */
  insert_images?: Maybe<Images_Mutation_Response>;
  /** insert a single row into the table: "images" */
  insert_images_one?: Maybe<Images>;
  /** insert data into the table: "invitations" */
  insert_invitations?: Maybe<Invitations_Mutation_Response>;
  /** insert a single row into the table: "invitations" */
  insert_invitations_one?: Maybe<Invitations>;
  /** insert data into the table: "lead_agents" */
  insert_lead_agents?: Maybe<Lead_Agents_Mutation_Response>;
  /** insert a single row into the table: "lead_agents" */
  insert_lead_agents_one?: Maybe<Lead_Agents>;
  /** insert data into the table: "lead_stages" */
  insert_lead_stages?: Maybe<Lead_Stages_Mutation_Response>;
  /** insert a single row into the table: "lead_stages" */
  insert_lead_stages_one?: Maybe<Lead_Stages>;
  /** insert data into the table: "leads" */
  insert_leads?: Maybe<Leads_Mutation_Response>;
  /** insert a single row into the table: "leads" */
  insert_leads_one?: Maybe<Leads>;
  /** insert data into the table: "leads_tags" */
  insert_leads_tags?: Maybe<Leads_Tags_Mutation_Response>;
  /** insert a single row into the table: "leads_tags" */
  insert_leads_tags_one?: Maybe<Leads_Tags>;
  /** insert data into the table: "lot_reference_aliases" */
  insert_lot_reference_aliases?: Maybe<Lot_Reference_Aliases_Mutation_Response>;
  /** insert a single row into the table: "lot_reference_aliases" */
  insert_lot_reference_aliases_one?: Maybe<Lot_Reference_Aliases>;
  /** insert data into the table: "lot_sellers" */
  insert_lot_sellers?: Maybe<Lot_Sellers_Mutation_Response>;
  /** insert a single row into the table: "lot_sellers" */
  insert_lot_sellers_one?: Maybe<Lot_Sellers>;
  /** insert data into the table: "lots" */
  insert_lots?: Maybe<Lots_Mutation_Response>;
  insert_lots_derived?: Maybe<InsertListingOutput>;
  /** insert a single row into the table: "lots" */
  insert_lots_one?: Maybe<Lots>;
  /** insert data into the table: "offers" */
  insert_offers?: Maybe<Offers_Mutation_Response>;
  /** insert a single row into the table: "offers" */
  insert_offers_one?: Maybe<Offers>;
  /** insert data into the table: "organisation_images" */
  insert_organisation_images?: Maybe<Organisation_Images_Mutation_Response>;
  /** insert a single row into the table: "organisation_images" */
  insert_organisation_images_one?: Maybe<Organisation_Images>;
  /** insert data into the table: "organisations" */
  insert_organisations?: Maybe<Organisations_Mutation_Response>;
  /** insert a single row into the table: "organisations" */
  insert_organisations_one?: Maybe<Organisations>;
  /** insert data into the table: "phone_number_type_enum" */
  insert_phone_number_type_enum?: Maybe<Phone_Number_Type_Enum_Mutation_Response>;
  /** insert a single row into the table: "phone_number_type_enum" */
  insert_phone_number_type_enum_one?: Maybe<Phone_Number_Type_Enum>;
  /** insert data into the table: "phone_numbers" */
  insert_phone_numbers?: Maybe<Phone_Numbers_Mutation_Response>;
  /** insert a single row into the table: "phone_numbers" */
  insert_phone_numbers_one?: Maybe<Phone_Numbers>;
  /** insert data into the table: "pipelines" */
  insert_pipelines?: Maybe<Pipelines_Mutation_Response>;
  /** insert a single row into the table: "pipelines" */
  insert_pipelines_one?: Maybe<Pipelines>;
  insert_pois_one: Scalars['Boolean']['output'];
  /** insert data into the table: "portals" */
  insert_portals?: Maybe<Portals_Mutation_Response>;
  /** insert a single row into the table: "portals" */
  insert_portals_one?: Maybe<Portals>;
  /** insert data into the table: "properties" */
  insert_properties?: Maybe<Properties_Mutation_Response>;
  /** insert a single row into the table: "properties" */
  insert_properties_one?: Maybe<Properties>;
  /** insert data into the table: "property_files" */
  insert_property_files?: Maybe<Property_Files_Mutation_Response>;
  /** insert a single row into the table: "property_files" */
  insert_property_files_one?: Maybe<Property_Files>;
  /** insert data into the table: "property_images" */
  insert_property_images?: Maybe<Property_Images_Mutation_Response>;
  /** insert a single row into the table: "property_images" */
  insert_property_images_one?: Maybe<Property_Images>;
  /** insert data into the table: "property_searches" */
  insert_property_searches?: Maybe<Property_Searches_Mutation_Response>;
  /** insert a single row into the table: "property_searches" */
  insert_property_searches_one?: Maybe<Property_Searches>;
  /** insert data into the table: "property_searches_places" */
  insert_property_searches_places?: Maybe<Property_Searches_Places_Mutation_Response>;
  /** insert a single row into the table: "property_searches_places" */
  insert_property_searches_places_one?: Maybe<Property_Searches_Places>;
  /** insert data into the table: "property_searches_property_types" */
  insert_property_searches_property_types?: Maybe<Property_Searches_Property_Types_Mutation_Response>;
  /** insert a single row into the table: "property_searches_property_types" */
  insert_property_searches_property_types_one?: Maybe<Property_Searches_Property_Types>;
  /** insert data into the table: "property_transactions" */
  insert_property_transactions?: Maybe<Property_Transactions_Mutation_Response>;
  /** insert data into the table: "property_transactions_listings" */
  insert_property_transactions_listings?: Maybe<Property_Transactions_Listings_Mutation_Response>;
  /** insert a single row into the table: "property_transactions_listings" */
  insert_property_transactions_listings_one?: Maybe<Property_Transactions_Listings>;
  /** insert a single row into the table: "property_transactions" */
  insert_property_transactions_one?: Maybe<Property_Transactions>;
  /** insert data into the table: "push_notification_tokens" */
  insert_push_notification_tokens?: Maybe<Push_Notification_Tokens_Mutation_Response>;
  /** insert a single row into the table: "push_notification_tokens" */
  insert_push_notification_tokens_one?: Maybe<Push_Notification_Tokens>;
  /** insert data into the table: "reviews" */
  insert_reviews?: Maybe<Reviews_Mutation_Response>;
  /** insert a single row into the table: "reviews" */
  insert_reviews_one?: Maybe<Reviews>;
  /** insert data into the table: "smart_lists" */
  insert_smart_lists?: Maybe<Smart_Lists_Mutation_Response>;
  /** insert a single row into the table: "smart_lists" */
  insert_smart_lists_one?: Maybe<Smart_Lists>;
  /** insert data into the table: "team_images" */
  insert_team_images?: Maybe<Team_Images_Mutation_Response>;
  /** insert a single row into the table: "team_images" */
  insert_team_images_one?: Maybe<Team_Images>;
  /** insert data into the table: "teams" */
  insert_teams?: Maybe<Teams_Mutation_Response>;
  /** insert a single row into the table: "teams" */
  insert_teams_one?: Maybe<Teams>;
  /** insert data into the table: "teams_portals" */
  insert_teams_portals?: Maybe<Teams_Portals_Mutation_Response>;
  /** insert a single row into the table: "teams_portals" */
  insert_teams_portals_one?: Maybe<Teams_Portals>;
  /** insert data into the table: "teams_users" */
  insert_teams_users?: Maybe<Teams_Users_Mutation_Response>;
  /** insert a single row into the table: "teams_users" */
  insert_teams_users_one?: Maybe<Teams_Users>;
  /** insert data into the table: "transaction_buyers" */
  insert_transaction_buyers?: Maybe<Transaction_Buyers_Mutation_Response>;
  /** insert a single row into the table: "transaction_buyers" */
  insert_transaction_buyers_one?: Maybe<Transaction_Buyers>;
  /** insert data into the table: "transaction_sellers" */
  insert_transaction_sellers?: Maybe<Transaction_Sellers_Mutation_Response>;
  /** insert a single row into the table: "transaction_sellers" */
  insert_transaction_sellers_one?: Maybe<Transaction_Sellers>;
  /** insert data into the table: "user_images" */
  insert_user_images?: Maybe<User_Images_Mutation_Response>;
  /** insert a single row into the table: "user_images" */
  insert_user_images_one?: Maybe<User_Images>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert data into the table: "users_listings" */
  insert_users_listings?: Maybe<Users_Listings_Mutation_Response>;
  /** insert a single row into the table: "users_listings" */
  insert_users_listings_one?: Maybe<Users_Listings>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  manual_search_pois: Array<Place>;
  order_buyer_lead?: Maybe<OrderBuyerLeadOutput>;
  prepare_upload?: Maybe<PreparedUpload>;
  property_appraisal?: Maybe<PropertyAppraisalOutput>;
  scrape_google_reviews?: Maybe<DataForSeoApiResponse>;
  /** Send a slack notification */
  send_slack_notification?: Maybe<SlackNotificationOutput>;
  /** execute VOLATILE function "set_default_team" which returns "users" */
  set_default_team: Array<Users>;
  start_review?: Maybe<StartReviewResponse>;
  toggle_portal_listing?: Maybe<PortalListing>;
  /** update data of the table: "activities" */
  update_activities?: Maybe<Activities_Mutation_Response>;
  /** update single row of the table: "activities" */
  update_activities_by_pk?: Maybe<Activities>;
  /** update multiples rows of table: "activities" */
  update_activities_many?: Maybe<Array<Maybe<Activities_Mutation_Response>>>;
  /** update data of the table: "buyer_leads" */
  update_buyer_leads?: Maybe<Buyer_Leads_Mutation_Response>;
  /** update single row of the table: "buyer_leads" */
  update_buyer_leads_by_pk?: Maybe<Buyer_Leads>;
  /** update multiples rows of table: "buyer_leads" */
  update_buyer_leads_many?: Maybe<Array<Maybe<Buyer_Leads_Mutation_Response>>>;
  /** update data of the table: "cma_report_files" */
  update_cma_report_files?: Maybe<Cma_Report_Files_Mutation_Response>;
  /** update multiples rows of table: "cma_report_files" */
  update_cma_report_files_many?: Maybe<Array<Maybe<Cma_Report_Files_Mutation_Response>>>;
  /** update data of the table: "cma_reports" */
  update_cma_reports?: Maybe<Cma_Reports_Mutation_Response>;
  /** update single row of the table: "cma_reports" */
  update_cma_reports_by_pk?: Maybe<Cma_Reports>;
  /** update data of the table: "cma_reports_comparables" */
  update_cma_reports_comparables?: Maybe<Cma_Reports_Comparables_Mutation_Response>;
  /** update multiples rows of table: "cma_reports_comparables" */
  update_cma_reports_comparables_many?: Maybe<Array<Maybe<Cma_Reports_Comparables_Mutation_Response>>>;
  /** update multiples rows of table: "cma_reports" */
  update_cma_reports_many?: Maybe<Array<Maybe<Cma_Reports_Mutation_Response>>>;
  /** update data of the table: "commissions" */
  update_commissions?: Maybe<Commissions_Mutation_Response>;
  /** update single row of the table: "commissions" */
  update_commissions_by_pk?: Maybe<Commissions>;
  /** update multiples rows of table: "commissions" */
  update_commissions_many?: Maybe<Array<Maybe<Commissions_Mutation_Response>>>;
  /** update data of the table: "dictionaries" */
  update_dictionaries?: Maybe<Dictionaries_Mutation_Response>;
  /** update single row of the table: "dictionaries" */
  update_dictionaries_by_pk?: Maybe<Dictionaries>;
  /** update multiples rows of table: "dictionaries" */
  update_dictionaries_many?: Maybe<Array<Maybe<Dictionaries_Mutation_Response>>>;
  /** update data of the table: "doc_templates" */
  update_doc_templates?: Maybe<Doc_Templates_Mutation_Response>;
  /** update single row of the table: "doc_templates" */
  update_doc_templates_by_pk?: Maybe<Doc_Templates>;
  /** update multiples rows of table: "doc_templates" */
  update_doc_templates_many?: Maybe<Array<Maybe<Doc_Templates_Mutation_Response>>>;
  /** update data of the table: "doc_templates_tenants" */
  update_doc_templates_tenants?: Maybe<Doc_Templates_Tenants_Mutation_Response>;
  /** update single row of the table: "doc_templates_tenants" */
  update_doc_templates_tenants_by_pk?: Maybe<Doc_Templates_Tenants>;
  /** update multiples rows of table: "doc_templates_tenants" */
  update_doc_templates_tenants_many?: Maybe<Array<Maybe<Doc_Templates_Tenants_Mutation_Response>>>;
  /** update data of the table: "email_sequences" */
  update_email_sequences?: Maybe<Email_Sequences_Mutation_Response>;
  /** update single row of the table: "email_sequences" */
  update_email_sequences_by_pk?: Maybe<Email_Sequences>;
  /** update multiples rows of table: "email_sequences" */
  update_email_sequences_many?: Maybe<Array<Maybe<Email_Sequences_Mutation_Response>>>;
  /** update data of the table: "email_sequences_recipients" */
  update_email_sequences_recipients?: Maybe<Email_Sequences_Recipients_Mutation_Response>;
  /** update single row of the table: "email_sequences_recipients" */
  update_email_sequences_recipients_by_pk?: Maybe<Email_Sequences_Recipients>;
  /** update multiples rows of table: "email_sequences_recipients" */
  update_email_sequences_recipients_many?: Maybe<Array<Maybe<Email_Sequences_Recipients_Mutation_Response>>>;
  /** update data of the table: "email_sequences_steps" */
  update_email_sequences_steps?: Maybe<Email_Sequences_Steps_Mutation_Response>;
  /** update single row of the table: "email_sequences_steps" */
  update_email_sequences_steps_by_pk?: Maybe<Email_Sequences_Steps>;
  /** update multiples rows of table: "email_sequences_steps" */
  update_email_sequences_steps_many?: Maybe<Array<Maybe<Email_Sequences_Steps_Mutation_Response>>>;
  /** update data of the table: "email_templates" */
  update_email_templates?: Maybe<Email_Templates_Mutation_Response>;
  /** update single row of the table: "email_templates" */
  update_email_templates_by_pk?: Maybe<Email_Templates>;
  /** update multiples rows of table: "email_templates" */
  update_email_templates_many?: Maybe<Array<Maybe<Email_Templates_Mutation_Response>>>;
  /** update data of the table: "emails" */
  update_emails?: Maybe<Emails_Mutation_Response>;
  /** update single row of the table: "emails" */
  update_emails_by_pk?: Maybe<Emails>;
  /** update multiples rows of table: "emails" */
  update_emails_many?: Maybe<Array<Maybe<Emails_Mutation_Response>>>;
  /** update data of the table: "enquiries" */
  update_enquiries?: Maybe<Enquiries_Mutation_Response>;
  /** update single row of the table: "enquiries" */
  update_enquiries_by_pk?: Maybe<Enquiries>;
  /** update multiples rows of table: "enquiries" */
  update_enquiries_many?: Maybe<Array<Maybe<Enquiries_Mutation_Response>>>;
  /** update data of the table: "files" */
  update_files?: Maybe<Files_Mutation_Response>;
  /** update single row of the table: "files" */
  update_files_by_pk?: Maybe<Files>;
  /** update multiples rows of table: "files" */
  update_files_many?: Maybe<Array<Maybe<Files_Mutation_Response>>>;
  /** update data of the table: "google_addresses" */
  update_google_addresses?: Maybe<Google_Addresses_Mutation_Response>;
  /** update multiples rows of table: "google_addresses" */
  update_google_addresses_many?: Maybe<Array<Maybe<Google_Addresses_Mutation_Response>>>;
  /** update data of the table: "invitations" */
  update_invitations?: Maybe<Invitations_Mutation_Response>;
  /** update single row of the table: "invitations" */
  update_invitations_by_pk?: Maybe<Invitations>;
  /** update multiples rows of table: "invitations" */
  update_invitations_many?: Maybe<Array<Maybe<Invitations_Mutation_Response>>>;
  /** update_key */
  update_key?: Maybe<ApiKey>;
  /** update data of the table: "lead_agents" */
  update_lead_agents?: Maybe<Lead_Agents_Mutation_Response>;
  /** update single row of the table: "lead_agents" */
  update_lead_agents_by_pk?: Maybe<Lead_Agents>;
  /** update multiples rows of table: "lead_agents" */
  update_lead_agents_many?: Maybe<Array<Maybe<Lead_Agents_Mutation_Response>>>;
  /** update data of the table: "lead_stages" */
  update_lead_stages?: Maybe<Lead_Stages_Mutation_Response>;
  /** update single row of the table: "lead_stages" */
  update_lead_stages_by_pk?: Maybe<Lead_Stages>;
  /** update multiples rows of table: "lead_stages" */
  update_lead_stages_many?: Maybe<Array<Maybe<Lead_Stages_Mutation_Response>>>;
  /** update data of the table: "leads" */
  update_leads?: Maybe<Leads_Mutation_Response>;
  /** update single row of the table: "leads" */
  update_leads_by_pk?: Maybe<Leads>;
  /** update multiples rows of table: "leads" */
  update_leads_many?: Maybe<Array<Maybe<Leads_Mutation_Response>>>;
  /** update data of the table: "lots" */
  update_lots?: Maybe<Lots_Mutation_Response>;
  /** update single row of the table: "lots" */
  update_lots_by_pk?: Maybe<Lots>;
  /** update multiples rows of table: "lots" */
  update_lots_many?: Maybe<Array<Maybe<Lots_Mutation_Response>>>;
  /** update data of the table: "offers" */
  update_offers?: Maybe<Offers_Mutation_Response>;
  /** update single row of the table: "offers" */
  update_offers_by_pk?: Maybe<Offers>;
  /** update multiples rows of table: "offers" */
  update_offers_many?: Maybe<Array<Maybe<Offers_Mutation_Response>>>;
  /** update data of the table: "organisation_images" */
  update_organisation_images?: Maybe<Organisation_Images_Mutation_Response>;
  /** update multiples rows of table: "organisation_images" */
  update_organisation_images_many?: Maybe<Array<Maybe<Organisation_Images_Mutation_Response>>>;
  /** update data of the table: "organisations" */
  update_organisations?: Maybe<Organisations_Mutation_Response>;
  /** update single row of the table: "organisations" */
  update_organisations_by_pk?: Maybe<Organisations>;
  /** update multiples rows of table: "organisations" */
  update_organisations_many?: Maybe<Array<Maybe<Organisations_Mutation_Response>>>;
  /** update data of the table: "phone_numbers" */
  update_phone_numbers?: Maybe<Phone_Numbers_Mutation_Response>;
  /** update single row of the table: "phone_numbers" */
  update_phone_numbers_by_pk?: Maybe<Phone_Numbers>;
  /** update multiples rows of table: "phone_numbers" */
  update_phone_numbers_many?: Maybe<Array<Maybe<Phone_Numbers_Mutation_Response>>>;
  /** update data of the table: "pipelines" */
  update_pipelines?: Maybe<Pipelines_Mutation_Response>;
  /** update single row of the table: "pipelines" */
  update_pipelines_by_pk?: Maybe<Pipelines>;
  /** update multiples rows of table: "pipelines" */
  update_pipelines_many?: Maybe<Array<Maybe<Pipelines_Mutation_Response>>>;
  update_portal_listing?: Maybe<UpdatePortalListing>;
  /** update data of the table: "portals" */
  update_portals?: Maybe<Portals_Mutation_Response>;
  /** update single row of the table: "portals" */
  update_portals_by_pk?: Maybe<Portals>;
  /** update multiples rows of table: "portals" */
  update_portals_many?: Maybe<Array<Maybe<Portals_Mutation_Response>>>;
  /** update data of the table: "properties" */
  update_properties?: Maybe<Properties_Mutation_Response>;
  /** update single row of the table: "properties" */
  update_properties_by_pk?: Maybe<Properties>;
  /** update multiples rows of table: "properties" */
  update_properties_many?: Maybe<Array<Maybe<Properties_Mutation_Response>>>;
  /** update data of the table: "property_files" */
  update_property_files?: Maybe<Property_Files_Mutation_Response>;
  /** update multiples rows of table: "property_files" */
  update_property_files_many?: Maybe<Array<Maybe<Property_Files_Mutation_Response>>>;
  /** update data of the table: "property_images" */
  update_property_images?: Maybe<Property_Images_Mutation_Response>;
  /** update single row of the table: "property_images" */
  update_property_images_by_pk?: Maybe<Property_Images>;
  /** update multiples rows of table: "property_images" */
  update_property_images_many?: Maybe<Array<Maybe<Property_Images_Mutation_Response>>>;
  /** update data of the table: "property_searches" */
  update_property_searches?: Maybe<Property_Searches_Mutation_Response>;
  /** update single row of the table: "property_searches" */
  update_property_searches_by_pk?: Maybe<Property_Searches>;
  /** update multiples rows of table: "property_searches" */
  update_property_searches_many?: Maybe<Array<Maybe<Property_Searches_Mutation_Response>>>;
  /** update data of the table: "property_transactions" */
  update_property_transactions?: Maybe<Property_Transactions_Mutation_Response>;
  /** update single row of the table: "property_transactions" */
  update_property_transactions_by_pk?: Maybe<Property_Transactions>;
  /** update data of the table: "property_transactions_listings" */
  update_property_transactions_listings?: Maybe<Property_Transactions_Listings_Mutation_Response>;
  /** update single row of the table: "property_transactions_listings" */
  update_property_transactions_listings_by_pk?: Maybe<Property_Transactions_Listings>;
  /** update multiples rows of table: "property_transactions_listings" */
  update_property_transactions_listings_many?: Maybe<Array<Maybe<Property_Transactions_Listings_Mutation_Response>>>;
  /** update multiples rows of table: "property_transactions" */
  update_property_transactions_many?: Maybe<Array<Maybe<Property_Transactions_Mutation_Response>>>;
  /** update data of the table: "reviews" */
  update_reviews?: Maybe<Reviews_Mutation_Response>;
  /** update single row of the table: "reviews" */
  update_reviews_by_pk?: Maybe<Reviews>;
  /** update multiples rows of table: "reviews" */
  update_reviews_many?: Maybe<Array<Maybe<Reviews_Mutation_Response>>>;
  /** update data of the table: "smart_lists" */
  update_smart_lists?: Maybe<Smart_Lists_Mutation_Response>;
  /** update single row of the table: "smart_lists" */
  update_smart_lists_by_pk?: Maybe<Smart_Lists>;
  /** update multiples rows of table: "smart_lists" */
  update_smart_lists_many?: Maybe<Array<Maybe<Smart_Lists_Mutation_Response>>>;
  /** update data of the table: "subscriptions" */
  update_subscriptions?: Maybe<Subscriptions_Mutation_Response>;
  /** update single row of the table: "subscriptions" */
  update_subscriptions_by_pk?: Maybe<Subscriptions>;
  /** update multiples rows of table: "subscriptions" */
  update_subscriptions_many?: Maybe<Array<Maybe<Subscriptions_Mutation_Response>>>;
  /** update data of the table: "teams" */
  update_teams?: Maybe<Teams_Mutation_Response>;
  /** update single row of the table: "teams" */
  update_teams_by_pk?: Maybe<Teams>;
  /** update multiples rows of table: "teams" */
  update_teams_many?: Maybe<Array<Maybe<Teams_Mutation_Response>>>;
  /** update data of the table: "teams_portals" */
  update_teams_portals?: Maybe<Teams_Portals_Mutation_Response>;
  /** update single row of the table: "teams_portals" */
  update_teams_portals_by_pk?: Maybe<Teams_Portals>;
  /** update multiples rows of table: "teams_portals" */
  update_teams_portals_many?: Maybe<Array<Maybe<Teams_Portals_Mutation_Response>>>;
  /** update data of the table: "teams_users" */
  update_teams_users?: Maybe<Teams_Users_Mutation_Response>;
  /** update multiples rows of table: "teams_users" */
  update_teams_users_many?: Maybe<Array<Maybe<Teams_Users_Mutation_Response>>>;
  /** update data of the table: "tenants" */
  update_tenants?: Maybe<Tenants_Mutation_Response>;
  /** update single row of the table: "tenants" */
  update_tenants_by_pk?: Maybe<Tenants>;
  /** update multiples rows of table: "tenants" */
  update_tenants_many?: Maybe<Array<Maybe<Tenants_Mutation_Response>>>;
  /** update data of the table: "user_images" */
  update_user_images?: Maybe<User_Images_Mutation_Response>;
  /** update single row of the table: "user_images" */
  update_user_images_by_pk?: Maybe<User_Images>;
  /** update multiples rows of table: "user_images" */
  update_user_images_many?: Maybe<Array<Maybe<User_Images_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update data of the table: "users_listings" */
  update_users_listings?: Maybe<Users_Listings_Mutation_Response>;
  /** update single row of the table: "users_listings" */
  update_users_listings_by_pk?: Maybe<Users_Listings>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  upsert_valuation_link?: Maybe<ValuationLinkOutput>;
  value_property?: Maybe<ValuePropertyOutput>;
};


/** mutation root */
export type Mutation_RootAuto_Search_PoisArgs = {
  property_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootChange_Buyer_Leads_StageArgs = {
  buyerLeadIds: Array<Scalars['uuid']['input']>;
  destinationStageId: Scalars['uuid']['input'];
  lotId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootCreate_Buyer_LeadArgs = {
  destinationStageId: Scalars['uuid']['input'];
  enquiryId?: InputMaybe<Scalars['uuid']['input']>;
  lotId: Scalars['uuid']['input'];
  user?: InputMaybe<CreateBuyerLeadUserInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootCreate_Buyer_Leads_ManyArgs = {
  lotId: Scalars['uuid']['input'];
  source: Scalars['String']['input'];
  userIds: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootCreate_KeyArgs = {
  partnerName: Scalars['String']['input'];
  partnerRole: Scalars['String']['input'];
  partnerTeamsIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** mutation root */
export type Mutation_RootDelete_Buyer_LeadsArgs = {
  where: Buyer_Leads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Buyer_Leads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Catchment_AreasArgs = {
  where: Catchment_Areas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cma_Report_FilesArgs = {
  where: Cma_Report_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cma_ReportsArgs = {
  where: Cma_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cma_Reports_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cma_Reports_ComparablesArgs = {
  where: Cma_Reports_Comparables_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CommissionsArgs = {
  where: Commissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Commissions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DictionariesArgs = {
  where: Dictionaries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dictionaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Doc_TemplatesArgs = {
  where: Doc_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Doc_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Doc_Templates_TenantsArgs = {
  where: Doc_Templates_Tenants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Doc_Templates_Tenants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Email_SequencesArgs = {
  where: Email_Sequences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Sequences_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Email_Sequences_RecipientsArgs = {
  where: Email_Sequences_Recipients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Sequences_Recipients_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Email_Sequences_StepsArgs = {
  where: Email_Sequences_Steps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Sequences_Steps_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Email_Templates_FilesArgs = {
  where: Email_Templates_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Templates_Files_By_PkArgs = {
  email_template_id: Scalars['uuid']['input'];
  file_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EmailsArgs = {
  where: Emails_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Emails_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EnquiriesArgs = {
  where: Enquiries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enquiries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FilesArgs = {
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Files_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Google_ReviewsArgs = {
  where: Google_Reviews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Google_Reviews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_KeyArgs = {
  partnerId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Lead_AgentsArgs = {
  where: Lead_Agents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lead_Agents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Lead_DebtsArgs = {
  where: Lead_Debts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lead_StagesArgs = {
  where: Lead_Stages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lead_Stages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Leads_TagsArgs = {
  where: Leads_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Leads_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Lot_SellersArgs = {
  where: Lot_Sellers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_LotsArgs = {
  where: Lots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OffersArgs = {
  where: Offers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Offers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OrganisationsArgs = {
  where: Organisations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Phone_NumbersArgs = {
  where: Phone_Numbers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Phone_Numbers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PipelinesArgs = {
  where: Pipelines_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pipelines_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PortalsArgs = {
  where: Portals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Portals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_FilesArgs = {
  where: Property_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_ImagesArgs = {
  where: Property_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_PoisArgs = {
  where: Property_Pois_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Pois_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_SearchesArgs = {
  where: Property_Searches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Searches_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_TransactionsArgs = {
  where: Property_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_Transactions_ListingsArgs = {
  where: Property_Transactions_Listings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Transactions_Listings_By_PkArgs = {
  listing_id: Scalars['Int']['input'];
  property_transaction_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Push_Notification_TokensArgs = {
  where: Push_Notification_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Push_Notification_Tokens_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ReviewsArgs = {
  where: Reviews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reviews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Smart_ListsArgs = {
  where: Smart_Lists_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Smart_Lists_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Team_ImagesArgs = {
  where: Team_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Team_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TeamsArgs = {
  where: Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Teams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Teams_PortalsArgs = {
  where: Teams_Portals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Teams_Portals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Teams_UsersArgs = {
  where: Teams_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transaction_BuyersArgs = {
  where: Transaction_Buyers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transaction_SellersArgs = {
  where: Transaction_Sellers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_ImagesArgs = {
  where: User_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Users_ListingsArgs = {
  where: Users_Listings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_Listings_By_PkArgs = {
  created_at: Scalars['timestamptz']['input'];
  merged_listing_id: Scalars['Int']['input'];
  type: Users_Listings_Types_Enum;
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootImport_LotsArgs = {
  objects: Array<LotImportInput>;
};


/** mutation root */
export type Mutation_RootImport_Property_SearchesArgs = {
  objects: Array<PropertySearchImportInput>;
};


/** mutation root */
export type Mutation_RootInsert_ActivitiesArgs = {
  objects: Array<Activities_Insert_Input>;
  on_conflict?: InputMaybe<Activities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activities_OneArgs = {
  object: Activities_Insert_Input;
  on_conflict?: InputMaybe<Activities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activities_Target_UsersArgs = {
  objects: Array<Activities_Target_Users_Insert_Input>;
  on_conflict?: InputMaybe<Activities_Target_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activities_Target_Users_OneArgs = {
  object: Activities_Target_Users_Insert_Input;
  on_conflict?: InputMaybe<Activities_Target_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Buyer_LeadsArgs = {
  objects: Array<Buyer_Leads_Insert_Input>;
  on_conflict?: InputMaybe<Buyer_Leads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Buyer_Leads_OneArgs = {
  object: Buyer_Leads_Insert_Input;
  on_conflict?: InputMaybe<Buyer_Leads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Catchment_AreasArgs = {
  objects: Array<Catchment_Areas_Insert_Input>;
  on_conflict?: InputMaybe<Catchment_Areas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Catchment_Areas_OneArgs = {
  object: Catchment_Areas_Insert_Input;
  on_conflict?: InputMaybe<Catchment_Areas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cma_Report_FilesArgs = {
  objects: Array<Cma_Report_Files_Insert_Input>;
  on_conflict?: InputMaybe<Cma_Report_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cma_Report_Files_OneArgs = {
  object: Cma_Report_Files_Insert_Input;
  on_conflict?: InputMaybe<Cma_Report_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cma_ReportsArgs = {
  objects: Array<Cma_Reports_Insert_Input>;
  on_conflict?: InputMaybe<Cma_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cma_Reports_ComparablesArgs = {
  objects: Array<Cma_Reports_Comparables_Insert_Input>;
  on_conflict?: InputMaybe<Cma_Reports_Comparables_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cma_Reports_Comparables_OneArgs = {
  object: Cma_Reports_Comparables_Insert_Input;
  on_conflict?: InputMaybe<Cma_Reports_Comparables_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cma_Reports_OneArgs = {
  object: Cma_Reports_Insert_Input;
  on_conflict?: InputMaybe<Cma_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CommissionsArgs = {
  objects: Array<Commissions_Insert_Input>;
  on_conflict?: InputMaybe<Commissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Commissions_OneArgs = {
  object: Commissions_Insert_Input;
  on_conflict?: InputMaybe<Commissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DictionariesArgs = {
  objects: Array<Dictionaries_Insert_Input>;
  on_conflict?: InputMaybe<Dictionaries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dictionaries_OneArgs = {
  object: Dictionaries_Insert_Input;
  on_conflict?: InputMaybe<Dictionaries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_TemplatesArgs = {
  objects: Array<Doc_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Doc_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_Templates_OneArgs = {
  object: Doc_Templates_Insert_Input;
  on_conflict?: InputMaybe<Doc_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_Templates_TenantsArgs = {
  objects: Array<Doc_Templates_Tenants_Insert_Input>;
  on_conflict?: InputMaybe<Doc_Templates_Tenants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_Templates_Tenants_OneArgs = {
  object: Doc_Templates_Tenants_Insert_Input;
  on_conflict?: InputMaybe<Doc_Templates_Tenants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_SequencesArgs = {
  objects: Array<Email_Sequences_Insert_Input>;
  on_conflict?: InputMaybe<Email_Sequences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Sequences_OneArgs = {
  object: Email_Sequences_Insert_Input;
  on_conflict?: InputMaybe<Email_Sequences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Sequences_RecipientsArgs = {
  objects: Array<Email_Sequences_Recipients_Insert_Input>;
  on_conflict?: InputMaybe<Email_Sequences_Recipients_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Sequences_Recipients_OneArgs = {
  object: Email_Sequences_Recipients_Insert_Input;
  on_conflict?: InputMaybe<Email_Sequences_Recipients_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Sequences_StepsArgs = {
  objects: Array<Email_Sequences_Steps_Insert_Input>;
  on_conflict?: InputMaybe<Email_Sequences_Steps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Sequences_Steps_OneArgs = {
  object: Email_Sequences_Steps_Insert_Input;
  on_conflict?: InputMaybe<Email_Sequences_Steps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_TemplatesArgs = {
  objects: Array<Email_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Email_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Templates_FilesArgs = {
  objects: Array<Email_Templates_Files_Insert_Input>;
  on_conflict?: InputMaybe<Email_Templates_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Templates_Files_OneArgs = {
  object: Email_Templates_Files_Insert_Input;
  on_conflict?: InputMaybe<Email_Templates_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Templates_OneArgs = {
  object: Email_Templates_Insert_Input;
  on_conflict?: InputMaybe<Email_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EmailsArgs = {
  objects: Array<Emails_Insert_Input>;
  on_conflict?: InputMaybe<Emails_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Emails_OneArgs = {
  object: Emails_Insert_Input;
  on_conflict?: InputMaybe<Emails_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FilesArgs = {
  objects: Array<Files_Insert_Input>;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Files_OneArgs = {
  object: Files_Insert_Input;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Google_AddressesArgs = {
  objects: Array<Google_Addresses_Insert_Input>;
  on_conflict?: InputMaybe<Google_Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Google_Addresses_OneArgs = {
  object: Google_Addresses_Insert_Input;
  on_conflict?: InputMaybe<Google_Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ImagesArgs = {
  objects: Array<Images_Insert_Input>;
  on_conflict?: InputMaybe<Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Images_OneArgs = {
  object: Images_Insert_Input;
  on_conflict?: InputMaybe<Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InvitationsArgs = {
  objects: Array<Invitations_Insert_Input>;
  on_conflict?: InputMaybe<Invitations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invitations_OneArgs = {
  object: Invitations_Insert_Input;
  on_conflict?: InputMaybe<Invitations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lead_AgentsArgs = {
  objects: Array<Lead_Agents_Insert_Input>;
  on_conflict?: InputMaybe<Lead_Agents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lead_Agents_OneArgs = {
  object: Lead_Agents_Insert_Input;
  on_conflict?: InputMaybe<Lead_Agents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lead_StagesArgs = {
  objects: Array<Lead_Stages_Insert_Input>;
  on_conflict?: InputMaybe<Lead_Stages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lead_Stages_OneArgs = {
  object: Lead_Stages_Insert_Input;
  on_conflict?: InputMaybe<Lead_Stages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LeadsArgs = {
  objects: Array<Leads_Insert_Input>;
  on_conflict?: InputMaybe<Leads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Leads_OneArgs = {
  object: Leads_Insert_Input;
  on_conflict?: InputMaybe<Leads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Leads_TagsArgs = {
  objects: Array<Leads_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Leads_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Leads_Tags_OneArgs = {
  object: Leads_Tags_Insert_Input;
  on_conflict?: InputMaybe<Leads_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lot_Reference_AliasesArgs = {
  objects: Array<Lot_Reference_Aliases_Insert_Input>;
  on_conflict?: InputMaybe<Lot_Reference_Aliases_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lot_Reference_Aliases_OneArgs = {
  object: Lot_Reference_Aliases_Insert_Input;
  on_conflict?: InputMaybe<Lot_Reference_Aliases_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lot_SellersArgs = {
  objects: Array<Lot_Sellers_Insert_Input>;
  on_conflict?: InputMaybe<Lot_Sellers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lot_Sellers_OneArgs = {
  object: Lot_Sellers_Insert_Input;
  on_conflict?: InputMaybe<Lot_Sellers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LotsArgs = {
  objects: Array<Lots_Insert_Input>;
  on_conflict?: InputMaybe<Lots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lots_DerivedArgs = {
  lot: InsertListingLotsInsertInput;
};


/** mutation root */
export type Mutation_RootInsert_Lots_OneArgs = {
  object: Lots_Insert_Input;
  on_conflict?: InputMaybe<Lots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OffersArgs = {
  objects: Array<Offers_Insert_Input>;
  on_conflict?: InputMaybe<Offers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Offers_OneArgs = {
  object: Offers_Insert_Input;
  on_conflict?: InputMaybe<Offers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_ImagesArgs = {
  objects: Array<Organisation_Images_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Images_OneArgs = {
  object: Organisation_Images_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganisationsArgs = {
  objects: Array<Organisations_Insert_Input>;
  on_conflict?: InputMaybe<Organisations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisations_OneArgs = {
  object: Organisations_Insert_Input;
  on_conflict?: InputMaybe<Organisations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Phone_Number_Type_EnumArgs = {
  objects: Array<Phone_Number_Type_Enum_Insert_Input>;
  on_conflict?: InputMaybe<Phone_Number_Type_Enum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Phone_Number_Type_Enum_OneArgs = {
  object: Phone_Number_Type_Enum_Insert_Input;
  on_conflict?: InputMaybe<Phone_Number_Type_Enum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Phone_NumbersArgs = {
  objects: Array<Phone_Numbers_Insert_Input>;
  on_conflict?: InputMaybe<Phone_Numbers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Phone_Numbers_OneArgs = {
  object: Phone_Numbers_Insert_Input;
  on_conflict?: InputMaybe<Phone_Numbers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PipelinesArgs = {
  objects: Array<Pipelines_Insert_Input>;
  on_conflict?: InputMaybe<Pipelines_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pipelines_OneArgs = {
  object: Pipelines_Insert_Input;
  on_conflict?: InputMaybe<Pipelines_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pois_OneArgs = {
  input: InsertPoisOneInput;
};


/** mutation root */
export type Mutation_RootInsert_PortalsArgs = {
  objects: Array<Portals_Insert_Input>;
  on_conflict?: InputMaybe<Portals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Portals_OneArgs = {
  object: Portals_Insert_Input;
  on_conflict?: InputMaybe<Portals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PropertiesArgs = {
  objects: Array<Properties_Insert_Input>;
  on_conflict?: InputMaybe<Properties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Properties_OneArgs = {
  object: Properties_Insert_Input;
  on_conflict?: InputMaybe<Properties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_FilesArgs = {
  objects: Array<Property_Files_Insert_Input>;
  on_conflict?: InputMaybe<Property_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Files_OneArgs = {
  object: Property_Files_Insert_Input;
  on_conflict?: InputMaybe<Property_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_ImagesArgs = {
  objects: Array<Property_Images_Insert_Input>;
  on_conflict?: InputMaybe<Property_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Images_OneArgs = {
  object: Property_Images_Insert_Input;
  on_conflict?: InputMaybe<Property_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_SearchesArgs = {
  objects: Array<Property_Searches_Insert_Input>;
  on_conflict?: InputMaybe<Property_Searches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Searches_OneArgs = {
  object: Property_Searches_Insert_Input;
  on_conflict?: InputMaybe<Property_Searches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Searches_PlacesArgs = {
  objects: Array<Property_Searches_Places_Insert_Input>;
  on_conflict?: InputMaybe<Property_Searches_Places_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Searches_Places_OneArgs = {
  object: Property_Searches_Places_Insert_Input;
  on_conflict?: InputMaybe<Property_Searches_Places_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Searches_Property_TypesArgs = {
  objects: Array<Property_Searches_Property_Types_Insert_Input>;
  on_conflict?: InputMaybe<Property_Searches_Property_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Searches_Property_Types_OneArgs = {
  object: Property_Searches_Property_Types_Insert_Input;
  on_conflict?: InputMaybe<Property_Searches_Property_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_TransactionsArgs = {
  objects: Array<Property_Transactions_Insert_Input>;
  on_conflict?: InputMaybe<Property_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Transactions_ListingsArgs = {
  objects: Array<Property_Transactions_Listings_Insert_Input>;
  on_conflict?: InputMaybe<Property_Transactions_Listings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Transactions_Listings_OneArgs = {
  object: Property_Transactions_Listings_Insert_Input;
  on_conflict?: InputMaybe<Property_Transactions_Listings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Transactions_OneArgs = {
  object: Property_Transactions_Insert_Input;
  on_conflict?: InputMaybe<Property_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Push_Notification_TokensArgs = {
  objects: Array<Push_Notification_Tokens_Insert_Input>;
  on_conflict?: InputMaybe<Push_Notification_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Push_Notification_Tokens_OneArgs = {
  object: Push_Notification_Tokens_Insert_Input;
  on_conflict?: InputMaybe<Push_Notification_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReviewsArgs = {
  objects: Array<Reviews_Insert_Input>;
  on_conflict?: InputMaybe<Reviews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reviews_OneArgs = {
  object: Reviews_Insert_Input;
  on_conflict?: InputMaybe<Reviews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Smart_ListsArgs = {
  objects: Array<Smart_Lists_Insert_Input>;
  on_conflict?: InputMaybe<Smart_Lists_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Smart_Lists_OneArgs = {
  object: Smart_Lists_Insert_Input;
  on_conflict?: InputMaybe<Smart_Lists_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_ImagesArgs = {
  objects: Array<Team_Images_Insert_Input>;
  on_conflict?: InputMaybe<Team_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_Images_OneArgs = {
  object: Team_Images_Insert_Input;
  on_conflict?: InputMaybe<Team_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TeamsArgs = {
  objects: Array<Teams_Insert_Input>;
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_OneArgs = {
  object: Teams_Insert_Input;
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_PortalsArgs = {
  objects: Array<Teams_Portals_Insert_Input>;
  on_conflict?: InputMaybe<Teams_Portals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_Portals_OneArgs = {
  object: Teams_Portals_Insert_Input;
  on_conflict?: InputMaybe<Teams_Portals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_UsersArgs = {
  objects: Array<Teams_Users_Insert_Input>;
  on_conflict?: InputMaybe<Teams_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_Users_OneArgs = {
  object: Teams_Users_Insert_Input;
  on_conflict?: InputMaybe<Teams_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transaction_BuyersArgs = {
  objects: Array<Transaction_Buyers_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Transaction_Buyers_OneArgs = {
  object: Transaction_Buyers_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Transaction_SellersArgs = {
  objects: Array<Transaction_Sellers_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Transaction_Sellers_OneArgs = {
  object: Transaction_Sellers_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_User_ImagesArgs = {
  objects: Array<User_Images_Insert_Input>;
  on_conflict?: InputMaybe<User_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Images_OneArgs = {
  object: User_Images_Insert_Input;
  on_conflict?: InputMaybe<User_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_ListingsArgs = {
  objects: Array<Users_Listings_Insert_Input>;
  on_conflict?: InputMaybe<Users_Listings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_Listings_OneArgs = {
  object: Users_Listings_Insert_Input;
  on_conflict?: InputMaybe<Users_Listings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootManual_Search_PoisArgs = {
  property_id: Scalars['uuid']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootOrder_Buyer_LeadArgs = {
  buyerLeadId: Scalars['uuid']['input'];
  destinationOrder: Scalars['Int']['input'];
  destinationStageId: Scalars['uuid']['input'];
  source: OrderBuyerLeadSource;
};


/** mutation root */
export type Mutation_RootPrepare_UploadArgs = {
  file_name: Scalars['String']['input'];
  file_type: Scalars['String']['input'];
  id: Scalars['String']['input'];
  mime_type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootProperty_AppraisalArgs = {
  object: PropertyAppraisalInput;
};


/** mutation root */
export type Mutation_RootScrape_Google_ReviewsArgs = {
  team_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSend_Slack_NotificationArgs = {
  channel: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSet_Default_TeamArgs = {
  args: Set_Default_Team_Args;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootStart_ReviewArgs = {
  address: StartReviewGoogleAddressInput;
  agent_id: Scalars['uuid']['input'];
  email_address: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  is_seller: Scalars['Boolean']['input'];
  last_name: Scalars['String']['input'];
  neverbounce_result?: InputMaybe<Scalars['String']['input']>;
  referer: Scalars['String']['input'];
  token: Scalars['String']['input'];
  transaction_date: Scalars['timestamptz']['input'];
};


/** mutation root */
export type Mutation_RootToggle_Portal_ListingArgs = {
  lot_id: Scalars['uuid']['input'];
  portal_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdate_ActivitiesArgs = {
  _set?: InputMaybe<Activities_Set_Input>;
  where: Activities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Activities_By_PkArgs = {
  _set?: InputMaybe<Activities_Set_Input>;
  pk_columns: Activities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Activities_ManyArgs = {
  updates: Array<Activities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Buyer_LeadsArgs = {
  _inc?: InputMaybe<Buyer_Leads_Inc_Input>;
  _set?: InputMaybe<Buyer_Leads_Set_Input>;
  where: Buyer_Leads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Buyer_Leads_By_PkArgs = {
  _inc?: InputMaybe<Buyer_Leads_Inc_Input>;
  _set?: InputMaybe<Buyer_Leads_Set_Input>;
  pk_columns: Buyer_Leads_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Buyer_Leads_ManyArgs = {
  updates: Array<Buyer_Leads_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cma_Report_FilesArgs = {
  _inc?: InputMaybe<Cma_Report_Files_Inc_Input>;
  _set?: InputMaybe<Cma_Report_Files_Set_Input>;
  where: Cma_Report_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cma_Report_Files_ManyArgs = {
  updates: Array<Cma_Report_Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cma_ReportsArgs = {
  _append?: InputMaybe<Cma_Reports_Append_Input>;
  _delete_at_path?: InputMaybe<Cma_Reports_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Cma_Reports_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Cma_Reports_Delete_Key_Input>;
  _inc?: InputMaybe<Cma_Reports_Inc_Input>;
  _prepend?: InputMaybe<Cma_Reports_Prepend_Input>;
  _set?: InputMaybe<Cma_Reports_Set_Input>;
  where: Cma_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cma_Reports_By_PkArgs = {
  _append?: InputMaybe<Cma_Reports_Append_Input>;
  _delete_at_path?: InputMaybe<Cma_Reports_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Cma_Reports_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Cma_Reports_Delete_Key_Input>;
  _inc?: InputMaybe<Cma_Reports_Inc_Input>;
  _prepend?: InputMaybe<Cma_Reports_Prepend_Input>;
  _set?: InputMaybe<Cma_Reports_Set_Input>;
  pk_columns: Cma_Reports_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cma_Reports_ComparablesArgs = {
  _append?: InputMaybe<Cma_Reports_Comparables_Append_Input>;
  _delete_at_path?: InputMaybe<Cma_Reports_Comparables_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Cma_Reports_Comparables_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Cma_Reports_Comparables_Delete_Key_Input>;
  _inc?: InputMaybe<Cma_Reports_Comparables_Inc_Input>;
  _prepend?: InputMaybe<Cma_Reports_Comparables_Prepend_Input>;
  _set?: InputMaybe<Cma_Reports_Comparables_Set_Input>;
  where: Cma_Reports_Comparables_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cma_Reports_Comparables_ManyArgs = {
  updates: Array<Cma_Reports_Comparables_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cma_Reports_ManyArgs = {
  updates: Array<Cma_Reports_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CommissionsArgs = {
  _inc?: InputMaybe<Commissions_Inc_Input>;
  _set?: InputMaybe<Commissions_Set_Input>;
  where: Commissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Commissions_By_PkArgs = {
  _inc?: InputMaybe<Commissions_Inc_Input>;
  _set?: InputMaybe<Commissions_Set_Input>;
  pk_columns: Commissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Commissions_ManyArgs = {
  updates: Array<Commissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DictionariesArgs = {
  _inc?: InputMaybe<Dictionaries_Inc_Input>;
  _set?: InputMaybe<Dictionaries_Set_Input>;
  where: Dictionaries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dictionaries_By_PkArgs = {
  _inc?: InputMaybe<Dictionaries_Inc_Input>;
  _set?: InputMaybe<Dictionaries_Set_Input>;
  pk_columns: Dictionaries_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dictionaries_ManyArgs = {
  updates: Array<Dictionaries_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_TemplatesArgs = {
  _append?: InputMaybe<Doc_Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Doc_Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Doc_Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Doc_Templates_Delete_Key_Input>;
  _prepend?: InputMaybe<Doc_Templates_Prepend_Input>;
  _set?: InputMaybe<Doc_Templates_Set_Input>;
  where: Doc_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Templates_By_PkArgs = {
  _append?: InputMaybe<Doc_Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Doc_Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Doc_Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Doc_Templates_Delete_Key_Input>;
  _prepend?: InputMaybe<Doc_Templates_Prepend_Input>;
  _set?: InputMaybe<Doc_Templates_Set_Input>;
  pk_columns: Doc_Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Templates_ManyArgs = {
  updates: Array<Doc_Templates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Templates_TenantsArgs = {
  _set?: InputMaybe<Doc_Templates_Tenants_Set_Input>;
  where: Doc_Templates_Tenants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Templates_Tenants_By_PkArgs = {
  _set?: InputMaybe<Doc_Templates_Tenants_Set_Input>;
  pk_columns: Doc_Templates_Tenants_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Templates_Tenants_ManyArgs = {
  updates: Array<Doc_Templates_Tenants_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_SequencesArgs = {
  _set?: InputMaybe<Email_Sequences_Set_Input>;
  where: Email_Sequences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Sequences_By_PkArgs = {
  _set?: InputMaybe<Email_Sequences_Set_Input>;
  pk_columns: Email_Sequences_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Sequences_ManyArgs = {
  updates: Array<Email_Sequences_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Sequences_RecipientsArgs = {
  _set?: InputMaybe<Email_Sequences_Recipients_Set_Input>;
  where: Email_Sequences_Recipients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Sequences_Recipients_By_PkArgs = {
  _set?: InputMaybe<Email_Sequences_Recipients_Set_Input>;
  pk_columns: Email_Sequences_Recipients_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Sequences_Recipients_ManyArgs = {
  updates: Array<Email_Sequences_Recipients_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Sequences_StepsArgs = {
  _inc?: InputMaybe<Email_Sequences_Steps_Inc_Input>;
  _set?: InputMaybe<Email_Sequences_Steps_Set_Input>;
  where: Email_Sequences_Steps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Sequences_Steps_By_PkArgs = {
  _inc?: InputMaybe<Email_Sequences_Steps_Inc_Input>;
  _set?: InputMaybe<Email_Sequences_Steps_Set_Input>;
  pk_columns: Email_Sequences_Steps_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Sequences_Steps_ManyArgs = {
  updates: Array<Email_Sequences_Steps_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_TemplatesArgs = {
  _append?: InputMaybe<Email_Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Email_Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Email_Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Email_Templates_Delete_Key_Input>;
  _prepend?: InputMaybe<Email_Templates_Prepend_Input>;
  _set?: InputMaybe<Email_Templates_Set_Input>;
  where: Email_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Templates_By_PkArgs = {
  _append?: InputMaybe<Email_Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Email_Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Email_Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Email_Templates_Delete_Key_Input>;
  _prepend?: InputMaybe<Email_Templates_Prepend_Input>;
  _set?: InputMaybe<Email_Templates_Set_Input>;
  pk_columns: Email_Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Templates_ManyArgs = {
  updates: Array<Email_Templates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EmailsArgs = {
  _set?: InputMaybe<Emails_Set_Input>;
  where: Emails_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Emails_By_PkArgs = {
  _set?: InputMaybe<Emails_Set_Input>;
  pk_columns: Emails_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Emails_ManyArgs = {
  updates: Array<Emails_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EnquiriesArgs = {
  _set?: InputMaybe<Enquiries_Set_Input>;
  where: Enquiries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enquiries_By_PkArgs = {
  _set?: InputMaybe<Enquiries_Set_Input>;
  pk_columns: Enquiries_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enquiries_ManyArgs = {
  updates: Array<Enquiries_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FilesArgs = {
  _set?: InputMaybe<Files_Set_Input>;
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Files_By_PkArgs = {
  _set?: InputMaybe<Files_Set_Input>;
  pk_columns: Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Files_ManyArgs = {
  updates: Array<Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Google_AddressesArgs = {
  _inc?: InputMaybe<Google_Addresses_Inc_Input>;
  _set?: InputMaybe<Google_Addresses_Set_Input>;
  where: Google_Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Google_Addresses_ManyArgs = {
  updates: Array<Google_Addresses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InvitationsArgs = {
  _set?: InputMaybe<Invitations_Set_Input>;
  where: Invitations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invitations_By_PkArgs = {
  _set?: InputMaybe<Invitations_Set_Input>;
  pk_columns: Invitations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invitations_ManyArgs = {
  updates: Array<Invitations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_KeyArgs = {
  partnerId: Scalars['String']['input'];
  partnerName: Scalars['String']['input'];
  partnerRole: Scalars['String']['input'];
  partnerTeamsIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_AgentsArgs = {
  _inc?: InputMaybe<Lead_Agents_Inc_Input>;
  _set?: InputMaybe<Lead_Agents_Set_Input>;
  where: Lead_Agents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_Agents_By_PkArgs = {
  _inc?: InputMaybe<Lead_Agents_Inc_Input>;
  _set?: InputMaybe<Lead_Agents_Set_Input>;
  pk_columns: Lead_Agents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_Agents_ManyArgs = {
  updates: Array<Lead_Agents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_StagesArgs = {
  _inc?: InputMaybe<Lead_Stages_Inc_Input>;
  _set?: InputMaybe<Lead_Stages_Set_Input>;
  where: Lead_Stages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_Stages_By_PkArgs = {
  _inc?: InputMaybe<Lead_Stages_Inc_Input>;
  _set?: InputMaybe<Lead_Stages_Set_Input>;
  pk_columns: Lead_Stages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_Stages_ManyArgs = {
  updates: Array<Lead_Stages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LeadsArgs = {
  _set?: InputMaybe<Leads_Set_Input>;
  where: Leads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Leads_By_PkArgs = {
  _set?: InputMaybe<Leads_Set_Input>;
  pk_columns: Leads_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Leads_ManyArgs = {
  updates: Array<Leads_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LotsArgs = {
  _append?: InputMaybe<Lots_Append_Input>;
  _delete_at_path?: InputMaybe<Lots_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Lots_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Lots_Delete_Key_Input>;
  _inc?: InputMaybe<Lots_Inc_Input>;
  _prepend?: InputMaybe<Lots_Prepend_Input>;
  _set?: InputMaybe<Lots_Set_Input>;
  where: Lots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lots_By_PkArgs = {
  _append?: InputMaybe<Lots_Append_Input>;
  _delete_at_path?: InputMaybe<Lots_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Lots_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Lots_Delete_Key_Input>;
  _inc?: InputMaybe<Lots_Inc_Input>;
  _prepend?: InputMaybe<Lots_Prepend_Input>;
  _set?: InputMaybe<Lots_Set_Input>;
  pk_columns: Lots_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lots_ManyArgs = {
  updates: Array<Lots_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OffersArgs = {
  _inc?: InputMaybe<Offers_Inc_Input>;
  _set?: InputMaybe<Offers_Set_Input>;
  where: Offers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Offers_By_PkArgs = {
  _inc?: InputMaybe<Offers_Inc_Input>;
  _set?: InputMaybe<Offers_Set_Input>;
  pk_columns: Offers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Offers_ManyArgs = {
  updates: Array<Offers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_ImagesArgs = {
  _set?: InputMaybe<Organisation_Images_Set_Input>;
  where: Organisation_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Images_ManyArgs = {
  updates: Array<Organisation_Images_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganisationsArgs = {
  _set?: InputMaybe<Organisations_Set_Input>;
  where: Organisations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisations_By_PkArgs = {
  _set?: InputMaybe<Organisations_Set_Input>;
  pk_columns: Organisations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisations_ManyArgs = {
  updates: Array<Organisations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Phone_NumbersArgs = {
  _set?: InputMaybe<Phone_Numbers_Set_Input>;
  where: Phone_Numbers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Phone_Numbers_By_PkArgs = {
  _set?: InputMaybe<Phone_Numbers_Set_Input>;
  pk_columns: Phone_Numbers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Phone_Numbers_ManyArgs = {
  updates: Array<Phone_Numbers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PipelinesArgs = {
  _set?: InputMaybe<Pipelines_Set_Input>;
  where: Pipelines_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pipelines_By_PkArgs = {
  _set?: InputMaybe<Pipelines_Set_Input>;
  pk_columns: Pipelines_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pipelines_ManyArgs = {
  updates: Array<Pipelines_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Portal_ListingArgs = {
  lot_id: Scalars['uuid']['input'];
  portal_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdate_PortalsArgs = {
  _inc?: InputMaybe<Portals_Inc_Input>;
  _set?: InputMaybe<Portals_Set_Input>;
  where: Portals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Portals_By_PkArgs = {
  _inc?: InputMaybe<Portals_Inc_Input>;
  _set?: InputMaybe<Portals_Set_Input>;
  pk_columns: Portals_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Portals_ManyArgs = {
  updates: Array<Portals_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PropertiesArgs = {
  _inc?: InputMaybe<Properties_Inc_Input>;
  _set?: InputMaybe<Properties_Set_Input>;
  where: Properties_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Properties_By_PkArgs = {
  _inc?: InputMaybe<Properties_Inc_Input>;
  _set?: InputMaybe<Properties_Set_Input>;
  pk_columns: Properties_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Properties_ManyArgs = {
  updates: Array<Properties_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_FilesArgs = {
  _inc?: InputMaybe<Property_Files_Inc_Input>;
  _set?: InputMaybe<Property_Files_Set_Input>;
  where: Property_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Files_ManyArgs = {
  updates: Array<Property_Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_ImagesArgs = {
  _inc?: InputMaybe<Property_Images_Inc_Input>;
  _set?: InputMaybe<Property_Images_Set_Input>;
  where: Property_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Images_By_PkArgs = {
  _inc?: InputMaybe<Property_Images_Inc_Input>;
  _set?: InputMaybe<Property_Images_Set_Input>;
  pk_columns: Property_Images_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Images_ManyArgs = {
  updates: Array<Property_Images_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_SearchesArgs = {
  _inc?: InputMaybe<Property_Searches_Inc_Input>;
  _set?: InputMaybe<Property_Searches_Set_Input>;
  where: Property_Searches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Searches_By_PkArgs = {
  _inc?: InputMaybe<Property_Searches_Inc_Input>;
  _set?: InputMaybe<Property_Searches_Set_Input>;
  pk_columns: Property_Searches_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Searches_ManyArgs = {
  updates: Array<Property_Searches_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_TransactionsArgs = {
  _inc?: InputMaybe<Property_Transactions_Inc_Input>;
  _set?: InputMaybe<Property_Transactions_Set_Input>;
  where: Property_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Transactions_By_PkArgs = {
  _inc?: InputMaybe<Property_Transactions_Inc_Input>;
  _set?: InputMaybe<Property_Transactions_Set_Input>;
  pk_columns: Property_Transactions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Transactions_ListingsArgs = {
  _inc?: InputMaybe<Property_Transactions_Listings_Inc_Input>;
  _set?: InputMaybe<Property_Transactions_Listings_Set_Input>;
  where: Property_Transactions_Listings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Transactions_Listings_By_PkArgs = {
  _inc?: InputMaybe<Property_Transactions_Listings_Inc_Input>;
  _set?: InputMaybe<Property_Transactions_Listings_Set_Input>;
  pk_columns: Property_Transactions_Listings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Transactions_Listings_ManyArgs = {
  updates: Array<Property_Transactions_Listings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Transactions_ManyArgs = {
  updates: Array<Property_Transactions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReviewsArgs = {
  _inc?: InputMaybe<Reviews_Inc_Input>;
  _set?: InputMaybe<Reviews_Set_Input>;
  where: Reviews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reviews_By_PkArgs = {
  _inc?: InputMaybe<Reviews_Inc_Input>;
  _set?: InputMaybe<Reviews_Set_Input>;
  pk_columns: Reviews_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reviews_ManyArgs = {
  updates: Array<Reviews_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_ListsArgs = {
  _append?: InputMaybe<Smart_Lists_Append_Input>;
  _delete_at_path?: InputMaybe<Smart_Lists_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Smart_Lists_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Smart_Lists_Delete_Key_Input>;
  _prepend?: InputMaybe<Smart_Lists_Prepend_Input>;
  _set?: InputMaybe<Smart_Lists_Set_Input>;
  where: Smart_Lists_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Lists_By_PkArgs = {
  _append?: InputMaybe<Smart_Lists_Append_Input>;
  _delete_at_path?: InputMaybe<Smart_Lists_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Smart_Lists_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Smart_Lists_Delete_Key_Input>;
  _prepend?: InputMaybe<Smart_Lists_Prepend_Input>;
  _set?: InputMaybe<Smart_Lists_Set_Input>;
  pk_columns: Smart_Lists_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Lists_ManyArgs = {
  updates: Array<Smart_Lists_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SubscriptionsArgs = {
  _set?: InputMaybe<Subscriptions_Set_Input>;
  where: Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_By_PkArgs = {
  _set?: InputMaybe<Subscriptions_Set_Input>;
  pk_columns: Subscriptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_ManyArgs = {
  updates: Array<Subscriptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TeamsArgs = {
  _append?: InputMaybe<Teams_Append_Input>;
  _delete_at_path?: InputMaybe<Teams_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Teams_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Teams_Delete_Key_Input>;
  _inc?: InputMaybe<Teams_Inc_Input>;
  _prepend?: InputMaybe<Teams_Prepend_Input>;
  _set?: InputMaybe<Teams_Set_Input>;
  where: Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_By_PkArgs = {
  _append?: InputMaybe<Teams_Append_Input>;
  _delete_at_path?: InputMaybe<Teams_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Teams_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Teams_Delete_Key_Input>;
  _inc?: InputMaybe<Teams_Inc_Input>;
  _prepend?: InputMaybe<Teams_Prepend_Input>;
  _set?: InputMaybe<Teams_Set_Input>;
  pk_columns: Teams_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_ManyArgs = {
  updates: Array<Teams_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_PortalsArgs = {
  _set?: InputMaybe<Teams_Portals_Set_Input>;
  where: Teams_Portals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_Portals_By_PkArgs = {
  _set?: InputMaybe<Teams_Portals_Set_Input>;
  pk_columns: Teams_Portals_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_Portals_ManyArgs = {
  updates: Array<Teams_Portals_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_UsersArgs = {
  _inc?: InputMaybe<Teams_Users_Inc_Input>;
  _set?: InputMaybe<Teams_Users_Set_Input>;
  where: Teams_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_Users_ManyArgs = {
  updates: Array<Teams_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TenantsArgs = {
  _inc?: InputMaybe<Tenants_Inc_Input>;
  _set?: InputMaybe<Tenants_Set_Input>;
  where: Tenants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenants_By_PkArgs = {
  _inc?: InputMaybe<Tenants_Inc_Input>;
  _set?: InputMaybe<Tenants_Set_Input>;
  pk_columns: Tenants_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenants_ManyArgs = {
  updates: Array<Tenants_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ImagesArgs = {
  _inc?: InputMaybe<User_Images_Inc_Input>;
  _set?: InputMaybe<User_Images_Set_Input>;
  where: User_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Images_By_PkArgs = {
  _inc?: InputMaybe<User_Images_Inc_Input>;
  _set?: InputMaybe<User_Images_Set_Input>;
  pk_columns: User_Images_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Images_ManyArgs = {
  updates: Array<User_Images_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ListingsArgs = {
  _inc?: InputMaybe<Users_Listings_Inc_Input>;
  _set?: InputMaybe<Users_Listings_Set_Input>;
  where: Users_Listings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_Listings_By_PkArgs = {
  _inc?: InputMaybe<Users_Listings_Inc_Input>;
  _set?: InputMaybe<Users_Listings_Set_Input>;
  pk_columns: Users_Listings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpsert_Valuation_LinkArgs = {
  agent_id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootValue_PropertyArgs = {
  property_id: Scalars['String']['input'];
};

/** columns and relationships of "nylas_account_configs" */
export type Nylas_Account_Configs = {
  account_id?: Maybe<Scalars['String']['output']>;
  calendar_name?: Maybe<Scalars['String']['output']>;
  calendar_sync_enabled: Scalars['Boolean']['output'];
  calendar_sync_enabled_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  nylas_calendar_id?: Maybe<Scalars['String']['output']>;
  scopes?: Maybe<Scalars['jsonb']['output']>;
  sync_activity_types?: Maybe<Array<Scalars['String']['output']>>;
  sync_enabled?: Maybe<Scalars['Boolean']['output']>;
  sync_enabled_at?: Maybe<Scalars['timestamptz']['output']>;
  sync_state?: Maybe<Scalars['String']['output']>;
  sync_state_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  sync_type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "nylas_account_configs" */
export type Nylas_Account_ConfigsScopesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "nylas_account_configs" */
export type Nylas_Account_Configs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Nylas_Account_Configs_Max_Order_By>;
  min?: InputMaybe<Nylas_Account_Configs_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "nylas_account_configs". All fields are combined with a logical 'AND'. */
export type Nylas_Account_Configs_Bool_Exp = {
  _and?: InputMaybe<Array<Nylas_Account_Configs_Bool_Exp>>;
  _not?: InputMaybe<Nylas_Account_Configs_Bool_Exp>;
  _or?: InputMaybe<Array<Nylas_Account_Configs_Bool_Exp>>;
  account_id?: InputMaybe<String_Comparison_Exp>;
  calendar_name?: InputMaybe<String_Comparison_Exp>;
  calendar_sync_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  calendar_sync_enabled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  nylas_calendar_id?: InputMaybe<String_Comparison_Exp>;
  scopes?: InputMaybe<Jsonb_Comparison_Exp>;
  sync_activity_types?: InputMaybe<String_Array_Comparison_Exp>;
  sync_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  sync_enabled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  sync_state?: InputMaybe<String_Comparison_Exp>;
  sync_state_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  sync_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "nylas_account_configs" */
export type Nylas_Account_Configs_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  calendar_name?: InputMaybe<Order_By>;
  calendar_sync_enabled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nylas_calendar_id?: InputMaybe<Order_By>;
  sync_activity_types?: InputMaybe<Order_By>;
  sync_enabled_at?: InputMaybe<Order_By>;
  sync_state?: InputMaybe<Order_By>;
  sync_state_updated_at?: InputMaybe<Order_By>;
  sync_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "nylas_account_configs" */
export type Nylas_Account_Configs_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  calendar_name?: InputMaybe<Order_By>;
  calendar_sync_enabled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nylas_calendar_id?: InputMaybe<Order_By>;
  sync_activity_types?: InputMaybe<Order_By>;
  sync_enabled_at?: InputMaybe<Order_By>;
  sync_state?: InputMaybe<Order_By>;
  sync_state_updated_at?: InputMaybe<Order_By>;
  sync_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "nylas_account_configs". */
export type Nylas_Account_Configs_Order_By = {
  account_id?: InputMaybe<Order_By>;
  calendar_name?: InputMaybe<Order_By>;
  calendar_sync_enabled?: InputMaybe<Order_By>;
  calendar_sync_enabled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nylas_calendar_id?: InputMaybe<Order_By>;
  scopes?: InputMaybe<Order_By>;
  sync_activity_types?: InputMaybe<Order_By>;
  sync_enabled?: InputMaybe<Order_By>;
  sync_enabled_at?: InputMaybe<Order_By>;
  sync_state?: InputMaybe<Order_By>;
  sync_state_updated_at?: InputMaybe<Order_By>;
  sync_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "nylas_account_configs" */
export enum Nylas_Account_Configs_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CalendarName = 'calendar_name',
  /** column name */
  CalendarSyncEnabled = 'calendar_sync_enabled',
  /** column name */
  CalendarSyncEnabledAt = 'calendar_sync_enabled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NylasCalendarId = 'nylas_calendar_id',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  SyncActivityTypes = 'sync_activity_types',
  /** column name */
  SyncEnabled = 'sync_enabled',
  /** column name */
  SyncEnabledAt = 'sync_enabled_at',
  /** column name */
  SyncState = 'sync_state',
  /** column name */
  SyncStateUpdatedAt = 'sync_state_updated_at',
  /** column name */
  SyncType = 'sync_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "nylas_account_configs" */
export type Nylas_Account_Configs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nylas_Account_Configs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nylas_Account_Configs_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  calendar_name?: InputMaybe<Scalars['String']['input']>;
  calendar_sync_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  calendar_sync_enabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nylas_calendar_id?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Scalars['jsonb']['input']>;
  sync_activity_types?: InputMaybe<Array<Scalars['String']['input']>>;
  sync_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  sync_enabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sync_state?: InputMaybe<Scalars['String']['input']>;
  sync_state_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sync_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "offers" */
export type Offers = {
  amount: Scalars['Int']['output'];
  /** An object relationship */
  buyer: Users;
  buyer_id: Scalars['uuid']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  creator?: Maybe<Users>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lot: Lots;
  lot_id: Scalars['uuid']['output'];
  made_on: Scalars['date']['output'];
  offer_refused_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  offer_refused_type?: Maybe<Dictionaries>;
  status: Offers_Status_Enum;
  updated_at: Scalars['timestamptz']['output'];
  valid_until?: Maybe<Scalars['date']['output']>;
};

/** aggregated selection of "offers" */
export type Offers_Aggregate = {
  aggregate?: Maybe<Offers_Aggregate_Fields>;
  nodes: Array<Offers>;
};

export type Offers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Offers_Aggregate_Bool_Exp_Count>;
};

export type Offers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Offers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Offers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "offers" */
export type Offers_Aggregate_Fields = {
  avg?: Maybe<Offers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Offers_Max_Fields>;
  min?: Maybe<Offers_Min_Fields>;
  stddev?: Maybe<Offers_Stddev_Fields>;
  stddev_pop?: Maybe<Offers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Offers_Stddev_Samp_Fields>;
  sum?: Maybe<Offers_Sum_Fields>;
  var_pop?: Maybe<Offers_Var_Pop_Fields>;
  var_samp?: Maybe<Offers_Var_Samp_Fields>;
  variance?: Maybe<Offers_Variance_Fields>;
};


/** aggregate fields of "offers" */
export type Offers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Offers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "offers" */
export type Offers_Aggregate_Order_By = {
  avg?: InputMaybe<Offers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Offers_Max_Order_By>;
  min?: InputMaybe<Offers_Min_Order_By>;
  stddev?: InputMaybe<Offers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Offers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Offers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Offers_Sum_Order_By>;
  var_pop?: InputMaybe<Offers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Offers_Var_Samp_Order_By>;
  variance?: InputMaybe<Offers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "offers" */
export type Offers_Arr_Rel_Insert_Input = {
  data: Array<Offers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Offers_On_Conflict>;
};

/** aggregate avg on columns */
export type Offers_Avg_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "offers" */
export type Offers_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "offers". All fields are combined with a logical 'AND'. */
export type Offers_Bool_Exp = {
  _and?: InputMaybe<Array<Offers_Bool_Exp>>;
  _not?: InputMaybe<Offers_Bool_Exp>;
  _or?: InputMaybe<Array<Offers_Bool_Exp>>;
  amount?: InputMaybe<Int_Comparison_Exp>;
  buyer?: InputMaybe<Users_Bool_Exp>;
  buyer_id?: InputMaybe<Uuid_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  made_on?: InputMaybe<Date_Comparison_Exp>;
  offer_refused_id?: InputMaybe<Uuid_Comparison_Exp>;
  offer_refused_type?: InputMaybe<Dictionaries_Bool_Exp>;
  status?: InputMaybe<Offers_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  valid_until?: InputMaybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "offers" */
export enum Offers_Constraint {
  /** unique or primary key constraint on columns "id" */
  OffersPkey = 'offers_pkey'
}

/** input type for incrementing numeric columns in table "offers" */
export type Offers_Inc_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "offers" */
export type Offers_Insert_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  buyer?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  buyer_id?: InputMaybe<Scalars['uuid']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  creator?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  made_on?: InputMaybe<Scalars['date']['input']>;
  offer_refused_id?: InputMaybe<Scalars['uuid']['input']>;
  offer_refused_type?: InputMaybe<Dictionaries_Obj_Rel_Insert_Input>;
  status?: InputMaybe<Offers_Status_Enum>;
  valid_until?: InputMaybe<Scalars['date']['input']>;
};

/** aggregate max on columns */
export type Offers_Max_Fields = {
  amount?: Maybe<Scalars['Int']['output']>;
  buyer_id?: Maybe<Scalars['uuid']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  made_on?: Maybe<Scalars['date']['output']>;
  offer_refused_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  valid_until?: Maybe<Scalars['date']['output']>;
};

/** order by max() on columns of table "offers" */
export type Offers_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  made_on?: InputMaybe<Order_By>;
  offer_refused_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  valid_until?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Offers_Min_Fields = {
  amount?: Maybe<Scalars['Int']['output']>;
  buyer_id?: Maybe<Scalars['uuid']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  made_on?: Maybe<Scalars['date']['output']>;
  offer_refused_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  valid_until?: Maybe<Scalars['date']['output']>;
};

/** order by min() on columns of table "offers" */
export type Offers_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  made_on?: InputMaybe<Order_By>;
  offer_refused_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  valid_until?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "offers" */
export type Offers_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Offers>;
};

/** on_conflict condition type for table "offers" */
export type Offers_On_Conflict = {
  constraint: Offers_Constraint;
  update_columns?: Array<Offers_Update_Column>;
  where?: InputMaybe<Offers_Bool_Exp>;
};

/** Ordering options when selecting data from "offers". */
export type Offers_Order_By = {
  amount?: InputMaybe<Order_By>;
  buyer?: InputMaybe<Users_Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  id?: InputMaybe<Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  made_on?: InputMaybe<Order_By>;
  offer_refused_id?: InputMaybe<Order_By>;
  offer_refused_type?: InputMaybe<Dictionaries_Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  valid_until?: InputMaybe<Order_By>;
};

/** primary key columns input for table: offers */
export type Offers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "offers" */
export enum Offers_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BuyerId = 'buyer_id',
  /** column name */
  Comments = 'comments',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  MadeOn = 'made_on',
  /** column name */
  OfferRefusedId = 'offer_refused_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidUntil = 'valid_until'
}

/** input type for updating data in table "offers" */
export type Offers_Set_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  buyer_id?: InputMaybe<Scalars['uuid']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  made_on?: InputMaybe<Scalars['date']['input']>;
  offer_refused_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Offers_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  valid_until?: InputMaybe<Scalars['date']['input']>;
};

export enum Offers_Status_Enum {
  Accepted = 'accepted',
  Pending = 'pending',
  Refused = 'refused'
}

/** Boolean expression to compare columns of type "offers_status_enum". All fields are combined with logical 'AND'. */
export type Offers_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Offers_Status_Enum>;
  _in?: InputMaybe<Array<Offers_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Offers_Status_Enum>;
  _nin?: InputMaybe<Array<Offers_Status_Enum>>;
};

/** aggregate stddev on columns */
export type Offers_Stddev_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "offers" */
export type Offers_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Offers_Stddev_Pop_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "offers" */
export type Offers_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Offers_Stddev_Samp_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "offers" */
export type Offers_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "offers" */
export type Offers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Offers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Offers_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  buyer_id?: InputMaybe<Scalars['uuid']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  made_on?: InputMaybe<Scalars['date']['input']>;
  offer_refused_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Offers_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  valid_until?: InputMaybe<Scalars['date']['input']>;
};

/** aggregate sum on columns */
export type Offers_Sum_Fields = {
  amount?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "offers" */
export type Offers_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "offers" */
export enum Offers_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BuyerId = 'buyer_id',
  /** column name */
  Comments = 'comments',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  MadeOn = 'made_on',
  /** column name */
  OfferRefusedId = 'offer_refused_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidUntil = 'valid_until'
}

export type Offers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Offers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Offers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Offers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Offers_Var_Pop_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "offers" */
export type Offers_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Offers_Var_Samp_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "offers" */
export type Offers_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Offers_Variance_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "offers" */
export type Offers_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "online_listing_map_data" */
export type Online_Listing_Map_Data = {
  geojson?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
};

export type Online_Listing_Map_Data_Aggregate = {
  aggregate?: Maybe<Online_Listing_Map_Data_Aggregate_Fields>;
  nodes: Array<Online_Listing_Map_Data>;
};

/** aggregate fields of "online_listing_map_data" */
export type Online_Listing_Map_Data_Aggregate_Fields = {
  avg?: Maybe<Online_Listing_Map_Data_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Online_Listing_Map_Data_Max_Fields>;
  min?: Maybe<Online_Listing_Map_Data_Min_Fields>;
  stddev?: Maybe<Online_Listing_Map_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Online_Listing_Map_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Online_Listing_Map_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Online_Listing_Map_Data_Sum_Fields>;
  var_pop?: Maybe<Online_Listing_Map_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Online_Listing_Map_Data_Var_Samp_Fields>;
  variance?: Maybe<Online_Listing_Map_Data_Variance_Fields>;
};


/** aggregate fields of "online_listing_map_data" */
export type Online_Listing_Map_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Online_Listing_Map_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Online_Listing_Map_Data_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "online_listing_map_data". All fields are combined with a logical 'AND'. */
export type Online_Listing_Map_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Online_Listing_Map_Data_Bool_Exp>>;
  _not?: InputMaybe<Online_Listing_Map_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Online_Listing_Map_Data_Bool_Exp>>;
  geojson?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
};

/** aggregate max on columns */
export type Online_Listing_Map_Data_Max_Fields = {
  geojson?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
};

/** aggregate min on columns */
export type Online_Listing_Map_Data_Min_Fields = {
  geojson?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
};

/** Ordering options when selecting data from "online_listing_map_data". */
export type Online_Listing_Map_Data_Order_By = {
  geojson?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** select columns of table "online_listing_map_data" */
export enum Online_Listing_Map_Data_Select_Column {
  /** column name */
  Geojson = 'geojson',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** aggregate stddev on columns */
export type Online_Listing_Map_Data_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Online_Listing_Map_Data_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Online_Listing_Map_Data_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Online_Listing_Map_Data_Sum_Fields = {
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Online_Listing_Map_Data_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Online_Listing_Map_Data_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Online_Listing_Map_Data_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "online_listings" */
export type Online_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_id?: Maybe<Scalars['uuid']['output']>;
  agency_logo_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  agency_reviews_count?: Maybe<Scalars['Int']['output']>;
  agency_slug?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  bullet_points?: Maybe<Scalars['jsonb']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  images?: Maybe<Scalars['jsonb']['output']>;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_place?: Maybe<Ch_Places>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  min_created_at?: Maybe<Scalars['timestamptz']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_descriptions?: Maybe<Scalars['jsonb']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  /** An array relationship */
  users_listings: Array<Users_Listings>;
  /** An aggregate relationship */
  users_listings_aggregate: Users_Listings_Aggregate;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "online_listings" */
export type Online_ListingsBullet_PointsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "online_listings" */
export type Online_ListingsImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "online_listings" */
export type Online_ListingsTranslated_DescriptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "online_listings" */
export type Online_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "online_listings" */
export type Online_ListingsUsers_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Users_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Listings_Order_By>>;
  where?: InputMaybe<Users_Listings_Bool_Exp>;
};


/** columns and relationships of "online_listings" */
export type Online_ListingsUsers_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Listings_Order_By>>;
  where?: InputMaybe<Users_Listings_Bool_Exp>;
};

export type Online_Listings_Aggregate = {
  aggregate?: Maybe<Online_Listings_Aggregate_Fields>;
  nodes: Array<Online_Listings>;
};

/** aggregate fields of "online_listings" */
export type Online_Listings_Aggregate_Fields = {
  avg?: Maybe<Online_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Online_Listings_Max_Fields>;
  min?: Maybe<Online_Listings_Min_Fields>;
  stddev?: Maybe<Online_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Online_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Online_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Online_Listings_Sum_Fields>;
  var_pop?: Maybe<Online_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Online_Listings_Var_Samp_Fields>;
  variance?: Maybe<Online_Listings_Variance_Fields>;
};


/** aggregate fields of "online_listings" */
export type Online_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Online_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Online_Listings_Avg_Fields = {
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reviews_count?: Maybe<Scalars['Float']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "online_listings". All fields are combined with a logical 'AND'. */
export type Online_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Online_Listings_Bool_Exp>>;
  _not?: InputMaybe<Online_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Online_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_id?: InputMaybe<Uuid_Comparison_Exp>;
  agency_logo_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_rating?: InputMaybe<Float_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  agency_reviews_count?: InputMaybe<Int_Comparison_Exp>;
  agency_slug?: InputMaybe<String_Comparison_Exp>;
  available_from?: InputMaybe<Date_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  bullet_points?: InputMaybe<Jsonb_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Jsonb_Comparison_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_place?: InputMaybe<Ch_Places_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  min_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_descriptions?: InputMaybe<Jsonb_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  users_listings?: InputMaybe<Users_Listings_Bool_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Online_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_id?: Maybe<Scalars['uuid']['output']>;
  agency_logo_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  agency_reviews_count?: Maybe<Scalars['Int']['output']>;
  agency_slug?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  min_created_at?: Maybe<Scalars['timestamptz']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Online_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_id?: Maybe<Scalars['uuid']['output']>;
  agency_logo_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  agency_reviews_count?: Maybe<Scalars['Int']['output']>;
  agency_slug?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  min_created_at?: Maybe<Scalars['timestamptz']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "online_listings". */
export type Online_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_id?: InputMaybe<Order_By>;
  agency_logo_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_rating?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  agency_reviews_count?: InputMaybe<Order_By>;
  agency_slug?: InputMaybe<Order_By>;
  available_from?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  bullet_points?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_place?: InputMaybe<Ch_Places_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  min_created_at?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_descriptions?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  users_listings_aggregate?: InputMaybe<Users_Listings_Aggregate_Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "online_listings" */
export enum Online_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  AgencyLogoUrl = 'agency_logo_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyRating = 'agency_rating',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  AgencyReviewsCount = 'agency_reviews_count',
  /** column name */
  AgencySlug = 'agency_slug',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  BulletPoints = 'bullet_points',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MinCreatedAt = 'min_created_at',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedDescriptions = 'translated_descriptions',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Online_Listings_Stddev_Fields = {
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reviews_count?: Maybe<Scalars['Float']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Online_Listings_Stddev_Pop_Fields = {
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reviews_count?: Maybe<Scalars['Float']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Online_Listings_Stddev_Samp_Fields = {
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reviews_count?: Maybe<Scalars['Float']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Online_Listings_Sum_Fields = {
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reviews_count?: Maybe<Scalars['Int']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Online_Listings_Var_Pop_Fields = {
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reviews_count?: Maybe<Scalars['Float']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Online_Listings_Var_Samp_Fields = {
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reviews_count?: Maybe<Scalars['Float']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Online_Listings_Variance_Fields = {
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reviews_count?: Maybe<Scalars['Float']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "organisation_images" */
export type Organisation_Images = {
  id: Scalars['uuid']['output'];
  /** An object relationship */
  image: Images;
  image_id: Scalars['uuid']['output'];
  is_primary?: Maybe<Scalars['Boolean']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  organisation: Organisations;
  organisation_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "organisation_images" */
export type Organisation_Images_Aggregate_Order_By = {
  avg?: InputMaybe<Organisation_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organisation_Images_Max_Order_By>;
  min?: InputMaybe<Organisation_Images_Min_Order_By>;
  stddev?: InputMaybe<Organisation_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organisation_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organisation_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organisation_Images_Sum_Order_By>;
  var_pop?: InputMaybe<Organisation_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organisation_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Organisation_Images_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organisation_images" */
export type Organisation_Images_Arr_Rel_Insert_Input = {
  data: Array<Organisation_Images_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisation_Images_On_Conflict>;
};

/** order by avg() on columns of table "organisation_images" */
export type Organisation_Images_Avg_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organisation_images". All fields are combined with a logical 'AND'. */
export type Organisation_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Images_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Images_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<Images_Bool_Exp>;
  image_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_primary?: InputMaybe<Boolean_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_images" */
export enum Organisation_Images_Constraint {
  /** unique or primary key constraint on columns "organisation_id", "is_primary" */
  IdxOrganisationImagesOrganisationIdIsPrimary = 'idx_organisation_images_organisation_id_is_primary',
  /** unique or primary key constraint on columns "id" */
  OrganisationImagesIdKey = 'organisation_images_id_key',
  /** unique or primary key constraint on columns "organisation_id", "image_id" */
  OrganisationImagesOrganisationIdImageIdUnique = 'organisation_images_organisation_id_image_id_unique'
}

/** input type for inserting data into table "organisation_images" */
export type Organisation_Images_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  organisation?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "organisation_images" */
export type Organisation_Images_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "organisation_images" */
export type Organisation_Images_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organisation_images" */
export type Organisation_Images_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Images>;
};

/** on_conflict condition type for table "organisation_images" */
export type Organisation_Images_On_Conflict = {
  constraint: Organisation_Images_Constraint;
  update_columns?: Array<Organisation_Images_Update_Column>;
  where?: InputMaybe<Organisation_Images_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation_images". */
export type Organisation_Images_Order_By = {
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Images_Order_By>;
  image_id?: InputMaybe<Order_By>;
  is_primary?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisations_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** select columns of table "organisation_images" */
export enum Organisation_Images_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  OrganisationId = 'organisation_id'
}

/** input type for updating data in table "organisation_images" */
export type Organisation_Images_Set_Input = {
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by stddev() on columns of table "organisation_images" */
export type Organisation_Images_Stddev_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "organisation_images" */
export type Organisation_Images_Stddev_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "organisation_images" */
export type Organisation_Images_Stddev_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organisation_images" */
export type Organisation_Images_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Images_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Images_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "organisation_images" */
export type Organisation_Images_Sum_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** update columns of table "organisation_images" */
export enum Organisation_Images_Update_Column {
  /** column name */
  IsPrimary = 'is_primary'
}

export type Organisation_Images_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Images_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organisation_Images_Bool_Exp;
};

/** order by var_pop() on columns of table "organisation_images" */
export type Organisation_Images_Var_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "organisation_images" */
export type Organisation_Images_Var_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "organisation_images" */
export type Organisation_Images_Variance_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** columns and relationships of "organisation_users" */
export type Organisation_Users = {
  /** An object relationship */
  organisation: Organisations;
  organisation_id: Scalars['uuid']['output'];
  /** An object relationship */
  users: Users;
};

/** order by aggregate values of table "organisation_users" */
export type Organisation_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organisation_Users_Max_Order_By>;
  min?: InputMaybe<Organisation_Users_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "organisation_users". All fields are combined with a logical 'AND'. */
export type Organisation_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Users_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Users_Bool_Exp>>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
};

/** order by max() on columns of table "organisation_users" */
export type Organisation_Users_Max_Order_By = {
  organisation_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "organisation_users" */
export type Organisation_Users_Min_Order_By = {
  organisation_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "organisation_users". */
export type Organisation_Users_Order_By = {
  organisation?: InputMaybe<Organisations_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  users?: InputMaybe<Users_Order_By>;
};

/** select columns of table "organisation_users" */
export enum Organisation_Users_Select_Column {
  /** column name */
  OrganisationId = 'organisation_id'
}

/** Streaming cursor of the table "organisation_users" */
export type Organisation_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Users_Stream_Cursor_Value_Input = {
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "organisations" */
export type Organisations = {
  branding_color?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  emails: Array<Emails>;
  id: Scalars['uuid']['output'];
  is_default_lender?: Maybe<Scalars['Boolean']['output']>;
  is_lender: Scalars['Boolean']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  organisation_images: Array<Organisation_Images>;
  /** An array relationship */
  organisation_users: Array<Organisation_Users>;
  parent_organisation_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  phone_numbers: Array<Phone_Numbers>;
  /** An aggregate relationship */
  phone_numbers_aggregate: Phone_Numbers_Aggregate;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  teams: Array<Teams>;
  /** An aggregate relationship */
  teams_aggregate: Teams_Aggregate;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  website?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "organisations" */
export type OrganisationsEmailsArgs = {
  distinct_on?: InputMaybe<Array<Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emails_Order_By>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsOrganisation_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Images_Order_By>>;
  where?: InputMaybe<Organisation_Images_Bool_Exp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsOrganisation_UsersArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Users_Order_By>>;
  where?: InputMaybe<Organisation_Users_Bool_Exp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsPhone_NumbersArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsPhone_Numbers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};

/** aggregated selection of "organisations" */
export type Organisations_Aggregate = {
  aggregate?: Maybe<Organisations_Aggregate_Fields>;
  nodes: Array<Organisations>;
};

/** aggregate fields of "organisations" */
export type Organisations_Aggregate_Fields = {
  avg?: Maybe<Organisations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organisations_Max_Fields>;
  min?: Maybe<Organisations_Min_Fields>;
  stddev?: Maybe<Organisations_Stddev_Fields>;
  stddev_pop?: Maybe<Organisations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisations_Stddev_Samp_Fields>;
  sum?: Maybe<Organisations_Sum_Fields>;
  var_pop?: Maybe<Organisations_Var_Pop_Fields>;
  var_samp?: Maybe<Organisations_Var_Samp_Fields>;
  variance?: Maybe<Organisations_Variance_Fields>;
};


/** aggregate fields of "organisations" */
export type Organisations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Organisations_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "organisations". All fields are combined with a logical 'AND'. */
export type Organisations_Bool_Exp = {
  _and?: InputMaybe<Array<Organisations_Bool_Exp>>;
  _not?: InputMaybe<Organisations_Bool_Exp>;
  _or?: InputMaybe<Array<Organisations_Bool_Exp>>;
  branding_color?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  emails?: InputMaybe<Emails_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_default_lender?: InputMaybe<Boolean_Comparison_Exp>;
  is_lender?: InputMaybe<Boolean_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisation_images?: InputMaybe<Organisation_Images_Bool_Exp>;
  organisation_users?: InputMaybe<Organisation_Users_Bool_Exp>;
  parent_organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  phone_numbers?: InputMaybe<Phone_Numbers_Bool_Exp>;
  phone_numbers_aggregate?: InputMaybe<Phone_Numbers_Aggregate_Bool_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  teams?: InputMaybe<Teams_Bool_Exp>;
  teams_aggregate?: InputMaybe<Teams_Aggregate_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisations" */
export enum Organisations_Constraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  OrganisationsIdTenantIdUnique = 'organisations_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  OrganisationsPkey = 'organisations_pkey'
}

/** input type for inserting data into table "organisations" */
export type Organisations_Insert_Input = {
  branding_color?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Emails_Arr_Rel_Insert_Input>;
  is_lender?: InputMaybe<Scalars['Boolean']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation_images?: InputMaybe<Organisation_Images_Arr_Rel_Insert_Input>;
  phone_numbers?: InputMaybe<Phone_Numbers_Arr_Rel_Insert_Input>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Teams_Arr_Rel_Insert_Input>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Organisations_Max_Fields = {
  branding_color?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_organisation_id?: Maybe<Scalars['uuid']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Organisations_Min_Fields = {
  branding_color?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_organisation_id?: Maybe<Scalars['uuid']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "organisations" */
export type Organisations_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisations>;
};

/** input type for inserting object relation for remote table "organisations" */
export type Organisations_Obj_Rel_Insert_Input = {
  data: Organisations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisations_On_Conflict>;
};

/** on_conflict condition type for table "organisations" */
export type Organisations_On_Conflict = {
  constraint: Organisations_Constraint;
  update_columns?: Array<Organisations_Update_Column>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};

/** Ordering options when selecting data from "organisations". */
export type Organisations_Order_By = {
  branding_color?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  emails_aggregate?: InputMaybe<Emails_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_default_lender?: InputMaybe<Order_By>;
  is_lender?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_images_aggregate?: InputMaybe<Organisation_Images_Aggregate_Order_By>;
  organisation_users_aggregate?: InputMaybe<Organisation_Users_Aggregate_Order_By>;
  parent_organisation_id?: InputMaybe<Order_By>;
  phone_numbers_aggregate?: InputMaybe<Phone_Numbers_Aggregate_Order_By>;
  postcode?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  teams_aggregate?: InputMaybe<Teams_Aggregate_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisations */
export type Organisations_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

export type Organisations_Search_Args = {
  order_by_first_ids?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** select columns of table "organisations" */
export enum Organisations_Select_Column {
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefaultLender = 'is_default_lender',
  /** column name */
  IsLender = 'is_lender',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  Name = 'name',
  /** column name */
  ParentOrganisationId = 'parent_organisation_id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  State = 'state',
  /** column name */
  Street = 'street',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Website = 'website'
}

/** input type for updating data in table "organisations" */
export type Organisations_Set_Input = {
  branding_color?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  is_lender?: InputMaybe<Scalars['Boolean']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Organisations_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Organisations_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Organisations_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "organisations" */
export type Organisations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisations_Stream_Cursor_Value_Input = {
  branding_color?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_default_lender?: InputMaybe<Scalars['Boolean']['input']>;
  is_lender?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Organisations_Sum_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** update columns of table "organisations" */
export enum Organisations_Update_Column {
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  Country = 'country',
  /** column name */
  IsLender = 'is_lender',
  /** column name */
  Locality = 'locality',
  /** column name */
  Name = 'name',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  State = 'state',
  /** column name */
  Street = 'street',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  Website = 'website'
}

export type Organisations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organisations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organisations_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Organisations_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Organisations_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export enum Parking_Price_Type_Enum_Enum {
  /** Price per parking space */
  PerSpacePrice = 'per_space_price',
  /** Total price */
  TotalPrice = 'total_price'
}

/** Boolean expression to compare columns of type "parking_price_type_enum_enum". All fields are combined with logical 'AND'. */
export type Parking_Price_Type_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Parking_Price_Type_Enum_Enum>;
  _in?: InputMaybe<Array<Parking_Price_Type_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Parking_Price_Type_Enum_Enum>;
  _nin?: InputMaybe<Array<Parking_Price_Type_Enum_Enum>>;
};

/** columns and relationships of "payments" */
export type Payments = {
  amount?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  payment_created_at?: Maybe<Scalars['timestamptz']['output']>;
  payment_intent_id?: Maybe<Scalars['String']['output']>;
  payment_intent_raw?: Maybe<Scalars['jsonb']['output']>;
  receipt_url?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "payments" */
export type PaymentsPayment_Intent_RawArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "payments" */
export type Payments_Aggregate_Order_By = {
  avg?: InputMaybe<Payments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payments_Max_Order_By>;
  min?: InputMaybe<Payments_Min_Order_By>;
  stddev?: InputMaybe<Payments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payments_Sum_Order_By>;
  var_pop?: InputMaybe<Payments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payments_Var_Samp_Order_By>;
  variance?: InputMaybe<Payments_Variance_Order_By>;
};

/** order by avg() on columns of table "payments" */
export type Payments_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payments". All fields are combined with a logical 'AND'. */
export type Payments_Bool_Exp = {
  _and?: InputMaybe<Array<Payments_Bool_Exp>>;
  _not?: InputMaybe<Payments_Bool_Exp>;
  _or?: InputMaybe<Array<Payments_Bool_Exp>>;
  amount?: InputMaybe<Float_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  payment_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  payment_intent_id?: InputMaybe<String_Comparison_Exp>;
  payment_intent_raw?: InputMaybe<Jsonb_Comparison_Exp>;
  receipt_url?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "payments" */
export type Payments_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_created_at?: InputMaybe<Order_By>;
  payment_intent_id?: InputMaybe<Order_By>;
  receipt_url?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "payments" */
export type Payments_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_created_at?: InputMaybe<Order_By>;
  payment_intent_id?: InputMaybe<Order_By>;
  receipt_url?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "payments". */
export type Payments_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_created_at?: InputMaybe<Order_By>;
  payment_intent_id?: InputMaybe<Order_By>;
  payment_intent_raw?: InputMaybe<Order_By>;
  receipt_url?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "payments" */
export enum Payments_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentCreatedAt = 'payment_created_at',
  /** column name */
  PaymentIntentId = 'payment_intent_id',
  /** column name */
  PaymentIntentRaw = 'payment_intent_raw',
  /** column name */
  ReceiptUrl = 'receipt_url',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** order by stddev() on columns of table "payments" */
export type Payments_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "payments" */
export type Payments_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "payments" */
export type Payments_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "payments" */
export type Payments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payments_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  payment_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent_raw?: InputMaybe<Scalars['jsonb']['input']>;
  receipt_url?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "payments" */
export type Payments_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "payments" */
export type Payments_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "payments" */
export type Payments_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "payments" */
export type Payments_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "pdf_compression_quality". All fields are combined with logical 'AND'. */
export type Pdf_Compression_Quality_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _gt?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _gte?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _in?: InputMaybe<Array<Scalars['pdf_compression_quality']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _lte?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _neq?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _nin?: InputMaybe<Array<Scalars['pdf_compression_quality']['input']>>;
};

/** columns and relationships of "phone_number_type_enum" */
export type Phone_Number_Type_Enum = {
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "phone_number_type_enum". All fields are combined with a logical 'AND'. */
export type Phone_Number_Type_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Phone_Number_Type_Enum_Bool_Exp>>;
  _not?: InputMaybe<Phone_Number_Type_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Phone_Number_Type_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "phone_number_type_enum" */
export enum Phone_Number_Type_Enum_Constraint {
  /** unique or primary key constraint on columns "value" */
  PhoneNumberTypeEnumPkey = 'phone_number_type_enum_pkey'
}

export enum Phone_Number_Type_Enum_Enum {
  /** Home phone number */
  Home = 'home',
  /** Mobile phone number */
  Mobile = 'mobile',
  /** Other phone number */
  Other = 'other',
  /** Proxy number user to track calls */
  Proxy = 'proxy',
  /** Work phone number */
  Work = 'work'
}

/** Boolean expression to compare columns of type "phone_number_type_enum_enum". All fields are combined with logical 'AND'. */
export type Phone_Number_Type_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Phone_Number_Type_Enum_Enum>;
  _in?: InputMaybe<Array<Phone_Number_Type_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Phone_Number_Type_Enum_Enum>;
  _nin?: InputMaybe<Array<Phone_Number_Type_Enum_Enum>>;
};

/** input type for inserting data into table "phone_number_type_enum" */
export type Phone_Number_Type_Enum_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "phone_number_type_enum" */
export type Phone_Number_Type_Enum_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Phone_Number_Type_Enum>;
};

/** on_conflict condition type for table "phone_number_type_enum" */
export type Phone_Number_Type_Enum_On_Conflict = {
  constraint: Phone_Number_Type_Enum_Constraint;
  update_columns?: Array<Phone_Number_Type_Enum_Update_Column>;
  where?: InputMaybe<Phone_Number_Type_Enum_Bool_Exp>;
};

/** Ordering options when selecting data from "phone_number_type_enum". */
export type Phone_Number_Type_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "phone_number_type_enum" */
export enum Phone_Number_Type_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "phone_number_type_enum" */
export type Phone_Number_Type_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Phone_Number_Type_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Phone_Number_Type_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** placeholder for update columns of table "phone_number_type_enum" (current role has no relevant permissions) */
export enum Phone_Number_Type_Enum_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "phone_numbers" */
export type Phone_Numbers = {
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  number: Scalars['String']['output'];
  /** An object relationship */
  organisation?: Maybe<Organisations>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id: Scalars['uuid']['output'];
  type?: Maybe<Phone_Number_Type_Enum_Enum>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  verification_attempts?: Maybe<Scalars['Int']['output']>;
  verification_code?: Maybe<Scalars['Int']['output']>;
  verification_codes_sent?: Maybe<Scalars['Int']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "phone_numbers" */
export type Phone_Numbers_Aggregate = {
  aggregate?: Maybe<Phone_Numbers_Aggregate_Fields>;
  nodes: Array<Phone_Numbers>;
};

export type Phone_Numbers_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Phone_Numbers_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Phone_Numbers_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Phone_Numbers_Aggregate_Bool_Exp_Count>;
};

export type Phone_Numbers_Aggregate_Bool_Exp_Bool_And = {
  arguments: Phone_Numbers_Select_Column_Phone_Numbers_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Phone_Numbers_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Phone_Numbers_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Phone_Numbers_Select_Column_Phone_Numbers_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Phone_Numbers_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Phone_Numbers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Phone_Numbers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "phone_numbers" */
export type Phone_Numbers_Aggregate_Fields = {
  avg?: Maybe<Phone_Numbers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Phone_Numbers_Max_Fields>;
  min?: Maybe<Phone_Numbers_Min_Fields>;
  stddev?: Maybe<Phone_Numbers_Stddev_Fields>;
  stddev_pop?: Maybe<Phone_Numbers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Phone_Numbers_Stddev_Samp_Fields>;
  sum?: Maybe<Phone_Numbers_Sum_Fields>;
  var_pop?: Maybe<Phone_Numbers_Var_Pop_Fields>;
  var_samp?: Maybe<Phone_Numbers_Var_Samp_Fields>;
  variance?: Maybe<Phone_Numbers_Variance_Fields>;
};


/** aggregate fields of "phone_numbers" */
export type Phone_Numbers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "phone_numbers" */
export type Phone_Numbers_Aggregate_Order_By = {
  avg?: InputMaybe<Phone_Numbers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Phone_Numbers_Max_Order_By>;
  min?: InputMaybe<Phone_Numbers_Min_Order_By>;
  stddev?: InputMaybe<Phone_Numbers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Phone_Numbers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Phone_Numbers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Phone_Numbers_Sum_Order_By>;
  var_pop?: InputMaybe<Phone_Numbers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Phone_Numbers_Var_Samp_Order_By>;
  variance?: InputMaybe<Phone_Numbers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "phone_numbers" */
export type Phone_Numbers_Arr_Rel_Insert_Input = {
  data: Array<Phone_Numbers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Phone_Numbers_On_Conflict>;
};

/** aggregate avg on columns */
export type Phone_Numbers_Avg_Fields = {
  verification_attempts?: Maybe<Scalars['Float']['output']>;
  verification_code?: Maybe<Scalars['Float']['output']>;
  verification_codes_sent?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "phone_numbers" */
export type Phone_Numbers_Avg_Order_By = {
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "phone_numbers". All fields are combined with a logical 'AND'. */
export type Phone_Numbers_Bool_Exp = {
  _and?: InputMaybe<Array<Phone_Numbers_Bool_Exp>>;
  _not?: InputMaybe<Phone_Numbers_Bool_Exp>;
  _or?: InputMaybe<Array<Phone_Numbers_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  primary?: InputMaybe<Boolean_Comparison_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Phone_Number_Type_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  verification_attempts?: InputMaybe<Int_Comparison_Exp>;
  verification_code?: InputMaybe<Int_Comparison_Exp>;
  verification_codes_sent?: InputMaybe<Int_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "phone_numbers" */
export enum Phone_Numbers_Constraint {
  /** unique or primary key constraint on columns "id" */
  PhoneNumbersPkey = 'phone_numbers_pkey',
  /** unique or primary key constraint on columns "tenant_id", "number" */
  PhoneNumbersTenantIdOrganisationIdUnique = 'phone_numbers_tenant_id_organisation_id_unique',
  /** unique or primary key constraint on columns "tenant_id", "number" */
  PhoneNumbersTenantIdUserIdUnique = 'phone_numbers_tenant_id_user_id_unique'
}

/** input type for inserting data into table "phone_numbers" */
export type Phone_Numbers_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  organisation?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Phone_Number_Type_Enum_Enum>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Phone_Numbers_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  verification_attempts?: Maybe<Scalars['Int']['output']>;
  verification_code?: Maybe<Scalars['Int']['output']>;
  verification_codes_sent?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "phone_numbers" */
export type Phone_Numbers_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Phone_Numbers_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  verification_attempts?: Maybe<Scalars['Int']['output']>;
  verification_code?: Maybe<Scalars['Int']['output']>;
  verification_codes_sent?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "phone_numbers" */
export type Phone_Numbers_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "phone_numbers" */
export type Phone_Numbers_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Phone_Numbers>;
};

/** on_conflict condition type for table "phone_numbers" */
export type Phone_Numbers_On_Conflict = {
  constraint: Phone_Numbers_Constraint;
  update_columns?: Array<Phone_Numbers_Update_Column>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};

/** Ordering options when selecting data from "phone_numbers". */
export type Phone_Numbers_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisations_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  primary?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: phone_numbers */
export type Phone_Numbers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "phone_numbers" */
export enum Phone_Numbers_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Primary = 'primary',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VerificationAttempts = 'verification_attempts',
  /** column name */
  VerificationCode = 'verification_code',
  /** column name */
  VerificationCodesSent = 'verification_codes_sent',
  /** column name */
  Verified = 'verified'
}

/** select "phone_numbers_aggregate_bool_exp_bool_and_arguments_columns" columns of table "phone_numbers" */
export enum Phone_Numbers_Select_Column_Phone_Numbers_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Primary = 'primary',
  /** column name */
  Verified = 'verified'
}

/** select "phone_numbers_aggregate_bool_exp_bool_or_arguments_columns" columns of table "phone_numbers" */
export enum Phone_Numbers_Select_Column_Phone_Numbers_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Primary = 'primary',
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "phone_numbers" */
export type Phone_Numbers_Set_Input = {
  number?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Phone_Number_Type_Enum_Enum>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Phone_Numbers_Stddev_Fields = {
  verification_attempts?: Maybe<Scalars['Float']['output']>;
  verification_code?: Maybe<Scalars['Float']['output']>;
  verification_codes_sent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "phone_numbers" */
export type Phone_Numbers_Stddev_Order_By = {
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Phone_Numbers_Stddev_Pop_Fields = {
  verification_attempts?: Maybe<Scalars['Float']['output']>;
  verification_code?: Maybe<Scalars['Float']['output']>;
  verification_codes_sent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "phone_numbers" */
export type Phone_Numbers_Stddev_Pop_Order_By = {
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Phone_Numbers_Stddev_Samp_Fields = {
  verification_attempts?: Maybe<Scalars['Float']['output']>;
  verification_code?: Maybe<Scalars['Float']['output']>;
  verification_codes_sent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "phone_numbers" */
export type Phone_Numbers_Stddev_Samp_Order_By = {
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "phone_numbers" */
export type Phone_Numbers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Phone_Numbers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Phone_Numbers_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Phone_Number_Type_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verification_attempts?: InputMaybe<Scalars['Int']['input']>;
  verification_code?: InputMaybe<Scalars['Int']['input']>;
  verification_codes_sent?: InputMaybe<Scalars['Int']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Phone_Numbers_Sum_Fields = {
  verification_attempts?: Maybe<Scalars['Int']['output']>;
  verification_code?: Maybe<Scalars['Int']['output']>;
  verification_codes_sent?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "phone_numbers" */
export type Phone_Numbers_Sum_Order_By = {
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** update columns of table "phone_numbers" */
export enum Phone_Numbers_Update_Column {
  /** column name */
  Number = 'number',
  /** column name */
  Primary = 'primary',
  /** column name */
  Type = 'type',
  /** column name */
  Verified = 'verified'
}

export type Phone_Numbers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Phone_Numbers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Phone_Numbers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Phone_Numbers_Var_Pop_Fields = {
  verification_attempts?: Maybe<Scalars['Float']['output']>;
  verification_code?: Maybe<Scalars['Float']['output']>;
  verification_codes_sent?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "phone_numbers" */
export type Phone_Numbers_Var_Pop_Order_By = {
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Phone_Numbers_Var_Samp_Fields = {
  verification_attempts?: Maybe<Scalars['Float']['output']>;
  verification_code?: Maybe<Scalars['Float']['output']>;
  verification_codes_sent?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "phone_numbers" */
export type Phone_Numbers_Var_Samp_Order_By = {
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Phone_Numbers_Variance_Fields = {
  verification_attempts?: Maybe<Scalars['Float']['output']>;
  verification_code?: Maybe<Scalars['Float']['output']>;
  verification_codes_sent?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "phone_numbers" */
export type Phone_Numbers_Variance_Order_By = {
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** columns and relationships of "pipelines" */
export type Pipelines = {
  created_at: Scalars['timestamptz']['output'];
  deletable?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  /** computed label based on x-hasura-website-language session variable */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  lead_type: Scalars['lead_type']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  stages: Array<Lead_Stages>;
  /** An aggregate relationship */
  stages_aggregate: Lead_Stages_Aggregate;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "pipelines" */
export type PipelinesStagesArgs = {
  distinct_on?: InputMaybe<Array<Lead_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Stages_Order_By>>;
  where?: InputMaybe<Lead_Stages_Bool_Exp>;
};


/** columns and relationships of "pipelines" */
export type PipelinesStages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Stages_Order_By>>;
  where?: InputMaybe<Lead_Stages_Bool_Exp>;
};

/** aggregated selection of "pipelines" */
export type Pipelines_Aggregate = {
  aggregate?: Maybe<Pipelines_Aggregate_Fields>;
  nodes: Array<Pipelines>;
};

/** aggregate fields of "pipelines" */
export type Pipelines_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Pipelines_Max_Fields>;
  min?: Maybe<Pipelines_Min_Fields>;
};


/** aggregate fields of "pipelines" */
export type Pipelines_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pipelines_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "pipelines". All fields are combined with a logical 'AND'. */
export type Pipelines_Bool_Exp = {
  _and?: InputMaybe<Array<Pipelines_Bool_Exp>>;
  _not?: InputMaybe<Pipelines_Bool_Exp>;
  _or?: InputMaybe<Array<Pipelines_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletable?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  lead_type?: InputMaybe<Lead_Type_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  stages?: InputMaybe<Lead_Stages_Bool_Exp>;
  stages_aggregate?: InputMaybe<Lead_Stages_Aggregate_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "pipelines" */
export enum Pipelines_Constraint {
  /** unique or primary key constraint on columns "id" */
  PipelinesPkey = 'pipelines_pkey'
}

/** input type for inserting data into table "pipelines" */
export type Pipelines_Insert_Input = {
  deletable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  lead_type?: InputMaybe<Scalars['lead_type']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stages?: InputMaybe<Lead_Stages_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Pipelines_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** computed label based on x-hasura-website-language session variable */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  lead_type?: Maybe<Scalars['lead_type']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Pipelines_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** computed label based on x-hasura-website-language session variable */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  lead_type?: Maybe<Scalars['lead_type']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "pipelines" */
export type Pipelines_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pipelines>;
};

/** input type for inserting object relation for remote table "pipelines" */
export type Pipelines_Obj_Rel_Insert_Input = {
  data: Pipelines_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pipelines_On_Conflict>;
};

/** on_conflict condition type for table "pipelines" */
export type Pipelines_On_Conflict = {
  constraint: Pipelines_Constraint;
  update_columns?: Array<Pipelines_Update_Column>;
  where?: InputMaybe<Pipelines_Bool_Exp>;
};

/** Ordering options when selecting data from "pipelines". */
export type Pipelines_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deletable?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  lead_type?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  stages_aggregate?: InputMaybe<Lead_Stages_Aggregate_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pipelines */
export type Pipelines_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "pipelines" */
export enum Pipelines_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deletable = 'deletable',
  /** column name */
  Id = 'id',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LeadType = 'lead_type',
  /** column name */
  Name = 'name',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "pipelines" */
export type Pipelines_Set_Input = {
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  lead_type?: InputMaybe<Scalars['lead_type']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "pipelines" */
export type Pipelines_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pipelines_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pipelines_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deletable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  lead_type?: InputMaybe<Scalars['lead_type']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "pipelines" */
export enum Pipelines_Update_Column {
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LeadType = 'lead_type',
  /** column name */
  Name = 'name'
}

export type Pipelines_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pipelines_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pipelines_Bool_Exp;
};

export type Place_By_Slug_Args = {
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type Place_By_Type_Args = {
  hasura_type?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['uuid']['input']>;
  municipality?: InputMaybe<Scalars['uuid']['input']>;
  neighbourhood?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['uuid']['input']>;
};

export enum Place_Type_Enum_Enum {
  /** Agglomeration */
  Agglomeration = 'agglomeration',
  /** Сountry */
  Country = 'country',
  /** District */
  District = 'district',
  /** Locality */
  Locality = 'locality',
  /** Municipality */
  Municipality = 'municipality',
  /** Neighbourhood */
  Neighbourhood = 'neighbourhood',
  /** Postcode */
  Postcode = 'postcode',
  /** Region */
  Region = 'region',
  /** State */
  State = 'state'
}

/** Boolean expression to compare columns of type "place_type_enum_enum". All fields are combined with logical 'AND'. */
export type Place_Type_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Place_Type_Enum_Enum>;
  _in?: InputMaybe<Array<Place_Type_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Place_Type_Enum_Enum>;
  _nin?: InputMaybe<Array<Place_Type_Enum_Enum>>;
};

/** columns and relationships of "places" */
export type Places = {
  /** A computed field, executes function "places_agent_ranking" */
  agent_ranking?: Maybe<Array<Agents_Rankings>>;
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  canonical_place?: Maybe<Places>;
  /** An array relationship */
  catchment_areas: Array<Catchment_Areas>;
  /** An aggregate relationship */
  catchment_areas_aggregate: Catchment_Areas_Aggregate;
  children_bbox: Scalars['jsonb']['output'];
  /** An object relationship */
  country?: Maybe<Places>;
  country_code: Scalars['String']['output'];
  /** An object relationship */
  country_place?: Maybe<Places>;
  /** An object relationship */
  district?: Maybe<Places>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  extra: Scalars['jsonb']['output'];
  geom: Scalars['geometry']['output'];
  hasura_type?: Maybe<Place_Type_Enum_Enum>;
  id: Scalars['uuid']['output'];
  /** to use instead of repetitive logic on client, x-hasura-website-language must be set */
  in_label?: Maybe<Scalars['String']['output']>;
  in_label_fr?: Maybe<Scalars['String']['output']>;
  index: Scalars['Boolean']['output'];
  index_rooms: Scalars['Boolean']['output'];
  /** to use instead of label_en label_de etc, x-hasura-website-language must be set */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  /** An object relationship */
  locality?: Maybe<Places>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  municipality?: Maybe<Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  municipality_places: Array<Places>;
  name: Scalars['String']['output'];
  /** An object relationship */
  neighbourhood?: Maybe<Places>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  parent_places?: Maybe<Array<Places>>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  /** Gets all properties in a given place */
  properties?: Maybe<Array<Properties>>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  search_base: Scalars['tsvector']['output'];
  simplified_geom?: Maybe<Scalars['geometry']['output']>;
  /** to use instead of slug_en slug_de etc, x-hasura-website-language must be set */
  slug?: Maybe<Scalars['String']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  state?: Maybe<Places>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  state_places: Array<Places>;
  /** A computed field, executes function "places_team_ranking" */
  team_ranking?: Maybe<Array<Teams_Rankings>>;
  type: Place_Type_Enum_Enum;
};


/** columns and relationships of "places" */
export type PlacesAgent_RankingArgs = {
  args?: InputMaybe<Agent_Ranking_Places_Args>;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


/** columns and relationships of "places" */
export type PlacesCatchment_AreasArgs = {
  distinct_on?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Catchment_Areas_Order_By>>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};


/** columns and relationships of "places" */
export type PlacesCatchment_Areas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Catchment_Areas_Order_By>>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};


/** columns and relationships of "places" */
export type PlacesChildren_BboxArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "places" */
export type PlacesExtraArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "places" */
export type PlacesMunicipality_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type PlacesParent_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type PlacesPropertiesArgs = {
  distinct_on?: InputMaybe<Array<Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Properties_Order_By>>;
  where?: InputMaybe<Properties_Bool_Exp>;
};


/** columns and relationships of "places" */
export type PlacesState_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


/** columns and relationships of "places" */
export type PlacesTeam_RankingArgs = {
  args?: InputMaybe<Team_Ranking_Places_Args>;
  distinct_on?: InputMaybe<Array<Teams_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Rankings_Order_By>>;
  where?: InputMaybe<Teams_Rankings_Bool_Exp>;
};

export type Places_Agent_Ranking_Args = {
  exclude_rental_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  hasura_session?: InputMaybe<Scalars['json']['input']>;
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  offset_count?: InputMaybe<Scalars['Int']['input']>;
  place_row?: InputMaybe<Scalars['places_scalar']['input']>;
  transaction_radius?: InputMaybe<Scalars['float8']['input']>;
};

/** order by aggregate values of table "places" */
export type Places_Aggregate_Order_By = {
  avg?: InputMaybe<Places_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Places_Max_Order_By>;
  min?: InputMaybe<Places_Min_Order_By>;
  stddev?: InputMaybe<Places_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Places_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Places_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Places_Sum_Order_By>;
  var_pop?: InputMaybe<Places_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Places_Var_Samp_Order_By>;
  variance?: InputMaybe<Places_Variance_Order_By>;
};

/** order by avg() on columns of table "places" */
export type Places_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places". All fields are combined with a logical 'AND'. */
export type Places_Bool_Exp = {
  _and?: InputMaybe<Array<Places_Bool_Exp>>;
  _not?: InputMaybe<Places_Bool_Exp>;
  _or?: InputMaybe<Array<Places_Bool_Exp>>;
  agglomeration_id?: InputMaybe<Uuid_Comparison_Exp>;
  canonical_id?: InputMaybe<Uuid_Comparison_Exp>;
  canonical_place?: InputMaybe<Places_Bool_Exp>;
  catchment_areas?: InputMaybe<Catchment_Areas_Bool_Exp>;
  catchment_areas_aggregate?: InputMaybe<Catchment_Areas_Aggregate_Bool_Exp>;
  children_bbox?: InputMaybe<Jsonb_Comparison_Exp>;
  country?: InputMaybe<Places_Bool_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  country_place?: InputMaybe<Places_Bool_Exp>;
  district?: InputMaybe<Places_Bool_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  extra?: InputMaybe<Jsonb_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  hasura_type?: InputMaybe<Place_Type_Enum_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  in_label?: InputMaybe<String_Comparison_Exp>;
  in_label_fr?: InputMaybe<String_Comparison_Exp>;
  index?: InputMaybe<Boolean_Comparison_Exp>;
  index_rooms?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<Places_Bool_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality?: InputMaybe<Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality_places?: InputMaybe<Places_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  neighbourhood?: InputMaybe<Places_Bool_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_places?: InputMaybe<Places_Bool_Exp>;
  population?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  properties?: InputMaybe<Properties_Bool_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  search_base?: InputMaybe<Tsvector_Comparison_Exp>;
  simplified_geom?: InputMaybe<Geometry_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  slug_de?: InputMaybe<String_Comparison_Exp>;
  slug_en?: InputMaybe<String_Comparison_Exp>;
  slug_es?: InputMaybe<String_Comparison_Exp>;
  slug_fr?: InputMaybe<String_Comparison_Exp>;
  slug_it?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<Places_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  state_places?: InputMaybe<Places_Bool_Exp>;
  type?: InputMaybe<Place_Type_Enum_Enum_Comparison_Exp>;
};

/** order by max() on columns of table "places" */
export type Places_Max_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_label_fr?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "places" */
export type Places_Min_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_label_fr?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places". */
export type Places_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  canonical_place?: InputMaybe<Places_Order_By>;
  catchment_areas_aggregate?: InputMaybe<Catchment_Areas_Aggregate_Order_By>;
  children_bbox?: InputMaybe<Order_By>;
  country?: InputMaybe<Places_Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_place?: InputMaybe<Places_Order_By>;
  district?: InputMaybe<Places_Order_By>;
  district_id?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  hasura_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_label?: InputMaybe<Order_By>;
  in_label_fr?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  index_rooms?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Places_Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  municipality_places_aggregate?: InputMaybe<Places_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood?: InputMaybe<Places_Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  parent_places_aggregate?: InputMaybe<Places_Aggregate_Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  properties_aggregate?: InputMaybe<Properties_Aggregate_Order_By>;
  region_id?: InputMaybe<Order_By>;
  search_base?: InputMaybe<Order_By>;
  simplified_geom?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  state?: InputMaybe<Places_Order_By>;
  state_id?: InputMaybe<Order_By>;
  state_places_aggregate?: InputMaybe<Places_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "places" */
export enum Places_Select_Column {
  /** column name */
  AgglomerationId = 'agglomeration_id',
  /** column name */
  CanonicalId = 'canonical_id',
  /** column name */
  ChildrenBbox = 'children_bbox',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  HasuraType = 'hasura_type',
  /** column name */
  Id = 'id',
  /** column name */
  InLabelFr = 'in_label_fr',
  /** column name */
  Index = 'index',
  /** column name */
  IndexRooms = 'index_rooms',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  Population = 'population',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SearchBase = 'search_base',
  /** column name */
  SimplifiedGeom = 'simplified_geom',
  /** column name */
  SlugDe = 'slug_de',
  /** column name */
  SlugEn = 'slug_en',
  /** column name */
  SlugEs = 'slug_es',
  /** column name */
  SlugFr = 'slug_fr',
  /** column name */
  SlugIt = 'slug_it',
  /** column name */
  StateId = 'state_id',
  /** column name */
  Type = 'type'
}

/** order by stddev() on columns of table "places" */
export type Places_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "places" */
export type Places_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "places" */
export type Places_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "places" */
export type Places_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Places_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Places_Stream_Cursor_Value_Input = {
  agglomeration_id?: InputMaybe<Scalars['uuid']['input']>;
  canonical_id?: InputMaybe<Scalars['uuid']['input']>;
  children_bbox?: InputMaybe<Scalars['jsonb']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  district_id?: InputMaybe<Scalars['uuid']['input']>;
  extra?: InputMaybe<Scalars['jsonb']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  hasura_type?: InputMaybe<Place_Type_Enum_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  in_label_fr?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Boolean']['input']>;
  index_rooms?: InputMaybe<Scalars['Boolean']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  population?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  region_id?: InputMaybe<Scalars['uuid']['input']>;
  search_base?: InputMaybe<Scalars['tsvector']['input']>;
  simplified_geom?: InputMaybe<Scalars['geometry']['input']>;
  slug_de?: InputMaybe<Scalars['String']['input']>;
  slug_en?: InputMaybe<Scalars['String']['input']>;
  slug_es?: InputMaybe<Scalars['String']['input']>;
  slug_fr?: InputMaybe<Scalars['String']['input']>;
  slug_it?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Place_Type_Enum_Enum>;
};

/** order by sum() on columns of table "places" */
export type Places_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "places" */
export type Places_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "places" */
export type Places_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "places" */
export type Places_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** columns and relationships of "pois" */
export type Pois = {
  category: Scalars['String']['output'];
  formatted_address: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  lat: Scalars['float8']['output'];
  lng: Scalars['float8']['output'];
  name: Scalars['String']['output'];
  primary_type: Scalars['String']['output'];
  /** An array relationship */
  property_pois: Array<Property_Pois>;
  types: Array<Scalars['String']['output']>;
};


/** columns and relationships of "pois" */
export type PoisProperty_PoisArgs = {
  distinct_on?: InputMaybe<Array<Property_Pois_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Pois_Order_By>>;
  where?: InputMaybe<Property_Pois_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "pois". All fields are combined with a logical 'AND'. */
export type Pois_Bool_Exp = {
  _and?: InputMaybe<Array<Pois_Bool_Exp>>;
  _not?: InputMaybe<Pois_Bool_Exp>;
  _or?: InputMaybe<Array<Pois_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  formatted_address?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  primary_type?: InputMaybe<String_Comparison_Exp>;
  property_pois?: InputMaybe<Property_Pois_Bool_Exp>;
  types?: InputMaybe<String_Array_Comparison_Exp>;
};

/** Ordering options when selecting data from "pois". */
export type Pois_Order_By = {
  category?: InputMaybe<Order_By>;
  formatted_address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  primary_type?: InputMaybe<Order_By>;
  property_pois_aggregate?: InputMaybe<Property_Pois_Aggregate_Order_By>;
  types?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "portal_idx_protocol". All fields are combined with logical 'AND'. */
export type Portal_Idx_Protocol_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _gt?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _gte?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _in?: InputMaybe<Array<Scalars['portal_idx_protocol']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _lte?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _neq?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _nin?: InputMaybe<Array<Scalars['portal_idx_protocol']['input']>>;
};

/** columns and relationships of "portal_listings" */
export type Portal_Listings = {
  created_at: Scalars['timestamptz']['output'];
  external_property_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  last_publication_warnings?: Maybe<Scalars['jsonb']['output']>;
  live: Scalars['Boolean']['output'];
  /** An object relationship */
  lot: Lots;
  lot_id: Scalars['uuid']['output'];
  milliseconds_online: Scalars['Float']['output'];
  /** An object relationship */
  portal: Portals;
  portal_id: Scalars['uuid']['output'];
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "portal_listings" */
export type Portal_ListingsLast_Publication_WarningsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "portal_listings" */
export type Portal_Listings_Aggregate = {
  aggregate?: Maybe<Portal_Listings_Aggregate_Fields>;
  nodes: Array<Portal_Listings>;
};

export type Portal_Listings_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Portal_Listings_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Portal_Listings_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Portal_Listings_Aggregate_Bool_Exp_Count>;
};

export type Portal_Listings_Aggregate_Bool_Exp_Bool_And = {
  arguments: Portal_Listings_Select_Column_Portal_Listings_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Portal_Listings_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Portal_Listings_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Portal_Listings_Select_Column_Portal_Listings_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Portal_Listings_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Portal_Listings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Portal_Listings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "portal_listings" */
export type Portal_Listings_Aggregate_Fields = {
  avg?: Maybe<Portal_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Portal_Listings_Max_Fields>;
  min?: Maybe<Portal_Listings_Min_Fields>;
  stddev?: Maybe<Portal_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Portal_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Portal_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Portal_Listings_Sum_Fields>;
  var_pop?: Maybe<Portal_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Portal_Listings_Var_Samp_Fields>;
  variance?: Maybe<Portal_Listings_Variance_Fields>;
};


/** aggregate fields of "portal_listings" */
export type Portal_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "portal_listings" */
export type Portal_Listings_Aggregate_Order_By = {
  avg?: InputMaybe<Portal_Listings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Portal_Listings_Max_Order_By>;
  min?: InputMaybe<Portal_Listings_Min_Order_By>;
  stddev?: InputMaybe<Portal_Listings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Portal_Listings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Portal_Listings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Portal_Listings_Sum_Order_By>;
  var_pop?: InputMaybe<Portal_Listings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Portal_Listings_Var_Samp_Order_By>;
  variance?: InputMaybe<Portal_Listings_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Portal_Listings_Avg_Fields = {
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "portal_listings" */
export type Portal_Listings_Avg_Order_By = {
  milliseconds_online?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "portal_listings". All fields are combined with a logical 'AND'. */
export type Portal_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Portal_Listings_Bool_Exp>>;
  _not?: InputMaybe<Portal_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Portal_Listings_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  external_property_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_publication_warnings?: InputMaybe<Jsonb_Comparison_Exp>;
  live?: InputMaybe<Boolean_Comparison_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  milliseconds_online?: InputMaybe<Float_Comparison_Exp>;
  portal?: InputMaybe<Portals_Bool_Exp>;
  portal_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Portal_Listings_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  external_property_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
  portal_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "portal_listings" */
export type Portal_Listings_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  external_property_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  milliseconds_online?: InputMaybe<Order_By>;
  portal_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Portal_Listings_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  external_property_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
  portal_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "portal_listings" */
export type Portal_Listings_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  external_property_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  milliseconds_online?: InputMaybe<Order_By>;
  portal_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "portal_listings". */
export type Portal_Listings_Order_By = {
  created_at?: InputMaybe<Order_By>;
  external_property_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_publication_warnings?: InputMaybe<Order_By>;
  live?: InputMaybe<Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  milliseconds_online?: InputMaybe<Order_By>;
  portal?: InputMaybe<Portals_Order_By>;
  portal_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "portal_listings" */
export enum Portal_Listings_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalPropertyId = 'external_property_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastPublicationWarnings = 'last_publication_warnings',
  /** column name */
  Live = 'live',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  MillisecondsOnline = 'milliseconds_online',
  /** column name */
  PortalId = 'portal_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "portal_listings_aggregate_bool_exp_bool_and_arguments_columns" columns of table "portal_listings" */
export enum Portal_Listings_Select_Column_Portal_Listings_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Live = 'live'
}

/** select "portal_listings_aggregate_bool_exp_bool_or_arguments_columns" columns of table "portal_listings" */
export enum Portal_Listings_Select_Column_Portal_Listings_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Live = 'live'
}

/** aggregate stddev on columns */
export type Portal_Listings_Stddev_Fields = {
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "portal_listings" */
export type Portal_Listings_Stddev_Order_By = {
  milliseconds_online?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Portal_Listings_Stddev_Pop_Fields = {
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "portal_listings" */
export type Portal_Listings_Stddev_Pop_Order_By = {
  milliseconds_online?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Portal_Listings_Stddev_Samp_Fields = {
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "portal_listings" */
export type Portal_Listings_Stddev_Samp_Order_By = {
  milliseconds_online?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "portal_listings" */
export type Portal_Listings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Portal_Listings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Portal_Listings_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_property_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_publication_warnings?: InputMaybe<Scalars['jsonb']['input']>;
  live?: InputMaybe<Scalars['Boolean']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  milliseconds_online?: InputMaybe<Scalars['Float']['input']>;
  portal_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Portal_Listings_Sum_Fields = {
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "portal_listings" */
export type Portal_Listings_Sum_Order_By = {
  milliseconds_online?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Portal_Listings_Var_Pop_Fields = {
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "portal_listings" */
export type Portal_Listings_Var_Pop_Order_By = {
  milliseconds_online?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Portal_Listings_Var_Samp_Fields = {
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "portal_listings" */
export type Portal_Listings_Var_Samp_Order_By = {
  milliseconds_online?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Portal_Listings_Variance_Fields = {
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "portal_listings" */
export type Portal_Listings_Variance_Order_By = {
  milliseconds_online?: InputMaybe<Order_By>;
};

/** columns and relationships of "portals" */
export type Portals = {
  active: Scalars['Boolean']['output'];
  contract_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  enquiries: Array<Enquiries>;
  /** An aggregate relationship */
  enquiries_aggregate: Enquiries_Aggregate;
  exact_address_required: Scalars['Boolean']['output'];
  exclude_from_published_stats: Scalars['Boolean']['output'];
  has_top_premium_listing?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  idx_protocol: Scalars['portal_idx_protocol']['output'];
  increment: Scalars['Int']['output'];
  /** An object relationship */
  logo?: Maybe<Images>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  master_portal_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  portal_listings: Array<Portal_Listings>;
  /** An aggregate relationship */
  portal_listings_aggregate: Portal_Listings_Aggregate;
  quota?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  shared_portal?: Maybe<Shared_Portals>;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  teams_portals: Array<Teams_Portals>;
  tenant_id: Scalars['uuid']['output'];
  type: Portals_Types_Enum_Enum;
  updated_at: Scalars['timestamptz']['output'];
  url?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "portals" */
export type PortalsEnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


/** columns and relationships of "portals" */
export type PortalsEnquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


/** columns and relationships of "portals" */
export type PortalsPortal_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portal_Listings_Order_By>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};


/** columns and relationships of "portals" */
export type PortalsPortal_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portal_Listings_Order_By>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};


/** columns and relationships of "portals" */
export type PortalsTeams_PortalsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Portals_Order_By>>;
  where?: InputMaybe<Teams_Portals_Bool_Exp>;
};

/** aggregated selection of "portals" */
export type Portals_Aggregate = {
  aggregate?: Maybe<Portals_Aggregate_Fields>;
  nodes: Array<Portals>;
};

/** aggregate fields of "portals" */
export type Portals_Aggregate_Fields = {
  avg?: Maybe<Portals_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Portals_Max_Fields>;
  min?: Maybe<Portals_Min_Fields>;
  stddev?: Maybe<Portals_Stddev_Fields>;
  stddev_pop?: Maybe<Portals_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Portals_Stddev_Samp_Fields>;
  sum?: Maybe<Portals_Sum_Fields>;
  var_pop?: Maybe<Portals_Var_Pop_Fields>;
  var_samp?: Maybe<Portals_Var_Samp_Fields>;
  variance?: Maybe<Portals_Variance_Fields>;
};


/** aggregate fields of "portals" */
export type Portals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Portals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Portals_Avg_Fields = {
  increment?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "portals". All fields are combined with a logical 'AND'. */
export type Portals_Bool_Exp = {
  _and?: InputMaybe<Array<Portals_Bool_Exp>>;
  _not?: InputMaybe<Portals_Bool_Exp>;
  _or?: InputMaybe<Array<Portals_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  contract_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  enquiries?: InputMaybe<Enquiries_Bool_Exp>;
  enquiries_aggregate?: InputMaybe<Enquiries_Aggregate_Bool_Exp>;
  exact_address_required?: InputMaybe<Boolean_Comparison_Exp>;
  exclude_from_published_stats?: InputMaybe<Boolean_Comparison_Exp>;
  has_top_premium_listing?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  idx_protocol?: InputMaybe<Portal_Idx_Protocol_Comparison_Exp>;
  increment?: InputMaybe<Int_Comparison_Exp>;
  logo?: InputMaybe<Images_Bool_Exp>;
  logo_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  master_portal_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  port?: InputMaybe<Int_Comparison_Exp>;
  portal_listings?: InputMaybe<Portal_Listings_Bool_Exp>;
  portal_listings_aggregate?: InputMaybe<Portal_Listings_Aggregate_Bool_Exp>;
  quota?: InputMaybe<Int_Comparison_Exp>;
  shared_portal?: InputMaybe<Shared_Portals_Bool_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  teams_portals?: InputMaybe<Teams_Portals_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Portals_Types_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  website_url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "portals" */
export enum Portals_Constraint {
  /** unique or primary key constraint on columns "increment" */
  PortalsIncrementKey = 'portals_increment_key',
  /** unique or primary key constraint on columns "id" */
  RealEstatePortalsPkey = 'real_estate_portals_pkey'
}

/** input type for incrementing numeric columns in table "portals" */
export type Portals_Inc_Input = {
  port?: InputMaybe<Scalars['Int']['input']>;
  quota?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "portals" */
export type Portals_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contract_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exact_address_required?: InputMaybe<Scalars['Boolean']['input']>;
  exclude_from_published_stats?: InputMaybe<Scalars['Boolean']['input']>;
  has_top_premium_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_protocol?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  logo?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  master_portal_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  quota?: InputMaybe<Scalars['Int']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  teams_portals?: InputMaybe<Teams_Portals_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Portals_Types_Enum_Enum>;
  url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Portals_Max_Fields = {
  contract_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idx_protocol?: Maybe<Scalars['portal_idx_protocol']['output']>;
  increment?: Maybe<Scalars['Int']['output']>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  master_portal_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  quota?: Maybe<Scalars['Int']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Portals_Min_Fields = {
  contract_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idx_protocol?: Maybe<Scalars['portal_idx_protocol']['output']>;
  increment?: Maybe<Scalars['Int']['output']>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  master_portal_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  quota?: Maybe<Scalars['Int']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "portals" */
export type Portals_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Portals>;
};

/** input type for inserting object relation for remote table "portals" */
export type Portals_Obj_Rel_Insert_Input = {
  data: Portals_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Portals_On_Conflict>;
};

/** on_conflict condition type for table "portals" */
export type Portals_On_Conflict = {
  constraint: Portals_Constraint;
  update_columns?: Array<Portals_Update_Column>;
  where?: InputMaybe<Portals_Bool_Exp>;
};

/** Ordering options when selecting data from "portals". */
export type Portals_Order_By = {
  active?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  enquiries_aggregate?: InputMaybe<Enquiries_Aggregate_Order_By>;
  exact_address_required?: InputMaybe<Order_By>;
  exclude_from_published_stats?: InputMaybe<Order_By>;
  has_top_premium_listing?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idx_protocol?: InputMaybe<Order_By>;
  increment?: InputMaybe<Order_By>;
  logo?: InputMaybe<Images_Order_By>;
  logo_image_id?: InputMaybe<Order_By>;
  master_portal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  port?: InputMaybe<Order_By>;
  portal_listings_aggregate?: InputMaybe<Portal_Listings_Aggregate_Order_By>;
  quota?: InputMaybe<Order_By>;
  shared_portal?: InputMaybe<Shared_Portals_Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  teams_portals_aggregate?: InputMaybe<Teams_Portals_Aggregate_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  website_url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: portals */
export type Portals_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "portals" */
export enum Portals_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Email = 'email',
  /** column name */
  ExactAddressRequired = 'exact_address_required',
  /** column name */
  ExcludeFromPublishedStats = 'exclude_from_published_stats',
  /** column name */
  HasTopPremiumListing = 'has_top_premium_listing',
  /** column name */
  Id = 'id',
  /** column name */
  IdxProtocol = 'idx_protocol',
  /** column name */
  Increment = 'increment',
  /** column name */
  LogoImageId = 'logo_image_id',
  /** column name */
  MasterPortalId = 'master_portal_id',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password',
  /** column name */
  Port = 'port',
  /** column name */
  Quota = 'quota',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  Username = 'username',
  /** column name */
  WebsiteUrl = 'website_url'
}

/** input type for updating data in table "portals" */
export type Portals_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contract_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exact_address_required?: InputMaybe<Scalars['Boolean']['input']>;
  exclude_from_published_stats?: InputMaybe<Scalars['Boolean']['input']>;
  has_top_premium_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_protocol?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  master_portal_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  quota?: InputMaybe<Scalars['Int']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Portals_Types_Enum_Enum>;
  url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Portals_Stddev_Fields = {
  increment?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Portals_Stddev_Pop_Fields = {
  increment?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Portals_Stddev_Samp_Fields = {
  increment?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "portals" */
export type Portals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Portals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Portals_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contract_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exact_address_required?: InputMaybe<Scalars['Boolean']['input']>;
  exclude_from_published_stats?: InputMaybe<Scalars['Boolean']['input']>;
  has_top_premium_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_protocol?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  master_portal_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  quota?: InputMaybe<Scalars['Int']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Portals_Types_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Portals_Sum_Fields = {
  increment?: Maybe<Scalars['Int']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  quota?: Maybe<Scalars['Int']['output']>;
};

/** columns and relationships of "portals_types_enum" */
export type Portals_Types_Enum = {
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "portals_types_enum". All fields are combined with a logical 'AND'. */
export type Portals_Types_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Portals_Types_Enum_Bool_Exp>>;
  _not?: InputMaybe<Portals_Types_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Portals_Types_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Portals_Types_Enum_Enum {
  Api = 'api',
  Comparis = 'comparis',
  Idealista = 'idealista',
  Idx = 'idx',
  Pisos = 'pisos',
  Shared = 'shared'
}

/** Boolean expression to compare columns of type "portals_types_enum_enum". All fields are combined with logical 'AND'. */
export type Portals_Types_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Portals_Types_Enum_Enum>;
  _in?: InputMaybe<Array<Portals_Types_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Portals_Types_Enum_Enum>;
  _nin?: InputMaybe<Array<Portals_Types_Enum_Enum>>;
};

/** Ordering options when selecting data from "portals_types_enum". */
export type Portals_Types_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "portals_types_enum" */
export enum Portals_Types_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "portals_types_enum" */
export type Portals_Types_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Portals_Types_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Portals_Types_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "portals" */
export enum Portals_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Email = 'email',
  /** column name */
  ExactAddressRequired = 'exact_address_required',
  /** column name */
  ExcludeFromPublishedStats = 'exclude_from_published_stats',
  /** column name */
  HasTopPremiumListing = 'has_top_premium_listing',
  /** column name */
  Id = 'id',
  /** column name */
  IdxProtocol = 'idx_protocol',
  /** column name */
  LogoImageId = 'logo_image_id',
  /** column name */
  MasterPortalId = 'master_portal_id',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password',
  /** column name */
  Port = 'port',
  /** column name */
  Quota = 'quota',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Type = 'type',
  /** column name */
  Url = 'url',
  /** column name */
  Username = 'username',
  /** column name */
  WebsiteUrl = 'website_url'
}

export type Portals_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Portals_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Portals_Set_Input>;
  /** filter the rows which have to be updated */
  where: Portals_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Portals_Var_Pop_Fields = {
  increment?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Portals_Var_Samp_Fields = {
  increment?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Portals_Variance_Fields = {
  increment?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "properties" */
export type Properties = {
  /** A computed field, executes function "properties_agent_ranking" */
  agent_ranking?: Maybe<Array<Agents_Rankings>>;
  /** An array relationship */
  appraisals: Array<Appraisals>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  basement_surface?: Maybe<Scalars['Float']['output']>;
  borrower_lead_id?: Maybe<Scalars['uuid']['output']>;
  building_condition?: Maybe<Scalars['Float']['output']>;
  building_standard?: Maybe<Scalars['Float']['output']>;
  building_volume?: Maybe<Scalars['Float']['output']>;
  building_volume_norm?: Maybe<Scalars['String']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  ceiling_height?: Maybe<Scalars['Float']['output']>;
  charges?: Maybe<Scalars['Float']['output']>;
  commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  commercial_surface?: Maybe<Scalars['Float']['output']>;
  commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  consumption?: Maybe<Scalars['Int']['output']>;
  cooling?: Maybe<Cooling_Enum_Enum>;
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  ctn?: Maybe<Scalars['String']['output']>;
  deleted_by_user: Scalars['Boolean']['output'];
  distance_to_airport?: Maybe<Scalars['Float']['output']>;
  distance_to_city_center?: Maybe<Scalars['Float']['output']>;
  distance_to_grocery_shop?: Maybe<Scalars['Float']['output']>;
  distance_to_high_school?: Maybe<Scalars['Float']['output']>;
  distance_to_hospital?: Maybe<Scalars['Float']['output']>;
  distance_to_kindergarten?: Maybe<Scalars['Float']['output']>;
  distance_to_motorway?: Maybe<Scalars['Float']['output']>;
  distance_to_primary_school?: Maybe<Scalars['Float']['output']>;
  distance_to_public_transport?: Maybe<Scalars['Float']['output']>;
  distance_to_sports_center?: Maybe<Scalars['Float']['output']>;
  distance_to_train_station?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  district_place?: Maybe<Places>;
  emissions?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_consumption_class?: Maybe<Energy_Class_Type_Enum_Enum>;
  energy_inspection_date?: Maybe<Scalars['date']['output']>;
  energy_reference_year?: Maybe<Scalars['Int']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Int']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Int']['output']>;
  financing_institution_id?: Maybe<Scalars['uuid']['output']>;
  flat_condition?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gas_emissions_class?: Maybe<Energy_Class_Type_Enum_Enum>;
  geom?: Maybe<Scalars['geometry']['output']>;
  /** An object relationship */
  google_address?: Maybe<Google_Addresses>;
  google_address_id?: Maybe<Scalars['uuid']['output']>;
  gross_floor_surface?: Maybe<Scalars['Float']['output']>;
  has_attic?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_gym?: Maybe<Scalars['Boolean']['output']>;
  has_photovoltaic_panels?: Maybe<Scalars['Boolean']['output']>;
  has_sauna?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_wellness_area?: Maybe<Scalars['Boolean']['output']>;
  heating?: Maybe<Heating_Enum_Enum>;
  heating_distribution?: Maybe<Heating_Distribution_Enum_Enum>;
  iazi_address_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  income_includes_parking?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_commercial_fully_rented?: Maybe<Scalars['Boolean']['output']>;
  is_luxury?: Maybe<Scalars['Boolean']['output']>;
  is_maisonette?: Maybe<Scalars['Boolean']['output']>;
  is_oriented_east: Scalars['Boolean']['output'];
  is_oriented_north: Scalars['Boolean']['output'];
  is_oriented_south: Scalars['Boolean']['output'];
  is_oriented_west: Scalars['Boolean']['output'];
  is_parking_fully_rented?: Maybe<Scalars['Boolean']['output']>;
  is_rental?: Maybe<Scalars['Boolean']['output']>;
  is_residential_fully_rented?: Maybe<Scalars['Boolean']['output']>;
  is_secondary_residence?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  /** An object relationship */
  latest_appraisal?: Maybe<Appraisals>;
  latest_appraisal_id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "properties_lead_agent_ranking" */
  lead_agent_ranking?: Maybe<Array<Agents_Rankings>>;
  /** An array relationship */
  leads: Array<Leads>;
  /** An aggregate relationship */
  leads_aggregate: Leads_Aggregate;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_place?: Maybe<Places>;
  /** An array relationship */
  lots: Array<Lots>;
  /** An aggregate relationship */
  lots_aggregate: Lots_Aggregate;
  macro_location?: Maybe<Scalars['Float']['output']>;
  micro_location?: Maybe<Scalars['Float']['output']>;
  minergie_code?: Maybe<Scalars['Int']['output']>;
  monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  municipality_place?: Maybe<Places>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  neighbourhood_place?: Maybe<Places>;
  number_of_bathrooms?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_commercial_units?: Maybe<Scalars['Int']['output']>;
  number_of_flats?: Maybe<Scalars['Int']['output']>;
  number_of_floors?: Maybe<Scalars['Int']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_lifts?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_residential_units?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Int']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  ownership_form?: Maybe<Scalars['String']['output']>;
  parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  perceived_value?: Maybe<Scalars['Float']['output']>;
  places?: Maybe<Array<Places>>;
  plot_has_constructible_reserve?: Maybe<Scalars['Boolean']['output']>;
  plot_is_constructible?: Maybe<Scalars['Boolean']['output']>;
  plot_number?: Maybe<Scalars['String']['output']>;
  plot_registry_number?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  property_files: Array<Property_Files>;
  /** An aggregate relationship */
  property_files_aggregate: Property_Files_Aggregate;
  /** An array relationship */
  property_images: Array<Property_Images>;
  /** An aggregate relationship */
  property_images_aggregate: Property_Images_Aggregate;
  /** An array relationship */
  property_pois: Array<Property_Pois>;
  /** An array relationship */
  property_transactions: Array<Property_Transactions>;
  /** An aggregate relationship */
  property_transactions_aggregate: Property_Transactions_Aggregate;
  /** An object relationship */
  property_type?: Maybe<Property_Types>;
  property_type_id?: Maybe<Scalars['uuid']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  relevant_servitudes?: Maybe<Scalars['Boolean']['output']>;
  renovation_fund?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  residential_surface?: Maybe<Scalars['Float']['output']>;
  residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  share_of_ownership?: Maybe<Scalars['Float']['output']>;
  side?: Maybe<Property_Side_Enum_Enum>;
  state?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  state_place?: Maybe<Places>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  weighted_floor_surface?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "properties" */
export type PropertiesAgent_RankingArgs = {
  args?: InputMaybe<Agent_Ranking_Properties_Args>;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


/** columns and relationships of "properties" */
export type PropertiesAppraisalsArgs = {
  distinct_on?: InputMaybe<Array<Appraisals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appraisals_Order_By>>;
  where?: InputMaybe<Appraisals_Bool_Exp>;
};


/** columns and relationships of "properties" */
export type PropertiesLead_Agent_RankingArgs = {
  args?: InputMaybe<Lead_Agent_Ranking_Properties_Args>;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


/** columns and relationships of "properties" */
export type PropertiesLeadsArgs = {
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


/** columns and relationships of "properties" */
export type PropertiesLeads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


/** columns and relationships of "properties" */
export type PropertiesLotsArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


/** columns and relationships of "properties" */
export type PropertiesLots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


/** columns and relationships of "properties" */
export type PropertiesPlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


/** columns and relationships of "properties" */
export type PropertiesProperty_FilesArgs = {
  distinct_on?: InputMaybe<Array<Property_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Files_Order_By>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


/** columns and relationships of "properties" */
export type PropertiesProperty_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Files_Order_By>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


/** columns and relationships of "properties" */
export type PropertiesProperty_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Property_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Images_Order_By>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};


/** columns and relationships of "properties" */
export type PropertiesProperty_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Images_Order_By>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};


/** columns and relationships of "properties" */
export type PropertiesProperty_PoisArgs = {
  distinct_on?: InputMaybe<Array<Property_Pois_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Pois_Order_By>>;
  where?: InputMaybe<Property_Pois_Bool_Exp>;
};


/** columns and relationships of "properties" */
export type PropertiesProperty_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


/** columns and relationships of "properties" */
export type PropertiesProperty_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};

/** order by aggregate values of table "properties" */
export type Properties_Aggregate_Order_By = {
  avg?: InputMaybe<Properties_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Properties_Max_Order_By>;
  min?: InputMaybe<Properties_Min_Order_By>;
  stddev?: InputMaybe<Properties_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Properties_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Properties_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Properties_Sum_Order_By>;
  var_pop?: InputMaybe<Properties_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Properties_Var_Samp_Order_By>;
  variance?: InputMaybe<Properties_Variance_Order_By>;
};

/** order by avg() on columns of table "properties" */
export type Properties_Avg_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "properties". All fields are combined with a logical 'AND'. */
export type Properties_Bool_Exp = {
  _and?: InputMaybe<Array<Properties_Bool_Exp>>;
  _not?: InputMaybe<Properties_Bool_Exp>;
  _or?: InputMaybe<Array<Properties_Bool_Exp>>;
  appraisals?: InputMaybe<Appraisals_Bool_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  basement_surface?: InputMaybe<Float_Comparison_Exp>;
  borrower_lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  building_condition?: InputMaybe<Float_Comparison_Exp>;
  building_standard?: InputMaybe<Float_Comparison_Exp>;
  building_volume?: InputMaybe<Float_Comparison_Exp>;
  building_volume_norm?: InputMaybe<String_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  ceiling_height?: InputMaybe<Float_Comparison_Exp>;
  charges?: InputMaybe<Float_Comparison_Exp>;
  commercial_potential_rental_income?: InputMaybe<Float_Comparison_Exp>;
  commercial_surface?: InputMaybe<Float_Comparison_Exp>;
  commercial_yearly_rental_income?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  consumption?: InputMaybe<Int_Comparison_Exp>;
  cooling?: InputMaybe<Cooling_Enum_Enum_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  country_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  ctn?: InputMaybe<String_Comparison_Exp>;
  deleted_by_user?: InputMaybe<Boolean_Comparison_Exp>;
  distance_to_airport?: InputMaybe<Float_Comparison_Exp>;
  distance_to_city_center?: InputMaybe<Float_Comparison_Exp>;
  distance_to_grocery_shop?: InputMaybe<Float_Comparison_Exp>;
  distance_to_high_school?: InputMaybe<Float_Comparison_Exp>;
  distance_to_hospital?: InputMaybe<Float_Comparison_Exp>;
  distance_to_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  distance_to_motorway?: InputMaybe<Float_Comparison_Exp>;
  distance_to_primary_school?: InputMaybe<Float_Comparison_Exp>;
  distance_to_public_transport?: InputMaybe<Float_Comparison_Exp>;
  distance_to_sports_center?: InputMaybe<Float_Comparison_Exp>;
  distance_to_train_station?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  district_place?: InputMaybe<Places_Bool_Exp>;
  emissions?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_consumption_class?: InputMaybe<Energy_Class_Type_Enum_Enum_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Date_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Int_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Int_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Int_Comparison_Exp>;
  financing_institution_id?: InputMaybe<Uuid_Comparison_Exp>;
  flat_condition?: InputMaybe<Float_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  gas_emissions_class?: InputMaybe<Energy_Class_Type_Enum_Enum_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  google_address?: InputMaybe<Google_Addresses_Bool_Exp>;
  google_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  gross_floor_surface?: InputMaybe<Float_Comparison_Exp>;
  has_attic?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_gym?: InputMaybe<Boolean_Comparison_Exp>;
  has_photovoltaic_panels?: InputMaybe<Boolean_Comparison_Exp>;
  has_sauna?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_wellness_area?: InputMaybe<Boolean_Comparison_Exp>;
  heating?: InputMaybe<Heating_Enum_Enum_Comparison_Exp>;
  heating_distribution?: InputMaybe<Heating_Distribution_Enum_Enum_Comparison_Exp>;
  iazi_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  income_includes_parking?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_commercial_fully_rented?: InputMaybe<Boolean_Comparison_Exp>;
  is_luxury?: InputMaybe<Boolean_Comparison_Exp>;
  is_maisonette?: InputMaybe<Boolean_Comparison_Exp>;
  is_oriented_east?: InputMaybe<Boolean_Comparison_Exp>;
  is_oriented_north?: InputMaybe<Boolean_Comparison_Exp>;
  is_oriented_south?: InputMaybe<Boolean_Comparison_Exp>;
  is_oriented_west?: InputMaybe<Boolean_Comparison_Exp>;
  is_parking_fully_rented?: InputMaybe<Boolean_Comparison_Exp>;
  is_rental?: InputMaybe<Boolean_Comparison_Exp>;
  is_residential_fully_rented?: InputMaybe<Boolean_Comparison_Exp>;
  is_secondary_residence?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  latest_appraisal?: InputMaybe<Appraisals_Bool_Exp>;
  latest_appraisal_id?: InputMaybe<Uuid_Comparison_Exp>;
  leads?: InputMaybe<Leads_Bool_Exp>;
  leads_aggregate?: InputMaybe<Leads_Aggregate_Bool_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_place?: InputMaybe<Places_Bool_Exp>;
  lots?: InputMaybe<Lots_Bool_Exp>;
  lots_aggregate?: InputMaybe<Lots_Aggregate_Bool_Exp>;
  macro_location?: InputMaybe<Float_Comparison_Exp>;
  micro_location?: InputMaybe<Float_Comparison_Exp>;
  minergie_code?: InputMaybe<Int_Comparison_Exp>;
  monthly_gross_rent?: InputMaybe<Float_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality_place?: InputMaybe<Places_Bool_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_place?: InputMaybe<Places_Bool_Exp>;
  number_of_bathrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_commercial_units?: InputMaybe<Int_Comparison_Exp>;
  number_of_flats?: InputMaybe<Int_Comparison_Exp>;
  number_of_floors?: InputMaybe<Int_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_lifts?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_residential_units?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Int_Comparison_Exp>;
  orientation?: InputMaybe<String_Comparison_Exp>;
  ownership_form?: InputMaybe<String_Comparison_Exp>;
  parking_potential_rental_income?: InputMaybe<Float_Comparison_Exp>;
  parking_yearly_rental_income?: InputMaybe<Float_Comparison_Exp>;
  perceived_value?: InputMaybe<Float_Comparison_Exp>;
  places?: InputMaybe<Places_Bool_Exp>;
  plot_has_constructible_reserve?: InputMaybe<Boolean_Comparison_Exp>;
  plot_is_constructible?: InputMaybe<Boolean_Comparison_Exp>;
  plot_number?: InputMaybe<String_Comparison_Exp>;
  plot_registry_number?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_files?: InputMaybe<Property_Files_Bool_Exp>;
  property_files_aggregate?: InputMaybe<Property_Files_Aggregate_Bool_Exp>;
  property_images?: InputMaybe<Property_Images_Bool_Exp>;
  property_images_aggregate?: InputMaybe<Property_Images_Aggregate_Bool_Exp>;
  property_pois?: InputMaybe<Property_Pois_Bool_Exp>;
  property_transactions?: InputMaybe<Property_Transactions_Bool_Exp>;
  property_transactions_aggregate?: InputMaybe<Property_Transactions_Aggregate_Bool_Exp>;
  property_type?: InputMaybe<Property_Types_Bool_Exp>;
  property_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  relevant_servitudes?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_fund?: InputMaybe<Float_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  residential_potential_rental_income?: InputMaybe<Float_Comparison_Exp>;
  residential_surface?: InputMaybe<Float_Comparison_Exp>;
  residential_yearly_rental_income?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  share_of_ownership?: InputMaybe<Float_Comparison_Exp>;
  side?: InputMaybe<Property_Side_Enum_Enum_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  state_place?: InputMaybe<Places_Bool_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  weighted_floor_surface?: InputMaybe<Float_Comparison_Exp>;
};

/** unique or primary key constraints on table "properties" */
export enum Properties_Constraint {
  /** unique or primary key constraint on columns "id" */
  PropertiesPkey = 'properties_pkey'
}

/** input type for incrementing numeric columns in table "properties" */
export type Properties_Inc_Input = {
  balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  basement_surface?: InputMaybe<Scalars['Float']['input']>;
  building_condition?: InputMaybe<Scalars['Float']['input']>;
  building_standard?: InputMaybe<Scalars['Float']['input']>;
  building_volume?: InputMaybe<Scalars['Float']['input']>;
  built_surface?: InputMaybe<Scalars['Float']['input']>;
  ceiling_height?: InputMaybe<Scalars['Float']['input']>;
  charges?: InputMaybe<Scalars['Float']['input']>;
  commercial_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  commercial_surface?: InputMaybe<Scalars['Float']['input']>;
  commercial_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  consumption?: InputMaybe<Scalars['Int']['input']>;
  distance_to_airport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_city_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_grocery_shop?: InputMaybe<Scalars['Float']['input']>;
  distance_to_high_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_hospital?: InputMaybe<Scalars['Float']['input']>;
  distance_to_kindergarten?: InputMaybe<Scalars['Float']['input']>;
  distance_to_motorway?: InputMaybe<Scalars['Float']['input']>;
  distance_to_primary_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_public_transport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_sports_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_train_station?: InputMaybe<Scalars['Float']['input']>;
  emissions?: InputMaybe<Scalars['Int']['input']>;
  energy_reference_year?: InputMaybe<Scalars['Int']['input']>;
  estimated_higher_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  estimated_lower_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  flat_condition?: InputMaybe<Scalars['Float']['input']>;
  floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  garden_surface?: InputMaybe<Scalars['Float']['input']>;
  gross_floor_surface?: InputMaybe<Scalars['Float']['input']>;
  land_surface?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  living_surface?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  macro_location?: InputMaybe<Scalars['Float']['input']>;
  micro_location?: InputMaybe<Scalars['Float']['input']>;
  minergie_code?: InputMaybe<Scalars['Int']['input']>;
  monthly_gross_rent?: InputMaybe<Scalars['Float']['input']>;
  number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_commercial_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_flats?: InputMaybe<Scalars['Int']['input']>;
  number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_lifts?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_residential_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  number_of_toilets?: InputMaybe<Scalars['Int']['input']>;
  parking_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  parking_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  perceived_value?: InputMaybe<Scalars['Float']['input']>;
  renovation_fund?: InputMaybe<Scalars['Float']['input']>;
  renovation_year?: InputMaybe<Scalars['Int']['input']>;
  residential_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  residential_surface?: InputMaybe<Scalars['Float']['input']>;
  residential_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  share_of_ownership?: InputMaybe<Scalars['Float']['input']>;
  terrace_surface?: InputMaybe<Scalars['Float']['input']>;
  usable_surface?: InputMaybe<Scalars['Float']['input']>;
  weighted_floor_surface?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "properties" */
export type Properties_Insert_Input = {
  balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  basement_surface?: InputMaybe<Scalars['Float']['input']>;
  borrower_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  building_condition?: InputMaybe<Scalars['Float']['input']>;
  building_standard?: InputMaybe<Scalars['Float']['input']>;
  building_volume?: InputMaybe<Scalars['Float']['input']>;
  building_volume_norm?: InputMaybe<Scalars['String']['input']>;
  built_surface?: InputMaybe<Scalars['Float']['input']>;
  ceiling_height?: InputMaybe<Scalars['Float']['input']>;
  charges?: InputMaybe<Scalars['Float']['input']>;
  commercial_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  commercial_surface?: InputMaybe<Scalars['Float']['input']>;
  commercial_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  consumption?: InputMaybe<Scalars['Int']['input']>;
  cooling?: InputMaybe<Cooling_Enum_Enum>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  deleted_by_user?: InputMaybe<Scalars['Boolean']['input']>;
  distance_to_airport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_city_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_grocery_shop?: InputMaybe<Scalars['Float']['input']>;
  distance_to_high_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_hospital?: InputMaybe<Scalars['Float']['input']>;
  distance_to_kindergarten?: InputMaybe<Scalars['Float']['input']>;
  distance_to_motorway?: InputMaybe<Scalars['Float']['input']>;
  distance_to_primary_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_public_transport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_sports_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_train_station?: InputMaybe<Scalars['Float']['input']>;
  district_id?: InputMaybe<Scalars['uuid']['input']>;
  emissions?: InputMaybe<Scalars['Int']['input']>;
  energy_certificate_version?: InputMaybe<Scalars['String']['input']>;
  energy_consumption_class?: InputMaybe<Energy_Class_Type_Enum_Enum>;
  energy_inspection_date?: InputMaybe<Scalars['date']['input']>;
  energy_reference_year?: InputMaybe<Scalars['Int']['input']>;
  estimated_higher_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  estimated_lower_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  financing_institution_id?: InputMaybe<Scalars['uuid']['input']>;
  flat_condition?: InputMaybe<Scalars['Float']['input']>;
  floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  garden_surface?: InputMaybe<Scalars['Float']['input']>;
  gas_emissions_class?: InputMaybe<Energy_Class_Type_Enum_Enum>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  google_address?: InputMaybe<Google_Addresses_Obj_Rel_Insert_Input>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  gross_floor_surface?: InputMaybe<Scalars['Float']['input']>;
  has_attic?: InputMaybe<Scalars['Boolean']['input']>;
  has_cellar?: InputMaybe<Scalars['Boolean']['input']>;
  has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_gym?: InputMaybe<Scalars['Boolean']['input']>;
  has_photovoltaic_panels?: InputMaybe<Scalars['Boolean']['input']>;
  has_sauna?: InputMaybe<Scalars['Boolean']['input']>;
  has_storage_room?: InputMaybe<Scalars['Boolean']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  has_wellness_area?: InputMaybe<Scalars['Boolean']['input']>;
  heating?: InputMaybe<Heating_Enum_Enum>;
  heating_distribution?: InputMaybe<Heating_Distribution_Enum_Enum>;
  iazi_address_id?: InputMaybe<Scalars['uuid']['input']>;
  income_includes_parking?: InputMaybe<Scalars['Boolean']['input']>;
  is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_commercial_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_luxury?: InputMaybe<Scalars['Boolean']['input']>;
  is_maisonette?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_east?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_north?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_south?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_west?: InputMaybe<Scalars['Boolean']['input']>;
  is_parking_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_rental?: InputMaybe<Scalars['Boolean']['input']>;
  is_residential_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_secondary_residence?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  latest_appraisal_id?: InputMaybe<Scalars['uuid']['input']>;
  leads?: InputMaybe<Leads_Arr_Rel_Insert_Input>;
  living_surface?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  lots?: InputMaybe<Lots_Arr_Rel_Insert_Input>;
  macro_location?: InputMaybe<Scalars['Float']['input']>;
  micro_location?: InputMaybe<Scalars['Float']['input']>;
  minergie_code?: InputMaybe<Scalars['Int']['input']>;
  monthly_gross_rent?: InputMaybe<Scalars['Float']['input']>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_commercial_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_flats?: InputMaybe<Scalars['Int']['input']>;
  number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_lifts?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_residential_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  number_of_toilets?: InputMaybe<Scalars['Int']['input']>;
  orientation?: InputMaybe<Scalars['String']['input']>;
  ownership_form?: InputMaybe<Scalars['String']['input']>;
  parking_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  parking_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  perceived_value?: InputMaybe<Scalars['Float']['input']>;
  plot_has_constructible_reserve?: InputMaybe<Scalars['Boolean']['input']>;
  plot_is_constructible?: InputMaybe<Scalars['Boolean']['input']>;
  plot_number?: InputMaybe<Scalars['String']['input']>;
  plot_registry_number?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_id?: InputMaybe<Scalars['uuid']['input']>;
  property_files?: InputMaybe<Property_Files_Arr_Rel_Insert_Input>;
  property_images?: InputMaybe<Property_Images_Arr_Rel_Insert_Input>;
  property_transactions?: InputMaybe<Property_Transactions_Arr_Rel_Insert_Input>;
  property_type_id?: InputMaybe<Scalars['uuid']['input']>;
  region_id?: InputMaybe<Scalars['uuid']['input']>;
  relevant_servitudes?: InputMaybe<Scalars['Boolean']['input']>;
  renovation_fund?: InputMaybe<Scalars['Float']['input']>;
  renovation_year?: InputMaybe<Scalars['Int']['input']>;
  residential_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  residential_surface?: InputMaybe<Scalars['Float']['input']>;
  residential_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  share_of_ownership?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<Property_Side_Enum_Enum>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  sub_locality?: InputMaybe<Scalars['String']['input']>;
  terrace_surface?: InputMaybe<Scalars['Float']['input']>;
  usable_surface?: InputMaybe<Scalars['Float']['input']>;
  weighted_floor_surface?: InputMaybe<Scalars['Float']['input']>;
};

/** order by max() on columns of table "properties" */
export type Properties_Max_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  borrower_lead_id?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  building_volume_norm?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  ctn?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  financing_institution_id?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  google_address_id?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  iazi_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  latest_appraisal_id?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  orientation?: InputMaybe<Order_By>;
  ownership_form?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  plot_number?: InputMaybe<Order_By>;
  plot_registry_number?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  property_type_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "properties" */
export type Properties_Min_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  borrower_lead_id?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  building_volume_norm?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  ctn?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  financing_institution_id?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  google_address_id?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  iazi_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  latest_appraisal_id?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  orientation?: InputMaybe<Order_By>;
  ownership_form?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  plot_number?: InputMaybe<Order_By>;
  plot_registry_number?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  property_type_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "properties" */
export type Properties_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Properties>;
};

/** input type for inserting object relation for remote table "properties" */
export type Properties_Obj_Rel_Insert_Input = {
  data: Properties_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Properties_On_Conflict>;
};

/** on_conflict condition type for table "properties" */
export type Properties_On_Conflict = {
  constraint: Properties_Constraint;
  update_columns?: Array<Properties_Update_Column>;
  where?: InputMaybe<Properties_Bool_Exp>;
};

/** Ordering options when selecting data from "properties". */
export type Properties_Order_By = {
  appraisals_aggregate?: InputMaybe<Appraisals_Aggregate_Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  borrower_lead_id?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  building_volume_norm?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  cooling?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  ctn?: InputMaybe<Order_By>;
  deleted_by_user?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  district_place?: InputMaybe<Places_Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_consumption_class?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  financing_institution_id?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gas_emissions_class?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  google_address?: InputMaybe<Google_Addresses_Order_By>;
  google_address_id?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  has_attic?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_gym?: InputMaybe<Order_By>;
  has_photovoltaic_panels?: InputMaybe<Order_By>;
  has_sauna?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_wellness_area?: InputMaybe<Order_By>;
  heating?: InputMaybe<Order_By>;
  heating_distribution?: InputMaybe<Order_By>;
  iazi_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  income_includes_parking?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_commercial_fully_rented?: InputMaybe<Order_By>;
  is_luxury?: InputMaybe<Order_By>;
  is_maisonette?: InputMaybe<Order_By>;
  is_oriented_east?: InputMaybe<Order_By>;
  is_oriented_north?: InputMaybe<Order_By>;
  is_oriented_south?: InputMaybe<Order_By>;
  is_oriented_west?: InputMaybe<Order_By>;
  is_parking_fully_rented?: InputMaybe<Order_By>;
  is_rental?: InputMaybe<Order_By>;
  is_residential_fully_rented?: InputMaybe<Order_By>;
  is_secondary_residence?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  latest_appraisal?: InputMaybe<Appraisals_Order_By>;
  latest_appraisal_id?: InputMaybe<Order_By>;
  leads_aggregate?: InputMaybe<Leads_Aggregate_Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_place?: InputMaybe<Places_Order_By>;
  lots_aggregate?: InputMaybe<Lots_Aggregate_Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  municipality_place?: InputMaybe<Places_Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  neighbourhood_place?: InputMaybe<Places_Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  orientation?: InputMaybe<Order_By>;
  ownership_form?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Places_Aggregate_Order_By>;
  plot_has_constructible_reserve?: InputMaybe<Order_By>;
  plot_is_constructible?: InputMaybe<Order_By>;
  plot_number?: InputMaybe<Order_By>;
  plot_registry_number?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  property_files_aggregate?: InputMaybe<Property_Files_Aggregate_Order_By>;
  property_images_aggregate?: InputMaybe<Property_Images_Aggregate_Order_By>;
  property_pois_aggregate?: InputMaybe<Property_Pois_Aggregate_Order_By>;
  property_transactions_aggregate?: InputMaybe<Property_Transactions_Aggregate_Order_By>;
  property_type?: InputMaybe<Property_Types_Order_By>;
  property_type_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  relevant_servitudes?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  side?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  state_place?: InputMaybe<Places_Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** primary key columns input for table: properties */
export type Properties_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "properties" */
export enum Properties_Select_Column {
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BasementSurface = 'basement_surface',
  /** column name */
  BorrowerLeadId = 'borrower_lead_id',
  /** column name */
  BuildingCondition = 'building_condition',
  /** column name */
  BuildingStandard = 'building_standard',
  /** column name */
  BuildingVolume = 'building_volume',
  /** column name */
  BuildingVolumeNorm = 'building_volume_norm',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CeilingHeight = 'ceiling_height',
  /** column name */
  Charges = 'charges',
  /** column name */
  CommercialPotentialRentalIncome = 'commercial_potential_rental_income',
  /** column name */
  CommercialSurface = 'commercial_surface',
  /** column name */
  CommercialYearlyRentalIncome = 'commercial_yearly_rental_income',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  Consumption = 'consumption',
  /** column name */
  Cooling = 'cooling',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Ctn = 'ctn',
  /** column name */
  DeletedByUser = 'deleted_by_user',
  /** column name */
  DistanceToAirport = 'distance_to_airport',
  /** column name */
  DistanceToCityCenter = 'distance_to_city_center',
  /** column name */
  DistanceToGroceryShop = 'distance_to_grocery_shop',
  /** column name */
  DistanceToHighSchool = 'distance_to_high_school',
  /** column name */
  DistanceToHospital = 'distance_to_hospital',
  /** column name */
  DistanceToKindergarten = 'distance_to_kindergarten',
  /** column name */
  DistanceToMotorway = 'distance_to_motorway',
  /** column name */
  DistanceToPrimarySchool = 'distance_to_primary_school',
  /** column name */
  DistanceToPublicTransport = 'distance_to_public_transport',
  /** column name */
  DistanceToSportsCenter = 'distance_to_sports_center',
  /** column name */
  DistanceToTrainStation = 'distance_to_train_station',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Emissions = 'emissions',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyConsumptionClass = 'energy_consumption_class',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FinancingInstitutionId = 'financing_institution_id',
  /** column name */
  FlatCondition = 'flat_condition',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  GasEmissionsClass = 'gas_emissions_class',
  /** column name */
  Geom = 'geom',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  GrossFloorSurface = 'gross_floor_surface',
  /** column name */
  HasAttic = 'has_attic',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGym = 'has_gym',
  /** column name */
  HasPhotovoltaicPanels = 'has_photovoltaic_panels',
  /** column name */
  HasSauna = 'has_sauna',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasWellnessArea = 'has_wellness_area',
  /** column name */
  Heating = 'heating',
  /** column name */
  HeatingDistribution = 'heating_distribution',
  /** column name */
  IaziAddressId = 'iazi_address_id',
  /** column name */
  Id = 'id',
  /** column name */
  IncomeIncludesParking = 'income_includes_parking',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsCommercialFullyRented = 'is_commercial_fully_rented',
  /** column name */
  IsLuxury = 'is_luxury',
  /** column name */
  IsMaisonette = 'is_maisonette',
  /** column name */
  IsOrientedEast = 'is_oriented_east',
  /** column name */
  IsOrientedNorth = 'is_oriented_north',
  /** column name */
  IsOrientedSouth = 'is_oriented_south',
  /** column name */
  IsOrientedWest = 'is_oriented_west',
  /** column name */
  IsParkingFullyRented = 'is_parking_fully_rented',
  /** column name */
  IsRental = 'is_rental',
  /** column name */
  IsResidentialFullyRented = 'is_residential_fully_rented',
  /** column name */
  IsSecondaryResidence = 'is_secondary_residence',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LatestAppraisalId = 'latest_appraisal_id',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MacroLocation = 'macro_location',
  /** column name */
  MicroLocation = 'micro_location',
  /** column name */
  MinergieCode = 'minergie_code',
  /** column name */
  MonthlyGrossRent = 'monthly_gross_rent',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfCommercialUnits = 'number_of_commercial_units',
  /** column name */
  NumberOfFlats = 'number_of_flats',
  /** column name */
  NumberOfFloors = 'number_of_floors',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLifts = 'number_of_lifts',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfResidentialUnits = 'number_of_residential_units',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  Orientation = 'orientation',
  /** column name */
  OwnershipForm = 'ownership_form',
  /** column name */
  ParkingPotentialRentalIncome = 'parking_potential_rental_income',
  /** column name */
  ParkingYearlyRentalIncome = 'parking_yearly_rental_income',
  /** column name */
  PerceivedValue = 'perceived_value',
  /** column name */
  PlotHasConstructibleReserve = 'plot_has_constructible_reserve',
  /** column name */
  PlotIsConstructible = 'plot_is_constructible',
  /** column name */
  PlotNumber = 'plot_number',
  /** column name */
  PlotRegistryNumber = 'plot_registry_number',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PropertyTypeId = 'property_type_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  RelevantServitudes = 'relevant_servitudes',
  /** column name */
  RenovationFund = 'renovation_fund',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  ResidentialPotentialRentalIncome = 'residential_potential_rental_income',
  /** column name */
  ResidentialSurface = 'residential_surface',
  /** column name */
  ResidentialYearlyRentalIncome = 'residential_yearly_rental_income',
  /** column name */
  Route = 'route',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  ShareOfOwnership = 'share_of_ownership',
  /** column name */
  Side = 'side',
  /** column name */
  State = 'state',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  WeightedFloorSurface = 'weighted_floor_surface'
}

/** input type for updating data in table "properties" */
export type Properties_Set_Input = {
  balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  basement_surface?: InputMaybe<Scalars['Float']['input']>;
  borrower_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  building_condition?: InputMaybe<Scalars['Float']['input']>;
  building_standard?: InputMaybe<Scalars['Float']['input']>;
  building_volume?: InputMaybe<Scalars['Float']['input']>;
  building_volume_norm?: InputMaybe<Scalars['String']['input']>;
  built_surface?: InputMaybe<Scalars['Float']['input']>;
  ceiling_height?: InputMaybe<Scalars['Float']['input']>;
  charges?: InputMaybe<Scalars['Float']['input']>;
  commercial_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  commercial_surface?: InputMaybe<Scalars['Float']['input']>;
  commercial_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  consumption?: InputMaybe<Scalars['Int']['input']>;
  cooling?: InputMaybe<Cooling_Enum_Enum>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  deleted_by_user?: InputMaybe<Scalars['Boolean']['input']>;
  distance_to_airport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_city_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_grocery_shop?: InputMaybe<Scalars['Float']['input']>;
  distance_to_high_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_hospital?: InputMaybe<Scalars['Float']['input']>;
  distance_to_kindergarten?: InputMaybe<Scalars['Float']['input']>;
  distance_to_motorway?: InputMaybe<Scalars['Float']['input']>;
  distance_to_primary_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_public_transport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_sports_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_train_station?: InputMaybe<Scalars['Float']['input']>;
  district_id?: InputMaybe<Scalars['uuid']['input']>;
  emissions?: InputMaybe<Scalars['Int']['input']>;
  energy_certificate_version?: InputMaybe<Scalars['String']['input']>;
  energy_consumption_class?: InputMaybe<Energy_Class_Type_Enum_Enum>;
  energy_inspection_date?: InputMaybe<Scalars['date']['input']>;
  energy_reference_year?: InputMaybe<Scalars['Int']['input']>;
  estimated_higher_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  estimated_lower_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  financing_institution_id?: InputMaybe<Scalars['uuid']['input']>;
  flat_condition?: InputMaybe<Scalars['Float']['input']>;
  floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  garden_surface?: InputMaybe<Scalars['Float']['input']>;
  gas_emissions_class?: InputMaybe<Energy_Class_Type_Enum_Enum>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  gross_floor_surface?: InputMaybe<Scalars['Float']['input']>;
  has_attic?: InputMaybe<Scalars['Boolean']['input']>;
  has_cellar?: InputMaybe<Scalars['Boolean']['input']>;
  has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_gym?: InputMaybe<Scalars['Boolean']['input']>;
  has_photovoltaic_panels?: InputMaybe<Scalars['Boolean']['input']>;
  has_sauna?: InputMaybe<Scalars['Boolean']['input']>;
  has_storage_room?: InputMaybe<Scalars['Boolean']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  has_wellness_area?: InputMaybe<Scalars['Boolean']['input']>;
  heating?: InputMaybe<Heating_Enum_Enum>;
  heating_distribution?: InputMaybe<Heating_Distribution_Enum_Enum>;
  iazi_address_id?: InputMaybe<Scalars['uuid']['input']>;
  income_includes_parking?: InputMaybe<Scalars['Boolean']['input']>;
  is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_commercial_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_luxury?: InputMaybe<Scalars['Boolean']['input']>;
  is_maisonette?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_east?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_north?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_south?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_west?: InputMaybe<Scalars['Boolean']['input']>;
  is_parking_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_rental?: InputMaybe<Scalars['Boolean']['input']>;
  is_residential_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_secondary_residence?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  latest_appraisal_id?: InputMaybe<Scalars['uuid']['input']>;
  living_surface?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  macro_location?: InputMaybe<Scalars['Float']['input']>;
  micro_location?: InputMaybe<Scalars['Float']['input']>;
  minergie_code?: InputMaybe<Scalars['Int']['input']>;
  monthly_gross_rent?: InputMaybe<Scalars['Float']['input']>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_commercial_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_flats?: InputMaybe<Scalars['Int']['input']>;
  number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_lifts?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_residential_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  number_of_toilets?: InputMaybe<Scalars['Int']['input']>;
  orientation?: InputMaybe<Scalars['String']['input']>;
  ownership_form?: InputMaybe<Scalars['String']['input']>;
  parking_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  parking_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  perceived_value?: InputMaybe<Scalars['Float']['input']>;
  plot_has_constructible_reserve?: InputMaybe<Scalars['Boolean']['input']>;
  plot_is_constructible?: InputMaybe<Scalars['Boolean']['input']>;
  plot_number?: InputMaybe<Scalars['String']['input']>;
  plot_registry_number?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_id?: InputMaybe<Scalars['uuid']['input']>;
  property_type_id?: InputMaybe<Scalars['uuid']['input']>;
  region_id?: InputMaybe<Scalars['uuid']['input']>;
  relevant_servitudes?: InputMaybe<Scalars['Boolean']['input']>;
  renovation_fund?: InputMaybe<Scalars['Float']['input']>;
  renovation_year?: InputMaybe<Scalars['Int']['input']>;
  residential_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  residential_surface?: InputMaybe<Scalars['Float']['input']>;
  residential_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  share_of_ownership?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<Property_Side_Enum_Enum>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  sub_locality?: InputMaybe<Scalars['String']['input']>;
  terrace_surface?: InputMaybe<Scalars['Float']['input']>;
  usable_surface?: InputMaybe<Scalars['Float']['input']>;
  weighted_floor_surface?: InputMaybe<Scalars['Float']['input']>;
};

/** order by stddev() on columns of table "properties" */
export type Properties_Stddev_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "properties" */
export type Properties_Stddev_Pop_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "properties" */
export type Properties_Stddev_Samp_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "properties" */
export type Properties_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Properties_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Properties_Stream_Cursor_Value_Input = {
  balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  basement_surface?: InputMaybe<Scalars['Float']['input']>;
  borrower_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  building_condition?: InputMaybe<Scalars['Float']['input']>;
  building_standard?: InputMaybe<Scalars['Float']['input']>;
  building_volume?: InputMaybe<Scalars['Float']['input']>;
  building_volume_norm?: InputMaybe<Scalars['String']['input']>;
  built_surface?: InputMaybe<Scalars['Float']['input']>;
  ceiling_height?: InputMaybe<Scalars['Float']['input']>;
  charges?: InputMaybe<Scalars['Float']['input']>;
  commercial_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  commercial_surface?: InputMaybe<Scalars['Float']['input']>;
  commercial_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  computed_surface?: InputMaybe<Scalars['Float']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  consumption?: InputMaybe<Scalars['Int']['input']>;
  cooling?: InputMaybe<Cooling_Enum_Enum>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  deleted_by_user?: InputMaybe<Scalars['Boolean']['input']>;
  distance_to_airport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_city_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_grocery_shop?: InputMaybe<Scalars['Float']['input']>;
  distance_to_high_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_hospital?: InputMaybe<Scalars['Float']['input']>;
  distance_to_kindergarten?: InputMaybe<Scalars['Float']['input']>;
  distance_to_motorway?: InputMaybe<Scalars['Float']['input']>;
  distance_to_primary_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_public_transport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_sports_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_train_station?: InputMaybe<Scalars['Float']['input']>;
  district_id?: InputMaybe<Scalars['uuid']['input']>;
  emissions?: InputMaybe<Scalars['Int']['input']>;
  energy_certificate_version?: InputMaybe<Scalars['String']['input']>;
  energy_consumption_class?: InputMaybe<Energy_Class_Type_Enum_Enum>;
  energy_inspection_date?: InputMaybe<Scalars['date']['input']>;
  energy_reference_year?: InputMaybe<Scalars['Int']['input']>;
  estimated_higher_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  estimated_lower_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  financing_institution_id?: InputMaybe<Scalars['uuid']['input']>;
  flat_condition?: InputMaybe<Scalars['Float']['input']>;
  floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  garden_surface?: InputMaybe<Scalars['Float']['input']>;
  gas_emissions_class?: InputMaybe<Energy_Class_Type_Enum_Enum>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  gross_floor_surface?: InputMaybe<Scalars['Float']['input']>;
  has_attic?: InputMaybe<Scalars['Boolean']['input']>;
  has_cellar?: InputMaybe<Scalars['Boolean']['input']>;
  has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_gym?: InputMaybe<Scalars['Boolean']['input']>;
  has_photovoltaic_panels?: InputMaybe<Scalars['Boolean']['input']>;
  has_sauna?: InputMaybe<Scalars['Boolean']['input']>;
  has_storage_room?: InputMaybe<Scalars['Boolean']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  has_wellness_area?: InputMaybe<Scalars['Boolean']['input']>;
  heating?: InputMaybe<Heating_Enum_Enum>;
  heating_distribution?: InputMaybe<Heating_Distribution_Enum_Enum>;
  iazi_address_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  income_includes_parking?: InputMaybe<Scalars['Boolean']['input']>;
  is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_commercial_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_luxury?: InputMaybe<Scalars['Boolean']['input']>;
  is_maisonette?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_east?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_north?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_south?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_west?: InputMaybe<Scalars['Boolean']['input']>;
  is_parking_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_rental?: InputMaybe<Scalars['Boolean']['input']>;
  is_residential_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_secondary_residence?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  latest_appraisal_id?: InputMaybe<Scalars['uuid']['input']>;
  living_surface?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  macro_location?: InputMaybe<Scalars['Float']['input']>;
  micro_location?: InputMaybe<Scalars['Float']['input']>;
  minergie_code?: InputMaybe<Scalars['Int']['input']>;
  monthly_gross_rent?: InputMaybe<Scalars['Float']['input']>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_commercial_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_flats?: InputMaybe<Scalars['Int']['input']>;
  number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_lifts?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_residential_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  number_of_toilets?: InputMaybe<Scalars['Int']['input']>;
  orientation?: InputMaybe<Scalars['String']['input']>;
  ownership_form?: InputMaybe<Scalars['String']['input']>;
  parking_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  parking_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  perceived_value?: InputMaybe<Scalars['Float']['input']>;
  plot_has_constructible_reserve?: InputMaybe<Scalars['Boolean']['input']>;
  plot_is_constructible?: InputMaybe<Scalars['Boolean']['input']>;
  plot_number?: InputMaybe<Scalars['String']['input']>;
  plot_registry_number?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_id?: InputMaybe<Scalars['uuid']['input']>;
  property_type_id?: InputMaybe<Scalars['uuid']['input']>;
  region_id?: InputMaybe<Scalars['uuid']['input']>;
  relevant_servitudes?: InputMaybe<Scalars['Boolean']['input']>;
  renovation_fund?: InputMaybe<Scalars['Float']['input']>;
  renovation_year?: InputMaybe<Scalars['Int']['input']>;
  residential_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  residential_surface?: InputMaybe<Scalars['Float']['input']>;
  residential_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  share_of_ownership?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<Property_Side_Enum_Enum>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  sub_locality?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  terrace_surface?: InputMaybe<Scalars['Float']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  usable_surface?: InputMaybe<Scalars['Float']['input']>;
  weighted_floor_surface?: InputMaybe<Scalars['Float']['input']>;
};

/** order by sum() on columns of table "properties" */
export type Properties_Sum_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** update columns of table "properties" */
export enum Properties_Update_Column {
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BasementSurface = 'basement_surface',
  /** column name */
  BorrowerLeadId = 'borrower_lead_id',
  /** column name */
  BuildingCondition = 'building_condition',
  /** column name */
  BuildingStandard = 'building_standard',
  /** column name */
  BuildingVolume = 'building_volume',
  /** column name */
  BuildingVolumeNorm = 'building_volume_norm',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CeilingHeight = 'ceiling_height',
  /** column name */
  Charges = 'charges',
  /** column name */
  CommercialPotentialRentalIncome = 'commercial_potential_rental_income',
  /** column name */
  CommercialSurface = 'commercial_surface',
  /** column name */
  CommercialYearlyRentalIncome = 'commercial_yearly_rental_income',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  Consumption = 'consumption',
  /** column name */
  Cooling = 'cooling',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  Ctn = 'ctn',
  /** column name */
  DeletedByUser = 'deleted_by_user',
  /** column name */
  DistanceToAirport = 'distance_to_airport',
  /** column name */
  DistanceToCityCenter = 'distance_to_city_center',
  /** column name */
  DistanceToGroceryShop = 'distance_to_grocery_shop',
  /** column name */
  DistanceToHighSchool = 'distance_to_high_school',
  /** column name */
  DistanceToHospital = 'distance_to_hospital',
  /** column name */
  DistanceToKindergarten = 'distance_to_kindergarten',
  /** column name */
  DistanceToMotorway = 'distance_to_motorway',
  /** column name */
  DistanceToPrimarySchool = 'distance_to_primary_school',
  /** column name */
  DistanceToPublicTransport = 'distance_to_public_transport',
  /** column name */
  DistanceToSportsCenter = 'distance_to_sports_center',
  /** column name */
  DistanceToTrainStation = 'distance_to_train_station',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Emissions = 'emissions',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyConsumptionClass = 'energy_consumption_class',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FinancingInstitutionId = 'financing_institution_id',
  /** column name */
  FlatCondition = 'flat_condition',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  GasEmissionsClass = 'gas_emissions_class',
  /** column name */
  Geom = 'geom',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  GrossFloorSurface = 'gross_floor_surface',
  /** column name */
  HasAttic = 'has_attic',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGym = 'has_gym',
  /** column name */
  HasPhotovoltaicPanels = 'has_photovoltaic_panels',
  /** column name */
  HasSauna = 'has_sauna',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasWellnessArea = 'has_wellness_area',
  /** column name */
  Heating = 'heating',
  /** column name */
  HeatingDistribution = 'heating_distribution',
  /** column name */
  IaziAddressId = 'iazi_address_id',
  /** column name */
  IncomeIncludesParking = 'income_includes_parking',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsCommercialFullyRented = 'is_commercial_fully_rented',
  /** column name */
  IsLuxury = 'is_luxury',
  /** column name */
  IsMaisonette = 'is_maisonette',
  /** column name */
  IsOrientedEast = 'is_oriented_east',
  /** column name */
  IsOrientedNorth = 'is_oriented_north',
  /** column name */
  IsOrientedSouth = 'is_oriented_south',
  /** column name */
  IsOrientedWest = 'is_oriented_west',
  /** column name */
  IsParkingFullyRented = 'is_parking_fully_rented',
  /** column name */
  IsRental = 'is_rental',
  /** column name */
  IsResidentialFullyRented = 'is_residential_fully_rented',
  /** column name */
  IsSecondaryResidence = 'is_secondary_residence',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LatestAppraisalId = 'latest_appraisal_id',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MacroLocation = 'macro_location',
  /** column name */
  MicroLocation = 'micro_location',
  /** column name */
  MinergieCode = 'minergie_code',
  /** column name */
  MonthlyGrossRent = 'monthly_gross_rent',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfCommercialUnits = 'number_of_commercial_units',
  /** column name */
  NumberOfFlats = 'number_of_flats',
  /** column name */
  NumberOfFloors = 'number_of_floors',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLifts = 'number_of_lifts',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfResidentialUnits = 'number_of_residential_units',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  Orientation = 'orientation',
  /** column name */
  OwnershipForm = 'ownership_form',
  /** column name */
  ParkingPotentialRentalIncome = 'parking_potential_rental_income',
  /** column name */
  ParkingYearlyRentalIncome = 'parking_yearly_rental_income',
  /** column name */
  PerceivedValue = 'perceived_value',
  /** column name */
  PlotHasConstructibleReserve = 'plot_has_constructible_reserve',
  /** column name */
  PlotIsConstructible = 'plot_is_constructible',
  /** column name */
  PlotNumber = 'plot_number',
  /** column name */
  PlotRegistryNumber = 'plot_registry_number',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PropertyTypeId = 'property_type_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  RelevantServitudes = 'relevant_servitudes',
  /** column name */
  RenovationFund = 'renovation_fund',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  ResidentialPotentialRentalIncome = 'residential_potential_rental_income',
  /** column name */
  ResidentialSurface = 'residential_surface',
  /** column name */
  ResidentialYearlyRentalIncome = 'residential_yearly_rental_income',
  /** column name */
  Route = 'route',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  ShareOfOwnership = 'share_of_ownership',
  /** column name */
  Side = 'side',
  /** column name */
  State = 'state',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  WeightedFloorSurface = 'weighted_floor_surface'
}

export type Properties_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Properties_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Properties_Set_Input>;
  /** filter the rows which have to be updated */
  where: Properties_Bool_Exp;
};

/** order by var_pop() on columns of table "properties" */
export type Properties_Var_Pop_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "properties" */
export type Properties_Var_Samp_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "properties" */
export type Properties_Variance_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** columns and relationships of "property_files" */
export type Property_Files = {
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  is_visible: Scalars['Boolean']['output'];
  order_nr: Scalars['Int']['output'];
  /** An object relationship */
  property: Properties;
  property_id: Scalars['uuid']['output'];
  tenant_id: Scalars['uuid']['output'];
};

/** aggregated selection of "property_files" */
export type Property_Files_Aggregate = {
  aggregate?: Maybe<Property_Files_Aggregate_Fields>;
  nodes: Array<Property_Files>;
};

export type Property_Files_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Property_Files_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Property_Files_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Property_Files_Aggregate_Bool_Exp_Count>;
};

export type Property_Files_Aggregate_Bool_Exp_Bool_And = {
  arguments: Property_Files_Select_Column_Property_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Files_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Property_Files_Select_Column_Property_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Files_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Files_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_files" */
export type Property_Files_Aggregate_Fields = {
  avg?: Maybe<Property_Files_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Files_Max_Fields>;
  min?: Maybe<Property_Files_Min_Fields>;
  stddev?: Maybe<Property_Files_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Files_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Files_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Files_Sum_Fields>;
  var_pop?: Maybe<Property_Files_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Files_Var_Samp_Fields>;
  variance?: Maybe<Property_Files_Variance_Fields>;
};


/** aggregate fields of "property_files" */
export type Property_Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_files" */
export type Property_Files_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Files_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Files_Max_Order_By>;
  min?: InputMaybe<Property_Files_Min_Order_By>;
  stddev?: InputMaybe<Property_Files_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Files_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Files_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Files_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Files_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Files_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Files_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "property_files" */
export type Property_Files_Arr_Rel_Insert_Input = {
  data: Array<Property_Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Files_On_Conflict>;
};

/** aggregate avg on columns */
export type Property_Files_Avg_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_files" */
export type Property_Files_Avg_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_files". All fields are combined with a logical 'AND'. */
export type Property_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Files_Bool_Exp>>;
  _not?: InputMaybe<Property_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Files_Bool_Exp>>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_visible?: InputMaybe<Boolean_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  property?: InputMaybe<Properties_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_files" */
export enum Property_Files_Constraint {
  /** unique or primary key constraint on columns "property_id", "file_id" */
  PropertyFilesPropertyIdFileIdUnique = 'property_files_property_id_file_id_unique',
  /** unique or primary key constraint on columns "property_id", "file_id" */
  UniquePropertyIdFileId = 'unique_property_id_file_id',
  /** unique or primary key constraint on columns "order_nr", "property_id" */
  UniquePropertyIdOrderNr = 'unique_property_id_order_nr'
}

/** input type for incrementing numeric columns in table "property_files" */
export type Property_Files_Inc_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "property_files" */
export type Property_Files_Insert_Input = {
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  property?: InputMaybe<Properties_Obj_Rel_Insert_Input>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Property_Files_Max_Fields = {
  file_id?: Maybe<Scalars['uuid']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "property_files" */
export type Property_Files_Max_Order_By = {
  file_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Files_Min_Fields = {
  file_id?: Maybe<Scalars['uuid']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "property_files" */
export type Property_Files_Min_Order_By = {
  file_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_files" */
export type Property_Files_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Files>;
};

/** on_conflict condition type for table "property_files" */
export type Property_Files_On_Conflict = {
  constraint: Property_Files_Constraint;
  update_columns?: Array<Property_Files_Update_Column>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};

/** Ordering options when selecting data from "property_files". */
export type Property_Files_Order_By = {
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  is_visible?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  property?: InputMaybe<Properties_Order_By>;
  property_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** select columns of table "property_files" */
export enum Property_Files_Select_Column {
  /** column name */
  FileId = 'file_id',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  TenantId = 'tenant_id'
}

/** select "property_files_aggregate_bool_exp_bool_and_arguments_columns" columns of table "property_files" */
export enum Property_Files_Select_Column_Property_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsVisible = 'is_visible'
}

/** select "property_files_aggregate_bool_exp_bool_or_arguments_columns" columns of table "property_files" */
export enum Property_Files_Select_Column_Property_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsVisible = 'is_visible'
}

/** input type for updating data in table "property_files" */
export type Property_Files_Set_Input = {
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Property_Files_Stddev_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_files" */
export type Property_Files_Stddev_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Property_Files_Stddev_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "property_files" */
export type Property_Files_Stddev_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Property_Files_Stddev_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "property_files" */
export type Property_Files_Stddev_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_files" */
export type Property_Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Files_Stream_Cursor_Value_Input = {
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Property_Files_Sum_Fields = {
  order_nr?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "property_files" */
export type Property_Files_Sum_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** update columns of table "property_files" */
export enum Property_Files_Update_Column {
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  OrderNr = 'order_nr'
}

export type Property_Files_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Files_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Files_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Files_Var_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "property_files" */
export type Property_Files_Var_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Property_Files_Var_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "property_files" */
export type Property_Files_Var_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Property_Files_Variance_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_files" */
export type Property_Files_Variance_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** columns and relationships of "property_images" */
export type Property_Images = {
  background_color: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  crop: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  display_on_brochure: Scalars['Boolean']['output'];
  display_on_listing: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  image: Images;
  image_id: Scalars['uuid']['output'];
  is_floor_plan: Scalars['Boolean']['output'];
  landscape_background_color: Scalars['String']['output'];
  landscape_crop: Scalars['String']['output'];
  landscape_size: Scalars['String']['output'];
  order_nr: Scalars['Int']['output'];
  /** An object relationship */
  property: Properties;
  property_id: Scalars['uuid']['output'];
  size: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "property_images" */
export type Property_Images_Aggregate = {
  aggregate?: Maybe<Property_Images_Aggregate_Fields>;
  nodes: Array<Property_Images>;
};

export type Property_Images_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Property_Images_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Property_Images_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Property_Images_Aggregate_Bool_Exp_Count>;
};

export type Property_Images_Aggregate_Bool_Exp_Bool_And = {
  arguments: Property_Images_Select_Column_Property_Images_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Images_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Images_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Property_Images_Select_Column_Property_Images_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Images_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Images_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Images_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_images" */
export type Property_Images_Aggregate_Fields = {
  avg?: Maybe<Property_Images_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Images_Max_Fields>;
  min?: Maybe<Property_Images_Min_Fields>;
  stddev?: Maybe<Property_Images_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Images_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Images_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Images_Sum_Fields>;
  var_pop?: Maybe<Property_Images_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Images_Var_Samp_Fields>;
  variance?: Maybe<Property_Images_Variance_Fields>;
};


/** aggregate fields of "property_images" */
export type Property_Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_images" */
export type Property_Images_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Images_Max_Order_By>;
  min?: InputMaybe<Property_Images_Min_Order_By>;
  stddev?: InputMaybe<Property_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Images_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Images_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "property_images" */
export type Property_Images_Arr_Rel_Insert_Input = {
  data: Array<Property_Images_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Images_On_Conflict>;
};

/** aggregate avg on columns */
export type Property_Images_Avg_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_images" */
export type Property_Images_Avg_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_images". All fields are combined with a logical 'AND'. */
export type Property_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Images_Bool_Exp>>;
  _not?: InputMaybe<Property_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Images_Bool_Exp>>;
  background_color?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_on_brochure?: InputMaybe<Boolean_Comparison_Exp>;
  display_on_listing?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<Images_Bool_Exp>;
  image_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_floor_plan?: InputMaybe<Boolean_Comparison_Exp>;
  landscape_background_color?: InputMaybe<String_Comparison_Exp>;
  landscape_crop?: InputMaybe<String_Comparison_Exp>;
  landscape_size?: InputMaybe<String_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  property?: InputMaybe<Properties_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  size?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_images" */
export enum Property_Images_Constraint {
  /** unique or primary key constraint on columns "id" */
  PropertyImagesPkey = 'property_images_pkey',
  /** unique or primary key constraint on columns "property_id", "image_id" */
  PropertyImagesPropertyIdImageIdUnique = 'property_images_property_id_image_id_unique',
  /** unique or primary key constraint on columns "order_nr", "property_id" */
  PropertyImagesPropertyIdOrderNrUnique = 'property_images_property_id_order_nr_unique'
}

/** input type for incrementing numeric columns in table "property_images" */
export type Property_Images_Inc_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "property_images" */
export type Property_Images_Insert_Input = {
  background_color?: InputMaybe<Scalars['String']['input']>;
  crop?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  display_on_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_floor_plan?: InputMaybe<Scalars['Boolean']['input']>;
  landscape_background_color?: InputMaybe<Scalars['String']['input']>;
  landscape_crop?: InputMaybe<Scalars['String']['input']>;
  landscape_size?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  property?: InputMaybe<Properties_Obj_Rel_Insert_Input>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Property_Images_Max_Fields = {
  background_color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_id?: Maybe<Scalars['uuid']['output']>;
  landscape_background_color?: Maybe<Scalars['String']['output']>;
  landscape_crop?: Maybe<Scalars['String']['output']>;
  landscape_size?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "property_images" */
export type Property_Images_Max_Order_By = {
  background_color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  landscape_background_color?: InputMaybe<Order_By>;
  landscape_crop?: InputMaybe<Order_By>;
  landscape_size?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Images_Min_Fields = {
  background_color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_id?: Maybe<Scalars['uuid']['output']>;
  landscape_background_color?: Maybe<Scalars['String']['output']>;
  landscape_crop?: Maybe<Scalars['String']['output']>;
  landscape_size?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "property_images" */
export type Property_Images_Min_Order_By = {
  background_color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  landscape_background_color?: InputMaybe<Order_By>;
  landscape_crop?: InputMaybe<Order_By>;
  landscape_size?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_images" */
export type Property_Images_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Images>;
};

/** on_conflict condition type for table "property_images" */
export type Property_Images_On_Conflict = {
  constraint: Property_Images_Constraint;
  update_columns?: Array<Property_Images_Update_Column>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};

/** Ordering options when selecting data from "property_images". */
export type Property_Images_Order_By = {
  background_color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_on_brochure?: InputMaybe<Order_By>;
  display_on_listing?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Images_Order_By>;
  image_id?: InputMaybe<Order_By>;
  is_floor_plan?: InputMaybe<Order_By>;
  landscape_background_color?: InputMaybe<Order_By>;
  landscape_crop?: InputMaybe<Order_By>;
  landscape_size?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  property?: InputMaybe<Properties_Order_By>;
  property_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_images */
export type Property_Images_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_images" */
export enum Property_Images_Select_Column {
  /** column name */
  BackgroundColor = 'background_color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crop = 'crop',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsFloorPlan = 'is_floor_plan',
  /** column name */
  LandscapeBackgroundColor = 'landscape_background_color',
  /** column name */
  LandscapeCrop = 'landscape_crop',
  /** column name */
  LandscapeSize = 'landscape_size',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  Size = 'size',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "property_images_aggregate_bool_exp_bool_and_arguments_columns" columns of table "property_images" */
export enum Property_Images_Select_Column_Property_Images_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  IsFloorPlan = 'is_floor_plan'
}

/** select "property_images_aggregate_bool_exp_bool_or_arguments_columns" columns of table "property_images" */
export enum Property_Images_Select_Column_Property_Images_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  IsFloorPlan = 'is_floor_plan'
}

/** input type for updating data in table "property_images" */
export type Property_Images_Set_Input = {
  background_color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  display_on_listing?: InputMaybe<Scalars['Boolean']['input']>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_floor_plan?: InputMaybe<Scalars['Boolean']['input']>;
  landscape_background_color?: InputMaybe<Scalars['String']['input']>;
  landscape_crop?: InputMaybe<Scalars['String']['input']>;
  landscape_size?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Property_Images_Stddev_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_images" */
export type Property_Images_Stddev_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Property_Images_Stddev_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "property_images" */
export type Property_Images_Stddev_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Property_Images_Stddev_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "property_images" */
export type Property_Images_Stddev_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_images" */
export type Property_Images_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Images_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Images_Stream_Cursor_Value_Input = {
  background_color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  display_on_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_floor_plan?: InputMaybe<Scalars['Boolean']['input']>;
  landscape_background_color?: InputMaybe<Scalars['String']['input']>;
  landscape_crop?: InputMaybe<Scalars['String']['input']>;
  landscape_size?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Property_Images_Sum_Fields = {
  order_nr?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "property_images" */
export type Property_Images_Sum_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** update columns of table "property_images" */
export enum Property_Images_Update_Column {
  /** column name */
  BackgroundColor = 'background_color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crop = 'crop',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsFloorPlan = 'is_floor_plan',
  /** column name */
  LandscapeBackgroundColor = 'landscape_background_color',
  /** column name */
  LandscapeCrop = 'landscape_crop',
  /** column name */
  LandscapeSize = 'landscape_size',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  Size = 'size',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Property_Images_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Images_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Images_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Images_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Images_Var_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "property_images" */
export type Property_Images_Var_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Property_Images_Var_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "property_images" */
export type Property_Images_Var_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Property_Images_Variance_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_images" */
export type Property_Images_Variance_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** columns and relationships of "property_pois" */
export type Property_Pois = {
  cycling_distance_meters?: Maybe<Scalars['Int']['output']>;
  cycling_time_minutes?: Maybe<Scalars['Int']['output']>;
  distance_meters: Scalars['Int']['output'];
  driving_distance_meters?: Maybe<Scalars['Int']['output']>;
  driving_time_minutes?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  poi: Pois;
  poi_id: Scalars['uuid']['output'];
  /** An object relationship */
  property: Properties;
  property_id: Scalars['uuid']['output'];
  transit_distance_meters?: Maybe<Scalars['Int']['output']>;
  transit_time_minutes?: Maybe<Scalars['Int']['output']>;
  walking_distance_meters?: Maybe<Scalars['Int']['output']>;
  walking_time_minutes?: Maybe<Scalars['Int']['output']>;
};

/** order by aggregate values of table "property_pois" */
export type Property_Pois_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Pois_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Pois_Max_Order_By>;
  min?: InputMaybe<Property_Pois_Min_Order_By>;
  stddev?: InputMaybe<Property_Pois_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Pois_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Pois_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Pois_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Pois_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Pois_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Pois_Variance_Order_By>;
};

/** order by avg() on columns of table "property_pois" */
export type Property_Pois_Avg_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_pois". All fields are combined with a logical 'AND'. */
export type Property_Pois_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Pois_Bool_Exp>>;
  _not?: InputMaybe<Property_Pois_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Pois_Bool_Exp>>;
  cycling_distance_meters?: InputMaybe<Int_Comparison_Exp>;
  cycling_time_minutes?: InputMaybe<Int_Comparison_Exp>;
  distance_meters?: InputMaybe<Int_Comparison_Exp>;
  driving_distance_meters?: InputMaybe<Int_Comparison_Exp>;
  driving_time_minutes?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  poi?: InputMaybe<Pois_Bool_Exp>;
  poi_id?: InputMaybe<Uuid_Comparison_Exp>;
  property?: InputMaybe<Properties_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  transit_distance_meters?: InputMaybe<Int_Comparison_Exp>;
  transit_time_minutes?: InputMaybe<Int_Comparison_Exp>;
  walking_distance_meters?: InputMaybe<Int_Comparison_Exp>;
  walking_time_minutes?: InputMaybe<Int_Comparison_Exp>;
};

/** order by max() on columns of table "property_pois" */
export type Property_Pois_Max_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poi_id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "property_pois" */
export type Property_Pois_Min_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poi_id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_pois" */
export type Property_Pois_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Pois>;
};

/** Ordering options when selecting data from "property_pois". */
export type Property_Pois_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poi?: InputMaybe<Pois_Order_By>;
  poi_id?: InputMaybe<Order_By>;
  property?: InputMaybe<Properties_Order_By>;
  property_id?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** select columns of table "property_pois" */
export enum Property_Pois_Select_Column {
  /** column name */
  CyclingDistanceMeters = 'cycling_distance_meters',
  /** column name */
  CyclingTimeMinutes = 'cycling_time_minutes',
  /** column name */
  DistanceMeters = 'distance_meters',
  /** column name */
  DrivingDistanceMeters = 'driving_distance_meters',
  /** column name */
  DrivingTimeMinutes = 'driving_time_minutes',
  /** column name */
  Id = 'id',
  /** column name */
  PoiId = 'poi_id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  TransitDistanceMeters = 'transit_distance_meters',
  /** column name */
  TransitTimeMinutes = 'transit_time_minutes',
  /** column name */
  WalkingDistanceMeters = 'walking_distance_meters',
  /** column name */
  WalkingTimeMinutes = 'walking_time_minutes'
}

/** order by stddev() on columns of table "property_pois" */
export type Property_Pois_Stddev_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "property_pois" */
export type Property_Pois_Stddev_Pop_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "property_pois" */
export type Property_Pois_Stddev_Samp_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "property_pois" */
export type Property_Pois_Sum_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "property_pois" */
export type Property_Pois_Var_Pop_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "property_pois" */
export type Property_Pois_Var_Samp_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "property_pois" */
export type Property_Pois_Variance_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** columns and relationships of "property_search_aggregator_source" */
export type Property_Search_Aggregator_Source = {
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "property_search_aggregator_source". All fields are combined with a logical 'AND'. */
export type Property_Search_Aggregator_Source_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Search_Aggregator_Source_Bool_Exp>>;
  _not?: InputMaybe<Property_Search_Aggregator_Source_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Search_Aggregator_Source_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Property_Search_Aggregator_Source_Enum {
  ListingClickout = 'listing_clickout',
  ListingSimilarClick = 'listing_similar_click',
  ListingsManual = 'listings_manual',
  ListingsPageNavigationClick = 'listings_page_navigation_click'
}

/** Boolean expression to compare columns of type "property_search_aggregator_source_enum". All fields are combined with logical 'AND'. */
export type Property_Search_Aggregator_Source_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Property_Search_Aggregator_Source_Enum>;
  _in?: InputMaybe<Array<Property_Search_Aggregator_Source_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Property_Search_Aggregator_Source_Enum>;
  _nin?: InputMaybe<Array<Property_Search_Aggregator_Source_Enum>>;
};

/** Ordering options when selecting data from "property_search_aggregator_source". */
export type Property_Search_Aggregator_Source_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "property_search_aggregator_source" */
export enum Property_Search_Aggregator_Source_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "property_search_aggregator_source" */
export type Property_Search_Aggregator_Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Search_Aggregator_Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Search_Aggregator_Source_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "property_search_source" */
export type Property_Search_Source = {
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "property_search_source". All fields are combined with a logical 'AND'. */
export type Property_Search_Source_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Search_Source_Bool_Exp>>;
  _not?: InputMaybe<Property_Search_Source_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Search_Source_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Property_Search_Source_Enum {
  Aggregator = 'aggregator',
  Android = 'android',
  Crm = 'crm',
  Enquiry = 'enquiry',
  ImmologicForm = 'immologic_form',
  Ios = 'ios',
  Other = 'other',
  Valuation = 'valuation'
}

/** Boolean expression to compare columns of type "property_search_source_enum". All fields are combined with logical 'AND'. */
export type Property_Search_Source_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Property_Search_Source_Enum>;
  _in?: InputMaybe<Array<Property_Search_Source_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Property_Search_Source_Enum>;
  _nin?: InputMaybe<Array<Property_Search_Source_Enum>>;
};

/** Ordering options when selecting data from "property_search_source". */
export type Property_Search_Source_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "property_search_source" */
export enum Property_Search_Source_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "property_search_source" */
export type Property_Search_Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Search_Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Search_Source_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "property_searches" */
export type Property_Searches = {
  activate_aggregator: Scalars['Boolean']['output'];
  agency_reference_contains?: Maybe<Scalars['String']['output']>;
  aggregator_source?: Maybe<Property_Search_Aggregator_Source_Enum>;
  awaiting_alert_handle: Scalars['Boolean']['output'];
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  composite_property_type_eq?: Maybe<Scalars['String']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_at_gte?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_lift?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool: Scalars['Boolean']['output'];
  has_view?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  imported_id?: Maybe<Scalars['String']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  last_alert_handle: Scalars['timestamptz']['output'];
  last_viewed_at?: Maybe<Scalars['timestamptz']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['float8']['output']>;
  max_travel_time?: Maybe<Scalars['Int']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Int']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Int']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  notification: Scalars['property_searches_notification']['output'];
  number_of_bathrooms_gte?: Maybe<Scalars['Int']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Int']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Int']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  portal_in?: Maybe<Array<Scalars['String']['output']>>;
  property_main_type_in?: Maybe<Array<Scalars['String']['output']>>;
  property_main_type_nin?: Maybe<Array<Scalars['String']['output']>>;
  /** An array relationship */
  property_searches_enquiries: Array<Property_Searches_Enquiries>;
  /** An array relationship */
  property_searches_places: Array<Property_Searches_Places>;
  property_status?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  property_types: Array<Property_Searches_Property_Types>;
  /** An aggregate relationship */
  property_types_aggregate: Property_Searches_Property_Types_Aggregate;
  property_usage?: Maybe<Scalars['String']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Int']['output']>;
  sale_price_lte?: Maybe<Scalars['Int']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Property_Search_Source_Enum>;
  tenant_id: Scalars['uuid']['output'];
  title?: Maybe<Scalars['String']['output']>;
  travel_from_lat?: Maybe<Scalars['float8']['output']>;
  travel_from_lng?: Maybe<Scalars['float8']['output']>;
  travel_mode?: Maybe<Travel_Modes_Enum_Enum>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "property_searches" */
export type Property_SearchesProperty_Searches_EnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Enquiries_Order_By>>;
  where?: InputMaybe<Property_Searches_Enquiries_Bool_Exp>;
};


/** columns and relationships of "property_searches" */
export type Property_SearchesProperty_Searches_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Places_Order_By>>;
  where?: InputMaybe<Property_Searches_Places_Bool_Exp>;
};


/** columns and relationships of "property_searches" */
export type Property_SearchesProperty_TypesArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Property_Types_Order_By>>;
  where?: InputMaybe<Property_Searches_Property_Types_Bool_Exp>;
};


/** columns and relationships of "property_searches" */
export type Property_SearchesProperty_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Property_Types_Order_By>>;
  where?: InputMaybe<Property_Searches_Property_Types_Bool_Exp>;
};

/** aggregated selection of "property_searches" */
export type Property_Searches_Aggregate = {
  aggregate?: Maybe<Property_Searches_Aggregate_Fields>;
  nodes: Array<Property_Searches>;
};

export type Property_Searches_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Var_Samp>;
};

export type Property_Searches_Aggregate_Bool_Exp_Avg = {
  arguments: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Bool_And = {
  arguments: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Corr = {
  arguments: Property_Searches_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Property_Searches_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Searches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Property_Searches_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Property_Searches_Aggregate_Bool_Exp_Max = {
  arguments: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Min = {
  arguments: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Sum = {
  arguments: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "property_searches" */
export type Property_Searches_Aggregate_Fields = {
  avg?: Maybe<Property_Searches_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Searches_Max_Fields>;
  min?: Maybe<Property_Searches_Min_Fields>;
  stddev?: Maybe<Property_Searches_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Searches_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Searches_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Searches_Sum_Fields>;
  var_pop?: Maybe<Property_Searches_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Searches_Var_Samp_Fields>;
  variance?: Maybe<Property_Searches_Variance_Fields>;
};


/** aggregate fields of "property_searches" */
export type Property_Searches_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Searches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_searches" */
export type Property_Searches_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Searches_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Searches_Max_Order_By>;
  min?: InputMaybe<Property_Searches_Min_Order_By>;
  stddev?: InputMaybe<Property_Searches_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Searches_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Searches_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Searches_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Searches_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Searches_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Searches_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "property_searches" */
export type Property_Searches_Arr_Rel_Insert_Input = {
  data: Array<Property_Searches_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Searches_On_Conflict>;
};

/** aggregate avg on columns */
export type Property_Searches_Avg_Fields = {
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  max_travel_time?: Maybe<Scalars['Float']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  travel_from_lat?: Maybe<Scalars['Float']['output']>;
  travel_from_lng?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_searches" */
export type Property_Searches_Avg_Order_By = {
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_searches". All fields are combined with a logical 'AND'. */
export type Property_Searches_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Searches_Bool_Exp>>;
  _not?: InputMaybe<Property_Searches_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Searches_Bool_Exp>>;
  activate_aggregator?: InputMaybe<Boolean_Comparison_Exp>;
  agency_reference_contains?: InputMaybe<String_Comparison_Exp>;
  aggregator_source?: InputMaybe<Property_Search_Aggregator_Source_Enum_Comparison_Exp>;
  awaiting_alert_handle?: InputMaybe<Boolean_Comparison_Exp>;
  balcony_surface_gte?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface_lte?: InputMaybe<Float_Comparison_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  composite_property_type_eq?: InputMaybe<String_Comparison_Exp>;
  computed_budget_gte?: InputMaybe<Float_Comparison_Exp>;
  computed_budget_lte?: InputMaybe<Float_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at_gte?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  garden_surface_gte?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  gross_rent_m2_yearly_gte?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2_yearly_lte?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly_gte?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly_lte?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_lift?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_id?: InputMaybe<String_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  land_surface_gte?: InputMaybe<Float_Comparison_Exp>;
  land_surface_lte?: InputMaybe<Float_Comparison_Exp>;
  last_alert_handle?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_viewed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  living_surface_gte?: InputMaybe<Float_Comparison_Exp>;
  living_surface_lte?: InputMaybe<Float_Comparison_Exp>;
  max_distance?: InputMaybe<Float8_Comparison_Exp>;
  max_travel_time?: InputMaybe<Int_Comparison_Exp>;
  monthly_rent_gte?: InputMaybe<Int_Comparison_Exp>;
  monthly_rent_lte?: InputMaybe<Int_Comparison_Exp>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Float_Comparison_Exp>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Float_Comparison_Exp>;
  notification?: InputMaybe<Property_Searches_Notification_Comparison_Exp>;
  number_of_bathrooms_gte?: InputMaybe<Int_Comparison_Exp>;
  number_of_bathrooms_lte?: InputMaybe<Int_Comparison_Exp>;
  number_of_bedrooms_gte?: InputMaybe<Int_Comparison_Exp>;
  number_of_bedrooms_lte?: InputMaybe<Int_Comparison_Exp>;
  number_of_indoor_parkings_gte?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings_gte?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms_gte?: InputMaybe<Float_Comparison_Exp>;
  number_of_rooms_lte?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  portal_in?: InputMaybe<String_Array_Comparison_Exp>;
  property_main_type_in?: InputMaybe<String_Array_Comparison_Exp>;
  property_main_type_nin?: InputMaybe<String_Array_Comparison_Exp>;
  property_searches_enquiries?: InputMaybe<Property_Searches_Enquiries_Bool_Exp>;
  property_searches_places?: InputMaybe<Property_Searches_Places_Bool_Exp>;
  property_status?: InputMaybe<String_Comparison_Exp>;
  property_types?: InputMaybe<Property_Searches_Property_Types_Bool_Exp>;
  property_types_aggregate?: InputMaybe<Property_Searches_Property_Types_Aggregate_Bool_Exp>;
  property_usage?: InputMaybe<String_Comparison_Exp>;
  rental_return_gte?: InputMaybe<Float_Comparison_Exp>;
  rental_return_lte?: InputMaybe<Float_Comparison_Exp>;
  sale_price_gte?: InputMaybe<Int_Comparison_Exp>;
  sale_price_lte?: InputMaybe<Int_Comparison_Exp>;
  sale_price_per_land_surface_gte?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface_lte?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface_gte?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface_lte?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price_gte?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price_lte?: InputMaybe<Float_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<Property_Search_Source_Enum_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  travel_from_lat?: InputMaybe<Float8_Comparison_Exp>;
  travel_from_lng?: InputMaybe<Float8_Comparison_Exp>;
  travel_mode?: InputMaybe<Travel_Modes_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_searches" */
export enum Property_Searches_Constraint {
  /** unique or primary key constraint on columns "id" */
  PropertySearchesTmpPkey = 'property_searches_tmp_pkey'
}

/** columns and relationships of "property_searches_enquiries" */
export type Property_Searches_Enquiries = {
  /** An object relationship */
  enquiry: Enquiries;
  enquiry_id: Scalars['uuid']['output'];
  /** An object relationship */
  property_search: Property_Searches;
  property_search_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "property_searches_enquiries" */
export type Property_Searches_Enquiries_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Searches_Enquiries_Max_Order_By>;
  min?: InputMaybe<Property_Searches_Enquiries_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "property_searches_enquiries". All fields are combined with a logical 'AND'. */
export type Property_Searches_Enquiries_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Searches_Enquiries_Bool_Exp>>;
  _not?: InputMaybe<Property_Searches_Enquiries_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Searches_Enquiries_Bool_Exp>>;
  enquiry?: InputMaybe<Enquiries_Bool_Exp>;
  enquiry_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_search?: InputMaybe<Property_Searches_Bool_Exp>;
  property_search_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "property_searches_enquiries" */
export type Property_Searches_Enquiries_Max_Order_By = {
  enquiry_id?: InputMaybe<Order_By>;
  property_search_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "property_searches_enquiries" */
export type Property_Searches_Enquiries_Min_Order_By = {
  enquiry_id?: InputMaybe<Order_By>;
  property_search_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "property_searches_enquiries". */
export type Property_Searches_Enquiries_Order_By = {
  enquiry?: InputMaybe<Enquiries_Order_By>;
  enquiry_id?: InputMaybe<Order_By>;
  property_search?: InputMaybe<Property_Searches_Order_By>;
  property_search_id?: InputMaybe<Order_By>;
};

/** select columns of table "property_searches_enquiries" */
export enum Property_Searches_Enquiries_Select_Column {
  /** column name */
  EnquiryId = 'enquiry_id',
  /** column name */
  PropertySearchId = 'property_search_id'
}

/** input type for incrementing numeric columns in table "property_searches" */
export type Property_Searches_Inc_Input = {
  balcony_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  built_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  built_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  garden_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_m2_yearly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_m2_yearly_lte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_lte?: InputMaybe<Scalars['Float']['input']>;
  land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  max_travel_time?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_gte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_lte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Scalars['Float']['input']>;
  number_of_bathrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bathrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms_gte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_lte?: InputMaybe<Scalars['Float']['input']>;
  rental_return_gte?: InputMaybe<Scalars['Float']['input']>;
  rental_return_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_gte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_lte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_per_land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_lte?: InputMaybe<Scalars['Float']['input']>;
  travel_from_lat?: InputMaybe<Scalars['float8']['input']>;
  travel_from_lng?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "property_searches" */
export type Property_Searches_Insert_Input = {
  agency_reference_contains?: InputMaybe<Scalars['String']['input']>;
  aggregator_source?: InputMaybe<Property_Search_Aggregator_Source_Enum>;
  balcony_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  book_online?: InputMaybe<Scalars['Boolean']['input']>;
  built_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  built_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  composite_property_type_eq?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  garden_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  geog?: InputMaybe<Scalars['geography']['input']>;
  gross_rent_m2_yearly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_m2_yearly_lte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_lte?: InputMaybe<Scalars['Float']['input']>;
  has_balcony?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_garage?: InputMaybe<Scalars['Boolean']['input']>;
  has_garden?: InputMaybe<Scalars['Boolean']['input']>;
  has_lift?: InputMaybe<Scalars['Boolean']['input']>;
  has_parking?: InputMaybe<Scalars['Boolean']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_fsbo?: InputMaybe<Scalars['Boolean']['input']>;
  is_furnished?: InputMaybe<Scalars['Boolean']['input']>;
  is_minergie_certified?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_development?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  max_travel_time?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_gte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_lte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Scalars['Float']['input']>;
  notification?: InputMaybe<Scalars['property_searches_notification']['input']>;
  number_of_bathrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bathrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms_gte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_lte?: InputMaybe<Scalars['Float']['input']>;
  offer_type?: InputMaybe<Scalars['String']['input']>;
  portal_in?: InputMaybe<Array<Scalars['String']['input']>>;
  property_main_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  property_main_type_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  property_searches_places?: InputMaybe<Property_Searches_Places_Arr_Rel_Insert_Input>;
  property_types?: InputMaybe<Property_Searches_Property_Types_Arr_Rel_Insert_Input>;
  property_usage?: InputMaybe<Scalars['String']['input']>;
  rental_return_gte?: InputMaybe<Scalars['Float']['input']>;
  rental_return_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_gte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_lte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_per_land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_lte?: InputMaybe<Scalars['Float']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Property_Search_Source_Enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  travel_from_lat?: InputMaybe<Scalars['float8']['input']>;
  travel_from_lng?: InputMaybe<Scalars['float8']['input']>;
  travel_mode?: InputMaybe<Travel_Modes_Enum_Enum>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Property_Searches_Max_Fields = {
  agency_reference_contains?: Maybe<Scalars['String']['output']>;
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  composite_property_type_eq?: Maybe<Scalars['String']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at_gte?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_id?: Maybe<Scalars['String']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  last_alert_handle?: Maybe<Scalars['timestamptz']['output']>;
  last_viewed_at?: Maybe<Scalars['timestamptz']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['float8']['output']>;
  max_travel_time?: Maybe<Scalars['Int']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Int']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Int']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  notification?: Maybe<Scalars['property_searches_notification']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Int']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Int']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Int']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  portal_in?: Maybe<Array<Scalars['String']['output']>>;
  property_main_type_in?: Maybe<Array<Scalars['String']['output']>>;
  property_main_type_nin?: Maybe<Array<Scalars['String']['output']>>;
  property_status?: Maybe<Scalars['String']['output']>;
  property_usage?: Maybe<Scalars['String']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Int']['output']>;
  sale_price_lte?: Maybe<Scalars['Int']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  travel_from_lat?: Maybe<Scalars['float8']['output']>;
  travel_from_lng?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "property_searches" */
export type Property_Searches_Max_Order_By = {
  agency_reference_contains?: InputMaybe<Order_By>;
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  composite_property_type_eq?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_at_gte?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_id?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  last_alert_handle?: InputMaybe<Order_By>;
  last_viewed_at?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  notification?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  portal_in?: InputMaybe<Order_By>;
  property_main_type_in?: InputMaybe<Order_By>;
  property_main_type_nin?: InputMaybe<Order_By>;
  property_status?: InputMaybe<Order_By>;
  property_usage?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Searches_Min_Fields = {
  agency_reference_contains?: Maybe<Scalars['String']['output']>;
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  composite_property_type_eq?: Maybe<Scalars['String']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at_gte?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_id?: Maybe<Scalars['String']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  last_alert_handle?: Maybe<Scalars['timestamptz']['output']>;
  last_viewed_at?: Maybe<Scalars['timestamptz']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['float8']['output']>;
  max_travel_time?: Maybe<Scalars['Int']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Int']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Int']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  notification?: Maybe<Scalars['property_searches_notification']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Int']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Int']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Int']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  portal_in?: Maybe<Array<Scalars['String']['output']>>;
  property_main_type_in?: Maybe<Array<Scalars['String']['output']>>;
  property_main_type_nin?: Maybe<Array<Scalars['String']['output']>>;
  property_status?: Maybe<Scalars['String']['output']>;
  property_usage?: Maybe<Scalars['String']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Int']['output']>;
  sale_price_lte?: Maybe<Scalars['Int']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  travel_from_lat?: Maybe<Scalars['float8']['output']>;
  travel_from_lng?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "property_searches" */
export type Property_Searches_Min_Order_By = {
  agency_reference_contains?: InputMaybe<Order_By>;
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  composite_property_type_eq?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_at_gte?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_id?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  last_alert_handle?: InputMaybe<Order_By>;
  last_viewed_at?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  notification?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  portal_in?: InputMaybe<Order_By>;
  property_main_type_in?: InputMaybe<Order_By>;
  property_main_type_nin?: InputMaybe<Order_By>;
  property_status?: InputMaybe<Order_By>;
  property_usage?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_searches" */
export type Property_Searches_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Searches>;
};

/** Boolean expression to compare columns of type "property_searches_notification". All fields are combined with logical 'AND'. */
export type Property_Searches_Notification_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _gt?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _gte?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _in?: InputMaybe<Array<Scalars['property_searches_notification']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _lte?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _neq?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _nin?: InputMaybe<Array<Scalars['property_searches_notification']['input']>>;
};

/** input type for inserting object relation for remote table "property_searches" */
export type Property_Searches_Obj_Rel_Insert_Input = {
  data: Property_Searches_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Searches_On_Conflict>;
};

/** on_conflict condition type for table "property_searches" */
export type Property_Searches_On_Conflict = {
  constraint: Property_Searches_Constraint;
  update_columns?: Array<Property_Searches_Update_Column>;
  where?: InputMaybe<Property_Searches_Bool_Exp>;
};

/** Ordering options when selecting data from "property_searches". */
export type Property_Searches_Order_By = {
  activate_aggregator?: InputMaybe<Order_By>;
  agency_reference_contains?: InputMaybe<Order_By>;
  aggregator_source?: InputMaybe<Order_By>;
  awaiting_alert_handle?: InputMaybe<Order_By>;
  balcony_surface_gte?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  composite_property_type_eq?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_at_gte?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_lift?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_id?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  last_alert_handle?: InputMaybe<Order_By>;
  last_viewed_at?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  notification?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  portal_in?: InputMaybe<Order_By>;
  property_main_type_in?: InputMaybe<Order_By>;
  property_main_type_nin?: InputMaybe<Order_By>;
  property_searches_enquiries_aggregate?: InputMaybe<Property_Searches_Enquiries_Aggregate_Order_By>;
  property_searches_places_aggregate?: InputMaybe<Property_Searches_Places_Aggregate_Order_By>;
  property_status?: InputMaybe<Order_By>;
  property_types_aggregate?: InputMaybe<Property_Searches_Property_Types_Aggregate_Order_By>;
  property_usage?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
  travel_mode?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_searches */
export type Property_Searches_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "property_searches_places" */
export type Property_Searches_Places = {
  /** An object relationship */
  place: Places;
  place_id: Scalars['uuid']['output'];
  /** An object relationship */
  property_search: Property_Searches;
  property_search_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "property_searches_places" */
export type Property_Searches_Places_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Searches_Places_Max_Order_By>;
  min?: InputMaybe<Property_Searches_Places_Min_Order_By>;
};

/** input type for inserting array relation for remote table "property_searches_places" */
export type Property_Searches_Places_Arr_Rel_Insert_Input = {
  data: Array<Property_Searches_Places_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Searches_Places_On_Conflict>;
};

/** Boolean expression to filter rows from the table "property_searches_places". All fields are combined with a logical 'AND'. */
export type Property_Searches_Places_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Searches_Places_Bool_Exp>>;
  _not?: InputMaybe<Property_Searches_Places_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Searches_Places_Bool_Exp>>;
  place?: InputMaybe<Places_Bool_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_search?: InputMaybe<Property_Searches_Bool_Exp>;
  property_search_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_searches_places" */
export enum Property_Searches_Places_Constraint {
  /** unique or primary key constraint on columns "property_search_id", "place_id" */
  PropertySearchesPlacesPkey = 'property_searches_places_pkey'
}

/** input type for inserting data into table "property_searches_places" */
export type Property_Searches_Places_Insert_Input = {
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  property_search?: InputMaybe<Property_Searches_Obj_Rel_Insert_Input>;
  property_search_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "property_searches_places" */
export type Property_Searches_Places_Max_Order_By = {
  place_id?: InputMaybe<Order_By>;
  property_search_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "property_searches_places" */
export type Property_Searches_Places_Min_Order_By = {
  place_id?: InputMaybe<Order_By>;
  property_search_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_searches_places" */
export type Property_Searches_Places_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Searches_Places>;
};

/** on_conflict condition type for table "property_searches_places" */
export type Property_Searches_Places_On_Conflict = {
  constraint: Property_Searches_Places_Constraint;
  update_columns?: Array<Property_Searches_Places_Update_Column>;
  where?: InputMaybe<Property_Searches_Places_Bool_Exp>;
};

/** Ordering options when selecting data from "property_searches_places". */
export type Property_Searches_Places_Order_By = {
  place?: InputMaybe<Places_Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_search?: InputMaybe<Property_Searches_Order_By>;
  property_search_id?: InputMaybe<Order_By>;
};

/** select columns of table "property_searches_places" */
export enum Property_Searches_Places_Select_Column {
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PropertySearchId = 'property_search_id'
}

/** Streaming cursor of the table "property_searches_places" */
export type Property_Searches_Places_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Searches_Places_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Searches_Places_Stream_Cursor_Value_Input = {
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  property_search_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "property_searches_places" (current role has no relevant permissions) */
export enum Property_Searches_Places_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "property_searches_property_types" */
export type Property_Searches_Property_Types = {
  /** An object relationship */
  property_search?: Maybe<Property_Searches>;
  property_search_id: Scalars['uuid']['output'];
  /** An object relationship */
  property_type: Property_Types;
  property_type_id: Scalars['uuid']['output'];
};

/** aggregated selection of "property_searches_property_types" */
export type Property_Searches_Property_Types_Aggregate = {
  aggregate?: Maybe<Property_Searches_Property_Types_Aggregate_Fields>;
  nodes: Array<Property_Searches_Property_Types>;
};

export type Property_Searches_Property_Types_Aggregate_Bool_Exp = {
  count?: InputMaybe<Property_Searches_Property_Types_Aggregate_Bool_Exp_Count>;
};

export type Property_Searches_Property_Types_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Searches_Property_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Property_Types_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_searches_property_types" */
export type Property_Searches_Property_Types_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Searches_Property_Types_Max_Fields>;
  min?: Maybe<Property_Searches_Property_Types_Min_Fields>;
};


/** aggregate fields of "property_searches_property_types" */
export type Property_Searches_Property_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Searches_Property_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_searches_property_types" */
export type Property_Searches_Property_Types_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Searches_Property_Types_Max_Order_By>;
  min?: InputMaybe<Property_Searches_Property_Types_Min_Order_By>;
};

/** input type for inserting array relation for remote table "property_searches_property_types" */
export type Property_Searches_Property_Types_Arr_Rel_Insert_Input = {
  data: Array<Property_Searches_Property_Types_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Searches_Property_Types_On_Conflict>;
};

/** Boolean expression to filter rows from the table "property_searches_property_types". All fields are combined with a logical 'AND'. */
export type Property_Searches_Property_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Searches_Property_Types_Bool_Exp>>;
  _not?: InputMaybe<Property_Searches_Property_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Searches_Property_Types_Bool_Exp>>;
  property_search?: InputMaybe<Property_Searches_Bool_Exp>;
  property_search_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_type?: InputMaybe<Property_Types_Bool_Exp>;
  property_type_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_searches_property_types" */
export enum Property_Searches_Property_Types_Constraint {
  /** unique or primary key constraint on columns "property_type_id", "property_search_id" */
  PropertySearchesPropertyTypesPropertySearchIdPropertyTy = 'property_searches_property_types_property_search_id_property_ty'
}

/** input type for inserting data into table "property_searches_property_types" */
export type Property_Searches_Property_Types_Insert_Input = {
  property_search?: InputMaybe<Property_Searches_Obj_Rel_Insert_Input>;
  property_search_id?: InputMaybe<Scalars['uuid']['input']>;
  property_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Property_Searches_Property_Types_Max_Fields = {
  property_search_id?: Maybe<Scalars['uuid']['output']>;
  property_type_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "property_searches_property_types" */
export type Property_Searches_Property_Types_Max_Order_By = {
  property_search_id?: InputMaybe<Order_By>;
  property_type_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Searches_Property_Types_Min_Fields = {
  property_search_id?: Maybe<Scalars['uuid']['output']>;
  property_type_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "property_searches_property_types" */
export type Property_Searches_Property_Types_Min_Order_By = {
  property_search_id?: InputMaybe<Order_By>;
  property_type_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_searches_property_types" */
export type Property_Searches_Property_Types_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Searches_Property_Types>;
};

/** on_conflict condition type for table "property_searches_property_types" */
export type Property_Searches_Property_Types_On_Conflict = {
  constraint: Property_Searches_Property_Types_Constraint;
  update_columns?: Array<Property_Searches_Property_Types_Update_Column>;
  where?: InputMaybe<Property_Searches_Property_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "property_searches_property_types". */
export type Property_Searches_Property_Types_Order_By = {
  property_search?: InputMaybe<Property_Searches_Order_By>;
  property_search_id?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Property_Types_Order_By>;
  property_type_id?: InputMaybe<Order_By>;
};

/** select columns of table "property_searches_property_types" */
export enum Property_Searches_Property_Types_Select_Column {
  /** column name */
  PropertySearchId = 'property_search_id',
  /** column name */
  PropertyTypeId = 'property_type_id'
}

/** placeholder for update columns of table "property_searches_property_types" (current role has no relevant permissions) */
export enum Property_Searches_Property_Types_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** select columns of table "property_searches" */
export enum Property_Searches_Select_Column {
  /** column name */
  ActivateAggregator = 'activate_aggregator',
  /** column name */
  AgencyReferenceContains = 'agency_reference_contains',
  /** column name */
  AggregatorSource = 'aggregator_source',
  /** column name */
  AwaitingAlertHandle = 'awaiting_alert_handle',
  /** column name */
  BalconySurfaceGte = 'balcony_surface_gte',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurfaceLte = 'built_surface_lte',
  /** column name */
  Comment = 'comment',
  /** column name */
  CompositePropertyTypeEq = 'composite_property_type_eq',
  /** column name */
  ComputedBudgetGte = 'computed_budget_gte',
  /** column name */
  ComputedBudgetLte = 'computed_budget_lte',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedAtGte = 'created_at_gte',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  GardenSurfaceGte = 'garden_surface_gte',
  /** column name */
  Geog = 'geog',
  /** column name */
  GrossRentM2YearlyGte = 'gross_rent_m2_yearly_gte',
  /** column name */
  GrossRentM2YearlyLte = 'gross_rent_m2_yearly_lte',
  /** column name */
  GrossRentRoomMonthlyGte = 'gross_rent_room_monthly_gte',
  /** column name */
  GrossRentRoomMonthlyLte = 'gross_rent_room_monthly_lte',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasLift = 'has_lift',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  LandSurfaceGte = 'land_surface_gte',
  /** column name */
  LandSurfaceLte = 'land_surface_lte',
  /** column name */
  LastAlertHandle = 'last_alert_handle',
  /** column name */
  LastViewedAt = 'last_viewed_at',
  /** column name */
  LivingSurfaceGte = 'living_surface_gte',
  /** column name */
  LivingSurfaceLte = 'living_surface_lte',
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  MaxTravelTime = 'max_travel_time',
  /** column name */
  MonthlyRentGte = 'monthly_rent_gte',
  /** column name */
  MonthlyRentLte = 'monthly_rent_lte',
  /** column name */
  MonthlyRentVsEstimatedRentGte = 'monthly_rent_vs_estimated_rent_gte',
  /** column name */
  MonthlyRentVsEstimatedRentLte = 'monthly_rent_vs_estimated_rent_lte',
  /** column name */
  Notification = 'notification',
  /** column name */
  NumberOfBathroomsGte = 'number_of_bathrooms_gte',
  /** column name */
  NumberOfBathroomsLte = 'number_of_bathrooms_lte',
  /** column name */
  NumberOfBedroomsGte = 'number_of_bedrooms_gte',
  /** column name */
  NumberOfBedroomsLte = 'number_of_bedrooms_lte',
  /** column name */
  NumberOfIndoorParkingsGte = 'number_of_indoor_parkings_gte',
  /** column name */
  NumberOfOutdoorParkingsGte = 'number_of_outdoor_parkings_gte',
  /** column name */
  NumberOfRoomsGte = 'number_of_rooms_gte',
  /** column name */
  NumberOfRoomsLte = 'number_of_rooms_lte',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  PortalIn = 'portal_in',
  /** column name */
  PropertyMainTypeIn = 'property_main_type_in',
  /** column name */
  PropertyMainTypeNin = 'property_main_type_nin',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  PropertyUsage = 'property_usage',
  /** column name */
  RentalReturnGte = 'rental_return_gte',
  /** column name */
  RentalReturnLte = 'rental_return_lte',
  /** column name */
  SalePriceGte = 'sale_price_gte',
  /** column name */
  SalePriceLte = 'sale_price_lte',
  /** column name */
  SalePricePerLandSurfaceGte = 'sale_price_per_land_surface_gte',
  /** column name */
  SalePricePerLandSurfaceLte = 'sale_price_per_land_surface_lte',
  /** column name */
  SalePricePerLivingSurfaceGte = 'sale_price_per_living_surface_gte',
  /** column name */
  SalePricePerLivingSurfaceLte = 'sale_price_per_living_surface_lte',
  /** column name */
  SaleVsEstimatedPriceGte = 'sale_vs_estimated_price_gte',
  /** column name */
  SaleVsEstimatedPriceLte = 'sale_vs_estimated_price_lte',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Source = 'source',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng',
  /** column name */
  TravelMode = 'travel_mode',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "property_searches_aggregate_bool_exp_avg_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng'
}

/** select "property_searches_aggregate_bool_exp_bool_and_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ActivateAggregator = 'activate_aggregator',
  /** column name */
  AwaitingAlertHandle = 'awaiting_alert_handle',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasLift = 'has_lift',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible'
}

/** select "property_searches_aggregate_bool_exp_bool_or_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ActivateAggregator = 'activate_aggregator',
  /** column name */
  AwaitingAlertHandle = 'awaiting_alert_handle',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasLift = 'has_lift',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible'
}

/** select "property_searches_aggregate_bool_exp_corr_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng'
}

/** select "property_searches_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng'
}

/** select "property_searches_aggregate_bool_exp_max_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng'
}

/** select "property_searches_aggregate_bool_exp_min_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng'
}

/** select "property_searches_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng'
}

/** select "property_searches_aggregate_bool_exp_sum_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng'
}

/** select "property_searches_aggregate_bool_exp_var_samp_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng'
}

/** input type for updating data in table "property_searches" */
export type Property_Searches_Set_Input = {
  activate_aggregator?: InputMaybe<Scalars['Boolean']['input']>;
  agency_reference_contains?: InputMaybe<Scalars['String']['input']>;
  aggregator_source?: InputMaybe<Property_Search_Aggregator_Source_Enum>;
  awaiting_alert_handle?: InputMaybe<Scalars['Boolean']['input']>;
  balcony_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  book_online?: InputMaybe<Scalars['Boolean']['input']>;
  built_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  built_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  composite_property_type_eq?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  garden_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  geog?: InputMaybe<Scalars['geography']['input']>;
  gross_rent_m2_yearly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_m2_yearly_lte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_lte?: InputMaybe<Scalars['Float']['input']>;
  has_balcony?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_garage?: InputMaybe<Scalars['Boolean']['input']>;
  has_garden?: InputMaybe<Scalars['Boolean']['input']>;
  has_lift?: InputMaybe<Scalars['Boolean']['input']>;
  has_parking?: InputMaybe<Scalars['Boolean']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_fsbo?: InputMaybe<Scalars['Boolean']['input']>;
  is_furnished?: InputMaybe<Scalars['Boolean']['input']>;
  is_minergie_certified?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_development?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  last_alert_handle?: InputMaybe<Scalars['timestamptz']['input']>;
  last_viewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  max_travel_time?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_gte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_lte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Scalars['Float']['input']>;
  notification?: InputMaybe<Scalars['property_searches_notification']['input']>;
  number_of_bathrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bathrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms_gte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_lte?: InputMaybe<Scalars['Float']['input']>;
  offer_type?: InputMaybe<Scalars['String']['input']>;
  portal_in?: InputMaybe<Array<Scalars['String']['input']>>;
  property_main_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  property_main_type_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  property_usage?: InputMaybe<Scalars['String']['input']>;
  rental_return_gte?: InputMaybe<Scalars['Float']['input']>;
  rental_return_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_gte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_lte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_per_land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_lte?: InputMaybe<Scalars['Float']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Property_Search_Source_Enum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  travel_from_lat?: InputMaybe<Scalars['float8']['input']>;
  travel_from_lng?: InputMaybe<Scalars['float8']['input']>;
  travel_mode?: InputMaybe<Travel_Modes_Enum_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Property_Searches_Stddev_Fields = {
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  max_travel_time?: Maybe<Scalars['Float']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  travel_from_lat?: Maybe<Scalars['Float']['output']>;
  travel_from_lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_searches" */
export type Property_Searches_Stddev_Order_By = {
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Property_Searches_Stddev_Pop_Fields = {
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  max_travel_time?: Maybe<Scalars['Float']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  travel_from_lat?: Maybe<Scalars['Float']['output']>;
  travel_from_lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "property_searches" */
export type Property_Searches_Stddev_Pop_Order_By = {
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Property_Searches_Stddev_Samp_Fields = {
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  max_travel_time?: Maybe<Scalars['Float']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  travel_from_lat?: Maybe<Scalars['Float']['output']>;
  travel_from_lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "property_searches" */
export type Property_Searches_Stddev_Samp_Order_By = {
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_searches" */
export type Property_Searches_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Searches_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Searches_Stream_Cursor_Value_Input = {
  activate_aggregator?: InputMaybe<Scalars['Boolean']['input']>;
  agency_reference_contains?: InputMaybe<Scalars['String']['input']>;
  aggregator_source?: InputMaybe<Property_Search_Aggregator_Source_Enum>;
  awaiting_alert_handle?: InputMaybe<Scalars['Boolean']['input']>;
  balcony_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  book_online?: InputMaybe<Scalars['Boolean']['input']>;
  built_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  composite_property_type_eq?: InputMaybe<Scalars['String']['input']>;
  computed_budget_gte?: InputMaybe<Scalars['Float']['input']>;
  computed_budget_lte?: InputMaybe<Scalars['Float']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at_gte?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  garden_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  geog?: InputMaybe<Scalars['geography']['input']>;
  gross_rent_m2_yearly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_m2_yearly_lte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_lte?: InputMaybe<Scalars['Float']['input']>;
  has_balcony?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_garage?: InputMaybe<Scalars['Boolean']['input']>;
  has_garden?: InputMaybe<Scalars['Boolean']['input']>;
  has_lift?: InputMaybe<Scalars['Boolean']['input']>;
  has_parking?: InputMaybe<Scalars['Boolean']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_fsbo?: InputMaybe<Scalars['Boolean']['input']>;
  is_furnished?: InputMaybe<Scalars['Boolean']['input']>;
  is_minergie_certified?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_development?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  last_alert_handle?: InputMaybe<Scalars['timestamptz']['input']>;
  last_viewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  max_travel_time?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_gte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_lte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Scalars['Float']['input']>;
  notification?: InputMaybe<Scalars['property_searches_notification']['input']>;
  number_of_bathrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bathrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms_gte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_lte?: InputMaybe<Scalars['Float']['input']>;
  offer_type?: InputMaybe<Scalars['String']['input']>;
  portal_in?: InputMaybe<Array<Scalars['String']['input']>>;
  property_main_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  property_main_type_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  property_usage?: InputMaybe<Scalars['String']['input']>;
  rental_return_gte?: InputMaybe<Scalars['Float']['input']>;
  rental_return_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_gte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_lte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_per_land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_lte?: InputMaybe<Scalars['Float']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Property_Search_Source_Enum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  travel_from_lat?: InputMaybe<Scalars['float8']['input']>;
  travel_from_lng?: InputMaybe<Scalars['float8']['input']>;
  travel_mode?: InputMaybe<Travel_Modes_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Property_Searches_Sum_Fields = {
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['float8']['output']>;
  max_travel_time?: Maybe<Scalars['Int']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Int']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Int']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Int']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Int']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Int']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Int']['output']>;
  sale_price_lte?: Maybe<Scalars['Int']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  travel_from_lat?: Maybe<Scalars['float8']['output']>;
  travel_from_lng?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "property_searches" */
export type Property_Searches_Sum_Order_By = {
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
};

/** update columns of table "property_searches" */
export enum Property_Searches_Update_Column {
  /** column name */
  ActivateAggregator = 'activate_aggregator',
  /** column name */
  AgencyReferenceContains = 'agency_reference_contains',
  /** column name */
  AggregatorSource = 'aggregator_source',
  /** column name */
  AwaitingAlertHandle = 'awaiting_alert_handle',
  /** column name */
  BalconySurfaceGte = 'balcony_surface_gte',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurfaceGte = 'built_surface_gte',
  /** column name */
  BuiltSurfaceLte = 'built_surface_lte',
  /** column name */
  Comment = 'comment',
  /** column name */
  CompositePropertyTypeEq = 'composite_property_type_eq',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  GardenSurfaceGte = 'garden_surface_gte',
  /** column name */
  Geog = 'geog',
  /** column name */
  GrossRentM2YearlyGte = 'gross_rent_m2_yearly_gte',
  /** column name */
  GrossRentM2YearlyLte = 'gross_rent_m2_yearly_lte',
  /** column name */
  GrossRentRoomMonthlyGte = 'gross_rent_room_monthly_gte',
  /** column name */
  GrossRentRoomMonthlyLte = 'gross_rent_room_monthly_lte',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasLift = 'has_lift',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  LandSurfaceGte = 'land_surface_gte',
  /** column name */
  LandSurfaceLte = 'land_surface_lte',
  /** column name */
  LastAlertHandle = 'last_alert_handle',
  /** column name */
  LastViewedAt = 'last_viewed_at',
  /** column name */
  LivingSurfaceGte = 'living_surface_gte',
  /** column name */
  LivingSurfaceLte = 'living_surface_lte',
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  MaxTravelTime = 'max_travel_time',
  /** column name */
  MonthlyRentGte = 'monthly_rent_gte',
  /** column name */
  MonthlyRentLte = 'monthly_rent_lte',
  /** column name */
  MonthlyRentVsEstimatedRentGte = 'monthly_rent_vs_estimated_rent_gte',
  /** column name */
  MonthlyRentVsEstimatedRentLte = 'monthly_rent_vs_estimated_rent_lte',
  /** column name */
  Notification = 'notification',
  /** column name */
  NumberOfBathroomsGte = 'number_of_bathrooms_gte',
  /** column name */
  NumberOfBathroomsLte = 'number_of_bathrooms_lte',
  /** column name */
  NumberOfBedroomsGte = 'number_of_bedrooms_gte',
  /** column name */
  NumberOfBedroomsLte = 'number_of_bedrooms_lte',
  /** column name */
  NumberOfIndoorParkingsGte = 'number_of_indoor_parkings_gte',
  /** column name */
  NumberOfOutdoorParkingsGte = 'number_of_outdoor_parkings_gte',
  /** column name */
  NumberOfRoomsGte = 'number_of_rooms_gte',
  /** column name */
  NumberOfRoomsLte = 'number_of_rooms_lte',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  PortalIn = 'portal_in',
  /** column name */
  PropertyMainTypeIn = 'property_main_type_in',
  /** column name */
  PropertyMainTypeNin = 'property_main_type_nin',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  PropertyUsage = 'property_usage',
  /** column name */
  RentalReturnGte = 'rental_return_gte',
  /** column name */
  RentalReturnLte = 'rental_return_lte',
  /** column name */
  SalePriceGte = 'sale_price_gte',
  /** column name */
  SalePriceLte = 'sale_price_lte',
  /** column name */
  SalePricePerLandSurfaceGte = 'sale_price_per_land_surface_gte',
  /** column name */
  SalePricePerLandSurfaceLte = 'sale_price_per_land_surface_lte',
  /** column name */
  SalePricePerLivingSurfaceGte = 'sale_price_per_living_surface_gte',
  /** column name */
  SalePricePerLivingSurfaceLte = 'sale_price_per_living_surface_lte',
  /** column name */
  SaleVsEstimatedPriceGte = 'sale_vs_estimated_price_gte',
  /** column name */
  SaleVsEstimatedPriceLte = 'sale_vs_estimated_price_lte',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Source = 'source',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng',
  /** column name */
  TravelMode = 'travel_mode',
  /** column name */
  UserId = 'user_id'
}

export type Property_Searches_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Searches_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Searches_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Searches_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Searches_Var_Pop_Fields = {
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  max_travel_time?: Maybe<Scalars['Float']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  travel_from_lat?: Maybe<Scalars['Float']['output']>;
  travel_from_lng?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "property_searches" */
export type Property_Searches_Var_Pop_Order_By = {
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Property_Searches_Var_Samp_Fields = {
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  max_travel_time?: Maybe<Scalars['Float']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  travel_from_lat?: Maybe<Scalars['Float']['output']>;
  travel_from_lng?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "property_searches" */
export type Property_Searches_Var_Samp_Order_By = {
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Property_Searches_Variance_Fields = {
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  max_travel_time?: Maybe<Scalars['Float']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  travel_from_lat?: Maybe<Scalars['Float']['output']>;
  travel_from_lng?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_searches" */
export type Property_Searches_Variance_Order_By = {
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
};

export enum Property_Side_Enum_Enum {
  Exterior = 'exterior',
  Interior = 'interior'
}

/** Boolean expression to compare columns of type "property_side_enum_enum". All fields are combined with logical 'AND'. */
export type Property_Side_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Property_Side_Enum_Enum>;
  _in?: InputMaybe<Array<Property_Side_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Property_Side_Enum_Enum>;
  _nin?: InputMaybe<Array<Property_Side_Enum_Enum>>;
};

/** columns and relationships of "property_transactions" */
export type Property_Transactions = {
  /** An object relationship */
  buyer_broker?: Maybe<Users>;
  buyer_broker_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  buyer_broker_team?: Maybe<Teams>;
  buyer_broker_team_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  buyers: Array<Transaction_Buyers>;
  /** An aggregate relationship */
  buyers_aggregate: Transaction_Buyers_Aggregate;
  /** An array relationship */
  commissions: Array<Commissions>;
  /** An aggregate relationship */
  commissions_aggregate: Commissions_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  creator?: Maybe<Users>;
  crm_link?: Maybe<Scalars['String']['output']>;
  estimated_signature_date?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  is_published: Scalars['Boolean']['output'];
  /** An object relationship */
  lot?: Maybe<Lots>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  notary_id?: Maybe<Scalars['uuid']['output']>;
  payment_date?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  property: Properties;
  property_id: Scalars['uuid']['output'];
  /** An array relationship */
  property_transactions_listings: Array<Property_Transactions_Listings>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  /** An array relationship */
  reviews: Array<Reviews>;
  /** An aggregate relationship */
  reviews_aggregate: Reviews_Aggregate;
  /** An object relationship */
  seller_broker?: Maybe<Users>;
  seller_broker_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  seller_broker_team?: Maybe<Teams>;
  seller_broker_team_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  sellers: Array<Transaction_Sellers>;
  /** An aggregate relationship */
  sellers_aggregate: Transaction_Sellers_Aggregate;
  signature_date?: Maybe<Scalars['timestamptz']['output']>;
  tenant_id: Scalars['uuid']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "property_transactions" */
export type Property_TransactionsBuyersArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Buyers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Buyers_Order_By>>;
  where?: InputMaybe<Transaction_Buyers_Bool_Exp>;
};


/** columns and relationships of "property_transactions" */
export type Property_TransactionsBuyers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Buyers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Buyers_Order_By>>;
  where?: InputMaybe<Transaction_Buyers_Bool_Exp>;
};


/** columns and relationships of "property_transactions" */
export type Property_TransactionsCommissionsArgs = {
  distinct_on?: InputMaybe<Array<Commissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Commissions_Order_By>>;
  where?: InputMaybe<Commissions_Bool_Exp>;
};


/** columns and relationships of "property_transactions" */
export type Property_TransactionsCommissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Commissions_Order_By>>;
  where?: InputMaybe<Commissions_Bool_Exp>;
};


/** columns and relationships of "property_transactions" */
export type Property_TransactionsProperty_Transactions_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Listings_Order_By>>;
  where?: InputMaybe<Property_Transactions_Listings_Bool_Exp>;
};


/** columns and relationships of "property_transactions" */
export type Property_TransactionsReviewsArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


/** columns and relationships of "property_transactions" */
export type Property_TransactionsReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


/** columns and relationships of "property_transactions" */
export type Property_TransactionsSellersArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Sellers_Order_By>>;
  where?: InputMaybe<Transaction_Sellers_Bool_Exp>;
};


/** columns and relationships of "property_transactions" */
export type Property_TransactionsSellers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Sellers_Order_By>>;
  where?: InputMaybe<Transaction_Sellers_Bool_Exp>;
};

/** aggregated selection of "property_transactions" */
export type Property_Transactions_Aggregate = {
  aggregate?: Maybe<Property_Transactions_Aggregate_Fields>;
  nodes: Array<Property_Transactions>;
};

export type Property_Transactions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Property_Transactions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Property_Transactions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Property_Transactions_Aggregate_Bool_Exp_Count>;
};

export type Property_Transactions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Property_Transactions_Select_Column_Property_Transactions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Transactions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Transactions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Property_Transactions_Select_Column_Property_Transactions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Transactions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Transactions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Transactions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_transactions" */
export type Property_Transactions_Aggregate_Fields = {
  avg?: Maybe<Property_Transactions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Transactions_Max_Fields>;
  min?: Maybe<Property_Transactions_Min_Fields>;
  stddev?: Maybe<Property_Transactions_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Transactions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Transactions_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Transactions_Sum_Fields>;
  var_pop?: Maybe<Property_Transactions_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Transactions_Var_Samp_Fields>;
  variance?: Maybe<Property_Transactions_Variance_Fields>;
};


/** aggregate fields of "property_transactions" */
export type Property_Transactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_transactions" */
export type Property_Transactions_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Transactions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Transactions_Max_Order_By>;
  min?: InputMaybe<Property_Transactions_Min_Order_By>;
  stddev?: InputMaybe<Property_Transactions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Transactions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Transactions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Transactions_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Transactions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Transactions_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Transactions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "property_transactions" */
export type Property_Transactions_Arr_Rel_Insert_Input = {
  data: Array<Property_Transactions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Transactions_On_Conflict>;
};

/** aggregate avg on columns */
export type Property_Transactions_Avg_Fields = {
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_transactions" */
export type Property_Transactions_Avg_Order_By = {
  purchase_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_transactions". All fields are combined with a logical 'AND'. */
export type Property_Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Transactions_Bool_Exp>>;
  _not?: InputMaybe<Property_Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Transactions_Bool_Exp>>;
  buyer_broker?: InputMaybe<Users_Bool_Exp>;
  buyer_broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  buyer_broker_team?: InputMaybe<Teams_Bool_Exp>;
  buyer_broker_team_id?: InputMaybe<Uuid_Comparison_Exp>;
  buyers?: InputMaybe<Transaction_Buyers_Bool_Exp>;
  buyers_aggregate?: InputMaybe<Transaction_Buyers_Aggregate_Bool_Exp>;
  commissions?: InputMaybe<Commissions_Bool_Exp>;
  commissions_aggregate?: InputMaybe<Commissions_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  crm_link?: InputMaybe<String_Comparison_Exp>;
  estimated_signature_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_published?: InputMaybe<Boolean_Comparison_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  notary_id?: InputMaybe<Uuid_Comparison_Exp>;
  payment_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  property?: InputMaybe<Properties_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_transactions_listings?: InputMaybe<Property_Transactions_Listings_Bool_Exp>;
  purchase_price?: InputMaybe<Float_Comparison_Exp>;
  reviews?: InputMaybe<Reviews_Bool_Exp>;
  reviews_aggregate?: InputMaybe<Reviews_Aggregate_Bool_Exp>;
  seller_broker?: InputMaybe<Users_Bool_Exp>;
  seller_broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  seller_broker_team?: InputMaybe<Teams_Bool_Exp>;
  seller_broker_team_id?: InputMaybe<Uuid_Comparison_Exp>;
  sellers?: InputMaybe<Transaction_Sellers_Bool_Exp>;
  sellers_aggregate?: InputMaybe<Transaction_Sellers_Aggregate_Bool_Exp>;
  signature_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_transactions" */
export enum Property_Transactions_Constraint {
  /** unique or primary key constraint on columns "id" */
  PropertyTransactionsPkey = 'property_transactions_pkey'
}

/** input type for incrementing numeric columns in table "property_transactions" */
export type Property_Transactions_Inc_Input = {
  purchase_price?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "property_transactions" */
export type Property_Transactions_Insert_Input = {
  buyer_broker?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  buyer_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_broker_team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  buyer_broker_team_id?: InputMaybe<Scalars['uuid']['input']>;
  buyers?: InputMaybe<Transaction_Buyers_Arr_Rel_Insert_Input>;
  commissions?: InputMaybe<Commissions_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  creator?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  estimated_signature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  notary_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  property?: InputMaybe<Properties_Obj_Rel_Insert_Input>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_transactions_listings?: InputMaybe<Property_Transactions_Listings_Arr_Rel_Insert_Input>;
  purchase_price?: InputMaybe<Scalars['Float']['input']>;
  reviews?: InputMaybe<Reviews_Arr_Rel_Insert_Input>;
  seller_broker?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  seller_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  seller_broker_team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  seller_broker_team_id?: InputMaybe<Scalars['uuid']['input']>;
  sellers?: InputMaybe<Transaction_Sellers_Arr_Rel_Insert_Input>;
  signature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "property_transactions_listings" */
export type Property_Transactions_Listings = {
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  listing_id: Scalars['Int']['output'];
  /** An object relationship */
  property_transaction: Property_Transactions;
  property_transaction_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  verified: Scalars['Boolean']['output'];
};

/** order by aggregate values of table "property_transactions_listings" */
export type Property_Transactions_Listings_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Transactions_Listings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Transactions_Listings_Max_Order_By>;
  min?: InputMaybe<Property_Transactions_Listings_Min_Order_By>;
  stddev?: InputMaybe<Property_Transactions_Listings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Transactions_Listings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Transactions_Listings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Transactions_Listings_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Transactions_Listings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Transactions_Listings_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Transactions_Listings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "property_transactions_listings" */
export type Property_Transactions_Listings_Arr_Rel_Insert_Input = {
  data: Array<Property_Transactions_Listings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Transactions_Listings_On_Conflict>;
};

/** order by avg() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Avg_Order_By = {
  listing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_transactions_listings". All fields are combined with a logical 'AND'. */
export type Property_Transactions_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Transactions_Listings_Bool_Exp>>;
  _not?: InputMaybe<Property_Transactions_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Transactions_Listings_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
  property_transaction?: InputMaybe<Property_Transactions_Bool_Exp>;
  property_transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_transactions_listings" */
export enum Property_Transactions_Listings_Constraint {
  /** unique or primary key constraint on columns "listing_id", "property_transaction_id" */
  PropertyTransactionsListingsPkey = 'property_transactions_listings_pkey'
}

/** input type for incrementing numeric columns in table "property_transactions_listings" */
export type Property_Transactions_Listings_Inc_Input = {
  listing_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "property_transactions_listings" */
export type Property_Transactions_Listings_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  listing_id?: InputMaybe<Scalars['Int']['input']>;
  property_transaction?: InputMaybe<Property_Transactions_Obj_Rel_Insert_Input>;
  property_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by max() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
  property_transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
  property_transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_transactions_listings" */
export type Property_Transactions_Listings_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Transactions_Listings>;
};

/** on_conflict condition type for table "property_transactions_listings" */
export type Property_Transactions_Listings_On_Conflict = {
  constraint: Property_Transactions_Listings_Constraint;
  update_columns?: Array<Property_Transactions_Listings_Update_Column>;
  where?: InputMaybe<Property_Transactions_Listings_Bool_Exp>;
};

/** Ordering options when selecting data from "property_transactions_listings". */
export type Property_Transactions_Listings_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
  property_transaction?: InputMaybe<Property_Transactions_Order_By>;
  property_transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_transactions_listings */
export type Property_Transactions_Listings_Pk_Columns_Input = {
  listing_id: Scalars['Int']['input'];
  property_transaction_id: Scalars['uuid']['input'];
};

/** select columns of table "property_transactions_listings" */
export enum Property_Transactions_Listings_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  PropertyTransactionId = 'property_transaction_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "property_transactions_listings" */
export type Property_Transactions_Listings_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  listing_id?: InputMaybe<Scalars['Int']['input']>;
  property_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by stddev() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Stddev_Order_By = {
  listing_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Stddev_Pop_Order_By = {
  listing_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Stddev_Samp_Order_By = {
  listing_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_transactions_listings" */
export type Property_Transactions_Listings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Transactions_Listings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Transactions_Listings_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  listing_id?: InputMaybe<Scalars['Int']['input']>;
  property_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by sum() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Sum_Order_By = {
  listing_id?: InputMaybe<Order_By>;
};

/** update columns of table "property_transactions_listings" */
export enum Property_Transactions_Listings_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  PropertyTransactionId = 'property_transaction_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Verified = 'verified'
}

export type Property_Transactions_Listings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Transactions_Listings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Transactions_Listings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Transactions_Listings_Bool_Exp;
};

/** order by var_pop() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Var_Pop_Order_By = {
  listing_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Var_Samp_Order_By = {
  listing_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Variance_Order_By = {
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Property_Transactions_Max_Fields = {
  buyer_broker_id?: Maybe<Scalars['uuid']['output']>;
  buyer_broker_team_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  crm_link?: Maybe<Scalars['String']['output']>;
  estimated_signature_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  notary_id?: Maybe<Scalars['uuid']['output']>;
  payment_date?: Maybe<Scalars['timestamptz']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  seller_broker_id?: Maybe<Scalars['uuid']['output']>;
  seller_broker_team_id?: Maybe<Scalars['uuid']['output']>;
  signature_date?: Maybe<Scalars['timestamptz']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "property_transactions" */
export type Property_Transactions_Max_Order_By = {
  buyer_broker_id?: InputMaybe<Order_By>;
  buyer_broker_team_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  estimated_signature_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  notary_id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  seller_broker_id?: InputMaybe<Order_By>;
  seller_broker_team_id?: InputMaybe<Order_By>;
  signature_date?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Transactions_Min_Fields = {
  buyer_broker_id?: Maybe<Scalars['uuid']['output']>;
  buyer_broker_team_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  crm_link?: Maybe<Scalars['String']['output']>;
  estimated_signature_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  notary_id?: Maybe<Scalars['uuid']['output']>;
  payment_date?: Maybe<Scalars['timestamptz']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  seller_broker_id?: Maybe<Scalars['uuid']['output']>;
  seller_broker_team_id?: Maybe<Scalars['uuid']['output']>;
  signature_date?: Maybe<Scalars['timestamptz']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "property_transactions" */
export type Property_Transactions_Min_Order_By = {
  buyer_broker_id?: InputMaybe<Order_By>;
  buyer_broker_team_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  estimated_signature_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  notary_id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  seller_broker_id?: InputMaybe<Order_By>;
  seller_broker_team_id?: InputMaybe<Order_By>;
  signature_date?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_transactions" */
export type Property_Transactions_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Transactions>;
};

/** input type for inserting object relation for remote table "property_transactions" */
export type Property_Transactions_Obj_Rel_Insert_Input = {
  data: Property_Transactions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Transactions_On_Conflict>;
};

/** on_conflict condition type for table "property_transactions" */
export type Property_Transactions_On_Conflict = {
  constraint: Property_Transactions_Constraint;
  update_columns?: Array<Property_Transactions_Update_Column>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};

/** Ordering options when selecting data from "property_transactions". */
export type Property_Transactions_Order_By = {
  buyer_broker?: InputMaybe<Users_Order_By>;
  buyer_broker_id?: InputMaybe<Order_By>;
  buyer_broker_team?: InputMaybe<Teams_Order_By>;
  buyer_broker_team_id?: InputMaybe<Order_By>;
  buyers_aggregate?: InputMaybe<Transaction_Buyers_Aggregate_Order_By>;
  commissions_aggregate?: InputMaybe<Commissions_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  crm_link?: InputMaybe<Order_By>;
  estimated_signature_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_published?: InputMaybe<Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  notary_id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  property?: InputMaybe<Properties_Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_transactions_listings_aggregate?: InputMaybe<Property_Transactions_Listings_Aggregate_Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  reviews_aggregate?: InputMaybe<Reviews_Aggregate_Order_By>;
  seller_broker?: InputMaybe<Users_Order_By>;
  seller_broker_id?: InputMaybe<Order_By>;
  seller_broker_team?: InputMaybe<Teams_Order_By>;
  seller_broker_team_id?: InputMaybe<Order_By>;
  sellers_aggregate?: InputMaybe<Transaction_Sellers_Aggregate_Order_By>;
  signature_date?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_transactions */
export type Property_Transactions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_transactions" */
export enum Property_Transactions_Select_Column {
  /** column name */
  BuyerBrokerId = 'buyer_broker_id',
  /** column name */
  BuyerBrokerTeamId = 'buyer_broker_team_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  EstimatedSignatureDate = 'estimated_signature_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  NotaryId = 'notary_id',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  SellerBrokerId = 'seller_broker_id',
  /** column name */
  SellerBrokerTeamId = 'seller_broker_team_id',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "property_transactions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "property_transactions" */
export enum Property_Transactions_Select_Column_Property_Transactions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPublished = 'is_published'
}

/** select "property_transactions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "property_transactions" */
export enum Property_Transactions_Select_Column_Property_Transactions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPublished = 'is_published'
}

/** input type for updating data in table "property_transactions" */
export type Property_Transactions_Set_Input = {
  buyer_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_broker_team_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  estimated_signature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  notary_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  purchase_price?: InputMaybe<Scalars['Float']['input']>;
  seller_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  seller_broker_team_id?: InputMaybe<Scalars['uuid']['input']>;
  signature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Property_Transactions_Stddev_Fields = {
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_transactions" */
export type Property_Transactions_Stddev_Order_By = {
  purchase_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Property_Transactions_Stddev_Pop_Fields = {
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "property_transactions" */
export type Property_Transactions_Stddev_Pop_Order_By = {
  purchase_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Property_Transactions_Stddev_Samp_Fields = {
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "property_transactions" */
export type Property_Transactions_Stddev_Samp_Order_By = {
  purchase_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_transactions" */
export type Property_Transactions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Transactions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Transactions_Stream_Cursor_Value_Input = {
  buyer_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_broker_team_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  estimated_signature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  notary_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  purchase_price?: InputMaybe<Scalars['Float']['input']>;
  seller_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  seller_broker_team_id?: InputMaybe<Scalars['uuid']['input']>;
  signature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Property_Transactions_Sum_Fields = {
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "property_transactions" */
export type Property_Transactions_Sum_Order_By = {
  purchase_price?: InputMaybe<Order_By>;
};

/** update columns of table "property_transactions" */
export enum Property_Transactions_Update_Column {
  /** column name */
  BuyerBrokerId = 'buyer_broker_id',
  /** column name */
  BuyerBrokerTeamId = 'buyer_broker_team_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EstimatedSignatureDate = 'estimated_signature_date',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  NotaryId = 'notary_id',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  SellerBrokerId = 'seller_broker_id',
  /** column name */
  SellerBrokerTeamId = 'seller_broker_team_id',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Property_Transactions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Transactions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Transactions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Transactions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Transactions_Var_Pop_Fields = {
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "property_transactions" */
export type Property_Transactions_Var_Pop_Order_By = {
  purchase_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Property_Transactions_Var_Samp_Fields = {
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "property_transactions" */
export type Property_Transactions_Var_Samp_Order_By = {
  purchase_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Property_Transactions_Variance_Fields = {
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_transactions" */
export type Property_Transactions_Variance_Order_By = {
  purchase_price?: InputMaybe<Order_By>;
};

/** columns and relationships of "property_types" */
export type Property_Types = {
  appraisal_type?: Maybe<Scalars['String']['output']>;
  composite_type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  composite_type_object?: Maybe<Property_Types>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  idx_type_id?: Maybe<Scalars['Int']['output']>;
  is_visible?: Maybe<Scalars['Boolean']['output']>;
  /** compute property type label */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  main_type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  main_type_object?: Maybe<Property_Types>;
  name?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  parent_type?: Maybe<Property_Types>;
  pricehubble_subcode?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "property_types" */
export type Property_Types_Aggregate = {
  aggregate?: Maybe<Property_Types_Aggregate_Fields>;
  nodes: Array<Property_Types>;
};

/** aggregate fields of "property_types" */
export type Property_Types_Aggregate_Fields = {
  avg?: Maybe<Property_Types_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Types_Max_Fields>;
  min?: Maybe<Property_Types_Min_Fields>;
  stddev?: Maybe<Property_Types_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Types_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Types_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Types_Sum_Fields>;
  var_pop?: Maybe<Property_Types_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Types_Var_Samp_Fields>;
  variance?: Maybe<Property_Types_Variance_Fields>;
};


/** aggregate fields of "property_types" */
export type Property_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Property_Types_Avg_Fields = {
  idx_type_id?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "property_types". All fields are combined with a logical 'AND'. */
export type Property_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Types_Bool_Exp>>;
  _not?: InputMaybe<Property_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Types_Bool_Exp>>;
  appraisal_type?: InputMaybe<String_Comparison_Exp>;
  composite_type?: InputMaybe<String_Comparison_Exp>;
  composite_type_object?: InputMaybe<Property_Types_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  idx_type_id?: InputMaybe<Int_Comparison_Exp>;
  is_visible?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  main_type?: InputMaybe<String_Comparison_Exp>;
  main_type_object?: InputMaybe<Property_Types_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  parent_type?: InputMaybe<Property_Types_Bool_Exp>;
  pricehubble_subcode?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Property_Types_Max_Fields = {
  appraisal_type?: Maybe<Scalars['String']['output']>;
  composite_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idx_type_id?: Maybe<Scalars['Int']['output']>;
  /** compute property type label */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  main_type?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  pricehubble_subcode?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Property_Types_Min_Fields = {
  appraisal_type?: Maybe<Scalars['String']['output']>;
  composite_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idx_type_id?: Maybe<Scalars['Int']['output']>;
  /** compute property type label */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  main_type?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  pricehubble_subcode?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "property_types". */
export type Property_Types_Order_By = {
  appraisal_type?: InputMaybe<Order_By>;
  composite_type?: InputMaybe<Order_By>;
  composite_type_object?: InputMaybe<Property_Types_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idx_type_id?: InputMaybe<Order_By>;
  is_visible?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  main_type?: InputMaybe<Order_By>;
  main_type_object?: InputMaybe<Property_Types_Order_By>;
  name?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  parent_type?: InputMaybe<Property_Types_Order_By>;
  pricehubble_subcode?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "property_types" */
export enum Property_Types_Select_Column {
  /** column name */
  AppraisalType = 'appraisal_type',
  /** column name */
  CompositeType = 'composite_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdxTypeId = 'idx_type_id',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  MainType = 'main_type',
  /** column name */
  Name = 'name',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PricehubbleSubcode = 'pricehubble_subcode',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Property_Types_Stddev_Fields = {
  idx_type_id?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Property_Types_Stddev_Pop_Fields = {
  idx_type_id?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Property_Types_Stddev_Samp_Fields = {
  idx_type_id?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "property_types" */
export type Property_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Types_Stream_Cursor_Value_Input = {
  appraisal_type?: InputMaybe<Scalars['String']['input']>;
  composite_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_type_id?: InputMaybe<Scalars['Int']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  main_type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  pricehubble_subcode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Property_Types_Sum_Fields = {
  idx_type_id?: Maybe<Scalars['Int']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Property_Types_Var_Pop_Fields = {
  idx_type_id?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Property_Types_Var_Samp_Fields = {
  idx_type_id?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Property_Types_Variance_Fields = {
  idx_type_id?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "push_notification_tokens" */
export type Push_Notification_Tokens = {
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  token: Scalars['String']['output'];
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "push_notification_tokens" */
export type Push_Notification_Tokens_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Push_Notification_Tokens_Max_Order_By>;
  min?: InputMaybe<Push_Notification_Tokens_Min_Order_By>;
};

/** input type for inserting array relation for remote table "push_notification_tokens" */
export type Push_Notification_Tokens_Arr_Rel_Insert_Input = {
  data: Array<Push_Notification_Tokens_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Push_Notification_Tokens_On_Conflict>;
};

/** Boolean expression to filter rows from the table "push_notification_tokens". All fields are combined with a logical 'AND'. */
export type Push_Notification_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<Push_Notification_Tokens_Bool_Exp>>;
  _not?: InputMaybe<Push_Notification_Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<Push_Notification_Tokens_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "push_notification_tokens" */
export enum Push_Notification_Tokens_Constraint {
  /** unique or primary key constraint on columns "id" */
  PushNotificationTokensPkey = 'push_notification_tokens_pkey'
}

/** input type for inserting data into table "push_notification_tokens" */
export type Push_Notification_Tokens_Insert_Input = {
  token?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "push_notification_tokens" */
export type Push_Notification_Tokens_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "push_notification_tokens" */
export type Push_Notification_Tokens_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "push_notification_tokens" */
export type Push_Notification_Tokens_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Push_Notification_Tokens>;
};

/** on_conflict condition type for table "push_notification_tokens" */
export type Push_Notification_Tokens_On_Conflict = {
  constraint: Push_Notification_Tokens_Constraint;
  update_columns?: Array<Push_Notification_Tokens_Update_Column>;
  where?: InputMaybe<Push_Notification_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "push_notification_tokens". */
export type Push_Notification_Tokens_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "push_notification_tokens" */
export enum Push_Notification_Tokens_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Token = 'token',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "push_notification_tokens" */
export type Push_Notification_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Push_Notification_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Push_Notification_Tokens_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "push_notification_tokens" (current role has no relevant permissions) */
export enum Push_Notification_Tokens_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

export type Query_Root = {
  /** An array relationship */
  activities: Array<Activities>;
  /** An aggregate relationship */
  activities_aggregate: Activities_Aggregate;
  /** fetch data from the table: "activities" using primary key columns */
  activities_by_pk?: Maybe<Activities>;
  /** fetch data from the table: "address_display_options_enum" */
  address_display_options_enum: Array<Address_Display_Options_Enum>;
  /** fetch data from the table: "address_display_options_enum" using primary key columns */
  address_display_options_enum_by_pk?: Maybe<Address_Display_Options_Enum>;
  /** execute function "agent_statistics" which returns "agent_stats" */
  agent_statistics: Array<Agent_Stats>;
  /** fetch data from the table: "agent_stats" */
  agent_stats: Array<Agent_Stats>;
  /** fetch data from the table: "agent_stats" using primary key columns */
  agent_stats_by_pk?: Maybe<Agent_Stats>;
  /** An array relationship */
  appraisals: Array<Appraisals>;
  /** fetch data from the table: "appraisals" using primary key columns */
  appraisals_by_pk?: Maybe<Appraisals>;
  auto_assign_ranking?: Maybe<AutoAssignRankingEu>;
  /** Get agents eligible for a lead and rank them */
  auto_assign_ranking_ch?: Maybe<AutoAssignRankingCh>;
  /** An array relationship */
  buyer_leads: Array<Buyer_Leads>;
  /** An aggregate relationship */
  buyer_leads_aggregate: Buyer_Leads_Aggregate;
  /** fetch data from the table: "buyer_leads" using primary key columns */
  buyer_leads_by_pk?: Maybe<Buyer_Leads>;
  calculate_mortgage_for_lead: MortgageOutput;
  /** An array relationship */
  catchment_areas: Array<Catchment_Areas>;
  /** An aggregate relationship */
  catchment_areas_aggregate: Catchment_Areas_Aggregate;
  /** fetch data from the table: "cma_listings" */
  ch_cma_listings: Array<Ch_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  ch_cma_listings_aggregate: Ch_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  ch_cma_listings_by_pk?: Maybe<Ch_Cma_Listings>;
  /** execute function "get_buy_rent_listings" which returns "merged_listings" */
  ch_get_buy_rent_listings: Array<Ch_Merged_Listings>;
  /** execute function "get_buy_rent_listings" and query aggregates on result of table type "merged_listings" */
  ch_get_buy_rent_listings_aggregate: Ch_Merged_Listings_Aggregate;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  ch_get_merged_listings: Array<Ch_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  ch_get_merged_listings_type: Array<Ch_Get_Merged_Listings_Type>;
  /** execute function "get_place_by_slug" which returns "places" */
  ch_get_place_by_slug?: Maybe<Ch_Places>;
  /** execute function "get_place_by_slug" and query aggregates on result of table type "places" */
  ch_get_place_by_slug_aggregate: Ch_Places_Aggregate;
  /** execute function "get_similar_listings" which returns "post_merged_listings" */
  ch_get_similar_listings: Array<Ch_Post_Merged_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "post_merged_listings" */
  ch_get_similar_listings_aggregate: Ch_Post_Merged_Listings_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "post_merged_listings" */
  ch_get_similar_listings_vector: Array<Ch_Post_Merged_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "post_merged_listings" */
  ch_get_similar_listings_vector_aggregate: Ch_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_images" */
  ch_merged_images: Array<Ch_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  ch_merged_images_aggregate: Ch_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  ch_merged_listings: Array<Ch_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  ch_merged_listings_aggregate: Ch_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  ch_merged_listings_by_pk?: Maybe<Ch_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  ch_merged_listings_compare: Array<Ch_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  ch_merged_listings_compare_aggregate: Ch_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  ch_places: Array<Ch_Places>;
  /** fetch aggregated fields from the table: "places" */
  ch_places_aggregate: Ch_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  ch_places_breadcrumbs: Array<Ch_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  ch_places_breadcrumbs_aggregate: Ch_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  ch_places_by_pk?: Maybe<Ch_Places>;
  /** fetch data from the table: "post_merged_listings" */
  ch_post_merged_listings: Array<Ch_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  ch_post_merged_listings_aggregate: Ch_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  ch_post_merged_listings_by_pk?: Maybe<Ch_Post_Merged_Listings>;
  /** fetch data from the table: "price_stats_quantiles" */
  ch_price_stats_quantiles: Array<Ch_Price_Stats_Quantiles>;
  /** fetch aggregated fields from the table: "price_stats_quantiles" */
  ch_price_stats_quantiles_aggregate: Ch_Price_Stats_Quantiles_Aggregate;
  /** fetch data from the table: "price_stats_quantiles" using primary key columns */
  ch_price_stats_quantiles_by_pk?: Maybe<Ch_Price_Stats_Quantiles>;
  /** fetch data from the table: "property_types" */
  ch_property_types: Array<Ch_Property_Types>;
  /** execute function "search_places" which returns "places" */
  ch_search_places: Array<Ch_Places>;
  /** execute function "search_places" and query aggregates on result of table type "places" */
  ch_search_places_aggregate: Ch_Places_Aggregate;
  /** execute function "search_places_with_index" which returns "places" */
  ch_search_places_with_index: Array<Ch_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  ch_search_places_with_index_aggregate: Ch_Places_Aggregate;
  /** An array relationship */
  cma_report_files: Array<Cma_Report_Files>;
  /** An aggregate relationship */
  cma_report_files_aggregate: Cma_Report_Files_Aggregate;
  /** An array relationship */
  cma_reports: Array<Cma_Reports>;
  /** An aggregate relationship */
  cma_reports_aggregate: Cma_Reports_Aggregate;
  /** fetch data from the table: "cma_reports" using primary key columns */
  cma_reports_by_pk?: Maybe<Cma_Reports>;
  /** fetch data from the table: "cma_reports_comparables" */
  cma_reports_comparables: Array<Cma_Reports_Comparables>;
  /** An array relationship */
  combined_reviews: Array<Combined_Reviews>;
  /** An aggregate relationship */
  combined_reviews_aggregate: Combined_Reviews_Aggregate;
  /** fetch data from the table: "cooling_enum" */
  cooling_enum: Array<Cooling_Enum>;
  /** fetch data from the table: "cooling_enum" using primary key columns */
  cooling_enum_by_pk?: Maybe<Cooling_Enum>;
  /** fetch data from the table: "countries" */
  countries: Array<Countries>;
  /** fetch data from the table: "countries" using primary key columns */
  countries_by_pk?: Maybe<Countries>;
  /** fetch data from the table: "developments" */
  developments: Array<Developments>;
  /** fetch data from the table: "developments" using primary key columns */
  developments_by_pk?: Maybe<Developments>;
  /** fetch data from the table: "dictionaries" */
  dictionaries: Array<Dictionaries>;
  /** fetch data from the table: "dictionaries" using primary key columns */
  dictionaries_by_pk?: Maybe<Dictionaries>;
  /** fetch data from the table: "dictionaries_types_enum" */
  dictionaries_types_enum: Array<Dictionaries_Types_Enum>;
  /** fetch data from the table: "dictionaries_types_enum" using primary key columns */
  dictionaries_types_enum_by_pk?: Maybe<Dictionaries_Types_Enum>;
  /** fetch data from the table: "doc_template_type_enum" */
  doc_template_type_enum: Array<Doc_Template_Type_Enum>;
  /** fetch data from the table: "doc_template_type_enum" using primary key columns */
  doc_template_type_enum_by_pk?: Maybe<Doc_Template_Type_Enum>;
  /** fetch data from the table: "doc_templates" */
  doc_templates: Array<Doc_Templates>;
  /** fetch data from the table: "doc_templates" using primary key columns */
  doc_templates_by_pk?: Maybe<Doc_Templates>;
  /** An array relationship */
  doc_templates_tenants: Array<Doc_Templates_Tenants>;
  /** fetch data from the table: "doc_templates_tenants" using primary key columns */
  doc_templates_tenants_by_pk?: Maybe<Doc_Templates_Tenants>;
  /** An aggregate relationship */
  email_messages_aggregate: Email_Messages_Aggregate;
  /** fetch data from the table: "email_sequences" */
  email_sequences: Array<Email_Sequences>;
  /** fetch data from the table: "email_sequences" using primary key columns */
  email_sequences_by_pk?: Maybe<Email_Sequences>;
  /** An array relationship */
  email_sequences_recipients: Array<Email_Sequences_Recipients>;
  /** An aggregate relationship */
  email_sequences_recipients_aggregate: Email_Sequences_Recipients_Aggregate;
  /** fetch data from the table: "email_sequences_recipients" using primary key columns */
  email_sequences_recipients_by_pk?: Maybe<Email_Sequences_Recipients>;
  /** An array relationship */
  email_sequences_steps: Array<Email_Sequences_Steps>;
  /** An aggregate relationship */
  email_sequences_steps_aggregate: Email_Sequences_Steps_Aggregate;
  /** fetch data from the table: "email_sequences_steps" using primary key columns */
  email_sequences_steps_by_pk?: Maybe<Email_Sequences_Steps>;
  /** An array relationship */
  email_templates: Array<Email_Templates>;
  /** fetch data from the table: "email_templates" using primary key columns */
  email_templates_by_pk?: Maybe<Email_Templates>;
  /** An array relationship */
  emails: Array<Emails>;
  /** fetch data from the table: "emails" using primary key columns */
  emails_by_pk?: Maybe<Emails>;
  /** An array relationship */
  enquiries: Array<Enquiries>;
  /** An aggregate relationship */
  enquiries_aggregate: Enquiries_Aggregate;
  /** fetch data from the table: "enquiries" using primary key columns */
  enquiries_by_pk?: Maybe<Enquiries>;
  /** fetch data from the table: "cma_listings" */
  es_cma_listings: Array<Es_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  es_cma_listings_aggregate: Es_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  es_cma_listings_by_pk?: Maybe<Es_Cma_Listings>;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  es_get_merged_listings: Array<Es_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  es_get_merged_listings_type: Array<Es_Get_Merged_Listings_Type>;
  /** execute function "get_place_by_slug" which returns "places" */
  es_get_place_by_slug?: Maybe<Es_Places>;
  /** execute function "get_place_by_slug" and query aggregates on result of table type "places" */
  es_get_place_by_slug_aggregate: Es_Places_Aggregate;
  /** execute function "get_similar_listings" which returns "post_merged_listings" */
  es_get_similar_listings: Array<Es_Post_Merged_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "post_merged_listings" */
  es_get_similar_listings_aggregate: Es_Post_Merged_Listings_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "post_merged_listings" */
  es_get_similar_listings_vector: Array<Es_Post_Merged_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "post_merged_listings" */
  es_get_similar_listings_vector_aggregate: Es_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_images" */
  es_merged_images: Array<Es_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  es_merged_images_aggregate: Es_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  es_merged_listings: Array<Es_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  es_merged_listings_aggregate: Es_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  es_merged_listings_by_pk?: Maybe<Es_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  es_merged_listings_compare: Array<Es_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  es_merged_listings_compare_aggregate: Es_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  es_places: Array<Es_Places>;
  /** fetch aggregated fields from the table: "places" */
  es_places_aggregate: Es_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  es_places_breadcrumbs: Array<Es_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  es_places_breadcrumbs_aggregate: Es_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  es_places_by_pk?: Maybe<Es_Places>;
  /** fetch data from the table: "post_merged_listings" */
  es_post_merged_listings: Array<Es_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  es_post_merged_listings_aggregate: Es_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  es_post_merged_listings_by_pk?: Maybe<Es_Post_Merged_Listings>;
  /** fetch data from the table: "property_types" */
  es_property_types: Array<Es_Property_Types>;
  /** execute function "search_places_with_index" which returns "places" */
  es_search_places_with_index: Array<Es_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  es_search_places_with_index_aggregate: Es_Places_Aggregate;
  /** fetch data from the table: "files" */
  files: Array<Files>;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: Maybe<Files>;
  /** execute function "financing_statistics" which returns "financing_stats" */
  financing_statistics: Array<Financing_Stats>;
  /** fetch data from the table: "financing_stats" */
  financing_stats: Array<Financing_Stats>;
  /** fetch data from the table: "financing_stats" using primary key columns */
  financing_stats_by_pk?: Maybe<Financing_Stats>;
  /** execute function "find_price_map_places" which returns "places" */
  find_price_map_places: Array<Places>;
  /** fetch data from the table: "cma_listings" */
  fr_cma_listings: Array<Fr_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  fr_cma_listings_aggregate: Fr_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  fr_cma_listings_by_pk?: Maybe<Fr_Cma_Listings>;
  /** execute function "get_buy_rent_listings" which returns "merged_listings" */
  fr_get_buy_rent_listings: Array<Fr_Merged_Listings>;
  /** execute function "get_buy_rent_listings" and query aggregates on result of table type "merged_listings" */
  fr_get_buy_rent_listings_aggregate: Fr_Merged_Listings_Aggregate;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  fr_get_merged_listings: Array<Fr_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  fr_get_merged_listings_type: Array<Fr_Get_Merged_Listings_Type>;
  /** execute function "get_place_by_slug" which returns "places" */
  fr_get_place_by_slug?: Maybe<Fr_Places>;
  /** execute function "get_place_by_slug" and query aggregates on result of table type "places" */
  fr_get_place_by_slug_aggregate: Fr_Places_Aggregate;
  /** execute function "get_similar_listings" which returns "post_merged_listings" */
  fr_get_similar_listings: Array<Fr_Post_Merged_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "post_merged_listings" */
  fr_get_similar_listings_aggregate: Fr_Post_Merged_Listings_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "post_merged_listings" */
  fr_get_similar_listings_vector: Array<Fr_Post_Merged_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "post_merged_listings" */
  fr_get_similar_listings_vector_aggregate: Fr_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_images" */
  fr_merged_images: Array<Fr_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  fr_merged_images_aggregate: Fr_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  fr_merged_listings: Array<Fr_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  fr_merged_listings_aggregate: Fr_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  fr_merged_listings_by_pk?: Maybe<Fr_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  fr_merged_listings_compare: Array<Fr_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  fr_merged_listings_compare_aggregate: Fr_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  fr_places: Array<Fr_Places>;
  /** fetch aggregated fields from the table: "places" */
  fr_places_aggregate: Fr_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  fr_places_breadcrumbs: Array<Fr_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  fr_places_breadcrumbs_aggregate: Fr_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  fr_places_by_pk?: Maybe<Fr_Places>;
  /** fetch data from the table: "post_merged_listings" */
  fr_post_merged_listings: Array<Fr_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  fr_post_merged_listings_aggregate: Fr_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  fr_post_merged_listings_by_pk?: Maybe<Fr_Post_Merged_Listings>;
  /** fetch data from the table: "property_types" */
  fr_property_types: Array<Fr_Property_Types>;
  /** execute function "search_places_with_index" which returns "places" */
  fr_search_places_with_index: Array<Fr_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  fr_search_places_with_index_aggregate: Fr_Places_Aggregate;
  /** generate-cma-description */
  generate_cma_description?: Maybe<GenerateCmaDescription>;
  /** generate-listing-description */
  generate_listings_description?: Maybe<GenerateListingDescription>;
  /** execute function "get_agents_ranking" which returns "agents_rankings" */
  get_agents_ranking: Array<Agents_Rankings>;
  /** execute function "get_agents_ranking" and query aggregates on result of table type "agents_rankings" */
  get_agents_ranking_aggregate: Agents_Rankings_Aggregate;
  get_api_key?: Maybe<ApiKey>;
  get_api_keys?: Maybe<Array<ApiKey>>;
  /** execute function "get_appraisals_by_slug" which returns "appraisals_public_view" */
  get_appraisals_by_slug: Array<Appraisals_Public_View>;
  /** execute function "get_catchment_area" which returns "places" */
  get_catchment_area: Array<Places>;
  get_listing_references?: Maybe<GetListingReferencesOutput>;
  get_me: GetMeOutput;
  /** execute function "get_nearby_appraisals" which returns "appraisals_public_view" */
  get_nearby_appraisals: Array<Appraisals_Public_View>;
  /** execute function "get_nearby_reviews" which returns "reviews" */
  get_nearby_reviews: Array<Reviews>;
  /** execute function "get_nearby_reviews" and query aggregates on result of table type "reviews" */
  get_nearby_reviews_aggregate: Reviews_Aggregate;
  /** execute function "get_nearby_transactions" which returns "property_transactions" */
  get_nearby_transactions: Array<Property_Transactions>;
  /** execute function "get_nearby_transactions" and query aggregates on result of table type "property_transactions" */
  get_nearby_transactions_aggregate: Property_Transactions_Aggregate;
  /** execute function "get_online_listing_map_data" which returns "online_listing_map_data" */
  get_online_listing_map_data: Array<Online_Listing_Map_Data>;
  /** execute function "get_online_listing_map_data" and query aggregates on result of table type "online_listing_map_data" */
  get_online_listing_map_data_aggregate: Online_Listing_Map_Data_Aggregate;
  /** execute function "get_similar_online_listings" which returns "online_listings" */
  get_similar_online_listings: Array<Online_Listings>;
  /** execute function "get_similar_online_listings" and query aggregates on result of table type "online_listings" */
  get_similar_online_listings_aggregate: Online_Listings_Aggregate;
  /** execute function "get_similar_online_listings_ids" which returns "similar_online_listings_ids" */
  get_similar_online_listings_ids: Array<Similar_Online_Listings_Ids>;
  /** execute function "get_similar_online_listings_ids" and query aggregates on result of table type "similar_online_listings_ids" */
  get_similar_online_listings_ids_aggregate: Similar_Online_Listings_Ids_Aggregate;
  /** execute function "get_similar_online_listings_vector" which returns "online_listings" */
  get_similar_online_listings_vector: Array<Online_Listings>;
  /** execute function "get_similar_online_listings_vector" and query aggregates on result of table type "online_listings" */
  get_similar_online_listings_vector_aggregate: Online_Listings_Aggregate;
  /** Get the surrounding places of a property listing */
  get_surrounding_listing_places?: Maybe<Array<GetSurroundingListingPlacesOutput>>;
  /** execute function "get_teams_ranking" which returns "teams_rankings" */
  get_teams_ranking: Array<Teams_Rankings>;
  /** execute function "get_teams_ranking" and query aggregates on result of table type "teams_rankings" */
  get_teams_ranking_aggregate: Teams_Rankings_Aggregate;
  get_valuation_link: GetValuationLinkOutput;
  /** execute function "global_statistics" which returns "global_stats" */
  global_statistics: Array<Global_Stats>;
  /** fetch data from the table: "global_stats" */
  global_stats: Array<Global_Stats>;
  /** fetch data from the table: "global_stats" using primary key columns */
  global_stats_by_pk?: Maybe<Global_Stats>;
  /** fetch data from the table: "google_addresses" */
  google_addresses: Array<Google_Addresses>;
  /** An array relationship */
  google_reviews: Array<Google_Reviews>;
  /** An aggregate relationship */
  google_reviews_aggregate: Google_Reviews_Aggregate;
  /** fetch data from the table: "google_reviews" using primary key columns */
  google_reviews_by_pk?: Maybe<Google_Reviews>;
  /** fetch data from the table: "heating_distribution_enum" */
  heating_distribution_enum: Array<Heating_Distribution_Enum>;
  /** fetch data from the table: "heating_distribution_enum" using primary key columns */
  heating_distribution_enum_by_pk?: Maybe<Heating_Distribution_Enum>;
  /** fetch data from the table: "heating_enum" */
  heating_enum: Array<Heating_Enum>;
  /** fetch data from the table: "heating_enum" using primary key columns */
  heating_enum_by_pk?: Maybe<Heating_Enum>;
  /** fetch data from the table: "images" */
  images: Array<Images>;
  /** fetch data from the table: "images" using primary key columns */
  images_by_pk?: Maybe<Images>;
  /** Get visibility impressions from bigquery grouped by a column */
  impressions_grouped_by_column?: Maybe<ImpressionsGroupedByColumnResponse>;
  /** improve_text */
  improve_text?: Maybe<ImprovedText>;
  /** fetch data from the table: "invitations" */
  invitations: Array<Invitations>;
  /** fetch aggregated fields from the table: "invitations" */
  invitations_aggregate: Invitations_Aggregate;
  /** fetch data from the table: "invitations" using primary key columns */
  invitations_by_pk?: Maybe<Invitations>;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoices_aggregate: Invoices_Aggregate;
  /** fetch data from the table: "invoices" using primary key columns */
  invoices_by_pk?: Maybe<Invoices>;
  /** fetch data from the table: "cma_listings" */
  it_cma_listings: Array<It_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  it_cma_listings_aggregate: It_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  it_cma_listings_by_pk?: Maybe<It_Cma_Listings>;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  it_get_merged_listings: Array<It_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  it_get_merged_listings_type: Array<It_Get_Merged_Listings_Type>;
  /** execute function "get_similar_listings" which returns "post_merged_listings" */
  it_get_similar_listings: Array<It_Post_Merged_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "post_merged_listings" */
  it_get_similar_listings_aggregate: It_Post_Merged_Listings_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "post_merged_listings" */
  it_get_similar_listings_vector: Array<It_Post_Merged_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "post_merged_listings" */
  it_get_similar_listings_vector_aggregate: It_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_images" */
  it_merged_images: Array<It_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  it_merged_images_aggregate: It_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  it_merged_listings: Array<It_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  it_merged_listings_aggregate: It_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  it_merged_listings_by_pk?: Maybe<It_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  it_merged_listings_compare: Array<It_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  it_merged_listings_compare_aggregate: It_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  it_places: Array<It_Places>;
  /** fetch aggregated fields from the table: "places" */
  it_places_aggregate: It_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  it_places_breadcrumbs: Array<It_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  it_places_breadcrumbs_aggregate: It_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  it_places_by_pk?: Maybe<It_Places>;
  /** fetch data from the table: "post_merged_listings" */
  it_post_merged_listings: Array<It_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  it_post_merged_listings_aggregate: It_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  it_post_merged_listings_by_pk?: Maybe<It_Post_Merged_Listings>;
  /** fetch data from the table: "property_types" */
  it_property_types: Array<It_Property_Types>;
  /** execute function "search_places_with_index" which returns "places" */
  it_search_places_with_index: Array<It_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  it_search_places_with_index_aggregate: It_Places_Aggregate;
  /** An array relationship */
  lead_agents: Array<Lead_Agents>;
  /** An aggregate relationship */
  lead_agents_aggregate: Lead_Agents_Aggregate;
  /** fetch data from the table: "lead_agents" using primary key columns */
  lead_agents_by_pk?: Maybe<Lead_Agents>;
  /** fetch data from the table: "lead_stages" */
  lead_stages: Array<Lead_Stages>;
  /** fetch aggregated fields from the table: "lead_stages" */
  lead_stages_aggregate: Lead_Stages_Aggregate;
  /** fetch data from the table: "lead_stages" using primary key columns */
  lead_stages_by_pk?: Maybe<Lead_Stages>;
  /** An array relationship */
  leads: Array<Leads>;
  /** An aggregate relationship */
  leads_aggregate: Leads_Aggregate;
  /** fetch data from the table: "leads" using primary key columns */
  leads_by_pk?: Maybe<Leads>;
  /** fetch data from the table: "leads_status" */
  leads_status: Array<Leads_Status>;
  /** fetch data from the table: "leads_status" using primary key columns */
  leads_status_by_pk?: Maybe<Leads_Status>;
  /** An array relationship */
  leads_tags: Array<Leads_Tags>;
  /** An aggregate relationship */
  leads_tags_aggregate: Leads_Tags_Aggregate;
  /** fetch data from the table: "leads_tags" using primary key columns */
  leads_tags_by_pk?: Maybe<Leads_Tags>;
  /** An array relationship */
  logins: Array<Logins>;
  /** An array relationship */
  lot_reference_aliases: Array<Lot_Reference_Aliases>;
  /** fetch data from the table: "lot_reference_aliases" using primary key columns */
  lot_reference_aliases_by_pk?: Maybe<Lot_Reference_Aliases>;
  /** An array relationship */
  lot_sellers: Array<Lot_Sellers>;
  /** An aggregate relationship */
  lot_sellers_aggregate: Lot_Sellers_Aggregate;
  /** An array relationship */
  lots: Array<Lots>;
  /** An aggregate relationship */
  lots_aggregate: Lots_Aggregate;
  /** fetch data from the table: "lots" using primary key columns */
  lots_by_pk?: Maybe<Lots>;
  /** fetch data from the table: "lots_status_enum" */
  lots_status_enum: Array<Lots_Status_Enum>;
  /** fetch data from the table: "lots_status_enum" using primary key columns */
  lots_status_enum_by_pk?: Maybe<Lots_Status_Enum>;
  /** execute function "me" which returns "users" */
  me?: Maybe<Users>;
  /** execute function "me" and query aggregates on result of table type "users" */
  me_aggregate: Users_Aggregate;
  /** fetch data from the table: "mls_lots" */
  mls_lots: Array<Mls_Lots>;
  /** fetch aggregated fields from the table: "mls_lots" */
  mls_lots_aggregate: Mls_Lots_Aggregate;
  /** fetch data from the table: "mls_properties" */
  mls_properties: Array<Mls_Properties>;
  /** fetch data from the table: "nylas_account_configs" */
  nylas_account_configs: Array<Nylas_Account_Configs>;
  /** fetch data from the table: "nylas_account_configs" using primary key columns */
  nylas_account_configs_by_pk?: Maybe<Nylas_Account_Configs>;
  /** An array relationship */
  offers: Array<Offers>;
  /** An aggregate relationship */
  offers_aggregate: Offers_Aggregate;
  /** fetch data from the table: "offers" using primary key columns */
  offers_by_pk?: Maybe<Offers>;
  /** fetch data from the table: "online_listing_map_data" */
  online_listing_map_data: Array<Online_Listing_Map_Data>;
  /** fetch aggregated fields from the table: "online_listing_map_data" */
  online_listing_map_data_aggregate: Online_Listing_Map_Data_Aggregate;
  /** fetch data from the table: "online_listings" */
  online_listings: Array<Online_Listings>;
  /** fetch aggregated fields from the table: "online_listings" */
  online_listings_aggregate: Online_Listings_Aggregate;
  /** fetch data from the table: "online_listings" using primary key columns */
  online_listings_by_pk?: Maybe<Online_Listings>;
  /** An array relationship */
  organisation_images: Array<Organisation_Images>;
  /** An array relationship */
  organisation_users: Array<Organisation_Users>;
  /** fetch data from the table: "organisations" */
  organisations: Array<Organisations>;
  /** fetch aggregated fields from the table: "organisations" */
  organisations_aggregate: Organisations_Aggregate;
  /** fetch data from the table: "organisations" using primary key columns */
  organisations_by_pk?: Maybe<Organisations>;
  /** execute function "organisations_search" which returns "organisations" */
  organisations_search: Array<Organisations>;
  /** execute function "organisations_search" and query aggregates on result of table type "organisations" */
  organisations_search_aggregate: Organisations_Aggregate;
  /** An array relationship */
  payments: Array<Payments>;
  /** fetch data from the table: "payments" using primary key columns */
  payments_by_pk?: Maybe<Payments>;
  /** fetch data from the table: "phone_number_type_enum" */
  phone_number_type_enum: Array<Phone_Number_Type_Enum>;
  /** fetch data from the table: "phone_number_type_enum" using primary key columns */
  phone_number_type_enum_by_pk?: Maybe<Phone_Number_Type_Enum>;
  /** An array relationship */
  phone_numbers: Array<Phone_Numbers>;
  /** An aggregate relationship */
  phone_numbers_aggregate: Phone_Numbers_Aggregate;
  /** fetch data from the table: "phone_numbers" using primary key columns */
  phone_numbers_by_pk?: Maybe<Phone_Numbers>;
  /** fetch data from the table: "pipelines" */
  pipelines: Array<Pipelines>;
  /** fetch aggregated fields from the table: "pipelines" */
  pipelines_aggregate: Pipelines_Aggregate;
  /** fetch data from the table: "pipelines" using primary key columns */
  pipelines_by_pk?: Maybe<Pipelines>;
  /** execute function "place_by_slug" which returns "places" */
  place_by_slug?: Maybe<Places>;
  /** execute function "place_by_type" which returns "places" */
  place_by_type: Array<Places>;
  /** fetch data from the table: "places" */
  places: Array<Places>;
  /** execute function "places_agent_ranking" which returns "agents_rankings" */
  places_agent_ranking: Array<Agents_Rankings>;
  /** execute function "places_agent_ranking" and query aggregates on result of table type "agents_rankings" */
  places_agent_ranking_aggregate: Agents_Rankings_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  places_by_pk?: Maybe<Places>;
  /** An array relationship */
  portal_listings: Array<Portal_Listings>;
  /** An aggregate relationship */
  portal_listings_aggregate: Portal_Listings_Aggregate;
  /** fetch data from the table: "portal_listings" using primary key columns */
  portal_listings_by_pk?: Maybe<Portal_Listings>;
  /** fetch data from the table: "portals" */
  portals: Array<Portals>;
  /** fetch aggregated fields from the table: "portals" */
  portals_aggregate: Portals_Aggregate;
  /** fetch data from the table: "portals" using primary key columns */
  portals_by_pk?: Maybe<Portals>;
  /** fetch data from the table: "portals_types_enum" */
  portals_types_enum: Array<Portals_Types_Enum>;
  /** fetch data from the table: "portals_types_enum" using primary key columns */
  portals_types_enum_by_pk?: Maybe<Portals_Types_Enum>;
  /** fetch data from the table: "properties" */
  properties: Array<Properties>;
  /** fetch data from the table: "properties" using primary key columns */
  properties_by_pk?: Maybe<Properties>;
  /** check if property is appraisable */
  property_appraisable?: Maybe<PropertyAppraisableOutput>;
  /** An array relationship */
  property_files: Array<Property_Files>;
  /** An aggregate relationship */
  property_files_aggregate: Property_Files_Aggregate;
  /** An array relationship */
  property_images: Array<Property_Images>;
  /** An aggregate relationship */
  property_images_aggregate: Property_Images_Aggregate;
  /** fetch data from the table: "property_images" using primary key columns */
  property_images_by_pk?: Maybe<Property_Images>;
  /** fetch data from the table: "property_search_aggregator_source" */
  property_search_aggregator_source: Array<Property_Search_Aggregator_Source>;
  /** fetch data from the table: "property_search_aggregator_source" using primary key columns */
  property_search_aggregator_source_by_pk?: Maybe<Property_Search_Aggregator_Source>;
  /** fetch data from the table: "property_search_source" */
  property_search_source: Array<Property_Search_Source>;
  /** fetch data from the table: "property_search_source" using primary key columns */
  property_search_source_by_pk?: Maybe<Property_Search_Source>;
  /** An array relationship */
  property_searches: Array<Property_Searches>;
  /** An aggregate relationship */
  property_searches_aggregate: Property_Searches_Aggregate;
  /** fetch data from the table: "property_searches" using primary key columns */
  property_searches_by_pk?: Maybe<Property_Searches>;
  /** An array relationship */
  property_searches_places: Array<Property_Searches_Places>;
  /** fetch data from the table: "property_searches_places" using primary key columns */
  property_searches_places_by_pk?: Maybe<Property_Searches_Places>;
  /** An array relationship */
  property_transactions: Array<Property_Transactions>;
  /** An aggregate relationship */
  property_transactions_aggregate: Property_Transactions_Aggregate;
  /** fetch data from the table: "property_transactions" using primary key columns */
  property_transactions_by_pk?: Maybe<Property_Transactions>;
  /** An array relationship */
  property_transactions_listings: Array<Property_Transactions_Listings>;
  /** fetch data from the table: "property_transactions_listings" using primary key columns */
  property_transactions_listings_by_pk?: Maybe<Property_Transactions_Listings>;
  /** fetch data from the table: "property_types" */
  property_types: Array<Property_Types>;
  /** fetch aggregated fields from the table: "property_types" */
  property_types_aggregate: Property_Types_Aggregate;
  /** fetch data from the table: "property_types" using primary key columns */
  property_types_by_pk?: Maybe<Property_Types>;
  /** An array relationship */
  push_notification_tokens: Array<Push_Notification_Tokens>;
  /** fetch data from the table: "push_notification_tokens" using primary key columns */
  push_notification_tokens_by_pk?: Maybe<Push_Notification_Tokens>;
  /** fetch data from the table: "read_only_tenants" */
  read_only_tenants: Array<Read_Only_Tenants>;
  /** An array relationship */
  reviews: Array<Reviews>;
  /** An aggregate relationship */
  reviews_aggregate: Reviews_Aggregate;
  /** fetch data from the table: "reviews" using primary key columns */
  reviews_by_pk?: Maybe<Reviews>;
  /** execute function "search_brockers_in_catchment_area" which returns "users" */
  search_brockers_in_catchment_area: Array<Users>;
  /** execute function "search_brockers_in_catchment_area" and query aggregates on result of table type "users" */
  search_brockers_in_catchment_area_aggregate: Users_Aggregate;
  /** execute function "search_leads" which returns "leads" */
  search_leads: Array<Leads>;
  /** execute function "search_leads" and query aggregates on result of table type "leads" */
  search_leads_aggregate: Leads_Aggregate;
  /** execute function "search_leads_tsv" which returns "leads" */
  search_leads_tsv: Array<Leads>;
  /** execute function "search_leads_tsv" and query aggregates on result of table type "leads" */
  search_leads_tsv_aggregate: Leads_Aggregate;
  /** execute function "search_lots_tsv" which returns "lots" */
  search_lots_tsv: Array<Lots>;
  /** execute function "search_lots_tsv" and query aggregates on result of table type "lots" */
  search_lots_tsv_aggregate: Lots_Aggregate;
  /** execute function "search_places" which returns "places" */
  search_places: Array<Places>;
  /** execute function "search_places_ex" which returns "places" */
  search_places_ex: Array<Places>;
  /** execute function "search_property_transactions_tsv" which returns "property_transactions" */
  search_property_transactions_tsv: Array<Property_Transactions>;
  /** execute function "search_property_transactions_tsv" and query aggregates on result of table type "property_transactions" */
  search_property_transactions_tsv_aggregate: Property_Transactions_Aggregate;
  /** execute function "search_teams_tsv" which returns "teams" */
  search_teams_tsv: Array<Teams>;
  /** execute function "search_teams_tsv" and query aggregates on result of table type "teams" */
  search_teams_tsv_aggregate: Teams_Aggregate;
  /** execute function "search_users" which returns "users" */
  search_users: Array<Users>;
  /** execute function "search_users" and query aggregates on result of table type "users" */
  search_users_aggregate: Users_Aggregate;
  /** execute function "search_users_tsv" which returns "users" */
  search_users_tsv: Array<Users>;
  /** execute function "search_users_tsv" and query aggregates on result of table type "users" */
  search_users_tsv_aggregate: Users_Aggregate;
  /** fetch data from the table: "shared_portals" */
  shared_portals: Array<Shared_Portals>;
  /** fetch aggregated fields from the table: "shared_portals" */
  shared_portals_aggregate: Shared_Portals_Aggregate;
  /** fetch data from the table: "similar_online_listings_ids" */
  similar_online_listings_ids: Array<Similar_Online_Listings_Ids>;
  /** fetch aggregated fields from the table: "similar_online_listings_ids" */
  similar_online_listings_ids_aggregate: Similar_Online_Listings_Ids_Aggregate;
  /** fetch data from the table: "smart_lists" */
  smart_lists: Array<Smart_Lists>;
  /** fetch data from the table: "smart_lists" using primary key columns */
  smart_lists_by_pk?: Maybe<Smart_Lists>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  /** fetch data from the table: "subscriptions" using primary key columns */
  subscriptions_by_pk?: Maybe<Subscriptions>;
  /** sync dictionary enums for enum translations */
  sync_dictionary_enums?: Maybe<SyncDictionaryEnumsOutput>;
  /** An array relationship */
  team_images: Array<Team_Images>;
  /** fetch data from the table: "team_images" using primary key columns */
  team_images_by_pk?: Maybe<Team_Images>;
  /** An array relationship */
  teams: Array<Teams>;
  /** An aggregate relationship */
  teams_aggregate: Teams_Aggregate;
  /** fetch data from the table: "teams" using primary key columns */
  teams_by_pk?: Maybe<Teams>;
  /** An array relationship */
  teams_portals: Array<Teams_Portals>;
  /** fetch data from the table: "teams_portals" using primary key columns */
  teams_portals_by_pk?: Maybe<Teams_Portals>;
  /** An array relationship */
  teams_users: Array<Teams_Users>;
  /** An aggregate relationship */
  teams_users_aggregate: Teams_Users_Aggregate;
  /** fetch data from the table: "tenants" */
  tenants: Array<Tenants>;
  /** fetch aggregated fields from the table: "tenants" */
  tenants_aggregate: Tenants_Aggregate;
  /** fetch data from the table: "tenants" using primary key columns */
  tenants_by_pk?: Maybe<Tenants>;
  /** An array relationship */
  user_images: Array<User_Images>;
  /** fetch data from the table: "user_images" using primary key columns */
  user_images_by_pk?: Maybe<User_Images>;
  /** execute function "user_primary_phone" which returns "phone_numbers" */
  user_primary_phone: Array<Phone_Numbers>;
  /** execute function "user_primary_phone" and query aggregates on result of table type "phone_numbers" */
  user_primary_phone_aggregate: Phone_Numbers_Aggregate;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** An array relationship */
  users_listings: Array<Users_Listings>;
  /** An aggregate relationship */
  users_listings_aggregate: Users_Listings_Aggregate;
  /** fetch data from the table: "users_listings" using primary key columns */
  users_listings_by_pk?: Maybe<Users_Listings>;
  /** validate_invitation */
  validate_invitation?: Maybe<ValidateInvitationOutput>;
  /** fetch data from the table: "valuation_models" */
  valuation_models: Array<Valuation_Models>;
  /** fetch data from the table: "valuation_models" using primary key columns */
  valuation_models_by_pk?: Maybe<Valuation_Models>;
  /** An array relationship */
  valuations: Array<Valuations>;
  /** fetch data from the table: "valuations" using primary key columns */
  valuations_by_pk?: Maybe<Valuations>;
};


export type Query_RootActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Query_RootActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Query_RootActivities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAddress_Display_Options_EnumArgs = {
  distinct_on?: InputMaybe<Array<Address_Display_Options_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Display_Options_Enum_Order_By>>;
  where?: InputMaybe<Address_Display_Options_Enum_Bool_Exp>;
};


export type Query_RootAddress_Display_Options_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAgent_StatisticsArgs = {
  args: Agent_Statistics_Args;
  distinct_on?: InputMaybe<Array<Agent_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Stats_Order_By>>;
  where?: InputMaybe<Agent_Stats_Bool_Exp>;
};


export type Query_RootAgent_StatsArgs = {
  distinct_on?: InputMaybe<Array<Agent_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Stats_Order_By>>;
  where?: InputMaybe<Agent_Stats_Bool_Exp>;
};


export type Query_RootAgent_Stats_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


export type Query_RootAppraisalsArgs = {
  distinct_on?: InputMaybe<Array<Appraisals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appraisals_Order_By>>;
  where?: InputMaybe<Appraisals_Bool_Exp>;
};


export type Query_RootAppraisals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuto_Assign_RankingArgs = {
  lead_id: Scalars['uuid']['input'];
};


export type Query_RootAuto_Assign_Ranking_ChArgs = {
  cut_off_date?: InputMaybe<Scalars['date']['input']>;
  lead_id: Scalars['uuid']['input'];
};


export type Query_RootBuyer_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


export type Query_RootBuyer_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


export type Query_RootBuyer_Leads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCalculate_Mortgage_For_LeadArgs = {
  lead_id: Scalars['uuid']['input'];
};


export type Query_RootCatchment_AreasArgs = {
  distinct_on?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Catchment_Areas_Order_By>>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};


export type Query_RootCatchment_Areas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Catchment_Areas_Order_By>>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};


export type Query_RootCh_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
};


export type Query_RootCh_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
};


export type Query_RootCh_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Query_RootCh_Get_Buy_Rent_ListingsArgs = {
  args: Get_Buy_Rent_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_Get_Buy_Rent_Listings_AggregateArgs = {
  args: Get_Buy_Rent_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Ch_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootCh_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Ch_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootCh_Get_Place_By_SlugArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Query_RootCh_Get_Place_By_Slug_AggregateArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Query_RootCh_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Ch_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Ch_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


export type Query_RootCh_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


export type Query_RootCh_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCh_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Query_RootCh_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Query_RootCh_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Ch_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootCh_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Ch_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootCh_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCh_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCh_Price_Stats_QuantilesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Quantiles_Bool_Exp>;
};


export type Query_RootCh_Price_Stats_Quantiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Quantiles_Bool_Exp>;
};


export type Query_RootCh_Price_Stats_Quantiles_By_PkArgs = {
  place_id: Scalars['uuid']['input'];
  property_main_type: Scalars['String']['input'];
};


export type Query_RootCh_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Property_Types_Order_By>>;
  where?: InputMaybe<Ch_Property_Types_Bool_Exp>;
};


export type Query_RootCh_Search_PlacesArgs = {
  args: Search_Places_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Query_RootCh_Search_Places_AggregateArgs = {
  args: Search_Places_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Query_RootCh_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Query_RootCh_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Query_RootCma_Report_FilesArgs = {
  distinct_on?: InputMaybe<Array<Cma_Report_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Report_Files_Order_By>>;
  where?: InputMaybe<Cma_Report_Files_Bool_Exp>;
};


export type Query_RootCma_Report_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cma_Report_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Report_Files_Order_By>>;
  where?: InputMaybe<Cma_Report_Files_Bool_Exp>;
};


export type Query_RootCma_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Order_By>>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};


export type Query_RootCma_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Order_By>>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};


export type Query_RootCma_Reports_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCma_Reports_ComparablesArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Comparables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Comparables_Order_By>>;
  where?: InputMaybe<Cma_Reports_Comparables_Bool_Exp>;
};


export type Query_RootCombined_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Combined_Reviews_Order_By>>;
  where?: InputMaybe<Combined_Reviews_Bool_Exp>;
};


export type Query_RootCombined_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Combined_Reviews_Order_By>>;
  where?: InputMaybe<Combined_Reviews_Bool_Exp>;
};


export type Query_RootCooling_EnumArgs = {
  distinct_on?: InputMaybe<Array<Cooling_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cooling_Enum_Order_By>>;
  where?: InputMaybe<Cooling_Enum_Bool_Exp>;
};


export type Query_RootCooling_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootCountriesArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Query_RootCountries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDevelopmentsArgs = {
  distinct_on?: InputMaybe<Array<Developments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Developments_Order_By>>;
  where?: InputMaybe<Developments_Bool_Exp>;
};


export type Query_RootDevelopments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDictionariesArgs = {
  distinct_on?: InputMaybe<Array<Dictionaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dictionaries_Order_By>>;
  where?: InputMaybe<Dictionaries_Bool_Exp>;
};


export type Query_RootDictionaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDictionaries_Types_EnumArgs = {
  distinct_on?: InputMaybe<Array<Dictionaries_Types_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dictionaries_Types_Enum_Order_By>>;
  where?: InputMaybe<Dictionaries_Types_Enum_Bool_Exp>;
};


export type Query_RootDictionaries_Types_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootDoc_Template_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Doc_Template_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Template_Type_Enum_Order_By>>;
  where?: InputMaybe<Doc_Template_Type_Enum_Bool_Exp>;
};


export type Query_RootDoc_Template_Type_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootDoc_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Doc_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Templates_Order_By>>;
  where?: InputMaybe<Doc_Templates_Bool_Exp>;
};


export type Query_RootDoc_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDoc_Templates_TenantsArgs = {
  distinct_on?: InputMaybe<Array<Doc_Templates_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Templates_Tenants_Order_By>>;
  where?: InputMaybe<Doc_Templates_Tenants_Bool_Exp>;
};


export type Query_RootDoc_Templates_Tenants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEmail_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>;
  where?: InputMaybe<Email_Messages_Bool_Exp>;
};


export type Query_RootEmail_SequencesArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Order_By>>;
  where?: InputMaybe<Email_Sequences_Bool_Exp>;
};


export type Query_RootEmail_Sequences_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEmail_Sequences_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Recipients_Order_By>>;
  where?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
};


export type Query_RootEmail_Sequences_Recipients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Recipients_Order_By>>;
  where?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
};


export type Query_RootEmail_Sequences_Recipients_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEmail_Sequences_StepsArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Steps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Steps_Order_By>>;
  where?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
};


export type Query_RootEmail_Sequences_Steps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Steps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Steps_Order_By>>;
  where?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
};


export type Query_RootEmail_Sequences_Steps_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEmail_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Templates_Order_By>>;
  where?: InputMaybe<Email_Templates_Bool_Exp>;
};


export type Query_RootEmail_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEmailsArgs = {
  distinct_on?: InputMaybe<Array<Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emails_Order_By>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


export type Query_RootEmails_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


export type Query_RootEnquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


export type Query_RootEnquiries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEs_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
};


export type Query_RootEs_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
};


export type Query_RootEs_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Query_RootEs_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Es_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootEs_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Es_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootEs_Get_Place_By_SlugArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Query_RootEs_Get_Place_By_Slug_AggregateArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Query_RootEs_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Es_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootEs_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Es_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootEs_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Es_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootEs_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Es_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootEs_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


export type Query_RootEs_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


export type Query_RootEs_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Merged_Listings_Bool_Exp>;
};


export type Query_RootEs_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Merged_Listings_Bool_Exp>;
};


export type Query_RootEs_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootEs_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Es_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Merged_Listings_Bool_Exp>;
};


export type Query_RootEs_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Es_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Merged_Listings_Bool_Exp>;
};


export type Query_RootEs_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Query_RootEs_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Query_RootEs_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Es_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootEs_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Es_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootEs_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEs_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Es_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootEs_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootEs_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootEs_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<Es_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Property_Types_Order_By>>;
  where?: InputMaybe<Es_Property_Types_Bool_Exp>;
};


export type Query_RootEs_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Query_RootEs_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Query_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFiles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFinancing_StatisticsArgs = {
  args: Financing_Statistics_Args;
  distinct_on?: InputMaybe<Array<Financing_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Financing_Stats_Order_By>>;
  where?: InputMaybe<Financing_Stats_Bool_Exp>;
};


export type Query_RootFinancing_StatsArgs = {
  distinct_on?: InputMaybe<Array<Financing_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Financing_Stats_Order_By>>;
  where?: InputMaybe<Financing_Stats_Bool_Exp>;
};


export type Query_RootFinancing_Stats_By_PkArgs = {
  date: Scalars['date']['input'];
};


export type Query_RootFind_Price_Map_PlacesArgs = {
  args: Find_Price_Map_Places_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootFr_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
};


export type Query_RootFr_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
};


export type Query_RootFr_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Query_RootFr_Get_Buy_Rent_ListingsArgs = {
  args: Get_Buy_Rent_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_Get_Buy_Rent_Listings_AggregateArgs = {
  args: Get_Buy_Rent_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Fr_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootFr_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Fr_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootFr_Get_Place_By_SlugArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Query_RootFr_Get_Place_By_Slug_AggregateArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Query_RootFr_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Fr_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Fr_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


export type Query_RootFr_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


export type Query_RootFr_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootFr_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Query_RootFr_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Query_RootFr_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Fr_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootFr_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Fr_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootFr_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFr_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootFr_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Property_Types_Order_By>>;
  where?: InputMaybe<Fr_Property_Types_Bool_Exp>;
};


export type Query_RootFr_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Query_RootFr_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Query_RootGenerate_Cma_DescriptionArgs = {
  cma_id: Scalars['uuid']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGenerate_Listings_DescriptionArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  lot_id: Scalars['uuid']['input'];
};


export type Query_RootGet_Agents_RankingArgs = {
  args?: InputMaybe<Get_Agents_Ranking_Args>;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Query_RootGet_Agents_Ranking_AggregateArgs = {
  args?: InputMaybe<Get_Agents_Ranking_Args>;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Query_RootGet_Api_KeyArgs = {
  partnerId: Scalars['String']['input'];
};


export type Query_RootGet_Appraisals_By_SlugArgs = {
  args: Get_Appraisals_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Appraisals_Public_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appraisals_Public_View_Order_By>>;
  where?: InputMaybe<Appraisals_Public_View_Bool_Exp>;
};


export type Query_RootGet_Catchment_AreaArgs = {
  args: Get_Catchment_Area_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootGet_Listing_ReferencesArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootGet_Nearby_AppraisalsArgs = {
  args: Get_Nearby_Appraisals_Args;
  distinct_on?: InputMaybe<Array<Appraisals_Public_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appraisals_Public_View_Order_By>>;
  where?: InputMaybe<Appraisals_Public_View_Bool_Exp>;
};


export type Query_RootGet_Nearby_ReviewsArgs = {
  args: Get_Nearby_Reviews_Args;
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Query_RootGet_Nearby_Reviews_AggregateArgs = {
  args: Get_Nearby_Reviews_Args;
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Query_RootGet_Nearby_TransactionsArgs = {
  args: Get_Nearby_Transactions_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Query_RootGet_Nearby_Transactions_AggregateArgs = {
  args: Get_Nearby_Transactions_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Query_RootGet_Online_Listing_Map_DataArgs = {
  args: Get_Online_Listing_Map_Data_Args;
  distinct_on?: InputMaybe<Array<Online_Listing_Map_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listing_Map_Data_Order_By>>;
  where?: InputMaybe<Online_Listing_Map_Data_Bool_Exp>;
};


export type Query_RootGet_Online_Listing_Map_Data_AggregateArgs = {
  args: Get_Online_Listing_Map_Data_Args;
  distinct_on?: InputMaybe<Array<Online_Listing_Map_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listing_Map_Data_Order_By>>;
  where?: InputMaybe<Online_Listing_Map_Data_Bool_Exp>;
};


export type Query_RootGet_Similar_Online_ListingsArgs = {
  args: Get_Similar_Online_Listings_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Query_RootGet_Similar_Online_Listings_AggregateArgs = {
  args: Get_Similar_Online_Listings_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Query_RootGet_Similar_Online_Listings_IdsArgs = {
  args: Get_Similar_Online_Listings_Ids_Args;
  distinct_on?: InputMaybe<Array<Similar_Online_Listings_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Online_Listings_Ids_Order_By>>;
  where?: InputMaybe<Similar_Online_Listings_Ids_Bool_Exp>;
};


export type Query_RootGet_Similar_Online_Listings_Ids_AggregateArgs = {
  args: Get_Similar_Online_Listings_Ids_Args;
  distinct_on?: InputMaybe<Array<Similar_Online_Listings_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Online_Listings_Ids_Order_By>>;
  where?: InputMaybe<Similar_Online_Listings_Ids_Bool_Exp>;
};


export type Query_RootGet_Similar_Online_Listings_VectorArgs = {
  args: Get_Similar_Online_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Query_RootGet_Similar_Online_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Online_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Query_RootGet_Surrounding_Listing_PlacesArgs = {
  listingId: Scalars['uuid']['input'];
  placeType: Scalars['String']['input'];
};


export type Query_RootGet_Teams_RankingArgs = {
  args?: InputMaybe<Get_Teams_Ranking_Args>;
  distinct_on?: InputMaybe<Array<Teams_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Rankings_Order_By>>;
  where?: InputMaybe<Teams_Rankings_Bool_Exp>;
};


export type Query_RootGet_Teams_Ranking_AggregateArgs = {
  args?: InputMaybe<Get_Teams_Ranking_Args>;
  distinct_on?: InputMaybe<Array<Teams_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Rankings_Order_By>>;
  where?: InputMaybe<Teams_Rankings_Bool_Exp>;
};


export type Query_RootGet_Valuation_LinkArgs = {
  agent_id: Scalars['String']['input'];
};


export type Query_RootGlobal_StatisticsArgs = {
  args: Global_Statistics_Args;
  distinct_on?: InputMaybe<Array<Global_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Global_Stats_Order_By>>;
  where?: InputMaybe<Global_Stats_Bool_Exp>;
};


export type Query_RootGlobal_StatsArgs = {
  distinct_on?: InputMaybe<Array<Global_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Global_Stats_Order_By>>;
  where?: InputMaybe<Global_Stats_Bool_Exp>;
};


export type Query_RootGlobal_Stats_By_PkArgs = {
  date: Scalars['date']['input'];
};


export type Query_RootGoogle_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Google_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Addresses_Order_By>>;
  where?: InputMaybe<Google_Addresses_Bool_Exp>;
};


export type Query_RootGoogle_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Google_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Reviews_Order_By>>;
  where?: InputMaybe<Google_Reviews_Bool_Exp>;
};


export type Query_RootGoogle_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Google_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Reviews_Order_By>>;
  where?: InputMaybe<Google_Reviews_Bool_Exp>;
};


export type Query_RootGoogle_Reviews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootHeating_Distribution_EnumArgs = {
  distinct_on?: InputMaybe<Array<Heating_Distribution_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Heating_Distribution_Enum_Order_By>>;
  where?: InputMaybe<Heating_Distribution_Enum_Bool_Exp>;
};


export type Query_RootHeating_Distribution_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootHeating_EnumArgs = {
  distinct_on?: InputMaybe<Array<Heating_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Heating_Enum_Order_By>>;
  where?: InputMaybe<Heating_Enum_Bool_Exp>;
};


export type Query_RootHeating_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootImagesArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Query_RootImages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootImpressions_Grouped_By_ColumnArgs = {
  agency_uuid?: InputMaybe<Scalars['uuid']['input']>;
  agent_uuid?: InputMaybe<Scalars['uuid']['input']>;
  date_range_end?: InputMaybe<Scalars['String']['input']>;
  date_range_start?: InputMaybe<Scalars['String']['input']>;
  event_names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grouping_column?: InputMaybe<ImpressionsGroupingColumn>;
  hostname?: InputMaybe<Scalars['String']['input']>;
  order_by_column?: InputMaybe<Scalars['String']['input']>;
  order_by_direction?: InputMaybe<Scalars['String']['input']>;
  page_types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Query_RootImprove_TextArgs = {
  text?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Invitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitations_Order_By>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};


export type Query_RootInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitations_Order_By>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};


export type Query_RootInvitations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Query_RootInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Query_RootInvoices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIt_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Bool_Exp>;
};


export type Query_RootIt_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Bool_Exp>;
};


export type Query_RootIt_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Query_RootIt_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<It_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<It_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootIt_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<It_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<It_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootIt_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<It_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootIt_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<It_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootIt_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<It_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootIt_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<It_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootIt_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


export type Query_RootIt_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


export type Query_RootIt_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Merged_Listings_Bool_Exp>;
};


export type Query_RootIt_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Merged_Listings_Bool_Exp>;
};


export type Query_RootIt_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootIt_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<It_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Merged_Listings_Bool_Exp>;
};


export type Query_RootIt_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<It_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Merged_Listings_Bool_Exp>;
};


export type Query_RootIt_PlacesArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


export type Query_RootIt_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


export type Query_RootIt_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<It_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootIt_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<It_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootIt_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIt_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<It_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootIt_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootIt_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootIt_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<It_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Property_Types_Order_By>>;
  where?: InputMaybe<It_Property_Types_Bool_Exp>;
};


export type Query_RootIt_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


export type Query_RootIt_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


export type Query_RootLead_AgentsArgs = {
  distinct_on?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Agents_Order_By>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


export type Query_RootLead_Agents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Agents_Order_By>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


export type Query_RootLead_Agents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLead_StagesArgs = {
  distinct_on?: InputMaybe<Array<Lead_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Stages_Order_By>>;
  where?: InputMaybe<Lead_Stages_Bool_Exp>;
};


export type Query_RootLead_Stages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Stages_Order_By>>;
  where?: InputMaybe<Lead_Stages_Bool_Exp>;
};


export type Query_RootLead_Stages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLeadsArgs = {
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Query_RootLeads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Query_RootLeads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLeads_StatusArgs = {
  distinct_on?: InputMaybe<Array<Leads_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Status_Order_By>>;
  where?: InputMaybe<Leads_Status_Bool_Exp>;
};


export type Query_RootLeads_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootLeads_TagsArgs = {
  distinct_on?: InputMaybe<Array<Leads_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Tags_Order_By>>;
  where?: InputMaybe<Leads_Tags_Bool_Exp>;
};


export type Query_RootLeads_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Leads_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Tags_Order_By>>;
  where?: InputMaybe<Leads_Tags_Bool_Exp>;
};


export type Query_RootLeads_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLoginsArgs = {
  distinct_on?: InputMaybe<Array<Logins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Logins_Order_By>>;
  where?: InputMaybe<Logins_Bool_Exp>;
};


export type Query_RootLot_Reference_AliasesArgs = {
  distinct_on?: InputMaybe<Array<Lot_Reference_Aliases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Reference_Aliases_Order_By>>;
  where?: InputMaybe<Lot_Reference_Aliases_Bool_Exp>;
};


export type Query_RootLot_Reference_Aliases_By_PkArgs = {
  reference_alias_decoded: Scalars['Int']['input'];
};


export type Query_RootLot_SellersArgs = {
  distinct_on?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Sellers_Order_By>>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};


export type Query_RootLot_Sellers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Sellers_Order_By>>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};


export type Query_RootLotsArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


export type Query_RootLots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


export type Query_RootLots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLots_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Lots_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Status_Enum_Order_By>>;
  where?: InputMaybe<Lots_Status_Enum_Bool_Exp>;
};


export type Query_RootLots_Status_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootMeArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootMe_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootMls_LotsArgs = {
  distinct_on?: InputMaybe<Array<Mls_Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Lots_Order_By>>;
  where?: InputMaybe<Mls_Lots_Bool_Exp>;
};


export type Query_RootMls_Lots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mls_Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Lots_Order_By>>;
  where?: InputMaybe<Mls_Lots_Bool_Exp>;
};


export type Query_RootMls_PropertiesArgs = {
  distinct_on?: InputMaybe<Array<Mls_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Properties_Order_By>>;
  where?: InputMaybe<Mls_Properties_Bool_Exp>;
};


export type Query_RootNylas_Account_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Nylas_Account_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nylas_Account_Configs_Order_By>>;
  where?: InputMaybe<Nylas_Account_Configs_Bool_Exp>;
};


export type Query_RootNylas_Account_Configs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOffersArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


export type Query_RootOffers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


export type Query_RootOffers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOnline_Listing_Map_DataArgs = {
  distinct_on?: InputMaybe<Array<Online_Listing_Map_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listing_Map_Data_Order_By>>;
  where?: InputMaybe<Online_Listing_Map_Data_Bool_Exp>;
};


export type Query_RootOnline_Listing_Map_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Online_Listing_Map_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listing_Map_Data_Order_By>>;
  where?: InputMaybe<Online_Listing_Map_Data_Bool_Exp>;
};


export type Query_RootOnline_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Query_RootOnline_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Query_RootOnline_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootOrganisation_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Images_Order_By>>;
  where?: InputMaybe<Organisation_Images_Bool_Exp>;
};


export type Query_RootOrganisation_UsersArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Users_Order_By>>;
  where?: InputMaybe<Organisation_Users_Bool_Exp>;
};


export type Query_RootOrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Query_RootOrganisations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Query_RootOrganisations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganisations_SearchArgs = {
  args: Organisations_Search_Args;
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Query_RootOrganisations_Search_AggregateArgs = {
  args: Organisations_Search_Args;
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Query_RootPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Query_RootPayments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPhone_Number_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Phone_Number_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Number_Type_Enum_Order_By>>;
  where?: InputMaybe<Phone_Number_Type_Enum_Bool_Exp>;
};


export type Query_RootPhone_Number_Type_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPhone_NumbersArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Query_RootPhone_Numbers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Query_RootPhone_Numbers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPipelinesArgs = {
  distinct_on?: InputMaybe<Array<Pipelines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pipelines_Order_By>>;
  where?: InputMaybe<Pipelines_Bool_Exp>;
};


export type Query_RootPipelines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pipelines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pipelines_Order_By>>;
  where?: InputMaybe<Pipelines_Bool_Exp>;
};


export type Query_RootPipelines_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPlace_By_SlugArgs = {
  args?: InputMaybe<Place_By_Slug_Args>;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootPlace_By_TypeArgs = {
  args: Place_By_Type_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootPlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootPlaces_Agent_RankingArgs = {
  args: Places_Agent_Ranking_Args;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Query_RootPlaces_Agent_Ranking_AggregateArgs = {
  args: Places_Agent_Ranking_Args;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Query_RootPlaces_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPortal_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portal_Listings_Order_By>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};


export type Query_RootPortal_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portal_Listings_Order_By>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};


export type Query_RootPortal_Listings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPortalsArgs = {
  distinct_on?: InputMaybe<Array<Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portals_Order_By>>;
  where?: InputMaybe<Portals_Bool_Exp>;
};


export type Query_RootPortals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portals_Order_By>>;
  where?: InputMaybe<Portals_Bool_Exp>;
};


export type Query_RootPortals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPortals_Types_EnumArgs = {
  distinct_on?: InputMaybe<Array<Portals_Types_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portals_Types_Enum_Order_By>>;
  where?: InputMaybe<Portals_Types_Enum_Bool_Exp>;
};


export type Query_RootPortals_Types_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPropertiesArgs = {
  distinct_on?: InputMaybe<Array<Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Properties_Order_By>>;
  where?: InputMaybe<Properties_Bool_Exp>;
};


export type Query_RootProperties_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_AppraisableArgs = {
  property_id: Scalars['uuid']['input'];
};


export type Query_RootProperty_FilesArgs = {
  distinct_on?: InputMaybe<Array<Property_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Files_Order_By>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


export type Query_RootProperty_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Files_Order_By>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


export type Query_RootProperty_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Property_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Images_Order_By>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};


export type Query_RootProperty_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Images_Order_By>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};


export type Query_RootProperty_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_Search_Aggregator_SourceArgs = {
  distinct_on?: InputMaybe<Array<Property_Search_Aggregator_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Search_Aggregator_Source_Order_By>>;
  where?: InputMaybe<Property_Search_Aggregator_Source_Bool_Exp>;
};


export type Query_RootProperty_Search_Aggregator_Source_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProperty_Search_SourceArgs = {
  distinct_on?: InputMaybe<Array<Property_Search_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Search_Source_Order_By>>;
  where?: InputMaybe<Property_Search_Source_Bool_Exp>;
};


export type Query_RootProperty_Search_Source_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProperty_SearchesArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Order_By>>;
  where?: InputMaybe<Property_Searches_Bool_Exp>;
};


export type Query_RootProperty_Searches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Order_By>>;
  where?: InputMaybe<Property_Searches_Bool_Exp>;
};


export type Query_RootProperty_Searches_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_Searches_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Places_Order_By>>;
  where?: InputMaybe<Property_Searches_Places_Bool_Exp>;
};


export type Query_RootProperty_Searches_Places_By_PkArgs = {
  place_id: Scalars['uuid']['input'];
  property_search_id: Scalars['uuid']['input'];
};


export type Query_RootProperty_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Query_RootProperty_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Query_RootProperty_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_Transactions_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Listings_Order_By>>;
  where?: InputMaybe<Property_Transactions_Listings_Bool_Exp>;
};


export type Query_RootProperty_Transactions_Listings_By_PkArgs = {
  listing_id: Scalars['Int']['input'];
  property_transaction_id: Scalars['uuid']['input'];
};


export type Query_RootProperty_TypesArgs = {
  distinct_on?: InputMaybe<Array<Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Types_Order_By>>;
  where?: InputMaybe<Property_Types_Bool_Exp>;
};


export type Query_RootProperty_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Types_Order_By>>;
  where?: InputMaybe<Property_Types_Bool_Exp>;
};


export type Query_RootProperty_Types_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPush_Notification_TokensArgs = {
  distinct_on?: InputMaybe<Array<Push_Notification_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Push_Notification_Tokens_Order_By>>;
  where?: InputMaybe<Push_Notification_Tokens_Bool_Exp>;
};


export type Query_RootPush_Notification_Tokens_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRead_Only_TenantsArgs = {
  distinct_on?: InputMaybe<Array<Read_Only_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Read_Only_Tenants_Order_By>>;
  where?: InputMaybe<Read_Only_Tenants_Bool_Exp>;
};


export type Query_RootReviewsArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Query_RootReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Query_RootReviews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSearch_Brockers_In_Catchment_AreaArgs = {
  args?: InputMaybe<Search_Brockers_In_Catchment_Area_Args>;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootSearch_Brockers_In_Catchment_Area_AggregateArgs = {
  args?: InputMaybe<Search_Brockers_In_Catchment_Area_Args>;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootSearch_LeadsArgs = {
  args?: InputMaybe<Search_Leads_Args>;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Query_RootSearch_Leads_AggregateArgs = {
  args?: InputMaybe<Search_Leads_Args>;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Query_RootSearch_Leads_TsvArgs = {
  args: Search_Leads_Tsv_Args;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Query_RootSearch_Leads_Tsv_AggregateArgs = {
  args: Search_Leads_Tsv_Args;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Query_RootSearch_Lots_TsvArgs = {
  args: Search_Lots_Tsv_Args;
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


export type Query_RootSearch_Lots_Tsv_AggregateArgs = {
  args: Search_Lots_Tsv_Args;
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


export type Query_RootSearch_PlacesArgs = {
  args: Search_Places_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootSearch_Places_ExArgs = {
  args: Search_Places_Ex_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootSearch_Property_Transactions_TsvArgs = {
  args: Search_Property_Transactions_Tsv_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Query_RootSearch_Property_Transactions_Tsv_AggregateArgs = {
  args: Search_Property_Transactions_Tsv_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Query_RootSearch_Teams_TsvArgs = {
  args: Search_Teams_Tsv_Args;
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Query_RootSearch_Teams_Tsv_AggregateArgs = {
  args: Search_Teams_Tsv_Args;
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Query_RootSearch_UsersArgs = {
  args?: InputMaybe<Search_Users_Args>;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootSearch_Users_AggregateArgs = {
  args?: InputMaybe<Search_Users_Args>;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootSearch_Users_TsvArgs = {
  args: Search_Users_Tsv_Args;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootSearch_Users_Tsv_AggregateArgs = {
  args: Search_Users_Tsv_Args;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootShared_PortalsArgs = {
  distinct_on?: InputMaybe<Array<Shared_Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shared_Portals_Order_By>>;
  where?: InputMaybe<Shared_Portals_Bool_Exp>;
};


export type Query_RootShared_Portals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shared_Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shared_Portals_Order_By>>;
  where?: InputMaybe<Shared_Portals_Bool_Exp>;
};


export type Query_RootSimilar_Online_Listings_IdsArgs = {
  distinct_on?: InputMaybe<Array<Similar_Online_Listings_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Online_Listings_Ids_Order_By>>;
  where?: InputMaybe<Similar_Online_Listings_Ids_Bool_Exp>;
};


export type Query_RootSimilar_Online_Listings_Ids_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Similar_Online_Listings_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Online_Listings_Ids_Order_By>>;
  where?: InputMaybe<Similar_Online_Listings_Ids_Bool_Exp>;
};


export type Query_RootSmart_ListsArgs = {
  distinct_on?: InputMaybe<Array<Smart_Lists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Lists_Order_By>>;
  where?: InputMaybe<Smart_Lists_Bool_Exp>;
};


export type Query_RootSmart_Lists_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Query_RootSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Query_RootSubscriptions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTeam_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Team_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Images_Order_By>>;
  where?: InputMaybe<Team_Images_Bool_Exp>;
};


export type Query_RootTeam_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Query_RootTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Query_RootTeams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTeams_PortalsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Portals_Order_By>>;
  where?: InputMaybe<Teams_Portals_Bool_Exp>;
};


export type Query_RootTeams_Portals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTeams_UsersArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


export type Query_RootTeams_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


export type Query_RootTenantsArgs = {
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Query_RootTenants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Query_RootTenants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_ImagesArgs = {
  distinct_on?: InputMaybe<Array<User_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Images_Order_By>>;
  where?: InputMaybe<User_Images_Bool_Exp>;
};


export type Query_RootUser_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_Primary_PhoneArgs = {
  args: User_Primary_Phone_Args;
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Query_RootUser_Primary_Phone_AggregateArgs = {
  args: User_Primary_Phone_Args;
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUsers_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Users_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Listings_Order_By>>;
  where?: InputMaybe<Users_Listings_Bool_Exp>;
};


export type Query_RootUsers_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Listings_Order_By>>;
  where?: InputMaybe<Users_Listings_Bool_Exp>;
};


export type Query_RootUsers_Listings_By_PkArgs = {
  created_at: Scalars['timestamptz']['input'];
  merged_listing_id: Scalars['Int']['input'];
  type: Users_Listings_Types_Enum;
  user_id: Scalars['uuid']['input'];
};


export type Query_RootValidate_InvitationArgs = {
  token: Scalars['String']['input'];
};


export type Query_RootValuation_ModelsArgs = {
  distinct_on?: InputMaybe<Array<Valuation_Models_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Valuation_Models_Order_By>>;
  where?: InputMaybe<Valuation_Models_Bool_Exp>;
};


export type Query_RootValuation_Models_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootValuationsArgs = {
  distinct_on?: InputMaybe<Array<Valuations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Valuations_Order_By>>;
  where?: InputMaybe<Valuations_Bool_Exp>;
};


export type Query_RootValuations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "read_only_tenants" */
export type Read_Only_Tenants = {
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "read_only_tenants". All fields are combined with a logical 'AND'. */
export type Read_Only_Tenants_Bool_Exp = {
  _and?: InputMaybe<Array<Read_Only_Tenants_Bool_Exp>>;
  _not?: InputMaybe<Read_Only_Tenants_Bool_Exp>;
  _or?: InputMaybe<Array<Read_Only_Tenants_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "read_only_tenants". */
export type Read_Only_Tenants_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "read_only_tenants" */
export enum Read_Only_Tenants_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "read_only_tenants" */
export type Read_Only_Tenants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Read_Only_Tenants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Read_Only_Tenants_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "reviews" */
export type Reviews = {
  completed: Scalars['Boolean']['output'];
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  display_name?: Maybe<Scalars['String']['output']>;
  email_address: Scalars['String']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  formatted_address: Scalars['String']['output'];
  /** An object relationship */
  google_address?: Maybe<Google_Addresses>;
  google_address_id?: Maybe<Scalars['uuid']['output']>;
  has_accepted_terms: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  is_buyer: Scalars['Boolean']['output'];
  is_seller: Scalars['Boolean']['output'];
  language?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  neverbounce_result?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  property_transaction?: Maybe<Property_Transactions>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_text?: Maybe<Scalars['String']['output']>;
  review_url?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id: Scalars['uuid']['output'];
  transaction_date: Scalars['timestamptz']['output'];
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "reviews" */
export type Reviews_Aggregate = {
  aggregate?: Maybe<Reviews_Aggregate_Fields>;
  nodes: Array<Reviews>;
};

export type Reviews_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Reviews_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Reviews_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Reviews_Aggregate_Bool_Exp_Count>;
};

export type Reviews_Aggregate_Bool_Exp_Bool_And = {
  arguments: Reviews_Select_Column_Reviews_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reviews_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Reviews_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Reviews_Select_Column_Reviews_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reviews_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Reviews_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Reviews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reviews_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "reviews" */
export type Reviews_Aggregate_Fields = {
  avg?: Maybe<Reviews_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Reviews_Max_Fields>;
  min?: Maybe<Reviews_Min_Fields>;
  stddev?: Maybe<Reviews_Stddev_Fields>;
  stddev_pop?: Maybe<Reviews_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reviews_Stddev_Samp_Fields>;
  sum?: Maybe<Reviews_Sum_Fields>;
  var_pop?: Maybe<Reviews_Var_Pop_Fields>;
  var_samp?: Maybe<Reviews_Var_Samp_Fields>;
  variance?: Maybe<Reviews_Variance_Fields>;
};


/** aggregate fields of "reviews" */
export type Reviews_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reviews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "reviews" */
export type Reviews_Aggregate_Order_By = {
  avg?: InputMaybe<Reviews_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Reviews_Max_Order_By>;
  min?: InputMaybe<Reviews_Min_Order_By>;
  stddev?: InputMaybe<Reviews_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Reviews_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Reviews_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Reviews_Sum_Order_By>;
  var_pop?: InputMaybe<Reviews_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Reviews_Var_Samp_Order_By>;
  variance?: InputMaybe<Reviews_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "reviews" */
export type Reviews_Arr_Rel_Insert_Input = {
  data: Array<Reviews_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Reviews_On_Conflict>;
};

/** aggregate avg on columns */
export type Reviews_Avg_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "reviews" */
export type Reviews_Avg_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "reviews". All fields are combined with a logical 'AND'. */
export type Reviews_Bool_Exp = {
  _and?: InputMaybe<Array<Reviews_Bool_Exp>>;
  _not?: InputMaybe<Reviews_Bool_Exp>;
  _or?: InputMaybe<Array<Reviews_Bool_Exp>>;
  completed?: InputMaybe<Boolean_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  email_address?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  formatted_address?: InputMaybe<String_Comparison_Exp>;
  google_address?: InputMaybe<Google_Addresses_Bool_Exp>;
  google_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  has_accepted_terms?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_buyer?: InputMaybe<Boolean_Comparison_Exp>;
  is_seller?: InputMaybe<Boolean_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  neverbounce_result?: InputMaybe<String_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_transaction?: InputMaybe<Property_Transactions_Bool_Exp>;
  rating?: InputMaybe<Int_Comparison_Exp>;
  review_text?: InputMaybe<String_Comparison_Exp>;
  review_url?: InputMaybe<String_Comparison_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  transaction_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "reviews" */
export enum Reviews_Constraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  ReviewsIdTenantIdUnique = 'reviews_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  ReviewsPkey = 'reviews_pkey'
}

/** input type for incrementing numeric columns in table "reviews" */
export type Reviews_Inc_Input = {
  rating?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "reviews" */
export type Reviews_Insert_Input = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  google_address?: InputMaybe<Google_Addresses_Obj_Rel_Insert_Input>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  has_accepted_terms?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_buyer?: InputMaybe<Scalars['Boolean']['input']>;
  is_seller?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  neverbounce_result?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  property_transaction?: InputMaybe<Property_Transactions_Obj_Rel_Insert_Input>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_text?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  transaction_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Reviews_Max_Fields = {
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  formatted_address?: Maybe<Scalars['String']['output']>;
  google_address_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  neverbounce_result?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_text?: Maybe<Scalars['String']['output']>;
  review_url?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  transaction_date?: Maybe<Scalars['timestamptz']['output']>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "reviews" */
export type Reviews_Max_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  formatted_address?: InputMaybe<Order_By>;
  google_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  neverbounce_result?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  review_text?: InputMaybe<Order_By>;
  review_url?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  transaction_date?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Reviews_Min_Fields = {
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  formatted_address?: Maybe<Scalars['String']['output']>;
  google_address_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  neverbounce_result?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_text?: Maybe<Scalars['String']['output']>;
  review_url?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  transaction_date?: Maybe<Scalars['timestamptz']['output']>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "reviews" */
export type Reviews_Min_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  formatted_address?: InputMaybe<Order_By>;
  google_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  neverbounce_result?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  review_text?: InputMaybe<Order_By>;
  review_url?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  transaction_date?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reviews" */
export type Reviews_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reviews>;
};

/** on_conflict condition type for table "reviews" */
export type Reviews_On_Conflict = {
  constraint: Reviews_Constraint;
  update_columns?: Array<Reviews_Update_Column>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};

/** Ordering options when selecting data from "reviews". */
export type Reviews_Order_By = {
  completed?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  formatted_address?: InputMaybe<Order_By>;
  google_address?: InputMaybe<Google_Addresses_Order_By>;
  google_address_id?: InputMaybe<Order_By>;
  has_accepted_terms?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_buyer?: InputMaybe<Order_By>;
  is_seller?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  neverbounce_result?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  property_transaction?: InputMaybe<Property_Transactions_Order_By>;
  rating?: InputMaybe<Order_By>;
  review_text?: InputMaybe<Order_By>;
  review_url?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  transaction_date?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reviews */
export type Reviews_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "reviews" */
export enum Reviews_Select_Column {
  /** column name */
  Completed = 'completed',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  Id = 'id',
  /** column name */
  IsBuyer = 'is_buyer',
  /** column name */
  IsSeller = 'is_seller',
  /** column name */
  Language = 'language',
  /** column name */
  LastName = 'last_name',
  /** column name */
  NeverbounceResult = 'neverbounce_result',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewText = 'review_text',
  /** column name */
  ReviewUrl = 'review_url',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TransactionDate = 'transaction_date',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "reviews_aggregate_bool_exp_bool_and_arguments_columns" columns of table "reviews" */
export enum Reviews_Select_Column_Reviews_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Completed = 'completed',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  IsBuyer = 'is_buyer',
  /** column name */
  IsSeller = 'is_seller'
}

/** select "reviews_aggregate_bool_exp_bool_or_arguments_columns" columns of table "reviews" */
export enum Reviews_Select_Column_Reviews_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Completed = 'completed',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  IsBuyer = 'is_buyer',
  /** column name */
  IsSeller = 'is_seller'
}

/** input type for updating data in table "reviews" */
export type Reviews_Set_Input = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  has_accepted_terms?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_buyer?: InputMaybe<Scalars['Boolean']['input']>;
  is_seller?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  neverbounce_result?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_text?: InputMaybe<Scalars['String']['input']>;
  review_url?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  transaction_date?: InputMaybe<Scalars['timestamptz']['input']>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Reviews_Stddev_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "reviews" */
export type Reviews_Stddev_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Reviews_Stddev_Pop_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "reviews" */
export type Reviews_Stddev_Pop_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Reviews_Stddev_Samp_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "reviews" */
export type Reviews_Stddev_Samp_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "reviews" */
export type Reviews_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reviews_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reviews_Stream_Cursor_Value_Input = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  has_accepted_terms?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_buyer?: InputMaybe<Scalars['Boolean']['input']>;
  is_seller?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  neverbounce_result?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_text?: InputMaybe<Scalars['String']['input']>;
  review_url?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  transaction_date?: InputMaybe<Scalars['timestamptz']['input']>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Reviews_Sum_Fields = {
  rating?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "reviews" */
export type Reviews_Sum_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** update columns of table "reviews" */
export enum Reviews_Update_Column {
  /** column name */
  Completed = 'completed',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  Id = 'id',
  /** column name */
  IsBuyer = 'is_buyer',
  /** column name */
  IsSeller = 'is_seller',
  /** column name */
  LastName = 'last_name',
  /** column name */
  NeverbounceResult = 'neverbounce_result',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewText = 'review_text',
  /** column name */
  ReviewUrl = 'review_url',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TransactionDate = 'transaction_date',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Reviews_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Reviews_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reviews_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reviews_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Reviews_Var_Pop_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "reviews" */
export type Reviews_Var_Pop_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Reviews_Var_Samp_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "reviews" */
export type Reviews_Var_Samp_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Reviews_Variance_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "reviews" */
export type Reviews_Variance_Order_By = {
  rating?: InputMaybe<Order_By>;
};

export type Search_Brockers_In_Catchment_Area_Args = {
  district_id?: InputMaybe<Scalars['uuid']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Search_Leads_Args = {
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Leads_Tsv_Args = {
  search_text?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Lots_Tsv_Args = {
  search_text?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Places_Args = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Places_Ex_Args = {
  id_in?: InputMaybe<Scalars['String']['input']>;
  index_eq?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type_in?: InputMaybe<Scalars['String']['input']>;
  type_nin?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Places_With_Index_Args = {
  search?: InputMaybe<Scalars['String']['input']>;
  with_index?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Search_Property_Transactions_Tsv_Args = {
  search_text?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Teams_Tsv_Args = {
  search_text?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Users_Args = {
  email?: InputMaybe<Scalars['citext']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Users_Tsv_Args = {
  search_text?: InputMaybe<Scalars['String']['input']>;
};

export type Set_Default_Team_Args = {
  user_ids?: InputMaybe<Scalars['_uuid']['input']>;
};

/** columns and relationships of "shared_portals" */
export type Shared_Portals = {
  active?: Maybe<Scalars['Boolean']['output']>;
  contract_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  exact_address_required?: Maybe<Scalars['Boolean']['output']>;
  has_top_premium_listing?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idx_protocol?: Maybe<Scalars['portal_idx_protocol']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  quota?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "shared_portals" */
export type Shared_Portals_Aggregate = {
  aggregate?: Maybe<Shared_Portals_Aggregate_Fields>;
  nodes: Array<Shared_Portals>;
};

/** aggregate fields of "shared_portals" */
export type Shared_Portals_Aggregate_Fields = {
  avg?: Maybe<Shared_Portals_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Shared_Portals_Max_Fields>;
  min?: Maybe<Shared_Portals_Min_Fields>;
  stddev?: Maybe<Shared_Portals_Stddev_Fields>;
  stddev_pop?: Maybe<Shared_Portals_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shared_Portals_Stddev_Samp_Fields>;
  sum?: Maybe<Shared_Portals_Sum_Fields>;
  var_pop?: Maybe<Shared_Portals_Var_Pop_Fields>;
  var_samp?: Maybe<Shared_Portals_Var_Samp_Fields>;
  variance?: Maybe<Shared_Portals_Variance_Fields>;
};


/** aggregate fields of "shared_portals" */
export type Shared_Portals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shared_Portals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Shared_Portals_Avg_Fields = {
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "shared_portals". All fields are combined with a logical 'AND'. */
export type Shared_Portals_Bool_Exp = {
  _and?: InputMaybe<Array<Shared_Portals_Bool_Exp>>;
  _not?: InputMaybe<Shared_Portals_Bool_Exp>;
  _or?: InputMaybe<Array<Shared_Portals_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  contract_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  exact_address_required?: InputMaybe<Boolean_Comparison_Exp>;
  has_top_premium_listing?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  idx_protocol?: InputMaybe<Portal_Idx_Protocol_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  port?: InputMaybe<Int_Comparison_Exp>;
  quota?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  website_url?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Shared_Portals_Max_Fields = {
  contract_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idx_protocol?: Maybe<Scalars['portal_idx_protocol']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  quota?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Shared_Portals_Min_Fields = {
  contract_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idx_protocol?: Maybe<Scalars['portal_idx_protocol']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  quota?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "shared_portals". */
export type Shared_Portals_Order_By = {
  active?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  exact_address_required?: InputMaybe<Order_By>;
  has_top_premium_listing?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idx_protocol?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  port?: InputMaybe<Order_By>;
  quota?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  website_url?: InputMaybe<Order_By>;
};

/** select columns of table "shared_portals" */
export enum Shared_Portals_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  ExactAddressRequired = 'exact_address_required',
  /** column name */
  HasTopPremiumListing = 'has_top_premium_listing',
  /** column name */
  Id = 'id',
  /** column name */
  IdxProtocol = 'idx_protocol',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password',
  /** column name */
  Port = 'port',
  /** column name */
  Quota = 'quota',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  Username = 'username',
  /** column name */
  WebsiteUrl = 'website_url'
}

/** aggregate stddev on columns */
export type Shared_Portals_Stddev_Fields = {
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Shared_Portals_Stddev_Pop_Fields = {
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Shared_Portals_Stddev_Samp_Fields = {
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "shared_portals" */
export type Shared_Portals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shared_Portals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shared_Portals_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contract_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exact_address_required?: InputMaybe<Scalars['Boolean']['input']>;
  has_top_premium_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_protocol?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  quota?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Shared_Portals_Sum_Fields = {
  port?: Maybe<Scalars['Int']['output']>;
  quota?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Shared_Portals_Var_Pop_Fields = {
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Shared_Portals_Var_Samp_Fields = {
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Shared_Portals_Variance_Fields = {
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "similar_online_listings_ids" */
export type Similar_Online_Listings_Ids = {
  id?: Maybe<Scalars['Int']['output']>;
};

export type Similar_Online_Listings_Ids_Aggregate = {
  aggregate?: Maybe<Similar_Online_Listings_Ids_Aggregate_Fields>;
  nodes: Array<Similar_Online_Listings_Ids>;
};

/** aggregate fields of "similar_online_listings_ids" */
export type Similar_Online_Listings_Ids_Aggregate_Fields = {
  avg?: Maybe<Similar_Online_Listings_Ids_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Similar_Online_Listings_Ids_Max_Fields>;
  min?: Maybe<Similar_Online_Listings_Ids_Min_Fields>;
  stddev?: Maybe<Similar_Online_Listings_Ids_Stddev_Fields>;
  stddev_pop?: Maybe<Similar_Online_Listings_Ids_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Similar_Online_Listings_Ids_Stddev_Samp_Fields>;
  sum?: Maybe<Similar_Online_Listings_Ids_Sum_Fields>;
  var_pop?: Maybe<Similar_Online_Listings_Ids_Var_Pop_Fields>;
  var_samp?: Maybe<Similar_Online_Listings_Ids_Var_Samp_Fields>;
  variance?: Maybe<Similar_Online_Listings_Ids_Variance_Fields>;
};


/** aggregate fields of "similar_online_listings_ids" */
export type Similar_Online_Listings_Ids_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Similar_Online_Listings_Ids_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Similar_Online_Listings_Ids_Avg_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "similar_online_listings_ids". All fields are combined with a logical 'AND'. */
export type Similar_Online_Listings_Ids_Bool_Exp = {
  _and?: InputMaybe<Array<Similar_Online_Listings_Ids_Bool_Exp>>;
  _not?: InputMaybe<Similar_Online_Listings_Ids_Bool_Exp>;
  _or?: InputMaybe<Array<Similar_Online_Listings_Ids_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Similar_Online_Listings_Ids_Max_Fields = {
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Similar_Online_Listings_Ids_Min_Fields = {
  id?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "similar_online_listings_ids". */
export type Similar_Online_Listings_Ids_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** select columns of table "similar_online_listings_ids" */
export enum Similar_Online_Listings_Ids_Select_Column {
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Similar_Online_Listings_Ids_Stddev_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Similar_Online_Listings_Ids_Stddev_Pop_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Similar_Online_Listings_Ids_Stddev_Samp_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Similar_Online_Listings_Ids_Sum_Fields = {
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Similar_Online_Listings_Ids_Var_Pop_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Similar_Online_Listings_Ids_Var_Samp_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Similar_Online_Listings_Ids_Variance_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']['input']>;
  _gt?: InputMaybe<Scalars['smallint']['input']>;
  _gte?: InputMaybe<Scalars['smallint']['input']>;
  _in?: InputMaybe<Array<Scalars['smallint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['smallint']['input']>;
  _lte?: InputMaybe<Scalars['smallint']['input']>;
  _neq?: InputMaybe<Scalars['smallint']['input']>;
  _nin?: InputMaybe<Array<Scalars['smallint']['input']>>;
};

/** columns and relationships of "smart_lists" */
export type Smart_Lists = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['uuid']['output'];
  crm_entity: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_shared: Scalars['Boolean']['output'];
  is_tenant_shared: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  where: Scalars['jsonb']['output'];
};


/** columns and relationships of "smart_lists" */
export type Smart_ListsWhereArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Smart_Lists_Append_Input = {
  order_by?: InputMaybe<Scalars['jsonb']['input']>;
  where?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "smart_lists". All fields are combined with a logical 'AND'. */
export type Smart_Lists_Bool_Exp = {
  _and?: InputMaybe<Array<Smart_Lists_Bool_Exp>>;
  _not?: InputMaybe<Smart_Lists_Bool_Exp>;
  _or?: InputMaybe<Array<Smart_Lists_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  crm_entity?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_shared?: InputMaybe<Boolean_Comparison_Exp>;
  is_tenant_shared?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  where?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "smart_lists" */
export enum Smart_Lists_Constraint {
  /** unique or primary key constraint on columns "id" */
  SmartListsPkey = 'smart_lists_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Smart_Lists_Delete_At_Path_Input = {
  order_by?: InputMaybe<Array<Scalars['String']['input']>>;
  where?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Smart_Lists_Delete_Elem_Input = {
  order_by?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Smart_Lists_Delete_Key_Input = {
  order_by?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "smart_lists" */
export type Smart_Lists_Insert_Input = {
  crm_entity?: InputMaybe<Scalars['String']['input']>;
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  is_tenant_shared?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  where?: InputMaybe<Scalars['jsonb']['input']>;
};

/** response of any mutation on the table "smart_lists" */
export type Smart_Lists_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Smart_Lists>;
};

/** on_conflict condition type for table "smart_lists" */
export type Smart_Lists_On_Conflict = {
  constraint: Smart_Lists_Constraint;
  update_columns?: Array<Smart_Lists_Update_Column>;
  where?: InputMaybe<Smart_Lists_Bool_Exp>;
};

/** Ordering options when selecting data from "smart_lists". */
export type Smart_Lists_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  crm_entity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_shared?: InputMaybe<Order_By>;
  is_tenant_shared?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  where?: InputMaybe<Order_By>;
};

/** primary key columns input for table: smart_lists */
export type Smart_Lists_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Smart_Lists_Prepend_Input = {
  order_by?: InputMaybe<Scalars['jsonb']['input']>;
  where?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "smart_lists" */
export enum Smart_Lists_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CrmEntity = 'crm_entity',
  /** column name */
  Id = 'id',
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  IsTenantShared = 'is_tenant_shared',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Where = 'where'
}

/** input type for updating data in table "smart_lists" */
export type Smart_Lists_Set_Input = {
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  is_tenant_shared?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_by?: InputMaybe<Scalars['jsonb']['input']>;
  where?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "smart_lists" */
export type Smart_Lists_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Smart_Lists_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Smart_Lists_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  crm_entity?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  is_tenant_shared?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  where?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "smart_lists" */
export enum Smart_Lists_Update_Column {
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  IsTenantShared = 'is_tenant_shared',
  /** column name */
  Name = 'name',
  /** column name */
  OrderBy = 'order_by',
  /** column name */
  Where = 'where'
}

export type Smart_Lists_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Smart_Lists_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Smart_Lists_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Smart_Lists_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Smart_Lists_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Smart_Lists_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Smart_Lists_Set_Input>;
  /** filter the rows which have to be updated */
  where: Smart_Lists_Bool_Exp;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geography']['input'];
  use_spheroid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geometry']['input'];
};

export type Subscription_Root = {
  /** An array relationship */
  activities: Array<Activities>;
  /** An aggregate relationship */
  activities_aggregate: Activities_Aggregate;
  /** fetch data from the table: "activities" using primary key columns */
  activities_by_pk?: Maybe<Activities>;
  /** fetch data from the table in a streaming manner: "activities" */
  activities_stream: Array<Activities>;
  /** fetch data from the table: "address_display_options_enum" */
  address_display_options_enum: Array<Address_Display_Options_Enum>;
  /** fetch data from the table: "address_display_options_enum" using primary key columns */
  address_display_options_enum_by_pk?: Maybe<Address_Display_Options_Enum>;
  /** fetch data from the table in a streaming manner: "address_display_options_enum" */
  address_display_options_enum_stream: Array<Address_Display_Options_Enum>;
  /** execute function "agent_statistics" which returns "agent_stats" */
  agent_statistics: Array<Agent_Stats>;
  /** fetch data from the table: "agent_stats" */
  agent_stats: Array<Agent_Stats>;
  /** fetch data from the table: "agent_stats" using primary key columns */
  agent_stats_by_pk?: Maybe<Agent_Stats>;
  /** fetch data from the table in a streaming manner: "agent_stats" */
  agent_stats_stream: Array<Agent_Stats>;
  /** An array relationship */
  appraisals: Array<Appraisals>;
  /** fetch data from the table: "appraisals" using primary key columns */
  appraisals_by_pk?: Maybe<Appraisals>;
  /** fetch data from the table in a streaming manner: "appraisals" */
  appraisals_stream: Array<Appraisals>;
  /** An array relationship */
  buyer_leads: Array<Buyer_Leads>;
  /** An aggregate relationship */
  buyer_leads_aggregate: Buyer_Leads_Aggregate;
  /** fetch data from the table: "buyer_leads" using primary key columns */
  buyer_leads_by_pk?: Maybe<Buyer_Leads>;
  /** fetch data from the table in a streaming manner: "buyer_leads" */
  buyer_leads_stream: Array<Buyer_Leads>;
  /** An array relationship */
  catchment_areas: Array<Catchment_Areas>;
  /** An aggregate relationship */
  catchment_areas_aggregate: Catchment_Areas_Aggregate;
  /** fetch data from the table in a streaming manner: "catchment_areas" */
  catchment_areas_stream: Array<Catchment_Areas>;
  /** fetch data from the table: "cma_listings" */
  ch_cma_listings: Array<Ch_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  ch_cma_listings_aggregate: Ch_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  ch_cma_listings_by_pk?: Maybe<Ch_Cma_Listings>;
  /** execute function "get_buy_rent_listings" which returns "merged_listings" */
  ch_get_buy_rent_listings: Array<Ch_Merged_Listings>;
  /** execute function "get_buy_rent_listings" and query aggregates on result of table type "merged_listings" */
  ch_get_buy_rent_listings_aggregate: Ch_Merged_Listings_Aggregate;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  ch_get_merged_listings: Array<Ch_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  ch_get_merged_listings_type: Array<Ch_Get_Merged_Listings_Type>;
  /** execute function "get_place_by_slug" which returns "places" */
  ch_get_place_by_slug?: Maybe<Ch_Places>;
  /** execute function "get_place_by_slug" and query aggregates on result of table type "places" */
  ch_get_place_by_slug_aggregate: Ch_Places_Aggregate;
  /** execute function "get_similar_listings" which returns "post_merged_listings" */
  ch_get_similar_listings: Array<Ch_Post_Merged_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "post_merged_listings" */
  ch_get_similar_listings_aggregate: Ch_Post_Merged_Listings_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "post_merged_listings" */
  ch_get_similar_listings_vector: Array<Ch_Post_Merged_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "post_merged_listings" */
  ch_get_similar_listings_vector_aggregate: Ch_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_images" */
  ch_merged_images: Array<Ch_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  ch_merged_images_aggregate: Ch_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  ch_merged_listings: Array<Ch_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  ch_merged_listings_aggregate: Ch_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  ch_merged_listings_by_pk?: Maybe<Ch_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  ch_merged_listings_compare: Array<Ch_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  ch_merged_listings_compare_aggregate: Ch_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  ch_places: Array<Ch_Places>;
  /** fetch aggregated fields from the table: "places" */
  ch_places_aggregate: Ch_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  ch_places_breadcrumbs: Array<Ch_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  ch_places_breadcrumbs_aggregate: Ch_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  ch_places_by_pk?: Maybe<Ch_Places>;
  /** fetch data from the table: "post_merged_listings" */
  ch_post_merged_listings: Array<Ch_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  ch_post_merged_listings_aggregate: Ch_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  ch_post_merged_listings_by_pk?: Maybe<Ch_Post_Merged_Listings>;
  /** fetch data from the table: "price_stats_quantiles" */
  ch_price_stats_quantiles: Array<Ch_Price_Stats_Quantiles>;
  /** fetch aggregated fields from the table: "price_stats_quantiles" */
  ch_price_stats_quantiles_aggregate: Ch_Price_Stats_Quantiles_Aggregate;
  /** fetch data from the table: "price_stats_quantiles" using primary key columns */
  ch_price_stats_quantiles_by_pk?: Maybe<Ch_Price_Stats_Quantiles>;
  /** fetch data from the table: "property_types" */
  ch_property_types: Array<Ch_Property_Types>;
  /** execute function "search_places" which returns "places" */
  ch_search_places: Array<Ch_Places>;
  /** execute function "search_places" and query aggregates on result of table type "places" */
  ch_search_places_aggregate: Ch_Places_Aggregate;
  /** execute function "search_places_with_index" which returns "places" */
  ch_search_places_with_index: Array<Ch_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  ch_search_places_with_index_aggregate: Ch_Places_Aggregate;
  /** An array relationship */
  cma_report_files: Array<Cma_Report_Files>;
  /** An aggregate relationship */
  cma_report_files_aggregate: Cma_Report_Files_Aggregate;
  /** fetch data from the table in a streaming manner: "cma_report_files" */
  cma_report_files_stream: Array<Cma_Report_Files>;
  /** An array relationship */
  cma_reports: Array<Cma_Reports>;
  /** An aggregate relationship */
  cma_reports_aggregate: Cma_Reports_Aggregate;
  /** fetch data from the table: "cma_reports" using primary key columns */
  cma_reports_by_pk?: Maybe<Cma_Reports>;
  /** fetch data from the table: "cma_reports_comparables" */
  cma_reports_comparables: Array<Cma_Reports_Comparables>;
  /** fetch data from the table in a streaming manner: "cma_reports_comparables" */
  cma_reports_comparables_stream: Array<Cma_Reports_Comparables>;
  /** fetch data from the table in a streaming manner: "cma_reports" */
  cma_reports_stream: Array<Cma_Reports>;
  /** An array relationship */
  combined_reviews: Array<Combined_Reviews>;
  /** An aggregate relationship */
  combined_reviews_aggregate: Combined_Reviews_Aggregate;
  /** fetch data from the table in a streaming manner: "combined_reviews" */
  combined_reviews_stream: Array<Combined_Reviews>;
  /** fetch data from the table: "cooling_enum" */
  cooling_enum: Array<Cooling_Enum>;
  /** fetch data from the table: "cooling_enum" using primary key columns */
  cooling_enum_by_pk?: Maybe<Cooling_Enum>;
  /** fetch data from the table in a streaming manner: "cooling_enum" */
  cooling_enum_stream: Array<Cooling_Enum>;
  /** fetch data from the table: "countries" */
  countries: Array<Countries>;
  /** fetch data from the table: "countries" using primary key columns */
  countries_by_pk?: Maybe<Countries>;
  /** fetch data from the table in a streaming manner: "countries" */
  countries_stream: Array<Countries>;
  /** fetch data from the table: "developments" */
  developments: Array<Developments>;
  /** fetch data from the table: "developments" using primary key columns */
  developments_by_pk?: Maybe<Developments>;
  /** fetch data from the table in a streaming manner: "developments" */
  developments_stream: Array<Developments>;
  /** fetch data from the table: "dictionaries" */
  dictionaries: Array<Dictionaries>;
  /** fetch data from the table: "dictionaries" using primary key columns */
  dictionaries_by_pk?: Maybe<Dictionaries>;
  /** fetch data from the table in a streaming manner: "dictionaries" */
  dictionaries_stream: Array<Dictionaries>;
  /** fetch data from the table: "dictionaries_types_enum" */
  dictionaries_types_enum: Array<Dictionaries_Types_Enum>;
  /** fetch data from the table: "dictionaries_types_enum" using primary key columns */
  dictionaries_types_enum_by_pk?: Maybe<Dictionaries_Types_Enum>;
  /** fetch data from the table in a streaming manner: "dictionaries_types_enum" */
  dictionaries_types_enum_stream: Array<Dictionaries_Types_Enum>;
  /** fetch data from the table: "doc_template_type_enum" */
  doc_template_type_enum: Array<Doc_Template_Type_Enum>;
  /** fetch data from the table: "doc_template_type_enum" using primary key columns */
  doc_template_type_enum_by_pk?: Maybe<Doc_Template_Type_Enum>;
  /** fetch data from the table in a streaming manner: "doc_template_type_enum" */
  doc_template_type_enum_stream: Array<Doc_Template_Type_Enum>;
  /** fetch data from the table: "doc_templates" */
  doc_templates: Array<Doc_Templates>;
  /** fetch data from the table: "doc_templates" using primary key columns */
  doc_templates_by_pk?: Maybe<Doc_Templates>;
  /** fetch data from the table in a streaming manner: "doc_templates" */
  doc_templates_stream: Array<Doc_Templates>;
  /** An array relationship */
  doc_templates_tenants: Array<Doc_Templates_Tenants>;
  /** fetch data from the table: "doc_templates_tenants" using primary key columns */
  doc_templates_tenants_by_pk?: Maybe<Doc_Templates_Tenants>;
  /** fetch data from the table in a streaming manner: "doc_templates_tenants" */
  doc_templates_tenants_stream: Array<Doc_Templates_Tenants>;
  /** fetch data from the table: "email_sequences" */
  email_sequences: Array<Email_Sequences>;
  /** fetch data from the table: "email_sequences" using primary key columns */
  email_sequences_by_pk?: Maybe<Email_Sequences>;
  /** An array relationship */
  email_sequences_recipients: Array<Email_Sequences_Recipients>;
  /** An aggregate relationship */
  email_sequences_recipients_aggregate: Email_Sequences_Recipients_Aggregate;
  /** fetch data from the table: "email_sequences_recipients" using primary key columns */
  email_sequences_recipients_by_pk?: Maybe<Email_Sequences_Recipients>;
  /** fetch data from the table in a streaming manner: "email_sequences_recipients" */
  email_sequences_recipients_stream: Array<Email_Sequences_Recipients>;
  /** An array relationship */
  email_sequences_steps: Array<Email_Sequences_Steps>;
  /** An aggregate relationship */
  email_sequences_steps_aggregate: Email_Sequences_Steps_Aggregate;
  /** fetch data from the table: "email_sequences_steps" using primary key columns */
  email_sequences_steps_by_pk?: Maybe<Email_Sequences_Steps>;
  /** fetch data from the table in a streaming manner: "email_sequences_steps" */
  email_sequences_steps_stream: Array<Email_Sequences_Steps>;
  /** fetch data from the table in a streaming manner: "email_sequences" */
  email_sequences_stream: Array<Email_Sequences>;
  /** An array relationship */
  email_templates: Array<Email_Templates>;
  /** fetch data from the table: "email_templates" using primary key columns */
  email_templates_by_pk?: Maybe<Email_Templates>;
  /** fetch data from the table in a streaming manner: "email_templates" */
  email_templates_stream: Array<Email_Templates>;
  /** An array relationship */
  emails: Array<Emails>;
  /** fetch data from the table: "emails" using primary key columns */
  emails_by_pk?: Maybe<Emails>;
  /** fetch data from the table in a streaming manner: "emails" */
  emails_stream: Array<Emails>;
  /** An array relationship */
  enquiries: Array<Enquiries>;
  /** An aggregate relationship */
  enquiries_aggregate: Enquiries_Aggregate;
  /** fetch data from the table: "enquiries" using primary key columns */
  enquiries_by_pk?: Maybe<Enquiries>;
  /** fetch data from the table in a streaming manner: "enquiries" */
  enquiries_stream: Array<Enquiries>;
  /** fetch data from the table: "cma_listings" */
  es_cma_listings: Array<Es_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  es_cma_listings_aggregate: Es_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  es_cma_listings_by_pk?: Maybe<Es_Cma_Listings>;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  es_get_merged_listings: Array<Es_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  es_get_merged_listings_type: Array<Es_Get_Merged_Listings_Type>;
  /** execute function "get_place_by_slug" which returns "places" */
  es_get_place_by_slug?: Maybe<Es_Places>;
  /** execute function "get_place_by_slug" and query aggregates on result of table type "places" */
  es_get_place_by_slug_aggregate: Es_Places_Aggregate;
  /** execute function "get_similar_listings" which returns "post_merged_listings" */
  es_get_similar_listings: Array<Es_Post_Merged_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "post_merged_listings" */
  es_get_similar_listings_aggregate: Es_Post_Merged_Listings_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "post_merged_listings" */
  es_get_similar_listings_vector: Array<Es_Post_Merged_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "post_merged_listings" */
  es_get_similar_listings_vector_aggregate: Es_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_images" */
  es_merged_images: Array<Es_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  es_merged_images_aggregate: Es_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  es_merged_listings: Array<Es_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  es_merged_listings_aggregate: Es_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  es_merged_listings_by_pk?: Maybe<Es_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  es_merged_listings_compare: Array<Es_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  es_merged_listings_compare_aggregate: Es_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  es_places: Array<Es_Places>;
  /** fetch aggregated fields from the table: "places" */
  es_places_aggregate: Es_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  es_places_breadcrumbs: Array<Es_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  es_places_breadcrumbs_aggregate: Es_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  es_places_by_pk?: Maybe<Es_Places>;
  /** fetch data from the table: "post_merged_listings" */
  es_post_merged_listings: Array<Es_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  es_post_merged_listings_aggregate: Es_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  es_post_merged_listings_by_pk?: Maybe<Es_Post_Merged_Listings>;
  /** fetch data from the table: "property_types" */
  es_property_types: Array<Es_Property_Types>;
  /** execute function "search_places_with_index" which returns "places" */
  es_search_places_with_index: Array<Es_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  es_search_places_with_index_aggregate: Es_Places_Aggregate;
  /** fetch data from the table: "files" */
  files: Array<Files>;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: Maybe<Files>;
  /** fetch data from the table in a streaming manner: "files" */
  files_stream: Array<Files>;
  /** execute function "financing_statistics" which returns "financing_stats" */
  financing_statistics: Array<Financing_Stats>;
  /** fetch data from the table: "financing_stats" */
  financing_stats: Array<Financing_Stats>;
  /** fetch data from the table: "financing_stats" using primary key columns */
  financing_stats_by_pk?: Maybe<Financing_Stats>;
  /** fetch data from the table in a streaming manner: "financing_stats" */
  financing_stats_stream: Array<Financing_Stats>;
  /** execute function "find_price_map_places" which returns "places" */
  find_price_map_places: Array<Places>;
  /** fetch data from the table: "cma_listings" */
  fr_cma_listings: Array<Fr_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  fr_cma_listings_aggregate: Fr_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  fr_cma_listings_by_pk?: Maybe<Fr_Cma_Listings>;
  /** execute function "get_buy_rent_listings" which returns "merged_listings" */
  fr_get_buy_rent_listings: Array<Fr_Merged_Listings>;
  /** execute function "get_buy_rent_listings" and query aggregates on result of table type "merged_listings" */
  fr_get_buy_rent_listings_aggregate: Fr_Merged_Listings_Aggregate;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  fr_get_merged_listings: Array<Fr_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  fr_get_merged_listings_type: Array<Fr_Get_Merged_Listings_Type>;
  /** execute function "get_place_by_slug" which returns "places" */
  fr_get_place_by_slug?: Maybe<Fr_Places>;
  /** execute function "get_place_by_slug" and query aggregates on result of table type "places" */
  fr_get_place_by_slug_aggregate: Fr_Places_Aggregate;
  /** execute function "get_similar_listings" which returns "post_merged_listings" */
  fr_get_similar_listings: Array<Fr_Post_Merged_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "post_merged_listings" */
  fr_get_similar_listings_aggregate: Fr_Post_Merged_Listings_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "post_merged_listings" */
  fr_get_similar_listings_vector: Array<Fr_Post_Merged_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "post_merged_listings" */
  fr_get_similar_listings_vector_aggregate: Fr_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_images" */
  fr_merged_images: Array<Fr_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  fr_merged_images_aggregate: Fr_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  fr_merged_listings: Array<Fr_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  fr_merged_listings_aggregate: Fr_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  fr_merged_listings_by_pk?: Maybe<Fr_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  fr_merged_listings_compare: Array<Fr_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  fr_merged_listings_compare_aggregate: Fr_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  fr_places: Array<Fr_Places>;
  /** fetch aggregated fields from the table: "places" */
  fr_places_aggregate: Fr_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  fr_places_breadcrumbs: Array<Fr_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  fr_places_breadcrumbs_aggregate: Fr_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  fr_places_by_pk?: Maybe<Fr_Places>;
  /** fetch data from the table: "post_merged_listings" */
  fr_post_merged_listings: Array<Fr_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  fr_post_merged_listings_aggregate: Fr_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  fr_post_merged_listings_by_pk?: Maybe<Fr_Post_Merged_Listings>;
  /** fetch data from the table: "property_types" */
  fr_property_types: Array<Fr_Property_Types>;
  /** execute function "search_places_with_index" which returns "places" */
  fr_search_places_with_index: Array<Fr_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  fr_search_places_with_index_aggregate: Fr_Places_Aggregate;
  /** execute function "get_agents_ranking" which returns "agents_rankings" */
  get_agents_ranking: Array<Agents_Rankings>;
  /** execute function "get_agents_ranking" and query aggregates on result of table type "agents_rankings" */
  get_agents_ranking_aggregate: Agents_Rankings_Aggregate;
  /** execute function "get_appraisals_by_slug" which returns "appraisals_public_view" */
  get_appraisals_by_slug: Array<Appraisals_Public_View>;
  /** execute function "get_catchment_area" which returns "places" */
  get_catchment_area: Array<Places>;
  /** execute function "get_nearby_appraisals" which returns "appraisals_public_view" */
  get_nearby_appraisals: Array<Appraisals_Public_View>;
  /** execute function "get_nearby_reviews" which returns "reviews" */
  get_nearby_reviews: Array<Reviews>;
  /** execute function "get_nearby_reviews" and query aggregates on result of table type "reviews" */
  get_nearby_reviews_aggregate: Reviews_Aggregate;
  /** execute function "get_nearby_transactions" which returns "property_transactions" */
  get_nearby_transactions: Array<Property_Transactions>;
  /** execute function "get_nearby_transactions" and query aggregates on result of table type "property_transactions" */
  get_nearby_transactions_aggregate: Property_Transactions_Aggregate;
  /** execute function "get_online_listing_map_data" which returns "online_listing_map_data" */
  get_online_listing_map_data: Array<Online_Listing_Map_Data>;
  /** execute function "get_online_listing_map_data" and query aggregates on result of table type "online_listing_map_data" */
  get_online_listing_map_data_aggregate: Online_Listing_Map_Data_Aggregate;
  /** execute function "get_similar_online_listings" which returns "online_listings" */
  get_similar_online_listings: Array<Online_Listings>;
  /** execute function "get_similar_online_listings" and query aggregates on result of table type "online_listings" */
  get_similar_online_listings_aggregate: Online_Listings_Aggregate;
  /** execute function "get_similar_online_listings_ids" which returns "similar_online_listings_ids" */
  get_similar_online_listings_ids: Array<Similar_Online_Listings_Ids>;
  /** execute function "get_similar_online_listings_ids" and query aggregates on result of table type "similar_online_listings_ids" */
  get_similar_online_listings_ids_aggregate: Similar_Online_Listings_Ids_Aggregate;
  /** execute function "get_similar_online_listings_vector" which returns "online_listings" */
  get_similar_online_listings_vector: Array<Online_Listings>;
  /** execute function "get_similar_online_listings_vector" and query aggregates on result of table type "online_listings" */
  get_similar_online_listings_vector_aggregate: Online_Listings_Aggregate;
  /** execute function "get_teams_ranking" which returns "teams_rankings" */
  get_teams_ranking: Array<Teams_Rankings>;
  /** execute function "get_teams_ranking" and query aggregates on result of table type "teams_rankings" */
  get_teams_ranking_aggregate: Teams_Rankings_Aggregate;
  /** execute function "global_statistics" which returns "global_stats" */
  global_statistics: Array<Global_Stats>;
  /** fetch data from the table: "global_stats" */
  global_stats: Array<Global_Stats>;
  /** fetch data from the table: "global_stats" using primary key columns */
  global_stats_by_pk?: Maybe<Global_Stats>;
  /** fetch data from the table in a streaming manner: "global_stats" */
  global_stats_stream: Array<Global_Stats>;
  /** fetch data from the table: "google_addresses" */
  google_addresses: Array<Google_Addresses>;
  /** An array relationship */
  google_reviews: Array<Google_Reviews>;
  /** An aggregate relationship */
  google_reviews_aggregate: Google_Reviews_Aggregate;
  /** fetch data from the table: "google_reviews" using primary key columns */
  google_reviews_by_pk?: Maybe<Google_Reviews>;
  /** fetch data from the table in a streaming manner: "google_reviews" */
  google_reviews_stream: Array<Google_Reviews>;
  /** fetch data from the table: "heating_distribution_enum" */
  heating_distribution_enum: Array<Heating_Distribution_Enum>;
  /** fetch data from the table: "heating_distribution_enum" using primary key columns */
  heating_distribution_enum_by_pk?: Maybe<Heating_Distribution_Enum>;
  /** fetch data from the table in a streaming manner: "heating_distribution_enum" */
  heating_distribution_enum_stream: Array<Heating_Distribution_Enum>;
  /** fetch data from the table: "heating_enum" */
  heating_enum: Array<Heating_Enum>;
  /** fetch data from the table: "heating_enum" using primary key columns */
  heating_enum_by_pk?: Maybe<Heating_Enum>;
  /** fetch data from the table in a streaming manner: "heating_enum" */
  heating_enum_stream: Array<Heating_Enum>;
  /** fetch data from the table: "images" */
  images: Array<Images>;
  /** fetch data from the table: "images" using primary key columns */
  images_by_pk?: Maybe<Images>;
  /** fetch data from the table in a streaming manner: "images" */
  images_stream: Array<Images>;
  /** fetch data from the table: "invitations" */
  invitations: Array<Invitations>;
  /** fetch aggregated fields from the table: "invitations" */
  invitations_aggregate: Invitations_Aggregate;
  /** fetch data from the table: "invitations" using primary key columns */
  invitations_by_pk?: Maybe<Invitations>;
  /** fetch data from the table in a streaming manner: "invitations" */
  invitations_stream: Array<Invitations>;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoices_aggregate: Invoices_Aggregate;
  /** fetch data from the table: "invoices" using primary key columns */
  invoices_by_pk?: Maybe<Invoices>;
  /** fetch data from the table in a streaming manner: "invoices" */
  invoices_stream: Array<Invoices>;
  /** fetch data from the table: "cma_listings" */
  it_cma_listings: Array<It_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  it_cma_listings_aggregate: It_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  it_cma_listings_by_pk?: Maybe<It_Cma_Listings>;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  it_get_merged_listings: Array<It_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  it_get_merged_listings_type: Array<It_Get_Merged_Listings_Type>;
  /** execute function "get_similar_listings" which returns "post_merged_listings" */
  it_get_similar_listings: Array<It_Post_Merged_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "post_merged_listings" */
  it_get_similar_listings_aggregate: It_Post_Merged_Listings_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "post_merged_listings" */
  it_get_similar_listings_vector: Array<It_Post_Merged_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "post_merged_listings" */
  it_get_similar_listings_vector_aggregate: It_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_images" */
  it_merged_images: Array<It_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  it_merged_images_aggregate: It_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  it_merged_listings: Array<It_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  it_merged_listings_aggregate: It_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  it_merged_listings_by_pk?: Maybe<It_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  it_merged_listings_compare: Array<It_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  it_merged_listings_compare_aggregate: It_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  it_places: Array<It_Places>;
  /** fetch aggregated fields from the table: "places" */
  it_places_aggregate: It_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  it_places_breadcrumbs: Array<It_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  it_places_breadcrumbs_aggregate: It_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  it_places_by_pk?: Maybe<It_Places>;
  /** fetch data from the table: "post_merged_listings" */
  it_post_merged_listings: Array<It_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  it_post_merged_listings_aggregate: It_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  it_post_merged_listings_by_pk?: Maybe<It_Post_Merged_Listings>;
  /** fetch data from the table: "property_types" */
  it_property_types: Array<It_Property_Types>;
  /** execute function "search_places_with_index" which returns "places" */
  it_search_places_with_index: Array<It_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  it_search_places_with_index_aggregate: It_Places_Aggregate;
  /** An array relationship */
  lead_agents: Array<Lead_Agents>;
  /** An aggregate relationship */
  lead_agents_aggregate: Lead_Agents_Aggregate;
  /** fetch data from the table: "lead_agents" using primary key columns */
  lead_agents_by_pk?: Maybe<Lead_Agents>;
  /** fetch data from the table in a streaming manner: "lead_agents" */
  lead_agents_stream: Array<Lead_Agents>;
  /** fetch data from the table: "lead_stages" */
  lead_stages: Array<Lead_Stages>;
  /** fetch aggregated fields from the table: "lead_stages" */
  lead_stages_aggregate: Lead_Stages_Aggregate;
  /** fetch data from the table: "lead_stages" using primary key columns */
  lead_stages_by_pk?: Maybe<Lead_Stages>;
  /** fetch data from the table in a streaming manner: "lead_stages" */
  lead_stages_stream: Array<Lead_Stages>;
  /** An array relationship */
  leads: Array<Leads>;
  /** An aggregate relationship */
  leads_aggregate: Leads_Aggregate;
  /** fetch data from the table: "leads" using primary key columns */
  leads_by_pk?: Maybe<Leads>;
  /** fetch data from the table: "leads_status" */
  leads_status: Array<Leads_Status>;
  /** fetch data from the table: "leads_status" using primary key columns */
  leads_status_by_pk?: Maybe<Leads_Status>;
  /** fetch data from the table in a streaming manner: "leads_status" */
  leads_status_stream: Array<Leads_Status>;
  /** fetch data from the table in a streaming manner: "leads" */
  leads_stream: Array<Leads>;
  /** An array relationship */
  leads_tags: Array<Leads_Tags>;
  /** An aggregate relationship */
  leads_tags_aggregate: Leads_Tags_Aggregate;
  /** fetch data from the table: "leads_tags" using primary key columns */
  leads_tags_by_pk?: Maybe<Leads_Tags>;
  /** fetch data from the table in a streaming manner: "leads_tags" */
  leads_tags_stream: Array<Leads_Tags>;
  /** An array relationship */
  logins: Array<Logins>;
  /** fetch data from the table in a streaming manner: "logins" */
  logins_stream: Array<Logins>;
  /** An array relationship */
  lot_reference_aliases: Array<Lot_Reference_Aliases>;
  /** fetch data from the table: "lot_reference_aliases" using primary key columns */
  lot_reference_aliases_by_pk?: Maybe<Lot_Reference_Aliases>;
  /** fetch data from the table in a streaming manner: "lot_reference_aliases" */
  lot_reference_aliases_stream: Array<Lot_Reference_Aliases>;
  /** An array relationship */
  lot_sellers: Array<Lot_Sellers>;
  /** An aggregate relationship */
  lot_sellers_aggregate: Lot_Sellers_Aggregate;
  /** fetch data from the table in a streaming manner: "lot_sellers" */
  lot_sellers_stream: Array<Lot_Sellers>;
  /** An array relationship */
  lots: Array<Lots>;
  /** An aggregate relationship */
  lots_aggregate: Lots_Aggregate;
  /** fetch data from the table: "lots" using primary key columns */
  lots_by_pk?: Maybe<Lots>;
  /** fetch data from the table: "lots_status_enum" */
  lots_status_enum: Array<Lots_Status_Enum>;
  /** fetch data from the table: "lots_status_enum" using primary key columns */
  lots_status_enum_by_pk?: Maybe<Lots_Status_Enum>;
  /** fetch data from the table in a streaming manner: "lots_status_enum" */
  lots_status_enum_stream: Array<Lots_Status_Enum>;
  /** fetch data from the table in a streaming manner: "lots" */
  lots_stream: Array<Lots>;
  /** execute function "me" which returns "users" */
  me?: Maybe<Users>;
  /** execute function "me" and query aggregates on result of table type "users" */
  me_aggregate: Users_Aggregate;
  /** fetch data from the table: "mls_lots" */
  mls_lots: Array<Mls_Lots>;
  /** fetch aggregated fields from the table: "mls_lots" */
  mls_lots_aggregate: Mls_Lots_Aggregate;
  /** fetch data from the table in a streaming manner: "mls_lots" */
  mls_lots_stream: Array<Mls_Lots>;
  /** fetch data from the table: "mls_properties" */
  mls_properties: Array<Mls_Properties>;
  /** fetch data from the table in a streaming manner: "mls_properties" */
  mls_properties_stream: Array<Mls_Properties>;
  /** fetch data from the table: "nylas_account_configs" */
  nylas_account_configs: Array<Nylas_Account_Configs>;
  /** fetch data from the table: "nylas_account_configs" using primary key columns */
  nylas_account_configs_by_pk?: Maybe<Nylas_Account_Configs>;
  /** fetch data from the table in a streaming manner: "nylas_account_configs" */
  nylas_account_configs_stream: Array<Nylas_Account_Configs>;
  /** An array relationship */
  offers: Array<Offers>;
  /** An aggregate relationship */
  offers_aggregate: Offers_Aggregate;
  /** fetch data from the table: "offers" using primary key columns */
  offers_by_pk?: Maybe<Offers>;
  /** fetch data from the table in a streaming manner: "offers" */
  offers_stream: Array<Offers>;
  /** fetch data from the table: "online_listing_map_data" */
  online_listing_map_data: Array<Online_Listing_Map_Data>;
  /** fetch aggregated fields from the table: "online_listing_map_data" */
  online_listing_map_data_aggregate: Online_Listing_Map_Data_Aggregate;
  /** fetch data from the table: "online_listings" */
  online_listings: Array<Online_Listings>;
  /** fetch aggregated fields from the table: "online_listings" */
  online_listings_aggregate: Online_Listings_Aggregate;
  /** fetch data from the table: "online_listings" using primary key columns */
  online_listings_by_pk?: Maybe<Online_Listings>;
  /** An array relationship */
  organisation_images: Array<Organisation_Images>;
  /** fetch data from the table in a streaming manner: "organisation_images" */
  organisation_images_stream: Array<Organisation_Images>;
  /** An array relationship */
  organisation_users: Array<Organisation_Users>;
  /** fetch data from the table in a streaming manner: "organisation_users" */
  organisation_users_stream: Array<Organisation_Users>;
  /** fetch data from the table: "organisations" */
  organisations: Array<Organisations>;
  /** fetch aggregated fields from the table: "organisations" */
  organisations_aggregate: Organisations_Aggregate;
  /** fetch data from the table: "organisations" using primary key columns */
  organisations_by_pk?: Maybe<Organisations>;
  /** execute function "organisations_search" which returns "organisations" */
  organisations_search: Array<Organisations>;
  /** execute function "organisations_search" and query aggregates on result of table type "organisations" */
  organisations_search_aggregate: Organisations_Aggregate;
  /** fetch data from the table in a streaming manner: "organisations" */
  organisations_stream: Array<Organisations>;
  /** An array relationship */
  payments: Array<Payments>;
  /** fetch data from the table: "payments" using primary key columns */
  payments_by_pk?: Maybe<Payments>;
  /** fetch data from the table in a streaming manner: "payments" */
  payments_stream: Array<Payments>;
  /** fetch data from the table: "phone_number_type_enum" */
  phone_number_type_enum: Array<Phone_Number_Type_Enum>;
  /** fetch data from the table: "phone_number_type_enum" using primary key columns */
  phone_number_type_enum_by_pk?: Maybe<Phone_Number_Type_Enum>;
  /** fetch data from the table in a streaming manner: "phone_number_type_enum" */
  phone_number_type_enum_stream: Array<Phone_Number_Type_Enum>;
  /** An array relationship */
  phone_numbers: Array<Phone_Numbers>;
  /** An aggregate relationship */
  phone_numbers_aggregate: Phone_Numbers_Aggregate;
  /** fetch data from the table: "phone_numbers" using primary key columns */
  phone_numbers_by_pk?: Maybe<Phone_Numbers>;
  /** fetch data from the table in a streaming manner: "phone_numbers" */
  phone_numbers_stream: Array<Phone_Numbers>;
  /** fetch data from the table: "pipelines" */
  pipelines: Array<Pipelines>;
  /** fetch aggregated fields from the table: "pipelines" */
  pipelines_aggregate: Pipelines_Aggregate;
  /** fetch data from the table: "pipelines" using primary key columns */
  pipelines_by_pk?: Maybe<Pipelines>;
  /** fetch data from the table in a streaming manner: "pipelines" */
  pipelines_stream: Array<Pipelines>;
  /** execute function "place_by_slug" which returns "places" */
  place_by_slug?: Maybe<Places>;
  /** execute function "place_by_type" which returns "places" */
  place_by_type: Array<Places>;
  /** fetch data from the table: "places" */
  places: Array<Places>;
  /** execute function "places_agent_ranking" which returns "agents_rankings" */
  places_agent_ranking: Array<Agents_Rankings>;
  /** execute function "places_agent_ranking" and query aggregates on result of table type "agents_rankings" */
  places_agent_ranking_aggregate: Agents_Rankings_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  places_by_pk?: Maybe<Places>;
  /** fetch data from the table in a streaming manner: "places" */
  places_stream: Array<Places>;
  /** An array relationship */
  portal_listings: Array<Portal_Listings>;
  /** An aggregate relationship */
  portal_listings_aggregate: Portal_Listings_Aggregate;
  /** fetch data from the table: "portal_listings" using primary key columns */
  portal_listings_by_pk?: Maybe<Portal_Listings>;
  /** fetch data from the table in a streaming manner: "portal_listings" */
  portal_listings_stream: Array<Portal_Listings>;
  /** fetch data from the table: "portals" */
  portals: Array<Portals>;
  /** fetch aggregated fields from the table: "portals" */
  portals_aggregate: Portals_Aggregate;
  /** fetch data from the table: "portals" using primary key columns */
  portals_by_pk?: Maybe<Portals>;
  /** fetch data from the table in a streaming manner: "portals" */
  portals_stream: Array<Portals>;
  /** fetch data from the table: "portals_types_enum" */
  portals_types_enum: Array<Portals_Types_Enum>;
  /** fetch data from the table: "portals_types_enum" using primary key columns */
  portals_types_enum_by_pk?: Maybe<Portals_Types_Enum>;
  /** fetch data from the table in a streaming manner: "portals_types_enum" */
  portals_types_enum_stream: Array<Portals_Types_Enum>;
  /** fetch data from the table: "properties" */
  properties: Array<Properties>;
  /** fetch data from the table: "properties" using primary key columns */
  properties_by_pk?: Maybe<Properties>;
  /** fetch data from the table in a streaming manner: "properties" */
  properties_stream: Array<Properties>;
  /** An array relationship */
  property_files: Array<Property_Files>;
  /** An aggregate relationship */
  property_files_aggregate: Property_Files_Aggregate;
  /** fetch data from the table in a streaming manner: "property_files" */
  property_files_stream: Array<Property_Files>;
  /** An array relationship */
  property_images: Array<Property_Images>;
  /** An aggregate relationship */
  property_images_aggregate: Property_Images_Aggregate;
  /** fetch data from the table: "property_images" using primary key columns */
  property_images_by_pk?: Maybe<Property_Images>;
  /** fetch data from the table in a streaming manner: "property_images" */
  property_images_stream: Array<Property_Images>;
  /** fetch data from the table: "property_search_aggregator_source" */
  property_search_aggregator_source: Array<Property_Search_Aggregator_Source>;
  /** fetch data from the table: "property_search_aggregator_source" using primary key columns */
  property_search_aggregator_source_by_pk?: Maybe<Property_Search_Aggregator_Source>;
  /** fetch data from the table in a streaming manner: "property_search_aggregator_source" */
  property_search_aggregator_source_stream: Array<Property_Search_Aggregator_Source>;
  /** fetch data from the table: "property_search_source" */
  property_search_source: Array<Property_Search_Source>;
  /** fetch data from the table: "property_search_source" using primary key columns */
  property_search_source_by_pk?: Maybe<Property_Search_Source>;
  /** fetch data from the table in a streaming manner: "property_search_source" */
  property_search_source_stream: Array<Property_Search_Source>;
  /** An array relationship */
  property_searches: Array<Property_Searches>;
  /** An aggregate relationship */
  property_searches_aggregate: Property_Searches_Aggregate;
  /** fetch data from the table: "property_searches" using primary key columns */
  property_searches_by_pk?: Maybe<Property_Searches>;
  /** An array relationship */
  property_searches_places: Array<Property_Searches_Places>;
  /** fetch data from the table: "property_searches_places" using primary key columns */
  property_searches_places_by_pk?: Maybe<Property_Searches_Places>;
  /** fetch data from the table in a streaming manner: "property_searches_places" */
  property_searches_places_stream: Array<Property_Searches_Places>;
  /** fetch data from the table in a streaming manner: "property_searches" */
  property_searches_stream: Array<Property_Searches>;
  /** An array relationship */
  property_transactions: Array<Property_Transactions>;
  /** An aggregate relationship */
  property_transactions_aggregate: Property_Transactions_Aggregate;
  /** fetch data from the table: "property_transactions" using primary key columns */
  property_transactions_by_pk?: Maybe<Property_Transactions>;
  /** An array relationship */
  property_transactions_listings: Array<Property_Transactions_Listings>;
  /** fetch data from the table: "property_transactions_listings" using primary key columns */
  property_transactions_listings_by_pk?: Maybe<Property_Transactions_Listings>;
  /** fetch data from the table in a streaming manner: "property_transactions_listings" */
  property_transactions_listings_stream: Array<Property_Transactions_Listings>;
  /** fetch data from the table in a streaming manner: "property_transactions" */
  property_transactions_stream: Array<Property_Transactions>;
  /** fetch data from the table: "property_types" */
  property_types: Array<Property_Types>;
  /** fetch aggregated fields from the table: "property_types" */
  property_types_aggregate: Property_Types_Aggregate;
  /** fetch data from the table: "property_types" using primary key columns */
  property_types_by_pk?: Maybe<Property_Types>;
  /** fetch data from the table in a streaming manner: "property_types" */
  property_types_stream: Array<Property_Types>;
  /** An array relationship */
  push_notification_tokens: Array<Push_Notification_Tokens>;
  /** fetch data from the table: "push_notification_tokens" using primary key columns */
  push_notification_tokens_by_pk?: Maybe<Push_Notification_Tokens>;
  /** fetch data from the table in a streaming manner: "push_notification_tokens" */
  push_notification_tokens_stream: Array<Push_Notification_Tokens>;
  /** fetch data from the table: "read_only_tenants" */
  read_only_tenants: Array<Read_Only_Tenants>;
  /** fetch data from the table in a streaming manner: "read_only_tenants" */
  read_only_tenants_stream: Array<Read_Only_Tenants>;
  /** An array relationship */
  reviews: Array<Reviews>;
  /** An aggregate relationship */
  reviews_aggregate: Reviews_Aggregate;
  /** fetch data from the table: "reviews" using primary key columns */
  reviews_by_pk?: Maybe<Reviews>;
  /** fetch data from the table in a streaming manner: "reviews" */
  reviews_stream: Array<Reviews>;
  /** execute function "search_brockers_in_catchment_area" which returns "users" */
  search_brockers_in_catchment_area: Array<Users>;
  /** execute function "search_brockers_in_catchment_area" and query aggregates on result of table type "users" */
  search_brockers_in_catchment_area_aggregate: Users_Aggregate;
  /** execute function "search_leads" which returns "leads" */
  search_leads: Array<Leads>;
  /** execute function "search_leads" and query aggregates on result of table type "leads" */
  search_leads_aggregate: Leads_Aggregate;
  /** execute function "search_leads_tsv" which returns "leads" */
  search_leads_tsv: Array<Leads>;
  /** execute function "search_leads_tsv" and query aggregates on result of table type "leads" */
  search_leads_tsv_aggregate: Leads_Aggregate;
  /** execute function "search_lots_tsv" which returns "lots" */
  search_lots_tsv: Array<Lots>;
  /** execute function "search_lots_tsv" and query aggregates on result of table type "lots" */
  search_lots_tsv_aggregate: Lots_Aggregate;
  /** execute function "search_places" which returns "places" */
  search_places: Array<Places>;
  /** execute function "search_places_ex" which returns "places" */
  search_places_ex: Array<Places>;
  /** execute function "search_property_transactions_tsv" which returns "property_transactions" */
  search_property_transactions_tsv: Array<Property_Transactions>;
  /** execute function "search_property_transactions_tsv" and query aggregates on result of table type "property_transactions" */
  search_property_transactions_tsv_aggregate: Property_Transactions_Aggregate;
  /** execute function "search_teams_tsv" which returns "teams" */
  search_teams_tsv: Array<Teams>;
  /** execute function "search_teams_tsv" and query aggregates on result of table type "teams" */
  search_teams_tsv_aggregate: Teams_Aggregate;
  /** execute function "search_users" which returns "users" */
  search_users: Array<Users>;
  /** execute function "search_users" and query aggregates on result of table type "users" */
  search_users_aggregate: Users_Aggregate;
  /** execute function "search_users_tsv" which returns "users" */
  search_users_tsv: Array<Users>;
  /** execute function "search_users_tsv" and query aggregates on result of table type "users" */
  search_users_tsv_aggregate: Users_Aggregate;
  /** fetch data from the table: "shared_portals" */
  shared_portals: Array<Shared_Portals>;
  /** fetch aggregated fields from the table: "shared_portals" */
  shared_portals_aggregate: Shared_Portals_Aggregate;
  /** fetch data from the table in a streaming manner: "shared_portals" */
  shared_portals_stream: Array<Shared_Portals>;
  /** fetch data from the table: "similar_online_listings_ids" */
  similar_online_listings_ids: Array<Similar_Online_Listings_Ids>;
  /** fetch aggregated fields from the table: "similar_online_listings_ids" */
  similar_online_listings_ids_aggregate: Similar_Online_Listings_Ids_Aggregate;
  /** fetch data from the table: "smart_lists" */
  smart_lists: Array<Smart_Lists>;
  /** fetch data from the table: "smart_lists" using primary key columns */
  smart_lists_by_pk?: Maybe<Smart_Lists>;
  /** fetch data from the table in a streaming manner: "smart_lists" */
  smart_lists_stream: Array<Smart_Lists>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  /** fetch data from the table: "subscriptions" using primary key columns */
  subscriptions_by_pk?: Maybe<Subscriptions>;
  /** fetch data from the table in a streaming manner: "subscriptions" */
  subscriptions_stream: Array<Subscriptions>;
  /** An array relationship */
  team_images: Array<Team_Images>;
  /** fetch data from the table: "team_images" using primary key columns */
  team_images_by_pk?: Maybe<Team_Images>;
  /** fetch data from the table in a streaming manner: "team_images" */
  team_images_stream: Array<Team_Images>;
  /** An array relationship */
  teams: Array<Teams>;
  /** An aggregate relationship */
  teams_aggregate: Teams_Aggregate;
  /** fetch data from the table: "teams" using primary key columns */
  teams_by_pk?: Maybe<Teams>;
  /** An array relationship */
  teams_portals: Array<Teams_Portals>;
  /** fetch data from the table: "teams_portals" using primary key columns */
  teams_portals_by_pk?: Maybe<Teams_Portals>;
  /** fetch data from the table in a streaming manner: "teams_portals" */
  teams_portals_stream: Array<Teams_Portals>;
  /** fetch data from the table in a streaming manner: "teams" */
  teams_stream: Array<Teams>;
  /** An array relationship */
  teams_users: Array<Teams_Users>;
  /** An aggregate relationship */
  teams_users_aggregate: Teams_Users_Aggregate;
  /** fetch data from the table in a streaming manner: "teams_users" */
  teams_users_stream: Array<Teams_Users>;
  /** fetch data from the table: "tenants" */
  tenants: Array<Tenants>;
  /** fetch aggregated fields from the table: "tenants" */
  tenants_aggregate: Tenants_Aggregate;
  /** fetch data from the table: "tenants" using primary key columns */
  tenants_by_pk?: Maybe<Tenants>;
  /** fetch data from the table in a streaming manner: "tenants" */
  tenants_stream: Array<Tenants>;
  /** An array relationship */
  user_images: Array<User_Images>;
  /** fetch data from the table: "user_images" using primary key columns */
  user_images_by_pk?: Maybe<User_Images>;
  /** fetch data from the table in a streaming manner: "user_images" */
  user_images_stream: Array<User_Images>;
  /** execute function "user_primary_phone" which returns "phone_numbers" */
  user_primary_phone: Array<Phone_Numbers>;
  /** execute function "user_primary_phone" and query aggregates on result of table type "phone_numbers" */
  user_primary_phone_aggregate: Phone_Numbers_Aggregate;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** An array relationship */
  users_listings: Array<Users_Listings>;
  /** An aggregate relationship */
  users_listings_aggregate: Users_Listings_Aggregate;
  /** fetch data from the table: "users_listings" using primary key columns */
  users_listings_by_pk?: Maybe<Users_Listings>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** fetch data from the table: "valuation_models" */
  valuation_models: Array<Valuation_Models>;
  /** fetch data from the table: "valuation_models" using primary key columns */
  valuation_models_by_pk?: Maybe<Valuation_Models>;
  /** fetch data from the table in a streaming manner: "valuation_models" */
  valuation_models_stream: Array<Valuation_Models>;
  /** An array relationship */
  valuations: Array<Valuations>;
  /** fetch data from the table: "valuations" using primary key columns */
  valuations_by_pk?: Maybe<Valuations>;
  /** fetch data from the table in a streaming manner: "valuations" */
  valuations_stream: Array<Valuations>;
};


export type Subscription_RootActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Subscription_RootActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Subscription_RootActivities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootActivities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Activities_Stream_Cursor_Input>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Subscription_RootAddress_Display_Options_EnumArgs = {
  distinct_on?: InputMaybe<Array<Address_Display_Options_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Display_Options_Enum_Order_By>>;
  where?: InputMaybe<Address_Display_Options_Enum_Bool_Exp>;
};


export type Subscription_RootAddress_Display_Options_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootAddress_Display_Options_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Address_Display_Options_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Display_Options_Enum_Bool_Exp>;
};


export type Subscription_RootAgent_StatisticsArgs = {
  args: Agent_Statistics_Args;
  distinct_on?: InputMaybe<Array<Agent_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Stats_Order_By>>;
  where?: InputMaybe<Agent_Stats_Bool_Exp>;
};


export type Subscription_RootAgent_StatsArgs = {
  distinct_on?: InputMaybe<Array<Agent_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Stats_Order_By>>;
  where?: InputMaybe<Agent_Stats_Bool_Exp>;
};


export type Subscription_RootAgent_Stats_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootAgent_Stats_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agent_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<Agent_Stats_Bool_Exp>;
};


export type Subscription_RootAppraisalsArgs = {
  distinct_on?: InputMaybe<Array<Appraisals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appraisals_Order_By>>;
  where?: InputMaybe<Appraisals_Bool_Exp>;
};


export type Subscription_RootAppraisals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAppraisals_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Appraisals_Stream_Cursor_Input>>;
  where?: InputMaybe<Appraisals_Bool_Exp>;
};


export type Subscription_RootBuyer_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


export type Subscription_RootBuyer_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


export type Subscription_RootBuyer_Leads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBuyer_Leads_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Buyer_Leads_Stream_Cursor_Input>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


export type Subscription_RootCatchment_AreasArgs = {
  distinct_on?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Catchment_Areas_Order_By>>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};


export type Subscription_RootCatchment_Areas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Catchment_Areas_Order_By>>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};


export type Subscription_RootCatchment_Areas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Catchment_Areas_Stream_Cursor_Input>>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};


export type Subscription_RootCh_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Subscription_RootCh_Get_Buy_Rent_ListingsArgs = {
  args: Get_Buy_Rent_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Get_Buy_Rent_Listings_AggregateArgs = {
  args: Get_Buy_Rent_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Ch_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootCh_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Ch_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootCh_Get_Place_By_SlugArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Subscription_RootCh_Get_Place_By_Slug_AggregateArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Subscription_RootCh_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Ch_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Ch_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


export type Subscription_RootCh_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


export type Subscription_RootCh_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCh_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Subscription_RootCh_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Subscription_RootCh_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Ch_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootCh_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Ch_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootCh_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCh_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCh_Price_Stats_QuantilesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Quantiles_Bool_Exp>;
};


export type Subscription_RootCh_Price_Stats_Quantiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Quantiles_Bool_Exp>;
};


export type Subscription_RootCh_Price_Stats_Quantiles_By_PkArgs = {
  place_id: Scalars['uuid']['input'];
  property_main_type: Scalars['String']['input'];
};


export type Subscription_RootCh_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Property_Types_Order_By>>;
  where?: InputMaybe<Ch_Property_Types_Bool_Exp>;
};


export type Subscription_RootCh_Search_PlacesArgs = {
  args: Search_Places_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Subscription_RootCh_Search_Places_AggregateArgs = {
  args: Search_Places_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Subscription_RootCh_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Subscription_RootCh_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Subscription_RootCma_Report_FilesArgs = {
  distinct_on?: InputMaybe<Array<Cma_Report_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Report_Files_Order_By>>;
  where?: InputMaybe<Cma_Report_Files_Bool_Exp>;
};


export type Subscription_RootCma_Report_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cma_Report_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Report_Files_Order_By>>;
  where?: InputMaybe<Cma_Report_Files_Bool_Exp>;
};


export type Subscription_RootCma_Report_Files_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cma_Report_Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Cma_Report_Files_Bool_Exp>;
};


export type Subscription_RootCma_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Order_By>>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};


export type Subscription_RootCma_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Order_By>>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};


export type Subscription_RootCma_Reports_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCma_Reports_ComparablesArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Comparables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Comparables_Order_By>>;
  where?: InputMaybe<Cma_Reports_Comparables_Bool_Exp>;
};


export type Subscription_RootCma_Reports_Comparables_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cma_Reports_Comparables_Stream_Cursor_Input>>;
  where?: InputMaybe<Cma_Reports_Comparables_Bool_Exp>;
};


export type Subscription_RootCma_Reports_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cma_Reports_Stream_Cursor_Input>>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};


export type Subscription_RootCombined_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Combined_Reviews_Order_By>>;
  where?: InputMaybe<Combined_Reviews_Bool_Exp>;
};


export type Subscription_RootCombined_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Combined_Reviews_Order_By>>;
  where?: InputMaybe<Combined_Reviews_Bool_Exp>;
};


export type Subscription_RootCombined_Reviews_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Combined_Reviews_Stream_Cursor_Input>>;
  where?: InputMaybe<Combined_Reviews_Bool_Exp>;
};


export type Subscription_RootCooling_EnumArgs = {
  distinct_on?: InputMaybe<Array<Cooling_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cooling_Enum_Order_By>>;
  where?: InputMaybe<Cooling_Enum_Bool_Exp>;
};


export type Subscription_RootCooling_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootCooling_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cooling_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Cooling_Enum_Bool_Exp>;
};


export type Subscription_RootCountriesArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Subscription_RootCountries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCountries_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Countries_Stream_Cursor_Input>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Subscription_RootDevelopmentsArgs = {
  distinct_on?: InputMaybe<Array<Developments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Developments_Order_By>>;
  where?: InputMaybe<Developments_Bool_Exp>;
};


export type Subscription_RootDevelopments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDevelopments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Developments_Stream_Cursor_Input>>;
  where?: InputMaybe<Developments_Bool_Exp>;
};


export type Subscription_RootDictionariesArgs = {
  distinct_on?: InputMaybe<Array<Dictionaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dictionaries_Order_By>>;
  where?: InputMaybe<Dictionaries_Bool_Exp>;
};


export type Subscription_RootDictionaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDictionaries_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dictionaries_Stream_Cursor_Input>>;
  where?: InputMaybe<Dictionaries_Bool_Exp>;
};


export type Subscription_RootDictionaries_Types_EnumArgs = {
  distinct_on?: InputMaybe<Array<Dictionaries_Types_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dictionaries_Types_Enum_Order_By>>;
  where?: InputMaybe<Dictionaries_Types_Enum_Bool_Exp>;
};


export type Subscription_RootDictionaries_Types_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootDictionaries_Types_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dictionaries_Types_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Dictionaries_Types_Enum_Bool_Exp>;
};


export type Subscription_RootDoc_Template_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Doc_Template_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Template_Type_Enum_Order_By>>;
  where?: InputMaybe<Doc_Template_Type_Enum_Bool_Exp>;
};


export type Subscription_RootDoc_Template_Type_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootDoc_Template_Type_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Doc_Template_Type_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Doc_Template_Type_Enum_Bool_Exp>;
};


export type Subscription_RootDoc_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Doc_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Templates_Order_By>>;
  where?: InputMaybe<Doc_Templates_Bool_Exp>;
};


export type Subscription_RootDoc_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDoc_Templates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Doc_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Doc_Templates_Bool_Exp>;
};


export type Subscription_RootDoc_Templates_TenantsArgs = {
  distinct_on?: InputMaybe<Array<Doc_Templates_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Templates_Tenants_Order_By>>;
  where?: InputMaybe<Doc_Templates_Tenants_Bool_Exp>;
};


export type Subscription_RootDoc_Templates_Tenants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDoc_Templates_Tenants_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Doc_Templates_Tenants_Stream_Cursor_Input>>;
  where?: InputMaybe<Doc_Templates_Tenants_Bool_Exp>;
};


export type Subscription_RootEmail_SequencesArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Order_By>>;
  where?: InputMaybe<Email_Sequences_Bool_Exp>;
};


export type Subscription_RootEmail_Sequences_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEmail_Sequences_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Recipients_Order_By>>;
  where?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
};


export type Subscription_RootEmail_Sequences_Recipients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Recipients_Order_By>>;
  where?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
};


export type Subscription_RootEmail_Sequences_Recipients_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEmail_Sequences_Recipients_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Email_Sequences_Recipients_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
};


export type Subscription_RootEmail_Sequences_StepsArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Steps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Steps_Order_By>>;
  where?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
};


export type Subscription_RootEmail_Sequences_Steps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Steps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Steps_Order_By>>;
  where?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
};


export type Subscription_RootEmail_Sequences_Steps_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEmail_Sequences_Steps_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Email_Sequences_Steps_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
};


export type Subscription_RootEmail_Sequences_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Email_Sequences_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Sequences_Bool_Exp>;
};


export type Subscription_RootEmail_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Templates_Order_By>>;
  where?: InputMaybe<Email_Templates_Bool_Exp>;
};


export type Subscription_RootEmail_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEmail_Templates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Email_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Templates_Bool_Exp>;
};


export type Subscription_RootEmailsArgs = {
  distinct_on?: InputMaybe<Array<Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emails_Order_By>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


export type Subscription_RootEmails_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEmails_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Emails_Stream_Cursor_Input>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


export type Subscription_RootEnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


export type Subscription_RootEnquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


export type Subscription_RootEnquiries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEnquiries_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enquiries_Stream_Cursor_Input>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


export type Subscription_RootEs_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Subscription_RootEs_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Es_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootEs_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Es_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootEs_Get_Place_By_SlugArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Subscription_RootEs_Get_Place_By_Slug_AggregateArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Subscription_RootEs_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Es_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Es_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Es_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Es_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


export type Subscription_RootEs_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


export type Subscription_RootEs_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootEs_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Es_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Es_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootEs_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Subscription_RootEs_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Subscription_RootEs_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Es_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootEs_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Es_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootEs_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEs_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Es_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootEs_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<Es_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Property_Types_Order_By>>;
  where?: InputMaybe<Es_Property_Types_Bool_Exp>;
};


export type Subscription_RootEs_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Subscription_RootEs_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Subscription_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFiles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFinancing_StatisticsArgs = {
  args: Financing_Statistics_Args;
  distinct_on?: InputMaybe<Array<Financing_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Financing_Stats_Order_By>>;
  where?: InputMaybe<Financing_Stats_Bool_Exp>;
};


export type Subscription_RootFinancing_StatsArgs = {
  distinct_on?: InputMaybe<Array<Financing_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Financing_Stats_Order_By>>;
  where?: InputMaybe<Financing_Stats_Bool_Exp>;
};


export type Subscription_RootFinancing_Stats_By_PkArgs = {
  date: Scalars['date']['input'];
};


export type Subscription_RootFinancing_Stats_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Financing_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<Financing_Stats_Bool_Exp>;
};


export type Subscription_RootFind_Price_Map_PlacesArgs = {
  args: Find_Price_Map_Places_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootFr_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Subscription_RootFr_Get_Buy_Rent_ListingsArgs = {
  args: Get_Buy_Rent_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Get_Buy_Rent_Listings_AggregateArgs = {
  args: Get_Buy_Rent_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Fr_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootFr_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Fr_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootFr_Get_Place_By_SlugArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Subscription_RootFr_Get_Place_By_Slug_AggregateArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Subscription_RootFr_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Fr_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Fr_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


export type Subscription_RootFr_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


export type Subscription_RootFr_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootFr_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Subscription_RootFr_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Subscription_RootFr_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Fr_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootFr_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Fr_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootFr_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFr_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootFr_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Property_Types_Order_By>>;
  where?: InputMaybe<Fr_Property_Types_Bool_Exp>;
};


export type Subscription_RootFr_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Subscription_RootFr_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Subscription_RootGet_Agents_RankingArgs = {
  args?: InputMaybe<Get_Agents_Ranking_Args>;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Subscription_RootGet_Agents_Ranking_AggregateArgs = {
  args?: InputMaybe<Get_Agents_Ranking_Args>;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Subscription_RootGet_Appraisals_By_SlugArgs = {
  args: Get_Appraisals_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Appraisals_Public_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appraisals_Public_View_Order_By>>;
  where?: InputMaybe<Appraisals_Public_View_Bool_Exp>;
};


export type Subscription_RootGet_Catchment_AreaArgs = {
  args: Get_Catchment_Area_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootGet_Nearby_AppraisalsArgs = {
  args: Get_Nearby_Appraisals_Args;
  distinct_on?: InputMaybe<Array<Appraisals_Public_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appraisals_Public_View_Order_By>>;
  where?: InputMaybe<Appraisals_Public_View_Bool_Exp>;
};


export type Subscription_RootGet_Nearby_ReviewsArgs = {
  args: Get_Nearby_Reviews_Args;
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Subscription_RootGet_Nearby_Reviews_AggregateArgs = {
  args: Get_Nearby_Reviews_Args;
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Subscription_RootGet_Nearby_TransactionsArgs = {
  args: Get_Nearby_Transactions_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Subscription_RootGet_Nearby_Transactions_AggregateArgs = {
  args: Get_Nearby_Transactions_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Subscription_RootGet_Online_Listing_Map_DataArgs = {
  args: Get_Online_Listing_Map_Data_Args;
  distinct_on?: InputMaybe<Array<Online_Listing_Map_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listing_Map_Data_Order_By>>;
  where?: InputMaybe<Online_Listing_Map_Data_Bool_Exp>;
};


export type Subscription_RootGet_Online_Listing_Map_Data_AggregateArgs = {
  args: Get_Online_Listing_Map_Data_Args;
  distinct_on?: InputMaybe<Array<Online_Listing_Map_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listing_Map_Data_Order_By>>;
  where?: InputMaybe<Online_Listing_Map_Data_Bool_Exp>;
};


export type Subscription_RootGet_Similar_Online_ListingsArgs = {
  args: Get_Similar_Online_Listings_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Subscription_RootGet_Similar_Online_Listings_AggregateArgs = {
  args: Get_Similar_Online_Listings_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Subscription_RootGet_Similar_Online_Listings_IdsArgs = {
  args: Get_Similar_Online_Listings_Ids_Args;
  distinct_on?: InputMaybe<Array<Similar_Online_Listings_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Online_Listings_Ids_Order_By>>;
  where?: InputMaybe<Similar_Online_Listings_Ids_Bool_Exp>;
};


export type Subscription_RootGet_Similar_Online_Listings_Ids_AggregateArgs = {
  args: Get_Similar_Online_Listings_Ids_Args;
  distinct_on?: InputMaybe<Array<Similar_Online_Listings_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Online_Listings_Ids_Order_By>>;
  where?: InputMaybe<Similar_Online_Listings_Ids_Bool_Exp>;
};


export type Subscription_RootGet_Similar_Online_Listings_VectorArgs = {
  args: Get_Similar_Online_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Subscription_RootGet_Similar_Online_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Online_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Subscription_RootGet_Teams_RankingArgs = {
  args?: InputMaybe<Get_Teams_Ranking_Args>;
  distinct_on?: InputMaybe<Array<Teams_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Rankings_Order_By>>;
  where?: InputMaybe<Teams_Rankings_Bool_Exp>;
};


export type Subscription_RootGet_Teams_Ranking_AggregateArgs = {
  args?: InputMaybe<Get_Teams_Ranking_Args>;
  distinct_on?: InputMaybe<Array<Teams_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Rankings_Order_By>>;
  where?: InputMaybe<Teams_Rankings_Bool_Exp>;
};


export type Subscription_RootGlobal_StatisticsArgs = {
  args: Global_Statistics_Args;
  distinct_on?: InputMaybe<Array<Global_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Global_Stats_Order_By>>;
  where?: InputMaybe<Global_Stats_Bool_Exp>;
};


export type Subscription_RootGlobal_StatsArgs = {
  distinct_on?: InputMaybe<Array<Global_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Global_Stats_Order_By>>;
  where?: InputMaybe<Global_Stats_Bool_Exp>;
};


export type Subscription_RootGlobal_Stats_By_PkArgs = {
  date: Scalars['date']['input'];
};


export type Subscription_RootGlobal_Stats_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Global_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<Global_Stats_Bool_Exp>;
};


export type Subscription_RootGoogle_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Google_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Addresses_Order_By>>;
  where?: InputMaybe<Google_Addresses_Bool_Exp>;
};


export type Subscription_RootGoogle_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Google_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Reviews_Order_By>>;
  where?: InputMaybe<Google_Reviews_Bool_Exp>;
};


export type Subscription_RootGoogle_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Google_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Reviews_Order_By>>;
  where?: InputMaybe<Google_Reviews_Bool_Exp>;
};


export type Subscription_RootGoogle_Reviews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootGoogle_Reviews_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Google_Reviews_Stream_Cursor_Input>>;
  where?: InputMaybe<Google_Reviews_Bool_Exp>;
};


export type Subscription_RootHeating_Distribution_EnumArgs = {
  distinct_on?: InputMaybe<Array<Heating_Distribution_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Heating_Distribution_Enum_Order_By>>;
  where?: InputMaybe<Heating_Distribution_Enum_Bool_Exp>;
};


export type Subscription_RootHeating_Distribution_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootHeating_Distribution_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Heating_Distribution_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Heating_Distribution_Enum_Bool_Exp>;
};


export type Subscription_RootHeating_EnumArgs = {
  distinct_on?: InputMaybe<Array<Heating_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Heating_Enum_Order_By>>;
  where?: InputMaybe<Heating_Enum_Bool_Exp>;
};


export type Subscription_RootHeating_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootHeating_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Heating_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Heating_Enum_Bool_Exp>;
};


export type Subscription_RootImagesArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Subscription_RootImages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootImages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Images_Stream_Cursor_Input>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Subscription_RootInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Invitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitations_Order_By>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};


export type Subscription_RootInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitations_Order_By>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};


export type Subscription_RootInvitations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootInvitations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Invitations_Stream_Cursor_Input>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};


export type Subscription_RootInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Subscription_RootInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Subscription_RootInvoices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootInvoices_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Invoices_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Subscription_RootIt_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Subscription_RootIt_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<It_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<It_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootIt_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<It_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<It_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootIt_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<It_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<It_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<It_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<It_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


export type Subscription_RootIt_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


export type Subscription_RootIt_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootIt_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<It_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<It_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootIt_PlacesArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


export type Subscription_RootIt_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


export type Subscription_RootIt_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<It_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootIt_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<It_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootIt_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIt_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<It_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootIt_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<It_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Property_Types_Order_By>>;
  where?: InputMaybe<It_Property_Types_Bool_Exp>;
};


export type Subscription_RootIt_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


export type Subscription_RootIt_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


export type Subscription_RootLead_AgentsArgs = {
  distinct_on?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Agents_Order_By>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


export type Subscription_RootLead_Agents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Agents_Order_By>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


export type Subscription_RootLead_Agents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLead_Agents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lead_Agents_Stream_Cursor_Input>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


export type Subscription_RootLead_StagesArgs = {
  distinct_on?: InputMaybe<Array<Lead_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Stages_Order_By>>;
  where?: InputMaybe<Lead_Stages_Bool_Exp>;
};


export type Subscription_RootLead_Stages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Stages_Order_By>>;
  where?: InputMaybe<Lead_Stages_Bool_Exp>;
};


export type Subscription_RootLead_Stages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLead_Stages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lead_Stages_Stream_Cursor_Input>>;
  where?: InputMaybe<Lead_Stages_Bool_Exp>;
};


export type Subscription_RootLeadsArgs = {
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Subscription_RootLeads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Subscription_RootLeads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLeads_StatusArgs = {
  distinct_on?: InputMaybe<Array<Leads_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Status_Order_By>>;
  where?: InputMaybe<Leads_Status_Bool_Exp>;
};


export type Subscription_RootLeads_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootLeads_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Leads_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Leads_Status_Bool_Exp>;
};


export type Subscription_RootLeads_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Leads_Stream_Cursor_Input>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Subscription_RootLeads_TagsArgs = {
  distinct_on?: InputMaybe<Array<Leads_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Tags_Order_By>>;
  where?: InputMaybe<Leads_Tags_Bool_Exp>;
};


export type Subscription_RootLeads_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Leads_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Tags_Order_By>>;
  where?: InputMaybe<Leads_Tags_Bool_Exp>;
};


export type Subscription_RootLeads_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLeads_Tags_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Leads_Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Leads_Tags_Bool_Exp>;
};


export type Subscription_RootLoginsArgs = {
  distinct_on?: InputMaybe<Array<Logins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Logins_Order_By>>;
  where?: InputMaybe<Logins_Bool_Exp>;
};


export type Subscription_RootLogins_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Logins_Stream_Cursor_Input>>;
  where?: InputMaybe<Logins_Bool_Exp>;
};


export type Subscription_RootLot_Reference_AliasesArgs = {
  distinct_on?: InputMaybe<Array<Lot_Reference_Aliases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Reference_Aliases_Order_By>>;
  where?: InputMaybe<Lot_Reference_Aliases_Bool_Exp>;
};


export type Subscription_RootLot_Reference_Aliases_By_PkArgs = {
  reference_alias_decoded: Scalars['Int']['input'];
};


export type Subscription_RootLot_Reference_Aliases_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lot_Reference_Aliases_Stream_Cursor_Input>>;
  where?: InputMaybe<Lot_Reference_Aliases_Bool_Exp>;
};


export type Subscription_RootLot_SellersArgs = {
  distinct_on?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Sellers_Order_By>>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};


export type Subscription_RootLot_Sellers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Sellers_Order_By>>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};


export type Subscription_RootLot_Sellers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lot_Sellers_Stream_Cursor_Input>>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};


export type Subscription_RootLotsArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


export type Subscription_RootLots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


export type Subscription_RootLots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLots_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Lots_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Status_Enum_Order_By>>;
  where?: InputMaybe<Lots_Status_Enum_Bool_Exp>;
};


export type Subscription_RootLots_Status_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootLots_Status_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lots_Status_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Lots_Status_Enum_Bool_Exp>;
};


export type Subscription_RootLots_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lots_Stream_Cursor_Input>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


export type Subscription_RootMeArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootMe_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootMls_LotsArgs = {
  distinct_on?: InputMaybe<Array<Mls_Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Lots_Order_By>>;
  where?: InputMaybe<Mls_Lots_Bool_Exp>;
};


export type Subscription_RootMls_Lots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mls_Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Lots_Order_By>>;
  where?: InputMaybe<Mls_Lots_Bool_Exp>;
};


export type Subscription_RootMls_Lots_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mls_Lots_Stream_Cursor_Input>>;
  where?: InputMaybe<Mls_Lots_Bool_Exp>;
};


export type Subscription_RootMls_PropertiesArgs = {
  distinct_on?: InputMaybe<Array<Mls_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Properties_Order_By>>;
  where?: InputMaybe<Mls_Properties_Bool_Exp>;
};


export type Subscription_RootMls_Properties_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mls_Properties_Stream_Cursor_Input>>;
  where?: InputMaybe<Mls_Properties_Bool_Exp>;
};


export type Subscription_RootNylas_Account_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Nylas_Account_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nylas_Account_Configs_Order_By>>;
  where?: InputMaybe<Nylas_Account_Configs_Bool_Exp>;
};


export type Subscription_RootNylas_Account_Configs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootNylas_Account_Configs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Nylas_Account_Configs_Stream_Cursor_Input>>;
  where?: InputMaybe<Nylas_Account_Configs_Bool_Exp>;
};


export type Subscription_RootOffersArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


export type Subscription_RootOffers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


export type Subscription_RootOffers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOffers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Offers_Stream_Cursor_Input>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


export type Subscription_RootOnline_Listing_Map_DataArgs = {
  distinct_on?: InputMaybe<Array<Online_Listing_Map_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listing_Map_Data_Order_By>>;
  where?: InputMaybe<Online_Listing_Map_Data_Bool_Exp>;
};


export type Subscription_RootOnline_Listing_Map_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Online_Listing_Map_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listing_Map_Data_Order_By>>;
  where?: InputMaybe<Online_Listing_Map_Data_Bool_Exp>;
};


export type Subscription_RootOnline_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Subscription_RootOnline_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Subscription_RootOnline_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootOrganisation_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Images_Order_By>>;
  where?: InputMaybe<Organisation_Images_Bool_Exp>;
};


export type Subscription_RootOrganisation_Images_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organisation_Images_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Images_Bool_Exp>;
};


export type Subscription_RootOrganisation_UsersArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Users_Order_By>>;
  where?: InputMaybe<Organisation_Users_Bool_Exp>;
};


export type Subscription_RootOrganisation_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organisation_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Users_Bool_Exp>;
};


export type Subscription_RootOrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Subscription_RootOrganisations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Subscription_RootOrganisations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganisations_SearchArgs = {
  args: Organisations_Search_Args;
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Subscription_RootOrganisations_Search_AggregateArgs = {
  args: Organisations_Search_Args;
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Subscription_RootOrganisations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organisations_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Subscription_RootPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Subscription_RootPayments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPayments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Payments_Stream_Cursor_Input>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Subscription_RootPhone_Number_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Phone_Number_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Number_Type_Enum_Order_By>>;
  where?: InputMaybe<Phone_Number_Type_Enum_Bool_Exp>;
};


export type Subscription_RootPhone_Number_Type_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPhone_Number_Type_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Phone_Number_Type_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Phone_Number_Type_Enum_Bool_Exp>;
};


export type Subscription_RootPhone_NumbersArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Subscription_RootPhone_Numbers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Subscription_RootPhone_Numbers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPhone_Numbers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Phone_Numbers_Stream_Cursor_Input>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Subscription_RootPipelinesArgs = {
  distinct_on?: InputMaybe<Array<Pipelines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pipelines_Order_By>>;
  where?: InputMaybe<Pipelines_Bool_Exp>;
};


export type Subscription_RootPipelines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pipelines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pipelines_Order_By>>;
  where?: InputMaybe<Pipelines_Bool_Exp>;
};


export type Subscription_RootPipelines_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPipelines_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pipelines_Stream_Cursor_Input>>;
  where?: InputMaybe<Pipelines_Bool_Exp>;
};


export type Subscription_RootPlace_By_SlugArgs = {
  args?: InputMaybe<Place_By_Slug_Args>;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootPlace_By_TypeArgs = {
  args: Place_By_Type_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootPlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootPlaces_Agent_RankingArgs = {
  args: Places_Agent_Ranking_Args;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Subscription_RootPlaces_Agent_Ranking_AggregateArgs = {
  args: Places_Agent_Ranking_Args;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Subscription_RootPlaces_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPlaces_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Places_Stream_Cursor_Input>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootPortal_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portal_Listings_Order_By>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};


export type Subscription_RootPortal_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portal_Listings_Order_By>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};


export type Subscription_RootPortal_Listings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPortal_Listings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Portal_Listings_Stream_Cursor_Input>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};


export type Subscription_RootPortalsArgs = {
  distinct_on?: InputMaybe<Array<Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portals_Order_By>>;
  where?: InputMaybe<Portals_Bool_Exp>;
};


export type Subscription_RootPortals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portals_Order_By>>;
  where?: InputMaybe<Portals_Bool_Exp>;
};


export type Subscription_RootPortals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPortals_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Portals_Stream_Cursor_Input>>;
  where?: InputMaybe<Portals_Bool_Exp>;
};


export type Subscription_RootPortals_Types_EnumArgs = {
  distinct_on?: InputMaybe<Array<Portals_Types_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portals_Types_Enum_Order_By>>;
  where?: InputMaybe<Portals_Types_Enum_Bool_Exp>;
};


export type Subscription_RootPortals_Types_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPortals_Types_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Portals_Types_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Portals_Types_Enum_Bool_Exp>;
};


export type Subscription_RootPropertiesArgs = {
  distinct_on?: InputMaybe<Array<Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Properties_Order_By>>;
  where?: InputMaybe<Properties_Bool_Exp>;
};


export type Subscription_RootProperties_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperties_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Properties_Stream_Cursor_Input>>;
  where?: InputMaybe<Properties_Bool_Exp>;
};


export type Subscription_RootProperty_FilesArgs = {
  distinct_on?: InputMaybe<Array<Property_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Files_Order_By>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


export type Subscription_RootProperty_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Files_Order_By>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


export type Subscription_RootProperty_Files_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


export type Subscription_RootProperty_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Property_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Images_Order_By>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};


export type Subscription_RootProperty_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Images_Order_By>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};


export type Subscription_RootProperty_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Images_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Images_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};


export type Subscription_RootProperty_Search_Aggregator_SourceArgs = {
  distinct_on?: InputMaybe<Array<Property_Search_Aggregator_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Search_Aggregator_Source_Order_By>>;
  where?: InputMaybe<Property_Search_Aggregator_Source_Bool_Exp>;
};


export type Subscription_RootProperty_Search_Aggregator_Source_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProperty_Search_Aggregator_Source_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Search_Aggregator_Source_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Search_Aggregator_Source_Bool_Exp>;
};


export type Subscription_RootProperty_Search_SourceArgs = {
  distinct_on?: InputMaybe<Array<Property_Search_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Search_Source_Order_By>>;
  where?: InputMaybe<Property_Search_Source_Bool_Exp>;
};


export type Subscription_RootProperty_Search_Source_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProperty_Search_Source_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Search_Source_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Search_Source_Bool_Exp>;
};


export type Subscription_RootProperty_SearchesArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Order_By>>;
  where?: InputMaybe<Property_Searches_Bool_Exp>;
};


export type Subscription_RootProperty_Searches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Order_By>>;
  where?: InputMaybe<Property_Searches_Bool_Exp>;
};


export type Subscription_RootProperty_Searches_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Searches_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Places_Order_By>>;
  where?: InputMaybe<Property_Searches_Places_Bool_Exp>;
};


export type Subscription_RootProperty_Searches_Places_By_PkArgs = {
  place_id: Scalars['uuid']['input'];
  property_search_id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Searches_Places_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Searches_Places_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Searches_Places_Bool_Exp>;
};


export type Subscription_RootProperty_Searches_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Searches_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Searches_Bool_Exp>;
};


export type Subscription_RootProperty_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Subscription_RootProperty_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Subscription_RootProperty_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Transactions_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Listings_Order_By>>;
  where?: InputMaybe<Property_Transactions_Listings_Bool_Exp>;
};


export type Subscription_RootProperty_Transactions_Listings_By_PkArgs = {
  listing_id: Scalars['Int']['input'];
  property_transaction_id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Transactions_Listings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Transactions_Listings_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Transactions_Listings_Bool_Exp>;
};


export type Subscription_RootProperty_Transactions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Transactions_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Subscription_RootProperty_TypesArgs = {
  distinct_on?: InputMaybe<Array<Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Types_Order_By>>;
  where?: InputMaybe<Property_Types_Bool_Exp>;
};


export type Subscription_RootProperty_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Types_Order_By>>;
  where?: InputMaybe<Property_Types_Bool_Exp>;
};


export type Subscription_RootProperty_Types_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Types_Bool_Exp>;
};


export type Subscription_RootPush_Notification_TokensArgs = {
  distinct_on?: InputMaybe<Array<Push_Notification_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Push_Notification_Tokens_Order_By>>;
  where?: InputMaybe<Push_Notification_Tokens_Bool_Exp>;
};


export type Subscription_RootPush_Notification_Tokens_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPush_Notification_Tokens_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Push_Notification_Tokens_Stream_Cursor_Input>>;
  where?: InputMaybe<Push_Notification_Tokens_Bool_Exp>;
};


export type Subscription_RootRead_Only_TenantsArgs = {
  distinct_on?: InputMaybe<Array<Read_Only_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Read_Only_Tenants_Order_By>>;
  where?: InputMaybe<Read_Only_Tenants_Bool_Exp>;
};


export type Subscription_RootRead_Only_Tenants_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Read_Only_Tenants_Stream_Cursor_Input>>;
  where?: InputMaybe<Read_Only_Tenants_Bool_Exp>;
};


export type Subscription_RootReviewsArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Subscription_RootReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Subscription_RootReviews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReviews_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reviews_Stream_Cursor_Input>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Subscription_RootSearch_Brockers_In_Catchment_AreaArgs = {
  args?: InputMaybe<Search_Brockers_In_Catchment_Area_Args>;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootSearch_Brockers_In_Catchment_Area_AggregateArgs = {
  args?: InputMaybe<Search_Brockers_In_Catchment_Area_Args>;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootSearch_LeadsArgs = {
  args?: InputMaybe<Search_Leads_Args>;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Subscription_RootSearch_Leads_AggregateArgs = {
  args?: InputMaybe<Search_Leads_Args>;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Subscription_RootSearch_Leads_TsvArgs = {
  args: Search_Leads_Tsv_Args;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Subscription_RootSearch_Leads_Tsv_AggregateArgs = {
  args: Search_Leads_Tsv_Args;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Subscription_RootSearch_Lots_TsvArgs = {
  args: Search_Lots_Tsv_Args;
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


export type Subscription_RootSearch_Lots_Tsv_AggregateArgs = {
  args: Search_Lots_Tsv_Args;
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


export type Subscription_RootSearch_PlacesArgs = {
  args: Search_Places_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootSearch_Places_ExArgs = {
  args: Search_Places_Ex_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootSearch_Property_Transactions_TsvArgs = {
  args: Search_Property_Transactions_Tsv_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Subscription_RootSearch_Property_Transactions_Tsv_AggregateArgs = {
  args: Search_Property_Transactions_Tsv_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Subscription_RootSearch_Teams_TsvArgs = {
  args: Search_Teams_Tsv_Args;
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootSearch_Teams_Tsv_AggregateArgs = {
  args: Search_Teams_Tsv_Args;
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootSearch_UsersArgs = {
  args?: InputMaybe<Search_Users_Args>;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootSearch_Users_AggregateArgs = {
  args?: InputMaybe<Search_Users_Args>;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootSearch_Users_TsvArgs = {
  args: Search_Users_Tsv_Args;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootSearch_Users_Tsv_AggregateArgs = {
  args: Search_Users_Tsv_Args;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootShared_PortalsArgs = {
  distinct_on?: InputMaybe<Array<Shared_Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shared_Portals_Order_By>>;
  where?: InputMaybe<Shared_Portals_Bool_Exp>;
};


export type Subscription_RootShared_Portals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shared_Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shared_Portals_Order_By>>;
  where?: InputMaybe<Shared_Portals_Bool_Exp>;
};


export type Subscription_RootShared_Portals_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Shared_Portals_Stream_Cursor_Input>>;
  where?: InputMaybe<Shared_Portals_Bool_Exp>;
};


export type Subscription_RootSimilar_Online_Listings_IdsArgs = {
  distinct_on?: InputMaybe<Array<Similar_Online_Listings_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Online_Listings_Ids_Order_By>>;
  where?: InputMaybe<Similar_Online_Listings_Ids_Bool_Exp>;
};


export type Subscription_RootSimilar_Online_Listings_Ids_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Similar_Online_Listings_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Online_Listings_Ids_Order_By>>;
  where?: InputMaybe<Similar_Online_Listings_Ids_Bool_Exp>;
};


export type Subscription_RootSmart_ListsArgs = {
  distinct_on?: InputMaybe<Array<Smart_Lists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Lists_Order_By>>;
  where?: InputMaybe<Smart_Lists_Bool_Exp>;
};


export type Subscription_RootSmart_Lists_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSmart_Lists_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Smart_Lists_Stream_Cursor_Input>>;
  where?: InputMaybe<Smart_Lists_Bool_Exp>;
};


export type Subscription_RootSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootSubscriptions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSubscriptions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscriptions_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootTeam_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Team_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Images_Order_By>>;
  where?: InputMaybe<Team_Images_Bool_Exp>;
};


export type Subscription_RootTeam_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTeam_Images_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Team_Images_Stream_Cursor_Input>>;
  where?: InputMaybe<Team_Images_Bool_Exp>;
};


export type Subscription_RootTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootTeams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTeams_PortalsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Portals_Order_By>>;
  where?: InputMaybe<Teams_Portals_Bool_Exp>;
};


export type Subscription_RootTeams_Portals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTeams_Portals_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Teams_Portals_Stream_Cursor_Input>>;
  where?: InputMaybe<Teams_Portals_Bool_Exp>;
};


export type Subscription_RootTeams_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Teams_Stream_Cursor_Input>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootTeams_UsersArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


export type Subscription_RootTeams_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


export type Subscription_RootTeams_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Teams_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


export type Subscription_RootTenantsArgs = {
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Subscription_RootTenants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Subscription_RootTenants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTenants_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenants_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Subscription_RootUser_ImagesArgs = {
  distinct_on?: InputMaybe<Array<User_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Images_Order_By>>;
  where?: InputMaybe<User_Images_Bool_Exp>;
};


export type Subscription_RootUser_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Images_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Images_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Images_Bool_Exp>;
};


export type Subscription_RootUser_Primary_PhoneArgs = {
  args: User_Primary_Phone_Args;
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Subscription_RootUser_Primary_Phone_AggregateArgs = {
  args: User_Primary_Phone_Args;
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUsers_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Users_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Listings_Order_By>>;
  where?: InputMaybe<Users_Listings_Bool_Exp>;
};


export type Subscription_RootUsers_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Listings_Order_By>>;
  where?: InputMaybe<Users_Listings_Bool_Exp>;
};


export type Subscription_RootUsers_Listings_By_PkArgs = {
  created_at: Scalars['timestamptz']['input'];
  merged_listing_id: Scalars['Int']['input'];
  type: Users_Listings_Types_Enum;
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootValuation_ModelsArgs = {
  distinct_on?: InputMaybe<Array<Valuation_Models_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Valuation_Models_Order_By>>;
  where?: InputMaybe<Valuation_Models_Bool_Exp>;
};


export type Subscription_RootValuation_Models_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootValuation_Models_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Valuation_Models_Stream_Cursor_Input>>;
  where?: InputMaybe<Valuation_Models_Bool_Exp>;
};


export type Subscription_RootValuationsArgs = {
  distinct_on?: InputMaybe<Array<Valuations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Valuations_Order_By>>;
  where?: InputMaybe<Valuations_Bool_Exp>;
};


export type Subscription_RootValuations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootValuations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Valuations_Stream_Cursor_Input>>;
  where?: InputMaybe<Valuations_Bool_Exp>;
};

/** Boolean expression to compare columns of type "subscription_status". All fields are combined with logical 'AND'. */
export type Subscription_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['subscription_status']['input']>;
  _gt?: InputMaybe<Scalars['subscription_status']['input']>;
  _gte?: InputMaybe<Scalars['subscription_status']['input']>;
  _in?: InputMaybe<Array<Scalars['subscription_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['subscription_status']['input']>;
  _lte?: InputMaybe<Scalars['subscription_status']['input']>;
  _neq?: InputMaybe<Scalars['subscription_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['subscription_status']['input']>>;
};

/** columns and relationships of "subscriptions" */
export type Subscriptions = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  billing_cycle_anchor?: Maybe<Scalars['timestamptz']['output']>;
  billing_thresholds?: Maybe<Scalars['jsonb']['output']>;
  cancel_at?: Maybe<Scalars['timestamptz']['output']>;
  cancel_at_period_end: Scalars['Boolean']['output'];
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  collection_method?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  current_period_end: Scalars['timestamptz']['output'];
  current_period_start: Scalars['timestamptz']['output'];
  customer: Scalars['String']['output'];
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_object?: Maybe<Scalars['jsonb']['output']>;
  days_until_due?: Maybe<Scalars['Int']['output']>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  default_tax_rates?: Maybe<Scalars['jsonb']['output']>;
  discount?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  email?: Maybe<Emails>;
  ended_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  interval_count?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoices_aggregate: Invoices_Aggregate;
  items: Scalars['jsonb']['output'];
  latest_invoice?: Maybe<Scalars['String']['output']>;
  livemode: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  next_pending_invoice_item_invoice?: Maybe<Scalars['timestamptz']['output']>;
  pause_collection?: Maybe<Scalars['jsonb']['output']>;
  pending_invoice_item_interval?: Maybe<Scalars['jsonb']['output']>;
  pending_setup_intent?: Maybe<Scalars['String']['output']>;
  pending_update?: Maybe<Scalars['jsonb']['output']>;
  plan_name?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  start_date: Scalars['timestamptz']['output'];
  status: Scalars['subscription_status']['output'];
  stripe_id: Scalars['String']['output'];
  tenant_id: Scalars['uuid']['output'];
  total_amount: Scalars['Int']['output'];
  transfer_data?: Maybe<Scalars['jsonb']['output']>;
  trial_end?: Maybe<Scalars['timestamptz']['output']>;
  trial_start?: Maybe<Scalars['timestamptz']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsBilling_ThresholdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsCustomer_ObjectArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsDefault_Tax_RatesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsDiscountArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsItemsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsPause_CollectionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsPending_Invoice_Item_IntervalArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsPending_UpdateArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsTransfer_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "subscriptions" */
export type Subscriptions_Aggregate = {
  aggregate?: Maybe<Subscriptions_Aggregate_Fields>;
  nodes: Array<Subscriptions>;
};

export type Subscriptions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Subscriptions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Subscriptions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Subscriptions_Aggregate_Bool_Exp_Count>;
};

export type Subscriptions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscriptions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscriptions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscriptions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscriptions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscriptions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "subscriptions" */
export type Subscriptions_Aggregate_Fields = {
  avg?: Maybe<Subscriptions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Subscriptions_Max_Fields>;
  min?: Maybe<Subscriptions_Min_Fields>;
  stddev?: Maybe<Subscriptions_Stddev_Fields>;
  stddev_pop?: Maybe<Subscriptions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscriptions_Stddev_Samp_Fields>;
  sum?: Maybe<Subscriptions_Sum_Fields>;
  var_pop?: Maybe<Subscriptions_Var_Pop_Fields>;
  var_samp?: Maybe<Subscriptions_Var_Samp_Fields>;
  variance?: Maybe<Subscriptions_Variance_Fields>;
};


/** aggregate fields of "subscriptions" */
export type Subscriptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "subscriptions" */
export type Subscriptions_Aggregate_Order_By = {
  avg?: InputMaybe<Subscriptions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscriptions_Max_Order_By>;
  min?: InputMaybe<Subscriptions_Min_Order_By>;
  stddev?: InputMaybe<Subscriptions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscriptions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscriptions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscriptions_Sum_Order_By>;
  var_pop?: InputMaybe<Subscriptions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscriptions_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscriptions_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Subscriptions_Avg_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  days_until_due?: Maybe<Scalars['Float']['output']>;
  interval_count?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "subscriptions" */
export type Subscriptions_Avg_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscriptions". All fields are combined with a logical 'AND'. */
export type Subscriptions_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Bool_Exp>>;
  application_fee_percent?: InputMaybe<Float_Comparison_Exp>;
  billing_cycle_anchor?: InputMaybe<Timestamptz_Comparison_Exp>;
  billing_thresholds?: InputMaybe<Jsonb_Comparison_Exp>;
  cancel_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  cancel_at_period_end?: InputMaybe<Boolean_Comparison_Exp>;
  canceled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  collection_method?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_period_end?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_period_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer?: InputMaybe<String_Comparison_Exp>;
  customer_email?: InputMaybe<String_Comparison_Exp>;
  customer_name?: InputMaybe<String_Comparison_Exp>;
  customer_object?: InputMaybe<Jsonb_Comparison_Exp>;
  days_until_due?: InputMaybe<Int_Comparison_Exp>;
  default_payment_method?: InputMaybe<String_Comparison_Exp>;
  default_source?: InputMaybe<String_Comparison_Exp>;
  default_tax_rates?: InputMaybe<Jsonb_Comparison_Exp>;
  discount?: InputMaybe<Jsonb_Comparison_Exp>;
  email?: InputMaybe<Emails_Bool_Exp>;
  ended_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  interval_count?: InputMaybe<Int_Comparison_Exp>;
  invoices?: InputMaybe<Invoices_Bool_Exp>;
  invoices_aggregate?: InputMaybe<Invoices_Aggregate_Bool_Exp>;
  items?: InputMaybe<Jsonb_Comparison_Exp>;
  latest_invoice?: InputMaybe<String_Comparison_Exp>;
  livemode?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  next_pending_invoice_item_invoice?: InputMaybe<Timestamptz_Comparison_Exp>;
  pause_collection?: InputMaybe<Jsonb_Comparison_Exp>;
  pending_invoice_item_interval?: InputMaybe<Jsonb_Comparison_Exp>;
  pending_setup_intent?: InputMaybe<String_Comparison_Exp>;
  pending_update?: InputMaybe<Jsonb_Comparison_Exp>;
  plan_name?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  schedule?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<Subscription_Status_Comparison_Exp>;
  stripe_id?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_amount?: InputMaybe<Int_Comparison_Exp>;
  transfer_data?: InputMaybe<Jsonb_Comparison_Exp>;
  trial_end?: InputMaybe<Timestamptz_Comparison_Exp>;
  trial_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Subscriptions_Max_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  billing_cycle_anchor?: Maybe<Scalars['timestamptz']['output']>;
  cancel_at?: Maybe<Scalars['timestamptz']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  collection_method?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  current_period_end?: Maybe<Scalars['timestamptz']['output']>;
  current_period_start?: Maybe<Scalars['timestamptz']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  days_until_due?: Maybe<Scalars['Int']['output']>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  ended_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interval_count?: Maybe<Scalars['Int']['output']>;
  latest_invoice?: Maybe<Scalars['String']['output']>;
  next_pending_invoice_item_invoice?: Maybe<Scalars['timestamptz']['output']>;
  pending_setup_intent?: Maybe<Scalars['String']['output']>;
  plan_name?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['subscription_status']['output']>;
  stripe_id?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  total_amount?: Maybe<Scalars['Int']['output']>;
  trial_end?: Maybe<Scalars['timestamptz']['output']>;
  trial_start?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "subscriptions" */
export type Subscriptions_Max_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  billing_cycle_anchor?: InputMaybe<Order_By>;
  cancel_at?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  collection_method?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_period_end?: InputMaybe<Order_By>;
  current_period_start?: InputMaybe<Order_By>;
  customer?: InputMaybe<Order_By>;
  customer_email?: InputMaybe<Order_By>;
  customer_name?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  default_payment_method?: InputMaybe<Order_By>;
  default_source?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  latest_invoice?: InputMaybe<Order_By>;
  next_pending_invoice_item_invoice?: InputMaybe<Order_By>;
  pending_setup_intent?: InputMaybe<Order_By>;
  plan_name?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  schedule?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  trial_end?: InputMaybe<Order_By>;
  trial_start?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscriptions_Min_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  billing_cycle_anchor?: Maybe<Scalars['timestamptz']['output']>;
  cancel_at?: Maybe<Scalars['timestamptz']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  collection_method?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  current_period_end?: Maybe<Scalars['timestamptz']['output']>;
  current_period_start?: Maybe<Scalars['timestamptz']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  days_until_due?: Maybe<Scalars['Int']['output']>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  ended_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interval_count?: Maybe<Scalars['Int']['output']>;
  latest_invoice?: Maybe<Scalars['String']['output']>;
  next_pending_invoice_item_invoice?: Maybe<Scalars['timestamptz']['output']>;
  pending_setup_intent?: Maybe<Scalars['String']['output']>;
  plan_name?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['subscription_status']['output']>;
  stripe_id?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  total_amount?: Maybe<Scalars['Int']['output']>;
  trial_end?: Maybe<Scalars['timestamptz']['output']>;
  trial_start?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "subscriptions" */
export type Subscriptions_Min_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  billing_cycle_anchor?: InputMaybe<Order_By>;
  cancel_at?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  collection_method?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_period_end?: InputMaybe<Order_By>;
  current_period_start?: InputMaybe<Order_By>;
  customer?: InputMaybe<Order_By>;
  customer_email?: InputMaybe<Order_By>;
  customer_name?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  default_payment_method?: InputMaybe<Order_By>;
  default_source?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  latest_invoice?: InputMaybe<Order_By>;
  next_pending_invoice_item_invoice?: InputMaybe<Order_By>;
  pending_setup_intent?: InputMaybe<Order_By>;
  plan_name?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  schedule?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  trial_end?: InputMaybe<Order_By>;
  trial_start?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscriptions" */
export type Subscriptions_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscriptions>;
};

/** Ordering options when selecting data from "subscriptions". */
export type Subscriptions_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  billing_cycle_anchor?: InputMaybe<Order_By>;
  billing_thresholds?: InputMaybe<Order_By>;
  cancel_at?: InputMaybe<Order_By>;
  cancel_at_period_end?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  collection_method?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_period_end?: InputMaybe<Order_By>;
  current_period_start?: InputMaybe<Order_By>;
  customer?: InputMaybe<Order_By>;
  customer_email?: InputMaybe<Order_By>;
  customer_name?: InputMaybe<Order_By>;
  customer_object?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  default_payment_method?: InputMaybe<Order_By>;
  default_source?: InputMaybe<Order_By>;
  default_tax_rates?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  email?: InputMaybe<Emails_Order_By>;
  ended_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  invoices_aggregate?: InputMaybe<Invoices_Aggregate_Order_By>;
  items?: InputMaybe<Order_By>;
  latest_invoice?: InputMaybe<Order_By>;
  livemode?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  next_pending_invoice_item_invoice?: InputMaybe<Order_By>;
  pause_collection?: InputMaybe<Order_By>;
  pending_invoice_item_interval?: InputMaybe<Order_By>;
  pending_setup_intent?: InputMaybe<Order_By>;
  pending_update?: InputMaybe<Order_By>;
  plan_name?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  schedule?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  transfer_data?: InputMaybe<Order_By>;
  trial_end?: InputMaybe<Order_By>;
  trial_start?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscriptions */
export type Subscriptions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "subscriptions" */
export enum Subscriptions_Select_Column {
  /** column name */
  ApplicationFeePercent = 'application_fee_percent',
  /** column name */
  BillingCycleAnchor = 'billing_cycle_anchor',
  /** column name */
  BillingThresholds = 'billing_thresholds',
  /** column name */
  CancelAt = 'cancel_at',
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CollectionMethod = 'collection_method',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentPeriodEnd = 'current_period_end',
  /** column name */
  CurrentPeriodStart = 'current_period_start',
  /** column name */
  Customer = 'customer',
  /** column name */
  CustomerEmail = 'customer_email',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  CustomerObject = 'customer_object',
  /** column name */
  DaysUntilDue = 'days_until_due',
  /** column name */
  DefaultPaymentMethod = 'default_payment_method',
  /** column name */
  DefaultSource = 'default_source',
  /** column name */
  DefaultTaxRates = 'default_tax_rates',
  /** column name */
  Discount = 'discount',
  /** column name */
  EndedAt = 'ended_at',
  /** column name */
  Id = 'id',
  /** column name */
  IntervalCount = 'interval_count',
  /** column name */
  Items = 'items',
  /** column name */
  LatestInvoice = 'latest_invoice',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextPendingInvoiceItemInvoice = 'next_pending_invoice_item_invoice',
  /** column name */
  PauseCollection = 'pause_collection',
  /** column name */
  PendingInvoiceItemInterval = 'pending_invoice_item_interval',
  /** column name */
  PendingSetupIntent = 'pending_setup_intent',
  /** column name */
  PendingUpdate = 'pending_update',
  /** column name */
  PlanName = 'plan_name',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Schedule = 'schedule',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  StripeId = 'stripe_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TransferData = 'transfer_data',
  /** column name */
  TrialEnd = 'trial_end',
  /** column name */
  TrialStart = 'trial_start',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "subscriptions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "subscriptions" */
export enum Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  Livemode = 'livemode'
}

/** select "subscriptions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "subscriptions" */
export enum Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  Livemode = 'livemode'
}

/** input type for updating data in table "subscriptions" */
export type Subscriptions_Set_Input = {
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Subscriptions_Stddev_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  days_until_due?: Maybe<Scalars['Float']['output']>;
  interval_count?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "subscriptions" */
export type Subscriptions_Stddev_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Subscriptions_Stddev_Pop_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  days_until_due?: Maybe<Scalars['Float']['output']>;
  interval_count?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "subscriptions" */
export type Subscriptions_Stddev_Pop_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Subscriptions_Stddev_Samp_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  days_until_due?: Maybe<Scalars['Float']['output']>;
  interval_count?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "subscriptions" */
export type Subscriptions_Stddev_Samp_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "subscriptions" */
export type Subscriptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscriptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscriptions_Stream_Cursor_Value_Input = {
  application_fee_percent?: InputMaybe<Scalars['Float']['input']>;
  billing_cycle_anchor?: InputMaybe<Scalars['timestamptz']['input']>;
  billing_thresholds?: InputMaybe<Scalars['jsonb']['input']>;
  cancel_at?: InputMaybe<Scalars['timestamptz']['input']>;
  cancel_at_period_end?: InputMaybe<Scalars['Boolean']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  collection_method?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_period_end?: InputMaybe<Scalars['timestamptz']['input']>;
  current_period_start?: InputMaybe<Scalars['timestamptz']['input']>;
  customer?: InputMaybe<Scalars['String']['input']>;
  customer_email?: InputMaybe<Scalars['String']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  customer_object?: InputMaybe<Scalars['jsonb']['input']>;
  days_until_due?: InputMaybe<Scalars['Int']['input']>;
  default_payment_method?: InputMaybe<Scalars['String']['input']>;
  default_source?: InputMaybe<Scalars['String']['input']>;
  default_tax_rates?: InputMaybe<Scalars['jsonb']['input']>;
  discount?: InputMaybe<Scalars['jsonb']['input']>;
  ended_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interval_count?: InputMaybe<Scalars['Int']['input']>;
  items?: InputMaybe<Scalars['jsonb']['input']>;
  latest_invoice?: InputMaybe<Scalars['String']['input']>;
  livemode?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  next_pending_invoice_item_invoice?: InputMaybe<Scalars['timestamptz']['input']>;
  pause_collection?: InputMaybe<Scalars['jsonb']['input']>;
  pending_invoice_item_interval?: InputMaybe<Scalars['jsonb']['input']>;
  pending_setup_intent?: InputMaybe<Scalars['String']['input']>;
  pending_update?: InputMaybe<Scalars['jsonb']['input']>;
  plan_name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['subscription_status']['input']>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  total_amount?: InputMaybe<Scalars['Int']['input']>;
  transfer_data?: InputMaybe<Scalars['jsonb']['input']>;
  trial_end?: InputMaybe<Scalars['timestamptz']['input']>;
  trial_start?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Subscriptions_Sum_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  days_until_due?: Maybe<Scalars['Int']['output']>;
  interval_count?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  total_amount?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "subscriptions" */
export type Subscriptions_Sum_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

export type Subscriptions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscriptions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscriptions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscriptions_Var_Pop_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  days_until_due?: Maybe<Scalars['Float']['output']>;
  interval_count?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "subscriptions" */
export type Subscriptions_Var_Pop_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Subscriptions_Var_Samp_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  days_until_due?: Maybe<Scalars['Float']['output']>;
  interval_count?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "subscriptions" */
export type Subscriptions_Var_Samp_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Subscriptions_Variance_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  days_until_due?: Maybe<Scalars['Float']['output']>;
  interval_count?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "subscriptions" */
export type Subscriptions_Variance_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "team_images" */
export type Team_Images = {
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  image: Images;
  image_id: Scalars['uuid']['output'];
  order_nr: Scalars['Int']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "team_images" */
export type Team_Images_Aggregate_Order_By = {
  avg?: InputMaybe<Team_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Team_Images_Max_Order_By>;
  min?: InputMaybe<Team_Images_Min_Order_By>;
  stddev?: InputMaybe<Team_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Team_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Team_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Team_Images_Sum_Order_By>;
  var_pop?: InputMaybe<Team_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Team_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Team_Images_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "team_images" */
export type Team_Images_Arr_Rel_Insert_Input = {
  data: Array<Team_Images_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Team_Images_On_Conflict>;
};

/** order by avg() on columns of table "team_images" */
export type Team_Images_Avg_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "team_images". All fields are combined with a logical 'AND'. */
export type Team_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Team_Images_Bool_Exp>>;
  _not?: InputMaybe<Team_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Team_Images_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<Images_Bool_Exp>;
  image_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "team_images" */
export enum Team_Images_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamImagesPkey = 'team_images_pkey'
}

/** input type for inserting data into table "team_images" */
export type Team_Images_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "team_images" */
export type Team_Images_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "team_images" */
export type Team_Images_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "team_images" */
export type Team_Images_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Team_Images>;
};

/** on_conflict condition type for table "team_images" */
export type Team_Images_On_Conflict = {
  constraint: Team_Images_Constraint;
  update_columns?: Array<Team_Images_Update_Column>;
  where?: InputMaybe<Team_Images_Bool_Exp>;
};

/** Ordering options when selecting data from "team_images". */
export type Team_Images_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Images_Order_By>;
  image_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "team_images" */
export enum Team_Images_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "team_images" */
export type Team_Images_Stddev_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "team_images" */
export type Team_Images_Stddev_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "team_images" */
export type Team_Images_Stddev_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "team_images" */
export type Team_Images_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Team_Images_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Team_Images_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "team_images" */
export type Team_Images_Sum_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "team_images" (current role has no relevant permissions) */
export enum Team_Images_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "team_images" */
export type Team_Images_Var_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "team_images" */
export type Team_Images_Var_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "team_images" */
export type Team_Images_Variance_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

export type Team_Ranking_Places_Args = {
  exclude_rental_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  offset_count?: InputMaybe<Scalars['Int']['input']>;
  transaction_radius?: InputMaybe<Scalars['float8']['input']>;
};

/** columns and relationships of "teams" */
export type Teams = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Int']['output']>;
  agency_slug?: Maybe<Scalars['String']['output']>;
  branding_color?: Maybe<Scalars['String']['output']>;
  centroid?: Maybe<Scalars['geometry']['output']>;
  /** An array relationship */
  combined_reviews: Array<Combined_Reviews>;
  /** An aggregate relationship */
  combined_reviews_aggregate: Combined_Reviews_Aggregate;
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  cover_photo?: Maybe<Images>;
  cover_photo_image_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  default_team_users: Array<Users>;
  /** An aggregate relationship */
  default_team_users_aggregate: Users_Aggregate;
  description?: Maybe<Scalars['String']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  do_follow_link?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  emails: Array<Emails>;
  /** An array relationship */
  enquiries: Array<Enquiries>;
  /** An aggregate relationship */
  enquiries_aggregate: Enquiries_Aggregate;
  enquiry_email_contact?: Maybe<Scalars['String']['output']>;
  facebook_url?: Maybe<Scalars['String']['output']>;
  geom?: Maybe<Scalars['geometry']['output']>;
  google_business_id?: Maybe<Scalars['String']['output']>;
  google_place_description?: Maybe<Scalars['String']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  google_reviews: Array<Google_Reviews>;
  /** An aggregate relationship */
  google_reviews_aggregate: Google_Reviews_Aggregate;
  hide_exact_address: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  idx_agency_id?: Maybe<Scalars['String']['output']>;
  idx_ftp_client_id?: Maybe<Scalars['String']['output']>;
  instagram_url?: Maybe<Scalars['String']['output']>;
  last_review_scraping?: Maybe<Scalars['timestamptz']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  legal_name?: Maybe<Scalars['String']['output']>;
  linkedin_url?: Maybe<Scalars['String']['output']>;
  listings_agency_names?: Maybe<Array<Scalars['String']['output']>>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  logo?: Maybe<Images>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  opening_hours?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  organisation?: Maybe<Organisations>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  phone_numbers: Array<Phone_Numbers>;
  /** An aggregate relationship */
  phone_numbers_aggregate: Phone_Numbers_Aggregate;
  /** A computed field, executes function "team_places" */
  places?: Maybe<Array<Places>>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  property_transactions: Array<Property_Transactions>;
  /** An aggregate relationship */
  property_transactions_aggregate: Property_Transactions_Aggregate;
  region_id?: Maybe<Scalars['uuid']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  show_in_agency_pages?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  team_images: Array<Team_Images>;
  /** An array relationship */
  teams_portals: Array<Teams_Portals>;
  /** An array relationship */
  teams_users: Array<Teams_Users>;
  /** An aggregate relationship */
  teams_users_aggregate: Teams_Users_Aggregate;
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
  tsv?: Maybe<Scalars['tsvector']['output']>;
  twitter_url?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  use_json_for_enquiry_emails: Scalars['Boolean']['output'];
  website_url?: Maybe<Scalars['String']['output']>;
  youtube_url?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "teams" */
export type TeamsCombined_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Combined_Reviews_Order_By>>;
  where?: InputMaybe<Combined_Reviews_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsCombined_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Combined_Reviews_Order_By>>;
  where?: InputMaybe<Combined_Reviews_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsDefault_Team_UsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsDefault_Team_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsEmailsArgs = {
  distinct_on?: InputMaybe<Array<Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emails_Order_By>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsEnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsEnquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsGoogle_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Google_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Reviews_Order_By>>;
  where?: InputMaybe<Google_Reviews_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsGoogle_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Google_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Reviews_Order_By>>;
  where?: InputMaybe<Google_Reviews_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsOpening_HoursArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "teams" */
export type TeamsPhone_NumbersArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsPhone_Numbers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsPlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsProperty_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsProperty_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsTeam_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Team_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Images_Order_By>>;
  where?: InputMaybe<Team_Images_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsTeams_PortalsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Portals_Order_By>>;
  where?: InputMaybe<Teams_Portals_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsTeams_UsersArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsTeams_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};

/** aggregated selection of "teams" */
export type Teams_Aggregate = {
  aggregate?: Maybe<Teams_Aggregate_Fields>;
  nodes: Array<Teams>;
};

export type Teams_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Teams_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Teams_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Teams_Aggregate_Bool_Exp_Count>;
};

export type Teams_Aggregate_Bool_Exp_Bool_And = {
  arguments: Teams_Select_Column_Teams_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teams_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Teams_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Teams_Select_Column_Teams_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teams_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Teams_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Teams_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teams_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "teams" */
export type Teams_Aggregate_Fields = {
  avg?: Maybe<Teams_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Teams_Max_Fields>;
  min?: Maybe<Teams_Min_Fields>;
  stddev?: Maybe<Teams_Stddev_Fields>;
  stddev_pop?: Maybe<Teams_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Teams_Stddev_Samp_Fields>;
  sum?: Maybe<Teams_Sum_Fields>;
  var_pop?: Maybe<Teams_Var_Pop_Fields>;
  var_samp?: Maybe<Teams_Var_Samp_Fields>;
  variance?: Maybe<Teams_Variance_Fields>;
};


/** aggregate fields of "teams" */
export type Teams_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Teams_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "teams" */
export type Teams_Aggregate_Order_By = {
  avg?: InputMaybe<Teams_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Teams_Max_Order_By>;
  min?: InputMaybe<Teams_Min_Order_By>;
  stddev?: InputMaybe<Teams_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Teams_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Teams_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Teams_Sum_Order_By>;
  var_pop?: InputMaybe<Teams_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Teams_Var_Samp_Order_By>;
  variance?: InputMaybe<Teams_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Teams_Append_Input = {
  opening_hours?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "teams" */
export type Teams_Arr_Rel_Insert_Input = {
  data: Array<Teams_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};

/** aggregate avg on columns */
export type Teams_Avg_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "teams" */
export type Teams_Avg_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "teams". All fields are combined with a logical 'AND'. */
export type Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_Bool_Exp>>;
  _not?: InputMaybe<Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_Bool_Exp>>;
  active_since?: InputMaybe<Int_Comparison_Exp>;
  agency_slug?: InputMaybe<String_Comparison_Exp>;
  branding_color?: InputMaybe<String_Comparison_Exp>;
  centroid?: InputMaybe<Geometry_Comparison_Exp>;
  combined_reviews?: InputMaybe<Combined_Reviews_Bool_Exp>;
  combined_reviews_aggregate?: InputMaybe<Combined_Reviews_Aggregate_Bool_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  country_id?: InputMaybe<Uuid_Comparison_Exp>;
  cover_photo?: InputMaybe<Images_Bool_Exp>;
  cover_photo_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  default_team_users?: InputMaybe<Users_Bool_Exp>;
  default_team_users_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  do_follow_link?: InputMaybe<Boolean_Comparison_Exp>;
  emails?: InputMaybe<Emails_Bool_Exp>;
  enquiries?: InputMaybe<Enquiries_Bool_Exp>;
  enquiries_aggregate?: InputMaybe<Enquiries_Aggregate_Bool_Exp>;
  enquiry_email_contact?: InputMaybe<String_Comparison_Exp>;
  facebook_url?: InputMaybe<String_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  google_business_id?: InputMaybe<String_Comparison_Exp>;
  google_place_description?: InputMaybe<String_Comparison_Exp>;
  google_place_id?: InputMaybe<String_Comparison_Exp>;
  google_reviews?: InputMaybe<Google_Reviews_Bool_Exp>;
  google_reviews_aggregate?: InputMaybe<Google_Reviews_Aggregate_Bool_Exp>;
  hide_exact_address?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  idx_agency_id?: InputMaybe<String_Comparison_Exp>;
  idx_ftp_client_id?: InputMaybe<String_Comparison_Exp>;
  instagram_url?: InputMaybe<String_Comparison_Exp>;
  last_review_scraping?: InputMaybe<Timestamptz_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  legal_name?: InputMaybe<String_Comparison_Exp>;
  linkedin_url?: InputMaybe<String_Comparison_Exp>;
  listings_agency_names?: InputMaybe<String_Array_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  logo?: InputMaybe<Images_Bool_Exp>;
  logo_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  opening_hours?: InputMaybe<Jsonb_Comparison_Exp>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  phone_numbers?: InputMaybe<Phone_Numbers_Bool_Exp>;
  phone_numbers_aggregate?: InputMaybe<Phone_Numbers_Aggregate_Bool_Exp>;
  places?: InputMaybe<Places_Bool_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_transactions?: InputMaybe<Property_Transactions_Bool_Exp>;
  property_transactions_aggregate?: InputMaybe<Property_Transactions_Aggregate_Bool_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  show_in_agency_pages?: InputMaybe<Boolean_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  team_images?: InputMaybe<Team_Images_Bool_Exp>;
  teams_portals?: InputMaybe<Teams_Portals_Bool_Exp>;
  teams_users?: InputMaybe<Teams_Users_Bool_Exp>;
  teams_users_aggregate?: InputMaybe<Teams_Users_Aggregate_Bool_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  tsv?: InputMaybe<Tsvector_Comparison_Exp>;
  twitter_url?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  use_json_for_enquiry_emails?: InputMaybe<Boolean_Comparison_Exp>;
  website_url?: InputMaybe<String_Comparison_Exp>;
  youtube_url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "teams" */
export enum Teams_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamsPkey = 'teams_pkey',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  TeamsTenantIdIdIdx = 'teams_tenant_id_id_idx',
  /** unique or primary key constraint on columns "agency_slug" */
  UniqueAgencySlugIndex = 'unique_agency_slug_index'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Teams_Delete_At_Path_Input = {
  opening_hours?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Teams_Delete_Elem_Input = {
  opening_hours?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Teams_Delete_Key_Input = {
  opening_hours?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "teams" */
export type Teams_Inc_Input = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "teams" */
export type Teams_Insert_Input = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Scalars['Int']['input']>;
  agency_slug?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  cover_photo?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  default_team_users?: InputMaybe<Users_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  do_follow_link?: InputMaybe<Scalars['Boolean']['input']>;
  emails?: InputMaybe<Emails_Arr_Rel_Insert_Input>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  google_business_id?: InputMaybe<Scalars['String']['input']>;
  google_place_description?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  hide_exact_address?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_agency_id?: InputMaybe<Scalars['String']['input']>;
  idx_ftp_client_id?: InputMaybe<Scalars['String']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  legal_name?: InputMaybe<Scalars['String']['input']>;
  listings_agency_names?: InputMaybe<Array<Scalars['String']['input']>>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_numbers?: InputMaybe<Phone_Numbers_Arr_Rel_Insert_Input>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  property_transactions?: InputMaybe<Property_Transactions_Arr_Rel_Insert_Input>;
  route?: InputMaybe<Scalars['String']['input']>;
  show_in_agency_pages?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  team_images?: InputMaybe<Team_Images_Arr_Rel_Insert_Input>;
  teams_portals?: InputMaybe<Teams_Portals_Arr_Rel_Insert_Input>;
  teams_users?: InputMaybe<Teams_Users_Arr_Rel_Insert_Input>;
  twitter_url?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
  youtube_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Teams_Max_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Int']['output']>;
  agency_slug?: Maybe<Scalars['String']['output']>;
  branding_color?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  cover_photo_image_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  enquiry_email_contact?: Maybe<Scalars['String']['output']>;
  facebook_url?: Maybe<Scalars['String']['output']>;
  google_business_id?: Maybe<Scalars['String']['output']>;
  google_place_description?: Maybe<Scalars['String']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idx_agency_id?: Maybe<Scalars['String']['output']>;
  idx_ftp_client_id?: Maybe<Scalars['String']['output']>;
  instagram_url?: Maybe<Scalars['String']['output']>;
  last_review_scraping?: Maybe<Scalars['timestamptz']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  legal_name?: Maybe<Scalars['String']['output']>;
  linkedin_url?: Maybe<Scalars['String']['output']>;
  listings_agency_names?: Maybe<Array<Scalars['String']['output']>>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  twitter_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
  youtube_url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "teams" */
export type Teams_Max_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  agency_slug?: InputMaybe<Order_By>;
  branding_color?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  cover_photo_image_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  enquiry_email_contact?: InputMaybe<Order_By>;
  facebook_url?: InputMaybe<Order_By>;
  google_business_id?: InputMaybe<Order_By>;
  google_place_description?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idx_agency_id?: InputMaybe<Order_By>;
  idx_ftp_client_id?: InputMaybe<Order_By>;
  instagram_url?: InputMaybe<Order_By>;
  last_review_scraping?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  legal_name?: InputMaybe<Order_By>;
  linkedin_url?: InputMaybe<Order_By>;
  listings_agency_names?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  logo_image_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  twitter_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  website_url?: InputMaybe<Order_By>;
  youtube_url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Teams_Min_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Int']['output']>;
  agency_slug?: Maybe<Scalars['String']['output']>;
  branding_color?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  cover_photo_image_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  enquiry_email_contact?: Maybe<Scalars['String']['output']>;
  facebook_url?: Maybe<Scalars['String']['output']>;
  google_business_id?: Maybe<Scalars['String']['output']>;
  google_place_description?: Maybe<Scalars['String']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idx_agency_id?: Maybe<Scalars['String']['output']>;
  idx_ftp_client_id?: Maybe<Scalars['String']['output']>;
  instagram_url?: Maybe<Scalars['String']['output']>;
  last_review_scraping?: Maybe<Scalars['timestamptz']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  legal_name?: Maybe<Scalars['String']['output']>;
  linkedin_url?: Maybe<Scalars['String']['output']>;
  listings_agency_names?: Maybe<Array<Scalars['String']['output']>>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  twitter_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
  youtube_url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "teams" */
export type Teams_Min_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  agency_slug?: InputMaybe<Order_By>;
  branding_color?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  cover_photo_image_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  enquiry_email_contact?: InputMaybe<Order_By>;
  facebook_url?: InputMaybe<Order_By>;
  google_business_id?: InputMaybe<Order_By>;
  google_place_description?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idx_agency_id?: InputMaybe<Order_By>;
  idx_ftp_client_id?: InputMaybe<Order_By>;
  instagram_url?: InputMaybe<Order_By>;
  last_review_scraping?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  legal_name?: InputMaybe<Order_By>;
  linkedin_url?: InputMaybe<Order_By>;
  listings_agency_names?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  logo_image_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  twitter_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  website_url?: InputMaybe<Order_By>;
  youtube_url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "teams" */
export type Teams_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Teams>;
};

/** input type for inserting object relation for remote table "teams" */
export type Teams_Obj_Rel_Insert_Input = {
  data: Teams_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};

/** on_conflict condition type for table "teams" */
export type Teams_On_Conflict = {
  constraint: Teams_Constraint;
  update_columns?: Array<Teams_Update_Column>;
  where?: InputMaybe<Teams_Bool_Exp>;
};

/** Ordering options when selecting data from "teams". */
export type Teams_Order_By = {
  active_since?: InputMaybe<Order_By>;
  agency_slug?: InputMaybe<Order_By>;
  branding_color?: InputMaybe<Order_By>;
  centroid?: InputMaybe<Order_By>;
  combined_reviews_aggregate?: InputMaybe<Combined_Reviews_Aggregate_Order_By>;
  country?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  cover_photo?: InputMaybe<Images_Order_By>;
  cover_photo_image_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  default_team_users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  do_follow_link?: InputMaybe<Order_By>;
  emails_aggregate?: InputMaybe<Emails_Aggregate_Order_By>;
  enquiries_aggregate?: InputMaybe<Enquiries_Aggregate_Order_By>;
  enquiry_email_contact?: InputMaybe<Order_By>;
  facebook_url?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  google_business_id?: InputMaybe<Order_By>;
  google_place_description?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  google_reviews_aggregate?: InputMaybe<Google_Reviews_Aggregate_Order_By>;
  hide_exact_address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idx_agency_id?: InputMaybe<Order_By>;
  idx_ftp_client_id?: InputMaybe<Order_By>;
  instagram_url?: InputMaybe<Order_By>;
  last_review_scraping?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  legal_name?: InputMaybe<Order_By>;
  linkedin_url?: InputMaybe<Order_By>;
  listings_agency_names?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  logo?: InputMaybe<Images_Order_By>;
  logo_image_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  opening_hours?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisations_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  phone_numbers_aggregate?: InputMaybe<Phone_Numbers_Aggregate_Order_By>;
  places_aggregate?: InputMaybe<Places_Aggregate_Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  property_transactions_aggregate?: InputMaybe<Property_Transactions_Aggregate_Order_By>;
  region_id?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  show_in_agency_pages?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  team_images_aggregate?: InputMaybe<Team_Images_Aggregate_Order_By>;
  teams_portals_aggregate?: InputMaybe<Teams_Portals_Aggregate_Order_By>;
  teams_users_aggregate?: InputMaybe<Teams_Users_Aggregate_Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  tsv?: InputMaybe<Order_By>;
  twitter_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  use_json_for_enquiry_emails?: InputMaybe<Order_By>;
  website_url?: InputMaybe<Order_By>;
  youtube_url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: teams */
export type Teams_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "teams_portals" */
export type Teams_Portals = {
  contract_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  portal: Portals;
  portal_id: Scalars['uuid']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "teams_portals" */
export type Teams_Portals_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Teams_Portals_Max_Order_By>;
  min?: InputMaybe<Teams_Portals_Min_Order_By>;
};

/** input type for inserting array relation for remote table "teams_portals" */
export type Teams_Portals_Arr_Rel_Insert_Input = {
  data: Array<Teams_Portals_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Teams_Portals_On_Conflict>;
};

/** Boolean expression to filter rows from the table "teams_portals". All fields are combined with a logical 'AND'. */
export type Teams_Portals_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_Portals_Bool_Exp>>;
  _not?: InputMaybe<Teams_Portals_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_Portals_Bool_Exp>>;
  contract_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  portal?: InputMaybe<Portals_Bool_Exp>;
  portal_id?: InputMaybe<Uuid_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "teams_portals" */
export enum Teams_Portals_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamsPortalsPkey = 'teams_portals_pkey',
  /** unique or primary key constraint on columns "portal_id", "team_id" */
  TeamsPortalsTeamIdPortalIdKey = 'teams_portals_team_id_portal_id_key'
}

/** input type for inserting data into table "teams_portals" */
export type Teams_Portals_Insert_Input = {
  contract_id?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<Portals_Obj_Rel_Insert_Input>;
  portal_id?: InputMaybe<Scalars['uuid']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "teams_portals" */
export type Teams_Portals_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portal_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "teams_portals" */
export type Teams_Portals_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portal_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "teams_portals" */
export type Teams_Portals_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Teams_Portals>;
};

/** on_conflict condition type for table "teams_portals" */
export type Teams_Portals_On_Conflict = {
  constraint: Teams_Portals_Constraint;
  update_columns?: Array<Teams_Portals_Update_Column>;
  where?: InputMaybe<Teams_Portals_Bool_Exp>;
};

/** Ordering options when selecting data from "teams_portals". */
export type Teams_Portals_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Portals_Order_By>;
  portal_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: teams_portals */
export type Teams_Portals_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "teams_portals" */
export enum Teams_Portals_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PortalId = 'portal_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "teams_portals" */
export type Teams_Portals_Set_Input = {
  contract_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "teams_portals" */
export type Teams_Portals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teams_Portals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teams_Portals_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portal_id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "teams_portals" */
export enum Teams_Portals_Update_Column {
  /** column name */
  ContractId = 'contract_id'
}

export type Teams_Portals_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teams_Portals_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teams_Portals_Bool_Exp;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Teams_Prepend_Input = {
  opening_hours?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "teams_rankings" */
export type Teams_Rankings = {
  distance?: Maybe<Scalars['float8']['output']>;
  payment_amount: Scalars['Int']['output'];
  subscription_status?: Maybe<Scalars['subscription_status']['output']>;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id: Scalars['uuid']['output'];
  total_transactions: Scalars['Int']['output'];
  transactions_in_district?: Maybe<Scalars['Int']['output']>;
  transactions_in_location?: Maybe<Scalars['Int']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Int']['output']>;
  transactions_in_radius?: Maybe<Scalars['Int']['output']>;
  transactions_in_state?: Maybe<Scalars['Int']['output']>;
};

export type Teams_Rankings_Aggregate = {
  aggregate?: Maybe<Teams_Rankings_Aggregate_Fields>;
  nodes: Array<Teams_Rankings>;
};

/** aggregate fields of "teams_rankings" */
export type Teams_Rankings_Aggregate_Fields = {
  avg?: Maybe<Teams_Rankings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Teams_Rankings_Max_Fields>;
  min?: Maybe<Teams_Rankings_Min_Fields>;
  stddev?: Maybe<Teams_Rankings_Stddev_Fields>;
  stddev_pop?: Maybe<Teams_Rankings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Teams_Rankings_Stddev_Samp_Fields>;
  sum?: Maybe<Teams_Rankings_Sum_Fields>;
  var_pop?: Maybe<Teams_Rankings_Var_Pop_Fields>;
  var_samp?: Maybe<Teams_Rankings_Var_Samp_Fields>;
  variance?: Maybe<Teams_Rankings_Variance_Fields>;
};


/** aggregate fields of "teams_rankings" */
export type Teams_Rankings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Teams_Rankings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Teams_Rankings_Avg_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "teams_rankings". All fields are combined with a logical 'AND'. */
export type Teams_Rankings_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_Rankings_Bool_Exp>>;
  _not?: InputMaybe<Teams_Rankings_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_Rankings_Bool_Exp>>;
  distance?: InputMaybe<Float8_Comparison_Exp>;
  payment_amount?: InputMaybe<Int_Comparison_Exp>;
  subscription_status?: InputMaybe<Subscription_Status_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_transactions?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_district?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_location?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_municipality?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_radius?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_state?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Teams_Rankings_Max_Fields = {
  distance?: Maybe<Scalars['float8']['output']>;
  payment_amount?: Maybe<Scalars['Int']['output']>;
  subscription_status?: Maybe<Scalars['subscription_status']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  total_transactions?: Maybe<Scalars['Int']['output']>;
  transactions_in_district?: Maybe<Scalars['Int']['output']>;
  transactions_in_location?: Maybe<Scalars['Int']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Int']['output']>;
  transactions_in_radius?: Maybe<Scalars['Int']['output']>;
  transactions_in_state?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Teams_Rankings_Min_Fields = {
  distance?: Maybe<Scalars['float8']['output']>;
  payment_amount?: Maybe<Scalars['Int']['output']>;
  subscription_status?: Maybe<Scalars['subscription_status']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  total_transactions?: Maybe<Scalars['Int']['output']>;
  transactions_in_district?: Maybe<Scalars['Int']['output']>;
  transactions_in_location?: Maybe<Scalars['Int']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Int']['output']>;
  transactions_in_radius?: Maybe<Scalars['Int']['output']>;
  transactions_in_state?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "teams_rankings". */
export type Teams_Rankings_Order_By = {
  distance?: InputMaybe<Order_By>;
  payment_amount?: InputMaybe<Order_By>;
  subscription_status?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  total_transactions?: InputMaybe<Order_By>;
  transactions_in_district?: InputMaybe<Order_By>;
  transactions_in_location?: InputMaybe<Order_By>;
  transactions_in_municipality?: InputMaybe<Order_By>;
  transactions_in_radius?: InputMaybe<Order_By>;
  transactions_in_state?: InputMaybe<Order_By>;
};

/** select columns of table "teams_rankings" */
export enum Teams_Rankings_Select_Column {
  /** column name */
  Distance = 'distance',
  /** column name */
  PaymentAmount = 'payment_amount',
  /** column name */
  SubscriptionStatus = 'subscription_status',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TotalTransactions = 'total_transactions',
  /** column name */
  TransactionsInDistrict = 'transactions_in_district',
  /** column name */
  TransactionsInLocation = 'transactions_in_location',
  /** column name */
  TransactionsInMunicipality = 'transactions_in_municipality',
  /** column name */
  TransactionsInRadius = 'transactions_in_radius',
  /** column name */
  TransactionsInState = 'transactions_in_state'
}

/** aggregate stddev on columns */
export type Teams_Rankings_Stddev_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Teams_Rankings_Stddev_Pop_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Teams_Rankings_Stddev_Samp_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Teams_Rankings_Sum_Fields = {
  distance?: Maybe<Scalars['float8']['output']>;
  payment_amount?: Maybe<Scalars['Int']['output']>;
  total_transactions?: Maybe<Scalars['Int']['output']>;
  transactions_in_district?: Maybe<Scalars['Int']['output']>;
  transactions_in_location?: Maybe<Scalars['Int']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Int']['output']>;
  transactions_in_radius?: Maybe<Scalars['Int']['output']>;
  transactions_in_state?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Teams_Rankings_Var_Pop_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Teams_Rankings_Var_Samp_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Teams_Rankings_Variance_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "teams" */
export enum Teams_Select_Column {
  /** column name */
  ActiveSince = 'active_since',
  /** column name */
  AgencySlug = 'agency_slug',
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  Centroid = 'centroid',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CoverPhotoImageId = 'cover_photo_image_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DoFollowLink = 'do_follow_link',
  /** column name */
  EnquiryEmailContact = 'enquiry_email_contact',
  /** column name */
  FacebookUrl = 'facebook_url',
  /** column name */
  Geom = 'geom',
  /** column name */
  GoogleBusinessId = 'google_business_id',
  /** column name */
  GooglePlaceDescription = 'google_place_description',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  HideExactAddress = 'hide_exact_address',
  /** column name */
  Id = 'id',
  /** column name */
  IdxAgencyId = 'idx_agency_id',
  /** column name */
  IdxFtpClientId = 'idx_ftp_client_id',
  /** column name */
  InstagramUrl = 'instagram_url',
  /** column name */
  LastReviewScraping = 'last_review_scraping',
  /** column name */
  Lat = 'lat',
  /** column name */
  LegalName = 'legal_name',
  /** column name */
  LinkedinUrl = 'linkedin_url',
  /** column name */
  ListingsAgencyNames = 'listings_agency_names',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LogoImageId = 'logo_image_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  OpeningHours = 'opening_hours',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Route = 'route',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  State = 'state',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Tsv = 'tsv',
  /** column name */
  TwitterUrl = 'twitter_url',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseJsonForEnquiryEmails = 'use_json_for_enquiry_emails',
  /** column name */
  WebsiteUrl = 'website_url',
  /** column name */
  YoutubeUrl = 'youtube_url'
}

/** select "teams_aggregate_bool_exp_bool_and_arguments_columns" columns of table "teams" */
export enum Teams_Select_Column_Teams_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DoFollowLink = 'do_follow_link',
  /** column name */
  HideExactAddress = 'hide_exact_address',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  UseJsonForEnquiryEmails = 'use_json_for_enquiry_emails'
}

/** select "teams_aggregate_bool_exp_bool_or_arguments_columns" columns of table "teams" */
export enum Teams_Select_Column_Teams_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DoFollowLink = 'do_follow_link',
  /** column name */
  HideExactAddress = 'hide_exact_address',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  UseJsonForEnquiryEmails = 'use_json_for_enquiry_emails'
}

/** input type for updating data in table "teams" */
export type Teams_Set_Input = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Scalars['Int']['input']>;
  agency_slug?: InputMaybe<Scalars['String']['input']>;
  branding_color?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  cover_photo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  do_follow_link?: InputMaybe<Scalars['Boolean']['input']>;
  enquiry_email_contact?: InputMaybe<Scalars['String']['input']>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  google_business_id?: InputMaybe<Scalars['String']['input']>;
  google_place_description?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  hide_exact_address?: InputMaybe<Scalars['Boolean']['input']>;
  idx_agency_id?: InputMaybe<Scalars['String']['input']>;
  idx_ftp_client_id?: InputMaybe<Scalars['String']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  legal_name?: InputMaybe<Scalars['String']['input']>;
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  listings_agency_names?: InputMaybe<Array<Scalars['String']['input']>>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opening_hours?: InputMaybe<Scalars['jsonb']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  show_in_agency_pages?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  twitter_url?: InputMaybe<Scalars['String']['input']>;
  use_json_for_enquiry_emails?: InputMaybe<Scalars['Boolean']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
  youtube_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Teams_Stddev_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "teams" */
export type Teams_Stddev_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Teams_Stddev_Pop_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "teams" */
export type Teams_Stddev_Pop_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Teams_Stddev_Samp_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "teams" */
export type Teams_Stddev_Samp_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "teams" */
export type Teams_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teams_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teams_Stream_Cursor_Value_Input = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Scalars['Int']['input']>;
  agency_slug?: InputMaybe<Scalars['String']['input']>;
  branding_color?: InputMaybe<Scalars['String']['input']>;
  centroid?: InputMaybe<Scalars['geometry']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  cover_photo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  district_id?: InputMaybe<Scalars['uuid']['input']>;
  do_follow_link?: InputMaybe<Scalars['Boolean']['input']>;
  enquiry_email_contact?: InputMaybe<Scalars['String']['input']>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  google_business_id?: InputMaybe<Scalars['String']['input']>;
  google_place_description?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  hide_exact_address?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_agency_id?: InputMaybe<Scalars['String']['input']>;
  idx_ftp_client_id?: InputMaybe<Scalars['String']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  last_review_scraping?: InputMaybe<Scalars['timestamptz']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  legal_name?: InputMaybe<Scalars['String']['input']>;
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  listings_agency_names?: InputMaybe<Array<Scalars['String']['input']>>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  opening_hours?: InputMaybe<Scalars['jsonb']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_id?: InputMaybe<Scalars['uuid']['input']>;
  region_id?: InputMaybe<Scalars['uuid']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  show_in_agency_pages?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  tsv?: InputMaybe<Scalars['tsvector']['input']>;
  twitter_url?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_json_for_enquiry_emails?: InputMaybe<Scalars['Boolean']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
  youtube_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Teams_Sum_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "teams" */
export type Teams_Sum_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** update columns of table "teams" */
export enum Teams_Update_Column {
  /** column name */
  ActiveSince = 'active_since',
  /** column name */
  AgencySlug = 'agency_slug',
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CoverPhotoImageId = 'cover_photo_image_id',
  /** column name */
  Description = 'description',
  /** column name */
  DoFollowLink = 'do_follow_link',
  /** column name */
  EnquiryEmailContact = 'enquiry_email_contact',
  /** column name */
  FacebookUrl = 'facebook_url',
  /** column name */
  GoogleBusinessId = 'google_business_id',
  /** column name */
  GooglePlaceDescription = 'google_place_description',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  HideExactAddress = 'hide_exact_address',
  /** column name */
  IdxAgencyId = 'idx_agency_id',
  /** column name */
  IdxFtpClientId = 'idx_ftp_client_id',
  /** column name */
  InstagramUrl = 'instagram_url',
  /** column name */
  Lat = 'lat',
  /** column name */
  LegalName = 'legal_name',
  /** column name */
  LinkedinUrl = 'linkedin_url',
  /** column name */
  ListingsAgencyNames = 'listings_agency_names',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LogoImageId = 'logo_image_id',
  /** column name */
  Name = 'name',
  /** column name */
  OpeningHours = 'opening_hours',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  Route = 'route',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  State = 'state',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  TwitterUrl = 'twitter_url',
  /** column name */
  UseJsonForEnquiryEmails = 'use_json_for_enquiry_emails',
  /** column name */
  WebsiteUrl = 'website_url',
  /** column name */
  YoutubeUrl = 'youtube_url'
}

export type Teams_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Teams_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Teams_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Teams_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Teams_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Teams_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Teams_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teams_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teams_Bool_Exp;
};

/** columns and relationships of "teams_users" */
export type Teams_Users = {
  created_at: Scalars['timestamptz']['output'];
  deactivated: Scalars['Boolean']['output'];
  is_leader: Scalars['Boolean']['output'];
  order_nr: Scalars['Int']['output'];
  /** An object relationship */
  property_transactions?: Maybe<Property_Transactions>;
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  title?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "teams_users" */
export type Teams_Users_Aggregate = {
  aggregate?: Maybe<Teams_Users_Aggregate_Fields>;
  nodes: Array<Teams_Users>;
};

export type Teams_Users_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Teams_Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Teams_Users_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Teams_Users_Aggregate_Bool_Exp_Count>;
};

export type Teams_Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Teams_Users_Select_Column_Teams_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teams_Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Teams_Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Teams_Users_Select_Column_Teams_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teams_Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Teams_Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Teams_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teams_Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "teams_users" */
export type Teams_Users_Aggregate_Fields = {
  avg?: Maybe<Teams_Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Teams_Users_Max_Fields>;
  min?: Maybe<Teams_Users_Min_Fields>;
  stddev?: Maybe<Teams_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Teams_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Teams_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Teams_Users_Sum_Fields>;
  var_pop?: Maybe<Teams_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Teams_Users_Var_Samp_Fields>;
  variance?: Maybe<Teams_Users_Variance_Fields>;
};


/** aggregate fields of "teams_users" */
export type Teams_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Teams_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "teams_users" */
export type Teams_Users_Aggregate_Order_By = {
  avg?: InputMaybe<Teams_Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Teams_Users_Max_Order_By>;
  min?: InputMaybe<Teams_Users_Min_Order_By>;
  stddev?: InputMaybe<Teams_Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Teams_Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Teams_Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Teams_Users_Sum_Order_By>;
  var_pop?: InputMaybe<Teams_Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Teams_Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Teams_Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "teams_users" */
export type Teams_Users_Arr_Rel_Insert_Input = {
  data: Array<Teams_Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Teams_Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Teams_Users_Avg_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "teams_users" */
export type Teams_Users_Avg_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "teams_users". All fields are combined with a logical 'AND'. */
export type Teams_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_Users_Bool_Exp>>;
  _not?: InputMaybe<Teams_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_Users_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated?: InputMaybe<Boolean_Comparison_Exp>;
  is_leader?: InputMaybe<Boolean_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  property_transactions?: InputMaybe<Property_Transactions_Bool_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "teams_users" */
export enum Teams_Users_Constraint {
  /** unique or primary key constraint on columns "user_id", "team_id" */
  TeamUsersTeamIdUserIdIdx = 'team_users_team_id_user_id_idx',
  /** unique or primary key constraint on columns "order_nr", "team_id" */
  UcTeamsUsersOrderNrTeamId = 'uc_teams_users_order_nr_team_id'
}

/** input type for incrementing numeric columns in table "teams_users" */
export type Teams_Users_Inc_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "teams_users" */
export type Teams_Users_Insert_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  property_transactions?: InputMaybe<Property_Transactions_Obj_Rel_Insert_Input>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Teams_Users_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "teams_users" */
export type Teams_Users_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Teams_Users_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "teams_users" */
export type Teams_Users_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "teams_users" */
export type Teams_Users_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Teams_Users>;
};

/** on_conflict condition type for table "teams_users" */
export type Teams_Users_On_Conflict = {
  constraint: Teams_Users_Constraint;
  update_columns?: Array<Teams_Users_Update_Column>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "teams_users". */
export type Teams_Users_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deactivated?: InputMaybe<Order_By>;
  is_leader?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  property_transactions?: InputMaybe<Property_Transactions_Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "teams_users" */
export enum Teams_Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deactivated = 'deactivated',
  /** column name */
  IsLeader = 'is_leader',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'user_id'
}

/** select "teams_users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "teams_users" */
export enum Teams_Users_Select_Column_Teams_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deactivated = 'deactivated',
  /** column name */
  IsLeader = 'is_leader'
}

/** select "teams_users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "teams_users" */
export enum Teams_Users_Select_Column_Teams_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deactivated = 'deactivated',
  /** column name */
  IsLeader = 'is_leader'
}

/** input type for updating data in table "teams_users" */
export type Teams_Users_Set_Input = {
  deactivated?: InputMaybe<Scalars['Boolean']['input']>;
  is_leader?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Teams_Users_Stddev_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "teams_users" */
export type Teams_Users_Stddev_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Teams_Users_Stddev_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "teams_users" */
export type Teams_Users_Stddev_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Teams_Users_Stddev_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "teams_users" */
export type Teams_Users_Stddev_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "teams_users" */
export type Teams_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teams_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teams_Users_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated?: InputMaybe<Scalars['Boolean']['input']>;
  is_leader?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Teams_Users_Sum_Fields = {
  order_nr?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "teams_users" */
export type Teams_Users_Sum_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** update columns of table "teams_users" */
export enum Teams_Users_Update_Column {
  /** column name */
  Deactivated = 'deactivated',
  /** column name */
  IsLeader = 'is_leader',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  Title = 'title'
}

export type Teams_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Teams_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teams_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teams_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Teams_Users_Var_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "teams_users" */
export type Teams_Users_Var_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Teams_Users_Var_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "teams_users" */
export type Teams_Users_Var_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Teams_Users_Variance_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "teams_users" */
export type Teams_Users_Variance_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Teams_Var_Pop_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "teams" */
export type Teams_Var_Pop_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Teams_Var_Samp_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "teams" */
export type Teams_Var_Samp_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Teams_Variance_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "teams" */
export type Teams_Variance_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** columns and relationships of "tenants" */
export type Tenants = {
  activate_land_registry_owners: Scalars['Boolean']['output'];
  activate_model_details: Scalars['Boolean']['output'];
  activate_model_iazi: Scalars['Boolean']['output'];
  activate_model_pricehubble: Scalars['Boolean']['output'];
  activate_model_propertydata: Scalars['Boolean']['output'];
  activate_model_realadvisor_listings: Scalars['Boolean']['output'];
  activate_model_realadvisor_perceived: Scalars['Boolean']['output'];
  activate_model_realadvisor_transactions: Scalars['Boolean']['output'];
  activate_model_wup: Scalars['Boolean']['output'];
  country?: Maybe<Scalars['String']['output']>;
  country_code: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  debug_email_mode: Scalars['Boolean']['output'];
  default_pipeline_id: Scalars['uuid']['output'];
  email_is_verified: Scalars['Boolean']['output'];
  email_sender_email: Scalars['String']['output'];
  email_sender_name: Scalars['String']['output'];
  email_template?: Maybe<Scalars['email_template']['output']>;
  google_place_description?: Maybe<Scalars['String']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  google_tag_manager_id: Scalars['String']['output'];
  help_link_de?: Maybe<Scalars['String']['output']>;
  help_link_en?: Maybe<Scalars['String']['output']>;
  help_link_es?: Maybe<Scalars['String']['output']>;
  help_link_fr?: Maybe<Scalars['String']['output']>;
  help_link_it?: Maybe<Scalars['String']['output']>;
  homepage_url: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  image?: Maybe<Images>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality: Scalars['String']['output'];
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  main_color: Scalars['String']['output'];
  mortgage_rates?: Maybe<Scalars['jsonb']['output']>;
  name: Scalars['String']['output'];
  phone_main: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  resources_de?: Maybe<Scalars['String']['output']>;
  resources_en?: Maybe<Scalars['String']['output']>;
  resources_es?: Maybe<Scalars['String']['output']>;
  resources_fr?: Maybe<Scalars['String']['output']>;
  resources_it?: Maybe<Scalars['String']['output']>;
  route: Scalars['String']['output'];
  send_in_blue_api_key?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street_number: Scalars['String']['output'];
  stripe_secret_key?: Maybe<Scalars['String']['output']>;
  stripe_secret_key_test?: Maybe<Scalars['String']['output']>;
  stripe_webhook_secret?: Maybe<Scalars['String']['output']>;
  stripe_webhook_secret_test?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
};


/** columns and relationships of "tenants" */
export type TenantsMortgage_RatesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tenants" */
export type TenantsUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "tenants" */
export type Tenants_Aggregate = {
  aggregate?: Maybe<Tenants_Aggregate_Fields>;
  nodes: Array<Tenants>;
};

/** aggregate fields of "tenants" */
export type Tenants_Aggregate_Fields = {
  avg?: Maybe<Tenants_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tenants_Max_Fields>;
  min?: Maybe<Tenants_Min_Fields>;
  stddev?: Maybe<Tenants_Stddev_Fields>;
  stddev_pop?: Maybe<Tenants_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tenants_Stddev_Samp_Fields>;
  sum?: Maybe<Tenants_Sum_Fields>;
  var_pop?: Maybe<Tenants_Var_Pop_Fields>;
  var_samp?: Maybe<Tenants_Var_Samp_Fields>;
  variance?: Maybe<Tenants_Variance_Fields>;
};


/** aggregate fields of "tenants" */
export type Tenants_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Tenants_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "tenants". All fields are combined with a logical 'AND'. */
export type Tenants_Bool_Exp = {
  _and?: InputMaybe<Array<Tenants_Bool_Exp>>;
  _not?: InputMaybe<Tenants_Bool_Exp>;
  _or?: InputMaybe<Array<Tenants_Bool_Exp>>;
  activate_land_registry_owners?: InputMaybe<Boolean_Comparison_Exp>;
  activate_model_details?: InputMaybe<Boolean_Comparison_Exp>;
  activate_model_iazi?: InputMaybe<Boolean_Comparison_Exp>;
  activate_model_pricehubble?: InputMaybe<Boolean_Comparison_Exp>;
  activate_model_propertydata?: InputMaybe<Boolean_Comparison_Exp>;
  activate_model_realadvisor_listings?: InputMaybe<Boolean_Comparison_Exp>;
  activate_model_realadvisor_perceived?: InputMaybe<Boolean_Comparison_Exp>;
  activate_model_realadvisor_transactions?: InputMaybe<Boolean_Comparison_Exp>;
  activate_model_wup?: InputMaybe<Boolean_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  debug_email_mode?: InputMaybe<Boolean_Comparison_Exp>;
  default_pipeline_id?: InputMaybe<Uuid_Comparison_Exp>;
  email_is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  email_sender_email?: InputMaybe<String_Comparison_Exp>;
  email_sender_name?: InputMaybe<String_Comparison_Exp>;
  email_template?: InputMaybe<Email_Template_Comparison_Exp>;
  google_place_description?: InputMaybe<String_Comparison_Exp>;
  google_place_id?: InputMaybe<String_Comparison_Exp>;
  google_tag_manager_id?: InputMaybe<String_Comparison_Exp>;
  help_link_de?: InputMaybe<String_Comparison_Exp>;
  help_link_en?: InputMaybe<String_Comparison_Exp>;
  help_link_es?: InputMaybe<String_Comparison_Exp>;
  help_link_fr?: InputMaybe<String_Comparison_Exp>;
  help_link_it?: InputMaybe<String_Comparison_Exp>;
  homepage_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<Images_Bool_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  logo_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  main_color?: InputMaybe<String_Comparison_Exp>;
  mortgage_rates?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone_main?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  resources_de?: InputMaybe<String_Comparison_Exp>;
  resources_en?: InputMaybe<String_Comparison_Exp>;
  resources_es?: InputMaybe<String_Comparison_Exp>;
  resources_fr?: InputMaybe<String_Comparison_Exp>;
  resources_it?: InputMaybe<String_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  send_in_blue_api_key?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  stripe_secret_key?: InputMaybe<String_Comparison_Exp>;
  stripe_secret_key_test?: InputMaybe<String_Comparison_Exp>;
  stripe_webhook_secret?: InputMaybe<String_Comparison_Exp>;
  stripe_webhook_secret_test?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
  users_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "tenants" */
export type Tenants_Inc_Input = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate max on columns */
export type Tenants_Max_Fields = {
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  default_pipeline_id?: Maybe<Scalars['uuid']['output']>;
  email_sender_email?: Maybe<Scalars['String']['output']>;
  email_sender_name?: Maybe<Scalars['String']['output']>;
  email_template?: Maybe<Scalars['email_template']['output']>;
  google_place_description?: Maybe<Scalars['String']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  google_tag_manager_id?: Maybe<Scalars['String']['output']>;
  help_link_de?: Maybe<Scalars['String']['output']>;
  help_link_en?: Maybe<Scalars['String']['output']>;
  help_link_es?: Maybe<Scalars['String']['output']>;
  help_link_fr?: Maybe<Scalars['String']['output']>;
  help_link_it?: Maybe<Scalars['String']['output']>;
  homepage_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  main_color?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_main?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  resources_de?: Maybe<Scalars['String']['output']>;
  resources_en?: Maybe<Scalars['String']['output']>;
  resources_es?: Maybe<Scalars['String']['output']>;
  resources_fr?: Maybe<Scalars['String']['output']>;
  resources_it?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  send_in_blue_api_key?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  stripe_secret_key?: Maybe<Scalars['String']['output']>;
  stripe_secret_key_test?: Maybe<Scalars['String']['output']>;
  stripe_webhook_secret?: Maybe<Scalars['String']['output']>;
  stripe_webhook_secret_test?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Tenants_Min_Fields = {
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  default_pipeline_id?: Maybe<Scalars['uuid']['output']>;
  email_sender_email?: Maybe<Scalars['String']['output']>;
  email_sender_name?: Maybe<Scalars['String']['output']>;
  email_template?: Maybe<Scalars['email_template']['output']>;
  google_place_description?: Maybe<Scalars['String']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  google_tag_manager_id?: Maybe<Scalars['String']['output']>;
  help_link_de?: Maybe<Scalars['String']['output']>;
  help_link_en?: Maybe<Scalars['String']['output']>;
  help_link_es?: Maybe<Scalars['String']['output']>;
  help_link_fr?: Maybe<Scalars['String']['output']>;
  help_link_it?: Maybe<Scalars['String']['output']>;
  homepage_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  main_color?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_main?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  resources_de?: Maybe<Scalars['String']['output']>;
  resources_en?: Maybe<Scalars['String']['output']>;
  resources_es?: Maybe<Scalars['String']['output']>;
  resources_fr?: Maybe<Scalars['String']['output']>;
  resources_it?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  send_in_blue_api_key?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  stripe_secret_key?: Maybe<Scalars['String']['output']>;
  stripe_secret_key_test?: Maybe<Scalars['String']['output']>;
  stripe_webhook_secret?: Maybe<Scalars['String']['output']>;
  stripe_webhook_secret_test?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "tenants" */
export type Tenants_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenants>;
};

/** Ordering options when selecting data from "tenants". */
export type Tenants_Order_By = {
  activate_land_registry_owners?: InputMaybe<Order_By>;
  activate_model_details?: InputMaybe<Order_By>;
  activate_model_iazi?: InputMaybe<Order_By>;
  activate_model_pricehubble?: InputMaybe<Order_By>;
  activate_model_propertydata?: InputMaybe<Order_By>;
  activate_model_realadvisor_listings?: InputMaybe<Order_By>;
  activate_model_realadvisor_perceived?: InputMaybe<Order_By>;
  activate_model_realadvisor_transactions?: InputMaybe<Order_By>;
  activate_model_wup?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  debug_email_mode?: InputMaybe<Order_By>;
  default_pipeline_id?: InputMaybe<Order_By>;
  email_is_verified?: InputMaybe<Order_By>;
  email_sender_email?: InputMaybe<Order_By>;
  email_sender_name?: InputMaybe<Order_By>;
  email_template?: InputMaybe<Order_By>;
  google_place_description?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  google_tag_manager_id?: InputMaybe<Order_By>;
  help_link_de?: InputMaybe<Order_By>;
  help_link_en?: InputMaybe<Order_By>;
  help_link_es?: InputMaybe<Order_By>;
  help_link_fr?: InputMaybe<Order_By>;
  help_link_it?: InputMaybe<Order_By>;
  homepage_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Images_Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  logo_image_id?: InputMaybe<Order_By>;
  main_color?: InputMaybe<Order_By>;
  mortgage_rates?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone_main?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  resources_de?: InputMaybe<Order_By>;
  resources_en?: InputMaybe<Order_By>;
  resources_es?: InputMaybe<Order_By>;
  resources_fr?: InputMaybe<Order_By>;
  resources_it?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  send_in_blue_api_key?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  stripe_secret_key?: InputMaybe<Order_By>;
  stripe_secret_key_test?: InputMaybe<Order_By>;
  stripe_webhook_secret?: InputMaybe<Order_By>;
  stripe_webhook_secret_test?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
};

/** primary key columns input for table: tenants */
export type Tenants_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "tenants" */
export enum Tenants_Select_Column {
  /** column name */
  ActivateLandRegistryOwners = 'activate_land_registry_owners',
  /** column name */
  ActivateModelDetails = 'activate_model_details',
  /** column name */
  ActivateModelIazi = 'activate_model_iazi',
  /** column name */
  ActivateModelPricehubble = 'activate_model_pricehubble',
  /** column name */
  ActivateModelPropertydata = 'activate_model_propertydata',
  /** column name */
  ActivateModelRealadvisorListings = 'activate_model_realadvisor_listings',
  /** column name */
  ActivateModelRealadvisorPerceived = 'activate_model_realadvisor_perceived',
  /** column name */
  ActivateModelRealadvisorTransactions = 'activate_model_realadvisor_transactions',
  /** column name */
  ActivateModelWup = 'activate_model_wup',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DebugEmailMode = 'debug_email_mode',
  /** column name */
  DefaultPipelineId = 'default_pipeline_id',
  /** column name */
  EmailIsVerified = 'email_is_verified',
  /** column name */
  EmailSenderEmail = 'email_sender_email',
  /** column name */
  EmailSenderName = 'email_sender_name',
  /** column name */
  EmailTemplate = 'email_template',
  /** column name */
  GooglePlaceDescription = 'google_place_description',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  GoogleTagManagerId = 'google_tag_manager_id',
  /** column name */
  HelpLinkDe = 'help_link_de',
  /** column name */
  HelpLinkEn = 'help_link_en',
  /** column name */
  HelpLinkEs = 'help_link_es',
  /** column name */
  HelpLinkFr = 'help_link_fr',
  /** column name */
  HelpLinkIt = 'help_link_it',
  /** column name */
  HomepageUrl = 'homepage_url',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LogoImageId = 'logo_image_id',
  /** column name */
  MainColor = 'main_color',
  /** column name */
  MortgageRates = 'mortgage_rates',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneMain = 'phone_main',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  ResourcesDe = 'resources_de',
  /** column name */
  ResourcesEn = 'resources_en',
  /** column name */
  ResourcesEs = 'resources_es',
  /** column name */
  ResourcesFr = 'resources_fr',
  /** column name */
  ResourcesIt = 'resources_it',
  /** column name */
  Route = 'route',
  /** column name */
  SendInBlueApiKey = 'send_in_blue_api_key',
  /** column name */
  Slug = 'slug',
  /** column name */
  State = 'state',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  StripeSecretKey = 'stripe_secret_key',
  /** column name */
  StripeSecretKeyTest = 'stripe_secret_key_test',
  /** column name */
  StripeWebhookSecret = 'stripe_webhook_secret',
  /** column name */
  StripeWebhookSecretTest = 'stripe_webhook_secret_test',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "tenants" */
export type Tenants_Set_Input = {
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  google_place_description?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  main_color?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Tenants_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Tenants_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Tenants_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "tenants" */
export type Tenants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenants_Stream_Cursor_Value_Input = {
  activate_land_registry_owners?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_details?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_iazi?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_pricehubble?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_propertydata?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_realadvisor_listings?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_realadvisor_perceived?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_realadvisor_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_wup?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  debug_email_mode?: InputMaybe<Scalars['Boolean']['input']>;
  default_pipeline_id?: InputMaybe<Scalars['uuid']['input']>;
  email_is_verified?: InputMaybe<Scalars['Boolean']['input']>;
  email_sender_email?: InputMaybe<Scalars['String']['input']>;
  email_sender_name?: InputMaybe<Scalars['String']['input']>;
  email_template?: InputMaybe<Scalars['email_template']['input']>;
  google_place_description?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  google_tag_manager_id?: InputMaybe<Scalars['String']['input']>;
  help_link_de?: InputMaybe<Scalars['String']['input']>;
  help_link_en?: InputMaybe<Scalars['String']['input']>;
  help_link_es?: InputMaybe<Scalars['String']['input']>;
  help_link_fr?: InputMaybe<Scalars['String']['input']>;
  help_link_it?: InputMaybe<Scalars['String']['input']>;
  homepage_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  main_color?: InputMaybe<Scalars['String']['input']>;
  mortgage_rates?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_main?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  resources_de?: InputMaybe<Scalars['String']['input']>;
  resources_en?: InputMaybe<Scalars['String']['input']>;
  resources_es?: InputMaybe<Scalars['String']['input']>;
  resources_fr?: InputMaybe<Scalars['String']['input']>;
  resources_it?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  send_in_blue_api_key?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  stripe_secret_key?: InputMaybe<Scalars['String']['input']>;
  stripe_secret_key_test?: InputMaybe<Scalars['String']['input']>;
  stripe_webhook_secret?: InputMaybe<Scalars['String']['input']>;
  stripe_webhook_secret_test?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Tenants_Sum_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type Tenants_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tenants_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenants_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenants_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tenants_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Tenants_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Tenants_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "third_pillar_organisation_type_a". All fields are combined with logical 'AND'. */
export type Third_Pillar_Organisation_Type_A_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _gt?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _gte?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _in?: InputMaybe<Array<Scalars['third_pillar_organisation_type_a']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _lte?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _neq?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _nin?: InputMaybe<Array<Scalars['third_pillar_organisation_type_a']['input']>>;
};

/** Boolean expression to compare columns of type "third_pillar_organisation_type_b". All fields are combined with logical 'AND'. */
export type Third_Pillar_Organisation_Type_B_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _gt?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _gte?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _in?: InputMaybe<Array<Scalars['third_pillar_organisation_type_b']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _lte?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _neq?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _nin?: InputMaybe<Array<Scalars['third_pillar_organisation_type_b']['input']>>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "transaction_buyers" */
export type Transaction_Buyers = {
  /** An object relationship */
  property_transaction?: Maybe<Property_Transactions>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "transaction_buyers" */
export type Transaction_Buyers_Aggregate = {
  aggregate?: Maybe<Transaction_Buyers_Aggregate_Fields>;
  nodes: Array<Transaction_Buyers>;
};

export type Transaction_Buyers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Transaction_Buyers_Aggregate_Bool_Exp_Count>;
};

export type Transaction_Buyers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Transaction_Buyers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Transaction_Buyers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "transaction_buyers" */
export type Transaction_Buyers_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Transaction_Buyers_Max_Fields>;
  min?: Maybe<Transaction_Buyers_Min_Fields>;
};


/** aggregate fields of "transaction_buyers" */
export type Transaction_Buyers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transaction_Buyers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "transaction_buyers" */
export type Transaction_Buyers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Transaction_Buyers_Max_Order_By>;
  min?: InputMaybe<Transaction_Buyers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "transaction_buyers" */
export type Transaction_Buyers_Arr_Rel_Insert_Input = {
  data: Array<Transaction_Buyers_Insert_Input>;
};

/** Boolean expression to filter rows from the table "transaction_buyers". All fields are combined with a logical 'AND'. */
export type Transaction_Buyers_Bool_Exp = {
  _and?: InputMaybe<Array<Transaction_Buyers_Bool_Exp>>;
  _not?: InputMaybe<Transaction_Buyers_Bool_Exp>;
  _or?: InputMaybe<Array<Transaction_Buyers_Bool_Exp>>;
  property_transaction?: InputMaybe<Property_Transactions_Bool_Exp>;
  transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "transaction_buyers" */
export type Transaction_Buyers_Insert_Input = {
  property_transaction?: InputMaybe<Property_Transactions_Obj_Rel_Insert_Input>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Transaction_Buyers_Max_Fields = {
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "transaction_buyers" */
export type Transaction_Buyers_Max_Order_By = {
  transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Transaction_Buyers_Min_Fields = {
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "transaction_buyers" */
export type Transaction_Buyers_Min_Order_By = {
  transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "transaction_buyers" */
export type Transaction_Buyers_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Transaction_Buyers>;
};

/** Ordering options when selecting data from "transaction_buyers". */
export type Transaction_Buyers_Order_By = {
  property_transaction?: InputMaybe<Property_Transactions_Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "transaction_buyers" */
export enum Transaction_Buyers_Select_Column {
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "transaction_sellers" */
export type Transaction_Sellers = {
  /** An object relationship */
  property_transaction?: Maybe<Property_Transactions>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "transaction_sellers" */
export type Transaction_Sellers_Aggregate = {
  aggregate?: Maybe<Transaction_Sellers_Aggregate_Fields>;
  nodes: Array<Transaction_Sellers>;
};

export type Transaction_Sellers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Transaction_Sellers_Aggregate_Bool_Exp_Count>;
};

export type Transaction_Sellers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Transaction_Sellers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Transaction_Sellers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "transaction_sellers" */
export type Transaction_Sellers_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Transaction_Sellers_Max_Fields>;
  min?: Maybe<Transaction_Sellers_Min_Fields>;
};


/** aggregate fields of "transaction_sellers" */
export type Transaction_Sellers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transaction_Sellers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "transaction_sellers" */
export type Transaction_Sellers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Transaction_Sellers_Max_Order_By>;
  min?: InputMaybe<Transaction_Sellers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "transaction_sellers" */
export type Transaction_Sellers_Arr_Rel_Insert_Input = {
  data: Array<Transaction_Sellers_Insert_Input>;
};

/** Boolean expression to filter rows from the table "transaction_sellers". All fields are combined with a logical 'AND'. */
export type Transaction_Sellers_Bool_Exp = {
  _and?: InputMaybe<Array<Transaction_Sellers_Bool_Exp>>;
  _not?: InputMaybe<Transaction_Sellers_Bool_Exp>;
  _or?: InputMaybe<Array<Transaction_Sellers_Bool_Exp>>;
  property_transaction?: InputMaybe<Property_Transactions_Bool_Exp>;
  transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "transaction_sellers" */
export type Transaction_Sellers_Insert_Input = {
  property_transaction?: InputMaybe<Property_Transactions_Obj_Rel_Insert_Input>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Transaction_Sellers_Max_Fields = {
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "transaction_sellers" */
export type Transaction_Sellers_Max_Order_By = {
  transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Transaction_Sellers_Min_Fields = {
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "transaction_sellers" */
export type Transaction_Sellers_Min_Order_By = {
  transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "transaction_sellers" */
export type Transaction_Sellers_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Transaction_Sellers>;
};

/** Ordering options when selecting data from "transaction_sellers". */
export type Transaction_Sellers_Order_By = {
  property_transaction?: InputMaybe<Property_Transactions_Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "transaction_sellers" */
export enum Transaction_Sellers_Select_Column {
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UserId = 'user_id'
}

export enum Travel_Modes_Enum_Enum {
  Cycling = 'cycling',
  Driving = 'driving',
  Walking = 'walking'
}

/** Boolean expression to compare columns of type "travel_modes_enum_enum". All fields are combined with logical 'AND'. */
export type Travel_Modes_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Travel_Modes_Enum_Enum>;
  _in?: InputMaybe<Array<Travel_Modes_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Travel_Modes_Enum_Enum>;
  _nin?: InputMaybe<Array<Travel_Modes_Enum_Enum>>;
};

/** Boolean expression to compare columns of type "tsvector". All fields are combined with logical 'AND'. */
export type Tsvector_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['tsvector']['input']>;
  _gt?: InputMaybe<Scalars['tsvector']['input']>;
  _gte?: InputMaybe<Scalars['tsvector']['input']>;
  _in?: InputMaybe<Array<Scalars['tsvector']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['tsvector']['input']>;
  _lte?: InputMaybe<Scalars['tsvector']['input']>;
  _neq?: InputMaybe<Scalars['tsvector']['input']>;
  _nin?: InputMaybe<Array<Scalars['tsvector']['input']>>;
};

/** columns and relationships of "user_images" */
export type User_Images = {
  id: Scalars['uuid']['output'];
  /** An object relationship */
  image: Images;
  image_id: Scalars['uuid']['output'];
  is_primary?: Maybe<Scalars['Boolean']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "user_images" */
export type User_Images_Aggregate_Order_By = {
  avg?: InputMaybe<User_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Images_Max_Order_By>;
  min?: InputMaybe<User_Images_Min_Order_By>;
  stddev?: InputMaybe<User_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Images_Sum_Order_By>;
  var_pop?: InputMaybe<User_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Images_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_images" */
export type User_Images_Arr_Rel_Insert_Input = {
  data: Array<User_Images_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Images_On_Conflict>;
};

/** order by avg() on columns of table "user_images" */
export type User_Images_Avg_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_images". All fields are combined with a logical 'AND'. */
export type User_Images_Bool_Exp = {
  _and?: InputMaybe<Array<User_Images_Bool_Exp>>;
  _not?: InputMaybe<User_Images_Bool_Exp>;
  _or?: InputMaybe<Array<User_Images_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<Images_Bool_Exp>;
  image_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_primary?: InputMaybe<Boolean_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_images" */
export enum User_Images_Constraint {
  /** unique or primary key constraint on columns "user_id", "is_primary" */
  IdxUserImagesUserIdIsPrimary = 'idx_user_images_user_id_is_primary',
  /** unique or primary key constraint on columns "id" */
  UserImagesIdKey = 'user_images_id_key',
  /** unique or primary key constraint on columns "id" */
  UserImagesPkey = 'user_images_pkey',
  /** unique or primary key constraint on columns "user_id", "image_id" */
  UserImagesUserIdImageIdUnique = 'user_images_user_id_image_id_unique'
}

/** input type for incrementing numeric columns in table "user_images" */
export type User_Images_Inc_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_images" */
export type User_Images_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "user_images" */
export type User_Images_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user_images" */
export type User_Images_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_images" */
export type User_Images_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Images>;
};

/** on_conflict condition type for table "user_images" */
export type User_Images_On_Conflict = {
  constraint: User_Images_Constraint;
  update_columns?: Array<User_Images_Update_Column>;
  where?: InputMaybe<User_Images_Bool_Exp>;
};

/** Ordering options when selecting data from "user_images". */
export type User_Images_Order_By = {
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Images_Order_By>;
  image_id?: InputMaybe<Order_By>;
  is_primary?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_images */
export type User_Images_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_images" */
export enum User_Images_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_images" */
export type User_Images_Set_Input = {
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** order by stddev() on columns of table "user_images" */
export type User_Images_Stddev_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "user_images" */
export type User_Images_Stddev_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "user_images" */
export type User_Images_Stddev_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_images" */
export type User_Images_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Images_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Images_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "user_images" */
export type User_Images_Sum_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** update columns of table "user_images" */
export enum User_Images_Update_Column {
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrderNr = 'order_nr'
}

export type User_Images_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Images_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Images_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Images_Bool_Exp;
};

/** order by var_pop() on columns of table "user_images" */
export type User_Images_Var_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "user_images" */
export type User_Images_Var_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "user_images" */
export type User_Images_Variance_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "user_language". All fields are combined with logical 'AND'. */
export type User_Language_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['user_language']['input']>;
  _gt?: InputMaybe<Scalars['user_language']['input']>;
  _gte?: InputMaybe<Scalars['user_language']['input']>;
  _in?: InputMaybe<Array<Scalars['user_language']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['user_language']['input']>;
  _lte?: InputMaybe<Scalars['user_language']['input']>;
  _neq?: InputMaybe<Scalars['user_language']['input']>;
  _nin?: InputMaybe<Array<Scalars['user_language']['input']>>;
};

export type User_Primary_Phone_Args = {
  user_row?: InputMaybe<Scalars['users_scalar']['input']>;
};

/** Boolean expression to compare columns of type "user_professional_situation". All fields are combined with logical 'AND'. */
export type User_Professional_Situation_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _gt?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _gte?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _in?: InputMaybe<Array<Scalars['user_professional_situation']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _lte?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _neq?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _nin?: InputMaybe<Array<Scalars['user_professional_situation']['input']>>;
};

/** columns and relationships of "users" */
export type Users = {
  /** An object relationship */
  account_manager?: Maybe<Users>;
  account_manager_id?: Maybe<Scalars['uuid']['output']>;
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  activities: Array<Activities>;
  /** An aggregate relationship */
  activities_aggregate: Activities_Aggregate;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  agent_slug?: Maybe<Scalars['String']['output']>;
  annual_costs_child_support?: Maybe<Scalars['float8']['output']>;
  annual_costs_leasing?: Maybe<Scalars['float8']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['float8']['output']>;
  annual_credits?: Maybe<Array<Scalars['jsonb']['output']>>;
  annual_credits_exist?: Maybe<Scalars['Boolean']['output']>;
  annual_income_additional_exist?: Maybe<Scalars['Boolean']['output']>;
  annual_income_bonus?: Maybe<Scalars['float8']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['float8']['output']>;
  annual_income_other?: Maybe<Scalars['float8']['output']>;
  annual_income_rent?: Maybe<Scalars['float8']['output']>;
  annual_income_salary?: Maybe<Scalars['Int']['output']>;
  annual_income_salary13?: Maybe<Scalars['Boolean']['output']>;
  annual_income_salary14?: Maybe<Scalars['Boolean']['output']>;
  annual_leasings?: Maybe<Array<Scalars['jsonb']['output']>>;
  annual_leasings_exist?: Maybe<Scalars['Boolean']['output']>;
  annual_other_exist?: Maybe<Scalars['Boolean']['output']>;
  annual_other_payments?: Maybe<Array<Scalars['float8']['output']>>;
  assets_savings?: Maybe<Scalars['Int']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Int']['output']>;
  assets_second_pillar_exist?: Maybe<Scalars['Boolean']['output']>;
  assets_second_pillar_organisation?: Maybe<Scalars['String']['output']>;
  assets_securities?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Int']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium_organization?: Maybe<Scalars['String']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a_exist?: Maybe<Scalars['Boolean']['output']>;
  assets_third_pillar_a_life_insurance?: Maybe<Scalars['Boolean']['output']>;
  assets_third_pillar_a_organisation?: Maybe<Scalars['String']['output']>;
  assets_third_pillar_a_organisation_type?: Maybe<Scalars['third_pillar_organisation_type_a']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_exist?: Maybe<Scalars['Boolean']['output']>;
  assets_third_pillar_b_life_insurance?: Maybe<Scalars['Boolean']['output']>;
  assets_third_pillar_b_organisation?: Maybe<Scalars['String']['output']>;
  assets_third_pillar_b_organisation_type?: Maybe<Scalars['third_pillar_organisation_type_b']['output']>;
  assets_third_pillar_exist?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  assigned_activities: Array<Activities>;
  /** An aggregate relationship */
  assigned_activities_aggregate: Activities_Aggregate;
  auto_assign_leads?: Maybe<Scalars['Boolean']['output']>;
  branding_color?: Maybe<Scalars['String']['output']>;
  branding_logo?: Maybe<Scalars['String']['output']>;
  branding_name?: Maybe<Scalars['String']['output']>;
  branding_website?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  broker?: Maybe<Users>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  broker_leads: Array<Leads>;
  /** An aggregate relationship */
  broker_leads_aggregate: Leads_Aggregate;
  /** An array relationship */
  buyer_leads: Array<Buyer_Leads>;
  /** An aggregate relationship */
  buyer_leads_aggregate: Buyer_Leads_Aggregate;
  /** An array relationship */
  buyer_offers: Array<Offers>;
  /** An aggregate relationship */
  buyer_offers_aggregate: Offers_Aggregate;
  can_edit_settings?: Maybe<Scalars['Boolean']['output']>;
  can_user_login_as: Scalars['Boolean']['output'];
  /** An array relationship */
  catchment_areas: Array<Catchment_Areas>;
  /** An aggregate relationship */
  catchment_areas_aggregate: Catchment_Areas_Aggregate;
  certifications?: Maybe<Array<Scalars['String']['output']>>;
  /** An array relationship */
  combined_reviews: Array<Combined_Reviews>;
  /** An aggregate relationship */
  combined_reviews_aggregate: Combined_Reviews_Aggregate;
  /** An array relationship */
  created_activities: Array<Activities>;
  /** An aggregate relationship */
  created_activities_aggregate: Activities_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  creator?: Maybe<Users>;
  /** A computed field, executes function "users_crm_link" */
  crm_link?: Maybe<Scalars['String']['output']>;
  date_of_birth?: Maybe<Scalars['date']['output']>;
  debt?: Maybe<Scalars['Int']['output']>;
  debt_leasing_balance?: Maybe<Scalars['float8']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['float8']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  default_team?: Maybe<Teams>;
  default_team_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  divorce_date?: Maybe<Scalars['date']['output']>;
  donation?: Maybe<Scalars['float8']['output']>;
  email_signature?: Maybe<Scalars['String']['output']>;
  email_signature_html?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  emails: Array<Emails>;
  employer?: Maybe<Scalars['String']['output']>;
  employer_id?: Maybe<Scalars['uuid']['output']>;
  employment_commencement_date?: Maybe<Scalars['date']['output']>;
  employment_rate?: Maybe<Scalars['float8']['output']>;
  /** An array relationship */
  enquiries: Array<Enquiries>;
  /** An aggregate relationship */
  enquiries_aggregate: Enquiries_Aggregate;
  facebook_profile?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  has_accepted_terms: Scalars['Boolean']['output'];
  has_children?: Maybe<Scalars['Boolean']['output']>;
  has_free_crm_access: Scalars['Boolean']['output'];
  has_used_trial_button: Scalars['Boolean']['output'];
  hires_on_realadvisor?: Maybe<Scalars['Int']['output']>;
  home_address_country_code?: Maybe<Scalars['String']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  home_address_locality?: Maybe<Scalars['String']['output']>;
  home_address_postcode?: Maybe<Scalars['String']['output']>;
  home_address_route?: Maybe<Scalars['String']['output']>;
  home_address_state?: Maybe<Scalars['String']['output']>;
  home_address_street_number?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  identification_document_expiry_date?: Maybe<Scalars['date']['output']>;
  identification_document_issue_date?: Maybe<Scalars['date']['output']>;
  identification_document_number?: Maybe<Scalars['String']['output']>;
  identification_document_type_id?: Maybe<Scalars['uuid']['output']>;
  imported_id?: Maybe<Scalars['String']['output']>;
  instagram_profile?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "generate_intercom_hash" */
  intercom_hash?: Maybe<Scalars['String']['output']>;
  is_admin: Scalars['Boolean']['output'];
  is_bot: Scalars['Boolean']['output'];
  is_broker: Scalars['Boolean']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_mortgage_broker: Scalars['Boolean']['output'];
  job_title?: Maybe<Scalars['String']['output']>;
  landing_page_url?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['user_language']['output']>;
  languages?: Maybe<Array<Scalars['String']['output']>>;
  last_bonus?: Maybe<Scalars['float8']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  lead_agents: Array<Lead_Agents>;
  /** An aggregate relationship */
  lead_agents_aggregate: Lead_Agents_Aggregate;
  /** An array relationship */
  leads: Array<Leads>;
  /** An aggregate relationship */
  leads_aggregate: Leads_Aggregate;
  linked_in_profile?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  logins: Array<Logins>;
  /** An array relationship */
  lot_sellers: Array<Lot_Sellers>;
  /** An aggregate relationship */
  lot_sellers_aggregate: Lot_Sellers_Aggregate;
  /** An array relationship */
  lots: Array<Lots>;
  /** An aggregate relationship */
  lots_aggregate: Lots_Aggregate;
  marital_partner_id?: Maybe<Scalars['uuid']['output']>;
  marital_status?: Maybe<Scalars['marital_status']['output']>;
  matrimonial_regime?: Maybe<Scalars['String']['output']>;
  membership_type?: Maybe<Scalars['String']['output']>;
  modules?: Maybe<Array<Scalars['String']['output']>>;
  mortgage_broker_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  nationality?: Maybe<Dictionaries>;
  nationality_id?: Maybe<Scalars['uuid']['output']>;
  number_of_buyers: Scalars['Int']['output'];
  number_of_dependant_children?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  nylas_account_config: Array<Nylas_Account_Configs>;
  occupation_id?: Maybe<Scalars['uuid']['output']>;
  occupation_text?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organisation?: Maybe<Organisations>;
  /** An object relationship */
  organisation_user?: Maybe<Organisation_Users>;
  /** An array relationship */
  payments: Array<Payments>;
  /** An array relationship */
  phone_numbers: Array<Phone_Numbers>;
  /** An aggregate relationship */
  phone_numbers_aggregate: Phone_Numbers_Aggregate;
  place_of_origin?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "user_primary_phone" */
  primary_phone_number?: Maybe<Array<Phone_Numbers>>;
  professional_address_country_code?: Maybe<Scalars['String']['output']>;
  professional_address_lat?: Maybe<Scalars['float8']['output']>;
  professional_address_lng?: Maybe<Scalars['float8']['output']>;
  professional_address_locality?: Maybe<Scalars['String']['output']>;
  professional_address_postcode?: Maybe<Scalars['String']['output']>;
  professional_address_route?: Maybe<Scalars['String']['output']>;
  professional_address_state?: Maybe<Scalars['String']['output']>;
  professional_address_street_number?: Maybe<Scalars['String']['output']>;
  professional_situation?: Maybe<Scalars['user_professional_situation']['output']>;
  properties_exist?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  property_searches: Array<Property_Searches>;
  /** An aggregate relationship */
  property_searches_aggregate: Property_Searches_Aggregate;
  /** An array relationship */
  property_transactions: Array<Property_Transactions>;
  /** An aggregate relationship */
  property_transactions_aggregate: Property_Transactions_Aggregate;
  /** An array relationship */
  push_notification_tokens: Array<Push_Notification_Tokens>;
  recommended_listings: Scalars['Boolean']['output'];
  referrer?: Maybe<Scalars['String']['output']>;
  referring_domain?: Maybe<Scalars['String']['output']>;
  registered_at?: Maybe<Scalars['timestamptz']['output']>;
  residence_country_code?: Maybe<Scalars['String']['output']>;
  residence_state_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  reviews: Array<Reviews>;
  /** An aggregate relationship */
  reviews_aggregate: Reviews_Aggregate;
  second_pillar_organisation_id?: Maybe<Scalars['uuid']['output']>;
  services?: Maybe<Array<Scalars['String']['output']>>;
  show_in_agency_pages?: Maybe<Scalars['Boolean']['output']>;
  social_security_number?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  team_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  teams_users: Array<Teams_Users>;
  /** An aggregate relationship */
  teams_users_aggregate: Teams_Users_Aggregate;
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
  /** A computed field, executes function "users_test_jwt" */
  test_jwt?: Maybe<Scalars['String']['output']>;
  third_pillar_a_annual_premium_organization_id?: Maybe<Scalars['uuid']['output']>;
  third_pillar_a_organisation_id?: Maybe<Scalars['uuid']['output']>;
  third_pillar_b_organisation_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitter_profile?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  updates_daily_tasks: Scalars['Boolean']['output'];
  updates_introduction_to_lead_contacts?: Maybe<Scalars['Boolean']['output']>;
  updates_new_lead_assigned_sms?: Maybe<Scalars['Boolean']['output']>;
  updates_newsletter?: Maybe<Scalars['Boolean']['output']>;
  updates_property_revaluation: Scalars['Boolean']['output'];
  /** An array relationship */
  user_images: Array<User_Images>;
  wedding_date?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  work_permit?: Maybe<Dictionaries>;
  work_permit_id?: Maybe<Scalars['uuid']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
  youtube_profile?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "users" */
export type UsersActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAssigned_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAssigned_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBroker_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBroker_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBuyer_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBuyer_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBuyer_OffersArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBuyer_Offers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCatchment_AreasArgs = {
  distinct_on?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Catchment_Areas_Order_By>>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCatchment_Areas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Catchment_Areas_Order_By>>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCombined_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Combined_Reviews_Order_By>>;
  where?: InputMaybe<Combined_Reviews_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCombined_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Combined_Reviews_Order_By>>;
  where?: InputMaybe<Combined_Reviews_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCreated_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCreated_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersEmailsArgs = {
  distinct_on?: InputMaybe<Array<Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emails_Order_By>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersEnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersEnquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLead_AgentsArgs = {
  distinct_on?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Agents_Order_By>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLead_Agents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Agents_Order_By>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLeadsArgs = {
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLeads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLoginsArgs = {
  distinct_on?: InputMaybe<Array<Logins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Logins_Order_By>>;
  where?: InputMaybe<Logins_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLot_SellersArgs = {
  distinct_on?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Sellers_Order_By>>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLot_Sellers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Sellers_Order_By>>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLotsArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNylas_Account_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Nylas_Account_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nylas_Account_Configs_Order_By>>;
  where?: InputMaybe<Nylas_Account_Configs_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPhone_NumbersArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPhone_Numbers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPrimary_Phone_NumberArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProperty_SearchesArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Order_By>>;
  where?: InputMaybe<Property_Searches_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProperty_Searches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Order_By>>;
  where?: InputMaybe<Property_Searches_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProperty_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProperty_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPush_Notification_TokensArgs = {
  distinct_on?: InputMaybe<Array<Push_Notification_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Push_Notification_Tokens_Order_By>>;
  where?: InputMaybe<Push_Notification_Tokens_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersReviewsArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTeams_UsersArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTeams_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_ImagesArgs = {
  distinct_on?: InputMaybe<Array<User_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Images_Order_By>>;
  where?: InputMaybe<User_Images_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Users_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Users_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Users_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Users_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Users_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Users_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Users_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Users_Aggregate_Bool_Exp_Var_Samp>;
};

export type Users_Aggregate_Bool_Exp_Avg = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Corr = {
  arguments: Users_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Users_Select_Column_Users_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Users_Select_Column_Users_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Users_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Users_Select_Column_Users_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Users_Select_Column_Users_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Users_Aggregate_Bool_Exp_Max = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Min = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Sum = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  avg?: InputMaybe<Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
  stddev?: InputMaybe<Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_Sum_Order_By>;
  var_pop?: InputMaybe<Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  annual_costs_child_support?: Maybe<Scalars['Float']['output']>;
  annual_costs_leasing?: Maybe<Scalars['Float']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['Float']['output']>;
  annual_income_bonus?: Maybe<Scalars['Float']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['Float']['output']>;
  annual_income_other?: Maybe<Scalars['Float']['output']>;
  annual_income_rent?: Maybe<Scalars['Float']['output']>;
  annual_income_salary?: Maybe<Scalars['Float']['output']>;
  assets_savings?: Maybe<Scalars['Float']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  assets_securities?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  debt_leasing_balance?: Maybe<Scalars['Float']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['Float']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  employment_rate?: Maybe<Scalars['Float']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Float']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  professional_address_lat?: Maybe<Scalars['Float']['output']>;
  professional_address_lng?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "users" */
export type Users_Avg_Order_By = {
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  account_manager?: InputMaybe<Users_Bool_Exp>;
  account_manager_id?: InputMaybe<Uuid_Comparison_Exp>;
  active_since?: InputMaybe<Int_Comparison_Exp>;
  activities?: InputMaybe<Activities_Bool_Exp>;
  activities_aggregate?: InputMaybe<Activities_Aggregate_Bool_Exp>;
  age?: InputMaybe<Int_Comparison_Exp>;
  agent_slug?: InputMaybe<String_Comparison_Exp>;
  annual_costs_child_support?: InputMaybe<Float8_Comparison_Exp>;
  annual_costs_leasing?: InputMaybe<Float8_Comparison_Exp>;
  annual_costs_other_credits?: InputMaybe<Float8_Comparison_Exp>;
  annual_credits?: InputMaybe<Jsonb_Array_Comparison_Exp>;
  annual_credits_exist?: InputMaybe<Boolean_Comparison_Exp>;
  annual_income_additional_exist?: InputMaybe<Boolean_Comparison_Exp>;
  annual_income_bonus?: InputMaybe<Float8_Comparison_Exp>;
  annual_income_family_allowances?: InputMaybe<Float8_Comparison_Exp>;
  annual_income_other?: InputMaybe<Float8_Comparison_Exp>;
  annual_income_rent?: InputMaybe<Float8_Comparison_Exp>;
  annual_income_salary?: InputMaybe<Int_Comparison_Exp>;
  annual_income_salary13?: InputMaybe<Boolean_Comparison_Exp>;
  annual_income_salary14?: InputMaybe<Boolean_Comparison_Exp>;
  annual_leasings?: InputMaybe<Jsonb_Array_Comparison_Exp>;
  annual_leasings_exist?: InputMaybe<Boolean_Comparison_Exp>;
  annual_other_exist?: InputMaybe<Boolean_Comparison_Exp>;
  annual_other_payments?: InputMaybe<Float8_Array_Comparison_Exp>;
  assets_savings?: InputMaybe<Int_Comparison_Exp>;
  assets_savings_donation?: InputMaybe<Float_Comparison_Exp>;
  assets_second_pillar?: InputMaybe<Int_Comparison_Exp>;
  assets_second_pillar_exist?: InputMaybe<Boolean_Comparison_Exp>;
  assets_second_pillar_organisation?: InputMaybe<String_Comparison_Exp>;
  assets_securities?: InputMaybe<Float8_Comparison_Exp>;
  assets_third_pillar_a?: InputMaybe<Int_Comparison_Exp>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Float_Comparison_Exp>;
  assets_third_pillar_a_annual_premium_organization?: InputMaybe<String_Comparison_Exp>;
  assets_third_pillar_a_cash?: InputMaybe<Float8_Comparison_Exp>;
  assets_third_pillar_a_exist?: InputMaybe<Boolean_Comparison_Exp>;
  assets_third_pillar_a_life_insurance?: InputMaybe<Boolean_Comparison_Exp>;
  assets_third_pillar_a_organisation?: InputMaybe<String_Comparison_Exp>;
  assets_third_pillar_a_organisation_type?: InputMaybe<Third_Pillar_Organisation_Type_A_Comparison_Exp>;
  assets_third_pillar_b?: InputMaybe<Float_Comparison_Exp>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Float_Comparison_Exp>;
  assets_third_pillar_b_exist?: InputMaybe<Boolean_Comparison_Exp>;
  assets_third_pillar_b_life_insurance?: InputMaybe<Boolean_Comparison_Exp>;
  assets_third_pillar_b_organisation?: InputMaybe<String_Comparison_Exp>;
  assets_third_pillar_b_organisation_type?: InputMaybe<Third_Pillar_Organisation_Type_B_Comparison_Exp>;
  assets_third_pillar_exist?: InputMaybe<Boolean_Comparison_Exp>;
  assigned_activities?: InputMaybe<Activities_Bool_Exp>;
  assigned_activities_aggregate?: InputMaybe<Activities_Aggregate_Bool_Exp>;
  auto_assign_leads?: InputMaybe<Boolean_Comparison_Exp>;
  branding_color?: InputMaybe<String_Comparison_Exp>;
  branding_logo?: InputMaybe<String_Comparison_Exp>;
  branding_name?: InputMaybe<String_Comparison_Exp>;
  branding_website?: InputMaybe<String_Comparison_Exp>;
  broker?: InputMaybe<Users_Bool_Exp>;
  broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  broker_leads?: InputMaybe<Leads_Bool_Exp>;
  broker_leads_aggregate?: InputMaybe<Leads_Aggregate_Bool_Exp>;
  buyer_leads?: InputMaybe<Buyer_Leads_Bool_Exp>;
  buyer_leads_aggregate?: InputMaybe<Buyer_Leads_Aggregate_Bool_Exp>;
  buyer_offers?: InputMaybe<Offers_Bool_Exp>;
  buyer_offers_aggregate?: InputMaybe<Offers_Aggregate_Bool_Exp>;
  can_edit_settings?: InputMaybe<Boolean_Comparison_Exp>;
  can_user_login_as?: InputMaybe<Boolean_Comparison_Exp>;
  catchment_areas?: InputMaybe<Catchment_Areas_Bool_Exp>;
  catchment_areas_aggregate?: InputMaybe<Catchment_Areas_Aggregate_Bool_Exp>;
  certifications?: InputMaybe<String_Array_Comparison_Exp>;
  combined_reviews?: InputMaybe<Combined_Reviews_Bool_Exp>;
  combined_reviews_aggregate?: InputMaybe<Combined_Reviews_Aggregate_Bool_Exp>;
  created_activities?: InputMaybe<Activities_Bool_Exp>;
  created_activities_aggregate?: InputMaybe<Activities_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  crm_link?: InputMaybe<String_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  debt?: InputMaybe<Int_Comparison_Exp>;
  debt_leasing_balance?: InputMaybe<Float8_Comparison_Exp>;
  debt_mortgage_balance?: InputMaybe<Float8_Comparison_Exp>;
  debt_other_credits_balance?: InputMaybe<Int_Comparison_Exp>;
  default_team?: InputMaybe<Teams_Bool_Exp>;
  default_team_id?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  divorce_date?: InputMaybe<Date_Comparison_Exp>;
  donation?: InputMaybe<Float8_Comparison_Exp>;
  email_signature?: InputMaybe<String_Comparison_Exp>;
  email_signature_html?: InputMaybe<String_Comparison_Exp>;
  emails?: InputMaybe<Emails_Bool_Exp>;
  employer?: InputMaybe<String_Comparison_Exp>;
  employer_id?: InputMaybe<Uuid_Comparison_Exp>;
  employment_commencement_date?: InputMaybe<Date_Comparison_Exp>;
  employment_rate?: InputMaybe<Float8_Comparison_Exp>;
  enquiries?: InputMaybe<Enquiries_Bool_Exp>;
  enquiries_aggregate?: InputMaybe<Enquiries_Aggregate_Bool_Exp>;
  facebook_profile?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  has_accepted_terms?: InputMaybe<Boolean_Comparison_Exp>;
  has_children?: InputMaybe<Boolean_Comparison_Exp>;
  has_free_crm_access?: InputMaybe<Boolean_Comparison_Exp>;
  has_used_trial_button?: InputMaybe<Boolean_Comparison_Exp>;
  hires_on_realadvisor?: InputMaybe<Int_Comparison_Exp>;
  home_address_country_code?: InputMaybe<String_Comparison_Exp>;
  home_address_lat?: InputMaybe<Float_Comparison_Exp>;
  home_address_lng?: InputMaybe<Float_Comparison_Exp>;
  home_address_locality?: InputMaybe<String_Comparison_Exp>;
  home_address_postcode?: InputMaybe<String_Comparison_Exp>;
  home_address_route?: InputMaybe<String_Comparison_Exp>;
  home_address_state?: InputMaybe<String_Comparison_Exp>;
  home_address_street_number?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identification_document_expiry_date?: InputMaybe<Date_Comparison_Exp>;
  identification_document_issue_date?: InputMaybe<Date_Comparison_Exp>;
  identification_document_number?: InputMaybe<String_Comparison_Exp>;
  identification_document_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_id?: InputMaybe<String_Comparison_Exp>;
  instagram_profile?: InputMaybe<String_Comparison_Exp>;
  intercom_hash?: InputMaybe<String_Comparison_Exp>;
  is_admin?: InputMaybe<Boolean_Comparison_Exp>;
  is_bot?: InputMaybe<Boolean_Comparison_Exp>;
  is_broker?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_mortgage_broker?: InputMaybe<Boolean_Comparison_Exp>;
  job_title?: InputMaybe<String_Comparison_Exp>;
  landing_page_url?: InputMaybe<String_Comparison_Exp>;
  language?: InputMaybe<User_Language_Comparison_Exp>;
  languages?: InputMaybe<String_Array_Comparison_Exp>;
  last_bonus?: InputMaybe<Float8_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  lead_agents?: InputMaybe<Lead_Agents_Bool_Exp>;
  lead_agents_aggregate?: InputMaybe<Lead_Agents_Aggregate_Bool_Exp>;
  leads?: InputMaybe<Leads_Bool_Exp>;
  leads_aggregate?: InputMaybe<Leads_Aggregate_Bool_Exp>;
  linked_in_profile?: InputMaybe<String_Comparison_Exp>;
  logins?: InputMaybe<Logins_Bool_Exp>;
  lot_sellers?: InputMaybe<Lot_Sellers_Bool_Exp>;
  lot_sellers_aggregate?: InputMaybe<Lot_Sellers_Aggregate_Bool_Exp>;
  lots?: InputMaybe<Lots_Bool_Exp>;
  lots_aggregate?: InputMaybe<Lots_Aggregate_Bool_Exp>;
  marital_partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  marital_status?: InputMaybe<Marital_Status_Comparison_Exp>;
  matrimonial_regime?: InputMaybe<String_Comparison_Exp>;
  membership_type?: InputMaybe<String_Comparison_Exp>;
  modules?: InputMaybe<String_Array_Comparison_Exp>;
  mortgage_broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  nationality?: InputMaybe<Dictionaries_Bool_Exp>;
  nationality_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_buyers?: InputMaybe<Int_Comparison_Exp>;
  number_of_dependant_children?: InputMaybe<Int_Comparison_Exp>;
  nylas_account_config?: InputMaybe<Nylas_Account_Configs_Bool_Exp>;
  occupation_id?: InputMaybe<Uuid_Comparison_Exp>;
  occupation_text?: InputMaybe<String_Comparison_Exp>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisation_user?: InputMaybe<Organisation_Users_Bool_Exp>;
  payments?: InputMaybe<Payments_Bool_Exp>;
  phone_numbers?: InputMaybe<Phone_Numbers_Bool_Exp>;
  phone_numbers_aggregate?: InputMaybe<Phone_Numbers_Aggregate_Bool_Exp>;
  place_of_origin?: InputMaybe<String_Comparison_Exp>;
  primary_phone_number?: InputMaybe<Phone_Numbers_Bool_Exp>;
  professional_address_country_code?: InputMaybe<String_Comparison_Exp>;
  professional_address_lat?: InputMaybe<Float8_Comparison_Exp>;
  professional_address_lng?: InputMaybe<Float8_Comparison_Exp>;
  professional_address_locality?: InputMaybe<String_Comparison_Exp>;
  professional_address_postcode?: InputMaybe<String_Comparison_Exp>;
  professional_address_route?: InputMaybe<String_Comparison_Exp>;
  professional_address_state?: InputMaybe<String_Comparison_Exp>;
  professional_address_street_number?: InputMaybe<String_Comparison_Exp>;
  professional_situation?: InputMaybe<User_Professional_Situation_Comparison_Exp>;
  properties_exist?: InputMaybe<Boolean_Comparison_Exp>;
  property_searches?: InputMaybe<Property_Searches_Bool_Exp>;
  property_searches_aggregate?: InputMaybe<Property_Searches_Aggregate_Bool_Exp>;
  property_transactions?: InputMaybe<Property_Transactions_Bool_Exp>;
  property_transactions_aggregate?: InputMaybe<Property_Transactions_Aggregate_Bool_Exp>;
  push_notification_tokens?: InputMaybe<Push_Notification_Tokens_Bool_Exp>;
  recommended_listings?: InputMaybe<Boolean_Comparison_Exp>;
  referrer?: InputMaybe<String_Comparison_Exp>;
  referring_domain?: InputMaybe<String_Comparison_Exp>;
  registered_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  residence_country_code?: InputMaybe<String_Comparison_Exp>;
  residence_state_id?: InputMaybe<Uuid_Comparison_Exp>;
  reviews?: InputMaybe<Reviews_Bool_Exp>;
  reviews_aggregate?: InputMaybe<Reviews_Aggregate_Bool_Exp>;
  second_pillar_organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  services?: InputMaybe<String_Array_Comparison_Exp>;
  show_in_agency_pages?: InputMaybe<Boolean_Comparison_Exp>;
  social_security_number?: InputMaybe<String_Comparison_Exp>;
  subscriptions?: InputMaybe<Subscriptions_Bool_Exp>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  teams_users?: InputMaybe<Teams_Users_Bool_Exp>;
  teams_users_aggregate?: InputMaybe<Teams_Users_Aggregate_Bool_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  test_jwt?: InputMaybe<String_Comparison_Exp>;
  third_pillar_a_annual_premium_organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  third_pillar_a_organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  third_pillar_b_organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  twitter_profile?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updates_daily_tasks?: InputMaybe<Boolean_Comparison_Exp>;
  updates_introduction_to_lead_contacts?: InputMaybe<Boolean_Comparison_Exp>;
  updates_new_lead_assigned_sms?: InputMaybe<Boolean_Comparison_Exp>;
  updates_newsletter?: InputMaybe<Boolean_Comparison_Exp>;
  updates_property_revaluation?: InputMaybe<Boolean_Comparison_Exp>;
  user_images?: InputMaybe<User_Images_Bool_Exp>;
  wedding_date?: InputMaybe<Date_Comparison_Exp>;
  work_permit?: InputMaybe<Dictionaries_Bool_Exp>;
  work_permit_id?: InputMaybe<Uuid_Comparison_Exp>;
  yearly_revenues_at_retirement?: InputMaybe<Float8_Comparison_Exp>;
  youtube_profile?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "agent_slug" */
  UniqueAgentSlugIndex = 'unique_agent_slug_index',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  UsersIdTenantIdUnique = 'users_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  /** The year when the agent started operating */
  active_since?: InputMaybe<Scalars['Int']['input']>;
  hires_on_realadvisor?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  account_manager?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  activities?: InputMaybe<Activities_Arr_Rel_Insert_Input>;
  assigned_activities?: InputMaybe<Activities_Arr_Rel_Insert_Input>;
  broker?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  broker_leads?: InputMaybe<Leads_Arr_Rel_Insert_Input>;
  buyer_leads?: InputMaybe<Buyer_Leads_Arr_Rel_Insert_Input>;
  buyer_offers?: InputMaybe<Offers_Arr_Rel_Insert_Input>;
  catchment_areas?: InputMaybe<Catchment_Areas_Arr_Rel_Insert_Input>;
  created_activities?: InputMaybe<Activities_Arr_Rel_Insert_Input>;
  creator?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  default_team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  emails?: InputMaybe<Emails_Arr_Rel_Insert_Input>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  home_address_country_code?: InputMaybe<Scalars['String']['input']>;
  home_address_locality?: InputMaybe<Scalars['String']['input']>;
  home_address_postcode?: InputMaybe<Scalars['String']['input']>;
  home_address_route?: InputMaybe<Scalars['String']['input']>;
  home_address_state?: InputMaybe<Scalars['String']['input']>;
  home_address_street_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  lead_agents?: InputMaybe<Lead_Agents_Arr_Rel_Insert_Input>;
  leads?: InputMaybe<Leads_Arr_Rel_Insert_Input>;
  lot_sellers?: InputMaybe<Lot_Sellers_Arr_Rel_Insert_Input>;
  lots?: InputMaybe<Lots_Arr_Rel_Insert_Input>;
  nationality?: InputMaybe<Dictionaries_Obj_Rel_Insert_Input>;
  organisation?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  phone_numbers?: InputMaybe<Phone_Numbers_Arr_Rel_Insert_Input>;
  property_searches?: InputMaybe<Property_Searches_Arr_Rel_Insert_Input>;
  property_transactions?: InputMaybe<Property_Transactions_Arr_Rel_Insert_Input>;
  push_notification_tokens?: InputMaybe<Push_Notification_Tokens_Arr_Rel_Insert_Input>;
  reviews?: InputMaybe<Reviews_Arr_Rel_Insert_Input>;
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  teams_users?: InputMaybe<Teams_Users_Arr_Rel_Insert_Input>;
  user_images?: InputMaybe<User_Images_Arr_Rel_Insert_Input>;
  work_permit?: InputMaybe<Dictionaries_Obj_Rel_Insert_Input>;
};

/** columns and relationships of "users_listings" */
export type Users_Listings = {
  created_at: Scalars['timestamptz']['output'];
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  merged_listing_id: Scalars['Int']['output'];
  /** An object relationship */
  online_listing?: Maybe<Online_Listings>;
  type: Users_Listings_Types_Enum;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "users_listings" */
export type Users_Listings_Aggregate = {
  aggregate?: Maybe<Users_Listings_Aggregate_Fields>;
  nodes: Array<Users_Listings>;
};

/** aggregate fields of "users_listings" */
export type Users_Listings_Aggregate_Fields = {
  avg?: Maybe<Users_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Listings_Max_Fields>;
  min?: Maybe<Users_Listings_Min_Fields>;
  stddev?: Maybe<Users_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Listings_Sum_Fields>;
  var_pop?: Maybe<Users_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Listings_Var_Samp_Fields>;
  variance?: Maybe<Users_Listings_Variance_Fields>;
};


/** aggregate fields of "users_listings" */
export type Users_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "users_listings" */
export type Users_Listings_Aggregate_Order_By = {
  avg?: InputMaybe<Users_Listings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Listings_Max_Order_By>;
  min?: InputMaybe<Users_Listings_Min_Order_By>;
  stddev?: InputMaybe<Users_Listings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_Listings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_Listings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_Listings_Sum_Order_By>;
  var_pop?: InputMaybe<Users_Listings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_Listings_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_Listings_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Users_Listings_Avg_Fields = {
  merged_listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "users_listings" */
export type Users_Listings_Avg_Order_By = {
  merged_listing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users_listings". All fields are combined with a logical 'AND'. */
export type Users_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Listings_Bool_Exp>>;
  _not?: InputMaybe<Users_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Listings_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  merged_listing_id?: InputMaybe<Int_Comparison_Exp>;
  online_listing?: InputMaybe<Online_Listings_Bool_Exp>;
  type?: InputMaybe<Users_Listings_Types_Enum_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "users_listings" */
export enum Users_Listings_Constraint {
  /** unique or primary key constraint on columns "created_at", "type", "merged_listing_id", "user_id" */
  UsersListingsPkey = 'users_listings_pkey',
  /** unique or primary key constraint on columns "type", "merged_listing_id", "user_id" */
  UsersListingsUserIdMergedListingIdTypeIdx = 'users_listings_user_id_merged_listing_id_type_idx'
}

/** input type for incrementing numeric columns in table "users_listings" */
export type Users_Listings_Inc_Input = {
  merged_listing_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "users_listings" */
export type Users_Listings_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  merged_listing_id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Users_Listings_Types_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Users_Listings_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  merged_listing_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "users_listings" */
export type Users_Listings_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  merged_listing_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Listings_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  merged_listing_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "users_listings" */
export type Users_Listings_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  merged_listing_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users_listings" */
export type Users_Listings_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users_Listings>;
};

/** on_conflict condition type for table "users_listings" */
export type Users_Listings_On_Conflict = {
  constraint: Users_Listings_Constraint;
  update_columns?: Array<Users_Listings_Update_Column>;
  where?: InputMaybe<Users_Listings_Bool_Exp>;
};

/** Ordering options when selecting data from "users_listings". */
export type Users_Listings_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  merged_listing_id?: InputMaybe<Order_By>;
  online_listing?: InputMaybe<Online_Listings_Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users_listings */
export type Users_Listings_Pk_Columns_Input = {
  created_at: Scalars['timestamptz']['input'];
  merged_listing_id: Scalars['Int']['input'];
  type: Users_Listings_Types_Enum;
  user_id: Scalars['uuid']['input'];
};

/** select columns of table "users_listings" */
export enum Users_Listings_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  LastName = 'last_name',
  /** column name */
  MergedListingId = 'merged_listing_id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "users_listings" */
export type Users_Listings_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  merged_listing_id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Users_Listings_Types_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Users_Listings_Stddev_Fields = {
  merged_listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "users_listings" */
export type Users_Listings_Stddev_Order_By = {
  merged_listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Listings_Stddev_Pop_Fields = {
  merged_listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "users_listings" */
export type Users_Listings_Stddev_Pop_Order_By = {
  merged_listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Listings_Stddev_Samp_Fields = {
  merged_listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "users_listings" */
export type Users_Listings_Stddev_Samp_Order_By = {
  merged_listing_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Users_Listings_Sum_Fields = {
  merged_listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "users_listings" */
export type Users_Listings_Sum_Order_By = {
  merged_listing_id?: InputMaybe<Order_By>;
};

export enum Users_Listings_Types_Enum {
  Clickout = 'clickout',
  Favourite = 'favourite',
  Hidden = 'hidden'
}

/** Boolean expression to compare columns of type "users_listings_types_enum". All fields are combined with logical 'AND'. */
export type Users_Listings_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Users_Listings_Types_Enum>;
  _in?: InputMaybe<Array<Users_Listings_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Users_Listings_Types_Enum>;
  _nin?: InputMaybe<Array<Users_Listings_Types_Enum>>;
};

/** update columns of table "users_listings" */
export enum Users_Listings_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  LastName = 'last_name',
  /** column name */
  MergedListingId = 'merged_listing_id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type Users_Listings_Var_Pop_Fields = {
  merged_listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "users_listings" */
export type Users_Listings_Var_Pop_Order_By = {
  merged_listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Listings_Var_Samp_Fields = {
  merged_listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "users_listings" */
export type Users_Listings_Var_Samp_Order_By = {
  merged_listing_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Listings_Variance_Fields = {
  merged_listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "users_listings" */
export type Users_Listings_Variance_Order_By = {
  merged_listing_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  account_manager_id?: Maybe<Scalars['uuid']['output']>;
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  agent_slug?: Maybe<Scalars['String']['output']>;
  annual_costs_child_support?: Maybe<Scalars['float8']['output']>;
  annual_costs_leasing?: Maybe<Scalars['float8']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['float8']['output']>;
  annual_credits?: Maybe<Array<Scalars['jsonb']['output']>>;
  annual_income_bonus?: Maybe<Scalars['float8']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['float8']['output']>;
  annual_income_other?: Maybe<Scalars['float8']['output']>;
  annual_income_rent?: Maybe<Scalars['float8']['output']>;
  annual_income_salary?: Maybe<Scalars['Int']['output']>;
  annual_leasings?: Maybe<Array<Scalars['jsonb']['output']>>;
  annual_other_payments?: Maybe<Array<Scalars['float8']['output']>>;
  assets_savings?: Maybe<Scalars['Int']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Int']['output']>;
  assets_second_pillar_organisation?: Maybe<Scalars['String']['output']>;
  assets_securities?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Int']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium_organization?: Maybe<Scalars['String']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a_organisation?: Maybe<Scalars['String']['output']>;
  assets_third_pillar_a_organisation_type?: Maybe<Scalars['third_pillar_organisation_type_a']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_organisation?: Maybe<Scalars['String']['output']>;
  assets_third_pillar_b_organisation_type?: Maybe<Scalars['third_pillar_organisation_type_b']['output']>;
  branding_color?: Maybe<Scalars['String']['output']>;
  branding_logo?: Maybe<Scalars['String']['output']>;
  branding_name?: Maybe<Scalars['String']['output']>;
  branding_website?: Maybe<Scalars['String']['output']>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  certifications?: Maybe<Array<Scalars['String']['output']>>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "users_crm_link" */
  crm_link?: Maybe<Scalars['String']['output']>;
  date_of_birth?: Maybe<Scalars['date']['output']>;
  debt?: Maybe<Scalars['Int']['output']>;
  debt_leasing_balance?: Maybe<Scalars['float8']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['float8']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Int']['output']>;
  default_team_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  divorce_date?: Maybe<Scalars['date']['output']>;
  donation?: Maybe<Scalars['float8']['output']>;
  email_signature?: Maybe<Scalars['String']['output']>;
  email_signature_html?: Maybe<Scalars['String']['output']>;
  employer?: Maybe<Scalars['String']['output']>;
  employer_id?: Maybe<Scalars['uuid']['output']>;
  employment_commencement_date?: Maybe<Scalars['date']['output']>;
  employment_rate?: Maybe<Scalars['float8']['output']>;
  facebook_profile?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Int']['output']>;
  home_address_country_code?: Maybe<Scalars['String']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  home_address_locality?: Maybe<Scalars['String']['output']>;
  home_address_postcode?: Maybe<Scalars['String']['output']>;
  home_address_route?: Maybe<Scalars['String']['output']>;
  home_address_state?: Maybe<Scalars['String']['output']>;
  home_address_street_number?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  identification_document_expiry_date?: Maybe<Scalars['date']['output']>;
  identification_document_issue_date?: Maybe<Scalars['date']['output']>;
  identification_document_number?: Maybe<Scalars['String']['output']>;
  identification_document_type_id?: Maybe<Scalars['uuid']['output']>;
  imported_id?: Maybe<Scalars['String']['output']>;
  instagram_profile?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "generate_intercom_hash" */
  intercom_hash?: Maybe<Scalars['String']['output']>;
  job_title?: Maybe<Scalars['String']['output']>;
  landing_page_url?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['user_language']['output']>;
  languages?: Maybe<Array<Scalars['String']['output']>>;
  last_bonus?: Maybe<Scalars['float8']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  linked_in_profile?: Maybe<Scalars['String']['output']>;
  marital_partner_id?: Maybe<Scalars['uuid']['output']>;
  marital_status?: Maybe<Scalars['marital_status']['output']>;
  matrimonial_regime?: Maybe<Scalars['String']['output']>;
  membership_type?: Maybe<Scalars['String']['output']>;
  modules?: Maybe<Array<Scalars['String']['output']>>;
  mortgage_broker_id?: Maybe<Scalars['uuid']['output']>;
  nationality_id?: Maybe<Scalars['uuid']['output']>;
  number_of_buyers?: Maybe<Scalars['Int']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Int']['output']>;
  occupation_id?: Maybe<Scalars['uuid']['output']>;
  occupation_text?: Maybe<Scalars['String']['output']>;
  place_of_origin?: Maybe<Scalars['String']['output']>;
  professional_address_country_code?: Maybe<Scalars['String']['output']>;
  professional_address_lat?: Maybe<Scalars['float8']['output']>;
  professional_address_lng?: Maybe<Scalars['float8']['output']>;
  professional_address_locality?: Maybe<Scalars['String']['output']>;
  professional_address_postcode?: Maybe<Scalars['String']['output']>;
  professional_address_route?: Maybe<Scalars['String']['output']>;
  professional_address_state?: Maybe<Scalars['String']['output']>;
  professional_address_street_number?: Maybe<Scalars['String']['output']>;
  professional_situation?: Maybe<Scalars['user_professional_situation']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
  referring_domain?: Maybe<Scalars['String']['output']>;
  registered_at?: Maybe<Scalars['timestamptz']['output']>;
  residence_country_code?: Maybe<Scalars['String']['output']>;
  residence_state_id?: Maybe<Scalars['uuid']['output']>;
  second_pillar_organisation_id?: Maybe<Scalars['uuid']['output']>;
  services?: Maybe<Array<Scalars['String']['output']>>;
  social_security_number?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "users_test_jwt" */
  test_jwt?: Maybe<Scalars['String']['output']>;
  third_pillar_a_annual_premium_organization_id?: Maybe<Scalars['uuid']['output']>;
  third_pillar_a_organisation_id?: Maybe<Scalars['uuid']['output']>;
  third_pillar_b_organisation_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitter_profile?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  wedding_date?: Maybe<Scalars['date']['output']>;
  work_permit_id?: Maybe<Scalars['uuid']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
  youtube_profile?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  account_manager_id?: InputMaybe<Order_By>;
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  agent_slug?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  annual_leasings?: InputMaybe<Order_By>;
  annual_other_payments?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_second_pillar_organisation?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium_organization?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_a_organisation?: InputMaybe<Order_By>;
  assets_third_pillar_a_organisation_type?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_b_organisation?: InputMaybe<Order_By>;
  assets_third_pillar_b_organisation_type?: InputMaybe<Order_By>;
  branding_color?: InputMaybe<Order_By>;
  branding_logo?: InputMaybe<Order_By>;
  branding_name?: InputMaybe<Order_By>;
  branding_website?: InputMaybe<Order_By>;
  broker_id?: InputMaybe<Order_By>;
  certifications?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  default_team_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  divorce_date?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  email_signature?: InputMaybe<Order_By>;
  email_signature_html?: InputMaybe<Order_By>;
  employer?: InputMaybe<Order_By>;
  employer_id?: InputMaybe<Order_By>;
  employment_commencement_date?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  facebook_profile?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_country_code?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  home_address_locality?: InputMaybe<Order_By>;
  home_address_postcode?: InputMaybe<Order_By>;
  home_address_route?: InputMaybe<Order_By>;
  home_address_state?: InputMaybe<Order_By>;
  home_address_street_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identification_document_expiry_date?: InputMaybe<Order_By>;
  identification_document_issue_date?: InputMaybe<Order_By>;
  identification_document_number?: InputMaybe<Order_By>;
  identification_document_type_id?: InputMaybe<Order_By>;
  imported_id?: InputMaybe<Order_By>;
  instagram_profile?: InputMaybe<Order_By>;
  job_title?: InputMaybe<Order_By>;
  landing_page_url?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  languages?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  linked_in_profile?: InputMaybe<Order_By>;
  marital_partner_id?: InputMaybe<Order_By>;
  marital_status?: InputMaybe<Order_By>;
  matrimonial_regime?: InputMaybe<Order_By>;
  membership_type?: InputMaybe<Order_By>;
  modules?: InputMaybe<Order_By>;
  mortgage_broker_id?: InputMaybe<Order_By>;
  nationality_id?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  occupation_id?: InputMaybe<Order_By>;
  occupation_text?: InputMaybe<Order_By>;
  place_of_origin?: InputMaybe<Order_By>;
  professional_address_country_code?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  professional_address_locality?: InputMaybe<Order_By>;
  professional_address_postcode?: InputMaybe<Order_By>;
  professional_address_route?: InputMaybe<Order_By>;
  professional_address_state?: InputMaybe<Order_By>;
  professional_address_street_number?: InputMaybe<Order_By>;
  professional_situation?: InputMaybe<Order_By>;
  referrer?: InputMaybe<Order_By>;
  referring_domain?: InputMaybe<Order_By>;
  registered_at?: InputMaybe<Order_By>;
  residence_country_code?: InputMaybe<Order_By>;
  residence_state_id?: InputMaybe<Order_By>;
  second_pillar_organisation_id?: InputMaybe<Order_By>;
  services?: InputMaybe<Order_By>;
  social_security_number?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  third_pillar_a_annual_premium_organization_id?: InputMaybe<Order_By>;
  third_pillar_a_organisation_id?: InputMaybe<Order_By>;
  third_pillar_b_organisation_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  twitter_profile?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wedding_date?: InputMaybe<Order_By>;
  work_permit_id?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  youtube_profile?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  account_manager_id?: Maybe<Scalars['uuid']['output']>;
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  agent_slug?: Maybe<Scalars['String']['output']>;
  annual_costs_child_support?: Maybe<Scalars['float8']['output']>;
  annual_costs_leasing?: Maybe<Scalars['float8']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['float8']['output']>;
  annual_credits?: Maybe<Array<Scalars['jsonb']['output']>>;
  annual_income_bonus?: Maybe<Scalars['float8']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['float8']['output']>;
  annual_income_other?: Maybe<Scalars['float8']['output']>;
  annual_income_rent?: Maybe<Scalars['float8']['output']>;
  annual_income_salary?: Maybe<Scalars['Int']['output']>;
  annual_leasings?: Maybe<Array<Scalars['jsonb']['output']>>;
  annual_other_payments?: Maybe<Array<Scalars['float8']['output']>>;
  assets_savings?: Maybe<Scalars['Int']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Int']['output']>;
  assets_second_pillar_organisation?: Maybe<Scalars['String']['output']>;
  assets_securities?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Int']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium_organization?: Maybe<Scalars['String']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a_organisation?: Maybe<Scalars['String']['output']>;
  assets_third_pillar_a_organisation_type?: Maybe<Scalars['third_pillar_organisation_type_a']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_organisation?: Maybe<Scalars['String']['output']>;
  assets_third_pillar_b_organisation_type?: Maybe<Scalars['third_pillar_organisation_type_b']['output']>;
  branding_color?: Maybe<Scalars['String']['output']>;
  branding_logo?: Maybe<Scalars['String']['output']>;
  branding_name?: Maybe<Scalars['String']['output']>;
  branding_website?: Maybe<Scalars['String']['output']>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  certifications?: Maybe<Array<Scalars['String']['output']>>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "users_crm_link" */
  crm_link?: Maybe<Scalars['String']['output']>;
  date_of_birth?: Maybe<Scalars['date']['output']>;
  debt?: Maybe<Scalars['Int']['output']>;
  debt_leasing_balance?: Maybe<Scalars['float8']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['float8']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Int']['output']>;
  default_team_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  divorce_date?: Maybe<Scalars['date']['output']>;
  donation?: Maybe<Scalars['float8']['output']>;
  email_signature?: Maybe<Scalars['String']['output']>;
  email_signature_html?: Maybe<Scalars['String']['output']>;
  employer?: Maybe<Scalars['String']['output']>;
  employer_id?: Maybe<Scalars['uuid']['output']>;
  employment_commencement_date?: Maybe<Scalars['date']['output']>;
  employment_rate?: Maybe<Scalars['float8']['output']>;
  facebook_profile?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Int']['output']>;
  home_address_country_code?: Maybe<Scalars['String']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  home_address_locality?: Maybe<Scalars['String']['output']>;
  home_address_postcode?: Maybe<Scalars['String']['output']>;
  home_address_route?: Maybe<Scalars['String']['output']>;
  home_address_state?: Maybe<Scalars['String']['output']>;
  home_address_street_number?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  identification_document_expiry_date?: Maybe<Scalars['date']['output']>;
  identification_document_issue_date?: Maybe<Scalars['date']['output']>;
  identification_document_number?: Maybe<Scalars['String']['output']>;
  identification_document_type_id?: Maybe<Scalars['uuid']['output']>;
  imported_id?: Maybe<Scalars['String']['output']>;
  instagram_profile?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "generate_intercom_hash" */
  intercom_hash?: Maybe<Scalars['String']['output']>;
  job_title?: Maybe<Scalars['String']['output']>;
  landing_page_url?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['user_language']['output']>;
  languages?: Maybe<Array<Scalars['String']['output']>>;
  last_bonus?: Maybe<Scalars['float8']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  linked_in_profile?: Maybe<Scalars['String']['output']>;
  marital_partner_id?: Maybe<Scalars['uuid']['output']>;
  marital_status?: Maybe<Scalars['marital_status']['output']>;
  matrimonial_regime?: Maybe<Scalars['String']['output']>;
  membership_type?: Maybe<Scalars['String']['output']>;
  modules?: Maybe<Array<Scalars['String']['output']>>;
  mortgage_broker_id?: Maybe<Scalars['uuid']['output']>;
  nationality_id?: Maybe<Scalars['uuid']['output']>;
  number_of_buyers?: Maybe<Scalars['Int']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Int']['output']>;
  occupation_id?: Maybe<Scalars['uuid']['output']>;
  occupation_text?: Maybe<Scalars['String']['output']>;
  place_of_origin?: Maybe<Scalars['String']['output']>;
  professional_address_country_code?: Maybe<Scalars['String']['output']>;
  professional_address_lat?: Maybe<Scalars['float8']['output']>;
  professional_address_lng?: Maybe<Scalars['float8']['output']>;
  professional_address_locality?: Maybe<Scalars['String']['output']>;
  professional_address_postcode?: Maybe<Scalars['String']['output']>;
  professional_address_route?: Maybe<Scalars['String']['output']>;
  professional_address_state?: Maybe<Scalars['String']['output']>;
  professional_address_street_number?: Maybe<Scalars['String']['output']>;
  professional_situation?: Maybe<Scalars['user_professional_situation']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
  referring_domain?: Maybe<Scalars['String']['output']>;
  registered_at?: Maybe<Scalars['timestamptz']['output']>;
  residence_country_code?: Maybe<Scalars['String']['output']>;
  residence_state_id?: Maybe<Scalars['uuid']['output']>;
  second_pillar_organisation_id?: Maybe<Scalars['uuid']['output']>;
  services?: Maybe<Array<Scalars['String']['output']>>;
  social_security_number?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "users_test_jwt" */
  test_jwt?: Maybe<Scalars['String']['output']>;
  third_pillar_a_annual_premium_organization_id?: Maybe<Scalars['uuid']['output']>;
  third_pillar_a_organisation_id?: Maybe<Scalars['uuid']['output']>;
  third_pillar_b_organisation_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitter_profile?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  wedding_date?: Maybe<Scalars['date']['output']>;
  work_permit_id?: Maybe<Scalars['uuid']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
  youtube_profile?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  account_manager_id?: InputMaybe<Order_By>;
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  agent_slug?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  annual_leasings?: InputMaybe<Order_By>;
  annual_other_payments?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_second_pillar_organisation?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium_organization?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_a_organisation?: InputMaybe<Order_By>;
  assets_third_pillar_a_organisation_type?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_b_organisation?: InputMaybe<Order_By>;
  assets_third_pillar_b_organisation_type?: InputMaybe<Order_By>;
  branding_color?: InputMaybe<Order_By>;
  branding_logo?: InputMaybe<Order_By>;
  branding_name?: InputMaybe<Order_By>;
  branding_website?: InputMaybe<Order_By>;
  broker_id?: InputMaybe<Order_By>;
  certifications?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  default_team_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  divorce_date?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  email_signature?: InputMaybe<Order_By>;
  email_signature_html?: InputMaybe<Order_By>;
  employer?: InputMaybe<Order_By>;
  employer_id?: InputMaybe<Order_By>;
  employment_commencement_date?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  facebook_profile?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_country_code?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  home_address_locality?: InputMaybe<Order_By>;
  home_address_postcode?: InputMaybe<Order_By>;
  home_address_route?: InputMaybe<Order_By>;
  home_address_state?: InputMaybe<Order_By>;
  home_address_street_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identification_document_expiry_date?: InputMaybe<Order_By>;
  identification_document_issue_date?: InputMaybe<Order_By>;
  identification_document_number?: InputMaybe<Order_By>;
  identification_document_type_id?: InputMaybe<Order_By>;
  imported_id?: InputMaybe<Order_By>;
  instagram_profile?: InputMaybe<Order_By>;
  job_title?: InputMaybe<Order_By>;
  landing_page_url?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  languages?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  linked_in_profile?: InputMaybe<Order_By>;
  marital_partner_id?: InputMaybe<Order_By>;
  marital_status?: InputMaybe<Order_By>;
  matrimonial_regime?: InputMaybe<Order_By>;
  membership_type?: InputMaybe<Order_By>;
  modules?: InputMaybe<Order_By>;
  mortgage_broker_id?: InputMaybe<Order_By>;
  nationality_id?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  occupation_id?: InputMaybe<Order_By>;
  occupation_text?: InputMaybe<Order_By>;
  place_of_origin?: InputMaybe<Order_By>;
  professional_address_country_code?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  professional_address_locality?: InputMaybe<Order_By>;
  professional_address_postcode?: InputMaybe<Order_By>;
  professional_address_route?: InputMaybe<Order_By>;
  professional_address_state?: InputMaybe<Order_By>;
  professional_address_street_number?: InputMaybe<Order_By>;
  professional_situation?: InputMaybe<Order_By>;
  referrer?: InputMaybe<Order_By>;
  referring_domain?: InputMaybe<Order_By>;
  registered_at?: InputMaybe<Order_By>;
  residence_country_code?: InputMaybe<Order_By>;
  residence_state_id?: InputMaybe<Order_By>;
  second_pillar_organisation_id?: InputMaybe<Order_By>;
  services?: InputMaybe<Order_By>;
  social_security_number?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  third_pillar_a_annual_premium_organization_id?: InputMaybe<Order_By>;
  third_pillar_a_organisation_id?: InputMaybe<Order_By>;
  third_pillar_b_organisation_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  twitter_profile?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wedding_date?: InputMaybe<Order_By>;
  work_permit_id?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  youtube_profile?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  account_manager?: InputMaybe<Users_Order_By>;
  account_manager_id?: InputMaybe<Order_By>;
  active_since?: InputMaybe<Order_By>;
  activities_aggregate?: InputMaybe<Activities_Aggregate_Order_By>;
  age?: InputMaybe<Order_By>;
  agent_slug?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_credits?: InputMaybe<Order_By>;
  annual_credits_exist?: InputMaybe<Order_By>;
  annual_income_additional_exist?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  annual_income_salary13?: InputMaybe<Order_By>;
  annual_income_salary14?: InputMaybe<Order_By>;
  annual_leasings?: InputMaybe<Order_By>;
  annual_leasings_exist?: InputMaybe<Order_By>;
  annual_other_exist?: InputMaybe<Order_By>;
  annual_other_payments?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_second_pillar_exist?: InputMaybe<Order_By>;
  assets_second_pillar_organisation?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium_organization?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_a_exist?: InputMaybe<Order_By>;
  assets_third_pillar_a_life_insurance?: InputMaybe<Order_By>;
  assets_third_pillar_a_organisation?: InputMaybe<Order_By>;
  assets_third_pillar_a_organisation_type?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_b_exist?: InputMaybe<Order_By>;
  assets_third_pillar_b_life_insurance?: InputMaybe<Order_By>;
  assets_third_pillar_b_organisation?: InputMaybe<Order_By>;
  assets_third_pillar_b_organisation_type?: InputMaybe<Order_By>;
  assets_third_pillar_exist?: InputMaybe<Order_By>;
  assigned_activities_aggregate?: InputMaybe<Activities_Aggregate_Order_By>;
  auto_assign_leads?: InputMaybe<Order_By>;
  branding_color?: InputMaybe<Order_By>;
  branding_logo?: InputMaybe<Order_By>;
  branding_name?: InputMaybe<Order_By>;
  branding_website?: InputMaybe<Order_By>;
  broker?: InputMaybe<Users_Order_By>;
  broker_id?: InputMaybe<Order_By>;
  broker_leads_aggregate?: InputMaybe<Leads_Aggregate_Order_By>;
  buyer_leads_aggregate?: InputMaybe<Buyer_Leads_Aggregate_Order_By>;
  buyer_offers_aggregate?: InputMaybe<Offers_Aggregate_Order_By>;
  can_edit_settings?: InputMaybe<Order_By>;
  can_user_login_as?: InputMaybe<Order_By>;
  catchment_areas_aggregate?: InputMaybe<Catchment_Areas_Aggregate_Order_By>;
  certifications?: InputMaybe<Order_By>;
  combined_reviews_aggregate?: InputMaybe<Combined_Reviews_Aggregate_Order_By>;
  created_activities_aggregate?: InputMaybe<Activities_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  crm_link?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  default_team?: InputMaybe<Teams_Order_By>;
  default_team_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  divorce_date?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  email_signature?: InputMaybe<Order_By>;
  email_signature_html?: InputMaybe<Order_By>;
  emails_aggregate?: InputMaybe<Emails_Aggregate_Order_By>;
  employer?: InputMaybe<Order_By>;
  employer_id?: InputMaybe<Order_By>;
  employment_commencement_date?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  enquiries_aggregate?: InputMaybe<Enquiries_Aggregate_Order_By>;
  facebook_profile?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  has_accepted_terms?: InputMaybe<Order_By>;
  has_children?: InputMaybe<Order_By>;
  has_free_crm_access?: InputMaybe<Order_By>;
  has_used_trial_button?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_country_code?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  home_address_locality?: InputMaybe<Order_By>;
  home_address_postcode?: InputMaybe<Order_By>;
  home_address_route?: InputMaybe<Order_By>;
  home_address_state?: InputMaybe<Order_By>;
  home_address_street_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identification_document_expiry_date?: InputMaybe<Order_By>;
  identification_document_issue_date?: InputMaybe<Order_By>;
  identification_document_number?: InputMaybe<Order_By>;
  identification_document_type_id?: InputMaybe<Order_By>;
  imported_id?: InputMaybe<Order_By>;
  instagram_profile?: InputMaybe<Order_By>;
  intercom_hash?: InputMaybe<Order_By>;
  is_admin?: InputMaybe<Order_By>;
  is_bot?: InputMaybe<Order_By>;
  is_broker?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_mortgage_broker?: InputMaybe<Order_By>;
  job_title?: InputMaybe<Order_By>;
  landing_page_url?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  languages?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  lead_agents_aggregate?: InputMaybe<Lead_Agents_Aggregate_Order_By>;
  leads_aggregate?: InputMaybe<Leads_Aggregate_Order_By>;
  linked_in_profile?: InputMaybe<Order_By>;
  logins_aggregate?: InputMaybe<Logins_Aggregate_Order_By>;
  lot_sellers_aggregate?: InputMaybe<Lot_Sellers_Aggregate_Order_By>;
  lots_aggregate?: InputMaybe<Lots_Aggregate_Order_By>;
  marital_partner_id?: InputMaybe<Order_By>;
  marital_status?: InputMaybe<Order_By>;
  matrimonial_regime?: InputMaybe<Order_By>;
  membership_type?: InputMaybe<Order_By>;
  modules?: InputMaybe<Order_By>;
  mortgage_broker_id?: InputMaybe<Order_By>;
  nationality?: InputMaybe<Dictionaries_Order_By>;
  nationality_id?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  nylas_account_config_aggregate?: InputMaybe<Nylas_Account_Configs_Aggregate_Order_By>;
  occupation_id?: InputMaybe<Order_By>;
  occupation_text?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisations_Order_By>;
  organisation_user?: InputMaybe<Organisation_Users_Order_By>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Order_By>;
  phone_numbers_aggregate?: InputMaybe<Phone_Numbers_Aggregate_Order_By>;
  place_of_origin?: InputMaybe<Order_By>;
  primary_phone_number_aggregate?: InputMaybe<Phone_Numbers_Aggregate_Order_By>;
  professional_address_country_code?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  professional_address_locality?: InputMaybe<Order_By>;
  professional_address_postcode?: InputMaybe<Order_By>;
  professional_address_route?: InputMaybe<Order_By>;
  professional_address_state?: InputMaybe<Order_By>;
  professional_address_street_number?: InputMaybe<Order_By>;
  professional_situation?: InputMaybe<Order_By>;
  properties_exist?: InputMaybe<Order_By>;
  property_searches_aggregate?: InputMaybe<Property_Searches_Aggregate_Order_By>;
  property_transactions_aggregate?: InputMaybe<Property_Transactions_Aggregate_Order_By>;
  push_notification_tokens_aggregate?: InputMaybe<Push_Notification_Tokens_Aggregate_Order_By>;
  recommended_listings?: InputMaybe<Order_By>;
  referrer?: InputMaybe<Order_By>;
  referring_domain?: InputMaybe<Order_By>;
  registered_at?: InputMaybe<Order_By>;
  residence_country_code?: InputMaybe<Order_By>;
  residence_state_id?: InputMaybe<Order_By>;
  reviews_aggregate?: InputMaybe<Reviews_Aggregate_Order_By>;
  second_pillar_organisation_id?: InputMaybe<Order_By>;
  services?: InputMaybe<Order_By>;
  show_in_agency_pages?: InputMaybe<Order_By>;
  social_security_number?: InputMaybe<Order_By>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Order_By>;
  team_id?: InputMaybe<Order_By>;
  teams_users_aggregate?: InputMaybe<Teams_Users_Aggregate_Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  test_jwt?: InputMaybe<Order_By>;
  third_pillar_a_annual_premium_organization_id?: InputMaybe<Order_By>;
  third_pillar_a_organisation_id?: InputMaybe<Order_By>;
  third_pillar_b_organisation_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  twitter_profile?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updates_daily_tasks?: InputMaybe<Order_By>;
  updates_introduction_to_lead_contacts?: InputMaybe<Order_By>;
  updates_new_lead_assigned_sms?: InputMaybe<Order_By>;
  updates_newsletter?: InputMaybe<Order_By>;
  updates_property_revaluation?: InputMaybe<Order_By>;
  user_images_aggregate?: InputMaybe<User_Images_Aggregate_Order_By>;
  wedding_date?: InputMaybe<Order_By>;
  work_permit?: InputMaybe<Dictionaries_Order_By>;
  work_permit_id?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  youtube_profile?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  AccountManagerId = 'account_manager_id',
  /** column name */
  ActiveSince = 'active_since',
  /** column name */
  AgentSlug = 'agent_slug',
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualCredits = 'annual_credits',
  /** column name */
  AnnualCreditsExist = 'annual_credits_exist',
  /** column name */
  AnnualIncomeAdditionalExist = 'annual_income_additional_exist',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AnnualIncomeSalary = 'annual_income_salary',
  /** column name */
  AnnualIncomeSalary13 = 'annual_income_salary13',
  /** column name */
  AnnualIncomeSalary14 = 'annual_income_salary14',
  /** column name */
  AnnualLeasings = 'annual_leasings',
  /** column name */
  AnnualLeasingsExist = 'annual_leasings_exist',
  /** column name */
  AnnualOtherExist = 'annual_other_exist',
  /** column name */
  AnnualOtherPayments = 'annual_other_payments',
  /** column name */
  AssetsSavings = 'assets_savings',
  /** column name */
  AssetsSavingsDonation = 'assets_savings_donation',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  AssetsSecondPillarExist = 'assets_second_pillar_exist',
  /** column name */
  AssetsSecondPillarOrganisation = 'assets_second_pillar_organisation',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarA = 'assets_third_pillar_a',
  /** column name */
  AssetsThirdPillarAAnnualPremium = 'assets_third_pillar_a_annual_premium',
  /** column name */
  AssetsThirdPillarAAnnualPremiumOrganization = 'assets_third_pillar_a_annual_premium_organization',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  AssetsThirdPillarAExist = 'assets_third_pillar_a_exist',
  /** column name */
  AssetsThirdPillarALifeInsurance = 'assets_third_pillar_a_life_insurance',
  /** column name */
  AssetsThirdPillarAOrganisation = 'assets_third_pillar_a_organisation',
  /** column name */
  AssetsThirdPillarAOrganisationType = 'assets_third_pillar_a_organisation_type',
  /** column name */
  AssetsThirdPillarB = 'assets_third_pillar_b',
  /** column name */
  AssetsThirdPillarBAnnualPremium = 'assets_third_pillar_b_annual_premium',
  /** column name */
  AssetsThirdPillarBExist = 'assets_third_pillar_b_exist',
  /** column name */
  AssetsThirdPillarBLifeInsurance = 'assets_third_pillar_b_life_insurance',
  /** column name */
  AssetsThirdPillarBOrganisation = 'assets_third_pillar_b_organisation',
  /** column name */
  AssetsThirdPillarBOrganisationType = 'assets_third_pillar_b_organisation_type',
  /** column name */
  AssetsThirdPillarExist = 'assets_third_pillar_exist',
  /** column name */
  AutoAssignLeads = 'auto_assign_leads',
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  BrandingLogo = 'branding_logo',
  /** column name */
  BrandingName = 'branding_name',
  /** column name */
  BrandingWebsite = 'branding_website',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CanEditSettings = 'can_edit_settings',
  /** column name */
  CanUserLoginAs = 'can_user_login_as',
  /** column name */
  Certifications = 'certifications',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Debt = 'debt',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  DebtOtherCreditsBalance = 'debt_other_credits_balance',
  /** column name */
  DefaultTeamId = 'default_team_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  DivorceDate = 'divorce_date',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmailSignature = 'email_signature',
  /** column name */
  EmailSignatureHtml = 'email_signature_html',
  /** column name */
  Employer = 'employer',
  /** column name */
  EmployerId = 'employer_id',
  /** column name */
  EmploymentCommencementDate = 'employment_commencement_date',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  FacebookProfile = 'facebook_profile',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasChildren = 'has_children',
  /** column name */
  HasFreeCrmAccess = 'has_free_crm_access',
  /** column name */
  HasUsedTrialButton = 'has_used_trial_button',
  /** column name */
  HiresOnRealadvisor = 'hires_on_realadvisor',
  /** column name */
  HomeAddressCountryCode = 'home_address_country_code',
  /** column name */
  HomeAddressLat = 'home_address_lat',
  /** column name */
  HomeAddressLng = 'home_address_lng',
  /** column name */
  HomeAddressLocality = 'home_address_locality',
  /** column name */
  HomeAddressPostcode = 'home_address_postcode',
  /** column name */
  HomeAddressRoute = 'home_address_route',
  /** column name */
  HomeAddressState = 'home_address_state',
  /** column name */
  HomeAddressStreetNumber = 'home_address_street_number',
  /** column name */
  Id = 'id',
  /** column name */
  IdentificationDocumentExpiryDate = 'identification_document_expiry_date',
  /** column name */
  IdentificationDocumentIssueDate = 'identification_document_issue_date',
  /** column name */
  IdentificationDocumentNumber = 'identification_document_number',
  /** column name */
  IdentificationDocumentTypeId = 'identification_document_type_id',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  InstagramProfile = 'instagram_profile',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  IsBot = 'is_bot',
  /** column name */
  IsBroker = 'is_broker',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMortgageBroker = 'is_mortgage_broker',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  LandingPageUrl = 'landing_page_url',
  /** column name */
  Language = 'language',
  /** column name */
  Languages = 'languages',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LinkedInProfile = 'linked_in_profile',
  /** column name */
  MaritalPartnerId = 'marital_partner_id',
  /** column name */
  MaritalStatus = 'marital_status',
  /** column name */
  MatrimonialRegime = 'matrimonial_regime',
  /** column name */
  MembershipType = 'membership_type',
  /** column name */
  Modules = 'modules',
  /** column name */
  MortgageBrokerId = 'mortgage_broker_id',
  /** column name */
  NationalityId = 'nationality_id',
  /** column name */
  NumberOfBuyers = 'number_of_buyers',
  /** column name */
  NumberOfDependantChildren = 'number_of_dependant_children',
  /** column name */
  OccupationId = 'occupation_id',
  /** column name */
  OccupationText = 'occupation_text',
  /** column name */
  PlaceOfOrigin = 'place_of_origin',
  /** column name */
  ProfessionalAddressCountryCode = 'professional_address_country_code',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  ProfessionalAddressLocality = 'professional_address_locality',
  /** column name */
  ProfessionalAddressPostcode = 'professional_address_postcode',
  /** column name */
  ProfessionalAddressRoute = 'professional_address_route',
  /** column name */
  ProfessionalAddressState = 'professional_address_state',
  /** column name */
  ProfessionalAddressStreetNumber = 'professional_address_street_number',
  /** column name */
  ProfessionalSituation = 'professional_situation',
  /** column name */
  PropertiesExist = 'properties_exist',
  /** column name */
  RecommendedListings = 'recommended_listings',
  /** column name */
  Referrer = 'referrer',
  /** column name */
  ReferringDomain = 'referring_domain',
  /** column name */
  RegisteredAt = 'registered_at',
  /** column name */
  ResidenceCountryCode = 'residence_country_code',
  /** column name */
  ResidenceStateId = 'residence_state_id',
  /** column name */
  SecondPillarOrganisationId = 'second_pillar_organisation_id',
  /** column name */
  Services = 'services',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  SocialSecurityNumber = 'social_security_number',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPillarAAnnualPremiumOrganizationId = 'third_pillar_a_annual_premium_organization_id',
  /** column name */
  ThirdPillarAOrganisationId = 'third_pillar_a_organisation_id',
  /** column name */
  ThirdPillarBOrganisationId = 'third_pillar_b_organisation_id',
  /** column name */
  Title = 'title',
  /** column name */
  TwitterProfile = 'twitter_profile',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatesDailyTasks = 'updates_daily_tasks',
  /** column name */
  UpdatesIntroductionToLeadContacts = 'updates_introduction_to_lead_contacts',
  /** column name */
  UpdatesNewLeadAssignedSms = 'updates_new_lead_assigned_sms',
  /** column name */
  UpdatesNewsletter = 'updates_newsletter',
  /** column name */
  UpdatesPropertyRevaluation = 'updates_property_revaluation',
  /** column name */
  WeddingDate = 'wedding_date',
  /** column name */
  WorkPermitId = 'work_permit_id',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement',
  /** column name */
  YoutubeProfile = 'youtube_profile'
}

/** select "users_aggregate_bool_exp_avg_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AnnualCreditsExist = 'annual_credits_exist',
  /** column name */
  AnnualIncomeAdditionalExist = 'annual_income_additional_exist',
  /** column name */
  AnnualIncomeSalary13 = 'annual_income_salary13',
  /** column name */
  AnnualIncomeSalary14 = 'annual_income_salary14',
  /** column name */
  AnnualLeasingsExist = 'annual_leasings_exist',
  /** column name */
  AnnualOtherExist = 'annual_other_exist',
  /** column name */
  AssetsSecondPillarExist = 'assets_second_pillar_exist',
  /** column name */
  AssetsThirdPillarAExist = 'assets_third_pillar_a_exist',
  /** column name */
  AssetsThirdPillarALifeInsurance = 'assets_third_pillar_a_life_insurance',
  /** column name */
  AssetsThirdPillarBExist = 'assets_third_pillar_b_exist',
  /** column name */
  AssetsThirdPillarBLifeInsurance = 'assets_third_pillar_b_life_insurance',
  /** column name */
  AssetsThirdPillarExist = 'assets_third_pillar_exist',
  /** column name */
  AutoAssignLeads = 'auto_assign_leads',
  /** column name */
  CanEditSettings = 'can_edit_settings',
  /** column name */
  CanUserLoginAs = 'can_user_login_as',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasChildren = 'has_children',
  /** column name */
  HasFreeCrmAccess = 'has_free_crm_access',
  /** column name */
  HasUsedTrialButton = 'has_used_trial_button',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  IsBot = 'is_bot',
  /** column name */
  IsBroker = 'is_broker',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMortgageBroker = 'is_mortgage_broker',
  /** column name */
  PropertiesExist = 'properties_exist',
  /** column name */
  RecommendedListings = 'recommended_listings',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  UpdatesDailyTasks = 'updates_daily_tasks',
  /** column name */
  UpdatesIntroductionToLeadContacts = 'updates_introduction_to_lead_contacts',
  /** column name */
  UpdatesNewLeadAssignedSms = 'updates_new_lead_assigned_sms',
  /** column name */
  UpdatesNewsletter = 'updates_newsletter',
  /** column name */
  UpdatesPropertyRevaluation = 'updates_property_revaluation'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AnnualCreditsExist = 'annual_credits_exist',
  /** column name */
  AnnualIncomeAdditionalExist = 'annual_income_additional_exist',
  /** column name */
  AnnualIncomeSalary13 = 'annual_income_salary13',
  /** column name */
  AnnualIncomeSalary14 = 'annual_income_salary14',
  /** column name */
  AnnualLeasingsExist = 'annual_leasings_exist',
  /** column name */
  AnnualOtherExist = 'annual_other_exist',
  /** column name */
  AssetsSecondPillarExist = 'assets_second_pillar_exist',
  /** column name */
  AssetsThirdPillarAExist = 'assets_third_pillar_a_exist',
  /** column name */
  AssetsThirdPillarALifeInsurance = 'assets_third_pillar_a_life_insurance',
  /** column name */
  AssetsThirdPillarBExist = 'assets_third_pillar_b_exist',
  /** column name */
  AssetsThirdPillarBLifeInsurance = 'assets_third_pillar_b_life_insurance',
  /** column name */
  AssetsThirdPillarExist = 'assets_third_pillar_exist',
  /** column name */
  AutoAssignLeads = 'auto_assign_leads',
  /** column name */
  CanEditSettings = 'can_edit_settings',
  /** column name */
  CanUserLoginAs = 'can_user_login_as',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasChildren = 'has_children',
  /** column name */
  HasFreeCrmAccess = 'has_free_crm_access',
  /** column name */
  HasUsedTrialButton = 'has_used_trial_button',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  IsBot = 'is_bot',
  /** column name */
  IsBroker = 'is_broker',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMortgageBroker = 'is_mortgage_broker',
  /** column name */
  PropertiesExist = 'properties_exist',
  /** column name */
  RecommendedListings = 'recommended_listings',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  UpdatesDailyTasks = 'updates_daily_tasks',
  /** column name */
  UpdatesIntroductionToLeadContacts = 'updates_introduction_to_lead_contacts',
  /** column name */
  UpdatesNewLeadAssignedSms = 'updates_new_lead_assigned_sms',
  /** column name */
  UpdatesNewsletter = 'updates_newsletter',
  /** column name */
  UpdatesPropertyRevaluation = 'updates_property_revaluation'
}

/** select "users_aggregate_bool_exp_corr_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "users_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "users_aggregate_bool_exp_max_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "users_aggregate_bool_exp_min_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "users_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "users_aggregate_bool_exp_sum_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "users_aggregate_bool_exp_var_samp_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  /** The year when the agent started operating */
  active_since?: InputMaybe<Scalars['Int']['input']>;
  agent_slug?: InputMaybe<Scalars['String']['input']>;
  auto_assign_leads?: InputMaybe<Scalars['Boolean']['input']>;
  branding_color?: InputMaybe<Scalars['String']['input']>;
  branding_logo?: InputMaybe<Scalars['String']['input']>;
  branding_name?: InputMaybe<Scalars['String']['input']>;
  branding_website?: InputMaybe<Scalars['String']['input']>;
  certifications?: InputMaybe<Array<Scalars['String']['input']>>;
  default_team_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facebook_profile?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  has_free_crm_access?: InputMaybe<Scalars['Boolean']['input']>;
  hires_on_realadvisor?: InputMaybe<Scalars['Int']['input']>;
  home_address_country_code?: InputMaybe<Scalars['String']['input']>;
  home_address_locality?: InputMaybe<Scalars['String']['input']>;
  home_address_postcode?: InputMaybe<Scalars['String']['input']>;
  home_address_route?: InputMaybe<Scalars['String']['input']>;
  home_address_state?: InputMaybe<Scalars['String']['input']>;
  home_address_street_number?: InputMaybe<Scalars['String']['input']>;
  instagram_profile?: InputMaybe<Scalars['String']['input']>;
  is_broker?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  linked_in_profile?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  show_in_agency_pages?: InputMaybe<Scalars['Boolean']['input']>;
  twitter_profile?: InputMaybe<Scalars['String']['input']>;
  updates_newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  youtube_profile?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  annual_costs_child_support?: Maybe<Scalars['Float']['output']>;
  annual_costs_leasing?: Maybe<Scalars['Float']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['Float']['output']>;
  annual_income_bonus?: Maybe<Scalars['Float']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['Float']['output']>;
  annual_income_other?: Maybe<Scalars['Float']['output']>;
  annual_income_rent?: Maybe<Scalars['Float']['output']>;
  annual_income_salary?: Maybe<Scalars['Float']['output']>;
  assets_savings?: Maybe<Scalars['Float']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  assets_securities?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  debt_leasing_balance?: Maybe<Scalars['Float']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['Float']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  employment_rate?: Maybe<Scalars['Float']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Float']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  professional_address_lat?: Maybe<Scalars['Float']['output']>;
  professional_address_lng?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "users" */
export type Users_Stddev_Order_By = {
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  annual_costs_child_support?: Maybe<Scalars['Float']['output']>;
  annual_costs_leasing?: Maybe<Scalars['Float']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['Float']['output']>;
  annual_income_bonus?: Maybe<Scalars['Float']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['Float']['output']>;
  annual_income_other?: Maybe<Scalars['Float']['output']>;
  annual_income_rent?: Maybe<Scalars['Float']['output']>;
  annual_income_salary?: Maybe<Scalars['Float']['output']>;
  assets_savings?: Maybe<Scalars['Float']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  assets_securities?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  debt_leasing_balance?: Maybe<Scalars['Float']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['Float']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  employment_rate?: Maybe<Scalars['Float']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Float']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  professional_address_lat?: Maybe<Scalars['Float']['output']>;
  professional_address_lng?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "users" */
export type Users_Stddev_Pop_Order_By = {
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  annual_costs_child_support?: Maybe<Scalars['Float']['output']>;
  annual_costs_leasing?: Maybe<Scalars['Float']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['Float']['output']>;
  annual_income_bonus?: Maybe<Scalars['Float']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['Float']['output']>;
  annual_income_other?: Maybe<Scalars['Float']['output']>;
  annual_income_rent?: Maybe<Scalars['Float']['output']>;
  annual_income_salary?: Maybe<Scalars['Float']['output']>;
  assets_savings?: Maybe<Scalars['Float']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  assets_securities?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  debt_leasing_balance?: Maybe<Scalars['Float']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['Float']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  employment_rate?: Maybe<Scalars['Float']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Float']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  professional_address_lat?: Maybe<Scalars['Float']['output']>;
  professional_address_lng?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "users" */
export type Users_Stddev_Samp_Order_By = {
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  account_manager_id?: InputMaybe<Scalars['uuid']['input']>;
  /** The year when the agent started operating */
  active_since?: InputMaybe<Scalars['Int']['input']>;
  agent_slug?: InputMaybe<Scalars['String']['input']>;
  annual_costs_child_support?: InputMaybe<Scalars['float8']['input']>;
  annual_costs_leasing?: InputMaybe<Scalars['float8']['input']>;
  annual_costs_other_credits?: InputMaybe<Scalars['float8']['input']>;
  annual_credits?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  annual_credits_exist?: InputMaybe<Scalars['Boolean']['input']>;
  annual_income_additional_exist?: InputMaybe<Scalars['Boolean']['input']>;
  annual_income_bonus?: InputMaybe<Scalars['float8']['input']>;
  annual_income_family_allowances?: InputMaybe<Scalars['float8']['input']>;
  annual_income_other?: InputMaybe<Scalars['float8']['input']>;
  annual_income_rent?: InputMaybe<Scalars['float8']['input']>;
  annual_income_salary?: InputMaybe<Scalars['Int']['input']>;
  annual_income_salary13?: InputMaybe<Scalars['Boolean']['input']>;
  annual_income_salary14?: InputMaybe<Scalars['Boolean']['input']>;
  annual_leasings?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  annual_leasings_exist?: InputMaybe<Scalars['Boolean']['input']>;
  annual_other_exist?: InputMaybe<Scalars['Boolean']['input']>;
  annual_other_payments?: InputMaybe<Array<Scalars['float8']['input']>>;
  assets_savings?: InputMaybe<Scalars['Int']['input']>;
  assets_savings_donation?: InputMaybe<Scalars['Float']['input']>;
  assets_second_pillar?: InputMaybe<Scalars['Int']['input']>;
  assets_second_pillar_exist?: InputMaybe<Scalars['Boolean']['input']>;
  assets_second_pillar_organisation?: InputMaybe<Scalars['String']['input']>;
  assets_securities?: InputMaybe<Scalars['float8']['input']>;
  assets_third_pillar_a?: InputMaybe<Scalars['Int']['input']>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Scalars['Float']['input']>;
  assets_third_pillar_a_annual_premium_organization?: InputMaybe<Scalars['String']['input']>;
  assets_third_pillar_a_cash?: InputMaybe<Scalars['float8']['input']>;
  assets_third_pillar_a_exist?: InputMaybe<Scalars['Boolean']['input']>;
  assets_third_pillar_a_life_insurance?: InputMaybe<Scalars['Boolean']['input']>;
  assets_third_pillar_a_organisation?: InputMaybe<Scalars['String']['input']>;
  assets_third_pillar_a_organisation_type?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  assets_third_pillar_b?: InputMaybe<Scalars['Float']['input']>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Scalars['Float']['input']>;
  assets_third_pillar_b_exist?: InputMaybe<Scalars['Boolean']['input']>;
  assets_third_pillar_b_life_insurance?: InputMaybe<Scalars['Boolean']['input']>;
  assets_third_pillar_b_organisation?: InputMaybe<Scalars['String']['input']>;
  assets_third_pillar_b_organisation_type?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  assets_third_pillar_exist?: InputMaybe<Scalars['Boolean']['input']>;
  auto_assign_leads?: InputMaybe<Scalars['Boolean']['input']>;
  branding_color?: InputMaybe<Scalars['String']['input']>;
  branding_logo?: InputMaybe<Scalars['String']['input']>;
  branding_name?: InputMaybe<Scalars['String']['input']>;
  branding_website?: InputMaybe<Scalars['String']['input']>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  can_edit_settings?: InputMaybe<Scalars['Boolean']['input']>;
  can_user_login_as?: InputMaybe<Scalars['Boolean']['input']>;
  certifications?: InputMaybe<Array<Scalars['String']['input']>>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  date_of_birth?: InputMaybe<Scalars['date']['input']>;
  debt?: InputMaybe<Scalars['Int']['input']>;
  debt_leasing_balance?: InputMaybe<Scalars['float8']['input']>;
  debt_mortgage_balance?: InputMaybe<Scalars['float8']['input']>;
  debt_other_credits_balance?: InputMaybe<Scalars['Int']['input']>;
  default_team_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  divorce_date?: InputMaybe<Scalars['date']['input']>;
  donation?: InputMaybe<Scalars['float8']['input']>;
  email_signature?: InputMaybe<Scalars['String']['input']>;
  email_signature_html?: InputMaybe<Scalars['String']['input']>;
  employer?: InputMaybe<Scalars['String']['input']>;
  employer_id?: InputMaybe<Scalars['uuid']['input']>;
  employment_commencement_date?: InputMaybe<Scalars['date']['input']>;
  employment_rate?: InputMaybe<Scalars['float8']['input']>;
  facebook_profile?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  has_accepted_terms?: InputMaybe<Scalars['Boolean']['input']>;
  has_children?: InputMaybe<Scalars['Boolean']['input']>;
  has_free_crm_access?: InputMaybe<Scalars['Boolean']['input']>;
  has_used_trial_button?: InputMaybe<Scalars['Boolean']['input']>;
  hires_on_realadvisor?: InputMaybe<Scalars['Int']['input']>;
  home_address_country_code?: InputMaybe<Scalars['String']['input']>;
  home_address_lat?: InputMaybe<Scalars['Float']['input']>;
  home_address_lng?: InputMaybe<Scalars['Float']['input']>;
  home_address_locality?: InputMaybe<Scalars['String']['input']>;
  home_address_postcode?: InputMaybe<Scalars['String']['input']>;
  home_address_route?: InputMaybe<Scalars['String']['input']>;
  home_address_state?: InputMaybe<Scalars['String']['input']>;
  home_address_street_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  identification_document_expiry_date?: InputMaybe<Scalars['date']['input']>;
  identification_document_issue_date?: InputMaybe<Scalars['date']['input']>;
  identification_document_number?: InputMaybe<Scalars['String']['input']>;
  identification_document_type_id?: InputMaybe<Scalars['uuid']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  instagram_profile?: InputMaybe<Scalars['String']['input']>;
  is_admin?: InputMaybe<Scalars['Boolean']['input']>;
  is_bot?: InputMaybe<Scalars['Boolean']['input']>;
  is_broker?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_mortgage_broker?: InputMaybe<Scalars['Boolean']['input']>;
  job_title?: InputMaybe<Scalars['String']['input']>;
  landing_page_url?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  last_bonus?: InputMaybe<Scalars['float8']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  linked_in_profile?: InputMaybe<Scalars['String']['input']>;
  marital_partner_id?: InputMaybe<Scalars['uuid']['input']>;
  marital_status?: InputMaybe<Scalars['marital_status']['input']>;
  matrimonial_regime?: InputMaybe<Scalars['String']['input']>;
  membership_type?: InputMaybe<Scalars['String']['input']>;
  modules?: InputMaybe<Array<Scalars['String']['input']>>;
  mortgage_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  nationality_id?: InputMaybe<Scalars['uuid']['input']>;
  number_of_buyers?: InputMaybe<Scalars['Int']['input']>;
  number_of_dependant_children?: InputMaybe<Scalars['Int']['input']>;
  occupation_id?: InputMaybe<Scalars['uuid']['input']>;
  occupation_text?: InputMaybe<Scalars['String']['input']>;
  place_of_origin?: InputMaybe<Scalars['String']['input']>;
  professional_address_country_code?: InputMaybe<Scalars['String']['input']>;
  professional_address_lat?: InputMaybe<Scalars['float8']['input']>;
  professional_address_lng?: InputMaybe<Scalars['float8']['input']>;
  professional_address_locality?: InputMaybe<Scalars['String']['input']>;
  professional_address_postcode?: InputMaybe<Scalars['String']['input']>;
  professional_address_route?: InputMaybe<Scalars['String']['input']>;
  professional_address_state?: InputMaybe<Scalars['String']['input']>;
  professional_address_street_number?: InputMaybe<Scalars['String']['input']>;
  professional_situation?: InputMaybe<Scalars['user_professional_situation']['input']>;
  properties_exist?: InputMaybe<Scalars['Boolean']['input']>;
  recommended_listings?: InputMaybe<Scalars['Boolean']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  referring_domain?: InputMaybe<Scalars['String']['input']>;
  registered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  residence_country_code?: InputMaybe<Scalars['String']['input']>;
  residence_state_id?: InputMaybe<Scalars['uuid']['input']>;
  second_pillar_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  show_in_agency_pages?: InputMaybe<Scalars['Boolean']['input']>;
  social_security_number?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  third_pillar_a_annual_premium_organization_id?: InputMaybe<Scalars['uuid']['input']>;
  third_pillar_a_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  third_pillar_b_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitter_profile?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updates_daily_tasks?: InputMaybe<Scalars['Boolean']['input']>;
  updates_introduction_to_lead_contacts?: InputMaybe<Scalars['Boolean']['input']>;
  updates_new_lead_assigned_sms?: InputMaybe<Scalars['Boolean']['input']>;
  updates_newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  updates_property_revaluation?: InputMaybe<Scalars['Boolean']['input']>;
  wedding_date?: InputMaybe<Scalars['date']['input']>;
  work_permit_id?: InputMaybe<Scalars['uuid']['input']>;
  yearly_revenues_at_retirement?: InputMaybe<Scalars['float8']['input']>;
  youtube_profile?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  annual_costs_child_support?: Maybe<Scalars['float8']['output']>;
  annual_costs_leasing?: Maybe<Scalars['float8']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['float8']['output']>;
  annual_income_bonus?: Maybe<Scalars['float8']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['float8']['output']>;
  annual_income_other?: Maybe<Scalars['float8']['output']>;
  annual_income_rent?: Maybe<Scalars['float8']['output']>;
  annual_income_salary?: Maybe<Scalars['Int']['output']>;
  assets_savings?: Maybe<Scalars['Int']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Int']['output']>;
  assets_securities?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Int']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Int']['output']>;
  debt_leasing_balance?: Maybe<Scalars['float8']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['float8']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Int']['output']>;
  donation?: Maybe<Scalars['float8']['output']>;
  employment_rate?: Maybe<Scalars['float8']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Int']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['float8']['output']>;
  number_of_buyers?: Maybe<Scalars['Int']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Int']['output']>;
  professional_address_lat?: Maybe<Scalars['float8']['output']>;
  professional_address_lng?: Maybe<Scalars['float8']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "users" */
export type Users_Sum_Order_By = {
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  ActiveSince = 'active_since',
  /** column name */
  AgentSlug = 'agent_slug',
  /** column name */
  AutoAssignLeads = 'auto_assign_leads',
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  BrandingLogo = 'branding_logo',
  /** column name */
  BrandingName = 'branding_name',
  /** column name */
  BrandingWebsite = 'branding_website',
  /** column name */
  Certifications = 'certifications',
  /** column name */
  DefaultTeamId = 'default_team_id',
  /** column name */
  Description = 'description',
  /** column name */
  FacebookProfile = 'facebook_profile',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  HasFreeCrmAccess = 'has_free_crm_access',
  /** column name */
  HiresOnRealadvisor = 'hires_on_realadvisor',
  /** column name */
  HomeAddressCountryCode = 'home_address_country_code',
  /** column name */
  HomeAddressLocality = 'home_address_locality',
  /** column name */
  HomeAddressPostcode = 'home_address_postcode',
  /** column name */
  HomeAddressRoute = 'home_address_route',
  /** column name */
  HomeAddressState = 'home_address_state',
  /** column name */
  HomeAddressStreetNumber = 'home_address_street_number',
  /** column name */
  InstagramProfile = 'instagram_profile',
  /** column name */
  IsBroker = 'is_broker',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Language = 'language',
  /** column name */
  Languages = 'languages',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LinkedInProfile = 'linked_in_profile',
  /** column name */
  Services = 'services',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  TwitterProfile = 'twitter_profile',
  /** column name */
  UpdatesNewsletter = 'updates_newsletter',
  /** column name */
  YoutubeProfile = 'youtube_profile'
}

export type Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  annual_costs_child_support?: Maybe<Scalars['Float']['output']>;
  annual_costs_leasing?: Maybe<Scalars['Float']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['Float']['output']>;
  annual_income_bonus?: Maybe<Scalars['Float']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['Float']['output']>;
  annual_income_other?: Maybe<Scalars['Float']['output']>;
  annual_income_rent?: Maybe<Scalars['Float']['output']>;
  annual_income_salary?: Maybe<Scalars['Float']['output']>;
  assets_savings?: Maybe<Scalars['Float']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  assets_securities?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  debt_leasing_balance?: Maybe<Scalars['Float']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['Float']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  employment_rate?: Maybe<Scalars['Float']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Float']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  professional_address_lat?: Maybe<Scalars['Float']['output']>;
  professional_address_lng?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "users" */
export type Users_Var_Pop_Order_By = {
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  annual_costs_child_support?: Maybe<Scalars['Float']['output']>;
  annual_costs_leasing?: Maybe<Scalars['Float']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['Float']['output']>;
  annual_income_bonus?: Maybe<Scalars['Float']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['Float']['output']>;
  annual_income_other?: Maybe<Scalars['Float']['output']>;
  annual_income_rent?: Maybe<Scalars['Float']['output']>;
  annual_income_salary?: Maybe<Scalars['Float']['output']>;
  assets_savings?: Maybe<Scalars['Float']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  assets_securities?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  debt_leasing_balance?: Maybe<Scalars['Float']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['Float']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  employment_rate?: Maybe<Scalars['Float']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Float']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  professional_address_lat?: Maybe<Scalars['Float']['output']>;
  professional_address_lng?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "users" */
export type Users_Var_Samp_Order_By = {
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  annual_costs_child_support?: Maybe<Scalars['Float']['output']>;
  annual_costs_leasing?: Maybe<Scalars['Float']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['Float']['output']>;
  annual_income_bonus?: Maybe<Scalars['Float']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['Float']['output']>;
  annual_income_other?: Maybe<Scalars['Float']['output']>;
  annual_income_rent?: Maybe<Scalars['Float']['output']>;
  annual_income_salary?: Maybe<Scalars['Float']['output']>;
  assets_savings?: Maybe<Scalars['Float']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  assets_securities?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  debt_leasing_balance?: Maybe<Scalars['Float']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['Float']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  employment_rate?: Maybe<Scalars['Float']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Float']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  professional_address_lat?: Maybe<Scalars['Float']['output']>;
  professional_address_lng?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "users" */
export type Users_Variance_Order_By = {
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "valuation_models" */
export type Valuation_Models = {
  name: Scalars['String']['output'];
  short_name?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "valuation_models". All fields are combined with a logical 'AND'. */
export type Valuation_Models_Bool_Exp = {
  _and?: InputMaybe<Array<Valuation_Models_Bool_Exp>>;
  _not?: InputMaybe<Valuation_Models_Bool_Exp>;
  _or?: InputMaybe<Array<Valuation_Models_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "valuation_models". */
export type Valuation_Models_Order_By = {
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
};

/** select columns of table "valuation_models" */
export enum Valuation_Models_Select_Column {
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name'
}

/** Streaming cursor of the table "valuation_models" */
export type Valuation_Models_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Valuation_Models_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Valuation_Models_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "valuations" */
export type Valuations = {
  /** An object relationship */
  appraisal?: Maybe<Appraisals>;
  id: Scalars['uuid']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  model: Scalars['String']['output'];
  /** An object relationship */
  valuation_model: Valuation_Models;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by aggregate values of table "valuations" */
export type Valuations_Aggregate_Order_By = {
  avg?: InputMaybe<Valuations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Valuations_Max_Order_By>;
  min?: InputMaybe<Valuations_Min_Order_By>;
  stddev?: InputMaybe<Valuations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Valuations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Valuations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Valuations_Sum_Order_By>;
  var_pop?: InputMaybe<Valuations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Valuations_Var_Samp_Order_By>;
  variance?: InputMaybe<Valuations_Variance_Order_By>;
};

/** order by avg() on columns of table "valuations" */
export type Valuations_Avg_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "valuations". All fields are combined with a logical 'AND'. */
export type Valuations_Bool_Exp = {
  _and?: InputMaybe<Array<Valuations_Bool_Exp>>;
  _not?: InputMaybe<Valuations_Bool_Exp>;
  _or?: InputMaybe<Array<Valuations_Bool_Exp>>;
  appraisal?: InputMaybe<Appraisals_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  max?: InputMaybe<Float_Comparison_Exp>;
  min?: InputMaybe<Float_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  valuation_model?: InputMaybe<Valuation_Models_Bool_Exp>;
  value?: InputMaybe<Float_Comparison_Exp>;
};

/** order by max() on columns of table "valuations" */
export type Valuations_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "valuations" */
export type Valuations_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "valuations". */
export type Valuations_Order_By = {
  appraisal?: InputMaybe<Appraisals_Order_By>;
  id?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  valuation_model?: InputMaybe<Valuation_Models_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "valuations" */
export enum Valuations_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Max = 'max',
  /** column name */
  Min = 'min',
  /** column name */
  Model = 'model',
  /** column name */
  Value = 'value'
}

/** order by stddev() on columns of table "valuations" */
export type Valuations_Stddev_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "valuations" */
export type Valuations_Stddev_Pop_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "valuations" */
export type Valuations_Stddev_Samp_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "valuations" */
export type Valuations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Valuations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Valuations_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** order by sum() on columns of table "valuations" */
export type Valuations_Sum_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "valuations" */
export type Valuations_Var_Pop_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "valuations" */
export type Valuations_Var_Samp_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "valuations" */
export type Valuations_Variance_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "vector". All fields are combined with logical 'AND'. */
export type Vector_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['vector']['input']>;
  _gt?: InputMaybe<Scalars['vector']['input']>;
  _gte?: InputMaybe<Scalars['vector']['input']>;
  _in?: InputMaybe<Array<Scalars['vector']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['vector']['input']>;
  _lte?: InputMaybe<Scalars['vector']['input']>;
  _neq?: InputMaybe<Scalars['vector']['input']>;
  _nin?: InputMaybe<Array<Scalars['vector']['input']>>;
};

export type GetPropertyTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPropertyTypesQuery = { property_types: Array<{ id: string, name?: string | null, label?: string | null, main_type?: string | null, type: string }> };

export type InsertUserMutationVariables = Exact<{
  user: Users_Insert_Input;
}>;


export type InsertUserMutation = { insert_users_one?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null };

export type AgentCard_UserFragment = { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, logo?: { id: string, url?: string | null } | null } | null, organisation?: { id: string, organisation_images: Array<{ id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } }> } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> };

export type AutoAssignRankingChQueryVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type AutoAssignRankingChQuery = { auto_assign_ranking_ch?: { message: string, agents?: Array<{ id?: string | null, membership_type?: string | null, modules?: Array<string | null> | null, full_name?: string | null, crm_link?: string | null, total_weighted_leads_assigned?: number | null, total_leads_assigned_30_days?: number | null, total_unique_lead_visits?: number | null, total_lead_mandates?: number | null, total_own_mandates?: number | null, total_transactions?: number | null, total_commissions?: number | null, total_agent_share?: number | null, lead_to_visit_conversion?: number | null, visit_to_mandate_conversion?: number | null, mandate_to_transaction_conversion?: number | null, lead_to_transaction_conversion?: number | null, lead_to_visit_score?: number | null, visit_to_mandate_score?: number | null, mandate_to_transaction_score?: number | null, lead_to_transaction_score?: number | null, overall_score?: number | null, revenues_per_lead?: number | null, gross_margin_per_lead?: number | null, number_of_overdue_leads?: number | null, number_of_overdue_days?: number | null, number_of_leads_without_activity?: number | null, number_of_listings_available?: number | null } | null> | null } | null, leads_by_pk?: { property?: { agent_ranking?: Array<{ transactions_in_location?: number | null, transactions_in_municipality?: number | null, transactions_in_district?: number | null, transactions_in_state?: number | null, total_transactions: number, distance?: number | null, agent?: { id: string, full_name?: string | null } | null }> | null } | null } | null };

export type AutoAssignRankingQueryVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type AutoAssignRankingQuery = { auto_assign_ranking?: { message: string, should_auto_assign?: boolean | null, assign_to?: { id?: string | null, full_name?: string | null, crm_link?: string | null } | null, agents?: Array<{ id?: string | null, full_name?: string | null, crm_link?: string | null, auto_assign_leads?: boolean | null, cost_per_lead?: number | null, amount_spent?: number | null, assigned_leads?: number | null, already_assigned?: boolean | null, subscriptions?: Array<{ id?: string | null, current_period_start?: string | null, current_period_end?: string | null, current_period_pct?: number | null, incurred_cost?: number | null, latest_invoice?: string | null, start_date?: string | null, status?: string | null, total_amount?: number | null, customer_email?: string | null } | null> | null } | null> | null } | null };

export type SentEmailCountOverRolling24HQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  date: Scalars['timestamptz']['input'];
}>;


export type SentEmailCountOverRolling24HQuery = { email_messages_aggregate: { aggregate?: { count: number } | null } };

export type EmailTemplateFormFragment = { id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> };

export type EmailTemplateFormEnquiryFragment = { id: string, lot?: { id: string, lot_reference?: string | null, mandate_type?: string | null, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null, property: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } } | null };

export type EmailTemplateFormBuyerLeadFragment = { id: string, lot: { id: string, lot_reference?: string | null, mandate_type?: string | null, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null, property: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } } };

export type EmailTemplateFormListingFragment = { id: string, lot_reference?: string | null, mandate_type?: string | null, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null, property: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } };

export type EmailTemplateFormLeadFragment = { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }>, broker?: { id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, lots: Array<{ id: string, lot_reference?: string | null, mandate_type?: string | null, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null }>, property?: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } | null };

export type GetDefaultUsersAndTemplatesQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  skipUsers: Scalars['Boolean']['input'];
}>;


export type GetDefaultUsersAndTemplatesQuery = { users?: Array<{ id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> }>, doc_templates: Array<{ id: string, name: string, type: Doc_Template_Type_Enum_Enum, active: boolean, doc_templates_tenants: Array<{ tenant_id: string, is_default: boolean }> }> };

export type EmailTemplateSelectFragment = { id: string, name?: string | null, subject?: string | null, subject_plaintext?: string | null, text?: string | null, add_signature: boolean, email_templates_files: Array<{ file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> };

export type SearchEmailTemplatesQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchEmailTemplatesQuery = { email_templates: Array<{ id: string, name?: string | null, subject?: string | null, subject_plaintext?: string | null, text?: string | null, add_signature: boolean, email_templates_files: Array<{ file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }> };

export type DeleteFileMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteFileMutation = { delete_files_by_pk?: { id: string } | null };

export type GetSelectedPlacesQueryVariables = Exact<{
  place_ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetSelectedPlacesQuery = { places: Array<{ id: string, label?: string | null, name: string }> };

export type GetPlacesQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPlacesQuery = { search_places: Array<{ id: string, label?: string | null, name: string, country?: { name: string } | null }> };

export type GetSelectedTeamsQueryVariables = Exact<{
  team_ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetSelectedTeamsQuery = { teams: Array<{ id: string, name: string }> };

export type GetTeamsQueryVariables = Exact<{
  q: Scalars['String']['input'];
}>;


export type GetTeamsQuery = { teams: Array<{ id: string, name: string }> };

export type GetSelectedUsersQueryVariables = Exact<{
  user_ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetSelectedUsersQuery = { users: Array<{ id: string, full_name?: string | null, primaryEmail: Array<{ email: string }> }> };

export type GetUsersQueryVariables = Exact<{
  q: Scalars['String']['input'];
}>;


export type GetUsersQuery = { search_users_tsv: Array<{ id: string, full_name?: string | null, primaryEmail: Array<{ email: string }> }> };

export type LanguageMenuUpdateUserMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  language: Scalars['user_language']['input'];
}>;


export type LanguageMenuUpdateUserMutation = { update_users_by_pk?: { id: string, language?: any | null } | null };

export type LeadSelectFragment = { id: string, anonymized_contact?: string | null, created_by?: string | null, property?: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null } | null, lead_agents: Array<{ user_id: string, claimed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null }> };

export type SearchLeadsTsvQueryVariables = Exact<{
  q: Scalars['String']['input'];
  where: Leads_Bool_Exp;
  orderBy?: InputMaybe<Array<Leads_Order_By> | Leads_Order_By>;
}>;


export type SearchLeadsTsvQuery = { search_leads_tsv: Array<{ id: string, anonymized_contact?: string | null, created_by?: string | null, property?: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null } | null, lead_agents: Array<{ user_id: string, claimed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null }> }> };

export type SearchLeadsQueryVariables = Exact<{
  where: Leads_Bool_Exp;
  orderBy?: InputMaybe<Array<Leads_Order_By> | Leads_Order_By>;
}>;


export type SearchLeadsQuery = { leads: Array<{ id: string, anonymized_contact?: string | null, created_by?: string | null, property?: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null } | null, lead_agents: Array<{ user_id: string, claimed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null }> }> };

export type GetDefaultLeadQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDefaultLeadQuery = { leads_by_pk?: { id: string, anonymized_contact?: string | null, created_by?: string | null, property?: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null } | null, lead_agents: Array<{ user_id: string, claimed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null }> } | null };

export type ListingCardSnippetFragment = { id: string, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> };

export type ListingPriceFragment = { offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, hide_price_on_portals: boolean, property: { id: string, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null } };

export type LotCardCarousel_LotFragment = { lot_reference?: string | null, created_at: any, created_by_user?: { id: string, first_name?: string | null, last_name?: string | null } | null, property: { id: string, property_images: Array<{ id: string, title?: string | null, image: { id: string, url?: string | null } }> }, portal_listings: Array<{ id: string, live: boolean }> };

export type LotCardInfo_LotFragment = { id: string, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, enquiries_aggregate: { aggregate?: { count: number } | null }, matching_buyer_leads: { aggregate?: { count: number } | null }, offers_aggregate: { aggregate?: { count: number } | null }, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null } };

export type LightLotCardInfo_LotFragment = { id: string, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null } };

export type LotGenerateDescriptionQueryVariables = Exact<{
  lot_id: Scalars['uuid']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type LotGenerateDescriptionQuery = { generate_listings_description?: { description: string } | null };

export type LotImproveDescriptionQueryVariables = Exact<{
  text: Scalars['String']['input'];
}>;


export type LotImproveDescriptionQuery = { improve_text?: { text: string } | null };

export type LotSelectFragment = { id: string, title?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_images: Array<{ order_nr: number, image: { id: string, url?: string | null } }> }, broker?: { id: string, full_name?: string | null } | null };

export type SearchLotsQueryVariables = Exact<{
  q: Scalars['String']['input'];
}>;


export type SearchLotsQuery = { search_lots_tsv: Array<{ id: string, title?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_images: Array<{ order_nr: number, image: { id: string, url?: string | null } }> }, broker?: { id: string, full_name?: string | null } | null }> };

export type GetDefaultLotQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDefaultLotQuery = { lots_by_pk?: { id: string, title?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_images: Array<{ order_nr: number, image: { id: string, url?: string | null } }> }, broker?: { id: string, full_name?: string | null } | null } | null };

export type GetLotsMlsQueryVariables = Exact<{
  lot_id: Scalars['uuid']['input'];
}>;


export type GetLotsMlsQuery = { lots_by_pk?: { id: string, shared_on_mls?: boolean | null } | null };

export type UpdateLotMlsMutationVariables = Exact<{
  lot_id: Scalars['uuid']['input'];
  shared_on_mls: Scalars['Boolean']['input'];
}>;


export type UpdateLotMlsMutation = { update_lots_by_pk?: { id: string, shared_on_mls?: boolean | null } | null };

export type PhoneNumberCard_Phone_NumberFragment = { id: string, user_id?: string | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null, primary?: boolean | null };

export type GetPhoneNumbersQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
}>;


export type GetPhoneNumbersQuery = { users_by_pk?: { id: string, phone_numbers: Array<{ id: string, user_id?: string | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null, primary?: boolean | null }> } | null, phone_number_type_enum: Array<{ value: string }> };

export type UpsertPhoneNumberMutationVariables = Exact<{
  input: Phone_Numbers_Insert_Input;
}>;


export type UpsertPhoneNumberMutation = { insert_phone_numbers_one?: { id: string, user_id?: string | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null, primary?: boolean | null, user?: { id: string, phone_numbers: Array<{ id: string, user_id?: string | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null, primary?: boolean | null }> } | null } | null };

export type UpdatePrimaryPhoneNumberMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
}>;


export type UpdatePrimaryPhoneNumberMutation = { update_phone_numbers?: { affected_rows: number } | null, update_phone_numbers_by_pk?: { id: string, user_id?: string | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null, primary?: boolean | null } | null };

export type DeletePhoneNumberMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeletePhoneNumberMutation = { delete_phone_numbers?: { returning: Array<{ user?: { id: string, phone_numbers: Array<{ id: string, user_id?: string | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null, primary?: boolean | null }> } | null }> } | null };

export type PropertyPoiFragment = { distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null };

export type PortalLogoFragment = { id: string, logo?: { id: string, url?: string | null } | null };

export type PropertyDetailsFragment = { living_surface?: number | null, land_surface?: number | null, commercial_surface?: number | null, number_of_floors?: number | null, floor_of_flat?: number | null, construction_year?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, micro_location?: number | null, macro_location?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null };

export type PropertyFeaturesFragment = { is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null };

export type PropertyFileFragment = { property_id: string, file_id: string, is_visible: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, label?: string | null } | null } };

export type GetDocumentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentTypesQuery = { document_types: Array<{ id: string, label?: string | null }> };

export type GetSmartListsQueryVariables = Exact<{
  crmEntity: Scalars['String']['input'];
}>;


export type GetSmartListsQuery = { smart_lists: Array<{ id: string, created_at: any, name: string, where: any, is_shared: boolean, is_tenant_shared: boolean, crm_entity: string, user: { id: string, full_name?: string | null } }> };

export type UpdateSmartListMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  is_shared: Scalars['Boolean']['input'];
  is_tenant_shared: Scalars['Boolean']['input'];
}>;


export type UpdateSmartListMutation = { update_smart_lists_by_pk?: { id: string, name: string, is_shared: boolean, is_tenant_shared: boolean } | null };

export type DeleteSmartListMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteSmartListMutation = { delete_smart_lists_by_pk?: { id: string } | null };

export type InsertSmartListMutationVariables = Exact<{
  name: Scalars['String']['input'];
  where: Scalars['jsonb']['input'];
  crmEntity: Scalars['String']['input'];
  is_shared: Scalars['Boolean']['input'];
  is_tenant_shared: Scalars['Boolean']['input'];
}>;


export type InsertSmartListMutation = { insert_smart_lists_one?: { id: string, name: string, where: any, is_shared: boolean, is_tenant_shared: boolean, user: { id: string, full_name?: string | null } } | null };

export type GetUserSubscriptionsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetUserSubscriptionsQuery = { users_by_pk?: { auto_assign_leads?: boolean | null, id: string, emails: Array<{ subscriptions: Array<{ id: string, status: any, created_at: any, start_date: any, ended_at?: any | null, current_period_end: any, current_period_start: any, total_amount: number, items: any, customer: string, plan_name?: string | null }> }> } | null };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  autoAssignLeads?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUserMutation = { update_users_by_pk?: { id: string, auto_assign_leads?: boolean | null } | null };

export type TemplateSelectFragment = { id: string, name: string, type: Doc_Template_Type_Enum_Enum };

export type SearchTemplatesQueryVariables = Exact<{
  where: Doc_Templates_Bool_Exp;
}>;


export type SearchTemplatesQuery = { doc_templates: Array<{ id: string, name: string, type: Doc_Template_Type_Enum_Enum }> };

export type TransactionCardFragment = { id: string, purchase_price?: number | null, signature_date?: any | null, seller_broker?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, listings_agency_names?: Array<string> | null } | null, property_transactions_listings: Array<{ listing_id: number }>, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, living_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, property_type?: { name?: string | null, id: string, label?: string | null } | null, locality_place?: { id: string } | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } };

export type TransactionSelectFragment = { id: string, signature_date?: any | null, buyer_broker?: { id: string, full_name?: string | null } | null, seller_broker?: { id: string, full_name?: string | null } | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } };

export type SearchTransactionsQueryVariables = Exact<{
  q: Scalars['String']['input'];
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
}>;


export type SearchTransactionsQuery = { search_property_transactions_tsv: Array<{ id: string, signature_date?: any | null, buyer_broker?: { id: string, full_name?: string | null } | null, seller_broker?: { id: string, full_name?: string | null } | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } }> };

export type GetDefaultTransactionQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDefaultTransactionQuery = { property_transactions_by_pk?: { id: string, signature_date?: any | null, buyer_broker?: { id: string, full_name?: string | null } | null, seller_broker?: { id: string, full_name?: string | null } | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null };

export type UserAvatarFragment = { id: string, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> };

export type UserCardDisplayNameFragment = { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, emails: Array<{ id: string, email: string, primary: boolean }> };

export type UserCard_UserFragment = { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> };

export type UserChipFragment = { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> };

export type UpdateBuyerLeadsStageMultipleMutationVariables = Exact<{
  buyerLeadIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  stageId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
  lotId: Scalars['uuid']['input'];
}>;


export type UpdateBuyerLeadsStageMultipleMutation = { change_buyer_leads_stage?: { lot?: { id: string, buyer_leads: Array<{ id: string, stage_id?: string | null, order_nr: number, status: string, source?: string | null, created_at: any, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, lot: { id: string, offer_type?: string | null, sale_price?: number | null } }> } | null } | null };

export type GetDefaultBrochureAppraisalTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultBrochureAppraisalTemplatesQuery = { doc_templates: Array<{ id: string, name: string, type: Doc_Template_Type_Enum_Enum, active: boolean, doc_templates_tenants: Array<{ tenant_id: string, is_default: boolean }> }> };

export type CreateBuyerLeadMutationVariables = Exact<{
  lotId: Scalars['uuid']['input'];
  userId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<CreateBuyerLeadUserInput>;
  destinationStageId: Scalars['uuid']['input'];
}>;


export type CreateBuyerLeadMutation = { create_buyer_lead?: { id: string } | null };

export type GetBuyerLeadDetailQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetBuyerLeadDetailQuery = { buyer_leads_by_pk?: { id: string, source?: string | null, created_at: any, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } } | null };

export type BuyerLeadDeleteDialogMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type BuyerLeadDeleteDialogMutation = { delete_buyer_leads_by_pk?: { id: string } | null };

export type BuyerLeadDnDColumnFragment = { id: string, stage_id?: string | null, order_nr: number, status: string, source?: string | null, created_at: any, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, lot: { id: string, offer_type?: string | null, sale_price?: number | null } };

export type UpdateBuyerLeadMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  status: Scalars['String']['input'];
}>;


export type UpdateBuyerLeadMutation = { update_buyer_leads_by_pk?: { id: string, status: string } | null };

export type InsertBuyerLeadsManyMutationVariables = Exact<{
  lotId: Scalars['uuid']['input'];
  userIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type InsertBuyerLeadsManyMutation = { create_buyer_leads_many?: Array<{ buyer_lead_id?: string | null, user_id: string, error?: string | null }> | null };

export type UserPhoneNumbersFragment = { phone_numbers: Array<{ id: string, number: string }> };

export type UserEmailsFragment = { emails: Array<{ id: string, email: string }> };

export type ContactCardUserFragmentFragment = { id: string, first_name?: string | null, last_name?: string | null, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string }> };

export type GetSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSourcesQuery = { dictionaries: Array<{ id: string, name: string, label?: string | null }> };

export type GetCreateLeadContactQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCreateLeadContactQuery = { users_by_pk?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null };

export type GetCreateListingLeadDataQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCreateListingLeadDataQuery = { leads_by_pk?: { id: string, broker_id?: string | null, contact_id?: string | null, property?: { id: string, created_at: any } | null } | null };

export type GetLotOriginsCreateListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLotOriginsCreateListingQuery = { origins: Array<{ id: string, name: string }> };

export type GetLotOriginsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLotOriginsQuery = { origins: Array<{ id: string, name: string }> };

export type GetListingDocumentTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListingDocumentTemplatesQuery = { lot_brochure_doc_templates: Array<{ id: string, name: string, active: boolean, doc_templates_tenants: Array<{ tenant_id: string, is_default: boolean }> }> };

export type ListingCreationAddressStepFragmentFragment = { address_display_option: Address_Display_Options_Enum_Enum, dummy_route?: string | null, dummy_locality?: string | null, dummy_state?: string | null, dummy_country_code?: string | null, dummy_postcode?: string | null, dummy_lat?: number | null, dummy_lng?: number | null, property: { property_type_id?: string | null, route?: string | null, locality?: string | null, state?: string | null, country?: string | null, country_code?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null } };

export type ListingCell_ListingFragment = { id: string, title?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, single_property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> } };

export type ListingPriceCellFragment = { offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, hide_price_on_portals: boolean, property: { id: string, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null } };

export type OrganisationCell_OrganisationFragment = { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, organisation_images: Array<{ image: { url?: string | null } }> };

export type PropertyCell_PropertyFragment = { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> };

export type TeamInfo_TeamFragment = { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null };

export type TransactionCellFragment = { id: string, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } };

export type UserInfo_UserFragment = { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> };

export type UserInfo_EnquiryFragment = { id: string, first_name?: string | null, last_name?: string | null, email_address?: string | null, phone_number?: string | null };

export type DictionarySelectFragment = { id: string, name: string, label?: string | null, type: Dictionaries_Types_Enum_Enum };

export type GetDictionariesQueryVariables = Exact<{
  type: Dictionaries_Types_Enum_Enum;
}>;


export type GetDictionariesQuery = { dictionaries: Array<{ id: string, name: string, label?: string | null, type: Dictionaries_Types_Enum_Enum }> };

export type ClaimLeadMutationVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
  stage_id: Scalars['uuid']['input'];
}>;


export type ClaimLeadMutation = { update_activities?: { affected_rows: number } | null, update_lead_agents?: { affected_rows: number } | null, insert_activities_one?: { id: string } | null, update_leads_by_pk?: { id: string, stage?: { id: string, status: Leads_Status_Enum, label?: string | null } | null } | null };

export type PassLeadMutationVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
}>;


export type PassLeadMutation = { update_activities?: { affected_rows: number } | null, update_lead_agents?: { affected_rows: number } | null };

export type GetClaimedStageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClaimedStageQuery = { lead_stages: Array<{ id: string, label_en?: string | null }> };

export type ActivityFieldsFragment = { id: string, lead_id?: string | null, user_id?: string | null, created_at: any, created_by?: string | null, done: boolean, due_at?: any | null, done_at?: any | null, consolidated_done_at?: any | null, activity_type: Activity_Types_Enum_Enum, subject?: string | null, note?: string | null, success: boolean, email_message?: { from: any, to: any, cc: any, bcc: any, unread?: boolean | null, snippet?: string | null, subject?: string | null, nylas_thread_id?: string | null } | null, creator?: { id: string, full_name?: string | null } | null, assignee?: { id: string, full_name?: string | null } | null, lead?: { id: string, created_by?: string | null, source: { id: string, name: string } } | null };

export type GetEnumsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEnumsQuery = { dictionaries: Array<{ name: string, label?: string | null }> };

export type GetListingsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetListingsByIdsQuery = { lots: Array<{ id: string, title?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_images: Array<{ order_nr: number, image: { id: string, url?: string | null } }> }, broker?: { id: string, full_name?: string | null } | null }> };

export type TeamFilterFragment = { id: string, name: string };

export type TeamFilterSearchTeamsQueryVariables = Exact<{
  where: Teams_Bool_Exp;
}>;


export type TeamFilterSearchTeamsQuery = { teams: Array<{ id: string, name: string }> };

export type GetTeamsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetTeamsByIdsQuery = { selected_teams: Array<{ id: string, name: string }>, initial_teams: Array<{ id: string, name: string }> };

export type UserFilterFragment = { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> };

export type UserFilterSearchUsersTsvQueryVariables = Exact<{
  q: Scalars['String']['input'];
  where?: InputMaybe<Users_Bool_Exp>;
}>;


export type UserFilterSearchUsersTsvQuery = { search_users_tsv: Array<{ id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> }> };

export type GetUsersByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  isNoneSelected: Scalars['Boolean']['input'];
  where?: InputMaybe<Users_Bool_Exp>;
}>;


export type GetUsersByIdsQuery = { selected_users?: Array<{ id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> }>, initial_users: Array<{ id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> }> };

export type GetImageQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetImageQuery = { images_by_pk?: { id: string, url?: string | null } | null };

export type GetListingPreviewQueryVariables = Exact<{
  listingId: Scalars['uuid']['input'];
  includeOffer: Scalars['Boolean']['input'];
  offerId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetListingPreviewQuery = { lots_by_pk?: { id: string, broker_id?: string | null, mandate_type?: string | null, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, last_accepted_offer?: Array<{ id: string, amount: number, buyer_id: string }>, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> } | null };

export type GetUserImagesQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
}>;


export type GetUserImagesQuery = { user_images: Array<{ id: string, order_nr?: number | null, is_primary?: boolean | null, image: { id: string, url?: string | null } }> };

export type GetTeamImagesQueryVariables = Exact<{
  team_id: Scalars['uuid']['input'];
}>;


export type GetTeamImagesQuery = { team_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> };

export type GetOrganisationImagesQueryVariables = Exact<{
  organisation_id: Scalars['uuid']['input'];
}>;


export type GetOrganisationImagesQuery = { organisation_images: Array<{ id: string, order_nr?: number | null, image: { id: string, url?: string | null } }> };

export type InsertUserImageMutationMutationVariables = Exact<{
  object: User_Images_Insert_Input;
}>;


export type InsertUserImageMutationMutation = { insert_user_images_one?: { id: string, image: { id: string, url?: string | null } } | null };

export type InsertTeamImageMutationMutationVariables = Exact<{
  object: Team_Images_Insert_Input;
}>;


export type InsertTeamImageMutationMutation = { insert_team_images_one?: { id: string, image: { id: string, url?: string | null } } | null };

export type InsertOrganisationImageMutationMutationVariables = Exact<{
  object: Organisation_Images_Insert_Input;
}>;


export type InsertOrganisationImageMutationMutation = { insert_organisation_images_one?: { id: string, image: { id: string, url?: string | null } } | null };

export type InsertImageOneMutationVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type InsertImageOneMutation = { insert_images_one?: { id: string, url?: string | null } | null };

export type FiancingLeadDetailFragment = { id: string, completed: boolean, mortgage_property_value?: number | null, mortgage_property_usage?: string | null, mortgage_is_construction?: boolean | null, mortgage_mortgage_type?: string | null, mortgage_report_type?: string | null, mortgage_google_address?: { formatted_address?: string | null } | null, property?: { id: string, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null, latest_appraisal?: { id: string, max?: number | null, min?: number | null } | null } | null };

export type LeadCard_MortgageQueryVariables = Exact<{
  leadId: Scalars['uuid']['input'];
}>;


export type LeadCard_MortgageQuery = { calculate_mortgage_for_lead: { mortgage_analysis?: { max_property_value?: number | null } | null } };

export type LeadCardFragment = { id: string, created_by?: string | null, appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_open_to_offer?: string | null, appraisal_selling_with?: string | null, appraisal_market_time?: number | null, appraisal_next_step?: string | null, appraisal_monthly_gross_rent?: number | null, appraisal_perceived_value?: number | null, appraisal_separation_next_step?: string | null, appraisal_inheritance_next_step?: string | null, sale_horizon: Leads_Sale_Horizon_Enum, appraisal_perception?: string | null, buy_horizon: Leads_Buy_Horizon_Enum, ownership?: any | null, relationship: Leads_Relationship_Enum, mortgage_term?: string | null, mortgage_buying_status?: any | null, mortgage_status?: any | null, received_mortgage_offer?: boolean | null, created_at: any, requalified_at?: any | null, completed: boolean, mortgage_property_value?: number | null, mortgage_property_usage?: string | null, mortgage_is_construction?: boolean | null, mortgage_mortgage_type?: string | null, mortgage_report_type?: string | null, referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null, appraisal_property_usage?: string | null, appraisal_property_occupied?: string | null, appraisal_property_route?: string | null, appraisal_property_street_number?: string | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, appraisal_property_state?: string | null, appraisal_property_country_code?: string | null, anonymized_contact?: string | null, stage?: { id: string, pipeline: { id: string, lead_type: any } } | null, property?: { id: string, lat?: number | null, lng?: number | null, country_code?: string | null, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_residential_units?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, parking_yearly_rental_income?: number | null, number_of_commercial_units?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, plot_number?: string | null, property_type?: { id: string, name?: string | null, main_type?: string | null, label?: string | null } | null, latest_appraisal?: { id: string, max?: number | null, min?: number | null } | null } | null, lead_agents: Array<{ id: string, user_id: string, source?: Lead_Agent_Source_Enum_Enum | null, claimed_at?: any | null }>, mortgage_google_address?: { formatted_address?: string | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, referrer?: string | null } | null };

export type LeadPropertyDetailFragment = { id: string, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_residential_units?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, parking_yearly_rental_income?: number | null, number_of_commercial_units?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, plot_number?: string | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null };

export type LeadQualificationFunnelFragment = { appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_open_to_offer?: string | null, appraisal_selling_with?: string | null, appraisal_market_time?: number | null, appraisal_next_step?: string | null, appraisal_monthly_gross_rent?: number | null, appraisal_perceived_value?: number | null, appraisal_separation_next_step?: string | null, appraisal_inheritance_next_step?: string | null, sale_horizon: Leads_Sale_Horizon_Enum, appraisal_perception?: string | null, buy_horizon: Leads_Buy_Horizon_Enum, ownership?: any | null, relationship: Leads_Relationship_Enum, mortgage_term?: string | null, mortgage_buying_status?: any | null, mortgage_status?: any | null, received_mortgage_offer?: boolean | null, property?: { id: string, country_code?: string | null, property_type?: { id: string, name?: string | null, main_type?: string | null } | null } | null };

export type LeadUpdatedTimeAgoFragment = { created_at: any, requalified_at?: any | null };

export type SalesLeadDetailFragment = { id: string, referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null, appraisal_perceived_value?: number | null, appraisal_perception?: string | null, appraisal_property_usage?: string | null, relationship: Leads_Relationship_Enum, appraisal_property_occupied?: string | null, appraisal_property_route?: string | null, appraisal_property_street_number?: string | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, appraisal_property_state?: string | null, appraisal_property_country_code?: string | null, anonymized_contact?: string | null, appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_open_to_offer?: string | null, appraisal_selling_with?: string | null, appraisal_market_time?: number | null, appraisal_next_step?: string | null, appraisal_monthly_gross_rent?: number | null, appraisal_separation_next_step?: string | null, appraisal_inheritance_next_step?: string | null, sale_horizon: Leads_Sale_Horizon_Enum, buy_horizon: Leads_Buy_Horizon_Enum, ownership?: any | null, mortgage_term?: string | null, mortgage_buying_status?: any | null, mortgage_status?: any | null, received_mortgage_offer?: boolean | null, created_at: any, requalified_at?: any | null, property?: { street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null, id: string, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_residential_units?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, parking_yearly_rental_income?: number | null, number_of_commercial_units?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, plot_number?: string | null, latest_appraisal?: { id: string, max?: number | null, min?: number | null } | null, property_type?: { id: string, name?: string | null, main_type?: string | null, label?: string | null } | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, referrer?: string | null } | null };

export type GetAutoMatchingFiltersQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetAutoMatchingFiltersQuery = { lots_by_pk?: { auto_matching_filters?: any | null } | null };

export type GetAutoFilterPlacesQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetAutoFilterPlacesQuery = { places: Array<{ id: string, name: string, label?: string | null, label_en?: string | null }> };

export type GetAutoFilterUsersQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetAutoFilterUsersQuery = { selected_users: Array<{ id: string, full_name?: string | null }> };

export type GetAutoFilterTeamsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetAutoFilterTeamsQuery = { selected_teams: Array<{ id: string, name: string }> };

export type GetAutoFilterEnumsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAutoFilterEnumsQuery = { dictionaries: Array<{ name: string, label?: string | null }> };

export type GetSenderDetailsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSenderDetailsQuery = { users_by_pk?: { id: string, branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null };

export type UpsertEmailTemplateMutationVariables = Exact<{
  listingId: Scalars['uuid']['input'];
  emailTemplateId: Scalars['uuid']['input'];
  responseSender?: InputMaybe<Scalars['uuid']['input']>;
  emailTemplate: Email_Templates_Insert_Input;
  files: Array<Email_Templates_Files_Insert_Input> | Email_Templates_Files_Insert_Input;
}>;


export type UpsertEmailTemplateMutation = { insert_email_templates_one?: { id: string, lot_id?: string | null } | null, delete_email_templates_files?: { affected_rows: number } | null, insert_email_templates_files?: { returning: Array<{ email_template_id: string, file_id: string }> } | null, update_lots_by_pk?: { id: string, enquiry_response_enabled?: boolean | null, lot_reference?: string | null, mandate_type?: string | null, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, response_sender?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, broker?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, development?: { id: string, enquiry_response_override_lot: boolean, enquiry_response_enabled?: boolean | null, email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }> } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null, property: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } } | null };

export type ListingEnquiryResponseEmailFragment = { id: string, enquiry_response_enabled?: boolean | null, lot_reference?: string | null, mandate_type?: string | null, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, response_sender?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, broker?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, development?: { id: string, enquiry_response_override_lot: boolean, enquiry_response_enabled?: boolean | null, email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }> } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null, property: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } };

export type UpdateEnquiryReponseEmailMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  lot?: InputMaybe<Lots_Set_Input>;
}>;


export type UpdateEnquiryReponseEmailMutation = { update_lots_by_pk?: { id: string, enquiry_response_enabled?: boolean | null, lot_reference?: string | null, mandate_type?: string | null, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, response_sender?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, broker?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, development?: { id: string, enquiry_response_override_lot: boolean, enquiry_response_enabled?: boolean | null, email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }> } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null, property: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } } | null };

export type EmailSenderFragment = { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null };

export type GetListingReferencesQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetListingReferencesQuery = { get_listing_references?: { id: string, reference_aliases_encoded: Array<{ alias: string, created_at: any }>, listing?: { id: string, lot_reference?: string | null } | null } | null };

export type RefreshReferenceMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RefreshReferenceMutation = { insert_lot_reference_aliases_one?: { reference_alias_decoded: number } | null };

export type MarketingFormDataFragment = { id: string, dummy_living_surface: string, dummy_usable_surface: string, listing_url?: string | null, property: { id: string, gross_floor_surface?: number | null, living_surface?: number | null, usable_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null }, tenant: { id: string, country_code: string } };

export type UpdateListingMarketingFormMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  lot?: InputMaybe<Lots_Set_Input>;
}>;


export type UpdateListingMarketingFormMutation = { update_lots_by_pk?: { id: string, dummy_living_surface: string, dummy_usable_surface: string, listing_url?: string | null, property: { id: string, gross_floor_surface?: number | null, living_surface?: number | null, usable_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null }, tenant: { id: string, country_code: string } } | null };

export type MandateFormFragment = { mandate_sale_price?: number | null, is_sales_tax_inclusive?: boolean | null, duration_in_months?: number | null, origin_id?: string | null, has_success_fee: boolean, success_fee_type: string, success_fee_custom?: string | null, success_fee_percentage?: number | null, currency?: string | null, commission_rate?: number | null, fixed_fee?: number | null, is_exclusive?: boolean | null, mandate_type?: string | null, expected_time_to_sell: string, signed_at?: string | null, origin?: { id: string, label?: string | null, name: string } | null, property: { id: string, country_code?: string | null } };

export type ListedByOverridesListingFragment = { use_dummy_contact: boolean, dummy_broker_name?: string | null, dummy_broker_phone?: string | null, dummy_organisation_name?: string | null, dummy_organisation_phone?: string | null, dummy_organisation_route?: string | null, dummy_organisation_street_number?: string | null, dummy_organisation_locality?: string | null, dummy_organisation_state?: string | null, dummy_organisation_country_code?: string | null, dummy_organisation_postcode?: string | null, dummy_organisation_lng?: number | null, dummy_organisation_lat?: number | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string, route?: string | null, street_number?: string | null, locality?: string | null, state?: string | null, country?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }> } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null };

export type AddressOverridesListingFragment = { use_dummy_address?: boolean | null, address_display_option: Address_Display_Options_Enum_Enum, dummy_route?: string | null, dummy_street_number?: string | null, dummy_locality?: string | null, dummy_state?: string | null, dummy_country_code?: string | null, dummy_postcode?: string | null, dummy_lng?: number | null, dummy_lat?: number | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, country_code?: string | null, lat?: number | null, lng?: number | null } };

export type ListingBuyerLeadsFragment = { buyer_leads: Array<{ id: string, source?: string | null }>, enquiries_aggregate: { aggregate?: { count: number } | null } };

export type ListingMandateCardFragment = { currency?: string | null, commission_rate?: number | null, fixed_fee?: number | null, is_exclusive?: boolean | null, mandate_type?: string | null, expected_time_to_sell: string, signed_at?: string | null, origin?: { id: string, label?: string | null, name: string } | null, property: { id: string, country_code?: string | null } };

export type ListingMapFragment = { id: string, lat?: number | null, lng?: number | null, google_address?: { lat?: number | null, lng?: number | null } | null };

export type PortalListingButtonFragment = { id: string, portal_listings: Array<{ id: string, live: boolean, portal_id: string, portal: { id: string, name?: string | null, active: boolean } }>, enquiries: Array<{ id: string, created_at: any, portal_id?: string | null }> };

export type GetListingQuickActionsDataQueryVariables = Exact<{
  team_ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  lot_id: Scalars['uuid']['input'];
}>;


export type GetListingQuickActionsDataQuery = { seller_report_templates: Array<{ id: string, name: string, active: boolean, doc_templates_tenants: Array<{ tenant_id: string, is_default: boolean }> }>, portals: Array<{ id: string, name?: string | null, active: boolean }>, lots_status_enum: Array<{ value: string }> };

export type ListingQuickActionsFragment = { id: string, offer_type?: string | null, shared_on_mls?: boolean | null, broker_id?: string | null, status: Lots_Status_Enum_Enum, broker?: { id: string, teams_users: Array<{ team_id: string }> } | null, sellers: Array<{ user_id: string, seller: { id: string } }>, created_by_user?: { id: string } | null, portal_listings: Array<{ id: string, live: boolean, portal_id: string, portal: { id: string, name?: string | null, active: boolean } }>, enquiries: Array<{ id: string, created_at: any, portal_id?: string | null }> };

export type ListingStatusSelectFragment = { id: string, status: Lots_Status_Enum_Enum };

export type GetListingTransactionsDataQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetListingTransactionsDataQuery = { property_transactions: Array<{ id: string, created_by?: string | null, created_at?: any | null, signature_date?: any | null, buyer_broker_id?: string | null, seller_broker_id?: string | null, buyer_broker_team_id?: string | null, seller_broker_team_id?: string | null, estimated_signature_date?: any | null, payment_date?: any | null, purchase_price?: number | null, is_published: boolean, lot_id?: string | null, commissions: Array<{ id: string, type?: string | null, amount?: number | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, emails: Array<{ id: string, email: string, primary: boolean }> } | null }>, lot?: { currency?: string | null, id: string, property: { id: string, country_code?: string | null } } | null, property: { country_code?: string | null }, sellers: Array<{ transaction_id?: string | null, user_id?: string | null }>, buyers: Array<{ transaction_id?: string | null, user_id?: string | null }> }> };

export type ChangeOfferStatusModalFragment = { id: string, amount: number, lot: { id: string, currency?: string | null, property: { id: string, country_code?: string | null } } };

export type OfferEditFormFragment = { id: string, amount: number, valid_until?: string | null, status: Offers_Status_Enum, made_on: string, comments?: string | null, lot: { id: string, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> }, offer_refused_type?: { id: string, label?: string | null } | null, buyer: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } };

export type OrganisationSelectFragment = { id: string, name?: string | null, website?: string | null };

export type SearchOrganisationsQueryVariables = Exact<{
  q: Scalars['String']['input'];
}>;


export type SearchOrganisationsQuery = { organisations_search: Array<{ id: string, name?: string | null, website?: string | null }> };

export type GetDefaultOrganisationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDefaultOrganisationQuery = { organisations_by_pk?: { id: string, name?: string | null, website?: string | null } | null };

export type SearchPlaceFragmentFragment = { id: string, name: string, lat: number, lng: number, label?: string | null, label_en?: string | null, population?: number | null, type: Place_Type_Enum_Enum, state?: { id: string, name: string } | null };

export type SearchPlacesQueryVariables = Exact<{
  q: Scalars['String']['input'];
  placeTypes: Array<Place_Type_Enum_Enum> | Place_Type_Enum_Enum;
  selectedIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type SearchPlacesQuery = { search_places: Array<{ id: string, name: string, lat: number, lng: number, label?: string | null, label_en?: string | null, population?: number | null, type: Place_Type_Enum_Enum, state?: { id: string, name: string } | null }> };

export type GetPlacesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetPlacesByIdsQuery = { places: Array<{ id: string, name: string, lat: number, lng: number, label?: string | null, label_en?: string | null, population?: number | null, type: Place_Type_Enum_Enum, state?: { id: string, name: string } | null }> };

export type AutoCatchmentAreaQueryVariables = Exact<{
  x: Scalars['float8']['input'];
  y: Scalars['float8']['input'];
  target_population: Scalars['Int']['input'];
}>;


export type AutoCatchmentAreaQuery = { get_catchment_area: Array<{ id: string, name: string, lat: number, lng: number, label?: string | null, label_en?: string | null, population?: number | null, type: Place_Type_Enum_Enum, state?: { id: string, name: string } | null }> };

export type GetPlaceByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPlaceByIdQuery = { places_by_pk?: { id: string, name: string, lat: number, lng: number, label?: string | null, label_en?: string | null, population?: number | null, type: Place_Type_Enum_Enum, state?: { id: string, name: string } | null } | null };

export type PropertyFormPricingFragment = { is_residential_fully_rented?: boolean | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, is_commercial_fully_rented?: boolean | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null };

export type PropertyAddressFragment = { street_number?: string | null, route?: string | null, locality?: string | null, state?: string | null, country?: string | null, country_code?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null };

export type PropertyFormDetailsFragment = { property_type_id?: string | null, usable_surface?: number | null, living_surface?: number | null, gross_floor_surface?: number | null, basement_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, land_surface?: number | null, garden_surface?: number | null, commercial_surface?: number | null, residential_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_floors?: number | null, floor_of_flat?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, number_of_lifts?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, construction_year?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, minergie_code?: number | null, energy_reference_year?: number | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_certificate_version?: string | null, energy_inspection_date?: string | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, emissions?: number | null, consumption?: number | null, plot_number?: string | null, micro_location?: number | null, macro_location?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null };

export type PropertyFragmentFragment = { id: string, created_at: any, created_by?: string | null, property_type_id?: string | null, usable_surface?: number | null, living_surface?: number | null, gross_floor_surface?: number | null, basement_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, land_surface?: number | null, garden_surface?: number | null, commercial_surface?: number | null, residential_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_floors?: number | null, floor_of_flat?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, number_of_lifts?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, construction_year?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, minergie_code?: number | null, energy_reference_year?: number | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_certificate_version?: string | null, energy_inspection_date?: string | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, emissions?: number | null, consumption?: number | null, plot_number?: string | null, micro_location?: number | null, macro_location?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_residential_fully_rented?: boolean | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, is_commercial_fully_rented?: boolean | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, street_number?: string | null, route?: string | null, locality?: string | null, state?: string | null, country?: string | null, country_code?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null };

export type GetPropertyQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPropertyQuery = { properties_by_pk?: { id: string, created_at: any, created_by?: string | null, property_type_id?: string | null, usable_surface?: number | null, living_surface?: number | null, gross_floor_surface?: number | null, basement_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, land_surface?: number | null, garden_surface?: number | null, commercial_surface?: number | null, residential_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_floors?: number | null, floor_of_flat?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, number_of_lifts?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, construction_year?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, minergie_code?: number | null, energy_reference_year?: number | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_certificate_version?: string | null, energy_inspection_date?: string | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, emissions?: number | null, consumption?: number | null, plot_number?: string | null, micro_location?: number | null, macro_location?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_residential_fully_rented?: boolean | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, is_commercial_fully_rented?: boolean | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, street_number?: string | null, route?: string | null, locality?: string | null, state?: string | null, country?: string | null, country_code?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null } | null, property_types: Array<{ id: string, name?: string | null, label?: string | null, main_type?: string | null, type: string }>, heating_enum: Array<{ value: string }>, heating_distribution_enum: Array<{ value: string }>, cooling_enum: Array<{ value: string }> };

export type UpdatePropertyMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  property: Properties_Set_Input;
}>;


export type UpdatePropertyMutation = { update_properties_by_pk?: { id: string, created_at: any, created_by?: string | null, property_type_id?: string | null, usable_surface?: number | null, living_surface?: number | null, gross_floor_surface?: number | null, basement_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, land_surface?: number | null, garden_surface?: number | null, commercial_surface?: number | null, residential_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_floors?: number | null, floor_of_flat?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, number_of_lifts?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, construction_year?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, minergie_code?: number | null, energy_reference_year?: number | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_certificate_version?: string | null, energy_inspection_date?: string | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, emissions?: number | null, consumption?: number | null, plot_number?: string | null, micro_location?: number | null, macro_location?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_residential_fully_rented?: boolean | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, is_commercial_fully_rented?: boolean | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, street_number?: string | null, route?: string | null, locality?: string | null, state?: string | null, country?: string | null, country_code?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null } | null };

export type DummyMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type DummyMutationMutation = { __typename: 'mutation_root' };

export type TeamsSelectFragment = { id: string, name: string, logo?: { id: string, url?: string | null } | null, team_images: Array<{ image: { url?: string | null } }> };

export type TeamsSelectQueryVariables = Exact<{
  search: Scalars['String']['input'];
  excludeTeamsIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type TeamsSelectQuery = { teams: Array<{ id: string, name: string, logo?: { id: string, url?: string | null } | null, team_images: Array<{ image: { url?: string | null } }> }> };

export type GetDefaultTeamsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetDefaultTeamsQuery = { teams: Array<{ id: string, name: string, logo?: { id: string, url?: string | null } | null, team_images: Array<{ image: { url?: string | null } }> }> };

export type ReadOnlyTenantSelectFragment = { id?: string | null, name?: string | null };

export type SearchReadOnlyTenantsQueryVariables = Exact<{
  where: Read_Only_Tenants_Bool_Exp;
}>;


export type SearchReadOnlyTenantsQuery = { read_only_tenants: Array<{ id?: string | null, name?: string | null }> };

export type TransactionCommissionsFormQueryQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TransactionCommissionsFormQueryQuery = { property_transactions_by_pk?: { id: string, purchase_price?: number | null, commissions: Array<{ id: string, type?: string | null, amount?: number | null, vat?: number | null, contact_id?: string | null, beneficiary_team_id?: string | null }>, lot?: { id: string, currency?: string | null, mandate_type?: string | null, property: { id: string, country_code?: string | null } } | null } | null };

export type TransactionsListRowFragment = { id: string, signature_date?: any | null, estimated_signature_date?: any | null, payment_date?: any | null, purchase_price?: number | null, seller_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, buyer_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, buyer_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, property: { living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_type?: { id: string, label?: string | null } | null, property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> }, commissions: Array<{ id: string, is_paid?: boolean | null, amount?: number | null }>, lot?: { id: string, currency?: string | null } | null, sellers: Array<{ user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null }>, buyers: Array<{ user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null }>, commissions_aggregate: { aggregate?: { sum?: { amount?: number | null } | null } | null }, my_commissions: { aggregate?: { sum?: { amount?: number | null } | null } | null } };

export type GetBrandingValuesQueryVariables = Exact<{
  user_id: Scalars['String']['input'];
}>;


export type GetBrandingValuesQuery = { get_valuation_link: { name?: string | null, landing_url?: string | null, valuation_url?: string | null, error?: string | null, agent_id: string, agent?: { id: string, language?: any | null, tenant_id: string, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, branding_logo?: string | null } | null } };

export type UpdateBrandingValuesMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  input: Users_Set_Input;
}>;


export type UpdateBrandingValuesMutation = { update_users_by_pk?: { id: string, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, branding_logo?: string | null } | null };

export type UpsertValuationLinkMutationVariables = Exact<{
  name: Scalars['String']['input'];
  agent_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
}>;


export type UpsertValuationLinkMutation = { upsert_valuation_link?: { name?: string | null, landing_url?: string | null, valuation_url?: string | null, agent_id?: string | null, survey_id?: string | null, error?: string | null } | null };

export type UserSelectFragment = { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> };

export type SearchUsersQueryVariables = Exact<{
  q: Scalars['String']['input'];
  order_by?: InputMaybe<Array<Users_Order_By> | Users_Order_By>;
  where?: InputMaybe<Users_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchUsersQuery = { search_users_tsv: Array<{ id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> }> };

export type GetDefaultUsersQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetDefaultUsersQuery = { users: Array<{ id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> }> };

export type AppraisalGraphQueryVariables = Exact<{
  appraisalId: Scalars['uuid']['input'];
}>;


export type AppraisalGraphQuery = { appraisals_by_pk?: { id: string, min?: number | null, max?: number | null, value?: number | null, updated_at: any, valuations: Array<{ id: string, min?: number | null, value?: number | null, max?: number | null, model: string, valuation_model: { name: string, short_name?: string | null } }> } | null };

export type AppraisalDetailsFragment = { id: string, min?: number | null, max?: number | null, value?: number | null, updated_at: any, valuations: Array<{ id: string, min?: number | null, value?: number | null, max?: number | null, model: string, valuation_model: { name: string, short_name?: string | null } }> };

export type AppraiseMutationVariables = Exact<{
  property_id: Scalars['String']['input'];
}>;


export type AppraiseMutation = { value_property?: { appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null, updated_at: any, valuations: Array<{ id: string, min?: number | null, value?: number | null, max?: number | null, model: string, valuation_model: { name: string, short_name?: string | null } }> } | null } | null };

export type InsertLeadMutationVariables = Exact<{
  input: Leads_Insert_Input;
  lead_id: Scalars['uuid']['input'];
  broker_id: Scalars['uuid']['input'];
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  include_call_activity: Scalars['Boolean']['input'];
  created_at: Scalars['timestamptz']['input'];
  created_at_plus_5: Scalars['timestamptz']['input'];
  created_at_plus_10: Scalars['timestamptz']['input'];
  claimed_at: Scalars['timestamptz']['input'];
  stage_id: Scalars['uuid']['input'];
}>;


export type InsertLeadMutation = { insert_leads_one?: { id: string } | null, origination?: { id: string } | null, assignment?: { id: string } | null, call?: { id: string, activities_target_users: Array<{ target_user_id?: string | null }> } | null, insert_lead_agents_one?: { id: string } | null };

export type GetLeadMetadataQueryVariables = Exact<{
  sourceName: Scalars['String']['input'];
}>;


export type GetLeadMetadataQuery = { pipelines: Array<{ id: string, stages: Array<{ id: string, name?: string | null }> }>, dictionaries: Array<{ id: string }> };

export type GetDictEnumsQueryVariables = Exact<{
  where?: InputMaybe<Dictionaries_Types_Enum_Bool_Exp>;
}>;


export type GetDictEnumsQuery = { dictionaries_types_enum: Array<{ value: string, label?: string | null }> };

export type DictionaryItemFragment = { id: string, label?: string | null, type: Dictionaries_Types_Enum_Enum, name: string, label_de?: string | null, label_es?: string | null, label_fr?: string | null, label_en: string, label_it?: string | null, is_deletable?: boolean | null, is_used?: boolean | null, updated_at: any, created_at: any, types?: Array<string> | null, group_id?: string | null, tenant_id?: string | null, group?: { id: string, label?: string | null } | null };

export type GetDictionariesByTypeQueryVariables = Exact<{
  type: Dictionaries_Types_Enum_Enum;
}>;


export type GetDictionariesByTypeQuery = { dictionaries: Array<{ id: string, label?: string | null, type: Dictionaries_Types_Enum_Enum, name: string, label_de?: string | null, label_es?: string | null, label_fr?: string | null, label_en: string, label_it?: string | null, is_deletable?: boolean | null, is_used?: boolean | null, updated_at: any, created_at: any, types?: Array<string> | null, group_id?: string | null, tenant_id?: string | null, group?: { id: string, label?: string | null } | null }> };

export type DeleteDictionaryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteDictionaryMutation = { delete_dictionaries_by_pk?: { id: string } | null };

export type Get_Dictionary_GroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Dictionary_GroupsQuery = { groups: Array<{ id: string, label?: string | null }> };

export type Get_Dictionary_ItemQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type Get_Dictionary_ItemQuery = { dictionaries_by_pk?: { id: string, label?: string | null, type: Dictionaries_Types_Enum_Enum, name: string, label_de?: string | null, label_es?: string | null, label_fr?: string | null, label_en: string, label_it?: string | null, is_deletable?: boolean | null, is_used?: boolean | null, updated_at: any, created_at: any, types?: Array<string> | null, group_id?: string | null, tenant_id?: string | null, group?: { id: string, label?: string | null } | null } | null };

export type Insert_Dictionary_ItemMutationVariables = Exact<{
  dictionary: Dictionaries_Insert_Input;
}>;


export type Insert_Dictionary_ItemMutation = { insert_dictionaries_one?: { id: string, label?: string | null, type: Dictionaries_Types_Enum_Enum, name: string, label_de?: string | null, label_es?: string | null, label_fr?: string | null, label_en: string, label_it?: string | null, is_deletable?: boolean | null, is_used?: boolean | null, updated_at: any, created_at: any, types?: Array<string> | null, group_id?: string | null, tenant_id?: string | null, group?: { id: string, label?: string | null } | null } | null };

export type Update_Dictionary_ItemMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  dictionary: Dictionaries_Set_Input;
}>;


export type Update_Dictionary_ItemMutation = { update_dictionaries_by_pk?: { id: string, label?: string | null, type: Dictionaries_Types_Enum_Enum, name: string, label_de?: string | null, label_es?: string | null, label_fr?: string | null, label_en: string, label_it?: string | null, is_deletable?: boolean | null, is_used?: boolean | null, updated_at: any, created_at: any, types?: Array<string> | null, group_id?: string | null, tenant_id?: string | null, group?: { id: string, label?: string | null } | null } | null };

export type Sync_Dictionary_EnumsQueryVariables = Exact<{ [key: string]: never; }>;


export type Sync_Dictionary_EnumsQuery = { sync_dictionary_enums?: { success: boolean, error?: string | null } | null };

export type DocTemplateFieldsFragment = { id: string, name: string, updated_at: any, type: Doc_Template_Type_Enum_Enum, active: boolean, content: string, filename_template: string, translations?: any | null, created_by_tenant?: { id?: string | null, name?: string | null } | null, doc_templates_tenants: Array<{ id: string, tenant_id: string, is_default: boolean, tenant?: { id?: string | null, name?: string | null } | null }> };

export type GetDocTemplatesQueryVariables = Exact<{
  where?: InputMaybe<Doc_Templates_Bool_Exp>;
}>;


export type GetDocTemplatesQuery = { doc_templates: Array<{ id: string, name: string, updated_at: any, type: Doc_Template_Type_Enum_Enum, active: boolean, content: string, filename_template: string, translations?: any | null, created_by_tenant?: { id?: string | null, name?: string | null } | null, doc_templates_tenants: Array<{ id: string, tenant_id: string, is_default: boolean, tenant?: { id?: string | null, name?: string | null } | null }> }> };

export type DeleteDocTemplateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteDocTemplateMutation = { delete_doc_templates_by_pk?: { id: string } | null };

export type DuplicateDocTemplateMutationVariables = Exact<{
  input: Doc_Templates_Insert_Input;
}>;


export type DuplicateDocTemplateMutation = { insert_doc_templates_one?: { id: string } | null };

export type GetDocTemplateQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDocTemplateQuery = { doc_templates_by_pk?: { id: string, name: string, updated_at: any, type: Doc_Template_Type_Enum_Enum, active: boolean, content: string, filename_template: string, translations?: any | null, created_by_tenant?: { id?: string | null, name?: string | null } | null, doc_templates_tenants: Array<{ id: string, tenant_id: string, is_default: boolean, tenant?: { id?: string | null, name?: string | null } | null }> } | null };

export type CreateDocTemplateMutationVariables = Exact<{
  input: Doc_Templates_Insert_Input;
}>;


export type CreateDocTemplateMutation = { insert_doc_templates_one?: { id: string, name: string, updated_at: any, type: Doc_Template_Type_Enum_Enum, active: boolean, content: string, filename_template: string, translations?: any | null, created_by_tenant?: { id?: string | null, name?: string | null } | null, doc_templates_tenants: Array<{ id: string, tenant_id: string, is_default: boolean, tenant?: { id?: string | null, name?: string | null } | null }> } | null };

export type UpdateDocTemplateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Doc_Templates_Set_Input;
}>;


export type UpdateDocTemplateMutation = { update_doc_templates_by_pk?: { id: string, name: string, updated_at: any, type: Doc_Template_Type_Enum_Enum, active: boolean, content: string, filename_template: string, translations?: any | null, created_by_tenant?: { id?: string | null, name?: string | null } | null, doc_templates_tenants: Array<{ id: string, tenant_id: string, is_default: boolean, tenant?: { id?: string | null, name?: string | null } | null }> } | null };

export type UpdateTenantShareMutationVariables = Exact<{
  doc_template_id: Scalars['uuid']['input'];
  tenant_id: Scalars['uuid']['input'];
  is_default: Scalars['Boolean']['input'];
}>;


export type UpdateTenantShareMutation = { insert_doc_templates_tenants_one?: { id: string, doc_template_id: string, tenant_id: string, is_default: boolean, tenant?: { id?: string | null, name?: string | null } | null } | null };

export type DeleteTenantShareMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteTenantShareMutation = { delete_doc_templates_tenants_by_pk?: { id: string, tenant_id: string } | null };

export type GetDocTemplateTypeEnumQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocTemplateTypeEnumQuery = { doc_template_type_enum: Array<{ value: string }> };

export type EmailSequencesDeleteSequenceMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type EmailSequencesDeleteSequenceMutation = { delete_email_sequences_by_pk?: { id: string } | null };

export type EmailSequenceRecipientStopDialogMutationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type EmailSequenceRecipientStopDialogMutationMutation = { update_email_sequences_recipients_by_pk?: { id: string, status: Email_Sequences_Recipients_Status_Enum_Enum } | null };

export type EmailSequenceDrawerUpsertMutationVariables = Exact<{
  input: Email_Sequences_Insert_Input;
}>;


export type EmailSequenceDrawerUpsertMutation = { insert_email_sequences_one?: { id: string } | null };

export type EmailSequenceDrawerDeleteStepsMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type EmailSequenceDrawerDeleteStepsMutation = { delete_email_sequences_steps?: { returning: Array<{ id: string }> } | null };

export type EmailSequenceDrawerDeleteFilesMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type EmailSequenceDrawerDeleteFilesMutation = { delete_email_templates_files?: { returning: Array<{ file: { id: string } }> } | null };

export type EmailSequenceDuplicateInsertMutationVariables = Exact<{
  input: Email_Sequences_Insert_Input;
}>;


export type EmailSequenceDuplicateInsertMutation = { insert_email_sequences_one?: { id: string } | null };

export type StatusSwitchSequenceMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  _set?: InputMaybe<Email_Sequences_Set_Input>;
}>;


export type StatusSwitchSequenceMutation = { update_email_sequences_by_pk?: { id: string, status: Email_Sequences_Status_Enum_Enum } | null };

export type StatusSwitchRecipientsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type StatusSwitchRecipientsMutation = { update_email_sequences_recipients?: { returning: Array<{ __typename: 'email_sequences_recipients' }> } | null };

export type EmailSequenceDrawer_MeFragment = { id: string };

export type StatusSwitch_IdFragment = { id: string, status: Email_Sequences_Status_Enum_Enum };

export type EmailSequencesMeQueryVariables = Exact<{ [key: string]: never; }>;


export type EmailSequencesMeQuery = { me?: { id: string, logins: Array<{ __typename: 'logins' }> } | null };

export type EmailSequencesTableQueryVariables = Exact<{
  where?: InputMaybe<Email_Sequences_Bool_Exp>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type EmailSequencesTableQuery = { email_sequences: Array<{ id: string, name?: string | null, is_shared_with_everyone?: boolean | null, is_shared_with_team?: boolean | null, created_at: any, status: Email_Sequences_Status_Enum_Enum, created_by_user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> }, recipients_stopped: { aggregate?: { count: number } | null }, recipients_active: { aggregate?: { count: number } | null }, email_sequences_steps_aggregate: { aggregate?: { count: number } | null } }> };

export type EmailSequenceDuplicateQueryVariables = Exact<{
  sequenceId: Scalars['uuid']['input'];
}>;


export type EmailSequenceDuplicateQuery = { me?: { id: string } | null, email_sequences_by_pk?: { email_sequences_steps: Array<{ delay: any, number: any, email_template: { target: Email_Templates_Target_Enum_Enum, add_signature: boolean, text?: string | null, text_html?: string | null, text_plaintext?: string | null, subject?: string | null, subject_plaintext?: string | null, email_templates_files: Array<{ file: { size: number, name: string, url: string, mimetype?: string | null } }> } }> } | null };

export type EmailSequenceDrawerQueryVariables = Exact<{
  where?: InputMaybe<Email_Sequences_Bool_Exp>;
}>;


export type EmailSequenceDrawerQuery = { email_sequences: Array<{ id: string, name?: string | null, stop_after_reply?: boolean | null, is_shared_with_everyone?: boolean | null, is_shared_with_team?: boolean | null, email_sequences_steps: Array<{ id: string, delay: any, number: any, email_template: { id: string, target: Email_Templates_Target_Enum_Enum, add_signature: boolean, text?: string | null, subject?: string | null, email_templates_files: Array<{ file: { id: string, size: number, name: string, url: string, mimetype?: string | null } }> } }> }> };

export type GetEmailSequenceRecipientsQueryVariables = Exact<{
  sequenceId: Scalars['uuid']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetEmailSequenceRecipientsQuery = { email_sequences_by_pk?: { email_sequences_steps_aggregate: { aggregate?: { count: number } | null } } | null, email_sequences_recipients: Array<{ id: string, status: Email_Sequences_Recipients_Status_Enum_Enum, created_at: any, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> }, from_user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> }, lot?: { title?: string | null, created_by_user?: { first_name?: string | null, last_name?: string | null } | null, property: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } } | null, lead?: { first_name?: string | null, last_name?: string | null, contact?: { first_name?: string | null, last_name?: string | null } | null, property?: { route?: string | null, street_number?: string | null, country_code?: string | null, postcode?: string | null, locality?: string | null, state?: string | null } | null } | null, buyer_leads?: { lot: { title?: string | null, property: { route?: string | null, street_number?: string | null, country_code?: string | null, postcode?: string | null, locality?: string | null, state?: string | null } } } | null, email_messages: Array<{ created_at: any, status: string }> }> };

export type GetEnquiriesListQueryVariables = Exact<{
  where: Enquiries_Bool_Exp;
  order_by?: InputMaybe<Array<Enquiries_Order_By> | Enquiries_Order_By>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetEnquiriesListQuery = { enquiries: Array<{ id: string, created_at: any, updated_at: any, processed: boolean, first_name?: string | null, last_name?: string | null, email_address?: string | null, portal?: { name?: string | null } | null, lot?: { id: string, title?: string | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, single_property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> } } | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, team?: { id: string, name: string } | null }>, enquiries_aggregate: { aggregate?: { count: number } | null } };

export type GetEnquiriesListCountQueryVariables = Exact<{
  where: Enquiries_Bool_Exp;
}>;


export type GetEnquiriesListCountQuery = { enquiries_aggregate: { aggregate?: { count: number } | null } };

export type GetEnquiryTypeQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEnquiryTypeQuery = { enquiries_by_pk?: { id: string, broker_id?: string | null, team_id?: string | null, created_at: any } | null };

export type GetEnquiryContactRequestQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEnquiryContactRequestQuery = { enquiries_by_pk?: { id: string, created_at: any, first_name?: string | null, last_name?: string | null, email_address?: string | null, phone_number?: string | null, contact_reason?: string | null, message?: string | null, broker?: { id: string, full_name?: string | null } | null, team?: { id: string, name: string } | null, property_transaction?: { id: string, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, living_surface?: number | null, number_of_rooms?: number | null } } | null } | null };

export type GetEnquiryQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEnquiryQuery = { enquiries_by_pk?: { id: string, created_at: any, updated_at: any, message?: string | null, raw_email?: string | null, first_name?: string | null, last_name?: string | null, email_address?: string | null, raw_email_address?: string | null, phone_number?: string | null, raw_phone_number?: string | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, matched_email_user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, matched_phone_user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, lot?: { id: string, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> } | null, buyer_lead?: { id: string, created_at: any, source?: string | null, status: string, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } } | null, response_activity?: { id: string, email_message?: { id: string, date: any, subject?: string | null, status: string, snippet?: string | null, to: any, from: any, cc: any, bcc: any } | null } | null, portal?: { id: string, name?: string | null, type: Portals_Types_Enum_Enum, logo?: { id: string, url?: string | null } | null } | null } | null };

export type DeleteEnquiryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteEnquiryMutation = { delete_enquiries_by_pk?: { id: string } | null };

export type ValidateInvitationQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ValidateInvitationQuery = { validate_invitation?: { success: boolean, tenant_id?: string | null, magic_token?: string | null } | null };

export type AppraisalRequestsCardAdminQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AppraisalRequestsCardAdminQuery = { lead_agents: Array<{ created_at: any, user: { id: string, first_name?: string | null, last_name?: string | null, default_team?: { name: string } | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }> } }> };

export type AssignBrokerWithActivitiesMutationVariables = Exact<{
  broker_id: Scalars['uuid']['input'];
  leads_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  activities: Array<Activities_Insert_Input> | Activities_Insert_Input;
  lead_agents: Array<Lead_Agents_Insert_Input> | Lead_Agents_Insert_Input;
  stage_id: Scalars['uuid']['input'];
}>;


export type AssignBrokerWithActivitiesMutation = { update_leads?: { affected_rows: number, returning: Array<{ id: string, broker?: { id: string, first_name?: string | null, last_name?: string | null, emails: Array<{ email: string }> } | null }> } | null, update_activities?: { affected_rows: number } | null, insert_activities?: { affected_rows: number, returning: Array<{ id: string, lead_id?: string | null }> } | null, insert_lead_agents?: { affected_rows: number, returning: Array<{ id: string }> } | null };

export type GetAssignStageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssignStageQuery = { lead_stages: Array<{ id: string }> };

export type GetPipelinesQueryVariables = Exact<{
  leadType: Scalars['lead_type']['input'];
}>;


export type GetPipelinesQuery = { pipelines: Array<{ id: string, label?: string | null, stages: Array<{ id: string, label?: string | null, status: Leads_Status_Enum }> }> };

export type UpdateMultipleLeadsStageMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  stageId: Scalars['uuid']['input'];
  activities: Array<Activities_Insert_Input> | Activities_Insert_Input;
}>;


export type UpdateMultipleLeadsStageMutation = { update_leads?: { returning: Array<{ id: string, stage?: { id: string, label?: string | null } | null }> } | null, update_lead_agents?: { returning: Array<{ id: string, stage_id?: string | null, lead_stage?: { id: string, label?: string | null } | null }> } | null, insert_activities?: { returning: Array<{ id: string }> } | null };

export type MarketingCardLeadFragmentFragment = { referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null };

export type GetLeadDataQueryVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type GetLeadDataQuery = { leads_by_pk?: { id: string, lots: Array<{ id: string }>, leads_tags: Array<{ id: string, created_by?: string | null, created_at: any, dictionary?: { id: string, label?: string | null } | null }> } | null, dictionaries: Array<{ id: string, label?: string | null }>, lead_stages: Array<{ id: string }> };

export type UpdateLeadTagsMutationVariables = Exact<{
  removedTags: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  newTags: Array<Leads_Tags_Insert_Input> | Leads_Tags_Insert_Input;
}>;


export type UpdateLeadTagsMutation = { delete_leads_tags?: { affected_rows: number } | null, insert_leads_tags?: { affected_rows: number } | null };

export type SelfAssignLeadAgentMutationVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
  broker_id: Scalars['uuid']['input'];
  stage_id: Scalars['uuid']['input'];
}>;


export type SelfAssignLeadAgentMutation = { update_leads_by_pk?: { id: string, stage_id?: string | null, stage?: { id: string, label?: string | null } | null } | null, insert_lead_agents_one?: { id: string, created_at: any, claimed_at?: any | null, passed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null, win_probability?: number | null, predicted_win_date?: string | null, stage_id?: string | null, lead: { id: string, stage?: { id: string, pipeline: { id: string } } | null }, lead_stage?: { id: string, name?: string | null, label?: string | null, status: Leads_Status_Enum } | null, user: { id: string, first_name?: string | null, last_name?: string | null, default_team?: { id: string, name: string } | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null };

export type CurrentLeadFragment = { id: string, stage?: { id: string } | null };

export type ActivityCellFragment = { id: string, created_at: any, due_at?: any | null, done_at?: any | null, start_date?: string | null, end_date?: string | null, done: boolean, success: boolean, subject?: string | null, activity_type: Activity_Types_Enum_Enum, note?: string | null };

export type GetLeadsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Leads_Bool_Exp>;
  order_by?: InputMaybe<Array<Leads_Order_By> | Leads_Order_By>;
}>;


export type GetLeadsQuery = { leads: Array<{ id: string, created_at: any, created_by?: string | null, requalified_at?: any | null, requalified_or_created_at?: any | null, appraisal_reason: Leads_Appraisal_Reason_Enum, sale_horizon: Leads_Sale_Horizon_Enum, buy_horizon: Leads_Buy_Horizon_Enum, appraisal_perceived_value?: number | null, appraisal_perception?: string | null, relationship: Leads_Relationship_Enum, completed: boolean, mandate_probability?: number | null, pos_within_stage?: number | null, predicted_listing_date?: any | null, landing_page_url?: string | null, anonymized_contact?: string | null, updated_at: any, lots: Array<{ id: string }>, stage?: { id: string, label?: string | null, status: Leads_Status_Enum, pipeline: { id: string, lead_type: any } } | null, source: { label?: string | null }, contact?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, lead_agents: Array<{ id: string, claimed_at?: any | null, user_id: string, source?: Lead_Agent_Source_Enum_Enum | null, user: { id: string, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } }>, next_activity: Array<{ id: string, created_at: any, due_at?: any | null, done_at?: any | null, start_date?: string | null, end_date?: string | null, done: boolean, success: boolean, subject?: string | null, activity_type: Activity_Types_Enum_Enum, note?: string | null }>, last_activity: Array<{ id: string, created_at: any, due_at?: any | null, done_at?: any | null, start_date?: string | null, end_date?: string | null, done: boolean, success: boolean, subject?: string | null, activity_type: Activity_Types_Enum_Enum, note?: string | null }>, property?: { id: string, route?: string | null, street_number?: string | null, locality?: string | null, postcode?: string | null, land_surface?: number | null, living_surface?: number | null, built_surface?: number | null, property_type?: { id: string, label?: string | null, main_type?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, value?: number | null, max?: number | null } | null } | null }> };

export type GetLeadsCountQueryVariables = Exact<{
  where?: InputMaybe<Leads_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLeadsCountQuery = { leads_aggregate: { aggregate?: { count: number } | null } };

export type GetLeadQueryVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type GetLeadQuery = { leads_by_pk?: { id: string, tenant_id: string, appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_perception?: string | null, appraisal_perceived_value?: number | null, referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null, property?: { id: string, latest_appraisal?: { id: string, value?: number | null } | null } | null, lots: Array<{ id: string }>, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string }> } | null } | null };

export type LeadFeedQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  email_addresses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  skip_email_activities: Scalars['Boolean']['input'];
}>;


export type LeadFeedQuery = { user_activities: Array<{ id: string, lead_id?: string | null, user_id?: string | null, created_at: any, created_by?: string | null, done: boolean, due_at?: any | null, done_at?: any | null, consolidated_done_at?: any | null, activity_type: Activity_Types_Enum_Enum, subject?: string | null, note?: string | null, success: boolean, email_message?: { from: any, to: any, cc: any, bcc: any, unread?: boolean | null, snippet?: string | null, subject?: string | null, nylas_thread_id?: string | null } | null, creator?: { id: string, full_name?: string | null } | null, assignee?: { id: string, full_name?: string | null } | null, lead?: { id: string, created_by?: string | null, source: { id: string, name: string } } | null }>, lead_activites: Array<{ id: string, lead_id?: string | null, user_id?: string | null, created_at: any, created_by?: string | null, done: boolean, due_at?: any | null, done_at?: any | null, consolidated_done_at?: any | null, activity_type: Activity_Types_Enum_Enum, subject?: string | null, note?: string | null, success: boolean, email_message?: { from: any, to: any, cc: any, bcc: any, unread?: boolean | null, snippet?: string | null, subject?: string | null, nylas_thread_id?: string | null } | null, creator?: { id: string, full_name?: string | null } | null, assignee?: { id: string, full_name?: string | null } | null, lead?: { id: string, created_by?: string | null, source: { id: string, name: string } } | null }>, email_activities?: Array<{ id: string, lead_id?: string | null, user_id?: string | null, created_at: any, created_by?: string | null, done: boolean, due_at?: any | null, done_at?: any | null, consolidated_done_at?: any | null, activity_type: Activity_Types_Enum_Enum, subject?: string | null, note?: string | null, success: boolean, email_message?: { from: any, to: any, cc: any, bcc: any, unread?: boolean | null, snippet?: string | null, subject?: string | null, nylas_thread_id?: string | null } | null, creator?: { id: string, full_name?: string | null } | null, assignee?: { id: string, full_name?: string | null } | null, lead?: { id: string, created_by?: string | null, source: { id: string, name: string } } | null }> };

export type AssignLeadMutationVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type AssignLeadMutation = { update_leads_by_pk?: { id: string } | null, insert_activities_one?: { id: string } | null };

export type LeadAgentFragment = { id: string, created_at: any, claimed_at?: any | null, passed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null, win_probability?: number | null, predicted_win_date?: string | null, stage_id?: string | null, lead: { id: string, stage?: { id: string, pipeline: { id: string } } | null }, lead_stage?: { id: string, name?: string | null, label?: string | null, status: Leads_Status_Enum } | null, user: { id: string, first_name?: string | null, last_name?: string | null, default_team?: { id: string, name: string } | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } };

export type GetLeadAgentsQueryVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type GetLeadAgentsQuery = { lead_agents: Array<{ id: string, created_at: any, claimed_at?: any | null, passed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null, win_probability?: number | null, predicted_win_date?: string | null, stage_id?: string | null, lead: { id: string, stage?: { id: string, pipeline: { id: string } } | null }, lead_stage?: { id: string, name?: string | null, label?: string | null, status: Leads_Status_Enum } | null, user: { id: string, first_name?: string | null, last_name?: string | null, default_team?: { id: string, name: string } | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } }> };

export type GetLeadQualificationQueryVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type GetLeadQualificationQuery = { leads_by_pk?: { id: string, lead_agents: Array<{ id: string, win_probability?: number | null, predicted_win_date?: string | null, user: { id: string, first_name?: string | null, last_name?: string | null } }> } | null };

export type AddLeadAgentMutationVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
}>;


export type AddLeadAgentMutation = { insert_lead_agents_one?: { id: string } | null, insert_activities_one?: { id: string } | null };

export type DeleteLeadAgentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteLeadAgentMutation = { delete_lead_agents_by_pk?: { id: string } | null };

export type UpdateLeadAgentsMutationVariables = Exact<{
  where: Lead_Agents_Bool_Exp;
  set: Lead_Agents_Set_Input;
  lead_id: Scalars['uuid']['input'];
  lead_stage_id?: InputMaybe<Scalars['uuid']['input']>;
  update_lead: Scalars['Boolean']['input'];
}>;


export type UpdateLeadAgentsMutation = { update_lead_agents?: { returning: Array<{ id: string, created_at: any, claimed_at?: any | null, passed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null, win_probability?: number | null, predicted_win_date?: string | null, stage_id?: string | null, lead: { id: string, stage?: { id: string, pipeline: { id: string } } | null }, lead_stage?: { id: string, name?: string | null, label?: string | null, status: Leads_Status_Enum } | null, user: { id: string, first_name?: string | null, last_name?: string | null, default_team?: { id: string, name: string } | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } }> } | null, update_leads_by_pk?: { id: string, stage_id?: string | null, stage?: { id: string, label?: string | null } | null } | null };

export type GetPipelineStagesQueryVariables = Exact<{
  pipeline_id: Scalars['uuid']['input'];
}>;


export type GetPipelineStagesQuery = { pipelines_by_pk?: { id: string, stages: Array<{ id: string, label?: string | null, status: Leads_Status_Enum, pipeline: { id: string, lead_type: any } }> } | null };

export type LeadQualificationGetPipelinesQueryVariables = Exact<{ [key: string]: never; }>;


export type LeadQualificationGetPipelinesQuery = { pipelines: Array<{ id: string, name?: string | null, label?: string | null, stages: Array<{ id: string, label?: string | null, status: Leads_Status_Enum, pipeline: { name?: string | null } }> }> };

export type UpdateLeadMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Leads_Set_Input;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  update_lead_agents: Scalars['Boolean']['input'];
}>;


export type UpdateLeadMutation = { update_leads_by_pk?: { id: string, stage_id?: string | null, stage?: { id: string, label?: string | null } | null } | null, update_lead_agents?: { returning: Array<{ id: string, stage_id?: string | null, lead_stage?: { id: string, label?: string | null } | null }> } | null };

export type GetListingBuyersLeadQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetListingBuyersLeadQuery = { lead_stages: Array<{ id: string, label?: string | null }>, lots_by_pk?: { id: string, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, price_unit?: string | null, title?: string | null, mandate_type?: string | null, lot_reference?: string | null, auto_matching_filters?: any | null, property: { id: string, locality?: string | null, postcode?: string | null, number_of_rooms?: number | null, computed_surface?: number | null, living_surface?: number | null, route?: string | null, street_number?: string | null, state?: string | null, land_surface?: number | null, places?: Array<{ id: string }> | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, property_type?: { id: string, label?: string | null, main_type?: string | null, name?: string | null, composite_type_object?: { id: string, name?: string | null } | null } | null, municipality_place?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null }, buyer_leads: Array<{ id: string, stage_id?: string | null, order_nr: number, status: string, source?: string | null, created_at: any, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, lot: { id: string, offer_type?: string | null, sale_price?: number | null } }>, broker?: { id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null } | null };

export type GetListingSurroundingPlacesQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetListingSurroundingPlacesQuery = { get_surrounding_listing_places?: Array<{ place_id: string }> | null };

export type UpdateBuyerLeadOrderAndStageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  destinationStageId: Scalars['uuid']['input'];
  orderNr: Scalars['Int']['input'];
}>;


export type UpdateBuyerLeadOrderAndStageMutation = { order_buyer_lead?: { id: string, buyer_lead?: { id: string, stage_id?: string | null, order_nr: number, status: string, source?: string | null, created_at: any, lot: { id: string, offer_type?: string | null, sale_price?: number | null, buyer_leads: Array<{ id: string, stage_id?: string | null, order_nr: number, status: string, source?: string | null, created_at: any, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, lot: { id: string, offer_type?: string | null, sale_price?: number | null } }> }, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } } | null } | null };

export type GetListingDuplicateDialogDataQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetListingDuplicateDialogDataQuery = { lots_by_pk?: { property: { id: string, property_images_aggregate: { aggregate?: { count: number } | null }, property_files_aggregate: { aggregate?: { count: number } | null } } } | null };

export type GetListingDuplicationDataQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  includeDocuments: Scalars['Boolean']['input'];
  includePhotos: Scalars['Boolean']['input'];
}>;


export type GetListingDuplicationDataQuery = { lots_by_pk?: { id: string, property: { id: string, property_files?: Array<{ file_id: string, property_id: string, file: { id: string } }>, property_images?: Array<{ id: string, property_id: string, image_id: string, image: { id: string } }> } } | null };

export type GetListingMarketingQueryVariables = Exact<{
  listingId: Scalars['uuid']['input'];
}>;


export type GetListingMarketingQuery = { lots_by_pk?: { id: string, status: Lots_Status_Enum_Enum, offer_type?: string | null, enable_auto_matching: boolean, auto_matching_filters?: any | null, send_enquiries_to_sellers: boolean, dummy_living_surface: string, dummy_usable_surface: string, listing_url?: string | null, enquiry_response_enabled?: boolean | null, lot_reference?: string | null, mandate_type?: string | null, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, broker?: { id: string, branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, teams_users: Array<{ team_id: string, user_id: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, portal_listings: Array<{ id: string, live: boolean, portal_id: string, portal: { id: string, name?: string | null, active: boolean } }>, enquiries: Array<{ id: string, created_at: any, portal_id?: string | null }>, property: { id: string, gross_floor_surface?: number | null, living_surface?: number | null, usable_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null }, tenant: { id: string, country_code: string }, email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, response_sender?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, development?: { id: string, enquiry_response_override_lot: boolean, enquiry_response_enabled?: boolean | null, email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }> } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null } | null };

export type SyncListingPortalsMutationVariables = Exact<{
  portalId: Scalars['uuid']['input'];
  lotId: Scalars['uuid']['input'];
}>;


export type SyncListingPortalsMutation = { update_portal_listing?: { success: boolean, warnings?: any | null } | null };

export type UpdateListingMarketingMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  lot?: InputMaybe<Lots_Set_Input>;
}>;


export type UpdateListingMarketingMutation = { update_lots_by_pk?: { id: string, status: Lots_Status_Enum_Enum, lot_reference?: string | null, enable_auto_matching: boolean, send_enquiries_to_sellers: boolean, broker?: { teams_users: Array<{ team_id: string, user_id: string }> } | null, portal_listings: Array<{ id: string, live: boolean, portal_id: string, portal: { id: string, name?: string | null, active: boolean } }>, enquiries: Array<{ id: string, created_at: any, portal_id?: string | null }> } | null };

export type GetListingOffersQueryVariables = Exact<{
  listingId: Scalars['uuid']['input'];
}>;


export type GetListingOffersQuery = { offers: Array<{ id: string, amount: number, valid_until?: string | null, status: Offers_Status_Enum, made_on: string, comments?: string | null, created_by?: string | null, lot: { id: string, currency?: string | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property: { id: string, country_code?: string | null } }, offer_refused_type?: { id: string, label?: string | null } | null, buyer: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> };

export type ListingOverviewPropertyFragment = { residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, energy_certificate_version?: string | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, consumption?: number | null, emissions?: number | null, minergie_code?: number | null, plot_number?: string | null, floor_of_flat?: number | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, living_surface?: number | null, land_surface?: number | null, commercial_surface?: number | null, number_of_floors?: number | null, construction_year?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, micro_location?: number | null, macro_location?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, id: string, created_at: any, created_by?: string | null, property_type_id?: string | null, usable_surface?: number | null, gross_floor_surface?: number | null, basement_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, garden_surface?: number | null, residential_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_lifts?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, is_residential_fully_rented?: boolean | null, is_commercial_fully_rented?: boolean | null, street_number?: string | null, route?: string | null, locality?: string | null, state?: string | null, country?: string | null, country_code?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null };

export type ListingOverviewFragment = { id: string, title?: string | null, description?: string | null, created_at: any, status: Lots_Status_Enum_Enum, currency?: string | null, sale_price?: number | null, offer_type?: string | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, minimum_net_seller_price?: number | null, commission_rate?: number | null, available_from?: string | null, virtual_visit_url?: string | null, video_url?: string | null, hide_price_on_portals: boolean, lot_reference?: string | null, broker_id?: string | null, parking_price?: number | null, parking_price_type?: Parking_Price_Type_Enum_Enum | null, indoor_parking_price?: number | null, outdoor_parking_price?: number | null, is_parking_included_in_total: boolean, use_dummy_address?: boolean | null, address_display_option: Address_Display_Options_Enum_Enum, dummy_route?: string | null, dummy_street_number?: string | null, dummy_locality?: string | null, dummy_state?: string | null, dummy_country_code?: string | null, dummy_postcode?: string | null, dummy_lng?: number | null, dummy_lat?: number | null, use_dummy_contact: boolean, dummy_broker_name?: string | null, dummy_broker_phone?: string | null, dummy_organisation_name?: string | null, dummy_organisation_phone?: string | null, dummy_organisation_route?: string | null, dummy_organisation_street_number?: string | null, dummy_organisation_locality?: string | null, dummy_organisation_state?: string | null, dummy_organisation_country_code?: string | null, dummy_organisation_postcode?: string | null, dummy_organisation_lng?: number | null, dummy_organisation_lat?: number | null, mandate_sale_price?: number | null, is_sales_tax_inclusive?: boolean | null, duration_in_months?: number | null, origin_id?: string | null, has_success_fee: boolean, success_fee_type: string, success_fee_custom?: string | null, success_fee_percentage?: number | null, shared_on_mls?: boolean | null, fixed_fee?: number | null, is_exclusive?: boolean | null, mandate_type?: string | null, expected_time_to_sell: string, signed_at?: string | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string, route?: string | null, street_number?: string | null, locality?: string | null, state?: string | null, country?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, logo?: { id: string, url?: string | null } | null } | null, teams_users: Array<{ team_id: string }>, organisation?: { id: string, organisation_images: Array<{ id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } }> } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, created_by_user?: { id: string, first_name?: string | null, last_name?: string | null } | null, lead?: { id: string, created_by?: string | null, appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_open_to_offer?: string | null, appraisal_selling_with?: string | null, appraisal_market_time?: number | null, appraisal_next_step?: string | null, appraisal_monthly_gross_rent?: number | null, appraisal_perceived_value?: number | null, appraisal_separation_next_step?: string | null, appraisal_inheritance_next_step?: string | null, sale_horizon: Leads_Sale_Horizon_Enum, appraisal_perception?: string | null, buy_horizon: Leads_Buy_Horizon_Enum, ownership?: any | null, relationship: Leads_Relationship_Enum, mortgage_term?: string | null, mortgage_buying_status?: any | null, mortgage_status?: any | null, received_mortgage_offer?: boolean | null, created_at: any, requalified_at?: any | null, completed: boolean, mortgage_property_value?: number | null, mortgage_property_usage?: string | null, mortgage_is_construction?: boolean | null, mortgage_mortgage_type?: string | null, mortgage_report_type?: string | null, referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null, appraisal_property_usage?: string | null, appraisal_property_occupied?: string | null, appraisal_property_route?: string | null, appraisal_property_street_number?: string | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, appraisal_property_state?: string | null, appraisal_property_country_code?: string | null, anonymized_contact?: string | null, stage?: { id: string, pipeline: { id: string, lead_type: any } } | null, property?: { id: string, lat?: number | null, lng?: number | null, country_code?: string | null, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_residential_units?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, parking_yearly_rental_income?: number | null, number_of_commercial_units?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, plot_number?: string | null, property_type?: { id: string, name?: string | null, main_type?: string | null, label?: string | null } | null, latest_appraisal?: { id: string, max?: number | null, min?: number | null } | null } | null, lead_agents: Array<{ id: string, user_id: string, source?: Lead_Agent_Source_Enum_Enum | null, claimed_at?: any | null }>, mortgage_google_address?: { formatted_address?: string | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, referrer?: string | null } | null } | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, country_code?: string | null, lat?: number | null, lng?: number | null, computed_surface?: number | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, energy_certificate_version?: string | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, consumption?: number | null, emissions?: number | null, minergie_code?: number | null, plot_number?: string | null, floor_of_flat?: number | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, living_surface?: number | null, land_surface?: number | null, commercial_surface?: number | null, number_of_floors?: number | null, construction_year?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, micro_location?: number | null, macro_location?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, created_at: any, created_by?: string | null, property_type_id?: string | null, usable_surface?: number | null, gross_floor_surface?: number | null, basement_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, garden_surface?: number | null, residential_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_lifts?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, is_residential_fully_rented?: boolean | null, is_commercial_fully_rented?: boolean | null, property_images: Array<{ id: string, property_id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, google_address?: { lat?: number | null, lng?: number | null } | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null }, buyer_leads: Array<{ id: string, source?: string | null }>, enquiries_aggregate: { aggregate?: { count: number } | null }, origin?: { id: string, label?: string | null, name: string } | null, portal_listings: Array<{ id: string, live: boolean, portal_id: string, portal: { id: string, name?: string | null, active: boolean } }>, enquiries: Array<{ id: string, created_at: any, portal_id?: string | null }> };

export type UpdateListingSellersMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  sellers: Array<Lot_Sellers_Insert_Input> | Lot_Sellers_Insert_Input;
}>;


export type UpdateListingSellersMutation = { delete_lot_sellers?: { affected_rows: number } | null, insert_lot_sellers?: { returning: Array<{ user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> } | null };

export type GetPropertyImagesQueryVariables = Exact<{
  property_id: Scalars['uuid']['input'];
}>;


export type GetPropertyImagesQuery = { property_images: Array<{ id: string, property_id: string, title?: string | null, description?: string | null, display_on_brochure: boolean, display_on_listing: boolean, is_floor_plan: boolean, size: string, crop: string, background_color: string, landscape_size: string, landscape_crop: string, landscape_background_color: string, order_nr: number, image: { id: string, url?: string | null } }> };

export type InsertPropertyImageMutationVariables = Exact<{
  object: Property_Images_Insert_Input;
}>;


export type InsertPropertyImageMutation = { insert_property_images_one?: { id: string, order_nr: number, display_on_brochure: boolean, display_on_listing: boolean, image: { id: string, url?: string | null } } | null };

export type InsertPropertyImagesBatchMutationVariables = Exact<{
  objects: Array<Property_Images_Insert_Input> | Property_Images_Insert_Input;
}>;


export type InsertPropertyImagesBatchMutation = { insert_property_images?: { returning: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> } | null };

export type DeletePropertyImageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeletePropertyImageMutation = { delete_property_images_by_pk?: { id: string } | null };

export type UpdatePropertyImagesOrderMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  target_position: Scalars['Int']['input'];
}>;


export type UpdatePropertyImagesOrderMutation = { update_property_images_by_pk?: { id: string, order_nr: number } | null };

export type UpdatePropertyImageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: Property_Images_Set_Input;
}>;


export type UpdatePropertyImageMutation = { update_property_images_by_pk?: { id: string } | null };

export type GetListingTransactionsQueryVariables = Exact<{
  listingId: Scalars['uuid']['input'];
  team_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetListingTransactionsQuery = { property_transactions: Array<{ id: string, signature_date?: any | null, estimated_signature_date?: any | null, payment_date?: any | null, purchase_price?: number | null, seller_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, buyer_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, buyer_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, property: { living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_type?: { id: string, label?: string | null } | null, property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> }, commissions: Array<{ id: string, is_paid?: boolean | null, amount?: number | null }>, lot?: { id: string, currency?: string | null } | null, sellers: Array<{ user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null }>, buyers: Array<{ user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null }>, commissions_aggregate: { aggregate?: { sum?: { amount?: number | null } | null } | null }, my_commissions: { aggregate?: { sum?: { amount?: number | null } | null } | null } }> };

export type ListingsDetailedViewFragment = { property: { id: string, floor_of_flat?: number | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, living_surface?: number | null, built_surface?: number | null, usable_surface?: number | null, gross_floor_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, basement_surface?: number | null, garden_surface?: number | null, land_surface?: number | null } };

export type CurrentListingFragment = { id: string, order_nr: number };

export type GetLotQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetLotQuery = { lots_by_pk?: { id: string, title?: string | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null } } | null };

export type GetLotsListQueryVariables = Exact<{
  where: Lots_Bool_Exp;
  order_by: Array<Lots_Order_By> | Lots_Order_By;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetLotsListQuery = { me?: { id: string, teams_users: Array<{ team_id: string }> } | null, lots: Array<{ created_at: any, updated_at: any, signed_at?: string | null, title?: string | null, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, status: Lots_Status_Enum_Enum, order_nr: number, is_exclusive?: boolean | null, lot_reference?: string | null, id: string, hide_price_on_portals: boolean, price_unit?: string | null, currency?: string | null, lots_status: { label?: string | null }, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, teams_users: Array<{ team_id: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, portal_listings: Array<{ id: string, portal_id: string, live: boolean }>, property: { id: string, route?: string | null, street_number?: string | null, locality?: string | null, postcode?: string | null, land_surface?: number | null, living_surface?: number | null, built_surface?: number | null, floor_of_flat?: number | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, usable_surface?: number | null, gross_floor_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, basement_surface?: number | null, garden_surface?: number | null, country_code?: string | null, computed_surface?: number | null, property_type?: { id: string, label?: string | null, main_type?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, value?: number | null, max?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, title?: string | null, image: { id: string, url?: string | null } }>, single_property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> }, enquiries: Array<{ id: string, portal_id?: string | null }>, enquiries_aggregate: { aggregate?: { count: number, max?: { created_at?: any | null } | null } | null }, created_by_user?: { id: string, first_name?: string | null, last_name?: string | null } | null, matching_buyer_leads: { aggregate?: { count: number } | null }, offers_aggregate: { aggregate?: { count: number } | null } }>, portals: Array<{ id: string, team_id?: string | null, name?: string | null, quota?: number | null, portal_listings_aggregate: { aggregate?: { count: number } | null }, team?: { id: string, name: string } | null, teams_portals: Array<{ team_id: string }> }> };

export type GetLotsListCountQueryVariables = Exact<{
  where: Lots_Bool_Exp;
}>;


export type GetLotsListCountQuery = { lots_aggregate: { aggregate?: { count: number } | null } };

export type TogglePortalListingMutationVariables = Exact<{
  portal_id: Scalars['uuid']['input'];
  lot_id: Scalars['uuid']['input'];
}>;


export type TogglePortalListingMutation = { toggle_portal_listing?: { id: string, portal_id: string, lot_id: string, live: boolean, milliseconds_online: number, last_publication_warnings?: any | null, lot?: { id: string, status: Lots_Status_Enum_Enum } | null } | null };

export type GetAvailableListingPortalsQueryVariables = Exact<{
  team_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  lot_id: Scalars['uuid']['input'];
}>;


export type GetAvailableListingPortalsQuery = { portals: Array<{ id: string, name?: string | null, type: Portals_Types_Enum_Enum, active: boolean }> };

export type DeleteLotMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteLotMutation = { delete_lots_by_pk?: { id: string } | null };

export type GetListingDetailsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetListingDetailsQuery = { lots_by_pk?: { id: string, title?: string | null, description?: string | null, created_at: any, status: Lots_Status_Enum_Enum, currency?: string | null, sale_price?: number | null, offer_type?: string | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, minimum_net_seller_price?: number | null, commission_rate?: number | null, available_from?: string | null, virtual_visit_url?: string | null, video_url?: string | null, hide_price_on_portals: boolean, lot_reference?: string | null, broker_id?: string | null, parking_price?: number | null, parking_price_type?: Parking_Price_Type_Enum_Enum | null, indoor_parking_price?: number | null, outdoor_parking_price?: number | null, is_parking_included_in_total: boolean, use_dummy_address?: boolean | null, address_display_option: Address_Display_Options_Enum_Enum, dummy_route?: string | null, dummy_street_number?: string | null, dummy_locality?: string | null, dummy_state?: string | null, dummy_country_code?: string | null, dummy_postcode?: string | null, dummy_lng?: number | null, dummy_lat?: number | null, use_dummy_contact: boolean, dummy_broker_name?: string | null, dummy_broker_phone?: string | null, dummy_organisation_name?: string | null, dummy_organisation_phone?: string | null, dummy_organisation_route?: string | null, dummy_organisation_street_number?: string | null, dummy_organisation_locality?: string | null, dummy_organisation_state?: string | null, dummy_organisation_country_code?: string | null, dummy_organisation_postcode?: string | null, dummy_organisation_lng?: number | null, dummy_organisation_lat?: number | null, mandate_sale_price?: number | null, is_sales_tax_inclusive?: boolean | null, duration_in_months?: number | null, origin_id?: string | null, has_success_fee: boolean, success_fee_type: string, success_fee_custom?: string | null, success_fee_percentage?: number | null, shared_on_mls?: boolean | null, fixed_fee?: number | null, is_exclusive?: boolean | null, mandate_type?: string | null, expected_time_to_sell: string, signed_at?: string | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string, route?: string | null, street_number?: string | null, locality?: string | null, state?: string | null, country?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, logo?: { id: string, url?: string | null } | null } | null, teams_users: Array<{ team_id: string }>, organisation?: { id: string, organisation_images: Array<{ id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } }> } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, created_by_user?: { id: string, first_name?: string | null, last_name?: string | null } | null, lead?: { id: string, created_by?: string | null, appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_open_to_offer?: string | null, appraisal_selling_with?: string | null, appraisal_market_time?: number | null, appraisal_next_step?: string | null, appraisal_monthly_gross_rent?: number | null, appraisal_perceived_value?: number | null, appraisal_separation_next_step?: string | null, appraisal_inheritance_next_step?: string | null, sale_horizon: Leads_Sale_Horizon_Enum, appraisal_perception?: string | null, buy_horizon: Leads_Buy_Horizon_Enum, ownership?: any | null, relationship: Leads_Relationship_Enum, mortgage_term?: string | null, mortgage_buying_status?: any | null, mortgage_status?: any | null, received_mortgage_offer?: boolean | null, created_at: any, requalified_at?: any | null, completed: boolean, mortgage_property_value?: number | null, mortgage_property_usage?: string | null, mortgage_is_construction?: boolean | null, mortgage_mortgage_type?: string | null, mortgage_report_type?: string | null, referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null, appraisal_property_usage?: string | null, appraisal_property_occupied?: string | null, appraisal_property_route?: string | null, appraisal_property_street_number?: string | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, appraisal_property_state?: string | null, appraisal_property_country_code?: string | null, anonymized_contact?: string | null, stage?: { id: string, pipeline: { id: string, lead_type: any } } | null, property?: { id: string, lat?: number | null, lng?: number | null, country_code?: string | null, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_residential_units?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, parking_yearly_rental_income?: number | null, number_of_commercial_units?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, plot_number?: string | null, property_type?: { id: string, name?: string | null, main_type?: string | null, label?: string | null } | null, latest_appraisal?: { id: string, max?: number | null, min?: number | null } | null } | null, lead_agents: Array<{ id: string, user_id: string, source?: Lead_Agent_Source_Enum_Enum | null, claimed_at?: any | null }>, mortgage_google_address?: { formatted_address?: string | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, referrer?: string | null } | null } | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, country_code?: string | null, lat?: number | null, lng?: number | null, computed_surface?: number | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, energy_certificate_version?: string | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, consumption?: number | null, emissions?: number | null, minergie_code?: number | null, plot_number?: string | null, floor_of_flat?: number | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, living_surface?: number | null, land_surface?: number | null, commercial_surface?: number | null, number_of_floors?: number | null, construction_year?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, micro_location?: number | null, macro_location?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, created_at: any, created_by?: string | null, property_type_id?: string | null, usable_surface?: number | null, gross_floor_surface?: number | null, basement_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, garden_surface?: number | null, residential_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_lifts?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, is_residential_fully_rented?: boolean | null, is_commercial_fully_rented?: boolean | null, property_images: Array<{ id: string, property_id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, google_address?: { lat?: number | null, lng?: number | null } | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null }, buyer_leads: Array<{ id: string, source?: string | null }>, enquiries_aggregate: { aggregate?: { count: number } | null }, origin?: { id: string, label?: string | null, name: string } | null, portal_listings: Array<{ id: string, live: boolean, portal_id: string, portal: { id: string, name?: string | null, active: boolean } }>, enquiries: Array<{ id: string, created_at: any, portal_id?: string | null }> } | null };

export type GetListingEditContextQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListingEditContextQuery = { property_types: Array<{ id: string, name?: string | null, label?: string | null, main_type?: string | null, type: string }>, heating_enum: Array<{ value: string }>, heating_distribution_enum: Array<{ value: string }>, cooling_enum: Array<{ value: string }> };

export type FileFragment = { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, label?: string | null } | null };

export type UpdateListingMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  lot?: InputMaybe<Lots_Set_Input>;
}>;


export type UpdateListingMutation = { update_lots_by_pk?: { id: string, title?: string | null, description?: string | null, created_at: any, status: Lots_Status_Enum_Enum, currency?: string | null, sale_price?: number | null, offer_type?: string | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, minimum_net_seller_price?: number | null, commission_rate?: number | null, available_from?: string | null, virtual_visit_url?: string | null, video_url?: string | null, hide_price_on_portals: boolean, lot_reference?: string | null, broker_id?: string | null, parking_price?: number | null, parking_price_type?: Parking_Price_Type_Enum_Enum | null, indoor_parking_price?: number | null, outdoor_parking_price?: number | null, is_parking_included_in_total: boolean, use_dummy_address?: boolean | null, address_display_option: Address_Display_Options_Enum_Enum, dummy_route?: string | null, dummy_street_number?: string | null, dummy_locality?: string | null, dummy_state?: string | null, dummy_country_code?: string | null, dummy_postcode?: string | null, dummy_lng?: number | null, dummy_lat?: number | null, use_dummy_contact: boolean, dummy_broker_name?: string | null, dummy_broker_phone?: string | null, dummy_organisation_name?: string | null, dummy_organisation_phone?: string | null, dummy_organisation_route?: string | null, dummy_organisation_street_number?: string | null, dummy_organisation_locality?: string | null, dummy_organisation_state?: string | null, dummy_organisation_country_code?: string | null, dummy_organisation_postcode?: string | null, dummy_organisation_lng?: number | null, dummy_organisation_lat?: number | null, mandate_sale_price?: number | null, is_sales_tax_inclusive?: boolean | null, duration_in_months?: number | null, origin_id?: string | null, has_success_fee: boolean, success_fee_type: string, success_fee_custom?: string | null, success_fee_percentage?: number | null, shared_on_mls?: boolean | null, fixed_fee?: number | null, is_exclusive?: boolean | null, mandate_type?: string | null, expected_time_to_sell: string, signed_at?: string | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string, route?: string | null, street_number?: string | null, locality?: string | null, state?: string | null, country?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, logo?: { id: string, url?: string | null } | null } | null, teams_users: Array<{ team_id: string }>, organisation?: { id: string, organisation_images: Array<{ id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } }> } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, created_by_user?: { id: string, first_name?: string | null, last_name?: string | null } | null, lead?: { id: string, created_by?: string | null, appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_open_to_offer?: string | null, appraisal_selling_with?: string | null, appraisal_market_time?: number | null, appraisal_next_step?: string | null, appraisal_monthly_gross_rent?: number | null, appraisal_perceived_value?: number | null, appraisal_separation_next_step?: string | null, appraisal_inheritance_next_step?: string | null, sale_horizon: Leads_Sale_Horizon_Enum, appraisal_perception?: string | null, buy_horizon: Leads_Buy_Horizon_Enum, ownership?: any | null, relationship: Leads_Relationship_Enum, mortgage_term?: string | null, mortgage_buying_status?: any | null, mortgage_status?: any | null, received_mortgage_offer?: boolean | null, created_at: any, requalified_at?: any | null, completed: boolean, mortgage_property_value?: number | null, mortgage_property_usage?: string | null, mortgage_is_construction?: boolean | null, mortgage_mortgage_type?: string | null, mortgage_report_type?: string | null, referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null, appraisal_property_usage?: string | null, appraisal_property_occupied?: string | null, appraisal_property_route?: string | null, appraisal_property_street_number?: string | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, appraisal_property_state?: string | null, appraisal_property_country_code?: string | null, anonymized_contact?: string | null, stage?: { id: string, pipeline: { id: string, lead_type: any } } | null, property?: { id: string, lat?: number | null, lng?: number | null, country_code?: string | null, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_residential_units?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, parking_yearly_rental_income?: number | null, number_of_commercial_units?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, plot_number?: string | null, property_type?: { id: string, name?: string | null, main_type?: string | null, label?: string | null } | null, latest_appraisal?: { id: string, max?: number | null, min?: number | null } | null } | null, lead_agents: Array<{ id: string, user_id: string, source?: Lead_Agent_Source_Enum_Enum | null, claimed_at?: any | null }>, mortgage_google_address?: { formatted_address?: string | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, referrer?: string | null } | null } | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, country_code?: string | null, lat?: number | null, lng?: number | null, computed_surface?: number | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, energy_certificate_version?: string | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, consumption?: number | null, emissions?: number | null, minergie_code?: number | null, plot_number?: string | null, floor_of_flat?: number | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, living_surface?: number | null, land_surface?: number | null, commercial_surface?: number | null, number_of_floors?: number | null, construction_year?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, micro_location?: number | null, macro_location?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, created_at: any, created_by?: string | null, property_type_id?: string | null, usable_surface?: number | null, gross_floor_surface?: number | null, basement_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, garden_surface?: number | null, residential_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_lifts?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, is_residential_fully_rented?: boolean | null, is_commercial_fully_rented?: boolean | null, property_images: Array<{ id: string, property_id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, google_address?: { lat?: number | null, lng?: number | null } | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null }, buyer_leads: Array<{ id: string, source?: string | null }>, enquiries_aggregate: { aggregate?: { count: number } | null }, origin?: { id: string, label?: string | null, name: string } | null, portal_listings: Array<{ id: string, live: boolean, portal_id: string, portal: { id: string, name?: string | null, active: boolean } }>, enquiries: Array<{ id: string, created_at: any, portal_id?: string | null }> } | null };

export type UpdateListingStatusMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  status?: InputMaybe<Lots_Status_Enum_Enum>;
}>;


export type UpdateListingStatusMutation = { update_lots_by_pk?: { id: string, status: Lots_Status_Enum_Enum } | null };

export type CreateListingMutationVariables = Exact<{
  lot: InsertListingLotsInsertInput;
}>;


export type CreateListingMutation = { insert_lots_derived?: { id: string, lot?: { id: string, title?: string | null, description?: string | null, created_at: any, status: Lots_Status_Enum_Enum, currency?: string | null, sale_price?: number | null, offer_type?: string | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, minimum_net_seller_price?: number | null, commission_rate?: number | null, available_from?: string | null, virtual_visit_url?: string | null, video_url?: string | null, hide_price_on_portals: boolean, lot_reference?: string | null, broker_id?: string | null, parking_price?: number | null, parking_price_type?: Parking_Price_Type_Enum_Enum | null, indoor_parking_price?: number | null, outdoor_parking_price?: number | null, is_parking_included_in_total: boolean, use_dummy_address?: boolean | null, address_display_option: Address_Display_Options_Enum_Enum, dummy_route?: string | null, dummy_street_number?: string | null, dummy_locality?: string | null, dummy_state?: string | null, dummy_country_code?: string | null, dummy_postcode?: string | null, dummy_lng?: number | null, dummy_lat?: number | null, use_dummy_contact: boolean, dummy_broker_name?: string | null, dummy_broker_phone?: string | null, dummy_organisation_name?: string | null, dummy_organisation_phone?: string | null, dummy_organisation_route?: string | null, dummy_organisation_street_number?: string | null, dummy_organisation_locality?: string | null, dummy_organisation_state?: string | null, dummy_organisation_country_code?: string | null, dummy_organisation_postcode?: string | null, dummy_organisation_lng?: number | null, dummy_organisation_lat?: number | null, mandate_sale_price?: number | null, is_sales_tax_inclusive?: boolean | null, duration_in_months?: number | null, origin_id?: string | null, has_success_fee: boolean, success_fee_type: string, success_fee_custom?: string | null, success_fee_percentage?: number | null, shared_on_mls?: boolean | null, fixed_fee?: number | null, is_exclusive?: boolean | null, mandate_type?: string | null, expected_time_to_sell: string, signed_at?: string | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string, route?: string | null, street_number?: string | null, locality?: string | null, state?: string | null, country?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, logo?: { id: string, url?: string | null } | null } | null, teams_users: Array<{ team_id: string }>, organisation?: { id: string, organisation_images: Array<{ id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } }> } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, created_by_user?: { id: string, first_name?: string | null, last_name?: string | null } | null, lead?: { id: string, created_by?: string | null, appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_open_to_offer?: string | null, appraisal_selling_with?: string | null, appraisal_market_time?: number | null, appraisal_next_step?: string | null, appraisal_monthly_gross_rent?: number | null, appraisal_perceived_value?: number | null, appraisal_separation_next_step?: string | null, appraisal_inheritance_next_step?: string | null, sale_horizon: Leads_Sale_Horizon_Enum, appraisal_perception?: string | null, buy_horizon: Leads_Buy_Horizon_Enum, ownership?: any | null, relationship: Leads_Relationship_Enum, mortgage_term?: string | null, mortgage_buying_status?: any | null, mortgage_status?: any | null, received_mortgage_offer?: boolean | null, created_at: any, requalified_at?: any | null, completed: boolean, mortgage_property_value?: number | null, mortgage_property_usage?: string | null, mortgage_is_construction?: boolean | null, mortgage_mortgage_type?: string | null, mortgage_report_type?: string | null, referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null, appraisal_property_usage?: string | null, appraisal_property_occupied?: string | null, appraisal_property_route?: string | null, appraisal_property_street_number?: string | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, appraisal_property_state?: string | null, appraisal_property_country_code?: string | null, anonymized_contact?: string | null, stage?: { id: string, pipeline: { id: string, lead_type: any } } | null, property?: { id: string, lat?: number | null, lng?: number | null, country_code?: string | null, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_residential_units?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, parking_yearly_rental_income?: number | null, number_of_commercial_units?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, plot_number?: string | null, property_type?: { id: string, name?: string | null, main_type?: string | null, label?: string | null } | null, latest_appraisal?: { id: string, max?: number | null, min?: number | null } | null } | null, lead_agents: Array<{ id: string, user_id: string, source?: Lead_Agent_Source_Enum_Enum | null, claimed_at?: any | null }>, mortgage_google_address?: { formatted_address?: string | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, referrer?: string | null } | null } | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, country_code?: string | null, lat?: number | null, lng?: number | null, computed_surface?: number | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, energy_certificate_version?: string | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, consumption?: number | null, emissions?: number | null, minergie_code?: number | null, plot_number?: string | null, floor_of_flat?: number | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, living_surface?: number | null, land_surface?: number | null, commercial_surface?: number | null, number_of_floors?: number | null, construction_year?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, micro_location?: number | null, macro_location?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, created_at: any, created_by?: string | null, property_type_id?: string | null, usable_surface?: number | null, gross_floor_surface?: number | null, basement_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, garden_surface?: number | null, residential_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_lifts?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, is_residential_fully_rented?: boolean | null, is_commercial_fully_rented?: boolean | null, property_images: Array<{ id: string, property_id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, google_address?: { lat?: number | null, lng?: number | null } | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null }, buyer_leads: Array<{ id: string, source?: string | null }>, enquiries_aggregate: { aggregate?: { count: number } | null }, origin?: { id: string, label?: string | null, name: string } | null, portal_listings: Array<{ id: string, live: boolean, portal_id: string, portal: { id: string, name?: string | null, active: boolean } }>, enquiries: Array<{ id: string, created_at: any, portal_id?: string | null }> } | null } | null };

export type CreatePropertyFileMutationVariables = Exact<{
  object: Property_Files_Insert_Input;
}>;


export type CreatePropertyFileMutation = { insert_property_files_one?: { order_nr: number, is_visible: boolean, property_id: string, file_id: string, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any } } | null };

export type UpdateListingWithPropertyMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  prop_id: Scalars['uuid']['input'];
  lot: Lots_Set_Input;
  property: Properties_Set_Input;
}>;


export type UpdateListingWithPropertyMutation = { update_lots_by_pk?: { id: string, title?: string | null, description?: string | null, created_at: any, status: Lots_Status_Enum_Enum, currency?: string | null, sale_price?: number | null, offer_type?: string | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, minimum_net_seller_price?: number | null, commission_rate?: number | null, available_from?: string | null, virtual_visit_url?: string | null, video_url?: string | null, hide_price_on_portals: boolean, lot_reference?: string | null, broker_id?: string | null, parking_price?: number | null, parking_price_type?: Parking_Price_Type_Enum_Enum | null, indoor_parking_price?: number | null, outdoor_parking_price?: number | null, is_parking_included_in_total: boolean, use_dummy_address?: boolean | null, address_display_option: Address_Display_Options_Enum_Enum, dummy_route?: string | null, dummy_street_number?: string | null, dummy_locality?: string | null, dummy_state?: string | null, dummy_country_code?: string | null, dummy_postcode?: string | null, dummy_lng?: number | null, dummy_lat?: number | null, use_dummy_contact: boolean, dummy_broker_name?: string | null, dummy_broker_phone?: string | null, dummy_organisation_name?: string | null, dummy_organisation_phone?: string | null, dummy_organisation_route?: string | null, dummy_organisation_street_number?: string | null, dummy_organisation_locality?: string | null, dummy_organisation_state?: string | null, dummy_organisation_country_code?: string | null, dummy_organisation_postcode?: string | null, dummy_organisation_lng?: number | null, dummy_organisation_lat?: number | null, mandate_sale_price?: number | null, is_sales_tax_inclusive?: boolean | null, duration_in_months?: number | null, origin_id?: string | null, has_success_fee: boolean, success_fee_type: string, success_fee_custom?: string | null, success_fee_percentage?: number | null, shared_on_mls?: boolean | null, fixed_fee?: number | null, is_exclusive?: boolean | null, mandate_type?: string | null, expected_time_to_sell: string, signed_at?: string | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string, route?: string | null, street_number?: string | null, locality?: string | null, state?: string | null, country?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, logo?: { id: string, url?: string | null } | null } | null, teams_users: Array<{ team_id: string }>, organisation?: { id: string, organisation_images: Array<{ id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } }> } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, created_by_user?: { id: string, first_name?: string | null, last_name?: string | null } | null, lead?: { id: string, created_by?: string | null, appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_open_to_offer?: string | null, appraisal_selling_with?: string | null, appraisal_market_time?: number | null, appraisal_next_step?: string | null, appraisal_monthly_gross_rent?: number | null, appraisal_perceived_value?: number | null, appraisal_separation_next_step?: string | null, appraisal_inheritance_next_step?: string | null, sale_horizon: Leads_Sale_Horizon_Enum, appraisal_perception?: string | null, buy_horizon: Leads_Buy_Horizon_Enum, ownership?: any | null, relationship: Leads_Relationship_Enum, mortgage_term?: string | null, mortgage_buying_status?: any | null, mortgage_status?: any | null, received_mortgage_offer?: boolean | null, created_at: any, requalified_at?: any | null, completed: boolean, mortgage_property_value?: number | null, mortgage_property_usage?: string | null, mortgage_is_construction?: boolean | null, mortgage_mortgage_type?: string | null, mortgage_report_type?: string | null, referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null, appraisal_property_usage?: string | null, appraisal_property_occupied?: string | null, appraisal_property_route?: string | null, appraisal_property_street_number?: string | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, appraisal_property_state?: string | null, appraisal_property_country_code?: string | null, anonymized_contact?: string | null, stage?: { id: string, pipeline: { id: string, lead_type: any } } | null, property?: { id: string, lat?: number | null, lng?: number | null, country_code?: string | null, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_residential_units?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, parking_yearly_rental_income?: number | null, number_of_commercial_units?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, plot_number?: string | null, property_type?: { id: string, name?: string | null, main_type?: string | null, label?: string | null } | null, latest_appraisal?: { id: string, max?: number | null, min?: number | null } | null } | null, lead_agents: Array<{ id: string, user_id: string, source?: Lead_Agent_Source_Enum_Enum | null, claimed_at?: any | null }>, mortgage_google_address?: { formatted_address?: string | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, referrer?: string | null } | null } | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, country_code?: string | null, lat?: number | null, lng?: number | null, computed_surface?: number | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, energy_certificate_version?: string | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, consumption?: number | null, emissions?: number | null, minergie_code?: number | null, plot_number?: string | null, floor_of_flat?: number | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, living_surface?: number | null, land_surface?: number | null, commercial_surface?: number | null, number_of_floors?: number | null, construction_year?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, micro_location?: number | null, macro_location?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, created_at: any, created_by?: string | null, property_type_id?: string | null, usable_surface?: number | null, gross_floor_surface?: number | null, basement_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, garden_surface?: number | null, residential_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_lifts?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, is_residential_fully_rented?: boolean | null, is_commercial_fully_rented?: boolean | null, property_images: Array<{ id: string, property_id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, google_address?: { lat?: number | null, lng?: number | null } | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null }, buyer_leads: Array<{ id: string, source?: string | null }>, enquiries_aggregate: { aggregate?: { count: number } | null }, origin?: { id: string, label?: string | null, name: string } | null, portal_listings: Array<{ id: string, live: boolean, portal_id: string, portal: { id: string, name?: string | null, active: boolean } }>, enquiries: Array<{ id: string, created_at: any, portal_id?: string | null }> } | null, update_properties_by_pk?: { id: string, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, energy_certificate_version?: string | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, consumption?: number | null, emissions?: number | null, minergie_code?: number | null, plot_number?: string | null, floor_of_flat?: number | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, living_surface?: number | null, land_surface?: number | null, commercial_surface?: number | null, number_of_floors?: number | null, construction_year?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, micro_location?: number | null, macro_location?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, created_at: any, created_by?: string | null, property_type_id?: string | null, usable_surface?: number | null, gross_floor_surface?: number | null, basement_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, garden_surface?: number | null, residential_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_lifts?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, is_residential_fully_rented?: boolean | null, is_commercial_fully_rented?: boolean | null, street_number?: string | null, route?: string | null, locality?: string | null, state?: string | null, country?: string | null, country_code?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null } | null };

export type ListingDocumentsQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
}>;


export type ListingDocumentsQuery = { lots_by_pk?: { id: string, property_id: string, lot_property_files: Array<{ property_id: string, file_id: string, is_visible: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, label?: string | null } | null } }> } | null };

export type UpdateFileMutationVariables = Exact<{
  input: Files_Set_Input;
  id: Scalars['uuid']['input'];
}>;


export type UpdateFileMutation = { update_files?: { affected_rows: number } | null };

export type UpdatePropertyFileMutationVariables = Exact<{
  input: Property_Files_Set_Input;
  file_id: Scalars['uuid']['input'];
  property_id: Scalars['uuid']['input'];
}>;


export type UpdatePropertyFileMutation = { update_property_files?: { returning: Array<{ property_id: string, file_id: string, is_visible: boolean }> } | null };

export type ReOrderPropertyFilesMutationVariables = Exact<{
  property_id: Scalars['uuid']['input'];
  file_id: Scalars['uuid']['input'];
  target_position: Scalars['Int']['input'];
}>;


export type ReOrderPropertyFilesMutation = { update_property_files?: { affected_rows: number, returning: Array<{ property_id: string, file_id: string, order_nr: number }> } | null };

export type InsertLotsMutationVariables = Exact<{
  objects: Array<LotImportInput> | LotImportInput;
}>;


export type InsertLotsMutation = { import_lots?: Array<{ lot_id?: string | null }> | null };

export type DeleteLotsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteLotsMutation = { delete_lots?: { affected_rows: number } | null };

export type ExportLotsQueryVariables = Exact<{
  where: Lots_Bool_Exp;
}>;


export type ExportLotsQuery = { lots: Array<{ id: string, lot_reference?: string | null, status: Lots_Status_Enum_Enum, title?: string | null, description?: string | null, offer_type?: string | null, price_unit?: string | null, currency?: string | null, sale_price?: number | null, rent_extra?: number | null, rent_net?: number | null, monthly_rent_computed?: number | null, available_from?: string | null, brochure_title?: string | null, brochure_description?: string | null, video_url?: string | null, virtual_visit_url?: string | null, use_custom_brochure_description: boolean, use_custom_brochure_title: boolean, hide_price_on_brochure: boolean, hide_price_on_portals: boolean, send_enquiries_to_sellers: boolean, origin_id?: string | null, shared_on_mls?: boolean | null, enquiry_response_enabled?: boolean | null, mandate_type?: string | null, is_exclusive?: boolean | null, signed_at?: string | null, is_sales_tax_inclusive?: boolean | null, commission_rate?: number | null, duration_in_months?: number | null, fixed_fee?: number | null, has_success_fee: boolean, order_nr: number, mandate_sale_price?: number | null, minimum_net_seller_price?: number | null, success_fee_percentage?: number | null, expected_time_to_sell: string, success_fee_custom?: string | null, success_fee_type: string, development_id?: string | null, created_at: any, updated_at: any, broker?: { full_name?: string | null, emails: Array<{ email: string }> } | null, property: { id: string, route?: string | null, street_number?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, country_code?: string | null, lat?: number | null, lng?: number | null, macro_location?: number | null, micro_location?: number | null, living_surface?: number | null, usable_surface?: number | null, weighted_floor_surface?: number | null, gross_floor_surface?: number | null, built_surface?: number | null, land_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, garden_surface?: number | null, basement_surface?: number | null, commercial_surface?: number | null, residential_surface?: number | null, ceiling_height?: number | null, building_volume?: number | null, building_volume_norm?: string | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_floors?: number | null, floor_of_flat?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, parking_potential_rental_income?: number | null, parking_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, number_of_lifts?: number | null, minergie_code?: number | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, has_view?: boolean | null, has_fireplace?: boolean | null, has_sauna?: boolean | null, has_gym?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, has_swimming_pool?: boolean | null, has_attic?: boolean | null, has_cellar?: boolean | null, has_storage_room?: boolean | null, has_elevator?: boolean | null, is_child_friendly?: boolean | null, is_commercial_fully_rented?: boolean | null, is_luxury?: boolean | null, is_maisonette?: boolean | null, is_parking_fully_rented?: boolean | null, is_rental?: boolean | null, is_residential_fully_rented?: boolean | null, is_secondary_residence?: boolean | null, is_wheelchair_accessible?: boolean | null, construction_year?: number | null, renovation_year?: number | null, building_condition?: number | null, flat_condition?: number | null, plot_number?: string | null, plot_registry_number?: string | null, plot_is_constructible?: boolean | null, plot_has_constructible_reserve?: boolean | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, share_of_ownership?: number | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, renovation_fund?: number | null, heating?: Heating_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, energy_certificate_version?: string | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, emissions?: number | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, estimated_higher_energy_cost?: number | null, estimated_lower_energy_cost?: number | null, created_at: any, updated_at: any, property_type?: { id: string, name?: string | null, main_type?: string | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } }> };

export type UpdateLotsOrderMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  target_position: Scalars['Int']['input'];
}>;


export type UpdateLotsOrderMutation = { update_lots_by_pk?: { id: string } | null };

export type UpdateAutoMatchingFiltersMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  filters?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateAutoMatchingFiltersMutation = { update_lots_by_pk?: { id: string, auto_matching_filters?: any | null } | null };

export type CatchmentAreasQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
}>;


export type CatchmentAreasQuery = { users_by_pk?: { default_team?: { teams_users: Array<{ user: { catchment_areas: Array<{ place: { postcode?: string | null, lat: number, lng: number } }> } }> } | null } | null };

export type GetMlsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mls_Lots_Bool_Exp>;
  order_by?: InputMaybe<Array<Mls_Lots_Order_By> | Mls_Lots_Order_By>;
  total_count_limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMlsQuery = { mls_lots_aggregate: { aggregate?: { count: number } | null }, lot_brochure_doc_templates: Array<{ id: string, name: string, active: boolean, doc_templates_tenants: Array<{ tenant_id: string, is_default: boolean }> }>, mls_lots: Array<{ id?: string | null, created_at?: any | null, title?: string | null, description?: string | null, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, price_unit?: string | null, status?: string | null, currency?: string | null, property?: { id?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, land_surface?: number | null, living_surface?: number | null, built_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, property_images: Array<{ image: { url?: string | null } }>, property_type?: { id: string, label?: string | null, main_type?: string | null } | null } | null }> };

export type GetOffersQueryVariables = Exact<{
  where: Offers_Bool_Exp;
  order_by: Array<Offers_Order_By> | Offers_Order_By;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetOffersQuery = { offers: Array<{ id: string, amount: number, valid_until?: string | null, status: Offers_Status_Enum, made_on: string, comments?: string | null, created_by?: string | null, lot: { id: string, currency?: string | null, title?: string | null, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, hide_price_on_portals: boolean, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property: { id: string, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_surface?: number | null, single_property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null } }, offer_refused_type?: { id: string, label?: string | null } | null, buyer: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> };

export type GetOffersCountQueryVariables = Exact<{
  where: Offers_Bool_Exp;
}>;


export type GetOffersCountQuery = { offers_count: { aggregate?: { count: number } | null } };

export type GetOfferDrawerQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetOfferDrawerQuery = { offers_by_pk?: { id: string, created_by?: string | null, amount: number, valid_until?: string | null, status: Offers_Status_Enum, made_on: string, comments?: string | null, lot: { id: string, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> }, offer_refused_type?: { id: string, label?: string | null } | null, buyer: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } } | null };

export type DeleteOfferMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteOfferMutation = { delete_offers?: { affected_rows: number } | null };

export type UpdateOfferMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  updates: Offers_Set_Input;
}>;


export type UpdateOfferMutation = { update_offers_by_pk?: { id: string, amount: number, valid_until?: string | null, status: Offers_Status_Enum, made_on: string, comments?: string | null, lot: { id: string, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> }, offer_refused_type?: { id: string, label?: string | null } | null, buyer: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } } | null };

export type GetOfferRefusedTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOfferRefusedTypesQuery = { dictionaries: Array<{ id: string, name: string, label?: string | null }> };

export type InsertOfferMutationVariables = Exact<{
  offer: Offers_Insert_Input;
}>;


export type InsertOfferMutation = { insert_offers_one?: { id: string, amount: number, valid_until?: string | null, status: Offers_Status_Enum, made_on: string, comments?: string | null, lot: { id: string, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> }, offer_refused_type?: { id: string, label?: string | null } | null, buyer: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } } | null };

export type OrganisationAddressFragment = { street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null };

export type GetOrganisationsListQueryVariables = Exact<{
  where: Organisations_Bool_Exp;
  order_by?: InputMaybe<Array<Organisations_Order_By> | Organisations_Order_By>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetOrganisationsListQuery = { organisations: Array<{ id: string, created_at: any, updated_at: any, name?: string | null, branding_color?: string | null, website?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, organisation_images: Array<{ image: { url?: string | null } }> }>, organisations_aggregate: { aggregate?: { count: number } | null } };

export type GetOrganisationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetOrganisationQuery = { organisations_by_pk?: { id: string, created_at: any, updated_at: any, name?: string | null, branding_color?: string | null, website?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, organisation_images: Array<{ id: string, image: { url?: string | null } }> } | null };

export type PortalTeamsQueryVariables = Exact<{
  portalId: Scalars['uuid']['input'];
}>;


export type PortalTeamsQuery = { portals_by_pk?: { id: string, name?: string | null, teams_portals: Array<{ id: string, contract_id?: string | null, team: { id: string, name: string } }> } | null, portal_listings: Array<{ lot: { broker?: { teams_users: Array<{ team_id: string }> } | null } }> };

export type AddPortalTeamMutationVariables = Exact<{
  portalId: Scalars['uuid']['input'];
  teamId: Scalars['uuid']['input'];
}>;


export type AddPortalTeamMutation = { insert_teams_portals_one?: { id: string, portal_id: string, team_id: string } | null };

export type UpdatePortalTeamMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  contract_id?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePortalTeamMutation = { update_teams_portals_by_pk?: { id: string, contract_id?: string | null } | null };

export type PortalFragmentFragment = { __typename: 'portals', id: string, created_at: any, updated_at: any, created_by?: string | null, active: boolean, contract_id?: string | null, email?: string | null, exact_address_required: boolean, exclude_from_published_stats: boolean, has_top_premium_listing?: boolean | null, idx_protocol: any, master_portal_id?: string | null, name?: string | null, port?: number | null, quota?: number | null, type: Portals_Types_Enum_Enum, url?: string | null, website_url?: string | null, team_id?: string | null, portal_listings_aggregate: { aggregate?: { count: number } | null }, logo?: { id: string, url?: string | null } | null };

export type GetPortalsQueryVariables = Exact<{
  where: Portals_Bool_Exp;
  order_by: Array<Portals_Order_By> | Portals_Order_By;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetPortalsQuery = { portals: Array<{ __typename: 'portals', id: string, created_at: any, updated_at: any, created_by?: string | null, active: boolean, contract_id?: string | null, email?: string | null, exact_address_required: boolean, exclude_from_published_stats: boolean, has_top_premium_listing?: boolean | null, idx_protocol: any, master_portal_id?: string | null, name?: string | null, port?: number | null, quota?: number | null, type: Portals_Types_Enum_Enum, url?: string | null, website_url?: string | null, team_id?: string | null, portal_listings_aggregate: { aggregate?: { count: number } | null }, logo?: { id: string, url?: string | null } | null }> };

export type GetPortalsCountQueryVariables = Exact<{
  where: Portals_Bool_Exp;
}>;


export type GetPortalsCountQuery = { portals_aggregate: { aggregate?: { count: number } | null } };

export type GetPortalQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPortalQuery = { portals_by_pk?: { __typename: 'portals', id: string, username?: string | null, password?: string | null, created_at: any, updated_at: any, created_by?: string | null, active: boolean, contract_id?: string | null, email?: string | null, exact_address_required: boolean, exclude_from_published_stats: boolean, has_top_premium_listing?: boolean | null, idx_protocol: any, master_portal_id?: string | null, name?: string | null, port?: number | null, quota?: number | null, type: Portals_Types_Enum_Enum, url?: string | null, website_url?: string | null, team_id?: string | null, portal_listings_aggregate: { aggregate?: { count: number } | null }, logo?: { id: string, url?: string | null } | null } | null, shared_portals: Array<{ id?: string | null, name?: string | null }>, portals_types_enum: Array<{ value: string }> };

export type UpdatePortalMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  portal: Portals_Set_Input;
}>;


export type UpdatePortalMutation = { update_portals_by_pk?: { __typename: 'portals', id: string, created_at: any, updated_at: any, created_by?: string | null, active: boolean, contract_id?: string | null, email?: string | null, exact_address_required: boolean, exclude_from_published_stats: boolean, has_top_premium_listing?: boolean | null, idx_protocol: any, master_portal_id?: string | null, name?: string | null, port?: number | null, quota?: number | null, type: Portals_Types_Enum_Enum, url?: string | null, website_url?: string | null, team_id?: string | null, portal_listings_aggregate: { aggregate?: { count: number } | null }, logo?: { id: string, url?: string | null } | null } | null };

export type UpsertPortalMutationVariables = Exact<{
  portal: Portals_Insert_Input;
}>;


export type UpsertPortalMutation = { insert_portals_one?: { __typename: 'portals', id: string, created_at: any, updated_at: any, created_by?: string | null, active: boolean, contract_id?: string | null, email?: string | null, exact_address_required: boolean, exclude_from_published_stats: boolean, has_top_premium_listing?: boolean | null, idx_protocol: any, master_portal_id?: string | null, name?: string | null, port?: number | null, quota?: number | null, type: Portals_Types_Enum_Enum, url?: string | null, website_url?: string | null, team_id?: string | null, portal_listings_aggregate: { aggregate?: { count: number } | null }, logo?: { id: string, url?: string | null } | null } | null };

export type DeletePortalMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeletePortalMutation = { delete_portals_by_pk?: { id: string } | null };

export type GetPropertySearchesListQueryVariables = Exact<{
  where: Property_Searches_Bool_Exp;
  order_by?: InputMaybe<Array<Property_Searches_Order_By> | Property_Searches_Order_By>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetPropertySearchesListQuery = { property_searches: Array<{ id: string, created_at: any, offer_type?: string | null, property_usage?: string | null, notification: any, source?: Property_Search_Source_Enum | null, aggregator_source?: Property_Search_Aggregator_Source_Enum | null, property_main_type_in?: Array<string> | null, property_main_type_nin?: Array<string> | null, composite_property_type_eq?: string | null, sale_price_lte?: number | null, sale_price_gte?: number | null, monthly_rent_lte?: number | null, monthly_rent_gte?: number | null, living_surface_lte?: number | null, living_surface_gte?: number | null, land_surface_lte?: number | null, land_surface_gte?: number | null, number_of_rooms_lte?: number | null, number_of_rooms_gte?: number | null, number_of_bedrooms_lte?: number | null, number_of_bedrooms_gte?: number | null, number_of_bathrooms_lte?: number | null, number_of_bathrooms_gte?: number | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property_searches_places: Array<{ place: { id: string, name: string, label?: string | null } }>, property_types: Array<{ property_type: { id: string, label?: string | null, type: string, composite_type_object?: { id: string, label?: string | null } | null } }> }> };

export type GetPropertySearchesCountQueryVariables = Exact<{
  where: Property_Searches_Bool_Exp;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPropertySearchesCountQuery = { property_searches_aggregate: { aggregate?: { count: number } | null } };

export type GetPropertySearchDrawerQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPropertySearchDrawerQuery = { property_searches_by_pk?: { id: string, created_at: any, offer_type?: string | null, notification: any, source?: Property_Search_Source_Enum | null, property_status?: string | null, property_main_type_in?: Array<string> | null, property_main_type_nin?: Array<string> | null, composite_property_type_eq?: string | null, sale_price_lte?: number | null, sale_price_gte?: number | null, monthly_rent_lte?: number | null, monthly_rent_gte?: number | null, number_of_rooms_lte?: number | null, number_of_rooms_gte?: number | null, number_of_bathrooms_lte?: number | null, number_of_bathrooms_gte?: number | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property_searches_places: Array<{ place: { id: string, name: string, label?: string | null } }>, property_types: Array<{ property_type: { id: string, label?: string | null, type: string, composite_type_object?: { id: string, label?: string | null } | null } }> } | null };

export type InsertPropertySearchesMutationVariables = Exact<{
  objects: Array<PropertySearchImportInput> | PropertySearchImportInput;
}>;


export type InsertPropertySearchesMutation = { import_property_searches?: Array<{ property_search_id?: string | null, property_search?: { id: string, user?: { id: string } | null, property_searches_places: Array<{ place: { id: string } }> } | null }> | null };

export type DeletePropertySearchesMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeletePropertySearchesMutation = { delete_property_searches?: { affected_rows: number } | null };

export type ExportPropertySearchesQueryVariables = Exact<{
  where: Property_Searches_Bool_Exp;
}>;


export type ExportPropertySearchesQuery = { property_searches: Array<{ id: string, created_at: any, offer_type?: string | null, property_usage?: string | null, notification: any, source?: Property_Search_Source_Enum | null, property_main_type_in?: Array<string> | null, property_main_type_nin?: Array<string> | null, sale_price_lte?: number | null, sale_price_gte?: number | null, monthly_rent_lte?: number | null, monthly_rent_gte?: number | null, living_surface_lte?: number | null, living_surface_gte?: number | null, land_surface_lte?: number | null, land_surface_gte?: number | null, number_of_rooms_lte?: number | null, number_of_rooms_gte?: number | null, number_of_bedrooms_lte?: number | null, number_of_bedrooms_gte?: number | null, user?: { id: string, full_name?: string | null, emails: Array<{ email: string }>, phone_numbers: Array<{ number: string }> } | null, property_searches_places: Array<{ place: { name: string, slug_en?: string | null } }> }> };

export type GetPropertySearchesDictionaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPropertySearchesDictionaryQuery = { sources: Array<{ id: string, name: string, label?: string | null }>, aggregator_sources: Array<{ id: string, name: string, label?: string | null }> };

export type BrochureReportIncludeFragment = { brochure_include_cover: boolean, brochure_include_property: boolean, brochure_include_description: boolean, brochure_include_photos: boolean, brochure_include_append_files: boolean };

export type GetBrochureReportQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetBrochureReportQuery = { lots_by_pk?: { __typename: 'lots', id: string, updated_at: any, title?: string | null, use_custom_brochure_title: boolean, brochure_title?: string | null, hide_price_on_brochure: boolean, address_display_option_brochure: Address_Display_Options_Enum_Enum, brochure_show_agent_on_brochure: boolean, brochure_description?: string | null, use_custom_brochure_description: boolean, brochure_description_layout: any, description?: string | null, brochure_include_cover: boolean, brochure_include_property: boolean, brochure_include_description: boolean, brochure_include_photos: boolean, brochure_include_append_files: boolean, brochure_font_family?: string | null, doc_template?: { id: string, content: string, filename_template: string, translations?: any | null } | null, property: { updated_at: any, id: string, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> }, brochure_cover_image?: { id: string } | null } | null };

export type StepCoverPhotoBrochureFragment = { id: string, title?: string | null, updated_at: any, use_custom_brochure_title: boolean, brochure_title?: string | null, hide_price_on_brochure: boolean, address_display_option_brochure: Address_Display_Options_Enum_Enum, brochure_show_agent_on_brochure: boolean, brochure_cover_image?: { id: string } | null, property: { id: string, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } };

export type UpdateBrochureCoverMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Lots_Set_Input;
}>;


export type UpdateBrochureCoverMutation = { update_lots_by_pk?: { id: string, title?: string | null, updated_at: any, use_custom_brochure_title: boolean, brochure_title?: string | null, hide_price_on_brochure: boolean, address_display_option_brochure: Address_Display_Options_Enum_Enum, brochure_show_agent_on_brochure: boolean, brochure_cover_image?: { id: string } | null, property: { id: string, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null };

export type StepDescriptionBrochureFragment = { id: string, updated_at: any, brochure_description?: string | null, use_custom_brochure_description: boolean, brochure_description_layout: any, description?: string | null };

export type UpdateBrochureDescriptionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Lots_Set_Input;
}>;


export type UpdateBrochureDescriptionMutation = { update_lots_by_pk?: { id: string, updated_at: any, brochure_description?: string | null, use_custom_brochure_description: boolean, brochure_description_layout: any, description?: string | null } | null };

export type UpdatePropertyDetailsBrochureMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Lots_Set_Input;
}>;


export type UpdatePropertyDetailsBrochureMutation = { update_lots_by_pk?: { id: string, updated_at: any, property: { id: string, updated_at: any } } | null };

export type StepPropertyDetailsBrochureFragment = { id: string, updated_at: any, property: { id: string, updated_at: any } };

export type StepPhotosBrochureFragment = { id: string, updated_at: any, property: { id: string, updated_at: any, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } };

export type UpdateStepPhotosBrochureMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Lots_Set_Input;
}>;


export type UpdateStepPhotosBrochureMutation = { update_lots_by_pk?: { id: string, updated_at: any, property: { id: string, updated_at: any, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null };

export type StepSettingsBrochureFragment = { id: string, brochure_font_family?: string | null, updated_at: any, doc_template?: { id: string } | null };

export type UpdateBrochureStepSettingsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Lots_Set_Input;
}>;


export type UpdateBrochureStepSettingsMutation = { update_lots_by_pk?: { id: string, brochure_font_family?: string | null, updated_at: any, doc_template?: { id: string } | null } | null };

export type DocTemplatesBrochureReportQueryVariables = Exact<{ [key: string]: never; }>;


export type DocTemplatesBrochureReportQuery = { doc_templates: Array<{ id: string, name: string, active: boolean, type: Doc_Template_Type_Enum_Enum, translations?: any | null }> };

export type UpdateBrochureReportFileMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Lots_Set_Input;
}>;


export type UpdateBrochureReportFileMutation = { update_lots_by_pk?: { id: string, updated_at: any } | null };

export type GetCmaReportsListQueryVariables = Exact<{
  where: Cma_Reports_Bool_Exp;
  order_by?: InputMaybe<Array<Cma_Reports_Order_By> | Cma_Reports_Order_By>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetCmaReportsListQuery = { cma_reports: Array<{ id: string, language: any, suggested_market_value?: number | null, is_price_range: boolean, price_range_min?: number | null, price_range_max?: number | null, updated_at: any, created_at: any, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, cover_image?: { url?: string | null } | null, doc_template?: { id: string, name: string } | null, lead?: { id: string, property?: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> } | null } | null }> };

export type GenerateCmaDescriptionQueryVariables = Exact<{
  cma_id: Scalars['uuid']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateCmaDescriptionQuery = { generate_cma_description?: { description: string, prompt: string } | null };

export type GetCmaReportsCountQueryVariables = Exact<{
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
}>;


export type GetCmaReportsCountQuery = { cma_reports_aggregate: { aggregate?: { count: number } | null } };

export type UpdateStepSettingsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateStepSettingsMutation = { update_cma_reports_by_pk?: { id: string, language: any, font_family?: string | null, updated_at: any, doc_template?: { id: string } | null } | null };

export type StepSettingsCmaFragment = { id: string, language: any, font_family?: string | null, updated_at: any, doc_template?: { id: string } | null };

export type StepCoverPhotoCmaFragment = { id: string, report_title?: string | null, updated_at: any, contact?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, broker?: { show_in_agency_pages?: boolean | null, id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { show_in_agency_pages?: boolean | null } | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, cover_image?: { id: string, url?: string | null } | null, lead?: { id: string, property?: { id: string, updated_at: any, lat?: number | null, lng?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null } | null };

export type StepHedonisticValuationFragment = { id: string, updated_at: any, include_hedonistic_valuation: boolean, lead?: { id: string, property?: { id: string, updated_at: any, latest_appraisal?: { id: string, updated_at: any } | null, appraisals: Array<{ id: string }> } | null } | null };

export type CmaReportFileFragment = { cma_report_id: string, file_id: string, is_visible: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any } };

export type CmaPropertyFileFragment = { property_id: string, file_id: string, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any } };

export type StepDescriptionFragment = { id: string, updated_at: any, include_description: boolean, description?: string | null };

export type UpdateStepPhotosMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UpdateStepPhotosMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type UpdateStepPointsOfInterestMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UpdateStepPointsOfInterestMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type UpdateDescriptionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateDescriptionMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, include_description: boolean, description?: string | null } | null };

export type StepAppendFilesFragment = { id: string, cma_report_files: Array<{ cma_report_id: string, file_id: string, is_visible: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any } }>, lead?: { id: string, property?: { id: string, property_files: Array<{ property_id: string, file_id: string, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any } }> } | null } | null };

export type CmaReportEditorFragment = { id: string, updated_at: any, language: any, lead?: { id: string, property?: { id: string, updated_at: any, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null } | null } | null, doc_template?: { id: string, content: string, filename_template: string, translations?: any | null } | null };

export type StepIntroductionFragment = { id: string, updated_at: any, introduction?: string | null };

export type StepPropertyDetailsFragment = { id: string, updated_at: any, lead?: { id: string, property?: { id: string, updated_at: any } | null } | null };

export type StepFinalFragment = { id: string, updated_at: any, positive_comments?: string | null, negative_comments?: string | null, suggested_market_value?: number | null, is_price_range: boolean, price_range_min?: number | null, price_range_max?: number | null, show_probability: boolean, probability_min?: number | null, probability_max?: number | null, probability_time_period?: number | null };

export type StepPotentialBuyersFragment = { id: string, updated_at: any, max_budget?: number | null, min_budget?: number | null, include_potential_buyers: boolean, suggested_market_value?: number | null, lead?: { id: string, property?: { id: string, latest_appraisal?: { id: string, min?: number | null, max?: number | null } | null } | null } | null };

export type DeleteCmaReportMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteCmaReportMutation = { delete_cma_reports_by_pk?: { id: string } | null };

export type DocTemplatesCmaReportQueryVariables = Exact<{ [key: string]: never; }>;


export type DocTemplatesCmaReportQuery = { doc_templates: Array<{ id: string, name: string, active: boolean, type: Doc_Template_Type_Enum_Enum, doc_templates_tenants: Array<{ tenant_id: string, is_default: boolean }> }> };

export type StepPoisFragment = { property_pois: Array<{ id: string, distance_meters: number, walking_distance_meters?: number | null, cycling_distance_meters?: number | null, walking_time_minutes?: number | null, cycling_time_minutes?: number | null, poi: { id: string, name: string, formatted_address: string, category: string, types: Array<string>, primary_type: string, lat: number, lng: number } }> };

export type GetCmaReportQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCmaReportQuery = { cma_reports_by_pk?: { __typename: 'cma_reports', id: string, updated_at: any, language: any, introduction?: string | null, report_title?: string | null, include_description: boolean, description?: string | null, include_hedonistic_valuation: boolean, include_comparables_valuation: boolean, caprate_estimated_monthly_rent?: number | null, caprate_minimum_required_yield?: number | null, construction_cost_base?: Cma_Reports_Construction_Base_Enum_Enum | null, intrinsic_building_surface?: number | null, intrinsic_construction_cost?: number | null, intrinsic_annual_deprecation_rate?: number | null, intrinsic_land_value?: number | null, intrinsic_custom_fields?: any | null, positive_comments?: string | null, negative_comments?: string | null, suggested_market_value?: number | null, is_price_range: boolean, price_range_min?: number | null, price_range_max?: number | null, show_probability: boolean, probability_min?: number | null, probability_max?: number | null, probability_time_period?: number | null, max_budget?: number | null, min_budget?: number | null, include_potential_buyers: boolean, font_family?: string | null, include_cover: boolean, include_introduction: boolean, include_property: boolean, include_photos: boolean, include_pois: boolean, include_cuprate_valuation: boolean, include_intrinsic_valuation: boolean, include_final_value: boolean, include_agent: boolean, include_agent_agency: boolean, include_client_testimonial: boolean, include_append_files: boolean, lead?: { id: string, property?: { id: string, updated_at: any, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, lat?: number | null, lng?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, living_surface?: number | null, built_surface?: number | null, usable_surface?: number | null, land_surface?: number | null, state?: string | null, building_volume?: number | null, construction_year?: number | null, renovation_year?: number | null, basement_surface?: number | null, commercial_surface?: number | null, balcony_surface?: number | null, garden_surface?: number | null, gross_floor_surface?: number | null, residential_surface?: number | null, terrace_surface?: number | null, weighted_floor_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, updated_at: any, value?: number | null, rent_value?: number | null, min?: number | null, max?: number | null } | null, appraisals: Array<{ id: string }>, locality_place?: { id: string, label?: string | null } | null, property_type?: { main_type?: string | null, name?: string | null } | null, property_files: Array<{ property_id: string, file_id: string, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any } }>, property_pois: Array<{ id: string, distance_meters: number, walking_distance_meters?: number | null, cycling_distance_meters?: number | null, walking_time_minutes?: number | null, cycling_time_minutes?: number | null, poi: { id: string, name: string, formatted_address: string, category: string, types: Array<string>, primary_type: string, lat: number, lng: number } }> } | null } | null, doc_template?: { id: string, content: string, filename_template: string, translations?: any | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, broker?: { show_in_agency_pages?: boolean | null, id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { show_in_agency_pages?: boolean | null } | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, cover_image?: { id: string, url?: string | null } | null, comparable_listings: Array<{ cma_report_id: string, order_nr: number, aggregates_db__merged_listings_clusters_id: any }>, cma_report_files: Array<{ cma_report_id: string, file_id: string, is_visible: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any } }> } | null };

export type GetPropertyAppraisableQueryVariables = Exact<{
  propertyId: Scalars['uuid']['input'];
}>;


export type GetPropertyAppraisableQuery = { property_appraisable?: { appraisable: { result: boolean, errors: Array<{ path: Array<string> }> } } | null };

export type UpdateCmaReportDocTemplateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateCmaReportDocTemplateMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, doc_template?: { id: string, name: string, type: Doc_Template_Type_Enum_Enum } | null } | null };

export type UpdateCmaStepCoverMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateCmaStepCoverMutation = { update_cma_reports_by_pk?: { id: string, report_title?: string | null, updated_at: any, contact?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, broker?: { show_in_agency_pages?: boolean | null, id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { show_in_agency_pages?: boolean | null } | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, cover_image?: { id: string, url?: string | null } | null, lead?: { id: string, property?: { id: string, updated_at: any, lat?: number | null, lng?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null } | null } | null };

export type StepCoverInsertPropertyImageMutationVariables = Exact<{
  object: Property_Images_Insert_Input;
}>;


export type StepCoverInsertPropertyImageMutation = { insert_property_images_one?: { id: string, image: { id: string, url?: string | null } } | null };

export type UpdateCmaIntroductionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateCmaIntroductionMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, introduction?: string | null } | null };

export type UpdatePropertyDetailsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdatePropertyDetailsMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, lead?: { id: string, property?: { id: string, updated_at: any } | null } | null } | null };

export type UpdateHedonisticValuationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateHedonisticValuationMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, include_hedonistic_valuation: boolean, lead?: { id: string, property?: { id: string, updated_at: any, latest_appraisal?: { id: string, updated_at: any } | null, appraisals: Array<{ id: string }> } | null } | null } | null };

export type UpdateFinalMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateFinalMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, positive_comments?: string | null, negative_comments?: string | null, suggested_market_value?: number | null, is_price_range: boolean, price_range_min?: number | null, price_range_max?: number | null, show_probability: boolean, probability_min?: number | null, probability_max?: number | null, probability_time_period?: number | null } | null };

export type UpdatePotentialBuyersMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdatePotentialBuyersMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, max_budget?: number | null, min_budget?: number | null, include_potential_buyers: boolean, suggested_market_value?: number | null, lead?: { id: string, property?: { id: string, latest_appraisal?: { id: string, min?: number | null, max?: number | null } | null } | null } | null } | null };

export type StepAddCmaReportFileMutationVariables = Exact<{
  object: Cma_Report_Files_Insert_Input;
  cma_report_id: Scalars['uuid']['input'];
}>;


export type StepAddCmaReportFileMutation = { insert_cma_report_files_one?: { cma_report_id: string, file_id: string, cma_report?: { id: string, cma_report_files: Array<{ cma_report_id: string, file_id: string, is_visible: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any } }> } | null } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type StepDeleteCmaReportFileMutationVariables = Exact<{
  file_id: Scalars['uuid']['input'];
  cma_report_id: Scalars['uuid']['input'];
}>;


export type StepDeleteCmaReportFileMutation = { delete_cma_report_files?: { returning: Array<{ cma_report_id: string, file_id: string }> } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type StepUpdateCmaReportFileMutationVariables = Exact<{
  input: Cma_Report_Files_Set_Input;
  file_id: Scalars['uuid']['input'];
  cma_report_id: Scalars['uuid']['input'];
}>;


export type StepUpdateCmaReportFileMutation = { update_cma_report_files?: { returning: Array<{ cma_report_id: string, file_id: string, cma_report?: { id: string, cma_report_files: Array<{ cma_report_id: string, file_id: string, is_visible: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any } }> } | null }> } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type StepUpdateCmaReportFileVisibilityMutationVariables = Exact<{
  file_id: Scalars['uuid']['input'];
  cma_report_id: Scalars['uuid']['input'];
  is_visible: Scalars['Boolean']['input'];
}>;


export type StepUpdateCmaReportFileVisibilityMutation = { update_cma_report_files?: { returning: Array<{ cma_report_id: string, file_id: string, is_visible: boolean }> } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type StepAppendAddPropertyFileMutationVariables = Exact<{
  object: Property_Files_Insert_Input;
}>;


export type StepAppendAddPropertyFileMutation = { insert_property_files_one?: { property_id: string, file_id: string, property: { id: string, property_files: Array<{ property_id: string, file_id: string, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any } }> } } | null };

export type StepListingsCompareFragment = { id: string, include_comparables_valuation: boolean, updated_at: any, comparable_listings: Array<{ cma_report_id: string, order_nr: number, aggregates_db__merged_listings_clusters_id: any }>, lead?: { id: string, property?: { id: string, number_of_rooms?: number | null, number_of_bedrooms?: number | null, living_surface?: number | null, built_surface?: number | null, usable_surface?: number | null, land_surface?: number | null, state?: string | null, lat?: number | null, lng?: number | null, locality_place?: { id: string, label?: string | null } | null, latest_appraisal?: { value?: number | null } | null, property_type?: { main_type?: string | null, name?: string | null } | null } | null } | null };

export type StepListingsCompareListingsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  ch: Scalars['Boolean']['input'];
  es: Scalars['Boolean']['input'];
  fr: Scalars['Boolean']['input'];
  it: Scalars['Boolean']['input'];
}>;


export type StepListingsCompareListingsQuery = { ch_cma_listings?: Array<{ id: number, number_of_rooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, address?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, property_type: string, valid_from: any, places?: Array<{ id: string, label?: string | null }> | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, fr_cma_listings?: Array<{ id: number, number_of_rooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, address?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, property_type: string, valid_from: any, places?: Array<{ id: string, label?: string | null }> | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, es_cma_listings?: Array<{ id: number, number_of_rooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, address?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, property_type: string, valid_from: any, places?: Array<{ id: string, label?: string | null }> | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, it_cma_listings?: Array<{ id: number, number_of_rooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, address?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, property_type: string, valid_from: any, places?: Array<{ id: string, label?: string | null }> | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }> };

export type StepListingsCompareAlgoQueryVariables = Exact<{
  built_surface?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  living_surface?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Int']['input']>;
  property_main_type?: InputMaybe<Scalars['String']['input']>;
  sale_price?: InputMaybe<Scalars['Float']['input']>;
  usable_surface?: InputMaybe<Scalars['Float']['input']>;
  ch: Scalars['Boolean']['input'];
  es: Scalars['Boolean']['input'];
  fr: Scalars['Boolean']['input'];
  it: Scalars['Boolean']['input'];
}>;


export type StepListingsCompareAlgoQuery = { ch_get_similar_listings_vector?: Array<{ id: number, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, address?: string | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id?: string | null, property_type: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, valid_from: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, es_get_similar_listings_vector?: Array<{ id: number, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, address?: string | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id?: string | null, property_type: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, valid_from: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, fr_get_similar_listings_vector?: Array<{ id: number, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, address?: string | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id?: string | null, property_type: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, valid_from: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, it_get_similar_listings_vector?: Array<{ id: number, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, address?: string | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id?: string | null, property_type: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, valid_from: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }> };

export type UpdateComparablesListMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateComparablesListMutation = { update_cma_reports_by_pk?: { id: string, include_comparables_valuation: boolean, updated_at: any } | null };

export type InsertCmaReportsComparablesMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  objects: Array<Cma_Reports_Comparables_Insert_Input> | Cma_Reports_Comparables_Insert_Input;
}>;


export type InsertCmaReportsComparablesMutation = { delete_cma_reports_comparables?: { __typename: 'cma_reports_comparables_mutation_response' } | null, insert_cma_reports_comparables?: { returning: Array<{ aggregates_db__merged_listings_clusters_id: any, cma_report_id: string, order_nr: number }> } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type UpdateCmaReportsComparablesMutationVariables = Exact<{
  cma_report_id: Scalars['uuid']['input'];
  listing_id: Scalars['bigint']['input'];
  order_nr: Scalars['Float']['input'];
}>;


export type UpdateCmaReportsComparablesMutation = { update_cma_reports_comparables?: { returning: Array<{ cma_report: { comparable_listings: Array<{ order_nr: number, cma_report_id: string, aggregates_db__merged_listings_clusters_id: any }> } }> } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type DeleteCmaReportsComparablesMutationVariables = Exact<{
  cma_report_id: Scalars['uuid']['input'];
  listing_id: Scalars['bigint']['input'];
}>;


export type DeleteCmaReportsComparablesMutation = { delete_cma_reports_comparables?: { returning: Array<{ cma_report: { comparable_listings: Array<{ order_nr: number, cma_report_id: string, aggregates_db__merged_listings_clusters_id: any }> } }> } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type ComparableCmaListingDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  stateId: Scalars['uuid']['input'];
  isCh: Scalars['Boolean']['input'];
  isFr: Scalars['Boolean']['input'];
  isEs: Scalars['Boolean']['input'];
  isIt: Scalars['Boolean']['input'];
}>;


export type ComparableCmaListingDetailsQuery = { ch_cma_listings_by_pk?: { id: number, title?: string | null, address?: string | null, offline_since?: any | null, valid_from: any, description?: string | null, sale_price?: number | null, number_of_rooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, offer_type: string, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, country_code?: string | null, living_surface?: number | null, built_surface?: number | null, computed_price_per_sqm?: number | null, property_type: string, floor_of_flat?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, construction_year?: number | null, property_main_type: string, agency_name?: string | null, agency_contact_address?: string | null, agency_contact_person?: string | null, url: string, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, created_at: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null, fr_cma_listings_by_pk?: { id: number, title?: string | null, address?: string | null, offline_since?: any | null, valid_from: any, description?: string | null, sale_price?: number | null, number_of_rooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, offer_type: string, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, country_code?: string | null, living_surface?: number | null, built_surface?: number | null, computed_price_per_sqm?: number | null, property_type: string, floor_of_flat?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, construction_year?: number | null, property_main_type: string, agency_name?: string | null, agency_contact_address?: string | null, agency_contact_person?: string | null, url: string, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, created_at: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null, es_cma_listings_by_pk?: { id: number, title?: string | null, address?: string | null, offline_since?: any | null, valid_from: any, description?: string | null, sale_price?: number | null, number_of_rooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, offer_type: string, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, country_code?: string | null, living_surface?: number | null, built_surface?: number | null, computed_price_per_sqm?: number | null, property_type: string, floor_of_flat?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, construction_year?: number | null, property_main_type: string, agency_name?: string | null, agency_contact_address?: string | null, agency_contact_person?: string | null, url: string, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, created_at: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null, it_cma_listings_by_pk?: { id: number, title?: string | null, address?: string | null, offline_since?: any | null, valid_from: any, description?: string | null, sale_price?: number | null, number_of_rooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, offer_type: string, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, country_code?: string | null, living_surface?: number | null, built_surface?: number | null, computed_price_per_sqm?: number | null, property_type: string, floor_of_flat?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, construction_year?: number | null, property_main_type: string, agency_name?: string | null, agency_contact_address?: string | null, agency_contact_person?: string | null, url: string, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, created_at: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null };

export type ComparableCmaListingsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  chWhere?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
  frWhere?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
  esWhere?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
  itWhere?: InputMaybe<It_Cma_Listings_Bool_Exp>;
  isCh: Scalars['Boolean']['input'];
  isEs: Scalars['Boolean']['input'];
  isFr: Scalars['Boolean']['input'];
  isIt: Scalars['Boolean']['input'];
}>;


export type ComparableCmaListingsQuery = { ch_cma_listings?: Array<{ id: number, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, address?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, valid_from: any, state_id: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, fr_cma_listings?: Array<{ id: number, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, address?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, valid_from: any, state_id: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, es_cma_listings?: Array<{ id: number, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, address?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, valid_from: any, state_id: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, it_cma_listings?: Array<{ id: number, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, address?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, valid_from: any, state_id: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }> };

export type ComparableCmaListingsCountQueryVariables = Exact<{
  chWhere?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
  frWhere?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
  esWhere?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
  itWhere?: InputMaybe<It_Cma_Listings_Bool_Exp>;
  isCh: Scalars['Boolean']['input'];
  isEs: Scalars['Boolean']['input'];
  isFr: Scalars['Boolean']['input'];
  isIt: Scalars['Boolean']['input'];
}>;


export type ComparableCmaListingsCountQuery = { ch_cma_listings_aggregate?: { aggregate?: { count: number } | null }, fr_cma_listings_aggregate?: { aggregate?: { count: number } | null }, es_cma_listings_aggregate?: { aggregate?: { count: number } | null }, it_cma_listings_aggregate?: { aggregate?: { count: number } | null } };

export type CreateCmaReportMutationVariables = Exact<{
  input: Cma_Reports_Insert_Input;
}>;


export type CreateCmaReportMutation = { insert_cma_reports_one?: { id: string } | null };

export type CmaReportIncludeFragment = { id: string, include_cover: boolean, include_introduction: boolean, include_property: boolean, include_description: boolean, include_photos: boolean, include_pois: boolean, include_hedonistic_valuation: boolean, include_comparables_valuation: boolean, include_cuprate_valuation: boolean, include_intrinsic_valuation: boolean, include_final_value: boolean, include_potential_buyers: boolean, include_agent: boolean, include_agent_agency: boolean, include_client_testimonial: boolean, include_append_files: boolean };

export type UpdateCmaReportStepVisibilityMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateCmaReportStepVisibilityMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, include_cover: boolean, include_introduction: boolean, include_property: boolean, include_description: boolean, include_photos: boolean, include_pois: boolean, include_hedonistic_valuation: boolean, include_comparables_valuation: boolean, include_cuprate_valuation: boolean, include_intrinsic_valuation: boolean, include_final_value: boolean, include_potential_buyers: boolean, include_agent: boolean, include_agent_agency: boolean, include_client_testimonial: boolean, include_append_files: boolean } | null };

export type StepCapRateValuationFragment = { id: string, updated_at: any, caprate_estimated_monthly_rent?: number | null, caprate_minimum_required_yield?: number | null, lead?: { id: string, property?: { id: string, latest_appraisal?: { id: string, value?: number | null, rent_value?: number | null } | null } | null } | null };

export type StepIntrinsicValuationFragment = { id: string, updated_at: any, construction_cost_base?: Cma_Reports_Construction_Base_Enum_Enum | null, intrinsic_building_surface?: number | null, intrinsic_construction_cost?: number | null, intrinsic_annual_deprecation_rate?: number | null, intrinsic_land_value?: number | null, intrinsic_custom_fields?: any | null, lead?: { id: string, property?: { id: string, building_volume?: number | null, construction_year?: number | null, renovation_year?: number | null, land_surface?: number | null, living_surface?: number | null, usable_surface?: number | null, basement_surface?: number | null, commercial_surface?: number | null, balcony_surface?: number | null, garden_surface?: number | null, gross_floor_surface?: number | null, residential_surface?: number | null, terrace_surface?: number | null, weighted_floor_surface?: number | null } | null } | null };

export type UpdateCapRateValuationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateCapRateValuationMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, caprate_estimated_monthly_rent?: number | null, caprate_minimum_required_yield?: number | null, lead?: { id: string, property?: { id: string, latest_appraisal?: { id: string, value?: number | null, rent_value?: number | null } | null } | null } | null } | null };

export type UpdateIntrinsicValuationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateIntrinsicValuationMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, construction_cost_base?: Cma_Reports_Construction_Base_Enum_Enum | null, intrinsic_building_surface?: number | null, intrinsic_construction_cost?: number | null, intrinsic_annual_deprecation_rate?: number | null, intrinsic_land_value?: number | null, intrinsic_custom_fields?: any | null, lead?: { id: string, property?: { id: string, building_volume?: number | null, construction_year?: number | null, renovation_year?: number | null, land_surface?: number | null, living_surface?: number | null, usable_surface?: number | null, basement_surface?: number | null, commercial_surface?: number | null, balcony_surface?: number | null, garden_surface?: number | null, gross_floor_surface?: number | null, residential_surface?: number | null, terrace_surface?: number | null, weighted_floor_surface?: number | null } | null } | null } | null };

export type DeletePropertyPoiMutationVariables = Exact<{
  propertyPoiId: Scalars['uuid']['input'];
}>;


export type DeletePropertyPoiMutation = { delete_property_pois_by_pk?: { id: string } | null };

export type GetPoiTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPoiTypesQuery = { dictionaries: Array<{ id: string, name: string, label?: string | null, types?: Array<string> | null }> };

export type GetAutoPoisMutationVariables = Exact<{
  propertyId: Scalars['uuid']['input'];
}>;


export type GetAutoPoisMutation = { auto_search_pois: boolean };

export type GetManualPoisMutationVariables = Exact<{
  propertyId: Scalars['uuid']['input'];
  search: Scalars['String']['input'];
}>;


export type GetManualPoisMutation = { manual_search_pois: Array<{ id: string, name: string, formattedAddress: string, distance: number, types: Array<string>, category: string, latitude: number, longitude: number, primaryType: string }> };

export type InsertPoiMutationVariables = Exact<{
  input: InsertPoisOneInput;
}>;


export type InsertPoiMutation = { insert_pois_one: boolean };

export type ReviewDrawerFragment = { id: string, completed_at?: any | null, created_at: any, rating?: number | null, review_text?: string | null, first_name?: string | null, last_name?: string | null, email_address: string, display_name?: string | null, is_buyer: boolean, formatted_address: string, transaction_date: any, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property_transaction?: { id: string, purchase_price?: number | null, signature_date?: any | null, seller_broker?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, listings_agency_names?: Array<string> | null } | null, property_transactions_listings: Array<{ listing_id: number }>, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, living_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, property_type?: { name?: string | null, id: string, label?: string | null } | null, locality_place?: { id: string } | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null };

export type GetReviewsQueryVariables = Exact<{
  where?: InputMaybe<Reviews_Bool_Exp>;
  orderBy?: InputMaybe<Array<Reviews_Order_By> | Reviews_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetReviewsQuery = { reviews: Array<{ id: string, completed_at?: any | null, created_at: any, rating?: number | null, review_text?: string | null, first_name?: string | null, last_name?: string | null, email_address: string, formatted_address: string, is_buyer: boolean, transaction_date: any, property_transaction?: { id: string, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null }> };

export type GetReviewsCountQueryVariables = Exact<{
  where?: InputMaybe<Reviews_Bool_Exp>;
}>;


export type GetReviewsCountQuery = { reviews_aggregate: { aggregate?: { count: number } | null } };

export type DeleteReviewMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteReviewMutation = { delete_reviews_by_pk?: { id: string } | null };

export type GetReviewQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetReviewQuery = { reviews_by_pk?: { id: string, completed_at?: any | null, created_at: any, rating?: number | null, review_text?: string | null, first_name?: string | null, last_name?: string | null, email_address: string, display_name?: string | null, is_buyer: boolean, formatted_address: string, transaction_date: any, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property_transaction?: { id: string, purchase_price?: number | null, signature_date?: any | null, seller_broker?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, listings_agency_names?: Array<string> | null } | null, property_transactions_listings: Array<{ listing_id: number }>, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, living_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, property_type?: { name?: string | null, id: string, label?: string | null } | null, locality_place?: { id: string } | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null } | null };

export type UpdateReviewMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  review?: InputMaybe<Reviews_Set_Input>;
}>;


export type UpdateReviewMutation = { update_reviews_by_pk?: { id: string, completed_at?: any | null, created_at: any, rating?: number | null, review_text?: string | null, first_name?: string | null, last_name?: string | null, email_address: string, display_name?: string | null, is_buyer: boolean, formatted_address: string, transaction_date: any, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property_transaction?: { id: string, purchase_price?: number | null, signature_date?: any | null, seller_broker?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, listings_agency_names?: Array<string> | null } | null, property_transactions_listings: Array<{ listing_id: number }>, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, living_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, property_type?: { name?: string | null, id: string, label?: string | null } | null, locality_place?: { id: string } | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null } | null };

export type GetTenantsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantsQuery = { tenants: Array<{ id: string, name: string, slug: string }> };

export type CreateApiKeyMutationVariables = Exact<{
  partnerName: Scalars['String']['input'];
  partnerRole: Scalars['String']['input'];
  partnerTeamsIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateApiKeyMutation = { create_key?: { PartnerName: string, PartnerID: string, PartnerApiKey: string, PartnerTeamsIds?: Array<string> | null, PartnerRole: string } | null };

export type DeleteApiKeyMutationVariables = Exact<{
  partnerId: Scalars['String']['input'];
}>;


export type DeleteApiKeyMutation = { delete_key?: { rowsDeleted?: string | null, message?: string | null } | null };

export type UpdateApiKeyMutationVariables = Exact<{
  partnerId: Scalars['String']['input'];
  partnerName: Scalars['String']['input'];
  partnerTeamsIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  partnerRole: Scalars['String']['input'];
}>;


export type UpdateApiKeyMutation = { update_key?: { PartnerName: string, PartnerID: string, PartnerApiKey: string, PartnerTeamsIds?: Array<string> | null, PartnerRole: string } | null };

export type GetApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApiKeysQuery = { get_api_keys?: Array<{ PartnerID: string, PartnerName: string, PartnerTeamsIds?: Array<string> | null, PartnerRole: string }> | null };

export type GetApiKeyQueryVariables = Exact<{
  partnerId: Scalars['String']['input'];
}>;


export type GetApiKeyQuery = { get_api_key?: { PartnerName: string, PartnerID: string, PartnerApiKey: string, PartnerTeamsIds?: Array<string> | null, PartnerRole: string } | null };

export type LeadStageFieldsFragment = { id: string, name?: string | null, status: Leads_Status_Enum, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, order_nr: number, pipeline_id: string };

export type LeadStagesQueryVariables = Exact<{
  pipelineId: Scalars['uuid']['input'];
}>;


export type LeadStagesQuery = { lead_stages: Array<{ id: string, name?: string | null, status: Leads_Status_Enum, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, order_nr: number, pipeline_id: string }> };

export type UpdatePipelineLeadStageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  lead_stage: Lead_Stages_Set_Input;
}>;


export type UpdatePipelineLeadStageMutation = { update_lead_stages_by_pk?: { id: string, name?: string | null, status: Leads_Status_Enum, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, order_nr: number, pipeline_id: string } | null };

export type ReorderLeadStagesMutationVariables = Exact<{
  pipelineId: Scalars['uuid']['input'];
  leadStageId: Scalars['uuid']['input'];
  starting_position: Scalars['Int']['input'];
  target_position: Scalars['Int']['input'];
}>;


export type ReorderLeadStagesMutation = { temp?: { id: string, name?: string | null, status: Leads_Status_Enum, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, order_nr: number, pipeline_id: string } | null, down?: { returning: Array<{ id: string, name?: string | null, status: Leads_Status_Enum, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, order_nr: number, pipeline_id: string }> } | null, up?: { returning: Array<{ id: string, name?: string | null, status: Leads_Status_Enum, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, order_nr: number, pipeline_id: string }> } | null, final?: { id: string, name?: string | null, status: Leads_Status_Enum, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, order_nr: number, pipeline_id: string } | null };

export type CreateLeadStageMutationVariables = Exact<{
  stage: Lead_Stages_Insert_Input;
}>;


export type CreateLeadStageMutation = { insert_lead_stages_one?: { id: string, name?: string | null, status: Leads_Status_Enum, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, order_nr: number, pipeline_id: string } | null };

export type DeleteLeadStageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteLeadStageMutation = { delete_lead_stages_by_pk?: { id: string } | null };

export type PipelineFragmentFragment = { id: string, created_at: any, updated_at: any, name?: string | null, label?: string | null, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, lead_type: any };

export type GetPipelinesListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPipelinesListQuery = { pipelines: Array<{ id: string, created_at: any, updated_at: any, name?: string | null, label?: string | null, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, lead_type: any, stages_aggregate: { aggregate?: { count: number } | null } }>, pipelines_aggregate: { aggregate?: { count: number } | null } };

export type GetPipelineQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPipelineQuery = { pipelines_by_pk?: { id: string, created_at: any, updated_at: any, name?: string | null, label?: string | null, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, lead_type: any } | null };

export type DeletePipelineMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeletePipelineMutation = { delete_pipelines_by_pk?: { id: string } | null };

export type UpsertPipelineMutationVariables = Exact<{
  pipeline: Pipelines_Insert_Input;
}>;


export type UpsertPipelineMutation = { insert_pipelines_one?: { id: string, created_at: any, updated_at: any, name?: string | null, label?: string | null, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, lead_type: any } | null };

export type TenantSettingsFragmentFragment = { id: string, name: string, route: string, street_number: string, postcode: string, locality: string, state: string, country?: string | null, google_place_description?: string | null, country_code: string, lng?: number | null, lat?: number | null, google_place_id?: string | null, default_pipeline_id: string };

export type GetTenantSettingsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetTenantSettingsQuery = { tenants_by_pk?: { id: string, name: string, route: string, street_number: string, postcode: string, locality: string, state: string, country?: string | null, google_place_description?: string | null, country_code: string, lng?: number | null, lat?: number | null, google_place_id?: string | null, default_pipeline_id: string } | null };

export type UpdateTenantSettingsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  tenant: Tenants_Set_Input;
}>;


export type UpdateTenantSettingsMutation = { update_tenants_by_pk?: { id: string, name: string, route: string, street_number: string, postcode: string, locality: string, state: string, country?: string | null, google_place_description?: string | null, country_code: string, lng?: number | null, lat?: number | null, google_place_id?: string | null, default_pipeline_id: string } | null };

export type InvoiceFragmentFragment = { id: string, stripe_id: string, created?: any | null, status: any, period_start?: any | null, period_end?: any | null, amount_due?: number | null, amount_paid?: number | null, lines?: any | null };

export type GetSubscriptionsListQueryVariables = Exact<{
  where: Subscriptions_Bool_Exp;
  order_by?: InputMaybe<Array<Subscriptions_Order_By> | Subscriptions_Order_By>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetSubscriptionsListQuery = { subscriptions: Array<{ id: string, stripe_id: string, created_at: any, updated_at: any, start_date: any, current_period_start: any, current_period_end: any, customer_email?: string | null, customer: string, status: any, total_amount: number, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, broker_leads_aggregate: { aggregate?: { count: number } | null }, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, invoices_aggregate: { aggregate?: { sum?: { amount_paid?: number | null } | null } | null } }> };

export type GetSubscriptionsListCountQueryVariables = Exact<{
  where: Subscriptions_Bool_Exp;
}>;


export type GetSubscriptionsListCountQuery = { subscriptions_aggregate: { aggregate?: { count: number } | null } };

export type GetSubscriptionQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSubscriptionQuery = { subscriptions_by_pk?: { id: string, stripe_id: string, created_at: any, updated_at: any, start_date: any, current_period_start: any, current_period_end: any, customer_email?: string | null, customer: string, status: any, total_amount: number, user_id?: string | null, user?: { id: string, full_name?: string | null, broker_leads_aggregate: { aggregate?: { count: number } | null } } | null, invoices: Array<{ id: string, stripe_id: string, created?: any | null, status: any, period_start?: any | null, period_end?: any | null, amount_due?: number | null, amount_paid?: number | null, lines?: any | null }>, invoices_aggregate: { aggregate?: { sum?: { amount_paid?: number | null } | null } | null } } | null };

export type UpdateSubscriptionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
}>;


export type UpdateSubscriptionMutation = { update_subscriptions_by_pk?: { id: string, user_id?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, broker_leads_aggregate: { aggregate?: { count: number } | null }, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null } | null };

export type GetTeamReviewsQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type GetTeamReviewsQuery = { teams_by_pk?: { id: string, last_review_scraping?: any | null, google_place_description?: string | null, google_reviews: Array<{ id: string, updated_at: any, google_timestamp: any, rating: number, review_text?: string | null, original_review_text?: string | null, profile_name: string, profile_url: string, review_url: string, profile_image_url: string, owner_answer?: string | null }>, google_reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null } } | null };

export type ScrapeReviewsMutationVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type ScrapeReviewsMutation = { scrape_google_reviews?: { status_message?: string | null, status_code?: number | null, tasks?: any | null } | null };

export type DeleteReviewsMutationVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type DeleteReviewsMutation = { delete_google_reviews?: { affected_rows: number } | null };

export type TeamCombinedReviewsAggFragment = { combined_reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null } };

export type GetTeamPortalsQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type GetTeamPortalsQuery = { portals: Array<{ id: string, name?: string | null, active: boolean, quota?: number | null, type: Portals_Types_Enum_Enum, portal_listings_aggregate: { aggregate?: { count: number } | null } }>, teams_portals: Array<{ id: string, portal: { id: string, name?: string | null, active: boolean, quota?: number | null, type: Portals_Types_Enum_Enum } }>, portal_listings: Array<{ portal: { id: string } }> };

export type DeleteTeamPortalMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteTeamPortalMutation = { delete_teams_portals_by_pk?: { portal_id: string, team_id: string } | null };

export type TeamAddressFragment = { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null };

export type TeamAddress_LightFragment = { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null };

export type GetTeamsListQueryVariables = Exact<{
  where: Teams_Bool_Exp;
  order_by: Array<Teams_Order_By> | Teams_Order_By;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetTeamsListQuery = { teams: Array<{ id: string, created_at: any, name: string, lat?: number | null, lng?: number | null, show_in_agency_pages?: boolean | null, agency_slug?: string | null, google_place_description?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, google_reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null }, logo?: { id: string, url?: string | null } | null, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, organisation_images: Array<{ image: { url?: string | null } }> } | null, teams_users: Array<{ user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, combined_reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null }, subscriptions: Array<{ status: any, total_amount: number }>, lead_agents_aggregate: { aggregate?: { count: number } | null } } }>, property_transactions_aggregate: { aggregate?: { count: number, max?: { updated_at?: any | null } | null } | null }, combined_reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null } }> };

export type GetTeamsListCountQueryVariables = Exact<{
  where: Teams_Bool_Exp;
}>;


export type GetTeamsListCountQuery = { teams_aggregate: { aggregate?: { count: number } | null } };

export type DrawerGetTeamQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DrawerGetTeamQuery = { teams_by_pk?: { id: string, created_at: any, name: string, teams_users_aggregate: { nodes: Array<{ user_id: string }> } } | null };

export type OverviewGetTeamQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  includeSubscriptions: Scalars['Boolean']['input'];
}>;


export type OverviewGetTeamQuery = { teams_by_pk?: { id: string, created_at: any, name: string, cover_photo?: { id: string, url?: string | null } | null, logo?: { id: string, url?: string | null } | null, teams_users: Array<{ created_at: any, is_leader: boolean, title?: string | null, deactivated: boolean, order_nr: number, user: { id: string, is_broker: boolean, is_admin: boolean, first_name?: string | null, last_name?: string | null, full_name?: string | null, combined_reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null }, subscriptions?: Array<{ total_amount: number, status: any, current_period_start: any, current_period_end: any, invoices_aggregate: { aggregate?: { sum?: { amount_paid?: number | null } | null } | null } }>, broker_leads_aggregate: { aggregate?: { count: number } | null }, lots_aggregate: { aggregate?: { count: number } | null }, property_transactions_aggregate: { aggregate?: { sum?: { purchase_price?: number | null } | null } | null }, reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null }, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, combined_reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null } } | null };

export type CreateTeamMutationVariables = Exact<{
  team: Teams_Insert_Input;
}>;


export type CreateTeamMutation = { insert_teams_one?: { id: string } | null };

export type DeleteTeamMutationVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  userIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  userIdsString?: InputMaybe<Scalars['_uuid']['input']>;
}>;


export type DeleteTeamMutation = { delete_teams_by_pk?: { id: string } | null, update_users?: { returning: Array<{ default_team_id?: string | null }> } | null, delete_teams_users?: { affected_rows: number } | null, disable_broker?: { returning: Array<{ is_broker: boolean }> } | null, set_default_team: Array<{ id: string }> };

export type DeleteTeamUserMutationVariables = Exact<{
  team_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
}>;


export type DeleteTeamUserMutation = { update_users?: { returning: Array<{ default_team_id?: string | null, teams_users: Array<{ deactivated: boolean, team: { id: string } }> }> } | null, delete_teams_users?: { affected_rows: number } | null, disable_broker?: { returning: Array<{ is_broker: boolean }> } | null };

export type AddTeamUserMutationVariables = Exact<{
  team_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
}>;


export type AddTeamUserMutation = { set_default_team_id?: { returning: Array<{ default_team_id?: string | null }> } | null, insert_teams_users_one?: { team: { id: string }, user: { id: string } } | null, enable_broker?: { returning: Array<{ is_broker: boolean }> } | null };

export type UpdateTeamUserOrderMutationVariables = Exact<{
  team_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
  target_position: Scalars['Int']['input'];
}>;


export type UpdateTeamUserOrderMutation = { update_teams_users?: { affected_rows: number, returning: Array<{ user_id: string, order_nr: number }> } | null };

export type UpdateTeamUserMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  team_id: Scalars['uuid']['input'];
  team_user: Teams_Users_Set_Input;
}>;


export type UpdateTeamUserMutation = { update_teams_users?: { returning: Array<{ is_leader: boolean }> } | null, enable_broker?: { returning: Array<{ is_broker: boolean, default_team_id?: string | null, teams_users: Array<{ deactivated: boolean, team: { id: string } }> }> } | null, disable_broker?: { returning: Array<{ is_broker: boolean }> } | null };

export type TeamsCardQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type TeamsCardQuery = { users: Array<{ default_team_id?: string | null, teams_users: Array<{ deactivated: boolean, is_leader: boolean, team: { id: string, name: string } }> }> };

export type TeamsCardUpdateUserDefaultTeamMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  team_id: Scalars['uuid']['input'];
}>;


export type TeamsCardUpdateUserDefaultTeamMutation = { update_users?: { returning: Array<{ default_team_id?: string | null }> } | null };

export type DeleteTeamImageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteTeamImageMutation = { delete_team_images_by_pk?: { id: string } | null };

export type TeamSettingsFragmentFragment = { id: string, branding_color?: string | null, created_at: any, created_by?: string | null, name: string, description?: string | null, website_url?: string | null, do_follow_link?: boolean | null, legal_name?: string | null, agency_slug?: string | null, idx_agency_id?: string | null, idx_ftp_client_id?: string | null, show_in_agency_pages?: boolean | null, hide_exact_address: boolean, active_since?: number | null, country_code?: string | null, lat?: number | null, lng?: number | null, google_place_id?: string | null, google_place_description?: string | null, organisation_id?: string | null, facebook_url?: string | null, instagram_url?: string | null, youtube_url?: string | null, linkedin_url?: string | null, twitter_url?: string | null, listings_agency_names?: Array<string> | null, enquiry_email_contact?: string | null, use_json_for_enquiry_emails: boolean, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string }> };

export type GetTeamSettingsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetTeamSettingsQuery = { teams_by_pk?: { id: string, branding_color?: string | null, created_at: any, created_by?: string | null, name: string, description?: string | null, website_url?: string | null, do_follow_link?: boolean | null, legal_name?: string | null, agency_slug?: string | null, idx_agency_id?: string | null, idx_ftp_client_id?: string | null, show_in_agency_pages?: boolean | null, hide_exact_address: boolean, active_since?: number | null, country_code?: string | null, lat?: number | null, lng?: number | null, google_place_id?: string | null, google_place_description?: string | null, organisation_id?: string | null, facebook_url?: string | null, instagram_url?: string | null, youtube_url?: string | null, linkedin_url?: string | null, twitter_url?: string | null, listings_agency_names?: Array<string> | null, enquiry_email_contact?: string | null, use_json_for_enquiry_emails: boolean, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string }> } | null };

export type UpdateTeamSettingsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  team: Teams_Set_Input;
}>;


export type UpdateTeamSettingsMutation = { update_teams_by_pk?: { id: string, branding_color?: string | null, created_at: any, created_by?: string | null, name: string, description?: string | null, website_url?: string | null, do_follow_link?: boolean | null, legal_name?: string | null, agency_slug?: string | null, idx_agency_id?: string | null, idx_ftp_client_id?: string | null, show_in_agency_pages?: boolean | null, hide_exact_address: boolean, active_since?: number | null, country_code?: string | null, lat?: number | null, lng?: number | null, google_place_id?: string | null, google_place_description?: string | null, organisation_id?: string | null, facebook_url?: string | null, instagram_url?: string | null, youtube_url?: string | null, linkedin_url?: string | null, twitter_url?: string | null, listings_agency_names?: Array<string> | null, enquiry_email_contact?: string | null, use_json_for_enquiry_emails: boolean, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, cover_photo?: { id: string, url?: string | null } | null, logo?: { id: string, url?: string | null } | null, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string }> } | null };

export type UpsertTeamEmailMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  email: Scalars['citext']['input'];
}>;


export type UpsertTeamEmailMutation = { delete_emails?: { affected_rows: number } | null, insert_emails_one?: { id: string, email: string } | null };

export type DeleteTeamEmailMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteTeamEmailMutation = { delete_emails?: { affected_rows: number } | null };

export type UpdateTeamPhoneNumberMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  phone_number: Scalars['String']['input'];
}>;


export type UpdateTeamPhoneNumberMutation = { delete_phone_numbers?: { affected_rows: number } | null, insert_phone_numbers_one?: { id: string, number: string } | null };

export type DeleteTeamPhoneNumberMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteTeamPhoneNumberMutation = { delete_phone_numbers?: { affected_rows: number } | null };

export type UpdateTeamImagesMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  team: Teams_Set_Input;
}>;


export type UpdateTeamImagesMutation = { update_teams_by_pk?: { id: string, branding_color?: string | null, created_at: any, created_by?: string | null, name: string, description?: string | null, website_url?: string | null, do_follow_link?: boolean | null, legal_name?: string | null, agency_slug?: string | null, idx_agency_id?: string | null, idx_ftp_client_id?: string | null, show_in_agency_pages?: boolean | null, hide_exact_address: boolean, active_since?: number | null, country_code?: string | null, lat?: number | null, lng?: number | null, google_place_id?: string | null, google_place_description?: string | null, organisation_id?: string | null, facebook_url?: string | null, instagram_url?: string | null, youtube_url?: string | null, linkedin_url?: string | null, twitter_url?: string | null, listings_agency_names?: Array<string> | null, enquiry_email_contact?: string | null, use_json_for_enquiry_emails: boolean, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, cover_photo?: { id: string, url?: string | null } | null, logo?: { id: string, url?: string | null } | null, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string }> } | null };

export type GetTeamValuationRequestsQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type GetTeamValuationRequestsQuery = { lead_agents: Array<{ id: string, created_at: any, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> }, lead: { id: string, appraisal_reason: Leads_Appraisal_Reason_Enum, sale_horizon: Leads_Sale_Horizon_Enum, contact?: { id: string, first_name?: string | null, last_name?: string | null, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string }> } | null } }> };

export type GetTeamContactRequestsQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type GetTeamContactRequestsQuery = { enquiries: Array<{ id: string, created_at: any, contact_reason?: string | null, first_name?: string | null, last_name?: string | null, email_address?: string | null, phone_number?: string | null, message?: string | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property_transaction?: { signature_date?: any | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } } | null }> };

export type GetCreateTransactionDataQueryVariables = Exact<{
  includeListing: Scalars['Boolean']['input'];
  includeOffer: Scalars['Boolean']['input'];
  offerId?: InputMaybe<Scalars['uuid']['input']>;
  listingId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetCreateTransactionDataQuery = { lots?: Array<{ id: string, broker_id?: string | null, mandate_type?: string | null, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, broker?: { id: string, default_team_id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, last_accepted_offer?: Array<{ id: string, amount: number, buyer_id: string }>, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> }>, property_types: Array<{ id: string, name?: string | null, label?: string | null, main_type?: string | null, type: string }> };

export type GetPropertyTransactionsQueryVariables = Exact<{
  where: Property_Transactions_Bool_Exp;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By> | Property_Transactions_Order_By>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  team_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetPropertyTransactionsQuery = { property_transactions: Array<{ id: string, signature_date?: any | null, estimated_signature_date?: any | null, payment_date?: any | null, purchase_price?: number | null, reviews: Array<{ id: string, is_buyer: boolean }>, seller_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, buyer_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, buyer_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, property: { living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_type?: { id: string, label?: string | null } | null, property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> }, commissions: Array<{ id: string, is_paid?: boolean | null, amount?: number | null }>, lot?: { id: string, currency?: string | null } | null, sellers: Array<{ user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null }>, buyers: Array<{ user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null }>, commissions_aggregate: { aggregate?: { sum?: { amount?: number | null } | null } | null }, my_commissions: { aggregate?: { sum?: { amount?: number | null } | null } | null } }> };

export type GetPropertyTransactionsListCountQueryVariables = Exact<{
  where: Property_Transactions_Bool_Exp;
}>;


export type GetPropertyTransactionsListCountQuery = { property_transactions_aggregate: { aggregate?: { count: number } | null } };

export type TransactionDrawerGetTransactionQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TransactionDrawerGetTransactionQuery = { property_transactions_by_pk?: { id: string, lot_id?: string | null, property_id: string, buyer_broker_team_id?: string | null, seller_broker_team_id?: string | null } | null };

export type DeleteTransactionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteTransactionMutation = { delete_property_transactions_by_pk?: { id: string } | null };

export type TransactionFormFragmentFragment = { id: string, created_by?: string | null, created_at?: any | null, signature_date?: any | null, buyer_broker_id?: string | null, seller_broker_id?: string | null, buyer_broker_team_id?: string | null, seller_broker_team_id?: string | null, estimated_signature_date?: any | null, payment_date?: any | null, purchase_price?: number | null, is_published: boolean, lot_id?: string | null, lot?: { id: string, currency?: string | null, property: { id: string, country_code?: string | null } } | null, sellers: Array<{ transaction_id?: string | null, user_id?: string | null }>, buyers: Array<{ transaction_id?: string | null, user_id?: string | null }> };

export type TransactionCommissionsFormFragmentFragment = { id: string, purchase_price?: number | null, commissions: Array<{ id: string, type?: string | null, amount?: number | null, vat?: number | null, contact_id?: string | null, beneficiary_team_id?: string | null }>, lot?: { id: string, currency?: string | null, mandate_type?: string | null, property: { id: string, country_code?: string | null } } | null };

export type TransactionFormQueryQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TransactionFormQueryQuery = { property_transactions_by_pk?: { id: string, created_by?: string | null, created_at?: any | null, signature_date?: any | null, buyer_broker_id?: string | null, seller_broker_id?: string | null, buyer_broker_team_id?: string | null, seller_broker_team_id?: string | null, estimated_signature_date?: any | null, payment_date?: any | null, purchase_price?: number | null, is_published: boolean, lot_id?: string | null, lot?: { id: string, currency?: string | null, property: { id: string, country_code?: string | null } } | null, sellers: Array<{ transaction_id?: string | null, user_id?: string | null }>, buyers: Array<{ transaction_id?: string | null, user_id?: string | null }> } | null };

export type TransactionFormUpdateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  transaction: Property_Transactions_Set_Input;
  sellers: Array<Transaction_Sellers_Insert_Input> | Transaction_Sellers_Insert_Input;
  buyers: Array<Transaction_Buyers_Insert_Input> | Transaction_Buyers_Insert_Input;
}>;


export type TransactionFormUpdateMutation = { update_property_transactions_by_pk?: { id: string, created_by?: string | null, created_at?: any | null, signature_date?: any | null, buyer_broker_id?: string | null, seller_broker_id?: string | null, buyer_broker_team_id?: string | null, seller_broker_team_id?: string | null, estimated_signature_date?: any | null, payment_date?: any | null, purchase_price?: number | null, is_published: boolean, lot_id?: string | null, seller_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, buyer_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, buyer_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, seller_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, lot?: { id: string, currency?: string | null, property: { id: string, country_code?: string | null } } | null, sellers: Array<{ transaction_id?: string | null, user_id?: string | null }>, buyers: Array<{ transaction_id?: string | null, user_id?: string | null }> } | null, delete_transaction_buyers?: { returning: Array<{ transaction_id?: string | null, user_id?: string | null }> } | null, delete_transaction_sellers?: { returning: Array<{ transaction_id?: string | null, user_id?: string | null }> } | null, insert_transaction_buyers?: { returning: Array<{ transaction_id?: string | null, user_id?: string | null }> } | null, insert_transaction_sellers?: { returning: Array<{ transaction_id?: string | null, user_id?: string | null }> } | null };

export type TransactionCommissionsFormUpdateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  commissions: Array<Commissions_Insert_Input> | Commissions_Insert_Input;
}>;


export type TransactionCommissionsFormUpdateMutation = { delete_commissions?: { returning: Array<{ id: string, type?: string | null, amount?: number | null, vat?: number | null, contact_id?: string | null, beneficiary_team_id?: string | null, property_transaction_id?: string | null }> } | null, insert_commissions?: { returning: Array<{ id: string, type?: string | null, amount?: number | null, vat?: number | null, contact_id?: string | null, beneficiary_team_id?: string | null, property_transaction_id?: string | null }> } | null };

export type CreateTransactionMutationVariables = Exact<{
  transaction: Property_Transactions_Insert_Input;
}>;


export type CreateTransactionMutation = { insert_property_transactions_one?: { id: string, created_by?: string | null, created_at?: any | null, signature_date?: any | null, buyer_broker_id?: string | null, seller_broker_id?: string | null, buyer_broker_team_id?: string | null, seller_broker_team_id?: string | null, estimated_signature_date?: any | null, payment_date?: any | null, purchase_price?: number | null, is_published: boolean, lot_id?: string | null, seller_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, buyer_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, buyer_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, seller_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, property: { id: string }, buyers: Array<{ user_id?: string | null, transaction_id?: string | null }>, sellers: Array<{ user_id?: string | null, transaction_id?: string | null }>, lot?: { id: string, currency?: string | null, property: { id: string, country_code?: string | null } } | null } | null };

export type GetUserDefaultTeamIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserDefaultTeamIdQuery = { users_by_pk?: { default_team_id?: string | null } | null };

export type GetTransactionDocumentsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetTransactionDocumentsQuery = { property_transactions_by_pk?: { id: string, property: { id: string, property_files: Array<{ property_id: string, file_id: string, is_visible: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, label?: string | null } | null } }> } } | null };

export type GetTransactionPropertyQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetTransactionPropertyQuery = { property_transactions_by_pk?: { id: string, purchase_price?: number | null, signature_date?: any | null, seller_broker?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, listings_agency_names?: Array<string> | null } | null, property_transactions_listings: Array<{ listing_id: number }>, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, living_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, property_type?: { name?: string | null, id: string, label?: string | null } | null, locality_place?: { id: string } | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null };

export type DeletePropertyTransactionListingMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  listingId: Scalars['Int']['input'];
}>;


export type DeletePropertyTransactionListingMutation = { delete_property_transactions_listings?: { affected_rows: number, returning: Array<{ property_transaction_id: string, listing_id: number }> } | null };

export type GetLinkedListingsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  ch: Scalars['Boolean']['input'];
  es: Scalars['Boolean']['input'];
  fr: Scalars['Boolean']['input'];
  it: Scalars['Boolean']['input'];
}>;


export type GetLinkedListingsQuery = { ch_cma_listings?: Array<{ id: number, number_of_rooms?: number | null, number_of_bathrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, address?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, visit_contact_person?: string | null, agency_contact_person?: string | null, agency_name?: string | null, property_type: string, valid_from: any, places?: Array<{ id: string, label?: string | null }> | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, fr_cma_listings?: Array<{ id: number, number_of_rooms?: number | null, number_of_bathrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, address?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, visit_contact_person?: string | null, agency_contact_person?: string | null, agency_name?: string | null, property_type: string, valid_from: any, places?: Array<{ id: string, label?: string | null }> | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, es_cma_listings?: Array<{ id: number, number_of_rooms?: number | null, number_of_bathrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, address?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, visit_contact_person?: string | null, agency_contact_person?: string | null, agency_name?: string | null, property_type: string, valid_from: any, places?: Array<{ id: string, label?: string | null }> | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, it_cma_listings?: Array<{ id: number, number_of_rooms?: number | null, number_of_bathrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, address?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, visit_contact_person?: string | null, agency_contact_person?: string | null, agency_name?: string | null, property_type: string, valid_from: any, places?: Array<{ id: string, label?: string | null }> | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }> };

export type InsertPropertyTransactionListingsMutationVariables = Exact<{
  objects: Array<Property_Transactions_Listings_Insert_Input> | Property_Transactions_Listings_Insert_Input;
}>;


export type InsertPropertyTransactionListingsMutation = { insert_property_transactions_listings?: { returning: Array<{ property_transaction_id: string, listing_id: number, property_transaction: { id: string, property_transactions_listings: Array<{ property_transaction_id: string, listing_id: number }> } }> } | null };

export type RestoreUserMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RestoreUserMutation = { update_users_by_pk?: { id: string, is_deleted?: boolean | null } | null };

export type GetCatchmentAreaQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetCatchmentAreaQuery = { users_by_pk?: { catchment_areas: Array<{ place: { id: string, postcode?: string | null, population?: number | null, lat: number, lng: number } }> } | null };

export type SetCatchmentAreaMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  objects: Array<Catchment_Areas_Insert_Input> | Catchment_Areas_Insert_Input;
}>;


export type SetCatchmentAreaMutation = { delete_catchment_areas?: { affected_rows: number } | null, insert_catchment_areas?: { affected_rows: number } | null };

export type GetUserReviewsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetUserReviewsQuery = { users_by_pk?: { id: string, reviews: Array<{ id: string, rating?: number | null, completed_at?: any | null, is_seller: boolean, is_buyer: boolean, review_text?: string | null, first_name?: string | null, last_name?: string | null, transaction_date: any, formatted_address: string }>, reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null } } | null };

export type DeleteUserReviewMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteUserReviewMutation = { delete_reviews_by_pk?: { id: string } | null };

export type UpdateUserReviewMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  review_text: Scalars['String']['input'];
}>;


export type UpdateUserReviewMutation = { update_reviews_by_pk?: { id: string, review_text?: string | null } | null };

export type GetUsersListQueryVariables = Exact<{
  where: Users_Bool_Exp;
  order_by: Array<Users_Order_By> | Users_Order_By;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetUsersListQuery = { users: Array<{ id: string, created_at: any, first_name?: string | null, last_name?: string | null, is_admin: boolean, is_broker: boolean, user_images: Array<{ id: string, image: { url?: string | null } }>, emails: Array<{ primary: boolean, email: string }>, phone_numbers: Array<{ primary?: boolean | null, number: string }> }> };

export type GetUsersListCountQueryVariables = Exact<{
  where: Users_Bool_Exp;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUsersListCountQuery = { users_aggregate: { aggregate?: { count: number } | null } };

export type UserFeedQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
}>;


export type UserFeedQuery = { users_by_pk?: { leads: Array<{ id: string, activities: Array<{ id: string, lead_id?: string | null, user_id?: string | null, created_at: any, created_by?: string | null, done: boolean, due_at?: any | null, done_at?: any | null, consolidated_done_at?: any | null, activity_type: Activity_Types_Enum_Enum, subject?: string | null, note?: string | null, success: boolean, email_message?: { from: any, to: any, cc: any, bcc: any, unread?: boolean | null, snippet?: string | null, subject?: string | null, nylas_thread_id?: string | null } | null, creator?: { id: string, full_name?: string | null } | null, assignee?: { id: string, full_name?: string | null } | null, lead?: { id: string, created_by?: string | null, source: { id: string, name: string } } | null }> }> } | null };

export type GetUserQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  includeSubscriptions: Scalars['Boolean']['input'];
}>;


export type GetUserQuery = { users_by_pk?: { id: string, is_broker: boolean, is_admin: boolean, is_deleted?: boolean | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, subscriptions?: Array<{ id: string, total_amount: number, status: any, created?: any | null, current_period_start: any, current_period_end: any, invoices: Array<{ id: string, stripe_id: string, created?: any | null, status: any, period_start?: any | null, period_end?: any | null, amount_due?: number | null, amount_paid?: number | null, lines?: any | null }>, invoices_aggregate: { aggregate?: { sum?: { amount_paid?: number | null } | null } | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string }> } | null };

export type AgentFeedQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
}>;


export type AgentFeedQuery = { activities: Array<{ id: string, lead_id?: string | null, user_id?: string | null, created_at: any, created_by?: string | null, done: boolean, due_at?: any | null, done_at?: any | null, consolidated_done_at?: any | null, activity_type: Activity_Types_Enum_Enum, subject?: string | null, note?: string | null, success: boolean, email_message?: { from: any, to: any, cc: any, bcc: any, unread?: boolean | null, snippet?: string | null, subject?: string | null, nylas_thread_id?: string | null } | null, creator?: { id: string, full_name?: string | null } | null, assignee?: { id: string, full_name?: string | null } | null, lead?: { id: string, created_by?: string | null, source: { id: string, name: string } } | null }> };

export type UserSettingsFragmentFragment = { id: string, created_at: any, created_by?: string | null, first_name?: string | null, last_name?: string | null, is_broker: boolean, has_free_crm_access: boolean, agent_slug?: string | null, show_in_agency_pages?: boolean | null, linked_in_profile?: string | null, instagram_profile?: string | null, youtube_profile?: string | null, twitter_profile?: string | null, facebook_profile?: string | null, description?: string | null, services?: Array<string> | null, certifications?: Array<string> | null, languages?: Array<string> | null, active_since?: number | null, hires_on_realadvisor?: number | null };

export type GetUserSettingsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserSettingsQuery = { users_by_pk?: { id: string, created_at: any, created_by?: string | null, first_name?: string | null, last_name?: string | null, is_broker: boolean, has_free_crm_access: boolean, agent_slug?: string | null, show_in_agency_pages?: boolean | null, linked_in_profile?: string | null, instagram_profile?: string | null, youtube_profile?: string | null, twitter_profile?: string | null, facebook_profile?: string | null, description?: string | null, services?: Array<string> | null, certifications?: Array<string> | null, languages?: Array<string> | null, active_since?: number | null, hires_on_realadvisor?: number | null } | null };

export type UpdateUserSettingsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  user: Users_Set_Input;
}>;


export type UpdateUserSettingsMutation = { update_users_by_pk?: { id: string, created_at: any, created_by?: string | null, first_name?: string | null, last_name?: string | null, is_broker: boolean, has_free_crm_access: boolean, agent_slug?: string | null, show_in_agency_pages?: boolean | null, linked_in_profile?: string | null, instagram_profile?: string | null, youtube_profile?: string | null, twitter_profile?: string | null, facebook_profile?: string | null, description?: string | null, services?: Array<string> | null, certifications?: Array<string> | null, languages?: Array<string> | null, active_since?: number | null, hires_on_realadvisor?: number | null } | null };

export type DeleteUserImageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteUserImageMutation = { delete_user_images_by_pk?: { image_id: string } | null };

export type SetUserProfileImageMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  user_images_id: Scalars['uuid']['input'];
}>;


export type SetUserProfileImageMutation = { update_user_images?: { affected_rows: number } | null, update_user_images_by_pk?: { id: string, user: { user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null };

export type InsertUsersMutationVariables = Exact<{
  users: Array<Users_Insert_Input> | Users_Insert_Input;
}>;


export type InsertUsersMutation = { insert_users?: { affected_rows: number } | null };

export type DeleteUsersMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteUsersMutation = { delete_users?: { affected_rows: number } | null };

export type ExportUsersQueryVariables = Exact<{
  where: Users_Bool_Exp;
}>;


export type ExportUsersQuery = { users: Array<{ id: string, first_name?: string | null, last_name?: string | null, created_at: any, emails: Array<{ email: string }>, phone_numbers: Array<{ number: string }> }> };

export type DashboardGetOverviewQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  team_id: Scalars['uuid']['input'];
}>;


export type DashboardGetOverviewQuery = { me?: { id: string, agent_slug?: string | null, account_manager?: { full_name?: string | null, user_images: Array<{ image: { id: string, url?: string | null } }>, phone_numbers: Array<{ number: string }> } | null } | null, teams_by_pk?: { id: string, created_at: any, name: string, agency_slug?: string | null, show_in_agency_pages?: boolean | null, cover_photo?: { id: string, url?: string | null } | null, logo?: { id: string, url?: string | null } | null, teams_users: Array<{ created_at: any, is_leader: boolean, title?: string | null, deactivated: boolean, order_nr: number, user: { id: string, is_broker: boolean, is_admin: boolean, first_name?: string | null, last_name?: string | null, full_name?: string | null, broker_leads_aggregate: { aggregate?: { count: number } | null }, lots_aggregate: { aggregate?: { count: number } | null }, property_transactions_aggregate: { aggregate?: { sum?: { purchase_price?: number | null } | null } | null }, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> } | null };

export type DashboardVisibilityStatsQueryVariables = Exact<{
  teamId?: InputMaybe<Scalars['uuid']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  hostname?: InputMaybe<Scalars['String']['input']>;
}>;


export type DashboardVisibilityStatsQuery = { impressions_data?: { data?: Array<{ name?: string | null, count?: number | null, user_count?: number | null, average_position?: number | null }> | null } | null, views_data?: { data?: Array<{ name?: string | null, count?: number | null, user_count?: number | null }> | null } | null };

export type GetVisibilityInboxQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetVisibilityInboxQuery = { lead_agents: Array<{ id: string, created_at: any, lead: { appraisal_reason: Leads_Appraisal_Reason_Enum, contact?: { full_name?: string | null, id: string, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null }, user: { full_name?: string | null, id: string, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, enquiries: Array<{ id: string, created_at: any, updated_at: any, first_name?: string | null, last_name?: string | null, phone_number?: string | null, email_address?: string | null, contact_reason?: string | null, message?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, broker?: { full_name?: string | null } | null, team?: { name: string } | null }> };

export type GetInboxMessageQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetInboxMessageQuery = { lead_agents_by_pk?: { id: string, created_at: any, lead: { appraisal_reason: Leads_Appraisal_Reason_Enum, contact?: { full_name?: string | null, phone_numbers: Array<{ number: string }>, emails: Array<{ email: string }> } | null, property?: { country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, living_surface?: number | null, built_surface?: number | null, number_of_rooms?: number | null, property_type?: { label?: string | null } | null, latest_appraisal?: { min?: number | null, max?: number | null } | null } | null }, user: { full_name?: string | null, default_team?: { name: string } | null } } | null, enquiries_by_pk?: { id: string, created_at: any, updated_at: any, first_name?: string | null, last_name?: string | null, phone_number?: string | null, email_address?: string | null, contact_reason?: string | null, message?: string | null, user?: { full_name?: string | null } | null, broker?: { full_name?: string | null } | null, team?: { name: string } | null, property_transaction?: { property: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, living_surface?: number | null, number_of_rooms?: number | null } } | null } | null };

export type VisibilityReviewFragment = { id: string, completed_at?: any | null, rating?: number | null, review_text?: string | null, first_name?: string | null, last_name?: string | null, email_address: string, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null };

export type GetUserSlugQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserSlugQuery = { users_by_pk?: { id: string, agent_slug?: string | null } | null };

export type GetFirstUserOfTeamQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type GetFirstUserOfTeamQuery = { teams_users: Array<{ user_id: string }> };

export type GetVisibilityReviewsAggregateQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type GetVisibilityReviewsAggregateQuery = { teams_by_pk?: { id: string, teams_users: Array<{ user: { id: string, reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null } } }> } | null };

export type GetVisibilityReviewsQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<Reviews_Order_By> | Reviews_Order_By>;
}>;


export type GetVisibilityReviewsQuery = { reviews: Array<{ id: string, completed_at?: any | null, rating?: number | null, review_text?: string | null, first_name?: string | null, last_name?: string | null, email_address: string, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null }> };

export type GetVisibilityReviewsRowCountQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type GetVisibilityReviewsRowCountQuery = { reviews_aggregate: { aggregate?: { count: number } | null } };

export type GetTeamVisibilityStatsGraphQueryVariables = Exact<{
  teamId?: InputMaybe<Scalars['uuid']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<ImpressionsGroupingColumn>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  hostname?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTeamVisibilityStatsGraphQuery = { impressions_graph_data?: { data?: Array<{ name?: string | null, count?: number | null }> | null } | null, views_graph_data?: { data?: Array<{ name?: string | null, count?: number | null, user_count?: number | null }> | null } | null, average_position?: { data?: Array<{ name?: string | null, average_position?: number | null, count?: number | null }> | null } | null, show_phone_number_data?: { data?: Array<{ name?: string | null, count?: number | null, user_count?: number | null }> | null } | null, me?: { is_admin: boolean } | null };

export type GetTeamVisibilityStatsListQueryVariables = Exact<{
  teamId?: InputMaybe<Scalars['uuid']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<ImpressionsGroupingColumn>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  hostname?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTeamVisibilityStatsListQuery = { list_data?: { data?: Array<{ name?: string | null, count?: number | null, user_count?: number | null, average_position?: number | null }> | null } | null, me?: { is_admin: boolean } | null };

export type GetVisibilityTeamMembersQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  twoYearsAgo: Scalars['timestamptz']['input'];
}>;


export type GetVisibilityTeamMembersQuery = { teams_by_pk?: { id: string, name: string, teams_users: Array<{ user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ image: { id: string, url?: string | null } }>, reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null }, property_transactions_aggregate: { aggregate?: { count: number } | null }, last_2_years_property_transactions_aggregate: { aggregate?: { count: number } | null } } }> } | null };

export type GetTeamMemberDetailsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  teamId: Scalars['uuid']['input'];
  twoYearsAgo: Scalars['timestamptz']['input'];
}>;


export type GetTeamMemberDetailsQuery = { users_by_pk?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, agent_slug?: string | null, show_in_agency_pages?: boolean | null, default_team_id?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, teams_users: Array<{ is_leader: boolean, title?: string | null, deactivated: boolean, team: { id: string, name: string, cover_photo?: { id: string, url?: string | null } | null } }>, all_reviews_count: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null }, verified_reviews_count: { aggregate?: { count: number } | null }, average_rating: { aggregate?: { avg?: { rating?: number | null } | null } | null }, latest_review: Array<{ completed_at?: any | null }> } | null, last_transaction: Array<{ signature_date?: any | null }>, all_transactions_count: { aggregate?: { count: number } | null }, last_2_years_transactions: Array<{ purchase_price?: number | null }>, teams: Array<{ id: string, name: string }> };

export type CreateTeamInvitationMutationVariables = Exact<{
  invitation: Invitations_Insert_Input;
}>;


export type CreateTeamInvitationMutation = { insert_invitations_one?: { id: string } | null };

export type CheckExistingTeamMemberQueryVariables = Exact<{
  email: Scalars['citext']['input'];
  teamId: Scalars['uuid']['input'];
  tenantId: Scalars['uuid']['input'];
}>;


export type CheckExistingTeamMemberQuery = { users: Array<{ id: string, first_name?: string | null, last_name?: string | null }> };

export type CheckExistingInvitationQueryVariables = Exact<{
  email: Scalars['citext']['input'];
  teamId: Scalars['uuid']['input'];
  tenantId: Scalars['uuid']['input'];
}>;


export type CheckExistingInvitationQuery = { invitations_aggregate: { aggregate?: { count: number } | null } };

export type CancelExistingInvitationsMutationVariables = Exact<{
  email: Scalars['citext']['input'];
  teamId: Scalars['uuid']['input'];
  tenantId: Scalars['uuid']['input'];
}>;


export type CancelExistingInvitationsMutation = { update_invitations?: { affected_rows: number } | null };

export type GetVisibilityTransactionsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  startDate: Scalars['timestamptz']['input'];
  endDate: Scalars['timestamptz']['input'];
}>;


export type GetVisibilityTransactionsQuery = { teams: Array<{ id: string, name: string }>, property_transactions: Array<{ id: string, signature_date?: any | null, property: { number_of_rooms?: number | null, living_surface?: number | null, id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_type?: { label?: string | null } | null, property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> }, seller_broker_team?: { id: string, name: string } | null, seller_broker?: { id: string, full_name?: string | null } | null, reviews: Array<{ id: string, is_buyer: boolean }> }>, teams_by_pk?: { id: string, created_at: any, name: string, cover_photo?: { id: string, url?: string | null } | null, logo?: { id: string, url?: string | null } | null, teams_users: Array<{ created_at: any, is_leader: boolean, title?: string | null, deactivated: boolean, order_nr: number, user: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, last_2_years_property_transactions_aggregate: { aggregate?: { count: number } | null }, property_transactions_aggregate: { aggregate?: { count: number } | null }, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> } | null, team_transactions: { aggregate?: { count: number } | null } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { get_me: { user_ids_in_led_teams?: Array<string> | null, show_plans: string, me?: { id: string, is_admin: boolean, is_broker: boolean, language?: any | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, has_used_trial_button: boolean, has_free_crm_access: boolean, auto_assign_leads?: boolean | null, can_user_login_as: boolean, can_edit_settings?: boolean | null, modules?: Array<string> | null, show_in_agency_pages?: boolean | null, tenant_id: string, intercom_hash?: string | null, default_team?: { id: string, name: string, lng?: number | null, lat?: number | null, show_in_agency_pages?: boolean | null } | null, teams_users: Array<{ team_id: string }>, emails: Array<{ id: string, email: string, primary: boolean, verified: boolean }>, tenant: { slug: string, resources_en?: string | null, resources_fr?: string | null, resources_de?: string | null, resources_es?: string | null, resources_it?: string | null, id: string, name: string, country_code: string, lng?: number | null, lat?: number | null, help_link_en?: string | null, help_link_fr?: string | null, help_link_de?: string | null, help_link_it?: string | null, help_link_es?: string | null, image?: { url?: string | null } | null }, subscriptions: Array<{ status: any, customer: string }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, teams: Array<{ is_leader: boolean, team_id: string, team: { id: string, name: string, organisation_id?: string | null } }>, nylas_account: Array<{ id: string, invalid: boolean }> } | null } };

export type EmailUserFragment = { id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null };

export type EmailPropertyFragment = { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null };

export type EmailListingFragment = { title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null };

export type PrepareUploadMutationVariables = Exact<{
  id: Scalars['String']['input'];
  file_type: Scalars['String']['input'];
  file_name: Scalars['String']['input'];
  mime_type: Scalars['String']['input'];
}>;


export type PrepareUploadMutation = { prepare_upload?: { id: string, url: string, signed_url: string } | null };

export type SearchTeamsQueryVariables = Exact<{
  q: Scalars['String']['input'];
}>;


export type SearchTeamsQuery = { search_teams_tsv: Array<{ id: string, name: string, logo?: { id: string, url?: string | null } | null, team_images: Array<{ image: { url?: string | null } }>, emails: Array<{ email: string }> }> };

export type NoAccessQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type NoAccessQuery = { users: Array<{ display_name?: string | null, phone_numbers: Array<{ number: string }>, emails: Array<{ email: string }> }> };

export type GetTenantBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetTenantBySlugQuery = { tenants: Array<{ id: string }> };

export type UserInputFragment = { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, branding_color?: string | null, branding_logo?: string | null, branding_name?: string | null, branding_website?: string | null, primaryEmail: Array<{ email: string }>, default_team?: { organisation?: { name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, subscriptions: Array<{ status: any }>, primaryImage: Array<{ image: { url?: string | null } }> };

export type UserInputSearchUsersQueryVariables = Exact<{
  q: Scalars['String']['input'];
  where?: InputMaybe<Users_Bool_Exp>;
}>;


export type UserInputSearchUsersQuery = { search_users_tsv: Array<{ id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, branding_color?: string | null, branding_logo?: string | null, branding_name?: string | null, branding_website?: string | null, primaryEmail: Array<{ email: string }>, default_team?: { organisation?: { name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, subscriptions: Array<{ status: any }>, primaryImage: Array<{ image: { url?: string | null } }> }> };

export type UserInputDefaultTeamsUsersQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UserInputDefaultTeamsUsersQuery = { users_by_pk?: { default_team?: { teams_users: Array<{ user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, branding_color?: string | null, branding_logo?: string | null, branding_name?: string | null, branding_website?: string | null, primaryEmail: Array<{ email: string }>, default_team?: { organisation?: { name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, subscriptions: Array<{ status: any }>, primaryImage: Array<{ image: { url?: string | null } }> } }> } | null } | null };

export const EmailListingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}}]} as unknown as DocumentNode<EmailListingFragment, unknown>;
export const OrganisationAddressFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]} as unknown as DocumentNode<OrganisationAddressFragment, unknown>;
export const EmailUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]} as unknown as DocumentNode<EmailUserFragment, unknown>;
export const EmailPropertyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<EmailPropertyFragment, unknown>;
export const EmailTemplateFormListingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<EmailTemplateFormListingFragment, unknown>;
export const EmailTemplateFormEnquiryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormEnquiry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EmailTemplateFormEnquiryFragment, unknown>;
export const EmailTemplateFormBuyerLeadFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormBuyerLead"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EmailTemplateFormBuyerLeadFragment, unknown>;
export const EmailTemplateFormLeadFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormLead"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<EmailTemplateFormLeadFragment, unknown>;
export const EmailTemplateSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"subject_plaintext"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}}]} as unknown as DocumentNode<EmailTemplateSelectFragment, unknown>;
export const LeadSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]} as unknown as DocumentNode<LeadSelectFragment, unknown>;
export const LotCardCarousel_LotFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotCardCarousel_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}}]}}]}}]} as unknown as DocumentNode<LotCardCarousel_LotFragment, unknown>;
export const ListingPriceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}}]} as unknown as DocumentNode<ListingPriceFragment, unknown>;
export const LightLotCardInfo_LotFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}}]} as unknown as DocumentNode<LightLotCardInfo_LotFragment, unknown>;
export const LotCardInfo_LotFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"matching_buyer_leads"},"name":{"kind":"Name","value":"buyer_leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"matched","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"offers_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}}]} as unknown as DocumentNode<LotCardInfo_LotFragment, unknown>;
export const LotSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]} as unknown as DocumentNode<LotSelectFragment, unknown>;
export const PhoneNumberCard_Phone_NumberFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]} as unknown as DocumentNode<PhoneNumberCard_Phone_NumberFragment, unknown>;
export const FileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<FileFragment, unknown>;
export const PropertyFileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<PropertyFileFragment, unknown>;
export const TemplateSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TemplateSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<TemplateSelectFragment, unknown>;
export const TransactionCellFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TransactionCellFragment, unknown>;
export const TransactionSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCell"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TransactionSelectFragment, unknown>;
export const UserAvatarFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<UserAvatarFragment, unknown>;
export const UserCardDisplayNameFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]} as unknown as DocumentNode<UserCardDisplayNameFragment, unknown>;
export const UserCard_UserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]} as unknown as DocumentNode<UserCard_UserFragment, unknown>;
export const BuyerLeadDnDColumnFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDnDColumn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<BuyerLeadDnDColumnFragment, unknown>;
export const UserPhoneNumbersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]} as unknown as DocumentNode<UserPhoneNumbersFragment, unknown>;
export const UserEmailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserEmails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<UserEmailsFragment, unknown>;
export const ContactCardUserFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContactCardUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserEmails"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserEmails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<ContactCardUserFragmentFragment, unknown>;
export const ListingCreationAddressStepFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCreationAddressStepFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address_display_option"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dummy_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lat"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lng"}}]}}]} as unknown as DocumentNode<ListingCreationAddressStepFragmentFragment, unknown>;
export const ListingCell_ListingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCell_listing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","alias":{"kind":"Name","value":"single_property_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListingCell_ListingFragment, unknown>;
export const ListingPriceCellFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPriceCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}}]} as unknown as DocumentNode<ListingPriceCellFragment, unknown>;
export const OrganisationCell_OrganisationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationCell_organisation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<OrganisationCell_OrganisationFragment, unknown>;
export const UserInfo_EnquiryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_enquiry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}}]}}]} as unknown as DocumentNode<UserInfo_EnquiryFragment, unknown>;
export const DictionarySelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DictionarySelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<DictionarySelectFragment, unknown>;
export const ActivityFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"activityFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"unread"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"nylas_thread_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ActivityFieldsFragment, unknown>;
export const TeamFilterFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<TeamFilterFragment, unknown>;
export const UserFilterFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<UserFilterFragment, unknown>;
export const EmailTemplateFormFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}}]} as unknown as DocumentNode<EmailTemplateFormFragment, unknown>;
export const EmailSenderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}}]} as unknown as DocumentNode<EmailSenderFragment, unknown>;
export const ListingEnquiryResponseEmailFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingEnquiryResponseEmail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"response_sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"development"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_override_lot"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListingEnquiryResponseEmailFragment, unknown>;
export const MarketingFormDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketingFormData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"listing_url"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]} as unknown as DocumentNode<MarketingFormDataFragment, unknown>;
export const ChangeOfferStatusModalFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeOfferStatusModal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"offers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]}}]} as unknown as DocumentNode<ChangeOfferStatusModalFragment, unknown>;
export const UserChipFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]} as unknown as DocumentNode<UserChipFragment, unknown>;
export const ListingCardSnippetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCardSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<ListingCardSnippetFragment, unknown>;
export const OfferEditFormFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OfferEditForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"offers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCardSnippet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"offer_refused_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"made_on"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCardSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<OfferEditFormFragment, unknown>;
export const OrganisationSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}}]} as unknown as DocumentNode<OrganisationSelectFragment, unknown>;
export const SearchPlaceFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchPlaceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"places"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SearchPlaceFragmentFragment, unknown>;
export const TeamsSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamsSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<TeamsSelectFragment, unknown>;
export const ReadOnlyTenantSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReadOnlyTenantSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"read_only_tenants"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ReadOnlyTenantSelectFragment, unknown>;
export const UserInfo_UserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]} as unknown as DocumentNode<UserInfo_UserFragment, unknown>;
export const TeamInfo_TeamFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamInfo_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}}]} as unknown as DocumentNode<TeamInfo_TeamFragment, unknown>;
export const PropertyCell_PropertyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyCell_property"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<PropertyCell_PropertyFragment, unknown>;
export const TransactionsListRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionsListRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"payment_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyCell_property"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_paid"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"total","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"my_commissions"},"name":{"kind":"Name","value":"commissions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"split","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"beneficiary_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamInfo_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyCell_property"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<TransactionsListRowFragment, unknown>;
export const UserSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<UserSelectFragment, unknown>;
export const AppraisalDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppraisalDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"appraisals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"valuations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"valuation_model"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}}]}}]}}]}}]} as unknown as DocumentNode<AppraisalDetailsFragment, unknown>;
export const DictionaryItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DictionaryItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"is_deletable"}},{"kind":"Field","name":{"kind":"Name","value":"is_used"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"group_id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<DictionaryItemFragment, unknown>;
export const DocTemplateFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"filename_template"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}}]} as unknown as DocumentNode<DocTemplateFieldsFragment, unknown>;
export const EmailSequenceDrawer_MeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSequenceDrawer_me"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<EmailSequenceDrawer_MeFragment, unknown>;
export const StatusSwitch_IdFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StatusSwitch_id"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_sequences"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<StatusSwitch_IdFragment, unknown>;
export const MarketingCardLeadFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketingCardLeadFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}}]}}]} as unknown as DocumentNode<MarketingCardLeadFragmentFragment, unknown>;
export const CurrentLeadFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentLead"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CurrentLeadFragment, unknown>;
export const ActivityCellFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]} as unknown as DocumentNode<ActivityCellFragment, unknown>;
export const LeadAgentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadAgent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"passed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"win_probability"}},{"kind":"Field","name":{"kind":"Name","value":"predicted_win_date"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<LeadAgentFragment, unknown>;
export const AddressOverridesListingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_address"}},{"kind":"Field","name":{"kind":"Name","value":"address_display_option"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lat"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]} as unknown as DocumentNode<AddressOverridesListingFragment, unknown>;
export const AgentCard_UserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgentCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<AgentCard_UserFragment, unknown>;
export const ListedByOverridesListingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListedByOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_contact"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lat"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<ListedByOverridesListingFragment, unknown>;
export const ListingMandateCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMandateCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_fee"}},{"kind":"Field","name":{"kind":"Name","value":"is_exclusive"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"expected_time_to_sell"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]} as unknown as DocumentNode<ListingMandateCardFragment, unknown>;
export const MandateFormFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MandateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMandateCard"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_sales_tax_inclusive"}},{"kind":"Field","name":{"kind":"Name","value":"duration_in_months"}},{"kind":"Field","name":{"kind":"Name","value":"origin_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_success_fee"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_type"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_custom"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMandateCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_fee"}},{"kind":"Field","name":{"kind":"Name","value":"is_exclusive"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"expected_time_to_sell"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]} as unknown as DocumentNode<MandateFormFragment, unknown>;
export const ListingBuyerLeadsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingBuyerLeads"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"matching","block":false},{"kind":"StringValue","value":"manual","block":false}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<ListingBuyerLeadsFragment, unknown>;
export const ListingStatusSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingStatusSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<ListingStatusSelectFragment, unknown>;
export const PortalListingButtonFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalListingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}}]} as unknown as DocumentNode<PortalListingButtonFragment, unknown>;
export const ListingQuickActionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingQuickActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingStatusSelect"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalListingButton"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingStatusSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalListingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}}]} as unknown as DocumentNode<ListingQuickActionsFragment, unknown>;
export const LeadQualificationFunnelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadQualificationFunnel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_selling_with"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_market_time"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_monthly_gross_rent"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_separation_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_inheritance_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_term"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_buying_status"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_status"}},{"kind":"Field","name":{"kind":"Name","value":"received_mortgage_offer"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}}]} as unknown as DocumentNode<LeadQualificationFunnelFragment, unknown>;
export const LeadUpdatedTimeAgoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}}]} as unknown as DocumentNode<LeadUpdatedTimeAgoFragment, unknown>;
export const FiancingLeadDetailFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FiancingLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_property_value"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_is_construction"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_mortgage_type"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_report_type"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}}]}}]} as unknown as DocumentNode<FiancingLeadDetailFragment, unknown>;
export const LeadPropertyDetailFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadPropertyDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]} as unknown as DocumentNode<LeadPropertyDetailFragment, unknown>;
export const SalesLeadDetailFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalesLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_occupied"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_route"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_state"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadPropertyDetail"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadQualificationFunnel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_selling_with"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_market_time"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_monthly_gross_rent"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_separation_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_inheritance_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_term"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_buying_status"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_status"}},{"kind":"Field","name":{"kind":"Name","value":"received_mortgage_offer"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadPropertyDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]} as unknown as DocumentNode<SalesLeadDetailFragment, unknown>;
export const LeadCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FiancingLeadDetail"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesLeadDetail"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadQualificationFunnel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_selling_with"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_market_time"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_monthly_gross_rent"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_separation_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_inheritance_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_term"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_buying_status"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_status"}},{"kind":"Field","name":{"kind":"Name","value":"received_mortgage_offer"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadPropertyDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FiancingLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_property_value"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_is_construction"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_mortgage_type"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_report_type"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalesLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_occupied"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_route"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_state"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadPropertyDetail"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}}]}}]}}]} as unknown as DocumentNode<LeadCardFragment, unknown>;
export const PropertyPoiFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}}]} as unknown as DocumentNode<PropertyPoiFragment, unknown>;
export const PropertyFeaturesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}}]} as unknown as DocumentNode<PropertyFeaturesFragment, unknown>;
export const PropertyDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]} as unknown as DocumentNode<PropertyDetailsFragment, unknown>;
export const PropertyFormDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}}]} as unknown as DocumentNode<PropertyFormDetailsFragment, unknown>;
export const PropertyFormPricingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}}]} as unknown as DocumentNode<PropertyFormPricingFragment, unknown>;
export const PropertyAddressFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]} as unknown as DocumentNode<PropertyAddressFragment, unknown>;
export const PropertyFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormPricing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAddress"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]} as unknown as DocumentNode<PropertyFragmentFragment, unknown>;
export const ListingOverviewPropertyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFragment"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormPricing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAddress"}}]}}]} as unknown as DocumentNode<ListingOverviewPropertyFragment, unknown>;
export const ListingMapFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMap"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]} as unknown as DocumentNode<ListingMapFragment, unknown>;
export const ListingOverviewFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_net_seller_price"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"available_from"}},{"kind":"Field","name":{"kind":"Name","value":"virtual_visit_url"}},{"kind":"Field","name":{"kind":"Name","value":"video_url"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressOverridesListing"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price_type"}},{"kind":"Field","name":{"kind":"Name","value":"indoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"outdoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_included_in_total"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgentCard_user"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListedByOverridesListing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MandateForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingBuyerLeads"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingQuickActions"}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverviewProperty"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMap"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMandateCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_fee"}},{"kind":"Field","name":{"kind":"Name","value":"is_exclusive"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"expected_time_to_sell"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingStatusSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalListingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadQualificationFunnel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_selling_with"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_market_time"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_monthly_gross_rent"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_separation_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_inheritance_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_term"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_buying_status"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_status"}},{"kind":"Field","name":{"kind":"Name","value":"received_mortgage_offer"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FiancingLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_property_value"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_is_construction"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_mortgage_type"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_report_type"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadPropertyDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalesLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_occupied"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_route"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_state"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadPropertyDetail"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormPricing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAddress"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_address"}},{"kind":"Field","name":{"kind":"Name","value":"address_display_option"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lat"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgentCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListedByOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_contact"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lat"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MandateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMandateCard"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_sales_tax_inclusive"}},{"kind":"Field","name":{"kind":"Name","value":"duration_in_months"}},{"kind":"Field","name":{"kind":"Name","value":"origin_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_success_fee"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_type"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_custom"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingBuyerLeads"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"matching","block":false},{"kind":"StringValue","value":"manual","block":false}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingQuickActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingStatusSelect"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalListingButton"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FiancingLeadDetail"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesLeadDetail"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFragment"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMap"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]} as unknown as DocumentNode<ListingOverviewFragment, unknown>;
export const ListingsDetailedViewFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingsDetailedView"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}}]}}]}}]} as unknown as DocumentNode<ListingsDetailedViewFragment, unknown>;
export const CurrentListingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}}]}}]} as unknown as DocumentNode<CurrentListingFragment, unknown>;
export const PortalLogoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<PortalLogoFragment, unknown>;
export const PortalFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"contract_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"exact_address_required"}},{"kind":"Field","name":{"kind":"Name","value":"exclude_from_published_stats"}},{"kind":"Field","name":{"kind":"Name","value":"has_top_premium_listing"}},{"kind":"Field","name":{"kind":"Name","value":"idx_protocol"}},{"kind":"Field","name":{"kind":"Name","value":"master_portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalLogo"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<PortalFragmentFragment, unknown>;
export const BrochureReportIncludeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrochureReportInclude"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brochure_include_cover"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_property"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_description"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_photos"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_append_files"}}]}}]} as unknown as DocumentNode<BrochureReportIncludeFragment, unknown>;
export const StepCoverPhotoBrochureFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepCoverPhotoBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"use_custom_brochure_title"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"address_display_option_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_show_agent_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_cover_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_brochure"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StepCoverPhotoBrochureFragment, unknown>;
export const StepDescriptionBrochureFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepDescriptionBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description"}},{"kind":"Field","name":{"kind":"Name","value":"use_custom_brochure_description"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_layout"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<StepDescriptionBrochureFragment, unknown>;
export const StepPropertyDetailsBrochureFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPropertyDetailsBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<StepPropertyDetailsBrochureFragment, unknown>;
export const StepPhotosBrochureFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPhotosBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_brochure"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StepPhotosBrochureFragment, unknown>;
export const StepSettingsBrochureFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepSettingsBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_font_family"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<StepSettingsBrochureFragment, unknown>;
export const StepSettingsCmaFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepSettingsCma"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"font_family"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<StepSettingsCmaFragment, unknown>;
export const StepCoverPhotoCmaFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepCoverPhotoCma"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"report_title"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cover_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_brochure"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<StepCoverPhotoCmaFragment, unknown>;
export const StepHedonisticValuationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepHedonisticValuation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"include_hedonistic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appraisals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StepHedonisticValuationFragment, unknown>;
export const StepDescriptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"include_description"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<StepDescriptionFragment, unknown>;
export const CmaReportFileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaReportFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_report_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<CmaReportFileFragment, unknown>;
export const CmaPropertyFileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaPropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<CmaPropertyFileFragment, unknown>;
export const StepAppendFilesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepAppendFiles"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaReportFile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaPropertyFile"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaReportFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_report_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaPropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<StepAppendFilesFragment, unknown>;
export const CmaReportEditorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CMAReportEditor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"filename_template"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}}]}}]} as unknown as DocumentNode<CmaReportEditorFragment, unknown>;
export const StepIntroductionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepIntroduction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"introduction"}}]}}]} as unknown as DocumentNode<StepIntroductionFragment, unknown>;
export const StepPropertyDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]} as unknown as DocumentNode<StepPropertyDetailsFragment, unknown>;
export const StepFinalFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepFinal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"positive_comments"}},{"kind":"Field","name":{"kind":"Name","value":"negative_comments"}},{"kind":"Field","name":{"kind":"Name","value":"suggested_market_value"}},{"kind":"Field","name":{"kind":"Name","value":"is_price_range"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_min"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_max"}},{"kind":"Field","name":{"kind":"Name","value":"show_probability"}},{"kind":"Field","name":{"kind":"Name","value":"probability_min"}},{"kind":"Field","name":{"kind":"Name","value":"probability_max"}},{"kind":"Field","name":{"kind":"Name","value":"probability_time_period"}}]}}]} as unknown as DocumentNode<StepFinalFragment, unknown>;
export const StepPotentialBuyersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPotentialBuyers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"max_budget"}},{"kind":"Field","name":{"kind":"Name","value":"min_budget"}},{"kind":"Field","name":{"kind":"Name","value":"include_potential_buyers"}},{"kind":"Field","name":{"kind":"Name","value":"suggested_market_value"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StepPotentialBuyersFragment, unknown>;
export const StepPoisFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPois"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_pois"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance_meters"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_meters"}},{"kind":"Field","name":{"kind":"Name","value":"walking_distance_meters"}},{"kind":"Field","name":{"kind":"Name","value":"cycling_distance_meters"}},{"kind":"Field","name":{"kind":"Name","value":"walking_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"cycling_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"poi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"primary_type"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]}}]} as unknown as DocumentNode<StepPoisFragment, unknown>;
export const StepListingsCompareFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepListingsCompare"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_comparables_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"comparable_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates_db__merged_listings_clusters_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<StepListingsCompareFragment, unknown>;
export const CmaReportIncludeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaReportInclude"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_cover"}},{"kind":"Field","name":{"kind":"Name","value":"include_introduction"}},{"kind":"Field","name":{"kind":"Name","value":"include_property"}},{"kind":"Field","name":{"kind":"Name","value":"include_description"}},{"kind":"Field","name":{"kind":"Name","value":"include_photos"}},{"kind":"Field","name":{"kind":"Name","value":"include_pois"}},{"kind":"Field","name":{"kind":"Name","value":"include_hedonistic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_comparables_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_cuprate_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_intrinsic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_final_value"}},{"kind":"Field","name":{"kind":"Name","value":"include_potential_buyers"}},{"kind":"Field","name":{"kind":"Name","value":"include_agent"}},{"kind":"Field","name":{"kind":"Name","value":"include_agent_agency"}},{"kind":"Field","name":{"kind":"Name","value":"include_client_testimonial"}},{"kind":"Field","name":{"kind":"Name","value":"include_append_files"}}]}}]} as unknown as DocumentNode<CmaReportIncludeFragment, unknown>;
export const StepCapRateValuationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepCapRateValuation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"caprate_estimated_monthly_rent"}},{"kind":"Field","name":{"kind":"Name","value":"caprate_minimum_required_yield"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rent_value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StepCapRateValuationFragment, unknown>;
export const StepIntrinsicValuationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepIntrinsicValuation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"construction_cost_base"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_building_surface"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_construction_cost"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_annual_deprecation_rate"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_land_value"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_custom_fields"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}}]}}]}}]}}]} as unknown as DocumentNode<StepIntrinsicValuationFragment, unknown>;
export const TransactionCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<TransactionCardFragment, unknown>;
export const ReviewDrawerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReviewDrawer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"reviews"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_buyer"}},{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_date"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCard"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReviewDrawerFragment, unknown>;
export const LeadStageFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadStageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_stages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline_id"}}]}}]} as unknown as DocumentNode<LeadStageFieldsFragment, unknown>;
export const PipelineFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PipelineFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pipelines"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}}]}}]} as unknown as DocumentNode<PipelineFragmentFragment, unknown>;
export const TenantSettingsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TenantSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tenants"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_description"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_id"}},{"kind":"Field","name":{"kind":"Name","value":"default_pipeline_id"}}]}}]} as unknown as DocumentNode<TenantSettingsFragmentFragment, unknown>;
export const InvoiceFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoiceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"invoices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"period_start"}},{"kind":"Field","name":{"kind":"Name","value":"period_end"}},{"kind":"Field","name":{"kind":"Name","value":"amount_due"}},{"kind":"Field","name":{"kind":"Name","value":"amount_paid"}},{"kind":"Field","name":{"kind":"Name","value":"lines"}}]}}]} as unknown as DocumentNode<InvoiceFragmentFragment, unknown>;
export const TeamCombinedReviewsAggFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamCombinedReviewsAgg"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"combined_reviews_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<TeamCombinedReviewsAggFragment, unknown>;
export const TeamAddress_LightFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamAddress_light"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}}]} as unknown as DocumentNode<TeamAddress_LightFragment, unknown>;
export const TeamAddressFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]} as unknown as DocumentNode<TeamAddressFragment, unknown>;
export const TeamSettingsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"do_follow_link"}},{"kind":"Field","name":{"kind":"Name","value":"legal_name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_slug"}},{"kind":"Field","name":{"kind":"Name","value":"idx_agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"idx_ftp_client_id"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"hide_exact_address"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamAddress"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_id"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_description"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_url"}},{"kind":"Field","name":{"kind":"Name","value":"instagram_url"}},{"kind":"Field","name":{"kind":"Name","value":"youtube_url"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin_url"}},{"kind":"Field","name":{"kind":"Name","value":"twitter_url"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_email_contact"}},{"kind":"Field","name":{"kind":"Name","value":"use_json_for_enquiry_emails"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]} as unknown as DocumentNode<TeamSettingsFragmentFragment, unknown>;
export const TransactionFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"payment_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode<TransactionFormFragmentFragment, unknown>;
export const TransactionCommissionsFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCommissionsFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"commissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"payment_date"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vat"}},{"kind":"Field","name":{"kind":"Name","value":"contact_id"}},{"kind":"Field","name":{"kind":"Name","value":"beneficiary_team_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]}}]} as unknown as DocumentNode<TransactionCommissionsFormFragmentFragment, unknown>;
export const UserSettingsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}},{"kind":"Field","name":{"kind":"Name","value":"has_free_crm_access"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"linked_in_profile"}},{"kind":"Field","name":{"kind":"Name","value":"instagram_profile"}},{"kind":"Field","name":{"kind":"Name","value":"youtube_profile"}},{"kind":"Field","name":{"kind":"Name","value":"twitter_profile"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_profile"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"certifications"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"Field","name":{"kind":"Name","value":"hires_on_realadvisor"}}]}}]} as unknown as DocumentNode<UserSettingsFragmentFragment, unknown>;
export const VisibilityReviewFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisibilityReview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"reviews"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<VisibilityReviewFragment, unknown>;
export const UserInputFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInput"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"primaryImage"},"name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}}]}}]} as unknown as DocumentNode<UserInputFragment, unknown>;
export const GetPropertyTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPropertyTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<GetPropertyTypesQuery, GetPropertyTypesQueryVariables>;
export const InsertUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_users_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<InsertUserMutation, InsertUserMutationVariables>;
export const AutoAssignRankingChDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AutoAssignRankingCh"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auto_assign_ranking_ch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"membership_type"}},{"kind":"Field","name":{"kind":"Name","value":"modules"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"crm_link"}},{"kind":"Field","name":{"kind":"Name","value":"total_weighted_leads_assigned"}},{"kind":"Field","name":{"kind":"Name","value":"total_leads_assigned_30_days"}},{"kind":"Field","name":{"kind":"Name","value":"total_unique_lead_visits"}},{"kind":"Field","name":{"kind":"Name","value":"total_lead_mandates"}},{"kind":"Field","name":{"kind":"Name","value":"total_own_mandates"}},{"kind":"Field","name":{"kind":"Name","value":"total_transactions"}},{"kind":"Field","name":{"kind":"Name","value":"total_commissions"}},{"kind":"Field","name":{"kind":"Name","value":"total_agent_share"}},{"kind":"Field","name":{"kind":"Name","value":"lead_to_visit_conversion"}},{"kind":"Field","name":{"kind":"Name","value":"visit_to_mandate_conversion"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_to_transaction_conversion"}},{"kind":"Field","name":{"kind":"Name","value":"lead_to_transaction_conversion"}},{"kind":"Field","name":{"kind":"Name","value":"lead_to_visit_score"}},{"kind":"Field","name":{"kind":"Name","value":"visit_to_mandate_score"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_to_transaction_score"}},{"kind":"Field","name":{"kind":"Name","value":"lead_to_transaction_score"}},{"kind":"Field","name":{"kind":"Name","value":"overall_score"}},{"kind":"Field","name":{"kind":"Name","value":"revenues_per_lead"}},{"kind":"Field","name":{"kind":"Name","value":"gross_margin_per_lead"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_overdue_leads"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_overdue_days"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_leads_without_activity"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_listings_available"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agent_ranking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agent"},"name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactions_in_location"}},{"kind":"Field","name":{"kind":"Name","value":"transactions_in_municipality"}},{"kind":"Field","name":{"kind":"Name","value":"transactions_in_district"}},{"kind":"Field","name":{"kind":"Name","value":"transactions_in_state"}},{"kind":"Field","name":{"kind":"Name","value":"total_transactions"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AutoAssignRankingChQuery, AutoAssignRankingChQueryVariables>;
export const AutoAssignRankingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AutoAssignRanking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auto_assign_ranking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"should_auto_assign"}},{"kind":"Field","name":{"kind":"Name","value":"assign_to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"crm_link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"crm_link"}},{"kind":"Field","name":{"kind":"Name","value":"auto_assign_leads"}},{"kind":"Field","name":{"kind":"Name","value":"cost_per_lead"}},{"kind":"Field","name":{"kind":"Name","value":"amount_spent"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_leads"}},{"kind":"Field","name":{"kind":"Name","value":"already_assigned"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_start"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_end"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_pct"}},{"kind":"Field","name":{"kind":"Name","value":"incurred_cost"}},{"kind":"Field","name":{"kind":"Name","value":"latest_invoice"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total_amount"}},{"kind":"Field","name":{"kind":"Name","value":"customer_email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AutoAssignRankingQuery, AutoAssignRankingQueryVariables>;
export const SentEmailCountOverRolling24HDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SentEmailCountOverRolling24H"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_messages_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_sent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"sent","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<SentEmailCountOverRolling24HQuery, SentEmailCountOverRolling24HQueryVariables>;
export const GetDefaultUsersAndTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDefaultUsersAndTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipUsers"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipUsers"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSelect"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"appraisal_report"},{"kind":"EnumValue","value":"lot_brochure"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetDefaultUsersAndTemplatesQuery, GetDefaultUsersAndTemplatesQueryVariables>;
export const SearchEmailTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchEmailTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"subject"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"development_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"subject_plaintext"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}}]} as unknown as DocumentNode<SearchEmailTemplatesQuery, SearchEmailTemplatesQueryVariables>;
export const DeleteFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteFileMutation, DeleteFileMutationVariables>;
export const GetSelectedPlacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSelectedPlaces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"place_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"place_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetSelectedPlacesQuery, GetSelectedPlacesQueryVariables>;
export const GetPlacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlaces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetPlacesQuery, GetPlacesQueryVariables>;
export const GetSelectedTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSelectedTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetSelectedTeamsQuery, GetSelectedTeamsQueryVariables>;
export const GetTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetTeamsQuery, GetTeamsQueryVariables>;
export const GetSelectedUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSelectedUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<GetSelectedUsersQuery, GetSelectedUsersQueryVariables>;
export const GetUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_users_tsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>;
export const LanguageMenuUpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LanguageMenuUpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_language"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]} as unknown as DocumentNode<LanguageMenuUpdateUserMutation, LanguageMenuUpdateUserMutationVariables>;
export const SearchLeadsTsvDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchLeadsTsv"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_order_by"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_leads_tsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]} as unknown as DocumentNode<SearchLeadsTsvQuery, SearchLeadsTsvQueryVariables>;
export const SearchLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_order_by"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]} as unknown as DocumentNode<SearchLeadsQuery, SearchLeadsQueryVariables>;
export const GetDefaultLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDefaultLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]} as unknown as DocumentNode<GetDefaultLeadQuery, GetDefaultLeadQueryVariables>;
export const LotGenerateDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LotGenerateDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generate_listings_description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<LotGenerateDescriptionQuery, LotGenerateDescriptionQueryVariables>;
export const LotImproveDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LotImproveDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"improve_text"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]} as unknown as DocumentNode<LotImproveDescriptionQuery, LotImproveDescriptionQueryVariables>;
export const SearchLotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchLots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_lots_tsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]} as unknown as DocumentNode<SearchLotsQuery, SearchLotsQueryVariables>;
export const GetDefaultLotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDefaultLot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]} as unknown as DocumentNode<GetDefaultLotQuery, GetDefaultLotQueryVariables>;
export const GetLotsMlsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLotsMls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls"}}]}}]}}]} as unknown as DocumentNode<GetLotsMlsQuery, GetLotsMlsQueryVariables>;
export const UpdateLotMlsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLotMls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shared_on_mls"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"shared_on_mls"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shared_on_mls"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls"}}]}}]}}]} as unknown as DocumentNode<UpdateLotMlsMutation, UpdateLotMlsMutationVariables>;
export const GetPhoneNumbersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPhoneNumbers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_number_type_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]} as unknown as DocumentNode<GetPhoneNumbersQuery, GetPhoneNumbersQueryVariables>;
export const UpsertPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertPhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_phone_numbers_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"phone_numbers_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"number"},{"kind":"EnumValue","value":"type"},{"kind":"EnumValue","value":"verified"},{"kind":"EnumValue","value":"primary"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]} as unknown as DocumentNode<UpsertPhoneNumberMutation, UpsertPhoneNumberMutationVariables>;
export const UpdatePrimaryPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePrimaryPhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_phone_numbers_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]} as unknown as DocumentNode<UpdatePrimaryPhoneNumberMutation, UpdatePrimaryPhoneNumberMutationVariables>;
export const DeletePhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]} as unknown as DocumentNode<DeletePhoneNumberMutation, DeletePhoneNumberMutationVariables>;
export const GetDocumentTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocumentTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"document_types"},"name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"documents"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"label"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetDocumentTypesQuery, GetDocumentTypesQueryVariables>;
export const GetSmartListsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSmartLists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"crmEntity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smart_lists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"crm_entity"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"crmEntity"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"where"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared"}},{"kind":"Field","name":{"kind":"Name","value":"is_tenant_shared"}},{"kind":"Field","name":{"kind":"Name","value":"crm_entity"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]} as unknown as DocumentNode<GetSmartListsQuery, GetSmartListsQueryVariables>;
export const UpdateSmartListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSmartList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_shared"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_tenant_shared"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_smart_lists_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_shared"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_shared"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_tenant_shared"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_tenant_shared"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared"}},{"kind":"Field","name":{"kind":"Name","value":"is_tenant_shared"}}]}}]}}]} as unknown as DocumentNode<UpdateSmartListMutation, UpdateSmartListMutationVariables>;
export const DeleteSmartListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSmartList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_smart_lists_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteSmartListMutation, DeleteSmartListMutationVariables>;
export const InsertSmartListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertSmartList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"crmEntity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_shared"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_tenant_shared"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_smart_lists_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"crm_entity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"crmEntity"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_shared"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_shared"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_tenant_shared"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_tenant_shared"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"where"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared"}},{"kind":"Field","name":{"kind":"Name","value":"is_tenant_shared"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]} as unknown as DocumentNode<InsertSmartListMutation, InsertSmartListMutationVariables>;
export const GetUserSubscriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserSubscriptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auto_assign_leads"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"ended_at"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_end"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_start"}},{"kind":"Field","name":{"kind":"Name","value":"total_amount"}},{"kind":"Field","name":{"kind":"Name","value":"items"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"plan_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserSubscriptionsQuery, GetUserSubscriptionsQueryVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autoAssignLeads"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"auto_assign_leads"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autoAssignLeads"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_assign_leads"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const SearchTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TemplateSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TemplateSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<SearchTemplatesQuery, SearchTemplatesQueryVariables>;
export const SearchTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_property_transactions_tsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCell"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]} as unknown as DocumentNode<SearchTransactionsQuery, SearchTransactionsQueryVariables>;
export const GetDefaultTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDefaultTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCell"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]} as unknown as DocumentNode<GetDefaultTransactionQuery, GetDefaultTransactionQueryVariables>;
export const UpdateBuyerLeadsStageMultipleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateBuyerLeadsStageMultiple"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"change_buyer_leads_stage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"buyerLeadIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"destinationStageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lotId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_stage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDnDColumn"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDnDColumn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}}]}}]}}]} as unknown as DocumentNode<UpdateBuyerLeadsStageMultipleMutation, UpdateBuyerLeadsStageMultipleMutationVariables>;
export const GetDefaultBrochureAppraisalTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDefaultBrochureAppraisalTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"appraisal_report"},{"kind":"EnumValue","value":"lot_brochure"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}}]}}]}}]} as unknown as DocumentNode<GetDefaultBrochureAppraisalTemplatesQuery, GetDefaultBrochureAppraisalTemplatesQueryVariables>;
export const CreateBuyerLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createBuyerLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBuyerLeadUserInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"destinationStageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_buyer_lead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lotId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"Argument","name":{"kind":"Name","value":"destinationStageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"destinationStageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateBuyerLeadMutation, CreateBuyerLeadMutationVariables>;
export const GetBuyerLeadDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBuyerLeadDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<GetBuyerLeadDetailQuery, GetBuyerLeadDetailQueryVariables>;
export const BuyerLeadDeleteDialogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"buyerLeadDeleteDialog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_buyer_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BuyerLeadDeleteDialogMutation, BuyerLeadDeleteDialogMutationVariables>;
export const UpdateBuyerLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBuyerLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_buyer_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<UpdateBuyerLeadMutation, UpdateBuyerLeadMutationVariables>;
export const InsertBuyerLeadsManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertBuyerLeadsMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_buyer_leads_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lotId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"StringValue","value":"matching","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<InsertBuyerLeadsManyMutation, InsertBuyerLeadsManyMutationVariables>;
export const GetSourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lead_source_types"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetSourcesQuery, GetSourcesQueryVariables>;
export const GetCreateLeadContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCreateLeadContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetCreateLeadContactQuery, GetCreateLeadContactQueryVariables>;
export const GetCreateListingLeadDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCreateListingLeadData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact_id"}}]}}]}}]} as unknown as DocumentNode<GetCreateListingLeadDataQuery, GetCreateListingLeadDataQueryVariables>;
export const GetLotOriginsCreateListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLotOriginsCreateListing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"origins"},"name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lot_origin_types"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetLotOriginsCreateListingQuery, GetLotOriginsCreateListingQueryVariables>;
export const GetLotOriginsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLotOrigins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"origins"},"name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lot_origin_types"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetLotOriginsQuery, GetLotOriginsQueryVariables>;
export const GetListingDocumentTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingDocumentTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lot_brochure_doc_templates"},"name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lot_brochure"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}}]}}]}}]} as unknown as DocumentNode<GetListingDocumentTemplatesQuery, GetListingDocumentTemplatesQueryVariables>;
export const GetDictionariesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDictionaries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries_types_enum_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DictionarySelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DictionarySelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<GetDictionariesQuery, GetDictionariesQueryVariables>;
export const ClaimLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClaimLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"assigned_to"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"assignment"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"done_at"},"value":{"kind":"StringValue","value":"now()","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"success"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"claimed_at"},"value":{"kind":"StringValue","value":"now()","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"stage_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_activities_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"EnumValue","value":"call"}},{"kind":"ObjectField","name":{"kind":"Name","value":"due_at"},"value":{"kind":"StringValue","value":"now()","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"assigned_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"stage_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]} as unknown as DocumentNode<ClaimLeadMutation, ClaimLeadMutationVariables>;
export const PassLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PassLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"assigned_to"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"assignment"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"done_at"},"value":{"kind":"StringValue","value":"now()","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"success"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"passed_at"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<PassLeadMutation, PassLeadMutationVariables>;
export const GetClaimedStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClaimedStage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"brokerage","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"claimed","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}}]}}]}}]} as unknown as DocumentNode<GetClaimedStageQuery, GetClaimedStageQueryVariables>;
export const GetEnumsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEnums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"enums"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetEnumsQuery, GetEnumsQueryVariables>;
export const GetListingsByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingsByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]} as unknown as DocumentNode<GetListingsByIdsQuery, GetListingsByIdsQueryVariables>;
export const TeamFilterSearchTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamFilterSearchTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFilter"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<TeamFilterSearchTeamsQuery, TeamFilterSearchTeamsQueryVariables>;
export const GetTeamsByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamsByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"selected_teams"},"name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFilter"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"initial_teams"},"name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFilter"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<GetTeamsByIdsQuery, GetTeamsByIdsQueryVariables>;
export const UserFilterSearchUsersTsvDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserFilterSearchUsersTsv"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"users_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_users_tsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"EnumValue","value":"asc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_broker"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFilter"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<UserFilterSearchUsersTsvQuery, UserFilterSearchUsersTsvQueryVariables>;
export const GetUsersByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isNoneSelected"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"users_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"selected_users"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isNoneSelected"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFilter"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"initial_users"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"EnumValue","value":"asc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_broker"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFilter"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetUsersByIdsQuery, GetUsersByIdsQueryVariables>;
export const GetImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<GetImageQuery, GetImageQueryVariables>;
export const GetListingPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeOffer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCardSnippet"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","alias":{"kind":"Name","value":"last_accepted_offer"},"name":{"kind":"Name","value":"offers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offerId"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeOffer"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCardSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}}]}}]}}]} as unknown as DocumentNode<GetListingPreviewQuery, GetListingPreviewQueryVariables>;
export const GetUserImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserImagesQuery, GetUserImagesQueryVariables>;
export const GetTeamImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamImagesQuery, GetTeamImagesQueryVariables>;
export const GetOrganisationImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganisationImagesQuery, GetOrganisationImagesQueryVariables>;
export const InsertUserImageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertUserImageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_images_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_images_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<InsertUserImageMutationMutation, InsertUserImageMutationMutationVariables>;
export const InsertTeamImageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertTeamImageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"team_images_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_team_images_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<InsertTeamImageMutationMutation, InsertTeamImageMutationMutationVariables>;
export const InsertOrganisationImageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertOrganisationImageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organisation_images_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_organisation_images_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<InsertOrganisationImageMutationMutation, InsertOrganisationImageMutationMutationVariables>;
export const InsertImageOneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertImageOne"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_images_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<InsertImageOneMutation, InsertImageOneMutationVariables>;
export const LeadCard_MortgageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LeadCard_mortgage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculate_mortgage_for_lead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mortgage_analysis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max_property_value"}}]}}]}}]}}]} as unknown as DocumentNode<LeadCard_MortgageQuery, LeadCard_MortgageQueryVariables>;
export const GetAutoMatchingFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAutoMatchingFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auto_matching_filters"}}]}}]}}]} as unknown as DocumentNode<GetAutoMatchingFiltersQuery, GetAutoMatchingFiltersQueryVariables>;
export const GetAutoFilterPlacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAutoFilterPlaces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"label"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}}]}}]}}]} as unknown as DocumentNode<GetAutoFilterPlacesQuery, GetAutoFilterPlacesQueryVariables>;
export const GetAutoFilterUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAutoFilterUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"selected_users"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]} as unknown as DocumentNode<GetAutoFilterUsersQuery, GetAutoFilterUsersQueryVariables>;
export const GetAutoFilterTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAutoFilterTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"selected_teams"},"name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetAutoFilterTeamsQuery, GetAutoFilterTeamsQueryVariables>;
export const GetAutoFilterEnumsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAutoFilterEnums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"enums"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetAutoFilterEnumsQuery, GetAutoFilterEnumsQueryVariables>;
export const GetSenderDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSenderDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GetSenderDetailsQuery, GetSenderDetailsQueryVariables>;
export const UpsertEmailTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertEmailTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responseSender"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates_insert_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"files"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates_files_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_email_templates_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplate"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"email_templates_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"add_signature"},{"kind":"EnumValue","value":"bcc"},{"kind":"EnumValue","value":"cc"},{"kind":"EnumValue","value":"is_shared_with_everyone"},{"kind":"EnumValue","value":"is_shared_with_organisation"},{"kind":"EnumValue","value":"subject"},{"kind":"EnumValue","value":"subject_plaintext"},{"kind":"EnumValue","value":"text"},{"kind":"EnumValue","value":"text_html"},{"kind":"EnumValue","value":"text_plaintext"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_email_templates_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email_template_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplateId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_email_templates_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"files"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"response_sender_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responseSender"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingEnquiryResponseEmail"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingEnquiryResponseEmail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"response_sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"development"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_override_lot"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}}]}}]} as unknown as DocumentNode<UpsertEmailTemplateMutation, UpsertEmailTemplateMutationVariables>;
export const UpdateEnquiryReponseEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateEnquiryReponseEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingEnquiryResponseEmail"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingEnquiryResponseEmail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"response_sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"development"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_override_lot"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}}]}}]} as unknown as DocumentNode<UpdateEnquiryReponseEmailMutation, UpdateEnquiryReponseEmailMutationVariables>;
export const GetListingReferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingReferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_listing_references"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference_aliases_encoded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}}]}}]}}]}}]} as unknown as DocumentNode<GetListingReferencesQuery, GetListingReferencesQueryVariables>;
export const RefreshReferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshReference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_lot_reference_aliases_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference_alias_decoded"}}]}}]}}]} as unknown as DocumentNode<RefreshReferenceMutation, RefreshReferenceMutationVariables>;
export const UpdateListingMarketingFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateListingMarketingForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarketingFormData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketingFormData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"listing_url"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]} as unknown as DocumentNode<UpdateListingMarketingFormMutation, UpdateListingMarketingFormMutationVariables>;
export const GetListingQuickActionsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingQuickActionsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"seller_report_templates"},"name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"seller_report"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"portal_listings"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_portals"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots_status_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<GetListingQuickActionsDataQuery, GetListingQuickActionsDataQueryVariables>;
export const GetListingTransactionsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingTransactionsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"payment_date"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionFormFragment"}},{"kind":"Field","name":{"kind":"Name","value":"commissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"payment_date"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"payment_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]} as unknown as DocumentNode<GetListingTransactionsDataQuery, GetListingTransactionsDataQueryVariables>;
export const SearchOrganisationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchOrganisations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations_search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}}]} as unknown as DocumentNode<SearchOrganisationsQuery, SearchOrganisationsQueryVariables>;
export const GetDefaultOrganisationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDefaultOrganisation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}}]} as unknown as DocumentNode<GetDefaultOrganisationQuery, GetDefaultOrganisationQueryVariables>;
export const SearchPlacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchPlaces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"placeTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"place_type_enum_enum"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeTypes"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"population"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchPlaceFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchPlaceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"places"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SearchPlacesQuery, SearchPlacesQueryVariables>;
export const GetPlacesByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlacesByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"label"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchPlaceFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchPlaceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"places"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetPlacesByIdsQuery, GetPlacesByIdsQueryVariables>;
export const AutoCatchmentAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AutoCatchmentArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"x"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"y"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target_population"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_catchment_area"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"x"},"value":{"kind":"Variable","name":{"kind":"Name","value":"x"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y"},"value":{"kind":"Variable","name":{"kind":"Name","value":"y"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"target_population"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_population"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchPlaceFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchPlaceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"places"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AutoCatchmentAreaQuery, AutoCatchmentAreaQueryVariables>;
export const GetPlaceByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlaceById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"places_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchPlaceFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchPlaceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"places"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetPlaceByIdQuery, GetPlaceByIdQueryVariables>;
export const GetPropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProperty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heating_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cooling_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormPricing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAddress"}}]}}]} as unknown as DocumentNode<GetPropertyQuery, GetPropertyQueryVariables>;
export const UpdatePropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProperty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"properties_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_properties_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormPricing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAddress"}}]}}]} as unknown as DocumentNode<UpdatePropertyMutation, UpdatePropertyMutationVariables>;
export const DummyMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DummyMutation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<DummyMutationMutation, DummyMutationMutationVariables>;
export const TeamsSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamsSelect"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeTeamsIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeTeamsIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamsSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamsSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<TeamsSelectQuery, TeamsSelectQueryVariables>;
export const GetDefaultTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDefaultTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamsSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamsSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetDefaultTeamsQuery, GetDefaultTeamsQueryVariables>;
export const SearchReadOnlyTenantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchReadOnlyTenants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"read_only_tenants_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"read_only_tenants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReadOnlyTenantSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReadOnlyTenantSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"read_only_tenants"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<SearchReadOnlyTenantsQuery, SearchReadOnlyTenantsQueryVariables>;
export const TransactionCommissionsFormQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransactionCommissionsFormQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCommissionsFormFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCommissionsFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"commissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"payment_date"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vat"}},{"kind":"Field","name":{"kind":"Name","value":"contact_id"}},{"kind":"Field","name":{"kind":"Name","value":"beneficiary_team_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]}}]} as unknown as DocumentNode<TransactionCommissionsFormQueryQuery, TransactionCommissionsFormQueryQueryVariables>;
export const GetBrandingValuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBrandingValues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_valuation_link"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agent_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"landing_url"}},{"kind":"Field","name":{"kind":"Name","value":"valuation_url"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"agent_id"}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}}]}}]}}]}}]} as unknown as DocumentNode<GetBrandingValuesQuery, GetBrandingValuesQueryVariables>;
export const UpdateBrandingValuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBrandingValues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}}]}}]}}]} as unknown as DocumentNode<UpdateBrandingValuesMutation, UpdateBrandingValuesMutationVariables>;
export const UpsertValuationLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertValuationLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenant_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsert_valuation_link"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenant_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenant_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"landing_url"}},{"kind":"Field","name":{"kind":"Name","value":"valuation_url"}},{"kind":"Field","name":{"kind":"Name","value":"agent_id"}},{"kind":"Field","name":{"kind":"Name","value":"survey_id"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<UpsertValuationLinkMutation, UpsertValuationLinkMutationVariables>;
export const SearchUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"users_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_users_tsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<SearchUsersQuery, SearchUsersQueryVariables>;
export const GetDefaultUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDefaultUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetDefaultUsersQuery, GetDefaultUsersQueryVariables>;
export const AppraisalGraphDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppraisalGraph"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appraisalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisals_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appraisalId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppraisalDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppraisalDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"appraisals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"valuations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"valuation_model"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}}]}}]}}]}}]} as unknown as DocumentNode<AppraisalGraphQuery, AppraisalGraphQueryVariables>;
export const AppraiseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Appraise"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value_property"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"property_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppraisalDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppraisalDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"appraisals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"valuations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"valuation_model"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}}]}}]}}]}}]} as unknown as DocumentNode<AppraiseMutation, AppraiseMutationVariables>;
export const InsertLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_insert_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contact_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"include_call_activity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"created_at"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"created_at_plus_5"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"created_at_plus_10"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"claimed_at"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_leads_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"origination"},"name":{"kind":"Name","value":"insert_activities_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"EnumValue","value":"origination"}},{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"success"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"done_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"created_at"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"created_at"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"assignment"},"name":{"kind":"Name","value":"insert_activities_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"EnumValue","value":"assignment"}},{"kind":"ObjectField","name":{"kind":"Name","value":"assigned_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"success"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"done_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"created_at_plus_5"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"created_at_plus_5"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"call"},"name":{"kind":"Name","value":"insert_activities_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"EnumValue","value":"call"}},{"kind":"ObjectField","name":{"kind":"Name","value":"assigned_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"created_at_plus_10"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"activities_target_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"target_user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contact_id"}}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"include_call_activity"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activities_target_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"target_user_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_lead_agents_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"crm"}},{"kind":"ObjectField","name":{"kind":"Name","value":"claimed_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"claimed_at"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"stage_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertLeadMutation, InsertLeadMutationVariables>;
export const GetLeadMetadataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadMetadata"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pipelines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"brokerage","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"claimed","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lead_source_types"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetLeadMetadataQuery, GetLeadMetadataQueryVariables>;
export const GetDictEnumsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDictEnums"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries_types_enum_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionaries_types_enum"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetDictEnumsQuery, GetDictEnumsQueryVariables>;
export const GetDictionariesByTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDictionariesByType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries_types_enum_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DictionaryItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DictionaryItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"is_deletable"}},{"kind":"Field","name":{"kind":"Name","value":"is_used"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"group_id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetDictionariesByTypeQuery, GetDictionariesByTypeQueryVariables>;
export const DeleteDictionaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteDictionary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_dictionaries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteDictionaryMutation, DeleteDictionaryMutationVariables>;
export const Get_Dictionary_GroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_DICTIONARY_GROUPS"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"groups"},"name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"document_type_groups"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<Get_Dictionary_GroupsQuery, Get_Dictionary_GroupsQueryVariables>;
export const Get_Dictionary_ItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_DICTIONARY_ITEM"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionaries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DictionaryItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DictionaryItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"is_deletable"}},{"kind":"Field","name":{"kind":"Name","value":"is_used"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"group_id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<Get_Dictionary_ItemQuery, Get_Dictionary_ItemQueryVariables>;
export const Insert_Dictionary_ItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"INSERT_DICTIONARY_ITEM"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dictionary"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_dictionaries_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dictionary"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DictionaryItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DictionaryItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"is_deletable"}},{"kind":"Field","name":{"kind":"Name","value":"is_used"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"group_id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<Insert_Dictionary_ItemMutation, Insert_Dictionary_ItemMutationVariables>;
export const Update_Dictionary_ItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_DICTIONARY_ITEM"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dictionary"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_dictionaries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dictionary"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DictionaryItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DictionaryItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"is_deletable"}},{"kind":"Field","name":{"kind":"Name","value":"is_used"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"group_id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<Update_Dictionary_ItemMutation, Update_Dictionary_ItemMutationVariables>;
export const Sync_Dictionary_EnumsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SYNC_DICTIONARY_ENUMS"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sync_dictionary_enums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<Sync_Dictionary_EnumsQuery, Sync_Dictionary_EnumsQueryVariables>;
export const GetDocTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocTemplateFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"filename_template"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}}]} as unknown as DocumentNode<GetDocTemplatesQuery, GetDocTemplatesQueryVariables>;
export const DeleteDocTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDocTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_doc_templates_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteDocTemplateMutation, DeleteDocTemplateMutationVariables>;
export const DuplicateDocTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DuplicateDocTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_doc_templates_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DuplicateDocTemplateMutation, DuplicateDocTemplateMutationVariables>;
export const GetDocTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocTemplateFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"filename_template"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}}]} as unknown as DocumentNode<GetDocTemplateQuery, GetDocTemplateQueryVariables>;
export const CreateDocTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDocTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_doc_templates_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocTemplateFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"filename_template"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}}]} as unknown as DocumentNode<CreateDocTemplateMutation, CreateDocTemplateMutationVariables>;
export const UpdateDocTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDocTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_doc_templates_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocTemplateFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"filename_template"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}}]} as unknown as DocumentNode<UpdateDocTemplateMutation, UpdateDocTemplateMutationVariables>;
export const UpdateTenantShareDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTenantShare"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"doc_template_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenant_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_default"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_doc_templates_tenants_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"doc_template_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"doc_template_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tenant_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenant_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_default"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_default"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"doc_templates_tenants_doc_template_id_tenant_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"is_default"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTenantShareMutation, UpdateTenantShareMutationVariables>;
export const DeleteTenantShareDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTenantShare"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_doc_templates_tenants_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}}]}}]}}]} as unknown as DocumentNode<DeleteTenantShareMutation, DeleteTenantShareMutationVariables>;
export const GetDocTemplateTypeEnumDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocTemplateTypeEnum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_template_type_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<GetDocTemplateTypeEnumQuery, GetDocTemplateTypeEnumQueryVariables>;
export const EmailSequencesDeleteSequenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmailSequencesDeleteSequence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_email_sequences_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<EmailSequencesDeleteSequenceMutation, EmailSequencesDeleteSequenceMutationVariables>;
export const EmailSequenceRecipientStopDialogMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmailSequenceRecipientStopDialogMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_email_sequences_recipients_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"stopped"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<EmailSequenceRecipientStopDialogMutationMutation, EmailSequenceRecipientStopDialogMutationMutationVariables>;
export const EmailSequenceDrawerUpsertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmailSequenceDrawerUpsert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"email_sequences_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_email_sequences_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"email_sequences_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"stop_after_reply"},{"kind":"EnumValue","value":"is_shared_with_team"},{"kind":"EnumValue","value":"is_shared_with_everyone"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<EmailSequenceDrawerUpsertMutation, EmailSequenceDrawerUpsertMutationVariables>;
export const EmailSequenceDrawerDeleteStepsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmailSequenceDrawerDeleteSteps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_email_sequences_steps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<EmailSequenceDrawerDeleteStepsMutation, EmailSequenceDrawerDeleteStepsMutationVariables>;
export const EmailSequenceDrawerDeleteFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmailSequenceDrawerDeleteFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_email_templates_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EmailSequenceDrawerDeleteFilesMutation, EmailSequenceDrawerDeleteFilesMutationVariables>;
export const EmailSequenceDuplicateInsertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmailSequenceDuplicateInsert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"email_sequences_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_email_sequences_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"email_sequences_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"stop_after_reply"},{"kind":"EnumValue","value":"is_shared_with_team"},{"kind":"EnumValue","value":"is_shared_with_everyone"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<EmailSequenceDuplicateInsertMutation, EmailSequenceDuplicateInsertMutationVariables>;
export const StatusSwitchSequenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StatusSwitchSequence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_set"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"email_sequences_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_email_sequences_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<StatusSwitchSequenceMutation, StatusSwitchSequenceMutationVariables>;
export const StatusSwitchRecipientsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StatusSwitchRecipients"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_email_sequences_recipients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email_sequence_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"stopped"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]} as unknown as DocumentNode<StatusSwitchRecipientsMutation, StatusSwitchRecipientsMutationVariables>;
export const EmailSequencesMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmailSequencesMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSequenceDrawer_me"}},{"kind":"Field","name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSequenceDrawer_me"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<EmailSequencesMeQuery, EmailSequencesMeQueryVariables>;
export const EmailSequencesTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmailSequencesTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"email_sequences_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_sequences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_team"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"recipients_stopped"},"name":{"kind":"Name","value":"email_sequences_recipients_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"stopped"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"recipients_active"},"name":{"kind":"Name","value":"email_sequences_recipients_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"active"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_sequences_steps_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StatusSwitch_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StatusSwitch_id"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_sequences"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<EmailSequencesTableQuery, EmailSequencesTableQueryVariables>;
export const EmailSequenceDuplicateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmailSequenceDuplicate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sequenceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_sequences_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sequenceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_sequences_steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delay"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"email_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"text_html"}},{"kind":"Field","name":{"kind":"Name","value":"text_plaintext"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"subject_plaintext"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EmailSequenceDuplicateQuery, EmailSequenceDuplicateQueryVariables>;
export const EmailSequenceDrawerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmailSequenceDrawer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"email_sequences_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_sequences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stop_after_reply"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_team"}},{"kind":"Field","name":{"kind":"Name","value":"email_sequences_steps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"delay"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"email_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EmailSequenceDrawerQuery, EmailSequenceDrawerQueryVariables>;
export const GetEmailSequenceRecipientsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEmailSequenceRecipients"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sequenceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_sequences_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sequenceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_sequences_steps_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_sequences_recipients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email_sequence_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sequenceId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetEmailSequenceRecipientsQuery, GetEmailSequenceRecipientsQueryVariables>;
export const GetEnquiriesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEnquiriesList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"processed"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCell_listing"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCell_listing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","alias":{"kind":"Name","value":"single_property_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetEnquiriesListQuery, GetEnquiriesListQueryVariables>;
export const GetEnquiriesListCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEnquiriesListCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetEnquiriesListCountQuery, GetEnquiriesListCountQueryVariables>;
export const GetEnquiryTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEnquiryType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enquiries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<GetEnquiryTypeQuery, GetEnquiryTypeQueryVariables>;
export const GetEnquiryContactRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEnquiryContactRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enquiries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"contact_reason"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEnquiryContactRequestQuery, GetEnquiryContactRequestQueryVariables>;
export const GetEnquiryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEnquiry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enquiries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"raw_email"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"raw_email_address"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"raw_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matched_email_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matched_phone_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCardSnippet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"response_activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalLogo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCardSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<GetEnquiryQuery, GetEnquiryQueryVariables>;
export const DeleteEnquiryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteEnquiry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_enquiries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteEnquiryMutation, DeleteEnquiryMutationVariables>;
export const ValidateInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ValidateInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validate_invitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"magic_token"}}]}}]}}]} as unknown as DocumentNode<ValidateInvitationQuery, ValidateInvitationQueryVariables>;
export const AppraisalRequestsCardAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppraisalRequestsCardAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"result_page"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]} as unknown as DocumentNode<AppraisalRequestsCardAdminQuery, AppraisalRequestsCardAdminQueryVariables>;
export const AssignBrokerWithActivitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignBrokerWithActivities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leads_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activities"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_agents"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leads_ids"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"broker_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"stage_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leads_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"assignment"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"success"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"done_at"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activities"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_agents"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AssignBrokerWithActivitiesMutation, AssignBrokerWithActivitiesMutationVariables>;
export const GetAssignStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssignStage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"assign","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"brokerage","block":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetAssignStageQuery, GetAssignStageQueryVariables>;
export const GetPipelinesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPipelines"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lead_type"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pipelines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadType"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<GetPipelinesQuery, GetPipelinesQueryVariables>;
export const UpdateMultipleLeadsStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMultipleLeadsStage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activities"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"stage_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stageId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"stage_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stageId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activities"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMultipleLeadsStageMutation, UpdateMultipleLeadsStageMutationVariables>;
export const GetLeadDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leads_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"dictionary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"tags_types"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"brokerage","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"is_a_duplicate","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetLeadDataQuery, GetLeadDataQueryVariables>;
export const UpdateLeadTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLeadTags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"removedTags"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newTags"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_tags_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_leads_tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removedTags"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_leads_tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newTags"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateLeadTagsMutation, UpdateLeadTagsMutationVariables>;
export const SelfAssignLeadAgentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SelfAssignLeadAgent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"stage_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_lead_agents_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"crm"}},{"kind":"ObjectField","name":{"kind":"Name","value":"stage_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadAgent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadAgent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"passed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"win_probability"}},{"kind":"Field","name":{"kind":"Name","value":"predicted_win_date"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<SelfAssignLeadAgentMutation, SelfAssignLeadAgentMutationVariables>;
export const GetLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_order_by"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"requalified_or_created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_or_created_at"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_probability"}},{"kind":"Field","name":{"kind":"Name","value":"pos_within_stage"}},{"kind":"Field","name":{"kind":"Name","value":"predicted_listing_date"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"due_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityCell"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"note"},{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"assignment"},{"kind":"EnumValue","value":"task"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_done_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityCell"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]} as unknown as DocumentNode<GetLeadsQuery, GetLeadsQueryVariables>;
export const GetLeadsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetLeadsCountQuery, GetLeadsCountQueryVariables>;
export const GetLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarketingCardLeadFragment"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContactCardUserFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserEmails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketingCardLeadFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContactCardUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserEmails"}}]}}]} as unknown as DocumentNode<GetLeadQuery, GetLeadQueryVariables>;
export const LeadFeedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LeadFeed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email_addresses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip_email_activities"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"user_activities"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"email"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"250"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"activityFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lead_activites"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contact_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"email"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"250"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"activityFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"email_activities"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"activities_target_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email_addresses"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"email"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"250"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip_email_activities"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"activityFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"activityFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"unread"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"nylas_thread_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<LeadFeedQuery, LeadFeedQueryVariables>;
export const AssignLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"broker_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_activities_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"assigned_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"EnumValue","value":"assignment"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AssignLeadMutation, AssignLeadMutationVariables>;
export const GetLeadAgentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadAgents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadAgent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadAgent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"passed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"win_probability"}},{"kind":"Field","name":{"kind":"Name","value":"predicted_win_date"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetLeadAgentsQuery, GetLeadAgentsQueryVariables>;
export const GetLeadQualificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadQualification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"win_probability"}},{"kind":"Field","name":{"kind":"Name","value":"predicted_win_date"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLeadQualificationQuery, GetLeadQualificationQueryVariables>;
export const AddLeadAgentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddLeadAgent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_lead_agents_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"crm"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_activities_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"assigned_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"EnumValue","value":"assignment"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddLeadAgentMutation, AddLeadAgentMutationVariables>;
export const DeleteLeadAgentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLeadAgent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_lead_agents_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteLeadAgentMutation, DeleteLeadAgentMutationVariables>;
export const UpdateLeadAgentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLeadAgents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_stage_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update_lead"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadAgent"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"stage_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_stage_id"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update_lead"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadAgent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"passed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"win_probability"}},{"kind":"Field","name":{"kind":"Name","value":"predicted_win_date"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLeadAgentsMutation, UpdateLeadAgentsMutationVariables>;
export const GetPipelineStagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPipelineStages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pipelines_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPipelineStagesQuery, GetPipelineStagesQueryVariables>;
export const LeadQualificationGetPipelinesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LeadQualificationGetPipelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pipelines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"sales","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline_id"},"value":{"kind":"EnumValue","value":"asc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LeadQualificationGetPipelinesQuery, LeadQualificationGetPipelinesQueryVariables>;
export const UpdateLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update_lead_agents"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"stage_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update_lead_agents"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLeadMutation, UpdateLeadMutationVariables>;
export const GetListingBuyersLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingBuyersLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"house_sales","block":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"auto_matching_filters"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"country"},{"kind":"EnumValue","value":"region"},{"kind":"EnumValue","value":"state"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_stage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDnDColumn"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDnDColumn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}}]}}]}}]} as unknown as DocumentNode<GetListingBuyersLeadQuery, GetListingBuyersLeadQueryVariables>;
export const GetListingSurroundingPlacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingSurroundingPlaces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_surrounding_listing_places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"listingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"placeType"},"value":{"kind":"StringValue","value":"locality","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place_id"}}]}}]}}]} as unknown as DocumentNode<GetListingSurroundingPlacesQuery, GetListingSurroundingPlacesQueryVariables>;
export const UpdateBuyerLeadOrderAndStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBuyerLeadOrderAndStage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"destinationStageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderNr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_buyer_lead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"buyerLeadId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"destinationOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderNr"}}},{"kind":"Argument","name":{"kind":"Name","value":"destinationStageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"destinationStageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"lot"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDnDColumn"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_stage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDnDColumn"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDnDColumn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}}]}}]}}]} as unknown as DocumentNode<UpdateBuyerLeadOrderAndStageMutation, UpdateBuyerLeadOrderAndStageMutationVariables>;
export const GetListingDuplicateDialogDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingDuplicateDialogData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_files_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetListingDuplicateDialogDataQuery, GetListingDuplicateDialogDataQueryVariables>;
export const GetListingDuplicationDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingDuplicationData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDocuments"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includePhotos"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDocuments"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includePhotos"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetListingDuplicationDataQuery, GetListingDuplicationDataQueryVariables>;
export const GetListingMarketingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingMarketing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalListingButton"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarketingFormData"}},{"kind":"Field","name":{"kind":"Name","value":"enable_auto_matching"}},{"kind":"Field","name":{"kind":"Name","value":"auto_matching_filters"}},{"kind":"Field","name":{"kind":"Name","value":"send_enquiries_to_sellers"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingEnquiryResponseEmail"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalListingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketingFormData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"listing_url"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingEnquiryResponseEmail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"response_sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"development"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_override_lot"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}}]}}]} as unknown as DocumentNode<GetListingMarketingQuery, GetListingMarketingQueryVariables>;
export const SyncListingPortalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncListingPortals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"portalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_portal_listing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"portal_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portalId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"warnings"}}]}}]}}]} as unknown as DocumentNode<SyncListingPortalsMutation, SyncListingPortalsMutationVariables>;
export const UpdateListingMarketingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateListingMarketing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalListingButton"}},{"kind":"Field","name":{"kind":"Name","value":"enable_auto_matching"}},{"kind":"Field","name":{"kind":"Name","value":"send_enquiries_to_sellers"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalListingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}}]} as unknown as DocumentNode<UpdateListingMarketingMutation, UpdateListingMarketingMutationVariables>;
export const GetListingOffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"made_on"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"offer_refused_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"made_on"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeOfferStatusModal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeOfferStatusModal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"offers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]}}]} as unknown as DocumentNode<GetListingOffersQuery, GetListingOffersQueryVariables>;
export const UpdateListingSellersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateListingSellers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sellers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lot_sellers_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_lot_sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_lot_sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sellers"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<UpdateListingSellersMutation, UpdateListingSellersMutationVariables>;
export const GetPropertyImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPropertyImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}},{"kind":"Field","name":{"kind":"Name","value":"is_floor_plan"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"crop"}},{"kind":"Field","name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"landscape_size"}},{"kind":"Field","name":{"kind":"Name","value":"landscape_crop"}},{"kind":"Field","name":{"kind":"Name","value":"landscape_background_color"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetPropertyImagesQuery, GetPropertyImagesQueryVariables>;
export const InsertPropertyImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertPropertyImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_images_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_property_images_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<InsertPropertyImageMutation, InsertPropertyImageMutationVariables>;
export const InsertPropertyImagesBatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertPropertyImagesBatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_images_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InsertPropertyImagesBatchMutation, InsertPropertyImagesBatchMutationVariables>;
export const DeletePropertyImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePropertyImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_property_images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeletePropertyImageMutation, DeletePropertyImageMutationVariables>;
export const UpdatePropertyImagesOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePropertyImagesOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_property_images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}}]}}]}}]} as unknown as DocumentNode<UpdatePropertyImagesOrderMutation, UpdatePropertyImagesOrderMutationVariables>;
export const UpdatePropertyImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePropertyImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_images_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_property_images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdatePropertyImageMutation, UpdatePropertyImageMutationVariables>;
export const GetListingTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionsListRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamInfo_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyCell_property"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionsListRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"payment_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyCell_property"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_paid"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"total","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"my_commissions"},"name":{"kind":"Name","value":"commissions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"split","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"beneficiary_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetListingTransactionsQuery, GetListingTransactionsQueryVariables>;
export const GetLotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}}]}}]}}]} as unknown as DocumentNode<GetLotQuery, GetLotQueryVariables>;
export const GetLotsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLotsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_order_by"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotCardCarousel_lot"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotCardInfo_lot"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingsDetailedView"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"lots_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_exclusive"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCell_listing"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_portals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotCardCarousel_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"matching_buyer_leads"},"name":{"kind":"Name","value":"buyer_leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"matched","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"offers_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingsDetailedView"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCell_listing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","alias":{"kind":"Name","value":"single_property_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetLotsListQuery, GetLotsListQueryVariables>;
export const GetLotsListCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLotsListCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetLotsListCountQuery, GetLotsListCountQueryVariables>;
export const TogglePortalListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TogglePortalListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"portal_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toggle_portal_listing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"portal_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portal_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"milliseconds_online"}},{"kind":"Field","name":{"kind":"Name","value":"last_publication_warnings"}}]}}]}}]} as unknown as DocumentNode<TogglePortalListingMutation, TogglePortalListingMutationVariables>;
export const GetAvailableListingPortalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAvailableListingPortals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"portal_listings"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_portals"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<GetAvailableListingPortalsQuery, GetAvailableListingPortalsQueryVariables>;
export const DeleteLotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteLotMutation, DeleteLotMutationVariables>;
export const GetListingDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverview"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_address"}},{"kind":"Field","name":{"kind":"Name","value":"address_display_option"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lat"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgentCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListedByOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_contact"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lat"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMandateCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_fee"}},{"kind":"Field","name":{"kind":"Name","value":"is_exclusive"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"expected_time_to_sell"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MandateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMandateCard"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_sales_tax_inclusive"}},{"kind":"Field","name":{"kind":"Name","value":"duration_in_months"}},{"kind":"Field","name":{"kind":"Name","value":"origin_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_success_fee"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_type"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_custom"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingBuyerLeads"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"matching","block":false},{"kind":"StringValue","value":"manual","block":false}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingStatusSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalListingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingQuickActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingStatusSelect"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalListingButton"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadQualificationFunnel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_selling_with"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_market_time"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_monthly_gross_rent"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_separation_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_inheritance_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_term"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_buying_status"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_status"}},{"kind":"Field","name":{"kind":"Name","value":"received_mortgage_offer"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FiancingLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_property_value"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_is_construction"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_mortgage_type"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_report_type"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadPropertyDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalesLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_occupied"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_route"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_state"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadPropertyDetail"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FiancingLeadDetail"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesLeadDetail"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormPricing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAddress"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFragment"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMap"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_net_seller_price"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"available_from"}},{"kind":"Field","name":{"kind":"Name","value":"virtual_visit_url"}},{"kind":"Field","name":{"kind":"Name","value":"video_url"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressOverridesListing"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price_type"}},{"kind":"Field","name":{"kind":"Name","value":"indoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"outdoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_included_in_total"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgentCard_user"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListedByOverridesListing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MandateForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingBuyerLeads"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingQuickActions"}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverviewProperty"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMap"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetListingDetailsQuery, GetListingDetailsQueryVariables>;
export const GetListingEditContextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingEditContext"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heating_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cooling_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<GetListingEditContextQuery, GetListingEditContextQueryVariables>;
export const UpdateListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverview"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_address"}},{"kind":"Field","name":{"kind":"Name","value":"address_display_option"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lat"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgentCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListedByOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_contact"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lat"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMandateCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_fee"}},{"kind":"Field","name":{"kind":"Name","value":"is_exclusive"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"expected_time_to_sell"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MandateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMandateCard"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_sales_tax_inclusive"}},{"kind":"Field","name":{"kind":"Name","value":"duration_in_months"}},{"kind":"Field","name":{"kind":"Name","value":"origin_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_success_fee"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_type"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_custom"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingBuyerLeads"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"matching","block":false},{"kind":"StringValue","value":"manual","block":false}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingStatusSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalListingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingQuickActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingStatusSelect"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalListingButton"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadQualificationFunnel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_selling_with"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_market_time"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_monthly_gross_rent"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_separation_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_inheritance_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_term"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_buying_status"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_status"}},{"kind":"Field","name":{"kind":"Name","value":"received_mortgage_offer"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FiancingLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_property_value"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_is_construction"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_mortgage_type"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_report_type"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadPropertyDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalesLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_occupied"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_route"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_state"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadPropertyDetail"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FiancingLeadDetail"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesLeadDetail"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormPricing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAddress"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFragment"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMap"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_net_seller_price"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"available_from"}},{"kind":"Field","name":{"kind":"Name","value":"virtual_visit_url"}},{"kind":"Field","name":{"kind":"Name","value":"video_url"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressOverridesListing"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price_type"}},{"kind":"Field","name":{"kind":"Name","value":"indoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"outdoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_included_in_total"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgentCard_user"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListedByOverridesListing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MandateForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingBuyerLeads"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingQuickActions"}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverviewProperty"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMap"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateListingMutation, UpdateListingMutationVariables>;
export const UpdateListingStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateListingStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_status_enum_enum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<UpdateListingStatusMutation, UpdateListingStatusMutationVariables>;
export const CreateListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertListingLotsInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_lots_derived"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lot"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverview"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_address"}},{"kind":"Field","name":{"kind":"Name","value":"address_display_option"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lat"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgentCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListedByOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_contact"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lat"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMandateCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_fee"}},{"kind":"Field","name":{"kind":"Name","value":"is_exclusive"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"expected_time_to_sell"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MandateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMandateCard"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_sales_tax_inclusive"}},{"kind":"Field","name":{"kind":"Name","value":"duration_in_months"}},{"kind":"Field","name":{"kind":"Name","value":"origin_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_success_fee"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_type"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_custom"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingBuyerLeads"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"matching","block":false},{"kind":"StringValue","value":"manual","block":false}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingStatusSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalListingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingQuickActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingStatusSelect"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalListingButton"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadQualificationFunnel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_selling_with"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_market_time"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_monthly_gross_rent"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_separation_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_inheritance_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_term"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_buying_status"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_status"}},{"kind":"Field","name":{"kind":"Name","value":"received_mortgage_offer"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FiancingLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_property_value"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_is_construction"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_mortgage_type"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_report_type"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadPropertyDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalesLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_occupied"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_route"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_state"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadPropertyDetail"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FiancingLeadDetail"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesLeadDetail"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormPricing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAddress"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFragment"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMap"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_net_seller_price"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"available_from"}},{"kind":"Field","name":{"kind":"Name","value":"virtual_visit_url"}},{"kind":"Field","name":{"kind":"Name","value":"video_url"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressOverridesListing"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price_type"}},{"kind":"Field","name":{"kind":"Name","value":"indoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"outdoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_included_in_total"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgentCard_user"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListedByOverridesListing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MandateForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingBuyerLeads"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingQuickActions"}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverviewProperty"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMap"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateListingMutation, CreateListingMutationVariables>;
export const CreatePropertyFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePropertyFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_files_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_property_files_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]}}]} as unknown as DocumentNode<CreatePropertyFileMutation, CreatePropertyFileMutationVariables>;
export const UpdateListingWithPropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateListingWithProperty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"prop_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"properties_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverview"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_properties_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"prop_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverviewProperty"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_address"}},{"kind":"Field","name":{"kind":"Name","value":"address_display_option"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lat"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgentCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListedByOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_contact"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lat"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMandateCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_fee"}},{"kind":"Field","name":{"kind":"Name","value":"is_exclusive"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"expected_time_to_sell"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MandateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMandateCard"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_sales_tax_inclusive"}},{"kind":"Field","name":{"kind":"Name","value":"duration_in_months"}},{"kind":"Field","name":{"kind":"Name","value":"origin_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_success_fee"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_type"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_custom"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingBuyerLeads"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"matching","block":false},{"kind":"StringValue","value":"manual","block":false}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingStatusSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalListingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingQuickActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingStatusSelect"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalListingButton"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadQualificationFunnel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_selling_with"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_market_time"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_monthly_gross_rent"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_separation_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_inheritance_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_term"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_buying_status"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_status"}},{"kind":"Field","name":{"kind":"Name","value":"received_mortgage_offer"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FiancingLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_property_value"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_is_construction"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_mortgage_type"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_report_type"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadPropertyDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalesLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_occupied"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_route"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_state"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadPropertyDetail"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FiancingLeadDetail"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesLeadDetail"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormPricing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAddress"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFragment"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMap"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_net_seller_price"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"available_from"}},{"kind":"Field","name":{"kind":"Name","value":"virtual_visit_url"}},{"kind":"Field","name":{"kind":"Name","value":"video_url"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressOverridesListing"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price_type"}},{"kind":"Field","name":{"kind":"Name","value":"indoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"outdoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_included_in_total"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgentCard_user"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListedByOverridesListing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MandateForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingBuyerLeads"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingQuickActions"}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverviewProperty"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMap"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateListingWithPropertyMutation, UpdateListingWithPropertyMutationVariables>;
export const ListingDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListingDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_property_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFile"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}}]}}]} as unknown as DocumentNode<ListingDocumentsQuery, ListingDocumentsQueryVariables>;
export const UpdateFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"files_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateFileMutation, UpdateFileMutationVariables>;
export const UpdatePropertyFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePropertyFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_files_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_property_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePropertyFileMutation, UpdatePropertyFileMutationVariables>;
export const ReOrderPropertyFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReOrderPropertyFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_property_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"file_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<ReOrderPropertyFilesMutation, ReOrderPropertyFilesMutationVariables>;
export const InsertLotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertLots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LotImportInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"import_lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}}]}}]}}]} as unknown as DocumentNode<InsertLotsMutation, InsertLotsMutationVariables>;
export const DeleteLotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteLotsMutation, DeleteLotsMutationVariables>;
export const ExportLotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportLots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_computed"}},{"kind":"Field","name":{"kind":"Name","value":"available_from"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description"}},{"kind":"Field","name":{"kind":"Name","value":"video_url"}},{"kind":"Field","name":{"kind":"Name","value":"virtual_visit_url"}},{"kind":"Field","name":{"kind":"Name","value":"use_custom_brochure_description"}},{"kind":"Field","name":{"kind":"Name","value":"use_custom_brochure_title"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"send_enquiries_to_sellers"}},{"kind":"Field","name":{"kind":"Name","value":"origin_id"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls"}},{"kind":"Field","name":{"kind":"Name","value":"send_enquiries_to_sellers"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"is_exclusive"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_sales_tax_inclusive"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"duration_in_months"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_fee"}},{"kind":"Field","name":{"kind":"Name","value":"has_success_fee"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_net_seller_price"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"expected_time_to_sell"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_custom"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_type"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"development_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"ceiling_height"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume_norm"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_maisonette"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"is_rental"}},{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"is_secondary_residence"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"flat_condition"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"plot_registry_number"}},{"kind":"Field","name":{"kind":"Name","value":"plot_is_constructible"}},{"kind":"Field","name":{"kind":"Name","value":"plot_has_constructible_reserve"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"share_of_ownership"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExportLotsQuery, ExportLotsQueryVariables>;
export const UpdateLotsOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLotsOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateLotsOrderMutation, UpdateLotsOrderMutationVariables>;
export const UpdateAutoMatchingFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAutoMatchingFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"auto_matching_filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_matching_filters"}}]}}]}}]} as unknown as DocumentNode<UpdateAutoMatchingFiltersMutation, UpdateAutoMatchingFiltersMutationVariables>;
export const CatchmentAreasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CatchmentAreas"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catchment_areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CatchmentAreasQuery, CatchmentAreasQueryVariables>;
export const GetMlsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"mls_lots_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"mls_lots_order_by"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"total_count_limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mls_lots_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"total_count_limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lot_brochure_doc_templates"},"name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lot_brochure"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMlsQuery, GetMlsQueryVariables>;
export const GetOffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"offers_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"offers_order_by"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCell_listing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPriceCell"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"offer_refused_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"made_on"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeOfferStatusModal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCell_listing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","alias":{"kind":"Name","value":"single_property_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPriceCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeOfferStatusModal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"offers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]}}]} as unknown as DocumentNode<GetOffersQuery, GetOffersQueryVariables>;
export const GetOffersCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOffersCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"offers_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"offers_count"},"name":{"kind":"Name","value":"offers_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetOffersCountQuery, GetOffersCountQueryVariables>;
export const GetOfferDrawerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOfferDrawer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offers_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OfferEditForm"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCardSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OfferEditForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"offers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCardSnippet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"offer_refused_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"made_on"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}}]} as unknown as DocumentNode<GetOfferDrawerQuery, GetOfferDrawerQueryVariables>;
export const DeleteOfferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOffer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_offers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteOfferMutation, DeleteOfferMutationVariables>;
export const UpdateOfferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOffer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"offers_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_offers_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OfferEditForm"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCardSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OfferEditForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"offers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCardSnippet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"offer_refused_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"made_on"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}}]} as unknown as DocumentNode<UpdateOfferMutation, UpdateOfferMutationVariables>;
export const GetOfferRefusedTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOfferRefusedTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"offer_refused_types"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetOfferRefusedTypesQuery, GetOfferRefusedTypesQueryVariables>;
export const InsertOfferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertOffer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"offers_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_offers_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offer"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OfferEditForm"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCardSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OfferEditForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"offers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCardSnippet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"offer_refused_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"made_on"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}}]} as unknown as DocumentNode<InsertOfferMutation, InsertOfferMutationVariables>;
export const GetOrganisationsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organisations_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organisations_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisations_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]} as unknown as DocumentNode<GetOrganisationsListQuery, GetOrganisationsListQueryVariables>;
export const GetOrganisationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]} as unknown as DocumentNode<GetOrganisationQuery, GetOrganisationQueryVariables>;
export const PortalTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PortalTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"portalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portals_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portalId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"teams_portals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contract_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"portal_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portalId"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PortalTeamsQuery, PortalTeamsQueryVariables>;
export const AddPortalTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPortalTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"portalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_teams_portals_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"portal_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portalId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]} as unknown as DocumentNode<AddPortalTeamMutation, AddPortalTeamMutationVariables>;
export const UpdatePortalTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePortalTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contract_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_teams_portals_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contract_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contract_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contract_id"}}]}}]}}]} as unknown as DocumentNode<UpdatePortalTeamMutation, UpdatePortalTeamMutationVariables>;
export const GetPortalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPortals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"portals_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"portals_order_by"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"contract_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"exact_address_required"}},{"kind":"Field","name":{"kind":"Name","value":"exclude_from_published_stats"}},{"kind":"Field","name":{"kind":"Name","value":"has_top_premium_listing"}},{"kind":"Field","name":{"kind":"Name","value":"idx_protocol"}},{"kind":"Field","name":{"kind":"Name","value":"master_portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalLogo"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetPortalsQuery, GetPortalsQueryVariables>;
export const GetPortalsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPortalsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"portals_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portals_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetPortalsCountQuery, GetPortalsCountQueryVariables>;
export const GetPortalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPortal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portals_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalFragment"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"password"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shared_portals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portals_types_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"contract_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"exact_address_required"}},{"kind":"Field","name":{"kind":"Name","value":"exclude_from_published_stats"}},{"kind":"Field","name":{"kind":"Name","value":"has_top_premium_listing"}},{"kind":"Field","name":{"kind":"Name","value":"idx_protocol"}},{"kind":"Field","name":{"kind":"Name","value":"master_portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalLogo"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetPortalQuery, GetPortalQueryVariables>;
export const UpdatePortalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePortal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"portal"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"portals_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_portals_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portal"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"contract_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"exact_address_required"}},{"kind":"Field","name":{"kind":"Name","value":"exclude_from_published_stats"}},{"kind":"Field","name":{"kind":"Name","value":"has_top_premium_listing"}},{"kind":"Field","name":{"kind":"Name","value":"idx_protocol"}},{"kind":"Field","name":{"kind":"Name","value":"master_portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalLogo"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePortalMutation, UpdatePortalMutationVariables>;
export const UpsertPortalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertPortal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"portal"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"portals_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_portals_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portal"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"real_estate_portals_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"active"},{"kind":"EnumValue","value":"contract_id"},{"kind":"EnumValue","value":"email"},{"kind":"EnumValue","value":"exact_address_required"},{"kind":"EnumValue","value":"exclude_from_published_stats"},{"kind":"EnumValue","value":"has_top_premium_listing"},{"kind":"EnumValue","value":"idx_protocol"},{"kind":"EnumValue","value":"master_portal_id"},{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"password"},{"kind":"EnumValue","value":"port"},{"kind":"EnumValue","value":"quota"},{"kind":"EnumValue","value":"type"},{"kind":"EnumValue","value":"url"},{"kind":"EnumValue","value":"username"},{"kind":"EnumValue","value":"website_url"},{"kind":"EnumValue","value":"team_id"},{"kind":"EnumValue","value":"logo_image_id"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"contract_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"exact_address_required"}},{"kind":"Field","name":{"kind":"Name","value":"exclude_from_published_stats"}},{"kind":"Field","name":{"kind":"Name","value":"has_top_premium_listing"}},{"kind":"Field","name":{"kind":"Name","value":"idx_protocol"}},{"kind":"Field","name":{"kind":"Name","value":"master_portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalLogo"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<UpsertPortalMutation, UpsertPortalMutationVariables>;
export const DeletePortalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePortal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_portals_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeletePortalMutation, DeletePortalMutationVariables>;
export const GetPropertySearchesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPropertySearchesList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_searches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_searches_places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"notification"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"aggregator_source"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type_in"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type_nin"}},{"kind":"Field","name":{"kind":"Name","value":"composite_property_type_eq"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_gte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_gte"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms_gte"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetPropertySearchesListQuery, GetPropertySearchesListQueryVariables>;
export const GetPropertySearchesCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPropertySearchesCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_searches_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetPropertySearchesCountQuery, GetPropertySearchesCountQueryVariables>;
export const GetPropertySearchDrawerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPropertySearchDrawer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_searches_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_searches_places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"notification"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"property_status"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type_in"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type_nin"}},{"kind":"Field","name":{"kind":"Name","value":"composite_property_type_eq"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_gte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms_gte"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetPropertySearchDrawerQuery, GetPropertySearchDrawerQueryVariables>;
export const InsertPropertySearchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertPropertySearches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PropertySearchImportInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"import_property_searches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_search_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_search"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_searches_places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<InsertPropertySearchesMutation, InsertPropertySearchesMutationVariables>;
export const DeletePropertySearchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePropertySearches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_property_searches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeletePropertySearchesMutation, DeletePropertySearchesMutationVariables>;
export const ExportPropertySearchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportPropertySearches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_searches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_searches_places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug_en"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"notification"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type_in"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type_nin"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_gte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_gte"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms_gte"}}]}}]}}]} as unknown as DocumentNode<ExportPropertySearchesQuery, ExportPropertySearchesQueryVariables>;
export const GetPropertySearchesDictionaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPropertySearchesDictionary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"sources"},"name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"enums"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_like"},"value":{"kind":"StringValue","value":"property_search_source.%","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"aggregator_sources"},"name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"enums"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_like"},"value":{"kind":"StringValue","value":"property_search_aggregator_source.%","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetPropertySearchesDictionaryQuery, GetPropertySearchesDictionaryQueryVariables>;
export const GetBrochureReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBrochureReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"filename_template"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepCoverPhotoBrochure"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepDescriptionBrochure"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepPropertyDetailsBrochure"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrochureReportInclude"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepSettingsBrochure"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepCoverPhotoBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"use_custom_brochure_title"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"address_display_option_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_show_agent_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_cover_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_brochure"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepDescriptionBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description"}},{"kind":"Field","name":{"kind":"Name","value":"use_custom_brochure_description"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_layout"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPropertyDetailsBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrochureReportInclude"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brochure_include_cover"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_property"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_description"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_photos"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_append_files"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepSettingsBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_font_family"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<GetBrochureReportQuery, GetBrochureReportQueryVariables>;
export const UpdateBrochureCoverDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBrochureCover"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepCoverPhotoBrochure"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepCoverPhotoBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"use_custom_brochure_title"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"address_display_option_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_show_agent_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_cover_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_brochure"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateBrochureCoverMutation, UpdateBrochureCoverMutationVariables>;
export const UpdateBrochureDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBrochureDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepDescriptionBrochure"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepDescriptionBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description"}},{"kind":"Field","name":{"kind":"Name","value":"use_custom_brochure_description"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_layout"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<UpdateBrochureDescriptionMutation, UpdateBrochureDescriptionMutationVariables>;
export const UpdatePropertyDetailsBrochureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePropertyDetailsBrochure"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepPropertyDetailsBrochure"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPropertyDetailsBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdatePropertyDetailsBrochureMutation, UpdatePropertyDetailsBrochureMutationVariables>;
export const UpdateStepPhotosBrochureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStepPhotosBrochure"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepPhotosBrochure"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPhotosBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_brochure"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateStepPhotosBrochureMutation, UpdateStepPhotosBrochureMutationVariables>;
export const UpdateBrochureStepSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBrochureStepSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepSettingsBrochure"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepSettingsBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_font_family"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<UpdateBrochureStepSettingsMutation, UpdateBrochureStepSettingsMutationVariables>;
export const DocTemplatesBrochureReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DocTemplatesBrochureReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lot_brochure"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}}]}}]} as unknown as DocumentNode<DocTemplatesBrochureReportQuery, DocTemplatesBrochureReportQueryVariables>;
export const UpdateBrochureReportFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBrochureReportFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateBrochureReportFileMutation, UpdateBrochureReportFileMutationVariables>;
export const GetCmaReportsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCMAReportsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"suggested_market_value"}},{"kind":"Field","name":{"kind":"Name","value":"is_price_range"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_min"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_max"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cover_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyCell_property"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyCell_property"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetCmaReportsListQuery, GetCmaReportsListQueryVariables>;
export const GenerateCmaDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GenerateCmaDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generate_cma_description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cma_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}}]}}]}}]} as unknown as DocumentNode<GenerateCmaDescriptionQuery, GenerateCmaDescriptionQueryVariables>;
export const GetCmaReportsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCmaReportsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_reports_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetCmaReportsCountQuery, GetCmaReportsCountQueryVariables>;
export const UpdateStepSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStepSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepSettingsCma"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepSettingsCma"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"font_family"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<UpdateStepSettingsMutation, UpdateStepSettingsMutationVariables>;
export const UpdateStepPhotosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStepPhotos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateStepPhotosMutation, UpdateStepPhotosMutationVariables>;
export const UpdateStepPointsOfInterestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStepPointsOfInterest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateStepPointsOfInterestMutation, UpdateStepPointsOfInterestMutationVariables>;
export const UpdateDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepDescription"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"include_description"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<UpdateDescriptionMutation, UpdateDescriptionMutationVariables>;
export const DeleteCmaReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCmaReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteCmaReportMutation, DeleteCmaReportMutationVariables>;
export const DocTemplatesCmaReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DocTemplatesCmaReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"cma_report"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_default"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}}]}}]}}]} as unknown as DocumentNode<DocTemplatesCmaReportQuery, DocTemplatesCmaReportQueryVariables>;
export const GetCmaReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCmaReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CMAReportEditor"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepIntroduction"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepCoverPhotoCma"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepPropertyDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepDescription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepHedonisticValuation"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepListingsCompare"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepCapRateValuation"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepIntrinsicValuation"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepFinal"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepPotentialBuyers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepAppendFiles"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepSettingsCma"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaReportInclude"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepPois"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaReportFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_report_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaPropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CMAReportEditor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"filename_template"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepIntroduction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"introduction"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepCoverPhotoCma"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"report_title"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cover_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_brochure"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"include_description"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepHedonisticValuation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"include_hedonistic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appraisals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepListingsCompare"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_comparables_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"comparable_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates_db__merged_listings_clusters_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepCapRateValuation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"caprate_estimated_monthly_rent"}},{"kind":"Field","name":{"kind":"Name","value":"caprate_minimum_required_yield"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rent_value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepIntrinsicValuation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"construction_cost_base"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_building_surface"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_construction_cost"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_annual_deprecation_rate"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_land_value"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_custom_fields"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepFinal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"positive_comments"}},{"kind":"Field","name":{"kind":"Name","value":"negative_comments"}},{"kind":"Field","name":{"kind":"Name","value":"suggested_market_value"}},{"kind":"Field","name":{"kind":"Name","value":"is_price_range"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_min"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_max"}},{"kind":"Field","name":{"kind":"Name","value":"show_probability"}},{"kind":"Field","name":{"kind":"Name","value":"probability_min"}},{"kind":"Field","name":{"kind":"Name","value":"probability_max"}},{"kind":"Field","name":{"kind":"Name","value":"probability_time_period"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPotentialBuyers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"max_budget"}},{"kind":"Field","name":{"kind":"Name","value":"min_budget"}},{"kind":"Field","name":{"kind":"Name","value":"include_potential_buyers"}},{"kind":"Field","name":{"kind":"Name","value":"suggested_market_value"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepAppendFiles"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaReportFile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaPropertyFile"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepSettingsCma"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"font_family"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaReportInclude"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_cover"}},{"kind":"Field","name":{"kind":"Name","value":"include_introduction"}},{"kind":"Field","name":{"kind":"Name","value":"include_property"}},{"kind":"Field","name":{"kind":"Name","value":"include_description"}},{"kind":"Field","name":{"kind":"Name","value":"include_photos"}},{"kind":"Field","name":{"kind":"Name","value":"include_pois"}},{"kind":"Field","name":{"kind":"Name","value":"include_hedonistic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_comparables_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_cuprate_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_intrinsic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_final_value"}},{"kind":"Field","name":{"kind":"Name","value":"include_potential_buyers"}},{"kind":"Field","name":{"kind":"Name","value":"include_agent"}},{"kind":"Field","name":{"kind":"Name","value":"include_agent_agency"}},{"kind":"Field","name":{"kind":"Name","value":"include_client_testimonial"}},{"kind":"Field","name":{"kind":"Name","value":"include_append_files"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPois"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_pois"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance_meters"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_meters"}},{"kind":"Field","name":{"kind":"Name","value":"walking_distance_meters"}},{"kind":"Field","name":{"kind":"Name","value":"cycling_distance_meters"}},{"kind":"Field","name":{"kind":"Name","value":"walking_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"cycling_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"poi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"primary_type"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]}}]} as unknown as DocumentNode<GetCmaReportQuery, GetCmaReportQueryVariables>;
export const GetPropertyAppraisableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPropertyAppraisable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_appraisable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"property_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPropertyAppraisableQuery, GetPropertyAppraisableQueryVariables>;
export const UpdateCmaReportDocTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaReportDocTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCmaReportDocTemplateMutation, UpdateCmaReportDocTemplateMutationVariables>;
export const UpdateCmaStepCoverDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaStepCover"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepCoverPhotoCma"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepCoverPhotoCma"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"report_title"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cover_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_brochure"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCmaStepCoverMutation, UpdateCmaStepCoverMutationVariables>;
export const StepCoverInsertPropertyImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StepCoverInsertPropertyImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_images_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_property_images_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<StepCoverInsertPropertyImageMutation, StepCoverInsertPropertyImageMutationVariables>;
export const UpdateCmaIntroductionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaIntroduction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepIntroduction"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepIntroduction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"introduction"}}]}}]} as unknown as DocumentNode<UpdateCmaIntroductionMutation, UpdateCmaIntroductionMutationVariables>;
export const UpdatePropertyDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePropertyDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepPropertyDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePropertyDetailsMutation, UpdatePropertyDetailsMutationVariables>;
export const UpdateHedonisticValuationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateHedonisticValuation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepHedonisticValuation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepHedonisticValuation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"include_hedonistic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appraisals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateHedonisticValuationMutation, UpdateHedonisticValuationMutationVariables>;
export const UpdateFinalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFinal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepFinal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepFinal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"positive_comments"}},{"kind":"Field","name":{"kind":"Name","value":"negative_comments"}},{"kind":"Field","name":{"kind":"Name","value":"suggested_market_value"}},{"kind":"Field","name":{"kind":"Name","value":"is_price_range"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_min"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_max"}},{"kind":"Field","name":{"kind":"Name","value":"show_probability"}},{"kind":"Field","name":{"kind":"Name","value":"probability_min"}},{"kind":"Field","name":{"kind":"Name","value":"probability_max"}},{"kind":"Field","name":{"kind":"Name","value":"probability_time_period"}}]}}]} as unknown as DocumentNode<UpdateFinalMutation, UpdateFinalMutationVariables>;
export const UpdatePotentialBuyersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePotentialBuyers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepPotentialBuyers"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPotentialBuyers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"max_budget"}},{"kind":"Field","name":{"kind":"Name","value":"min_budget"}},{"kind":"Field","name":{"kind":"Name","value":"include_potential_buyers"}},{"kind":"Field","name":{"kind":"Name","value":"suggested_market_value"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePotentialBuyersMutation, UpdatePotentialBuyersMutationVariables>;
export const StepAddCmaReportFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StepAddCmaReportFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_report_files_insert_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_cma_report_files_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaReportFile"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaReportFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_report_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<StepAddCmaReportFileMutation, StepAddCmaReportFileMutationVariables>;
export const StepDeleteCmaReportFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StepDeleteCmaReportFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_cma_report_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"cma_report_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<StepDeleteCmaReportFileMutation, StepDeleteCmaReportFileMutationVariables>;
export const StepUpdateCmaReportFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StepUpdateCmaReportFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_report_files_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_report_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"cma_report_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaReportFile"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaReportFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_report_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<StepUpdateCmaReportFileMutation, StepUpdateCmaReportFileMutationVariables>;
export const StepUpdateCmaReportFileVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StepUpdateCmaReportFileVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_visible"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_report_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"cma_report_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_visible"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_visible"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<StepUpdateCmaReportFileVisibilityMutation, StepUpdateCmaReportFileVisibilityMutationVariables>;
export const StepAppendAddPropertyFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StepAppendAddPropertyFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_files_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_property_files_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaPropertyFile"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaPropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<StepAppendAddPropertyFileMutation, StepAppendAddPropertyFileMutationVariables>;
export const StepListingsCompareListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StepListingsCompareListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"es"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"it"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ch"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"es"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"it"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}}]}}]} as unknown as DocumentNode<StepListingsCompareListingsQuery, StepListingsCompareListingsQueryVariables>;
export const StepListingsCompareAlgoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StepListingsCompareAlgo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"built_surface"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"living_surface"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lng"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sale_price"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usable_surface"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"es"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"it"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_get_similar_listings_vector"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_built_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"built_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_living_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"living_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_sale_price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sale_price"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_usable_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usable_surface"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ch"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_get_similar_listings_vector"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_built_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"built_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_living_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"living_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_sale_price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sale_price"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_usable_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usable_surface"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"es"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_get_similar_listings_vector"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_built_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"built_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_living_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"living_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_sale_price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sale_price"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_usable_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usable_surface"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_get_similar_listings_vector"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_built_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"built_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_living_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"living_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_sale_price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sale_price"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_usable_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usable_surface"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"it"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}}]}}]} as unknown as DocumentNode<StepListingsCompareAlgoQuery, StepListingsCompareAlgoQueryVariables>;
export const UpdateComparablesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateComparablesList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_comparables_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateComparablesListMutation, UpdateComparablesListMutationVariables>;
export const InsertCmaReportsComparablesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertCmaReportsComparables"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_comparables_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_cma_reports_comparables"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cma_report_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_cma_reports_comparables"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates_db__merged_listings_clusters_id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<InsertCmaReportsComparablesMutation, InsertCmaReportsComparablesMutationVariables>;
export const UpdateCmaReportsComparablesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaReportsComparables"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listing_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_nr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_comparables"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cma_report_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"aggregates_db__merged_listings_clusters_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listing_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_nr"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comparable_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates_db__merged_listings_clusters_id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateCmaReportsComparablesMutation, UpdateCmaReportsComparablesMutationVariables>;
export const DeleteCmaReportsComparablesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCmaReportsComparables"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listing_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_cma_reports_comparables"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cma_report_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"aggregates_db__merged_listings_clusters_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listing_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comparable_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates_db__merged_listings_clusters_id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<DeleteCmaReportsComparablesMutation, DeleteCmaReportsComparablesMutationVariables>;
export const ComparableCmaListingDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComparableCmaListingDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_cma_listings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_cma_listings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_cma_listings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_cma_listings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<ComparableCmaListingDetailsQuery, ComparableCmaListingDetailsQueryVariables>;
export const ComparableCmaListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComparableCmaListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ch_cma_listings_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"fr_cma_listings_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"es_cma_listings_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"it_cma_listings_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}}]} as unknown as DocumentNode<ComparableCmaListingsQuery, ComparableCmaListingsQueryVariables>;
export const ComparableCmaListingsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComparableCmaListingsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ch_cma_listings_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"fr_cma_listings_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"es_cma_listings_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"it_cma_listings_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_cma_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_cma_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_cma_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_cma_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<ComparableCmaListingsCountQuery, ComparableCmaListingsCountQueryVariables>;
export const CreateCmaReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCmaReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_cma_reports_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"cma_reports_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateCmaReportMutation, CreateCmaReportMutationVariables>;
export const UpdateCmaReportStepVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaReportStepVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaReportInclude"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaReportInclude"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_cover"}},{"kind":"Field","name":{"kind":"Name","value":"include_introduction"}},{"kind":"Field","name":{"kind":"Name","value":"include_property"}},{"kind":"Field","name":{"kind":"Name","value":"include_description"}},{"kind":"Field","name":{"kind":"Name","value":"include_photos"}},{"kind":"Field","name":{"kind":"Name","value":"include_pois"}},{"kind":"Field","name":{"kind":"Name","value":"include_hedonistic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_comparables_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_cuprate_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_intrinsic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_final_value"}},{"kind":"Field","name":{"kind":"Name","value":"include_potential_buyers"}},{"kind":"Field","name":{"kind":"Name","value":"include_agent"}},{"kind":"Field","name":{"kind":"Name","value":"include_agent_agency"}},{"kind":"Field","name":{"kind":"Name","value":"include_client_testimonial"}},{"kind":"Field","name":{"kind":"Name","value":"include_append_files"}}]}}]} as unknown as DocumentNode<UpdateCmaReportStepVisibilityMutation, UpdateCmaReportStepVisibilityMutationVariables>;
export const UpdateCapRateValuationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCapRateValuation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepCapRateValuation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepCapRateValuation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"caprate_estimated_monthly_rent"}},{"kind":"Field","name":{"kind":"Name","value":"caprate_minimum_required_yield"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rent_value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCapRateValuationMutation, UpdateCapRateValuationMutationVariables>;
export const UpdateIntrinsicValuationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateIntrinsicValuation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepIntrinsicValuation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepIntrinsicValuation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"construction_cost_base"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_building_surface"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_construction_cost"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_annual_deprecation_rate"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_land_value"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_custom_fields"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateIntrinsicValuationMutation, UpdateIntrinsicValuationMutationVariables>;
export const DeletePropertyPoiDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePropertyPoi"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyPoiId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_property_pois_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyPoiId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeletePropertyPoiMutation, DeletePropertyPoiMutationVariables>;
export const GetPoiTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPoiTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"poi_types"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"types"}}]}}]}}]} as unknown as DocumentNode<GetPoiTypesQuery, GetPoiTypesQueryVariables>;
export const GetAutoPoisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetAutoPois"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auto_search_pois"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"property_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}}}]}]}}]} as unknown as DocumentNode<GetAutoPoisMutation, GetAutoPoisMutationVariables>;
export const GetManualPoisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetManualPois"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manual_search_pois"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"property_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"primaryType"}}]}}]}}]} as unknown as DocumentNode<GetManualPoisMutation, GetManualPoisMutationVariables>;
export const InsertPoiDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertPoi"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertPoisOneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_pois_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<InsertPoiMutation, InsertPoiMutationVariables>;
export const GetReviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"reviews_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"reviews_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}},{"kind":"Field","name":{"kind":"Name","value":"is_buyer"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_date"}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCell"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetReviewsQuery, GetReviewsQueryVariables>;
export const GetReviewsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReviewsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"reviews_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetReviewsCountQuery, GetReviewsCountQueryVariables>;
export const DeleteReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_reviews_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteReviewMutation, DeleteReviewMutationVariables>;
export const GetReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviews_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReviewDrawer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReviewDrawer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"reviews"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_buyer"}},{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_date"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCard"}}]}}]}}]} as unknown as DocumentNode<GetReviewQuery, GetReviewQueryVariables>;
export const UpdateReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"review"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"reviews_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_reviews_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"review"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReviewDrawer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReviewDrawer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"reviews"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_buyer"}},{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_date"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCard"}}]}}]}}]} as unknown as DocumentNode<UpdateReviewMutation, UpdateReviewMutationVariables>;
export const GetTenantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<GetTenantsQuery, GetTenantsQueryVariables>;
export const CreateApiKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateApiKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerRole"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerTeamsIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_key"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"partnerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerName"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnerRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerRole"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnerTeamsIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerTeamsIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PartnerName"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerID"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerApiKey"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerTeamsIds"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerRole"}}]}}]}}]} as unknown as DocumentNode<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const DeleteApiKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteApiKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_key"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"partnerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowsDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;
export const UpdateApiKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateApiKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerTeamsIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerRole"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_key"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"partnerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerName"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnerTeamsIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerTeamsIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnerRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerRole"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PartnerName"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerID"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerApiKey"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerTeamsIds"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerRole"}}]}}]}}]} as unknown as DocumentNode<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;
export const GetApiKeysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetApiKeys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_api_keys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PartnerID"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerName"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerTeamsIds"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerRole"}}]}}]}}]} as unknown as DocumentNode<GetApiKeysQuery, GetApiKeysQueryVariables>;
export const GetApiKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetApiKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_api_key"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"partnerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PartnerName"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerID"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerApiKey"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerTeamsIds"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerRole"}}]}}]}}]} as unknown as DocumentNode<GetApiKeyQuery, GetApiKeyQueryVariables>;
export const LeadStagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LeadStages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipelineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipelineId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadStageFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadStageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_stages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline_id"}}]}}]} as unknown as DocumentNode<LeadStagesQuery, LeadStagesQueryVariables>;
export const UpdatePipelineLeadStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePipelineLeadStage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_stage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lead_stages_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lead_stages_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_stage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadStageFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadStageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_stages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline_id"}}]}}]} as unknown as DocumentNode<UpdatePipelineLeadStageMutation, UpdatePipelineLeadStageMutationVariables>;
export const ReorderLeadStagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReorderLeadStages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipelineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadStageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"starting_position"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"temp"},"name":{"kind":"Name","value":"update_lead_stages_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadStageId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"IntValue","value":"-1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadStageFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"down"},"name":{"kind":"Name","value":"update_lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipelineId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"starting_position"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadStageId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_inc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadStageFields"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"up"},"name":{"kind":"Name","value":"update_lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipelineId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"starting_position"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadStageId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_inc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"IntValue","value":"-1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadStageFields"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"final"},"name":{"kind":"Name","value":"update_lead_stages_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadStageId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadStageFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadStageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_stages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline_id"}}]}}]} as unknown as DocumentNode<ReorderLeadStagesMutation, ReorderLeadStagesMutationVariables>;
export const CreateLeadStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLeadStage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lead_stages_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_lead_stages_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline_id"}}]}}]}}]} as unknown as DocumentNode<CreateLeadStageMutation, CreateLeadStageMutationVariables>;
export const DeleteLeadStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLeadStage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_lead_stages_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteLeadStageMutation, DeleteLeadStageMutationVariables>;
export const GetPipelinesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPipelinesList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pipelines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PipelineFragment"}},{"kind":"Field","name":{"kind":"Name","value":"stages_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pipelines_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PipelineFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pipelines"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}}]}}]} as unknown as DocumentNode<GetPipelinesListQuery, GetPipelinesListQueryVariables>;
export const GetPipelineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPipeline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pipelines_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PipelineFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PipelineFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pipelines"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}}]}}]} as unknown as DocumentNode<GetPipelineQuery, GetPipelineQueryVariables>;
export const DeletePipelineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePipeline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_pipelines_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeletePipelineMutation, DeletePipelineMutationVariables>;
export const UpsertPipelineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertPipeline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"pipelines_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_pipelines_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"pipelines_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"label_fr"},{"kind":"EnumValue","value":"label_en"},{"kind":"EnumValue","value":"label_de"},{"kind":"EnumValue","value":"label_es"},{"kind":"EnumValue","value":"label_it"},{"kind":"EnumValue","value":"lead_type"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PipelineFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PipelineFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pipelines"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}}]}}]} as unknown as DocumentNode<UpsertPipelineMutation, UpsertPipelineMutationVariables>;
export const GetTenantSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenantSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenants_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TenantSettingsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TenantSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tenants"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_description"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_id"}},{"kind":"Field","name":{"kind":"Name","value":"default_pipeline_id"}}]}}]} as unknown as DocumentNode<GetTenantSettingsQuery, GetTenantSettingsQueryVariables>;
export const UpdateTenantSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTenantSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"tenants_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_tenants_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenant"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TenantSettingsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TenantSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tenants"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_description"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_id"}},{"kind":"Field","name":{"kind":"Name","value":"default_pipeline_id"}}]}}]} as unknown as DocumentNode<UpdateTenantSettingsMutation, UpdateTenantSettingsMutationVariables>;
export const GetSubscriptionsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSubscriptionsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"subscriptions_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"subscriptions_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_start"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_end"}},{"kind":"Field","name":{"kind":"Name","value":"customer_email"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total_amount"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}},{"kind":"Field","name":{"kind":"Name","value":"broker_leads_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_paid"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetSubscriptionsListQuery, GetSubscriptionsListQueryVariables>;
export const GetSubscriptionsListCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSubscriptionsListCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"subscriptions_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetSubscriptionsListCountQuery, GetSubscriptionsListCountQueryVariables>;
export const GetSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_start"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_end"}},{"kind":"Field","name":{"kind":"Name","value":"customer_email"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total_amount"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"broker_leads_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvoiceFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_paid"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoiceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"invoices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"period_start"}},{"kind":"Field","name":{"kind":"Name","value":"period_end"}},{"kind":"Field","name":{"kind":"Name","value":"amount_due"}},{"kind":"Field","name":{"kind":"Name","value":"amount_paid"}},{"kind":"Field","name":{"kind":"Name","value":"lines"}}]}}]} as unknown as DocumentNode<GetSubscriptionQuery, GetSubscriptionQueryVariables>;
export const UpdateSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_subscriptions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}},{"kind":"Field","name":{"kind":"Name","value":"broker_leads_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const GetTeamReviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamReviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_review_scraping"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_description"}},{"kind":"Field","name":{"kind":"Name","value":"google_reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"google_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"original_review_text"}},{"kind":"Field","name":{"kind":"Name","value":"profile_name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_url"}},{"kind":"Field","name":{"kind":"Name","value":"review_url"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}},{"kind":"Field","name":{"kind":"Name","value":"owner_answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"google_reviews_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamReviewsQuery, GetTeamReviewsQueryVariables>;
export const ScrapeReviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ScrapeReviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scrape_google_reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status_message"}},{"kind":"Field","name":{"kind":"Name","value":"status_code"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}}]}}]}}]} as unknown as DocumentNode<ScrapeReviewsMutation, ScrapeReviewsMutationVariables>;
export const DeleteReviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteReviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_google_reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteReviewsMutation, DeleteReviewsMutationVariables>;
export const GetTeamPortalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamPortals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_portals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"portal"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"broker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamPortalsQuery, GetTeamPortalsQueryVariables>;
export const DeleteTeamPortalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTeamPortal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_teams_portals_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]} as unknown as DocumentNode<DeleteTeamPortalMutation, DeleteTeamPortalMutationVariables>;
export const GetTeamsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_order_by"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamAddress_light"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"agency_slug"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamCombinedReviewsAgg"}},{"kind":"Field","name":{"kind":"Name","value":"google_reviews_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationCell_organisation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"combined_reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"native","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total_amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"result_page"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamAddress_light"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamCombinedReviewsAgg"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"combined_reviews_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationCell_organisation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamsListQuery, GetTeamsListQueryVariables>;
export const GetTeamsListCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamsListCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamsListCountQuery, GetTeamsListCountQueryVariables>;
export const DrawerGetTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DrawerGetTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DrawerGetTeamQuery, DrawerGetTeamQueryVariables>;
export const OverviewGetTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OverviewGetTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeSubscriptions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamCombinedReviewsAgg"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_leader"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"deactivated"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}},{"kind":"Field","name":{"kind":"Name","value":"is_admin"}},{"kind":"Field","name":{"kind":"Name","value":"combined_reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"native","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeSubscriptions"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_start"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_end"}},{"kind":"Field","name":{"kind":"Name","value":"invoices_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_paid"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker_leads_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamCombinedReviewsAgg"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"combined_reviews_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<OverviewGetTeamQuery, OverviewGetTeamQueryVariables>;
export const CreateTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_teams_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateTeamMutation, CreateTeamMutationVariables>;
export const DeleteTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIdsString"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"_uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"default_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"default_team_id"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"disable_broker"},"name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_broker"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_broker"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"set_default_team"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIdsString"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const DeleteTeamUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTeamUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"default_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"default_team_id"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deactivated"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"disable_broker"},"name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_broker"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_broker"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteTeamUserMutation, DeleteTeamUserMutationVariables>;
export const AddTeamUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddTeamUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"set_default_team_id"},"name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"default_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"default_team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_teams_users_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"IntValue","value":"1000"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"enable_broker"},"name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_broker"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_broker"}}]}}]}}]}}]} as unknown as DocumentNode<AddTeamUserMutation, AddTeamUserMutationVariables>;
export const UpdateTeamUserOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTeamUserOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateTeamUserOrderMutation, UpdateTeamUserOrderMutationVariables>;
export const UpdateTeamUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTeamUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_users_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_user"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_leader"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"enable_broker"},"name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_broker"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_broker"}},{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deactivated"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"disable_broker"},"name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_broker"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_broker"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTeamUserMutation, UpdateTeamUserMutationVariables>;
export const TeamsCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamsCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivated"}},{"kind":"Field","name":{"kind":"Name","value":"is_leader"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TeamsCardQuery, TeamsCardQueryVariables>;
export const TeamsCardUpdateUserDefaultTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TeamsCardUpdateUserDefaultTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"default_team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}}]}}]}}]}}]} as unknown as DocumentNode<TeamsCardUpdateUserDefaultTeamMutation, TeamsCardUpdateUserDefaultTeamMutationVariables>;
export const DeleteTeamImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTeamImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_team_images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteTeamImageMutation, DeleteTeamImageMutationVariables>;
export const GetTeamSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTeamSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamSettingsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"do_follow_link"}},{"kind":"Field","name":{"kind":"Name","value":"legal_name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_slug"}},{"kind":"Field","name":{"kind":"Name","value":"idx_agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"idx_ftp_client_id"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"hide_exact_address"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamAddress"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_id"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_description"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_url"}},{"kind":"Field","name":{"kind":"Name","value":"instagram_url"}},{"kind":"Field","name":{"kind":"Name","value":"youtube_url"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin_url"}},{"kind":"Field","name":{"kind":"Name","value":"twitter_url"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_email_contact"}},{"kind":"Field","name":{"kind":"Name","value":"use_json_for_enquiry_emails"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetTeamSettingsQuery, GetTeamSettingsQueryVariables>;
export const UpdateTeamSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTeamSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamSettingsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"do_follow_link"}},{"kind":"Field","name":{"kind":"Name","value":"legal_name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_slug"}},{"kind":"Field","name":{"kind":"Name","value":"idx_agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"idx_ftp_client_id"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"hide_exact_address"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamAddress"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_id"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_description"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_url"}},{"kind":"Field","name":{"kind":"Name","value":"instagram_url"}},{"kind":"Field","name":{"kind":"Name","value":"youtube_url"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin_url"}},{"kind":"Field","name":{"kind":"Name","value":"twitter_url"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_email_contact"}},{"kind":"Field","name":{"kind":"Name","value":"use_json_for_enquiry_emails"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<UpdateTeamSettingsMutation, UpdateTeamSettingsMutationVariables>;
export const UpsertTeamEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertTeamEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"citext"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_emails_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<UpsertTeamEmailMutation, UpsertTeamEmailMutationVariables>;
export const DeleteTeamEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTeamEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteTeamEmailMutation, DeleteTeamEmailMutationVariables>;
export const UpdateTeamPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTeamPhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone_number"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_phone_numbers_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone_number"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]} as unknown as DocumentNode<UpdateTeamPhoneNumberMutation, UpdateTeamPhoneNumberMutationVariables>;
export const DeleteTeamPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTeamPhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteTeamPhoneNumberMutation, DeleteTeamPhoneNumberMutationVariables>;
export const UpdateTeamImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTeamImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamSettingsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"do_follow_link"}},{"kind":"Field","name":{"kind":"Name","value":"legal_name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_slug"}},{"kind":"Field","name":{"kind":"Name","value":"idx_agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"idx_ftp_client_id"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"hide_exact_address"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamAddress"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_id"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_description"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_url"}},{"kind":"Field","name":{"kind":"Name","value":"instagram_url"}},{"kind":"Field","name":{"kind":"Name","value":"youtube_url"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin_url"}},{"kind":"Field","name":{"kind":"Name","value":"twitter_url"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_email_contact"}},{"kind":"Field","name":{"kind":"Name","value":"use_json_for_enquiry_emails"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<UpdateTeamImagesMutation, UpdateTeamImagesMutationVariables>;
export const GetTeamValuationRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamValuationRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"result_page"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lead"},"value":{"kind":"ObjectValue","fields":[]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetTeamValuationRequestsQuery, GetTeamValuationRequestsQueryVariables>;
export const GetTeamContactRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamContactRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"broker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"contact_reason"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_enquiry"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_enquiry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetTeamContactRequestsQuery, GetTeamContactRequestsQueryVariables>;
export const GetCreateTransactionDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCreateTransactionData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeListing"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeOffer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeListing"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCardSnippet"}},{"kind":"Field","alias":{"kind":"Name","value":"last_accepted_offer"},"name":{"kind":"Name","value":"offers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offerId"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeOffer"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCardSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}}]}}]}}]} as unknown as DocumentNode<GetCreateTransactionDataQuery, GetCreateTransactionDataQueryVariables>;
export const GetPropertyTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPropertyTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionsListRow"}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_buyer"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamInfo_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyCell_property"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionsListRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"payment_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyCell_property"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_paid"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"total","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"my_commissions"},"name":{"kind":"Name","value":"commissions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"split","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"beneficiary_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPropertyTransactionsQuery, GetPropertyTransactionsQueryVariables>;
export const GetPropertyTransactionsListCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPropertyTransactionsListCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetPropertyTransactionsListCountQuery, GetPropertyTransactionsListCountQueryVariables>;
export const TransactionDrawerGetTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransactionDrawerGetTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team_id"}}]}}]}}]} as unknown as DocumentNode<TransactionDrawerGetTransactionQuery, TransactionDrawerGetTransactionQueryVariables>;
export const DeleteTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteTransactionMutation, DeleteTransactionMutationVariables>;
export const TransactionFormQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransactionFormQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionFormFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"payment_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode<TransactionFormQueryQuery, TransactionFormQueryQueryVariables>;
export const TransactionFormUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransactionFormUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transaction"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sellers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"transaction_sellers_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"transaction_buyers_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transaction"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionFormFragment"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_transaction_buyers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_transaction_sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_transaction_buyers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyers"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_transaction_sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sellers"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"payment_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamInfo_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}}]} as unknown as DocumentNode<TransactionFormUpdateMutation, TransactionFormUpdateMutationVariables>;
export const TransactionCommissionsFormUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransactionCommissionsFormUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commissions"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"commissions_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_commissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property_transaction_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vat"}},{"kind":"Field","name":{"kind":"Name","value":"contact_id"}},{"kind":"Field","name":{"kind":"Name","value":"beneficiary_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_commissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commissions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vat"}},{"kind":"Field","name":{"kind":"Name","value":"contact_id"}},{"kind":"Field","name":{"kind":"Name","value":"beneficiary_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction_id"}}]}}]}}]}}]} as unknown as DocumentNode<TransactionCommissionsFormUpdateMutation, TransactionCommissionsFormUpdateMutationVariables>;
export const CreateTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transaction"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_property_transactions_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transaction"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionFormFragment"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"payment_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamInfo_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}}]} as unknown as DocumentNode<CreateTransactionMutation, CreateTransactionMutationVariables>;
export const GetUserDefaultTeamIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserDefaultTeamId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}}]}}]}}]} as unknown as DocumentNode<GetUserDefaultTeamIdQuery, GetUserDefaultTeamIdQueryVariables>;
export const GetTransactionDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTransactionDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFile"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}}]}}]} as unknown as DocumentNode<GetTransactionDocumentsQuery, GetTransactionDocumentsQueryVariables>;
export const GetTransactionPropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTransactionProperty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCard"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTransactionPropertyQuery, GetTransactionPropertyQueryVariables>;
export const DeletePropertyTransactionListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePropertyTransactionListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_property_transactions_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property_transaction_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"listing_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeletePropertyTransactionListingMutation, DeletePropertyTransactionListingMutationVariables>;
export const GetLinkedListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLinkedListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"es"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"it"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ch"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"es"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"it"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}}]}}]}}]} as unknown as DocumentNode<GetLinkedListingsQuery, GetLinkedListingsQueryVariables>;
export const InsertPropertyTransactionListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertPropertyTransactionListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions_listings_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_property_transactions_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"property_transactions_listings_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"updated_at"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}}]}}]}}]} as unknown as DocumentNode<InsertPropertyTransactionListingsMutation, InsertPropertyTransactionListingsMutationVariables>;
export const RestoreUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RestoreUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_deleted"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_deleted"}}]}}]}}]} as unknown as DocumentNode<RestoreUserMutation, RestoreUserMutationVariables>;
export const GetCatchmentAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCatchmentArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catchment_areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCatchmentAreaQuery, GetCatchmentAreaQueryVariables>;
export const SetCatchmentAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetCatchmentArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"catchment_areas_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_catchment_areas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_catchment_areas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<SetCatchmentAreaMutation, SetCatchmentAreaMutationVariables>;
export const GetUserReviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserReviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_seller"}},{"kind":"Field","name":{"kind":"Name","value":"is_buyer"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_date"}},{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserReviewsQuery, GetUserReviewsQueryVariables>;
export const DeleteUserReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUserReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_reviews_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteUserReviewMutation, DeleteUserReviewMutationVariables>;
export const UpdateUserReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"review_text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_reviews_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"review_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"review_text"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}}]}}]}}]} as unknown as DocumentNode<UpdateUserReviewMutation, UpdateUserReviewMutationVariables>;
export const GetUsersListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_order_by"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_admin"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]}}]} as unknown as DocumentNode<GetUsersListQuery, GetUsersListQueryVariables>;
export const GetUsersListCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersListCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetUsersListCountQuery, GetUsersListCountQueryVariables>;
export const UserFeedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserFeed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"activityFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"activityFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"unread"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"nylas_thread_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UserFeedQuery, UserFeedQueryVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeSubscriptions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}},{"kind":"Field","name":{"kind":"Name","value":"is_admin"}},{"kind":"Field","name":{"kind":"Name","value":"is_deleted"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContactCardUserFragment"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeSubscriptions"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"total_amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_start"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_end"}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvoiceFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_paid"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserEmails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContactCardUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserEmails"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoiceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"invoices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"period_start"}},{"kind":"Field","name":{"kind":"Name","value":"period_end"}},{"kind":"Field","name":{"kind":"Name","value":"amount_due"}},{"kind":"Field","name":{"kind":"Name","value":"amount_paid"}},{"kind":"Field","name":{"kind":"Name","value":"lines"}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const AgentFeedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AgentFeed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assigned_to"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"250"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"activityFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"activityFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"unread"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"nylas_thread_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AgentFeedQuery, AgentFeedQueryVariables>;
export const GetUserSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSettingsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}},{"kind":"Field","name":{"kind":"Name","value":"has_free_crm_access"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"linked_in_profile"}},{"kind":"Field","name":{"kind":"Name","value":"instagram_profile"}},{"kind":"Field","name":{"kind":"Name","value":"youtube_profile"}},{"kind":"Field","name":{"kind":"Name","value":"twitter_profile"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_profile"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"certifications"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"Field","name":{"kind":"Name","value":"hires_on_realadvisor"}}]}}]} as unknown as DocumentNode<GetUserSettingsQuery, GetUserSettingsQueryVariables>;
export const UpdateUserSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSettingsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}},{"kind":"Field","name":{"kind":"Name","value":"has_free_crm_access"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"linked_in_profile"}},{"kind":"Field","name":{"kind":"Name","value":"instagram_profile"}},{"kind":"Field","name":{"kind":"Name","value":"youtube_profile"}},{"kind":"Field","name":{"kind":"Name","value":"twitter_profile"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_profile"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"certifications"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"Field","name":{"kind":"Name","value":"hires_on_realadvisor"}}]}}]} as unknown as DocumentNode<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;
export const DeleteUserImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUserImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_user_images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image_id"}}]}}]}}]} as unknown as DocumentNode<DeleteUserImageMutation, DeleteUserImageMutationVariables>;
export const SetUserProfileImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetUserProfileImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_images_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_user_images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_images_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SetUserProfileImageMutation, SetUserProfileImageMutationVariables>;
export const InsertUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"users_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertUsersMutation, InsertUsersMutationVariables>;
export const DeleteUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteUsersMutation, DeleteUsersMutationVariables>;
export const ExportUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<ExportUsersQuery, ExportUsersQueryVariables>;
export const DashboardGetOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardGetOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"me"},"name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account_manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_slug"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_leader"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"deactivated"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}},{"kind":"Field","name":{"kind":"Name","value":"is_admin"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}},{"kind":"Field","name":{"kind":"Name","value":"broker_leads_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<DashboardGetOverviewQuery, DashboardGetOverviewQueryVariables>;
export const DashboardVisibilityStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardVisibilityStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"impressions_data"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"NullValue"}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"user_count"}},{"kind":"Field","name":{"kind":"Name","value":"average_position"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"views_data"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"NullValue"}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"page_types"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"agency-detail","block":false},{"kind":"StringValue","value":"agent-detail","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"user_count"}}]}}]}}]}}]} as unknown as DocumentNode<DashboardVisibilityStatsQuery, DashboardVisibilityStatsQueryVariables>;
export const GetVisibilityInboxDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisibilityInbox"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"result_page"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lead"},"value":{"kind":"ObjectValue","fields":[]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"broker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_enquiry"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"contact_reason"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_enquiry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}}]}}]} as unknown as DocumentNode<GetVisibilityInboxQuery, GetVisibilityInboxQueryVariables>;
export const GetInboxMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInboxMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_agents_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"contact_reason"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetInboxMessageQuery, GetInboxMessageQueryVariables>;
export const GetUserSlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserSlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}}]}}]}}]} as unknown as DocumentNode<GetUserSlugQuery, GetUserSlugQueryVariables>;
export const GetFirstUserOfTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFirstUserOfTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"show_in_agency_pages"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode<GetFirstUserOfTeamQuery, GetFirstUserOfTeamQueryVariables>;
export const GetVisibilityReviewsAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisibilityReviewsAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVisibilityReviewsAggregateQuery, GetVisibilityReviewsAggregateQueryVariables>;
export const GetVisibilityReviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisibilityReviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"reviews_order_by"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisibilityReview"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisibilityReview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"reviews"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}}]} as unknown as DocumentNode<GetVisibilityReviewsQuery, GetVisibilityReviewsQueryVariables>;
export const GetVisibilityReviewsRowCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisibilityReviewsRowCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetVisibilityReviewsRowCountQuery, GetVisibilityReviewsRowCountQueryVariables>;
export const GetTeamVisibilityStatsGraphDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamVisibilityStatsGraph"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ImpressionsGroupingColumn"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"impressions_graph_data"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"EnumValue","value":"date"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_column"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_direction"},"value":{"kind":"StringValue","value":"asc","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"views_graph_data"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"EnumValue","value":"date"}},{"kind":"Argument","name":{"kind":"Name","value":"page_types"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"agency-detail","block":false},{"kind":"StringValue","value":"agent-detail","block":false}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_column"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_direction"},"value":{"kind":"StringValue","value":"asc","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"user_count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"average_position"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"EnumValue","value":"date"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_column"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_direction"},"value":{"kind":"StringValue","value":"asc","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"average_position"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"show_phone_number_data"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"EnumValue","value":"date"}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_column"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_direction"},"value":{"kind":"StringValue","value":"asc","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"event_names"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"show_phone_number","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"user_count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_admin"}}]}}]}}]} as unknown as DocumentNode<GetTeamVisibilityStatsGraphQuery, GetTeamVisibilityStatsGraphQueryVariables>;
export const GetTeamVisibilityStatsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamVisibilityStatsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ImpressionsGroupingColumn"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"list_data"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_column"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_direction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"user_count"}},{"kind":"Field","name":{"kind":"Name","value":"average_position"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_admin"}}]}}]}}]} as unknown as DocumentNode<GetTeamVisibilityStatsListQuery, GetTeamVisibilityStatsListQueryVariables>;
export const GetVisibilityTeamMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisibilityTeamMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_2_years_property_transactions_aggregate"},"name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVisibilityTeamMembersQuery, GetVisibilityTeamMembersQueryVariables>;
export const GetTeamMemberDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamMemberDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_leader"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"deactivated"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"all_reviews_count"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"verified_reviews_count"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"average_rating"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latest_review"},"name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completed_at"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_transaction"},"name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signature_date"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"all_transactions_count"},"name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_2_years_transactions"},"name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"purchase_price"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetTeamMemberDetailsQuery, GetTeamMemberDetailsQueryVariables>;
export const CreateTeamInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTeamInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"invitations_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_invitations_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitation"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateTeamInvitationMutation, CreateTeamInvitationMutationVariables>;
export const CheckExistingTeamMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckExistingTeamMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"citext"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"emails"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tenant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]} as unknown as DocumentNode<CheckExistingTeamMemberQuery, CheckExistingTeamMemberQueryVariables>;
export const CheckExistingInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckExistingInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"citext"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invitations_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tenant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accepted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelled_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<CheckExistingInvitationQuery, CheckExistingInvitationQueryVariables>;
export const CancelExistingInvitationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelExistingInvitations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"citext"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_invitations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tenant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"accepted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"cancelled_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelled_at"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<CancelExistingInvitationsMutation, CancelExistingInvitationsMutationVariables>;
export const GetVisibilityTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisibilityTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10000"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyCell_property"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_buyer"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_leader"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"deactivated"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_2_years_property_transactions_aggregate"},"name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"team_transactions"},"name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyCell_property"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetVisibilityTransactionsQuery, GetVisibilityTransactionsQueryVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_ids_in_led_teams"}},{"kind":"Field","name":{"kind":"Name","value":"show_plans"}},{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_admin"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"has_used_trial_button"}},{"kind":"Field","name":{"kind":"Name","value":"has_free_crm_access"}},{"kind":"Field","name":{"kind":"Name","value":"auto_assign_leads"}},{"kind":"Field","name":{"kind":"Name","value":"can_user_login_as"}},{"kind":"Field","name":{"kind":"Name","value":"can_edit_settings"}},{"kind":"Field","name":{"kind":"Name","value":"modules"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"intercom_hash"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"resources_en"}},{"kind":"Field","name":{"kind":"Name","value":"resources_fr"}},{"kind":"Field","name":{"kind":"Name","value":"resources_de"}},{"kind":"Field","name":{"kind":"Name","value":"resources_es"}},{"kind":"Field","name":{"kind":"Name","value":"resources_it"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"help_link_en"}},{"kind":"Field","name":{"kind":"Name","value":"help_link_fr"}},{"kind":"Field","name":{"kind":"Name","value":"help_link_de"}},{"kind":"Field","name":{"kind":"Name","value":"help_link_it"}},{"kind":"Field","name":{"kind":"Name","value":"help_link_es"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"EnumValue","value":"asc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"teams"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_leader"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invalid"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const PrepareUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PrepareUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mime_type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepare_upload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"file_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_type"}}},{"kind":"Argument","name":{"kind":"Name","value":"file_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"mime_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mime_type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"signed_url"}}]}}]}}]} as unknown as DocumentNode<PrepareUploadMutation, PrepareUploadMutationVariables>;
export const SearchTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_teams_tsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<SearchTeamsQuery, SearchTeamsQueryVariables>;
export const NoAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NoAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<NoAccessQuery, NoAccessQueryVariables>;
export const GetTenantBySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenantBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetTenantBySlugQuery, GetTenantBySlugQueryVariables>;
export const UserInputSearchUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserInputSearchUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"users_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_users_tsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInput"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInput"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"primaryImage"},"name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}}]}}]} as unknown as DocumentNode<UserInputSearchUsersQuery, UserInputSearchUsersQueryVariables>;
export const UserInputDefaultTeamsUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserInputDefaultTeamsUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInput"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInput"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"primaryImage"},"name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}}]}}]} as unknown as DocumentNode<UserInputDefaultTeamsUsersQuery, UserInputDefaultTeamsUsersQueryVariables>;